
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("3CqQm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "MaybeInlineCreateActiveIndexContainer", () => $f198d0139942408f$export$88c9e8ba5ac9f501);
$parcel$export(module.exports, "default", () => $f198d0139942408f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "NativeIssueTableEntryPoint", () => $f198d0139942408f$export$1c6b4acc188098eb);

var $SOgcQ = parcelRequire("SOgcQ");

var $3hzHu = parcelRequire("3hzHu");

var $46RRC = parcelRequire("46RRC");

var $9vx30 = parcelRequire("9vx30");

var $cgUa2 = parcelRequire("cgUa2");

var $aZKxL = parcelRequire("aZKxL");

var $cDHjO = parcelRequire("cDHjO");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");

var $6djmC = parcelRequire("6djmC");
var $3cMgR = parcelRequire("3cMgR");

var $2gvG4 = parcelRequire("2gvG4");

var $9cbmy = parcelRequire("9cbmy");

var $cxKOj = parcelRequire("cxKOj");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $PETi0 = parcelRequire("PETi0");

var $88wTt = parcelRequire("88wTt");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");
var $eS29z = parcelRequire("eS29z");
var $ftN6c = parcelRequire("ftN6c");

var $jE8Tu = parcelRequire("jE8Tu");

var $dLXgn = parcelRequire("dLXgn");

var $j8Km1 = parcelRequire("j8Km1");

var $bYhG9 = parcelRequire("bYhG9");

var $9RE4U = parcelRequire("9RE4U");

var $8jOO7 = parcelRequire("8jOO7");

var $f4DUY = parcelRequire("f4DUY");

var $lqvgs = parcelRequire("lqvgs");

var $kmIYY = parcelRequire("kmIYY");

var $dmolI = parcelRequire("dmolI");

var $l7qKV = parcelRequire("l7qKV");

var $P01So = parcelRequire("P01So");

var $kbYhH = parcelRequire("kbYhH");

var $4hsdx = parcelRequire("4hsdx");

var $jKV5x = parcelRequire("jKV5x");

var $6LwYU = parcelRequire("6LwYU");

var $6KVf0 = parcelRequire("6KVf0");

var $3F6xT = parcelRequire("3F6xT");

var $eqbO4 = parcelRequire("eqbO4");

var $jZFgr = parcelRequire("jZFgr");

var $kfIml = parcelRequire("kfIml");

var $7XD6x = parcelRequire("7XD6x");

var $9r0oq = parcelRequire("9r0oq");

var $8SzGK = parcelRequire("8SzGK");

var $91XFx = parcelRequire("91XFx");

var $sJrIm = parcelRequire("sJrIm");

var $7t30r = parcelRequire("7t30r");

var $4jaZO = parcelRequire("4jaZO");

var $8Cpk9 = parcelRequire("8Cpk9");

var $4aaY3 = parcelRequire("4aaY3");

var $aUa0f = parcelRequire("aUa0f");

var $12O1M = parcelRequire("12O1M");

var $clZvH = parcelRequire("clZvH");

var $9VBAD = parcelRequire("9VBAD");

var $eiAn5 = parcelRequire("eiAn5");

var $bUOjV = parcelRequire("bUOjV");

var $cyJHb = parcelRequire("cyJHb");

var $1GzaA = parcelRequire("1GzaA");

var $5CeML = parcelRequire("5CeML");

var $1PY5i = parcelRequire("1PY5i");

var $jyos0 = parcelRequire("jyos0");
const $f198d0139942408f$export$88c9e8ba5ac9f501 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jira_inline_field_config_gate'), (0, $6KVf0.InlineCreateActiveIndexContainer), ({ children: children })=>children);
const $f198d0139942408f$var$NativeIssueTable = ({ view: view, issues: issues, groups: groups, columns: columns, project: project, rankField: rankField, columnWidthOverrides: columnWidthOverrides, columnConfigOverrides: columnConfigOverrides, components: components, loading: loading = false, selectedRow: selectedRow = null, eventHandlers: eventHandlers, isInlineEditingEnabled: isInlineEditingEnabled = true, isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled = false, onSelectedRowChange: onSelectedRowChange, sortField: sortField, sortDirection: sortDirection = (0, $8jOO7.SORT_ASC), onReady: onReady, onSortChange: onSortChange, onColumnsChange: onColumnsChange, onColumnResize: onColumnResize, onColumnFreeze: onColumnFreeze, onRestoreDefaultColumns: onRestoreDefaultColumns, issueSearchBaseUrl: issueSearchBaseUrl = '/issues', useColumnLoader: useColumnLoader, isColumnPickerLoading: isColumnPickerLoading, projectContext: projectContext, density: density = (0, $8jOO7.DENSITY_COMPACT), isIssueHierarchyEnabled: isIssueHierarchyEnabled = false, isHideDoneItemsEnabled: isHideDoneItemsEnabled = false, areShortcutsEnabled: areShortcutsEnabled = true, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled = false, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled = false, isIssueCreateEnabled: isIssueCreateEnabled = false, enableMultiSelect: enableMultiSelect = false, tableBorderRadius: tableBorderRadius, onIssueFlatListUpdated: onIssueFlatListUpdated, jql: jql, isStatusTrackingEnabled: isStatusTrackingEnabled = false, isMergedColumnEnabled: isMergedColumnEnabled = false, isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled = false, isChildIssuesTable: isChildIssuesTable = false, isIssueRankingEnabled: isIssueRankingEnabled = false, isTimelineEnabled: isTimelineEnabled = false, isSkipIssueCreateSuccessFlagEnabled: isSkipIssueCreateSuccessFlagEnabled = false, onPageChange: // Discrete pagination props
onPageChange, onLoadNext: // Infinite scroll pagination props
onLoadNext, onLoadPrevious: onLoadPrevious, isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious, activationThreshold: activationThreshold, isGroupingSupported: // Experiment value props
isGroupingSupported = false, isOpenIssueLinkEnabled: isOpenIssueLinkEnabled = true, isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled = true, isCompactColumnEnabled: isCompactColumnEnabled = false, isReparentingEnabled: isReparentingEnabled = false, isColumnBordersEnabled: isColumnBordersEnabled = true, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled = false, isGridNavigationEnabled: isGridNavigationEnabled = false, onRowReorder: // Row reordering props
onRowReorder, isEntireRowDraggable: // TODO: Remove on jsc-2065-unify-onrowreorder cleanup
isEntireRowDraggable = false, ifcConfig: ifcConfig, onRefetch: onRefetch, isStickyColumnsEnabled: isStickyColumnsEnabled = false, isConditionalFormattingEnabled: isConditionalFormattingEnabled = false, stickyColumnIds: stickyColumnIds, enableAutoUnstickyOnSmallScreen: enableAutoUnstickyOnSmallScreen = false, enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn = false, cellBorderStyle: cellBorderStyle = 'FULL_BORDER', isProjectQuickstartOnboardingEnabled: isProjectQuickstartOnboardingEnabled = false, isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled = false, isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled = false, isEditableSyncLoaded: isEditableSyncLoaded = false, isDraggingRowFaded: isDraggingRowFaded = true, footerInlineCreateCanShowAdditionalFields: footerInlineCreateCanShowAdditionalFields = true, rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields = true, mergedColumnMinWidth: mergedColumnMinWidth = (0, $4cTDP.fg)('refactor_issue_table_for_timline') ? (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH) : undefined, tableRole: tableRole, formattingRules: formattingRules, footerBorderRadius: footerBorderRadius, resizeHandleType: resizeHandleType, isInBetweenStickyColumnPickerEnabled: isInBetweenStickyColumnPickerEnabled = false, isColumnConfigColumnEnabled: isColumnConfigColumnEnabled = true, isRemoveColumnEnabled: isRemoveColumnEnabled = true, topLevelIssueCreateConfig: topLevelIssueCreateConfig, isMakeSpaceForGlobalRovoButtonEnabled: isMakeSpaceForGlobalRovoButtonEnabled = false, shouldQuerySprints: shouldQuerySprints = false })=>{
    const tableRef = (0, $eJOHy.useRef)(null);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (isGridNavigationEnabled) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7t30r.useKeyboardNavigation)(tableRef, isStickyColumnsEnabled);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const viewData = (0, $j4oe4.useFragment)((0, $cDHjO.default), view ?? null);
    const issuesData = (0, $j4oe4.useFragment)((0, $aZKxL.default), issues ?? null);
    const groupData = (0, $j4oe4.useFragment)((0, $cgUa2.default), groups ?? null);
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const columnsData = (0, $j4oe4.useFragment)((0, $9vx30.default), columns);
    /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ const projectData = (0, $j4oe4.useFragment)((0, $46RRC.default), project ?? null);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $3hzHu.default), rankField ?? null);
    const formattingRulesData = (0, $j4oe4.useFragment)((0, $SOgcQ.default), formattingRules ?? null);
    const isInitialDataLoaded = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (!loading && !isInitialDataLoaded.current) isInitialDataLoaded.current = true;
    }, [
        loading
    ]);
    // initialPopulateConnectionArgs is used to initialise the hierarchy store container on initial load for root connections.
    const [initialisePopulateConnectionArgs] = (0, $eJOHy.useState)(()=>{
        if (!(0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store')) return undefined;
        const connections = [];
        // Rows.tsx pattern with root parent
        if (issuesData && issuesData.edges) {
            const issueItems = issuesData.edges.map((edge)=>edge?.node && {
                    key: edge.node.key,
                    itemId: edge.node.issueId,
                    groupId: undefined
                }).filter(Boolean) ?? [];
            connections.push({
                parentItemId: 'root',
                itemsConnectionId: issuesData.__id,
                parentConnectionId: issuesData.__id,
                list: issueItems
            });
            return connections;
        }
        return undefined;
    });
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>{
        const issueTableNumberOfColumns = columnsData.totalCount;
        if ((0, $4cTDP.fg)('add-fields-enabled-attribute-to-nin-screen-event')) {
            const issueTableFieldTypes = columnsData.edges.map((edge)=>edge?.node.type);
            const issueTableFieldTypesWithCount = issueTableFieldTypes.filter((0, $P01So.isNonNullish)).sort().reduce((acc, type)=>{
                acc[type] = (acc[type] || 0) + 1;
                return acc;
            }, {});
            return {
                issueTableNumberOfColumns: issueTableNumberOfColumns,
                issueTableFieldTypes: issueTableFieldTypes,
                issueTableFieldTypesWithCount: issueTableFieldTypesWithCount
            };
        }
        const issueTableFieldTypesWithCount = columnsData.edges.map((edge)=>edge?.node.type).filter((0, $P01So.isNonNullish)).sort().reduce((acc, type)=>{
            acc[type] = (acc[type] || 0) + 1;
            return acc;
        }, {});
        const issueTableFieldTypes = Object.keys(issueTableFieldTypesWithCount);
        return {
            issueTableNumberOfColumns: issueTableNumberOfColumns,
            issueTableFieldTypes: issueTableFieldTypes,
            issueTableFieldTypesWithCount: issueTableFieldTypesWithCount
        };
    }, [
        columnsData.edges,
        columnsData.totalCount
    ]);
    const canViewColumnConfiguration = useColumnLoader !== undefined;
    const canEditColumnConfiguration = onColumnsChange !== undefined;
    const isColumnResizingEnabled = onColumnResize != null;
    // TODO: Remove on jsc-2065-unify-onrowreorder cleanup
    const isRowReorderingEnabled = onRowReorder != null;
    const isInfiniteScrollEnabled = onLoadNext != null && onLoadPrevious != null;
    const userHasEditIssuePermission = projectData?.editIssues?.canPerform === true;
    const userHasCreateIssuePermission = projectData?.createIssues?.canPerform === true;
    if (isInfiniteScrollEnabled && density === (0, $8jOO7.DENSITY_FULL)) throw new Error(`Infinite scroll is not allowed when density=${density}`);
    const onColumnPickerChange = (0, $eJOHy.useCallback)((pickerArgs)=>{
        if (Array.isArray(pickerArgs)) onColumnsChange && onColumnsChange(pickerArgs, (0, $8jOO7.MODIFY_COLUMNS));
        else if ((0, $4cTDP.fg)('jira_inline_field_config_gate')) {
            const { columnIds: columnIds, isHorizontalAutoScrollNeeded: isHorizontalAutoScrollNeeded, isHorizontalAutoScrollLeftNeeded: isHorizontalAutoScrollLeftNeeded, onSuccessCallback: onSuccessCallback, onErrorCallback: onErrorCallback, retries: retries, analyticsAttributes: attributes, skipRefetch: skipRefetch = false } = pickerArgs;
            if (isHorizontalAutoScrollLeftNeeded && isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate')) tableRef?.current?.parentElement?.scrollTo({
                left: 0,
                behavior: 'smooth'
            });
            else if (isHorizontalAutoScrollNeeded) tableRef?.current?.parentElement?.scrollTo({
                left: tableRef?.current.scrollWidth,
                behavior: 'smooth'
            });
            onColumnsChange && onColumnsChange(columnIds, (0, $8jOO7.MODIFY_COLUMNS), undefined, onSuccessCallback, onErrorCallback, retries, attributes, skipRefetch);
        }
    }, [
        isMergedColumnEnabled,
        onColumnsChange
    ]);
    const isMergedColumnVisible = (0, $eJOHy.useMemo)(()=>{
        if (isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate')) return columnsData.edges.some((edge)=>edge?.node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY || edge?.node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_TYPE || edge?.node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY);
        return false;
    }, [
        isMergedColumnEnabled,
        columnsData
    ]);
    const mappedColumnConfig = (0, $eJOHy.useMemo)(()=>{
        const columnConfig = (0, $dmolI.getColumnConfig)(formatMessage);
        const columnsWithConfig = [];
        const types = columnsData.edges.filter((0, $P01So.isNonNullish)).map((edge)=>edge.node.type);
        if (isIssueHierarchyEnabled && !(isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate'))) columnsWithConfig.push({
            id: (0, $8jOO7.COLUMN_ID_EXPAND_BUTTON),
            type: (0, $j8Km1.KNOWN_COLUMN_TYPES).EXPAND_BUTTON,
            title: '',
            fieldTypeDisplayName: '',
            jqlTerm: '',
            aliases: [],
            customHeader: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
                name: "expand-column-header"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f4DUY.default), null))),
            ...columnConfig[(0, $j8Km1.KNOWN_COLUMN_TYPES).EXPAND_BUTTON](),
            ...columnConfigOverrides?.[(0, $j8Km1.KNOWN_COLUMN_TYPES).EXPAND_BUTTON](types)
        });
        const unsanitizedSortField = (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? sortField && (0, $P01So.desanitizeField)(sortField) : null;
        columnsData.edges.map((edge)=>edge?.node).filter((0, $P01So.isNonNullish)).forEach((node)=>{
            const { fieldSetId: fieldSetId, type: type, displayName: displayName, jqlTerm: jqlTerm, aliases: aliases, isSortable: isSortable, fieldSetPreferences: fieldSetPreferences, isPlaceHolderField: isPlaceHolderField, fieldsMetadata: fieldsMetadata } = node;
            let configureableFieldId;
            if (fieldsMetadata && (0, $4cTDP.fg)('jira_inline_field_config_gate')) {
                const configureableField = fieldsMetadata?.edges?.find((edge)=>edge?.node?.canBeConfigured);
                if (configureableField != null) configureableFieldId = configureableField?.node?.fieldId;
            }
            const mutableAliases = [
                ...aliases ?? []
            ];
            let currentSorting = (0, $8jOO7.SORT_NONE);
            if ((0, $4cTDP.fg)('jsc_list_reranking_ast_refactor')) {
                if (unsanitizedSortField && (jqlTerm.toLowerCase() === unsanitizedSortField || mutableAliases.includes(unsanitizedSortField))) currentSorting = sortDirection;
            } else if (jqlTerm === sortField) currentSorting = sortDirection;
            const baseConfig = {
                id: fieldSetId,
                type: type,
                title: displayName ?? '',
                jqlTerm: jqlTerm,
                aliases: mutableAliases,
                fieldTypeDisplayName: '',
                isSortable: isSortable ?? undefined,
                currentSorting: currentSorting,
                onSortOrderChanged: onSortChange,
                customWidth: columnWidthOverrides?.[fieldSetId] ?? fieldSetPreferences?.width ?? undefined,
                ...type === (0, $8jOO7.COLUMN_TYPE_PARENT_LINK) && {
                    warningText: formatMessage((0, $clZvH.default).deprecatedParentLinkMessage, {
                        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                                color: "color.text.inverse",
                                as: "strong"
                            }, chunks)
                    })
                },
                configureableFieldId: configureableFieldId
            };
            if ((0, $P01So.isKnownColumnType)(type)) {
                const getColumnTypeConfig = columnConfig[type];
                const knownColumnTypeConfig = getColumnTypeConfig();
                const getColumnConfigOverride = columnConfigOverrides?.[type];
                const columnConfigOverride = getColumnConfigOverride?.(types);
                columnsWithConfig.push({
                    ...baseConfig,
                    ...knownColumnTypeConfig,
                    ...columnConfigOverride,
                    isSortable: knownColumnTypeConfig.isSortable ?? true,
                    isPlaceHolderField: !!isPlaceHolderField
                });
            } else columnsWithConfig.push({
                ...baseConfig,
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                isPlaceHolderField: !!isPlaceHolderField
            });
        });
        const shouldShowColumnConfigColumn = (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? canViewColumnConfiguration && isColumnConfigColumnEnabled || isIssueOperationMeatballMenuEnabled : canViewColumnConfiguration || isIssueOperationMeatballMenuEnabled;
        if (shouldShowColumnConfigColumn) {
            const emptyFooter = (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? {} : {
                Footer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
            };
            columnsWithConfig.push({
                id: (0, $8jOO7.COLUMN_ID_MEATBALL_MENU),
                type: (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS,
                title: '',
                fieldTypeDisplayName: '',
                jqlTerm: '',
                customHeader: canViewColumnConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
                    alignInline: "end"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $88wTt.default), {
                    view: viewData,
                    columns: columnsData,
                    components: (0, $4cTDP.fg)('jira_inline_field_config_gate') ? {
                        ...components?.columnPicker,
                        ...isInlineFieldConfigEnabled ? {
                            Footer: (0, $7XD6x.IFCFooter)
                        } : emptyFooter
                    } : components?.columnPicker,
                    onChange: canEditColumnConfiguration ? onColumnPickerChange : undefined,
                    onRestoreDefaultColumns: onRestoreDefaultColumns,
                    useColumnLoader: useColumnLoader,
                    isLoading: isColumnPickerLoading || loading,
                    isMergedColumnEnabled: isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate'),
                    isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
                    projectContext: (0, $4cTDP.fg)('jira_inline_field_config_gate') ? projectContext : undefined
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), null, formatMessage((0, $clZvH.default).columnHeaderIssueActions)),
                ...columnConfig[(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS](),
                ...columnConfigOverrides?.[(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS]?.(types)
            });
        }
        return columnsWithConfig;
    }, [
        formatMessage,
        columnsData,
        isIssueHierarchyEnabled,
        isMergedColumnEnabled,
        canViewColumnConfiguration,
        isIssueOperationMeatballMenuEnabled,
        columnConfigOverrides,
        sortField,
        onSortChange,
        columnWidthOverrides,
        sortDirection,
        components?.columnPicker,
        isInlineFieldConfigEnabled,
        canEditColumnConfiguration,
        onColumnPickerChange,
        onRestoreDefaultColumns,
        useColumnLoader,
        isColumnPickerLoading,
        loading,
        projectContext,
        viewData,
        isColumnConfigColumnEnabled
    ]);
    const checkboxColumnConfig = (0, $eJOHy.useMemo)(()=>{
        const checkboxConfig = (0, $dmolI.getColumnConfig)(formatMessage)[(0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX]();
        return {
            id: (0, $8jOO7.COLUMN_ID_CHECKBOX),
            type: (0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX,
            title: '',
            fieldTypeDisplayName: '',
            jqlTerm: '',
            customHeader: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lqvgs.HeaderCheckboxCell), {
                groupByFieldId: groupData?.groupByField ?? null,
                totalIssueSearchResultCount: (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? issuesData?.totalIssueSearchResultCount ?? null : undefined
            }),
            ...checkboxConfig
        };
    }, [
        formatMessage,
        groupData?.groupByField,
        issuesData?.totalIssueSearchResultCount
    ]);
    const mappedColumns = (0, $eJOHy.useMemo)(()=>{
        // Step 1: get columnConfigs based on bulk ops gate (when enabled)
        let computedMappedColumns = mappedColumnConfig;
        if (enableMultiSelect) computedMappedColumns = [
            checkboxColumnConfig,
            ...mappedColumnConfig
        ];
        // Step 2: get columnConfigs with merged column when enabled.
        if (isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate')) {
            if ((0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) computedMappedColumns = (0, $91XFx.getMergedColumnConfigWithDynamicOrder)(computedMappedColumns, isIssueHierarchyEnabled, formatMessage, enableDynamicOrderForMergedColumn);
            else computedMappedColumns = (0, $91XFx.getMergedColumnConfig)(computedMappedColumns, isIssueHierarchyEnabled, formatMessage);
        }
        // Step 3: get columnConfigs with sticky attributes when frozen columns enabled.
        if (isStickyColumnsEnabled && (0, $4cTDP.fg)('issue_table_frozen_columns')) computedMappedColumns = (0, $l7qKV.getColumnsWithStickyOffsets)(computedMappedColumns, stickyColumnIds);
        return computedMappedColumns;
    }, [
        checkboxColumnConfig,
        enableMultiSelect,
        formatMessage,
        isMergedColumnEnabled,
        isIssueHierarchyEnabled,
        isStickyColumnsEnabled,
        mappedColumnConfig,
        stickyColumnIds,
        enableDynamicOrderForMergedColumn
    ]);
    let isStickyColumnsVisible = false;
    if ((0, $4cTDP.fg)('issue_table_frozen_columns')) {
        const lastStickyColumn = mappedColumns.find((col)=>col.isLastStickyColumn);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isStickyColumnsVisible = (0, $eJOHy.useMemo)(()=>{
            if (!isStickyColumnsEnabled) return false;
            if (!lastStickyColumn) return false;
            // Check if lastStickyColumn's id is not COLUMN_ID_CHECKBOX or COLUMN_ID_EXPAND_BUTTON
            return ![
                (0, $8jOO7.COLUMN_ID_CHECKBOX),
                (0, $8jOO7.COLUMN_ID_EXPAND_BUTTON)
            ].includes(lastStickyColumn.id);
        }, [
            lastStickyColumn,
            isStickyColumnsEnabled
        ]);
    }
    const handleOnColumnsChange = (0, $eJOHy.useCallback)((newColumns)=>{
        if (onColumnsChange) {
            let columnsWithIssueData = newColumns.filter(({ id: id })=>id ? !(0, $8jOO7.ACTION_COLUMNS).includes(id) : id !== (0, $8jOO7.COLUMN_ID_MEATBALL_MENU));
            // make sure merged fields (key, type, summary) are passed to the onColumnsChange
            if (isMergedColumnVisible && (0, $4cTDP.fg)('jira_list_merged_column_gate')) {
                // If re-ordering is enabled for merged column then update columns before merged column with correct order
                if (enableDynamicOrderForMergedColumn && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) {
                    const mergedColumnIndex = newColumns.findIndex((col)=>col?.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN));
                    if (mergedColumnIndex !== -1) {
                        const columnsOnLeft = newColumns.slice(0, mergedColumnIndex).filter(({ id: id })=>id ? !(0, $8jOO7.ACTION_COLUMNS).includes(id) : id !== (0, $8jOO7.COLUMN_ID_MEATBALL_MENU));
                        const columnsOnRight = newColumns.slice(mergedColumnIndex + 1).filter(({ id: id })=>id ? !(0, $8jOO7.ACTION_COLUMNS).includes(id) : id !== (0, $8jOO7.COLUMN_ID_MEATBALL_MENU));
                        const mergedColumns = newColumns[mergedColumnIndex].mergedColumns ?? [];
                        columnsWithIssueData = [
                            ...columnsOnLeft,
                            ...mergedColumns,
                            ...columnsOnRight
                        ];
                    }
                } else {
                    const mergedColumns = newColumns.find((col)=>col?.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN))?.mergedColumns;
                    if (mergedColumns?.length) columnsWithIssueData = [
                        ...mergedColumns,
                        ...columnsWithIssueData
                    ];
                }
            }
            const columnIds = columnsWithIssueData.map(({ id: id })=>id);
            const edges = columnsWithIssueData.map(({ id: id, type: type, title: title, jqlTerm: jqlTerm, aliases: aliases, isSortable: isSortable, fieldTypeDisplayName: fieldTypeDisplayName, customWidth: customWidth })=>({
                    node: {
                        fieldSetId: id,
                        type: type ?? null,
                        displayName: title,
                        jqlTerm: jqlTerm ?? null,
                        aliases: aliases ?? [],
                        isSortable: isSortable ?? null,
                        fieldType: fieldTypeDisplayName ? {
                            displayName: fieldTypeDisplayName
                        } : null,
                        fieldSetPreferences: customWidth ? {
                            width: customWidth
                        } : null,
                        fieldsMetadata: null
                    }
                }));
            const optimisticFieldSets = {
                totalCount: columnsData.totalCount,
                edges: edges
            };
            onColumnsChange(columnIds, (0, $8jOO7.REORDER_COLUMNS), optimisticFieldSets);
        }
    }, [
        columnsData.totalCount,
        isMergedColumnVisible,
        onColumnsChange,
        enableDynamicOrderForMergedColumn
    ]);
    const tableInjectedProps = (0, $eJOHy.useMemo)(()=>({
            ...eventHandlers,
            issueSearchBaseUrl: issueSearchBaseUrl
        }), [
        eventHandlers,
        issueSearchBaseUrl
    ]);
    const columnPickerProps = (0, $eJOHy.useMemo)(()=>isInBetweenColumnPickerEnabled && canViewColumnConfiguration ? {
            columns: columnsData,
            components: components?.columnPicker,
            onChange: canEditColumnConfiguration ? onColumnPickerChange : undefined,
            onRestoreDefaultColumns: onRestoreDefaultColumns,
            useColumnLoader: useColumnLoader,
            isLoading: isColumnPickerLoading || loading
        } : undefined, [
        canEditColumnConfiguration,
        canViewColumnConfiguration,
        columnsData,
        components?.columnPicker,
        isColumnPickerLoading,
        isInBetweenColumnPickerEnabled,
        loading,
        onColumnPickerChange,
        onRestoreDefaultColumns,
        useColumnLoader
    ]);
    (0, $2gvG4.addUFOCustomData)({
        numberOfColumns: mappedColumns.length
    });
    (0, $eJOHy.useEffect)(()=>{
        onReady && (0, $4cTDP.fg)('endeavour_nin_filter_results_gadget') && onReady();
    }, [
        onReady
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isChildIssuesTable && (0, $4cTDP.fg)('ken-2879_is_child_issue_table')) (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'columnsCount updated', 'childIssuesTable', {
            numberOfColumns: mappedColumns.length
        });
    }, [
        createAnalyticsEvent,
        isChildIssuesTable,
        mappedColumns.length
    ]);
    const isPageHydrating = (0, $9RE4U.useIsHydrateRenderMode)();
    const displaySsrPlaceholderAttrs = (0, $9RE4U.useSsrPlaceholders)();
    const conditionalOnColumnsChange = canEditColumnConfiguration ? handleOnColumnsChange : undefined;
    // Show the skeleton if we are loading on initial render as we may only have partial row data
    if (loading && !isInitialDataLoaded.current) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kmIYY.IssueTableSkeleton), null);
    const footer = issuesData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Cpk9.default), {
        topLevelIssueCreateConfig: topLevelIssueCreateConfig,
        Footer: components?.Footer,
        rankField: rankFieldData ?? null,
        IssueCount: components?.IssueCount,
        issues: issuesData,
        onPageChange: onPageChange,
        ...(0, $4cTDP.fg)('refactor_issue_table_for_timline') && {
            canShowAdditionalFields: footerInlineCreateCanShowAdditionalFields,
            footerBorderRadius: footerBorderRadius
        },
        isMakeSpaceForGlobalRovoButtonEnabled: isMakeSpaceForGlobalRovoButtonEnabled
    }) : null;
    const connectionsSubscriber = components?.ConnectionsSubscriber && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1GzaA.ConnectionsSubscriberContainer), {
        ConnectionsSubscriber: components.ConnectionsSubscriber
    });
    const hierarchyRemountKey = `${isIssueHierarchyEnabled}-${isGroupingSupported ? groupData?.jql || issuesData?.jql : ''}-${groupData?.groupByField}`;
    const ScrollContainer = components?.ScrollContainer ?? (0, $9VBAD.ScrollContainer);
    const MainContainer = (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting') ? components?.MainContainer ?? (0, $eiAn5.MainContainer) : (0, $eiAn5.MainContainer);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "nativeIssueTable",
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4hsdx.FeaturesContainer), {
        density: density,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isInfiniteScrollEnabled: isInfiniteScrollEnabled,
        isInlineEditingEnabled: isInlineEditingEnabled,
        isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled,
        isIssueCreateEnabled: isIssueCreateEnabled && userHasCreateIssuePermission,
        projectContext: projectContext,
        isIssueHierarchyEnabled: isIssueHierarchyEnabled,
        isIssueRankingEnabled: isIssueRankingEnabled,
        isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled,
        isRowReorderingEnabled: (0, $4cTDP.fg)('jsc-2065-unify-onrowreorder') ? false : isRowReorderingEnabled,
        isEntireRowDraggable: (0, $4cTDP.fg)('jsc-2065-unify-onrowreorder') ? isEntireRowDraggable : isRowReorderingEnabled && isEntireRowDraggable,
        isReparentingEnabled: isReparentingEnabled && isIssueHierarchyEnabled && (!groupData || !groupData?.groupByField) && userHasEditIssuePermission,
        sortDirection: sortDirection,
        sortField: sortField,
        jql: jql ?? '',
        isColumnBordersEnabled: isColumnBordersEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
        isHideDoneItemsEnabled: isHideDoneItemsEnabled,
        isMergedColumnEnabled: isMergedColumnEnabled,
        isMergedColumnVisible: isMergedColumnVisible,
        isStickyColumnsEnabled: isStickyColumnsEnabled,
        isStickyColumnsVisible: isStickyColumnsVisible,
        isAutoUnstickyOnSmallScreenEnabled: enableAutoUnstickyOnSmallScreen,
        isConditionalFormattingEnabled: (0, $4cTDP.fg)('jira_list_conditional_formatting') ? isConditionalFormattingEnabled : undefined,
        isTimelineEnabled: isTimelineEnabled,
        isOpenIssueLinkEnabled: isOpenIssueLinkEnabled,
        isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled,
        cellBorderStyle: (0, $4cTDP.fg)('jira_timeline_cell_border_style') ? cellBorderStyle : 'FULL_BORDER',
        isProjectQuickstartOnboardingEnabled: isProjectQuickstartOnboardingEnabled,
        isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
        isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
        isEditableSyncLoaded: isEditableSyncLoaded,
        isSkipIssueCreateSuccessFlagEnabled: isSkipIssueCreateSuccessFlagEnabled,
        isInBetweenStickyColumnPickerEnabled: isInBetweenStickyColumnPickerEnabled,
        isColumnConfigColumnEnabled: isColumnConfigColumnEnabled,
        isRemoveColumnEnabled: isRemoveColumnEnabled,
        ...(0, $4cTDP.fg)('timeline_harmonisation_m3_targeting') && {
            shouldQuerySprints: shouldQuerySprints
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SzGK.MaybeEventHandlersProvider), {
        eventHandlers: eventHandlers ?? {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9r0oq.TimelineCustomComponentsProvider), {
        components: components?.timeline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3F6xT.TableIntersectionObserverContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4aaY3.IssueFetchQueryVariables), {
        columns: columnsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f198d0139942408f$export$88c9e8ba5ac9f501, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6LwYU.SiblingCreateActiveIndexContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4jaZO.ShouldUseSSRVirtualizerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jE8Tu.HierarchyContainer), {
        // Key used to reset the container store when the hierarchy settings change
        // Without it there may be flickering when Concurrent Mode is enabled
        key: hierarchyRemountKey,
        ...(0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store') && {
            populateConnectionArgs: initialisePopulateConnectionArgs
        },
        // Used to determine the selected row when returning from the full page issue app. Clean up with issue app removal
        selectedRowIndex: selectedRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYhG9.HoverPopoverStateProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kfIml.DraggableRowsContainer), {
        issueConnectionId: issuesData?.__id || '',
        instanceId: issuesData?.__id,
        ...(0, $4cTDP.fg)('jsc-2065-unify-onrowreorder') ? {} : {
            onRowReorder: onRowReorder
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MainContainer, {
        tableBorderRadius: isChildIssuesTableVisualUpliftEnabled && (0, $4cTDP.fg)('fg_visual_uplift_for_child_issues_table') ? "var(--ds-space-0, 0px)" : tableBorderRadius,
        tableBorderWidth: isChildIssuesTableVisualUpliftEnabled && (0, $4cTDP.fg)('fg_visual_uplift_for_child_issues_table') ? '0px' : (0, $8jOO7.BORDER_WIDTH),
        "data-vc": `issue-table-main-container${false && !isPageHydrating ? '-ssr' : ''}`,
        ...false && displaySsrPlaceholderAttrs && {
            'data-ssr-placeholder': 'issue-table-main-container-placeholder'
        },
        ...!false && displaySsrPlaceholderAttrs && {
            'data-ssr-placeholder-replace': 'issue-table-main-container-placeholder'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kbYhH.ElementSizeProvider), {
        elementRef: tableRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLXgn.ConnectionsListContainer), {
        // Key used to reset the container store when the hierarchy settings change
        // Without it there may be flickering when Concurrent Mode is enabled
        key: hierarchyRemountKey
    }, connectionsSubscriber, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sJrIm.SortChangeContextProvider), {
        value: {
            onSortChange: onSortChange
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ScrollContainer, {
        footer: footer,
        onLoadNext: onLoadNext,
        onLoadPrevious: onLoadPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        activationThreshold: activationThreshold,
        loading: loading,
        isGrouping: isGroupingSupported && !!groupData,
        ...(0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate') && {
            columnCount: mappedColumns.length
        },
        ...((0, $4cTDP.fg)('ken-2879_is_child_issue_table') || (0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate')) && {
            isChildIssuesTable: isChildIssuesTable
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eqbO4.LazyEditabilityLoaderContainer), {
        scope: (0, $8jOO7.LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jZFgr.LazyMediaViewContextLoaderContainer), {
        scope: (0, $8jOO7.LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jKV5x.SelectedRowContainer), {
        selectedRowIndex: selectedRow,
        amountOfRows: issuesData?.edges?.length ?? 0,
        onRowChange: onSelectedRowChange,
        onPageChange: onPageChange,
        issues: issuesData ?? null
    }, areShortcutsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $12O1M.default), {
        onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $PETi0.ColumnPickerContainer), isInBetweenColumnPickerEnabled && {
        scope: (0, $8jOO7.COLUMN_PICKER_CONFIGURATION_CONTAINER)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cyJHb.CopyPasteContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aUa0f.default), {
        view: viewData ?? null,
        columnPickerProps: columnPickerProps,
        issueResults: issuesData ?? null,
        groupResults: groupData ?? null,
        project: projectData ?? null,
        rankField: rankFieldData ?? null,
        columns: mappedColumns,
        canViewColumnConfiguration: canViewColumnConfiguration,
        canEditColumnConfiguration: canEditColumnConfiguration,
        loading: loading,
        tableInjectedProps: tableInjectedProps,
        onColumnsChange: conditionalOnColumnsChange,
        onResizeColumn: onColumnResize,
        onFreezeColumn: onColumnFreeze,
        NoColumns: components?.NoColumns,
        NoIssues: components?.NoIssues,
        tableRef: tableRef,
        isGroupingSupported: isGroupingSupported,
        isCompactColumnEnabled: isCompactColumnEnabled,
        tableBorderRadius: isChildIssuesTableVisualUpliftEnabled && (0, $4cTDP.fg)('fg_visual_uplift_for_child_issues_table') ? "var(--ds-space-0, 0px)" : tableBorderRadius,
        onIssueFlatListUpdated: onIssueFlatListUpdated,
        ifcConfig: ifcConfig,
        columnsQueryRef: columnsData,
        enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn,
        isDraggingRowFaded: isDraggingRowFaded,
        mergedColumnMinWidth: mergedColumnMinWidth,
        tableRole: tableRole,
        formattingRules: formattingRulesData,
        rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
        resizeHandleType: resizeHandleType,
        topLevelIssueCreateConfig: topLevelIssueCreateConfig,
        ...(0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store') && {
            initialPopulateConnectionArgs: initialisePopulateConnectionArgs
        }
    })))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CeML.RootConnectionRegister), {
        issues: issuesData
    }), (0, $4cTDP.fg)('jira_list_reduce_re_renders') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jyos0.FlatListUpdateHandler), {
        onIssueFlatListUpdated: onIssueFlatListUpdated
    }), projectData && (0, $cxKOj.expVal)('jira_list_realtime_updates_with_queue', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1PY5i.IssueRealtimeUpdater), {
        project: projectData,
        issues: issuesData,
        groups: groupData,
        isHierarchyEnabled: isIssueHierarchyEnabled,
        isStatusTrackingEnabled: isStatusTrackingEnabled,
        onRefetch: onRefetch,
        useCustomSubscription: false
    }))))))))))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "nativeIssueTable"
    }));
};
const $f198d0139942408f$var$NativeIssueTableWithSelectedIssuesProvider = (0, $bUOjV.IssueTableSelectedIssuesProvider)($f198d0139942408f$var$NativeIssueTable);
var $f198d0139942408f$export$2e2bcd8739ae039 = $f198d0139942408f$var$NativeIssueTableWithSelectedIssuesProvider;
const $f198d0139942408f$export$1c6b4acc188098eb = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f198d0139942408f$var$NativeIssueTableWithSelectedIssuesProvider, props);

});
parcelRegister("SOgcQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fc5cb55dbab821d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6985c07e30668bf0a3137d89e31c7ce8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3fc5cb55dbab821d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "NativeIssueTableWithSelectedIssuesProvider_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "IssueTable_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$3fc5cb55dbab821d$var$node.hash = "bee4ee6b4e3b0de62d9a8d49cc6ce0f7";
var $3fc5cb55dbab821d$export$2e2bcd8739ae039 = $3fc5cb55dbab821d$var$node;

});

parcelRegister("3hzHu", function(module, exports) {
$parcel$export(module.exports, "default", () => $f69dee3c2ab632e6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d05b0e3dbaccaeeae8e3e0b8e436ca48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f69dee3c2ab632e6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "NativeIssueTableWithSelectedIssuesProvider_rankField",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "IssueTable_rankField"
        },
        {
            "kind": "FragmentSpread",
            "name": "FooterRenderer_rank"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$f69dee3c2ab632e6$var$node.hash = "82614f163ab491b25be4a02199e7de19";
var $f69dee3c2ab632e6$export$2e2bcd8739ae039 = $f69dee3c2ab632e6$var$node;

});

parcelRegister("46RRC", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd9b2216e0890db5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ab3c425b9b8ca16040953f3b399f51a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bd9b2216e0890db5$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "NativeIssueTableWithSelectedIssuesProvider_project",
        "selections": [
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "editIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "EDIT_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": v0 /*: any*/ ,
                        "storageKey": "action(type:\"EDIT_ISSUES\")"
                    }
                ]
            },
            {
                "alias": "createIssues",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "CREATE_ISSUES"
                    }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": v0 /*: any*/ ,
                "storageKey": "action(type:\"CREATE_ISSUES\")"
            },
            {
                "kind": "FragmentSpread",
                "name": "IssueRealtimeUpdater_project"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isConditionalFormattingEnabled",
                        "variableName": "isConditionalFormattingEnabled"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "IssueTable_project"
            }
        ],
        "type": "JiraProject"
    };
}();
$bd9b2216e0890db5$var$node.hash = "4533ca80ef71718ba0712a1b7d6bfd66";
var $bd9b2216e0890db5$export$2e2bcd8739ae039 = $bd9b2216e0890db5$var$node;

});

parcelRegister("9vx30", function(module, exports) {
$parcel$export(module.exports, "default", () => $c89954307e7b8090$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<10a524d8a265b2ef146dd954ec86f385>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c89954307e7b8090$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "NativeIssueTableWithSelectedIssuesProvider_columns",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "IssueFetchQueryVariables"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "totalCount"
            },
            "action": "THROW",
            "path": "totalCount"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraIssueSearchFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "fieldSetId"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.fieldSetId"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "type"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.type"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.displayName"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "jqlTerm"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.jqlTerm"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "aliases"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSortable"
                                },
                                {
                                    "concreteType": "JiraFieldSetPreferences",
                                    "kind": "LinkedField",
                                    "name": "fieldSetPreferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "width"
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsMetadata",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchMetadataField",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canBeConfigured"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fieldId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPlaceHolderField"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "edges.node"
                    }
                ]
            },
            "action": "THROW",
            "path": "edges"
        },
        {
            "kind": "FragmentSpread",
            "name": "ColumnConfigWithContainer"
        },
        {
            "kind": "FragmentSpread",
            "name": "context_nativeIssueTable_IFCConfigContextProvider_columnsQueryRef"
        }
    ],
    "type": "JiraIssueSearchFieldSetConnection"
};
$c89954307e7b8090$var$node.hash = "1b4c38bed9d29dd542d8e29a16f86aeb";
var $c89954307e7b8090$export$2e2bcd8739ae039 = $c89954307e7b8090$var$node;

});

parcelRegister("cgUa2", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa51251bbeb44745$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1b9a57cc0440fe5f9e390df8eac0b95c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aa51251bbeb44745$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": true,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isPaginating"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isRemoteLinkedIssuesEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewConfigInput"
        }
    ],
    "kind": "Fragment",
    "name": "NativeIssueTableWithSelectedIssuesProvider_group",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "groupByField"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isEditableSyncLoaded",
                    "variableName": "isEditableSyncLoaded"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isPaginating",
                    "variableName": "isPaginating"
                },
                {
                    "kind": "Variable",
                    "name": "isRemoteLinkedIssuesEnabled",
                    "variableName": "isRemoteLinkedIssuesEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "viewConfigInput",
                    "variableName": "viewConfigInput"
                }
            ],
            "kind": "FragmentSpread",
            "name": "IssueTable_spreadsheetGroupConnection"
        },
        {
            "kind": "FragmentSpread",
            "name": "IssueRealtimeUpdater_spreadsheetGroupConnection"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$aa51251bbeb44745$var$node.hash = "88dc0e51120ba6a2407f1dcc0359d894";
var $aa51251bbeb44745$export$2e2bcd8739ae039 = $aa51251bbeb44745$var$node;

});

parcelRegister("aZKxL", function(module, exports) {
$parcel$export(module.exports, "default", () => $19e2cd76000c3e07$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8a7ef7e32e28570412d1fd7228cdf995>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $19e2cd76000c3e07$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "pageSize",
            "variableName": "pageSize"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isEditableSyncLoaded"
            },
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isRemoteLinkedIssuesEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "pageSize"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "NativeIssueTableWithSelectedIssuesProvider_issues",
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "issueId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "key"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "jql"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isConditionalFormattingEnabled",
                        "variableName": "isConditionalFormattingEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isDensityFull",
                        "variableName": "isDensityFull"
                    },
                    {
                        "kind": "Variable",
                        "name": "isEditableSyncLoaded",
                        "variableName": "isEditableSyncLoaded"
                    },
                    {
                        "kind": "Variable",
                        "name": "isInlineEditingEnabled",
                        "variableName": "isInlineEditingEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isLinkRelationshipFieldEnabled",
                        "variableName": "isLinkRelationshipFieldEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isRemoteLinkedIssuesEnabled",
                        "variableName": "isRemoteLinkedIssuesEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isReparentingEnabled",
                        "variableName": "isReparentingEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isTimelineEnabled",
                        "variableName": "isTimelineEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "projectKey",
                        "variableName": "projectKey"
                    },
                    {
                        "kind": "Variable",
                        "name": "projectKeys",
                        "variableName": "projectKeys"
                    },
                    {
                        "kind": "Variable",
                        "name": "shouldQueryHasChildren",
                        "variableName": "shouldQueryHasChildren"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "IssueTable_issueConnection"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "FooterRenderer"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "SelectedRowContainer"
            },
            {
                "kind": "FragmentSpread",
                "name": "IssueRealtimeUpdater"
            },
            {
                "kind": "FragmentSpread",
                "name": "RootConnectionRegister"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalIssueSearchResultCount"
                    }
                ]
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$19e2cd76000c3e07$var$node.hash = "a3caa2ffc2a50fee7dd9804bbbb0b313";
var $19e2cd76000c3e07$export$2e2bcd8739ae039 = $19e2cd76000c3e07$var$node;

});

parcelRegister("cDHjO", function(module, exports) {
$parcel$export(module.exports, "default", () => $ffb9a70a0e30be08$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e823476b84c438a45771a4dc39ab805e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ffb9a70a0e30be08$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "NativeIssueTableWithSelectedIssuesProvider",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ColumnConfigWithContainer_savedViewId"
        },
        {
            "kind": "FragmentSpread",
            "name": "IssueTableIssueTable"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$ffb9a70a0e30be08$var$node.hash = "187425a6602b2816d5481a2bd973ae1d";
var $ffb9a70a0e30be08$export$2e2bcd8739ae039 = $ffb9a70a0e30be08$var$node;

});

parcelRegister("PETi0", function(module, exports) {
$parcel$export(module.exports, "ColumnPickerContainer", () => $3bc985482a1599b5$export$e1286e1cb3fa0dec);
$parcel$export(module.exports, "useColumnPickerOpenState", () => $3bc985482a1599b5$export$81588ffe8d9d4add);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $3bc985482a1599b5$export$e1286e1cb3fa0dec = (0, $6E16M.createContainer)();
const $3bc985482a1599b5$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        isOpen: false
    },
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    },
    name: 'ColumnPickerOpenState',
    containedBy: $3bc985482a1599b5$export$e1286e1cb3fa0dec
});
const $3bc985482a1599b5$export$81588ffe8d9d4add = (0, $iJq0l.createHook)($3bc985482a1599b5$var$Store);

});

parcelRegister("88wTt", function(module, exports) {
$parcel$export(module.exports, "default", () => $54e03d97ba1f3fd3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7rjYb = parcelRequire("7rjYb");

var $4cTDP = parcelRequire("4cTDP");

var $5vQ2T = parcelRequire("5vQ2T");

var $dyvFQ = parcelRequire("dyvFQ");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $cWT2N = parcelRequire("cWT2N");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $54e03d97ba1f3fd3$var$ColumnConfig = (0, $bQWwW.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("9NBLG"))), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/issue-table/column-picker/src/ui/ColumnConfigWithContainer.tsx"
});
const $54e03d97ba1f3fd3$var$ErrorFallback = ({ onRetry: onRetry, customIcon: customIcon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cWT2N.default), {
                ...props,
                ref: triggerRef,
                customIcon: customIcon
            }),
        placement: "bottom-end",
        spacing: "compact",
        shouldRenderToParent: (0, $4cTDP.fg)('should-render-to-parent-should-be-true-empanada')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dyvFQ.ErrorState), {
        onRetry: onRetry,
        pageAction: "columnPicker"
    }));
const $54e03d97ba1f3fd3$var$AsyncColumnConfig = (props)=>{
    const [resetCaughtError, setResetCaughtError] = (0, $eJOHy.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraIssueTableColumnPicker",
        id: "unhandled",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($54e03d97ba1f3fd3$var$ErrorFallback, {
                onRetry: ()=>setResetCaughtError(error),
                customIcon: props.components?.Icon
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-column-config",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cWT2N.PickerButtonFallback), {
            customIcon: props.components?.Icon,
            isInBetweenColumnPickerEnabled: props.isInBetweenColumnPickerEnabled
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($54e03d97ba1f3fd3$var$ColumnConfig, props)));
};
var $54e03d97ba1f3fd3$export$2e2bcd8739ae039 = $54e03d97ba1f3fd3$var$AsyncColumnConfig;

});
parcelRegister("dyvFQ", function(module, exports) {
$parcel$export(module.exports, "ErrorState", () => $147eb7ee5e3e0a78$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $goZPP = parcelRequire("goZPP");

var $80DPg = parcelRequire("80DPg");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $ivs94 = parcelRequire("ivs94");

var $1m9Wj = parcelRequire("1m9Wj");
const $147eb7ee5e3e0a78$var$BOX_HEIGHT = 144;
const $147eb7ee5e3e0a78$var$ERROR_ICON_BOX_WRAPPER_HEIGHT = 72;
const $147eb7ee5e3e0a78$var$ICON_SIZE = 72;
const $147eb7ee5e3e0a78$export$c1ed4f415b9e7023 = (props)=>{
    const { pageAction: pageAction, onRetry: onRetry, description: description, role: role } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClick = ()=>{
        onRetry?.();
        (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), `${pageAction}Retry clicked`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($147eb7ee5e3e0a78$var$StyledBox, {
        height: $147eb7ee5e3e0a78$var$BOX_HEIGHT,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($147eb7ee5e3e0a78$var$StyledBox, {
        height: $147eb7ee5e3e0a78$var$ERROR_ICON_BOX_WRAPPER_HEIGHT,
        iconSize: $147eb7ee5e3e0a78$var$ICON_SIZE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        color: "var(--ds-icon, #292A2E)",
        LEGACY_primaryColor: "var(--ds-icon, #292A2E)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1m9Wj.StyledText), null, description !== undefined ? description : formatMessage((0, $ivs94.default).errorMessage)), onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: onClick,
        appearance: "link",
        testId: "issue-navigator-actions-common.ui.error.button"
    }, formatMessage((0, $ivs94.default).retryMessage)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $147eb7ee5e3e0a78$var$StyledBox = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $awdRS.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _19pkpxbi _2hwx1ejb _otyrpxbi _18u01ejb",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ivs94", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fc2779f4954708a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7fc2779f4954708a$var$messages = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-actions-common.error.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "issue-navigator-actions-common.error.retry-message",
        "defaultMessage": "Click to retry"
    }
});
var $7fc2779f4954708a$export$2e2bcd8739ae039 = $7fc2779f4954708a$var$messages;

});

parcelRegister("1m9Wj", function(module, exports) {
$parcel$export(module.exports, "StyledText", () => $fe5d3814363465dc$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $806LH = parcelRequire("806LH");
const $fe5d3814363465dc$export$d675f139b342d51a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $awdRS.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _19pkpxbi _2hwx1ejb _otyrpxbi _18u01ejb",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});
const $fe5d3814363465dc$var$StyledTextComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $fe5d3814363465dc$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fe5d3814363465dc$var$StyledTextComponent, props));

});


parcelRegister("cWT2N", function(module, exports) {
$parcel$export(module.exports, "PickerButtonFallback", () => $19f27efe9b61f432$export$d2ed0044a1cffec6);
$parcel$export(module.exports, "default", () => $19f27efe9b61f432$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $Ay1uj = parcelRequire("Ay1uj");

var $dcLzM = parcelRequire("dcLzM");

var $2a3IQ = parcelRequire("2a3IQ");

var $iiRWr = parcelRequire("iiRWr");

var $k71qx = parcelRequire("k71qx");

var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $4cTDP = parcelRequire("4cTDP");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $fbuFM = parcelRequire("fbuFM");
const $19f27efe9b61f432$var$PickerButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, isLoading: isLoading = false, isSelected: isSelected = false, customIcon: customIcon, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, onPickerMouseEnter: onPickerMouseEnter, onPickerMouseLeave: onPickerMouseLeave }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const iconColor = isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)";
    const tooltipContent = formatMessage(isInBetweenColumnPickerEnabled && (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $fbuFM.default).addColumnTooltipText : (0, $fbuFM.default).tooltipText);
    const tooltipOptions = {
        position: 'bottom',
        content: tooltipContent,
        delay: 0
    };
    const isDisabled = !isSelected && isLoading;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'ninColumnPickerButton', {
            isInline: !!isInBetweenColumnPickerEnabled
        });
        onClick?.(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isInBetweenColumnPickerEnabled,
        onClick
    ]);
    if (isInBetweenColumnPickerEnabled && (0, $4cTDP.fg)('jira_inline_field_config_gate')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "top",
        content: tooltipContent,
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $19f27efe9b61f432$var$pressableStyles,
        testId: "issue-table-column-picker.ui.column-picker.picker-button.pressable-add-column",
        isDisabled: isDisabled,
        onClick: handleOnClick,
        onMouseEnter: onPickerMouseEnter,
        onMouseLeave: onPickerMouseLeave,
        ref: ref,
        "aria-haspopup": "true",
        "aria-expanded": isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
        label: tooltipContent
    })));
    const icon = customIcon ?? ((0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, (/*@__PURE__*/$parcel$interopDefault($2a3IQ))) : (0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))));
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: icon,
        testId: "issue-table-column-picker.ui.column-picker.picker-button.picker-button",
        label: tooltipContent,
        appearance: "subtle",
        isDisabled: isDisabled,
        onClick: (0, $4cTDP.fg)('jira_inline_field_config_gate') ? handleOnClick : onClick,
        ref: ref,
        "aria-haspopup": "true",
        "aria-expanded": isSelected,
        isSelected: isSelected,
        tooltip: tooltipOptions,
        isTooltipDisabled: false,
        ...(0, $4cTDP.fg)('relay_migration_children_issues_section') ? {
            spacing: 'compact'
        } : {}
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "bottom",
        content: tooltipContent,
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        testId: "issue-table-column-picker.ui.column-picker.picker-button.picker-button",
        "aria-label": tooltipContent,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iiRWr))), {
            label: "",
            spacing: "spacious",
            color: iconColor
        }),
        isDisabled: isDisabled,
        onClick: (0, $4cTDP.fg)('jira_inline_field_config_gate') ? handleOnClick : onClick,
        ref: ref,
        "aria-haspopup": "true",
        "aria-expanded": isSelected,
        isSelected: isSelected,
        ...(0, $4cTDP.fg)('relay_migration_children_issues_section') ? {
            spacing: 'compact'
        } : {}
    }));
});
const $19f27efe9b61f432$export$d2ed0044a1cffec6 = ({ customIcon: customIcon, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tooltipContent = formatMessage(isInBetweenColumnPickerEnabled && (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $fbuFM.default).addColumnTooltipText : (0, $fbuFM.default).tooltipText);
    if (isInBetweenColumnPickerEnabled && (0, $4cTDP.fg)('jira_inline_field_config_gate')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "top",
        content: tooltipContent,
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $19f27efe9b61f432$var$pressableStyles,
        isDisabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
        label: tooltipContent
    })));
    const icon = customIcon ?? ((0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, (/*@__PURE__*/$parcel$interopDefault($2a3IQ))) : (0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))));
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: icon,
        label: tooltipContent,
        appearance: "subtle",
        isDisabled: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        "aria-label": formatMessage((0, $fbuFM.default).tooltipText),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iiRWr))), {
            color: "currentColor",
            label: ""
        }),
        isDisabled: true
    });
};
const $19f27efe9b61f432$var$pressableStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '24px',
    width: '24px',
    borderRadius: "var(--ds-radius-small, 4px)",
    position: 'relative',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    boxShadow: 'elevation.shadow.overlay',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
var $19f27efe9b61f432$export$2e2bcd8739ae039 = $19f27efe9b61f432$var$PickerButton;

});
parcelRegister("fbuFM", function(module, exports) {
$parcel$export(module.exports, "default", () => $066cf44b88090e47$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $066cf44b88090e47$var$messages = (0, $7qGN1.defineMessages)({
    tooltipText: {
        "id": "issue-table-column-picker.column-picker.picker-button.tooltip-text",
        "defaultMessage": "Configure columns"
    },
    addColumnTooltipText: {
        "id": "issue-table-column-picker.column-picker.picker-button.add-column-tooltip-text",
        "defaultMessage": "Add column"
    },
    columnPickerButtonText: {
        "id": "issue-table-column-picker.column-picker.picker-button.column-picker-button-text",
        "defaultMessage": "Column picker menu"
    },
    chevronDownIconText: {
        "id": "issue-table-column-picker.column-picker.picker-button.chevron-down-icon-text",
        "defaultMessage": "Chevron down icon"
    },
    boardIconText: {
        "id": "issue-table-column-picker.column-picker.picker-button.board-icon-text",
        "defaultMessage": "board icon"
    }
});
var $066cf44b88090e47$export$2e2bcd8739ae039 = $066cf44b88090e47$var$messages;

});


parcelRegister("9NBLG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $40052367dcb6c307$export$2e2bcd8739ae039);

var $fhGpI = parcelRequire("fhGpI");

var $jHGWc = parcelRequire("jHGWc");

var $eJOHy = parcelRequire("eJOHy");

var $f0K4l = parcelRequire("f0K4l");

var $j4oe4 = parcelRequire("j4oe4");

var $LFmXM = parcelRequire("LFmXM");

var $99mLG = parcelRequire("99mLG");

var $fwzaq = parcelRequire("fwzaq");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $d9b92 = parcelRequire("d9b92");

var $cjRWP = parcelRequire("cjRWP");

var $o3Hdn = parcelRequire("o3Hdn");

var $gMbEk = parcelRequire("gMbEk");

var $6d9QY = parcelRequire("6d9QY");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $j8Km1 = parcelRequire("j8Km1");

var $d8Dow = parcelRequire("d8Dow");

var $5NRap = parcelRequire("5NRap");

var $PETi0 = parcelRequire("PETi0");

var $itmi8 = parcelRequire("itmi8");

var $ft2LQ = parcelRequire("ft2LQ");

var $fpyg5 = parcelRequire("fpyg5");
const $40052367dcb6c307$var$mapSelectedColumns = (0, $LFmXM.default)((fieldSets, canEditColumnConfiguration, formatMessage)=>fieldSets.edges.filter(Boolean).map((edge)=>{
        const icon = edge.node.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99mLG.FieldTypeIcon), {
            type: edge.node.type,
            size: "small"
        }) : undefined;
        const fieldTypeDisplayName = edge.node.fieldType?.displayName;
        return {
            optionType: 'option',
            value: edge.node.fieldSetId,
            label: edge.node.displayName,
            secondaryLabel: fieldTypeDisplayName && icon ? (0, $cjRWP.getSecondaryLabelWithIcon)(icon, fieldTypeDisplayName) : undefined,
            isDisabled: !canEditColumnConfiguration,
            isOnlyUnselectable: (0, $fpyg5.isOnlyUnselectableField)(edge.node.type, canEditColumnConfiguration),
            disabledMessage: (0, $fpyg5.getFieldDisabledMessage)(edge.node.type, formatMessage),
            ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                type: edge.node.type
            }
        };
    }));
const $40052367dcb6c307$var$ColumnConfig = ({ view: view, columns: columns, components: components, onChange: onChangeProp, onRestoreDefaultColumns: onRestoreDefaultColumnsProp, useColumnLoader: useColumnLoader, isLoading: isLoading = false, columnInsertIndex: columnInsertIndex, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, isMergedColumnEnabled: isMergedColumnEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, showInlineFieldCreateOnboarding: showInlineFieldCreateOnboarding, onPickerMouseEnter: onPickerMouseEnter, onPickerMouseLeave: onPickerMouseLeave, projectContext: projectContext })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isColumnUpdateInProgress = (0, $eJOHy.useRef)(false);
    const environment = (0, $j4oe4.useRelayEnvironment)();
    // This fragment should be moved to a different file whose responsibility is to provide the savedViewId
    const viewData = (0, $j4oe4.useFragment)((0, $jHGWc.default), view ?? null);
    const columnsData = (0, $j4oe4.useFragment)((0, $fhGpI.default), columns);
    const canEditColumnConfiguration = onChangeProp !== undefined;
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>{
        const columnPickerNumberOfColumns = columnsData.totalCount;
        const columnPickerFieldTypesSet = new Set();
        columnsData.edges.map((edge)=>edge?.node.type).filter(Boolean).forEach(columnPickerFieldTypesSet.add, columnPickerFieldTypesSet);
        const columnPickerFieldTypes = Array.from(columnPickerFieldTypesSet).sort();
        return {
            columnPickerNumberOfColumns: columnPickerNumberOfColumns,
            columnPickerFieldTypes: columnPickerFieldTypes,
            pickerType: 'columnConfiguration'
        };
    }, [
        columnsData.edges,
        columnsData.totalCount
    ]);
    const [selectedColumns, setSelectedColumns] = (0, $eJOHy.useState)(()=>$40052367dcb6c307$var$mapSelectedColumns(columnsData, canEditColumnConfiguration, formatMessage));
    const mappedColumnsDataRef = (0, $eJOHy.useRef)($40052367dcb6c307$var$mapSelectedColumns(columnsData, canEditColumnConfiguration, formatMessage));
    const prevColumnsDataRef = (0, $eJOHy.useRef)(columnsData);
    if (prevColumnsDataRef.current !== columnsData && (0, $4cTDP.fg)('jira_inline_field_config_gate')) {
        mappedColumnsDataRef.current = $40052367dcb6c307$var$mapSelectedColumns(columnsData, canEditColumnConfiguration, formatMessage);
        prevColumnsDataRef.current = columnsData;
    }
    const selectedColumnsBeforeUpdateRef = (0, $eJOHy.useRef)(mappedColumnsDataRef.current);
    let backupFieldsRef;
    if ((0, $4cTDP.fg)('jira_inline_field_config_gate')) // eslint-disable-next-line react-hooks/rules-of-hooks
    backupFieldsRef = (0, $eJOHy.useRef)((0, $fpyg5.getRollbackFields)({
        environment: environment,
        fieldConfigId: columnsData.__id
    }));
    const [{ isOpen: isOpen }, { open: open, close: close }] = (0, $PETi0.useColumnPickerOpenState)();
    const prevIsOpen = (0, $6d9QY.usePreviousWithInitial)(isOpen);
    (0, $eJOHy.useEffect)(()=>{
        // Recompute selected columns when picker renders in open state as config data may have changed
        if (!prevIsOpen && isOpen) setSelectedColumns($40052367dcb6c307$var$mapSelectedColumns(columnsData, canEditColumnConfiguration, formatMessage));
    }, [
        canEditColumnConfiguration,
        columnsData,
        formatMessage,
        isOpen,
        prevIsOpen
    ]);
    const [debouncedSetSelectedColumns] = (0, $fwzaq.default)((options, isHorizontalAutoScrollNeeded, onSuccessCallback, onErrorCallback, isHorizontalAutoScrollLeftNeeded)=>{
        const columnIds = options.map((option)=>(0, $gMbEk.isSingleValueOption)(option) ? option.value : undefined).filter(Boolean);
        if ((0, $4cTDP.fg)('jira_inline_field_config_gate')) {
            const attributes = {
                isInline: columnInsertIndex !== undefined,
                actionType: options.length < selectedColumnsBeforeUpdateRef.current.length ? (0, $d8Dow.REMOVE_COLUMNS) : (0, $d8Dow.ADD_COLUMNS)
            };
            onChangeProp && onChangeProp({
                columnIds: columnIds,
                onSuccessCallback: ()=>{
                    onSuccessCallback?.();
                    selectedColumnsBeforeUpdateRef.current = mappedColumnsDataRef.current;
                    if (backupFieldsRef) backupFieldsRef.current = (0, $fpyg5.getRollbackFields)({
                        environment: environment,
                        fieldConfigId: columnsData.__id
                    });
                },
                onErrorCallback: ()=>{
                    onErrorCallback?.();
                    if (backupFieldsRef) (0, $fpyg5.rollbackOptimisticFieldConfig)({
                        environment: environment,
                        fieldConfigId: columnsData.__id,
                        fields: backupFieldsRef?.current
                    });
                    setSelectedColumns(selectedColumnsBeforeUpdateRef.current);
                },
                isHorizontalAutoScrollNeeded: isHorizontalAutoScrollNeeded,
                isHorizontalAutoScrollLeftNeeded: isHorizontalAutoScrollLeftNeeded,
                analyticsAttributes: attributes
            });
        } else onChangeProp && onChangeProp(columnIds);
        isColumnUpdateInProgress.current = false;
    }, 1000);
    const handleOnChangeOld = (0, $eJOHy.useCallback)((options)=>{
        if ((0, $o3Hdn.isSelectOptionArray)(options)) {
            setSelectedColumns(options);
            debouncedSetSelectedColumns(options);
        }
    }, [
        debouncedSetSelectedColumns,
        setSelectedColumns
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)((options, onSuccessCallback, onErrorCallback)=>{
        isColumnUpdateInProgress.current = true;
        if (!(0, $o3Hdn.isSelectOptionArray)(options)) return;
        if (mappedColumnsDataRef.current.length >= options.length) {
            const removedFields = (0, $fpyg5.findRemovedFields)(options, mappedColumnsDataRef.current);
            (0, $fpyg5.deleteOptimisticFieldConfig)({
                environment: environment,
                fieldConfigId: columnsData.__id,
                fields: removedFields
            });
            const newOptions = isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate') ? (0, $fpyg5.sortMergedColumnOptions)(options) : options;
            setSelectedColumns(newOptions);
            debouncedSetSelectedColumns(newOptions, false, onSuccessCallback, onErrorCallback, false);
            return;
        }
        const insertFields = (0, $fpyg5.findNewInsertFields)(options, mappedColumnsDataRef.current);
        const fields = [];
        insertFields.forEach((option)=>{
            if ((0, $gMbEk.isSingleValueOption)(option)) {
                const { label: label, value: value, type: type } = option;
                fields.push({
                    fieldSetId: value,
                    name: label,
                    type: type,
                    customWidth: option.customWidth
                });
            }
        });
        (0, $fpyg5.createOptimisticFieldConfig)({
            environment: environment,
            fieldConfigId: columnsData.__id,
            fields: fields,
            createIndex: columnInsertIndex
        });
        let isHorizontalAutoScrollLeftNeeded = false;
        let updatedOptions = (0, $fpyg5.getUpdatedOptions)(mappedColumnsDataRef.current, insertFields, columnInsertIndex);
        if (isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate')) {
            updatedOptions = (0, $fpyg5.sortMergedColumnOptions)(updatedOptions);
            isHorizontalAutoScrollLeftNeeded = !!fields.find(({ fieldSetId: fieldSetId })=>(0, $j8Km1.MERGED_COLUMN_IDS).includes(fieldSetId));
        }
        setSelectedColumns(updatedOptions);
        debouncedSetSelectedColumns(updatedOptions, columnInsertIndex === undefined && !isHorizontalAutoScrollLeftNeeded, onSuccessCallback, onErrorCallback, isHorizontalAutoScrollLeftNeeded);
    }, [
        columnInsertIndex,
        columnsData.__id,
        debouncedSetSelectedColumns,
        environment,
        isMergedColumnEnabled
    ]);
    const handleOnOpen = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'screen'
        });
        const attributes = {
            actionType: 'open'
        };
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'ninDefaultsColumnPickerDialog', attributes);
        open();
    }, [
        createAnalyticsEvent,
        open
    ]);
    const onChange = (0, $eJOHy.useCallback)((options, meta, _, onSuccessCallback, onErrorCallback)=>{
        if (meta.action === (0, $d9b92.MetaActions).selectOption && (0, $o3Hdn.isSelectOptionArray)(options) && options.length > (0, $d8Dow.MAX_COLUMNS)) return;
        if ((0, $4cTDP.fg)('jira_inline_field_config_gate')) handleOnChange(options, onSuccessCallback, onErrorCallback);
        else handleOnChangeOld(options);
        let mergedFieldsCount = 0;
        if (Array.isArray(options) && (0, $4cTDP.fg)('jira_list_merged_column_gate')) options?.forEach((option)=>{
            if ('value' in option && (0, $j8Km1.MERGED_COLUMN_IDS).includes(option.value)) mergedFieldsCount += 1;
        });
        if (meta.action === (0, $d9b92.MetaActions).selectOption || meta.action === (0, $d9b92.MetaActions).deselectOption) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'checkbox changed', 'columnPickerField', {
            checkboxChecked: meta.action === (0, $d9b92.MetaActions).selectOption,
            ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                isInline: !!isInBetweenColumnPickerEnabled
            },
            ...meta.option && 'value' in meta.option && (0, $4cTDP.fg)('jira_list_merged_column_gate') && {
                fieldType: meta.option?.value
            },
            ...(0, $4cTDP.fg)('jira_list_merged_column_gate') && {
                isMergedColumnVisible: mergedFieldsCount > 1
            }
        });
    }, [
        createAnalyticsEvent,
        handleOnChange,
        handleOnChangeOld,
        isInBetweenColumnPickerEnabled
    ]);
    const loadOptions = useColumnLoader(selectedColumns, isInlineFieldConfigEnabled, projectContext, viewData?.savedViewId);
    const onRestoreDefaults = (0, $eJOHy.useCallback)(()=>{
        onRestoreDefaultColumnsProp && onRestoreDefaultColumnsProp();
        return [];
    }, [
        onRestoreDefaultColumnsProp
    ]);
    // Compute a set of all fieldSetIds that have been selected/deselected and not yet committed in the BE
    // Remove memoised data when cleaning up jira_inline_field_config_gate
    const nonCommittedFieldSetIds = (0, $eJOHy.useMemo)(()=>{
        const localFieldSetIds = selectedColumns.map((option)=>'value' in option ? option.value : undefined).filter((0, $5NRap.isNonNullish));
        const remoteFieldSetIds = columnsData.edges.filter((0, $5NRap.isNonNullish)).map((edge)=>edge.node.fieldSetId);
        return (0, $4cTDP.fg)('jira_inline_field_config_gate') ? new Set() : new Set((0, (/*@__PURE__*/$parcel$interopDefault($f0K4l)))(localFieldSetIds, remoteFieldSetIds));
    }, [
        columnsData.edges,
        selectedColumns
    ]);
    const formatOptionLabel = (0, $ft2LQ.useFormatOptionLabelWithShimmer)(nonCommittedFieldSetIds);
    const conditionalOnrestoreDefaults = onRestoreDefaultColumnsProp !== undefined ? onRestoreDefaults : false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "fieldSearch",
        sourceType: (0, $aa42ce8e355d58fa$export$cae2783c9279926),
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $itmi8.default), {
        components: components,
        formatOptionLabel: formatOptionLabel,
        onLoadOptions: loadOptions,
        onChange: onChange,
        onSortOptions: isMergedColumnEnabled ? (0, $fpyg5.sortMergedColumnOptions) : undefined,
        onRestoreDefaults: conditionalOnrestoreDefaults,
        selectedColumns: selectedColumns,
        isOpen: isOpen,
        onOpen: handleOnOpen,
        onClose: close,
        isLoading: isLoading,
        isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
        ...(0, $4cTDP.fg)('jira_inline_field_config_gate') ? {
            columnsDataId: columnsData.__id,
            columnInsertIndex: columnInsertIndex
        } : {},
        showInlineFieldCreateOnboarding: showInlineFieldCreateOnboarding,
        onPickerMouseEnter: onPickerMouseEnter,
        onPickerMouseLeave: onPickerMouseLeave
    }));
};
const $40052367dcb6c307$var$ColumnConfigWithContainer = (props)=>{
    const Container = props.components?.Container ?? (0, $eJOHy.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($40052367dcb6c307$var$ColumnConfig, props));
};
var $40052367dcb6c307$export$2e2bcd8739ae039 = $40052367dcb6c307$var$ColumnConfigWithContainer;

});
parcelRegister("fhGpI", function(module, exports) {
$parcel$export(module.exports, "default", () => $8479508b3ee93b2a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4457a7ce1b37b60bd16542e6e54badaa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8479508b3ee93b2a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ColumnConfigWithContainer",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                "action": "THROW",
                "path": "totalCount"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssueSearchFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraIssueSearchFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "kind": "ScalarField",
                                            "name": "fieldSetId"
                                        },
                                        "action": "THROW",
                                        "path": "edges.node.fieldSetId"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        "action": "THROW",
                                        "path": "edges.node.type"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v0 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "edges.node.displayName"
                                    },
                                    {
                                        "concreteType": "JiraFieldType",
                                        "kind": "LinkedField",
                                        "name": "fieldType",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "edges.node"
                        }
                    ]
                },
                "action": "THROW",
                "path": "edges"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ],
        "type": "JiraIssueSearchFieldSetConnection"
    };
}();
$8479508b3ee93b2a$var$node.hash = "3ae1385f88e17b8e9d2dda509c942a08";
var $8479508b3ee93b2a$export$2e2bcd8739ae039 = $8479508b3ee93b2a$var$node;

});

parcelRegister("jHGWc", function(module, exports) {
$parcel$export(module.exports, "default", () => $199449ba5db0a0ce$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<907e4fea993562414a0211669e4610ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $199449ba5db0a0ce$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "ColumnConfigWithContainer_savedViewId",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "savedViewId"
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$199449ba5db0a0ce$var$node.hash = "afbf244a6fb59419cd38207a8d27060a";
var $199449ba5db0a0ce$export$2e2bcd8739ae039 = $199449ba5db0a0ce$var$node;

});

parcelRegister("f0K4l", function(module, exports) {

var $821Ou = parcelRequire("821Ou");

var $l76qh = parcelRequire("l76qh");

var $hm1zt = parcelRequire("hm1zt");

var $d1ShJ = parcelRequire("d1ShJ");
/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */ var $aeda977b669045b0$var$xor = $l76qh(function(arrays) {
    return $hm1zt($821Ou(arrays, $d1ShJ));
});
module.exports = $aeda977b669045b0$var$xor;

});
parcelRegister("hm1zt", function(module, exports) {

var $leN9Q = parcelRequire("leN9Q");

var $72Qfa = parcelRequire("72Qfa");

var $1txRh = parcelRequire("1txRh");
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $ca25b5c1c14f707f$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $1txRh(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $leN9Q(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $1txRh($72Qfa(result, 1), iteratee, comparator);
}
module.exports = $ca25b5c1c14f707f$var$baseXor;

});


parcelRegister("99mLG", function(module, exports) {
$parcel$export(module.exports, "fieldTypesIcons", () => $fdaf5e373b76ddd5$export$67f993f3bbfb364d);
$parcel$export(module.exports, "panelIcons", () => $fdaf5e373b76ddd5$export$4641b622f6c36f58);
$parcel$export(module.exports, "allFieldTypeGlyphs", () => $fdaf5e373b76ddd5$export$14355977bfae6aaa);
$parcel$export(module.exports, "StrictFieldTypeIcon", () => $fdaf5e373b76ddd5$export$aaac7dbe01e6025d);
$parcel$export(module.exports, "FieldTypeIcon", () => $fdaf5e373b76ddd5$export$87c5289d8835f589);
$parcel$export(module.exports, "default", () => $fdaf5e373b76ddd5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $leHbU = parcelRequire("leHbU");

var $fL0In = parcelRequire("fL0In");

var $9qes7 = parcelRequire("9qes7");

var $lmJ87 = parcelRequire("lmJ87");

var $awZZu = parcelRequire("awZZu");

var $1x1T9 = parcelRequire("1x1T9");

var $eALjj = parcelRequire("eALjj");

var $6F4i5 = parcelRequire("6F4i5");

var $3mZMJ = parcelRequire("3mZMJ");

var $4cTDP = parcelRequire("4cTDP");

var $itRkB = parcelRequire("itRkB");
// @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => ReactElement<any, string | JSXElementConstructor<any>>' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'.
// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
const $fdaf5e373b76ddd5$var$ResizedIcon = ({ glyph: glyph })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        label: "",
        glyph: glyph,
        size: "medium"
    });
const $fdaf5e373b76ddd5$var$TeamCfTypeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eALjj)));
const $fdaf5e373b76ddd5$var$checkedFieldTypesIcons = {
    [(0, $3mZMJ.NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.numberGlyph)
    }),
    [(0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.numberGlyph)
    }),
    [(0, $3mZMJ.LABELS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.labelGlyph)
    }),
    [(0, $3mZMJ.DATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dateGlyph)
    }),
    [(0, $3mZMJ.DATETIME_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.timeStampGlyph)
    }),
    [(0, $3mZMJ.RADIO_BUTTONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.radioGlyph)
    }),
    [(0, $3mZMJ.SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    [(0, $3mZMJ.MULTI_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    [(0, $3mZMJ.CASCADING_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.doubleDropdownGlyph)
    }),
    [(0, $3mZMJ.MULTI_VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    [(0, $3mZMJ.VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    [(0, $3mZMJ.GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    [(0, $3mZMJ.MULTI_GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    [(0, $3mZMJ.USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGlyph)
    }),
    [(0, $leHbU.USERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGlyph)
    }),
    [(0, $3mZMJ.MULTI_USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGlyph)
    }),
    [(0, $leHbU.MULTIUSERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGlyph)
    }),
    [(0, $3mZMJ.PEOPLE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGlyph)
    }),
    [(0, $3mZMJ.FLAGGED_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.timeStampGlyph)
    }),
    [(0, $3mZMJ.URL_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.customFieldGlyph)
    }),
    [(0, $3mZMJ.TEAM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.customFieldGlyph)
    }),
    // <ResizedIcon /> was introduced when SWIFT had a limited number of supported field types,
    // but it's no longer a scalable option. We should be using icons directly provided by @atlaskit,
    // and if it does not match our design constraints, then we'll need to investigate contributing to a new @atlaskit icon set.
    [(0, $3mZMJ.TEAMS_PLATFORM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$TeamCfTypeIcon, {
        spacing: "spacious",
        label: ""
    }),
    [(0, $3mZMJ.PARENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.customFieldGlyph)
    }),
    [(0, $3mZMJ.BASELINE_START_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dateGlyph)
    }),
    [(0, $3mZMJ.BASELINE_END_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dateGlyph)
    }),
    [(0, $3mZMJ.SPRINT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.shipGlyph)
    }),
    [(0, $3mZMJ.REQUEST_PARTICIPANTS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGroupGlyph)
    }),
    [(0, $3mZMJ.ORGANIZATIONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.officeBuildingGlyph)
    }),
    [(0, $3mZMJ.REPORTER_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGlyph)
    }),
    [(0, $3mZMJ.ATTACHMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.attachmentGlyph)
    }),
    [(0, $3mZMJ.ASSIGNEE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGlyph)
    }),
    [(0, $3mZMJ.LABELS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.labelGlyph)
    }),
    [(0, $3mZMJ.PRIORITY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.priorityGlyph)
    }),
    [(0, $3mZMJ.DUE_DATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dateGlyph)
    }),
    [(0, $3mZMJ.TIME_ESTIMATE_CONFIG_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.timeStampGlyph)
    }),
    [(0, $3mZMJ.TIME_TRACKING_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.timeTrackingGlyph)
    }),
    [(0, $3mZMJ.TIME_ESTIMATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.originalTimeEstimateGlyph)
    }),
    [(0, $3mZMJ.ASSETS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.screenGlyph)
    }),
    [(0, $3mZMJ.SERVICE_ENTITY_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.labelGlyph)
    }),
    [(0, $3mZMJ.STATUS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.arrowRightGlyph)
    }),
    [(0, $3mZMJ.SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.shortTextGlyph)
    }),
    [(0, $leHbU.DESCRIPTION_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.paragraphGlyph)
    }),
    [(0, $3mZMJ.TEXT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.shortTextGlyph)
    }),
    [(0, $leHbU.TEXT_AREA_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.paragraphGlyph)
    }),
    [(0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.checkboxGlyph)
    }),
    [(0, $3mZMJ.ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.customFieldGlyph)
    }),
    [(0, $leHbU.ENVIRONMENT_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.paragraphGlyph)
    }),
    [(0, $3mZMJ.FIX_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    [(0, $3mZMJ.COMMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.commentGlyph)
    }),
    [(0, $3mZMJ.APPROVERS_LIST_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.appAccessGlyph)
    }),
    [(0, $3mZMJ.APPROVALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.appAccessGlyph)
    }),
    [(0, $3mZMJ.PROJECT_PICKER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.folderGlyph)
    }),
    [(0, $3mZMJ.MESSAGE_EDIT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.paragraphGlyph)
    }),
    [(0, $3mZMJ.MESSAGE_VIEW_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.paragraphGlyph)
    }),
    [(0, $3mZMJ.CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.jwmCategoryGlyph)
    }),
    [(0, $3mZMJ.ENTITLEMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    [(0, $3mZMJ.SENTIMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.customFieldGlyph)
    }),
    [(0, $3mZMJ.GOALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qes7))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }),
    [(0, $3mZMJ.ATLAS_PROJECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lmJ87))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }),
    [(0, $3mZMJ.ORGANIZATION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.customFieldGlyph)
    }),
    [(0, $3mZMJ.FORMULA_NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6F4i5))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    })
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
({
    ...$fdaf5e373b76ddd5$var$checkedFieldTypesIcons
});
const $fdaf5e373b76ddd5$export$67f993f3bbfb364d = $fdaf5e373b76ddd5$var$checkedFieldTypesIcons;
const $fdaf5e373b76ddd5$export$4641b622f6c36f58 = {
    development: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($awZZu))), {
        label: "",
        spacing: "spacious"
    }),
    devSummary: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($awZZu))), {
        label: "",
        spacing: "spacious"
    }),
    timetracking: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1x1T9))), {
        label: "",
        spacing: "spacious"
    })
};
/**
 * @deprecated - consider using allFieldTypeGlyphs or FieldTypeIcon instead
 */ const $fdaf5e373b76ddd5$var$allIcons = {
    ...$fdaf5e373b76ddd5$export$67f993f3bbfb364d,
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.paragraphGlyph)
    }),
    number: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.numberGlyph)
    }),
    date: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dateGlyph)
    }),
    datetime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.timeStampGlyph)
    }),
    dropdown: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    addon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.addonGlyph)
    }),
    checkbox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.checkboxGlyph)
    }),
    user: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGlyph)
    }),
    radio: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.radioGlyph)
    }),
    time: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.timeStampGlyph)
    }),
    message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.commentGlyph)
    }),
    bulletList: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.bulletListGlyph)
    }),
    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.labelGlyph)
    }),
    labelpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.labelGlyph)
    }),
    close: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.closeGlyph)
    }),
    assetspicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.screenGlyph)
    }),
    select: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    multiselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    cascadingselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.doubleDropdownGlyph)
    }),
    multigrouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    grouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    multiversion: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    version: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    projectpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    customField: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.customFieldGlyph)
    })
};
const $fdaf5e373b76ddd5$var$checkedFieldTypesGlyphs = {
    [(0, $3mZMJ.NUMBER_CF_TYPE)]: (0, $itRkB.numberGlyph),
    [(0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE)]: (0, $itRkB.numberGlyph),
    [(0, $3mZMJ.LABELS_CF_TYPE)]: (0, $itRkB.labelGlyph),
    [(0, $3mZMJ.DATE_CF_TYPE)]: (0, $itRkB.dateGlyph),
    [(0, $3mZMJ.DATETIME_CF_TYPE)]: (0, $itRkB.timeStampGlyph),
    [(0, $3mZMJ.RADIO_BUTTONS_CF_TYPE)]: (0, $itRkB.radioGlyph),
    [(0, $3mZMJ.SELECT_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.MULTI_SELECT_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.CASCADING_SELECT_CF_TYPE)]: (0, $itRkB.doubleDropdownGlyph),
    [(0, $3mZMJ.MULTI_VERSION_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.VERSION_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.GROUP_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.MULTI_GROUP_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.USER_CF_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $leHbU.USERPICKER_FIELD_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $3mZMJ.MULTI_USER_CF_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $leHbU.MULTIUSERPICKER_FIELD_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $3mZMJ.PEOPLE_CF_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $3mZMJ.FLAGGED_CF_TYPE)]: (0, $itRkB.timeStampGlyph),
    [(0, $3mZMJ.URL_CF_TYPE)]: (0, $itRkB.customFieldGlyph),
    [(0, $3mZMJ.TEAM_CF_TYPE)]: (0, $itRkB.customFieldGlyph),
    [(0, $3mZMJ.PARENT_CF_TYPE)]: (0, $itRkB.customFieldGlyph),
    [(0, $3mZMJ.BASELINE_START_CF_TYPE)]: (0, $itRkB.dateGlyph),
    [(0, $3mZMJ.BASELINE_END_CF_TYPE)]: (0, $itRkB.dateGlyph),
    [(0, $3mZMJ.SPRINT_TYPE)]: (0, $itRkB.shipGlyph),
    [(0, $3mZMJ.REQUEST_PARTICIPANTS_CF_TYPE)]: (0, $itRkB.peopleGroupGlyph),
    [(0, $3mZMJ.ORGANIZATIONS_CF_TYPE)]: (0, $itRkB.officeBuildingGlyph),
    [(0, $3mZMJ.REPORTER_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $3mZMJ.ATTACHMENT_TYPE)]: (0, $itRkB.attachmentGlyph),
    [(0, $3mZMJ.ASSIGNEE_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $3mZMJ.LABELS_TYPE)]: (0, $itRkB.labelGlyph),
    [(0, $3mZMJ.PRIORITY_TYPE)]: (0, $itRkB.priorityGlyph),
    [(0, $3mZMJ.DUE_DATE_TYPE)]: (0, $itRkB.dateGlyph),
    [(0, $3mZMJ.TIME_ESTIMATE_CONFIG_TYPE)]: (0, $itRkB.timeStampGlyph),
    [(0, $3mZMJ.TIME_TRACKING_TYPE)]: (0, $itRkB.timeTrackingGlyph),
    [(0, $3mZMJ.TIME_ESTIMATE_TYPE)]: (0, $itRkB.originalTimeEstimateGlyph),
    [(0, $3mZMJ.ASSETS_CF_TYPE)]: (0, $itRkB.screenGlyph),
    [(0, $3mZMJ.SERVICE_ENTITY_CF_TYPE)]: (0, $itRkB.labelGlyph),
    [(0, $3mZMJ.STATUS_TYPE)]: (0, $itRkB.arrowRightGlyph),
    [(0, $3mZMJ.SUMMARY_TYPE)]: (0, $itRkB.shortTextGlyph),
    [(0, $leHbU.DESCRIPTION_FIELD_TYPE)]: (0, $itRkB.paragraphGlyph),
    [(0, $3mZMJ.TEXT_CF_TYPE)]: (0, $itRkB.shortTextGlyph),
    [(0, $leHbU.TEXT_AREA_CF_TYPE)]: (0, $itRkB.paragraphGlyph),
    [(0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE)]: (0, $itRkB.checkboxGlyph),
    [(0, $3mZMJ.ISSUE_LINKS_TYPE)]: (0, $itRkB.customFieldGlyph),
    [(0, $leHbU.ENVIRONMENT_FIELD_TYPE)]: (0, $itRkB.paragraphGlyph),
    [(0, $3mZMJ.FIX_VERSIONS_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.COMMENT_TYPE)]: (0, $itRkB.commentGlyph),
    [(0, $3mZMJ.APPROVERS_LIST_CF_TYPE)]: (0, $itRkB.appAccessGlyph),
    [(0, $3mZMJ.APPROVALS_CF_TYPE)]: (0, $itRkB.appAccessGlyph),
    [(0, $3mZMJ.PROJECT_PICKER_CF_TYPE)]: (0, $itRkB.folderGlyph),
    [(0, $3mZMJ.MESSAGE_EDIT_CF_TYPE)]: (0, $itRkB.paragraphGlyph),
    [(0, $3mZMJ.MESSAGE_VIEW_CF_TYPE)]: (0, $itRkB.paragraphGlyph),
    [(0, $3mZMJ.CATEGORY_TYPE)]: (0, $itRkB.jwmCategoryGlyph),
    [(0, $3mZMJ.ENTITLEMENT_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.SENTIMENT_CF_TYPE)]: (0, $itRkB.customFieldGlyph),
    [(0, $3mZMJ.ORGANIZATION_CF_TYPE)]: (0, $itRkB.customFieldGlyph),
    [(0, $3mZMJ.ATLAS_PROJECT_CF_TYPE)]: (0, $itRkB.customFieldGlyph)
};
const $fdaf5e373b76ddd5$export$14355977bfae6aaa = {
    ...$fdaf5e373b76ddd5$var$checkedFieldTypesGlyphs,
    text: (0, $itRkB.paragraphGlyph),
    number: (0, $itRkB.numberGlyph),
    date: (0, $itRkB.dateGlyph),
    datetime: (0, $itRkB.timeStampGlyph),
    dropdown: (0, $itRkB.dropdownGlyph),
    addon: (0, $itRkB.addonGlyph),
    checkbox: (0, $itRkB.checkboxGlyph),
    user: (0, $itRkB.peopleGlyph),
    radio: (0, $itRkB.radioGlyph),
    time: (0, $itRkB.timeStampGlyph),
    message: (0, $itRkB.commentGlyph),
    bulletList: (0, $itRkB.bulletListGlyph),
    label: (0, $itRkB.labelGlyph),
    labelpicker: (0, $itRkB.labelGlyph),
    close: (0, $itRkB.closeGlyph),
    assetspicker: (0, $itRkB.screenGlyph),
    select: (0, $itRkB.dropdownGlyph),
    multiselect: (0, $itRkB.dropdownGlyph),
    cascadingselect: (0, $itRkB.doubleDropdownGlyph),
    multigrouppicker: (0, $itRkB.dropdownGlyph),
    grouppicker: (0, $itRkB.dropdownGlyph),
    multiversion: (0, $itRkB.dropdownGlyph),
    version: (0, $itRkB.dropdownGlyph),
    projectpicker: (0, $itRkB.dropdownGlyph),
    customField: (0, $itRkB.customFieldGlyph)
};
const $fdaf5e373b76ddd5$export$aaac7dbe01e6025d = /*#__PURE__*/ (0, $eJOHy.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $3mZMJ.TEAMS_PLATFORM_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eALjj))), {
        label: "",
        size: size,
        spacing: "spacious",
        testId: testId
    });
    if (type === (0, $3mZMJ.GOALS_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qes7))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #292A2E)"
    });
    if (type === (0, $3mZMJ.ATLAS_PROJECT_CF_TYPE) && (0, $4cTDP.fg)('atlassian_projects_admin_icon')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lmJ87))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #292A2E)"
    });
    return(// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        label: "",
        glyph: $fdaf5e373b76ddd5$var$checkedFieldTypesGlyphs[type] || $fdaf5e373b76ddd5$var$checkedFieldTypesGlyphs.customField,
        size: size,
        testId: testId
    }));
});
const $fdaf5e373b76ddd5$export$87c5289d8835f589 = /*#__PURE__*/ (0, $eJOHy.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $3mZMJ.TEAMS_PLATFORM_CF_TYPE)) {
        const iconSpacing = size === 'small' ? 'compact' : 'spacious';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eALjj))), {
            label: "",
            size: size,
            spacing: iconSpacing,
            testId: testId
        });
    }
    if (type === (0, $3mZMJ.GOALS_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qes7))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #292A2E)"
    });
    if (type === (0, $3mZMJ.ATLAS_PROJECT_CF_TYPE) && (0, $4cTDP.fg)('atlassian_projects_admin_icon')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lmJ87))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #292A2E)"
    });
    return(// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        label: "",
        glyph: $fdaf5e373b76ddd5$export$14355977bfae6aaa[type] || $fdaf5e373b76ddd5$export$14355977bfae6aaa.customField,
        size: size,
        testId: testId
    }));
});
var /**
 * @deprecated - Use allFieldTypeGlyphs or FieldTypeIcon instead.
 */ $fdaf5e373b76ddd5$export$2e2bcd8739ae039 = $fdaf5e373b76ddd5$var$allIcons;

});
parcelRegister("6F4i5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32871a9e1205ad83473907533912c2d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d99e67988431e9e$var$_react = $4d99e67988431e9e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4d99e67988431e9e$var$_baseNew = $4d99e67988431e9e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $4d99e67988431e9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DataFormula".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for data formulas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4d99e67988431e9e$var$DataFormulaIcon = (props)=>/*#__PURE__*/ $4d99e67988431e9e$var$_react.default.createElement($4d99e67988431e9e$var$_baseNew.default, Object.assign({
        name: "DataFormulaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9 0a2.5 2.5 0 0 1 2.5 2.5H10a1 1 0 0 0-1-1h-.12a1.12 1.12 0 0 0-1.11.967L7.354 5.5H10V7H7.146l-.93 6.738A2.62 2.62 0 0 1 1 13.38V13h1.5v.38a1.12 1.12 0 0 0 2.23.153L5.63 7H4V5.5h1.838l.446-3.238A2.62 2.62 0 0 1 8.88 0z"/><path fill="currentcolor" d="m15.052 9.008-2.392 2.598 1.948 2.706-1.216.877-1.768-2.456-2.322 2.525-1.104-1.016 2.53-2.752-1.836-2.552 1.216-.876 1.658 2.301 2.182-2.37z"/>`
    }, props));
$4d99e67988431e9e$var$DataFormulaIcon.displayName = 'DataFormulaIcon';
var $4d99e67988431e9e$var$_default = module.exports.default = $4d99e67988431e9e$var$DataFormulaIcon;

});

parcelRegister("itRkB", function(module, exports) {
$parcel$export(module.exports, "numberGlyph", () => $c548f0a472b13f77$export$b368272069fe93ea);
$parcel$export(module.exports, "checkboxGlyph", () => $c548f0a472b13f77$export$747056db840f2e62);
$parcel$export(module.exports, "folderGlyph", () => $c548f0a472b13f77$export$fc939f15c0ac57d8);
$parcel$export(module.exports, "dateGlyph", () => $c548f0a472b13f77$export$54ae6633cc16eed1);
$parcel$export(module.exports, "dropdownGlyph", () => $c548f0a472b13f77$export$d298f123ec74117c);
$parcel$export(module.exports, "doubleDropdownGlyph", () => $c548f0a472b13f77$export$b3ea0fc10228ca3e);
$parcel$export(module.exports, "labelGlyph", () => $c548f0a472b13f77$export$fc64eea29ed0831d);
$parcel$export(module.exports, "paragraphGlyph", () => $c548f0a472b13f77$export$cbee9ded46569696);
$parcel$export(module.exports, "peopleGlyph", () => $c548f0a472b13f77$export$2ade78849d2113ea);
$parcel$export(module.exports, "shortTextGlyph", () => $c548f0a472b13f77$export$1c6cf19eb34bcc14);
$parcel$export(module.exports, "timeStampGlyph", () => $c548f0a472b13f77$export$98a4a461fe316fce);
$parcel$export(module.exports, "timeTrackingGlyph", () => $c548f0a472b13f77$export$637d50811e2b7176);
$parcel$export(module.exports, "originalTimeEstimateGlyph", () => $c548f0a472b13f77$export$bc2bb299bed9df91);
$parcel$export(module.exports, "arrowRightGlyph", () => $c548f0a472b13f77$export$3a9d3f1c52f4dab9);
$parcel$export(module.exports, "addonGlyph", () => $c548f0a472b13f77$export$a4cdad58220c405a);
$parcel$export(module.exports, "attachmentGlyph", () => $c548f0a472b13f77$export$e6e85f1bc2e23bd4);
$parcel$export(module.exports, "bulletListGlyph", () => $c548f0a472b13f77$export$a6a7f7b7c0399a2a);
$parcel$export(module.exports, "commentGlyph", () => $c548f0a472b13f77$export$835d228e2a9d6a93);
$parcel$export(module.exports, "officeBuildingGlyph", () => $c548f0a472b13f77$export$fdad804cb16a6544);
$parcel$export(module.exports, "peopleGroupGlyph", () => $c548f0a472b13f77$export$a20644de4b67f161);
$parcel$export(module.exports, "radioGlyph", () => $c548f0a472b13f77$export$ce87e45dceec205d);
$parcel$export(module.exports, "shipGlyph", () => $c548f0a472b13f77$export$d95e2215202c8556);
$parcel$export(module.exports, "priorityGlyph", () => $c548f0a472b13f77$export$3062e49c5521698d);
$parcel$export(module.exports, "screenGlyph", () => $c548f0a472b13f77$export$17d48fc8b753df77);
$parcel$export(module.exports, "closeGlyph", () => $c548f0a472b13f77$export$cbbe21ca62a58ed6);
$parcel$export(module.exports, "appAccessGlyph", () => $c548f0a472b13f77$export$8fd991b9da3a43e5);
$parcel$export(module.exports, "jwmCategoryGlyph", () => $c548f0a472b13f77$export$f21213fb7b480582);
$parcel$export(module.exports, "customFieldGlyph", () => $c548f0a472b13f77$export$88453606d7da6ff7);

var $eJOHy = parcelRequire("eJOHy");
const $c548f0a472b13f77$export$b368272069fe93ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$747056db840f2e62 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4 5.994C4 4.893 4.895 4 5.994 4h12.012C19.107 4 20 4.895 20 5.994v12.012A1.995 1.995 0 0 1 18.006 20H5.994A1.995 1.995 0 0 1 4 18.006V5.994zm5.707 5.299a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$fc939f15c0ac57d8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19h16zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862L12.2 6z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$54ae6633cc16eed1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.667 6.167V7A.834.834 0 0 1 7 7V5.333a.834.834 0 0 1 1.667 0v.834zm6.666 0v-.834a.834.834 0 0 1 1.667 0V7a.834.834 0 0 1-1.667 0v-.833zm2.5 0h.005c.918 0 1.662.745 1.662 1.661v10.01c0 .918-.743 1.662-1.662 1.662H6.161A1.663 1.663 0 0 1 4.5 17.838V7.828c0-.917.743-1.661 1.662-1.661h.005V7c0 .927.746 1.667 1.666 1.667C8.76 8.667 9.5 7.92 9.5 7v-.833h5V7c0 .927.746 1.667 1.667 1.667.927 0 1.666-.747 1.666-1.667v-.833zm-10 6.667H9.5v-1.667H7.833v1.667zm0 3.334H9.5V14.5H7.833v1.668zm3.334-3.334h1.666v-1.667h-1.666v1.667zm0 3.334h1.666V14.5h-1.666v1.668zm3.333-3.334h1.667v-1.667H14.5v1.667zm0 3.334h1.667V14.5H14.5v1.668z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$d298f123ec74117c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM15.708 11.723L12.779 14.678C12.566 14.893 12.288 15 12.009 15C11.73 15 11.449 14.893 11.231 14.678L8.291 11.713C7.903 11.321 7.903 10.686 8.291 10.294C8.679 9.902 9.309 9.902 9.698 10.294L12.005 12.621L14.303 10.304C14.69 9.912 15.32 9.912 15.708 10.304C16.097 10.696 16.097 11.331 15.708 11.723Z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$b3ea0fc10228ca3e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM10.0543 7.95865C9.72121 7.63948 9.17412 7.63199 8.83238 7.94192C8.49064 8.25184 8.48365 8.76182 8.81678 9.08099L11.3658 11.5232C11.5389 11.689 11.7698 11.7707 11.9997 11.7675C12.2295 11.7707 12.4604 11.689 12.6335 11.5232L15.1825 9.08099C15.5156 8.76182 15.5087 8.25184 15.1669 7.94192C14.8252 7.63199 14.2781 7.63948 13.945 7.95865L11.9997 9.82242L10.0543 7.95865ZM8.83238 12.3333C9.17412 12.0234 9.72121 12.0309 10.0543 12.35L11.9997 14.2138L13.945 12.35C14.2781 12.0309 14.8252 12.0234 15.1669 12.3333C15.5087 12.6432 15.5156 13.1532 15.1825 13.4724L12.6335 15.9146C12.4604 16.0804 12.2295 16.1621 11.9997 16.1588C11.7698 16.1621 11.5389 16.0804 11.3658 15.9146L8.81678 13.4724C8.48365 13.1532 8.49064 12.6432 8.83238 12.3333Z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$fc64eea29ed0831d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M11.433 5.428l-4.207.6a2 2 0 0 0-1.697 1.698l-.601 4.207a1 1 0 0 0 .283.849l6.894 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283zm-.647 5.858a1.667 1.667 0 1 1-2.357-2.357 1.667 1.667 0 0 1 2.357 2.357z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$cbee9ded46569696 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7 7h11a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2zm0 4h11a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm0 4h6a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$2ade78849d2113ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.12 20.249a8.398 8.398 0 0 1-.39-.003A8.25 8.25 0 0 1 3.75 12 8.25 8.25 0 0 1 12 3.75 8.25 8.25 0 0 1 20.25 12a8.25 8.25 0 0 1-8.13 8.25v-.001zm4.463-3.762A6.396 6.396 0 0 0 18.417 12 6.424 6.424 0 0 0 12 5.583 6.424 6.424 0 0 0 5.583 12c0 1.745.7 3.33 1.834 4.487v-1.27a2.291 2.291 0 0 1 2.292-2.292h4.582a2.292 2.292 0 0 1 2.292 2.291v1.27zM12 12a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$1c6cf19eb34bcc14 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6.72 7.178l-2.93 8.627a.5.5 0 0 0 .473.661h.842a.75.75 0 0 0 .716-.53l.581-1.887h3.425l.58 1.887a.75.75 0 0 0 .717.53h.916a.5.5 0 0 0 .473-.66L9.578 7.177a1 1 0 0 0-.946-.678h-.966a1 1 0 0 0-.947.678zm1.37 1.228h.047l1.25 4.082H6.841l1.25-4.082zm10.187 1.872v-.23a.986.986 0 1 1 1.972 0v5.433a.986.986 0 0 1-1.972 0v-.217h-.08c-.36.802-1.13 1.32-2.217 1.32-1.81 0-2.952-1.479-2.952-3.834 0-2.334 1.149-3.805 2.952-3.805 1.075 0 1.858.546 2.216 1.333h.08zm-.04 2.486c0-1.347-.63-2.203-1.61-2.203-.978 0-1.58.843-1.58 2.203 0 1.368.602 2.196 1.58 2.196.988 0 1.61-.836 1.61-2.196z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$98a4a461fe316fce = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm.787-7.674V8.944c0-.52-.402-.944-.893-.944-.492 0-.894.425-.894.944v3.777c0 .263.104.5.269.672l2.207 2.332a.862.862 0 0 0 1.263 0 .985.985 0 0 0 0-1.336l-1.952-2.063z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$637d50811e2b7176 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M17.476 9.067A6.552 6.552 0 0 1 19 13.263C19 16.983 15.866 20 12 20s-7-3.016-7-6.737c0-1.587.57-3.045 1.524-4.196l-.383-.402a.82.82 0 0 1 .054-1.19.9.9 0 0 1 1.237.052l.345.363a7.116 7.116 0 0 1 3.348-1.312v-.894h-.438a.43.43 0 0 1-.437-.42V4.42a.43.43 0 0 1 .438-.42h2.624a.43.43 0 0 1 .438.421v.842a.43.43 0 0 1-.438.421h-.437v.894a7.116 7.116 0 0 1 3.348 1.312l.345-.363a.9.9 0 0 1 1.237-.052.82.82 0 0 1 .054 1.19l-.383.402zM12 18.316c2.9 0 5.25-2.262 5.25-5.053 0-2.79-2.35-5.052-5.25-5.052s-5.25 2.262-5.25 5.052c0 2.79 2.35 5.053 5.25 5.053zm.645-4.562a.9.9 0 0 1-1.237-.02.82.82 0 0 1 .02-1.19l2.588-2.412a.9.9 0 0 1 1.238.02.82.82 0 0 1-.02 1.19l-2.589 2.412z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$bc2bb299bed9df91 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$3a9d3f1c52f4dab9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.268 4.934a.919.919 0 0 0 0 1.296l4.852 4.853H4.668A.92.92 0 0 0 3.75 12a.92.92 0 0 0 .917.917H17.12l-4.856 4.855a.917.917 0 0 0 1.296 1.296l6.416-6.415c.002 0 .003-.003.006-.004a.914.914 0 0 0 .267-.65.915.915 0 0 0-.274-.653l-6.412-6.412a.915.915 0 0 0-.648-.267.915.915 0 0 0-.648.267z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$a4cdad58220c405a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.928 6.917l4.81-2.846c.727-.429 1.8-.427 2.523 0l4.811 2.846c.726.43 1.261 1.382 1.261 2.238v5.69c0 .859-.537 1.81-1.26 2.238L13.26 19.93c-.726.429-1.799.427-2.522 0l-4.811-2.846c-.726-.43-1.261-1.382-1.261-2.238v-5.69c0-.859.537-1.81 1.26-2.238zm6.408-1.204c-.152-.09-.52-.09-.672 0L6.853 8.558c-.152.09-.336.416-.336.597v5.69c0 .18.183.507.336.597l4.81 2.845c.153.09.52.09.673 0l4.811-2.845c.152-.09.336-.416.336-.597v-5.69c0-.18-.183-.507-.336-.597l-4.81-2.845zM12 15.667a3.667 3.667 0 1 1 0-7.334 3.667 3.667 0 0 1 0 7.334zm0-1.834a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$e6e85f1bc2e23bd4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.672 17.468c-1.402 1.37-3.68 1.37-5.08.004a3.458 3.458 0 0 1 .002-4.962l6.552-6.402a2.123 2.123 0 0 1 2.964-.003c.818.8.82 2.092.003 2.89L10.968 15a.599.599 0 0 1-.838-.008.568.568 0 0 1 0-.827l5.71-5.58a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.268 0l-5.71 5.58a2.294 2.294 0 0 0 0 3.307 2.423 2.423 0 0 0 3.375.008l6.145-6.005a3.735 3.735 0 0 0-.003-5.37 3.947 3.947 0 0 0-5.502.003L6.325 11.27a5.184 5.184 0 0 0-.001 7.442c2.1 2.052 5.514 2.051 7.617-.004l6.13-5.99a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.27 0l-6.129 5.99z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$a6a7f7b7c0399a2a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.5 7.59a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.008v.152A1 1 0 0 1 6.659 8.75h-.152A1 1 0 0 1 5.5 7.743V7.59zm4.333 8.667a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.008h-6.678a.993.993 0 0 1-.995-1.008v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.008h-.152A1 1 0 0 1 5.5 16.409v-.152zm4.333-4.333a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.007h-.152A1 1 0 0 1 5.5 12.076v-.152zM9.833 7.59a.999.999 0 0 1 .995-1.008h6.678c.549 0 .994.439.994 1.008v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007V7.59z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$835d228e2a9d6a93 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.524.524 0 0 0 .164.033.515.515 0 0 0 .474-.716zM7 10c0-.552.456-1 .995-1h8.01c.55 0 .995.444.995 1 0 .552-.456 1-.995 1h-8.01A.995.995 0 0 1 7 10zm0 3c0-.552.444-1 1-1h3c.552 0 1 .444 1 1 0 .552-.444 1-1 1H8c-.552 0-1-.444-1-1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$fdad804cb16a6544 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.444 14.667V20H5.785C4.8 20 4 19.146 4 18.09V8.577c0-1.055.802-1.91 1.785-1.91h2.66v3.556H6.666V12h1.777v.889H6.667v1.778h1.777zm.89-8.894A1.78 1.78 0 0 1 11.119 4h7.096A1.78 1.78 0 0 1 20 5.773v12.454c0 .979-.802 1.773-1.785 1.773H9.333V5.773zM12 7.556v1.777h1.778V7.556H12zm0 2.666V12h1.778v-1.778H12zm0 2.667v1.778h1.778v-1.778H12zm1.778 2.667v2.666h1.778v-2.666h-1.778zm1.778-8v1.777h1.777V7.556h-1.777zm0 2.666V12h1.777v-1.778h-1.777zm0 2.667v1.778h1.777v-1.778h-1.777z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$a20644de4b67f161 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 12a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm-3.228-1.667A3.333 3.333 0 0 0 9.795 12H9.5A2.501 2.501 0 0 0 7 14.497v2.469c-1.771-.147-3.333-.766-3.333-1.858V12c0-.92.74-1.667 1.666-1.667h3.439zm6.456 0h3.439c.92 0 1.666.738 1.666 1.667v3.108c0 1.092-1.562 1.711-3.333 1.858v-2.47A2.5 2.5 0 0 0 14.5 12h-.295a3.333 3.333 0 0 0 1.023-1.667zM10.306 6.63A3.332 3.332 0 0 0 8.67 9.357a2.5 2.5 0 1 1 1.636-2.728zm5.024 2.728a3.328 3.328 0 0 0-1.636-2.73 2.5 2.5 0 1 1 1.636 2.73zm-7.497 5.456c0-1.093.892-1.98 1.996-1.98h4.342a2 2 0 0 1 1.996 1.994v2.781c0 2.523-8.334 2.523-8.334 0v-2.795z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$ce87e45dceec205d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$d95e2215202c8556 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6.5 12h7.333v-1.833H6.5V12zM4.667 9.242c0-.502.417-.909.919-.909h9.162c.507 0 .919.414.919.909v4.591h-11V9.242zm.458 7.341h12.828l.919-2.75H4.795l.33 2.75zm-2.287-3.677A.79.79 0 0 1 3.643 12h16.86c.504 0 .786.382.625.865l-1.565 4.686c-.16.478-.695.866-1.205.866H4.415c-.506 0-.964-.402-1.025-.906l-.552-4.605zM6.5 7.42c0-1.015.823-1.838 1.831-1.838h1.838c1.011 0 1.831.82 1.831 1.838v2.746H6.5V7.42zm3.667 0v-.004H8.331c.005 0 .002.002.002.004v.912h1.834V7.42z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$3062e49c5521698d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7.959 15.833V8.474l-2.868 2.868a.541.541 0 1 1-.766-.766l3.79-3.789.001-.004a.544.544 0 0 1 .77.003l3.791 3.792a.543.543 0 0 1 0 .766.543.543 0 0 1-.765 0l-2.87-2.87v7.36a.543.543 0 0 1-.541.541.543.543 0 0 1-.542-.542zm7-6.666v7.359l-2.868-2.868a.541.541 0 1 0-.766.766l3.79 3.789.001.004a.544.544 0 0 0 .77-.003l3.791-3.792a.543.543 0 0 0 0-.766.543.543 0 0 0-.765 0l-2.87 2.87v-7.36a.543.543 0 0 0-.541-.541.543.543 0 0 0-.542.542z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: ".5",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$17d48fc8b753df77 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4 6.772C4 5.793 4.793 5 5.773 5h12.454C19.206 5 20 5.796 20 6.772v7.044c0 .979-.793 1.772-1.773 1.772H5.773A1.774 1.774 0 0 1 4 13.816V6.772zm1.778 7.052h12.444v-7.06H5.778v7.06zm8 5.294h.452c.241 0 .437.204.437.44V20H9.333v-.441c0-.244.203-.441.437-.441h.452V16.47h3.556v2.647z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$cbbe21ca62a58ed6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M16.244 6.244a.833.833 0 1 1 1.179 1.179l-4.412 4.41 4.412 4.411a.834.834 0 0 1 .074 1.093l-.074.086a.833.833 0 0 1-1.179 0l-4.411-4.412-4.41 4.412a.834.834 0 0 1-1.094.074l-.085-.074a.833.833 0 0 1 0-1.179l4.411-4.411-4.41-4.41a.834.834 0 0 1-.076-1.094l.075-.085a.833.833 0 0 1 1.179 0l4.41 4.411z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$8fd991b9da3a43e5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.682 12H5.01A2.006 2.006 0 0 0 3 14v4.446c0 2.162 4.836 2.951 8.368 2.368A5.975 5.975 0 0 1 10 17a5.994 5.994 0 0 1 2.682-5z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        fill: "currentColor",
        cx: "9",
        cy: "7",
        r: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        fill: "currentColor",
        cx: "16",
        cy: "17",
        r: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14.674 19.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3l1.406 1.405z",
        fill: "inherit"
    })));
const $c548f0a472b13f77$export$f21213fb7b480582 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 12zm0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 16zm0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 8z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$88453606d7da6ff7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        role: "presentation",
        focusable: "false",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M3 6C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8H11C11.5523 8 12 7.55228 12 7C12 6.44772 11.5523 6 11 6H3ZM4 16V12H20V16H4ZM2 12C2 10.8954 2.89543 10 4 10H20C21.1046 10 22 10.8954 22 12V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V12Z",
        fill: "currentColor"
    })));

});


parcelRegister("d9b92", function(module, exports) {
$parcel$export(module.exports, "MetaActions", () => $5ca44d217725f710$export$50531cf3046c5956);
const $5ca44d217725f710$export$50531cf3046c5956 = {
    setValue: 'set-value',
    inputChange: 'input-change',
    inputBlur: 'input-blur',
    menuClose: 'menu-close',
    selectOption: 'select-option',
    deselectOption: 'deselect-option',
    removeValue: 'remove-value',
    popValue: 'pop-value',
    clear: 'clear',
    createOption: 'create-option',
    clearOptions: 'clear-options',
    add: 'add',
    remove: 'remove',
    update: 'update'
};

});

parcelRegister("cjRWP", function(module, exports) {
$parcel$export(module.exports, "getSecondaryLabelWithIcon", () => $fe2515622481ebd0$export$de24d837eb50c435);

var $eJOHy = parcelRequire("eJOHy");
const $fe2515622481ebd0$export$de24d837eb50c435 = (icon, fieldTypeDisplayName)=>({
        label: fieldTypeDisplayName,
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, icon, fieldTypeDisplayName)
    });

});

parcelRegister("o3Hdn", function(module, exports) {
$parcel$export(module.exports, "isSelectOptionArray", () => $ca4870fcc6b451a8$export$4be42473522c84f6);
const $ca4870fcc6b451a8$export$4be42473522c84f6 = (options)=>options != null && Array.isArray(options);

});

parcelRegister("gMbEk", function(module, exports) {
$parcel$export(module.exports, "isSingleValueOption", () => $282a6706fedd463a$export$35faed52a6bc243e);
const $282a6706fedd463a$export$35faed52a6bc243e = (option)=>option.optionType === 'option' || option.optionType === 'avatar' || option.optionType === 'lozenge' || option.optionType === 'field';

});

// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("d8Dow", function(module, exports) {
$parcel$export(module.exports, "MAX_COLUMNS", () => $0ea88860b9e82601$export$7ec4af037f372df4);
$parcel$export(module.exports, "createDebouncedColumnLoader", () => $0ea88860b9e82601$export$a6cff24b97727de1);
$parcel$export(module.exports, "REMOVE_COLUMNS", () => $0ea88860b9e82601$export$191e3e934175a609);
$parcel$export(module.exports, "ADD_COLUMNS", () => $0ea88860b9e82601$export$ccf17692f1fc979a);

var $3Zpjn = parcelRequire("3Zpjn");

const $0ea88860b9e82601$export$7ec4af037f372df4 = 500;
const $0ea88860b9e82601$export$a6cff24b97727de1 = (0, $3Zpjn.createGenericDebouncableDataLoader);
const $0ea88860b9e82601$export$191e3e934175a609 = 'REMOVE_COLUMNS';
const $0ea88860b9e82601$export$ccf17692f1fc979a = 'ADD_COLUMNS';

});
parcelRegister("3Zpjn", function(module, exports) {
$parcel$export(module.exports, "createGenericDebouncableDataLoader", () => $515f3085be272897$export$ea63a11564958c9e);

var $3s8bj = parcelRequire("3s8bj");
const $515f3085be272897$export$ea63a11564958c9e = (dataLoader)=>{
    const debouncedDataLoader = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((search, enableFullList, endCursor, cb)=>dataLoader(search, enableFullList, endCursor).then((data)=>{
            cb(data);
            return data;
        }), 500);
    return (search, enableFullList, endCursor, cb)=>{
        // No need to debounce When no search string is provided.
        // We want the initial list displaying as quickly as possible when a user reopens the dropdown.
        // It will be cached by the GraphQL client and debouncing will show an unneccessary spinner.
        if (!search) {
            debouncedDataLoader.cancel();
            return dataLoader(search, enableFullList, endCursor).then((data)=>{
                cb(data);
                return data;
            });
        }
        return debouncedDataLoader(search, enableFullList, endCursor, cb);
    };
};
var $515f3085be272897$export$2e2bcd8739ae039 = $515f3085be272897$export$ea63a11564958c9e;

});


parcelRegister("5NRap", function(module, exports) {
$parcel$export(module.exports, "isNonNullish", () => $4a6b75787dcaf92b$export$70573498ee17fe1d);
/**
 * Type predicate to determine that a value is not `null` or `undefined`.
 */ function $4a6b75787dcaf92b$export$70573498ee17fe1d(value) {
    return value != null;
}

});

parcelRegister("itmi8", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d34faeba17d9896$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1jVV7 = parcelRequire("1jVV7");

var $guChT = parcelRequire("guChT");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $lHHP1 = parcelRequire("lHHP1");

var $6sTi7 = parcelRequire("6sTi7");

var $fNOMn = parcelRequire("fNOMn");

var $437hw = parcelRequire("437hw");

var $ixh2S = parcelRequire("ixh2S");

var $7JbAM = parcelRequire("7JbAM");

var $eo5xA = parcelRequire("eo5xA");

var $cWT2N = parcelRequire("cWT2N");
const $8d34faeba17d9896$var$ColumnPicker = ({ components: components, selectedColumns: selectedColumns = [], isOpen: isOpen, onOpen: onOpen, onClose: onClose, zIndex: zIndex, isLoading: isLoading, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled = false, columnsDataId: columnsDataId, showInlineFieldCreateOnboarding: showInlineFieldCreateOnboarding = false, columnInsertIndex: columnInsertIndex, onPickerMouseEnter: onPickerMouseEnter, onPickerMouseLeave: onPickerMouseLeave, ...restProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const loadingMessages = (0, $eJOHy.useMemo)(()=>({
            paginationStart: formatMessage((0, $eo5xA.default).loadingMessageStart),
            paginationEnd: formatMessage((0, $eo5xA.default).loadingMessageEnd)
        }), [
        formatMessage
    ]);
    const onClick = (0, $eJOHy.useCallback)(()=>isOpen ? onClose() : onOpen(), [
        isOpen,
        onClose,
        onOpen
    ]); // Define a CustomNoOptionsMessage component that supports rendering of custom help actions
    const CustomNoOptionsMessage = (0, $eJOHy.useCallback)(()=>components?.EmptyState !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(components.EmptyState, {
            closeColumnPicker: onClose
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7JbAM.default), null), [
        components,
        onClose
    ]); // Remove all the changeboarding on clean up of 'remove_nin_changeboarding_rll_usages', should be showing as empty fragments already
    const onTrigger = (0, $eJOHy.useCallback)(({ ref: ref })=>{
        const renderSpotlightCard = ({ onEndTour: onEndTour })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fNOMn.default), {
                cardKey: (0, $6sTi7.cardKeys).GLOBAL_SCOPE_COLUMN_PICKER,
                dialogWidth: 272,
                dialogPlacement: "left middle",
                actions: [
                    {
                        onClick: ()=>{
                            onEndTour();
                        },
                        text: formatMessage((0, $eo5xA.default).done)
                    }
                ],
                heading: formatMessage((0, $eo5xA.default).tourHeading),
                target: "nin.spotlight.column-picker",
                targetRadius: 3,
                targetBgColor: "var(--ds-surface, #FFFFFF)",
                messageId: "issue-table-column-picker.ui.column-picker.spotlight-tour-card.nin.spotlight.column-picker.spotlight",
                messageType: "transactional"
            }, formatMessage((0, $eo5xA.default).tourBody));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $437hw.default), {
            name: "nin.spotlight.column-picker",
            renderSpotlightCard: renderSpotlightCard
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHHP1.NinChangeboardingTourTarget), {
            engagementId: "nin.native-issue-table.column-picker"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cWT2N.default), {
            isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
            onClick: onClick,
            ref: ref,
            isSelected: isOpen,
            customIcon: components?.Icon,
            isLoading: isLoading,
            onPickerMouseEnter: onPickerMouseEnter,
            onPickerMouseLeave: onPickerMouseLeave
        })));
    }, [
        isInBetweenColumnPickerEnabled,
        onClick,
        isOpen,
        components?.Icon,
        isLoading,
        formatMessage,
        onPickerMouseEnter,
        onPickerMouseLeave
    ]);
    const zIndexChangeEnabled = zIndex ?? (0, $1jVV7.layers).modal;
    const pickerComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8d34faeba17d9896$var$PickerContainer, {
        "data-testid": "issue-table-column-picker.ui.column-picker.column-picker-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixh2S.Picker), {
        ...restProps,
        fallbackPlacements: isInBetweenColumnPickerEnabled && (0, $4cTDP.fg)('jira_inline_field_config_gate') ? [
            'bottom-start'
        ] : [
            'left',
            'top-end'
        ],
        id: "column-picker",
        isOpen: isOpen,
        onClose: onClose,
        value: selectedColumns,
        zIndex: zIndexChangeEnabled,
        PopupComponent: components?.PopupComponent,
        placement: "bottom-end",
        isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
        enableFullList: false,
        onTrigger: onTrigger,
        CustomNoOptionsMessage: CustomNoOptionsMessage,
        searchInputPlaceholder: (0, $4cTDP.fg)('jira_inline_field_config_gate') ? formatMessage((0, $eo5xA.default).searchColumnPlaceholderNew) : formatMessage((0, $eo5xA.default).searchColumnPlaceholder),
        // bug where overflowing content with fixed positioning inside a sticky container can be cut off –
        // as a mitigation, we need to portal the popup component outside the table boundaries
        // @see https://jplat.jira.atlassian.cloud/browse/EM-7679
        // @see https://stackoverflow.com/q/70939616
        shouldRenderToParent: false,
        CustomFooter: // eslint-disable-next-line jira/ff/no-preconditioning
        components?.Footer && (0, $4cTDP.fg)('jira_inline_field_config_gate') && !(0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(components.Footer, {
            onPickerClose: onClose,
            columnsDataId: columnsDataId,
            columnInsertIndex: columnInsertIndex
        }) : undefined,
        renderFooter: // eslint-disable-next-line jira/ff/no-preconditioning
        components?.Footer && (0, $4cTDP.fg)('jira_inline_field_config_gate') && (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? (rightSideComponent)=>{
            return components?.Footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(components.Footer, {
                onPickerClose: onClose,
                columnsDataId: columnsDataId,
                columnInsertIndex: columnInsertIndex,
                rightSideComponent: rightSideComponent
            }) : null;
        } : undefined,
        loadingMessages: loadingMessages
    }));
    return (showInlineFieldCreateOnboarding || !isInBetweenColumnPickerEnabled) && (0, $4cTDP.fg)('jira_inline_field_config_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: `inline-field-create-onboarding-column-picker-button.${isInBetweenColumnPickerEnabled ? 'in-between' : 'default'}`
    }, pickerComponent) : pickerComponent;
};
var $8d34faeba17d9896$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eJOHy.memo)($8d34faeba17d9896$var$ColumnPicker);
const $8d34faeba17d9896$var$PickerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48pi7a9 _o5724jg8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lHHP1", function(module, exports) {
$parcel$export(module.exports, "NinChangeboardingContext", () => $c026bf20b22e170d$export$b349f970aff316d8);
$parcel$export(module.exports, "EnableNinChangeboardingProvider", () => $c026bf20b22e170d$export$dd1deacfc61c978a);
$parcel$export(module.exports, "NinChangeboardingTourTarget", () => $c026bf20b22e170d$export$eb95770b90ecc1f3);
$parcel$export(module.exports, "NinChangeboardingTourCard", () => $c026bf20b22e170d$export$7c27d65549066b5);
$parcel$export(module.exports, "useGlobalScopeOptInFlag", () => $c026bf20b22e170d$export$9e9f507adee88e58);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $cSXp8 = parcelRequire("cSXp8");

var $ezJEv = parcelRequire("ezJEv");

var $8tIrO = parcelRequire("8tIrO");

var $4cTDP = parcelRequire("4cTDP");

var $9ncIL = parcelRequire("9ncIL");

var $5Rrlj = parcelRequire("5Rrlj");

var $hqX3Z = parcelRequire("hqX3Z");

var $5gIAR = parcelRequire("5gIAR");
const $c026bf20b22e170d$var$sessionStorageProvider = (0, $8tIrO.createSessionStorageProvider)('', false);
const $c026bf20b22e170d$export$b349f970aff316d8 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $c026bf20b22e170d$export$dd1deacfc61c978a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c026bf20b22e170d$export$b349f970aff316d8.Provider, {
        value: true
    }, children);
const $c026bf20b22e170d$export$eb95770b90ecc1f3 = ({ children: children, engagementId: engagementId })=>{
    const isTourEnabled = (0, $eJOHy.useContext)($c026bf20b22e170d$export$b349f970aff316d8);
    if (!isTourEnabled || (0, $4cTDP.fg)('remove_nin_changeboarding_rll_usages')) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hqX3Z.default), {
        engagementId: engagementId
    }, children);
};
const $c026bf20b22e170d$export$7c27d65549066b5 = ({ mode: mode, view: view, hasIssueResults: hasIssueResults, isAiEnabled: isAiEnabled })=>{
    const isTourEnabled = (0, $eJOHy.useContext)($c026bf20b22e170d$export$b349f970aff316d8);
    return !isTourEnabled || (0, $4cTDP.fg)('remove_nin_changeboarding_rll_usages') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Rrlj.AsyncSpotlightCard), {
        mode: mode,
        view: view,
        hasIssueResults: hasIssueResults,
        isAiEnabled: isAiEnabled
    });
};
const $c026bf20b22e170d$export$9e9f507adee88e58 = ()=>{
    const isFlagEnabled = (0, $eJOHy.useContext)($c026bf20b22e170d$export$b349f970aff316d8);
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const onOpenInProductHelpArticle = (0, $ezJEv.useHelpPanelLink)();
    const onLearnMore = (0, $eJOHy.useCallback)(()=>{
        onOpenInProductHelpArticle((0, $9ncIL.LEARN_MORE_IPH_ARTICLE_ID));
    }, [
        onOpenInProductHelpArticle
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const shouldShowOptInFlag = (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? $c026bf20b22e170d$var$sessionStorageProvider.get('showNinOptInFlag') : sessionStorage.getItem('showNinOptInFlag');
        if (isFlagEnabled && shouldShowOptInFlag === 'true') {
            showFlag({
                type: 'success',
                title: (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5gIAR.default).successOptInTitleIssueTermRefresh : (0, $5gIAR.default).successOptInTitle,
                description: (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5gIAR.default).successOptInDescIssueTermRefresh : (0, $5gIAR.default).successOptInDesc,
                messageId: 'issue-navigator-changeboarding.controllers.enable-nin-changeboarding.show-flag.success',
                messageType: 'transactional',
                actions: [
                    {
                        content: (0, $5gIAR.default).successActionLearnMoreLink,
                        onClick: onLearnMore
                    }
                ],
                isAutoDismiss: false,
                testId: 'issue-navigator-changeboarding.optin-success-flag'
            });
            (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? $c026bf20b22e170d$var$sessionStorageProvider.remove('showNinOptInFlag') : sessionStorage.removeItem('showNinOptInFlag');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});
parcelRegister("ezJEv", function(module, exports) {
$parcel$export(module.exports, "useHelpPanelLink", () => $906804a52fd3782f$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "HelpPanelLink", () => $906804a52fd3782f$export$5a09250ffddd7fd1);
$parcel$export(module.exports, "default", () => $906804a52fd3782f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");


var $3VPsL = parcelRequire("3VPsL");

var $dfP3D = parcelRequire("dfP3D");

var $cxKOj = parcelRequire("cxKOj");
const $906804a52fd3782f$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $3VPsL.useHelpPanelActions)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $60b564818f0d5fed$export$e99efa3985fa3c26), (0, $60b564818f0d5fed$export$23aa6670f346c214), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: type
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: type
            }
        });
    };
    return handleOnClick;
};
const $906804a52fd3782f$export$5a09250ffddd7fd1 = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, // unused, but needs to be here so it's not passed to Link/Button in the ...props splat
...props })=>{
    const onOpenInProductHelpArticle = $906804a52fd3782f$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle(articleId, type);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ...props,
        appearance: props.appearance === 'subtle-link' && (0, $cxKOj.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? 'link' : props.appearance,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hcewu.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            props.appearance === 'subtle-link' && (0, $cxKOj.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') && "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, children);
};
var /**
 * @deprecated Use named export instead.
 */ $906804a52fd3782f$export$2e2bcd8739ae039 = $906804a52fd3782f$export$5a09250ffddd7fd1;
const $906804a52fd3782f$var$buttonWrapperStyles = null;
const $906804a52fd3782f$var$buttonWrapperSubtleStyles = null;

});
const $60b564818f0d5fed$export$c43c7444da662fa1 = '1';
const $60b564818f0d5fed$export$e99efa3985fa3c26 = 'helpPanel';
const $60b564818f0d5fed$export$23aa6670f346c214 = 368;


parcelRegister("9ncIL", function(module, exports) {
$parcel$export(module.exports, "FALLBACK_SUPPORT_ARTICLE", () => $1b1bba2c09c1943d$export$ff66aa7a4971d979);
$parcel$export(module.exports, "LEARN_MORE_IPH_ARTICLE_ID", () => $1b1bba2c09c1943d$export$88d16e35389ab3c6);
$parcel$export(module.exports, "getEngagementPlatformlMessageId", () => $1b1bba2c09c1943d$export$91074f0ada4f4533);
$parcel$export(module.exports, "TOUR_MESSAGE_ID", () => $1b1bba2c09c1943d$export$4ac775bda929f47);
$parcel$export(module.exports, "views", () => $1b1bba2c09c1943d$export$d0079916fe6800ac);
const $1b1bba2c09c1943d$export$ff66aa7a4971d979 = 'https://support.atlassian.com/jira-software-cloud/docs/search-for-issues-in-jira/';
const $1b1bba2c09c1943d$export$88d16e35389ab3c6 = '3FGQv6n7fB93yWWTYqY0hq';
const $1b1bba2c09c1943d$export$91074f0ada4f4533 = (id)=>`${id}-march2024`;
const $1b1bba2c09c1943d$export$4ac775bda929f47 = 'nin-changeboarding-start';
const $1b1bba2c09c1943d$export$6c69c3d1b5f6fe55 = {
    basic: 'basic',
    advanced: 'advanced'
};
const $1b1bba2c09c1943d$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};

});

parcelRegister("5Rrlj", function(module, exports) {
$parcel$export(module.exports, "AsyncSpotlightCard", () => $09a720f6524e2b48$export$40e85aa59c198f98);
// Remove this file on clean up of 'remove_nin_changeboarding_rll_usages'

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $09a720f6524e2b48$var$SpotlightCard = (0, $bQWwW.lazy)(// we want both these types of spotlights to be within the same webpack chunk
()=>(parcelRequire("ePPqq")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/common/ui/spotlight/spotlight-card/index.tsx"
});
const $09a720f6524e2b48$export$40e85aa59c198f98 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-spotlight-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-spotlight-card",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09a720f6524e2b48$var$SpotlightCard, props)));

});
parcelRegister("ePPqq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2ymnl").then(()=>parcelRequire('knqHM'));

});


parcelRegister("hqX3Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $a165742ed253731e$export$2e2bcd8739ae039);
// Remove this file on clean up of 'remove_nin_changeboarding_rll_usages'

var $eJOHy = parcelRequire("eJOHy");

var $guChT = parcelRequire("guChT");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $bJscI = parcelRequire("bJscI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a165742ed253731e$var$EngagementSpotlightAsync = (0, $bQWwW.lazy)(()=>(parcelRequire("fbCP6")).then(({ EngagementSpotlight: EngagementSpotlight })=>EngagementSpotlight), {
    ssr: false,
    moduleId: "../platform/packages/personalization/engagekit-ts/src/index.ts"
});
const $a165742ed253731e$var$OldSpotlightTourTarget = ({ children: children, engagementId: engagementId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: engagementId
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-engagement-spotlight",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-engagement-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a165742ed253731e$var$EngagementSpotlightAsync, {
        engagementId: engagementId
    }))));
const $a165742ed253731e$var$SpotlightTourTarget = (0, $bJscI.componentWithFG)('remove_nin_changeboarding_rll_usages', ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null), $a165742ed253731e$var$OldSpotlightTourTarget);
var $a165742ed253731e$export$2e2bcd8739ae039 = $a165742ed253731e$var$SpotlightTourTarget;

});
parcelRegister("fbCP6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("66OvY")
]).then(()=>parcelRequire('cf0I9'));

});


parcelRegister("5gIAR", function(module, exports) {
$parcel$export(module.exports, "default", () => $b48b63ba324164d9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b48b63ba324164d9$var$messages = (0, $7qGN1.defineMessages)({
    successOptInTitle: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title",
        "defaultMessage": "You've switched to the new issue search"
    },
    successOptInDesc: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for issues across Jira."
    },
    successActionLearnMoreLink: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-action-learn-more-link",
        "defaultMessage": "Learn more"
    },
    successOptInTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title-issue-term-refresh",
        "defaultMessage": "You've switched to the new search"
    },
    successOptInDescIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc-issue-term-refresh",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for work across Jira."
    }
});
var $b48b63ba324164d9$export$2e2bcd8739ae039 = $b48b63ba324164d9$var$messages;

});


parcelRegister("6sTi7", function(module, exports) {
$parcel$export(module.exports, "cardKeys", () => $fe025dbff69a9482$export$79399c5778983d77);
// Remove this file on clean up of 'remove_nin_changeboarding_rll_usages'
/**
 * Collection of keys representing individual spotlight cards displayed within the issue navigator.
 */ const $fe025dbff69a9482$export$79399c5778983d77 = {
    GLOBAL_SCOPE_JQL_BUILDER_NL_TO_JQL: 'global-scope.jql-builder-with-ai.natural-language-to-jql',
    GLOBAL_SCOPE_VIEW_SWITCHER: 'global-scope.view-switcher',
    GLOBAL_SCOPE_COLUMN_PICKER: 'global-scope.column-picker',
    JQL_BUILDER_NL_TOGGLE: 'jql-builder-with-ai.natural-language-toggle',
    JQL_BUILDER_NL_TO_JQL: 'jql-builder-with-ai.natural-language-to-jql'
};

});

parcelRegister("fNOMn", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b9bd65aec627275$export$2e2bcd8739ae039);
// Remove this file on clean up of 'remove_nin_changeboarding_rll_usages'

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $bJscI = parcelRequire("bJscI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5b9bd65aec627275$var$SpotlightTourCardAsync = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("aOhkZ")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/ui/spotlight-tour-card/main.tsx"
});
const $5b9bd65aec627275$var$SpotlightTourCardBase = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-issue-navigator-changeboarding-spotlight-tour-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-issue-navigator-changeboarding-spotlight-tour-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5b9bd65aec627275$var$SpotlightTourCardAsync, props)));
const $5b9bd65aec627275$var$SpotlightTourCard = (0, $bJscI.componentWithFG)('remove_nin_changeboarding_rll_usages', ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null), $5b9bd65aec627275$var$SpotlightTourCardBase);
var $5b9bd65aec627275$export$2e2bcd8739ae039 = $5b9bd65aec627275$var$SpotlightTourCard;

});
parcelRegister("aOhkZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3L085").then(()=>parcelRequire('966Nd'));

});


parcelRegister("437hw", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb7042db8e62785d$export$2e2bcd8739ae039);
// Remove this file on clean up of 'remove_nin_changeboarding_rll_usages'

var $eJOHy = parcelRequire("eJOHy");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");
var $d2s5v = parcelRequire("d2s5v");

var $gokBr = parcelRequire("gokBr");
/**
 *
 * Renders a spotlight target and associated spotlight card.
 */ const $cb7042db8e62785d$var$SpotlightTourTarget = ({ children: children, name: name, renderSpotlightCard: renderSpotlightCard })=>{
    const { onEndTour: onEndTour, onSetActiveCard: onSetActiveCard } = (0, $gokBr.useSpotlightCoordinationActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: name
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, typeof renderSpotlightCard === 'function' ? renderSpotlightCard({
        onEndTour: onEndTour,
        onSetActiveCard: onSetActiveCard
    }) : renderSpotlightCard));
};
var $cb7042db8e62785d$export$2e2bcd8739ae039 = $cb7042db8e62785d$var$SpotlightTourTarget;

});
parcelRegister("gokBr", function(module, exports) {
$parcel$export(module.exports, "useIsActiveSpotlightCard", () => $afabf68402b50fe5$export$ac706a6842f43035);
$parcel$export(module.exports, "useSpotlightCoordinationActions", () => $afabf68402b50fe5$export$d0297e733168e478);

var $12DRg = parcelRequire("12DRg");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4cTDP = parcelRequire("4cTDP");

const $afabf68402b50fe5$var$initialState = {
    cardKey: null,
    onStopCoordination: null
};
const $afabf68402b50fe5$var$actions = {
    onSetActiveCard: (cardKey, stop)=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            setState({
                cardKey: cardKey,
                onStopCoordination: stop ?? onStopCoordination
            });
        },
    onEndTour: ()=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            onStopCoordination && onStopCoordination();
            setState({
                cardKey: null,
                onStopCoordination: null
            });
        }
};
const $afabf68402b50fe5$var$Store = (0, $GtRbT.createStore)({
    initialState: $afabf68402b50fe5$var$initialState,
    actions: $afabf68402b50fe5$var$actions
});
/**
 * Return `true` if the provided `cardKey` should be displayed as an active spotlight card.
 */ const $afabf68402b50fe5$var$useIsActiveSpotlightCardOld = (0, $iJq0l.createHook)($afabf68402b50fe5$var$Store, {
    selector: (state, cardKeys)=>Array.isArray(cardKeys) ? state.cardKey !== null && cardKeys.includes(state.cardKey) : state.cardKey === cardKeys
});
const $afabf68402b50fe5$export$ac706a6842f43035 = (...args)=>{
    const oldResult = $afabf68402b50fe5$var$useIsActiveSpotlightCardOld(...args);
    if ((0, $4cTDP.fg)('remove_nin_changeboarding_rll_usages')) return [
        false,
        {
            onSetActiveCard: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onEndTour: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        }
    ];
    return oldResult;
};
const $afabf68402b50fe5$var$useSpotlightCoordinationActionsOld = (0, $iJq0l.createActionsHook)($afabf68402b50fe5$var$Store);
const $afabf68402b50fe5$export$d0297e733168e478 = (...args)=>{
    const oldResult = $afabf68402b50fe5$var$useSpotlightCoordinationActionsOld(...args);
    if ((0, $4cTDP.fg)('remove_nin_changeboarding_rll_usages')) return {
        onSetActiveCard: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onEndTour: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    };
    return oldResult;
};

});


parcelRegister("ixh2S", function(module, exports) {
$parcel$export(module.exports, "Picker", () => $e80b57c94adae16a$export$ba25329847403e11);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $kJsb4 = parcelRequire("kJsb4");

var $8IeH1 = parcelRequire("8IeH1");

var $6qaBj = parcelRequire("6qaBj");

var $4cTDP = parcelRequire("4cTDP");

var $d0VAM = parcelRequire("d0VAM");

var $hEe9x = parcelRequire("hEe9x");

var $5LwVz = parcelRequire("5LwVz");
const $e80b57c94adae16a$export$ba25329847403e11 = ({ isOpen: isPickerOpen, value: value, onClose: onClose, onClearValues: onClearValues, onRestoreDefaults: onRestoreDefaults, id: id, invalidLabel: invalidLabel, onChange: onChange, onSortOptions: onSortOptions, formatOptionLabel: formatOptionLabel = (0, $hEe9x.default), onLoadOptions: onLoadOptions, enableFullList: enableFullList, operandDisplayValues: operandDisplayValues, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList, PopupComponent: PopupComponent, onTrigger: onTrigger, placement: placement = 'bottom-start', zIndex: zIndex, CustomNoOptionsMessage: CustomNoOptionsMessage, pickerComponents: pickerComponents, fallbackPlacements: fallbackPlacements, showOperatorSelect: showOperatorSelect = false, onChangeOperator: onChangeOperator, allowedOperators: allowedOperators, selectedOperator: selectedOperator, isMulti: isMulti, searchInputPlaceholder: searchInputPlaceholder, shouldRenderToParent: shouldRenderToParent = false, experienceAnalyticsAttributes: experienceAnalyticsAttributes, isLoading: isLoading = false, CustomFooter: CustomFooter, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled = false, loadingMessages: loadingMessages, renderFooter: renderFooter, verticalMode: verticalMode = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        role: "presentation",
        onKeyDown: (event)=>{
            if (event.key === 'Escape') {
                // avoid closing a modal on closing a picker with esc key
                isPickerOpen && event.stopPropagation();
                onClose && onClose(event);
            }
        },
        xcss: (0, $6qaBj.cx)(verticalMode && $e80b57c94adae16a$var$styles.vertical)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJsb4.default), {
        key: id,
        zIndex: zIndex,
        placement: placement,
        isOpen: isPickerOpen,
        onClose: onClose,
        popupComponent: PopupComponent ?? (0, $5LwVz.FixedWidthPopupComponent),
        trigger: onTrigger,
        autoFocus: false,
        fallbackPlacements: fallbackPlacements,
        testId: `jql-builder-basic-picker-${id}`,
        shouldRenderToParent: shouldRenderToParent,
        /* Our default popup component supports resizing to fit the viewport. */ shouldFitViewport: PopupComponent === undefined,
        // eslint-disable-next-line jira/import/no-direct-popup
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d0VAM.default), {
                id: id,
                invalidLabel: invalidLabel,
                enableFullList: enableFullList,
                operandDisplayValues: operandDisplayValues,
                showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList,
                loadOptions: onLoadOptions,
                onChange: onChange,
                onSortOptions: onSortOptions,
                value: value,
                formatOptionLabel: formatOptionLabel,
                onClear: onClearValues,
                onRestoreDefaults: onRestoreDefaults,
                NoOptionsMessage: CustomNoOptionsMessage,
                components: pickerComponents,
                showOperatorSelect: showOperatorSelect,
                onChangeOperator: onChangeOperator,
                allowedOperators: allowedOperators,
                selectedOperator: selectedOperator,
                isMulti: isMulti,
                placeholder: searchInputPlaceholder,
                setInitialFocusRef: setInitialFocusRef,
                experienceAnalyticsAttributes: experienceAnalyticsAttributes,
                isLoading: isLoading,
                isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
                CustomFooter: // eslint-disable-next-line jira/ff/no-preconditioning
                (0, $4cTDP.fg)('jira_inline_field_config_gate') && !(0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? CustomFooter : undefined,
                loadingMessages: loadingMessages,
                renderFooter: // eslint-disable-next-line jira/ff/no-preconditioning
                (0, $4cTDP.fg)('jira_inline_field_config_gate') && (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? renderFooter : undefined
            })
    }));
$e80b57c94adae16a$export$ba25329847403e11.whyDidYouRender = {
    customName: 'Picker'
};
const $e80b57c94adae16a$var$styles = {
    vertical: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx2vrvc"
};

});
parcelRegister("d0VAM", function(module, exports) {
$parcel$export(module.exports, "default", () => $8bc6c8c7998de8b9$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gyBpf = parcelRequire("gyBpf");

var $cSmYj = parcelRequire("cSmYj");

var $4B7rn = parcelRequire("4B7rn");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $6d9QY = parcelRequire("6d9QY");

var $9cbmy = parcelRequire("9cbmy");

var $gMbEk = parcelRequire("gMbEk");

var $j8m5Z = parcelRequire("j8m5Z");

var $f3ko0 = parcelRequire("f3ko0");

var $f1iCr = parcelRequire("f1iCr");

var $1fUys = parcelRequire("1fUys");

var $5lNLi = parcelRequire("5lNLi");

var $j7wtI = parcelRequire("j7wtI");

var $fSowc = parcelRequire("fSowc");

var $icknm = parcelRequire("icknm");

var $bWslp = parcelRequire("bWslp");

var $7XraK = parcelRequire("7XraK");
const $8bc6c8c7998de8b9$var$MAX_TOTAL_COUNT = 1000; // To be cleaned up in EM-3568
const $8bc6c8c7998de8b9$var$selectStyles = {
    container: (baseStyles)=>({
            ...baseStyles,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        })
};
const $8bc6c8c7998de8b9$var$getLoadingMessage = ({ isLoadingPaginationStart: isLoadingPaginationStart, isLoadingPaginationEnd: isLoadingPaginationEnd, loadingMessages: loadingMessages, formatMessage: formatMessage })=>{
    if (isLoadingPaginationStart) return loadingMessages?.paginationStart || formatMessage((0, $7XraK.default).loadingStart);
    if (isLoadingPaginationEnd) return loadingMessages?.paginationEnd || formatMessage((0, $7XraK.default).loadingEnd);
    return undefined;
};
const $8bc6c8c7998de8b9$export$f2aa4c50966ce803 = ()=>(0, $eJOHy.useState)(false);
const $8bc6c8c7998de8b9$var$PaginatedAsyncSelectView = ({ id: id, onMenuScrollToBottom: onMenuScrollToBottom, onMenuScrollToTop: onMenuScrollToTop, placeholder: placeholder, invalidLabel: invalidLabel, enableFullList: enableFullListProp, operandDisplayValues: operandDisplayValues, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList, loadOptions: loadOptions, onInputChange: onInputChange, value: value, onChange: onChange, onChangeOperator: onChangeOperator, onSortOptions: onSortOptions, onClear: onClear, onRestoreDefaults: onRestoreDefaults, components: customComponents, showOperatorSelect: showOperatorSelect, allowedOperators: allowedOperators, selectedOperator: selectedOperator, isMulti: isMulti = true, setInitialFocusRef: setInitialFocusRef, isLoading: isLoadingExternal, CustomFooter: CustomFooter, onKeyDown: onKeyDown, loadingMessages: loadingMessages, renderFooter: renderFooter, ...restProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const paginatedComponents = (0, $eJOHy.useMemo)(()=>({
            ...(0, $j7wtI.selectComponents),
            MenuList: $f3ko0.MenuList
        }), []);
    const paginatedSingleSelectComponents = (0, $eJOHy.useMemo)(()=>({
            ...(0, $j7wtI.singleSelectComponents),
            Option: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fSowc.default), {
                    ...props,
                    isMulti: false
                }),
            MenuList: $f3ko0.MenuList
        }), []);
    const [isLoadingInternal, setIsLoading] = (0, $eJOHy.useState)(true);
    const [isPaginationLoading, setIsPaginationLoading] = $8bc6c8c7998de8b9$export$f2aa4c50966ce803();
    const [inputValue, setInputValue] = (0, $eJOHy.useState)('');
    const [loadedOptions, setLoadedOptions] = (0, $eJOHy.useState)([]);
    const rollbackOptionsRef = (0, $eJOHy.useRef)(loadedOptions);
    const [enableFullList, setEnableFullList] = (0, $eJOHy.useState)(enableFullListProp || false);
    const [totalCount, setTotalCount] = (0, $eJOHy.useState)(null);
    const [endCursor, setEndCursor] = (0, $eJOHy.useState)(undefined);
    const loadingScreenMessage = (0, $eJOHy.useRef)(undefined);
    const [error, setError] = (0, $eJOHy.useState)({
        isError: false,
        error: null,
        onRetry: null
    });
    const isLoading = isLoadingInternal || isLoadingExternal;
    const prevIsPaginationLoading = (0, $6d9QY.usePreviousWithInitial)(isPaginationLoading);
    const hasFinishedPaginationLoading = prevIsPaginationLoading && !isPaginationLoading;
    loadingScreenMessage.current = $8bc6c8c7998de8b9$var$getLoadingMessage({
        isLoadingPaginationStart: Boolean(isPaginationLoading && !prevIsPaginationLoading),
        isLoadingPaginationEnd: hasFinishedPaginationLoading,
        loadingMessages: loadingMessages,
        formatMessage: formatMessage
    });
    const searchRef = (0, $eJOHy.useRef)('');
    const isColumnChangeInProgress = (0, $eJOHy.useRef)(false);
    const itemCount = (0, $eJOHy.useMemo)(()=>loadedOptions.flatMap((option)=>option.optionType === 'group' ? option.options : option).length, [
        loadedOptions
    ]);
    const getTotalCountWithFunctions = (0, $eJOHy.useCallback)((newTotalCount)=>{
        if (newTotalCount === null || !operandDisplayValues?.length) return newTotalCount;
        let newTotalCountWithKeywords;
        if (showOperandDisplayValuesInFullList === true) newTotalCountWithKeywords = newTotalCount + operandDisplayValues.length;
        else newTotalCountWithKeywords = newTotalCount + value.filter((option)=>(0, $gMbEk.isSingleValueOption)(option) && operandDisplayValues.includes(option.value)).length;
        return newTotalCountWithKeywords < $8bc6c8c7998de8b9$var$MAX_TOTAL_COUNT ? newTotalCountWithKeywords : $8bc6c8c7998de8b9$var$MAX_TOTAL_COUNT;
    }, [
        operandDisplayValues,
        showOperandDisplayValuesInFullList,
        value
    ]);
    const checkIfError = (0, $eJOHy.useCallback)((search, options, onRetry)=>{
        const errorOption = options.find((option)=>option.optionType === 'error' && option.error instanceof Error);
        if (errorOption && errorOption.optionType === 'error') {
            setError({
                isError: true,
                error: errorOption.error,
                onRetry: onRetry
            });
            setIsLoading(false);
            return true;
        }
        setError({
            isError: false,
            error: null,
            onRetry: null
        });
        return false;
    }, []);
    const handleLoadOptions = (0, $eJOHy.useCallback)((search, overridenValue, renderInitialValues = enableFullList)=>{
        if (!loadOptions) return;
        searchRef.current = search;
        setIsLoading(true);
        loadOptions(search, renderInitialValues, undefined, ({ options: options, totalCount: newTotalCount, endCursor: newEndCursor })=>{
            // Handle error
            if (checkIfError(search, options, ()=>{
                handleLoadOptions(search);
            })) return; // This is to prevent outdated options/results from overriding if a race condition occurs
            if (searchRef.current !== search) return;
            if (search) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(loadedOptions, options)) {
                    setLoadedOptions(options);
                    setTotalCount(newTotalCount);
                }
            } else {
                const newLoadedOptions = (0, $bWslp.generateOptions)([
                    ...overridenValue ?? value
                ], options);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(loadedOptions, newLoadedOptions)) {
                    setLoadedOptions(newLoadedOptions);
                    setTotalCount(getTotalCountWithFunctions(newTotalCount));
                }
            }
            setEndCursor(newEndCursor);
            setIsLoading(false);
        });
    }, [
        loadOptions,
        enableFullList,
        checkIfError,
        value,
        loadedOptions,
        getTotalCountWithFunctions
    ]);
    const handleShowMore = (0, $eJOHy.useCallback)((firstLoad = false, isRetry = false)=>{
        if (!loadOptions || !loadedOptions) return;
        let originalLoadedOptions;
        if (firstLoad) {
            originalLoadedOptions = [];
            setIsLoading(true);
        } else {
            originalLoadedOptions = loadedOptions;
            if (isRetry) setIsLoading(true);
            else setIsPaginationLoading(true);
        }
        loadOptions(inputValue, false, endCursor, ({ options: options, totalCount: newTotalCount, endCursor: newEndCursor })=>{
            if (checkIfError(inputValue, options, ()=>{
                handleShowMore(firstLoad, true);
            })) return;
            const newLoadedOptions = inputValue ? originalLoadedOptions.concat(options) : (0, $bWslp.generateOptions)(value, options, originalLoadedOptions, firstLoad);
            setEnableFullList(false);
            setTotalCount(inputValue ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setLoadedOptions(newLoadedOptions);
            setIsPaginationLoading(false);
            setIsLoading(false);
            setEndCursor(newEndCursor);
        });
    }, [
        loadOptions,
        loadedOptions,
        inputValue,
        endCursor,
        checkIfError,
        value,
        getTotalCountWithFunctions,
        setIsPaginationLoading
    ]);
    const handleShowFullList = (0, $eJOHy.useCallback)(()=>{
        handleShowMore(true);
    }, [
        handleShowMore
    ]);
    const handleInputChange = (0, $eJOHy.useCallback)((newInputValue)=>{
        // on empty search: reset to default state for pickers where enableFullListProp==true
        if (newInputValue.length === 0 && enableFullListProp) {
            setEnableFullList(true);
            handleLoadOptions(newInputValue, undefined, true);
        } else {
            setEnableFullList(false);
            handleLoadOptions(newInputValue);
        }
        setInputValue(newInputValue);
        onInputChange && onInputChange();
    }, [
        enableFullListProp,
        handleLoadOptions,
        onInputChange
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)((options, meta)=>{
        if (!isColumnChangeInProgress.current && (0, $4cTDP.fg)('jira_inline_field_config_gate')) {
            isColumnChangeInProgress.current = true;
            rollbackOptionsRef.current = loadedOptions;
        }
        if ('option' in meta && meta.option) {
            const selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($gyBpf)))(loadedOptions, (option)=>(0, $gMbEk.isSingleValueOption)(option) && meta.option !== undefined && (0, $gMbEk.isSingleValueOption)(meta.option) && option.value === meta.option.value);
            onChange && onChange(options, meta, {
                selectedIndex: selectedIndex
            }, (0, $4cTDP.fg)('jira_inline_field_config_gate') ? ()=>{
                isColumnChangeInProgress.current = false;
            } : undefined, (0, $4cTDP.fg)('jira_inline_field_config_gate') ? ()=>{
                setLoadedOptions(rollbackOptionsRef.current);
                isColumnChangeInProgress.current = false;
            } : undefined);
        } else onChange && onChange(options, meta, undefined, (0, $4cTDP.fg)('jira_inline_field_config_gate') ? ()=>{
            isColumnChangeInProgress.current = false;
        } : undefined, (0, $4cTDP.fg)('jira_inline_field_config_gate') ? ()=>{
            setLoadedOptions(rollbackOptionsRef.current);
            isColumnChangeInProgress.current = false;
        } : undefined);
    }, [
        onChange,
        loadedOptions
    ]);
    const handleOnRestoreDefaults = (0, $eJOHy.useCallback)(()=>{
        if (typeof onRestoreDefaults === 'function') {
            const defaultOptions = onRestoreDefaults(); // Reset picker input and force update of options to go back to an initial-like state where selected options are on top
            setInputValue('');
            handleLoadOptions('', defaultOptions);
        }
    }, [
        handleLoadOptions,
        onRestoreDefaults
    ]); // We only want to call this on init, so it's ok to disable react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(()=>{
        handleLoadOptions(''); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const loadedOptionsWithFullList = (0, $eJOHy.useMemo)(()=>{
        let newLoadedOptions = loadedOptions;
        if (onSortOptions && !(0, $4cTDP.fg)('jira_inline_field_config_gate') && (0, $4cTDP.fg)('jira_list_merged_column_gate')) newLoadedOptions = onSortOptions(newLoadedOptions);
        return (0, $bWslp.addFullListToOptions)(newLoadedOptions, !enableFullList, onSortOptions);
    }, [
        loadedOptions,
        enableFullList,
        onSortOptions
    ]);
    const components = (0, $eJOHy.useMemo)(()=>isMulti ? {
            ...paginatedComponents,
            ...customComponents
        } : {
            ...paginatedSingleSelectComponents,
            ...customComponents
        }, [
        customComponents,
        isMulti,
        paginatedComponents,
        paginatedSingleSelectComponents
    ]);
    const selectedValue = (0, $eJOHy.useMemo)(/**
   * This method is to form the value from loadedOptionsWithFullList Array so that the 'Options' and 'Value' props of
   * select component will have same object references, This is a workaround to meet the below condition in the '@atlaskit/select'
   * component's ariaFocused method
   * var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));.
   * This condition must work to announce the state of selection.
   *
   * The below method can be removed if the above condition is improved to check just the value instead of reference.
   */ ()=>(0, $bWslp.getValueFromOptions)(loadedOptionsWithFullList, value), [
        loadedOptionsWithFullList,
        value
    ]);
    const showFooterType = (0, $eJOHy.useMemo)(()=>{
        const showFooter = !isLoading && loadedOptions && Boolean(loadedOptions.length) && !error.isError;
        if (showFooter) {
            if ((0, $4cTDP.fg)('jira_inline_field_config_gate')) {
                if (CustomFooter != null || renderFooter != null && (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates')) return 'custom';
            }
            return 'default';
        }
    }, [
        CustomFooter,
        error.isError,
        isLoading,
        loadedOptions,
        renderFooter
    ]);
    const handleOnKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (isPaginationLoading && event.key === 'ArrowUp' || isPaginationLoading && event.key === 'ArrowDown' || isLoading && event.key === 'ArrowUp' || isLoading && event.key === 'ArrowDown') {
            // prevent focusing first option when loading of more options
            event.preventDefault();
            return;
        }
        onKeyDown?.(event);
    }, [
        isLoading,
        isPaginationLoading,
        onKeyDown
    ]);
    const footerComponent = (0, $eJOHy.useMemo)(()=>{
        if (renderFooter && (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates')) return renderFooter(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1fUys.SimplePaginationDetails), {
            itemsCount: itemCount,
            totalCount: totalCount
        }));
        return CustomFooter;
    }, [
        renderFooter,
        CustomFooter,
        itemCount,
        totalCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showOperatorSelect && onChangeOperator && allowedOperators && Boolean(allowedOperators.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f1iCr.OperatorsSelect), {
        onChange: onChangeOperator,
        allowedOperators: allowedOperators,
        selectedOperator: selectedOperator
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j7wtI.BaseSelect), {
        components: components,
        inputValue: inputValue,
        onInputChange: handleInputChange,
        onMenuScrollToBottom: onMenuScrollToBottom,
        onMenuScrollToTop: onMenuScrollToTop,
        placeholder: placeholder,
        id: id,
        invalidLabel: invalidLabel,
        options: loadedOptionsWithFullList,
        setInitialFocusRef: setInitialFocusRef,
        menuListProps: {
            error: error,
            handleShowMore: handleShowMore,
            isLoading: isLoading,
            isPaginationLoading: isPaginationLoading,
            isShowMoreEnabled: totalCount !== null && itemCount < totalCount
        },
        onChange: handleOnChange,
        value: selectedValue,
        styles: $8bc6c8c7998de8b9$var$selectStyles,
        ...restProps,
        isMulti: isMulti,
        totalCount: totalCount,
        onKeyDown: handleOnKeyDown
    }), showFooterType === 'default' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8bc6c8c7998de8b9$var$Footer, null, onRestoreDefaults !== undefined ? typeof onRestoreDefaults === 'function' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5lNLi.default), {
        onRestoreDefaults: handleOnRestoreDefaults
    }) : Boolean(value.length) && isMulti && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j8m5Z.default), {
        onClear: onClear
    }), (!value.length || !isMulti) && enableFullList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $icknm.default), {
        onShowFullList: handleShowFullList
    }), !enableFullList && totalCount !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1fUys.PaginationDetails), {
        itemsCount: itemCount,
        totalCount: totalCount
    })), showFooterType === 'custom' && footerComponent, loadingScreenMessage.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), {
        role: "alert",
        "aria-live": "polite"
    }, loadingScreenMessage.current), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null));
};
var $8bc6c8c7998de8b9$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $8bc6c8c7998de8b9$var$PaginatedAsyncSelectView;
const $8bc6c8c7998de8b9$var$Footer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3do1o5y _ca0q1b66 _n3td1b66 _1e0c1txw _2lx2vrvc _4cvr1h6o _4t3i1ylp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gyBpf", function(module, exports) {

var $9gUEB = parcelRequire("9gUEB");

var $1lM9j = parcelRequire("1lM9j");

var $c9FP3 = parcelRequire("c9FP3");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c0dcd66d5aa7faa7$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $c0dcd66d5aa7faa7$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $c9FP3(fromIndex);
    if (index < 0) index = $c0dcd66d5aa7faa7$var$nativeMax(length + index, 0);
    return $9gUEB(array, $1lM9j(predicate, 3), index);
}
module.exports = $c0dcd66d5aa7faa7$var$findIndex;

});

parcelRegister("j8m5Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ce8dc8742c8663f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $aFyWG = parcelRequire("aFyWG");

var $6vNSg = parcelRequire("6vNSg");
const $4ce8dc8742c8663f$export$1d4b7cda9e589b53 = ({ onClear: onClear })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClearSelectedItems = (0, $eJOHy.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'filterSearchClearSelectedItems', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onClear && onClear();
    }, [
        onClear
    ]);
    const message = formatMessage((0, $6vNSg.default).clearAllSelectedItemsButtonText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aFyWG.LeftFooterButton), {
        message: message,
        onClick: onClearSelectedItems,
        appearance: "subtle-link",
        testId: "jql-builder-basic-picker.ui.async-select.clear-selection-button.clear-selected-items",
        hasTooltip: true
    });
};
var $4ce8dc8742c8663f$export$2e2bcd8739ae039 = $4ce8dc8742c8663f$export$1d4b7cda9e589b53;

});
parcelRegister("aFyWG", function(module, exports) {
$parcel$export(module.exports, "LeftFooterButton", () => $0affafe94b46ba2e$export$edc8e1365283b1f0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $6XJko = parcelRequire("6XJko");
const $0affafe94b46ba2e$export$edc8e1365283b1f0 = ({ message: message, onClick: onClick, testId: testId, appearance: appearance, hasTooltip: hasTooltip, label: label })=>{
    const shouldApplyVisualRefresh = (0, $6XJko.isVisualRefreshEnabled)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: appearance,
        onClick: onClick,
        testId: testId
    }, message);
    if (!hasTooltip) {
        if (shouldApplyVisualRefresh) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            padding: "space.050",
            xcss: $0affafe94b46ba2e$var$leftFooterButtonContainerStyles
        }, content);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0affafe94b46ba2e$var$LeftFooterButtonContainerOld, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: appearance,
            onClick: onClick,
            testId: testId
        }, message));
    }
    if (shouldApplyVisualRefresh) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        padding: "space.050",
        xcss: $0affafe94b46ba2e$var$leftFooterButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: message
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0affafe94b46ba2e$var$LeftFooterButtonContainerOld, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: appearance,
        onClick: onClick,
        testId: testId,
        ...label && {
            'aria-label': label
        }
    }, message)));
};
const $0affafe94b46ba2e$var$leftFooterButtonContainerStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    marginInlineStart: 'space.300'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0affafe94b46ba2e$var$LeftFooterButtonContainerOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _ahbqu2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6vNSg", function(module, exports) {
$parcel$export(module.exports, "default", () => $069e3a8465402294$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $069e3a8465402294$var$messages = (0, $7qGN1.defineMessages)({
    clearAllSelectedItemsButtonText: {
        "id": "jql-builder-basic-picker.async-select.clear-selection-button.clear-all-selected-items-button-text",
        "defaultMessage": "Clear selection"
    }
});
var $069e3a8465402294$export$2e2bcd8739ae039 = $069e3a8465402294$var$messages;

});


parcelRegister("f3ko0", function(module, exports) {
$parcel$export(module.exports, "MenuList", () => $810d101605fb454f$export$d4c4e98c5044dc8);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $6XEne = parcelRequire("6XEne");

var $kRgKj = parcelRequire("kRgKj");

var $4P0pd = parcelRequire("4P0pd");

var $9LD2u = parcelRequire("9LD2u");

var $lhCeH = parcelRequire("lhCeH");
const $810d101605fb454f$export$d4c4e98c5044dc8 = (props)=>{
    const { selectProps: { menuListProps: { error: { isError: isError, onRetry: onRetry }, handleShowMore: handleShowMore, isLoading: isLoading, isPaginationLoading: isPaginationLoading, isShowMoreEnabled: isShowMoreEnabled } } } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnShowMore = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'options',
            action: 'scrolled'
        }), 'filterSearchShowMore');
        handleShowMore();
    }, [
        handleShowMore,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MenuList, props, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LD2u.default), null), !isLoading && isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4P0pd.default), {
        onRetry: onRetry
    }), !isLoading && !isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children, isShowMoreEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lhCeH.default), {
        onShowMore: handleOnShowMore,
        isPaginationLoading: isPaginationLoading
    }))));
};
var $810d101605fb454f$export$2e2bcd8739ae039 = $810d101605fb454f$export$d4c4e98c5044dc8;

});
parcelRegister("4P0pd", function(module, exports) {
$parcel$export(module.exports, "default", () => $068e9aea02769269$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $80DPg = parcelRequire("80DPg");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cb8jR = parcelRequire("cb8jR");

var $ipK0z = parcelRequire("ipK0z");
const $068e9aea02769269$var$ErrorMessage = ({ onRetry: onRetry })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        onRetry?.();
        (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'refinementBarSelectRetry clicked');
    }, [
        onRetry,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        height: 144,
        "data-testid": "jql-builder-basic-picker.ui.async-select.menu-list.error-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        height: 72,
        iconSize: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledText), null, formatMessage((0, $ipK0z.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: onClick,
        appearance: "link",
        testId: "jql-builder-basic-picker.ui.async-select.menu-list.error-message.retry-button"
    }, formatMessage((0, $ipK0z.default).retryMessage)));
};
var $068e9aea02769269$export$2e2bcd8739ae039 = $068e9aea02769269$var$ErrorMessage;

});
parcelRegister("cb8jR", function(module, exports) {
$parcel$export(module.exports, "StyledBox", () => $965991b8073d69d7$export$d675f139b342d51a);
$parcel$export(module.exports, "StyledText", () => $965991b8073d69d7$export$31ea92f3997410dd);
$parcel$export(module.exports, "StyledControl", () => $965991b8073d69d7$export$5c7b7f0e517b89f8);
$parcel$export(module.exports, "CloseIconWrapper", () => $965991b8073d69d7$export$94756becb802e330);
$parcel$export(module.exports, "DisplayWrapper", () => $965991b8073d69d7$export$6833d6d22987ee7f);
$parcel$export(module.exports, "CustomOptionStyles", () => $965991b8073d69d7$export$fa3694617a82202b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $806LH = parcelRequire("806LH");
const $965991b8073d69d7$export$d675f139b342d51a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10ib6lf": (0, $awdRS.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $awdRS.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _1bah1h6o",
            __cmplp.height ? "_4t3it1jn" : "_4t3i1qr7",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$var$StyledTextComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($965991b8073d69d7$var$StyledTextComponent, props));
const $965991b8073d69d7$export$5c7b7f0e517b89f8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zl1wtt _1e0c1txw _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$export$94756becb802e330 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_80omtlke _30l31ibz",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$export$6833d6d22987ee7f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { displayFlag: displayFlag, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.displayFlag ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$export$fa3694617a82202b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasIconAfter: hasIconAfter, isSingleSelect: isSingleSelect, isFocused: isFocused, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_13a9kew": (0, $awdRS.default)(__cmplp.isFocused ? `inset 2px 0px 0px ${"var(--ds-border-focused, #4688EC)"}` : 'none'),
            "--_1p23kyf": (0, $awdRS.default)(__cmplp.isDisabled ? 'color.text.disabled' : 'color.text')
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _dzc2v2br _m3zku2gc",
            __cmplp.hasIconAfter ? "_sktr1ejb" : "_sktrze3t",
            __cmplp.isSingleSelect && "_bp7o1csk _ngc03plq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ipK0z", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0214a23e274561c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c0214a23e274561c$var$messages = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "jql-builder-basic-picker.async-select.menu-list.error-message.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "jql-builder-basic-picker.async-select.menu-list.error-message.retry-message",
        "defaultMessage": "Click to retry"
    }
});
var $c0214a23e274561c$export$2e2bcd8739ae039 = $c0214a23e274561c$var$messages;

});


parcelRegister("9LD2u", function(module, exports) {
$parcel$export(module.exports, "default", () => $da95119f1df2e865$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $kDaaB = parcelRequire("kDaaB");

var $cb8jR = parcelRequire("cb8jR");

var $dyWxb = parcelRequire("dyWxb");
const $da95119f1df2e865$export$e928a71d039d3102 = ()=>// eslint disabled because it is valid for options, see recommended https://github.com/jsx-eslint/eslint-plugin-@atlassian/a11y/blob/main/docs/rules/no-noninteractive-element-to-interactive-role.md
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "li",
        xcss: $da95119f1df2e865$var$listItemStyle,
        role: "option",
        "aria-selected": false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        "data-testid": "jql-builder-basic-picker.ui.async-select.menu-list.loading-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        height: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $dyWxb.default).loadingMessage))));
var $da95119f1df2e865$export$2e2bcd8739ae039 = $da95119f1df2e865$export$e928a71d039d3102;
const $da95119f1df2e865$var$listItemStyle = (0, $1DXK0.xcss)({
    listStyle: 'none'
});

});
parcelRegister("dyWxb", function(module, exports) {
$parcel$export(module.exports, "default", () => $9012dc4eef88d2fd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9012dc4eef88d2fd$var$messages = (0, $7qGN1.defineMessages)({
    loadingMessage: {
        "id": "jql-builder-basic-picker.async-select.menu-list.loading-message.loading-message",
        "defaultMessage": "Loading..."
    }
});
var $9012dc4eef88d2fd$export$2e2bcd8739ae039 = $9012dc4eef88d2fd$var$messages;

});


parcelRegister("lhCeH", function(module, exports) {
$parcel$export(module.exports, "default", () => $553b58ca6b88f3b1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $lRq8t = parcelRequire("lRq8t");

var $1R4YX = parcelRequire("1R4YX");

var $aJkOP = parcelRequire("aJkOP");
const $553b58ca6b88f3b1$var$LoadMoreTrigger = ({ onShowMore: onShowMore, isPaginationLoading: isPaginationLoading })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const loadingRef = /*#__PURE__*/ (0, $eJOHy.createRef)();
    const loadMoreRef = (0, $1R4YX.useIntersectionObserver)({
        margin: 0,
        onIntersection: ()=>{
            if (!isPaginationLoading) {
                loadingRef?.current?.scrollIntoView();
                onShowMore();
            }
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        role: "option",
        "aria-hidden": "true",
        "aria-selected": false,
        ref: loadingRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $553b58ca6b88f3b1$var$loadingContainerStyles,
        justifyContent: "center",
        alignItems: "center",
        ref: loadMoreRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        label: formatMessage((0, $aJkOP.default).loadingLabel)
    })));
};
const $553b58ca6b88f3b1$var$loadingContainerStyles = (0, $1DXK0.xcss)({
    height: '56px'
});
var $553b58ca6b88f3b1$export$2e2bcd8739ae039 = $553b58ca6b88f3b1$var$LoadMoreTrigger;

});
parcelRegister("1R4YX", function(module, exports) {
$parcel$export(module.exports, "useIntersectionObserver", () => $01379305a4b54492$export$a7395f9832c00176);

var $eJOHy = parcelRequire("eJOHy");
const $01379305a4b54492$export$a7395f9832c00176 = ({ margin: margin, threshold: threshold = 0, onIntersection: onIntersection })=>{
    const [observedElement, setObservedElement] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (observedElement === null || window.IntersectionObserver === undefined) return undefined;
        const observerCallback = (entries)=>entries.forEach(({ isIntersecting: isIntersecting, time: time })=>{
                if (isIntersecting) onIntersection(time);
            });
        const observer = new IntersectionObserver(observerCallback, {
            rootMargin: `${margin}px`,
            threshold: threshold
        });
        observer.observe(observedElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        observedElement,
        onIntersection,
        margin,
        threshold
    ]);
    return setObservedElement;
};

});

parcelRegister("aJkOP", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c10a5a4e92317e0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9c10a5a4e92317e0$var$messages = (0, $7qGN1.defineMessages)({
    loadingLabel: {
        "id": "jql-builder-basic-picker.async-select.menu-list.load-more-trigger.loading-label",
        "defaultMessage": "Loading"
    }
});
var $9c10a5a4e92317e0$export$2e2bcd8739ae039 = $9c10a5a4e92317e0$var$messages;

});



parcelRegister("f1iCr", function(module, exports) {
$parcel$export(module.exports, "OperatorsSelect", () => $45891c3f91875637$export$72ded8b112fe0b1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $8nu6j = parcelRequire("8nu6j");

var $c4OV1 = parcelRequire("c4OV1");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cO6Ov = parcelRequire("cO6Ov");
const $45891c3f91875637$var$selectStyles = {
    control: (baseStyles)=>({
            ...baseStyles,
            backgroundColor: "var(--ds-background-neutral, #0515240F)"
        })
};
const $45891c3f91875637$var$styles = {
    operatorsSelectOld: "_u5f3utpp _19bvutpp _ca0qu2gc",
    operatorsSelect: "_u5f3utpp _19bvutpp _ca0qze3t _n3tdu2gc"
};
const $45891c3f91875637$var$getOptionLabel = (option)=>option.ariaLabel;
const $45891c3f91875637$var$formatOptionLabel = (option)=>option.label;
const $45891c3f91875637$export$72ded8b112fe0b1 = ({ onChange: onChange, allowedOperators: allowedOperators, selectedOperator: selectedOperator })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onChangeWithAnalytics = (0, $eJOHy.useCallback)((option)=>{
        onChange && onChange(option);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        });
        option && (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'operatorSelect', {
            option: option.value,
            selectType: 'dropdown'
        });
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const onMenuOpenAnalytics = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'dropdown'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'operatorSelect', {
            selectType: 'dropdown'
        });
    }, [
        createAnalyticsEvent
    ]);
    const onKeyDown = (0, $eJOHy.useCallback)((event)=>{
        event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $k0ahr.cx)((0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? $45891c3f91875637$var$styles.operatorsSelect : $45891c3f91875637$var$styles.operatorsSelectOld)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        "aria-label": formatMessage((0, $cO6Ov.default).operatorLabel),
        value: selectedOperator || allowedOperators[0],
        options: allowedOperators,
        onChange: onChangeWithAnalytics,
        spacing: "compact",
        appearance: "subtle",
        styles: $45891c3f91875637$var$selectStyles,
        onKeyDown: onKeyDown,
        onMenuOpen: onMenuOpenAnalytics,
        isSearchable: false,
        getOptionLabel: $45891c3f91875637$var$getOptionLabel,
        formatOptionLabel: $45891c3f91875637$var$formatOptionLabel
    }));
};

});
parcelRegister("cO6Ov", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1c4c55cc3aef0b4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b1c4c55cc3aef0b4$var$messages = (0, $7qGN1.defineMessages)({
    operatorLabel: {
        "id": "jql-builder-basic-picker.async-select.operator-select.operator-label",
        "defaultMessage": "Operator dropdown"
    }
});
var $b1c4c55cc3aef0b4$export$2e2bcd8739ae039 = $b1c4c55cc3aef0b4$var$messages;

});


parcelRegister("1fUys", function(module, exports) {
$parcel$export(module.exports, "PaginationDetails", () => $60bd543addf3cb57$export$33eb0288c0936a84);
$parcel$export(module.exports, "SimplePaginationDetails", () => $60bd543addf3cb57$export$b7935720442eff68);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $kCiis = parcelRequire("kCiis");
const $60bd543addf3cb57$var$styles = {
    paginationDetails: "_11c82smr _y3gnusic _syaz1rpy _16jlkb7n _1o9zidpf _i0dl1wug _19pkze3t _2hwxutpp _otyrze3t _18u0utpp",
    fontMedium: "_k48p1wq8"
};
const $60bd543addf3cb57$export$33eb0288c0936a84 = ({ itemsCount: itemsCount, totalCount: totalCount })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (totalCount == null) return null;
    return /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    , {
        "data-testid": "jql-builder-basic.ui.jql-editor.picker.async-select.pagination-details",
        className: (0, $hcewu.default)([
            $60bd543addf3cb57$var$styles.paginationDetails,
            (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') && $60bd543addf3cb57$var$styles.fontMedium
        ])
    }, formatMessage((0, $kCiis.default).ofTotalCount, {
        itemsCount: itemsCount,
        totalCount: totalCount
    }));
};
const $60bd543addf3cb57$export$b7935720442eff68 = ({ itemsCount: itemsCount, totalCount: totalCount })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ $eJOHy.createElement((0, $3cMgR.default), {
        color: "color.text.subtlest",
        weight: "medium"
    }, formatMessage((0, $kCiis.default).ofTotalCount, {
        itemsCount: itemsCount,
        totalCount: totalCount
    }));
};

});
parcelRegister("kCiis", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ca9967a4a24ae17$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6ca9967a4a24ae17$var$messages = (0, $7qGN1.defineMessages)({
    ofTotalCount: {
        "id": "jql-builder-basic-picker.async-select.pagination-details.of-total-count",
        "defaultMessage": "{itemsCount} of {totalCount}"
    }
});
var $6ca9967a4a24ae17$export$2e2bcd8739ae039 = $6ca9967a4a24ae17$var$messages;

});


parcelRegister("5lNLi", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce6429fb8860ba26$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $aFyWG = parcelRequire("aFyWG");

var $5HR61 = parcelRequire("5HR61");
const $ce6429fb8860ba26$export$2543cc45221bf5bc = ({ onRestoreDefaults: onRestoreDefaults })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleRestoreDefaults = (0, $eJOHy.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'filterSearchRestoreDefaults', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onRestoreDefaults && onRestoreDefaults();
    }, [
        onRestoreDefaults
    ]);
    const message = formatMessage((0, $5HR61.default).restoreDefaultsButtonText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aFyWG.LeftFooterButton), {
        message: message,
        onClick: handleRestoreDefaults,
        appearance: "subtle-link",
        testId: "jql-builder-basic-picker.ui.async-select.restore-defaults-button",
        hasTooltip: true
    });
};
var $ce6429fb8860ba26$export$2e2bcd8739ae039 = $ce6429fb8860ba26$export$2543cc45221bf5bc;

});
parcelRegister("5HR61", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f7feca5c1b3e4c8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $1f7feca5c1b3e4c8$var$messages = (0, $7qGN1.defineMessages)({
    restoreDefaultsButtonText: {
        "id": "jql-builder-basic-picker.async-select.restore-defaults-button.restore-defaults-button-text",
        "defaultMessage": "Restore defaults"
    }
});
var $1f7feca5c1b3e4c8$export$2e2bcd8739ae039 = $1f7feca5c1b3e4c8$var$messages;

});


parcelRegister("j7wtI", function(module, exports) {
$parcel$export(module.exports, "selectComponents", () => $952582033f9b0a69$export$c34d65c0f5a1c617);
$parcel$export(module.exports, "singleSelectComponents", () => $952582033f9b0a69$export$6161e15c6859b0c9);
$parcel$export(module.exports, "BaseSelect", () => $952582033f9b0a69$export$dcee1aa94a106d27);

var $eJOHy = parcelRequire("eJOHy");

var $c4OV1 = parcelRequire("c4OV1");

var $mjinE = parcelRequire("mjinE");

var $dMM78 = parcelRequire("dMM78");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $d9b92 = parcelRequire("d9b92");

var $gMbEk = parcelRequire("gMbEk");


var $gWVN2 = parcelRequire("gWVN2");

var $62EHB = parcelRequire("62EHB");

var $aeAJB = parcelRequire("aeAJB");

var $35vKc = parcelRequire("35vKc");

var $3UBK2 = parcelRequire("3UBK2");

var $fSowc = parcelRequire("fSowc");

var $j1sv5 = parcelRequire("j1sv5");
const $952582033f9b0a69$export$c34d65c0f5a1c617 = {
    Control: $gWVN2.default,
    DropdownIndicator: $62EHB.default,
    LoadingIndicator: ()=>null,
    Menu: $aeAJB.default,
    Option: $fSowc.default
};
const $952582033f9b0a69$export$6161e15c6859b0c9 = {
    Control: $gWVN2.default,
    DropdownIndicator: $62EHB.default,
    LoadingIndicator: undefined,
    Menu: $aeAJB.default
};
const $952582033f9b0a69$var$onIsOptionDisabled = (option, value)=>{
    if (option.optionType === 'error') return true;
    // if an option is only unselectable and currently selected, it should not be a disabled option
    if ('isOnlyUnselectable' in option && option.isOnlyUnselectable) {
        const isSelectedOption = (0, $gMbEk.isSingleValueOption)(option) && value.map((v)=>(0, $gMbEk.isSingleValueOption)(v) && v.value).includes(option.value);
        return !(isSelectedOption && option.isOnlyUnselectable);
    }
    if ('isDisabled' in option && option.isDisabled) return option.isDisabled;
    return false;
};
// Needed to disable filtering from react-select
const $952582033f9b0a69$var$noFilterOptions = ()=>true;
const $952582033f9b0a69$export$dcee1aa94a106d27 = ({ onReload: onReload, placeholder: placeholder, NoOptionsMessage: NoOptionsMessage = (0, $3UBK2.default), isMulti: isMulti = true, setInitialFocusRef: setInitialFocusRef, totalCount: totalCount, components: componentsSelect, options: options, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, ...restProps })=>{
    const { onInputChange: onInputChangeProp, inputValue: inputValueProp, id: id, menuListProps: { isLoading: isLoading, error: { isError: isError, error: error } }, experienceAnalyticsAttributes: experienceAnalyticsAttributes, value: value } = restProps;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectRef = /*#__PURE__*/ (0, $eJOHy.createRef)(); // use any type for react-select ref
    const [inputValue, setInputValue] = (0, $eJOHy.useState)(inputValueProp ?? '');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        // only set once when the component mounted
        if (selectRef.current && setInitialFocusRef) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        setInitialFocusRef(selectRef.current.select.inputRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (options && !(isLoading ?? false)) {
            let errorType = 'unknown';
            if (error != null && (0, $dMM78.isClientFetchError)(error)) errorType = 'networkError';
            const errorAttributes = error ? {
                errorType: errorType,
                message: error.message
            } : null;
            (0, $mjinE.default)({
                analyticsSource: 'refinement-bar-select',
                wasExperienceSuccesful: error == null,
                experience: 'showOptions',
                application: null,
                edition: null,
                additionalAttributes: {
                    filter: id ?? 'unknown',
                    ...experienceAnalyticsAttributes,
                    ...errorAttributes
                }
            });
        }
    }, [
        isError,
        error,
        isLoading,
        options,
        id,
        experienceAnalyticsAttributes
    ]);
    const hasEnabledOption = (0, $eJOHy.useMemo)(()=>options?.some((option)=>!$952582033f9b0a69$var$onIsOptionDisabled(option, value)), [
        options,
        value
    ]);
    const onInputChange = (0, $eJOHy.useCallback)((newInputValue, meta)=>{
        /**
     * Do not clear the filter input value when an input is selected or blured.
     * NOTE: We are also returning when 'menu-close' event are triggered,
     * which happens when the input is clicked for some reason, but not when we click outside of the dropdown
     * */ if (Array.from([
            (0, $d9b92.MetaActions).setValue,
            (0, $d9b92.MetaActions).inputBlur,
            (0, $d9b92.MetaActions).menuClose
        ]).includes(meta.action) && !newInputValue.length) return;
        // Reload defaultOptions in case of potential error by changing key on AsyncSelect
        if (meta.action === (0, $d9b92.MetaActions).inputChange && !newInputValue.length) onReload?.('');
        onInputChangeProp && onInputChangeProp(newInputValue, meta);
        setInputValue(newInputValue);
    }, [
        onInputChangeProp,
        onReload
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
        setInputValue(inputValueProp);
    }, [
        inputValueProp
    ]);
    const getOptionLabel = (0, $eJOHy.useCallback)((option)=>{
        if ((0, $gMbEk.isSingleValueOption)(option)) {
            if (typeof option.secondaryLabel === 'string') return `${option.label}, ${option.secondaryLabel}`;
            if (// remove !isValidElement(data.secondaryLabel) with cleanup with m7.3-mm2-custom-fields-with-existing-uis_vzhn7
            typeof option.secondaryLabel === 'object' && !/*#__PURE__*/ (0, $eJOHy.isValidElement)(option.secondaryLabel)) return `${option.label}, ${option.secondaryLabel.label}`;
            return option.label;
        }
        return option.optionType === 'group' ? option?.label ?? '' : '';
    }, []);
    // placeholder type is reactNode and aria-label won't allow, for safe side checking the type and empty value
    const ariaLabel = typeof placeholder === 'string' && placeholder ? placeholder : formatMessage((0, $35vKc.default).searchPlaceholder);
    const OriginalOptionComponent = componentsSelect?.Option || undefined;
    // Note: this is a workaround to not visually focus any option, when there are only disabled options in the list
    // react-select autofocuses the first option, see more here: https://github.com/JedWatson/react-select/pull/4080
    // tracked bug ticket: https://product-fabric.atlassian.net/browse/DSP-17138
    const OptionComponentExtended = (0, $eJOHy.useCallback)((props)=>OriginalOptionComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(OriginalOptionComponent, {
            ...props,
            isFocused: hasEnabledOption ? props.isFocused : false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null), [
        OriginalOptionComponent,
        hasEnabledOption
    ]);
    const unselectedOptions = (0, $eJOHy.useMemo)(()=>{
        if (!isInBetweenColumnPickerEnabled) return [];
        if (!inputValue) return (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? options?.filter((option)=>option.optionType === 'group' && option.id !== (0, $398aa02f7b594968$export$bfd1c05c2e5a5a01)) || [] : options?.filter((option)=>option.optionType === 'group') || [];
        const selectedOptions = new Set(value.map((v)=>(0, $gMbEk.isSingleValueOption)(v) ? v.value : ''));
        return options?.filter((option)=>(0, $gMbEk.isSingleValueOption)(option) && !selectedOptions.has(option.value)) || [];
    }, [
        isInBetweenColumnPickerEnabled,
        inputValue,
        options,
        value
    ]);
    const memoizedComponents = (0, $eJOHy.useMemo)(()=>{
        const totalCountOfUnselectedFields = totalCount ? totalCount - value.length : null;
        let groupComponents = {};
        if ((0, $4cTDP.fg)('jira_inline_field_config_gate')) groupComponents = {
            GroupHeading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j1sv5.GroupHeading), {
                    ...props,
                    totalCount: totalCountOfUnselectedFields
                })
        };
        // this changes should override the IFC changes
        if ((0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates')) groupComponents = {
            GroupHeading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j1sv5.GroupHeadingNew), props),
            Group: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j1sv5.Group), props)
        };
        return {
            ...componentsSelect,
            ...groupComponents,
            ...OriginalOptionComponent !== undefined ? {
                Option: OptionComponentExtended
            } : {}
        };
    }, [
        componentsSelect,
        OriginalOptionComponent,
        OptionComponentExtended,
        totalCount,
        value.length
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        ...restProps,
        options: isInBetweenColumnPickerEnabled && (0, $4cTDP.fg)('jira_inline_field_config_gate') ? unselectedOptions : options,
        // Using classNamePrefix to identify the select component in cypress test, testId doesn't work (doc https://atlassian.design/components/select/testing)
        classNamePrefix: "jql-builder-basic-picker-atlaskit-select",
        components: memoizedComponents,
        cacheOptions: false,
        ref: selectRef,
        autoFocus: !setInitialFocusRef,
        backspaceRemovesValue: false,
        blurInputOnSelect: false,
        closeMenuOnSelect: false,
        controlShouldRenderValue: false,
        hideSelectedOptions: false,
        isClearable: false,
        isMulti: isMulti,
        inputValue: inputValue,
        menuIsOpen: true,
        menuShouldScrollIntoView: false,
        tabSelectsValue: false,
        onInputChange: onInputChange,
        isOptionDisabled: $952582033f9b0a69$var$onIsOptionDisabled,
        reload: onReload,
        filterOption: $952582033f9b0a69$var$noFilterOptions,
        placeholder: placeholder ?? formatMessage((0, $35vKc.default).searchPlaceholder),
        label: ariaLabel,
        noOptionsMessage: NoOptionsMessage,
        getOptionLabel: getOptionLabel
    });
};

});
const $398aa02f7b594968$export$eb85a4c9b5d9ce7b = 'all-columns';
const $398aa02f7b594968$export$bfd1c05c2e5a5a01 = 'selected-columns';

parcelRegister("gWVN2", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c50f99a84b41b08$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dt3aG = parcelRequire("dt3aG");

var $8nu6j = parcelRequire("8nu6j");

var $6XJko = parcelRequire("6XJko");

var $4cTDP = parcelRequire("4cTDP");

var $cb8jR = parcelRequire("cb8jR");
const $0c50f99a84b41b08$var$styles = {
    control: "_2rko12b0 _1dqonqa1 _189ee4h9 _1h6drsbi _1e0c1txw _syaz1rpy _19pkze3t _2hwxutpp _otyrze3t _18u0utpp _jyzf1v1w _1u6lvyy1",
    wrapper: "_1e0c1txw _4cvr1h6o _19bvu2gc"
};
const $0c50f99a84b41b08$export$7a7fa4424cb20976 = ({ children: children, innerProps: innerProps, innerRef: innerRef })=>{
    if ((0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates')) return /*#__PURE__*/ $eJOHy.createElement("div", {
        ref: innerRef ?? undefined,
        ...innerProps,
        className: (0, $hcewu.default)([
            $0c50f99a84b41b08$var$styles.control
        ])
    }, (0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        xcss: $0c50f99a84b41b08$var$styles.wrapper
    }, /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        label: ""
    })), children);
    return /*#__PURE__*/ $eJOHy.createElement((0, $cb8jR.StyledControl), {
        ref: innerRef ?? undefined,
        ...innerProps
    }, (0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        xcss: $0c50f99a84b41b08$var$styles.wrapper
    }, /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        label: ""
    })), children);
};
var $0c50f99a84b41b08$export$2e2bcd8739ae039 = $0c50f99a84b41b08$export$7a7fa4424cb20976;

});

parcelRegister("62EHB", function(module, exports) {
$parcel$export(module.exports, "default", () => $54055c12a318bc3b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $a03qM = parcelRequire("a03qM");

var $bQP4O = parcelRequire("bQP4O");

var $dt3aG = parcelRequire("dt3aG");

var $6XEne = parcelRequire("6XEne");

var $4cTDP = parcelRequire("4cTDP");

var $6XJko = parcelRequire("6XJko");

var $cb8jR = parcelRequire("cb8jR");
const $54055c12a318bc3b$var$styles = {
    dropdownIndicatorWrapper: "_2hwxv77o _y3gn1h6o",
    dropdownIndicatorWrapperOld: "_2hwxv77o _y3gn1h6o _1bsbzwfg",
    iconWrapper: "_2rko1rr0 _1e0c1txw _80omtlke _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz1rpy _30l31sqi"
};
const $54055c12a318bc3b$export$ec98719d3db7f2e4 = (props)=>{
    return /*#__PURE__*/ $eJOHy.createElement((0, $6XEne.components).DropdownIndicator, props, /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? $54055c12a318bc3b$var$styles.dropdownIndicatorWrapper : $54055c12a318bc3b$var$styles.dropdownIndicatorWrapperOld
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $cb8jR.DisplayWrapper), {
        displayFlag: props.selectProps.inputValue
    }, (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? /*#__PURE__*/ $eJOHy.createElement((0, $bQP4O.default), {
        xcss: $54055c12a318bc3b$var$styles.iconWrapper,
        onClick: (event)=>{
            event.preventDefault();
            props.selectProps.onInputChange && props.selectProps.onInputChange('', {
                action: 'input-change',
                prevInputValue: props.selectProps.inputValue
            });
        },
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1
    }, /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        label: ""
    })) : /*#__PURE__*/ $eJOHy.createElement((0, $cb8jR.CloseIconWrapper), {
        "data-testid": "jql-builder-basic-picker.ui.async-select.select.dropdown-indicator.dropdown-close-icon",
        onClick: (event)=>{
            event.preventDefault();
            props.selectProps.onInputChange && props.selectProps.onInputChange('', {
                action: 'input-change',
                prevInputValue: props.selectProps.inputValue
            });
        }
    }, /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        label: ""
    }))), !(0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ $eJOHy.createElement((0, $cb8jR.DisplayWrapper), {
        displayFlag: !props.selectProps.inputValue
    }, /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        label: ""
    }))));
};
var $54055c12a318bc3b$export$2e2bcd8739ae039 = $54055c12a318bc3b$export$ec98719d3db7f2e4;

});

parcelRegister("aeAJB", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b7f34fee106459a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $4b7f34fee106459a$var$Menu = ({ innerRef: innerRef, innerProps: innerProps, children: children })=>// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4b7f34fee106459a$var$MenuBox, {
        "data-testid": "refinement-bar.common.ui.select.menu",
        ref: innerRef,
        ...innerProps
    }, children);
var $4b7f34fee106459a$export$2e2bcd8739ae039 = $4b7f34fee106459a$var$Menu;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4b7f34fee106459a$var$MenuBox = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("35vKc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6409cd14587ac6e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b6409cd14587ac6e$var$messages = (0, $7qGN1.defineMessages)({
    searchPlaceholder: {
        "id": "jql-builder-basic-picker.async-select.select.search-placeholder",
        "defaultMessage": "Search"
    }
});
var $b6409cd14587ac6e$export$2e2bcd8739ae039 = $b6409cd14587ac6e$var$messages;

});

parcelRegister("3UBK2", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba06491bbd0f20a1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $80DPg = parcelRequire("80DPg");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $kDaaB = parcelRequire("kDaaB");

var $eS29z = parcelRequire("eS29z");

var $6XJko = parcelRequire("6XJko");

var $cb8jR = parcelRequire("cb8jR");

var $lWJ0U = parcelRequire("lWJ0U");
const $ba06491bbd0f20a1$var$NoOptionsMessageContainer = ({ children: children })=>{
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.150",
        alignInline: "center"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $lWJ0U.default).noOptionsPrimaryMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "small",
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $lWJ0U.default).noOptionsSecondaryMessage)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        height: 72
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $lWJ0U.default).noOptionsMessage)));
};
const $ba06491bbd0f20a1$export$d58b72b7d3c4072c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        "data-testid": "jql-builder-basic.ui.jql-editor.picker.async-select.select.no-options-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ba06491bbd0f20a1$var$NoOptionsMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        label: "",
        color: "var(--ds-icon, #292A2E)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        actionSubject: "emptyState",
        action: "viewed",
        actionSubjectId: "noMatches"
    }));
var $ba06491bbd0f20a1$export$2e2bcd8739ae039 = $ba06491bbd0f20a1$export$d58b72b7d3c4072c;

});
parcelRegister("lWJ0U", function(module, exports) {
$parcel$export(module.exports, "default", () => $43e390d646017ea1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $43e390d646017ea1$var$messages = (0, $7qGN1.defineMessages)({
    noOptionsMessage: {
        "id": "jql-builder-basic-picker.async-select.select.no-options-message.no-options-message",
        "defaultMessage": "No matches found"
    },
    noOptionsPrimaryMessage: {
        "id": "jql-builder-basic-picker.async-select.select.no-options-message.no-options-primary-message",
        "defaultMessage": "We couldn't find what you're looking for"
    },
    noOptionsSecondaryMessage: {
        "id": "jql-builder-basic-picker.async-select.select.no-options-message.no-options-secondary-message",
        "defaultMessage": "Try using different search terms."
    }
});
var $43e390d646017ea1$export$2e2bcd8739ae039 = $43e390d646017ea1$var$messages;

});


parcelRegister("fSowc", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c802979ef0e97e4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $80DPg = parcelRequire("80DPg");

var $2R0ne = parcelRequire("2R0ne");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $jzkyh = parcelRequire("jzkyh");
var $6XEne = parcelRequire("6XEne");

var $k71qx = parcelRequire("k71qx");

var $8cv11 = parcelRequire("8cv11");

var $cb8jR = parcelRequire("cb8jR");

var $1MOGE = parcelRequire("1MOGE");
const $9c802979ef0e97e4$var$tooltipStyles = null;
const $9c802979ef0e97e4$var$ConditionalTooltip = ({ condition: condition, content: content, children: children })=>condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: content
    }, children) : children;
const $9c802979ef0e97e4$export$36d18380658d5d20 = ({ isMulti: isMulti = true, ...props })=>{
    const iconRef = (0, $eJOHy.useRef)(null);
    const { isOnlyUnselectable: isOnlyUnselectable, disabledMessage: disabledMessage, invalid: invalid } = props.data?.optionType === 'option' || props.data?.optionType === 'avatar' || props.data?.optionType === 'lozenge' || props.data?.optionType === 'field' ? props.data : {
        isOnlyUnselectable: undefined,
        disabledMessage: undefined,
        invalid: undefined
    };
    // Only disable checkbox for an only unselectable option when it is not a selected option
    const optionState = (0, $1MOGE.getOptionState)(props.isDisabled, Boolean(isOnlyUnselectable), props.isSelected, Boolean(invalid));
    const hasIconAfter = ()=>{
        switch(optionState){
            case 'only-unselectable-unselected':
            case 'only-unselectable-selected':
            case 'disabled':
                return Boolean(disabledMessage);
            case 'invalid':
                return true;
            default:
                return undefined;
        }
    };
    const OptionInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        spread: "space-between",
        alignBlock: "center",
        xcss: $9c802979ef0e97e4$export$d318e19053d98641[optionState].xcss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.CustomOptionStyles), {
        hasIconAfter: hasIconAfter(),
        isFocused: props.isFocused,
        isDisabled: props.isDisabled,
        isSingleSelect: true
    }, isMulti ? /* @ts-expect-error - This component has stricter OptionType args which isn't compatible with ErrorOption in SelectOption. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jzkyh.CheckboxOption), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option, {
        ...props,
        isMulti: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9c802979ef0e97e4$var$TooltipContainer, {
        ref: iconRef
    }, optionState !== 'invalid' && Boolean(disabledMessage) && // Show a tooltip for mouse users, since option.isFocused is not triggered for disabled options on mouse over
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9c802979ef0e97e4$var$ConditionalTooltip, {
        content: disabledMessage,
        condition: props.isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
        testId: "jql-builder-basic-picker.ui.async-select.select.option.info-icon",
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    })), optionState === 'invalid' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        testId: "jql-builder-basic-picker.ui.async-select.select.option.invalid-icon",
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon-danger, #C9372C)"
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": $9c802979ef0e97e4$export$d318e19053d98641[optionState].testid
    }, optionState === 'only-unselectable-unselected' || optionState === 'disabled' || optionState === 'invalid' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9c802979ef0e97e4$var$UnsafeStyledCheckboxOption, null, OptionInner) : OptionInner), (disabledMessage || props.selectProps?.invalidLabel && optionState === 'invalid') && props.isFocused && iconRef.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8cv11.JiraPopper), {
        referenceElement: iconRef.current,
        placement: "bottom",
        messageType: "transactional",
        messageId: "jql-builder-basic-picker.ui.async-select.select.option.popper"
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            ref: ref,
            style: style,
            className: (0, $hcewu.default)([
                "_2rko12b0 _11c8dcr7 _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna"
            ])
        }, optionState === 'invalid' ? props.selectProps?.invalidLabel : disabledMessage))));
};
var $9c802979ef0e97e4$export$2e2bcd8739ae039 = $9c802979ef0e97e4$export$36d18380658d5d20;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9c802979ef0e97e4$var$UnsafeStyledCheckboxOption = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_nrk9jdj5",
            __cmplp.className
        ])
    });
});
const $9c802979ef0e97e4$var$TooltipContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _18u0p1rm _u5f3utpp _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $9c802979ef0e97e4$var$DisabledCheckboxOptionStyles = (0, $1DXK0.xcss)({
    color: 'color.text.disabled'
});
const $9c802979ef0e97e4$var$InvalidCheckboxOptionStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.danger'
});
const $9c802979ef0e97e4$export$d318e19053d98641 = {
    disabled: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option.disabled-option',
        xcss: [
            $9c802979ef0e97e4$var$DisabledCheckboxOptionStyles
        ]
    },
    invalid: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option.invalid-option',
        xcss: [
            $9c802979ef0e97e4$var$InvalidCheckboxOptionStyles
        ]
    },
    selected: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.selected-option',
        xcss: []
    },
    unselected: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option',
        xcss: []
    },
    'only-unselectable-unselected': {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option.only-unselectable',
        xcss: [
            $9c802979ef0e97e4$var$DisabledCheckboxOptionStyles
        ]
    },
    'only-unselectable-selected': {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.selected-option.only-unselectable',
        xcss: []
    }
};

});
parcelRegister("jzkyh", function(module, exports) {
$parcel$export(module.exports, "CheckboxOption", () => $c59673c02b42adcb$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $c59673c02b42adcb$export$82ab7168879267a7);
/* input-options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dwm7g = parcelRequire("dwm7g");

var $279SN = parcelRequire("279SN");

var $2Swhg = parcelRequire("2Swhg");

var $eGOwo = parcelRequire("eGOwo");
const $c59673c02b42adcb$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk18uv _16qs1kw7 _syaz1kw7 _1di6fcek",
    focused: "_bfhk1dpa _16qsgkog _112e126o",
    disabled: "_syaz15gi"
};
// the primary color represents the outer or background element
const $c59673c02b42adcb$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #17171708)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #123263)";
    else if (isActive) return "var(--ds-background-selected-pressed, #8FB8F6)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #1558BC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #1868DB)";
    return "var(--ds-background-neutral, #0515240F)";
};
// the secondary color represents the radio dot or checkmark
const $c59673c02b42adcb$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #080F214A)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $c59673c02b42adcb$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9jrsbi _1gqprsbi"
};
const $c59673c02b42adcb$var$baseIconStyles = null;
const $c59673c02b42adcb$var$baseOptionStyles = null;
const $c59673c02b42adcb$var$ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, $eJOHy.useState)(false);
    const onMouseDown = (0, $eJOHy.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $eJOHy.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $eJOHy.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $c59673c02b42adcb$var$optionStyles.default,
            isFocused && $c59673c02b42adcb$var$optionStyles.focused,
            isDisabled && $c59673c02b42adcb$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $c59673c02b42adcb$var$iconStyles.inherit : $c59673c02b42adcb$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                    label: "",
                    primaryColor: $c59673c02b42adcb$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $c59673c02b42adcb$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
const $c59673c02b42adcb$var$NewCheckboxIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props, @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
const $c59673c02b42adcb$var$NewRadioIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props, @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
const $c59673c02b42adcb$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($c59673c02b42adcb$var$ControlOption, {
        Icon: (0, $eGOwo.fg)('platform-visual-refresh-icons') ? $c59673c02b42adcb$var$NewCheckboxIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($dwm7g))),
        ...props
    });
const $c59673c02b42adcb$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, $gt9Am.jsx)($c59673c02b42adcb$var$ControlOption, {
        Icon: (0, $eGOwo.fg)('platform-visual-refresh-icons') ? $c59673c02b42adcb$var$NewRadioIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($279SN))),
        ...props
    });

});
parcelRegister("dwm7g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7f6b5a4b54b43d$var$_react = $9d7f6b5a4b54b43d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $9d7f6b5a4b54b43d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d7f6b5a4b54b43d$var$CheckboxIcon = (props)=>/*#__PURE__*/ $9d7f6b5a4b54b43d$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$9d7f6b5a4b54b43d$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $9d7f6b5a4b54b43d$var$_default = module.exports.default = $9d7f6b5a4b54b43d$var$CheckboxIcon;

});

parcelRegister("279SN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18a3e6b70b5fecb4$var$_react = $18a3e6b70b5fecb4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $18a3e6b70b5fecb4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $18a3e6b70b5fecb4$var$RadioIcon = (props)=>/*#__PURE__*/ $18a3e6b70b5fecb4$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props));
$18a3e6b70b5fecb4$var$RadioIcon.displayName = 'RadioIcon';
var $18a3e6b70b5fecb4$var$_default = module.exports.default = $18a3e6b70b5fecb4$var$RadioIcon;

});


parcelRegister("8cv11", function(module, exports) {
$parcel$export(module.exports, "JiraPopper", () => $7c774b4266762c6b$export$23789575ac361b5d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $8qmYl = parcelRequire("8qmYl");

var $bRMVI = parcelRequire("bRMVI");

var $k3Xbr = parcelRequire("k3Xbr");
const $7c774b4266762c6b$export$23789575ac361b5d = (props)=>{
    if ((0, $bRMVI.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k3Xbr.ChoreographerPopper), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8qmYl.Popper), rest);
};

});
parcelRegister("k3Xbr", function(module, exports) {
$parcel$export(module.exports, "ChoreographerPopper", () => $035f7c874f3f3baa$export$6077de4a190b560c);
// eslint-disable-next-line jira/restricted/react-component-props

var $8qmYl = parcelRequire("8qmYl");

var $5hQBi = parcelRequire("5hQBi");
const $035f7c874f3f3baa$export$6077de4a190b560c = (0, $5hQBi.withChoreographedRender)((0, $8qmYl.Popper));

});


parcelRegister("1MOGE", function(module, exports) {
$parcel$export(module.exports, "getOptionState", () => $af5121b5036d97d9$export$e651787bf17e8335);
const $af5121b5036d97d9$export$e651787bf17e8335 = (isDisabled, isOnlyUnselectable, isSelected, isInvalid)=>{
    if (isDisabled) return 'disabled';
    if (isOnlyUnselectable && !isSelected) return 'only-unselectable-unselected';
    if (isInvalid) return 'invalid';
    if (isOnlyUnselectable && isSelected) return 'only-unselectable-selected';
    if (isSelected) return 'selected';
    return 'unselected';
};

});


parcelRegister("j1sv5", function(module, exports) {
$parcel$export(module.exports, "GroupHeading", () => $f8d83750115807b5$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "GroupHeadingNew", () => $f8d83750115807b5$export$68d21e17c31e791a);
$parcel$export(module.exports, "Group", () => $f8d83750115807b5$export$eb2fcfdbd7ba97d4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");

var $6XEne = parcelRequire("6XEne");

const $f8d83750115807b5$var$styles = {
    groupHeading: "_1e0c1txw _4cvr1h6o _1bah1yb4",
    borderGroup: "_n7zlia51 _ca0qze3t _otyru2gc",
    allColumnsGroup: "_ca0qze3t"
};
const $f8d83750115807b5$var$HeadingContent = ({ label: label, totalCount: totalCount })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f8d83750115807b5$var$styles.groupHeading,
        paddingBlockEnd: "space.075",
        paddingInline: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        size: "small",
        weight: "bold",
        color: "color.text.subtle"
    }, label?.toLocaleUpperCase()), totalCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        size: "small",
        color: "color.text.subtle"
    }, totalCount));
};
const $f8d83750115807b5$export$85c8b41a3cd87edc = ({ data: data, totalCount: totalCount, ...restProps })=>{
    const { id: id, label: label } = data;
    switch(id){
        case 0, $398aa02f7b594968$export$eb85a4c9b5d9ce7b:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f8d83750115807b5$var$HeadingContent, {
                label: label,
                totalCount: totalCount
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).GroupHeading, {
                ...restProps,
                data: data
            });
    }
};
const $f8d83750115807b5$export$68d21e17c31e791a = ({ data: data, ...props })=>{
    const { id: id } = data;
    switch(id){
        // no heading for these groups
        case 0, $398aa02f7b594968$export$eb85a4c9b5d9ce7b:
        case 0, $398aa02f7b594968$export$bfd1c05c2e5a5a01:
            return null;
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).GroupHeading, {
                ...props,
                data: data
            });
    }
};
const $f8d83750115807b5$export$eb2fcfdbd7ba97d4 = ({ data: data, ...props })=>{
    const { id: id } = data;
    // selected columns group should have a border bottom divider
    if (id === (0, $398aa02f7b594968$export$bfd1c05c2e5a5a01)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Group, {
        ...props,
        data: data,
        xcss: $f8d83750115807b5$var$styles.borderGroup
    });
    if (id === (0, $398aa02f7b594968$export$eb85a4c9b5d9ce7b)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Group, {
        ...props,
        data: data,
        xcss: $f8d83750115807b5$var$styles.allColumnsGroup
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Group, {
        ...props,
        data: data
    });
};

});


parcelRegister("icknm", function(module, exports) {
$parcel$export(module.exports, "default", () => $295f45065da2298c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $aFyWG = parcelRequire("aFyWG");

var $8quwH = parcelRequire("8quwH");
const $295f45065da2298c$export$bf0956d66cd7566b = ({ onShowFullList: onShowFullList })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleShowFullList = (0, $eJOHy.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent({
            eventType: 'UI',
            action: 'expanded',
            actionSubject: 'filterSearch',
            actionSubjectId: 'refinementBarFilterSearch'
        });
        const attributes = {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: e.detail === 0
        };
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'refinementBarFilterSearch', attributes);
        onShowFullList();
    }, [
        createAnalyticsEvent,
        onShowFullList
    ]);
    const message = formatMessage((0, $8quwH.default).showFullListButtonText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aFyWG.LeftFooterButton), {
        message: message,
        onClick: handleShowFullList,
        appearance: "subtle-link",
        testId: "jql-builder-basic-picker.ui.async-select.show-full-list-button.show-full-list-button",
        hasTooltip: true
    });
};
var $295f45065da2298c$export$2e2bcd8739ae039 = $295f45065da2298c$export$bf0956d66cd7566b;

});
parcelRegister("8quwH", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa637fe2306205e4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $aa637fe2306205e4$var$messages = (0, $7qGN1.defineMessages)({
    showFullListButtonText: {
        "id": "jql-builder-basic-picker.async-select.show-full-list-button.show-full-list-button-text",
        "defaultMessage": "Show full list"
    }
});
var $aa637fe2306205e4$export$2e2bcd8739ae039 = $aa637fe2306205e4$var$messages;

});


parcelRegister("bWslp", function(module, exports) {
$parcel$export(module.exports, "addFullListToOptions", () => $c7a0e88bf351185c$export$f3b09dca68236b3);
$parcel$export(module.exports, "generateOptions", () => $c7a0e88bf351185c$export$c21133b4499f5374);
$parcel$export(module.exports, "getValueFromOptions", () => $c7a0e88bf351185c$export$cc4ee748665ecf20);

var $4cTDP = parcelRequire("4cTDP");

var $gMbEk = parcelRequire("gMbEk");

const $c7a0e88bf351185c$export$17aec06b00a4043e = (keys, options, option)=>{
    if ((0, $gMbEk.isSingleValueOption)(option) && !keys.has(option.value)) {
        keys.add(option.value);
        options.push(option);
    }
    // If the option is a group, we either append to an existing group or add a new group
    if (option.optionType === 'group') {
        const foundDuplicateGroup = options.some((o)=>'label' in o && o.label === option.label);
        if (foundDuplicateGroup) option.options.forEach((groupVal)=>{
            const existingGroup = options.find((o)=>'label' in o && o.label === option.label);
            if (existingGroup && existingGroup.optionType === 'group') {
                const newOptions = [
                    ...existingGroup?.options,
                    groupVal
                ];
                existingGroup.options = newOptions;
            }
        });
        else options.push(option);
    }
};
const $c7a0e88bf351185c$export$f3b09dca68236b3 = (options, fullList, onSortOptions)=>options.map((option)=>{
        switch(option.optionType){
            case 'group':
                {
                    const newOptions = $c7a0e88bf351185c$export$f3b09dca68236b3(option.options, fullList, onSortOptions);
                    return {
                        ...option,
                        options: onSortOptions && (0, $4cTDP.fg)('jira_list_merged_column_gate') ? onSortOptions(newOptions) : newOptions
                    };
                }
            case 'avatar':
            case 'lozenge':
            case 'option':
                {
                    // keep same object reference to keep focus on same option on pagination
                    const optionRef = option;
                    optionRef.fullList = fullList;
                    return optionRef;
                }
            default:
                return option;
        }
    });
const $c7a0e88bf351185c$export$c21133b4499f5374 = (selected, data, previousData, addSelectedFirst = true)=>{
    // Handle currently selected
    const optionKeys = new Set();
    const options = [];
    if (addSelectedFirst) {
        // add selected options as a group
        if ((0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates')) {
            const groupSelectedOptions = [];
            selected && selected.forEach((val)=>{
                $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, groupSelectedOptions, val);
            });
            if (groupSelectedOptions.length > 0) $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, {
                id: (0, $398aa02f7b594968$export$bfd1c05c2e5a5a01),
                optionType: 'group',
                options: groupSelectedOptions,
                label: 'Selected columns'
            });
        } else selected && selected.forEach((val)=>{
            $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, val);
        });
    }
    if (previousData) // add previous loaded options
    previousData.forEach((val)=>{
        $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, val);
    });
    data && data.forEach((val)=>{
        // Add group options
        if (val && val.optionType === 'group') {
            const groupOptions = [];
            val.options.forEach((groupVal)=>{
                // removing values from the group that are already in the options list (e.g. selected values, values from previousData)
                $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, groupOptions, groupVal);
            });
            if (groupOptions.length > 0) $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, {
                ...val,
                options: groupOptions,
                optionType: 'group'
            });
            return;
        }
        // add individual options
        $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, val);
    });
    return options;
};
const $c7a0e88bf351185c$export$cc4ee748665ecf20 = (loadedOptionsWithFullList, value)=>{
    if (loadedOptionsWithFullList.length === 0) return value;
    const loadedOptionsWithFullListFlat = loadedOptionsWithFullList.flatMap((option)=>option.optionType === 'group' ? option.options : option);
    return value.map((selectedValue)=>loadedOptionsWithFullListFlat.find((option)=>(0, $gMbEk.isSingleValueOption)(option) && (0, $gMbEk.isSingleValueOption)(selectedValue) && selectedValue.value === option.value) || selectedValue);
};

});

parcelRegister("7XraK", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6bbce5e4b9b1a0a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e6bbce5e4b9b1a0a$var$messages = (0, $7qGN1.defineMessages)({
    loadingStart: {
        "id": "jql-builder-basic-picker.async-select.loading-start",
        "defaultMessage": "Loading more"
    },
    loadingEnd: {
        "id": "jql-builder-basic-picker.async-select.loading-end",
        "defaultMessage": "Finished loading"
    }
});
var $e6bbce5e4b9b1a0a$export$2e2bcd8739ae039 = $e6bbce5e4b9b1a0a$var$messages;

});


parcelRegister("hEe9x", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d51a2057bdff96c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $g5nWu = parcelRequire("g5nWu");

var $7PBuN = parcelRequire("7PBuN");

var $5xIBb = parcelRequire("5xIBb");
const $9d51a2057bdff96c$var$formatOptionLabel = (data)=>{
    switch(data.optionType){
        case 'avatar':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g5nWu.default), {
                data: data
            });
        case 'lozenge':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5xIBb.default), {
                data: data
            });
        case 'option':
        case 'field':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7PBuN.default), {
                data: data
            });
        default:
            return null;
    }
};
var $9d51a2057bdff96c$export$2e2bcd8739ae039 = $9d51a2057bdff96c$var$formatOptionLabel;

});
parcelRegister("g5nWu", function(module, exports) {
$parcel$export(module.exports, "default", () => $53de91e06cefcdc0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");

var $hxN6p = parcelRequire("hxN6p");

var $lRq8t = parcelRequire("lRq8t");

var $buJG5 = parcelRequire("buJG5");

var $9cbmy = parcelRequire("9cbmy");

var $jMiTg = parcelRequire("jMiTg");

var $lCwqw = parcelRequire("lCwqw");
const $53de91e06cefcdc0$export$fe00f602c942368a = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [labelOverflows, setLabelOverflows] = (0, $eJOHy.useState)(false);
    const onLabelRef = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) setLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buJG5.ConditionalTooltip), {
        condition: labelOverflows,
        content: data.label,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabel), null, data.hideAvatar !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabelIcon), null, data.isGroup === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StylesGroupIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hxN6p))), {
        testId: "jql-builder-basic-picker.ui.format-option-label.avatar-option-label.group-icon",
        label: formatMessage((0, $lCwqw.default).groupIcon)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        src: typeof data.avatar !== 'string' ? undefined : data.avatar,
        size: "xsmall",
        testId: "jql-builder-basic-picker.ui.format-option-label.avatar-option-label.avatar",
        appearance: typeof data.square === 'boolean' && data.square === true ? 'square' : 'circle'
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabelText), {
        ref: onLabelRef
    }, data.label)), data.disabledMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), null, data.disabledMessage)));
};
var $53de91e06cefcdc0$export$2e2bcd8739ae039 = $53de91e06cefcdc0$export$fe00f602c942368a;

});
parcelRegister("buJG5", function(module, exports) {
$parcel$export(module.exports, "ConditionalTooltip", () => $f134232f4e230d4e$export$d8abb7a1cfbd4b6b);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");
const $f134232f4e230d4e$export$d8abb7a1cfbd4b6b = ({ condition: condition, children: children, ...rest })=>// @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
    condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), rest, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);

});

parcelRegister("jMiTg", function(module, exports) {
$parcel$export(module.exports, "PICKER_DROPDOWN_WIDTH", () => $53e13f8b42d31da6$export$ca493ca2aa631e47);
$parcel$export(module.exports, "StyledOption", () => $53e13f8b42d31da6$export$844bee7de236d7ec);
$parcel$export(module.exports, "StyledLabel", () => $53e13f8b42d31da6$export$eea83358d9434634);
$parcel$export(module.exports, "StyledLabelIcon", () => $53e13f8b42d31da6$export$282e0b7f297acea7);
$parcel$export(module.exports, "StyledIcon", () => $53e13f8b42d31da6$export$7c8f159da0dc916);
$parcel$export(module.exports, "StyledLabelText", () => $53e13f8b42d31da6$export$601dc5d21f1e8182);
$parcel$export(module.exports, "StyledLozenge", () => $53e13f8b42d31da6$export$fb418b53e6535057);
$parcel$export(module.exports, "StyledLozengeLabel", () => $53e13f8b42d31da6$export$cd2803f359bf9865);
$parcel$export(module.exports, "StyledSecondaryLabel", () => $53e13f8b42d31da6$export$385a11497793b305);
$parcel$export(module.exports, "StylesGroupIconContainer", () => $53e13f8b42d31da6$export$56cfb14c006d4229);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $53e13f8b42d31da6$export$ca493ca2aa631e47 = 300;
const $53e13f8b42d31da6$export$844bee7de236d7ec = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$eea83358d9434634 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$282e0b7f297acea7 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _18u0v77o",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$7c8f159da0dc916 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1rr0 _4t3i7vkz _1bsb7vkz _1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$601dc5d21f1e8182 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _18u01b66",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$fb418b53e6535057 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _18u01b66 _p12f1osq",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$cd2803f359bf9865 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1o8l _1bsb1osq _1bto1l2s _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$385a11497793b305 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _11c81o8v _zulpv77o _1bto1l2s _syaz1rpy _19pk1i6y _18u01b66 _4cvr1h6o _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$56cfb14c006d4229 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lCwqw", function(module, exports) {
$parcel$export(module.exports, "default", () => $8dbf9dc996adfbbc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8dbf9dc996adfbbc$var$messages = (0, $7qGN1.defineMessages)({
    groupIcon: {
        "id": "jql-builder-basic-picker.format-option-label.avatar-option-label.group-icon",
        "defaultMessage": "Group Icon"
    }
});
var $8dbf9dc996adfbbc$export$2e2bcd8739ae039 = $8dbf9dc996adfbbc$var$messages;

});


parcelRegister("7PBuN", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c0e2fe81e1bf76c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $buJG5 = parcelRequire("buJG5");

var $9cbmy = parcelRequire("9cbmy");

var $jMiTg = parcelRequire("jMiTg");
const $9c0e2fe81e1bf76c$export$914fa095fc1e0a45 = ({ data: data })=>{
    const [labelOverflows, setLabelOverflows] = (0, $eJOHy.useState)(false);
    const [secondaryLabelOverflows, setSecondaryLabelOverflows] = (0, $eJOHy.useState)(false);
    const showSecondaryLabel = (input)=>typeof input.secondaryLabel === 'string' && input.secondaryLabel.length > 0 || // remove !isValidElement(data.secondaryLabel) with cleanup with m7.3-mm2-custom-fields-with-existing-uis_vzhn7
        typeof input.secondaryLabel === 'object' && !/*#__PURE__*/ (0, $eJOHy.isValidElement)(input.secondaryLabel) && /*#__PURE__*/ (0, $eJOHy.isValidElement)(input.secondaryLabel.element);
    const onLabelRef = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) setLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    const onSecondaryLabelRef = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) setSecondaryLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    const tooltipContent = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, data.label), typeof data.secondaryLabel === 'string' && data.secondaryLabel.length > 0 && // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx, @atlassian/i18n/no-literal-string-in-jsx
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, "(", data.secondaryLabel, ")")), [
        data
    ]);
    const getSecondaryLabelComponent = (option)=>{
        if (typeof option === 'object' && !/*#__PURE__*/ (0, $eJOHy.isValidElement)(option)) return option.element;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, option);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buJG5.ConditionalTooltip), {
        condition: labelOverflows || secondaryLabelOverflows,
        content: tooltipContent,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabel), null, data.icon != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabelIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledIcon), {
        src: data.icon,
        alt: data.label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabelText), {
        ref: onLabelRef
    }, data.label)), showSecondaryLabel(data) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledSecondaryLabel), {
        ref: onSecondaryLabelRef,
        "data-testid": "jql-builder-basic-picker.ui.format-option-label.icon-option-label.secondary-label"
    }, data.secondaryLabel && getSecondaryLabelComponent(data.secondaryLabel))), data.disabledMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), null, data.disabledMessage));
};
var $9c0e2fe81e1bf76c$export$2e2bcd8739ae039 = $9c0e2fe81e1bf76c$export$914fa095fc1e0a45;

});

parcelRegister("5xIBb", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba51567c14d8e757$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");

var $buJG5 = parcelRequire("buJG5");

var $9cbmy = parcelRequire("9cbmy");

var $jMiTg = parcelRequire("jMiTg");
// Checkbox icon width = 24
// Margins and paddings around checkbox icon = 16
// Option right padding = (3 / 2) * 8
const $ba51567c14d8e757$var$DEFAULT_MAX_WIDTH = (0, $jMiTg.PICKER_DROPDOWN_WIDTH) - 24 - 16 - 12;
const $ba51567c14d8e757$export$5f70fe304106fcb1 = ({ data: data })=>{
    const [labelOverflows, setLabelOverflows] = (0, $eJOHy.useState)(false);
    const onLabelRef = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) setLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabel), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLozenge), {
        "data-testid": "jql-builder-basic-picker.ui.format-option-label.lozenge-option-label.lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: data.appearance,
        isBold: data.isBold,
        maxWidth: data.maxWidth ?? $ba51567c14d8e757$var$DEFAULT_MAX_WIDTH
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buJG5.ConditionalTooltip), {
        condition: labelOverflows,
        content: data.label,
        position: "right",
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLozengeLabel), {
        ref: onLabelRef
    }, data.label))))), data.disabledMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), null, data.disabledMessage));
};
var $ba51567c14d8e757$export$2e2bcd8739ae039 = $ba51567c14d8e757$export$5f70fe304106fcb1;

});


parcelRegister("5LwVz", function(module, exports) {
$parcel$export(module.exports, "DefaultPopupComponent", () => $4e7f80d8c92d0b45$export$5038854ec49970e4);
$parcel$export(module.exports, "FixedWidthPopupComponent", () => $4e7f80d8c92d0b45$export$84690c88a5faffa0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $IW7jS = parcelRequire("IW7jS");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $jMiTg = parcelRequire("jMiTg");
const $4e7f80d8c92d0b45$var$getPopupComponent = (width)=>/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4e7f80d8c92d0b45$var$PopupComponentContainer, {
            ...props,
            ref: ref,
            width: width
        }));
const $4e7f80d8c92d0b45$export$5038854ec49970e4 = $4e7f80d8c92d0b45$var$getPopupComponent();
const $4e7f80d8c92d0b45$export$84690c88a5faffa0 = $4e7f80d8c92d0b45$var$getPopupComponent((0, $jMiTg.PICKER_DROPDOWN_WIDTH));
// Workaround for https://github.com/atlassian-labs/compiled/issues/1200
const $4e7f80d8c92d0b45$var$layerValue = (0, $IW7jS.layers).layer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e7f80d8c92d0b45$var$PopupComponentContainerOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $awdRS.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _16jlkb7n _1o9zkb7n _i0dl1wug _1reoewfl _18m9ewfl _bfhk1bhr _16qs130s _vchhusvi _1e0c1txw _2lx21bp4 _1pby1nn1 _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.width && "_1bsb1efm",
            __cmplp.className
        ])
    });
});
const $4e7f80d8c92d0b45$var$PopupComponentContainerNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $awdRS.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _16jlkb7n _1o9zkb7n _i0dl1wug _1reoewfl _18m9ewfl _bfhk1bhr _16qs130s _vchhusvi _1e0c1txw _2lx21bp4 _1pby1nn1 _ca0qutpp _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.width && "_1bsb1efm",
            __cmplp.className
        ])
    });
});
const $4e7f80d8c92d0b45$var$PopupComponentContainer = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates'), $4e7f80d8c92d0b45$var$PopupComponentContainerNew, $4e7f80d8c92d0b45$var$PopupComponentContainerOld);

});


parcelRegister("7JbAM", function(module, exports) {
$parcel$export(module.exports, "default", () => $bae9d594d2745981$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $80DPg = parcelRequire("80DPg");

var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $eS29z = parcelRequire("eS29z");

var $6XJko = parcelRequire("6XJko");

var $3ycj9 = parcelRequire("3ycj9");
const $bae9d594d2745981$var$IconContainerConditional = ({ children: children })=>{
    if ((0, $6XJko.isVisualRefreshEnabled)()) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bae9d594d2745981$var$IconContainer, null, children);
};
const $bae9d594d2745981$var$MessageContainer = ({ icon: icon, children: children })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.150",
        xcss: $bae9d594d2745981$var$stackStyles,
        alignInline: "center"
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: "color.text"
    }, formatMessage((0, $3ycj9.default).noOptionsPrimaryMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: "color.text.subtle",
        size: "small"
    }, formatMessage((0, $3ycj9.default).noOptionsSecondaryMessage)), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bae9d594d2745981$var$Container, null, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bae9d594d2745981$var$StyledTitle, null, formatMessage((0, $3ycj9.default).title)), children);
};
/**
 * Custom message to show when no options are visible in the column picker. This allows additional help text/content to
 * be rendered using the children prop.
 */ const $bae9d594d2745981$var$NoOptionsMessage = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bae9d594d2745981$var$MessageContainer, {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bae9d594d2745981$var$IconContainerConditional, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
            label: "",
            color: "var(--ds-icon, #292A2E)",
            LEGACY_primaryColor: "currentColor"
        }))
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        actionSubject: "emptyState",
        action: "viewed",
        actionSubjectId: "columnPicker"
    }));
};
var $bae9d594d2745981$export$2e2bcd8739ae039 = $bae9d594d2745981$var$NoOptionsMessage;
const $bae9d594d2745981$var$stackStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.100',
    // this is for the children additional help text/content
    color: 'color.text.subtlest'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bae9d594d2745981$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1rpy _1e0c1txw _2lx21bp4 _4cvr1h6o _19pku2gc _2hwxv47k _otyr120g _18u0v47k",
            __cmplp.className
        ])
    });
});
const $bae9d594d2745981$var$IconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyru2gc _w8l5t9kd _1752t9kd",
            __cmplp.className
        ])
    });
});
const $bae9d594d2745981$var$StyledTitle = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syazi7uo _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3ycj9", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bd552da9271bc32$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6bd552da9271bc32$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-table-column-picker.column-picker.no-options-message.title",
        "defaultMessage": "We couldn\u2019t find the field you\u2019re looking for."
    },
    noOptionsPrimaryMessage: {
        "id": "issue-table-column-picker.common.no-options-message.no-options-primary-message",
        "defaultMessage": "We couldn't find what you're looking for"
    },
    noOptionsSecondaryMessage: {
        "id": "issue-table-column-picker.common.no-options-message.no-options-secondary-message",
        "defaultMessage": "Try using different search terms."
    }
});
var $6bd552da9271bc32$export$2e2bcd8739ae039 = $6bd552da9271bc32$var$messages;

});


parcelRegister("eo5xA", function(module, exports) {
$parcel$export(module.exports, "default", () => $576bc32fb33dfcac$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $576bc32fb33dfcac$var$messages = (0, $7qGN1.defineMessages)({
    done: {
        "id": "issue-table-column-picker.column-picker.done",
        "defaultMessage": "Done"
    },
    tourHeading: {
        "id": "issue-table-column-picker.column-picker.tour-heading",
        "defaultMessage": "Column picker"
    },
    tourBody: {
        "id": "issue-table-column-picker.column-picker.tour-body",
        "defaultMessage": "Add or remove columns to see your most important fields."
    },
    searchColumnPlaceholder: {
        "id": "issue-table-column-picker.column-picker.search-column-placeholder",
        "defaultMessage": "Search column options"
    },
    searchColumnPlaceholderNew: {
        "id": "issue-table-column-picker.column-picker.search-column-placeholder-new",
        "defaultMessage": "Search columns"
    },
    loadingMessageStart: {
        "id": "issue-table-column-picker.column-picker.loading-message-start",
        "defaultMessage": "Loading more columns"
    },
    loadingMessageEnd: {
        "id": "issue-table-column-picker.column-picker.loading-message-end",
        "defaultMessage": "Finished loading columns"
    }
});
var $576bc32fb33dfcac$export$2e2bcd8739ae039 = $576bc32fb33dfcac$var$messages;

});


parcelRegister("ft2LQ", function(module, exports) {
$parcel$export(module.exports, "useFormatOptionLabelWithShimmer", () => $38946615baebed1a$export$e3c9f09c60e50c3e);

var $eJOHy = parcelRequire("eJOHy");

var $gMbEk = parcelRequire("gMbEk");

var $hEe9x = parcelRequire("hEe9x");

var $c9Mpl = parcelRequire("c9Mpl");
const $38946615baebed1a$var$ANIMATION_INTERVAL_MS = 1000;
const $38946615baebed1a$export$87328f5dc0b3b4c3 = ({ data: data, isShimmering: isShimmering, onAnimateStart: onAnimateStart, onAnimateEnd: onAnimateEnd })=>{
    const element = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (element.current && isShimmering) {
            const el = element.current;
            onAnimateStart(el);
            // Clean up animations when the component is unmounted or isShimmering changes
            return ()=>onAnimateEnd(el);
        }
        return undefined;
    }, [
        isShimmering,
        onAnimateEnd,
        onAnimateStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        ref: element
    }, (0, $hEe9x.default)(data));
};
const $38946615baebed1a$export$e3c9f09c60e50c3e = (nonCommittedFieldSetIds)=>{
    // We use state instead of constructing the object at the module level to prevent errors being thrown during tests
    const [shimmerEffect] = (0, $eJOHy.useState)(()=>// KeyframeEffect is available in all supported browsers but we'll check anyway so the app doesn't crash.
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.KeyframeEffect ? new KeyframeEffect(null, [
            {
                color: "var(--ds-text, #292A2E)"
            },
            {
                color: "var(--ds-text-disabled, #080F214A)"
            },
            {
                color: "var(--ds-text, #292A2E)"
            }
        ], {
            duration: $38946615baebed1a$var$ANIMATION_INTERVAL_MS
        }) : null);
    const { onAnimateStart: onAnimateStart, onAnimateEnd: onAnimateEnd } = (0, $c9Mpl.useSynchronisedAnimation)(shimmerEffect, $38946615baebed1a$var$ANIMATION_INTERVAL_MS);
    return (0, $eJOHy.useCallback)((data)=>(0, $gMbEk.isSingleValueOption)(data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($38946615baebed1a$export$87328f5dc0b3b4c3, {
            data: data,
            isShimmering: nonCommittedFieldSetIds.has(data.value),
            onAnimateStart: onAnimateStart,
            onAnimateEnd: onAnimateEnd
        }) : null, [
        nonCommittedFieldSetIds,
        onAnimateEnd,
        onAnimateStart
    ]);
};

});
parcelRegister("c9Mpl", function(module, exports) {
$parcel$export(module.exports, "useSynchronisedAnimation", () => $c0f2ad01be021cb4$export$5ca53ad8be1d6630);

var $eJOHy = parcelRequire("eJOHy");
const $c0f2ad01be021cb4$export$5ca53ad8be1d6630 = (baseKeyframeEffect, interval)=>{
    const animationMap = (0, $eJOHy.useRef)(new Map());
    const intervalRef = (0, $eJOHy.useRef)(undefined);
    const playAnimations = (0, $eJOHy.useCallback)(()=>{
        // Restart all animations in our map
        animationMap.current.forEach((animation)=>{
            // eslint-disable-next-line no-param-reassign
            animation.currentTime = 0;
            animation.play();
        });
    }, []);
    const onAnimateStart = (0, $eJOHy.useCallback)((element)=>{
        // Silently exit if KeyframeEffect is not available. It is available in all supported browsers but we'll
        // check anyway so the app doesn't crash.
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (!baseKeyframeEffect || !window.KeyframeEffect) return;
        // Clone our keyframe effect and set it onto the new target
        const keyframe = new KeyframeEffect(baseKeyframeEffect);
        keyframe.target = element;
        // Create a new animation for our element
        animationMap.current.set(element, new Animation(keyframe));
        if (intervalRef.current === undefined) {
            intervalRef.current = setInterval(playAnimations, interval);
            // Ensure initial group of animations are started at the same time, e.g. when clicking restore defaults.
            queueMicrotask(playAnimations);
        }
    }, [
        baseKeyframeEffect,
        interval,
        playAnimations
    ]);
    const onAnimateEnd = (0, $eJOHy.useCallback)((element)=>{
        if (!animationMap.current.has(element)) return;
        // Cancel the element animation and remove it from the map
        animationMap.current.get(element).cancel();
        animationMap.current.delete(element);
        // Clear our animation interval when there are no elements to be animated
        if (animationMap.current.size === 0) {
            clearInterval(intervalRef.current);
            intervalRef.current = undefined;
        }
    }, []);
    // End all pending animations on unmount
    (0, $eJOHy.useEffect)(()=>()=>{
            animationMap.current.forEach((_, element)=>onAnimateEnd(element));
        }, [
        onAnimateEnd
    ]);
    return {
        onAnimateStart: onAnimateStart,
        onAnimateEnd: onAnimateEnd
    };
};

});


parcelRegister("fpyg5", function(module, exports) {
$parcel$export(module.exports, "isOnlyUnselectableField", () => $608fafa198ebf130$export$bf5bbd6344a5f1aa);
$parcel$export(module.exports, "getFieldDisabledMessage", () => $608fafa198ebf130$export$b547e1f9b04ac0ef);
$parcel$export(module.exports, "findNewInsertFields", () => $608fafa198ebf130$export$60fa8135877879de);
$parcel$export(module.exports, "findRemovedFields", () => $608fafa198ebf130$export$bcbd9324b737d43e);
$parcel$export(module.exports, "getUpdatedOptions", () => $608fafa198ebf130$export$f35b98a37123c93f);
$parcel$export(module.exports, "sortMergedColumnOptions", () => $608fafa198ebf130$export$9c9602c008ed572e);
$parcel$export(module.exports, "createOptimisticFieldConfig", () => $608fafa198ebf130$export$156c6a7908536c2c);
$parcel$export(module.exports, "deleteOptimisticFieldConfig", () => $608fafa198ebf130$export$c2b4d8461d595052);
$parcel$export(module.exports, "getRollbackFields", () => $608fafa198ebf130$export$f07a9aef49bee569);
$parcel$export(module.exports, "rollbackOptimisticFieldConfig", () => $608fafa198ebf130$export$4b8e679985e2412d);

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");

var $j4oe4 = parcelRequire("j4oe4");

var $aXKmr = parcelRequire("aXKmr");

var $3cMgR = parcelRequire("3cMgR");

var $j8Km1 = parcelRequire("j8Km1");

var $lWeUb = parcelRequire("lWeUb");
const $608fafa198ebf130$export$bf5bbd6344a5f1aa = (fieldType, canEditColumnConfiguration)=>{
    // Epic Link can only be unselected
    if (fieldType === 'com.pyxis.greenhopper.jira:gh-epic-link') return canEditColumnConfiguration;
    // Parent Link can only be unselected
    if (fieldType === 'com.atlassian.jpo:jpo-custom-field-parent') return canEditColumnConfiguration;
    return false;
};
const $608fafa198ebf130$export$b547e1f9b04ac0ef = (fieldType, formatMessage)=>{
    // Epic Link deprecation message
    if (fieldType === 'com.pyxis.greenhopper.jira:gh-epic-link') return formatMessage((0, $lWeUb.default).deprecatedEpicMessage, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                as: "strong"
            }, chunks)
    });
    // Parent Link deprecation message
    if (fieldType === 'com.atlassian.jpo:jpo-custom-field-parent') return formatMessage((0, $lWeUb.default).deprecatedParentLinkMessage, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                as: "strong"
            }, chunks)
    });
    return undefined;
};
const $608fafa198ebf130$export$60fa8135877879de = (options, selectedColumns)=>{
    return options.filter((option)=>!selectedColumns.some((prevOption)=>{
            if ('value' in prevOption && 'value' in option) return prevOption.value === option.value;
            return false;
        }));
};
const $608fafa198ebf130$export$bcbd9324b737d43e = (options, selectedColumns)=>{
    const removedFields = [];
    const existingValues = new Set(options.map((opt)=>'value' in opt ? opt.value : ''));
    selectedColumns.forEach((option)=>{
        if ('value' in option && !existingValues.has(option.value)) removedFields.push({
            name: option.label,
            fieldSetId: option.value
        });
    });
    return removedFields;
};
const $608fafa198ebf130$export$f35b98a37123c93f = (options, insertFields, insertIndex)=>{
    if (insertIndex !== undefined) {
        const updatedOptions = [
            ...options
        ];
        updatedOptions.splice(insertIndex, 0, ...insertFields);
        return updatedOptions;
    }
    return [
        ...options,
        ...insertFields
    ];
};
const $608fafa198ebf130$export$9c9602c008ed572e = (options)=>{
    let issuekey;
    let issuetype;
    let summary;
    const otherOptions = [];
    options.forEach((option)=>{
        if ('value' in option) {
            if (option.value === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_TYPE) issuetype = option;
            else if (option.value === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY) issuekey = option;
            else if (option.value === (0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY) summary = option;
            else otherOptions.push(option);
        } else otherOptions.push(option);
    });
    return [
        issuetype,
        issuekey,
        summary,
        ...otherOptions
    ].filter(Boolean);
};
const $608fafa198ebf130$export$156c6a7908536c2c = ({ environment: environment, fieldConfigId: fieldConfigId, fields: newFields, createIndex: createIndex })=>{
    if (fieldConfigId) (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fields = store.get(fieldConfigId)?.getLinkedRecords('edges');
            const createdFields = [];
            newFields.forEach((field)=>{
                const exists = fields?.find((edge)=>edge.getLinkedRecord('node')?.getValue('fieldSetId') === field.fieldSetId);
                if (!exists) createdFields.push($608fafa198ebf130$var$createFieldInStore(field, store));
            });
            if (fields) {
                if (createIndex !== undefined && createIndex >= 0 && createIndex <= fields.length) {
                    const updatedFields = [
                        ...fields
                    ];
                    updatedFields.splice(createIndex, 0, ...createdFields);
                    store.get(fieldConfigId)?.setLinkedRecords(updatedFields, 'edges');
                } else store.get(fieldConfigId)?.setLinkedRecords([
                    ...fields,
                    ...createdFields
                ], 'edges');
                store.get(fieldConfigId)?.setValue(fields.length + createdFields.length, 'totalCount');
            }
        }
    });
    const rollback = ()=>{
        if (fieldConfigId) (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            const fieldSetsConnection = store.get(fieldConfigId);
            if (fieldConfigId) {
                fieldSetsConnection?.getLinkedRecords('edges')?.forEach((edge)=>{
                    const node = edge.getLinkedRecord('node');
                    const exists = newFields?.find((field)=>node?.getValue('fieldSetId') === field.fieldSetId);
                    if (exists) {
                        const nodeId = node?.getDataID();
                        nodeId && (0, $37Ewn.ConnectionHandler).deleteNode(fieldSetsConnection, nodeId);
                    }
                });
                const newTotalCount = fieldSetsConnection?.getLinkedRecords('edges')?.length;
                store.get(fieldConfigId)?.setValue(newTotalCount, 'totalCount');
            }
        });
    };
    return rollback;
};
const $608fafa198ebf130$export$c2b4d8461d595052 = ({ environment: environment, fieldConfigId: fieldConfigId, fields: deletedFields })=>{
    if (fieldConfigId) (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
        const fieldSetsConnection = store.get(fieldConfigId);
        const deletedFieldsSetIds = new Set(deletedFields.map((field)=>field.fieldSetId));
        fieldSetsConnection?.getLinkedRecords('edges')?.forEach((edge)=>{
            const node = edge.getLinkedRecord('node');
            const fieldSetId = node?.getValue('fieldSetId')?.toString();
            if (fieldSetId && deletedFieldsSetIds.has(fieldSetId)) {
                const nodeId = node?.getDataID();
                nodeId && (0, $37Ewn.ConnectionHandler).deleteNode(fieldSetsConnection, nodeId);
            }
        });
        const newTotalCount = fieldSetsConnection?.getLinkedRecords('edges')?.length;
        store.get(fieldConfigId)?.setValue(newTotalCount, 'totalCount');
    });
};
const $608fafa198ebf130$export$f07a9aef49bee569 = ({ environment: environment, fieldConfigId: fieldConfigId })=>{
    const backupFields = [];
    (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fieldSetsConnection = store.get(fieldConfigId);
            fieldSetsConnection?.getLinkedRecords('edges')?.forEach((edge)=>{
                const node = edge.getLinkedRecord('node');
                const fieldSetPreferences = node?.getLinkedRecord('fieldSetPreferences');
                const width = fieldSetPreferences?.getValue('width')?.toString();
                const field = {
                    fieldSetId: node?.getValue('fieldSetId')?.toString() || '',
                    jqlTerm: node?.getValue('jqlTerm')?.toString() || '',
                    type: node?.getValue('type')?.toString() || '',
                    name: node?.getValue('displayName')?.toString() || '',
                    customWidth: width ? Number(width) : undefined
                };
                backupFields.push(field);
            });
        }
    });
    return backupFields;
};
const $608fafa198ebf130$export$4b8e679985e2412d = ({ environment: environment, fieldConfigId: fieldConfigId, fields: backupFields })=>{
    if (fieldConfigId && backupFields.length > 0) (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
        const fieldSetsConnection = store.get(fieldConfigId);
        // Create new edges for each backup node and completely replace the current edges
        const restoredEdges = backupFields.map((field)=>$608fafa198ebf130$var$createFieldInStore(field, store));
        if (fieldSetsConnection) {
            fieldSetsConnection.setLinkedRecords(restoredEdges, 'edges');
            fieldSetsConnection.setValue(restoredEdges.length, 'totalCount');
        }
    });
};
const $608fafa198ebf130$var$createFieldInStore = (newField, store)=>{
    const fieldJqlTerm = 'jql-placeholder-only';
    const edge = store.create((0, $aXKmr.v4)(), 'JiraIssueSearchFieldSetEdge');
    const aField = store.create((0, $aXKmr.v4)(), 'JiraIssueSearchFieldSet');
    aField.setValue(newField.fieldSetId, 'fieldSetId');
    aField.setValue(newField.jqlTerm ?? fieldJqlTerm, 'jqlTerm');
    aField.setValue(newField.type, 'type');
    aField.setValue(newField.name, 'displayName');
    if (!newField.jqlTerm) aField.setValue(true, 'isPlaceHolderField');
    if (newField.customWidth) {
        const preferences = store.create((0, $aXKmr.v4)(), 'FieldSetPreferences');
        preferences.setValue(newField.customWidth, 'width');
        aField.setLinkedRecord(preferences, 'fieldSetPreferences');
    }
    edge.setLinkedRecord(aField, 'node');
    return edge;
};

});
parcelRegister("lWeUb", function(module, exports) {
$parcel$export(module.exports, "default", () => $d35255bd661bd8f4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d35255bd661bd8f4$var$messages = (0, $7qGN1.defineMessages)({
    issuetype: {
        "id": "issue-table-column-picker.issuetype",
        "defaultMessage": "Issue Type"
    },
    issuekey: {
        "id": "issue-table-column-picker.issuekey",
        "defaultMessage": "Key"
    },
    summary: {
        "id": "issue-table-column-picker.summary",
        "defaultMessage": "Summary"
    },
    assignee: {
        "id": "issue-table-column-picker.assignee",
        "defaultMessage": "Assignee"
    },
    reporter: {
        "id": "issue-table-column-picker.reporter",
        "defaultMessage": "Reporter"
    },
    priority: {
        "id": "issue-table-column-picker.priority",
        "defaultMessage": "Priority"
    },
    status: {
        "id": "issue-table-column-picker.status",
        "defaultMessage": "Status"
    },
    resolution: {
        "id": "issue-table-column-picker.resolution",
        "defaultMessage": "Resolution"
    },
    created: {
        "id": "issue-table-column-picker.created",
        "defaultMessage": "Created"
    },
    updated: {
        "id": "issue-table-column-picker.updated",
        "defaultMessage": "Updated"
    },
    duedate: {
        "id": "issue-table-column-picker.duedate",
        "defaultMessage": "Due date"
    },
    deprecatedParentLinkMessage: {
        "id": "issue-table-column-picker.deprecated-parent-link-message",
        "defaultMessage": "<strong>Parent Link</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    },
    deprecatedEpicMessage: {
        "id": "issue-table-column-picker.deprecated-epic-message",
        "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    },
    issuetypeIssueTerminologyRefreshM4: {
        "id": "issue-table-column-picker.issuetype-issue-terminology-refresh-m4",
        "defaultMessage": "Work type"
    }
});
var $d35255bd661bd8f4$export$2e2bcd8739ae039 = $d35255bd661bd8f4$var$messages;

});




parcelRegister("jE8Tu", function(module, exports) {
$parcel$export(module.exports, "filterNonIssueItems", () => $8416c949b39a62cd$export$3bf3427e3d5241d1);
$parcel$export(module.exports, "getItemKey", () => $8416c949b39a62cd$export$424834ba1b0663bc);
$parcel$export(module.exports, "getChildIssueCreateItemKey", () => $8416c949b39a62cd$export$5dbc02cdc002848d);
$parcel$export(module.exports, "getShowMoreItemKey", () => $8416c949b39a62cd$export$b262bb2cd2ab9f00);
$parcel$export(module.exports, "HierarchyContainer", () => $8416c949b39a62cd$export$4666215eda1bff58);
$parcel$export(module.exports, "useHierarchyStore", () => $8416c949b39a62cd$export$2fc259d06066fab6);
$parcel$export(module.exports, "useHierarchyActions", () => $8416c949b39a62cd$export$4fd9d94900cdff43);
$parcel$export(module.exports, "useIsItemExpanded", () => $8416c949b39a62cd$export$d11bf3cdf2aca60f);
$parcel$export(module.exports, "useIsItemVisuallyExpanded", () => $8416c949b39a62cd$export$d553a4716051e682);
$parcel$export(module.exports, "useIsSelected", () => $8416c949b39a62cd$export$fb40a80c530e5f2b);
$parcel$export(module.exports, "useIsFocused", () => $8416c949b39a62cd$export$a774b9356e1b793);
$parcel$export(module.exports, "useSelectedRow", () => $8416c949b39a62cd$export$11a86b67953bcc50);
$parcel$export(module.exports, "useVisibleDepth", () => $8416c949b39a62cd$export$ebb5be32d1c1b3ea);
$parcel$export(module.exports, "useFlatList", () => $8416c949b39a62cd$export$e8de618a961e45f5);
$parcel$export(module.exports, "useIssueIds", () => $8416c949b39a62cd$export$85c95ca9de9161bf);
$parcel$export(module.exports, "useChildIssueIds", () => $8416c949b39a62cd$export$785805018de3f0fe);
$parcel$export(module.exports, "useFlatListIssueKeys", () => $8416c949b39a62cd$export$9f91dbe98f60bbaa);
$parcel$export(module.exports, "useHasExpandedItems", () => $8416c949b39a62cd$export$d77963246cf4131);
$parcel$export(module.exports, "useSelectedIssueKey", () => $8416c949b39a62cd$export$7cedcbfb2da7e49d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $4MchI = parcelRequire("4MchI");
var $GtRbT = parcelRequire("GtRbT");

var $4cTDP = parcelRequire("4cTDP");

var $jBNts = parcelRequire("jBNts");
const $8416c949b39a62cd$var$initialState = {
    selectedItem: null,
    selectedItemIndex: null,
    focusedItem: null,
    expandedItems: {},
    rootConnectionId: null,
    connectionMap: {},
    connectionItems: {},
    loadingItems: {},
    /**
	 * Indicates the maximum expanded hierarhcy level:
	 * - Starts with 0 on initial load (flat list)
	 * - Expanding each level increments the value
	 */ visibleDepth: 0,
    flatList: [],
    issueKeys: [],
    listMetadata: [],
    amountOfRows: 0,
    itemsWithSiblingCreate: {}
};
const $8416c949b39a62cd$var$CHILD_ISSUE_CREATE_PREFIX = 'CHILD_ISSUE_CREATE';
const $8416c949b39a62cd$var$SIBLING_ISSUE_CREATE_PREFIX = 'SIBLING_ISSUE_CREATE';
const $8416c949b39a62cd$var$SHOW_MORE_PREFIX = 'SHOW_MORE';
const $8416c949b39a62cd$var$LOADING_ROW_PREFIX = 'LOADING_ROW';
const $8416c949b39a62cd$var$isSpecialItem = (id)=>id?.startsWith($8416c949b39a62cd$var$CHILD_ISSUE_CREATE_PREFIX) || id?.startsWith($8416c949b39a62cd$var$SHOW_MORE_PREFIX) || id?.startsWith($8416c949b39a62cd$var$LOADING_ROW_PREFIX);
const $8416c949b39a62cd$export$3bf3427e3d5241d1 = (list)=>list.filter(Boolean).filter((item)=>!$8416c949b39a62cd$var$isSpecialItem(item));
const $8416c949b39a62cd$export$424834ba1b0663bc = (itemsConnectionId, itemId, groupId)=>`${itemsConnectionId}::${itemId}${groupId ? `::${groupId}` : ''}`;
const $8416c949b39a62cd$export$5dbc02cdc002848d = (siblingItemId)=>`${$8416c949b39a62cd$var$CHILD_ISSUE_CREATE_PREFIX}_${siblingItemId}`;
const $8416c949b39a62cd$export$65582958b69a9e4c = (parentItemId)=>`${$8416c949b39a62cd$var$SIBLING_ISSUE_CREATE_PREFIX}_${parentItemId}`;
const $8416c949b39a62cd$export$b262bb2cd2ab9f00 = (parentItemId)=>`${$8416c949b39a62cd$var$SHOW_MORE_PREFIX}_${parentItemId}`;
const $8416c949b39a62cd$export$4db25121b2596d32 = (parentItemId)=>`${$8416c949b39a62cd$var$LOADING_ROW_PREFIX}_${parentItemId}`;
const $8416c949b39a62cd$export$4aad0fc50e1251e4 = (key)=>{
    if (typeof key !== 'string') return {
        connectionId: null,
        itemId: null
    };
    const [connectionId, itemId] = key.split('::');
    return {
        connectionId: connectionId,
        itemId: itemId
    };
};
const $8416c949b39a62cd$var$actions = {
    populateConnection: ({ parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, parentConnectionId: parentConnectionId, list: list, hasNext: hasNext, isChildIssueCreateRowVisible: isChildIssueCreateRowVisible, groupId: groupId })=>{
        return ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            if (parentItemId === 'root') setState({
                rootConnectionId: itemsConnectionId
            });
            const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, parentItemId, groupId);
            const state = getState();
            let nextList = list?.slice() ?? null;
            // adding [Show more] button to flat list so that virtualiser recognizes it
            if (hasNext && nextList) {
                const showMoreRowKey = $8416c949b39a62cd$export$b262bb2cd2ab9f00(parentItemId);
                nextList = nextList.concat({
                    key: showMoreRowKey,
                    itemId: showMoreRowKey,
                    groupId: groupId
                });
            }
            if (isChildIssueCreateRowVisible && nextList) {
                const childIssueCreateRowKey = $8416c949b39a62cd$export$5dbc02cdc002848d(parentItemId);
                nextList.unshift({
                    key: childIssueCreateRowKey,
                    itemId: childIssueCreateRowKey,
                    groupId: groupId
                });
            }
            const parentKey = $8416c949b39a62cd$export$424834ba1b0663bc(parentConnectionId, parentItemId, // root doesn't have a groupId
            parentItemId === 'root' ? undefined : groupId);
            setState({
                connectionMap: {
                    ...state.connectionMap,
                    [parentKey]: key
                },
                connectionItems: {
                    ...state.connectionItems,
                    [key]: nextList
                }
            });
            dispatch($8416c949b39a62cd$var$actions.traverseTreeAndUpdateState());
            dispatch($8416c949b39a62cd$var$actions.clearSelectionIfItemIsNotInList());
        };
    },
    setItemIsLoading: ({ itemId: itemId, groupId: groupId, isLoading: isLoading })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { loadingItems: loadingItems, listMetadata: listMetadata, connectionItems: connectionItems } = getState();
            const loadingItemKey = $8416c949b39a62cd$export$4db25121b2596d32(itemId);
            const metadataItem = listMetadata.find((metadata)=>metadata.itemId === itemId);
            const key = metadataItem ? $8416c949b39a62cd$export$424834ba1b0663bc(metadataItem.connectionId, metadataItem.parentId, metadataItem.groupId) : null;
            if (!key || !connectionItems) return;
            let nextList = (connectionItems?.[key] ?? []).slice();
            if (isLoading) {
                const itemIndex = nextList.findIndex((item)=>item.itemId === itemId);
                if (itemIndex > -1) // insert loading row right after the expanded item
                nextList.splice(itemIndex + 1, 0, {
                    key: loadingItemKey,
                    itemId: loadingItemKey,
                    groupId: groupId
                });
            } else nextList = nextList.filter((item)=>item.itemId !== loadingItemKey);
            setState({
                loadingItems: {
                    ...loadingItems,
                    [itemId]: isLoading
                },
                connectionItems: {
                    ...connectionItems,
                    [key]: nextList
                }
            });
            dispatch($8416c949b39a62cd$var$actions.traverseTreeAndUpdateState());
            dispatch($8416c949b39a62cd$var$actions.clearSelectionIfItemIsNotInList());
        },
    setIsSiblingCreateVisible: (itemDetails, isSiblingCreateVisible)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { itemsWithSiblingCreate: itemsWithSiblingCreate } = getState();
            if (!itemDetails) return;
            const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
            const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
            setState({
                itemsWithSiblingCreate: {
                    ...itemsWithSiblingCreate,
                    [key]: isSiblingCreateVisible
                }
            });
            dispatch($8416c949b39a62cd$var$actions.traverseTreeAndUpdateState());
        },
    toggleIsItemExpanded: (itemDetails, issueDepth)=>({ getState: getState, dispatch: dispatch })=>{
            if (!itemDetails) return;
            const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
            const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
            const state = getState();
            const isExpanded = !state.expandedItems[key];
            dispatch($8416c949b39a62cd$var$actions.setIsItemExpanded(itemDetails, isExpanded, issueDepth));
        },
    setIsItemExpanded: (itemDetails, isItemExpanded, issueDepth = 0)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            if (!itemDetails) return;
            const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
            const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
            const state = getState();
            /*
				Update visibleDepth with the new depth if is expanded an item
				traverseTreeAndUpdateState function would update the visibleDepth when collapse
			*/ const optimisticVisibleDepth = issueDepth + 1;
            const currentVisibleDepth = state.visibleDepth;
            const newVisibleDepth = isItemExpanded && optimisticVisibleDepth > currentVisibleDepth ? optimisticVisibleDepth : state.visibleDepth;
            setState({
                expandedItems: {
                    ...state.expandedItems,
                    [key]: isItemExpanded
                },
                ...isItemExpanded === false ? {
                    connectionItems: {
                        ...state.connectionItems,
                        [key]: null
                    }
                } : {},
                visibleDepth: newVisibleDepth
            });
            dispatch($8416c949b39a62cd$var$actions.traverseTreeAndUpdateState());
            dispatch($8416c949b39a62cd$var$actions.clearSelectionIfItemIsNotInList());
        },
    traverseTreeAndUpdateState: ()=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const result = $8416c949b39a62cd$export$dc56145edcd15e3e(getState());
            setState({
                flatList: result.flatlist,
                issueKeys: result.issueKeys,
                listMetadata: result.listMetadata,
                visibleDepth: result.hierarchyLevels[result.hierarchyLevels.length - 1]
            });
            dispatch($8416c949b39a62cd$var$actions.setAmountOfRows(result.flatlist.length));
        },
    setSelectedRow: (itemDetails)=>({ setState: setState })=>{
            if (!itemDetails) {
                setState({
                    selectedItem: null,
                    focusedItem: null
                });
                return;
            }
            const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
            const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
            setState({
                selectedItem: key,
                focusedItem: key
            });
        },
    // Sets the selected row based on the index provided when returning from the full page issue app. Clean up with issue app removal
    setSelectedRowByIndex: (rowIndex)=>({ getState: getState, setState: setState })=>{
            const { listMetadata: listMetadata } = getState();
            if (rowIndex >= 0 && rowIndex < listMetadata.length) {
                const formattedKey = listMetadata[rowIndex].key;
                setState({
                    selectedItem: formattedKey,
                    selectedItemIndex: rowIndex,
                    focusedItem: formattedKey
                });
            }
        },
    selectNextRow: ()=>({ getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const { listMetadata: listMetadata, selectedItem: selectedItem } = state;
            if (!selectedItem) return;
            const currentIndex = listMetadata.findIndex((item)=>item.key === selectedItem);
            const nextIndex = currentIndex + 1;
            if (nextIndex < listMetadata.length) dispatch($8416c949b39a62cd$var$actions.setSelectedRow({
                itemsConnectionId: listMetadata[nextIndex].connectionId,
                itemId: listMetadata[nextIndex].itemId,
                groupId: listMetadata[nextIndex].groupId
            }));
        },
    selectPrevRow: ()=>({ getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const { listMetadata: listMetadata, selectedItem: selectedItem } = state;
            if (!selectedItem) return;
            const currentIndex = listMetadata.findIndex((item)=>item.key === selectedItem);
            const previousIndex = currentIndex - 1;
            if (previousIndex >= 0) dispatch($8416c949b39a62cd$var$actions.setSelectedRow({
                itemsConnectionId: listMetadata[previousIndex].connectionId,
                itemId: listMetadata[previousIndex].itemId,
                groupId: listMetadata[previousIndex].groupId
            }));
        },
    clearSelectionIfItemIsNotInList: ()=>({ getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const { selectedItem: selectedItem } = state;
            if (!selectedItem || state.listMetadata.find((item)=>item.key === selectedItem)) return;
            dispatch($8416c949b39a62cd$var$actions.setSelectedRow(null));
        },
    setAmountOfRows: (newAmountOfRows)=>({ getState: getState, setState: setState })=>{
            const { amountOfRows: amountOfRows } = getState();
            amountOfRows !== newAmountOfRows && setState({
                amountOfRows: newAmountOfRows
            });
        },
    resetFocus: ()=>({ getState: getState, setState: setState })=>{
            const { focusedItem: focusedItem } = getState();
            focusedItem !== null && setState({
                focusedItem: null
            });
        },
    resetHierarchyKeepingFirstGroupExpanded: ({ firstGroupId: firstGroupId, itemsConnectionId: itemsConnectionId })=>({ setState: setState, dispatch: dispatch })=>{
            if (firstGroupId && itemsConnectionId) {
                const firstGroupKey = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, firstGroupId, firstGroupId);
                // First group is always expanded by default
                setState({
                    expandedItems: {
                        [firstGroupKey]: true
                    }
                });
            } else setState({
                expandedItems: {}
            });
            dispatch($8416c949b39a62cd$var$actions.traverseTreeAndUpdateState());
        }
};
const $8416c949b39a62cd$export$4666215eda1bff58 = (0, $6E16M.createContainer)({
    getIsConcurrentSafe: ()=>(0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store')
});
const $8416c949b39a62cd$var$Store = (0, $GtRbT.createStore)({
    initialState: $8416c949b39a62cd$var$initialState,
    actions: $8416c949b39a62cd$var$actions,
    name: 'hierarchy',
    containedBy: $8416c949b39a62cd$export$4666215eda1bff58,
    handlers: {
        onInit: ()=>({ dispatch: dispatch }, { populateConnectionArgs: populateConnectionArgs })=>{
                // eslint-disable-next-line jira/ff/no-preconditioning
                if ((0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store') && populateConnectionArgs) populateConnectionArgs.forEach((args)=>{
                    dispatch($8416c949b39a62cd$var$actions.populateConnection(args));
                });
            },
        // Only used when returning from the full page issue app. Clean up with issue app removal
        onUpdate: ()=>({ getState: getState, dispatch: dispatch }, { selectedRowIndex: selectedRowIndex })=>{
                const { selectedItemIndex: selectedItemIndex } = getState();
                if (selectedRowIndex && selectedItemIndex !== selectedRowIndex) dispatch($8416c949b39a62cd$var$actions.setSelectedRowByIndex(selectedRowIndex));
            }
    }
});
const $8416c949b39a62cd$export$2fc259d06066fab6 = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store);
const $8416c949b39a62cd$export$4fd9d94900cdff43 = (0, $iJq0l.createActionsHook)($8416c949b39a62cd$var$Store);
const $8416c949b39a62cd$var$getIsItemExpandedSelector = (state, itemDetails)=>{
    if (!itemDetails) return false;
    const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
    const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
    return state.expandedItems[key] ?? false;
};
const $8416c949b39a62cd$export$d11bf3cdf2aca60f = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getIsItemExpandedSelector
});
const $8416c949b39a62cd$var$getIsItemVisuallyExpandedSelector = (0, $4MchI.createSelector)($8416c949b39a62cd$var$getIsItemExpandedSelector, (state, itemDetails)=>{
    if (!itemDetails) return false;
    const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
    const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
    const childrenConnection = state.connectionMap[key];
    return !!childrenConnection && !!state.connectionItems[childrenConnection]?.length || state.loadingItems[itemId] || false;
}, (isExpanded, canBeExpanded)=>isExpanded && canBeExpanded);
const $8416c949b39a62cd$export$d553a4716051e682 = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getIsItemVisuallyExpandedSelector
});
const $8416c949b39a62cd$export$fb40a80c530e5f2b = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: (state, itemDetails)=>{
        if (!itemDetails) return false;
        const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
        return state.selectedItem === $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
    }
});
const $8416c949b39a62cd$export$a774b9356e1b793 = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: (state, itemDetails)=>{
        if (!itemDetails) return false;
        const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
        return state.focusedItem === $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
    }
});
const $8416c949b39a62cd$var$getSelectedIndexSelector = (state)=>{
    const index = state.listMetadata.findIndex((item)=>item.key === state.selectedItem);
    if (index === -1) return null;
    return index;
};
const $8416c949b39a62cd$export$d169440ae865c511 = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: (state, itemId)=>Boolean(itemId && state.loadingItems[itemId])
});
const $8416c949b39a62cd$export$11a86b67953bcc50 = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getSelectedIndexSelector
});
const $8416c949b39a62cd$export$dc56145edcd15e3e = (state)=>{
    const traverse = ({ itemsConnectionId: itemsConnectionId, parentId: parentId, flatlist: flatlist, issueKeys: issueKeys, listMetadata: listMetadata, hierarchyLevels: hierarchyLevels, depth: depth, groupId: groupId })=>{
        const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, parentId, groupId);
        const connectionItem = state.connectionItems[key];
        if (!connectionItem) return {
            flatlist: flatlist,
            issueKeys: issueKeys,
            listMetadata: listMetadata,
            hierarchyLevels: hierarchyLevels
        };
        // itemGroupId is different from groupId at the root level
        connectionItem.forEach(({ itemId: id, key: issueKey, groupId: itemGroupId })=>{
            const childConnectionKey = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, id, itemGroupId);
            if (state.itemsWithSiblingCreate[childConnectionKey] && (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting')) {
                const siblingIssueCreateKey = $8416c949b39a62cd$export$65582958b69a9e4c(id);
                const siblingIssueCreateFlatListKey = (0, $jBNts.getFlatListKey)({
                    itemId: siblingIssueCreateKey,
                    groupId: itemGroupId
                });
                flatlist.push(siblingIssueCreateFlatListKey);
            }
            // groupId is needed in flatlist to make the issueId unique across multiple groups
            flatlist.push((0, $jBNts.getFlatListKey)({
                itemId: id,
                groupId: itemGroupId
            }));
            issueKeys.push(issueKey);
            listMetadata.push({
                itemId: id,
                parentId: parentId,
                key: childConnectionKey,
                connectionId: itemsConnectionId,
                groupId: itemGroupId
            });
            const isExpanded = state.expandedItems[childConnectionKey];
            if (isExpanded) {
                const currentDepth = depth + 1;
                if (!hierarchyLevels.includes(currentDepth)) hierarchyLevels.push(currentDepth);
                const childrenConnection = state.connectionMap[childConnectionKey];
                const { connectionId: childrenConnectionId } = $8416c949b39a62cd$export$4aad0fc50e1251e4(childrenConnection);
                if (childrenConnectionId) traverse({
                    itemsConnectionId: childrenConnectionId,
                    parentId: id,
                    flatlist: flatlist,
                    issueKeys: issueKeys,
                    listMetadata: listMetadata,
                    hierarchyLevels: hierarchyLevels,
                    depth: currentDepth,
                    groupId: itemGroupId
                });
            }
        });
        return {
            flatlist: flatlist,
            issueKeys: issueKeys,
            listMetadata: listMetadata,
            hierarchyLevels: hierarchyLevels
        };
    };
    const depth = 0;
    const flatlist = [];
    const issueKeys = [];
    const listMetadata = [];
    const hierarchyLevels = [
        depth
    ];
    if (!state.rootConnectionId) return {
        flatlist: flatlist,
        issueKeys: issueKeys,
        listMetadata: listMetadata,
        hierarchyLevels: hierarchyLevels
    };
    return traverse({
        itemsConnectionId: state.rootConnectionId,
        parentId: 'root',
        flatlist: flatlist,
        issueKeys: issueKeys,
        listMetadata: listMetadata,
        hierarchyLevels: hierarchyLevels,
        depth: depth
    });
};
const $8416c949b39a62cd$export$ebb5be32d1c1b3ea = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: (state)=>state.visibleDepth
});
const $8416c949b39a62cd$export$e8de618a961e45f5 = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: (state)=>state.flatList
});
const $8416c949b39a62cd$var$getIssueIdsSelector = (0, $4MchI.createSelector)((state)=>state.listMetadata, (listMetadata)=>listMetadata// filtering group headers out
    .filter(({ itemId: itemId, groupId: groupId })=>itemId !== groupId && !$8416c949b39a62cd$var$isSpecialItem(itemId)).map(({ itemId: itemId })=>itemId));
const $8416c949b39a62cd$export$85c95ca9de9161bf = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getIssueIdsSelector
});
const $8416c949b39a62cd$var$getChildIssueIdsSelector = (0, $4MchI.createSelector)((state)=>state.listMetadata, (listMetadata)=>listMetadata// filtering group headers out
    .filter(({ itemId: itemId, groupId: groupId })=>itemId !== groupId && !$8416c949b39a62cd$var$isSpecialItem(itemId)).filter(({ parentId: parentId })=>parentId !== 'root').map(({ itemId: itemId })=>itemId));
const $8416c949b39a62cd$export$785805018de3f0fe = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getChildIssueIdsSelector
});
const $8416c949b39a62cd$var$getIssueKeysSelector = (state)=>state.issueKeys;
const $8416c949b39a62cd$var$getFlatListIssueKeysSelector = (0, $4MchI.createSelector)($8416c949b39a62cd$var$getIssueKeysSelector, (issueKeys)=>$8416c949b39a62cd$export$3bf3427e3d5241d1(issueKeys));
const $8416c949b39a62cd$export$9f91dbe98f60bbaa = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getFlatListIssueKeysSelector
});
const $8416c949b39a62cd$export$a5d72277eb099991 = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getIssueKeysSelector
});
const $8416c949b39a62cd$var$getSelectedIssueKeySelector = (0, $4MchI.createSelector)($8416c949b39a62cd$var$getSelectedIndexSelector, $8416c949b39a62cd$var$getIssueKeysSelector, (selectedIndex, issueKeys)=>{
    if (selectedIndex === null) return null;
    return issueKeys[selectedIndex];
});
const $8416c949b39a62cd$export$d77963246cf4131 = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: (state)=>Object.values(state.expandedItems).some((isExpanded)=>isExpanded)
});
const $8416c949b39a62cd$export$7cedcbfb2da7e49d = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getSelectedIssueKeySelector
});

});
parcelRegister("jBNts", function(module, exports) {
$parcel$export(module.exports, "getFlatListKey", () => $53a9450db45372ed$export$c15cfc620819beb5);
const $53a9450db45372ed$export$c15cfc620819beb5 = ({ itemId: itemId, groupId: groupId })=>`${itemId}${groupId ? `::${groupId}` : ''}`;

});


parcelRegister("dLXgn", function(module, exports) {
$parcel$export(module.exports, "ConnectionsListContainer", () => $281e5150464a3bb6$export$ba73231554574611);
$parcel$export(module.exports, "useConnectionsList", () => $281e5150464a3bb6$export$8d76c2ce1bf0921e);
$parcel$export(module.exports, "useConnectionsListActions", () => $281e5150464a3bb6$export$d656d29a379d1749);
$parcel$export(module.exports, "useRegisterConnection", () => $281e5150464a3bb6$export$f9bef9773768341d);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $7zZ4w = parcelRequire("7zZ4w");
const $281e5150464a3bb6$var$INITIAL_CONNECTIONS_LIST_STATE = {
    connections: {}
};
const $281e5150464a3bb6$export$ba73231554574611 = (0, $6E16M.createContainer)();
const $281e5150464a3bb6$var$getKeyForConnection = (connection)=>{
    let key = connection.connectionId;
    if (connection.type === 'PARENT_CHILDREN') key = connection.parentId;
    if (connection.type === 'GROUP_CHILDREN') key = connection.groupId;
    // add some formatting to ensure it is not used for another purpose
    return `KEY_${key}`;
};
const $281e5150464a3bb6$var$actions = {
    addConnection: (connection)=>({ setState: setState, getState: getState })=>{
            const { connections: connections } = getState();
            const key = $281e5150464a3bb6$var$getKeyForConnection(connection);
            setState({
                connections: {
                    ...connections,
                    [key]: connection
                }
            });
        },
    removeConnection: (connection)=>({ setState: setState, getState: getState })=>{
            const { connections: connections } = getState();
            const key = $281e5150464a3bb6$var$getKeyForConnection(connection);
            const { [key]: _, ...newConnections } = connections;
            setState({
                connections: newConnections
            });
        }
};
const $281e5150464a3bb6$var$Store = (0, $GtRbT.createStore)({
    initialState: $281e5150464a3bb6$var$INITIAL_CONNECTIONS_LIST_STATE,
    name: 'ConnectionsListStore',
    containedBy: $281e5150464a3bb6$export$ba73231554574611,
    actions: $281e5150464a3bb6$var$actions,
    handlers: {
        onDestroy: ()=>({ getState: getState })=>{
                const { connections: connections } = getState();
                const environment = (0, $7zZ4w.default)();
                Object.values(connections).forEach((connection)=>{
                    environment.commitUpdate((store)=>{
                        const connectionToInvalidate = store.get(connection.connectionId);
                        if (connectionToInvalidate) connectionToInvalidate.invalidateRecord();
                    });
                });
            }
    }
});
const $281e5150464a3bb6$export$8d76c2ce1bf0921e = (0, $iJq0l.createStateHook)($281e5150464a3bb6$var$Store);
const $281e5150464a3bb6$export$d656d29a379d1749 = (0, $iJq0l.createActionsHook)($281e5150464a3bb6$var$Store);
const $281e5150464a3bb6$export$f9bef9773768341d = (connection)=>{
    const { addConnection: addConnection } = $281e5150464a3bb6$export$d656d29a379d1749();
    (0, $eJOHy.useEffect)(()=>{
        if (connection) addConnection(connection);
    }, [
        addConnection,
        connection
    ]);
};

});

parcelRegister("bYhG9", function(module, exports) {
$parcel$export(module.exports, "useHoverPopoverState", () => $d736550e3de5add3$export$ecaed54879b49151);
$parcel$export(module.exports, "useHoverPopoverSetter", () => $d736550e3de5add3$export$3ced34cbab3dc9bf);
$parcel$export(module.exports, "HoverPopoverStateProvider", () => $d736550e3de5add3$export$3240cf68ec0b7d81);

var $eJOHy = parcelRequire("eJOHy");

var $3OT15 = parcelRequire("3OT15");
const $d736550e3de5add3$var$HoverPopoverStateContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $d736550e3de5add3$var$HoverPopoverSetterContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $d736550e3de5add3$var$defaultState = {
    content: null,
    contentElement: null,
    cellRef: null,
    isOpen: false
};
const $d736550e3de5add3$var$HoverPopoverProviderLocal = ({ children: children })=>{
    const [hoverPopoverState, setHoverPopoverState] = (0, $eJOHy.useState)($d736550e3de5add3$var$defaultState);
    const unsubscribeRef = (0, $eJOHy.useRef)(null);
    const { getHoverPopoverContentById: getHoverPopoverContentById, subscribeHoverPopoverContentDeleteById: subscribeHoverPopoverContentDeleteById } = (0, $3OT15.useHoverPopoverContent)();
    const setPopoverClosed = (0, $eJOHy.useCallback)(()=>{
        setHoverPopoverState($d736550e3de5add3$var$defaultState);
    }, [
        setHoverPopoverState
    ]);
    /**
	 * When a popoover is opened, we subscribe to whether the content ref is deleted (i.e user switches from read to edit mode).
	 * If the content ref is deleted, we close the popover.
	 */ const setPopoverOpen = (0, $eJOHy.useCallback)(({ fieldId: fieldId, cell: cell, clearHoverFocusState: clearHoverFocusState })=>{
        const content = getHoverPopoverContentById(fieldId);
        if (!content) return;
        setHoverPopoverState({
            ...content,
            isOpen: true,
            cellRef: cell
        });
        unsubscribeRef.current = subscribeHoverPopoverContentDeleteById(fieldId, clearHoverFocusState);
    }, [
        setHoverPopoverState,
        getHoverPopoverContentById,
        subscribeHoverPopoverContentDeleteById
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            unsubscribeRef.current?.();
        };
    }, []);
    const stateValue = (0, $eJOHy.useMemo)(()=>({
            hoverPopoverState: hoverPopoverState
        }), [
        hoverPopoverState
    ]);
    const setterValue = (0, $eJOHy.useMemo)(()=>({
            setPopoverClosed: setPopoverClosed,
            setPopoverOpen: setPopoverOpen
        }), [
        setPopoverClosed,
        setPopoverOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d736550e3de5add3$var$HoverPopoverStateContext.Provider, {
        value: stateValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d736550e3de5add3$var$HoverPopoverSetterContext.Provider, {
        value: setterValue
    }, children));
};
const $d736550e3de5add3$export$ecaed54879b49151 = ()=>{
    const context = (0, $eJOHy.useContext)($d736550e3de5add3$var$HoverPopoverStateContext);
    if (context === undefined) throw new Error('useHoverPopover must be used within a HoverPopoverProvider');
    return context;
};
const $d736550e3de5add3$export$3ced34cbab3dc9bf = ()=>{
    const context = (0, $eJOHy.useContext)($d736550e3de5add3$var$HoverPopoverSetterContext);
    if (context === undefined) throw new Error('useHoverPopover must be used within a HoverPopoverProvider');
    return context;
};
const $d736550e3de5add3$export$3240cf68ec0b7d81 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3OT15.HoverPopoverContentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d736550e3de5add3$var$HoverPopoverProviderLocal, null, children));
};

});
parcelRegister("3OT15", function(module, exports) {
$parcel$export(module.exports, "HoverPopoverContentProvider", () => $0eef00447d3c2884$export$ae46fde6067ae6a0);
$parcel$export(module.exports, "useHoverPopoverContent", () => $0eef00447d3c2884$export$b82953ec381ff123);
$parcel$export(module.exports, "useHoverPopoverContentRef", () => $0eef00447d3c2884$export$674a542a71639eb6);

var $eJOHy = parcelRequire("eJOHy");

var $hX7Ca = parcelRequire("hX7Ca");
const $0eef00447d3c2884$var$HoverPopoverContentContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $0eef00447d3c2884$export$ae46fde6067ae6a0 = ({ children: children })=>{
    /**
	 * cellRefFieldIdMap is a map of cell refs to field IDs. This is used by the
	 * event delegator to lookup which field is hovered by table cell ref.
	 */ const cellRefFieldIdMap = (0, $hX7Ca.useLazyRef)(()=>new Map());
    /**
	 * fieldIdPopoverContentMap is a map of ARI field IDs to hover popover content.
	 * This is used by the hover popover state provider to lookup what the content for a hover popover
	 * is by a given field ID. In conjunction with the cellRefFieldIdMap above, this allows us to
	 * lookup the content for a hover popover by a given table cell ref.
	 */ const fieldIdPopoverContentMap = (0, $hX7Ca.useLazyRef)(()=>new Map());
    /**
	 * deleteListeners is a map of ARI field IDs to a set of delete listeners. See comments below on deleteHoverPopoverContentById.
	 */ const deleteListeners = (0, $hX7Ca.useLazyRef)(()=>new Map());
    const setCellIdByRef = (0, $eJOHy.useCallback)((cell, fieldId)=>{
        cellRefFieldIdMap.current.set(cell, fieldId);
    }, [
        cellRefFieldIdMap
    ]);
    const getCellIdByRef = (0, $eJOHy.useCallback)((cell)=>{
        return cellRefFieldIdMap.current.get(cell);
    }, [
        cellRefFieldIdMap
    ]);
    const deleteCellIdByRef = (0, $eJOHy.useCallback)((cell)=>{
        cellRefFieldIdMap.current.delete(cell);
    }, [
        cellRefFieldIdMap
    ]);
    const setHoverPopoverContentById = (0, $eJOHy.useCallback)((fieldId, content)=>{
        fieldIdPopoverContentMap.current.set(fieldId, content);
    }, [
        fieldIdPopoverContentMap
    ]);
    const getHoverPopoverContentById = (0, $eJOHy.useCallback)((fieldId)=>{
        return fieldIdPopoverContentMap.current.get(fieldId);
    }, [
        fieldIdPopoverContentMap
    ]);
    /**
	 * When a user hovers on a cell a popover opens. Then if they open inline edit we need the popover to close.
	 *
	 * The popover is attached using the hoverPopoverContentRef. When the popup is mounted, subscribeHoverPopoverContentDeleteById
	 * is called which allows us to subscribe to calls to deleteHoverPopoverContentById. When the component unmounts, the hover popover content ref will call this
	 * delete method (i.e user switches from read to edit mode), which calls any listeners (e.g closePopup).
	 */ const deleteHoverPopoverContentById = (0, $eJOHy.useCallback)((fieldId)=>{
        const isDeleted = fieldIdPopoverContentMap.current.delete(fieldId);
        if (isDeleted && deleteListeners.current.has(fieldId)) {
            for (const listener of deleteListeners.current.get(fieldId) ?? [])listener(fieldId);
            deleteListeners.current.delete(fieldId);
        }
    }, [
        fieldIdPopoverContentMap,
        deleteListeners
    ]);
    const subscribeHoverPopoverContentDeleteById = (0, $eJOHy.useCallback)((fieldId, listener)=>{
        if (!deleteListeners.current.has(fieldId)) deleteListeners.current.set(fieldId, new Set());
        deleteListeners.current.get(fieldId)?.add(listener);
        return ()=>{
            const listeners = deleteListeners.current.get(fieldId);
            if (listeners) {
                listeners.delete(listener);
                if (listeners.size === 0) deleteListeners.current.delete(fieldId);
            }
        };
    }, [
        deleteListeners
    ]);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            setCellIdByRef: setCellIdByRef,
            deleteCellIdByRef: deleteCellIdByRef,
            getCellIdByRef: getCellIdByRef,
            setHoverPopoverContentById: setHoverPopoverContentById,
            deleteHoverPopoverContentById: deleteHoverPopoverContentById,
            getHoverPopoverContentById: getHoverPopoverContentById,
            subscribeHoverPopoverContentDeleteById: subscribeHoverPopoverContentDeleteById
        }), [
        setCellIdByRef,
        deleteCellIdByRef,
        getCellIdByRef,
        setHoverPopoverContentById,
        deleteHoverPopoverContentById,
        getHoverPopoverContentById,
        subscribeHoverPopoverContentDeleteById
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0eef00447d3c2884$var$HoverPopoverContentContext.Provider, {
        value: contextValue
    }, children);
};
const $0eef00447d3c2884$export$b82953ec381ff123 = ()=>{
    const context = (0, $eJOHy.useContext)($0eef00447d3c2884$var$HoverPopoverContentContext);
    if (context === undefined) throw new Error('useHoverPopoverContent must be used within a HoverPopoverContentProvider');
    return context;
};
const $0eef00447d3c2884$export$674a542a71639eb6 = (fieldId)=>{
    const lastNode = (0, $eJOHy.useRef)(null);
    const { setHoverPopoverContentById: setHoverPopoverContentById, deleteHoverPopoverContentById: deleteHoverPopoverContentById } = $0eef00447d3c2884$export$b82953ec381ff123();
    const hoverPopoverContentRefFactory = (0, $eJOHy.useCallback)((content)=>(node)=>{
            if (node && fieldId) {
                setHoverPopoverContentById(fieldId, {
                    ...content,
                    contentElement: node
                });
                lastNode.current = node;
            } else if (lastNode.current && fieldId) {
                deleteHoverPopoverContentById(fieldId);
                lastNode.current = null;
            }
        }, [
        fieldId,
        setHoverPopoverContentById,
        deleteHoverPopoverContentById
    ]);
    return hoverPopoverContentRefFactory;
};

});
parcelRegister("hX7Ca", function(module, exports) {
$parcel$export(module.exports, "getClosestTextElement", () => $d5817523e8234df4$export$a4c1c84a8efc2153);
$parcel$export(module.exports, "checkIsClamped", () => $d5817523e8234df4$export$63c32f0123c21b4d);
$parcel$export(module.exports, "useLazyRef", () => $d5817523e8234df4$export$fd27aa36f007ec3d);

var $eJOHy = parcelRequire("eJOHy");
const $d5817523e8234df4$export$a4c1c84a8efc2153 = (el)=>{
    if (!el || !el.children || el.children.length === 0) return el;
    const elements = [
        el
    ];
    for (const e of elements){
        if (e.clientWidth !== e.scrollWidth) return e;
        for (const child of e.children)elements.push(child);
    }
    return el;
};
const $d5817523e8234df4$export$63c32f0123c21b4d = (el)=>{
    if (!el) return false;
    if (!(el instanceof Element)) return false;
    const currentStyle = getComputedStyle(el);
    const lineClamp = parseInt(currentStyle.getPropertyValue('-webkit-line-clamp'), 10);
    if (lineClamp > 0 && currentStyle.getPropertyValue('overflow') === 'hidden') return el.scrollHeight > el.clientHeight;
    return false;
};
const $d5817523e8234df4$var$uniqueReferencedValue = {};
function $d5817523e8234df4$export$fd27aa36f007ec3d(initializer) {
    const ref = (0, $eJOHy.useRef)($d5817523e8234df4$var$uniqueReferencedValue);
    if (ref.current === $d5817523e8234df4$var$uniqueReferencedValue) ref.current = initializer();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ref;
}

});



parcelRegister("f4DUY", function(module, exports) {
$parcel$export(module.exports, "default", () => $f06e7986112c40eb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cQxBL = parcelRequire("cQxBL");

var $1OQKp = parcelRequire("1OQKp");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $9cbmy = parcelRequire("9cbmy");

var $lRq8t = parcelRequire("lRq8t");

var $cxKOj = parcelRequire("cxKOj");

var $jE8Tu = parcelRequire("jE8Tu");

var $1NtzV = parcelRequire("1NtzV");
const $f06e7986112c40eb$var$ExpandHeaderCell = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const hasExpandedItems = (0, $jE8Tu.useHasExpandedItems)();
    const getScreenReaderMessage = ()=>{
        if (hasExpandedItems) return (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1NtzV.default).columnHeaderCollapseButtonIssueTermRefresh : (0, $1NtzV.default).columnHeaderCollapseButton;
        return (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1NtzV.default).columnHeaderExpandButtonIssueTermRefresh : (0, $1NtzV.default).columnHeaderExpandButton;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        xcss: $f06e7986112c40eb$var$hierarchyHeaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $f06e7986112c40eb$var$headerIconStyles
    }, hasExpandedItems ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
        label: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1NtzV.default).columnHeaderCollapseButtonIssueTermRefresh : (0, $1NtzV.default).columnHeaderCollapseButton),
        color: "currentColor",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
        label: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1NtzV.default).columnHeaderExpandButtonIssueTermRefresh : (0, $1NtzV.default).columnHeaderExpandButton),
        color: "currentColor",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), null, formatMessage(getScreenReaderMessage()))));
};
/* TODO: remove after cleaning jsc_m2_hierarchy - style added for the onboarding spotlight  */ const $f06e7986112c40eb$var$hierarchyHeaderStyles = (0, $1DXK0.xcss)({
    height: 'size.300'
});
const $f06e7986112c40eb$var$headerIconStyles = (0, $1DXK0.xcss)({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)"
});
var $f06e7986112c40eb$export$2e2bcd8739ae039 = $f06e7986112c40eb$var$ExpandHeaderCell;

});
parcelRegister("1NtzV", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c95e471dc06941e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5c95e471dc06941e$var$messages = (0, $7qGN1.defineMessages)({
    columnHeaderExpandButton: {
        "id": "native-issue-table.column-header-expand-button",
        "defaultMessage": "Show all issues - expanded"
    },
    columnHeaderCollapseButton: {
        "id": "native-issue-table.column-header-collapse-button",
        "defaultMessage": "Show all issues - collapsed"
    },
    columnHeaderExpandButtonIssueTermRefresh: {
        "id": "native-issue-table.column-header-expand-button-issue-term-refresh",
        "defaultMessage": "Show all work items - expanded"
    },
    columnHeaderCollapseButtonIssueTermRefresh: {
        "id": "native-issue-table.column-header-collapse-button-issue-term-refresh",
        "defaultMessage": "Show all work items - collapsed"
    }
});
var $5c95e471dc06941e$export$2e2bcd8739ae039 = $5c95e471dc06941e$var$messages;

});


parcelRegister("lqvgs", function(module, exports) {
$parcel$export(module.exports, "CheckboxCell", () => $9bcf807234d52bfa$export$e0722abfbf26acc0);
$parcel$export(module.exports, "HeaderCheckboxCell", () => $9bcf807234d52bfa$export$b9d19e1dc166efac);

var $eJOHy = parcelRequire("eJOHy");

var $86tBw = parcelRequire("86tBw");

var $6djmC = parcelRequire("6djmC");

var $2QO3b = parcelRequire("2QO3b");

var $lRq8t = parcelRequire("lRq8t");

var $cxKOj = parcelRequire("cxKOj");

var $bJscI = parcelRequire("bJscI");

var $4EKqI = parcelRequire("4EKqI");

var $da0uW = parcelRequire("da0uW");

var $bjHjL = parcelRequire("bjHjL");
const $9bcf807234d52bfa$var$MaybeCheckboxUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "checkbox-cell",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $9bcf807234d52bfa$var$MaybeHeaderCheckboxUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "header-checkbox-cell",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $9bcf807234d52bfa$export$e0722abfbf26acc0 = ({ issueId: issueId, ...checkboxProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9bcf807234d52bfa$var$MaybeCheckboxUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignInline: "center",
        "data-vc": "checkbox-cell"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        "aria-label": formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bjHjL.messages).checkboxAriaLabelIssueTermRefresh : (0, $bjHjL.messages).checkboxAriaLabel),
        onClick: ()=>(0, $2QO3b.abortAll)('new_interaction'),
        ...checkboxProps
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9bcf807234d52bfa$var$MaybeCheckboxUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $da0uW.CheckboxCell), {
        issueId: issueId,
        ...checkboxProps
    }));
};
const $9bcf807234d52bfa$export$b9d19e1dc166efac = ({ ...checkboxProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9bcf807234d52bfa$var$MaybeHeaderCheckboxUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignInline: "center",
        "data-vc": "header-checkbox-cell"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        "aria-label": formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bjHjL.messages).checkboxAriaLabelIssueTermRefresh : (0, $bjHjL.messages).checkboxAriaLabel),
        onClick: ()=>(0, $2QO3b.abortAll)('new_interaction'),
        ...checkboxProps
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9bcf807234d52bfa$var$MaybeHeaderCheckboxUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $da0uW.HeaderCheckboxCell), checkboxProps));
};

});
parcelRegister("da0uW", function(module, exports) {
$parcel$export(module.exports, "CheckboxCell", () => $c779eb0d2caf5c35$export$e0722abfbf26acc0);
$parcel$export(module.exports, "HeaderCheckboxCell", () => $c779eb0d2caf5c35$export$b9d19e1dc166efac);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $86tBw = parcelRequire("86tBw");

var $6djmC = parcelRequire("6djmC");

var $2QO3b = parcelRequire("2QO3b");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cxKOj = parcelRequire("cxKOj");


var $jE8Tu = parcelRequire("jE8Tu");

var $3TtKq = parcelRequire("3TtKq");

var $bjHjL = parcelRequire("bjHjL");
const $c779eb0d2caf5c35$var$EMPTY_ARRAY = [];
const $c779eb0d2caf5c35$export$e0722abfbf26acc0 = ({ issueId: issueId, rowIndex: rowIndex, depth: depth, ...checkboxProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isIssueSelected = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3TtKq.useIsIssueSelected)({
        rowIndex: rowIndex,
        issueId: issueId,
        depth: depth ?? 0
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3TtKq.useIsIssueSelectedOld)(issueId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const flatListIssueIds = (0, $jE8Tu.useIssueIds)();
    const { selectedOnlyIssueId: selectedOnlyIssueId, checkIssueRow: checkIssueRow } = (0, $3TtKq.useIssueTableSelectedIssuesActions)();
    const isShiftPressed = (0, $eJOHy.useRef)(false);
    const onCheckboxChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        const toggleCheckboxChecked = e.target.checked;
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'newIssueNavigatorTableRow', {
            isCheckboxChecked: toggleCheckboxChecked,
            selectionType: isShiftPressed.current ? 'shift' : 'default'
        });
        checkIssueRow(issueId, toggleCheckboxChecked, isShiftPressed.current, flatListIssueIds, (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? depth : undefined);
    }, [
        checkIssueRow,
        issueId,
        flatListIssueIds,
        depth
    ]);
    const handleSelectedOnlyIssueId = (0, $eJOHy.useCallback)((ev)=>{
        ev.preventDefault();
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'checkbox',
            action: 'changed'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'newIssueNavigatorTableRow', {
            isCheckboxChecked: true,
            selectionType: 'ctrl'
        });
        selectedOnlyIssueId(issueId);
    }, [
        createAnalyticsEvent,
        selectedOnlyIssueId,
        issueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignInline: "center",
        "data-vc": "checkbox-cell"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        ...checkboxProps,
        "aria-label": formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bjHjL.messages).checkboxAriaLabelIssueTermRefresh : (0, $bjHjL.messages).checkboxAriaLabel),
        isChecked: isIssueSelected,
        onChange: onCheckboxChange,
        onClick: (ev)=>{
            isShiftPressed.current = ev.shiftKey;
            (0, $2QO3b.abortAll)('new_interaction');
        },
        onKeyDown: (ev)=>{
            if (!isIssueSelected && ev.ctrlKey && ev.code === 'Space') handleSelectedOnlyIssueId(ev);
        },
        onContextMenu: (ev)=>{
            if (!isIssueSelected && ev.ctrlKey) handleSelectedOnlyIssueId(ev);
        }
    }));
};
const $c779eb0d2caf5c35$export$b9d19e1dc166efac = ({ groupByFieldId: groupByFieldId, totalIssueSearchResultCount: totalIssueSearchResultCount, ...checkboxProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const selectedIssueIdsOld = (0, $3TtKq.useIssueTableSelectedIssues)();
    const { excludedIssueIds: excludedIssueIds, selectedIssueIds: selectedIssueIds } = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3TtKq.useSelectedIssuesState)() : {
        excludedIssueIds: new Set(),
        selectedIssueIds: []
    };
    const { insertSelectedIssueIds: insertSelectedIssueIds, reset: reset, selectAllIssues: selectAllIssues } = (0, $3TtKq.useIssueTableSelectedIssuesActions)();
    const childIssueIds = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jE8Tu.useChildIssueIds)() : $c779eb0d2caf5c35$var$EMPTY_ARRAY;
    const prevGroupByFieldId = (0, $eJOHy.useRef)(groupByFieldId);
    if (prevGroupByFieldId.current !== groupByFieldId) {
        prevGroupByFieldId.current = groupByFieldId;
        reset();
    }
    const issueIds = (0, $jE8Tu.useIssueIds)();
    const isChecked = (0, $3TtKq.useAreAllIssuesSelected)(issueIds);
    const allUnloadedOrLoadedChilds = (0, $eJOHy.useMemo)(()=>new Set([
            ...childIssueIds,
            ...selectedIssueIds
        ]), [
        childIssueIds,
        selectedIssueIds
    ]);
    const isIndeterminate = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3TtKq.useIsHeaderCheckboxIndeterminate)({
        isChecked: isChecked,
        allUnloadedOrLoadedChilds: allUnloadedOrLoadedChilds
    }) : !isChecked && selectedIssueIdsOld.length > 0;
    const onCheckboxChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        const toggleCheckboxChecked = e.target.checked;
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'bulkSelectTableRows', {
            isCheckboxChecked: toggleCheckboxChecked
        });
        if (isIndeterminate || !isChecked) {
            if ((0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false)) {
                const exceedsLimit = totalIssueSearchResultCount && totalIssueSearchResultCount >= (0, $ac0d9865d010f3a9$export$bccea427639cacb7);
                const hasInteracted = excludedIssueIds.size > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(selectedIssueIds, allUnloadedOrLoadedChilds);
                if (isIndeterminate && exceedsLimit && !hasInteracted) reset();
                else selectAllIssues({
                    childIds: childIssueIds,
                    visibleIds: issueIds,
                    count: totalIssueSearchResultCount
                });
            } else insertSelectedIssueIds(issueIds);
        } else if (isChecked) reset();
    }, [
        isIndeterminate,
        isChecked,
        totalIssueSearchResultCount,
        reset,
        selectAllIssues,
        insertSelectedIssueIds,
        issueIds,
        childIssueIds,
        excludedIssueIds,
        selectedIssueIds,
        allUnloadedOrLoadedChilds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignInline: "center",
        "data-vc": "header-checkbox-cell"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        ...checkboxProps,
        "aria-label": formatMessage((0, $bjHjL.messages).headerCheckboxAriaLabel),
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        onChange: onCheckboxChange,
        onClick: ()=>{
            (0, $2QO3b.abortAll)('new_interaction');
        }
    }));
};

});
const $ac0d9865d010f3a9$export$ed483e23b857a8f6 = 'edit-button';
const $ac0d9865d010f3a9$export$c9fe64c29742060e = 'sidebar-header';
const $ac0d9865d010f3a9$export$8789cbfc17809729 = 'sidebar-search';
const $ac0d9865d010f3a9$export$9d8014b892bf6344 = 'sidebar-field';
const $ac0d9865d010f3a9$export$f08be8cd81d9f623 = 382;
const $ac0d9865d010f3a9$export$3a2b34d7e17c7646 = 448;
const $ac0d9865d010f3a9$export$9c1c16e5827224e9 = 'bulkMenu';
const $ac0d9865d010f3a9$export$e9a6cdc6ca093f61 = 'bulkEdit';
const $ac0d9865d010f3a9$export$2de0d879ab3de42d = 'bulkTransition';
const $ac0d9865d010f3a9$export$bccea427639cacb7 = 1000;

parcelRegister("3TtKq", function(module, exports) {
$parcel$export(module.exports, "IssueTableSelectedIssuesContainer", () => $8531abba95832313$export$b11112517798dbed);
$parcel$export(module.exports, "useIssueTableSelectedIssuesActions", () => $8531abba95832313$export$b4602482fdfd31ed);
$parcel$export(module.exports, "useIssueTableSelectedIssues", () => $8531abba95832313$export$ad5f97924b14314b);
$parcel$export(module.exports, "useSelectedIssuesState", () => $8531abba95832313$export$b1fbb226d385face);
$parcel$export(module.exports, "useIssueTableSelectAllTotalSelected", () => $8531abba95832313$export$dc4b7e7d055a0e6c);
$parcel$export(module.exports, "useIsIssueSelectedOld", () => $8531abba95832313$export$f1f122caeb05df26);
$parcel$export(module.exports, "useIsIssueSelected", () => $8531abba95832313$export$cfefd69fc8a5ac52);
$parcel$export(module.exports, "useAreAllIssuesSelected", () => $8531abba95832313$export$949e47631f4a60a5);
$parcel$export(module.exports, "useIsHeaderCheckboxIndeterminate", () => $8531abba95832313$export$c5603c18b2a7ed7a);
$parcel$export(module.exports, "useIsSelectingAll", () => $8531abba95832313$export$815cd134b5001b40);
$parcel$export(module.exports, "useExcludedIssueIds", () => $8531abba95832313$export$f8e8cd326aec0190);

var $cSmYj = parcelRequire("cSmYj");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $cxKOj = parcelRequire("cxKOj");


var $1hqwo = parcelRequire("1hqwo");
const $8531abba95832313$export$b11112517798dbed = (0, $6E16M.createContainer)();
const $8531abba95832313$var$Store = (0, $GtRbT.createStore)({
    initialState: $1hqwo.initialState,
    actions: $1hqwo.actions,
    name: 'jira-native-issue-table-selected-issues-state',
    containedBy: $8531abba95832313$export$b11112517798dbed
});
const $8531abba95832313$export$b4602482fdfd31ed = (0, $iJq0l.createActionsHook)($8531abba95832313$var$Store);
const $8531abba95832313$var$getSelectedIssueIdsSelector = (state)=>{
    return Array.from(state.selectedIssueIds);
};
const $8531abba95832313$export$ad5f97924b14314b = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getSelectedIssueIdsSelector
});
const $8531abba95832313$var$getSelectedState = (state)=>{
    return state;
};
const $8531abba95832313$export$b1fbb226d385face = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getSelectedState
});
const $8531abba95832313$var$getSelectAllTotalSelected = (state, totalIssueSearchResultCount)=>{
    const limitedTotalIssueSearchResultCount = totalIssueSearchResultCount > (0, $ac0d9865d010f3a9$export$bccea427639cacb7) ? (0, $ac0d9865d010f3a9$export$bccea427639cacb7) : totalIssueSearchResultCount;
    return limitedTotalIssueSearchResultCount + state.selectedIssueIds.size - (limitedTotalIssueSearchResultCount >= (0, $ac0d9865d010f3a9$export$bccea427639cacb7) ? state.exclusionCount : 0) - state.excludedIssueIds.size;
};
const $8531abba95832313$export$dc4b7e7d055a0e6c = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getSelectAllTotalSelected
});
const $8531abba95832313$var$getIsIssueIdSelectedSelector = (state, { rowIndex: rowIndex, issueId: issueId, depth: depth })=>{
    // issueId is a uuid when optimistically created via inline create and therefore NaN
    const isOptimisticIssueId = Number.isNaN(Number(issueId)) && (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false);
    if (isOptimisticIssueId) return false;
    const selectLimit = (0, $ac0d9865d010f3a9$export$bccea427639cacb7) - state.exclusionCount;
    if (state.isSelectingAll && (rowIndex > selectLimit - 1 || state.excludedIssueIds.has(issueId)) && !state.selectedIssueIds.has(issueId)) return false;
    return state.isSelectingAll && !depth || state.selectedIssueIds.has(issueId);
};
const $8531abba95832313$var$getIsIssueIdSelectedSelectorOld = (state, issueId)=>{
    return state.selectedIssueIds.has(issueId);
};
const $8531abba95832313$export$f1f122caeb05df26 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getIsIssueIdSelectedSelectorOld
});
const $8531abba95832313$export$cfefd69fc8a5ac52 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getIsIssueIdSelectedSelector
});
const $8531abba95832313$var$getAreAllIssuesSelectedSelector = (state, issueIds)=>{
    if (state.isSelectingAll && (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false)) // everything is selected unless there are issues in excludedIssueIds
    return state.excludedIssueIds.size === 0;
    if (!issueIds) return false;
    return issueIds.length > 0 && issueIds.every((issueId)=>state.selectedIssueIds.has(issueId));
};
const $8531abba95832313$export$949e47631f4a60a5 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getAreAllIssuesSelectedSelector
});
const $8531abba95832313$var$getIsHeaderCheckboxIndeterminate = (state, { isChecked: isChecked, allUnloadedOrLoadedChilds: allUnloadedOrLoadedChilds })=>{
    const { isSelectingAll: isSelectingAll, totalIssueSearchResultCount: totalIssueSearchResultCount, excludedIssueIds: excludedIssueIds, selectedIssueIds: selectedIssueIds } = state;
    if (isSelectingAll) {
        const isOverSelectAllLimit = totalIssueSearchResultCount && totalIssueSearchResultCount >= (0, $ac0d9865d010f3a9$export$bccea427639cacb7);
        const hasExcludedIssuesAndNotAllExcluded = excludedIssueIds.size > 0 && totalIssueSearchResultCount !== excludedIssueIds.size;
        const hasUnselectedExpandedChild = !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(selectedIssueIds, allUnloadedOrLoadedChilds);
        return isOverSelectAllLimit || hasExcludedIssuesAndNotAllExcluded || hasUnselectedExpandedChild;
    }
    return !isChecked && selectedIssueIds.size > 0;
};
const $8531abba95832313$export$c5603c18b2a7ed7a = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getIsHeaderCheckboxIndeterminate
});
const $8531abba95832313$var$getIsSelectingAll = (state)=>{
    return state.isSelectingAll;
};
const $8531abba95832313$export$815cd134b5001b40 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getIsSelectingAll
});
const $8531abba95832313$var$getExcludedIssueIds = (state)=>{
    return Array.from(state.excludedIssueIds);
};
const $8531abba95832313$export$f8e8cd326aec0190 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getExcludedIssueIds
});

});
parcelRegister("1hqwo", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $d2b10d6e7ee3216e$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "actions", () => $d2b10d6e7ee3216e$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state


var $cxKOj = parcelRequire("cxKOj");
const $d2b10d6e7ee3216e$export$d4c72bab9d6cc13a = {
    isSelectingAll: false,
    exclusionCount: 0,
    selectedIssueIds: new Set([]),
    excludedIssueIds: new Set([]),
    lastSelectedRowIndex: null,
    totalIssueSearchResultCount: null
};
const $d2b10d6e7ee3216e$export$e324594224ef24da = {
    selectAllIssues: (data)=>({ dispatch: dispatch, setState: setState }, { onIssueSelected: onIssueSelected, shouldForceManualSelectAll: shouldForceManualSelectAll })=>{
            const { childIds: childIds, count: count, visibleIds: visibleIds } = data;
            const hasReachedLimit = (visibleIds.length ?? 0) >= (0, $ac0d9865d010f3a9$export$bccea427639cacb7);
            const limitedVisibleIds = hasReachedLimit ? visibleIds.slice(0, (0, $ac0d9865d010f3a9$export$bccea427639cacb7)) : visibleIds;
            if (shouldForceManualSelectAll || hasReachedLimit) // when grouping is enabled or the first page is not loaded we should disable "true" select all functionality
            // and fallback to selecting all the loaded issue ids
            dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.insertSelectedIssueIds(limitedVisibleIds));
            else {
                // otherwise conditions are met for true select all
                onIssueSelected?.([]);
                setState({
                    isSelectingAll: true,
                    exclusionCount: childIds?.length ?? 0,
                    selectedIssueIds: new Set(childIds ?? []),
                    excludedIssueIds: new Set([]),
                    totalIssueSearchResultCount: count
                });
            }
        },
    checkIssueRowSelectAll: (selectedIssueIds, isChecked, isShiftPressed, flatList, currentCheckedIndex, depth)=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
            const currentState = getState();
            if (isShiftPressed && currentState.lastSelectedRowIndex !== null) {
                const beyondLimitIssueIds = selectedIssueIds.filter((id)=>{
                    const idx = flatList.findIndex((flatId)=>flatId === id);
                    return idx > (0, $ac0d9865d010f3a9$export$bccea427639cacb7) - 1;
                });
                const withinLimitIssueIds = selectedIssueIds.filter((id)=>{
                    const idx = flatList.findIndex((flatId)=>flatId === id);
                    return idx < (0, $ac0d9865d010f3a9$export$bccea427639cacb7);
                });
                if (isChecked) {
                    const updatedExcludedIssueIds = new Set(currentState.excludedIssueIds);
                    withinLimitIssueIds.forEach((id)=>updatedExcludedIssueIds.delete(id));
                    setState({
                        selectedIssueIds: new Set([
                            ...currentState.selectedIssueIds,
                            ...beyondLimitIssueIds
                        ]),
                        excludedIssueIds: updatedExcludedIssueIds
                    });
                } else {
                    const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
                    beyondLimitIssueIds.forEach((id)=>updatedSelectedIssueIds.delete(id));
                    const updatedExcludedIssueIds = new Set([
                        ...currentState.excludedIssueIds,
                        ...withinLimitIssueIds
                    ]);
                    setState({
                        selectedIssueIds: updatedSelectedIssueIds,
                        excludedIssueIds: updatedExcludedIssueIds
                    });
                    // if all issues have been excluded, we are not selecting all anymore
                    if (updatedExcludedIssueIds.size === currentState.totalIssueSearchResultCount) dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.reset());
                }
                return;
            }
            if (isChecked) dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.addToSelectAllIssues(selectedIssueIds, currentCheckedIndex, depth));
            else dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.excludeFromSelectAllIssues(selectedIssueIds, currentCheckedIndex, depth));
        },
    excludeFromSelectAllIssues: (issueIds, rowIndex, depth = 0)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const currentState = getState();
            if (rowIndex <= (0, $ac0d9865d010f3a9$export$bccea427639cacb7) - 1 && depth === 0) {
                const updatedExcludedIssueIds = new Set([
                    ...currentState.excludedIssueIds,
                    ...issueIds
                ]);
                setState({
                    excludedIssueIds: updatedExcludedIssueIds
                });
                // if all issues have been excluded, we are not selecting all anymore
                if (updatedExcludedIssueIds.size === currentState.totalIssueSearchResultCount) dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.reset());
            } else {
                const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
                issueIds.forEach((issueId)=>updatedSelectedIssueIds.delete(issueId));
                setState({
                    selectedIssueIds: updatedSelectedIssueIds
                });
            }
        },
    addToSelectAllIssues: (issueIds, rowIndex, depth = 0)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (rowIndex > (0, $ac0d9865d010f3a9$export$bccea427639cacb7) - 1 || depth > 0) setState({
                selectedIssueIds: new Set([
                    ...currentState.selectedIssueIds,
                    ...issueIds
                ])
            });
            else {
                const updatedExcludedIssueIds = new Set(currentState.excludedIssueIds);
                issueIds.forEach((issueId)=>updatedExcludedIssueIds.delete(issueId));
                setState({
                    excludedIssueIds: updatedExcludedIssueIds
                });
            }
        },
    insertSelectedIssueIds: (selectedIssueIds)=>({ setState: setState, getState: getState }, { onIssueSelected: onIssueSelected })=>{
            const currentState = getState();
            onIssueSelected?.(selectedIssueIds);
            setState({
                selectedIssueIds: new Set([
                    ...currentState.selectedIssueIds,
                    ...selectedIssueIds
                ])
            });
        },
    removeSelectedIssueIds: (selectedIssueIds)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            selectedIssueIds.forEach((selectedIssueId)=>{
                updatedSelectedIssueIds.delete(selectedIssueId);
            });
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    insertSelectedIssueId: (selectedIssueId)=>({ setState: setState, getState: getState }, { onIssueSelected: onIssueSelected })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            updatedSelectedIssueIds.add(selectedIssueId);
            onIssueSelected?.([
                selectedIssueId
            ]);
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    removeSelectedIssueId: (selectedIssueId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            updatedSelectedIssueIds.delete(selectedIssueId);
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    selectedOnlyIssueId: (selectedIssueId)=>({ setState: setState }, { onIssueSelected: onIssueSelected })=>{
            onIssueSelected?.([
                selectedIssueId
            ]);
            setState({
                selectedIssueIds: new Set([
                    selectedIssueId
                ])
            });
        },
    updateLastSelectedRowIndex: (lastSelectedRowIndex)=>({ setState: setState })=>{
            setState({
                lastSelectedRowIndex: lastSelectedRowIndex
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState($d2b10d6e7ee3216e$export$d4c72bab9d6cc13a);
        },
    checkIssueRow: (issueId, isChecked, isShiftPressed, flatList, depth)=>({ dispatch: dispatch, getState: getState })=>{
            // issueId is a uuid when optimistically created via inline create and therefore NaN
            const isOptimisticIssueId = Number.isNaN(Number(issueId)) && (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false);
            if (isOptimisticIssueId) return;
            const selectedIssueIds = [
                issueId
            ];
            const currentState = getState();
            const currentCheckedIndex = flatList.findIndex((id)=>id === issueId);
            if (isShiftPressed && currentState.lastSelectedRowIndex !== null) {
                const start = Math.min(currentState.lastSelectedRowIndex, currentCheckedIndex);
                const end = Math.max(currentState.lastSelectedRowIndex, currentCheckedIndex);
                selectedIssueIds.push(...flatList.slice(start, end + 1).filter((id)=>id !== issueId));
            }
            dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.updateLastSelectedRowIndex(currentCheckedIndex));
            if (currentState.isSelectingAll && (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false)) dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.checkIssueRowSelectAll(selectedIssueIds, isChecked, isShiftPressed, flatList, currentCheckedIndex, depth));
            else if (isChecked) dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.insertSelectedIssueIds(selectedIssueIds));
            else dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.removeSelectedIssueIds(selectedIssueIds));
        }
};

});


parcelRegister("bjHjL", function(module, exports) {
$parcel$export(module.exports, "messages", () => $b1f512fd4e489e96$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $b1f512fd4e489e96$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    checkboxAriaLabel: {
        "id": "native-issue-table.common.issue-cells.checkbox.checkbox-aria-label",
        "defaultMessage": "Issue checkbox"
    },
    checkboxAriaLabelIssueTermRefresh: {
        "id": "native-issue-table.common.issue-cells.checkbox.checkbox-aria-label-issue-term-refresh",
        "defaultMessage": "Work item checkbox"
    },
    headerCheckboxAriaLabel: {
        "id": "native-issue-table.common.issue-cells.checkbox.header-checkbox-aria-label",
        "defaultMessage": "Select all checkbox"
    }
});

});



parcelRegister("kmIYY", function(module, exports) {
$parcel$export(module.exports, "IssueTableSkeleton", () => $d01bd5b1473e1c91$export$32020b6a5557f03e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $coBPg = parcelRequire("coBPg");
const $d01bd5b1473e1c91$export$32020b6a5557f03e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d01bd5b1473e1c91$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coBPg.NativeIssueTableSkeleton), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d01bd5b1473e1c91$var$SkeletonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("coBPg", function(module, exports) {
$parcel$export(module.exports, "NativeIssueTableSkeleton", () => $f004264ba9491c9c$export$309a6db85e3f2aaa);
/* NativeIssueTableSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $9co9i = parcelRequire("9co9i");
const $f004264ba9491c9c$var$customCssStyles = null;
const $f004264ba9491c9c$var$containerStyles = {
    height: '448px'
};
const $f004264ba9491c9c$export$309a6db85e3f2aaa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9co9i))),
        containerStyles: $f004264ba9491c9c$var$containerStyles,
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("9co9i", function(module, exports) {
module.exports = new URL("native-issue-table-skeleton.tpl.e6209376.svg", import.meta.url).toString();

});



parcelRegister("dmolI", function(module, exports) {
$parcel$export(module.exports, "getColumnConfig", () => $7eb0a7a19768d5ff$export$38a3f9395eadb298);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $3cMgR = parcelRequire("3cMgR");

var $4cTDP = parcelRequire("4cTDP");

var $6XJko = parcelRequire("6XJko");

var $j8Km1 = parcelRequire("j8Km1");

var $8jOO7 = parcelRequire("8jOO7");

var $kpvjE = parcelRequire("kpvjE");
const $7eb0a7a19768d5ff$export$47c53e05a89322a1 = (0, $LFmXM.default)((formatMessage)=>({
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ASSIGNEE]: ()=>({
                defaultWidth: (0, $4cTDP.fg)('jif_fixed_width_for_assignee_column_in_nin') ? (0, $8jOO7.COLUMN_WIDTH_ASSIGNEE) : (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX]: ()=>({
                defaultWidth: 40,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CREATED]: ()=>({
                defaultWidth: 201,
                ascText: formatMessage((0, $kpvjE.default).oldestToNewestOrderOld),
                descText: formatMessage((0, $kpvjE.default).newestToOldestOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).UPDATED]: ()=>({
                defaultWidth: 201,
                ascText: formatMessage((0, $kpvjE.default).oldestToNewestOrderOld),
                descText: formatMessage((0, $kpvjE.default).newestToOldestOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TIMELINE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DUE_DATE]: ()=>({
                defaultWidth: 140,
                ascText: formatMessage((0, $kpvjE.default).oldestToNewestOrderOld),
                descText: formatMessage((0, $kpvjE.default).newestToOldestOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).RESOLUTION_DATE]: ()=>({
                defaultWidth: 106,
                ascText: formatMessage((0, $kpvjE.default).oldestToNewestOrderOld),
                descText: formatMessage((0, $kpvjE.default).newestToOldestOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PRIORITY]: ()=>({
                defaultWidth: 140
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY]: ()=>({
                defaultWidth: (0, $4cTDP.fg)('jira_list_merged_column_gate') ? 140 : 96,
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).EXPAND_BUTTON]: ()=>({
                defaultWidth: 48,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS]: ()=>({
                title: '',
                defaultWidth: 48,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).STATUS]: ()=>({
                defaultWidth: 140
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SUMMARY),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_TYPE]: ()=>({
                // Overrides title from the server's displayName from "Issue Type" to "Type" as per designs
                title: formatMessage((0, $kpvjE.default).columnHeaderIssueType),
                defaultWidth: 101,
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).RESOLUTION]: ()=>({
                defaultWidth: 106
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).REPORTER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CREATOR]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).SPRINT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PARENT]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SUMMARY),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        // Labels renders using an Atlaskit Tag which doesn't respect its container, and there's no prop to override it...
        // <Tag/> has a maxWidth of 180px with 4px of padding either side
        // And we need to accound for 5px & 8px for left and right padding on our cell respectively
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).LABELS]: ()=>({
                defaultWidth: 201
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).COMPONENTS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).FIX_VERSIONS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).STATUS_CATEGORY]: ()=>({
                defaultWidth: 140
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PROJECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).EPIC_LINK]: ()=>({
                // EpicLink renders using an Atlaskit Tag which doesn't respect its container, and there's no prop to override it...
                // <Tag/> has a maxWidth of 180px with 4px of padding either side
                // And we need to account for 5px & 8px for left and right padding on our cell respectively
                defaultWidth: 201,
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld),
                warningText: formatMessage((0, $kpvjE.default).deprecatedEpicLinkMessage, {
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                            color: "color.text.inverse",
                            as: "strong"
                        }, chunks)
                })
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DESCRIPTION]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_LONG),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ENVIRONMENT]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_LONG),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TEXT_AREA]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_LONG),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TEXT]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SHORT),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).READ_ONLY]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SHORT),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).AFFECTS_VERSIONS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).REQUEST_TYPE]: ()=>({
                defaultWidth: 251,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).NUMBER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).STORY_POINT_ESTIMATE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).USER_PICKER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CUSTOM_LABELS]: ()=>({
                defaultWidth: 201
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DATE_TIME]: ()=>({
                defaultWidth: 201
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).URL]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).MULTI_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).MULTI_USER_PICKER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TEAM]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ORIGINAL_ESTIMATE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).GOALS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CASCADING_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CONFLUENCE_PAGES]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PEOPLE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DATE_PICKER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).MERGED_COLUMN]: ()=>({
                defaultWidth: (0, $j8Km1.MERGED_COLUMN_DEFAULT_WIDTH),
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ATLAS_PROJECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).RELATIONSHIP]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            })
    }));
const $7eb0a7a19768d5ff$export$f7ea0b98861f6494 = (0, $LFmXM.default)((formatMessage)=>{
    const aToZOrder = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $8jOO7.SORT_A_TO_Z) : formatMessage((0, $kpvjE.default).aToZOrder);
    const zToAOrder = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $8jOO7.SORT_Z_TO_A) : formatMessage((0, $kpvjE.default).zToAOrder);
    const oldestToNewestOrder = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $8jOO7.SORT_OLDEST_TO_NEWEST) : formatMessage((0, $kpvjE.default).oldestToNewestOrder);
    const newestToOldestOrder = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $8jOO7.SORT_NEWEST_TO_OLDEST) : formatMessage((0, $kpvjE.default).newestToOldestOrder);
    return {
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ASSIGNEE]: ()=>({
                defaultWidth: (0, $4cTDP.fg)('jif_fixed_width_for_assignee_column_in_nin') ? (0, $8jOO7.COLUMN_WIDTH_ASSIGNEE) : (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX]: ()=>({
                defaultWidth: 40,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CREATED]: ()=>({
                defaultWidth: 201,
                ascText: oldestToNewestOrder,
                descText: newestToOldestOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).UPDATED]: ()=>({
                defaultWidth: 201,
                ascText: oldestToNewestOrder,
                descText: newestToOldestOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TIMELINE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DUE_DATE]: ()=>({
                defaultWidth: 140,
                ascText: oldestToNewestOrder,
                descText: newestToOldestOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).RESOLUTION_DATE]: ()=>({
                defaultWidth: 106,
                ascText: oldestToNewestOrder,
                descText: newestToOldestOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PRIORITY]: ()=>({
                defaultWidth: 140,
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: (0, $8jOO7.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $8jOO7.SORT_HIGHEST_TO_LOWEST)
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY]: ()=>({
                defaultWidth: (0, $4cTDP.fg)('jira_list_merged_column_gate') ? 140 : 96,
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') ? {
                    ascText: (0, $8jOO7.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $8jOO7.SORT_HIGHEST_TO_LOWEST)
                } : {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).EXPAND_BUTTON]: ()=>({
                defaultWidth: 48,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS]: ()=>({
                title: '',
                defaultWidth: 48,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).STATUS]: ()=>({
                defaultWidth: 140
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SUMMARY),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_TYPE]: ()=>({
                // Overrides title from the server's displayName from "Issue Type" to "Type" as per designs
                title: formatMessage((0, $kpvjE.default).columnHeaderIssueType),
                defaultWidth: 101,
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).RESOLUTION]: ()=>({
                defaultWidth: 106,
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).REPORTER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CREATOR]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).SPRINT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PARENT]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SUMMARY),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        // Labels renders using an Atlaskit Tag which doesn't respect its container, and there's no prop to override it...
        // <Tag/> has a maxWidth of 180px with 4px of padding either side
        // And we need to accound for 5px & 8px for left and right padding on our cell respectively
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).LABELS]: ()=>({
                defaultWidth: 201,
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).COMPONENTS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).FIX_VERSIONS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: (0, $8jOO7.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $8jOO7.SORT_HIGHEST_TO_LOWEST)
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).STATUS_CATEGORY]: ()=>({
                defaultWidth: 140
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PROJECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).EPIC_LINK]: ()=>({
                // EpicLink renders using an Atlaskit Tag which doesn't respect its container, and there's no prop to override it...
                // <Tag/> has a maxWidth of 180px with 4px of padding either side
                // And we need to account for 5px & 8px for left and right padding on our cell respectively
                defaultWidth: 201,
                ascText: aToZOrder,
                descText: zToAOrder,
                warningText: formatMessage((0, $kpvjE.default).deprecatedEpicLinkMessage, {
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                            color: "color.text.inverse",
                            as: "strong"
                        }, chunks)
                })
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DESCRIPTION]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_LONG),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ENVIRONMENT]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_LONG),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TEXT_AREA]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_LONG),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TEXT]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SHORT),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).READ_ONLY]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SHORT),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).AFFECTS_VERSIONS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).REQUEST_TYPE]: ()=>({
                defaultWidth: 251,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).NUMBER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: (0, $8jOO7.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $8jOO7.SORT_HIGHEST_TO_LOWEST)
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).STORY_POINT_ESTIMATE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).USER_PICKER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CUSTOM_LABELS]: ()=>({
                defaultWidth: 201,
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DATE_TIME]: ()=>({
                defaultWidth: 201,
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: oldestToNewestOrder,
                    descText: newestToOldestOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).URL]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).MULTI_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).MULTI_USER_PICKER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TEAM]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ORIGINAL_ESTIMATE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: (0, $8jOO7.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $8jOO7.SORT_HIGHEST_TO_LOWEST)
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).GOALS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CASCADING_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CONFLUENCE_PAGES]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PEOPLE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DATE_PICKER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: oldestToNewestOrder,
                    descText: newestToOldestOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).MERGED_COLUMN]: ()=>({
                defaultWidth: (0, $j8Km1.MERGED_COLUMN_DEFAULT_WIDTH),
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ATLAS_PROJECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).RELATIONSHIP]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            })
    };
});
const $7eb0a7a19768d5ff$export$38a3f9395eadb298 = (formatMessage)=>{
    return (0, $6XJko.isVisualRefreshEnabled)() ? $7eb0a7a19768d5ff$export$f7ea0b98861f6494(formatMessage) : $7eb0a7a19768d5ff$export$47c53e05a89322a1(formatMessage);
};

});
parcelRegister("kpvjE", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6783773279e9ee3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e6783773279e9ee3$var$messages = (0, $7qGN1.defineMessages)({
    columnHeaderIssueType: {
        "id": "native-issue-table.common.utils.get-column-config.column-header-issue-type",
        "defaultMessage": "Type"
    },
    aToZOrderOld: {
        "id": "native-issue-table.common.utils.get-column-config.a-to-z-order-old",
        "defaultMessage": "A \u279E Z"
    },
    zToAOrderOld: {
        "id": "native-issue-table.common.utils.get-column-config.z-to-a-order-old",
        "defaultMessage": "Z \u279E A"
    },
    oldestToNewestOrderOld: {
        "id": "native-issue-table.common.utils.get-column-config.oldest-to-newest-order-old",
        "defaultMessage": "oldest \u279E newest"
    },
    newestToOldestOrderOld: {
        "id": "native-issue-table.common.utils.get-column-config.newest-to-oldest-order-old",
        "defaultMessage": "newest \u279E oldest"
    },
    deprecatedEpicLinkMessage: {
        "id": "native-issue-table.common.utils.get-column-config.deprecated-epic-link-message",
        "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>."
    },
    aToZOrder: {
        "id": "native-issue-table.common.utils.get-column-config.a-to-z-order",
        "defaultMessage": "A \u2192 Z"
    },
    zToAOrder: {
        "id": "native-issue-table.common.utils.get-column-config.z-to-a-order",
        "defaultMessage": "Z \u2192 A"
    },
    oldestToNewestOrder: {
        "id": "native-issue-table.common.utils.get-column-config.oldest-to-newest-order",
        "defaultMessage": "oldest \u2192 newest"
    },
    newestToOldestOrder: {
        "id": "native-issue-table.common.utils.get-column-config.newest-to-oldest-order",
        "defaultMessage": "newest \u2192 oldest"
    }
});
var $e6783773279e9ee3$export$2e2bcd8739ae039 = $e6783773279e9ee3$var$messages;

});


parcelRegister("l7qKV", function(module, exports) {
$parcel$export(module.exports, "getColumnsWithStickyOffsets", () => $5ccab77fed5b6341$export$6e976bf0e5378347);

var $j8Km1 = parcelRequire("j8Km1");

var $4cTDP = parcelRequire("4cTDP");

var $8jOO7 = parcelRequire("8jOO7");
const $5ccab77fed5b6341$var$calculateStickyOffsets = (orderedStickyColumns, nonStickyColumns)=>{
    let cumulativeStickyOffset = 0;
    const processedStickyColumns = orderedStickyColumns.map((column, i)=>{
        const { id: id, customWidth: customWidth, defaultWidth: defaultWidth } = column;
        const stickyOffsets = cumulativeStickyOffset;
        if (id === (0, $8jOO7.COLUMN_ID_EXPAND_BUTTON)) cumulativeStickyOffset += defaultWidth + (0, $8jOO7.EXPAND_CELL_PADDING);
        else cumulativeStickyOffset += customWidth ?? defaultWidth;
        const isLastStickyColumn = id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) ? column.mergedColumns && column.mergedColumns.length > 0 && i === orderedStickyColumns.length - 1 : i === orderedStickyColumns.length - 1;
        return {
            ...column,
            isColumnSticky: true,
            stickyOffsets: stickyOffsets,
            isLastStickyColumn: isLastStickyColumn
        };
    });
    return [
        ...processedStickyColumns,
        ...nonStickyColumns
    ];
};
const $5ccab77fed5b6341$export$6e976bf0e5378347 = (columnConfig, stickyColumnIds)=>{
    const stickyColumnsById = {};
    const orderedStickyColumns = [];
    const nonStickyColumns = [];
    // if there are no sticky columns we don't calculate offsets and set any columns to sticky
    // this avoids a bug where checkbox is rendered as sticky before the stickyColumnIds are populated
    // due to concurrent rendering
    if (stickyColumnIds && stickyColumnIds.length === 0 && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) return columnConfig;
    columnConfig.forEach((column)=>{
        const { id: id } = column;
        if (id === (0, $8jOO7.COLUMN_ID_CHECKBOX) || id === (0, $8jOO7.COLUMN_ID_EXPAND_BUTTON)) orderedStickyColumns.push(column);
        else if (id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN)) {
            const { mergedColumns: mergedColumns = [] } = column;
            const isMergedCellSticky = mergedColumns.some((mergedCol)=>stickyColumnIds?.includes(mergedCol.id));
            if (isMergedCellSticky) orderedStickyColumns.push(column);
            else nonStickyColumns.push(column);
        } else if (stickyColumnIds?.includes(id)) stickyColumnsById[id] = column;
        else nonStickyColumns.push(column);
    });
    stickyColumnIds?.forEach((columnId)=>{
        if (stickyColumnsById[columnId]) orderedStickyColumns.push(stickyColumnsById[columnId]);
    });
    return $5ccab77fed5b6341$var$calculateStickyOffsets(orderedStickyColumns, nonStickyColumns);
};

});

parcelRegister("P01So", function(module, exports) {
$parcel$export(module.exports, "isNonNullish", () => $a4f78649e91890cd$export$70573498ee17fe1d);
$parcel$export(module.exports, "isKnownColumnType", () => $a4f78649e91890cd$export$e8280bcdc1c3f84);
$parcel$export(module.exports, "exclusiveGroupsOrIssuesFragment", () => $a4f78649e91890cd$export$7ac78cf15a1a4ba3);
$parcel$export(module.exports, "getProjectKeyFromIssueKey", () => $a4f78649e91890cd$export$defe38779a6b81d2);
$parcel$export(module.exports, "escapeBackslashes", () => $a4f78649e91890cd$export$fbd15c27bb7e257c);
$parcel$export(module.exports, "desanitizeField", () => $a4f78649e91890cd$export$261830fe943e88ac);

var $j8Km1 = parcelRequire("j8Km1");

function $a4f78649e91890cd$export$70573498ee17fe1d(value) {
    return value != null;
}
function $a4f78649e91890cd$export$e8280bcdc1c3f84(value) {
    return value !== undefined && Object.values((0, $j8Km1.KNOWN_COLUMN_TYPES)).includes(value);
}
function $a4f78649e91890cd$export$7ac78cf15a1a4ba3({ groups: groups, issues: issues }) {
    if (issues) return {
        groups: null,
        issues: issues
    };
    if (groups) return {
        groups: groups,
        issues: null
    };
    return null;
}
function $a4f78649e91890cd$export$defe38779a6b81d2(issueKey) {
    return issueKey.split('-')[0];
}
const $a4f78649e91890cd$export$fbd15c27bb7e257c = (text)=>text.replace(/\\/g, '\\\\');
const $a4f78649e91890cd$export$261830fe943e88ac = (field)=>{
    const firstChar = field[0];
    const lastChar = field[field.length - 1];
    if ((firstChar === '"' || firstChar === "'") && firstChar === lastChar) return field.slice(1, -1).toLowerCase();
    return field.toLowerCase();
};

});

parcelRegister("kbYhH", function(module, exports) {
$parcel$export(module.exports, "useElementSizeSelector", () => $815a2426d7099138$export$6af5bd31f067d7e5);
$parcel$export(module.exports, "ElementSizeProvider", () => $815a2426d7099138$export$73bf76c50625186);

var $eJOHy = parcelRequire("eJOHy");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $815a2426d7099138$export$e4c0458e30711294 = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0
};
const $815a2426d7099138$export$638cf470f916deb7 = (0, $6E16M.createContainer)({
    getIsConcurrentSafe: ()=>true
});
const $815a2426d7099138$export$3378d8ea7d02abd0 = {
    height: 0,
    width: 0
};
const $815a2426d7099138$var$actions = {
    update: (newState)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                ...newState
            });
        }
};
const $815a2426d7099138$var$Store = (0, $GtRbT.createStore)({
    containedBy: $815a2426d7099138$export$638cf470f916deb7,
    initialState: $815a2426d7099138$export$3378d8ea7d02abd0,
    name: 'ElementSize',
    actions: $815a2426d7099138$var$actions,
    handlers: {
        onInit: ()=>({ setState: setState, getState: getState }, { width: width, height: height })=>{
                const state = getState();
                setState({
                    ...state,
                    width: width,
                    height: height
                });
            },
        onContainerUpdate: ()=>({ setState: setState, getState: getState }, { width: width, height: height })=>{
                const state = getState();
                setState({
                    ...state,
                    width: width,
                    height: height
                });
            }
    }
});
const $815a2426d7099138$export$6af5bd31f067d7e5 = (0, $iJq0l.createStateHook)($815a2426d7099138$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $815a2426d7099138$export$2b86bedf890eab8 = (elementRef)=>{
    const [size, setSize] = (0, $eJOHy.useState)($815a2426d7099138$export$e4c0458e30711294);
    (0, $eJOHy.useEffect)(()=>{
        const element = elementRef.current;
        if (element) {
            const resizeObserver = new ResizeObserver(()=>{
                setSize({
                    height: element.clientHeight,
                    width: element.clientWidth,
                    scrollHeight: element.scrollHeight,
                    scrollWidth: element.scrollWidth
                });
            });
            resizeObserver.observe(element);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        elementRef
    ]);
    return size;
};
const $815a2426d7099138$export$73bf76c50625186 = ({ elementRef: elementRef, children: children })=>{
    const { width: width, height: height } = $815a2426d7099138$export$2b86bedf890eab8(elementRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($815a2426d7099138$export$638cf470f916deb7, {
        width: width,
        height: height
    }, children);
};

});

parcelRegister("4hsdx", function(module, exports) {
$parcel$export(module.exports, "FeaturesContainer", () => $8decaf9559798f71$export$449fd4f36db88f87);

var $eJOHy = parcelRequire("eJOHy");

var $kGj4V = parcelRequire("kGj4V");

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");

var $iFFNS = parcelRequire("iFFNS");
const $8decaf9559798f71$var$ContextualFeatureAnalytics = ({ children: children })=>{
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isVirtualizationEnabled = (0, $34oCh.useIsVirtualizationEnabled)();
    const isColumnResizingEnabled = (0, $34oCh.useIsColumnResizingEnabled)();
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const isInlineEditingEnabled = (0, $34oCh.useIsInlineEditingEnabled)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isIssueCreateEnabled = (0, $34oCh.useIsIssueCreateEnabled)();
    const isInfiniteScrollEnabled = (0, $34oCh.useIsInfiniteScrollEnabled)();
    const isSiblingIssueCreateEnabled = (0, $34oCh.useIsSiblingIssueCreateEnabled)();
    const isChildIssueCreateEnabled = (0, $34oCh.useIsChildIssueCreateEnabled)();
    const isIssueRankDescending = (0, $34oCh.useIsIssueRankDescending)();
    const isIssueHierarchyEnabled = (0, $34oCh.useIsIssueHierarchyEnabled)();
    const isIssueOperationMeatballMenuEnabled = (0, $34oCh.useIsIssueOperationMeatballMenuEnabled)();
    const isColumnBordersEnabled = (0, $34oCh.useIsColumnBordersEnabled)();
    const isRowReorderingEnabled = (0, $34oCh.useIsRowReorderingEnabled)();
    const isEntireRowDraggable = (0, $34oCh.useIsEntireRowDraggable)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    const isInBetweenColumnPickerEnabled = (0, $34oCh.useIsInBetweenColumnPickerEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const isHideDoneItemsEnabled = (0, $34oCh.useIsHideDoneItemsEnabled)();
    const isMergedColumnEnabled = (0, $34oCh.useIsMergedColumnEnabled)();
    const isMergedColumnVisible = (0, $34oCh.useIsMergedColumnVisible)();
    const isChildIssuesTableVisualUpliftEnabled = (0, $34oCh.useIsChildIssuesTableVisualUpliftEnabled)();
    const isStickyColumnsEnabled = (0, $34oCh.useIsStickyColumnsEnabled)();
    const isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
    const isAutoUnstickyOnSmallScreenEnabled = (0, $34oCh.useIsAutoUnstickyOnSmallScreenEnabled)();
    let isConditionalFormattingEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_conditional_formatting')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isConditionalFormattingEnabled = (0, $34oCh.useIsConditionalFormattingEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const isOpenIssueLinkEnabled = (0, $4cTDP.fg)('jira_issue_table_open_issue_link_config') ? (0, $34oCh.useIsOpenIssueLinkEnabled)() : true;
    const isProjectQuickstartOnboardingEnabled = (0, $34oCh.useIsProjectQuickstartOnboardingEnabled)();
    const isSkipIssueCreateSuccessFlagEnabled = (0, $34oCh.useIsSkipIssueCreateSuccessFlagEnabled)();
    const isInBetweenStickyColumnPickerEnabled = (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? (0, $34oCh.useIsInBetweenStickyColumnPickerEnabled)() : false;
    const isColumnConfigColumnEnabled = (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? (0, $34oCh.useIsColumnConfigColumnEnabled)() : true;
    const isRemoveColumnEnabled = (0, $4cTDP.fg)('jira_issue_table_remove_column_check') ? (0, $34oCh.useIsRemoveColumnEnabled)() : true;
    const shouldQuerySprints = (0, $4cTDP.fg)('timeline_harmonisation_m3_targeting') ? (0, $34oCh.useShouldQuerySprints)() : false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: {
            issueTableFeatures: {
                isDensityFull: isDensityFull,
                isVirtualizationEnabled: isVirtualizationEnabled,
                isColumnResizingEnabled: isColumnResizingEnabled,
                isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
                isInlineEditingEnabled: isInlineEditingEnabled,
                isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled,
                isIssueCreateEnabled: isIssueCreateEnabled,
                isInfiniteScrollEnabled: isInfiniteScrollEnabled,
                isSiblingIssueCreateEnabled: isSiblingIssueCreateEnabled,
                isChildIssueCreateEnabled: isChildIssueCreateEnabled,
                isIssueRankDescending: isIssueRankDescending,
                isIssueHierarchyEnabled: isIssueHierarchyEnabled,
                isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled,
                isColumnBordersEnabled: isColumnBordersEnabled,
                isRowReorderingEnabled: isRowReorderingEnabled,
                isEntireRowDraggable: isEntireRowDraggable,
                isGridNavigationEnabled: isGridNavigationEnabled,
                isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
                isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
                isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                isHideDoneItemsEnabled: isHideDoneItemsEnabled,
                isMergedColumnEnabled: isMergedColumnEnabled,
                isMergedColumnVisible: isMergedColumnVisible,
                isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled,
                isStickyColumnsEnabled: isStickyColumnsEnabled,
                isStickyColumnsVisible: isStickyColumnsVisible,
                isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled,
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                isTimelineEnabled: isTimelineEnabled,
                isOpenIssueLinkEnabled: isOpenIssueLinkEnabled,
                isProjectQuickstartOnboardingEnabled: isProjectQuickstartOnboardingEnabled,
                isSkipIssueCreateSuccessFlagEnabled: isSkipIssueCreateSuccessFlagEnabled,
                isInBetweenStickyColumnPickerEnabled: isInBetweenStickyColumnPickerEnabled,
                isColumnConfigColumnEnabled: isColumnConfigColumnEnabled,
                isRemoveColumnEnabled: isRemoveColumnEnabled,
                shouldQuerySprints: shouldQuerySprints
            }
        }
    }, children);
};
const $8decaf9559798f71$export$449fd4f36db88f87 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iFFNS.FeaturesContainerInternal), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8decaf9559798f71$var$ContextualFeatureAnalytics, null, children));
};

});
parcelRegister("34oCh", function(module, exports) {
$parcel$export(module.exports, "useIsDensityFull", () => $0a9c6aee69856176$export$f031d973e8f9ebd1);
$parcel$export(module.exports, "useIsVirtualizationEnabled", () => $0a9c6aee69856176$export$e8cb30aec148fb72);
$parcel$export(module.exports, "useIsColumnResizingEnabled", () => $0a9c6aee69856176$export$928fba01e945632a);
$parcel$export(module.exports, "useIsFixedTableLayoutEnabled", () => $0a9c6aee69856176$export$bce4f421d3fcab1b);
$parcel$export(module.exports, "useIsInlineEditingEnabled", () => $0a9c6aee69856176$export$3e66c03eddc15634);
$parcel$export(module.exports, "useIsInlineEditingExtendedFieldSupportEnabled", () => $0a9c6aee69856176$export$2763573a98b052ad);
$parcel$export(module.exports, "useIsIssueCreateEnabled", () => $0a9c6aee69856176$export$543273904a8063c6);
$parcel$export(module.exports, "useIsInfiniteScrollEnabled", () => $0a9c6aee69856176$export$de7fbee8ed52ae4);
$parcel$export(module.exports, "useIsSiblingIssueCreateEnabled", () => $0a9c6aee69856176$export$f1842b07a822e21a);
$parcel$export(module.exports, "useIsChildIssueCreateEnabled", () => $0a9c6aee69856176$export$1c15679efffd4e2b);
$parcel$export(module.exports, "useIsIssueRankDescending", () => $0a9c6aee69856176$export$82982f49a24a3a9b);
$parcel$export(module.exports, "useIsIssueHierarchyEnabled", () => $0a9c6aee69856176$export$4f04f80fe2006454);
$parcel$export(module.exports, "useIsIssueOperationMeatballMenuEnabled", () => $0a9c6aee69856176$export$a99d862d213ae04);
$parcel$export(module.exports, "useIsRowReorderingEnabled", () => $0a9c6aee69856176$export$3c2a1b4963d788c8);
$parcel$export(module.exports, "useIsEntireRowDraggable", () => $0a9c6aee69856176$export$40143afd2a4a7546);
$parcel$export(module.exports, "useIsReparentingEnabled", () => $0a9c6aee69856176$export$64a4c7b004e35cb6);
$parcel$export(module.exports, "useIsDragAndDropEnabled", () => $0a9c6aee69856176$export$b4fbf34545c95b8e);
$parcel$export(module.exports, "useProjectContext", () => $0a9c6aee69856176$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useSortField", () => $0a9c6aee69856176$export$f8f71fe8cdc658b6);
$parcel$export(module.exports, "useSortDirection", () => $0a9c6aee69856176$export$c88af24ce42b9b94);
$parcel$export(module.exports, "useJql", () => $0a9c6aee69856176$export$f813789488fdc0c7);
$parcel$export(module.exports, "useIsColumnBordersEnabled", () => $0a9c6aee69856176$export$8136b1ebbacf80ef);
$parcel$export(module.exports, "useIsInlineFieldConfigEnabled", () => $0a9c6aee69856176$export$edb9f869c9fd4d6e);
$parcel$export(module.exports, "useIsInBetweenColumnPickerEnabled", () => $0a9c6aee69856176$export$9e70cd1d138c2276);
$parcel$export(module.exports, "useIsSingleLineRowHeightEnabled", () => $0a9c6aee69856176$export$626f961c251cf22e);
$parcel$export(module.exports, "useIsHideDoneItemsEnabled", () => $0a9c6aee69856176$export$41bad204cf3bf31b);
$parcel$export(module.exports, "useIsMergedColumnEnabled", () => $0a9c6aee69856176$export$f6d8bbcfea5cc718);
$parcel$export(module.exports, "useIsMergedColumnVisible", () => $0a9c6aee69856176$export$28416a110952f775);
$parcel$export(module.exports, "useIsChildIssuesTableVisualUpliftEnabled", () => $0a9c6aee69856176$export$5e14421c97bdcf37);
$parcel$export(module.exports, "useIsIssueRankingEnabled", () => $0a9c6aee69856176$export$7fa8121781f45255);
$parcel$export(module.exports, "useIsStickyColumnsEnabled", () => $0a9c6aee69856176$export$6050cee0da5e731b);
$parcel$export(module.exports, "useIsStickyColumnsVisible", () => $0a9c6aee69856176$export$9cc19f3a611a61c0);
$parcel$export(module.exports, "useIsAutoUnstickyOnSmallScreenEnabled", () => $0a9c6aee69856176$export$ab0624efaf6f43c6);
$parcel$export(module.exports, "useIsConditionalFormattingEnabled", () => $0a9c6aee69856176$export$c799a83481d5936b);
$parcel$export(module.exports, "useIsTimelineEnabled", () => $0a9c6aee69856176$export$1a04536b4e3a55ba);
$parcel$export(module.exports, "useIsOpenIssueLinkEnabled", () => $0a9c6aee69856176$export$7923c1bfde5e54d8);
$parcel$export(module.exports, "useIsGridNavigationEnabled", () => $0a9c6aee69856176$export$2903dd9e444e3b01);
$parcel$export(module.exports, "useCellBorderStyle", () => $0a9c6aee69856176$export$1eb373d02f6c5617);
$parcel$export(module.exports, "useIsProjectQuickstartOnboardingEnabled", () => $0a9c6aee69856176$export$3fba142df85df85e);
$parcel$export(module.exports, "useIsRelationshipFieldEnabled", () => $0a9c6aee69856176$export$836cda5e064d5cca);
$parcel$export(module.exports, "useIsRemoteLinkedIssuesEnabled", () => $0a9c6aee69856176$export$a0b21d85bbf85b54);
$parcel$export(module.exports, "useIsEditableSyncLoaded", () => $0a9c6aee69856176$export$1b794ad90463ad6e);
$parcel$export(module.exports, "useIsSkipIssueCreateSuccessFlagEnabled", () => $0a9c6aee69856176$export$32da4d6adc350864);
$parcel$export(module.exports, "useIsInBetweenStickyColumnPickerEnabled", () => $0a9c6aee69856176$export$cc3d2b69eec92586);
$parcel$export(module.exports, "useIsColumnConfigColumnEnabled", () => $0a9c6aee69856176$export$2b72beca6275e92a);
$parcel$export(module.exports, "useIsRemoveColumnEnabled", () => $0a9c6aee69856176$export$108430cb09038e65);
$parcel$export(module.exports, "useShouldQuerySprints", () => $0a9c6aee69856176$export$c9dfb4a12c80ab10);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $8jOO7 = parcelRequire("8jOO7");

var $iFFNS = parcelRequire("iFFNS");
const $0a9c6aee69856176$export$f031d973e8f9ebd1 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.density === (0, $8jOO7.DENSITY_FULL)
});
const $0a9c6aee69856176$export$e8cb30aec148fb72 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.density === (0, $8jOO7.DENSITY_COMPACT) && state.isInfiniteScrollEnabled
});
const $0a9c6aee69856176$export$928fba01e945632a = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isColumnResizingEnabled
});
const $0a9c6aee69856176$export$bce4f421d3fcab1b = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isFixedTableLayoutEnabled
});
const $0a9c6aee69856176$export$3e66c03eddc15634 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isInlineEditingEnabled
});
const $0a9c6aee69856176$export$2763573a98b052ad = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isInlineEditingExtendedFieldSupportEnabled
});
const $0a9c6aee69856176$export$543273904a8063c6 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueCreateEnabled && state.isInfiniteScrollEnabled
});
const $0a9c6aee69856176$export$de7fbee8ed52ae4 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isInfiniteScrollEnabled
});
const $0a9c6aee69856176$export$f1842b07a822e21a = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueCreateEnabled && state.isIssueRankingEnabled
});
const $0a9c6aee69856176$export$1c15679efffd4e2b = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueCreateEnabled && state.isIssueHierarchyEnabled
});
const $0a9c6aee69856176$export$82982f49a24a3a9b = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueRankDescending
});
const $0a9c6aee69856176$export$4f04f80fe2006454 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueHierarchyEnabled && state.isInfiniteScrollEnabled
});
const $0a9c6aee69856176$export$a99d862d213ae04 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueOperationMeatballMenuEnabled
});
const $0a9c6aee69856176$export$3c2a1b4963d788c8 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isRowReorderingEnabled
});
const $0a9c6aee69856176$export$40143afd2a4a7546 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isEntireRowDraggable
});
const $0a9c6aee69856176$export$64a4c7b004e35cb6 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isReparentingEnabled
});
const $0a9c6aee69856176$export$b4fbf34545c95b8e = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isRowReorderingEnabled || state.isReparentingEnabled || state.isIssueRankingEnabled
});
const $0a9c6aee69856176$export$8f31c2503e1efa93 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.projectContext
});
const $0a9c6aee69856176$export$f8f71fe8cdc658b6 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.sortField
});
const $0a9c6aee69856176$export$c88af24ce42b9b94 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.sortDirection
});
const $0a9c6aee69856176$export$f813789488fdc0c7 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.jql
});
const $0a9c6aee69856176$export$8136b1ebbacf80ef = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isColumnBordersEnabled
});
const $0a9c6aee69856176$export$edb9f869c9fd4d6e = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isInlineFieldConfigEnabled
});
const $0a9c6aee69856176$export$9e70cd1d138c2276 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isInBetweenColumnPickerEnabled
});
const $0a9c6aee69856176$export$626f961c251cf22e = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isSingleLineRowHeightEnabled
});
const $0a9c6aee69856176$export$41bad204cf3bf31b = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isHideDoneItemsEnabled
});
const $0a9c6aee69856176$export$f6d8bbcfea5cc718 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isMergedColumnEnabled
});
const $0a9c6aee69856176$export$28416a110952f775 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isMergedColumnVisible
});
const $0a9c6aee69856176$export$5e14421c97bdcf37 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isChildIssuesTableVisualUpliftEnabled
});
const $0a9c6aee69856176$export$7fa8121781f45255 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueRankingEnabled
});
const $0a9c6aee69856176$export$6050cee0da5e731b = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isStickyColumnsEnabled
});
const $0a9c6aee69856176$export$9cc19f3a611a61c0 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isStickyColumnsVisible
});
const $0a9c6aee69856176$export$ab0624efaf6f43c6 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isAutoUnstickyOnSmallScreenEnabled
});
const $0a9c6aee69856176$export$c799a83481d5936b = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isConditionalFormattingEnabled
});
const $0a9c6aee69856176$export$1a04536b4e3a55ba = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isTimelineEnabled
});
const $0a9c6aee69856176$export$7923c1bfde5e54d8 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isOpenIssueLinkEnabled
});
const $0a9c6aee69856176$export$2903dd9e444e3b01 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isGridNavigationEnabled
});
const $0a9c6aee69856176$export$1eb373d02f6c5617 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.cellBorderStyle
});
const $0a9c6aee69856176$export$3fba142df85df85e = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isProjectQuickstartOnboardingEnabled
});
const $0a9c6aee69856176$export$836cda5e064d5cca = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isLinkRelationshipFieldEnabled
});
const $0a9c6aee69856176$export$a0b21d85bbf85b54 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isRemoteLinkedIssuesEnabled
});
const $0a9c6aee69856176$export$1b794ad90463ad6e = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isEditableSyncLoaded
});
const $0a9c6aee69856176$export$32da4d6adc350864 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isSkipIssueCreateSuccessFlagEnabled
});
const $0a9c6aee69856176$export$cc3d2b69eec92586 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isInBetweenStickyColumnPickerEnabled
});
const $0a9c6aee69856176$export$2b72beca6275e92a = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isColumnConfigColumnEnabled
});
const $0a9c6aee69856176$export$108430cb09038e65 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isRemoveColumnEnabled
});
const $0a9c6aee69856176$export$c9dfb4a12c80ab10 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.shouldQuerySprints
});

});
parcelRegister("iFFNS", function(module, exports) {
$parcel$export(module.exports, "FeaturesContainerInternal", () => $fec205bcdab5c4a8$export$8a9f5b92d3cec1ec);
$parcel$export(module.exports, "FeaturesStore", () => $fec205bcdab5c4a8$export$b78abb146634afd0);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $8jOO7 = parcelRequire("8jOO7");
const $fec205bcdab5c4a8$var$initialState = {
    density: (0, $8jOO7.DENSITY_COMPACT),
    isColumnResizingEnabled: true,
    isFixedTableLayoutEnabled: true,
    isInlineEditingEnabled: true,
    isInlineEditingExtendedFieldSupportEnabled: false,
    isIssueCreateEnabled: false,
    projectContext: null,
    isInfiniteScrollEnabled: false,
    isIssueRankingEnabled: false,
    isIssueRankDescending: false,
    isIssueHierarchyEnabled: false,
    isIssueOperationMeatballMenuEnabled: true,
    isRowReorderingEnabled: false,
    isEntireRowDraggable: false,
    isReparentingEnabled: false,
    isColumnBordersEnabled: true,
    isGridNavigationEnabled: false,
    isInlineFieldConfigEnabled: false,
    isInBetweenColumnPickerEnabled: false,
    isSingleLineRowHeightEnabled: false,
    isHideDoneItemsEnabled: false,
    isMergedColumnEnabled: false,
    isMergedColumnVisible: false,
    isChildIssuesTableVisualUpliftEnabled: false,
    isStickyColumnsEnabled: false,
    isStickyColumnsVisible: false,
    isAutoUnstickyOnSmallScreenEnabled: false,
    isConditionalFormattingEnabled: false,
    isTimelineEnabled: false,
    cellBorderStyle: 'FULL_BORDER',
    isProjectQuickstartOnboardingEnabled: false,
    isLinkRelationshipFieldEnabled: false,
    isRemoteLinkedIssuesEnabled: false,
    isEditableSyncLoaded: false,
    isOpenIssueLinkEnabled: true,
    isSkipIssueCreateSuccessFlagEnabled: false,
    isInBetweenStickyColumnPickerEnabled: false,
    isColumnConfigColumnEnabled: true,
    isRemoveColumnEnabled: true,
    shouldQuerySprints: false
};
const $fec205bcdab5c4a8$export$8a9f5b92d3cec1ec = (0, $6E16M.createContainer)();
const $fec205bcdab5c4a8$var$updateStore = ({ setState: setState }, { density: density, isColumnResizingEnabled: isColumnResizingEnabled, isInlineEditingEnabled: isInlineEditingEnabled, isIssueCreateEnabled: isIssueCreateEnabled, isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled, projectContext: projectContext, isInfiniteScrollEnabled: isInfiniteScrollEnabled, sortDirection: sortDirection, sortField: sortField, isIssueHierarchyEnabled: isIssueHierarchyEnabled, isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled, isRowReorderingEnabled: isRowReorderingEnabled, isEntireRowDraggable: isEntireRowDraggable, isReparentingEnabled: isReparentingEnabled, jql: jql, isColumnBordersEnabled: isColumnBordersEnabled, isGridNavigationEnabled: isGridNavigationEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled, isHideDoneItemsEnabled: isHideDoneItemsEnabled, isMergedColumnEnabled: isMergedColumnEnabled, isMergedColumnVisible: isMergedColumnVisible, isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled, isIssueRankingEnabled: isIssueRankingEnabled, isStickyColumnsEnabled: isStickyColumnsEnabled, isStickyColumnsVisible: isStickyColumnsVisible, isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled, isConditionalFormattingEnabled: isConditionalFormattingEnabled = false, isTimelineEnabled: isTimelineEnabled, cellBorderStyle: cellBorderStyle, isProjectQuickstartOnboardingEnabled: isProjectQuickstartOnboardingEnabled, isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled, isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled, isEditableSyncLoaded: isEditableSyncLoaded, isOpenIssueLinkEnabled: isOpenIssueLinkEnabled, isSkipIssueCreateSuccessFlagEnabled: isSkipIssueCreateSuccessFlagEnabled, isInBetweenStickyColumnPickerEnabled: isInBetweenStickyColumnPickerEnabled, isColumnConfigColumnEnabled: isColumnConfigColumnEnabled, isRemoveColumnEnabled: isRemoveColumnEnabled, shouldQuerySprints: shouldQuerySprints })=>{
    setState({
        density: density,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isFixedTableLayoutEnabled: isColumnResizingEnabled,
        isInlineEditingEnabled: isInlineEditingEnabled,
        isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled,
        isIssueCreateEnabled: isIssueCreateEnabled && Boolean(projectContext),
        projectContext: projectContext ?? null,
        isInfiniteScrollEnabled: isInfiniteScrollEnabled,
        isIssueHierarchyEnabled: isIssueHierarchyEnabled && Boolean(projectContext),
        isIssueRankingEnabled: isIssueRankingEnabled,
        isIssueRankDescending: sortDirection === (0, $8jOO7.SORT_DESC),
        isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled,
        isRowReorderingEnabled: isRowReorderingEnabled,
        isEntireRowDraggable: isEntireRowDraggable,
        isReparentingEnabled: isReparentingEnabled,
        sortDirection: sortDirection,
        sortField: sortField,
        jql: jql,
        isColumnBordersEnabled: isColumnBordersEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
        isHideDoneItemsEnabled: isHideDoneItemsEnabled,
        isMergedColumnEnabled: isMergedColumnEnabled,
        isMergedColumnVisible: isMergedColumnVisible,
        isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled,
        isStickyColumnsEnabled: isStickyColumnsEnabled,
        isStickyColumnsVisible: isStickyColumnsVisible,
        isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled,
        isConditionalFormattingEnabled: isConditionalFormattingEnabled,
        isTimelineEnabled: isTimelineEnabled,
        cellBorderStyle: cellBorderStyle,
        isProjectQuickstartOnboardingEnabled: isProjectQuickstartOnboardingEnabled,
        isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
        isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
        isEditableSyncLoaded: isEditableSyncLoaded,
        isOpenIssueLinkEnabled: isOpenIssueLinkEnabled,
        isSkipIssueCreateSuccessFlagEnabled: isSkipIssueCreateSuccessFlagEnabled,
        isInBetweenStickyColumnPickerEnabled: isInBetweenStickyColumnPickerEnabled,
        isColumnConfigColumnEnabled: isColumnConfigColumnEnabled,
        isRemoveColumnEnabled: isRemoveColumnEnabled,
        shouldQuerySprints: shouldQuerySprints
    });
};
const $fec205bcdab5c4a8$export$b78abb146634afd0 = (0, $GtRbT.createStore)({
    initialState: $fec205bcdab5c4a8$var$initialState,
    actions: {},
    containedBy: $fec205bcdab5c4a8$export$8a9f5b92d3cec1ec,
    handlers: {
        onInit: ()=>$fec205bcdab5c4a8$var$updateStore,
        onContainerUpdate: ()=>$fec205bcdab5c4a8$var$updateStore
    }
});

});



parcelRegister("jKV5x", function(module, exports) {
$parcel$export(module.exports, "SelectedRowContainer", () => $909ecdd45b96ffd4$export$613ab77d2c52b90d);

var $gKHX4 = parcelRequire("gKHX4");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $3TtKq = parcelRequire("3TtKq");

var $jILqm = parcelRequire("jILqm");
const $909ecdd45b96ffd4$var$initialState = {
    selectedRowIndex: null,
    amountOfRows: 0,
    focusedRowIndex: null
};
const $909ecdd45b96ffd4$var$Store = (0, $GtRbT.createStore)({
    initialState: $909ecdd45b96ffd4$var$initialState,
    actions: $jILqm.default,
    name: 'selectedRowState'
});
const $909ecdd45b96ffd4$export$42a852a2b6b56249 = (0, $6E16M.createContainer)($909ecdd45b96ffd4$var$Store, {
    onInit: ()=>({ setState: setState }, { selectedRowIndex: selectedRowIndex = null, amountOfRows: amountOfRows = 0 })=>{
            setState({
                selectedRowIndex: selectedRowIndex,
                amountOfRows: amountOfRows
            });
        },
    onUpdate: ()=>({ setState: setState, getState: getState }, { selectedRowIndex: newRowIndex, amountOfRows: newAmountOfRows })=>{
            const { selectedRowIndex: selectedRowIndex, amountOfRows: amountOfRows } = getState();
            selectedRowIndex !== newRowIndex && setState({
                selectedRowIndex: newRowIndex ?? null
            });
            amountOfRows !== newAmountOfRows && setState({
                amountOfRows: newAmountOfRows ?? 0
            });
        }
});
const $909ecdd45b96ffd4$export$613ab77d2c52b90d = ({ issues: issues, onPageChange: onPageChange, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $gKHX4.default), issues);
    const { insertSelectedIssueIds: insertSelectedIssueIds, removeSelectedIssueIds: removeSelectedIssueIds } = (0, $3TtKq.useIssueTableSelectedIssuesActions)();
    const lastSelectedRow = (0, $eJOHy.useRef)(null);
    const cursors = data?.pageCursors?.around;
    const currentPageIndex = (0, $eJOHy.useMemo)(()=>cursors?.findIndex((cursor)=>cursor?.isCurrent) ?? -1, [
        cursors
    ]);
    const onNextPage = (0, $eJOHy.useCallback)(()=>{
        if (onPageChange && currentPageIndex > -1) {
            const nextPage = cursors?.[currentPageIndex + 1];
            if (nextPage && nextPage.cursor != null) onPageChange(nextPage.cursor, false);
        }
    }, [
        currentPageIndex,
        cursors,
        onPageChange
    ]);
    const onPreviousPage = (0, $eJOHy.useCallback)(()=>{
        if (onPageChange && currentPageIndex > 0) {
            const previousPage = cursors?.[currentPageIndex - 1];
            if (previousPage && previousPage.cursor != null) onPageChange(previousPage.cursor, true);
        }
    }, [
        currentPageIndex,
        cursors,
        onPageChange
    ]);
    const onCheckRow = (0, $eJOHy.useCallback)((rowIndex, isChecked, isShiftSelected)=>{
        const initialIssueId = data?.edges?.[rowIndex]?.node?.issueId;
        if (!initialIssueId) return;
        const selectedIssueIds = [
            initialIssueId
        ];
        if (isShiftSelected && lastSelectedRow.current !== null) {
            const start = Math.min(lastSelectedRow.current, rowIndex);
            const end = Math.max(lastSelectedRow.current, rowIndex);
            for(let i = start; i <= end; i++){
                const currentIssueId = data?.edges?.[i]?.node?.issueId;
                if (i !== rowIndex && currentIssueId) selectedIssueIds.push(currentIssueId);
            }
        }
        lastSelectedRow.current = rowIndex;
        if (isChecked) insertSelectedIssueIds(selectedIssueIds);
        else removeSelectedIssueIds(selectedIssueIds);
    }, [
        data?.edges,
        insertSelectedIssueIds,
        removeSelectedIssueIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($909ecdd45b96ffd4$export$42a852a2b6b56249, {
        ...props,
        onNextPage: onNextPage,
        onPreviousPage: onPreviousPage,
        onCheckRow: onCheckRow
    });
};
const $909ecdd45b96ffd4$export$11a86b67953bcc50 = (0, $iJq0l.createHook)($909ecdd45b96ffd4$var$Store, {
    selector: (state)=>state.selectedRowIndex
});
const $909ecdd45b96ffd4$export$fb40a80c530e5f2b = (0, $iJq0l.createHook)($909ecdd45b96ffd4$var$Store, {
    selector: (state, { selectedRowIndex: selectedRowIndex })=>state.selectedRowIndex === selectedRowIndex
});
const $909ecdd45b96ffd4$export$a774b9356e1b793 = (0, $iJq0l.createHook)($909ecdd45b96ffd4$var$Store, {
    selector: (state, { selectedRowIndex: selectedRowIndex })=>state.focusedRowIndex === selectedRowIndex
});
const $909ecdd45b96ffd4$export$7b16b18429291a5c = (0, $iJq0l.createActionsHook)($909ecdd45b96ffd4$var$Store);
const $909ecdd45b96ffd4$export$f8ee25964657042a = (0, $iJq0l.createHook)($909ecdd45b96ffd4$var$Store, {
    selector: (state)=>state.amountOfRows
});

});
parcelRegister("gKHX4", function(module, exports) {
$parcel$export(module.exports, "default", () => $813202a7cc0f14c4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a3fa6fd9898db324998b23e343f4083>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $813202a7cc0f14c4$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageSize"
        }
    ],
    "kind": "Fragment",
    "name": "SelectedRowContainer",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "maxCursors",
                    "value": 7
                },
                {
                    "kind": "Variable",
                    "name": "pageSize",
                    "variableName": "pageSize"
                }
            ],
            "concreteType": "JiraPageCursors",
            "kind": "LinkedField",
            "name": "pageCursors",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraPageCursor",
                    "kind": "LinkedField",
                    "name": "around",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "cursor"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isCurrent"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "issueId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$813202a7cc0f14c4$var$node.hash = "768571ad9e025ec88f84f83f5e4f5108";
var $813202a7cc0f14c4$export$2e2bcd8739ae039 = $813202a7cc0f14c4$var$node;

});

parcelRegister("jILqm", function(module, exports) {
$parcel$export(module.exports, "default", () => $496a7015da5426ec$export$2e2bcd8739ae039);
const $496a7015da5426ec$var$actions = {
    setSelectedRow: (rowIndex)=>({ getState: getState, setState: setState }, { onRowChange: onRowChange })=>{
            const { selectedRowIndex: selectedRowIndex, amountOfRows: amountOfRows } = getState();
            if (selectedRowIndex !== rowIndex && amountOfRows > 0) {
                setState({
                    selectedRowIndex: rowIndex,
                    focusedRowIndex: rowIndex
                });
                onRowChange && onRowChange(rowIndex);
            }
        },
    resetFocus: ()=>({ getState: getState, setState: setState })=>{
            const { focusedRowIndex: focusedRowIndex } = getState();
            focusedRowIndex !== null && setState({
                focusedRowIndex: null
            });
        },
    setAmountOfRows: (newAmountOfRows)=>({ setState: setState, getState: getState })=>{
            const { amountOfRows: amountOfRows } = getState();
            amountOfRows !== newAmountOfRows && setState({
                amountOfRows: newAmountOfRows
            });
        },
    selectNextRow: ()=>({ getState: getState, dispatch: dispatch }, { onNextPage: onNextPage })=>{
            const { amountOfRows: amountOfRows, selectedRowIndex: selectedRowIndex } = getState();
            if (amountOfRows === 0) return;
            // edge case: we have only blank issues in the list, we want to make it key accessible
            if (selectedRowIndex === null) dispatch($496a7015da5426ec$var$actions.setSelectedRow(0));
            else if (selectedRowIndex < amountOfRows - 1) dispatch($496a7015da5426ec$var$actions.setSelectedRow(selectedRowIndex + 1));
            else if (selectedRowIndex === amountOfRows - 1 && onNextPage) onNextPage();
        },
    selectPrevRow: ()=>({ getState: getState, dispatch: dispatch }, { onPreviousPage: onPreviousPage })=>{
            const { selectedRowIndex: selectedRowIndex, amountOfRows: amountOfRows } = getState();
            if (amountOfRows === 0) return;
            // edge case: we have only one blank issues in the list, we want to make it key accessible
            if (selectedRowIndex === null) dispatch($496a7015da5426ec$var$actions.setSelectedRow(0));
            else if (selectedRowIndex > 0) dispatch($496a7015da5426ec$var$actions.setSelectedRow(selectedRowIndex - 1));
            else if (selectedRowIndex === 0 && onPreviousPage) onPreviousPage();
        },
    checkRow: (rowIndex, isChecked, isShiftPressed)=>(_, { onCheckRow: onCheckRow })=>{
            onCheckRow && onCheckRow(rowIndex, isChecked, isShiftPressed);
        }
};
var $496a7015da5426ec$export$2e2bcd8739ae039 = $496a7015da5426ec$var$actions;

});


parcelRegister("6LwYU", function(module, exports) {
$parcel$export(module.exports, "SiblingCreateActiveIndexContainer", () => $cce11cf956429fbb$export$3bb3687dbfff2504);
$parcel$export(module.exports, "useIsSiblingIssueCreateActive", () => $cce11cf956429fbb$export$1e0d27763664702c);
$parcel$export(module.exports, "useSiblingCreateActiveIndexActions", () => $cce11cf956429fbb$export$c2ceb7cc1900ce28);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $cce11cf956429fbb$var$CLEAR_DELAY = 300;
const $cce11cf956429fbb$var$initialState = {
    issue: {
        index: undefined,
        isIndexLocked: false,
        timeoutId: undefined
    },
    field: {
        index: undefined,
        isIndexLocked: false,
        timeoutId: undefined
    }
};
const $cce11cf956429fbb$var$actions = {
    setIndex: (key, index)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: index
                }
            });
            dispatch($cce11cf956429fbb$var$actions.lockIndex(key));
        },
    clearIndex: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: undefined
                }
            });
            dispatch($cce11cf956429fbb$var$actions.unlockIndex(key));
        },
    clearIndexAfterDelay: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const timeoutId = setTimeout(()=>{
                if (!getState()[key].isIndexLocked) {
                    dispatch($cce11cf956429fbb$var$actions.clearIndex(key));
                    setState({
                        [key]: {
                            ...getState()[key],
                            timeoutId: undefined
                        }
                    });
                }
            }, $cce11cf956429fbb$var$CLEAR_DELAY);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false,
                    timeoutId: timeoutId
                }
            });
        },
    lockIndex: (key)=>({ setState: setState, getState: getState })=>{
            const { timeoutId: timeoutId } = getState()[key];
            if (timeoutId) clearTimeout(timeoutId);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: true,
                    timeoutId: undefined
                }
            });
        },
    unlockIndex: (key)=>({ setState: setState, getState: getState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false
                }
            });
        }
};
const $cce11cf956429fbb$export$3bb3687dbfff2504 = (0, $6E16M.createContainer)();
const $cce11cf956429fbb$var$Store = (0, $GtRbT.createStore)({
    initialState: $cce11cf956429fbb$var$initialState,
    actions: $cce11cf956429fbb$var$actions,
    containedBy: $cce11cf956429fbb$export$3bb3687dbfff2504
});
const $cce11cf956429fbb$var$isIndexEqual = (a, b)=>a !== undefined && a[0] === b[0] && a[1] === b[1];
const $cce11cf956429fbb$export$1e0d27763664702c = (0, $iJq0l.createHook)($cce11cf956429fbb$var$Store, {
    selector: (state, index)=>$cce11cf956429fbb$var$isIndexEqual(state.issue.index, index)
});
const $cce11cf956429fbb$export$c2ceb7cc1900ce28 = (0, $iJq0l.createActionsHook)($cce11cf956429fbb$var$Store);
const $cce11cf956429fbb$export$7de76a106681e3b2 = (0, $iJq0l.createHook)($cce11cf956429fbb$var$Store);

});

parcelRegister("6KVf0", function(module, exports) {
$parcel$export(module.exports, "InlineCreateActiveIndexContainer", () => $27ce9003fc1e8500$export$293e9de3e94ac3e3);
$parcel$export(module.exports, "useInlineCreateActiveIndexActions", () => $27ce9003fc1e8500$export$109b1f65f6277f1f);
$parcel$export(module.exports, "useInlineFieldCreateActiveIndex", () => $27ce9003fc1e8500$export$b47f84449b2c30b5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $27ce9003fc1e8500$var$CLEAR_DELAY = 300;
const $27ce9003fc1e8500$export$3378d8ea7d02abd0 = {
    issue: {
        index: undefined,
        isIndexLocked: false,
        timeoutId: undefined
    },
    field: {
        index: undefined,
        isHovered: false,
        isIndexLocked: false,
        timeoutId: undefined
    }
};
const $27ce9003fc1e8500$var$actions = {
    setIndex: (key, index)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: index
                }
            });
            dispatch($27ce9003fc1e8500$var$actions.lockIndex(key));
        },
    clearIndex: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: undefined
                }
            });
            dispatch($27ce9003fc1e8500$var$actions.unlockIndex(key));
        },
    clearIndexAfterDelay: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const timeoutId = setTimeout(()=>{
                if (!getState()[key].isIndexLocked) {
                    dispatch($27ce9003fc1e8500$var$actions.clearIndex(key));
                    setState({
                        [key]: {
                            ...getState()[key],
                            timeoutId: undefined
                        }
                    });
                }
            }, $27ce9003fc1e8500$var$CLEAR_DELAY);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false,
                    timeoutId: timeoutId
                }
            });
        },
    setIsHovered: (key)=>({ getState: getState, setState: setState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isHovered: true
                }
            });
        },
    clearIsHovered: (key)=>({ setState: setState, getState: getState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isHovered: false
                }
            });
        },
    lockIndex: (key)=>({ setState: setState, getState: getState })=>{
            const { timeoutId: timeoutId } = getState()[key];
            if (timeoutId) clearTimeout(timeoutId);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: true,
                    timeoutId: undefined
                }
            });
        },
    unlockIndex: (key)=>({ setState: setState, getState: getState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false
                }
            });
        }
};
const $27ce9003fc1e8500$export$293e9de3e94ac3e3 = (0, $6E16M.createContainer)();
const $27ce9003fc1e8500$var$Store = (0, $GtRbT.createStore)({
    initialState: $27ce9003fc1e8500$export$3378d8ea7d02abd0,
    actions: $27ce9003fc1e8500$var$actions,
    containedBy: $27ce9003fc1e8500$export$293e9de3e94ac3e3
});
const $27ce9003fc1e8500$export$121b3ed4dfcef179 = (0, $iJq0l.createHook)($27ce9003fc1e8500$var$Store);
const $27ce9003fc1e8500$export$109b1f65f6277f1f = (0, $iJq0l.createActionsHook)($27ce9003fc1e8500$var$Store);
const $27ce9003fc1e8500$var$getInlineIssueCreate = (state)=>state.issue;
const $27ce9003fc1e8500$var$getInlineFieldCreate = (state)=>state.field;
const $27ce9003fc1e8500$var$isIssueIndexEqual = (a, b)=>a !== undefined && a[0] === b[0] && a[1] === b[1];
const $27ce9003fc1e8500$export$4e43a4c525201572 = (0, $iJq0l.createHook)($27ce9003fc1e8500$var$Store, {
    selector: (state, index)=>$27ce9003fc1e8500$var$isIssueIndexEqual(state.issue.index, index)
});
const $27ce9003fc1e8500$export$72e323294e39f1e1 = (0, $iJq0l.createHook)($27ce9003fc1e8500$var$Store, {
    selector: $27ce9003fc1e8500$var$getInlineIssueCreate
});
const $27ce9003fc1e8500$export$b47f84449b2c30b5 = (0, $iJq0l.createHook)($27ce9003fc1e8500$var$Store, {
    selector: $27ce9003fc1e8500$var$getInlineFieldCreate
});

});

parcelRegister("3F6xT", function(module, exports) {
$parcel$export(module.exports, "TableIntersectionObserverContainer", () => $38738d16686b0ed7$export$d70db3a85b45c17e);
$parcel$export(module.exports, "useIntersectionObserver", () => $38738d16686b0ed7$export$a7395f9832c00176);
$parcel$export(module.exports, "useObserveItem", () => $38738d16686b0ed7$export$323a1519def7418e);
$parcel$export(module.exports, "useCalculateIssueInsertionPoint", () => $38738d16686b0ed7$export$736db8d31780fc97);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $8jOO7 = parcelRequire("8jOO7");

var $dEwO3 = parcelRequire("dEwO3");
const $38738d16686b0ed7$export$d4c72bab9d6cc13a = {
    intersectionObserver: null,
    itemsObserved: new Map(),
    insertionPoint: null,
    isObserving: false
};
const $38738d16686b0ed7$export$d70db3a85b45c17e = (0, $6E16M.createContainer)();
const $38738d16686b0ed7$var$actions = {
    /**
	 * Starts the intersection observer to observer any stored item.
	 */ observeItems: ()=>({ getState: getState, setState: setState })=>{
            const { intersectionObserver: intersectionObserver, itemsObserved: itemsObserved, isObserving: isObserving } = getState();
            if (isObserving) return;
            if (intersectionObserver != null) itemsObserved.forEach((_, element)=>{
                intersectionObserver.observe(element);
            });
            setState({
                isObserving: true
            });
        },
    /**
	 * Stops the intersection observer.
	 */ unobserveItems: ()=>({ getState: getState, setState: setState })=>{
            const { intersectionObserver: intersectionObserver, isObserving: isObserving } = getState();
            if (!isObserving) return;
            if (intersectionObserver != null) intersectionObserver.disconnect();
            setState({
                isObserving: false
            });
        },
    /**
	 * Disconnect any previous intersection observer stored, if the stored is set to automatically observe,
	 * we start observing any stored item, finally we updated the stored with the new observer.
	 * @param {Object} config
	 * @param {IntersectionObserver} config.intersectionObserver - New IntersectionObserver to be added it
	 */ setIntersectionObserver: ({ intersectionObserver: newIntersectionObserver })=>({ setState: setState, getState: getState })=>{
            const { intersectionObserver: intersectionObserver, isObserving: isObserving, itemsObserved: itemsObserved } = getState();
            if (intersectionObserver != null) intersectionObserver.disconnect();
            if (isObserving) itemsObserved.forEach((_, element)=>{
                newIntersectionObserver.observe(element);
            });
            setState({
                intersectionObserver: newIntersectionObserver
            });
        },
    /**
	 * Add a HTML element ot the list of observed elements. It start's observing automatically
	 * if the stored is observing.
	 * @param {Object} config
	 * @param {HTMLElement} element - HTML Element to be observed
	 * @param {string} issueId - Id of the issue that is associated to the HTML Element that is been observed
	 */ observeItem: ({ element: element, issueId: issueId })=>({ getState: getState, setState: setState })=>{
            const { intersectionObserver: intersectionObserver, itemsObserved: itemsObserved, isObserving: isObserving } = getState();
            setState({
                itemsObserved: new Map([
                    ...itemsObserved.entries(),
                    [
                        element,
                        issueId
                    ]
                ])
            });
            if (intersectionObserver == null || !isObserving) return;
            intersectionObserver.observe(element);
        },
    /**
	 * Removes an element from been observed, I stop's observing the element automatically
	 * if the stored is observing
	 * @param {Object} config
	 * @param {HTMLElement} element - Element to be unobserved
	 */ unobserveItem: ({ element: element })=>({ getState: getState, setState: setState })=>{
            const { intersectionObserver: intersectionObserver, itemsObserved: itemsObserved, isObserving: isObserving } = getState();
            if (itemsObserved.has(element)) {
                const newItemsObserved = new Map(itemsObserved.entries());
                newItemsObserved.delete(element);
                setState({
                    itemsObserved: newItemsObserved
                });
            }
            if (intersectionObserver == null || !isObserving) return;
            intersectionObserver.unobserve(element);
        },
    /**
	 * It stored the insertion point in the stored
	 * @param {InsertionPoint} insertionPoint - Insertion point to be stored
	 */ setInsertionPoint: (insertionPoint)=>({ setState: setState })=>{
            setState({
                insertionPoint: insertionPoint
            });
        }
};
const $38738d16686b0ed7$export$bc23ad63575022d9 = (0, $GtRbT.createStore)({
    initialState: $38738d16686b0ed7$export$d4c72bab9d6cc13a,
    actions: $38738d16686b0ed7$var$actions,
    containedBy: $38738d16686b0ed7$export$d70db3a85b45c17e
});
const $38738d16686b0ed7$export$bfaae927f3082143 = (0, $iJq0l.createHook)($38738d16686b0ed7$export$bc23ad63575022d9);
const $38738d16686b0ed7$export$bc925ad7e18c9ef8 = (0, $iJq0l.createActionsHook)($38738d16686b0ed7$export$bc23ad63575022d9);
const $38738d16686b0ed7$var$ROW_HEIGHT_WITH_BORDER = (0, $8jOO7.ROW_HEIGHT) + 1;
const $38738d16686b0ed7$export$a7395f9832c00176 = ()=>{
    const { setIntersectionObserver: setObserver, setInsertionPoint: setInsertionPoint } = $38738d16686b0ed7$export$bc925ad7e18c9ef8();
    return (0, $eJOHy.useCallback)((element)=>{
        if (element != null) {
            const observer = new IntersectionObserver((entries)=>{
                const isOverflow = element.scrollHeight > element.clientHeight;
                const mostRecentEntryCloseToFooter = entries.map((entry)=>{
                    if (entry.rootBounds == null) return;
                    const { top: top } = entry.boundingClientRect;
                    const { bottom: interceptLine } = entry.rootBounds;
                    /**
								 * When scrolling upward (mac), the top line of the item rect is
								 * passing from below to above the intercept line. We identify this
								 * because the entry rectangle will look like:
								 *
								 *  --------  -> Top of root
								 * |        |
								 * |        |
								 * =========  -> Top of item
								 * ---------  -> Bottom of root (aka intercept line)
								 * =========  -> Bottom of item (aka top + height )
								 */ const isBelow = top <= interceptLine && top + $38738d16686b0ed7$var$ROW_HEIGHT_WITH_BORDER >= interceptLine;
                    /**
								 * When scrolling downward (mac), the top line of the item rect is
								 * passing from above to below the intercept line. We identify this
								 * because the entry rectangle will look like:
								 *
								 *  --------  -> Top of root
								 * |        |
								 * |        |
								 * ---------  -> Bottom of root (aka intercept line)
								 * =========  -> Top of item
								 * |        |
								 * =========  -> Bottom of item (aka top + height )
								 * If top minus height is below that the intercept line, means that is
								 * rectangle fits
								 */ const isAbove = top >= interceptLine && top - $38738d16686b0ed7$var$ROW_HEIGHT_WITH_BORDER <= interceptLine;
                    // We prioritize below vs above when is possible.
                    if (isBelow) return {
                        position: 'below',
                        entry: entry
                    };
                    if (isAbove) return {
                        position: 'above',
                        entry: entry
                    };
                    // Otherwise; Is pass the intercept line ignored
                    return undefined;
                }).filter((a)=>a !== undefined)// put most recent entries on top, is possible that multiple
                // entries pass the intercept line
                .sort((a, b)=>{
                    if (b.entry.time !== a.entry.time) return b.entry.time - a.entry.time;
                    // Returns the closest to the bottom when the time is the same
                    if (b.entry.boundingClientRect.y > a.entry.boundingClientRect.y) return 1;
                    if (b.entry.boundingClientRect.y < a.entry.boundingClientRect.y) return -1;
                    return 0;
                })// get the most recent one
                .shift();
                if (mostRecentEntryCloseToFooter) setInsertionPoint({
                    element: mostRecentEntryCloseToFooter.entry.target,
                    // Always insert below when is not overflowing
                    position: isOverflow ? mostRecentEntryCloseToFooter.position : 'below'
                });
            }, {
                root: element,
                // We are placing the interceptor just below the header
                // and a row above the footer, as we want to insert the icon
                // at least a row above the footer to be visible
                rootMargin: `-40px 0px -${2 * $38738d16686b0ed7$var$ROW_HEIGHT_WITH_BORDER}px 0px`
            });
            setObserver({
                intersectionObserver: observer
            });
        }
    }, [
        setInsertionPoint,
        setObserver
    ]);
};
const $38738d16686b0ed7$export$323a1519def7418e = (issueId)=>{
    const { observeItem: observeItem, unobserveItem: unobserveItem } = $38738d16686b0ed7$export$bc925ad7e18c9ef8();
    const itemRef = (0, $eJOHy.useRef)();
    const wasObserved = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>()=>{
            itemRef.current != null && unobserveItem({
                element: itemRef.current
            });
        }, [
        unobserveItem
    ]);
    return (0, $eJOHy.useCallback)((element)=>{
        if (element != null) {
            itemRef.current = element;
            if (issueId != null) {
                observeItem({
                    element: element,
                    issueId: issueId
                });
                wasObserved.current = true;
            }
        }
    }, [
        issueId,
        observeItem
    ]);
};
const $38738d16686b0ed7$export$935a9e0cb21f3923 = (0, $iJq0l.createStateHook)($38738d16686b0ed7$export$bc23ad63575022d9, {
    selector: (0, $dEwO3.getInsertionPointSelector)
});
const $38738d16686b0ed7$export$736db8d31780fc97 = ()=>{
    const { observeItems: observeItems, unobserveItems: unobserveItems } = $38738d16686b0ed7$export$bc925ad7e18c9ef8();
    (0, $eJOHy.useEffect)(()=>{
        observeItems();
        return ()=>{
            unobserveItems();
        };
    }, [
        observeItems,
        unobserveItems
    ]);
    return $38738d16686b0ed7$export$935a9e0cb21f3923();
};

});
parcelRegister("dEwO3", function(module, exports) {
$parcel$export(module.exports, "getInsertionPointSelector", () => $c3d64bf506bc2d61$export$74f2307c2f2b1be0);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4MchI = parcelRequire("4MchI");
const $c3d64bf506bc2d61$var$getIssueIdSelector = (0, $4MchI.createSelector)((state)=>state.itemsObserved, (_, element)=>element, (items, element)=>{
    const issueId = items.get(element);
    if (issueId === undefined) return null;
    return issueId;
});
const $c3d64bf506bc2d61$export$74f2307c2f2b1be0 = (state)=>{
    const { insertionPoint: insertionPoint } = state;
    if (insertionPoint == null) return null;
    const { element: element, position: position } = insertionPoint;
    const issueId = $c3d64bf506bc2d61$var$getIssueIdSelector(state, element);
    if (issueId == null) return null;
    return {
        issueId: issueId,
        position: position
    };
};

});


parcelRegister("eqbO4", function(module, exports) {
$parcel$export(module.exports, "LazyEditabilityLoaderContainer", () => $8a9b205a24007018$export$9e924386fdd64f6e);
$parcel$export(module.exports, "useLazyLoadEditability", () => $8a9b205a24007018$export$9b127efb5c6c57e8);

var $eJOHy = parcelRequire("eJOHy");

var $79KwK = parcelRequire("79KwK");

var $j4oe4 = parcelRequire("j4oe4");

var $3pSHx = parcelRequire("3pSHx");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $lMr7M = parcelRequire("lMr7M");

var $ehqRw = parcelRequire("ehqRw");

const $8a9b205a24007018$var$initialState = {
    loader: null,
    scheduler: null
};
const $8a9b205a24007018$var$Container = (0, $6E16M.createContainer)();
const $8a9b205a24007018$var$Store = (0, $GtRbT.createStore)({
    containedBy: $8a9b205a24007018$var$Container,
    initialState: $8a9b205a24007018$var$initialState,
    actions: $ehqRw.actions,
    handlers: {
        onInit: ()=>({ setState: setState }, { environment: environment })=>{
                const scheduler = (0, $lMr7M.createDataLoaderScheduler)(100);
                const loader = new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))((0, $ehqRw.batchIsEditableInIssueViewFactory)(environment), {
                    maxBatchSize: (0, $df5a5f20911361eb$export$fba142522eb62862),
                    batchScheduleFn: scheduler.schedule
                });
                setState({
                    loader: loader,
                    scheduler: scheduler
                });
            }
    }
});
const $8a9b205a24007018$export$9e924386fdd64f6e = ({ children: children, scope: scope })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8a9b205a24007018$var$Container, {
        scope: scope,
        environment: environment
    }, children);
};
const $8a9b205a24007018$export$ceb1f4a193b695d1 = (0, $iJq0l.createActionsHook)($8a9b205a24007018$var$Store);
const $8a9b205a24007018$export$9b127efb5c6c57e8 = (id, isEditable)=>{
    const { load: load } = $8a9b205a24007018$export$ceb1f4a193b695d1();
    (0, $eJOHy.useEffect)(()=>{
        const executeLoad = async ()=>{
            // If there is no editability information for the issue field then queue a request to lazily fetch this data
            // We need to explicitly check the ID is an ARI to ignore fields for optimistically created issues, which
            // are initialised as a UUID.
            if (id != null && isEditable === undefined && (0, $3pSHx.JiraIssuefieldvalueAri).check(id)) load(id);
        };
        executeLoad();
    }, [
        isEditable,
        load,
        id
    ]);
};

});
parcelRegister("3pSHx", function(module, exports) {
$parcel$export(module.exports, "JiraIssuefieldvalueAri", () => $27ce236fe1a3184f$export$828c4931ae562af7);

var $caazz = parcelRequire("caazz");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/issuefieldvalue/manifest.ts
var $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $caazz.JiraIssuefieldvalueAriResourceOwner),
    resourceType: (0, $caazz.JiraIssuefieldvalueAriResourceType),
    resourceIdSlug: "{issueId}/{fieldId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[a-zA-Z0-9_\-]+/
    }
};
// src/jira/issuefieldvalue/index.ts
var $27ce236fe1a3184f$export$828c4931ae562af7 = class _JiraIssuefieldvalueAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId, this._fieldId = opts.resourceIdSegmentValues.fieldId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    get fieldId() {
        return this._fieldId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.qualifier,
            platformQualifier: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.resourceOwner,
            resourceType: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}/${opts.fieldId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId,
                fieldId: opts.fieldId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId,
            fieldId: this.fieldId
        };
    }
};

});
parcelRegister("caazz", function(module, exports) {
$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceOwner", () => $8dae9ec06e7b65f0$export$39e9358142fbbc64);
$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceType", () => $8dae9ec06e7b65f0$export$f9e57427271adc95);
// src/jira/issuefieldvalue/types.ts
var $8dae9ec06e7b65f0$export$39e9358142fbbc64 = "jira", $8dae9ec06e7b65f0$export$f9e57427271adc95 = "issuefieldvalue";

});


parcelRegister("lMr7M", function(module, exports) {
$parcel$export(module.exports, "createDataLoaderScheduler", () => $4339ad4fc34caffc$export$f3542fc7467ff455);

var $3s8bj = parcelRequire("3s8bj");
function $4339ad4fc34caffc$export$f3542fc7467ff455(delay) {
    let cb = [];
    return {
        schedule (callback) {
            cb.push(callback);
        },
        dispatch: (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            cb.forEach((callback)=>callback());
            cb = [];
        }, delay)
    };
}

});

parcelRegister("ehqRw", function(module, exports) {
$parcel$export(module.exports, "batchIsEditableInIssueViewFactory", () => $7517476ac4a04208$export$781008fa22e0792);
$parcel$export(module.exports, "actions", () => $7517476ac4a04208$export$e324594224ef24da);

var $2FNNm = parcelRequire("2FNNm");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $8jOO7 = parcelRequire("8jOO7");

const $7517476ac4a04208$export$781008fa22e0792 = (environment)=>async (fieldIds)=>{
        const isEditableMap = new Map();
        const promise = (0, $j4oe4.fetchQuery)(environment, (0, $2FNNm.default), {
            ids: fieldIds,
            first: (0, $df5a5f20911361eb$export$fba142522eb62862)
        }).toPromise();
        try {
            const data = await promise;
            (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
                data?.jira?.issueFieldsByIds?.edges?.map((edge)=>edge?.node).filter(Boolean).forEach(({ __id: __id, id: id, isEditableInIssueView: isEditableInIssueView })=>{
                    isEditableMap.set(id, isEditableInIssueView ?? null);
                    // Set whether issue fields are editable as a new client-only field on the matching node in the Relay
                    // store
                    store.get(__id)?.setValue(isEditableInIssueView ?? null, 'lazyIsEditableInIssueView');
                });
            });
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'lazyEditabilityLoader',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                },
                error: error instanceof Error ? error : undefined,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        // Ensure input argument order is preserved when returning batch results as required by the dataloader
        return fieldIds.map((id)=>isEditableMap.get(id) ?? null);
    };
const $7517476ac4a04208$export$e324594224ef24da = {
    load: (fieldId)=>({ getState: getState })=>{
            const { loader: loader, scheduler: scheduler } = getState();
            const loading = loader ? loader.load(fieldId) : Promise.resolve(null);
            scheduler?.dispatch();
            return loading;
        }
};

});
parcelRegister("2FNNm", function(module, exports) {
$parcel$export(module.exports, "default", () => $a746a1fc6c2914c4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ed8b5de75ebbeb144021c7c45b21dfd7>>
 * @relayHash f1b7f7b512da9e0aa08b55196721bc8a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1442e789c5171157bf882e3c96a4fe1dbfaf4171cde4fc7ff6761b6ca4e0d511
const $a746a1fc6c2914c4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ids"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "ids",
            "variableName": "ids"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isEditableInIssueView"
    }, v5 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "batchIsEditableInIssueViewFactoryQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "issueFieldsByIds",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "batchIsEditableInIssueViewFactoryQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "issueFieldsByIds",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1442e789c5171157bf882e3c96a4fe1dbfaf4171cde4fc7ff6761b6ca4e0d511",
            "metadata": {},
            "name": "batchIsEditableInIssueViewFactoryQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a746a1fc6c2914c4$var$node.hash = "c26db256f9ee6c88ad5dbf683c6b0507";
var $a746a1fc6c2914c4$export$2e2bcd8739ae039 = $a746a1fc6c2914c4$var$node;

});

const $df5a5f20911361eb$export$fba142522eb62862 = 499;



parcelRegister("jZFgr", function(module, exports) {
$parcel$export(module.exports, "LazyMediaViewContextLoaderContainer", () => $4b1ddbdb2bf7672f$export$c268c26f941d1a5);
$parcel$export(module.exports, "useLazyMediaViewContext", () => $4b1ddbdb2bf7672f$export$5475aeba7ee80aa1);

var $eJOHy = parcelRequire("eJOHy");

var $79KwK = parcelRequire("79KwK");

var $j4oe4 = parcelRequire("j4oe4");

var $d7xa7 = parcelRequire("d7xa7");

var $cHtIB = parcelRequire("cHtIB");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $lMr7M = parcelRequire("lMr7M");

var $aHvCt = parcelRequire("aHvCt");

var $93QIg = parcelRequire("93QIg");
const $4b1ddbdb2bf7672f$var$initialState = {
    loader: null,
    scheduler: null
};
const $4b1ddbdb2bf7672f$var$Container = (0, $6E16M.createContainer)();
const $4b1ddbdb2bf7672f$var$Store = (0, $GtRbT.createStore)({
    containedBy: $4b1ddbdb2bf7672f$var$Container,
    initialState: $4b1ddbdb2bf7672f$var$initialState,
    actions: $aHvCt.actions,
    handlers: {
        onInit: ()=>({ setState: setState }, { environment: environment, cloudId: cloudId })=>{
                const scheduler = (0, $lMr7M.createDataLoaderScheduler)(100);
                const loader = new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))((0, $aHvCt.batchMediaViewResponseFactory)(environment, cloudId), {
                    maxBatchSize: (0, $93QIg.MAX_BATCH_SIZE),
                    batchScheduleFn: scheduler.schedule
                });
                setState({
                    loader: loader,
                    scheduler: scheduler
                });
            }
    }
});
const $4b1ddbdb2bf7672f$export$c268c26f941d1a5 = ({ children: children, scope: scope })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $cHtIB.useCloudId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4b1ddbdb2bf7672f$var$Container, {
        scope: scope,
        environment: environment,
        cloudId: cloudId
    }, children);
};
const $4b1ddbdb2bf7672f$export$2ccec1e3fc6f5f = (0, $iJq0l.createActionsHook)($4b1ddbdb2bf7672f$var$Store);
const $4b1ddbdb2bf7672f$export$5475aeba7ee80aa1 = (issueKey)=>{
    const { load: load } = $4b1ddbdb2bf7672f$export$2ccec1e3fc6f5f();
    const [viewContext, setViewContext] = (0, $eJOHy.useState)();
    (0, $eJOHy.useEffect)(()=>{
        const executeLoad = async ()=>{
            // We only want to fetch when viewContext's value hasn't been initialised yet
            if (viewContext === undefined) {
                const viewResponse = await load(issueKey);
                if (viewResponse) setViewContext((0, $d7xa7.viewContextTransformer)(viewResponse));
                else setViewContext(null);
            }
        };
        executeLoad();
    }, [
        viewContext,
        load,
        issueKey
    ]);
    return viewContext ?? null;
};

});
parcelRegister("d7xa7", function(module, exports) {
$parcel$export(module.exports, "getTokenDeltaProps", () => $16b06cb22c076d80$export$4d271852dd07ca26);
$parcel$export(module.exports, "isTokenValid", () => $16b06cb22c076d80$export$d1a8c8b605234fe8);
$parcel$export(module.exports, "viewContextTransformer", () => $16b06cb22c076d80$export$5fb65caa7eb9e932);
// This has TS defs, so when we move to TS let's enable them again
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'jwt-decode'. '/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/node_modules/jwt-decode/lib/index.js' implicitly has an 'any' type.

var $lNv8v = parcelRequire("lNv8v");
const $16b06cb22c076d80$var$TOKEN_NETWORK_BUFFER = 10000;
const $16b06cb22c076d80$export$e9df841c4c486a60 = (startTimestamp)=>startTimestamp ? startTimestamp - Date.now() + 0 : undefined;
const $16b06cb22c076d80$export$4d271852dd07ca26 = (token)=>{
    let decodedToken;
    try {
        decodedToken = (0, (/*@__PURE__*/$parcel$interopDefault($lNv8v)))(token);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // why would this be the case
        return {
            tokenDecodeError: typeof error.message === 'string' ? error.message : undefined,
            localTimeDelta: undefined,
            tokenExpiryTime: undefined
        };
    }
    // In my testing, sometimes issued at was missing
    const startTimestamp = decodedToken.iat || decodedToken.nbf;
    return {
        tokenDecodeError: undefined,
        localTimeDelta: $16b06cb22c076d80$export$e9df841c4c486a60(startTimestamp * 1000),
        tokenExpiryTime: decodedToken.exp * 1000
    };
};
function $16b06cb22c076d80$export$d1a8c8b605234fe8({ token: token, tokenExpiryTime: tokenExpiryTime, localTimeDelta: localTimeDelta }) {
    if (typeof token !== 'string' || token.length === 0) return false;
    if (typeof tokenExpiryTime !== 'number' || typeof localTimeDelta !== 'number') return false;
    const actualExpiryTime = tokenExpiryTime + localTimeDelta - $16b06cb22c076d80$var$TOKEN_NETWORK_BUFFER;
    const timeUntilExpiry = actualExpiryTime - Date.now();
    const isValid = timeUntilExpiry >= 0;
    return isValid;
}
const $16b06cb22c076d80$export$5fb65caa7eb9e932 = (viewResponse)=>{
    const token = viewResponse.tokensWithFiles[0]?.token || null;
    const tokenProps = typeof token === 'string' ? $16b06cb22c076d80$export$4d271852dd07ca26(token) : {};
    const issueId = viewResponse.tokensWithFiles[0]?.files?.[0]?.issueId;
    return {
        clientId: viewResponse.clientId,
        serviceHost: viewResponse.endpointUrl,
        token: token,
        areTokenPermissionsUpToDate: true,
        tokenLifespanInMs: viewResponse.tokenLifespanInSeconds * 1000,
        collection: viewResponse.collection !== undefined && viewResponse.collection !== '' ? viewResponse.collection : null,
        tokenIssueTimestamp: Date.now() - $16b06cb22c076d80$var$TOKEN_NETWORK_BUFFER,
        tokenDecodeError: tokenProps.tokenDecodeError,
        localTimeDelta: tokenProps.localTimeDelta,
        tokenExpiryTime: tokenProps.tokenExpiryTime,
        issueId: issueId === undefined ? undefined : String(issueId)
    };
};

});
parcelRegister("lNv8v", function(module, exports) {
'use strict';

var $6bURt = parcelRequire("6bURt");
function $fde6539338bf9ae7$var$InvalidTokenError(message) {
    this.message = message;
}
$fde6539338bf9ae7$var$InvalidTokenError.prototype = new Error();
$fde6539338bf9ae7$var$InvalidTokenError.prototype.name = 'InvalidTokenError';
module.exports = function(token, options) {
    if (typeof token !== 'string') throw new $fde6539338bf9ae7$var$InvalidTokenError('Invalid token specified');
    options = options || {};
    var pos = options.header === true ? 0 : 1;
    try {
        return JSON.parse($6bURt(token.split('.')[pos]));
    } catch (e) {
        throw new $fde6539338bf9ae7$var$InvalidTokenError('Invalid token specified: ' + e.message);
    }
};
module.exports.InvalidTokenError = $fde6539338bf9ae7$var$InvalidTokenError;

});
parcelRegister("6bURt", function(module, exports) {

var $1UChD = parcelRequire("1UChD");
function $481fe0ae33ee61a4$var$b64DecodeUnicode(str) {
    return decodeURIComponent($1UChD(str).replace(/(.)/g, function(m, p) {
        var code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = '0' + code;
        return '%' + code;
    }));
}
module.exports = function(str) {
    var output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return $481fe0ae33ee61a4$var$b64DecodeUnicode(output);
    } catch (err) {
        return $1UChD(output);
    }
};

});
parcelRegister("1UChD", function(module, exports) {
/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */ var $1648b7b5b93c4620$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
function $1648b7b5b93c4620$var$InvalidCharacterError(message) {
    this.message = message;
}
$1648b7b5b93c4620$var$InvalidCharacterError.prototype = new Error();
$1648b7b5b93c4620$var$InvalidCharacterError.prototype.name = 'InvalidCharacterError';
function $1648b7b5b93c4620$var$polyfill(input) {
    var str = String(input).replace(/=+$/, '');
    if (str.length % 4 == 1) throw new $1648b7b5b93c4620$var$InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
    for(// initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = ''; // get next character
    buffer = str.charAt(idx++); // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, // and if not first of each 4 characters,
    // convert the first 8 bits to one ascii character
    bc++ % 4) && (output += String.fromCharCode(255 & bs >> (-2 * bc & 6))))// try to find character in table (0-63, not found => -1)
    buffer = $1648b7b5b93c4620$var$chars.indexOf(buffer);
    return output;
}
module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || $1648b7b5b93c4620$var$polyfill;

});




parcelRegister("aHvCt", function(module, exports) {
$parcel$export(module.exports, "batchMediaViewResponseFactory", () => $f1d81eb8a0075a3d$export$eedff7e9aaf52da1);
$parcel$export(module.exports, "actions", () => $f1d81eb8a0075a3d$export$e324594224ef24da);

var $kIOD7 = parcelRequire("kIOD7");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $8jOO7 = parcelRequire("8jOO7");

var $93QIg = parcelRequire("93QIg");
const $f1d81eb8a0075a3d$export$eedff7e9aaf52da1 = (environment, cloudId)=>async (issueKeys)=>{
        const issueKeysMap = new Map();
        const uniqueIssueKeys = [
            ...new Set(issueKeys)
        ];
        const promise = (0, $j4oe4.fetchQuery)(environment, (0, $kIOD7.default), {
            issueKeys: uniqueIssueKeys,
            cloudId: cloudId,
            maxTokenLength: (0, $93QIg.MAX_TOKEN_LENGTH)
        }).toPromise();
        try {
            const result = await promise;
            const issues = result?.jira?.issuesByKey;
            issues?.forEach((issue)=>{
                if (issue?.mediaReadToken) {
                    const { clientId: clientId, endpointUrl: endpointUrl, tokenLifespanInSeconds: tokenLifespanInSeconds, tokensWithFiles: tokensWithFiles } = issue?.mediaReadToken;
                    const tokensWithFilesFlattened = tokensWithFiles?.edges?.map((edge)=>edge?.node?.token ? {
                            token: edge.node.token
                        } : null).filter(Boolean);
                    if (clientId && endpointUrl && tokenLifespanInSeconds && tokensWithFilesFlattened) {
                        const viewResponse = {
                            clientId: clientId,
                            endpointUrl: endpointUrl,
                            tokenLifespanInSeconds: tokenLifespanInSeconds,
                            tokensWithFiles: tokensWithFilesFlattened
                        };
                        issueKeysMap.set(issue.key, viewResponse);
                    }
                }
            });
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'lazyMediaViewResponseFactory',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                },
                error: error instanceof Error ? error : undefined,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        // Ensure input argument order is preserved when returning batch results as required by the dataloader
        return issueKeys.map((issueKey)=>issueKeysMap.get(issueKey) ?? null);
    };
const $f1d81eb8a0075a3d$export$e324594224ef24da = {
    load: (issueKey)=>({ getState: getState })=>{
            const { loader: loader, scheduler: scheduler } = getState();
            const loading = loader ? loader.load(issueKey) : Promise.resolve(null);
            scheduler?.dispatch();
            return loading;
        }
};

});
parcelRegister("kIOD7", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d538983f9d142c7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<038490e885f5ed59aebe309ed3d06370>>
 * @relayHash 88dc3fe18d2828d729fb2bf7929e7076
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 878b3b6282e98d324c50ccd49dbaf8a07c889063b5efed0881fe239f64e5160d
const $2d538983f9d142c7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKeys"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "maxTokenLength"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "keys",
            "variableName": "issueKeys"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "maxTokenLength",
                "variableName": "maxTokenLength"
            }
        ],
        "concreteType": "JiraMediaReadToken",
        "kind": "LinkedField",
        "name": "mediaReadToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "clientId"
            },
            {
                "kind": "ScalarField",
                "name": "endpointUrl"
            },
            {
                "kind": "ScalarField",
                "name": "tokenLifespanInSeconds"
            },
            {
                "concreteType": "JiraMediaTokenWithFilesConnection",
                "kind": "LinkedField",
                "name": "tokensWithFiles",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraMediaTokenWithFilesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraMediaTokenWithFiles",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "actions_LazyLoadMediaReadTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issuesByKey",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "actions_LazyLoadMediaReadTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issuesByKey",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "878b3b6282e98d324c50ccd49dbaf8a07c889063b5efed0881fe239f64e5160d",
            "metadata": {},
            "name": "actions_LazyLoadMediaReadTokenQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2d538983f9d142c7$var$node.hash = "a1b3499bc5d237db13d819b5abf7ce41";
var $2d538983f9d142c7$export$2e2bcd8739ae039 = $2d538983f9d142c7$var$node;

});

parcelRegister("93QIg", function(module, exports) {
$parcel$export(module.exports, "MAX_BATCH_SIZE", () => $161cf6e30dc5abb0$export$b79d95ee17a87a);
$parcel$export(module.exports, "MAX_TOKEN_LENGTH", () => $161cf6e30dc5abb0$export$525f5433a110000f);

var $cGVqS = parcelRequire("cGVqS");
const $161cf6e30dc5abb0$export$b79d95ee17a87a = 100;
const $161cf6e30dc5abb0$export$525f5433a110000f = (0, $cGVqS.getMaxTokenLength)();

});
parcelRegister("cGVqS", function(module, exports) {
$parcel$export(module.exports, "getMaxTokenLength", () => $fda68ad41e642ef5$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $fda68ad41e642ef5$var$nonIE11MaxTokenLength = 2 ** 16;
const $fda68ad41e642ef5$export$e40f2acaf1a50b00 = ()=>$fda68ad41e642ef5$var$nonIE11MaxTokenLength;

});




parcelRegister("kfIml", function(module, exports) {
$parcel$export(module.exports, "DraggableRowsContainer", () => $5287baf143ef1bf7$export$d659f1efda86963d);
$parcel$export(module.exports, "Store", () => $5287baf143ef1bf7$export$390f32400eaf98c9);
$parcel$export(module.exports, "useDraggableRowsConnectionId", () => $5287baf143ef1bf7$export$ab74a8a2556419cd);

var $cSmYj = parcelRequire("cSmYj");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4cTDP = parcelRequire("4cTDP");
const $5287baf143ef1bf7$export$d4c72bab9d6cc13a = {
    currentDropTarget: null,
    instanceId: 'pdnd-issue-table-rows',
    issueConnectionId: '',
    items: new Map(),
    // TODO: Remove on jsc-2065-unify-onrowreorder cleanup
    /** @deprecated Use `useIssuesRanker` directly */ onRowReorder: undefined
};
const $5287baf143ef1bf7$var$actions = {
    setDropTarget: (dropTarget)=>({ setState: setState, getState: getState })=>{
            const currentDropTarget = getState().currentDropTarget;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(currentDropTarget, dropTarget)) setState({
                currentDropTarget: dropTarget
            });
        },
    /** @deprecated Use `useIssuesRanker` directly */ reorderRows: (sourceIndex, destinationIndex)=>({ getState: getState })=>{
            if ((0, $4cTDP.fg)('jsc-2065-unify-onrowreorder')) return;
            const { items: items, onRowReorder: onRowReorder } = getState();
            onRowReorder?.({
                source: {
                    issueIds: [
                        items.get(sourceIndex) ?? ''
                    ],
                    rowIndex: sourceIndex
                },
                destination: {
                    relativeToIssueId: items.get(destinationIndex) ?? '',
                    rowIndex: destinationIndex
                },
                edge: sourceIndex > destinationIndex ? 'top' : 'bottom'
            });
        },
    registerItem: (edgeIndex, issueId)=>({ getState: getState, setState: setState })=>{
            const { items: items } = getState();
            setState({
                items: items.set(edgeIndex, issueId)
            });
        },
    unregisterItem: (edgeIndex)=>({ getState: getState, setState: setState })=>{
            const { items: items } = getState();
            if (items.delete(edgeIndex)) setState({
                items: items
            });
        }
};
const $5287baf143ef1bf7$export$d659f1efda86963d = (0, $6E16M.createContainer)({
    getIsConcurrentSafe: ()=>true
});
const $5287baf143ef1bf7$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    initialState: $5287baf143ef1bf7$export$d4c72bab9d6cc13a,
    actions: $5287baf143ef1bf7$var$actions,
    containedBy: $5287baf143ef1bf7$export$d659f1efda86963d,
    handlers: {
        onInit: ()=>({ setState: setState }, { instanceId: instanceId, onRowReorder: onRowReorder, issueConnectionId: issueConnectionId })=>{
                if ((0, $4cTDP.fg)('jsc-2065-unify-onrowreorder')) setState({
                    instanceId: instanceId ?? $5287baf143ef1bf7$export$d4c72bab9d6cc13a.instanceId,
                    issueConnectionId: issueConnectionId
                });
                else setState({
                    instanceId: instanceId ?? $5287baf143ef1bf7$export$d4c72bab9d6cc13a.instanceId,
                    onRowReorder: onRowReorder,
                    issueConnectionId: issueConnectionId
                });
            },
        onContainerUpdate: (props, prevProps)=>({ setState: setState }, { instanceId: instanceId, onRowReorder: onRowReorder, issueConnectionId: issueConnectionId })=>{
                if (props.instanceId !== prevProps.instanceId || props.onRowReorder !== prevProps.onRowReorder || // TODO: Remove on jsc-2065-unify-onrowreorder cleanup
                props.issueConnectionId !== prevProps.issueConnectionId) setState({
                    instanceId: instanceId,
                    onRowReorder: onRowReorder,
                    issueConnectionId: issueConnectionId
                });
            }
    }
});
const $5287baf143ef1bf7$export$ab74a8a2556419cd = (0, $iJq0l.createHook)($5287baf143ef1bf7$export$390f32400eaf98c9, {
    selector: ({ issueConnectionId: issueConnectionId })=>issueConnectionId
});

});

parcelRegister("7XD6x", function(module, exports) {
$parcel$export(module.exports, "IFCFooter", () => $8b646a3a3d5430a0$export$7b0e717a6d1208a9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hx3Sa = parcelRequire("hx3Sa");

var $8nu6j = parcelRequire("8nu6j");

var $2sLVw = parcelRequire("2sLVw");
var $6djmC = parcelRequire("6djmC");
var $3cMgR = parcelRequire("3cMgR");

var $5CSKW = parcelRequire("5CSKW");

var $dcLzM = parcelRequire("dcLzM");

var $2R0ne = parcelRequire("2R0ne");

var $lL4G9 = parcelRequire("lL4G9");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $kAwwe = parcelRequire("kAwwe");

var $2aY2d = parcelRequire("2aY2d");

var $fpyg5 = parcelRequire("fpyg5");

var $cxKOj = parcelRequire("cxKOj");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6KVf0 = parcelRequire("6KVf0");


var $pZqvR = parcelRequire("pZqvR");

var $cEWre = parcelRequire("cEWre");

var $kompv = parcelRequire("kompv");

var $7lNJU = parcelRequire("7lNJU");
const $8b646a3a3d5430a0$var$useIsProjectAdmin = ()=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    return !!data?.isProjectAdmin;
};
const $8b646a3a3d5430a0$var$styles = {
    ifcFooter: "_1h6d1l7x _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1e0c1txw _2lx2vrvc _15a5nqa1 _uwhke4h9 _1bah1h6o",
    footerContainer: "_1h6d1l7x _15a5nqa1 _uwhke4h9 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
    anchor: "_4bfu18uv _1hmsglyw _ajmmnqa1"
};
const $8b646a3a3d5430a0$export$7b0e717a6d1208a9 = ({ onPickerClose: onPickerClose, columnsDataId: columnsDataId, columnInsertIndex: columnInsertIndex, rightSideComponent: rightSideComponent })=>{
    const contactAdminGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $kompv.default).contactAdminGalaxia : (0, $kompv.default).contactAdmin;
    const { ifcConfig: ifcConfig, addFieldToColumns: addFieldToColumns } = (0, $pZqvR.useIFCConfigContext)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isSiteAdmin = (0, $kAwwe.useIsAdmin)();
    const isProjectAdmin = $8b646a3a3d5430a0$var$useIsProjectAdmin();
    const isTMP = (0, $2aY2d.useIsSimplifiedProject)();
    const isAdmin = isSiteAdmin || isProjectAdmin;
    const isCMPAdmin = isAdmin && !isTMP;
    const isTMPAdmin = isAdmin && isTMP;
    const { clearIndex: clearIndex } = (0, $6KVf0.useInlineCreateActiveIndexActions)();
    const environment = (0, $hx3Sa.useRelayEnvironment)();
    const editField = (0, $cEWre.useIFCEditField)();
    const onStartFieldCreate = (0, $eJOHy.useCallback)(({ name: name, type: type })=>{
        const field = {
            fieldSetId: (0, $7lNJU.TEMP_CREATE_FIELDSET_ID),
            name: name,
            type: type
        };
        (0, $fpyg5.createOptimisticFieldConfig)({
            environment: environment,
            fieldConfigId: columnsDataId,
            fields: [
                field
            ],
            createIndex: columnInsertIndex
        });
    }, [
        columnInsertIndex,
        columnsDataId,
        environment
    ]);
    const onFieldCreated = (0, $eJOHy.useCallback)((fieldId, fieldSetId)=>{
        if (fieldSetId) {
            (0, $7lNJU.updateTempOptimisticFieldSetId)({
                environment: environment,
                fieldConfigId: columnsDataId,
                fieldSetId: fieldSetId
            });
            addFieldToColumns?.(fieldSetId, columnInsertIndex, ()=>{
                (0, $fpyg5.deleteOptimisticFieldConfig)({
                    environment: environment,
                    fieldConfigId: columnsDataId,
                    fields: [
                        {
                            fieldSetId: fieldSetId,
                            name: ''
                        }
                    ]
                });
            });
            editField(fieldId, fieldSetId);
        }
    }, [
        environment,
        columnsDataId,
        addFieldToColumns,
        columnInsertIndex,
        editField
    ]);
    const onFieldCreateError = (0, $eJOHy.useCallback)(()=>{
        (0, $fpyg5.deleteOptimisticFieldConfig)({
            environment: environment,
            fieldConfigId: columnsDataId,
            fields: [
                {
                    fieldSetId: (0, $7lNJU.TEMP_CREATE_FIELDSET_ID),
                    name: ''
                }
            ]
        });
    }, [
        columnsDataId,
        environment
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const clickHandler = (0, $eJOHy.useCallback)((event)=>{
        onPickerClose?.(event);
        clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
        ifcConfig?.onCreate({
            onFieldCreated: onFieldCreated,
            onStartFieldCreate: onStartFieldCreate,
            onFieldCreateError: onFieldCreateError
        });
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'createFieldIFCFooterButton');
    }, [
        onPickerClose,
        clearIndex,
        ifcConfig,
        onFieldCreated,
        onStartFieldCreate,
        onFieldCreateError,
        createAnalyticsEvent
    ]);
    if (!isAdmin) {
        if ((0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates')) {
            if (rightSideComponent == null) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $8b646a3a3d5430a0$var$styles.footerContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
                justifyContent: "end"
            }, rightSideComponent));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $8b646a3a3d5430a0$var$styles.ifcFooter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
            space: "space.100",
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
            label: "",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage(contactAdminGalaxia, {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
                    href: "/secure/ContactAdministrators!default.jspa",
                    target: "_blank",
                    onClick: ()=>{
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                            action: 'clicked',
                            actionSubject: 'link'
                        }), 'endUserIFCFooterLink');
                    }
                }, chunks)
        }))));
    }
    if (isTMPAdmin && ifcConfig && ((0, $4cTDP.fg)('jsc_list_category_editing_in_nin') ? ifcConfig.isEnabledForProject : ifcConfig.IFCTriggerRef)) {
        if ((0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $8b646a3a3d5430a0$var$styles.footerContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
            grow: "fill",
            spread: "space-between",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ifcConfig.IFCTriggerRef, null, ({ triggerRef: triggerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                ref: triggerRef,
                onClick: clickHandler,
                spacing: "compact",
                appearance: "subtle",
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($dcLzM)))
            }, formatMessage((0, $kompv.default).createAnotherButton))), rightSideComponent));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $8b646a3a3d5430a0$var$styles.ifcFooter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ifcConfig.IFCTriggerRef, null, ({ triggerRef: triggerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                ref: triggerRef,
                onClick: clickHandler,
                shouldFitContainer: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
                space: "space.100",
                alignBlock: "center",
                alignInline: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                label: ""
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $kompv.default).createAnotherButton))))));
    }
    if (isCMPAdmin) {
        if ((0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $8b646a3a3d5430a0$var$styles.footerContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
            grow: "fill",
            spread: "space-between",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
            xcss: $8b646a3a3d5430a0$var$styles.anchor,
            href: (0, $cxKOj.expVal)('jira-admin-pages-centralised-fields-m1-experiment', 'isEnabled', false) ? '/jira/settings/issues/fields' : '/secure/admin/ViewCustomFields.jspa',
            target: "_blank",
            onClick: ()=>{
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link'
                }), 'cmpAdminIFCFooterLink');
            }
        }, formatMessage((0, $kompv.default).createAFieldInConfig)), rightSideComponent));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $8b646a3a3d5430a0$var$styles.ifcFooter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
            space: "space.100",
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
            label: "",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $kompv.default).makeChangesInConfig, {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
                    href: (0, $cxKOj.expVal)('jira-admin-pages-centralised-fields-m1-experiment', 'isEnabled', false) ? '/jira/settings/issues/fields' : '/secure/admin/ViewCustomFields.jspa',
                    target: "_blank",
                    onClick: ()=>{
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                            action: 'clicked',
                            actionSubject: 'link'
                        }), 'cmpAdminIFCFooterLink');
                    }
                }, chunks)
        }))));
    }
};

});
const $7423e9894c2b8b23$export$76a449e52fa0e1e8 = 'issue';
const $7423e9894c2b8b23$export$d6f887e0c1be1b74 = 'field';

parcelRegister("pZqvR", function(module, exports) {
$parcel$export(module.exports, "useIFCConfigContext", () => $48ca4011692a630d$export$e3a7198c51d237d7);
$parcel$export(module.exports, "IFCConfigContextProviderComponent", () => $48ca4011692a630d$export$8df178a0d1abc310);

var $7yX18 = parcelRequire("7yX18");

var $cFUSG = parcelRequire("cFUSG");

var $eJOHy = parcelRequire("eJOHy");

var $hx3Sa = parcelRequire("hx3Sa");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $j8Km1 = parcelRequire("j8Km1");

var $fpyg5 = parcelRequire("fpyg5");

var $dLXgn = parcelRequire("dLXgn");

var $d8Dow = parcelRequire("d8Dow");

var $8jOO7 = parcelRequire("8jOO7");

var $7lNJU = parcelRequire("7lNJU");

var $1zGNP = parcelRequire("1zGNP");
const $48ca4011692a630d$export$be578a14685d978b = /*#__PURE__*/ (0, $eJOHy.createContext)({
    ifcConfig: undefined
});
const $48ca4011692a630d$export$16276ffbd566ecbc = ({ children: children, ifcConfig: ifcConfig, columns: columns, onColumnsChange: onColumnsChange, queryRef: queryRef, columnsQueryRef: columnsQueryRef })=>{
    const columnRef = (0, $eJOHy.useRef)(columns);
    const currentIssuesRef = (0, $eJOHy.useRef)(null);
    const processedIssuesRef = (0, $eJOHy.useRef)({
        issuesRef: null,
        fieldId: null
    });
    const selectedOptions = (0, $eJOHy.useRef)(undefined);
    if (columnRef.current !== columns) columnRef.current = columns;
    const environment = (0, $hx3Sa.useRelayEnvironment)();
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const currentConnections = (0, $eJOHy.useRef)();
    const currentGroupsIssuesRef = (0, $eJOHy.useRef)([]);
    if (currentConnections.current !== connections) {
        currentGroupsIssuesRef.current = Object.values(connections).filter((connection)=>connection.type === 'GROUP_CHILDREN' || connection.type === 'PARENT_CHILDREN').map((connection)=>connection.type === 'GROUP_CHILDREN' || connection.type === 'PARENT_CHILDREN' ? connection.fieldSetsData : undefined);
        currentConnections.current = connections;
    }
    const issuesQueryRef = (0, $hx3Sa.useFragment)((0, $cFUSG.default), queryRef);
    const fieldConfig = (0, $hx3Sa.useFragment)((0, $7yX18.default), columnsQueryRef);
    if (currentIssuesRef.current !== issuesQueryRef) currentIssuesRef.current = issuesQueryRef ?? null;
    const optimisticDeleteField = (0, $eJOHy.useCallback)((fieldSetId)=>{
        (0, $fpyg5.deleteOptimisticFieldConfig)({
            environment: environment,
            fieldConfigId: fieldConfig?.__id,
            fields: [
                {
                    fieldSetId: fieldSetId,
                    name: ''
                }
            ]
        });
    }, [
        environment,
        fieldConfig?.__id
    ]);
    const getColumnIds = (0, $eJOHy.useCallback)(()=>{
        const columnIds = columnRef.current?.map(({ id: id })=>id)?.filter((id)=>!id.startsWith((0, $8jOO7.COLUMN_ID_INTERNAL_COLUMN)) && id !== (0, $7lNJU.TEMP_CREATE_FIELDSET_ID));
        const mergedColumnsIds = (0, $4cTDP.fg)('jira_list_merged_column_gate') ? (columnRef.current.find((col)=>col?.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN))?.mergedColumns ?? []).map((col)=>col.id) : [];
        return [
            ...mergedColumnsIds,
            ...columnIds
        ];
    }, []);
    const replaceFieldSetInColumns = (0, $eJOHy.useCallback)((fieldSetId, newfieldSetId, fieldId)=>{
        const columnIds = getColumnIds();
        let skipRefetch = true;
        // find out if a column of the same fieldsetid exists
        // if yes, the column will get merged when we refetch so we also don't skip refetch
        const duplicateFieldSetIndex = columnIds.findIndex((id)=>id === newfieldSetId);
        if (duplicateFieldSetIndex > -1) {
            optimisticDeleteField(newfieldSetId);
            skipRefetch = false;
            columnIds.splice(duplicateFieldSetIndex, 1);
        }
        (0, $7lNJU.optimisticUpdateColumnConfigFieldSetIdById)({
            environment: environment,
            fieldConfigId: fieldConfig?.__id,
            field: {
                fieldId: fieldId,
                fieldSetId: newfieldSetId
            }
        });
        (0, $1zGNP.optimisticUpdateIssuesFieldSetId)(environment, currentIssuesRef.current, fieldId, newfieldSetId);
        // for groups
        currentGroupsIssuesRef.current.forEach((groupIssuesRef)=>{
            if (groupIssuesRef != null) (0, $1zGNP.optimisticUpdateIssuesFieldSetId)(environment, groupIssuesRef, fieldId, newfieldSetId);
        });
        const insertIndex = columnIds.findIndex((id)=>id === fieldSetId);
        if (insertIndex > -1) {
            columnIds[insertIndex] = newfieldSetId;
            onColumnsChange?.({
                columnIds: columnIds,
                retries: 3,
                onErrorCallback: ()=>{
                    optimisticDeleteField(newfieldSetId);
                },
                isHorizontalAutoScrollNeeded: false,
                skipRefetch: skipRefetch,
                analyticsAttributes: {
                    fromIFCFieldUpdated: true,
                    changeType: (0, $d8Dow.ADD_COLUMNS)
                }
            });
        }
    }, [
        environment,
        fieldConfig?.__id,
        getColumnIds,
        onColumnsChange,
        optimisticDeleteField
    ]);
    const addFieldToColumns = (0, $eJOHy.useCallback)((fieldSetId, index, onErrorCallback)=>{
        const columnIds = getColumnIds();
        const insertIndex = index == null ? columnIds.length : index;
        columnIds.splice(insertIndex, 0, fieldSetId);
        onColumnsChange?.({
            columnIds: columnIds,
            retries: 3,
            onErrorCallback: onErrorCallback,
            isHorizontalAutoScrollNeeded: index === undefined,
            analyticsAttributes: {
                fromIFCFieldCreated: true,
                changeType: (0, $d8Dow.ADD_COLUMNS)
            }
        });
    }, [
        getColumnIds,
        onColumnsChange
    ]);
    const updateSelectedOptions = (0, $eJOHy.useCallback)((fieldId, type, options)=>{
        if (type !== (0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT && type !== (0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT) return;
        if (processedIssuesRef.current.issuesRef !== currentIssuesRef.current || processedIssuesRef.current.fieldId !== fieldId) {
            selectedOptions.current = (0, $1zGNP.getSelectedOptions)(currentIssuesRef.current, fieldId, type);
            processedIssuesRef.current.issuesRef = currentIssuesRef.current;
            processedIssuesRef.current.fieldId = fieldId;
        }
        // for groups
        currentGroupsIssuesRef.current.forEach((groupIssuesRef)=>{
            if (groupIssuesRef != null) selectedOptions.current = {
                ...selectedOptions.current,
                ...(0, $1zGNP.getSelectedOptions)(groupIssuesRef, fieldId, type)
            };
        });
        if (selectedOptions.current) return (0, $1zGNP.optimisticUpdatesSelectedOptions)(environment, type, selectedOptions.current, options);
    }, [
        environment
    ]);
    const optimisticUpdateField = (0, $eJOHy.useCallback)((fieldId, field)=>{
        if (fieldConfig?.__id) {
            const prevName = (0, $7lNJU.updateOptimisticFieldName)({
                environment: environment,
                fieldConfigId: fieldConfig?.__id,
                field: {
                    fieldId: fieldId,
                    name: field.name
                }
            });
            let prevOptions;
            if (field.options) prevOptions = updateSelectedOptions?.(fieldId, field.type, field.options);
            if (prevName) return {
                id: fieldId,
                field: {
                    name: prevName,
                    type: field.type,
                    options: prevOptions
                }
            };
        }
    }, [
        environment,
        fieldConfig?.__id,
        updateSelectedOptions
    ]);
    const value = (0, $eJOHy.useMemo)(()=>({
            ifcConfig: ifcConfig,
            addFieldToColumns: addFieldToColumns,
            updateSelectedOptions: updateSelectedOptions,
            replaceFieldSetInColumns: replaceFieldSetInColumns,
            optimisticUpdateField: optimisticUpdateField,
            optimisticDeleteField: optimisticDeleteField
        }), [
        ifcConfig,
        addFieldToColumns,
        updateSelectedOptions,
        replaceFieldSetInColumns,
        optimisticUpdateField,
        optimisticDeleteField
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($48ca4011692a630d$export$be578a14685d978b.Provider, {
        value: value
    }, children);
};
const $48ca4011692a630d$export$e3a7198c51d237d7 = ()=>{
    return (0, $eJOHy.useContext)($48ca4011692a630d$export$be578a14685d978b);
};
const $48ca4011692a630d$export$8df178a0d1abc310 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jira_inline_field_config_gate'), $48ca4011692a630d$export$16276ffbd566ecbc, ({ children: children })=>children);

});
parcelRegister("7yX18", function(module, exports) {
$parcel$export(module.exports, "default", () => $c74b6714c0523eb3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab771d6d7f14313f1bf27206756b3ede>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c74b6714c0523eb3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "context_nativeIssueTable_IFCConfigContextProvider_columnsQueryRef",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueSearchFieldSetConnection"
};
$c74b6714c0523eb3$var$node.hash = "da9cc8f15ae8ed9e7e4b651383cc3495";
var $c74b6714c0523eb3$export$2e2bcd8739ae039 = $c74b6714c0523eb3$var$node;

});

parcelRegister("cFUSG", function(module, exports) {
$parcel$export(module.exports, "default", () => $23d2ce58a05b4a67$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<18f187046e493bc63d953540bf4d6b3d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $23d2ce58a05b4a67$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "type"
    }, v1 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "context_nativeIssueTable_IFCConfigContextProvider_queryRef",
        "selections": [
            {
                "kind": "InlineDataFragmentSpread",
                "name": "getSelectedOptions",
                "selections": [
                    {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 500
                                    }
                                ],
                                "concreteType": "JiraIssueFieldSetConnection",
                                "kind": "LinkedField",
                                "name": "fieldSets",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldSetEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldSet",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraIssueFieldConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fields",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueFieldEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "__typename"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "fieldId"
                                                                            },
                                                                            v0 /*: any*/ ,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraOptionConnection",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "selectedOptions",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraOptionEdge",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "edges",
                                                                                                "plural": true,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraOption",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "node",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "id"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "value"
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    v1 /*: any*/ 
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "type": "JiraCheckboxesField"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraOption",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "fieldOption",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "optionId"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "type": "JiraSingleSelectField"
                                                                            },
                                                                            v1 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v1 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldSets(first:500)"
                            }
                        ]
                    }
                ],
                "argumentDefinitions": []
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$23d2ce58a05b4a67$var$node.hash = "0831223130cceb4db1fa0dc5958c658a";
var $23d2ce58a05b4a67$export$2e2bcd8739ae039 = $23d2ce58a05b4a67$var$node;

});

parcelRegister("7lNJU", function(module, exports) {
$parcel$export(module.exports, "TEMP_CREATE_FIELDSET_ID", () => $108bec5f55b27c19$export$6ec0f6605f2c959e);
$parcel$export(module.exports, "updateTempOptimisticFieldSetId", () => $108bec5f55b27c19$export$983fb13ccb9ab7e0);
$parcel$export(module.exports, "updateOptimisticFieldName", () => $108bec5f55b27c19$export$1ba75d43b01f9290);
$parcel$export(module.exports, "optimisticUpdateColumnConfigFieldSetIdById", () => $108bec5f55b27c19$export$28a743eeaeb242db);

var $hx3Sa = parcelRequire("hx3Sa");
const $108bec5f55b27c19$export$6ec0f6605f2c959e = 'temp_new_fieldset_id';
const $108bec5f55b27c19$export$983fb13ccb9ab7e0 = ({ environment: environment, fieldConfigId: fieldConfigId, fieldSetId: fieldSetId })=>{
    (0, $hx3Sa.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fields = store.get(fieldConfigId)?.getLinkedRecords('edges');
            const currentField = fields?.find((edge)=>edge.getLinkedRecord('node')?.getValue('fieldSetId') === $108bec5f55b27c19$export$6ec0f6605f2c959e);
            if (currentField) currentField.getLinkedRecord('node')?.setValue(fieldSetId, 'fieldSetId');
        }
    });
};
const $108bec5f55b27c19$export$1ba75d43b01f9290 = ({ environment: environment, fieldConfigId: fieldConfigId, field: { fieldId: fieldId, name: name } })=>{
    let previousName;
    (0, $hx3Sa.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fields = store.get(fieldConfigId)?.getLinkedRecords('edges');
            const currentField = fields?.find((edge)=>{
                const metadata = edge.getLinkedRecord('node')?.getLinkedRecord('fieldsMetadata');
                const fsFields = metadata?.getLinkedRecords('edges');
                const fsField = fsFields?.find((fedge)=>fedge?.getLinkedRecord('node')?.getValue('fieldId') === fieldId);
                return !!fsField;
            });
            if (currentField) {
                previousName = currentField.getLinkedRecord('node')?.getValue('displayName');
                currentField.getLinkedRecord('node')?.setValue(name, 'displayName');
            }
        }
    });
    return previousName;
};
const $108bec5f55b27c19$export$28a743eeaeb242db = ({ environment: environment, fieldConfigId: fieldConfigId, field: { fieldId: fieldId, fieldSetId: fieldSetId } })=>{
    (0, $hx3Sa.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fields = store.get(fieldConfigId)?.getLinkedRecords('edges');
            const currentField = fields?.find((edge)=>{
                const metadata = edge.getLinkedRecord('node')?.getLinkedRecord('fieldsMetadata');
                const fsFields = metadata?.getLinkedRecords('edges');
                const fsField = fsFields?.find((fedge)=>fedge?.getLinkedRecord('node')?.getValue('fieldId') === fieldId);
                return !!fsField;
            });
            if (currentField) currentField.getLinkedRecord('node')?.setValue(fieldSetId, 'fieldSetId');
        }
    });
};

});

parcelRegister("1zGNP", function(module, exports) {
$parcel$export(module.exports, "getSelectedOptions", () => $349a280504733ccd$export$dd5cf00ceb58ef45);
$parcel$export(module.exports, "optimisticUpdatesSelectedOptions", () => $349a280504733ccd$export$b96cfa9b16d1cfb3);
$parcel$export(module.exports, "optimisticUpdateIssuesFieldSetId", () => $349a280504733ccd$export$6b82cef47b481f3a);

var $ar3QR = parcelRequire("ar3QR");

var $j4oe4 = parcelRequire("j4oe4");

var $hx3Sa = parcelRequire("hx3Sa");

var $wufAv = parcelRequire("wufAv");

var $j8Km1 = parcelRequire("j8Km1");
const $349a280504733ccd$var$readIssuesData = (queryRef)=>{
    return (0, $j4oe4.readInlineData)((0, $ar3QR.default), queryRef);
};
const $349a280504733ccd$export$dd5cf00ceb58ef45 = (queryRef, fieldId, type)=>{
    if (!queryRef) return;
    const selectedOptions = $349a280504733ccd$var$readIssuesData(queryRef);
    const selectedOptionMap = {};
    switch(type){
        case (0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT:
            selectedOptions?.edges?.forEach((issue)=>{
                const fieldsets = issue?.fieldSets?.edges?.filter((fieldSet)=>fieldSet?.node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT);
                fieldsets?.forEach((fieldSet)=>{
                    const field = fieldSet?.node?.fields?.edges?.find((f)=>f?.node?.fieldId === fieldId);
                    field?.node?.selectedOptions?.edges?.forEach((option)=>{
                        if (option?.__id != null && option?.node?.id != null) {
                            const optionId = option?.__id ?? '';
                            selectedOptionMap[optionId] = option?.node?.id;
                        }
                    });
                });
            });
            break;
        case (0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT:
            selectedOptions?.edges?.forEach((issue)=>{
                const fieldsets = issue?.fieldSets?.edges?.filter((fieldSet)=>fieldSet?.node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT);
                fieldsets?.forEach((fieldSet)=>{
                    const field = fieldSet?.node?.fields?.edges?.find((f)=>{
                        return f?.node?.fieldId === fieldId;
                    });
                    if (field?.node?.__id != null && field?.node?.fieldOption?.optionId) selectedOptionMap[field?.node?.__id ?? ''] = field?.node?.fieldOption?.optionId;
                });
            });
            break;
        default:
            break;
    }
    return selectedOptionMap;
};
const $349a280504733ccd$export$b96cfa9b16d1cfb3 = (environment, type, selectedOptionMap, options)=>{
    if (type !== (0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT && type !== (0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT) return;
    const previousOptions = {};
    (0, $hx3Sa.commitLocalUpdate)(environment, (store)=>{
        const ids = Object.keys(selectedOptionMap);
        if (ids.length > 0) {
            const optionMap = {};
            options.forEach((opt)=>{
                optionMap[opt.id] = opt.value;
            });
            switch(type){
                case (0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT:
                    ids.forEach((id)=>{
                        const option = store.get(id)?.getLinkedRecord('node');
                        const optionId = (0, $wufAv.JiraIssueFieldOptionAri).parse(selectedOptionMap[id]).optionId;
                        // set return value
                        if (!previousOptions[optionId]) previousOptions[optionId] = option?.getValue('value')?.toString() ?? '';
                        if (optionMap[optionId]) option?.setValue(optionMap[optionId], 'value');
                    });
                    break;
                case (0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT:
                    ids.forEach((id)=>{
                        const option = store.get(id)?.getLinkedRecord('fieldOption');
                        const optionId = selectedOptionMap[id];
                        // set return value
                        if (!previousOptions[optionId]) previousOptions[optionId] = option?.getValue('value')?.toString() ?? '';
                        if (optionMap[optionId]) option?.setValue(optionMap[optionId], 'value');
                    });
                    break;
                default:
                    break;
            }
        }
    });
    return Object.keys(previousOptions).map((id)=>({
            id: id,
            value: previousOptions[id]
        }));
};
const $349a280504733ccd$export$6b82cef47b481f3a = (environment, queryRef, fieldId, fieldSetId)=>{
    (0, $hx3Sa.commitLocalUpdate)(environment, (store)=>{
        const issues = $349a280504733ccd$var$readIssuesData(queryRef);
        issues?.edges?.forEach((issue)=>{
            const fieldsets = issue?.fieldSets?.edges;
            fieldsets?.forEach((fieldSet)=>{
                const field = fieldSet?.node?.fields?.edges?.find((f)=>f?.node?.fieldId === fieldId);
                if (field) {
                    const id = fieldSet?.node?.__id ?? '';
                    const fieldSetToUpdate = store.get(id);
                    fieldSetToUpdate?.setValue(fieldSetId, 'fieldSetId');
                }
            });
        });
    });
};

});
parcelRegister("ar3QR", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab21e5730b94b314$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<00991a1eed811e83f9015c0764b0824d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ab21e5730b94b314$var$node = {
    "kind": "InlineDataFragment",
    "name": "getSelectedOptions"
};
$ab21e5730b94b314$var$node.hash = "d834d874b11bf040e4a6fed6a2824cab";
var $ab21e5730b94b314$export$2e2bcd8739ae039 = $ab21e5730b94b314$var$node;

});

parcelRegister("wufAv", function(module, exports) {
$parcel$export(module.exports, "JiraIssueFieldOptionAri", () => $061a7460522c266a$export$e3bc1ec22f941fbe);

var $4gJvn = parcelRequire("4gJvn");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/issue-field-option/manifest.ts
var $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $4gJvn.JiraIssueFieldOptionAriResourceOwner),
    resourceType: (0, $4gJvn.JiraIssueFieldOptionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldId}/{optionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/,
        // eslint-disable-line no-useless-escape
        optionId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/issue-field-option/index.ts
var $061a7460522c266a$export$e3bc1ec22f941fbe = class _JiraIssueFieldOptionAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldId = opts.resourceIdSegmentValues.fieldId, this._optionId = opts.resourceIdSegmentValues.optionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldId() {
        return this._fieldId;
    }
    get optionId() {
        return this._optionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts.qualifier,
            platformQualifier: $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts.resourceOwner,
            resourceType: $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldId}/${opts.optionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldId: opts.fieldId,
                optionId: opts.optionId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldId: this.fieldId,
            optionId: this.optionId
        };
    }
};

});
parcelRegister("4gJvn", function(module, exports) {
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceOwner", () => $31bbf461f55c01f8$export$eb4f4cf0880fe5a8);
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceType", () => $31bbf461f55c01f8$export$4bec333360908e78);
// src/jira/issue-field-option/types.ts
var $31bbf461f55c01f8$export$eb4f4cf0880fe5a8 = "jira", $31bbf461f55c01f8$export$4bec333360908e78 = "issue-field-option";

});




parcelRegister("cEWre", function(module, exports) {
$parcel$export(module.exports, "useIFCEditField", () => $0bd928140d605343$export$9e12f6c6c7e366bd);

var $eJOHy = parcelRequire("eJOHy");

var $fwzaq = parcelRequire("fwzaq");

var $pZqvR = parcelRequire("pZqvR");
const $0bd928140d605343$export$9e12f6c6c7e366bd = ()=>{
    const { ifcConfig: ifcConfig, optimisticUpdateField: optimisticUpdateField, replaceFieldSetInColumns: replaceFieldSetInColumns, optimisticDeleteField: optimisticDeleteField } = (0, $pZqvR.useIFCConfigContext)();
    const currentFieldSetId = (0, $eJOHy.useRef)();
    const currentField = (0, $eJOHy.useRef)(null);
    const isUpdateInProgress = (0, $eJOHy.useRef)();
    const onStartFieldUpdate = (0, $eJOHy.useCallback)((id, field)=>{
        isUpdateInProgress.current = true;
        const previousValue = optimisticUpdateField?.(id, field);
        // init the old value here
        if (currentField.current == null && previousValue) currentField.current = previousValue;
    }, [
        optimisticUpdateField
    ]);
    const [onDebouncedFieldUpdated] = (0, $fwzaq.default)((fieldId, field)=>{
        if (field?.collapsedName && currentFieldSetId.current && !isUpdateInProgress.current) {
            // skip saving fieldset config when there is no change in name
            if (field?.collapsedName !== currentFieldSetId.current) replaceFieldSetInColumns?.(currentFieldSetId.current, field.collapsedName, fieldId);
            currentFieldSetId.current = field?.collapsedName;
            // reset old value to null so it gets initialised on start update again
            currentField.current = null;
        }
    }, 1000);
    const onFieldUpdated = (0, $eJOHy.useCallback)((fieldId, field)=>{
        isUpdateInProgress.current = false;
        onDebouncedFieldUpdated(fieldId, field);
    }, [
        onDebouncedFieldUpdated
    ]);
    const onFieldUpdateError = (0, $eJOHy.useCallback)(()=>{
        if (currentField.current) {
            const { id: id, field: field } = currentField.current;
            optimisticUpdateField?.(id, field);
        }
    }, [
        optimisticUpdateField
    ]);
    const onFieldDeleted = (0, $eJOHy.useCallback)(()=>{
        if (currentFieldSetId.current) optimisticDeleteField?.(currentFieldSetId.current);
    }, [
        optimisticDeleteField
    ]);
    const onUpdate = (fieldId, fieldSetId)=>{
        currentFieldSetId.current = fieldSetId;
        ifcConfig?.onUpdate({
            fieldId: fieldId,
            onStartFieldUpdate: (field)=>onStartFieldUpdate(fieldId, field),
            onFieldUpdated: onFieldUpdated,
            onFieldDeleted: onFieldDeleted,
            onFieldUpdateError: onFieldUpdateError
        });
    };
    return onUpdate;
};

});

parcelRegister("kompv", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d0bca35a7562312$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3d0bca35a7562312$var$messages = (0, $7qGN1.defineMessages)({
    createAnotherButton: {
        "id": "native-issue-table.inline-field-config-footer.create-another-button",
        "defaultMessage": "Create another"
    },
    contactAdmin: {
        "id": "native-issue-table.inline-field-config-footer.contact-admin-text",
        "defaultMessage": "<link>Contact your project admin</link> to make changes"
    },
    makeChangesInConfig: {
        "id": "native-issue-table.inline-field-config-footer.make-config-changes-text",
        "defaultMessage": "Make changes in <link>configurations</link>"
    },
    contactAdminGalaxia: {
        "id": "native-issue-table.inline-field-config-footer.contact-admin-text-galaxia",
        "defaultMessage": "<link>Contact your space admin</link> to make changes"
    },
    totalCount: {
        "id": "native-issue-table.inline-field-config-footer.of-total-count",
        "defaultMessage": "{itemCount} of {totalCount}"
    },
    createAFieldInConfig: {
        "id": "native-issue-table.inline-field-config-footer.create-a-field-in-config",
        "defaultMessage": "Create a field"
    }
});
var $3d0bca35a7562312$export$2e2bcd8739ae039 = $3d0bca35a7562312$var$messages;

});


parcelRegister("9r0oq", function(module, exports) {
$parcel$export(module.exports, "TimelineCustomComponentsProvider", () => $59c3d16a0863ee6a$export$b40cbaf5e0e69a15);
$parcel$export(module.exports, "useTimelineCustomComponents", () => $59c3d16a0863ee6a$export$911a6abc1d3f8f05);

var $eJOHy = parcelRequire("eJOHy");

var $34oCh = parcelRequire("34oCh");
const $59c3d16a0863ee6a$var$TimelineCustomComponentsContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $59c3d16a0863ee6a$export$b40cbaf5e0e69a15 = ({ children: children, components: components })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($59c3d16a0863ee6a$var$TimelineCustomComponentsContext.Provider, {
        value: components ?? null
    }, children);
const $59c3d16a0863ee6a$export$911a6abc1d3f8f05 = ()=>{
    const context = (0, $eJOHy.useContext)($59c3d16a0863ee6a$var$TimelineCustomComponentsContext);
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    if (!isTimelineEnabled) return null;
    if (!context) throw new Error('useTimelineCustomComponents must be used within a TimelineCustomComponentsProvider');
    return context;
};

});

parcelRegister("8SzGK", function(module, exports) {
$parcel$export(module.exports, "useEventHandlers", () => $ca9d69e6c052c62b$export$8ce912bc34d0dbea);
$parcel$export(module.exports, "MaybeEventHandlersProvider", () => $ca9d69e6c052c62b$export$fef07f5f874e2160);

var $eJOHy = parcelRequire("eJOHy");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");
const $ca9d69e6c052c62b$var$EventHandlersContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $ca9d69e6c052c62b$var$EventHandlersProvider = ({ children: children, eventHandlers: eventHandlers })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ca9d69e6c052c62b$var$EventHandlersContext.Provider, {
        value: eventHandlers
    }, children);
};
const $ca9d69e6c052c62b$export$8ce912bc34d0dbea = ()=>{
    const context = (0, $eJOHy.useContext)($ca9d69e6c052c62b$var$EventHandlersContext);
    if (context === null) return {};
    return context;
};
const $ca9d69e6c052c62b$export$fef07f5f874e2160 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('timeline_rollups_issue_table_callbacks'), $ca9d69e6c052c62b$var$EventHandlersProvider, ({ children: children })=>children);

});

parcelRegister("91XFx", function(module, exports) {
$parcel$export(module.exports, "getMergedColumnConfig", () => $cad9621c000691ac$export$9fce51f35317a690);
$parcel$export(module.exports, "getMergedColumnConfigWithDynamicOrder", () => $cad9621c000691ac$export$582ade26f0b65534);

var $eJOHy = parcelRequire("eJOHy");

var $j8Km1 = parcelRequire("j8Km1");

var $dmolI = parcelRequire("dmolI");

var $9vDhp = parcelRequire("9vDhp");
const $cad9621c000691ac$var$getColumnTitle = (mergedColumns, baseField, formatMessage)=>{
    if (mergedColumns.length === 0) return '';
    if (mergedColumns.length === 1 && baseField) return baseField.title;
    return formatMessage((0, $9vDhp.default).columnHeaderMergedColumn);
};
const $cad9621c000691ac$export$9fce51f35317a690 = (columns, isIssueHierarchyEnabled, formatMessage)=>{
    const filteredColumns = [];
    let mergedColumns = [];
    let issueKeyColumn = null;
    let issueTypeColumn = null;
    let summaryColumn = null;
    let isCheckboxColumnEnabled = false;
    // Filter out the issue key, issue type, and summary columns
    columns.forEach((column)=>{
        if (column.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY) issueKeyColumn = column;
        else if (column.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_TYPE) issueTypeColumn = column;
        else if (column.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY) summaryColumn = column;
        else filteredColumns.push(column);
        if (column.id === (0, $j8Km1.COLUMN_ID_CHECKBOX)) isCheckboxColumnEnabled = true;
    });
    // Always preserve this order: issue type, key, summary
    mergedColumns = [
        issueTypeColumn,
        issueKeyColumn,
        summaryColumn
    ].filter(Boolean);
    // If there is no issue key, issue type, or summary column, we show only expand & child issue create icons
    const baseField = summaryColumn ?? issueKeyColumn ?? issueTypeColumn ?? null;
    // return original columns if hierarchy is OFF and merged fields are OFF
    if (!mergedColumns.length && !isIssueHierarchyEnabled) return columns;
    const columnConfig = baseField ?? (0, $dmolI.getColumnConfig)(formatMessage)[(0, $j8Km1.KNOWN_COLUMN_TYPES).MERGED_COLUMN]();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const resizeColumnId = baseField ? baseField.id : undefined;
    const mergedColumn = {
        jqlTerm: '',
        aliases: [],
        fieldTypeDisplayName: '',
        ...columnConfig,
        id: (0, $j8Km1.COLUMN_ID_MERGED_COLUMN),
        type: (0, $j8Km1.KNOWN_COLUMN_TYPES).MERGED_COLUMN,
        title: $cad9621c000691ac$var$getColumnTitle(mergedColumns, baseField, formatMessage),
        // only show quick sort icon if there is a single merged field enabled
        isSortable: mergedColumns.length < 2,
        mergedColumns: mergedColumns,
        resizeColumnId: resizeColumnId,
        customHeader: baseField ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    };
    // insert the merged column after the checkbox column if it exists
    const mergedColumnIndex = isCheckboxColumnEnabled ? 1 : 0;
    return [
        ...filteredColumns.slice(0, mergedColumnIndex),
        mergedColumn,
        ...filteredColumns.slice(mergedColumnIndex)
    ];
};
const $cad9621c000691ac$export$582ade26f0b65534 = (columns, isIssueHierarchyEnabled, formatMessage, enableDynamicOrderForMergedColumn)=>{
    const filteredColumns = [];
    let mergedColumns = [];
    let issueKeyColumn = null;
    let issueKeyColumnIndex = null;
    let issueTypeColumn = null;
    let issueTypeColumnIndex = null;
    let summaryColumn = null;
    let summaryColumnIndex = null;
    let isCheckboxColumnEnabled = false;
    // Filter out the issue key, issue type, and summary columns
    columns.forEach((column, index)=>{
        if (column.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY) {
            issueKeyColumn = column;
            issueKeyColumnIndex = index;
        } else if (column.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_TYPE) {
            issueTypeColumn = column;
            issueTypeColumnIndex = index;
        } else if (column.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY) {
            summaryColumn = column;
            summaryColumnIndex = index;
        } else filteredColumns.push(column);
        if (column.id === (0, $j8Km1.COLUMN_ID_CHECKBOX)) isCheckboxColumnEnabled = true;
    });
    // Always preserve this order: issue type, key, summary
    mergedColumns = [
        issueTypeColumn,
        issueKeyColumn,
        summaryColumn
    ].filter(Boolean);
    // If there is no issue key, issue type, or summary column, we show only expand & child issue create icons
    const baseField = summaryColumn ?? issueKeyColumn ?? issueTypeColumn ?? null;
    // return original columns if hierarchy is OFF and merged fields are OFF
    if (!mergedColumns.length && !isIssueHierarchyEnabled) return columns;
    const columnConfig = baseField ?? (0, $dmolI.getColumnConfig)(formatMessage)[(0, $j8Km1.KNOWN_COLUMN_TYPES).MERGED_COLUMN]();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const resizeColumnId = baseField ? baseField.id : undefined;
    const mergedColumn = {
        jqlTerm: '',
        aliases: [],
        fieldTypeDisplayName: '',
        ...columnConfig,
        id: (0, $j8Km1.COLUMN_ID_MERGED_COLUMN),
        type: (0, $j8Km1.KNOWN_COLUMN_TYPES).MERGED_COLUMN,
        title: $cad9621c000691ac$var$getColumnTitle(mergedColumns, baseField, formatMessage),
        // only show quick sort icon if there is a single merged field enabled
        isSortable: mergedColumns.length < 2,
        mergedColumns: mergedColumns,
        resizeColumnId: resizeColumnId,
        customHeader: baseField ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    };
    // choose the lowest order among issue type, issue key, and summary column
    let mergedColumnIndex = enableDynamicOrderForMergedColumn ? Math.min(issueTypeColumnIndex ?? Infinity, issueKeyColumnIndex ?? Infinity, summaryColumnIndex ?? Infinity) : 0;
    // insert the merged column after the checkbox column if it exists
    mergedColumnIndex = isCheckboxColumnEnabled ? mergedColumnIndex + 1 : mergedColumnIndex;
    return [
        ...filteredColumns.slice(0, mergedColumnIndex),
        mergedColumn,
        ...filteredColumns.slice(mergedColumnIndex)
    ];
};

});
parcelRegister("9vDhp", function(module, exports) {
$parcel$export(module.exports, "default", () => $991d287fa52317bd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $991d287fa52317bd$var$messages = (0, $7qGN1.defineMessages)({
    columnHeaderMergedColumn: {
        "id": "native-issue-table.common.utils.get-merged-column-config.column-header-merged-column",
        "defaultMessage": "Work"
    }
});
var $991d287fa52317bd$export$2e2bcd8739ae039 = $991d287fa52317bd$var$messages;

});


parcelRegister("sJrIm", function(module, exports) {
$parcel$export(module.exports, "SortChangeContextProvider", () => $9d128466cbfef453$export$61767aa5bd260064);
$parcel$export(module.exports, "useSortContext", () => $9d128466cbfef453$export$a3b9cb2711d4166);

var $eJOHy = parcelRequire("eJOHy");
const $9d128466cbfef453$var$SortChangeContext = /*#__PURE__*/ (0, $eJOHy.createContext)({});
const $9d128466cbfef453$export$61767aa5bd260064 = $9d128466cbfef453$var$SortChangeContext.Provider;
const $9d128466cbfef453$export$a3b9cb2711d4166 = ()=>{
    const context = (0, $eJOHy.useContext)($9d128466cbfef453$var$SortChangeContext);
    return context !== undefined ? context : {};
};

});

parcelRegister("7t30r", function(module, exports) {
$parcel$export(module.exports, "useKeyboardNavigation", () => $3e29ded337e90265$export$4da28cf324280418);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $5V25X = parcelRequire("5V25X");

var $ezJEv = parcelRequire("ezJEv");

var $8jOO7 = parcelRequire("8jOO7");
const $3e29ded337e90265$export$4da28cf324280418 = (ref, isStickyColumnsEnabled)=>{
    const lastFocusedElement = (0, $eJOHy.useRef)();
    const onboardingTriggered = (0, $eJOHy.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // Post-office trigger handlers for grid navigation onboarding
    const { isActive: isMoreShortcutsClicked } = (0, $5V25X.useTrigger)((0, $8jOO7.GRID_NAVIGATION_ONBOARDING_TRIGGERS).MORE_SHORTCUTS_CLICKED);
    const { isActive: isOkClicked } = (0, $5V25X.useTrigger)((0, $8jOO7.GRID_NAVIGATION_ONBOARDING_TRIGGERS).OK_CLICKED);
    const openHelpPanelLink = (0, $ezJEv.useHelpPanelLink)();
    (0, $eJOHy.useEffect)(()=>{
        const table = ref.current;
        if (!table) return;
        const getCell = (ele)=>ele?.closest('td') ?? ele?.closest('th');
        const isCell = (ele)=>getCell(ele) === ele;
        const getFocusableElements = ()=>Array.from(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, @atlaskit/platform/no-direct-document-usage
            document.querySelectorAll([
                'a[href]:not([tabindex="-1"]):not([href=""]):not([href="javascript:;"])',
                'button:not([tabindex="-1"])',
                'input:not([tabindex="-1"], [type="hidden"])',
                'select:not([tabindex="-1"])',
                'textarea:not([tabindex="-1"])',
                "[tabindex]:not([tabindex='-1'])"
            ].join(',')));
        const getCellDepth = (ele, count = 0)=>{
            if (ele instanceof HTMLTableCellElement || !ele?.parentElement) return count;
            return getCellDepth(ele?.parentElement, count + 1);
        };
        // Ensure the target cell is fully visible horizontally, taking frozen columns into account
        const ensureCellFullyVisible = (cell)=>{
            const scroller = getScrollableContainer();
            if (!scroller) {
                // Fallback: if there is no scrollable container, scroll the cell into view centered horizontally
                cell.scrollIntoView({
                    behavior: 'auto',
                    block: 'nearest',
                    inline: 'center'
                });
                return;
            }
            const scrollerRect = scroller.getBoundingClientRect();
            const cellRect = cell.getBoundingClientRect();
            // Estimate the right edge of the frozen columns (look at the first row or table header with sticky position)
            const measureFrozenRight = ()=>{
                // Prefer the thead row; if not present, use the first row in tbody or the first tr
                const headerRow = table.querySelector('thead tr') ?? table.querySelector('tbody tr') ?? table.querySelector('tr');
                if (!headerRow) return scrollerRect.left;
                let maxRight = scrollerRect.left;
                for (const el of Array.from(headerRow.children)){
                    if (!(el instanceof HTMLElement)) return null;
                    // Check if the element is sticky and visible
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    const cs = window.getComputedStyle(el);
                    const isSticky = cs.position === 'sticky' && cs.left !== 'auto';
                    if (isSticky && el.getAttribute('aria-hidden') !== 'true') {
                        const r = el.getBoundingClientRect();
                        if (r.right > maxRight) maxRight = r.right;
                    }
                }
                return maxRight;
            };
            const frozenRight = measureFrozenRight();
            // Compute the left boundary of the visible area: the larger of the scroller left or the frozen columns right edge
            const visibleLeft = Math.max(scrollerRect.left, frozenRight ?? 0);
            const visibleRight = scrollerRect.right;
            // Add a small margin for better visual spacing
            const margin = 8;
            // If the cell is partially hidden on the left, scroll left
            if (cellRect.left < visibleLeft + margin) scroller.scrollLeft -= visibleLeft + margin - cellRect.left;
            else if (cellRect.right > visibleRight - margin) scroller.scrollLeft += cellRect.right - (visibleRight - margin);
        };
        const getScrollableContainer = (node = table)=>{
            // Goes up the DOM tree until we encounter a scrollable element.
            if (!(node instanceof HTMLElement)) return null;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const styles = window.getComputedStyle(node);
            if (styles?.overflowY === 'scroll' || styles?.overflowY === 'auto') return node;
            return getScrollableContainer(node.parentElement);
        };
        const onKeyDown = (event)=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, @atlaskit/platform/no-direct-document-usage
            const activeElement = document.activeElement;
            const currentTr = activeElement?.closest('tr');
            if (event.key === 'Escape') {
                event.preventDefault();
                const cell = getCell(activeElement);
                const cellButton = cell?.querySelector('button[aria-hidden="false"]');
                if (cellButton instanceof HTMLElement && getCellDepth(cellButton) < 4) return cellButton.focus();
                return cell?.focus();
            }
            if (event.key === 'Tab' && event.shiftKey && activeElement instanceof Element) {
                /*
					If focus would move from our cell to another cell when pressing shift+tab;
					Prevent default and focus last element before the table.
				*/ const isCurrentCellFocused = isCell(activeElement);
                const index = activeElement.getAttribute('tabindex');
                if (isCurrentCellFocused) activeElement.setAttribute('tabindex', '0');
                const focusable = getFocusableElements();
                const currentFocusableElementsCell = getCell(activeElement);
                const nextFocusableElementsCell = getCell(focusable[focusable.indexOf(activeElement) - 1]);
                if (isCurrentCellFocused) activeElement.setAttribute('tabindex', index ?? '-1');
                if (!isCurrentCellFocused) {
                    // go back to grid navigation
                    event.preventDefault();
                    return currentFocusableElementsCell?.focus();
                }
                if (currentFocusableElementsCell === nextFocusableElementsCell || !nextFocusableElementsCell) return;
                lastFocusedElement.current = getCell(activeElement);
                // Find the last element before the table in the document
                const lastElementBeforeTable = focusable.slice(0, focusable.findIndex((ele)=>table.contains(ele))).at(-1);
                event.preventDefault();
                if (lastElementBeforeTable instanceof HTMLElement) lastElementBeforeTable.focus();
                return;
            }
            if (event.key === 'Tab' && activeElement) {
                /*
					If focus would move from our cell to another cell when pressing tab;
					Prevent default and focus first interactable thing outside the table. (probably create button but not always)
					If we're inside a dialog; don't programmatically control focus.
				*/ if (activeElement.closest('[role="dialog"]')) return;
                const isCurrentCellFocused = isCell(activeElement);
                const index = activeElement.getAttribute('tabindex');
                if (isCurrentCellFocused) activeElement.setAttribute('tabindex', '0');
                const focusable = getFocusableElements();
                const currentFocusableElementsCell = getCell(activeElement);
                const nextFocusableElementsCell = getCell(focusable[focusable.indexOf(activeElement) + 1]);
                if (isCurrentCellFocused) activeElement.setAttribute('tabindex', index ?? '-1');
                if (currentFocusableElementsCell === nextFocusableElementsCell || !nextFocusableElementsCell) return;
                const nextFocusableElementOutsideTable = focusable.slice(focusable.indexOf(activeElement)).find((ele)=>!table.contains(ele));
                if (!nextFocusableElementOutsideTable) {
                    const lastInsideTable = focusable.slice(focusable.indexOf(activeElement)).at(-1);
                    if (!(lastInsideTable instanceof HTMLElement)) return;
                    lastInsideTable.focus({
                        preventScroll: true
                    });
                    return;
                }
                event.preventDefault();
                nextFocusableElementOutsideTable?.focus();
                return;
            }
            if (!activeElement || !(activeElement instanceof HTMLElement)) return;
            if (!currentTr || !(currentTr instanceof HTMLTableRowElement)) return;
            const currentTd = getCell(activeElement);
            if (!currentTd) return;
            const currentTds = Array.from(currentTr.children).filter((n)=>{
                return n.getAttribute('aria-hidden') !== 'true';
            });
            const currentTdIndex = currentTds.indexOf(currentTd);
            const rows = Array.from(table.querySelectorAll('tr:not([aria-hidden="true"])'));
            const currentTrIndex = rows.indexOf(currentTr);
            const isKeyboardNavigableElement = activeElement instanceof HTMLTableCellElement || activeElement instanceof HTMLButtonElement && activeElement.getAttribute('aria-hidden') === 'false';
            if (!isKeyboardNavigableElement) return;
            const next = (()=>{
                switch(event.code){
                    case 'ArrowUp':
                    case (0, $4cTDP.fg)('list-navigation-consistency') ? 'KeyK' : 'KeyJ':
                        {
                            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateUp', {
                                keyPressed: event.key
                            });
                            // Firing track metric to measure nin_grid_navigation_experiment, clean up when cleaning up experiment
                            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'keyboardShortcut pressed', 'KeyboardShortcut', {
                                action: 'pressed',
                                key: 'arrowup'
                            });
                            if (currentTrIndex === 0) return;
                            /* same index, in next row or first index in next row [grouped] */ const children = Array.from(rows[currentTrIndex - 1]?.children ?? []).filter((ele)=>{
                                return ele.getAttribute('aria-hidden') !== 'true';
                            });
                            return children[currentTdIndex] ?? rows[currentTrIndex - 1].children[0];
                        }
                    case 'ArrowDown':
                    case (0, $4cTDP.fg)('list-navigation-consistency') ? 'KeyJ' : 'KeyK':
                        {
                            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateDown', {
                                keyPressed: event.key
                            });
                            // Firing track metric to measure nin_grid_navigation_experiment, clean up when cleaning up experiment
                            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'keyboardShortcut pressed', 'KeyboardShortcut', {
                                action: 'pressed',
                                key: 'arrowdown'
                            });
                            if (currentTrIndex === rows.length - 1) return;
                            /* same index, in next row or first index in next row [grouped] */ const children = Array.from(rows[currentTrIndex + 1]?.children ?? []).filter((ele)=>{
                                return ele.getAttribute('aria-hidden') !== 'true';
                            });
                            return children[currentTdIndex] ?? rows[currentTrIndex + 1].children[0];
                        }
                    case 'ArrowLeft':
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateLeft', {
                            keyPressed: event.key
                        });
                        return currentTds[currentTdIndex - 1];
                    case 'ArrowRight':
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateRight', {
                            keyPressed: event.key
                        });
                        return currentTds[currentTdIndex + 1];
                    case 'End':
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateEnd', {
                            keyPressed: event.key
                        });
                        return currentTds[currentTds.length - 1];
                    case 'Home':
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateHome', {
                            keyPressed: event.key
                        });
                        return currentTds[0];
                    case 'Enter':
                    case 'Space':
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateEdit', {
                            keyPressed: event.key
                        });
                        if (activeElement instanceof HTMLTableCellElement) {
                            if (event.code === 'Space') event.preventDefault();
                            if (currentTd.children.length !== 1) return currentTd.click();
                            const interactiveElements = Array.from(currentTd.querySelectorAll('button:not([aria-hidden="true"]), a:not([aria-hidden="true"]), input:not([aria-hidden="true"]), select:not([aria-hidden="true"]), textarea:not([aria-hidden="true"]), [role="button"]:not([aria-hidden="true"])'));
                            if (interactiveElements.length === 1) {
                                const element = interactiveElements[0];
                                if (element instanceof HTMLElement) {
                                    element.click();
                                    return;
                                }
                            }
                        }
                        return currentTd.click();
                    case 'PageDown':
                        {
                            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigatePageDown', {
                                keyPressed: event.key
                            });
                            /* Get last visible index in scrollable area, then focus the cell at the same index */ const scrollable = getScrollableContainer();
                            const rowsReversed = [
                                ...rows
                            ].reverse();
                            if (!scrollable) return null;
                            const scrollableRect = scrollable.getBoundingClientRect();
                            const lastVisibleIndex = rowsReversed.findIndex((row)=>{
                                const rowRect = row.getBoundingClientRect();
                                const isVisible = rowRect.bottom > scrollableRect.top && rowRect.top < scrollableRect.bottom;
                                return isVisible;
                            }) - 1;
                            const children = Array.from(rowsReversed[Math.max(0, lastVisibleIndex)]?.children ?? []).filter((ele)=>{
                                return ele.getAttribute('aria-hidden') !== 'true';
                            });
                            if (children.length === 0) return;
                            return children[currentTdIndex] ?? rowsReversed[Math.max(0, lastVisibleIndex)].children[0];
                        }
                    case 'PageUp':
                        {
                            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigatePageUp', {
                                keyPressed: event.key
                            });
                            /* Get first visible index in scrollable area, then focus the cell at the same index */ const scrollable = getScrollableContainer();
                            const rowsExcludingHeader = rows.filter((row)=>!row.closest('thead'));
                            if (!scrollable) return null;
                            const scrollableRect = scrollable.getBoundingClientRect();
                            const firstVisibleIndex = rowsExcludingHeader.findIndex((row)=>{
                                const rowRect = row.getBoundingClientRect();
                                const isVisible = rowRect.bottom > scrollableRect.top && rowRect.top < scrollableRect.bottom;
                                return isVisible;
                            });
                            const children = Array.from(rowsExcludingHeader[Math.max(0, firstVisibleIndex)]?.children ?? []).filter((ele)=>{
                                return ele.getAttribute('aria-hidden') !== 'true';
                            });
                            if (children.length === 0) return;
                            return children[currentTdIndex] ?? rowsExcludingHeader[Math.max(0, firstVisibleIndex)].children[0];
                        }
                    default:
                        return null;
                }
            })();
            if (!(next instanceof HTMLElement)) return;
            event.stopImmediatePropagation(); // Stop meatball menu onKeyDown hijacking focus
            event.preventDefault();
            if (isStickyColumnsEnabled && (event.code === 'ArrowRight' || event.code === 'ArrowLeft') && (0, $4cTDP.fg)('issue_table_frozen_columns')) ensureCellFullyVisible(next);
            const button = next.querySelector('button[aria-hidden="false"]');
            const depth = getCellDepth(button);
            if (button && button instanceof HTMLElement && depth < 4) return button.focus();
            return next.focus();
        };
        const onFocusIn = (e)=>{
            /*
				Focus on last focused cell if we're moving focus from inside the table to outside the table
				and lastFocusedElement is defined. (tab into table), otherwise focus on the first cell in the table.
			*/ if (e.target instanceof HTMLElement && e.relatedTarget instanceof Element && lastFocusedElement.current) {
                if (table.contains(e.target) && !table.contains(e.relatedTarget)) return lastFocusedElement.current.focus();
            }
            /* Focus first element inside table, if we've referred focus from outside table (shift+tab back into table) */ const target = e.target;
            if (!(target instanceof HTMLElement) || !(e.relatedTarget instanceof Element) || table.contains(e.relatedTarget)) {
                if (target instanceof HTMLElement) lastFocusedElement.current = getCell(target);
                return;
            }
            const focusable = getFocusableElements();
            const indexOfTable = focusable.findIndex((ele)=>table.contains(ele));
            const indexOfRelatedTarget = focusable.indexOf(e.relatedTarget);
            if (indexOfRelatedTarget < indexOfTable) lastFocusedElement.current = undefined;
        };
        const onKeyDownWindow = (e)=>{
            /*
				If focus is on the first element outside the table.
				prevent the default behaviour and move focus either to the last focuse element inside the table, or the first table cell.
			*/ if (e.key === 'Tab' && e.shiftKey) {
                const focusable = getFocusableElements();
                const elementOutsideTable = focusable.slice(focusable.findIndex((ele)=>table.contains(ele))).find((ele)=>!table.contains(ele));
                if (elementOutsideTable === e.target) {
                    e.preventDefault();
                    if (lastFocusedElement.current && table.contains(lastFocusedElement.current)) return lastFocusedElement.current.focus();
                    focusable.find((ele)=>table.contains(ele))?.focus();
                }
            }
        };
        table.addEventListener('keydown', onKeyDown);
        table.addEventListener('focusin', onFocusIn);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keydown', onKeyDownWindow);
        return ()=>{
            table.removeEventListener('keydown', onKeyDown);
            table.removeEventListener('focusin', onFocusIn);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keydown', onKeyDownWindow);
        };
    // RefObject is a constant reference.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref.current
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isMoreShortcutsClicked && !onboardingTriggered.current && (0, $4cTDP.fg)('jira_nin_navigation_onboarding')) {
            onboardingTriggered.current = true;
            openHelpPanelLink((0, $8jOO7.KEYBOARD_SHORTCUTS_HELP_ARTICLE_ID));
        }
    }, [
        isMoreShortcutsClicked,
        openHelpPanelLink
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isOkClicked && !onboardingTriggered.current && (0, $4cTDP.fg)('jira_nin_navigation_onboarding')) {
            onboardingTriggered.current = true;
            const table = ref.current;
            if (table) {
                const firstThCell = table.querySelector('th');
                if (firstThCell instanceof HTMLElement) firstThCell.focus();
            }
        }
    }, [
        isOkClicked,
        ref
    ]);
};

});

parcelRegister("4jaZO", function(module, exports) {
$parcel$export(module.exports, "ShouldUseSSRVirtualizerProvider", () => $02fccf8bdbf5d1dd$export$d91019f71aae1e4a);
$parcel$export(module.exports, "useSSRSafeVirtualizer", () => $02fccf8bdbf5d1dd$export$e290ffcf7d3b6e02);

var $eJOHy = parcelRequire("eJOHy");

var $bVtHf = parcelRequire("bVtHf");

var $4cTDP = parcelRequire("4cTDP");
const $02fccf8bdbf5d1dd$var$ShouldUseSSRVirtualizerContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $02fccf8bdbf5d1dd$export$d91019f71aae1e4a = ({ children: children })=>{
    const value = (0, $eJOHy.useState)(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02fccf8bdbf5d1dd$var$ShouldUseSSRVirtualizerContext.Provider, {
        value: value
    }, children);
};
const $02fccf8bdbf5d1dd$var$useShouldUseSSRVirtualizer = ()=>{
    const context = (0, $eJOHy.useContext)($02fccf8bdbf5d1dd$var$ShouldUseSSRVirtualizerContext);
    if (!context) throw new Error('useShouldUseSSRVirtualizer must be used within a ShouldUseSSRVirtualizerProvider');
    return context;
};
const $02fccf8bdbf5d1dd$export$f4c0efb17365077d = (options)=>{
    const { count: count, estimateSize: estimateSize, getItemKey: getItemKey } = options;
    const totalSize = count * estimateSize(0);
    let start = 0;
    const items = Array.from({
        length: count
    }).map((_, i)=>{
        const end = start + estimateSize(i);
        const item = {
            index: i,
            key: getItemKey?.(i) ?? i,
            start: start,
            end: end,
            lane: 0,
            size: estimateSize(i)
        };
        start = end;
        return item;
    });
    return {
        getTotalSize () {
            return totalSize;
        },
        getVirtualItems () {
            return items;
        }
    };
};
const $02fccf8bdbf5d1dd$var$dummyVirtualizer = {
    getTotalSize () {
        return 0;
    },
    getVirtualItems () {
        return [];
    }
};
const $02fccf8bdbf5d1dd$export$e290ffcf7d3b6e02 = (options)=>{
    const { getScrollElement: getScrollElement, count: count, estimateSize: estimateSize, getItemKey: getItemKey } = options;
    const [shouldUseSSRVirtualizer, setShouldUseSSRVirtualizer] = $02fccf8bdbf5d1dd$var$useShouldUseSSRVirtualizer();
    const serverVirtualizer = (0, $eJOHy.useMemo)(()=>{
        if (shouldUseSSRVirtualizer) // only calculated when is going to be used
        return $02fccf8bdbf5d1dd$export$f4c0efb17365077d({
            count: count,
            estimateSize: estimateSize,
            getItemKey: getItemKey
        });
        return $02fccf8bdbf5d1dd$var$dummyVirtualizer;
    }, [
        count,
        estimateSize,
        getItemKey,
        shouldUseSSRVirtualizer
    ]);
    const originalVirtualizer = (0, $bVtHf.useVirtualizer)(options);
    /**
	 * We swap to real virtualization when we detect that the user has initiated a scroll
	 */ (0, $eJOHy.useEffect)(()=>{
        if (!shouldUseSSRVirtualizer) return;
        const element = getScrollElement();
        const onScroll = ()=>{
            if (!false && (!(0, $4cTDP.fg)('jira_issue_table_virtualizer_vertical_scroll_init') || element && element.scrollTop > 0)) {
                setShouldUseSSRVirtualizer(false);
                element?.removeEventListener('scroll', onScroll);
            }
        };
        element?.addEventListener('scroll', onScroll);
        return ()=>{
            element?.removeEventListener('scroll', onScroll);
        };
    }, [
        shouldUseSSRVirtualizer,
        getScrollElement,
        setShouldUseSSRVirtualizer
    ]);
    /**
	 * We overwrite the methods to render the items and calculate size
	 * to assure that SSR renders the same as the frontend on the initial
	 * render
	 */ return (0, $eJOHy.useMemo)(()=>{
        if (shouldUseSSRVirtualizer) return {
            ...originalVirtualizer,
            ...serverVirtualizer
        };
        // Ensure we return a stable reference between renders when we stop using the SSR virtualizer
        return originalVirtualizer;
    }, [
        originalVirtualizer,
        serverVirtualizer,
        shouldUseSSRVirtualizer
    ]);
};

});
parcelRegister("bVtHf", function(module, exports) {
$parcel$export(module.exports, "defaultRangeExtractor", () => (parcelRequire("gMNDC")).defaultRangeExtractor);
$parcel$export(module.exports, "elementScroll", () => (parcelRequire("gMNDC")).elementScroll);
$parcel$export(module.exports, "notUndefined", () => (parcelRequire("8GBQp")).notUndefined);
$parcel$export(module.exports, "observeElementOffset", () => (parcelRequire("gMNDC")).observeElementOffset);
$parcel$export(module.exports, "observeElementRect", () => (parcelRequire("gMNDC")).observeElementRect);
$parcel$export(module.exports, "observeWindowOffset", () => (parcelRequire("gMNDC")).observeWindowOffset);
$parcel$export(module.exports, "observeWindowRect", () => (parcelRequire("gMNDC")).observeWindowRect);
$parcel$export(module.exports, "Virtualizer", () => (parcelRequire("gMNDC")).Virtualizer);
$parcel$export(module.exports, "windowScroll", () => (parcelRequire("gMNDC")).windowScroll);
$parcel$export(module.exports, "useVirtualizer", () => $8aec0db0c0df701a$export$dd6d526d88b5a137);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $gMNDC = parcelRequire("gMNDC");
const $8aec0db0c0df701a$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $eJOHy.useLayoutEffect : $eJOHy.useEffect;
function $8aec0db0c0df701a$var$useVirtualizerBase(options) {
    const rerender = $eJOHy.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $aQK2r.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $eJOHy.useState(()=>new (0, $gMNDC.Virtualizer)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $eJOHy.useEffect(()=>{
        return instance._didMount();
    }, []);
    $8aec0db0c0df701a$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $8aec0db0c0df701a$export$dd6d526d88b5a137(options) {
    return $8aec0db0c0df701a$var$useVirtualizerBase({
        observeElementRect: $gMNDC.observeElementRect,
        observeElementOffset: $gMNDC.observeElementOffset,
        scrollToFn: (0, $gMNDC.elementScroll),
        ...options
    });
}
function $8aec0db0c0df701a$export$645722dcac657cb9(options) {
    return $8aec0db0c0df701a$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $gMNDC.observeWindowRect),
        observeElementOffset: (0, $gMNDC.observeWindowOffset),
        scrollToFn: (0, $gMNDC.windowScroll),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}

});
parcelRegister("gMNDC", function(module, exports) {
$parcel$export(module.exports, "defaultRangeExtractor", () => $c387a2210354f599$export$7eb7cb13fd21e5e1);
$parcel$export(module.exports, "observeElementRect", () => $c387a2210354f599$export$5a50ff2cde8c3802);
$parcel$export(module.exports, "observeWindowRect", () => $c387a2210354f599$export$e911b82c7a99311);
$parcel$export(module.exports, "observeElementOffset", () => $c387a2210354f599$export$fbc040aee017375a);
$parcel$export(module.exports, "observeWindowOffset", () => $c387a2210354f599$export$518998f8c5d09287);
$parcel$export(module.exports, "windowScroll", () => $c387a2210354f599$export$2162c5b3eeedd27);
$parcel$export(module.exports, "elementScroll", () => $c387a2210354f599$export$1cdb988e5ab69fe7);
$parcel$export(module.exports, "Virtualizer", () => $c387a2210354f599$export$89be5a243e59c4b2);
$parcel$export(module.exports, "notUndefined", () => (parcelRequire("8GBQp")).notUndefined);

var $8GBQp = parcelRequire("8GBQp");
const $c387a2210354f599$export$76974b428a49f15b = (index)=>index;
const $c387a2210354f599$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $c387a2210354f599$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (!targetWindow.ResizeObserver) return ()=>{};
    const observer = new targetWindow.ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $c387a2210354f599$var$addEventListenerOptions = {
    passive: true
};
const $c387a2210354f599$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $c387a2210354f599$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $c387a2210354f599$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $c387a2210354f599$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $c387a2210354f599$var$supportsScrollend ? ()=>void 0 : (0, $8GBQp.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            const { horizontal: horizontal, isRtl: isRtl } = instance.options;
            offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $c387a2210354f599$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $c387a2210354f599$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $c387a2210354f599$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $c387a2210354f599$var$supportsScrollend ? ()=>void 0 : (0, $8GBQp.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $c387a2210354f599$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $c387a2210354f599$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $c387a2210354f599$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $c387a2210354f599$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $c387a2210354f599$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $c387a2210354f599$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.targetWindow = null;
        this.isScrolling = false;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollRect = null;
        this.scrollOffset = null;
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.elementsCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        this._measureElement(entry.target, entry);
                    });
                });
            };
            return {
                disconnect: ()=>{
                    var _a;
                    (_a = get()) == null || _a.disconnect();
                    _ro = null;
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $c387a2210354f599$export$76974b428a49f15b,
                rangeExtractor: $c387a2210354f599$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $c387a2210354f599$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                isScrollingResetDelay: 150,
                enabled: true,
                isRtl: false,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $8GBQp.memo)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.observer.disconnect();
            this.scrollElement = null;
            this.targetWindow = null;
        };
        this._didMount = ()=>{
            return ()=>{
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            var _a;
            const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                if (!scrollElement) {
                    this.maybeNotify();
                    return;
                }
                this.scrollElement = scrollElement;
                if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                this.elementsCache.forEach((cached)=>{
                    this.observer.observe(cached);
                });
                this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    this.isScrolling = isScrolling;
                    this.maybeNotify();
                }));
            }
        };
        this.getSize = ()=>{
            if (!this.options.enabled) {
                this.scrollRect = null;
                return 0;
            }
            this.scrollRect = this.scrollRect ?? this.options.initialRect;
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getScrollOffset = ()=>{
            if (!this.options.enabled) {
                this.scrollOffset = null;
                return 0;
            }
            this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
            return this.scrollOffset;
        };
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurementOptions = (0, $8GBQp.memo)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey,
                this.options.enabled
            ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey,
                enabled: enabled
            };
        }, {
            key: false
        });
        this.getMeasurements = (0, $8GBQp.memo)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
            if (!enabled) {
                this.measurementsCache = [];
                this.itemSizeCache.clear();
                return [];
            }
            if (this.measurementsCache.length === 0) {
                this.measurementsCache = this.options.initialMeasurementsCache;
                this.measurementsCache.forEach((item)=>{
                    this.itemSizeCache.set(item.key, item.size);
                });
            }
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $8GBQp.memo)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.getScrollOffset()
            ], (measurements, outerSize, scrollOffset)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $c387a2210354f599$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getIndexes = (0, $8GBQp.memo)(()=>[
                this.options.rangeExtractor,
                this.calculateRange(),
                this.options.overscan,
                this.options.count
            ], (rangeExtractor, range, overscan, count)=>{
            return range === null ? [] : rangeExtractor({
                startIndex: range.startIndex,
                endIndex: range.endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const index = this.indexFromElement(node);
            const item = this.measurementsCache[index];
            if (!item) return;
            const key = item.key;
            const prevNode = this.elementsCache.get(key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.elementsCache.set(key, node);
            }
            if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
        };
        this.resizeItem = (index, size)=>{
            const item = this.measurementsCache[index];
            if (!item) return;
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) {
                this.elementsCache.forEach((cached, key)=>{
                    if (!cached.isConnected) {
                        this.observer.unobserve(cached);
                        this.elementsCache.delete(key);
                    }
                });
                return;
            }
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $8GBQp.memo)(()=>[
                this.getIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            if (measurements.length === 0) return void 0;
            return (0, $8GBQp.notUndefined)(measurements[$c387a2210354f599$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $8GBQp.notUndefined)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align)=>{
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (toOffset <= scrollOffset) align = "start";
                else if (toOffset >= scrollOffset + size) align = "end";
                else align = "start";
            }
            if (align === "start") toOffset;
            else if (align === "end") toOffset = toOffset - size;
            else if (align === "center") toOffset = toOffset - size / 2;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - size;
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const item = this.measurementsCache[index];
            if (!item) return void 0;
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align),
                align
            ];
        };
        this.isDynamicMode = ()=>this.elementsCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
                this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
            if (!offsetAndAlign) return;
            const [offset, align] = offsetAndAlign;
            this._scrollToOffset(offset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.elementsCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [latestOffset] = (0, $8GBQp.notUndefined)(this.getOffsetForIndex(index, align));
                    if (!(0, $8GBQp.approxEqual)(latestOffset, this.getScrollOffset())) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getScrollOffset() + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
            return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
    }
}
const $c387a2210354f599$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $c387a2210354f599$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
    const count = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    const startIndex = $c387a2210354f599$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
    let endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}

});
parcelRegister("8GBQp", function(module, exports) {
$parcel$export(module.exports, "memo", () => $652f9a140a44b154$export$7c73462e0d25e514);
$parcel$export(module.exports, "notUndefined", () => $652f9a140a44b154$export$9a1adf421b69c6a);
$parcel$export(module.exports, "approxEqual", () => $652f9a140a44b154$export$8a4f1dcc58a69dbd);
$parcel$export(module.exports, "debounce", () => $652f9a140a44b154$export$61fc7d43ac8f84b0);
function $652f9a140a44b154$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    return ()=>{
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    };
}
function $652f9a140a44b154$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $652f9a140a44b154$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
const $652f9a140a44b154$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
    let timeoutId;
    return function(...args) {
        targetWindow.clearTimeout(timeoutId);
        timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
    };
};

});




parcelRegister("8Cpk9", function(module, exports) {
$parcel$export(module.exports, "default", () => $734acbe44f1f7d3b$export$2e2bcd8739ae039);

var $698UM = parcelRequire("698UM");

var $33Zg7 = parcelRequire("33Zg7");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $6XJko = parcelRequire("6XJko");

var $4cTDP = parcelRequire("4cTDP");

var $4ohGb = parcelRequire("4ohGb");

var $34oCh = parcelRequire("34oCh");

var $g212q = parcelRequire("g212q");

var $kmFBu = parcelRequire("kmFBu");

var $lfz0B = parcelRequire("lfz0B");
/**
 * Render the table footer, composing together the default IssueCount and Pagination UI elements.
 */ const $734acbe44f1f7d3b$var$FooterRenderer = ({ Footer: Footer, IssueCount: IssueCount, issues: issues, rankField: rankField, onPageChange: onPageChange, canShowAdditionalFields: canShowAdditionalFields, footerBorderRadius: footerBorderRadius, topLevelIssueCreateConfig: topLevelIssueCreateConfig, isMakeSpaceForGlobalRovoButtonEnabled: isMakeSpaceForGlobalRovoButtonEnabled = false })=>{
    const issueData = (0, $j4oe4.useFragment)((0, $33Zg7.default), issues);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $698UM.default), rankField ?? null);
    const isIssueCreateEnabled = (0, $34oCh.useIsIssueCreateEnabled)();
    const isInfiniteScrollEnabled = (0, $34oCh.useIsInfiniteScrollEnabled)();
    // Use new Visual Refresh footer order if visual refresh or any m1 features are enabled to
    // simplfiy the number of cases we need to handle with the new features.
    const isNewFooterOrderEnabled = (0, $6XJko.isVisualRefreshEnabled)() || isIssueCreateEnabled || isInfiniteScrollEnabled;
    let start;
    let center;
    let end;
    // Show pagination controls only when discrete pagination is enabled
    if (onPageChange && !isInfiniteScrollEnabled) {
        const paginationControls = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lfz0B.PaginationControls), {
            issues: issueData,
            onPageChange: (after)=>onPageChange(after, false),
            isNewFooterOrderEnabled: isNewFooterOrderEnabled
        });
        if (isNewFooterOrderEnabled) center = paginationControls;
        else end = paginationControls;
    }
    // Show issue count when either pagination or infinite scroll are enabled
    if (onPageChange || isInfiniteScrollEnabled) {
        const moveIssueCountToEnd = isMakeSpaceForGlobalRovoButtonEnabled && (0, $4cTDP.fg)('global_rovo_button_in_jira') ? center !== undefined : isNewFooterOrderEnabled;
        const issueCount = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g212q.default), {
            issues: issueData,
            IssueCount: IssueCount,
            isNewFooterOrderEnabled: moveIssueCountToEnd,
            isInfiniteScrollEnabled: isInfiniteScrollEnabled
        });
        if (moveIssueCountToEnd) end = issueCount;
        else center = issueCount;
    }
    const hasIssues = (issueData.totalIssueSearchResultCount ?? 0) > 0;
    const hasIssueConnectionControls = hasIssues && (!!onPageChange || isInfiniteScrollEnabled);
    const hasControlsToDisplay = hasIssueConnectionControls || isIssueCreateEnabled;
    // Hide the footer if we have no issues UNLESS the consumer has provided a custom footer component, in which case
    // the consumer becomes responsible for when the footer should be shown/hidden.
    if (!hasControlsToDisplay && !Footer) return null;
    const FooterToRender = Footer ?? (0, $4ohGb.Footer);
    if (isIssueCreateEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kmFBu.IssueCreateFooter), {
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        Footer: FooterToRender,
        rankField: rankFieldData ?? null,
        start: start,
        center: center,
        end: end,
        issues: issueData,
        canShowAdditionalFields: canShowAdditionalFields,
        footerBorderRadius: footerBorderRadius,
        topLevelIssueCreateConfig: topLevelIssueCreateConfig
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FooterToRender, {
        start: start,
        center: center,
        end: end
    });
};
var $734acbe44f1f7d3b$export$2e2bcd8739ae039 = $734acbe44f1f7d3b$var$FooterRenderer;

});
parcelRegister("698UM", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b074ec87456f033$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cca09b170ab2d2818122119c2cf83406>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2b074ec87456f033$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "FooterRenderer_rank",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "IssueCreateFooter_rankField"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$2b074ec87456f033$var$node.hash = "1a295e01caab47d2d434a50b4c74845e";
var $2b074ec87456f033$export$2e2bcd8739ae039 = $2b074ec87456f033$var$node;

});

parcelRegister("33Zg7", function(module, exports) {
$parcel$export(module.exports, "default", () => $b167ff6216a82293$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7d47dafec3f3560d64fc18784e02d428>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b167ff6216a82293$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageSize"
        }
    ],
    "kind": "Fragment",
    "name": "FooterRenderer",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "IssueCountRenderer"
        },
        {
            "kind": "FragmentSpread",
            "name": "IssueCreateFooter"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "pageSize",
                    "variableName": "pageSize"
                }
            ],
            "kind": "FragmentSpread",
            "name": "PaginationControls"
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        }
    ],
    "type": "JiraIssueConnection"
};
$b167ff6216a82293$var$node.hash = "3b4b5fcc961dfdfdc9948a5e19cf7228";
var $b167ff6216a82293$export$2e2bcd8739ae039 = $b167ff6216a82293$var$node;

});

parcelRegister("4ohGb", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $74e7263cd9d59bbd$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $kbYhH = parcelRequire("kbYhH");

var $7n9BS = parcelRequire("7n9BS");
const $74e7263cd9d59bbd$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ start: start = $74e7263cd9d59bbd$var$SpacerElement, center: center = $74e7263cd9d59bbd$var$SpacerElement, end: end = $74e7263cd9d59bbd$var$SpacerElement }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterBase, {
        ref: ref
    }, start, center, end);
});
const $74e7263cd9d59bbd$var$FooterBase = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, ref)=>{
    const tableHeight = (0, $kbYhH.useElementSizeSelector)((size)=>size.height);
    const hasShadow = (0, $7n9BS.useScrollStateSelector)((scrollState)=>{
        const { height: containerHeight, scrollTop: scrollTop } = scrollState;
        // Scroll measurements are fractional, while height measurements are integer, so we need to round before comparing
        return containerHeight < tableHeight && Math.round(scrollTop) < tableHeight - containerHeight;
    });
    return (0, $4cTDP.fg)('reduce_size_of_scroll_container_shadow') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterWrapper, null, hasShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterShadow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterContainer, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ref: ref,
        "data-testid": "native-issue-table.common.ui.components.footer.footer-container",
        hasShadow: false
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterContainer, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ref: ref,
        "data-testid": "native-issue-table.common.ui.components.footer.footer-container",
        hasShadow: hasShadow
    }, children);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $74e7263cd9d59bbd$var$FooterWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$var$FooterShadow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _4t3i1y44 _lcxvglyw _16qs1nax",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$var$FooterContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasShadow: hasShadow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3doj0fz _1e0c1txw _2lx2vrvc _1n261q9c _kqsw1if8 _1ltvidpf _94n5idpf _bfhkvuon _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.hasShadow && "_16qs2iat",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$var$SpacerElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$export$d7a54cba636a8cd6, null);

});
parcelRegister("7n9BS", function(module, exports) {
$parcel$export(module.exports, "useScrollStateActions", () => $fb5e49bfa6da600b$export$f4fa046095d4d6af);
$parcel$export(module.exports, "useScrollStateSelector", () => $fb5e49bfa6da600b$export$a2d79f83724ed591);
$parcel$export(module.exports, "useScrollElement", () => $fb5e49bfa6da600b$export$fae04c81b2201f65);
$parcel$export(module.exports, "ScrollStateProvider", () => $fb5e49bfa6da600b$export$9f9741e7dc6bdb9b);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $8jOO7 = parcelRequire("8jOO7");
const $fb5e49bfa6da600b$export$50b6b7783d156e1b = 200;
const $fb5e49bfa6da600b$export$f9abcb6f103965a2 = (0, $6E16M.createContainer)();
const $fb5e49bfa6da600b$var$INITIAL_SCROLL_STATE = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    scrollTop: 0,
    scrollLeft: 0,
    isScrolling: false,
    scrollElement: null,
    hasScrolled: false
};
const $fb5e49bfa6da600b$var$actions = {
    update: (newState)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                ...newState
            });
        },
    getScrollInfo: ()=>({ getState: getState })=>{
            const { scrollElement: scrollElement, isScrolling: isScrolling, width: width } = getState();
            return {
                isScrolling: isScrolling,
                scrollElement: scrollElement,
                // Calculated by adding the scroll container’s left and right positions relative to the viewport to the table width to get the total horizontal space
                isSmallScreen: width + (scrollElement?.getBoundingClientRect().left ?? 0) + (scrollElement?.getBoundingClientRect().right ?? 0) < (0, $8jOO7.SMALL_SCREEN_WIDTH) && width !== 0
            };
        }
};
const $fb5e49bfa6da600b$var$Store = (0, $GtRbT.createStore)({
    containedBy: $fb5e49bfa6da600b$export$f9abcb6f103965a2,
    initialState: $fb5e49bfa6da600b$var$INITIAL_SCROLL_STATE,
    name: 'ScrollStateManager',
    actions: $fb5e49bfa6da600b$var$actions
});
const $fb5e49bfa6da600b$export$f4fa046095d4d6af = (0, $iJq0l.createActionsHook)($fb5e49bfa6da600b$var$Store);
const $fb5e49bfa6da600b$export$a2d79f83724ed591 = (0, $iJq0l.createStateHook)($fb5e49bfa6da600b$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $fb5e49bfa6da600b$export$fae04c81b2201f65 = (0, $iJq0l.createStateHook)($fb5e49bfa6da600b$var$Store, {
    selector: (state)=>state.scrollElement
});
const $fb5e49bfa6da600b$var$attachResizeObserver = (callback, targetEl)=>{
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!targetEl) return ()=>{};
    let resizeObserver = null;
    // SSR fix. Do not instantiate for SSR
    if (typeof ResizeObserver !== 'undefined') resizeObserver = new ResizeObserver(()=>callback());
    // When mounting our listener, if its the Window object, treat it as such.
    // This can happen in Storybook but not in any other scenario
    if (targetEl instanceof Window) targetEl.addEventListener('resize', callback);
    else resizeObserver?.observe(targetEl);
    return ()=>{
        // Cleanup the resize callback we have attached
        if (targetEl instanceof Window) targetEl.removeEventListener('resize', callback);
        else resizeObserver?.disconnect();
    };
};
/**
 * Listens for scroll events on the `HTMLElement` `scrollRef.current` and updates a state
 * variable with the scroll state, which is returned.
 */ const $fb5e49bfa6da600b$var$useElementScrollState = (scrollRef)=>{
    const { update: update } = $fb5e49bfa6da600b$export$f4fa046095d4d6af();
    (0, $eJOHy.useEffect)(()=>{
        const targetEl = scrollRef.current;
        // The element should always exists as the useEffect triggers after the reference is assigned.
        if (!targetEl) return undefined;
        let clearScrollingTimeoutId;
        const onScroll = ()=>{
            update({
                scrollWidth: targetEl.scrollWidth,
                scrollTop: targetEl.scrollTop,
                scrollLeft: targetEl.scrollLeft,
                isScrolling: true,
                hasScrolled: true
            });
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                update({
                    scrollWidth: targetEl.scrollWidth,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: false
                });
            }, $fb5e49bfa6da600b$export$50b6b7783d156e1b);
        };
        const onResize = ()=>{
            update({
                scrollTop: targetEl.scrollTop,
                scrollLeft: targetEl.scrollLeft,
                height: targetEl.clientHeight,
                width: targetEl.clientWidth,
                scrollHeight: targetEl.scrollHeight,
                scrollWidth: targetEl.scrollWidth,
                isScrolling: true
            });
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                update({
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: false
                });
            }, $fb5e49bfa6da600b$export$50b6b7783d156e1b);
        };
        // We want to know when the scroll element/container itself resizes as this impacts
        // the number of rows we show
        const cleanupResizeObserver = $fb5e49bfa6da600b$var$attachResizeObserver(onResize, targetEl);
        targetEl.addEventListener('scroll', onScroll);
        update({
            height: targetEl.clientHeight,
            width: targetEl.clientWidth,
            scrollHeight: targetEl.scrollHeight,
            scrollWidth: targetEl.scrollWidth,
            scrollTop: targetEl.scrollTop,
            scrollLeft: targetEl.scrollLeft,
            isScrolling: false,
            scrollElement: targetEl
        });
        return ()=>{
            targetEl.removeEventListener('scroll', onScroll);
            cleanupResizeObserver();
            clearTimeout(clearScrollingTimeoutId);
        };
    }, [
        scrollRef,
        update
    ]);
};
const $fb5e49bfa6da600b$var$ScrollStateProviderInner = ({ scrollRef: scrollRef, children: children })=>{
    $fb5e49bfa6da600b$var$useElementScrollState(scrollRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $fb5e49bfa6da600b$export$9f9741e7dc6bdb9b = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb5e49bfa6da600b$export$f9abcb6f103965a2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb5e49bfa6da600b$var$ScrollStateProviderInner, props));
};

});


parcelRegister("g212q", function(module, exports) {
$parcel$export(module.exports, "default", () => $84a76d68624b4129$export$2e2bcd8739ae039);

var $2AIGx = parcelRequire("2AIGx");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2bNYj = parcelRequire("2bNYj");
const $84a76d68624b4129$var$IssueCountRenderer = ({ issues: issues, IssueCount: IssueCount = (0, $2bNYj.IssueCount), isNewFooterOrderEnabled: isNewFooterOrderEnabled, isInfiniteScrollEnabled: isInfiniteScrollEnabled })=>{
    const data = (0, $j4oe4.useFragment)((0, $2AIGx.default), issues);
    const startIssueRange = data.issueNavigatorPageInfo?.firstIssuePosition ?? 0;
    const endIssueRange = data.issueNavigatorPageInfo?.lastIssuePosition ?? 0;
    const loadedIssuesCount = data.edges?.length ?? 0;
    const total = data.totalIssueSearchResultCount ?? 0;
    const countExceedsMaxResults = !!data.isCappingIssueSearchResult;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IssueCount, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange,
        loadedIssuesCount: loadedIssuesCount,
        total: total,
        countExceedsMaxResults: countExceedsMaxResults,
        isNewFooterOrderEnabled: isNewFooterOrderEnabled,
        isInfiniteScrollEnabled: isInfiniteScrollEnabled
    });
};
var $84a76d68624b4129$export$2e2bcd8739ae039 = $84a76d68624b4129$var$IssueCountRenderer;

});
parcelRegister("2AIGx", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f09ed86cfc13a5f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d2de91d8ec54b88dc57599501ba85984>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4f09ed86cfc13a5f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueCountRenderer",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        },
        {
            "concreteType": "JiraIssueNavigatorPageInfo",
            "kind": "LinkedField",
            "name": "issueNavigatorPageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "firstIssuePosition"
                },
                {
                    "kind": "ScalarField",
                    "name": "lastIssuePosition"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$4f09ed86cfc13a5f$var$node.hash = "a7311216a2dbc3d7090b0f6d487ae3d3";
var $4f09ed86cfc13a5f$export$2e2bcd8739ae039 = $4f09ed86cfc13a5f$var$node;

});

parcelRegister("2bNYj", function(module, exports) {
$parcel$export(module.exports, "IssueCount", () => $efade5dddaf06e66$export$542fba90cc9c1bd1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $iIICj = parcelRequire("iIICj");
const $efade5dddaf06e66$export$542fba90cc9c1bd1 = ({ startIssueRange: startIssueRange, endIssueRange: endIssueRange, loadedIssuesCount: loadedIssuesCount, total: total, countExceedsMaxResults: countExceedsMaxResults, isNewFooterOrderEnabled: isNewFooterOrderEnabled, isInfiniteScrollEnabled: isInfiniteScrollEnabled })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const totalNumberIssues = countExceedsMaxResults ? `${total}+` : total;
    const isTotalUnknown = total <= 0;
    if (isInfiniteScrollEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($efade5dddaf06e66$var$IssueCountContainer, {
        "data-testid": "native-issue-table.ui.footer-renderer.issue-count-renderer.issue-count.issue-count",
        isFlexEnd: true
    }, isTotalUnknown ? String(loadedIssuesCount) : formatMessage((0, $iIICj.default).loadedIssuesTotalKnown, {
        loadedIssuesCount: loadedIssuesCount,
        totalNumberIssues: totalNumberIssues
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($efade5dddaf06e66$var$IssueCountContainer, {
        "data-testid": "native-issue-table.ui.footer-renderer.issue-count-renderer.issue-count.issue-count",
        isFlexEnd: isNewFooterOrderEnabled
    }, isTotalUnknown ? formatMessage((0, $iIICj.default).issueRangeUnknown, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange
    }) : formatMessage((0, $iIICj.default).issueRangeKnown, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange,
        totalNumberIssues: totalNumberIssues
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efade5dddaf06e66$var$IssueCountContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexEnd: isFlexEnd, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _k48p1pd9",
            __cmplp.isFlexEnd ? "_1bahesu3" : "_1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iIICj", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfb9f623cbed4390$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $bfb9f623cbed4390$var$messages = (0, $7qGN1.defineMessages)({
    loadedIssuesTotalKnown: {
        "id": "native-issue-table.footer-renderer.issue-count-renderer.issue-count.loaded-issues-total-known",
        "defaultMessage": "{loadedIssuesCount} of {totalNumberIssues}"
    },
    issueRangeKnown: {
        "id": "native-issue-table.footer-renderer.issue-count-renderer.issue-count.issue-range-known",
        "defaultMessage": "{startIssueRange}-{endIssueRange} of {totalNumberIssues}"
    },
    issueRangeUnknown: {
        "id": "native-issue-table.footer-renderer.issue-count-renderer.issue-count.issue-range-unknown",
        "defaultMessage": "{startIssueRange}-{endIssueRange}"
    }
});
var $bfb9f623cbed4390$export$2e2bcd8739ae039 = $bfb9f623cbed4390$var$messages;

});



parcelRegister("kmFBu", function(module, exports) {
$parcel$export(module.exports, "IssueCreateFooter", () => $190f8104c06ec555$export$e3ef2bbdafbe53d8);

var $3HvIh = parcelRequire("3HvIh");

var $1fKiW = parcelRequire("1fKiW");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $79KhM = parcelRequire("79KhM");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $68iTT = parcelRequire("68iTT");

var $6xIZT = parcelRequire("6xIZT");

var $1cMAs = parcelRequire("1cMAs");

var $4cTDP = parcelRequire("4cTDP");

var $64b9C = parcelRequire("64b9C");


var $4ohGb = parcelRequire("4ohGb");

var $34oCh = parcelRequire("34oCh");

var $3F6xT = parcelRequire("3F6xT");

var $aNnbk = parcelRequire("aNnbk");
const $190f8104c06ec555$var$FormWithInsertionPoint = ({ connectionId: connectionId, rankFieldId: rankFieldId, rankFieldTerms: rankFieldTerms, footerBorderRadius: footerBorderRadius, ...props })=>{
    const insertionPoint = (0, $3F6xT.useCalculateIssueInsertionPoint)();
    const jql = (0, $34oCh.useJql)();
    const handleIssueCreate = (0, $aNnbk.useIssueCreateMutation)({
        issueConnectionId: connectionId,
        jql: jql,
        ...(0, $4cTDP.fg)('jsc_list_reranking_gate') && {
            rankFieldTerms: rankFieldTerms
        },
        ...(0, $4cTDP.fg)('jira_timeline_analytics_harmonization_v2') && {
            location: 'footerCreateForm'
        }
    });
    const isIssueRankDescending = (0, $34oCh.useIsIssueRankDescending)();
    const isIssueRankingEnabled = (0, $34oCh.useIsIssueRankingEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const formContextualFields = (0, $eJOHy.useMemo)(()=>{
        if (!isIssueRankingEnabled || !(0, $4cTDP.fg)('jsc_list_reranking_gate')) return undefined;
        if (isIssueRankDescending) return insertionPoint?.position === 'below' ? {
            rankBeforeIssueId: insertionPoint?.issueId,
            rankFieldId: rankFieldId
        } : {
            rankAfterIssueId: insertionPoint?.issueId,
            rankFieldId: rankFieldId
        };
        return insertionPoint?.position === 'below' ? {
            rankAfterIssueId: insertionPoint?.issueId,
            rankFieldId: rankFieldId
        } : {
            rankBeforeIssueId: insertionPoint?.issueId,
            rankFieldId: rankFieldId
        };
    }, [
        insertionPoint?.issueId,
        insertionPoint?.position,
        isIssueRankDescending,
        isIssueRankingEnabled,
        rankFieldId
    ]);
    const handleIssueCreateWithInsertionPoint = (0, $eJOHy.useCallback)((issueToCreate, contextualFields)=>{
        if (insertionPoint == null) return handleIssueCreate(issueToCreate, contextualFields);
        return handleIssueCreate(issueToCreate, contextualFields, {
            insertAfter: insertionPoint.position === 'below',
            insertNodeId: insertionPoint.issueId
        });
    }, [
        handleIssueCreate,
        insertionPoint
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $190f8104c06ec555$var$formContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6xIZT.default), {
        ...props,
        onCreateIssue: handleIssueCreateWithInsertionPoint,
        rankFieldId: rankFieldId,
        contextualFields: formContextualFields,
        isTimeline: isTimelineEnabled,
        footerBorderRadius: footerBorderRadius
    }));
};
const $190f8104c06ec555$var$nudgeRuntimeProps = {};
const $190f8104c06ec555$export$e3ef2bbdafbe53d8 = ({ Footer: // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
Footer = (0, $4ohGb.Footer), issues: issues, rankField: rankField, canShowAdditionalFields: canShowAdditionalFields, footerBorderRadius: footerBorderRadius, topLevelIssueCreateConfig: topLevelIssueCreateConfig, ...footerProps })=>{
    const issueData = (0, $j4oe4.useFragment)((0, $1fKiW.default), issues);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $3HvIh.default), rankField ?? null);
    const projectContext = (0, $34oCh.useProjectContext)();
    const isFormRendered = (0, $eJOHy.useRef)(false);
    const inlineCreateHandlersInput = (0, $4cTDP.fg)('timeline_harmonisation_m3_targeting') ? {
        projectKey: projectContext,
        maxHierarchyLevel: topLevelIssueCreateConfig?.maxHierarchyLevel,
        minHierarchyLevel: topLevelIssueCreateConfig?.minHierarchyLevel ?? 0
    } : {
        projectKey: projectContext,
        minHierarchyLevel: 0
    };
    const { isFormVisible: isFormVisible, formProps: formProps, triggerProps: triggerProps } = (0, $68iTT.useInlineCreateHandlers)(inlineCreateHandlersInput);
    const rankFieldTerms = (0, $eJOHy.useMemo)(()=>({
            jqlTerm: rankFieldData?.jqlTerm ?? null,
            aliases: rankFieldData?.aliases ? Array.from(rankFieldData.aliases) : null
        }), [
        rankFieldData
    ]);
    const isProjectQuickstartOnboardingEnabled = (0, $34oCh.useIsProjectQuickstartOnboardingEnabled)();
    const isNudgeTargetEnabled = isProjectQuickstartOnboardingEnabled && (0, $4cTDP.fg)('jira_list_nin_merge');
    const { ref: gettingStartedListNudgeRef } = (0, $79KhM.useRegisterNudgeTarget)((0, $2b839a8453de5367$export$c6df9a2c7447e12d), isNudgeTargetEnabled);
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    if (isFormVisible) {
        isFormRendered.current = true;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($190f8104c06ec555$var$FormWithInsertionPoint, {
            connectionId: issueData?.__id,
            rankFieldId: rankFieldData?.fieldId ?? null,
            rankFieldTerms: rankFieldTerms,
            ...formProps,
            appearance: "footer",
            depth: 0,
            ...(0, $4cTDP.fg)('refactor_issue_table_for_timline') ? {
                canShowAdditionalFields: canShowAdditionalFields
            } : {
                canShowAdditionalFields: !isTimelineEnabled
            },
            footerBorderRadius: footerBorderRadius
        });
    }
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Footer, {
        ref: (0, $4cTDP.fg)('jira_list_nin_merge') ? gettingStartedListNudgeRef : undefined,
        ...footerProps,
        start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $190f8104c06ec555$var$triggerContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1cMAs.default), {
            ...triggerProps,
            isFormRendered: isFormRendered.current
        }))
    });
    if (isNudgeTargetEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $64b9C.GetStartedListNudge), {
        runtimeProps: $190f8104c06ec555$var$nudgeRuntimeProps
    }, footer);
    return footer;
};
const $190f8104c06ec555$var$BORDER_WIDTH = '1px';
const $190f8104c06ec555$var$formContainerStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface',
    boxShadow: 'elevation.shadow.overflow',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: $190f8104c06ec555$var$BORDER_WIDTH,
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopStyle: 'solid',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopColor: 'color.border'
});
const $190f8104c06ec555$var$triggerContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    minHeight: '32px'
});

});
parcelRegister("3HvIh", function(module, exports) {
$parcel$export(module.exports, "default", () => $58ef85485237ff91$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e642f5e9e155c4c7a57efe47d3149c5b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $58ef85485237ff91$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "IssueCreateFooter_rankField",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "jqlTerm"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "aliases"
                }
            ]
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$58ef85485237ff91$var$node.hash = "a4046922d80cd423f4205dcd4a424119";
var $58ef85485237ff91$export$2e2bcd8739ae039 = $58ef85485237ff91$var$node;

});

parcelRegister("1fKiW", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ae8bf8cac4e98f0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<37ee5eaec597e35d55dbb7615ad2f6b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9ae8bf8cac4e98f0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueCreateFooter",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$9ae8bf8cac4e98f0$var$node.hash = "bb4169454bfd5537e0b923f7af0c8e7e";
var $9ae8bf8cac4e98f0$export$2e2bcd8739ae039 = $9ae8bf8cac4e98f0$var$node;

});

parcelRegister("68iTT", function(module, exports) {
$parcel$export(module.exports, "useInlineCreateHandlers", () => $f2e349346c4eb6b1$export$bec6eb88acc84895);

var $eJOHy = parcelRequire("eJOHy");

var $dZ3jN = parcelRequire("dZ3jN");

var $bzbsd = parcelRequire("bzbsd");

var $4cTDP = parcelRequire("4cTDP");

var $6xIZT = parcelRequire("6xIZT");

var $1Ob2L = parcelRequire("1Ob2L");

var $1cMAs = parcelRequire("1cMAs");
const $f2e349346c4eb6b1$export$bec6eb88acc84895 = ({ projectKey: projectKey, defaultAssigneeId: defaultAssigneeId, minHierarchyLevel: minHierarchyLevel, maxHierarchyLevel: maxHierarchyLevel })=>{
    const [isFormVisible, setIsFormVisible] = (0, $eJOHy.useState)(false);
    const formIssueDraftRef = (0, $eJOHy.useRef)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $1Ob2L.useInlineIssueCreateEntryPoint)(projectKey, minHierarchyLevel, maxHierarchyLevel);
    const ref = (0, $eJOHy.useRef)(null);
    const buttonRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions);
    const handleTriggerClick = (0, $eJOHy.useCallback)(()=>{
        setIsFormVisible(true);
    }, []);
    const handleFormCancel = (0, $eJOHy.useCallback)(()=>{
        setIsFormVisible(false);
        ref.current?.focus();
    }, []);
    const onDraftUpdate = (0, $eJOHy.useCallback)((issueDraft)=>{
        formIssueDraftRef.current = issueDraft;
    }, []);
    const { entryPointActions: additionalFieldsEntryPointActions, entryPointReferenceSubject: additionalFieldsEntryPointSubject } = (0, $1Ob2L.useInlineIssueCreateAdditionalFieldsEntryPoint)({
        projectKey: projectKey,
        defaultAssigneeId: defaultAssigneeId
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const additionalFieldsRef = (0, $dZ3jN.useEntryPointButtonTrigger)(additionalFieldsEntryPointActions);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const mergedRefWithAdditionalFields = (0, $bzbsd.default)(ref, buttonRef, additionalFieldsRef);
    if ((0, $4cTDP.fg)('memoize_inline_create_handlers')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const formProps = (0, $eJOHy.useMemo)(()=>({
                initialIssueDraft: formIssueDraftRef.current,
                getInitialIssueDraft: ()=>formIssueDraftRef.current,
                onDraftUpdate: onDraftUpdate,
                onCancel: handleFormCancel,
                entryPointSubject: entryPointReferenceSubject,
                additionalFieldsEntryPointSubject: additionalFieldsEntryPointSubject
            }), [
            additionalFieldsEntryPointSubject,
            entryPointReferenceSubject,
            handleFormCancel,
            onDraftUpdate
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const triggerProps = (0, $eJOHy.useMemo)(()=>({
                onClick: handleTriggerClick,
                ref: mergedRefWithAdditionalFields
            }), [
            handleTriggerClick,
            mergedRefWithAdditionalFields
        ]);
        return {
            isFormVisible: isFormVisible,
            entryPointActions: entryPointActions,
            additionalFieldsEntryPointActions: additionalFieldsEntryPointActions,
            formProps: formProps,
            triggerProps: triggerProps
        };
    }
    return {
        isFormVisible: isFormVisible,
        entryPointActions: entryPointActions,
        additionalFieldsEntryPointActions: additionalFieldsEntryPointActions,
        formProps: {
            initialIssueDraft: formIssueDraftRef.current,
            onDraftUpdate: onDraftUpdate,
            onCancel: handleFormCancel,
            entryPointSubject: entryPointReferenceSubject,
            additionalFieldsEntryPointSubject: additionalFieldsEntryPointSubject
        },
        triggerProps: {
            onClick: handleTriggerClick,
            ref: mergedRefWithAdditionalFields
        }
    };
};
const $f2e349346c4eb6b1$var$InlineCreate = ({ projectKey: projectKey, minHierarchyLevel: minHierarchyLevel, ...formProps })=>{
    const { isFormVisible: isFormVisible, formProps: formPropsAdditional, triggerProps: triggerProps } = $f2e349346c4eb6b1$export$bec6eb88acc84895({
        projectKey: projectKey,
        minHierarchyLevel: minHierarchyLevel
    });
    return isFormVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6xIZT.default), {
        ...formProps,
        ...formPropsAdditional
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1cMAs.default), triggerProps);
};
var $f2e349346c4eb6b1$export$2e2bcd8739ae039 = $f2e349346c4eb6b1$var$InlineCreate;

});
parcelRegister("6xIZT", function(module, exports) {
$parcel$export(module.exports, "default", () => $6479a1a8f48bc6cf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $cBavF = parcelRequire("cBavF");

var $5vQ2T = parcelRequire("5vQ2T");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $j8Km1 = parcelRequire("j8Km1");

var $cxKOj = parcelRequire("cxKOj");

var $bJscI = parcelRequire("bJscI");


var $gBHpC = parcelRequire("gBHpC");

var $ljpuj = parcelRequire("ljpuj");

var $eNuUB = parcelRequire("eNuUB");

var $ab4Fp = parcelRequire("ab4Fp");

const $6479a1a8f48bc6cf$var$ICON_WIDTH = 24;
const $6479a1a8f48bc6cf$var$PADDING = 8;
const $6479a1a8f48bc6cf$var$HIERARCHY_LEVEL_PADDING = 12;
const $6479a1a8f48bc6cf$var$ICC_ICON_PADDING = 6;
const $6479a1a8f48bc6cf$export$35cad9398ceaeef0 = ()=>{
    const isReadyRef = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        setTimeout(()=>{
            isReadyRef.current = true;
        }, 100);
    }, []);
    return isReadyRef;
};
const $6479a1a8f48bc6cf$var$isComposing = (event)=>event.nativeEvent.isComposing;
const $6479a1a8f48bc6cf$export$848553d86b9bee59 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ljpuj.IssueTypeDropdown), {
        project: null,
        onChange: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onProjectChange: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        selectedType: null
    });
const $6479a1a8f48bc6cf$var$calledFromSource = 'issueTable';
const $6479a1a8f48bc6cf$var$InlineCreateForm = ({ initialIssueDraft: initialIssueDraftProp, getInitialIssueDraft: getInitialIssueDraft, onDraftUpdate: onDraftUpdate, onCreateIssue: onCreateIssue, onCancel: onCancel, entryPointSubject: entryPointSubject, appearance: appearance = 'row', depth: depth = 0, columns: columns, isGrouping: isGrouping, additionalFieldsEntryPointSubject: additionalFieldsEntryPointSubject, location: location, isTimeline: isTimeline, canShowAdditionalFields: canShowAdditionalFields, isSearchable: isSearchable, footerBorderRadius: footerBorderRadius })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isManageIssueTypesModalOpen, setIsManageIssueTypesModalOpen] = (0, $eJOHy.useState)(false);
    const initialIssueDraft = (0, $4cTDP.fg)('memoize_inline_create_handlers') ? getInitialIssueDraft?.() : initialIssueDraftProp;
    const [textContent, setTextContent] = (0, $eJOHy.useState)(initialIssueDraft?.summary ?? '');
    const [selectedType, setSelectedType] = (0, $eJOHy.useState)(initialIssueDraft?.issueType ?? null);
    const [selectedProject, setSelectedProject] = (0, $eJOHy.useState)(initialIssueDraft?.project ?? null); // assignee would be undefined initially, when user selects unassigned user from picker then it will be null
    // Default assignee is fetched from the entrypoint
    const initialAssignee = (0, $eJOHy.useMemo)(()=>initialIssueDraft?.assignee ? {
            accountId: initialIssueDraft.assignee.accountId,
            displayName: initialIssueDraft.assignee.name,
            avatarUrls: {
                '48x48': initialIssueDraft.assignee.picture
            }
        } : undefined, [
        initialIssueDraft?.assignee
    ]);
    const [assignee, setAssignee] = (0, $eJOHy.useState)(initialAssignee);
    const [dueDate, setDueDate] = (0, $eJOHy.useState)(initialIssueDraft?.dueDate ?? null);
    const [isUpdatingAdditionalFields, setIsUpdatingAdditionalFields] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-live-state-to-parent
        onDraftUpdate?.({
            summary: textContent,
            project: selectedProject ?? undefined,
            issueType: selectedType ?? undefined,
            ...assignee ? {
                assignee: {
                    accountId: assignee.accountId ?? '',
                    name: assignee.displayName,
                    picture: assignee.avatarUrls['48x48'] ?? ''
                }
            } : {},
            ...dueDate != null ? {
                dueDate: dueDate
            } : {}
        });
    }, [
        onDraftUpdate,
        selectedProject,
        selectedType,
        textContent,
        assignee,
        dueDate
    ]);
    const formRef = (0, $eJOHy.useRef)(null);
    const isEmptyRef = (0, $eJOHy.useRef)(true);
    const textAreaRef = (0, $eJOHy.useRef)(null);
    isEmptyRef.current = textContent.trim().length === 0;
    const contextualFields = (0, $gBHpC.useIssueCreateContextualFields)(); // prevent blurring from occurring when the form is first rendered
    const isReadyRef = $6479a1a8f48bc6cf$export$35cad9398ceaeef0();
    const handleCreateIssue = (0, $eJOHy.useCallback)(()=>{
        if (!isEmptyRef.current && selectedType && selectedProject) {
            onCreateIssue({
                summary: textContent,
                project: selectedProject,
                issueType: selectedType,
                ...assignee ? {
                    assignee: {
                        accountId: assignee.accountId ?? '',
                        name: assignee.displayName ?? '',
                        picture: assignee.avatarUrls['48x48'] ?? ''
                    }
                } : {},
                ...dueDate != null ? {
                    dueDate: dueDate
                } : {}
            }, contextualFields);
            setTextContent('');
            setAssignee(undefined);
            setDueDate(null);
        }
    }, [
        contextualFields,
        onCreateIssue,
        selectedProject,
        selectedType,
        textContent,
        assignee,
        dueDate
    ]);
    const handleCreateIssueRef = (0, $eJOHy.useRef)(handleCreateIssue);
    handleCreateIssueRef.current = handleCreateIssue;
    const handleBlur = (0, $eJOHy.useCallback)((event)=>{
        if (!isReadyRef.current || isManageIssueTypesModalOpen && (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg')) return;
         // make sure to make a local copy of the isEmptyRef value before it gets reset by the create handler
        const formEmpty = isEmptyRef.current; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const inForm = formRef.current?.contains(event.target) ?? false; // Don't close ICC when additional fields (assignee/due date pickers) are active
        // This prevents the ICC from closing when users click outside the pickers in NIN for both Software and Business
        if (isUpdatingAdditionalFields) {
            if (!inForm) {
                setTimeout(()=>{
                    textAreaRef.current?.focus();
                }, 0);
                if ((0, $4cTDP.fg)('jifjam2_icc_fix')) setIsUpdatingAdditionalFields(false);
            }
            return;
        }
        if (!inForm) {
            onCancel?.();
            event.stopPropagation();
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'form blurred', 'inlineCreate', {
                formEmpty: formEmpty,
                escapeKeyPressed: false
            });
        }
    }, [
        isReadyRef,
        isManageIssueTypesModalOpen,
        isUpdatingAdditionalFields,
        onCancel,
        createAnalyticsEvent
    ]);
    const handleChange = (0, $eJOHy.useCallback)((e)=>{
        const content = e.target.value.replace(/[\n\r]+/g, ' ');
        setTextContent(content);
    }, []);
    const handleIssueTypeChange = (0, $eJOHy.useCallback)((newType, isSelected)=>{
        setSelectedType(newType);
        if (isSelected) setTimeout(()=>{
            textAreaRef.current?.focus();
        }, 0);
    }, []);
    const handleKeyDown = (0, $eJOHy.useCallback)((e)=>{
        if (e.key === 'Enter' && !$6479a1a8f48bc6cf$var$isComposing(e)) {
            e.preventDefault();
            handleCreateIssue();
        }
    }, [
        handleCreateIssue
    ]);
    const handleFormKeyDown = (0, $eJOHy.useCallback)((e)=>{
        if (!isUpdatingAdditionalFields) e.stopPropagation();
    }, [
        isUpdatingAdditionalFields
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        handleCreateIssue();
    }, [
        handleCreateIssue
    ]);
    const handleCreateButtonClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'inlineCreateSubmit');
    }, [
        createAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // on mount, we want to move the cursor to the end of the input
        // TODO; Add test for this feature once we support pre-population of the summary
        textAreaRef.current?.setSelectionRange(textAreaRef.current.value.length, textAreaRef.current.value.length);
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'form focused', 'inlineCreate', {
            location: location
        });
    }, [
        createAnalyticsEvent,
        location
    ]);
    const handleEscape = (0, $eJOHy.useCallback)((e)=>{
        const isAdditionalFieldsPickersActive = isUpdatingAdditionalFields;
        if (!isAdditionalFieldsPickersActive && !(isManageIssueTypesModalOpen && (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg'))) {
            e.stopPropagation();
            if (e.key === 'Escape') {
                onCancel?.();
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'form blurred', 'inlineCreate', {
                    formEmpty: isEmptyRef.current,
                    escapeKeyPressed: true
                });
            }
        }
        if (e.key === 'Enter') {
            if (e.target === textAreaRef.current) {
                e.preventDefault();
                handleCreateIssue();
            }
        }
    }, [
        isUpdatingAdditionalFields,
        isManageIssueTypesModalOpen,
        onCancel,
        createAnalyticsEvent,
        handleCreateIssue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!false) {
            document.addEventListener('click', handleBlur, true);
            document.addEventListener('keydown', handleEscape, true); // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            document.addEventListener('dragstart', handleBlur, true);
            return ()=>{
                document.removeEventListener('click', handleBlur, true);
                document.removeEventListener('keydown', handleEscape, true);
                document.removeEventListener('dragstart', handleBlur, true);
            };
        }
    }, [
        handleBlur,
        handleEscape
    ]);
    const padding = (0, $4cTDP.fg)('jira_list_merged_column_gate') ? $6479a1a8f48bc6cf$var$HIERARCHY_LEVEL_PADDING : $6479a1a8f48bc6cf$var$PADDING;
    let paddingLeft = depth > 1 ? (depth - 1) * $6479a1a8f48bc6cf$var$ICON_WIDTH + padding : padding;
    const mergedColumn = (0, $4cTDP.fg)('jira_list_merged_column_gate') ? columns?.find(({ id: id })=>id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN)) : undefined;
    if (mergedColumn && !isGrouping) {
        // For merged columns, use the same padding calculation as MergedCell component:
        // paddingLeft: `${HIERARCHY_LEVEL_PADDING * depth + CELL_PADDING}px`
        // This matches the logic in MergedCell.tsx minus the ICC icon padding;
        paddingLeft = $6479a1a8f48bc6cf$var$HIERARCHY_LEVEL_PADDING * depth + $6479a1a8f48bc6cf$var$PADDING - $6479a1a8f48bc6cf$var$ICC_ICON_PADDING; // Add checkbox column width if present
        const checkboxColumnWidth = columns?.find(({ id: id })=>id === (0, $j8Km1.COLUMN_ID_CHECKBOX))?.defaultWidth ?? 0;
        paddingLeft += checkboxColumnWidth; // Add expand icon width if there are merged fields (hierarchy chevron space)
        const hasMergedFields = Number(mergedColumn.mergedColumns?.length) > 0;
        if (hasMergedFields) paddingLeft += $6479a1a8f48bc6cf$var$ICON_WIDTH;
    }
    const shouldShowAdditionalFields = (0, $eJOHy.useCallback)(()=>(0, $cxKOj.expVal)('jira_powerful_inline_create_for_nin', 'isEnabled', false), []);
    return(// TODO: Check if we can catch the escape in a different level that removes below lint rule
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6479a1a8f48bc6cf$var$FullContent, {
        ref: formRef,
        onKeyDown: handleFormKeyDown,
        onSubmit: handleSubmit,
        appearance: appearance,
        paddingLeft: paddingLeft,
        ...(0, $4cTDP.fg)('refactor_issue_table_for_timline') ? {
            footerBorderRadius: footerBorderRadius
        } : {
            isTimeline: isTimeline
        },
        isMakeSpaceForRovoEnabled: (0, $4cTDP.fg)('global_rovo_button_in_jira')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointSubject,
        id: "async-issue-create-issue-type-dropdown",
        packageName: (0, $23b4218cfd94fe9f$export$b8b9d90f9e5bd72b),
        teamName: (0, $23b4218cfd94fe9f$export$d57b6b390e78d90f),
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6479a1a8f48bc6cf$export$848553d86b9bee59, null),
        runtimeProps: {
            onChange: (0, $4cTDP.fg)('yurree_jjj2_timeline') ? handleIssueTypeChange : setSelectedType,
            onProjectChange: setSelectedProject,
            setIsEditing: (0, $4cTDP.fg)('jifjam2_icc_fix') ? setIsUpdatingAdditionalFields : undefined,
            setIsManageIssueTypesModalOpen: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? setIsManageIssueTypesModalOpen : undefined,
            isManageIssueTypesModalOpen: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? isManageIssueTypesModalOpen : undefined,
            selectedType: selectedType,
            isSearchable: isSearchable
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "issue-table-inline-issue-create.ui.inline-create-form.textarea",
        xcss: $6479a1a8f48bc6cf$var$TextAreaStyles,
        as: "textarea",
        autoFocus: true,
        "aria-label": formatMessage((0, $eNuUB.default).placeholderText),
        placeholder: formatMessage((0, $eNuUB.default).placeholderText),
        value: textContent,
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        ref: textAreaRef
    }), canShowAdditionalFields && additionalFieldsEntryPointSubject != null && selectedProject?.key && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: additionalFieldsEntryPointSubject,
        id: "async-inline-create-additional-fields",
        packageName: "async-inline-create-additional-fields",
        teamName: "jira-werewolves",
        fallback: null,
        errorFallback: "unmount",
        runtimeProps: {
            projectKey: selectedProject?.key,
            fullWidth: false,
            isCompactDueDatePicker: true,
            shouldRenderToParent: true,
            shouldShowNameLabel: false,
            strategy: 'fixed',
            onAssigneeUpdate: setAssignee,
            defaultAssignee: assignee,
            defaultDueDate: dueDate,
            onDateSelected: setDueDate,
            shouldShowAdditionalFields: shouldShowAdditionalFields,
            source: $6479a1a8f48bc6cf$var$calledFromSource,
            onUpdatingAssigneePicker: setIsUpdatingAdditionalFields,
            onUpdatingDueDatePicker: setIsUpdatingAdditionalFields,
            issueTypeId: selectedType?.issueTypeId
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.100",
        alignItems: "center",
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6479a1a8f48bc6cf$var$StyledCreateButton, {
        appearance: "primary",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ab4Fp.default), null),
        isDisabled: isEmptyRef.current,
        spacing: "compact",
        type: "submit",
        onClick: handleCreateButtonClick
    }, formatMessage((0, $eNuUB.default).createButton)))));
};
const $6479a1a8f48bc6cf$var$InlineCreateFormWithContainer = ({ contextualFields: contextualFields, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        id: "issue-table-inline-issue-create"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gBHpC.IssueCreateContextualFieldsData), {
        payload: contextualFields
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6479a1a8f48bc6cf$var$InlineCreateForm, props)));
var $6479a1a8f48bc6cf$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eJOHy.memo)($6479a1a8f48bc6cf$var$InlineCreateFormWithContainer);
const $6479a1a8f48bc6cf$var$FullContentNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMakeSpaceForRovoEnabled: isMakeSpaceForRovoEnabled, paddingLeft: paddingLeft, footerBorderRadius: footerBorderRadius, appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_to5f02": (0, $awdRS.default)(`${__cmplp.paddingLeft}px`),
            "--_et7yx1": (0, $awdRS.default)(__cmplp.footerBorderRadius)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _v56416gf _12ji1r31 _1qu2glyw _12y31o36 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _bfhkvuon _16qs1ah0 _vchhusvi _1tke1ylp _2lx2vrvc _4cvr1h6o _4t3i1ylp _ca0q1b66 _n3td1b66 _19bvedk6",
            __cmplp.isMakeSpaceForRovoEnabled ? "_u5f31ejb" : "_u5f3u2gc",
            __cmplp.footerBorderRadius && "_2rko17r0",
            !__cmplp.footerBorderRadius && __cmplp.appearance === 'footer' && "_mrkb1mok _1o0z1mok",
            !__cmplp.footerBorderRadius && __cmplp.appearance !== 'footer' && "_2rko12b0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6479a1a8f48bc6cf$var$FullContentOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMakeSpaceForRovoEnabled: isMakeSpaceForRovoEnabled, paddingLeft: paddingLeft, isTimeline: isTimeline, appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_to5f02": (0, $awdRS.default)(`${__cmplp.paddingLeft}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _v56416gf _12ji1r31 _1qu2glyw _12y31o36 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _bfhkvuon _16qs1ah0 _vchhusvi _1tke1ylp _2lx2vrvc _4cvr1h6o _4t3i1ylp _ca0q1b66 _n3td1b66 _19bvedk6",
            __cmplp.isMakeSpaceForRovoEnabled ? "_u5f31ejb" : "_u5f3u2gc",
            __cmplp.isTimeline && "_2rkoidpf",
            !__cmplp.isTimeline && __cmplp.appearance === 'footer' && "_mrkb1mok _1o0z1mok",
            !__cmplp.isTimeline && __cmplp.appearance !== 'footer' && "_2rko12b0",
            __cmplp.className
        ])
    });
});
const $6479a1a8f48bc6cf$var$FullContent = (0, $bJscI.componentWithFG)('refactor_issue_table_for_timline', $6479a1a8f48bc6cf$var$FullContentNew, $6479a1a8f48bc6cf$var$FullContentOld);
const $6479a1a8f48bc6cf$var$TextAreaStyles = (0, $1DXK0.xcss)({
    flex: '1',
    border: 'none',
    outline: 'none',
    margin: '0',
    padding: 'space.050',
    height: '20px',
    resize: 'none',
    backgroundColor: 'elevation.surface',
    color: 'color.text',
    font: 'font.body',
    scrollbarWidth: 'none',
    whiteSpace: 'pre',
    boxSizing: 'content-box',
    fontFamily: 'inherit'
}); // TODO: Maybe we can rewrite to pressable....
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6479a1a8f48bc6cf$var$StyledCreateButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});
const $23b4218cfd94fe9f$export$b8b9d90f9e5bd72b = 'jiraIssueTableInlineIssueCreate';
const $23b4218cfd94fe9f$export$d57b6b390e78d90f = 'empanada';
const $23b4218cfd94fe9f$export$e77c67bc8157f49 = 'jsc_onboarding_inline_create';
const $23b4218cfd94fe9f$export$c7e6a6b283196232 = '/gateway/api';

parcelRegister("gBHpC", function(module, exports) {
$parcel$export(module.exports, "IssueCreateContextualFieldsData", () => $ebc2e159f3e0305c$export$a4ac6f56634f61f4);
$parcel$export(module.exports, "useIssueCreateContextualFields", () => $ebc2e159f3e0305c$export$6bb8d4e3be0700f9);

var $eJOHy = parcelRequire("eJOHy");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $ebc2e159f3e0305c$var$initialState = {};
const $ebc2e159f3e0305c$var$Store = (0, $GtRbT.createStore)({
    initialState: $ebc2e159f3e0305c$var$initialState,
    actions: {}
});
const $ebc2e159f3e0305c$var$updateStore = ()=>({ setState: setState }, { payload: payload })=>setState(payload);
const $ebc2e159f3e0305c$var$Container = (0, $6E16M.createContainer)($ebc2e159f3e0305c$var$Store, {
    onInit: $ebc2e159f3e0305c$var$updateStore,
    onUpdate: $ebc2e159f3e0305c$var$updateStore
});
const $ebc2e159f3e0305c$export$a4ac6f56634f61f4 = ({ children: children, payload: payload })=>{
    const ancestorPayload = $ebc2e159f3e0305c$export$6bb8d4e3be0700f9();
    const nextPayload = (0, $eJOHy.useMemo)(()=>({
            ...ancestorPayload,
            ...payload
        }), [
        ancestorPayload,
        payload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ebc2e159f3e0305c$var$Container, {
        payload: nextPayload
    }, children);
};
const $ebc2e159f3e0305c$export$6bb8d4e3be0700f9 = (0, $iJq0l.createStateHook)($ebc2e159f3e0305c$var$Store);

});

parcelRegister("ljpuj", function(module, exports) {
$parcel$export(module.exports, "IssueTypeDropdown", () => $f618bd39dd67a3ad$export$16aea7aa4bac227f);
$parcel$export(module.exports, "IssueTypeDropdownEntryPoint", () => $f618bd39dd67a3ad$export$7b1e666ab7e366e1);

var $cvMpq = parcelRequire("cvMpq");

var $7kLYq = parcelRequire("7kLYq");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $7ep4S = parcelRequire("7ep4S");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $c24ZZ = parcelRequire("c24ZZ");

var $4cTDP = parcelRequire("4cTDP");

var $aB2Z6 = parcelRequire("aB2Z6");

var $f34ZP = parcelRequire("f34ZP");

var $l4kLF = parcelRequire("l4kLF");

var $kLXPe = parcelRequire("kLXPe");
const $f618bd39dd67a3ad$var$createIssueTypeOption = (id, name, avatar, issueTypeId)=>({
        label: name,
        value: id,
        avatar: {
            small: avatar
        },
        issueTypeId: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? issueTypeId || undefined : undefined
    });
const $f618bd39dd67a3ad$var$createIssueType = (id, issueTypeId, name, avatar, hierarchyLevel)=>({
        id: id,
        issueTypeId: issueTypeId,
        name: name,
        avatar: {
            small: avatar
        },
        ...typeof hierarchyLevel === 'number' ? {
            hierarchy: {
                level: hierarchyLevel
            }
        } : {}
    });
const $f618bd39dd67a3ad$var$placeholder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
    size: "medium"
});
const $f618bd39dd67a3ad$export$16aea7aa4bac227f = ({ onChange: onChange, onProjectChange: onProjectChange, setIsEditing: setIsEditing, setIsManageIssueTypesModalOpen: setIsManageIssueTypesModalOpen, isManageIssueTypesModalOpen: isManageIssueTypesModalOpen, project: project, selectedType: selectedType, isSearchable: isSearchable, filter: filter })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isPristine = (0, $eJOHy.useRef)(true);
    // TODO; JSC-36  We need to integrate hierarchy level filter once JSC-59 is implemented
    const { data: data, refetch: refetch } = (0, $j4oe4.usePaginationFragment)((0, $7kLYq.default), project);
    const [defaultIssueTypeId, { setDefaultIssueType: setDefaultIssueType }] = (0, $aB2Z6.useDefaultIssueType)(data?.key ?? null);
    const selectedTypeOption = (0, $eJOHy.useMemo)(()=>{
        if (selectedType == null) return null;
        return $f618bd39dd67a3ad$var$createIssueTypeOption(selectedType.id, selectedType.name, selectedType.avatar?.small, selectedType.issueTypeId);
    }, [
        selectedType
    ]);
    const handleGetRefetchVariables = (0, $eJOHy.useCallback)(// @ts-expect-error - isInlineManageWorkTypesConfigNinIccEnabled is automatically injected at runtime by the Relay provider
    ()=>({
            id: data?.id || ''
        }), [
        data?.id
    ]);
    const handleIssueTypeChange = (0, $eJOHy.useCallback)((typeOption)=>{
        let newIssueType = null;
        if (typeOption != null) {
            const issueType = (data?.issueTypes?.edges || []).find((edge)=>edge?.node?.id === typeOption.value);
            if (issueType?.node != null && issueType.node.issueTypeId != null) newIssueType = $f618bd39dd67a3ad$var$createIssueType(issueType.node.id, issueType.node.issueTypeId, issueType.node.name, issueType.node.avatar?.small, issueType.node.hierarchy?.level);
        }
        isPristine.current = false;
        onChange(newIssueType, (0, $4cTDP.fg)('yurree_jjj2_timeline') ? true : undefined);
        if (newIssueType?.issueTypeId) setDefaultIssueType(data?.key ?? null, newIssueType?.issueTypeId);
    }, [
        data?.issueTypes?.edges,
        data?.key,
        onChange,
        setDefaultIssueType
    ]);
    // Initialize with the first default issue
    (0, $eJOHy.useEffect)(()=>{
        if (isPristine.current) {
            const defaultIssueTypeEdge = (data?.issueTypes?.edges || []).find((edge)=>edge?.node?.issueTypeId === defaultIssueTypeId);
            if (defaultIssueTypeEdge?.node != null && defaultIssueTypeEdge.node.issueTypeId != null) // Return default issue type if exists
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            return onChange($f618bd39dd67a3ad$var$createIssueType(defaultIssueTypeEdge.node.id, defaultIssueTypeEdge.node.issueTypeId, defaultIssueTypeEdge.node.name, defaultIssueTypeEdge.node.avatar?.small, defaultIssueTypeEdge.node.hierarchy?.level));
            const firstIssue = data?.issueTypes?.edges?.[0];
            if (firstIssue?.node != null && firstIssue.node.issueTypeId != null) // Return first issue type in the connection
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            return onChange($f618bd39dd67a3ad$var$createIssueType(firstIssue.node.id, firstIssue.node.issueTypeId, firstIssue.node.name, firstIssue.node.avatar?.small, firstIssue.node.hierarchy?.level));
        }
    }, [
        data?.issueTypes?.edges,
        defaultIssueTypeId,
        onChange
    ]);
    const prevProjectKey = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (data?.id != null && prevProjectKey.current !== data?.id && data.projectId != null) {
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            onProjectChange({
                id: data.id,
                projectId: data.projectId,
                key: data.key,
                name: data.name,
                avatar: data.avatar ? {
                    large: data.avatar.large
                } : null
            });
            prevProjectKey.current = data?.id;
        }
    }, [
        data?.avatar,
        data?.id,
        data?.key,
        data?.name,
        data?.projectId,
        onProjectChange
    ]);
    const updateIssueTypeLinksOnCreate = (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fast_follow') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kLXPe.useUpdateIssueTypeLinksOnCreate)() : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    const handleIssueTypeCreation = (0, $eJOHy.useCallback)((createdIssueType)=>{
        if (createdIssueType?.issueTypeId && data?.projectId && data?.id) {
            const issueTypeEdge = (data?.issueTypes?.edges || []).find((edge)=>edge?.node?.issueTypeId === createdIssueType.issueTypeId);
            if (issueTypeEdge?.node?.id) updateIssueTypeLinksOnCreate({
                issueTypeId: issueTypeEdge.node.id,
                projectId: data.projectId
            });
        }
    }, [
        updateIssueTypeLinksOnCreate,
        data?.projectId,
        data?.id,
        data?.issueTypes?.edges
    ]);
    const manageIssueTypeProps = (0, $eJOHy.useMemo)(()=>{
        if (!data?.key || !data?.projectId || !(0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg')) return undefined;
        const { minHierarchyLevel: minHierarchyLevel, maxHierarchyLevel: maxHierarchyLevel } = filter || {};
        return {
            projectKey: data.key,
            projectId: data.projectId,
            // We don't allow issue type creation if level 0 issues are excluded from the dropdown
            allowIssueTypeCreation: (!minHierarchyLevel || minHierarchyLevel <= 0) && (!maxHierarchyLevel || maxHierarchyLevel >= 0),
            setIsManageIssueTypesModalOpen: setIsManageIssueTypesModalOpen,
            onIssueTypeCreation: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fast_follow') ? handleIssueTypeCreation : undefined
        };
    }, [
        data?.key,
        data?.projectId,
        filter,
        setIsManageIssueTypesModalOpen,
        handleIssueTypeCreation
    ]);
    // TODO: JSC-71 We need to updated below component styles to adapt more to JWM current design
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c24ZZ.IssueTypeEditViewWithIssueTypeConnection), {
        issueTypesFragmentRef: data?.issueTypes ?? null,
        projectFragmentRef: manageIssueTypeProps && (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? data : undefined,
        menuPosition: "fixed",
        menuPlacement: "top",
        onChange: handleIssueTypeChange,
        onRefetch: refetch,
        onGetRefetchVariables: handleGetRefetchVariables,
        setIsEditing: setIsEditing,
        refetchQuery: (0, $f34ZP.default),
        value: selectedTypeOption,
        spacing: "compact",
        stopPropagationOfMenuEscape: true,
        label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $l4kLF.default).labelIssueTerminologyRefreshM4 : (0, $l4kLF.default).label),
        iconsOnly: true,
        appearance: "subtle",
        isSearchable: isSearchable,
        placeholder: (0, $4cTDP.fg)('jifjam_deliveroo_icc_changes') ? $f618bd39dd67a3ad$var$placeholder : undefined,
        manageIssueTypeProps: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') && (0, $cxKOj.expVal)('work_type_inline_config_nin_icc', 'isEnabled', false) ? manageIssueTypeProps : undefined,
        isManageIssueTypesModalOpen: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? isManageIssueTypesModalOpen : undefined,
        renderAsPopupSelect: (0, $4cTDP.fg)('jifjam2_icc_fix')
    });
};
const $f618bd39dd67a3ad$export$7b1e666ab7e366e1 = ({ queries: { projectData: projectData }, props: props })=>{
    const data = (0, $j4oe4.usePreloadedQuery)((0, $cvMpq.default), projectData);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f618bd39dd67a3ad$export$16aea7aa4bac227f, {
        ...props,
        project: data.jira.jiraProjectByKey ?? null,
        filter: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? projectData.variables.filter : undefined
    });
};
var $f618bd39dd67a3ad$export$2e2bcd8739ae039 = $f618bd39dd67a3ad$export$16aea7aa4bac227f;

});
parcelRegister("cvMpq", function(module, exports) {
$parcel$export(module.exports, "default", () => $2163ffef975d728e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d534cfee839bb8c50e63790ad40073ed>>
 * @relayHash 13d26172a26eb9fd9bc44e01c17b4a8f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID baec945a329fbc351826d69fcacbce16a8c6b454eb1077de0cd2cda3bf67e8c2

var $g8m5l = parcelRequire("g8m5l");
const $2163ffef975d728e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasProjectKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v5 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = [
        v5 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueTypeDropdownQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "hasProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "jiraProjectByKey",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "kind": "FragmentSpread",
                                                    "name": "IssueTypeDropdown"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jiraProjectByKey"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueTypeDropdownQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "hasProjectKey",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "large"
                                                }
                                            ]
                                        },
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "JiraIssueTypeConnection",
                                            "kind": "LinkedField",
                                            "name": "issueTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueTypeId"
                                                                },
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "small"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                    "kind": "LinkedField",
                                                                    "name": "hierarchy",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "level"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                {
                                                                    "alias": "value",
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                },
                                                                {
                                                                    "alias": "label",
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v8 /*: any*/ ,
                                            "filters": [
                                                "filter"
                                            ],
                                            "handle": "connection",
                                            "key": "inlineIssueCreate_IssueTable_issueTypes",
                                            "kind": "LinkedHandle",
                                            "name": "issueTypes"
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "admin",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canPerform"
                                                        }
                                                    ],
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "baec945a329fbc351826d69fcacbce16a8c6b454eb1077de0cd2cda3bf67e8c2",
            "metadata": {},
            "name": "IssueTypeDropdownQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider": (0, $g8m5l.default)
            }
        }
    };
}();
$2163ffef975d728e$var$node.hash = "0238e0aca7edc4704b3aa7f61762f162";
var $2163ffef975d728e$export$2e2bcd8739ae039 = $2163ffef975d728e$var$node;

});
parcelRegister("g8m5l", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f8b50c4e7e6e6cf$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $5f8b50c4e7e6e6cf$var$inlineManageWorkTypesConfigNinIcc = {
    get () {
        return (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg');
    }
};
var $5f8b50c4e7e6e6cf$export$2e2bcd8739ae039 = $5f8b50c4e7e6e6cf$var$inlineManageWorkTypesConfigNinIcc;

});


parcelRegister("7kLYq", function(module, exports) {
$parcel$export(module.exports, "default", () => $b52361cccc1d01f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9d50dc7ee659af4a0155ac5d44f1e06c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $f34ZP = parcelRequire("f34ZP");
const $b52361cccc1d01f8$var$node = function() {
    var v0 = [
        "issueTypes"
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "filter"
            },
            {
                "defaultValue": 10,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "cursor"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $f34ZP.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "IssueTypeDropdown",
        "selections": [
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "projectId"
            },
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v2 /*: any*/ ,
            {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "large"
                    }
                ]
            },
            {
                "alias": "issueTypes",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "filter",
                        "variableName": "filter"
                    }
                ],
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "__inlineIssueCreate_IssueTable_issueTypes_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "issueTypeId"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "concreteType": "JiraAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "small"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraIssueTypeHierarchyLevel",
                                        "kind": "LinkedField",
                                        "name": "hierarchy",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "level"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef"
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_permissionsFragmentRef"
                    }
                ]
            }
        ],
        "type": "JiraProject"
    };
}();
$b52361cccc1d01f8$var$node.hash = "aec60961411e82d617f031c4c43f1516";
var $b52361cccc1d01f8$export$2e2bcd8739ae039 = $b52361cccc1d01f8$var$node;

});
parcelRegister("f34ZP", function(module, exports) {
$parcel$export(module.exports, "default", () => $038ba88322ff51a2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dfb5e2a51a4355c1b778f617486d135f>>
 * @relayHash 8adf0afe91a8b76e78174f3a6ccbc56a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4d3934c09943829fd1a6c1f597a5f5b6447de126c3ab2bdb486a699a10938f78

var $g8m5l = parcelRequire("g8m5l");
const $038ba88322ff51a2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cursor"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isInlineManageWorkTypesConfigNinIccEnabled"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v6 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v7 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        },
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cursor",
                                    "variableName": "cursor"
                                },
                                v6 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "IssueTypeDropdown"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueTypeId"
                                                        },
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "small"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                            "kind": "LinkedField",
                                                            "name": "hierarchy",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "level"
                                                                }
                                                            ]
                                                        },
                                                        v8 /*: any*/ ,
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v11 /*: any*/ ,
                                    "filters": [
                                        "filter"
                                    ],
                                    "handle": "connection",
                                    "key": "inlineIssueCreate_IssueTable_issueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "issueTypes"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "admin",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "EDIT_PROJECT_CONFIG"
                                                }
                                            ],
                                            "concreteType": "JiraProjectAction",
                                            "kind": "LinkedField",
                                            "name": "action",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canPerform"
                                                }
                                            ],
                                            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectStyle"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectType"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraProject"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4d3934c09943829fd1a6c1f597a5f5b6447de126c3ab2bdb486a699a10938f78",
            "metadata": {},
            "name": "issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "isInlineManageWorkTypesConfigNinIccEnabled": (0, $g8m5l.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider": (0, $g8m5l.default)
            }
        }
    };
}();
$038ba88322ff51a2$var$node.hash = "aec60961411e82d617f031c4c43f1516";
var $038ba88322ff51a2$export$2e2bcd8739ae039 = $038ba88322ff51a2$var$node;

});


parcelRegister("c24ZZ", function(module, exports) {
$parcel$export(module.exports, "IssueTypeEditViewWithIssueTypeConnection", () => $657e3371d6260ec4$export$139e4bfeb055992c);
$parcel$export(module.exports, "IssueTypeEditView", () => $657e3371d6260ec4$export$83fe9ca9fdf41761);

var $jhOlu = parcelRequire("jhOlu");

var $e0UsS = parcelRequire("e0UsS");

var $1AEld = parcelRequire("1AEld");

var $1z9K4 = parcelRequire("1z9K4");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $7XH79 = parcelRequire("7XH79");

var $FhXEJ = parcelRequire("FhXEJ");

var $1jVV7 = parcelRequire("1jVV7");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $c4OV1 = parcelRequire("c4OV1");
var $sl8jM = parcelRequire("sl8jM");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $jbtzi = parcelRequire("jbtzi");

var $f1FvV = parcelRequire("f1FvV");

var $aUMMA = parcelRequire("aUMMA");

var $fwzaq = parcelRequire("fwzaq");

var $bzbsd = parcelRequire("bzbsd");

var $bskNA = parcelRequire("bskNA");

var $5vQ2T = parcelRequire("5vQ2T");

var $cxKOj = parcelRequire("cxKOj");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $lwztx = parcelRequire("lwztx");

var $4F1Zj = parcelRequire("4F1Zj");

var $3NHkq = parcelRequire("3NHkq");

var $hUVzR = parcelRequire("hUVzR");

var $lvadq = parcelRequire("lvadq");
const $657e3371d6260ec4$var$iconOnlySelectStyles = {
    menuPortal: (base)=>({
            ...base,
            zIndex: (0, $1jVV7.layers).modal
        }),
    menu: (base)=>({
            ...base,
            zIndex: (0, $1jVV7.layers).modal,
            minWidth: '120px',
            maxWidth: '440px',
            width: 'auto',
            overflowY: 'auto'
        }),
    control: (base)=>({
            ...base,
            '&:hover': {
                borderColor: 'transparent'
            }
        })
};
const $657e3371d6260ec4$export$6a277fd8285f68cf = ({ queryFragmentRef: queryFragmentRef, fieldId: fieldId, filterOptionsById: filterOptionsById = null, ...props })=>{
    const { data: issueTypesSearchData, refetch: refetchSuggestions } = (0, $j4oe4.usePaginationFragment)((0, $1z9K4.default), queryFragmentRef);
    const onGetRefetchVariables = (0, $eJOHy.useCallback)((searchBy)=>({
            id: fieldId,
            searchBy: searchBy,
            filterById: filterOptionsById
        }), [
        fieldId,
        filterOptionsById
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($657e3371d6260ec4$export$139e4bfeb055992c, {
        ...props,
        issueTypesFragmentRef: issueTypesSearchData.node?.issueTypes ?? null,
        onGetRefetchVariables: onGetRefetchVariables,
        refetchQuery: (0, $lwztx.default),
        onRefetch: refetchSuggestions
    });
};
const $657e3371d6260ec4$export$139e4bfeb055992c = ({ autoFocus: autoFocus = false, issueTypesFragmentRef: issueTypesFragmentRef, onChange: onChangeProp, onGetRefetchVariables: onGetRefetchVariables, setIsEditing: setIsEditing, value: value, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, isInvalid: isInvalid, isDisabled: isDisabled = false, inputId: inputId, menuPosition: menuPosition, menuPlacement: menuPlacement, refetchQuery: refetchQuery, onRefetch: onRefetch, openMenuOnFocus: openMenuOnFocus, spacing: spacing, stopPropagationOfMenuEscape: stopPropagationOfMenuEscape, iconsOnly: iconsOnly = false, appearance: appearance = 'default', isSearchable: isSearchable = true, placeholder: placeholder, manageIssueTypeProps: manageIssueTypeProps, isManageIssueTypesModalOpen: isManageIssueTypesModalOpen, projectFragmentRef: projectFragmentRef, renderAsPopupSelect: renderAsPopupSelect = false })=>{
    const hasAutoFocus = autoFocus && (!renderAsPopupSelect || !(0, $4cTDP.fg)('jifjam2_icc_fix'));
    const [menuIsOpen, setMenuIsOpen] = (0, $eJOHy.useState)(hasAutoFocus);
    const triggerRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getNoOptionsMessage = (0, $eJOHy.useCallback)(()=>noOptionsMessage ?? formatMessage((0, $4F1Zj.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $eJOHy.useCallback)(()=>loadingMessage ?? formatMessage((0, $4F1Zj.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const defaultPlaceholder = formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $4F1Zj.default).placeholderIssueTerminologyRefreshM4 : (0, $4F1Zj.default).placeholder); // #region Relay
    // suggestions fragment with pagination and refetch
    const data = (0, $j4oe4.useFragment)((0, $1AEld.default), issueTypesFragmentRef); // manage issue types permission fragment
    const permissionsData = (0, $j4oe4.useFragment)((0, $e0UsS.default), projectFragmentRef ?? null); // Check if user has permission to manage issue types
    // If fragment wasn't spread by consumer, permissionsData will be null and we won't show the feature
    const canManageIssueTypes = permissionsData?.admin?.canPerform ?? false; // #endregion
    // #region Common state (might be handy for other components)
    const [searchByString, setSearchByString] = (0, $eJOHy.useState)(''); // #endregion
    // #region Debounced suspensless refetch helpers
    const [searchSuspenselessRefetch, isLoading, lastFetchError] = (0, $7XH79.useSuspenselessRefetch)(refetchQuery, onRefetch);
    const [searchDebouncedSuspenselessRefetch] = (0, $fwzaq.default)(searchSuspenselessRefetch, (0, $jbtzi.SEARCH_DEBOUNCE_TIMEOUT));
    (0, $eJOHy.useEffect)(()=>{
        if (hasAutoFocus) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-live-state-to-parent
        searchSuspenselessRefetch(onGetRefetchVariables(searchByString));
    }, [
        searchSuspenselessRefetch,
        autoFocus,
        searchByString,
        onGetRefetchVariables,
        hasAutoFocus
    ]);
    const onKeyDown = (0, $eJOHy.useCallback)((e)=>{
        if (stopPropagationOfMenuEscape && menuIsOpen && e.key === 'Escape') e.stopPropagation();
    }, [
        menuIsOpen,
        stopPropagationOfMenuEscape
    ]); // #region Common callbacks for the selector
    const openMenuOld = ()=>setMenuIsOpen(true);
    const openMenu = (0, $eJOHy.useCallback)(()=>{
        setIsEditing?.(true);
        setMenuIsOpen(true);
        if ((0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg')) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'select clicked', 'issueTypeSelect', {
            numIssueTypes: data?.edges?.length ?? undefined
        });
    }, [
        setIsEditing,
        setMenuIsOpen,
        createAnalyticsEvent,
        data?.edges?.length
    ]);
    const closeMenuOld = ()=>setMenuIsOpen(false);
    const closeMenu = ()=>{
        setMenuIsOpen(false);
        if ((0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg')) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'select closed', 'issueTypeSelect', {
            numIssueTypes: data?.edges?.length ?? undefined
        });
        setTimeout(()=>{
            setIsEditing?.(false);
            triggerRef.current?.focus();
        }, 0);
    };
    const onSelectFocus = (0, $eJOHy.useCallback)(()=>{
        searchSuspenselessRefetch(onGetRefetchVariables(searchByString));
    }, [
        searchSuspenselessRefetch,
        searchByString,
        onGetRefetchVariables
    ]);
    const onSearchByStringChangeFunction = (0, $eJOHy.useCallback)((newSearchByString)=>{
        setSearchByString(newSearchByString);
        searchDebouncedSuspenselessRefetch(onGetRefetchVariables(newSearchByString || ''));
    }, [
        onGetRefetchVariables,
        searchDebouncedSuspenselessRefetch
    ]);
    const onChange = (0, $eJOHy.useCallback)((newOption)=>{
        onChangeProp?.(newOption);
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'select changed', 'issueTypeSelect', {
            numIssueTypes: data?.edges?.length ?? undefined
        });
    }, [
        createAnalyticsEvent,
        onChangeProp,
        data?.edges?.length
    ]); // #endregion
    // #region Transform options data from relay to AK Select
    const defaultFailedOption = (0, $eJOHy.useMemo)(()=>({
            label: formatMessage((0, $4F1Zj.default).failedFetch),
            value: '',
            avatar: {
                small: ''
            },
            issueTypeId: undefined,
            isDisabled: true
        }), [
        formatMessage
    ]);
    const renderIconOnlyOption = (option, formatOptionLabelMeta)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($657e3371d6260ec4$var$OptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            xcss: $657e3371d6260ec4$var$inlineIconStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
            src: option.avatar?.small || '',
            alt: option.label,
            width: 16,
            height: 16
        })), formatOptionLabelMeta.context !== 'value' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, option.label));
    const renderIconWithTextOption = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($657e3371d6260ec4$var$OptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($657e3371d6260ec4$var$ImgSpan, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
            src: option.avatar?.small || '',
            alt: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? '' : option.label,
            width: 16,
            height: 16
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, option.label));
    const selectFieldOptions = (0, $eJOHy.useMemo)(()=>{
        // checks for query errors
        if (lastFetchError != null) return [
            defaultFailedOption
        ];
        return data?.edges?.map((edge)=>edge?.node).filter(Boolean).map(({ label: optionLabel, value: optionValue, avatar: avatar, issueTypeId: issueTypeId })=>({
                label: optionLabel ?? '',
                value: optionValue,
                avatar: avatar,
                issueTypeId: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? issueTypeId ?? undefined : undefined
            })) ?? [];
    }, [
        lastFetchError,
        data,
        defaultFailedOption
    ]); // #endregion
    const { onIssueTypeUpdated: onIssueTypeUpdated, onIssueTypeCreated: onIssueTypeCreated } = (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $hUVzR.useManageIssueTypeCallbacks)({
        onRefetch: onRefetch,
        onGetRefetchVariables: onGetRefetchVariables,
        selectFieldOptions: selectFieldOptions,
        onChange: onChange,
        onIssueTypeCreation: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fast_follow') ? manageIssueTypeProps?.onIssueTypeCreation : undefined
    }) : {
        onIssueTypeUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onIssueTypeCreated: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    };
    const selectedIssueTypeId = value?.issueTypeId;
    const shouldRenderFooter = // eslint-disable-next-line jira/ff/no-preconditioning
    manageIssueTypeProps && canManageIssueTypes && selectedIssueTypeId && lastFetchError == null && (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') && (0, $cxKOj.expVal)('work_type_inline_config_nin_icc', 'isEnabled', false);
    const MaybeModalContextProvider = (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? (0, $bskNA.ModalContextProvider) : (0, $eJOHy.Fragment);
    if (!renderAsPopupSelect || !(0, $4cTDP.fg)('jifjam2_icc_fix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        "aria-label": formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $4F1Zj.default).labelIssueTerminologyRefreshM4 : (0, $4F1Zj.default).label),
        formatOptionLabel: iconsOnly ? renderIconOnlyOption : renderIconWithTextOption,
        styles: iconsOnly ? $657e3371d6260ec4$var$iconOnlySelectStyles : (0, $aUMMA.defaultSelectStyles),
        value: value,
        options: selectFieldOptions,
        menuIsOpen: menuIsOpen,
        placeholder: placeholder && (0, $4cTDP.fg)('jifjam_deliveroo_icc_changes') ? placeholder : defaultPlaceholder,
        noOptionsMessage: getNoOptionsMessage,
        loadingMessage: getLoadingMessage,
        filterOption: (0, $f1FvV.filterOptionByLabelAndFilterValues),
        onInputChange: onSearchByStringChangeFunction,
        onChange: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? onChange : onChangeProp,
        openMenuOnFocus: openMenuOnFocus,
        onFocus: onSelectFocus,
        onKeyDown: onKeyDown,
        autoFocus: autoFocus,
        isInvalid: isInvalid,
        isDisabled: isDisabled,
        isLoading: isLoading && menuIsOpen,
        inputId: inputId,
        menuPosition: menuPosition,
        menuPlacement: menuPlacement,
        onMenuOpen: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? openMenu : openMenuOld,
        onMenuClose: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? closeMenu : closeMenuOld,
        spacing: spacing,
        appearance: appearance,
        isSearchable: isSearchable
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MaybeModalContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sl8jM.default), {
        formatOptionLabel: renderIconWithTextOption,
        styles: (0, $aUMMA.defaultSelectStyles),
        value: value,
        options: selectFieldOptions,
        isOpen: isManageIssueTypesModalOpen ? false : undefined,
        noOptionsMessage: getNoOptionsMessage,
        loadingMessage: getLoadingMessage,
        filterOption: (0, $f1FvV.filterOptionByLabelAndFilterValues),
        onInputChange: onSearchByStringChangeFunction,
        onFocus: onSelectFocus,
        onChange: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? onChange : onChangeProp,
        onKeyDown: onKeyDown,
        isDisabled: isDisabled,
        isLoading: isLoading && menuIsOpen,
        inputId: inputId,
        onMenuOpen: openMenu,
        onMenuClose: closeMenu,
        spacing: spacing,
        appearance: appearance,
        target: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvadq.Trigger), {
                ...triggerProps,
                value: value,
                triggerRef: (0, $bzbsd.mergeRefs)(ref, triggerRef),
                isOpen: menuIsOpen,
                isDisabled: isDisabled
            }),
        footer: shouldRenderFooter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3NHkq.MenuFooter), {
            ...manageIssueTypeProps,
            selectedIssueTypeId: selectedIssueTypeId,
            onIssueTypeUpdated: onIssueTypeUpdated,
            onIssueTypeCreated: onIssueTypeCreated,
            options: selectFieldOptions,
            menuIsOpen: menuIsOpen,
            isSimplifiedProject: permissionsData?.projectStyle === (0, $FhXEJ.TEAM_MANAGED_PROJECT),
            projectType: permissionsData?.projectType
        }) : undefined,
        popperProps: {
            strategy: menuPosition,
            modifiers: [
                {
                    name: 'preventOverflow',
                    enabled: false
                }
            ]
        },
        shouldCloseMenuOnTab: !shouldRenderFooter,
        closeMenuOnSelect: true,
        isSearchable: false
    }));
};
const $657e3371d6260ec4$export$83fe9ca9fdf41761 = (props)=>{
    const suggestionsData = (0, $j4oe4.useLazyLoadQuery)((0, $jhOlu.default), {
        id: props.fieldId,
        filterById: props.filterOptionsById
    }, {
        fetchPolicy: 'store-only'
    });
    if ((0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraPlatformIssueTypeEditView",
        id: "jira-platform-issue-type-edit-view",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($657e3371d6260ec4$export$6a277fd8285f68cf, {
        ...props,
        queryFragmentRef: suggestionsData
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($657e3371d6260ec4$export$6a277fd8285f68cf, {
        ...props,
        queryFragmentRef: suggestionsData
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $657e3371d6260ec4$var$OptionWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $657e3371d6260ec4$var$ImgSpan = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.className
        ])
    });
});
const $657e3371d6260ec4$var$inlineIconStyle = (0, $1DXK0.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("jhOlu", function(module, exports) {
$parcel$export(module.exports, "default", () => $c09044acd072c6d7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<876729a26dd060ef7a5c5e9b31808218>>
 * @relayHash 211a69c30b4f214a1cccdbd7dfc2fd9c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54c1a073e9dd218421f63fef52aaa2d1b8e7e0c8707d4d24c135590a7068c68b

var $g8m5l = parcelRequire("g8m5l");
const $c09044acd072c6d7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterById"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v3 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v4 = {
        "kind": "Literal",
        "name": "searchBy",
        "value": ""
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        v4 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueType_issueTypeSearchQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "issueType_issueTypeSearchQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "small"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueTypeId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v6 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "issueType_issueFieldIssueTypeEditviewFull_issueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "issueTypes"
                                }
                            ],
                            "type": "JiraIssueTypeField"
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "54c1a073e9dd218421f63fef52aaa2d1b8e7e0c8707d4d24c135590a7068c68b",
            "metadata": {},
            "name": "issueType_issueTypeSearchQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider": (0, $g8m5l.default)
            }
        }
    };
}();
$c09044acd072c6d7$var$node.hash = "a9ae551cfa917838f44cb5ad82166383";
var $c09044acd072c6d7$export$2e2bcd8739ae039 = $c09044acd072c6d7$var$node;

});

parcelRegister("e0UsS", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f82a3fcbe65f8e1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2907a1d7a90ffd607149a9434adaf261>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2f82a3fcbe65f8e1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_permissionsFragmentRef",
    "selections": [
        {
            "alias": "admin",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        }
    ],
    "type": "JiraProject"
};
$2f82a3fcbe65f8e1$var$node.hash = "a379aab42f3391944eef1fd31015b8b1";
var $2f82a3fcbe65f8e1$export$2e2bcd8739ae039 = $2f82a3fcbe65f8e1$var$node;

});

parcelRegister("1AEld", function(module, exports) {
$parcel$export(module.exports, "default", () => $48ea07c41b3a6bd1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d527ee74c6495d3b078a74f10a7750cf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $48ea07c41b3a6bd1$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef",
    "selections": [
        {
            "concreteType": "JiraIssueTypeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "value",
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "alias": "label",
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "small"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueTypeConnection"
};
$48ea07c41b3a6bd1$var$node.hash = "39660377c07394b192f504658c1422f2";
var $48ea07c41b3a6bd1$export$2e2bcd8739ae039 = $48ea07c41b3a6bd1$var$node;

});

parcelRegister("1z9K4", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a2a3858e9aed8ce$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<92d1e3360b2d69683e70b781460fce34>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $lwztx = parcelRequire("lwztx");
const $9a2a3858e9aed8ce$var$node = function() {
    var v0 = [
        "node",
        "issueTypes"
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "filterById"
            },
            {
                "defaultValue": 1000,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "id"
            },
            {
                "defaultValue": "",
                "kind": "LocalArgument",
                "name": "searchBy"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $lwztx.default)
            }
        },
        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "id"
                    }
                ],
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": "issueTypes",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "filterById",
                                        "variableName": "filterById"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "searchBy",
                                        "variableName": "searchBy"
                                    }
                                ],
                                "concreteType": "JiraIssueTypeConnection",
                                "kind": "LinkedField",
                                "name": "__issueType_issueFieldIssueTypeEditviewFull_issueTypes_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueTypeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            },
                                            {
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v1 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef"
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraIssueTypeField"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$9a2a3858e9aed8ce$var$node.hash = "54c04d4f507b644a10ef1cc8b3c0fc09";
var $9a2a3858e9aed8ce$export$2e2bcd8739ae039 = $9a2a3858e9aed8ce$var$node;

});
parcelRegister("lwztx", function(module, exports) {
$parcel$export(module.exports, "default", () => $9aeafee7ce005a49$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9612834897878e6e0e746b411ed2976f>>
 * @relayHash 591e5a64cd39c5711484ae5bf44555f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 31597ee9b844f996baf7db704f197520752c0c643e5453dfab9e40d9fb175bd6

var $g8m5l = parcelRequire("g8m5l");
const $9aeafee7ce005a49$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterById"
    }, v2 = {
        "defaultValue": 1000,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v4 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "searchBy"
    }, v5 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v6 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v7 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v8 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v9 = {
        "kind": "Variable",
        "name": "searchBy",
        "variableName": "searchBy"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = [
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ ,
        v9 /*: any*/ 
    ], v12 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueType_SearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "issueType_SearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v8 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "small"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueTypeId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v11 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "issueType_issueFieldIssueTypeEditviewFull_issueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "issueTypes"
                                }
                            ],
                            "type": "JiraIssueTypeField"
                        },
                        v12 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "31597ee9b844f996baf7db704f197520752c0c643e5453dfab9e40d9fb175bd6",
            "metadata": {},
            "name": "issueType_SearchRefetchQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider": (0, $g8m5l.default)
            }
        }
    };
}();
$9aeafee7ce005a49$var$node.hash = "54c04d4f507b644a10ef1cc8b3c0fc09";
var $9aeafee7ce005a49$export$2e2bcd8739ae039 = $9aeafee7ce005a49$var$node;

});


parcelRegister("7XH79", function(module, exports) {
$parcel$export(module.exports, "useSuspenselessRefetchStateless", () => $a5387c0f4da0e3f5$export$ae1adabf094b2244);
$parcel$export(module.exports, "useSuspenselessRefetch", () => $a5387c0f4da0e3f5$export$c7ce5f64dc007896);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4im1M = parcelRequire("4im1M");
const $a5387c0f4da0e3f5$var$useInFlightRequests = ({ setIsLoading: setIsLoading })=>{
    const inFlightRequestsRef = (0, $eJOHy.useRef)([]);
    return (0, $eJOHy.useMemo)(()=>({
            onNewRequest: (request)=>{
                inFlightRequestsRef.current.push(request);
            },
            onRequestFinish: (request, /**
				 * Called only if the request hasn't been superceded by a more recent request's success / failure
				 */ onIfRequestIsRelevant)=>{
                // find the first occurrence of this request
                const inFlightRequestIndex = inFlightRequestsRef.current.indexOf(request);
                // If the current request is still considered "in flight"
                if (inFlightRequestIndex !== -1) {
                    onIfRequestIsRelevant?.();
                    // Cut out the current and all proceeding requests from the in-flight queue
                    inFlightRequestsRef.current = inFlightRequestsRef.current.slice(inFlightRequestIndex + 1);
                    // Update isLoading to reflect the current number of in-flight requests
                    setIsLoading?.(!!inFlightRequestsRef.current.length);
                }
            }
        }), [
        setIsLoading
    ]);
};
const $a5387c0f4da0e3f5$export$ae1adabf094b2244 = (// Relay-generated query from the @refetchable annotation in a useRefetchableFragment
// or usePaginationFragment
query, // Refetch function from a useRefetchableFragment or usePaginationFragment
// (which ordinarily would trigger suspense)
refetch, { setIsLoading: setIsLoading, setLastFetchError: setLastFetchError, fetchPolicy: fetchPolicy = 'store-or-network', networkCacheConfig: networkCacheConfig } = {})=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const isMounted = (0, $4im1M.useIsMounted)();
    const { onNewRequest: onNewRequest, onRequestFinish: onRequestFinish } = $a5387c0f4da0e3f5$var$useInFlightRequests({
        setIsLoading: setIsLoading
    });
    const [_, startTransition] = (0, $eJOHy.useTransition)();
    return (0, $eJOHy.useCallback)((variables, options)=>{
        if (isMounted.current) setIsLoading?.(true);
        onNewRequest(variables);
        return (0, $j4oe4.fetchQuery)(environment, query, variables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: networkCacheConfig
        }).subscribe({
            complete () {
                if (isMounted.current) {
                    if (startTransition) // we need concurrent mode for useTransition to work
                    startTransition(()=>{
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                            options?.onComplete?.();
                        });
                    });
                    else {
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                            options?.onComplete?.();
                        });
                    }
                }
            },
            error (e) {
                if (isMounted.current) onRequestFinish(variables, ()=>setLastFetchError?.(e));
            }
        });
    }, [
        environment,
        fetchPolicy,
        isMounted,
        networkCacheConfig,
        onNewRequest,
        onRequestFinish,
        query,
        refetch,
        setIsLoading,
        setLastFetchError,
        startTransition
    ]);
};
const $a5387c0f4da0e3f5$export$c7ce5f64dc007896 = (query, refetch, options)=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [lastFetchError, setLastFetchError] = (0, $eJOHy.useState)(null);
    const refetchFunction = $a5387c0f4da0e3f5$export$ae1adabf094b2244(query, refetch, {
        ...options,
        setIsLoading: setIsLoading,
        setLastFetchError: setLastFetchError
    });
    return [
        refetchFunction,
        isLoading,
        lastFetchError
    ];
};

});
parcelRegister("4im1M", function(module, exports) {
$parcel$export(module.exports, "useIsMounted", () => $bb7ff1168b248128$export$80c2a3957bcb42ea);

var $eJOHy = parcelRequire("eJOHy");
const $bb7ff1168b248128$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});


parcelRegister("jbtzi", function(module, exports) {
$parcel$export(module.exports, "FRAGMENT_FIELD_OPTIONS_FIRST", () => $d156ca0cd64e2913$export$971747fe11f2a6f4);
$parcel$export(module.exports, "FRAGMENT_SELECTABLE_FIELD_OPTIONS_FIRST", () => $d156ca0cd64e2913$export$1a6463c5895cff9e);
$parcel$export(module.exports, "SELECTABLE_FIELD_PAGE_OPTIONS", () => $d156ca0cd64e2913$export$d1beabd8dceb4469);
$parcel$export(module.exports, "MULTI_VERSIONS_FIELD_OPTIONS_FETCH_FIRST", () => $d156ca0cd64e2913$export$176e9e0c749f88b2);
$parcel$export(module.exports, "SEARCH_DEBOUNCE_TIMEOUT", () => $d156ca0cd64e2913$export$228cc37ca8dce73);
$parcel$export(module.exports, "versionStatus", () => $d156ca0cd64e2913$export$7fc41a408a0533d3);
/**
 * This will be used to set the default value for the number of options
 * to be fetched in the first request for the field options.
 */ const $d156ca0cd64e2913$export$971747fe11f2a6f4 = 100;
const $d156ca0cd64e2913$export$1a6463c5895cff9e = 55;
const $d156ca0cd64e2913$export$d1beabd8dceb4469 = 50;
const $d156ca0cd64e2913$export$176e9e0c749f88b2 = 1000;
const $d156ca0cd64e2913$export$228cc37ca8dce73 = 300;
const $d156ca0cd64e2913$export$b983f2cb1f658a55 = 'RELEASED';
const $d156ca0cd64e2913$export$cb459d726a8530a5 = 'UNRELEASED';
const $d156ca0cd64e2913$export$c936349447a77fe0 = 'ARCHIVED';
const $d156ca0cd64e2913$export$7fc41a408a0533d3 = {
    RELEASED: $d156ca0cd64e2913$export$b983f2cb1f658a55,
    UNRELEASED: $d156ca0cd64e2913$export$cb459d726a8530a5,
    ARCHIVED: $d156ca0cd64e2913$export$c936349447a77fe0
};

});

parcelRegister("f1FvV", function(module, exports) {
$parcel$export(module.exports, "filterOptionByLabelAndFilterValues", () => $0b19d4706e6a94cf$export$58bb91b619b113f6);

var $LFmXM = parcelRequire("LFmXM");

var $1beam = parcelRequire("1beam");
const $0b19d4706e6a94cf$export$d3e698d53f63efcd = (val, inputValueIgnoredCase)=>// label can be Object for new option in CreatableSelect
    typeof val === 'string' && val// no need to .trim() since input is already trimmed and we search for .includes() so it does not matter if field has leading or trailing spaces
    .toLowerCase().includes(inputValueIgnoredCase);
const $0b19d4706e6a94cf$var$stringifyLabelAndDataFilterValues = (option)=>{
    const { label: label, data: data } = option || {};
    const { filterValues: filterValues } = data || {};
    const labelString = typeof label === 'string' ? label : '';
    const filterValuesString = (filterValues || []).join(' ');
    return `${labelString} ${filterValuesString}`;
};
/**
 * By default react-select matches by both option.label and option.value: https://github.com/JedWatson/react-select/blob/b7868d23ccd0b9e623b277f971e89020d426fbdb/packages/react-select/src/filters.js#L14.
 * This leads to undesired UX, when filter result includes options without displayed text matching the query (which is very confusing for the user): BENTO-5735, BENTO-5655.
 * That's why we need this function.
 */ const $0b19d4706e6a94cf$var$filterOptionByLabelAndFilterValuesInternal = (0, $LFmXM.default)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $1beam.createFilter)({
        // Take an option object and convert it to a string that needs to partially match the user's query
        stringify: $0b19d4706e6a94cf$var$stringifyLabelAndDataFilterValues
    }));
const $0b19d4706e6a94cf$export$58bb91b619b113f6 = (option, inputValue)=>$0b19d4706e6a94cf$var$filterOptionByLabelAndFilterValuesInternal()(option, inputValue);

});

parcelRegister("4F1Zj", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc03aeeb2a58dadd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $dc03aeeb2a58dadd$var$messages = (0, $7qGN1.defineMessages)({
    empty: {
        "id": "issue-field-issue-type-editview-full.issue-type.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-issue-type-editview-full.issue-type.failed-fetch",
        "defaultMessage": "Search failed."
    },
    loading: {
        "id": "issue-field-issue-type-editview-full.issue-type.loading",
        "defaultMessage": "Searching..."
    },
    placeholder: {
        "id": "issue-field-issue-type-editview-full.issue-type.placeholder",
        "defaultMessage": "Select Issue Type"
    },
    label: {
        "id": "issue-field-issue-type-editview-full.issue-type.label",
        "defaultMessage": "Issue Type"
    },
    placeholderIssueTerminologyRefreshM4: {
        "id": "issue-field-issue-type-editview-full.issue-type.placeholder-issue-terminology-refresh-m4",
        "defaultMessage": "Select work type"
    },
    labelIssueTerminologyRefreshM4: {
        "id": "issue-field-issue-type-editview-full.issue-type.label-issue-terminology-refresh-m4",
        "defaultMessage": "Work Type"
    }
});
var $dc03aeeb2a58dadd$export$2e2bcd8739ae039 = $dc03aeeb2a58dadd$var$messages;

});

parcelRegister("3NHkq", function(module, exports) {
$parcel$export(module.exports, "MenuFooter", () => $37a129e7c79bccb3$export$d6f87b6f250ab93e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $7saMl = parcelRequire("7saMl");
var $6YEko = parcelRequire("6YEko");

var $lRq8t = parcelRequire("lRq8t");

var $83DiZ = parcelRequire("83DiZ");

var $jMRoT = parcelRequire("jMRoT");

var $asoyU = parcelRequire("asoyU");

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $4cTDP = parcelRequire("4cTDP");

var $llT4J = parcelRequire("llT4J");

var $cHtIB = parcelRequire("cHtIB");

var $eCVV2 = parcelRequire("eCVV2");

var $fGRYk = parcelRequire("fGRYk");

var $aaGSX = parcelRequire("aaGSX");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $lexMn = parcelRequire("lexMn");

var $8HM6I = parcelRequire("8HM6I");
const $37a129e7c79bccb3$var$getIssueTypeEditExperience = (source)=>{
    return new (0, $f39LL.UFOExperience)(`${source}.edit-issue-type`, {
        type: (0, $2lxLk.ExperienceTypes).Operation,
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom
    });
};
const $37a129e7c79bccb3$export$a51de57a74d54dd1 = (options)=>{
    return options.filter((option)=>'issueTypeId' in option && typeof option.issueTypeId === 'string').map((option)=>option.issueTypeId);
};
const $37a129e7c79bccb3$export$d6f87b6f250ab93e = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const source = (0, $lexMn.useExtractSourceFromNamespace)();
    const { projectKey: projectKey, projectType: projectType, projectId: projectId, selectedIssueTypeId: selectedIssueTypeId, allowIssueTypeCreation: allowIssueTypeCreation = true, onIssueTypeUpdated: onIssueTypeUpdated, onIssueTypeCreated: onIssueTypeCreated, setIsManageIssueTypesModalOpen: setIsManageIssueTypesModalOpen, options: options, menuIsOpen: menuIsOpen, isSimplifiedProject: isSimplifiedProject } = props;
    const projectSettingsUrl = (0, $jMRoT.getProjectSettingsIssueTypesUrl)({
        projectKey: projectKey,
        projectType: projectType ?? '',
        isSimplifiedProject: isSimplifiedProject
    });
    const handleManageIssueTypesClick = (0, $eJOHy.useCallback)(()=>{
        if ((0, $4cTDP.fg)('work_type_inline_config_nin_icc_analytics')) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'manageIssueTypesButton');
        push(projectSettingsUrl);
    }, [
        push,
        projectSettingsUrl,
        createAnalyticsEvent
    ]);
    const handleAddIssueTypeClick = (0, $eJOHy.useCallback)(()=>{
        setIsManageIssueTypesModalOpen?.(true);
        if ((0, $4cTDP.fg)('work_type_inline_config_nin_icc_analytics')) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createIssueTypeButton');
    }, [
        setIsManageIssueTypesModalOpen,
        createAnalyticsEvent
    ]);
    const handleEditIssueTypeClick = (0, $eJOHy.useCallback)(()=>{
        setIsManageIssueTypesModalOpen?.(true);
        if ((0, $4cTDP.fg)('work_type_inline_config_nin_icc_analytics')) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'editIssueTypeButton');
    }, [
        setIsManageIssueTypesModalOpen,
        createAnalyticsEvent
    ]);
    const ufoExperience = $37a129e7c79bccb3$var$getIssueTypeEditExperience(source);
    const onCloseCreateIssueTypeModal = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'inlineCreateIssueTypeModal',
            action: 'closed'
        }));
    }, [
        createAnalyticsEvent
    ]);
    const onCloseEditIssueTypeModal = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'inlineEditIssueTypeModal',
            action: 'closed'
        }));
    }, [
        createAnalyticsEvent
    ]);
    const createEntryPointProps = (0, $eJOHy.useMemo)(()=>({
            projectId: Number(projectId),
            projectKey: projectKey,
            onClose: onCloseCreateIssueTypeModal,
            onOpen: handleAddIssueTypeClick,
            onOpenManageTypes: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            issueTypeId: selectedIssueTypeId,
            ufoExperience: ufoExperience,
            onIssueTypeCreated: onIssueTypeCreated ?? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            source: source,
            showNewIssueTypeForm: true,
            isProjectAdmin: true,
            isWrappedInModal: true
        }), [
        projectId,
        projectKey,
        onCloseCreateIssueTypeModal,
        handleAddIssueTypeClick,
        selectedIssueTypeId,
        ufoExperience,
        onIssueTypeCreated,
        source
    ]);
    const editEntryPointProps = (0, $eJOHy.useMemo)(()=>({
            projectId: Number(projectId),
            projectKey: projectKey,
            onClose: onCloseEditIssueTypeModal,
            onOpen: handleEditIssueTypeClick,
            issueTypeId: selectedIssueTypeId,
            ufoExperience: ufoExperience,
            onRefetchIssueTypesWhenIssueTypeUpdated: onIssueTypeUpdated ?? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            calledFrom: source,
            shouldShowIssueTypeSelect: true,
            relevantIssueTypeIds: $37a129e7c79bccb3$export$a51de57a74d54dd1(options)
        }), [
        projectId,
        projectKey,
        handleEditIssueTypeClick,
        selectedIssueTypeId,
        ufoExperience,
        onIssueTypeUpdated,
        source,
        options,
        onCloseEditIssueTypeModal
    ]);
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            projectKey: projectKey,
            cloudId: cloudId
        }), [
        projectKey,
        cloudId
    ]);
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            ...(0, $llT4J.defaultModalProps),
            onCloseComplete: ()=>{
                setIsManageIssueTypesModalOpen?.(false);
            }
        }), [
        setIsManageIssueTypesModalOpen
    ]);
    if (!menuIsOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        hasSeparator: true
    }, allowIssueTypeCreation && isSimplifiedProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $asoyU.ModalTrigger), {
        entryPoint: (0, $fGRYk.asyncCreateIssueTypeModalEntryPoint),
        entryPointParams: entryPointParams,
        entryPointProps: createEntryPointProps,
        modalProps: modalProps,
        Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 1
            })
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
            ref: ref
        }, formatMessage((0, $8HM6I.default).addIssueType))), isSimplifiedProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $asoyU.ModalTrigger), {
        entryPoint: (0, $eCVV2.asyncEditIssueTypeModalEntrypoint),
        entryPointParams: entryPointParams,
        entryPointProps: editEntryPointProps,
        modalProps: modalProps,
        Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 1
            })
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
            ref: ref
        }, formatMessage((0, $8HM6I.default).editIssueType))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        onClick: handleManageIssueTypesClick
    }, formatMessage((0, $8HM6I.default).manageIssueTypes)));
};

});
parcelRegister("jMRoT", function(module, exports) {
$parcel$export(module.exports, "getProjectSettingsIssueTypesUrl", () => $de0c8e134ff95356$export$e2e29d5bcfe97104);

var $4cTDP = parcelRequire("4cTDP");
const $de0c8e134ff95356$export$e2e29d5bcfe97104 = ({ projectKey: projectKey, projectType: projectType, isSimplifiedProject: isSimplifiedProject })=>{
    if ((0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg')) return $de0c8e134ff95356$export$3f2a8a2b05ad3842({
        projectKey: projectKey,
        projectType: projectType,
        isSimplifiedProject: isSimplifiedProject
    });
    return $de0c8e134ff95356$export$10e2e08b7045ea91({
        projectKey: projectKey,
        projectType: projectType
    });
};
const $de0c8e134ff95356$export$10e2e08b7045ea91 = ({ projectKey: projectKey, projectType: projectType })=>{
    switch(projectType?.toLowerCase()){
        case 'customer_service':
        case 'service_desk':
            return `/plugins/servlet/project-config/${projectKey}/issueTypes`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/issuetypes`;
        default:
            return `/jira/software/projects/${projectKey}/settings/issuetypes`;
    }
};
const $de0c8e134ff95356$export$3f2a8a2b05ad3842 = ({ projectKey: projectKey, projectType: projectType, isSimplifiedProject: isSimplifiedProject })=>{
    switch(projectType?.toLowerCase()){
        case 'customer_service':
        case 'service_desk':
            return `/plugins/servlet/project-config/${projectKey}/issuetypes`;
        case 'business':
            return $de0c8e134ff95356$var$getBusinessProjectSettingsUrl({
                projectKey: projectKey,
                isSimplifiedProject: isSimplifiedProject
            });
        case 'software':
            return $de0c8e134ff95356$var$getSoftwareProjectSettingsUrl({
                projectKey: projectKey,
                isSimplifiedProject: isSimplifiedProject
            });
        default:
            return `/jira/software/projects/${projectKey}/settings/issuetypes`;
    }
};
const $de0c8e134ff95356$var$getSoftwareProjectSettingsUrl = ({ projectKey: projectKey, isSimplifiedProject: isSimplifiedProject })=>isSimplifiedProject !== undefined && !isSimplifiedProject ? `/plugins/servlet/project-config/${projectKey}/issuetypes` : `/jira/software/projects/${projectKey}/settings/issuetypes`;
const $de0c8e134ff95356$var$getBusinessProjectSettingsUrl = ({ projectKey: projectKey, isSimplifiedProject: isSimplifiedProject })=>isSimplifiedProject !== undefined && !isSimplifiedProject ? `/plugins/servlet/project-config/${projectKey}/issuetypes` : `/jira/core/projects/${projectKey}/settings/issuetypes`;

});

parcelRegister("llT4J", function(module, exports) {
$parcel$export(module.exports, "defaultModalProps", () => $38e5b01445975ac2$export$14c11acc66fd51b3);
const $38e5b01445975ac2$export$14c11acc66fd51b3 = {
    width: '395px'
};

});

parcelRegister("eCVV2", function(module, exports) {
$parcel$export(module.exports, "asyncEditIssueTypeModalEntrypoint", () => $09686e3af1a308a2$export$77154afa25455a57);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $iBl8G = parcelRequire("iBl8G");

const $09686e3af1a308a2$export$77154afa25455a57 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("8a7so")).then((module)=>module.AsyncEditIssueTypeModal), {
        moduleId: "22548b83",
        priority: "interaction"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId })=>({
            queries: {
                editIssueTypeModal: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $iBl8G.default,
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("iBl8G", function(module, exports) {
$parcel$export(module.exports, "default", () => $375bc989a6788bcc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e1192085c48690de29428a79c9d6d1b6>>
 * @relayHash e7bd81102c1dee96dbca11245e366952
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b119f6603ebb196c870e258ef65c6302b9c0f15a6c9732a0f8d24d5c27ad696
const $375bc989a6788bcc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "description"
    }, v5 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "medium"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcAsyncEditIssueTypeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueTypeConnection",
                                                "kind": "LinkedField",
                                                "name": "issueTypes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueTypeEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v2 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraProjectByKey.issueTypes.edges.node.issueTypeId"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraProjectByKey.issueTypes.edges.node.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v4 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraProjectByKey.issueTypes.edges.node.description"
                                                                            },
                                                                            v5 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.jiraProjectByKey.issueTypes.edges.node"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.jiraProjectByKey.issueTypes.edges"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.issueTypes"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcAsyncEditIssueTypeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4b119f6603ebb196c870e258ef65c6302b9c0f15a6c9732a0f8d24d5c27ad696",
            "metadata": {},
            "name": "srcAsyncEditIssueTypeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$375bc989a6788bcc$var$node.hash = "95da41f0960685e3830143828659ecad";
var $375bc989a6788bcc$export$2e2bcd8739ae039 = $375bc989a6788bcc$var$node;

});

parcelRegister("8a7so", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("hvGrC")
]).then(()=>parcelRequire('d5kQ7'));

});


parcelRegister("fGRYk", function(module, exports) {
$parcel$export(module.exports, "asyncCreateIssueTypeModalEntryPoint", () => $017dfafefc3951e5$export$7f9428aac5b01dff);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $eeWnE = parcelRequire("eeWnE");

const $017dfafefc3951e5$export$7f9428aac5b01dff = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("eRAye")), {
        moduleId: "0ca2b96c",
        priority: "interaction"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId, shouldFetchProjectData: shouldFetchProjectData })=>({
            queries: {
                createIssueTypeModal: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $eeWnE.default,
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        shouldFetchProjectData: shouldFetchProjectData
                    }
                }
            }
        })
});

});
parcelRegister("eeWnE", function(module, exports) {
$parcel$export(module.exports, "default", () => $aaa736cee5e6bf3b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<36277921a8012e0702a65f1227cbbd1b>>
 * @relayHash 4a7b622560b3b3e20bb696680e8560ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d8c35e32d8548b68e2966c6dacdbc893c0768a3dd5dc31d2dfca58cd3e11bc76
const $aaa736cee5e6bf3b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "shouldFetchProjectData"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcAsyncCreateIssueTypeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueTypeConnection",
                                                "kind": "LinkedField",
                                                "name": "issueTypes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ui_createIssueTypeModal_CreateIssueTypeModalWrapper_createIssueTypeFragmentRef"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.issueTypes"
                                        },
                                        {
                                            "condition": "shouldFetchProjectData",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_createIssueTypeModal_CreateIssueTypeModalWrapper_projectDataFragmentRef"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcAsyncCreateIssueTypeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        },
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                            "kind": "LinkedField",
                                                            "name": "hierarchy",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "level"
                                                                }
                                                            ]
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "shouldFetchProjectData",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectStyle"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "uuid"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "medium"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d8c35e32d8548b68e2966c6dacdbc893c0768a3dd5dc31d2dfca58cd3e11bc76",
            "metadata": {},
            "name": "srcAsyncCreateIssueTypeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$aaa736cee5e6bf3b$var$node.hash = "b50515a18d5488758aa762560868c40c";
var $aaa736cee5e6bf3b$export$2e2bcd8739ae039 = $aaa736cee5e6bf3b$var$node;

});

parcelRegister("eRAye", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kNFvF"),
    $ewTvA("f5XY9")
]).then(()=>parcelRequire('bRzMj'));

});


parcelRegister("aaGSX", function(module, exports) {
$parcel$export(module.exports, "FormDialogSkeleton", () => $0b33aba420d5c901$export$3e5b4585c21ca29d);

var $eJOHy = parcelRequire("eJOHy");

var $lmgo6 = parcelRequire("lmgo6");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $jjS5D = parcelRequire("jjS5D");
const $0b33aba420d5c901$var$COMMON_SKELETON_PROPS = {
    borderRadius: "var(--ds-radius-large, 8px)",
    isShimmering: true
};
const $0b33aba420d5c901$export$3e5b4585c21ca29d = ({ numFormFields: numFormFields })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        direction: "column",
        xcss: $0b33aba420d5c901$var$modalSkeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        direction: "column",
        xcss: $0b33aba420d5c901$var$headerSkeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "40%",
        height: 24,
        ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.header-title"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "35%",
        height: 16,
        ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.header-subtitle"
    }))), Array.from({
        length: numFormFields
    }).map((_, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
            space: "space.050",
            key: idx,
            xcss: $0b33aba420d5c901$var$formFieldSkeletonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
            width: "30%",
            height: 16,
            ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
            testId: `form-field-label-${idx}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
            width: "100%",
            height: 40,
            ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
            testId: `form-field-input-${idx}`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        justifyContent: "end",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: 72,
        height: 32,
        ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.cancel-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: 72,
        height: 32,
        ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.submit-button"
    }))));
const $0b33aba420d5c901$var$modalSkeletonStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.xlarge',
    width: '394px',
    padding: 'space.300'
});
const $0b33aba420d5c901$var$headerSkeletonStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.100'
});
const $0b33aba420d5c901$var$formFieldSkeletonStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});

});

parcelRegister("lexMn", function(module, exports) {
$parcel$export(module.exports, "useExtractSourceFromNamespace", () => $6b2ce75ad83cf61e$export$71a635bf14994f91);

var $eJOHy = parcelRequire("eJOHy");


var $ftN6c = parcelRequire("ftN6c");
const $6b2ce75ad83cf61e$var$extractSourceFromContext = (analyticsEvent, sourceName)=>{
    if (!analyticsEvent?.context || !Array.isArray(analyticsEvent.context)) return undefined;
    const contextEntry = analyticsEvent.context.find((entry)=>entry?.source === sourceName);
    return contextEntry?.source;
};
const $6b2ce75ad83cf61e$export$71a635bf14994f91 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = (0, $eJOHy.useMemo)(()=>createAnalyticsEvent({}), [
        createAnalyticsEvent
    ]);
    const issueNavigatorListViewScreen = (0, $eJOHy.useMemo)(()=>$6b2ce75ad83cf61e$var$extractSourceFromContext(analyticsEvent, 'issueNavigatorListViewScreen'), [
        analyticsEvent
    ]);
    const jiraTimelineScreen = (0, $eJOHy.useMemo)(()=>$6b2ce75ad83cf61e$var$extractSourceFromContext(analyticsEvent, 'jiraTimelineScreen'), [
        analyticsEvent
    ]);
    const businessProjectContextScreen = (0, $eJOHy.useMemo)(()=>$6b2ce75ad83cf61e$var$extractSourceFromContext(analyticsEvent, 'businessProjectContextScreen'), [
        analyticsEvent
    ]);
    const mappedSource = (0, $eJOHy.useMemo)(()=>{
        if (issueNavigatorListViewScreen) return 0, $a9cbb8c64aa7f847$export$4edb790587638895;
        if (businessProjectContextScreen && jiraTimelineScreen) return 0, $a9cbb8c64aa7f847$export$feb45a6c3660f344;
        return 0, $a9cbb8c64aa7f847$export$8f4fd516b77f8d43;
    }, [
        issueNavigatorListViewScreen,
        businessProjectContextScreen,
        jiraTimelineScreen
    ]);
    return mappedSource;
};

});
const $a9cbb8c64aa7f847$export$c766acff4513a976 = 'summaryView';
const $a9cbb8c64aa7f847$export$4edb790587638895 = 'listView';
const $a9cbb8c64aa7f847$export$cafb161c2b21b455 = 'issueView';
const $a9cbb8c64aa7f847$export$66397ed56abea4ca = 'gicView';
const $a9cbb8c64aa7f847$export$a1077f863a923e94 = 'gicViewNoResults';
const $a9cbb8c64aa7f847$export$7f04bd1df3763938 = 'jswBoard';
const $a9cbb8c64aa7f847$export$e9d7f84ef97a0f63 = 'businessBoard';
const $a9cbb8c64aa7f847$export$bd8f63529bb9357f = 'jswBacklog';
const $a9cbb8c64aa7f847$export$57eacdfdee901d4c = 'jswTimeline';
const $a9cbb8c64aa7f847$export$feb45a6c3660f344 = 'businessTimeline';
const $a9cbb8c64aa7f847$export$8f4fd516b77f8d43 = 'unknown';
const $a9cbb8c64aa7f847$export$334975a13cb19c35 = 'editIssueTypeButton';
const $a9cbb8c64aa7f847$export$e970abb363c8ec67 = 'deleteIssueTypeButton';


parcelRegister("8HM6I", function(module, exports) {
$parcel$export(module.exports, "default", () => $df7c2167bd3906bd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $df7c2167bd3906bd$var$messages = (0, $7qGN1.defineMessages)({
    addIssueType: {
        "id": "issue-field-issue-type-editview-full.issue-type.add-work-type",
        "defaultMessage": "Add work type"
    },
    editIssueType: {
        "id": "issue-field-issue-type-editview-full.issue-type.edit-work-type",
        "defaultMessage": "Edit work type"
    },
    manageIssueTypes: {
        "id": "issue-field-issue-type-editview-full.issue-type.manage-work-types",
        "defaultMessage": "Manage"
    }
});
var $df7c2167bd3906bd$export$2e2bcd8739ae039 = $df7c2167bd3906bd$var$messages;

});


parcelRegister("hUVzR", function(module, exports) {
$parcel$export(module.exports, "useManageIssueTypeCallbacks", () => $499f47d3098f6095$export$22b4f8796fd11f31);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");
const $499f47d3098f6095$var$PENDING_CREATED_ISSUE_TYPE_TIMEOUT_MS = 10000; // 10 seconds
function $499f47d3098f6095$export$22b4f8796fd11f31({ onRefetch: onRefetch, onGetRefetchVariables: onGetRefetchVariables, selectFieldOptions: selectFieldOptions, onChange: onChange, onIssueTypeCreation: onIssueTypeCreation }) {
    const [pendingCreatedIssueType, setPendingCreatedIssueType] = (0, $eJOHy.useState)(null);
    // Watch for created issue type to appear in options after refetch in order to select it
    (0, $eJOHy.useEffect)(()=>{
        if (!pendingCreatedIssueType) return;
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-live-state-to-parent
        const foundOption = selectFieldOptions.find((option)=>option.issueTypeId === pendingCreatedIssueType.issueTypeId);
        if (foundOption) {
            onChange?.(foundOption);
            if ((0, $4cTDP.fg)('work_type_inline_config_nin_icc_fast_follow')) onIssueTypeCreation?.({
                issueTypeId: foundOption.issueTypeId ?? undefined
            });
            setPendingCreatedIssueType(null);
            return;
        }
        // Issue type not found yet - set timeout to clear pending state after 10 seconds
        // This handles the case where refetch fails or the issue type never appears
        const timeout = setTimeout(()=>{
            setPendingCreatedIssueType(null);
        }, $499f47d3098f6095$var$PENDING_CREATED_ISSUE_TYPE_TIMEOUT_MS);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        pendingCreatedIssueType,
        selectFieldOptions,
        onChange,
        onIssueTypeCreation
    ]);
    const onIssueTypeUpdated = (0, $eJOHy.useCallback)((updatedIssueType)=>{
        onRefetch(onGetRefetchVariables(''), {
            fetchPolicy: 'network-only'
        });
        const issueTypeOptionToSelect = selectFieldOptions.find((option)=>option.issueTypeId === updatedIssueType?.issueTypeId);
        onChange?.(issueTypeOptionToSelect ?? null);
    }, [
        onRefetch,
        onGetRefetchVariables,
        selectFieldOptions,
        onChange
    ]);
    const onIssueTypeCreated = (0, $eJOHy.useCallback)((createdIssueType)=>{
        if ((0, $4cTDP.fg)('work_type_inline_config_nin_icc_fast_follow')) setPendingCreatedIssueType(createdIssueType);
        onRefetch(onGetRefetchVariables(''), {
            fetchPolicy: 'network-only'
        });
    }, [
        onGetRefetchVariables,
        onRefetch
    ]);
    return {
        onIssueTypeUpdated: onIssueTypeUpdated,
        onIssueTypeCreated: onIssueTypeCreated
    };
}

});

parcelRegister("lvadq", function(module, exports) {
$parcel$export(module.exports, "Trigger", () => $30cfd4265ea87fdf$export$41fb9f06171c75f4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $2sLVw = parcelRequire("2sLVw");

var $5CSKW = parcelRequire("5CSKW");

var $1OQKp = parcelRequire("1OQKp");

var $1vA1E = parcelRequire("1vA1E");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $kf5CR = parcelRequire("kf5CR");
const $30cfd4265ea87fdf$var$GENERIC_ICON_URL = '/icons/issuetypes/genericissue.svg';
const $30cfd4265ea87fdf$export$41fb9f06171c75f4 = ({ isOpen: isOpen, triggerRef: triggerRef, value: value, ...triggerProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: value?.label ?? null,
        delay: 500,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        ...triggerProps,
        "aria-label": formatMessage((0, $kf5CR.default).label, {
            issueType: value?.label
        }),
        appearance: "subtle",
        isSelected: isOpen,
        ref: triggerRef,
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        alignItems: "center",
        justifyContent: "center",
        gap: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: value?.avatar?.small || $30cfd4265ea87fdf$var$GENERIC_ICON_URL,
        alt: "",
        className: (0, $hcewu.default)([
            $30cfd4265ea87fdf$var$imgStyles.root
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        className: (0, $hcewu.default)([
            $30cfd4265ea87fdf$var$wrapperStyles.root
        ])
    }, isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1vA1E))), {
        label: "",
        color: "var(--ds-icon, #292A2E)",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
        label: "",
        color: "var(--ds-icon, #292A2E)",
        size: "small"
    })))));
};
const $30cfd4265ea87fdf$var$imgStyles = {
    root: "_4t3i7vkz _1bsb7vkz _19pkv77o"
}; // Required for issue-table, as it adds an eventlistener that checks if the event target was part of the ICC form
// Therefore we need the event target to be the button so that it remains in the DOM
const $30cfd4265ea87fdf$var$wrapperStyles = {
    root: "_lcxvglyw"
};

});
parcelRegister("kf5CR", function(module, exports) {
$parcel$export(module.exports, "default", () => $fefb87dddd8a1010$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fefb87dddd8a1010$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    label: {
        "id": "issue-field-issue-type-editview-full.issue-type.label",
        "defaultMessage": "Select work type. {issueType} currently selected."
    }
});

});



parcelRegister("aB2Z6", function(module, exports) {
$parcel$export(module.exports, "useDefaultIssueType", () => $eafa7e0acaad2c22$export$9c7f64b201a937e7);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $4MchI = parcelRequire("4MchI");

var $1W85r = parcelRequire("1W85r");
const $eafa7e0acaad2c22$var$defaultProjectConfigProjectConfig = {
    defaultIssueType: null
};
const $eafa7e0acaad2c22$var$selectProjectConfig = (0, $4MchI.createSelector)((_, projectKey)=>projectKey, ({ projectConfigs: projectConfigs })=>projectConfigs, (projectKey, projectConfigs)=>{
    if (projectKey == null) return $eafa7e0acaad2c22$var$defaultProjectConfigProjectConfig;
    const config = projectConfigs[projectKey];
    if (config == null) return $eafa7e0acaad2c22$var$defaultProjectConfigProjectConfig;
    return config;
});
const $eafa7e0acaad2c22$var$selectIssueType = (0, $4MchI.createSelector)($eafa7e0acaad2c22$var$selectProjectConfig, (config)=>config.defaultIssueType);
const $eafa7e0acaad2c22$export$9c7f64b201a937e7 = (0, $iJq0l.createHook)((0, $1W85r.IICConfigStore), {
    selector: $eafa7e0acaad2c22$var$selectIssueType
});

});
parcelRegister("1W85r", function(module, exports) {
$parcel$export(module.exports, "IICConfigStore", () => $0b13d55531392d29$export$9bd138189628b8f1);
$parcel$export(module.exports, "useIICConfigActions", () => $0b13d55531392d29$export$d86349fef3b2869d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $0b13d55531392d29$var$initialState = {
    projectConfigs: {}
};
const $0b13d55531392d29$var$actions = {
    setDefaultIssueType: (projectKey, issueType)=>({ setState: setState, getState: getState })=>{
            if (projectKey == null) return;
            const currentState = getState();
            let projectConfig = currentState.projectConfigs[projectKey];
            if (projectConfig == null) projectConfig = {
                defaultIssueType: null
            };
            projectConfig.defaultIssueType = issueType;
            setState({
                ...currentState,
                projectConfigs: {
                    ...currentState.projectConfigs,
                    [projectKey]: projectConfig
                }
            });
        }
};
const $0b13d55531392d29$export$9bd138189628b8f1 = (0, $GtRbT.createStore)({
    initialState: $0b13d55531392d29$var$initialState,
    actions: $0b13d55531392d29$var$actions
});
const $0b13d55531392d29$export$8b216441e8d7a953 = (0, $iJq0l.createHook)($0b13d55531392d29$export$9bd138189628b8f1);
const $0b13d55531392d29$export$d86349fef3b2869d = (0, $iJq0l.createActionsHook)($0b13d55531392d29$export$9bd138189628b8f1);

});


parcelRegister("l4kLF", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb1df118e16999d7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cb1df118e16999d7$var$messages = (0, $7qGN1.defineMessages)({
    label: {
        "id": "issue-table-inline-issue-create.inline-create-from.issue-type-dropdown.label",
        "defaultMessage": "Issue type"
    },
    labelIssueTerminologyRefreshM4: {
        "id": "issue-table-inline-issue-create.inline-create-from.issue-type-dropdown.label-issue-terminology-refresh-m4",
        "defaultMessage": "Work type"
    }
});
var $cb1df118e16999d7$export$2e2bcd8739ae039 = $cb1df118e16999d7$var$messages;

});

parcelRegister("kLXPe", function(module, exports) {
$parcel$export(module.exports, "useUpdateIssueTypeLinksOnCreate", () => $72f11ef9259924a4$export$8d4f5d0c6832f888);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $kqd31 = parcelRequire("kqd31");

var $cHtIB = parcelRequire("cHtIB");

var $3osLr = parcelRequire("3osLr");
const $72f11ef9259924a4$export$8d4f5d0c6832f888 = ()=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $cHtIB.useCloudId)();
    return (0, $eJOHy.useCallback)(({ issueTypeId: issueTypeId, projectId: projectId })=>{
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            const issueRelayId = (0, $kqd31.default)({
                id: issueTypeId
            }, 'JiraIssueType');
            const issueTypeRecordToLink = issueRelayId ? store.get(issueRelayId) : null;
            const ari = (0, $3osLr.JiraProjectAri).create({
                siteId: cloudId,
                projectId: projectId
            });
            const linkedProjectRelayId = (0, $kqd31.default)({
                id: ari
            }, 'JiraProject');
            if (issueTypeRecordToLink && linkedProjectRelayId) {
                const linkedProjectRecord = store.get(linkedProjectRelayId);
                if (linkedProjectRecord) {
                    let connection = (0, $37Ewn.ConnectionHandler).getConnection(linkedProjectRecord, 'issueTypes');
                    if (!connection) {
                        const connectionId = `client:${linkedProjectRelayId}:issueTypes`;
                        connection = store.get(connectionId);
                    }
                    if (connection) {
                        const newIssueTypeRecord = (0, $37Ewn.ConnectionHandler).createEdge(store, connection, issueTypeRecordToLink, 'JiraIssueTypeEdge');
                        newIssueTypeRecord.setValue(true, 'isDueDatePresentInIssueCreate');
                        newIssueTypeRecord.setValue(true, 'isAssigneePresentInIssueCreate');
                        (0, $37Ewn.ConnectionHandler).insertEdgeBefore(connection, newIssueTypeRecord);
                    }
                }
            }
        });
    }, [
        environment,
        cloudId
    ]);
};

});


parcelRegister("eNuUB", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c7dd3f69b21f2c1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3c7dd3f69b21f2c1$var$messages = (0, $7qGN1.defineMessages)({
    createButton: {
        "id": "issue-table-inline-issue-create.inline-create-from.create-button",
        "defaultMessage": "Create"
    },
    placeholderText: {
        "id": "issue-table-inline-issue-create.inline-create-from.placeholder-text",
        "defaultMessage": "What needs to be done?"
    }
});
var $3c7dd3f69b21f2c1$export$2e2bcd8739ae039 = $3c7dd3f69b21f2c1$var$messages;

});

parcelRegister("ab4Fp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f79f07048da8f6ae$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $f79f07048da8f6ae$var$ReturnGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 0C1.34315 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16H21C22.6569 16 24 14.6569 24 13V3C24 1.34315 22.6569 0 21 0H3Z",
        fill: "var(--ds-background-inverse-subtle, #00000029)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M15.5 5.75V6.75C15.5 8.26878 14.2688 9.5 12.75 9.5H8.75C8.33579 9.5 8 9.16421 8 8.75C8 8.33579 8.33579 8 8.75 8H12.75C13.4404 8 14 7.44036 14 6.75V5.75C14 5.33579 14.3358 5 14.75 5C15.1642 5 15.5 5.33579 15.5 5.75Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M9.28033 9.28033L11.0303 7.53033C11.3232 7.23744 11.3232 6.76256 11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967L8.21967 8.21967C7.92678 8.51256 7.92678 8.98744 8.21967 9.28033C8.51256 9.57322 8.98744 9.57322 9.28033 9.28033Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M9.28033 8.21967L11.0303 9.96967C11.3232 10.2626 11.3232 10.7374 11.0303 11.0303C10.7374 11.3232 10.2626 11.3232 9.96967 11.0303L8.21967 9.28033C7.92678 8.98744 7.92678 8.51256 8.21967 8.21967C8.51256 7.92678 8.98744 7.92678 9.28033 8.21967Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }));
// Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $f79f07048da8f6ae$var$ReturnIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f79f07048da8f6ae$var$ReturnGlyph, null);
var $f79f07048da8f6ae$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($f79f07048da8f6ae$var$ReturnIcon);

});


parcelRegister("1Ob2L", function(module, exports) {
$parcel$export(module.exports, "useInlineIssueCreateEntryPoint", () => $a59bff9a3ee71001$export$885248fb7870aaf0);
$parcel$export(module.exports, "useInlineIssueCreateAdditionalFieldsEntryPoint", () => $a59bff9a3ee71001$export$345c7d6ef1e7c79c);

var $iWvkh = parcelRequire("iWvkh");

var $cHtIB = parcelRequire("cHtIB");

var $bYsdT = parcelRequire("bYsdT");

var $63ryK = parcelRequire("63ryK");
const $a59bff9a3ee71001$export$885248fb7870aaf0 = (projectKey, minHierarchyLevel, maxHierarchyLevel)=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    return (0, $iWvkh.useEntryPoint)((0, $63ryK.default), {
        cloudId: cloudId,
        projectKey: projectKey,
        minHierarchyLevel: minHierarchyLevel ?? undefined,
        maxHierarchyLevel: maxHierarchyLevel ?? undefined
    });
};
const $a59bff9a3ee71001$export$345c7d6ef1e7c79c = ({ projectKey: projectKey, defaultAssigneeId: defaultAssigneeId })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    return (0, $iWvkh.useEntryPoint)((0, $bYsdT.InlineCreateAdditionalFieldsEntrypoint), {
        cloudId: cloudId,
        projectKey: projectKey,
        defaultAssigneeId: defaultAssigneeId
    });
};

});
parcelRegister("bYsdT", function(module, exports) {
$parcel$export(module.exports, "InlineCreateAdditionalFieldsEntrypoint", () => $4dcf8b0cdfa91d90$export$19884e0312fcb420);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $lQexZ = parcelRequire("lQexZ");

const $4dcf8b0cdfa91d90$export$19884e0312fcb420 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("kV2gv")), {
        moduleId: "be327326",
        moduleName: "InlineCreateAdditionalFieldsEntrypoint",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey, defaultAssigneeId: defaultAssigneeId })=>({
            queries: {
                rootData: {
                    parameters: $lQexZ.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey ?? '',
                        hasProjectKey: !!projectKey,
                        defaultAssigneeId: defaultAssigneeId ?? '',
                        hasDefaultAssignee: !!defaultAssigneeId
                    }
                }
            }
        })
});

});
parcelRegister("lQexZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ce020f230b7b2e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<083791ee8fe8ac629678816f5ad84129>>
 * @relayHash 18a79873a0d8adb8b564459d1e3933ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e912661cb90a2ca17e80283a3722471456baf4b4679e680954281ed13e4261ef
const $1ce020f230b7b2e8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e912661cb90a2ca17e80283a3722471456baf4b4679e680954281ed13e4261ef",
        "metadata": {},
        "name": "InlineCreateAdditionalFieldsEntrypointQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1ce020f230b7b2e8$export$2e2bcd8739ae039 = $1ce020f230b7b2e8$var$node;

});

parcelRegister("kV2gv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jfnqE").then(()=>parcelRequire('bwXPC'));

});


parcelRegister("63ryK", function(module, exports) {
$parcel$export(module.exports, "default", () => $00eae25319f329e7$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $cvMpq = parcelRequire("cvMpq");

const $00eae25319f329e7$var$IssueTypeDropdownEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("ljpuj"))).then((module)=>module.IssueTypeDropdownEntryPoint), {
        moduleId: "4b489ed2",
        moduleName: "IssueTypeDropdown",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey, minHierarchyLevel: minHierarchyLevel, maxHierarchyLevel: maxHierarchyLevel })=>({
            queries: {
                projectData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $cvMpq.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey ?? '',
                        hasProjectKey: !!projectKey,
                        ...minHierarchyLevel != null ? {
                            filter: {
                                minHierarchyLevel: minHierarchyLevel,
                                maxHierarchyLevel: maxHierarchyLevel
                            }
                        } : {}
                    }
                }
            }
        })
});
var $00eae25319f329e7$export$2e2bcd8739ae039 = $00eae25319f329e7$var$IssueTypeDropdownEntryPoint;

});


parcelRegister("1cMAs", function(module, exports) {
$parcel$export(module.exports, "default", () => $979fa4e593532476$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $biF5G = parcelRequire("biF5G");

var $5CSKW = parcelRequire("5CSKW");

var $dcLzM = parcelRequire("dcLzM");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");

var $9zZj0 = parcelRequire("9zZj0");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $g9Vr6 = parcelRequire("g9Vr6");

var $cHtIB = parcelRequire("cHtIB");

var $4cTDP = parcelRequire("4cTDP");


var $iTHfM = parcelRequire("iTHfM");

var $dCQmT = parcelRequire("dCQmT");
const $979fa4e593532476$var$InlineCreateTrigger = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, isFormRendered: isFormRendered }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const [isStoplightVisible, setIsSpotlightVisible] = (0, $eJOHy.useState)(false);
    const { shouldShowYbrMessage: shouldShowYbrMessage } = (0, $biF5G.useYbrFeature)();
    const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, (0, $23b4218cfd94fe9f$export$c7e6a6b283196232), false, orgId), [
        cloudId,
        orgId
    ]);
    const startTour = (0, $eJOHy.useCallback)(async ()=>{
        const started = await coordinationClient?.start((0, $23b4218cfd94fe9f$export$e77c67bc8157f49));
        if (started) setIsSpotlightVisible(true);
    }, [
        coordinationClient
    ]);
    const endTour = (0, $eJOHy.useCallback)(()=>{
        setIsSpotlightVisible(false);
        coordinationClient?.stop?.((0, $23b4218cfd94fe9f$export$e77c67bc8157f49));
    }, [
        coordinationClient
    ]);
    (0, $eJOHy.useEffect)(()=>{
        startTour();
    }, [
        startTour
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onClickCallback = (0, $eJOHy.useCallback)(()=>{
        onClick?.();
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'inlineIssueCreateButton');
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    (0, $eJOHy.useEffect)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button viewed', 'inlineIssueCreateButton');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: "inline-create-trigger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default // autofocus enabled when the form is rendered to focus back into the `create` button
    ), {
        ...(0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting') ? {
            autoFocus: isFormRendered
        } : {},
        appearance: "subtle",
        onClick: onClickCallback,
        ref: ref,
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))),
        testId: "issue-table-inline-issue-create.ui.inline-create-trigger.button"
    }, formatMessage((0, $iTHfM.default).createLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dCQmT.default), {
        showOnboarding: shouldShowYbrMessage({
            shouldDisplayMessage: isStoplightVisible
        }),
        onDismiss: endTour
    }));
});
var $979fa4e593532476$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($979fa4e593532476$var$InlineCreateTrigger);

});
parcelRegister("biF5G", function(module, exports) {
$parcel$export(module.exports, "useYbrFeature", () => $3964affdc2e6018d$export$f3013a905e8f3491);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $ea0Pc = parcelRequire("ea0Pc");

var $cHtIB = parcelRequire("cHtIB");

var $e6YEs = parcelRequire("e6YEs");

var $58aKG = parcelRequire("58aKG");

var $4cTDP = parcelRequire("4cTDP");

var $fZP7i = parcelRequire("fZP7i");
const $3964affdc2e6018d$export$f3013a905e8f3491 = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const accountId = (0, $e6YEs.useAccountId)();
    const { fetchTraits: fetchTraits } = (0, $ea0Pc.useTraitsActions)();
    (0, $eJOHy.useEffect)(()=>{
        // For productioniosation, we will target all users and not just new users so no need to fetch site_user trait to detect new users
        if (cloudId && accountId && !(0, $4cTDP.fg)('productionise_ybr_cleanup_non_xflow_messages')) fetchTraits([
            (0, $58aKG.SITE_USER)
        ], {
            cloudId: cloudId,
            accountId: accountId
        });
    }, [
        cloudId,
        accountId,
        fetchTraits
    ]);
    // For productioniosation, we will target all users and not just new users
    const [isTargetedUser] = (0, $4cTDP.fg)('productionise_ybr_cleanup_non_xflow_messages') ? [
        true
    ] : (0, $fZP7i.useIsJiraNewUserTraitSelector)();
    const shouldShowYbrMessage = (0, $eJOHy.useCallback)(({ shouldDisplayMessage: shouldDisplayMessage })=>{
        // Prevent SSR for showing the message first, and then hide it due to the experiment cohort
        if (false) return false;
        // If the user is not a targeted user or the message is not enabled, we should return the original condition of the message
        if (!shouldDisplayMessage || !isTargetedUser) return shouldDisplayMessage;
        // we should not show the message if the experiment is enabled
        return !(0, $cxKOj.expVal)('jira_ybr_first_batch', 'isYBREnabled', false);
    }, [
        isTargetedUser
    ]);
    const shouldShowYbrMessageForIssueView = (0, $eJOHy.useCallback)(({ shouldDisplayMessage: shouldDisplayMessage })=>{
        // Prevent SSR for showing the message first, and then hide it due to the experiment cohort
        if (false) return false;
        // If the user is not a targeted user or the message is not enabled, we should return the original condition of the message
        if (!shouldDisplayMessage || !isTargetedUser) return shouldDisplayMessage;
        // we should not show the message if the experiment is enabled
        return !(0, $cxKOj.expVal)('jira_ybr_first_batch', 'isYBREnabled', false);
    }, [
        isTargetedUser
    ]);
    return {
        shouldShowYbrMessage: shouldShowYbrMessage,
        shouldShowYbrMessageForIssueView: shouldShowYbrMessageForIssueView
    };
};

});
parcelRegister("fZP7i", function(module, exports) {
$parcel$export(module.exports, "useIsJiraNewUserTraitSelector", () => $28517ba1f217338c$export$2dd2d5a960dc1ee6);

var $ibLUB = parcelRequire("ibLUB");

var $ea0Pc = parcelRequire("ea0Pc");

var $cxKOj = parcelRequire("cxKOj");

var $9pTd3 = parcelRequire("9pTd3");
const $28517ba1f217338c$export$2dd2d5a960dc1ee6 = ()=>(0, $ea0Pc.createTraitsSelector)('SITE_USER', ({ getTraitValue: getTraitValue })=>{
        try {
            const firstActiveDate = getTraitValue('jira_first_active');
            if (!firstActiveDate || !(typeof firstActiveDate === 'string') || firstActiveDate.trim() === '') return false;
            return (0, $ibLUB.default)(new Date(firstActiveDate), // This is to get the target new user date from dynamic config jira-ybr-first-batch-new-users
            // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/jira-ybr-first-batch-new-users
            // We confirm that this is a working way to get the value from the dynamic config
            // Other Jira teams are using this approach as well (filtered target app jira_web on dynamic config and confirmed)
            new Date((0, $cxKOj.expVal)('jira-ybr-first-batch-new-users', 'value', '2050-12-31T00:00:00Z')));
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'useIsJiraNewUserTraitSelector',
                    packageName: 'yellowBrickRoadUtils',
                    teamName: 'jira-werewolves'
                }
            });
            return false;
        }
    })();

});


parcelRegister("iTHfM", function(module, exports) {
$parcel$export(module.exports, "default", () => $66695a78f0b2ab0e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $66695a78f0b2ab0e$var$messages = (0, $7qGN1.defineMessages)({
    createLabel: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.create-label",
        "defaultMessage": "Create"
    }
});
var $66695a78f0b2ab0e$export$2e2bcd8739ae039 = $66695a78f0b2ab0e$var$messages;

});

parcelRegister("dCQmT", function(module, exports) {
$parcel$export(module.exports, "default", () => $349f8bf77bb8cae2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $d2s5v = parcelRequire("d2s5v");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $iC2Fk = parcelRequire("iC2Fk");

var $e625v = parcelRequire("e625v");
const $349f8bf77bb8cae2$var$InlineCreateOnboardingSpotlight = ({ showOnboarding: showOnboarding, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, showOnboarding && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2Fk.JiraSpotlight), {
        actions: [
            {
                onClick: onDismiss,
                text: formatMessage((0, $e625v.default).onboardingDismiss)
            }
        ],
        heading: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $e625v.default).onboardingHeaderIssueTerminologyRefreshM4 : (0, $e625v.default).onboardingHeader),
        target: "inline-create-trigger",
        key: "inline-create-trigger",
        messageType: "engagement",
        dialogPlacement: "top right",
        messageId: ((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $e625v.default).onboardingDescriptionIssueTerminologyRefreshM4 : (0, $e625v.default).onboardingDescription).id,
        dialogWidth: 275
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $e625v.default).onboardingDescriptionIssueTerminologyRefreshM4 : (0, $e625v.default).onboardingDescription)));
};
var $349f8bf77bb8cae2$export$2e2bcd8739ae039 = $349f8bf77bb8cae2$var$InlineCreateOnboardingSpotlight;

});
parcelRegister("e625v", function(module, exports) {
$parcel$export(module.exports, "default", () => $5acc70d9685ac55c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5acc70d9685ac55c$var$messages = (0, $7qGN1.defineMessages)({
    onboardingDescription: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-description",
        "defaultMessage": "Quickly create issues on this page by selecting + Create below"
    },
    onboardingHeader: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-header",
        "defaultMessage": "Create issues in context"
    },
    onboardingDismiss: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-dismiss",
        "defaultMessage": "OK"
    },
    onboardingDescriptionIssueTerminologyRefreshM4: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-description-issue-terminology-refresh-m4",
        "defaultMessage": "Quickly create work items on this page by selecting + Create below"
    },
    onboardingHeaderIssueTerminologyRefreshM4: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-header-issue-terminology-refresh-m4",
        "defaultMessage": "Create work items in context"
    }
});
var $5acc70d9685ac55c$export$2e2bcd8739ae039 = $5acc70d9685ac55c$var$messages;

});




parcelRegister("64b9C", function(module, exports) {
$parcel$export(module.exports, "GetStartedListNudgeAsync", () => $18d4b0cafbd25f4b$export$668308feff224acf);
$parcel$export(module.exports, "GetStartedListNudge", () => $18d4b0cafbd25f4b$export$a25758cc5ad6c45a);

var $eJOHy = parcelRequire("eJOHy");

var $79KhM = parcelRequire("79KhM");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");


var $gxP9D = parcelRequire("gxP9D");


var $2Xsxh = parcelRequire("2Xsxh");

var $jqMdt = parcelRequire("jqMdt");
const $18d4b0cafbd25f4b$var$runtimeProps = {};
const $18d4b0cafbd25f4b$export$668308feff224acf = ({ children: children })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $jqMdt.getStartedListNudgeEntrypoint), {});
    const [nudgeStep] = (0, $gxP9D.useNudgeStep)();
    const [hasNudgeActive] = (0, $gxP9D.useHasNudgeActive)();
    const firstLoadRef = (0, $eJOHy.useRef)(true);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (firstLoadRef.current && hasNudgeActive && nudgeStep === (0, $2b839a8453de5367$export$c6df9a2c7447e12d)) entryPointActions.load();
    }, [
        entryPointActions,
        hasNudgeActive,
        nudgeStep
    ]);
    const { ref: getStartedListNudgeRef } = (0, $79KhM.useRegisterNudgeTarget)((0, $2b839a8453de5367$export$c6df9a2c7447e12d), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: getStartedListNudgeRef
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: (0, $44259bc988b99eaa$export$501e36925fa10eef),
        packageName: "jiraListOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
        runtimeProps: $18d4b0cafbd25f4b$var$runtimeProps
    }));
};
const $18d4b0cafbd25f4b$export$a25758cc5ad6c45a = (0, $2Xsxh.withAsyncNudgeTarget)({
    entryPoint: (0, $jqMdt.getStartedListNudgeEntrypoint),
    entryPointParams: {},
    nudgeId: (0, $2b839a8453de5367$export$c6df9a2c7447e12d)
});

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
const $2b839a8453de5367$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $2b839a8453de5367$export$e3884212029f7bef = 'should-show-welcome-modal';
const $2b839a8453de5367$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $2b839a8453de5367$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $2b839a8453de5367$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $2b839a8453de5367$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $2b839a8453de5367$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $2b839a8453de5367$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $2b839a8453de5367$export$6e69f8dc03075ef8 = 'team-type';
const $2b839a8453de5367$export$c06666264cd35603 = 'team-type-shorthand';
const $2b839a8453de5367$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $2b839a8453de5367$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $2b839a8453de5367$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $2b839a8453de5367$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $2b839a8453de5367$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $2b839a8453de5367$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $2b839a8453de5367$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $2b839a8453de5367$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $2b839a8453de5367$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $2b839a8453de5367$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $2b839a8453de5367$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $2b839a8453de5367$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $2b839a8453de5367$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $2b839a8453de5367$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $2b839a8453de5367$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $2b839a8453de5367$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $2b839a8453de5367$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $2b839a8453de5367$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $2b839a8453de5367$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $2b839a8453de5367$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $2b839a8453de5367$export$468488291ccd988 = 'timelineAddItemNudge';
const $2b839a8453de5367$export$7a33548109ac931d = 'createFormNudge';
const $2b839a8453de5367$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $2b839a8453de5367$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $2b839a8453de5367$export$594d3436316492be = 'summaryViewNudge';
const $2b839a8453de5367$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $2b839a8453de5367$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $2b839a8453de5367$export$baf21119361ffad = 'planCreateMoreWorkItemsNudge';
const $2b839a8453de5367$export$7fac0b950c128b4b = 'planConnectRelatedWorkNudge';
const $2b839a8453de5367$export$9fac41c1d8941795 = 'planShareYourPlanWithTheWorldTeamNudge';
const $2b839a8453de5367$export$994f00a8ff485faf = 'planShareYourPlanWithTheWorldAddPeopleNudge';
const $2b839a8453de5367$export$fc1e19da8853ecdc = 'planBringInTheTeamNudge';
const $2b839a8453de5367$export$d0ece87d6f260877 = 'planConfirmScopeNudge';
const $2b839a8453de5367$export$cc93e7cb8dd884fe = 'planCheckYourSettingsNudge';
const $2b839a8453de5367$export$b579a6f09436e23e = 'asyncPlanOnboardingTourNudge';
const $2b839a8453de5367$export$c7f7837470493c6f = 'planAdjustDetailsFieldsMenuNudge';
const $2b839a8453de5367$export$8909317d0f73beab = 'planAdjustDetailsFieldCellsNudge';
const $2b839a8453de5367$export$699265ec8ad9a740 = 'Software Development';
const $2b839a8453de5367$export$e07d1fa2da8ed874 = 'Customer Service';
const $2b839a8453de5367$export$76dcec3f438d9e56 = 'IT Support';
const $2b839a8453de5367$export$9a574c301f67ba30 = 'Human Resources';
const $2b839a8453de5367$export$363ec144a94029c8 = 'Finance';
const $2b839a8453de5367$export$df0fb32d68ae1e78 = 'Legal';
const $2b839a8453de5367$export$d9c0e3e59442fb4 = 'Marketing';
const $2b839a8453de5367$export$27dbc7d7ce66e6e3 = 'Operations';
const $2b839a8453de5367$export$a5dce388adf922bd = 'Sales';
const $2b839a8453de5367$export$e1473b31a257caff = 'Data Science';
const $2b839a8453de5367$export$85657457db93c2c2 = 'Product Management';
const $2b839a8453de5367$export$c0c2d1dfaeba89dd = 'Project Management';
const $2b839a8453de5367$export$2e6a7ad3ab9c82a3 = 'Design';
const $2b839a8453de5367$export$7b60378c3b4372e9 = 'Other or Personal';
const $2b839a8453de5367$export$572242e58bd07594 = 'CS';
const $2b839a8453de5367$export$d7de553940261eba = 'ITS';
const $2b839a8453de5367$export$4c29d0d04c15e55d = 'HR';
const $2b839a8453de5367$export$3950f7f841bf94b6 = 'FNC';
const $2b839a8453de5367$export$881249b988b6030f = 'LGL';
const $2b839a8453de5367$export$e4824f74b9879164 = 'MKT';
const $2b839a8453de5367$export$4f3cb0844009af52 = 'OPS';
const $2b839a8453de5367$export$1a65d50c4a641bb4 = 'SAL';
const $2b839a8453de5367$export$9ee64e8fbd8b03a2 = 'DS';
const $2b839a8453de5367$export$b8b1ac856ba1434b = 'DEV';
const $2b839a8453de5367$export$4f54a09a24fd1d74 = 'PDM';
const $2b839a8453de5367$export$79685802e8ff1098 = 'PJM';
const $2b839a8453de5367$export$e5c438b7501b5a24 = 'DES';
const $2b839a8453de5367$export$cbc0e551d91a692d = 'OTR';

const $44259bc988b99eaa$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $44259bc988b99eaa$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $44259bc988b99eaa$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $44259bc988b99eaa$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $44259bc988b99eaa$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $44259bc988b99eaa$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $44259bc988b99eaa$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $44259bc988b99eaa$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $44259bc988b99eaa$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $44259bc988b99eaa$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $44259bc988b99eaa$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $44259bc988b99eaa$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $44259bc988b99eaa$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $44259bc988b99eaa$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $44259bc988b99eaa$export$f8bf435a6066832c = 'button clicked';
const $44259bc988b99eaa$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $44259bc988b99eaa$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $44259bc988b99eaa$export$2ef41782ca91324c = 'businessSampleDataNudge';
const $44259bc988b99eaa$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $44259bc988b99eaa$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $44259bc988b99eaa$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $44259bc988b99eaa$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $44259bc988b99eaa$export$5908fa8acd2c0739 = 'filterListNudge';
const $44259bc988b99eaa$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $44259bc988b99eaa$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $44259bc988b99eaa$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $44259bc988b99eaa$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $44259bc988b99eaa$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $44259bc988b99eaa$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $44259bc988b99eaa$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $44259bc988b99eaa$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $44259bc988b99eaa$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $44259bc988b99eaa$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $44259bc988b99eaa$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $44259bc988b99eaa$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $44259bc988b99eaa$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $44259bc988b99eaa$export$a1be34032ee24f78 = 'shareProjectNudge';
const $44259bc988b99eaa$export$29fe6611cc093756 = 'summaryTabNudge';
const $44259bc988b99eaa$export$f107c06c0830f09d = 'reportsTabNudge';
const $44259bc988b99eaa$export$9749a972a54ad7ba = 'boardContainerNudge';
const $44259bc988b99eaa$export$fb4f98ca3ff0420 = 'businessSampleDataNudge';
const $44259bc988b99eaa$export$b7fd448c62b5fb97 = 'listview';
const $44259bc988b99eaa$export$10c63dc5c09466d2 = 'boardview';
const $44259bc988b99eaa$export$75b8d65228d517e9 = 'sampleProjectScrumTourNudge';
const $44259bc988b99eaa$export$59a47f76d45b99 = 'sampleProjectScrumSprintNudge';
const $44259bc988b99eaa$export$513a9459cd6c3f96 = 'sampleProjectScrumBacklogNudge';
const $44259bc988b99eaa$export$657cdc4d7e8d9e5f = 'sampleProjectScrumBoardNudge';
const $44259bc988b99eaa$export$e16b25a220be9f3b = 'sampleProjectBoardNudge';
const $44259bc988b99eaa$export$c2f124710ac3a3ab = 'sampleProjectListNudge';
const $44259bc988b99eaa$export$b1c1e2ff4cbedbe = 'sampleProjectScrumSprintNudgeErrorBoundary';
const $44259bc988b99eaa$export$b230ed22c9a186d5 = 'sampleProjectScrumBacklogNudgeErrorBoundary';
const $44259bc988b99eaa$export$a321b777cf077071 = 'sampleProjectScrumBoardNudgeErrorBoundary';
const $44259bc988b99eaa$export$b51b409cb5508624 = 'sampleProjectBoardNudgeErrorBoundary';
const $44259bc988b99eaa$export$9757a1f68dc7a9b = 'sampleProjectListNudgeErrorBoundary';
const $44259bc988b99eaa$export$63a886637b84800 = 'sampleProjectNavTourNudge';
const $44259bc988b99eaa$export$bb40993d16db4a4b = 'SampleProjectNavNudge';
const $44259bc988b99eaa$export$8c300ac9d8c53332 = 'SampleProjectNavNudgeErrorBoundary';

parcelRegister("2Xsxh", function(module, exports) {
$parcel$export(module.exports, "withAsyncNudgeTarget", () => $e38a9da8bab7189c$export$f45e05c2289b21a4);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $gxP9D = parcelRequire("gxP9D");

var $4bItR = parcelRequire("4bItR");

const $e38a9da8bab7189c$export$f45e05c2289b21a4 = ({ entryPoint: entryPoint, entryPointParams: entryPointParams, nudgeId: nudgeId })=>{
    return function AsyncNudgeTargetWithAsyncNudgeTarget({ children: children, runtimeProps: runtimeProps }) {
        // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)(entryPoint, entryPointParams);
        (0, $4bItR.useTrackMountedNudgesController)(nudgeId);
        const [nudgeStep] = (0, $gxP9D.useNudgeStep)();
        const [hasNudgeActive] = (0, $gxP9D.useHasNudgeActive)();
        const entryPointLoaded = (0, $eJOHy.useRef)(false);
        if (!entryPointLoaded.current && hasNudgeActive && nudgeStep === nudgeId) {
            entryPointActions.load();
            entryPointLoaded.current = true;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            id: (0, $44259bc988b99eaa$export$501e36925fa10eef),
            packageName: "jiraListOnboarding",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
            runtimeProps: runtimeProps
        }));
    };
};

});
parcelRegister("4bItR", function(module, exports) {
$parcel$export(module.exports, "useTrackMountedNudgesController", () => $c38db5a434cfd377$export$b759b5124fe0d138);

var $eJOHy = parcelRequire("eJOHy");

var $gxP9D = parcelRequire("gxP9D");
const $c38db5a434cfd377$export$b759b5124fe0d138 = (nudgeId)=>{
    const [, { addMountedNudge: addMountedNudge, removeMountedNudge: removeMountedNudge }] = (0, $gxP9D.useQuickstartActions)();
    (0, $eJOHy.useEffect)(()=>{
        addMountedNudge(nudgeId);
        return ()=>{
            removeMountedNudge(nudgeId);
        };
    }, [
        addMountedNudge,
        nudgeId,
        removeMountedNudge
    ]);
};

});


parcelRegister("jqMdt", function(module, exports) {
$parcel$export(module.exports, "getStartedListNudgeEntrypoint", () => $e01c67701edc3180$export$69d80773367d872c);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $e01c67701edc3180$export$69d80773367d872c = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("4kNZi")), {
        moduleId: "3b9fe78b",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4kNZi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dX6yW").then(()=>parcelRequire('9qxUw'));

});



parcelRegister("aNnbk", function(module, exports) {
$parcel$export(module.exports, "useIssueCreateMutation", () => $0ac2d5a51eab7fff$export$2a4bb6ab1e983642);
$parcel$export(module.exports, "CreateIssueController", () => $0ac2d5a51eab7fff$export$dac3b0377215001c);

var $f3VDv = parcelRequire("f3VDv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $2ApNu = parcelRequire("2ApNu");

var $h1PFK = parcelRequire("h1PFK");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $6bbL3 = parcelRequire("6bbL3");

var $3ElzA = parcelRequire("3ElzA");

var $sJrIm = parcelRequire("sJrIm");

var $8SzGK = parcelRequire("8SzGK");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $d0yFI = parcelRequire("d0yFI");

var $5NEjg = parcelRequire("5NEjg");

var $fidcQ = parcelRequire("fidcQ");

var $dhVsI = parcelRequire("dhVsI");

var $4uses = parcelRequire("4uses");

var $5hgjg = parcelRequire("5hgjg");
const $0ac2d5a51eab7fff$var$ACTION_SUBJECT_ID = 'issueTableIssueCreate';
const $0ac2d5a51eab7fff$var$PACKAGE_LOCATION = 'jira-native-issue-table-inline-issue-create';
const $0ac2d5a51eab7fff$var$issueConnectionMutationUpdater = (store, response, issueConnectionId, insertionArgs, parentItemConnectionId, projectKey, groupId)=>{
    const issue = response?.jira?.createIssue?.issue;
    const issueId = issue?.__id; // it's always defined, but relay types it as nullable, relay sets this field whether it's there or not.
    if (!issue || !issueId) return;
    (0, $d0yFI.issueConnectionUpdater)(store, {
        ...insertionArgs,
        issue: issue,
        issueConnectionId: issueConnectionId,
        parentItemConnectionId: parentItemConnectionId,
        issueRecordId: issueId,
        fieldSetsConnectionId: issue.fieldSetsById?.__id ?? '',
        projectKey: projectKey,
        groupId: groupId
    });
};
const $0ac2d5a51eab7fff$export$2a4bb6ab1e983642 = ({ issueConnectionId: issueConnectionId, parentItemConnectionId: parentItemConnectionId, groupContextFieldInput: groupContextFieldInput, jql: jql, location: location, rankFieldTerms: rankFieldTerms })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const handleErrorIIC = (0, $h1PFK.useIssueCreateOnError)();
    const shouldSkipIssuesConnectionUpdateAndShowFlag = (0, $6bbL3.useShouldSkipIssuesConnectionUpdate)();
    const isLinkRelationshipFieldEnabled = (0, $34oCh.useIsRelationshipFieldEnabled)();
    const isEditableSyncLoaded = (0, $34oCh.useIsEditableSyncLoaded)();
    const isSkipIssueCreateSuccessFlagEnabled = (0, $34oCh.useIsSkipIssueCreateSuccessFlagEnabled)();
    const { onSortChange: onSortChange } = (0, $sJrIm.useSortContext)();
    const { onIssueCreated: onIssueCreated } = (0, $8SzGK.useEventHandlers)();
    const { fieldSetIds: fieldSetIds } = (0, $5NEjg.useIssueFetchQueryVariables)();
    const onIssueFetchAndAppend = (0, $fidcQ.useIssueFetchAndAppend)({
        issueConnectionId: issueConnectionId,
        groupContextFieldInput: groupContextFieldInput,
        jql: jql
    });
    const { generateOptimisticId: generateOptimisticId, getRealId: getRealId } = (0, $5hgjg.useOptimisticId)();
    let queuedCommit;
    if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const generateDeferredVariables = (0, $eJOHy.useCallback)((oldVariables)=>{
            const rank = oldVariables.issueCreateInput.rank;
            if (rank) return {
                ...oldVariables,
                issueCreateInput: {
                    ...oldVariables.issueCreateInput,
                    rank: {
                        ...rank,
                        afterIssueId: rank.afterIssueId ? getRealId(rank.afterIssueId) ?? rank.afterIssueId : rank.afterIssueId,
                        beforeIssueId: rank.beforeIssueId ? getRealId(rank.beforeIssueId) ?? rank.beforeIssueId : rank.beforeIssueId
                    }
                }
            };
            return oldVariables;
        }, [
            getRealId
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        queuedCommit = (0, $3ElzA.useQueuedMutationCommit)({
            generateDeferredVariables: generateDeferredVariables
        });
    }
    const [commit] = (0, $j4oe4.useMutation)((0, $f3VDv.default), queuedCommit);
    const projectKey = (0, $34oCh.useProjectContext)();
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const isInlineEditingEnabled = (0, $34oCh.useIsInlineEditingEnabled)();
    const isIssueHierarchyEnabled = (0, $34oCh.useIsIssueHierarchyEnabled)();
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $8jOO7.INLINE_ISSUE_CREATE_EXPERIENCE),
        analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE)
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $8jOO7.INLINE_ISSUE_CREATE_EXPERIENCE),
        attributes: {
            isGroupIssueCreate: !!groupContextFieldInput
        }
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $8jOO7.INLINE_ISSUE_CREATE_EXPERIENCE)
    });
    const isIssueRankingEnabled = (0, $34oCh.useIsIssueRankingEnabled)();
    const isConditionalFormattingEnabled = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4cTDP.fg)('jira_list_conditional_formatting') && (0, $34oCh.useIsConditionalFormattingEnabled)();
    return (0, $eJOHy.useCallback)((issueToCreate, contextualFields, insertionArgs)=>{
        const issueCreateInput = (0, $dhVsI.toIssueCreateInput)(issueToCreate, contextualFields, groupContextFieldInput, isIssueRankingEnabled);
        if (!issueCreateInput || issueConnectionId == null) return;
        const insertionArgsWithIdGetter = insertionArgs == null ? insertionArgs : {
            ...insertionArgs,
            getRealId: getRealId
        };
        const experienceExtraAttributes = location && (0, $4cTDP.fg)('jira_timeline_analytics_harmonization_v2') ? {
            actionLocation: location
        } : undefined;
        const handleError = async (error)=>{
            const response = await handleErrorIIC({
                issueToCreate: issueToCreate,
                contextualFields: contextualFields,
                groupContextFieldInput: groupContextFieldInput,
                error: error,
                onFail: (e)=>onExperienceFail($0ac2d5a51eab7fff$var$PACKAGE_LOCATION, e, experienceExtraAttributes)
            });
            if (response) {
                onIssueFetchAndAppend(response, insertionArgsWithIdGetter);
                onExperienceSuccess(experienceExtraAttributes);
            }
        };
        const { id: optimisticId, saveRealId: saveRealId } = generateOptimisticId();
        onExperienceStart();
        commit({
            variables: {
                issueCreateInput: issueCreateInput,
                fieldSetIds: fieldSetIds,
                isInlineEditingEnabled: isInlineEditingEnabled,
                isDensityFull: isDensityFull,
                isIssueHierarchyEnabled: isIssueHierarchyEnabled,
                isIdFieldEnabled: !(0, $4cTDP.fg)('nin-optimistic-flashing-fix'),
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                isTimelineEnabled: isTimelineEnabled,
                isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
                isEditableSyncLoaded: isEditableSyncLoaded,
                projectKey: projectKey,
                ...groupContextFieldInput ? {
                    shouldQueryFieldsByIdOrAlias: true,
                    fieldIdsOrAliases: [
                        groupContextFieldInput.fieldId
                    ]
                } : {
                    shouldQueryFieldsByIdOrAlias: false,
                    fieldIdsOrAliases: []
                },
                ...jql ? {
                    shouldQueryMatchesIssueSearch: true,
                    issueSearchInput: {
                        jql: jql
                    }
                } : {
                    shouldQueryMatchesIssueSearch: false,
                    issueSearchInput: {
                        jql: ''
                    }
                }
            },
            optimisticResponse: (0, $4uses.toOptimisticResponse)(issueToCreate, optimisticId, isIssueHierarchyEnabled, groupContextFieldInput),
            optimisticUpdater: (store, response)=>$0ac2d5a51eab7fff$var$issueConnectionMutationUpdater(store, response, issueConnectionId, insertionArgsWithIdGetter, parentItemConnectionId, projectKey),
            updater: (store, response)=>{
                if (response != null && response?.jira?.createIssue?.issue?.id != null) saveRealId(response?.jira?.createIssue?.issue?.id);
                if (shouldSkipIssuesConnectionUpdateAndShowFlag(groupContextFieldInput, response?.jira?.createIssue?.issue, isIssueRankingEnabled, onSortChange, rankFieldTerms, isSkipIssueCreateSuccessFlagEnabled)) return;
                return $0ac2d5a51eab7fff$var$issueConnectionMutationUpdater(store, response, issueConnectionId, insertionArgsWithIdGetter, parentItemConnectionId, projectKey, groupContextFieldInput?.groupId);
            },
            onCompleted: (response)=>{
                const { errors: errors, issue: issue } = response?.jira?.createIssue ?? {};
                if (!issue) {
                    // Handle any GraphQL errors that occurred during issue create
                    errors && handleError(errors);
                    return;
                }
                // Event contributes towards Jira Monthly Core User, see https://hello.atlassian.net/wiki/spaces/ANALYTICS/pages/3767029088/Monthly+Core+User+MCU+Definition#%3Ajira%3A-Jira.
                (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', $0ac2d5a51eab7fff$var$ACTION_SUBJECT_ID, {
                    ...location && (0, $4cTDP.fg)('jsc_list_reranking_gate') && {
                        location: location
                    },
                    fields: {
                        hasAssignee: Boolean(issueToCreate.assignee),
                        hasDueDate: Boolean(issueToCreate.dueDate)
                    },
                    ...(0, $4cTDP.fg)('jira_timeline_analytics_harmonization_v2') && {
                        issueHierarchy: issueToCreate.issueType.hierarchy?.level,
                        parentId: contextualFields.parentIssueAri ? (0, $2ApNu.JiraIssueAri).parse(contextualFields.parentIssueAri).issueId : undefined,
                        issueType: issueToCreate.issueType.name,
                        location: location
                    }
                });
                onExperienceSuccess(experienceExtraAttributes);
                (0, $d0yFI.removeHighlightAfterDelay)(environment, issue);
                if (onIssueCreated && (0, $4cTDP.fg)('timeline_rollups_issue_table_callbacks')) onIssueCreated(issue.issueId);
            },
            onError: (error)=>{
                // Handle any network errors that occurred during issue create
                handleError(error);
            }
        });
    }, [
        groupContextFieldInput,
        isIssueRankingEnabled,
        issueConnectionId,
        getRealId,
        generateOptimisticId,
        onExperienceStart,
        commit,
        fieldSetIds,
        isInlineEditingEnabled,
        isDensityFull,
        isIssueHierarchyEnabled,
        isConditionalFormattingEnabled,
        projectKey,
        jql,
        handleErrorIIC,
        onExperienceFail,
        onIssueFetchAndAppend,
        onExperienceSuccess,
        parentItemConnectionId,
        shouldSkipIssuesConnectionUpdateAndShowFlag,
        onSortChange,
        rankFieldTerms,
        createAnalyticsEvent,
        location,
        environment,
        isTimelineEnabled,
        isLinkRelationshipFieldEnabled,
        isEditableSyncLoaded,
        isSkipIssueCreateSuccessFlagEnabled,
        onIssueCreated
    ]);
};
const $0ac2d5a51eab7fff$export$dac3b0377215001c = ({ childConnectionId: childConnectionId, parentItemConnectionId: parentItemConnectionId, groupContextFieldInput: groupContextFieldInput, setOnCreateIssue: setOnCreateIssue, jql: jql, location: location, rankFieldTerms: rankFieldTerms })=>{
    const onCreateIssue = $0ac2d5a51eab7fff$export$2a4bb6ab1e983642({
        issueConnectionId: childConnectionId,
        parentItemConnectionId: parentItemConnectionId,
        groupContextFieldInput: groupContextFieldInput,
        jql: jql,
        ...(0, $4cTDP.fg)('jsc_list_reranking_gate') && {
            location: location,
            rankFieldTerms: rankFieldTerms
        }
    });
    setOnCreateIssue(onCreateIssue);
    return null;
};

});
parcelRegister("f3VDv", function(module, exports) {
$parcel$export(module.exports, "default", () => $29df6f1fa9fd9c0c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<be6644c9550c89162de7ca9a99eca317>>
 * @relayHash 9e6439d7cd253a11b9a04bd5fb997149
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe825e8edb06e48a45b56500d343fa4763e7725ac939a835a9a13ec84c884cd5

var $3Bt2F = parcelRequire("3Bt2F");

var $3jVIX = parcelRequire("3jVIX");

var $hRj2m = parcelRequire("hRj2m");

var $6AioA = parcelRequire("6AioA");

var $04qit = parcelRequire("04qit");

var $jvWSl = parcelRequire("jvWSl");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $1fipb = parcelRequire("1fipb");

var $FU9UR = parcelRequire("FU9UR");
const $29df6f1fa9fd9c0c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldIdsOrAliases"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDensityFull"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isEditableSyncLoaded"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isIdFieldEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isInlineEditingEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isIssueHierarchyEnabled"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLinkRelationshipFieldEnabled"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueCreateInput"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldsByIdOrAlias"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryMatchesIssueSearch"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "issueCreateInput"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v17 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v18 = {
        "condition": "isIdFieldEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v17 /*: any*/ 
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "id"
    }, v20 = {
        "kind": "ScalarField",
        "name": "key"
    }, v21 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v22 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v23 = {
        "args": [
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ],
        "kind": "ScalarField",
        "name": "canHaveChildIssues"
    }, v24 = [
        {
            "kind": "Variable",
            "name": "idsOrAliases",
            "variableName": "fieldIdsOrAliases"
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v26 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v27 = {
        "kind": "ScalarField",
        "name": "statusId"
    }, v28 = {
        "kind": "ScalarField",
        "name": "name"
    }, v29 = {
        "kind": "ScalarField",
        "name": "priorityId"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v29 /*: any*/ 
                ]
            }
        ],
        "type": "JiraPriorityField"
    }, v31 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v32 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v33 = [
        v32 /*: any*/ 
    ], v34 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v35 = {
        "kind": "ScalarField",
        "name": "sprintId"
    }, v36 = {
        "kind": "ScalarField",
        "name": "number"
    }, v37 = {
        "kind": "InlineFragment",
        "selections": [
            v36 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v38 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v28 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraLabelsField"
    }, v39 = [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": v33 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ], v40 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v41 = [
        v40 /*: any*/ 
    ], v42 = {
        "condition": "shouldQueryMatchesIssueSearch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "kind": "ScalarField",
                "name": "matchesIssueSearch"
            }
        ]
    }, v43 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v44 = [
        v19 /*: any*/ 
    ], v45 = {
        "kind": "ScalarField",
        "name": "type"
    }, v46 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v47 = {
        "kind": "ScalarField",
        "name": "value"
    }, v48 = [
        v47 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v49 = {
        "condition": "isInlineEditingEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lazyIsEditableInIssueView"
                    }
                ]
            }
        ]
    }, v50 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v51 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v52 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v53 = {
        "kind": "ScalarField",
        "name": "date"
    }, v54 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v55 = {
        "kind": "ScalarField",
        "name": "text"
    }, v56 = {
        "condition": "isEditableSyncLoaded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditableInIssueView"
            }
        ]
    }, v57 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v58 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v57 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v59 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v19 /*: any*/ 
        ]
    }, v60 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v61 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v62 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v63 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v58 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v64 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v65 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v66 = [
        {
            "kind": "ScalarField",
            "name": "appType"
        }
    ], v67 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v68 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v69 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v70 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v44 /*: any*/ 
    }, v71 = {
        "kind": "ScalarField",
        "name": "href"
    }, v72 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v73 = {
        "kind": "InlineFragment",
        "selections": [
            v53 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v74 = [
        v25 /*: any*/ ,
        v26 /*: any*/ ,
        v73 /*: any*/ ,
        v19 /*: any*/ 
    ], v75 = [
        v25 /*: any*/ ,
        v73 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": v44 /*: any*/ ,
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ], v76 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "issue",
                    "plural": false,
                    "selections": [
                        v19 /*: any*/ ,
                        v21 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v19 /*: any*/ 
                                    ]
                                },
                                v19 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraParentIssueField",
                            "kind": "LinkedField",
                            "name": "parentIssueField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "parentIssue",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v19 /*: any*/ 
                                    ]
                                },
                                v19 /*: any*/ 
                            ]
                        },
                        v20 /*: any*/ ,
                        {
                            "concreteType": "JiraStatusField",
                            "kind": "LinkedField",
                            "name": "statusField",
                            "plural": false,
                            "selections": [
                                v63 /*: any*/ ,
                                v19 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraSingleSelectUserPickerField",
                            "kind": "LinkedField",
                            "name": "assigneeField",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v25 /*: any*/ ,
                                        v64 /*: any*/ ,
                                        v19 /*: any*/ 
                                    ]
                                },
                                v19 /*: any*/ 
                            ]
                        },
                        {
                            "args": v72 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "startDateViewField",
                            "plural": false,
                            "selections": v74 /*: any*/ ,
                            "storageKey": "startDateViewField(viewId:\"list_default\")"
                        },
                        {
                            "args": v72 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "endDateViewField",
                            "plural": false,
                            "selections": v74 /*: any*/ ,
                            "storageKey": "endDateViewField(viewId:\"list_default\")"
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "aggregatedStartDateViewField",
                                    "plural": false,
                                    "selections": v75 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "aggregatedEndDateViewField",
                                    "plural": false,
                                    "selections": v75 /*: any*/ 
                                }
                            ],
                            "type": "JiraAggregatedTimelineField"
                        }
                    ]
                }
            ],
            "type": "JiraTimelineVirtualField",
            "abstractKey": "__isJiraTimelineVirtualField"
        }
    ], v77 = [
        v40 /*: any*/ ,
        v19 /*: any*/ 
    ], v78 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": v77 /*: any*/ 
            }
        ],
        "type": "JiraSingleVersionPickerField"
    }, v79 = [
        v25 /*: any*/ ,
        v19 /*: any*/ 
    ], v80 = [
        v32 /*: any*/ ,
        v19 /*: any*/ 
    ], v81 = [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": v80 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CreateIssueControllerMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v15 /*: any*/ ,
                            "concreteType": "JiraIssueCreatePayload",
                            "kind": "LinkedField",
                            "name": "createIssue",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "highlightIssueRow"
                                        },
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        {
                                            "condition": "isIssueHierarchyEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v22 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v23 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryFieldsByIdOrAlias",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v24 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "fieldsByIdOrAlias",
                                                    "plural": true,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraStatusField"
                                                        },
                                                        v30 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOption",
                                                                    "plural": false,
                                                                    "selections": v33 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v34 /*: any*/ ,
                                                                    "concreteType": "JiraSprintConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedSprintsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprintEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprint",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedSprintsConnection(first:1)"
                                                                }
                                                            ],
                                                            "type": "JiraSprintField"
                                                        },
                                                        v37 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOption",
                                                                    "plural": false,
                                                                    "selections": v33 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraRadioSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v39 /*: any*/ ,
                                                            "type": "JiraMultipleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v39 /*: any*/ ,
                                                            "type": "JiraCheckboxesField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedVersionsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraVersion",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v41 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraMultipleVersionPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersion",
                                                                    "kind": "LinkedField",
                                                                    "name": "version",
                                                                    "plural": false,
                                                                    "selections": v41 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraSingleVersionPickerField"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v42 /*: any*/ ,
                                        {
                                            "args": v43 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSetsById",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isConditionalFormattingEnabled",
                                                            "variableName": "isConditionalFormattingEnabled"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isDensityFull",
                                                            "variableName": "isDensityFull"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isEditableSyncLoaded",
                                                            "variableName": "isEditableSyncLoaded"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isInlineEditingEnabled",
                                                            "variableName": "isInlineEditingEnabled"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isLinkRelationshipFieldEnabled",
                                                            "variableName": "isLinkRelationshipFieldEnabled"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isTimelineEnabled",
                                                            "variableName": "isTimelineEnabled"
                                                        }
                                                    ],
                                                    "kind": "FragmentSpread",
                                                    "name": "IssueRow_fieldSets"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v10 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v13 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v12 /*: any*/ ,
                v11 /*: any*/ ,
                v14 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v9 /*: any*/ ,
                v8 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "CreateIssueControllerMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v15 /*: any*/ ,
                            "concreteType": "JiraIssueCreatePayload",
                            "kind": "LinkedField",
                            "name": "createIssue",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v25 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v44 /*: any*/ ,
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        v25 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        {
                                            "args": v43 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSetsById",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fieldSetId"
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v46 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v19 /*: any*/ ,
                                                                                        v25 /*: any*/ ,
                                                                                        v26 /*: any*/ ,
                                                                                        v45 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "serviceId"
                                                                                                                        },
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraAffectedServicesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "cascadingOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v48 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "childOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v48 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCascadingSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "objectId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "label"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "clientId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "fileId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "url48"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "QueryError",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "errors",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "message"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCMDBField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v50 /*: any*/ ,
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedComponentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v51 /*: any*/ ,
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v53 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v54 /*: any*/ ,
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDatePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "dateTime"
                                                                                                },
                                                                                                v28 /*: any*/ ,
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraEpic",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "epic",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "summary"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color"
                                                                                                        },
                                                                                                        v19 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraEpicLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "renderedFieldHtml"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFallbackField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v55 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v56 /*: any*/ ,
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v57 /*: any*/ ,
                                                                                                        v19 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v58 /*: any*/ ,
                                                                                                        v19 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v50 /*: any*/ ,
                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedLabelsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v59 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                },
                                                                                                v28 /*: any*/ ,
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraLabelsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "small"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v28 /*: any*/ ,
                                                                                                        v19 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraColorField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueColorField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v59 /*: any*/ ,
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueTypeField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v60 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraSingleLineTextField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "summaryField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v55 /*: any*/ ,
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v19 /*: any*/ ,
                                                                                                        v21 /*: any*/ ,
                                                                                                        v61 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "issuetype",
                                                                                                                                "project",
                                                                                                                                "summary",
                                                                                                                                "status"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v25 /*: any*/ ,
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v26 /*: any*/ ,
                                                                                                                                                v55 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v26 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                        v62 /*: any*/ ,
                                                                                                                                                        v28 /*: any*/ ,
                                                                                                                                                        v60 /*: any*/ ,
                                                                                                                                                        v22 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v26 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "status",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "statusCategory",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v19 /*: any*/ ,
                                                                                                                                                                v57 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraStatusField"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v62 /*: any*/ ,
                                                                                                                                v22 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "summaryField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v63 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v28 /*: any*/ ,
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraParentIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v19 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v28 /*: any*/ ,
                                                                                                v56 /*: any*/ ,
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v20 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "large"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v19 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraResolution",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "resolution",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v19 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraResolutionField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedSprintsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "state"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "endDate"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v28 /*: any*/ ,
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSprintField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v28 /*: any*/ ,
                                                                                                        v64 /*: any*/ ,
                                                                                                        v65 /*: any*/ ,
                                                                                                        v19 /*: any*/ ,
                                                                                                        v31 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "TypeDiscriminator",
                                                                                                                    "abstractKey": "__isUser"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": v66 /*: any*/ ,
                                                                                                                    "type": "AppUser"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": v66 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "AppUser"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v54 /*: any*/ ,
                                                                                                v56 /*: any*/ ,
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraRichText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "richText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraADF",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "adfValue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "isDensityFull",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "isDensityFull",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "json"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRichTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "requestType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v60 /*: any*/ ,
                                                                                                        v19 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v34 /*: any*/ ,
                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLinkConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v61 /*: any*/ ,
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "statusCategory"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v25 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v58 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                        },
                                                                                                                                                        v19 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "isResolved"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v19 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v67 /*: any*/ ,
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isStoryPointField"
                                                                                                },
                                                                                                v36 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v49 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "formatConfig",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatStyle"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatUnit"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraNumberField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "commentSummary",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canAddComment"
                                                                                                        },
                                                                                                        v46 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCommentSummaryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "uri"
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraUrlField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v47 /*: any*/ ,
                                                                                                        v59 /*: any*/ ,
                                                                                                        v19 /*: any*/ ,
                                                                                                        v32 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v32 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v47 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCheckboxesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedUsersConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v31 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v64 /*: any*/ ,
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v65 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "email"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraTeamView",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedTeam",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedId"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedName"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraTeamViewField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v49 /*: any*/ ,
                                                                                                                        v68 /*: any*/ ,
                                                                                                                        v69 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v45 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v68 /*: any*/ ,
                                                                                                                        v69 /*: any*/ ,
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v45 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v49 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "label",
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "value"
                                                                                                        },
                                                                                                        v19 /*: any*/ ,
                                                                                                        v51 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraRadioSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v50 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v51 /*: any*/ ,
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v40 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                v70 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v50 /*: any*/ ,
                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGoals",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v20 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "status"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v17 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                },
                                                                                                v49 /*: any*/ ,
                                                                                                v17 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraGoalsField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v70 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isLinkEditable"
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraTownsquareProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "alias": "atlasProjectName",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "name"
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": "atlasProjectKey",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "key"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "privateProject"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "hasPermission"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWorkspaceActive"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconName"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v49 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTownsquareProjectField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v50 /*: any*/ ,
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v71 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "pageContent",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v25 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v71 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraConfluencePageContentDetails"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v46 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGroupsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "groupId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraFlag",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "flag",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isFlagged"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFlagField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraWatch",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "watch",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "count"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isWatching"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraWatchesField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "isLinkRelationshipFieldEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLink",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "direction"
                                                                                                                },
                                                                                                                v67 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "type",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v44 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v56 /*: any*/ ,
                                                                                                        v49 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkRelationshipTypeField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "isTimelineEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": v76 /*: any*/ ,
                                                                                                    "type": "JiraTimelineField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": v76 /*: any*/ ,
                                                                                                    "type": "JiraAggregatedTimelineField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v17 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v18 /*: any*/ ,
                                                {
                                                    "condition": "isConditionalFormattingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v50 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "componentId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                v30 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "projectId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                v78 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v62 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v79 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSelectableValueConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValues",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v79 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v18 /*: any*/ ,
                                        {
                                            "condition": "isIssueHierarchyEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v22 /*: any*/ ,
                                                                v19 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v23 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryFieldsByIdOrAlias",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v24 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "fieldsByIdOrAlias",
                                                    "plural": true,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraStatusField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v29 /*: any*/ ,
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraPriorityField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v25 /*: any*/ ,
                                                                        v31 /*: any*/ ,
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOption",
                                                                    "plural": false,
                                                                    "selections": v80 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v34 /*: any*/ ,
                                                                    "concreteType": "JiraSprintConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedSprintsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprintEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprint",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedSprintsConnection(first:1)"
                                                                }
                                                            ],
                                                            "type": "JiraSprintField"
                                                        },
                                                        v37 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOption",
                                                                    "plural": false,
                                                                    "selections": v80 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraRadioSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v81 /*: any*/ ,
                                                            "type": "JiraMultipleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v81 /*: any*/ ,
                                                            "type": "JiraCheckboxesField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedVersionsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraVersion",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v77 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraMultipleVersionPickerField"
                                                        },
                                                        v78 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v42 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fe825e8edb06e48a45b56500d343fa4763e7725ac939a835a9a13ec84c884cd5",
            "metadata": {},
            "name": "CreateIssueControllerMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": (0, $04qit.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $6AioA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": (0, $1fipb.default)
            }
        }
    };
}();
$29df6f1fa9fd9c0c$var$node.hash = "2a101e882bc4ee8ec9c444bca45c2a46";
var $29df6f1fa9fd9c0c$export$2e2bcd8739ae039 = $29df6f1fa9fd9c0c$var$node;

});

parcelRegister("h1PFK", function(module, exports) {
$parcel$export(module.exports, "useIssueCreateOnError", () => $0e9105b7566f222f$export$5a42366aaf5bc501);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");

var $14RSn = parcelRequire("14RSn");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");


var $5ppNC = parcelRequire("5ppNC");

var $dwCPn = parcelRequire("dwCPn");
const $0e9105b7566f222f$var$isMutationValidationError = (errors)=>errors.some((error)=>error.extensions?.statusCode === 400);
const $0e9105b7566f222f$var$toError = (errors)=>{
    const statusCodes = new Set();
    errors.forEach((err)=>{
        const sc = err.extensions?.statusCode;
        if (sc) statusCodes.add(String(sc));
    });
    return new Error(`Fail to fallback to GIC extension status codes: ${statusCodes.size > 0 ? Array.from(statusCodes.values()).join(',') : 'No status'}`);
};
const $0e9105b7566f222f$export$5a42366aaf5bc501 = ()=>{
    const onFallbackToGIC = (0, $5ppNC.useFallbackToGIC)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    return (0, $eJOHy.useCallback)(({ issueToCreate: issueToCreate, contextualFields: contextualFields, groupContextFieldInput: groupContextFieldInput, error: error, onFail: onFail })=>{
        let shouldFallbackToGIC;
        if (error instanceof Error) shouldFallbackToGIC = error instanceof (0, $14RSn.ValidationError);
        else shouldFallbackToGIC = $0e9105b7566f222f$var$isMutationValidationError(error);
        if (shouldFallbackToGIC) {
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'globalIssueCreate fallback', 'inlineIssueCreate');
            return onFallbackToGIC({
                issueToCreate: issueToCreate,
                contextualFields: contextualFields,
                groupContextFieldInput: groupContextFieldInput
            });
        }
        // Fire error analytics event and display flag if we were unable to fallback to GIC
        (0, $9pTd3.fireErrorAnalytics)({
            event: createAnalyticsEvent({}),
            meta: {
                id: 'inlineIssueCreate',
                packageName: (0, $23b4218cfd94fe9f$export$b8b9d90f9e5bd72b),
                teamName: (0, $23b4218cfd94fe9f$export$d57b6b390e78d90f)
            },
            error: error instanceof Error ? error : undefined,
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag({
            type: 'error',
            title: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $dwCPn.default).errorFlagTitleIssueTerminologyRefreshM4 : (0, $dwCPn.default).errorFlagTitleNonFinal),
            description: formatMessage((0, $dwCPn.default).errorFlagDescriptionNonFinal),
            messageId: 'issue-table-inline-issue-create.controllers.use-issue-create-on-error.show-flag.error',
            messageType: 'transactional'
        });
        onFail?.(error instanceof Error ? error : $0e9105b7566f222f$var$toError(error));
        return Promise.resolve(null);
    }, [
        createAnalyticsEvent,
        formatMessage,
        onFallbackToGIC,
        showFlag
    ]);
};

});
parcelRegister("5ppNC", function(module, exports) {
$parcel$export(module.exports, "useFallbackToGIC", () => $8dac54862ef56e31$export$1682627434940303);

var $eJOHy = parcelRequire("eJOHy");

var $57raR = parcelRequire("57raR");
var $3T7mg = parcelRequire("3T7mg");

var $2ApNu = parcelRequire("2ApNu");

var $4cTDP = parcelRequire("4cTDP");

var $xMjNG = parcelRequire("xMjNG");

var $4PKlm = parcelRequire("4PKlm");

var $84DOT = parcelRequire("84DOT");

var $jipjz = parcelRequire("jipjz");

var $8ntPR = parcelRequire("8ntPR");

var $3mZMJ = parcelRequire("3mZMJ");
const $8dac54862ef56e31$var$issueIdFromAri = (ari)=>(0, $2ApNu.JiraIssueAri).parse(ari).issueId;
const $8dac54862ef56e31$var$toGICAdditionalFields = ({ rankFieldId: rankFieldId, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId }, groupContextFieldInput)=>{
    const additionalFields = {};
    if (rankFieldId && (rankBeforeIssueId || rankAfterIssueId)) {
        if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) additionalFields[rankFieldId] = {
            ...rankBeforeIssueId ? {
                rankBeforeIssue: $8dac54862ef56e31$var$issueIdFromAri(rankBeforeIssueId)
            } : {},
            ...rankAfterIssueId ? {
                rankAfterIssue: $8dac54862ef56e31$var$issueIdFromAri(rankAfterIssueId)
            } : {}
        };
        else additionalFields[rankFieldId] = {
            ...rankBeforeIssueId ? {
                rankBeforeIssue: rankBeforeIssueId
            } : {},
            ...rankAfterIssueId ? {
                rankAfterIssue: rankAfterIssueId
            } : {}
        };
    }
    if (groupContextFieldInput) return {
        ...additionalFields,
        ...(0, $8ntPR.convertFieldToGICAdditionalFieldsPayload)(groupContextFieldInput)
    };
    return additionalFields;
};
const $8dac54862ef56e31$export$1682627434940303 = ()=>{
    const openIssueCreateModal = (0, $jipjz.useOpenIssueCreateModal)();
    const { subscribe: subscribe } = (0, $4PKlm.useGICLifeCycleEvents)();
    return (0, $eJOHy.useCallback)(({ issueToCreate: issueToCreate, contextualFields: contextualFields, groupContextFieldInput: groupContextFieldInput })=>{
        const { project: { projectId: projectId }, issueType: { issueTypeId: issueTypeId }, summary: summary, assignee: assignee, dueDate: dueDate } = issueToCreate;
        const payload = {
            project: {
                projectId: projectId
            },
            issueType: {
                issueTypeId: issueTypeId
            },
            ...contextualFields.parentIssueAri ? {
                parentId: {
                    parentId: $8dac54862ef56e31$var$issueIdFromAri(contextualFields.parentIssueAri)
                }
            } : {},
            ...groupContextFieldInput?.fieldType === (0, $3mZMJ.STATUS_TYPE) ? (0, $8ntPR.convertFieldToStatusGICInput)(groupContextFieldInput) : {},
            defaultValues: {
                singleLineTextFields: [
                    {
                        fieldId: 'summary',
                        text: summary
                    }
                ],
                ...assignee && {
                    singleSelectUserPickerFields: [
                        {
                            fieldId: 'assignee',
                            user: {
                                accountId: assignee.accountId
                            }
                        }
                    ]
                },
                ...dueDate && {
                    datePickerFields: [
                        {
                            fieldId: 'duedate',
                            date: {
                                formattedDate: (0, $57raR.default)((0, $3T7mg.default)(dueDate), 'yyyy-MM-dd')
                            }
                        }
                    ]
                },
                ...contextualFields.parentIssueAri ? {
                    parentField: {
                        issueId: $8dac54862ef56e31$var$issueIdFromAri(contextualFields.parentIssueAri)
                    }
                } : {},
                ...groupContextFieldInput ? (0, $8ntPR.convertFieldToIssueCreateInput)(groupContextFieldInput) : {}
            }
        };
        return new Promise((resolve)=>{
            const unsubscribe = subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).MODAL_KEEP_EDITING_EXISTING_ISSUE, ()=>{
                // the user cancelled editing
                onClose(null);
            });
            // resolve the promise once the GIC has been closed or cancelled
            const onClose = (data)=>{
                const result = data?.[0]?.issueKey ?? null;
                resolve(result);
                unsubscribe();
            };
            const isSubTaskCreationOpen = !!(issueToCreate.issueType?.hierarchy?.level === -1);
            openIssueCreateModal({
                payload: payload,
                context: {
                    projectId: projectId,
                    submitApiData: {
                        additionalFields: $8dac54862ef56e31$var$toGICAdditionalFields(contextualFields, groupContextFieldInput)
                    }
                },
                onClose: onClose,
                isSubTaskCreationOpen: isSubTaskCreationOpen,
                triggerPointKey: (0, $84DOT.JIRA_ISSUE_TABLE_TRIGGER),
                disableProjectDropdown: true,
                disableIssueTypeDropdown: false,
                disableCreationSuccessFlag: true,
                minimizableModalView: 'mini'
            });
        });
    }, [
        openIssueCreateModal,
        subscribe
    ]);
};

});
parcelRegister("xMjNG", function(module, exports) {
$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $6988db3fd722d63c$export$876003a5b887f37e);
const $6988db3fd722d63c$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("4PKlm", function(module, exports) {
$parcel$export(module.exports, "useGICLifeCycleEvents", () => $8e36a2abc6a32ec2$export$e3ff72f196296fcc);

var $8Urkc = parcelRequire("8Urkc");
const $8e36a2abc6a32ec2$var$GICLifeCycleEventsService = new (0, $8Urkc.PubSubHub)();
const $8e36a2abc6a32ec2$export$e3ff72f196296fcc = ()=>({
        ...$8e36a2abc6a32ec2$var$GICLifeCycleEventsService
    });

});
parcelRegister("8Urkc", function(module, exports) {
$parcel$export(module.exports, "PubSubHub", () => $ef124bfbd3a417bb$export$e3607828f8f2c01e);
class $ef124bfbd3a417bb$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


parcelRegister("8ntPR", function(module, exports) {
$parcel$export(module.exports, "isOptionFieldType", () => $1e3493a9d203145a$export$cdebdb13954c63c8);
$parcel$export(module.exports, "isVersionFieldType", () => $1e3493a9d203145a$export$3868397c63c76330);
$parcel$export(module.exports, "isUserFieldType", () => $1e3493a9d203145a$export$fe80a5e9db59a835);
$parcel$export(module.exports, "isGroupPickerFieldType", () => $1e3493a9d203145a$export$4f3a0ae044bc7de2);
$parcel$export(module.exports, "isLabelFieldType", () => $1e3493a9d203145a$export$fd0a45989264d2bb);
$parcel$export(module.exports, "isCreateIssueSupportedForFieldType", () => $1e3493a9d203145a$export$6a7d6e7c75a0955e);
$parcel$export(module.exports, "convertFieldToStatusGICInput", () => $1e3493a9d203145a$export$ff734d0b6c783fa9);
$parcel$export(module.exports, "convertFieldToGICAdditionalFieldsPayload", () => $1e3493a9d203145a$export$2bcbed170a89c245);
$parcel$export(module.exports, "convertFieldToIssueCreateInput", () => $1e3493a9d203145a$export$1492200cb52faf7c);
$parcel$export(module.exports, "toOptimisticField", () => $1e3493a9d203145a$export$4905b0508c306b7b);

var $3mZMJ = parcelRequire("3mZMJ");

var $4cTDP = parcelRequire("4cTDP");

var $gwBQn = parcelRequire("gwBQn");
const $1e3493a9d203145a$var$OPTION_FIELD_TYPES = new Set([
    (0, $3mZMJ.CATEGORY_TYPE),
    (0, $3mZMJ.SELECT_CF_TYPE),
    (0, $3mZMJ.MULTI_SELECT_CF_TYPE),
    (0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE),
    (0, $3mZMJ.RADIO_BUTTONS_CF_TYPE)
]);
const $1e3493a9d203145a$var$VERSION_FIELD_TYPES = new Set([
    (0, $3mZMJ.VERSION_CF_TYPE),
    (0, $3mZMJ.MULTI_VERSION_CF_TYPE),
    (0, $3mZMJ.AFFECTS_VERSIONS_TYPE),
    (0, $3mZMJ.FIX_VERSIONS_TYPE)
]);
const $1e3493a9d203145a$var$LABEL_FIELD_TYPES = new Set([
    (0, $3mZMJ.LABELS_TYPE),
    (0, $3mZMJ.LABELS_CF_TYPE)
]);
const $1e3493a9d203145a$var$USER_FIELD_TYPES = new Set([
    (0, $3mZMJ.ASSIGNEE_TYPE),
    (0, $3mZMJ.REPORTER_TYPE),
    (0, $3mZMJ.USER_CF_TYPE)
]);
const $1e3493a9d203145a$var$GROUP_PICKER_FIELD_TYPES = new Set([
    (0, $3mZMJ.GROUP_CF_TYPE),
    (0, $3mZMJ.MULTI_GROUP_CF_TYPE)
]);
const $1e3493a9d203145a$export$f9c7798bde1b3073 = new Set([
    (0, $3mZMJ.PRIORITY_TYPE),
    (0, $3mZMJ.STATUS_TYPE),
    (0, $3mZMJ.LABELS_TYPE),
    (0, $3mZMJ.LABELS_CF_TYPE),
    (0, $3mZMJ.SPRINT_TYPE),
    (0, $3mZMJ.ISSUE_TYPE),
    ...$1e3493a9d203145a$var$OPTION_FIELD_TYPES,
    ...$1e3493a9d203145a$var$VERSION_FIELD_TYPES,
    ...$1e3493a9d203145a$var$USER_FIELD_TYPES,
    ...$1e3493a9d203145a$var$GROUP_PICKER_FIELD_TYPES
]);
const $1e3493a9d203145a$export$2ebdffdb7d794ccf = new Set([
    (0, $3mZMJ.NUMBER_CF_TYPE),
    (0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE)
]);
const $1e3493a9d203145a$export$8dd5b143c91a8104 = new Set([
    ...$1e3493a9d203145a$export$f9c7798bde1b3073,
    ...$1e3493a9d203145a$export$2ebdffdb7d794ccf
]);
const $1e3493a9d203145a$export$cdebdb13954c63c8 = (fieldType)=>$1e3493a9d203145a$var$OPTION_FIELD_TYPES.has(fieldType);
const $1e3493a9d203145a$export$3868397c63c76330 = (fieldType)=>$1e3493a9d203145a$var$VERSION_FIELD_TYPES.has(fieldType);
const $1e3493a9d203145a$export$fe80a5e9db59a835 = (fieldType)=>$1e3493a9d203145a$var$USER_FIELD_TYPES.has(fieldType);
const $1e3493a9d203145a$export$4f3a0ae044bc7de2 = (fieldType)=>$1e3493a9d203145a$var$GROUP_PICKER_FIELD_TYPES.has(fieldType);
const $1e3493a9d203145a$export$fd0a45989264d2bb = (fieldType)=>$1e3493a9d203145a$var$LABEL_FIELD_TYPES.has(fieldType);
const $1e3493a9d203145a$export$6a7d6e7c75a0955e = (fieldType)=>Boolean(fieldType && $1e3493a9d203145a$export$8dd5b143c91a8104.has(fieldType));
const $1e3493a9d203145a$export$ff734d0b6c783fa9 = ({ fieldValue: fieldValue })=>{
    if (fieldValue === null) return null;
    return {
        status: {
            statusId: fieldValue
        }
    };
};
const $1e3493a9d203145a$export$2bcbed170a89c245 = (groupContextFieldInput)=>{
    const { fieldType: fieldType, fieldValue: fieldValue, fieldId: fieldId } = groupContextFieldInput;
    if (fieldValue === null) return null;
    // Note: excluding status type and issue type as they're always shown in GIC
    switch(fieldType){
        case 0, $3mZMJ.PRIORITY_TYPE:
        case 0, $3mZMJ.ASSIGNEE_TYPE:
        case 0, $3mZMJ.REPORTER_TYPE:
        case 0, $3mZMJ.USER_CF_TYPE:
            return {
                [fieldId]: {
                    id: fieldValue
                }
            };
        case 0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $3mZMJ.NUMBER_CF_TYPE:
            if (typeof fieldValue === 'number') return {
                [fieldId]: fieldValue
            };
            return {
                [fieldId]: {
                    id: fieldId,
                    value: fieldValue
                }
            };
        case 0, $3mZMJ.SPRINT_TYPE:
            return {
                [fieldId]: {
                    id: fieldId,
                    value: fieldValue
                }
            };
        case 0, $3mZMJ.LABELS_CF_TYPE:
        case 0, $3mZMJ.LABELS_TYPE:
            return {
                [fieldId]: [
                    fieldValue
                ]
            };
        case 0, $3mZMJ.VERSION_CF_TYPE:
        case 0, $3mZMJ.AFFECTS_VERSIONS_TYPE:
        case 0, $3mZMJ.FIX_VERSIONS_TYPE:
        case 0, $3mZMJ.SELECT_CF_TYPE:
        case 0, $3mZMJ.RADIO_BUTTONS_CF_TYPE:
        case 0, $3mZMJ.CATEGORY_TYPE:
            return {
                [fieldId]: {
                    id: fieldValue,
                    value: fieldValue
                }
            };
        case 0, $3mZMJ.MULTI_SELECT_CF_TYPE:
        case 0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE:
        case 0, $3mZMJ.MULTI_VERSION_CF_TYPE:
            return {
                [fieldId]: [
                    {
                        id: fieldValue
                    }
                ]
            };
        default:
            // note: this code path should never be reached as the typing on GroupContextField will only support supported field types
            return null;
    }
};
const $1e3493a9d203145a$export$1492200cb52faf7c = ({ fieldType: fieldType, fieldValue: fieldValue, fieldId: fieldId })=>{
    if (fieldValue === null) return null;
    // Note: excluding issue type as it's supported directly via inline issue create
    switch(fieldType){
        case 0, $3mZMJ.PRIORITY_TYPE:
            return {
                priority: {
                    priorityId: fieldValue
                }
            };
        case 0, $3mZMJ.ASSIGNEE_TYPE:
        case 0, $3mZMJ.USER_CF_TYPE:
        case 0, $3mZMJ.REPORTER_TYPE:
            return {
                singleSelectUserPickerFields: [
                    {
                        fieldId: fieldId,
                        user: {
                            accountId: fieldValue
                        }
                    }
                ]
            };
        case 0, $3mZMJ.STATUS_TYPE:
            return {
                status: {
                    statusId: fieldValue
                }
            };
        case 0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $3mZMJ.NUMBER_CF_TYPE:
            return {
                numberFields: [
                    {
                        fieldId: fieldId,
                        value: fieldValue
                    }
                ]
            };
        case 0, $3mZMJ.CATEGORY_TYPE:
        case 0, $3mZMJ.SELECT_CF_TYPE:
        case 0, $3mZMJ.RADIO_BUTTONS_CF_TYPE:
            return {
                singleSelectFields: [
                    {
                        fieldId: fieldId,
                        option: {
                            id: fieldValue,
                            optionId: fieldValue
                        }
                    }
                ]
            };
        case 0, $3mZMJ.MULTI_SELECT_CF_TYPE:
        case 0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE:
            return {
                multipleSelectFields: [
                    {
                        fieldId: fieldId,
                        options: [
                            {
                                id: fieldValue,
                                optionId: fieldValue
                            }
                        ]
                    }
                ]
            };
        case 0, $3mZMJ.VERSION_CF_TYPE:
            if ((0, $4cTDP.fg)('group_by_any_field_single_version_picker_fix')) return {
                singleVersionPickerFields: [
                    {
                        fieldId: fieldId,
                        version: {
                            versionId: fieldValue
                        }
                    }
                ]
            };
            return {
                multipleVersionPickerFields: [
                    {
                        fieldId: fieldId,
                        versions: [
                            {
                                versionId: fieldValue
                            }
                        ]
                    }
                ]
            };
        case 0, $3mZMJ.AFFECTS_VERSIONS_TYPE:
        case 0, $3mZMJ.FIX_VERSIONS_TYPE:
        case 0, $3mZMJ.MULTI_VERSION_CF_TYPE:
            return {
                multipleVersionPickerFields: [
                    {
                        fieldId: fieldId,
                        versions: [
                            {
                                versionId: fieldValue
                            }
                        ]
                    }
                ]
            };
        case 0, $3mZMJ.SPRINT_TYPE:
            return {
                sprintsField: {
                    fieldId: fieldId,
                    sprints: [
                        {
                            sprintId: fieldValue
                        }
                    ]
                }
            };
        case 0, $3mZMJ.LABELS_CF_TYPE:
        case 0, $3mZMJ.LABELS_TYPE:
            return {
                labelsFields: [
                    {
                        fieldId: fieldId,
                        labels: [
                            {
                                name: fieldValue
                            }
                        ]
                    }
                ]
            };
        case 0, $3mZMJ.GROUP_CF_TYPE:
            return {
                singleGroupPickerFields: [
                    {
                        fieldId: fieldId,
                        group: {
                            groupName: fieldValue
                        }
                    }
                ]
            };
        case 0, $3mZMJ.MULTI_GROUP_CF_TYPE:
            return {
                multipleGroupPickerFields: [
                    {
                        fieldId: fieldId,
                        groups: [
                            {
                                groupName: fieldValue
                            }
                        ]
                    }
                ]
            };
        default:
            // note: this code path should never be reached as the typing on GroupContextField will only support supported field types
            return null;
    }
};
const $1e3493a9d203145a$export$4905b0508c306b7b = (issueId, { fieldId: fieldId, fieldType: fieldType, optimisticResponse: optimisticResponse })=>{
    // Note: excluding issue type as it's supported separately
    switch(optimisticResponse?.type){
        case 0, $3mZMJ.PRIORITY_TYPE:
            return (0, $gwBQn.toOptimisticPriority)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.ASSIGNEE_TYPE:
        case 0, $3mZMJ.USER_CF_TYPE:
        case 0, $3mZMJ.REPORTER_TYPE:
            return (0, $gwBQn.toOptimisticUser)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.STATUS_TYPE:
            return (0, $gwBQn.toOptimisticStatus)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.CATEGORY_TYPE:
        case 0, $3mZMJ.SELECT_CF_TYPE:
            return (0, $gwBQn.toOptimisticSingleSelect)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.RADIO_BUTTONS_CF_TYPE:
            return (0, $gwBQn.toOptimisticRadioSelect)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.MULTI_SELECT_CF_TYPE:
            return (0, $gwBQn.toOptimisticMultiSelect)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE:
            return (0, $gwBQn.toOptimisticCheckbox)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.SPRINT_TYPE:
            return (0, $gwBQn.toOptimisticSprint)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.NUMBER_CF_TYPE:
            return (0, $gwBQn.toOptimisticNumber)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.LABELS_TYPE:
        case 0, $3mZMJ.LABELS_CF_TYPE:
            return (0, $gwBQn.toOptimisticLabels)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.MULTI_GROUP_CF_TYPE:
            return (0, $gwBQn.toOptimisticMultiGroup)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        // Note: Excluding VERSION_CF_TYPE as it's a fallback field.
        case 0, $3mZMJ.MULTI_VERSION_CF_TYPE:
        case 0, $3mZMJ.AFFECTS_VERSIONS_TYPE:
        case 0, $3mZMJ.FIX_VERSIONS_TYPE:
            return (0, $gwBQn.toOptimisticMultiVersion)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        default:
            return null;
    }
};

});
parcelRegister("gwBQn", function(module, exports) {
$parcel$export(module.exports, "toOptimisticPriority", () => $bed603991fa02297$export$b0e8bb5f2ea51c4f);
$parcel$export(module.exports, "toOptimisticUser", () => $bed603991fa02297$export$afc99b621d72ef26);
$parcel$export(module.exports, "toOptimisticStatus", () => $bed603991fa02297$export$3e4b4b49e4ee4e20);
$parcel$export(module.exports, "toOptimisticSingleSelect", () => $bed603991fa02297$export$71ead0fa097cead6);
$parcel$export(module.exports, "toOptimisticRadioSelect", () => $bed603991fa02297$export$f32e937f8185cba6);
$parcel$export(module.exports, "toOptimisticMultiSelect", () => $bed603991fa02297$export$a0aeb0a088349a7f);
$parcel$export(module.exports, "toOptimisticCheckbox", () => $bed603991fa02297$export$bdb06cc2dd7fdd79);
$parcel$export(module.exports, "toOptimisticSprint", () => $bed603991fa02297$export$d9be65aae3a85c75);
$parcel$export(module.exports, "toOptimisticNumber", () => $bed603991fa02297$export$4b7137aed66177e0);
$parcel$export(module.exports, "toOptimisticLabels", () => $bed603991fa02297$export$deffb20716f51298);
$parcel$export(module.exports, "toOptimisticMultiGroup", () => $bed603991fa02297$export$da80edba1526dc1d);
$parcel$export(module.exports, "toOptimisticMultiVersion", () => $bed603991fa02297$export$32cb633741e0efe2);
const $bed603991fa02297$export$b0e8bb5f2ea51c4f = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { priority: priority, fieldSetId: fieldSetId } })=>({
        node: {
            fieldSetId: fieldSetId,
            type: fieldId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraPriorityField',
                            __isJiraIssueField: 'JiraPriorityField',
                            fieldId: fieldId,
                            id: `${issueId}/${fieldId}`,
                            type: fieldType,
                            name: 'Priority',
                            priority: priority
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$afc99b621d72ef26 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { user: user, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSingleSelectUserPickerField',
                            __isJiraIssueField: 'JiraSingleSelectUserPickerField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'User',
                            user: user ? {
                                __isUser: 'AtlassianAccountUser',
                                __typename: 'AtlassianAccountUser',
                                accountStatus: 'active',
                                id: user.id,
                                accountId: user.accountId,
                                picture: user.picture,
                                name: user.name
                            } : null
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$3e4b4b49e4ee4e20 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { status: status, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraStatusField',
                            __isJiraIssueField: 'JiraStatusField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            status: status
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$71ead0fa097cead6 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { option: option, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSingleSelectField',
                            __isJiraIssueField: 'JiraSingleSelectField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'SingleSelectCustomField',
                            fieldOption: option ? {
                                id: option.id,
                                optionId: option.optionId,
                                value: option.value,
                                color: option.color
                            } : null
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$f32e937f8185cba6 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { option: option, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraRadioSelectField',
                            __isJiraIssueField: 'JiraRadioSelectField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'RadioSelectField',
                            selectedOption: option ? {
                                id: option.id,
                                // NOTE: For radio select fields, the value is the id of the option
                                value: option.id,
                                label: option.value
                            } : null
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$a0aeb0a088349a7f = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { option: option, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraMultipleSelectField',
                            __isJiraIssueField: 'JiraMultipleSelectField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'MultiSelectCustomField',
                            selectedOptions: {
                                edges: option ? [
                                    {
                                        node: {
                                            id: option.id,
                                            optionId: option.optionId,
                                            value: option.value
                                        }
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$bdb06cc2dd7fdd79 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { option: option, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraCheckboxesField',
                            __isJiraIssueField: 'JiraCheckboxesField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'MultiSelectCustomField',
                            selectedOptions: {
                                edges: option ? [
                                    {
                                        node: {
                                            id: option.id,
                                            value: option.value
                                        }
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$d9be65aae3a85c75 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { sprint: sprint, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSprintField',
                            __isJiraIssueField: 'JiraSprintField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Sprint',
                            selectedSprintsConnection: {
                                edges: sprint ? [
                                    {
                                        node: {
                                            id: sprint.id,
                                            sprintId: sprint.sprintId,
                                            name: sprint.name,
                                            state: sprint.state,
                                            endDate: sprint.endDate
                                        }
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$4b7137aed66177e0 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { value: value, fieldSetId: fieldSetId, isStoryPointField: isStoryPointField } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraNumberField',
                            __isJiraIssueField: 'JiraNumberField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Story point estimate',
                            number: value,
                            isStoryPointField: isStoryPointField
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$deffb20716f51298 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { value: value, fieldSetId: fieldSetId } })=>{
    return {
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraLabelsField',
                            __isJiraIssueField: 'JiraLabelsField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Labels',
                            selectedLabelsConnection: {
                                totalCount: value ? 1 : 0,
                                edges: value ? [
                                    {
                                        node: {
                                            name: value,
                                            color: null
                                        }
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    };
};
const $bed603991fa02297$export$da80edba1526dc1d = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { value: value, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraMultipleGroupPickerField',
                            __isJiraIssueField: 'JiraMultipleGroupPickerField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Groups',
                            selectedGroupsConnection: {
                                edges: value ? [
                                    {
                                        node: value
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$32cb633741e0efe2 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { version: version, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraMultipleVersionPickerField',
                            __isJiraIssueField: 'JiraMultipleVersionPickerField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Versions',
                            selectedVersionsConnection: {
                                edges: version ? [
                                    {
                                        node: {
                                            id: version.id,
                                            value: version.id,
                                            name: version.name,
                                            label: version.name,
                                            versionId: version.versionId
                                        }
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    });

});



parcelRegister("dwCPn", function(module, exports) {
$parcel$export(module.exports, "default", () => $10f04f10d016508d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $10f04f10d016508d$var$messages = (0, $7qGN1.defineMessages)({
    errorFlagTitleNonFinal: {
        "id": "issue-table-inline-issue-create.controllers.use-issue-create-on-error.error-flag-title-non-final",
        "defaultMessage": "We weren't able to create an issue"
    },
    errorFlagDescriptionNonFinal: {
        "id": "issue-table-inline-issue-create.controllers.use-issue-create-on-error.error-flag-description-non-final",
        "defaultMessage": "Refresh the page and try again."
    },
    errorFlagTitleIssueTerminologyRefreshM4: {
        "id": "issue-table-inline-issue-create.controllers.use-issue-create-on-error.error-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "We weren't able to create a work item"
    }
});
var $10f04f10d016508d$export$2e2bcd8739ae039 = $10f04f10d016508d$var$messages;

});


parcelRegister("6bbL3", function(module, exports) {
$parcel$export(module.exports, "useShouldSkipIssuesConnectionUpdate", () => $586a076f65fa653e$export$39d39d16a578afb3);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $cSXp8 = parcelRequire("cSXp8");

var $3hRxq = parcelRequire("3hRxq");

var $3mZMJ = parcelRequire("3mZMJ");

var $kRgKj = parcelRequire("kRgKj");

var $4cTDP = parcelRequire("4cTDP");

var $k9oyv = parcelRequire("k9oyv");
const $586a076f65fa653e$export$ce7751641b93537d = (0, $3hRxq.createLocalStorageProvider)('jira-native-issue-table-inline-issue-create');
const $586a076f65fa653e$export$39d39d16a578afb3 = ()=>{
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireApplyRankingAnalytics = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'applyRankingFromSuccessFlag');
    }, [
        createAnalyticsEvent
    ]);
    const fireViewWorkItemUIAnalytics = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'viewWorkItemFromSuccessFlag');
    }, [
        createAnalyticsEvent
    ]);
    // TODO convert params into an object
    return (0, $eJOHy.useCallback)((groupContextField, createdIssue, isIssueRankingEnabled = false, onSortChange, rankFieldTerms, isSkipIssueCreateSuccessFlagEnabled = false)=>{
        if (!createdIssue) return false;
        // Determines whether to show the default success flag or the reranking prompt success flag
        const showDefaultSuccessFlag = (issueKey)=>{
            const issueCreatedCount = $586a076f65fa653e$export$ce7751641b93537d.get('issueCreatedCount') ?? 0;
            if (issueCreatedCount < 3) {
                $586a076f65fa653e$export$ce7751641b93537d.set('issueCreatedCount', issueCreatedCount + 1);
                showFlag((0, $k9oyv.getIssueCreateRerankingPromptSuccessFlag)({
                    issueKey: issueKey,
                    onSortChange: onSortChange,
                    rankFieldTerms: rankFieldTerms,
                    fireApplyRankingAnalytics: fireApplyRankingAnalytics,
                    fireViewWorkItemUIAnalytics: fireViewWorkItemUIAnalytics
                }));
            } else showFlag((0, $k9oyv.getIssueCreateSuccessFlag)({
                issueKey: issueKey
            }));
        };
        const issueKey = createdIssue.key;
        const event = createAnalyticsEvent({});
        const matchesIssueSearch = createdIssue.matchesIssueSearch !== false;
        const hasGroupValueChanged = !!groupContextField && !(0, $k9oyv.fieldValueContainsGroupContextValue)(createdIssue, groupContextField, groupContextField.fieldId);
        const shouldSkipIssueConnectionUpdate = hasGroupValueChanged || !matchesIssueSearch;
        if (isSkipIssueCreateSuccessFlagEnabled) return shouldSkipIssueConnectionUpdate;
        if (!matchesIssueSearch) issueKey && showFlag((0, $k9oyv.getIssueCreateHiddenFlag)({
            issueKey: issueKey
        }));
        else if (hasGroupValueChanged && groupContextField?.fieldType === (0, $3mZMJ.STATUS_TYPE)) issueKey && showFlag((0, $k9oyv.getIssueCreateSuccessFlag)({
            issueKey: issueKey,
            statusName: (0, $k9oyv.getStatusName)(createdIssue)
        }));
        else if (!isIssueRankingEnabled && (0, $4cTDP.fg)('jsc_list_reranking_gate')) issueKey && showDefaultSuccessFlag(issueKey);
        else issueKey && showFlag((0, $k9oyv.getIssueCreateSuccessFlag)({
            issueKey: issueKey
        }));
        (0, $kRgKj.fireUIAnalytics)(event, 'issueCreatedInListFlag shown', {
            matchesIssueSearch: matchesIssueSearch,
            groupIssueCreateFieldType: groupContextField?.fieldType || null,
            hasGroupValueChanged: hasGroupValueChanged
        });
        return shouldSkipIssueConnectionUpdate;
    }, [
        createAnalyticsEvent,
        showFlag,
        fireApplyRankingAnalytics,
        fireViewWorkItemUIAnalytics
    ]);
};

});
parcelRegister("k9oyv", function(module, exports) {
$parcel$export(module.exports, "fieldValueContainsGroupContextValue", () => $690b1b9780012057$export$a22b68ac49a3d37c);
$parcel$export(module.exports, "getStatusName", () => $690b1b9780012057$export$25a87d7a26b3901c);
$parcel$export(module.exports, "getIssueCreateSuccessFlag", () => $690b1b9780012057$export$d4c1d656d8898934);
$parcel$export(module.exports, "getIssueCreateRerankingPromptSuccessFlag", () => $690b1b9780012057$export$3b825da3d0425a10);
$parcel$export(module.exports, "getIssueCreateHiddenFlag", () => $690b1b9780012057$export$58532011dc58b882);

var $eJOHy = parcelRequire("eJOHy");

var $4sprp = parcelRequire("4sprp");

var $3cMgR = parcelRequire("3cMgR");

var $3mZMJ = parcelRequire("3mZMJ");

var $4cTDP = parcelRequire("4cTDP");

var $lFP7n = parcelRequire("lFP7n");
const $690b1b9780012057$export$a22b68ac49a3d37c = (createdIssue, groupContextField, fieldId)=>{
    const issueField = createdIssue.fieldsByIdOrAlias?.find((field)=>field?.fieldId === fieldId);
    let fieldValue;
    switch(issueField?.__typename){
        case 'JiraStatusField':
            fieldValue = issueField.status?.statusId ?? null;
            break;
        case 'JiraPriorityField':
            fieldValue = issueField.priority?.priorityId ?? null;
            break;
        case 'JiraSingleSelectUserPickerField':
            fieldValue = issueField.user?.accountId ?? null;
            break;
        case 'JiraSingleSelectField':
            fieldValue = issueField.fieldOption?.optionId ?? null;
            break;
        case 'JiraRadioSelectField':
            fieldValue = issueField.selectedOption?.optionId ?? null;
            break;
        case 'JiraCheckboxesField':
        case 'JiraMultipleSelectField':
            fieldValue = issueField.selectedOptions?.edges?.map((edge)=>edge?.node?.optionId).filter((optionId)=>!!optionId) ?? null;
            break;
        case 'JiraSprintField':
            fieldValue = issueField.selectedSprintsConnection?.edges?.map((edge)=>edge?.node?.sprintId).filter((sprintId)=>!!sprintId) ?? null;
            break;
        case 'JiraNumberField':
            fieldValue = issueField.number ?? null;
            break;
        case 'JiraLabelsField':
            fieldValue = issueField.selectedLabelsConnection?.edges?.map((edge)=>edge?.node?.name).filter((name)=>!!name) ?? null;
            break;
        case 'JiraMultipleVersionPickerField':
            fieldValue = issueField.selectedVersionsConnection?.edges?.map((edge)=>edge?.node?.versionId).filter((versionId)=>!!versionId) ?? null;
            break;
        case 'JiraSingleVersionPickerField':
            fieldValue = issueField.version?.versionId ?? null;
            break;
        default:
            fieldValue = null;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4sprp)))(fieldValue)) return fieldValue === groupContextField.fieldValue;
    if (fieldValue.length === 0) return groupContextField.fieldValue === null;
    return typeof groupContextField.fieldValue === 'string' && fieldValue?.includes(groupContextField.fieldValue);
};
const $690b1b9780012057$export$25a87d7a26b3901c = (createdIssue)=>{
    const issueField = createdIssue.fieldsByIdOrAlias?.find((field)=>field?.fieldId === (0, $3mZMJ.STATUS_TYPE));
    return issueField?.status?.name;
};
const $690b1b9780012057$var$Bold = (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "strong"
    }, chunk);
const $690b1b9780012057$export$d4c1d656d8898934 = ({ issueKey: issueKey, statusName: statusName })=>({
        id: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-success',
        type: 'success',
        messageId: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-success',
        messageType: 'transactional',
        isAutoDismiss: true,
        title: [
            (0, $lFP7n.default).workItemCreatedSuccessfullyTitle,
            {
                issueKey: issueKey
            }
        ],
        description: statusName ? [
            (0, $lFP7n.default).workItemChangedStatusDescription,
            {
                issueKey: issueKey,
                statusName: statusName,
                Bold: $690b1b9780012057$var$Bold
            }
        ] : undefined,
        actions: [
            {
                content: [
                    (0, $lFP7n.default).viewWorkItem,
                    {
                        issueKey: issueKey
                    }
                ],
                href: `/browse/${issueKey}`
            }
        ]
    });
const $690b1b9780012057$export$3b825da3d0425a10 = ({ issueKey: issueKey, onSortChange: onSortChange, rankFieldTerms: rankFieldTerms, fireApplyRankingAnalytics: fireApplyRankingAnalytics, fireViewWorkItemUIAnalytics: fireViewWorkItemUIAnalytics })=>({
        id: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-reranking-prompt-success',
        type: 'success',
        messageId: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-reranking-prompt-success',
        messageType: 'transactional',
        isAutoDismiss: true,
        title: [
            (0, $lFP7n.default).workItemCreatedSuccessfullyTitle,
            {
                issueKey: issueKey
            }
        ],
        description: [
            (0, $lFP7n.default).rerankingPromptDescription,
            {
                issueKey: issueKey,
                Bold: $690b1b9780012057$var$Bold
            }
        ],
        actions: [
            {
                content: (0, $lFP7n.default).applyRanking,
                onClick: ()=>{
                    fireApplyRankingAnalytics();
                    rankFieldTerms?.jqlTerm && onSortChange?.(rankFieldTerms.jqlTerm, 'ASC', rankFieldTerms.aliases && (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? rankFieldTerms.aliases : undefined);
                }
            },
            {
                content: [
                    (0, $lFP7n.default).viewWorkItem,
                    {
                        issueKey: issueKey
                    }
                ],
                href: `/browse/${issueKey}`,
                onClick: ()=>{
                    fireViewWorkItemUIAnalytics();
                }
            }
        ]
    });
const $690b1b9780012057$export$58532011dc58b882 = ({ issueKey: issueKey })=>({
        id: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-hidden',
        type: 'success',
        messageId: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-hidden',
        messageType: 'transactional',
        isAutoDismiss: true,
        title: [
            (0, $lFP7n.default).workItemCreatedSuccessfullyTitle,
            {
                issueKey: issueKey
            }
        ],
        description: [
            (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $lFP7n.default).workItemHiddenDescription : (0, $lFP7n.default).issueHiddenDescription,
            {
                issueKey: issueKey,
                Bold: $690b1b9780012057$var$Bold
            }
        ],
        actions: [
            {
                content: [
                    (0, $lFP7n.default).viewWorkItem,
                    {
                        issueKey: issueKey
                    }
                ],
                href: `/browse/${issueKey}`
            }
        ]
    });

});
parcelRegister("lFP7n", function(module, exports) {
$parcel$export(module.exports, "default", () => $20d9124b1f2da319$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $20d9124b1f2da319$var$messages = (0, $7qGN1.defineMessages)({
    workItemCreatedSuccessfullyTitle: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.work-item-created-successfully-title",
        "defaultMessage": "Created {issueKey}"
    },
    workItemChangedStatusDescription: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.work-item-changed-status-description",
        "defaultMessage": "Created <Bold>{issueKey}</Bold> with <Bold>{statusName}</Bold> status"
    },
    workItemHiddenDescription: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.work-item-hidden-description",
        "defaultMessage": "<Bold>{issueKey}</Bold> is hidden because a filter is applied. Clear the filter to see all work items."
    },
    rerankingPromptDescription: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.reranking-prompt-description",
        "defaultMessage": "Select <Bold>apply ranking</Bold> to create and reorder work in specific positions."
    },
    applyRanking: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.apply-ranking",
        "defaultMessage": "Apply ranking"
    },
    viewWorkItem: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.view-work-item",
        "defaultMessage": "View {issueKey}"
    },
    issueHiddenDescription: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.issue-hidden-description",
        "defaultMessage": "<Bold>{issueKey}</Bold> is hidden because a filter is applied. Clear the filter to see all issues."
    }
});
var $20d9124b1f2da319$export$2e2bcd8739ae039 = $20d9124b1f2da319$var$messages;

});



parcelRegister("3ElzA", function(module, exports) {
$parcel$export(module.exports, "useQueuedMutationCommit", () => $13f1b54ac5fcbf64$export$4eb3ddef28ed9675);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");
const $13f1b54ac5fcbf64$export$4eb3ddef28ed9675 = ({ generateDeferredVariables: generateDeferredVariables })=>{
    const running = (0, $eJOHy.useRef)(false);
    const queue = (0, $eJOHy.useRef)([]);
    /**
   * Dispose of any queued commits (in backwards order) and requeue each commit (which will execute the first commit
   * immediately). We need to explicitly dispose and requeue commits so optimistic updates are performed in the
   * correct order when the first queued commit is executed.
   */ const dequeue = (0, $eJOHy.useCallback)(()=>{
        running.current = false;
        const requeue = [];
        while(queue.current.length){
            const entry = queue.current.pop();
            if (entry) {
                entry.dispose();
                requeue.unshift(entry.requeue);
            }
        }
        requeue.forEach((fn)=>fn());
    }, []);
    const queuedCommit = (0, $eJOHy.useCallback)((environment, config)=>{
        const disposables = [];
        const requeue = ()=>{
            disposables.push(queuedCommit(environment, config));
        };
        const dispose = ()=>{
            while(disposables.length)disposables.pop()?.dispose();
        };
        const commit = ()=>{
            running.current = true;
            const disposable = (0, $j4oe4.commitMutation)(environment, {
                ...config,
                variables: generateDeferredVariables ? generateDeferredVariables(config.variables) : config.variables,
                onCompleted: (response, errors)=>{
                    // Run any queued commits after the mutation has completed
                    dequeue();
                    config.onCompleted?.(response, errors);
                },
                onError: (error)=>{
                    // Run any queued commits after the mutation has failed
                    dequeue();
                    config.onError?.(error);
                }
            });
            disposables.push(disposable);
        };
        if (!running.current) commit();
        else {
            const optimisticDisposable = (0, $j4oe4.applyOptimisticMutation)(environment, config);
            disposables.push(optimisticDisposable);
            queue.current.push({
                requeue: requeue,
                dispose: dispose
            });
        }
        // Return a new disposable that cleans up the optimistic AND committed operations
        return {
            dispose: dispose
        };
    }, [
        dequeue,
        generateDeferredVariables
    ]);
    return queuedCommit;
};

});

parcelRegister("d0yFI", function(module, exports) {
$parcel$export(module.exports, "issueConnectionUpdater", () => $7fde21bc9a1cb8cc$export$340227f0fce3ad1b);
$parcel$export(module.exports, "removeHighlightAfterDelay", () => $7fde21bc9a1cb8cc$export$c6f131ddea3d52b7);

var $j4oe4 = parcelRequire("j4oe4");

var $afQ2l = parcelRequire("afQ2l");

var $8jOO7 = parcelRequire("8jOO7");

var $57Nys = parcelRequire("57Nys");

var $cf7fh = parcelRequire("cf7fh");
const $7fde21bc9a1cb8cc$export$340227f0fce3ad1b = (store, { issue: issue, issueConnectionId: issueConnectionId, parentItemConnectionId: parentItemConnectionId, issueRecordId: issueRecordId, fieldSetsConnectionId: fieldSetsConnectionId, insertAfter: insertAfter = true, insertNodeId: insertNodeId, getRealId: getRealId = (id)=>id, projectKey: projectKey, groupId: groupId })=>{
    (0, $afQ2l.highlightIssueRow)(store, issue, true);
    const issueRecord = store.get(issueRecordId);
    const connectionRecord = store.get(issueConnectionId);
    const fieldSetsRecord = store.get(fieldSetsConnectionId);
    if (!issueRecord || !connectionRecord || !fieldSetsRecord) return;
    if (parentItemConnectionId) {
        const updateArgs = projectKey ? {
            filterByProjectKeys: [
                projectKey
            ]
        } : undefined;
        store.get(parentItemConnectionId)?.setValue(true, 'hasChildren', updateArgs);
    }
    const edge = (0, $j4oe4.ConnectionHandler).createEdge(store, connectionRecord, issueRecord, 'JiraIssueEdge');
    // don't insert the same edge in case optimisticUpdater gets called multiple times
    if ((0, $cf7fh.hasEdge)(connectionRecord, edge)) return;
    const updateArgs = projectKey ? {
        projectKey: projectKey
    } : undefined;
    const canHaveChildIssues = issueRecord.getValue('canHaveChildIssues', updateArgs);
    if (canHaveChildIssues) edge.setValue(true, 'canHaveChildIssues', updateArgs);
    let realNodeId = insertNodeId;
    if (insertNodeId != null) realNodeId = getRealId(insertNodeId) ?? insertNodeId;
    if (insertAfter) (0, $cf7fh.insertEdgeAfter)(connectionRecord, edge, realNodeId);
    else (0, $cf7fh.insertEdgeBefore)(connectionRecord, edge, realNodeId);
    const fieldSets = edge.getOrCreateLinkedRecord('fieldSets', 'JiraIssueFieldSetEdge', {
        first: 500
    });
    fieldSets.copyFieldsFrom(fieldSetsRecord);
    const totalIssues = connectionRecord.getValue('totalIssueSearchResultCount');
    if (totalIssues != null && typeof totalIssues === 'number') connectionRecord.setValue(totalIssues + 1, 'totalIssueSearchResultCount');
    if (groupId) (0, $57Nys.updateGroupIssueCount)({
        store: store,
        groupId: groupId,
        netChangeInIssueCount: 1
    });
};
const $7fde21bc9a1cb8cc$export$c6f131ddea3d52b7 = (environment, issue)=>{
    setTimeout(()=>{
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            (0, $afQ2l.highlightIssueRow)(store, issue, false);
        });
    }, (0, $8jOO7.HIGHLIGHT_LINGER_DURATION_MS));
};

});
parcelRegister("afQ2l", function(module, exports) {
$parcel$export(module.exports, "highlightIssueRow", () => $b2c45d2ca600a278$export$53e8a18b32fbb0d6);

var $j1ap8 = parcelRequire("j1ap8");
const $b2c45d2ca600a278$export$53e8a18b32fbb0d6 = (store, issueRef, isHighlighted)=>{
    const { updatableData: updatableData } = store.readUpdatableFragment((0, $j1ap8.default), issueRef);
    updatableData.isHighlightedIssueRow = isHighlighted;
};

});
parcelRegister("j1ap8", function(module, exports) {
$parcel$export(module.exports, "default", () => $f74871dfd2351f3e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<31b8657f09b7a729f0bb61efdd7b5bb2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f74871dfd2351f3e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "highlightIssueRow",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isHighlightedIssueRow"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$f74871dfd2351f3e$var$node.hash = "a9247a88904b4ab4be14f6ca46a6806e";
var $f74871dfd2351f3e$export$2e2bcd8739ae039 = $f74871dfd2351f3e$var$node;

});


parcelRegister("57Nys", function(module, exports) {
$parcel$export(module.exports, "getIssueIndexInConnection", () => $88b8327741a45694$export$fc68d8bf4e03e424);
$parcel$export(module.exports, "updateGroupIssueCount", () => $88b8327741a45694$export$9d5e7224bfc56344);
$parcel$export(module.exports, "updateParentHasChildren", () => $88b8327741a45694$export$49a0ddeeed46a5b);
$parcel$export(module.exports, "useUpdateConnectionDetails", () => $88b8327741a45694$export$8ce878b875ed1164);
$parcel$export(module.exports, "insertNewGroupInGroupsConnection", () => $88b8327741a45694$export$4369efd6760b11d0);

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");

var $kqd31 = parcelRequire("kqd31");

var $4cTDP = parcelRequire("4cTDP");

var $dLXgn = parcelRequire("dLXgn");
const $88b8327741a45694$var$JIRA_SPREADSHEET_GROUP_TYPENAME = 'JiraSpreadsheetGroup';
const $88b8327741a45694$export$fc68d8bf4e03e424 = ({ issues: issues, issuesWithContext: issuesWithContext, context: context })=>{
    let foundMovedIssue = false;
    // There is a possible race condition where the bulk query for positions fires without all the issue subscriptions arriving (when an issue is created right as the timeout for the client finishes)
    // In those cases, we should use relative positioning instead of the absolute position where possible to prevent issues from being inserted at the wrong position
    const relativeIssueIndex = issues.findIndex((issue)=>{
        const issueId = issue.getLinkedRecord('node')?.getValue('issueId');
        if (issueId === context.sourceIssueId) foundMovedIssue = true;
        if (!issueId || typeof issueId === 'string' && issuesWithContext.has(issueId)) return false;
        return issueId === context.afterIssueId || issueId === context.beforeIssueId;
    });
    let relativePosition;
    if (relativeIssueIndex !== -1) {
        const relativeIssue = issues[relativeIssueIndex];
        const relativeIssueId = relativeIssue?.getLinkedRecord('node')?.getValue('issueId');
        if (relativeIssueId === context.afterIssueId) relativePosition = relativeIssueIndex;
        else if (relativeIssueId === context.beforeIssueId) relativePosition = relativeIssueIndex + 1;
        if (foundMovedIssue && relativePosition != null) // if we moved the issue down the list, we need to adjust the position otherwise its original position in the list impacts the index of all issues after
        relativePosition -= 1;
    }
    return relativePosition ?? context.position;
};
const $88b8327741a45694$var$removeGroupFromConnection = ({ store: store, groupId: groupId, connectionId: connectionId, groupConnectionId: groupConnectionId })=>{
    if (!groupConnectionId) return;
    if (connectionId) {
        // invalidate connection for next incoming updates.
        const connectionRecord = store.get(connectionId);
        connectionRecord?.invalidateRecord();
    }
    const relayId = (0, $kqd31.default)({
        id: groupId
    }, $88b8327741a45694$var$JIRA_SPREADSHEET_GROUP_TYPENAME);
    const groupConnectionRecord = store.get(groupConnectionId);
    if (!groupConnectionRecord || !relayId) return;
    (0, $37Ewn.ConnectionHandler).deleteNode(groupConnectionRecord, relayId);
    // Remove the firstGroup reference if it's the same as the group being removed
    if (groupConnectionRecord.getLinkedRecord('firstGroup')?.getDataID() === relayId) groupConnectionRecord.setValue(null, 'firstGroup');
};
const $88b8327741a45694$export$9d5e7224bfc56344 = ({ store: store, groupId: groupId, netChangeInIssueCount: netChangeInIssueCount, groupConnectionId: groupConnectionId, connectionId: connectionId })=>{
    const relayId = (0, $kqd31.default)({
        id: groupId
    }, $88b8327741a45694$var$JIRA_SPREADSHEET_GROUP_TYPENAME);
    if (!relayId) return;
    const groupRecord = store.get(relayId);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueCount = groupRecord?.getValue('issueCount') || 0;
    const newIssueCount = issueCount + netChangeInIssueCount;
    if (newIssueCount <= 0) $88b8327741a45694$var$removeGroupFromConnection({
        store: store,
        groupId: groupId,
        connectionId: connectionId,
        groupConnectionId: groupConnectionId
    });
    else groupRecord?.setValue(newIssueCount, 'issueCount');
};
const $88b8327741a45694$export$49a0ddeeed46a5b = ({ store: store, parentIssueEdgeRecordId: parentIssueEdgeRecordId, connectionId: connectionId, hasChildren: hasChildren, projectKey: projectKey })=>{
    // returns whether an update was performed
    const parentIssueRecord = store.get(parentIssueEdgeRecordId);
    const updateArgs = projectKey ? {
        filterByProjectKeys: [
            projectKey
        ]
    } : undefined;
    if (parentIssueRecord && parentIssueRecord.getValue('hasChildren', updateArgs) !== hasChildren) {
        parentIssueRecord?.setValue(hasChildren, 'hasChildren', updateArgs);
        if (hasChildren === false && connectionId && (0, $4cTDP.fg)('jsc_list_reparenting')) {
            const connectionRecord = store.get(connectionId);
            connectionRecord?.invalidateRecord();
        }
        return true;
    }
    return false;
};
const $88b8327741a45694$export$8ce878b875ed1164 = ()=>{
    const { removeConnection: removeConnectionFromList } = (0, $dLXgn.useConnectionsListActions)();
    return (0, $eJOHy.useCallback)(({ store: store, connection: connection, netChangeInIssueCount: netChangeInIssueCount, remainingIssueCount: remainingIssueCount, groupConnectionId: groupConnectionId, projectKey: projectKey, hasAccurateGroupCounts: hasAccurateGroupCounts })=>{
        if (remainingIssueCount === undefined) return;
        switch(connection.type){
            case 'GROUP_CHILDREN':
                // we only want to manually update the group issue count if the group count is not accurate
                !hasAccurateGroupCounts && $88b8327741a45694$export$9d5e7224bfc56344({
                    store: store,
                    groupId: connection.groupId,
                    netChangeInIssueCount: netChangeInIssueCount,
                    groupConnectionId: groupConnectionId,
                    connectionId: connection.connectionId
                });
                break;
            case 'PARENT_CHILDREN':
                $88b8327741a45694$export$49a0ddeeed46a5b({
                    store: store,
                    parentIssueEdgeRecordId: connection.parentRelayId,
                    connectionId: connection.connectionId,
                    hasChildren: remainingIssueCount > 0,
                    projectKey: projectKey
                });
                break;
            case 'ROOT_ISSUES':
                {
                    const connectionRecord = store.get(connection.connectionId);
                    if (!connectionRecord) break;
                    const totalIssues = connectionRecord.getValue('totalIssueSearchResultCount');
                    if (totalIssues != null && typeof totalIssues === 'number') connectionRecord.setValue(totalIssues + netChangeInIssueCount, 'totalIssueSearchResultCount');
                    break;
                }
            default:
        }
        if (remainingIssueCount === 0) {
            if (connection.type !== 'PARENT_CHILDREN') removeConnectionFromList(connection);
        }
    }, [
        removeConnectionFromList
    ]);
};
function $88b8327741a45694$var$insertEdgeAtPosition(existingEdges, newEdge, index) {
    return [
        ...existingEdges.slice(0, index),
        newEdge,
        ...existingEdges.slice(index)
    ];
}
const $88b8327741a45694$export$4369efd6760b11d0 = ({ store: store, groupsConnection: groupsConnection, newGroup: newGroup, groupEdges: groupEdges, afterGroupId: afterGroupId })=>{
    const newGroupEdge = (0, $37Ewn.ConnectionHandler).createEdge(store, groupsConnection, newGroup, 'JiraSpreadsheetGroupEdge');
    if (afterGroupId === null) return $88b8327741a45694$var$insertEdgeAtPosition(groupEdges, newGroupEdge, 0);
    const afterGroupIndex = groupEdges.findIndex((edge)=>edge.getLinkedRecord('node')?.getValue('id') === afterGroupId);
    if (afterGroupIndex !== -1) return $88b8327741a45694$var$insertEdgeAtPosition(groupEdges, newGroupEdge, afterGroupIndex + 1);
    return groupEdges;
};

});

parcelRegister("cf7fh", function(module, exports) {
$parcel$export(module.exports, "insertEdgeBefore", () => $0d35c4acd0065c5a$export$af841f09852c57d0);
$parcel$export(module.exports, "insertEdgeAfter", () => $0d35c4acd0065c5a$export$10e6263a191d72a0);
$parcel$export(module.exports, "hasEdge", () => $0d35c4acd0065c5a$export$da04cd0b23213625);

var $37Ewn = parcelRequire("37Ewn");
const $0d35c4acd0065c5a$var$findEdgeIndex = (edges, id)=>{
    if (id == null) return -1;
    const { NODE: NODE } = (0, $37Ewn.ConnectionInterface).get();
    return edges.findIndex((edge)=>edge.getLinkedRecord(NODE)?.getValue('id') === id);
};
const $0d35c4acd0065c5a$export$af841f09852c57d0 = (record, newEdge, id)=>{
    const { EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES) ?? [];
    const index = $0d35c4acd0065c5a$var$findEdgeIndex(edges, id);
    let nextEdges;
    if (index === -1) nextEdges = [
        newEdge
    ].concat(edges);
    else nextEdges = edges.slice(0, index).concat(newEdge).concat(edges.slice(index));
    record.setLinkedRecords(nextEdges, EDGES);
};
const $0d35c4acd0065c5a$export$10e6263a191d72a0 = (record, newEdge, id)=>{
    const { EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES) ?? [];
    const index = $0d35c4acd0065c5a$var$findEdgeIndex(edges, id);
    let nextEdges;
    if (index === -1) nextEdges = edges.concat(newEdge);
    else nextEdges = edges.slice(0, index + 1).concat(newEdge).concat(edges.slice(index + 1));
    record.setLinkedRecords(nextEdges, EDGES);
};
const $0d35c4acd0065c5a$export$da04cd0b23213625 = (record, edge)=>{
    const { NODE: NODE, EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES) ?? [];
    const edgeIndex = edges.findIndex((e)=>e.getLinkedRecord(NODE)?.getValue('id') === edge.getLinkedRecord(NODE)?.getValue('id'));
    return edgeIndex > -1;
};

});


parcelRegister("5NEjg", function(module, exports) {
$parcel$export(module.exports, "IssueFetchQueryVariablesContainer", () => $9a9cd43ba0376cc5$export$72556f17a9cf678b);
$parcel$export(module.exports, "useIssueFetchQueryVariables", () => $9a9cd43ba0376cc5$export$52ce8dcf7591a458);

var $cSmYj = parcelRequire("cSmYj");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $9a9cd43ba0376cc5$export$72556f17a9cf678b = (0, $6E16M.createContainer)();
const $9a9cd43ba0376cc5$export$d4c72bab9d6cc13a = {
    fieldSetIds: []
};
const $9a9cd43ba0376cc5$var$updateStore = ()=>({ setState: setState, getState: getState }, { fieldSetIds: fieldSetIds })=>{
        const state = getState();
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(fieldSetIds, state.fieldSetIds)) setState({
            fieldSetIds: fieldSetIds
        });
    };
const $9a9cd43ba0376cc5$var$Store = (0, $GtRbT.createStore)({
    containedBy: $9a9cd43ba0376cc5$export$72556f17a9cf678b,
    initialState: $9a9cd43ba0376cc5$export$d4c72bab9d6cc13a,
    actions: {},
    handlers: {
        onInit: $9a9cd43ba0376cc5$var$updateStore,
        onContainerUpdate: $9a9cd43ba0376cc5$var$updateStore
    }
});
const $9a9cd43ba0376cc5$export$52ce8dcf7591a458 = (0, $iJq0l.createStateHook)($9a9cd43ba0376cc5$var$Store);

});

parcelRegister("fidcQ", function(module, exports) {
$parcel$export(module.exports, "useIssueFetchAndAppend", () => $88f0a96292e49178$export$e36c00c1dfa0c592);

var $bnId1 = parcelRequire("bnId1");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $cHtIB = parcelRequire("cHtIB");

var $6bbL3 = parcelRequire("6bbL3");

var $34oCh = parcelRequire("34oCh");

var $d0yFI = parcelRequire("d0yFI");

var $5NEjg = parcelRequire("5NEjg");
const $88f0a96292e49178$var$issueConnectionQueryUpdater = (environment, response, issueConnectionId, insertionArgs, groupId)=>{
    const issue = response?.jira?.issueByKey;
    if (!issue) return;
    (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
        (0, $d0yFI.issueConnectionUpdater)(store, {
            ...insertionArgs,
            issue: issue,
            issueConnectionId: issueConnectionId,
            issueRecordId: issue.__id,
            fieldSetsConnectionId: issue.fieldSetsById.__id,
            groupId: groupId
        });
    });
    (0, $d0yFI.removeHighlightAfterDelay)(environment, issue);
};
const $88f0a96292e49178$export$e36c00c1dfa0c592 = ({ issueConnectionId: issueConnectionId, groupContextFieldInput: groupContextFieldInput, jql: jql })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isInlineEditingEnabled = (0, $34oCh.useIsInlineEditingEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const { fieldSetIds: fieldSetIds } = (0, $5NEjg.useIssueFetchQueryVariables)();
    const shouldSkipIssuesConnectionUpdateAndShowFlag = (0, $6bbL3.useShouldSkipIssuesConnectionUpdate)();
    const isLinkRelationshipFieldEnabled = (0, $34oCh.useIsRelationshipFieldEnabled)();
    const isSkipIssueCreateSuccessFlagEnabled = (0, $34oCh.useIsSkipIssueCreateSuccessFlagEnabled)();
    return (0, $eJOHy.useCallback)((issueKey, insertionArgs)=>{
        if (!issueConnectionId) return null;
        (0, $j4oe4.fetchQuery)(environment, (0, $bnId1.default), {
            cloudId: cloudId,
            issueKey: issueKey,
            fieldSetIds: fieldSetIds,
            isInlineEditingEnabled: isInlineEditingEnabled,
            isDensityFull: isDensityFull,
            isConditionalFormattingEnabled: false,
            ...groupContextFieldInput ? {
                shouldQueryFieldsByIdOrAlias: true,
                fieldIdsOrAliases: [
                    groupContextFieldInput.fieldId
                ]
            } : {
                shouldQueryFieldsByIdOrAlias: false,
                fieldIdsOrAliases: []
            },
            ...jql ? {
                shouldQueryMatchesIssueSearch: true,
                issueSearchInput: {
                    jql: jql
                }
            } : {
                shouldQueryMatchesIssueSearch: false,
                issueSearchInput: {
                    jql: ''
                }
            },
            isTimelineEnabled: isTimelineEnabled,
            isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled
        }).subscribe({
            next: (data)=>{
                const shouldSkipIssueConnectionUpdate = shouldSkipIssuesConnectionUpdateAndShowFlag(groupContextFieldInput, data?.jira?.issueByKey, undefined, undefined, undefined, isSkipIssueCreateSuccessFlagEnabled);
                if (shouldSkipIssueConnectionUpdate === true) return;
                $88f0a96292e49178$var$issueConnectionQueryUpdater(environment, data, issueConnectionId, insertionArgs, groupContextFieldInput?.groupId);
            }
        });
    }, [
        cloudId,
        environment,
        fieldSetIds,
        isDensityFull,
        isInlineEditingEnabled,
        issueConnectionId,
        groupContextFieldInput,
        jql,
        shouldSkipIssuesConnectionUpdateAndShowFlag,
        isTimelineEnabled,
        isLinkRelationshipFieldEnabled,
        isSkipIssueCreateSuccessFlagEnabled
    ]);
};

});
parcelRegister("bnId1", function(module, exports) {
$parcel$export(module.exports, "default", () => $364e4341df7caad6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6b4927c6bd10cc139688de7d005d5bb5>>
 * @relayHash 4393baaf5aa507459c966df216df403b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 38796adbb7731403cfbc8d3b17fa7773fb7244ae07f0fbfdd659ba31c0707214

var $3Bt2F = parcelRequire("3Bt2F");

var $3jVIX = parcelRequire("3jVIX");

var $hRj2m = parcelRequire("hRj2m");

var $6AioA = parcelRequire("6AioA");

var $04qit = parcelRequire("04qit");

var $jvWSl = parcelRequire("jvWSl");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $1fipb = parcelRequire("1fipb");

var $FU9UR = parcelRequire("FU9UR");
const $364e4341df7caad6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldIdsOrAliases"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDensityFull"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isInlineEditingEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLinkRelationshipFieldEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldsByIdOrAlias"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryMatchesIssueSearch"
    }, v12 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "key"
    }, v14 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v16 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v17 = [
        {
            "kind": "Variable",
            "name": "idsOrAliases",
            "variableName": "fieldIdsOrAliases"
        }
    ], v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "statusId"
    }, v21 = {
        "kind": "ScalarField",
        "name": "name"
    }, v22 = {
        "kind": "ScalarField",
        "name": "priorityId"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "JiraPriorityField"
    }, v24 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v25 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v26 = [
        v25 /*: any*/ 
    ], v27 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v28 = {
        "kind": "ScalarField",
        "name": "sprintId"
    }, v29 = {
        "kind": "ScalarField",
        "name": "number"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": [
            v29 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v21 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraLabelsField"
    }, v32 = [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": v26 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ], v33 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v34 = [
        v33 /*: any*/ 
    ], v35 = {
        "condition": "shouldQueryMatchesIssueSearch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "kind": "ScalarField",
                "name": "matchesIssueSearch"
            }
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "type"
    }, v37 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v38 = {
        "kind": "ScalarField",
        "name": "id"
    }, v39 = {
        "kind": "ScalarField",
        "name": "value"
    }, v40 = [
        v39 /*: any*/ ,
        v38 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v41 = {
        "condition": "isInlineEditingEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lazyIsEditableInIssueView"
                    }
                ]
            }
        ]
    }, v42 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v43 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v44 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v45 = {
        "kind": "ScalarField",
        "name": "date"
    }, v46 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v47 = {
        "kind": "ScalarField",
        "name": "text"
    }, v48 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v49 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v48 /*: any*/ ,
            v38 /*: any*/ 
        ]
    }, v50 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v38 /*: any*/ 
        ]
    }, v51 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v52 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v53 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v54 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v55 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v49 /*: any*/ ,
            v38 /*: any*/ 
        ]
    }, v56 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v57 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v58 = [
        {
            "kind": "ScalarField",
            "name": "appType"
        }
    ], v59 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v60 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v61 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v62 = [
        v38 /*: any*/ 
    ], v63 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v62 /*: any*/ 
    }, v64 = {
        "kind": "ScalarField",
        "name": "href"
    }, v65 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v66 = {
        "kind": "InlineFragment",
        "selections": [
            v45 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v67 = [
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v66 /*: any*/ ,
        v38 /*: any*/ 
    ], v68 = [
        v18 /*: any*/ ,
        v66 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": v62 /*: any*/ ,
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ], v69 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "issue",
                    "plural": false,
                    "selections": [
                        v38 /*: any*/ ,
                        v14 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        v54 /*: any*/ ,
                                        v38 /*: any*/ 
                                    ]
                                },
                                v38 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraParentIssueField",
                            "kind": "LinkedField",
                            "name": "parentIssueField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "parentIssue",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v38 /*: any*/ 
                                    ]
                                },
                                v38 /*: any*/ 
                            ]
                        },
                        v13 /*: any*/ ,
                        {
                            "concreteType": "JiraStatusField",
                            "kind": "LinkedField",
                            "name": "statusField",
                            "plural": false,
                            "selections": [
                                v55 /*: any*/ ,
                                v38 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraSingleSelectUserPickerField",
                            "kind": "LinkedField",
                            "name": "assigneeField",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        v56 /*: any*/ ,
                                        v38 /*: any*/ 
                                    ]
                                },
                                v38 /*: any*/ 
                            ]
                        },
                        {
                            "args": v65 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "startDateViewField",
                            "plural": false,
                            "selections": v67 /*: any*/ ,
                            "storageKey": "startDateViewField(viewId:\"list_default\")"
                        },
                        {
                            "args": v65 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "endDateViewField",
                            "plural": false,
                            "selections": v67 /*: any*/ ,
                            "storageKey": "endDateViewField(viewId:\"list_default\")"
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "aggregatedStartDateViewField",
                                    "plural": false,
                                    "selections": v68 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "aggregatedEndDateViewField",
                                    "plural": false,
                                    "selections": v68 /*: any*/ 
                                }
                            ],
                            "type": "JiraAggregatedTimelineField"
                        }
                    ]
                }
            ],
            "type": "JiraTimelineVirtualField",
            "abstractKey": "__isJiraTimelineVirtualField"
        }
    ], v70 = [
        v33 /*: any*/ ,
        v38 /*: any*/ 
    ], v71 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": v70 /*: any*/ 
            }
        ],
        "type": "JiraSingleVersionPickerField"
    }, v72 = [
        v18 /*: any*/ ,
        v38 /*: any*/ 
    ], v73 = [
        v25 /*: any*/ ,
        v38 /*: any*/ 
    ], v74 = [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": v73 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useIssueFetchAndAppendQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v12 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "highlightIssueRow"
                                },
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v15 /*: any*/ ,
                                        "concreteType": "JiraIssueFieldSetConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldSetsById",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "isConditionalFormattingEnabled",
                                                        "variableName": "isConditionalFormattingEnabled"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "isDensityFull",
                                                        "variableName": "isDensityFull"
                                                    },
                                                    {
                                                        "kind": "Literal",
                                                        "name": "isEditableSyncLoaded",
                                                        "value": false
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "isInlineEditingEnabled",
                                                        "variableName": "isInlineEditingEnabled"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "isLinkRelationshipFieldEnabled",
                                                        "variableName": "isLinkRelationshipFieldEnabled"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "isTimelineEnabled",
                                                        "variableName": "isTimelineEnabled"
                                                    }
                                                ],
                                                "kind": "FragmentSpread",
                                                "name": "IssueRow_fieldSets"
                                            },
                                            v16 /*: any*/ 
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.issueByKey.fieldSetsById"
                                },
                                {
                                    "condition": "shouldQueryFieldsByIdOrAlias",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v17 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "fieldsByIdOrAlias",
                                            "plural": true,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusField"
                                                },
                                                v23 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v24 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "fieldOption",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraSingleSelectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraSprintConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedSprintsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprint",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v28 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "selectedSprintsConnection(first:1)"
                                                        }
                                                    ],
                                                    "type": "JiraSprintField"
                                                },
                                                v30 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "selectedOption",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraRadioSelectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v32 /*: any*/ ,
                                                    "type": "JiraMultipleSelectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v32 /*: any*/ ,
                                                    "type": "JiraCheckboxesField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedVersionsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersion",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": v34 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraMultipleVersionPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersion",
                                                            "kind": "LinkedField",
                                                            "name": "version",
                                                            "plural": false,
                                                            "selections": v34 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraSingleVersionPickerField"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v35 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v8 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v10 /*: any*/ ,
                v1 /*: any*/ ,
                v9 /*: any*/ ,
                v11 /*: any*/ ,
                v3 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "useIssueFetchAndAppendQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v12 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v18 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraIssueFieldSetConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldSetsById",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldSetEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSet",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v36 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldSetId"
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fields",
                                                            "plural": false,
                                                            "selections": [
                                                                v37 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v38 /*: any*/ ,
                                                                                v18 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v36 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isJiraIssueField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraAffectedServiceConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedAffectedServicesConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedService",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "serviceId"
                                                                                                                },
                                                                                                                v21 /*: any*/ ,
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraAffectedServicesField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraCascadingOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "cascadingOption",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentOptionValue",
                                                                                                    "plural": false,
                                                                                                    "selections": v40 /*: any*/ 
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "childOptionValue",
                                                                                                    "plural": false,
                                                                                                    "selections": v40 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraCascadingSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCmdbObjectConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedCmdbObjectsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "objectId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "label"
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "mediaClientConfig",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "clientId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "fileId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "mediaBaseUrl"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "mediaJwtToken"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "url48"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "QueryError",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "errors",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "message"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraCMDBField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "args": v42 /*: any*/ ,
                                                                                            "concreteType": "JiraComponentConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedComponentsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponent",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v43 /*: any*/ ,
                                                                                                                v44 /*: any*/ ,
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraComponentsField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v45 /*: any*/ ,
                                                                                        v21 /*: any*/ ,
                                                                                        v46 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDatePickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "dateTime"
                                                                                        },
                                                                                        v21 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDateTimePickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraEpic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "epic",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v13 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "summary"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "color"
                                                                                                },
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraEpicLinkField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "renderedFieldHtml"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraFallbackField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v47 /*: any*/ ,
                                                                                        v21 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraSingleLineTextField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraStatusCategory",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "statusCategory",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v48 /*: any*/ ,
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusCategoryField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v20 /*: any*/ ,
                                                                                                v49 /*: any*/ ,
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "args": v42 /*: any*/ ,
                                                                                            "concreteType": "JiraLabelConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedLabelsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraLabelEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraLabel",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v21 /*: any*/ ,
                                                                                                                v50 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                        },
                                                                                        v21 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraLabelsField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAvatar",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "avatar",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "small"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v21 /*: any*/ ,
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "parentIssue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v13 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraColorField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueColorField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v50 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueTypeField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v51 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "summaryField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v47 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v38 /*: any*/ ,
                                                                                                v14 /*: any*/ ,
                                                                                                v52 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "ids",
                                                                                                                    "value": [
                                                                                                                        "issuetype",
                                                                                                                        "project",
                                                                                                                        "summary",
                                                                                                                        "status"
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldsById",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        v47 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issueType",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v38 /*: any*/ ,
                                                                                                                                                v53 /*: any*/ ,
                                                                                                                                                v21 /*: any*/ ,
                                                                                                                                                v51 /*: any*/ ,
                                                                                                                                                v54 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "status",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v38 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "statusCategory",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v38 /*: any*/ ,
                                                                                                                                                        v48 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraStatusField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueTypeField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v53 /*: any*/ ,
                                                                                                                        v54 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraSingleLineTextField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "summaryField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v19 /*: any*/ ,
                                                                                                                v55 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v21 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraParentIssueField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraPriority",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "priority",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v21 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraPriorityField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraProject",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "project",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v13 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraAvatar",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "avatar",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "large"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraResolution",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "resolution",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraResolutionField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraSprintConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedSprintsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprint",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v28 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "state"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "endDate"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v21 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraSprintField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v21 /*: any*/ ,
                                                                                                v56 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v38 /*: any*/ ,
                                                                                                v24 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "TypeDiscriminator",
                                                                                                            "abstractKey": "__isUser"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": v58 /*: any*/ ,
                                                                                                            "type": "AppUser"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": v58 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "AppUser"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v46 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraRichText",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "richText",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraADF",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "adfValue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "condition": "isDensityFull",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "convertedPlainText",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "plainText"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "isDensityFull",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "json"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraRichTextField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraServiceManagementRequestType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "requestType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v51 /*: any*/ ,
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraServiceManagementRequestTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "args": v27 /*: any*/ ,
                                                                                            "concreteType": "JiraIssueLinkConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueLinkConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v13 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "args": [
                                                                                                                                {
                                                                                                                                    "kind": "Literal",
                                                                                                                                    "name": "ids",
                                                                                                                                    "value": [
                                                                                                                                        "statusCategory"
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "fieldsById",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "edges",
                                                                                                                                    "plural": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "node",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v18 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v49 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                                                },
                                                                                                                                                v38 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "isResolved"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v38 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v59 /*: any*/ ,
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "issueLinkConnection(first:1)"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueLinkField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isStoryPointField"
                                                                                        },
                                                                                        v29 /*: any*/ ,
                                                                                        v21 /*: any*/ ,
                                                                                        v41 /*: any*/ ,
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "formatConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "formatStyle"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "formatUnit"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraNumberField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCommentSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "commentSummary",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "canAddComment"
                                                                                                },
                                                                                                v37 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraCommentSummaryField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "uri"
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraUrlField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldOption",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v39 /*: any*/ ,
                                                                                                v50 /*: any*/ ,
                                                                                                v38 /*: any*/ ,
                                                                                                v25 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraSingleSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraOptionConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedOptions",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v39 /*: any*/ ,
                                                                                                                v25 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraMultipleSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraOptionConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedOptions",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v39 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraCheckboxesField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraUserConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedUsersConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v18 /*: any*/ ,
                                                                                                                v24 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                v56 /*: any*/ ,
                                                                                                                v38 /*: any*/ ,
                                                                                                                v57 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "email"
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "AtlassianAccountUser"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraTeamView",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedTeam",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "jiraSuppliedId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "jiraSuppliedName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraTeamViewField"
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "timeTrackingField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v41 /*: any*/ ,
                                                                                                                v60 /*: any*/ ,
                                                                                                                v61 /*: any*/ ,
                                                                                                                v19 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                v36 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "timeTrackingField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v60 /*: any*/ ,
                                                                                                                v61 /*: any*/ ,
                                                                                                                v38 /*: any*/ ,
                                                                                                                v19 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                v36 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedOption",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": "label",
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "value"
                                                                                                },
                                                                                                v38 /*: any*/ ,
                                                                                                v43 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraRadioSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "args": v42 /*: any*/ ,
                                                                                            "concreteType": "JiraVersionConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedVersionsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersion",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                v43 /*: any*/ ,
                                                                                                                v44 /*: any*/ ,
                                                                                                                v33 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        v63 /*: any*/ ,
                                                                                        {
                                                                                            "args": v42 /*: any*/ ,
                                                                                            "concreteType": "JiraGoalConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedGoals",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGoalEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGoal",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        v21 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "status"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v16 /*: any*/ 
                                                                                            ],
                                                                                            "storageKey": "selectedGoals(first:1000)"
                                                                                        },
                                                                                        v41 /*: any*/ ,
                                                                                        v16 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraGoalsField"
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v63 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isLinkEditable"
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraTownsquareProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "alias": "atlasProjectName",
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "name"
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": "atlasProjectKey",
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "key"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "privateProject"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "hasPermission"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isWorkspaceActive"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconName"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraTownsquareProjectField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "args": v42 /*: any*/ ,
                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "confluenceRemoteIssueLinks",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v64 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "pageContent",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v64 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraConfluencePageContentDetails"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v37 /*: any*/ 
                                                                                            ],
                                                                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraGroupConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedGroupsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGroupEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroup",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "groupId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraMultipleGroupPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraFlag",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "flag",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFlagged"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraFlagField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraWatch",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "watch",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "count"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isWatching"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraWatchesField"
                                                                                },
                                                                                {
                                                                                    "condition": "isLinkRelationshipFieldEnabled",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLink",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "direction"
                                                                                                        },
                                                                                                        v59 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "type",
                                                                                                            "plural": false,
                                                                                                            "selections": v62 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraIssueLinkRelationshipTypeField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "isTimelineEnabled",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": v69 /*: any*/ ,
                                                                                            "type": "JiraTimelineField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": v69 /*: any*/ ,
                                                                                            "type": "JiraAggregatedTimelineField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v16 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConditionalFormattingEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v42 /*: any*/ ,
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedComponentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "componentId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        v23 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "projectId"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        v71 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v53 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedValue",
                                                                                                    "plural": false,
                                                                                                    "selections": v72 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSelectableValueConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedValues",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSelectableValueEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v72 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectField"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ 
                                    ]
                                },
                                v38 /*: any*/ ,
                                {
                                    "condition": "shouldQueryFieldsByIdOrAlias",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v17 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "fieldsByIdOrAlias",
                                            "plural": true,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v21 /*: any*/ ,
                                                                v38 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraPriority",
                                                            "kind": "LinkedField",
                                                            "name": "priority",
                                                            "plural": false,
                                                            "selections": [
                                                                v22 /*: any*/ ,
                                                                v38 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraPriorityField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                v24 /*: any*/ ,
                                                                v38 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "fieldOption",
                                                            "plural": false,
                                                            "selections": v73 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraSingleSelectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraSprintConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedSprintsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprint",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v28 /*: any*/ ,
                                                                                v38 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "selectedSprintsConnection(first:1)"
                                                        }
                                                    ],
                                                    "type": "JiraSprintField"
                                                },
                                                v30 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "selectedOption",
                                                            "plural": false,
                                                            "selections": v73 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraRadioSelectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v74 /*: any*/ ,
                                                    "type": "JiraMultipleSelectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v74 /*: any*/ ,
                                                    "type": "JiraCheckboxesField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedVersionsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersion",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": v70 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraMultipleVersionPickerField"
                                                },
                                                v71 /*: any*/ ,
                                                v38 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v35 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "38796adbb7731403cfbc8d3b17fa7773fb7244ae07f0fbfdd659ba31c0707214",
            "metadata": {},
            "name": "useIssueFetchAndAppendQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": (0, $04qit.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $6AioA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": (0, $1fipb.default)
            }
        }
    };
}();
$364e4341df7caad6$var$node.hash = "92fe6d9520071592f5157038f57aedf9";
var $364e4341df7caad6$export$2e2bcd8739ae039 = $364e4341df7caad6$var$node;

});


parcelRegister("dhVsI", function(module, exports) {
$parcel$export(module.exports, "toIssueCreateInput", () => $9a20f8fc188f0eb6$export$8430ab93380b81ae);

var $16aVR = parcelRequire("16aVR");

var $57raR = parcelRequire("57raR");

var $4cTDP = parcelRequire("4cTDP");

var $8ntPR = parcelRequire("8ntPR");
const $9a20f8fc188f0eb6$var$mapContextualFieldDataToInput = (payload)=>{
    let rank;
    if (payload.rankBeforeIssueId) rank = {
        beforeIssueId: payload.rankBeforeIssueId
    };
    else if (payload.rankAfterIssueId) rank = {
        afterIssueId: payload.rankAfterIssueId
    };
    return {
        rank: rank
    };
};
const $9a20f8fc188f0eb6$var$generateRankInput = (payload)=>{
    if (payload.rankBeforeIssueId) return {
        beforeIssueId: payload.rankBeforeIssueId
    };
    if (payload.rankAfterIssueId) return {
        afterIssueId: payload.rankAfterIssueId
    };
    return undefined;
};
const $9a20f8fc188f0eb6$export$8430ab93380b81ae = ({ project: project, issueType: issueType, summary: summary, assignee: assignee, dueDate: dueDate }, contextualFields, groupContextFieldInput, isIssueRankingEnabled)=>{
    if (!summary.trim().length) return null;
    const input = {
        projectId: project.id,
        issueTypeId: issueType.id,
        fields: {
            singleLineTextFields: [
                {
                    fieldId: 'summary',
                    text: summary
                }
            ],
            ...contextualFields.parentIssueAri !== undefined && {
                parentField: {
                    issueId: contextualFields.parentIssueAri
                }
            },
            ...groupContextFieldInput && (0, $8ntPR.convertFieldToIssueCreateInput)(groupContextFieldInput),
            ...assignee && {
                singleSelectUserPickerFields: [
                    {
                        fieldId: 'assignee',
                        user: {
                            accountId: assignee.accountId
                        }
                    }
                ]
            },
            ...dueDate && {
                datePickerFields: [
                    {
                        fieldId: 'duedate',
                        date: {
                            formattedDate: (0, $57raR.default)(dueDate, 'dd/MMM/yy')
                        }
                    }
                ]
            }
        },
        rank: isIssueRankingEnabled && (0, $4cTDP.fg)('jsc_list_reranking_gate') ? $9a20f8fc188f0eb6$var$generateRankInput(contextualFields) : undefined
    };
    if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) return input;
    return (0, (/*@__PURE__*/$parcel$interopDefault($16aVR)))(input, $9a20f8fc188f0eb6$var$mapContextualFieldDataToInput(contextualFields), (objValue, srcValue)=>{
        if (Array.isArray(objValue)) return objValue.concat(srcValue);
    });
};

});

parcelRegister("4uses", function(module, exports) {
$parcel$export(module.exports, "toOptimisticResponse", () => $9e8fadc0c70ba0f6$export$79353fa5e28d43d8);

var $57raR = parcelRequire("57raR");

var $4cTDP = parcelRequire("4cTDP");

var $8ntPR = parcelRequire("8ntPR");
const $9e8fadc0c70ba0f6$export$79353fa5e28d43d8 = ({ project: project, issueType: issueType, summary: summary, assignee: assignee, dueDate: dueDate }, optimisticId, isIssueHierarchyEnabled, groupContextFieldInput)=>{
    const issueId = optimisticId;
    const summaryEdge = summary ? $9e8fadc0c70ba0f6$var$toOptimisticSummary(issueId, summary) : null;
    const projectEdge = project ? $9e8fadc0c70ba0f6$var$toOptimisticProject(issueId, project) : null;
    const issueTypeEdge = issueType ? $9e8fadc0c70ba0f6$var$toOptimisticIssueType(issueId, issueType) : null;
    const assigneeEdge = assignee ? $9e8fadc0c70ba0f6$var$toOptimisticAssignee(issueId, assignee) : null;
    const dueDateEdge = dueDate ? $9e8fadc0c70ba0f6$var$toOptimisticDueDate(issueId, dueDate) : null;
    const edges = [
        summaryEdge,
        projectEdge,
        issueTypeEdge,
        assigneeEdge,
        dueDateEdge
    ].filter((edge)=>edge !== null);
    if (groupContextFieldInput) {
        if (groupContextFieldInput.fieldId !== 'assignee' || assigneeEdge === null) {
            const groupContextFieldEdge = (0, $8ntPR.toOptimisticField)(issueId, groupContextFieldInput);
            // @ts-expect-error - TS2345 Typescript 5.9.2 upgrade
            edges.push(groupContextFieldEdge);
        }
    }
    return {
        jira: {
            createIssue: {
                errors: null,
                issue: {
                    __typename: 'JiraIssue',
                    id: issueId,
                    issueId: issueId,
                    key: '',
                    fieldsByIdOrAlias: [],
                    fieldSetsById: {
                        edges: edges
                    },
                    matchesIssueSearch: undefined,
                    ...isIssueHierarchyEnabled ? {
                        issueTypeField: {
                            issueType: {
                                hierarchy: {
                                    level: issueType?.hierarchy?.level
                                },
                                id: issueType?.id
                            },
                            id: ''
                        },
                        canHaveChildIssues: false
                    } : {
                        issueTypeField: undefined,
                        canHaveChildIssues: undefined
                    }
                }
            }
        }
    };
};
const $9e8fadc0c70ba0f6$var$toOptimisticSummary = (issueId, summary)=>({
        node: {
            fieldSetId: 'summary',
            type: 'summary',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSingleLineTextField',
                            __isJiraIssueField: 'JiraSingleLineTextField',
                            fieldId: 'summary',
                            id: `${issueId}/summary`,
                            name: 'Summary',
                            text: summary,
                            type: 'summary',
                            lazyIsEditableInIssueView: undefined
                        }
                    }
                ]
            }
        }
    });
const $9e8fadc0c70ba0f6$var$toOptimisticIssueType = (issueId, issueType)=>({
        node: {
            fieldSetId: 'issuetype',
            type: 'issuetype',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraIssueTypeField',
                            __isJiraIssueField: 'JiraIssueTypeField',
                            fieldId: 'issuetype',
                            id: `${issueId}/issuetype`,
                            type: 'issuetype',
                            issueType: {
                                id: issueType.id,
                                ...(0, $4cTDP.fg)('jira_list_conditional_formatting') && {
                                    issueTypeId: issueType.issueTypeId
                                },
                                name: issueType.name,
                                avatar: issueType.avatar
                            }
                        }
                    }
                ]
            }
        }
    });
const $9e8fadc0c70ba0f6$var$toOptimisticProject = (issueId, project)=>({
        node: {
            fieldSetId: 'project',
            type: 'project',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraProjectField',
                            __isJiraIssueField: 'JiraProjectField',
                            fieldId: 'project',
                            id: `${issueId}/project`,
                            type: 'project',
                            project: {
                                id: project.id,
                                ...(0, $4cTDP.fg)('jira_list_conditional_formatting') && {
                                    projectId: project.projectId
                                },
                                key: project.key,
                                name: project.name,
                                avatar: project.avatar
                            }
                        }
                    }
                ]
            }
        }
    });
const $9e8fadc0c70ba0f6$var$toOptimisticAssignee = (issueId, { accountId: accountId, name: name, picture: picture })=>({
        node: {
            fieldSetId: 'assignee',
            type: 'assignee',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSingleSelectUserPickerField',
                            __isJiraIssueField: 'JiraSingleSelectUserPickerField',
                            fieldId: 'assignee',
                            id: `${issueId}/assignee`,
                            type: 'assignee',
                            name: 'Assignee',
                            user: {
                                id: accountId,
                                accountId: accountId,
                                name: name,
                                picture: picture,
                                accountStatus: 'active',
                                __typename: 'AtlassianAccountUser',
                                __isUser: 'AtlassianAccountUser'
                            }
                        }
                    }
                ]
            }
        }
    });
const $9e8fadc0c70ba0f6$var$toOptimisticDueDate = (issueId, dueDate)=>({
        node: {
            fieldSetId: 'duedate',
            type: 'duedate',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraDatePickerField',
                            __isJiraIssueField: 'JiraDatePickerField',
                            fieldId: 'duedate',
                            id: `${issueId}/duedate`,
                            type: 'duedate',
                            date: (0, $57raR.default)(dueDate, 'yyyy-MM-dd'),
                            name: 'Due Date',
                            fieldConfig: {
                                isRequired: false
                            }
                        }
                    }
                ]
            }
        }
    });

});

parcelRegister("5hgjg", function(module, exports) {
$parcel$export(module.exports, "useOptimisticId", () => $0e6eea24f2449862$export$753dc4430b354b6a);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");
const $0e6eea24f2449862$export$753dc4430b354b6a = ()=>{
    const optimisticIDtoReal = (0, $eJOHy.useRef)(new Map());
    const generateOptimisticId = (0, $eJOHy.useCallback)(()=>{
        const id = (0, $aXKmr.v4)();
        optimisticIDtoReal.current.set(id, undefined);
        return {
            id: id,
            saveRealId: (realId)=>{
                optimisticIDtoReal.current.set(id, realId);
            }
        };
    }, []);
    const getRealId = (0, $eJOHy.useCallback)((optimisticId)=>{
        return optimisticIDtoReal.current.get(optimisticId);
    }, []);
    return {
        generateOptimisticId: generateOptimisticId,
        getRealId: getRealId
    };
};

});



parcelRegister("lfz0B", function(module, exports) {
$parcel$export(module.exports, "PaginationControls", () => $389cf10d7be3e2cb$export$ff17519edeb6015d);

var $7PoAk = parcelRequire("7PoAk");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $b3eVo = parcelRequire("b3eVo");

var $k71qx = parcelRequire("k71qx");

var $3LCex = parcelRequire("3LCex");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $21Au6 = parcelRequire("21Au6");
const $389cf10d7be3e2cb$var$getFirstPage = (data)=>{
    if (data?.pageCursors?.first) return data?.pageCursors.first.pageNumber;
    if (data?.pageCursors?.around?.length) return data?.pageCursors.around[0]?.pageNumber;
    return undefined;
};
const $389cf10d7be3e2cb$var$getLastPage = (data)=>{
    if (data?.pageCursors?.last) return data?.pageCursors.last.pageNumber;
    if (data?.pageCursors?.around?.length) return data?.pageCursors.around[data?.pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $389cf10d7be3e2cb$var$getPageCursor = (data, page)=>{
    const { first: first, last: last, around: around } = data?.pageCursors ?? {};
    if (page === first?.pageNumber) return first?.cursor ?? undefined;
    if (page === last?.pageNumber) return last?.cursor ?? undefined;
    return around?.find((pageCursor)=>page === pageCursor?.pageNumber)?.cursor ?? undefined;
};
const $389cf10d7be3e2cb$export$ff17519edeb6015d = ({ issues: issues, onPageChange: onPageChange, isNewFooterOrderEnabled: isNewFooterOrderEnabled })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $7PoAk.default), issues);
    const [optimisticCurrentPage, setOptimisticCurrentPage] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        // Clear our optimistically set page number whenever fragment data changes.
        setOptimisticCurrentPage(null);
    }, [
        data
    ]);
    const pages = (0, $eJOHy.useMemo)(()=>{
        const firstPage = $389cf10d7be3e2cb$var$getFirstPage(data) ?? 1;
        const lastPage = $389cf10d7be3e2cb$var$getLastPage(data) ?? 1;
        return Array(lastPage - firstPage + 1).fill(undefined).map((_, i)=>firstPage + i);
    }, [
        data
    ]);
    const currentPage = optimisticCurrentPage ?? data?.pageCursors?.around?.find((pageCursor)=>pageCursor?.isCurrent)?.pageNumber ?? 1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onChange = (0, $eJOHy.useCallback)((_, page)=>{
        if (page === currentPage || optimisticCurrentPage !== null) return;
        const pageCursorToFetch = $389cf10d7be3e2cb$var$getPageCursor(data, page);
        if (pageCursorToFetch != null) {
            setOptimisticCurrentPage(page);
            onPageChange(pageCursorToFetch);
            const attributes = {
                currentPage: currentPage,
                nextPage: page,
                randomAccess: Math.abs(page - currentPage) > 1,
                isLastPage: page === pages.length
            };
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'pageNumber'
            }), 'issueTablePagination', attributes);
        }
    }, [
        createAnalyticsEvent,
        currentPage,
        data,
        onPageChange,
        optimisticCurrentPage,
        pages.length
    ]); // Disable the pagination buttons while the selected page is optimistically rendered as we may not have page cursors
    // readily available for pages rendered on the UI.
    const OptimisticDisabledButtonRenderer = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ 'aria-label': ariaLabel, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("button", {
            ref: ref,
            ...props,
            "aria-label": !ariaLabel && props.page ? formatMessage((0, $21Au6.default).pageButtonPrefix, {
                page: props.page
            }) : ariaLabel,
            disabled: props.disabled || optimisticCurrentPage !== null
        }), [
        formatMessage,
        optimisticCurrentPage
    ]);
    const OptimisticDisabledButtonRendererWithTooltip = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ 'aria-label': ariaLabel, ...props }, ref)=>props.disabled && optimisticCurrentPage == null && data?.isCappingIssueSearchResult ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $21Au6.default).disabledButtonTooltipIssueTermRefresh : (0, $21Au6.default).disabledButtonTooltip),
            position: "top-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($389cf10d7be3e2cb$var$FullHeightDisabledButton, {
            tabIndex: 0,
            isDisabled: true,
            "aria-label": formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $21Au6.default).disabledButtonTooltipIssueTermRefresh : (0, $21Au6.default).disabledButtonTooltip),
            "data-testid": "native-issue-table.ui.footer-renderer.pagination-controls.full-height-disabled-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("button", {
            ref: ref,
            ...props,
            "aria-label": ariaLabel
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("button", {
            ref: ref,
            ...props,
            "aria-label": ariaLabel,
            disabled: props.disabled || optimisticCurrentPage !== null
        }), [
        optimisticCurrentPage,
        data?.isCappingIssueSearchResult,
        formatMessage
    ]);
    const components = (0, $eJOHy.useMemo)(()=>{
        const OptimisticDisabledButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(OptimisticDisabledButtonRenderer);
        const OptimisticDisabledButtonWithTooltip = /*#__PURE__*/ (0, $eJOHy.forwardRef)(OptimisticDisabledButtonRendererWithTooltip);
        return {
            Page: OptimisticDisabledButton,
            Previous: OptimisticDisabledButton,
            Next: OptimisticDisabledButtonWithTooltip
        };
    }, [
        OptimisticDisabledButtonRenderer,
        OptimisticDisabledButtonRendererWithTooltip
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($389cf10d7be3e2cb$var$PaginationContainer, {
        isFlexCenter: isNewFooterOrderEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b3eVo.default), {
        testId: "native-issue-table.ui.footer-renderer.pagination-controls.pagination-controls",
        components: components,
        pages: pages,
        onChange: onChange,
        selectedIndex: currentPage - 1,
        max: 7,
        nextLabel: formatMessage((0, $21Au6.default).nextButton),
        previousLabel: formatMessage((0, $21Au6.default).prevButton)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $389cf10d7be3e2cb$var$FullHeightDisabledButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $3LCex.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $389cf10d7be3e2cb$var$PaginationContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexCenter: isFlexCenter, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o",
            __cmplp.isFlexCenter ? "_1bah1h6o" : "_1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7PoAk", function(module, exports) {
$parcel$export(module.exports, "default", () => $b05a83f2e24adcbe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<060fb173eea287115e5bcf553d9d303f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b05a83f2e24adcbe$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "pageSize"
            }
        ],
        "kind": "Fragment",
        "name": "PaginationControls",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isCappingIssueSearchResult"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    },
                    {
                        "kind": "Variable",
                        "name": "pageSize",
                        "variableName": "pageSize"
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "first",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$b05a83f2e24adcbe$var$node.hash = "8b100d40eebaedba37160add53361a22";
var $b05a83f2e24adcbe$export$2e2bcd8739ae039 = $b05a83f2e24adcbe$var$node;

});

parcelRegister("b3eVo", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e9938bbbd4852c0$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $7O2l7 = parcelRequire("7O2l7");

var $a2JSB = parcelRequire("a2JSB");

var $1kTzc = parcelRequire("1kTzc");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $2xCo3 = parcelRequire("2xCo3");

var $6CP4r = parcelRequire("6CP4r");

var $3IiVn = parcelRequire("3IiVn");

var $1CN10 = parcelRequire("1CN10");

var $1hfAD = parcelRequire("1hfAD");
const $2e9938bbbd4852c0$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $2e9938bbbd4852c0$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $2e9938bbbd4852c0$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($a2JSB))) : (0, (/*@__PURE__*/$parcel$interopDefault($1kTzc)));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $2e9938bbbd4852c0$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor",
            size: "small"
        })
    });
}
function $2e9938bbbd4852c0$var$InnerPagination({ components: components = (0, $1CN10.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1CN10.emptyObject), max: max = 7, onChange: onChange = (0, $3Vuhz.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $3IiVn.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $7O2l7.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$2e9938bbbd4852c0$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
            as: "li",
            xcss: $2e9938bbbd4852c0$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6CP4r.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $2e9938bbbd4852c0$var$styles.paginationMenu,
                    children: (0, $1hfAD.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $2e9938bbbd4852c0$var$Pagination = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)($2e9938bbbd4852c0$var$InnerPagination));
var $2e9938bbbd4852c0$export$2e2bcd8739ae039 = $2e9938bbbd4852c0$var$Pagination;

});
parcelRegister("2xCo3", function(module, exports) {
$parcel$export(module.exports, "default", () => $390a465a7b875c7d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $390a465a7b875c7d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("6CP4r", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7a0738c73e50f62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $a7a0738c73e50f62$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("3IiVn", function(module, exports) {
$parcel$export(module.exports, "default", () => $eee95bde3b212432$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $6fs4r = parcelRequire("6fs4r");
const $eee95bde3b212432$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $eee95bde3b212432$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "li",
        testId: testId,
        xcss: $eee95bde3b212432$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3cMgR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6fs4r.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("1CN10", function(module, exports) {
$parcel$export(module.exports, "emptyObject", () => $1b85b3c8ab534085$export$3f860eba1218f8d3);
const $1b85b3c8ab534085$export$3f860eba1218f8d3 = {};

});

parcelRegister("1hfAD", function(module, exports) {
$parcel$export(module.exports, "default", () => $916df7f6e7c50105$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $916df7f6e7c50105$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $LFmXM.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $916df7f6e7c50105$export$2e2bcd8739ae039 = $916df7f6e7c50105$var$collapseRange;

});


parcelRegister("3LCex", function(module, exports) {
$parcel$export(module.exports, "default", () => $0be296db7657e907$export$2e2bcd8739ae039);

var $cdbP5 = parcelRequire("cdbP5");
/**
 * When the @atlaskit/button component is disabled it prevents mouse events being fired for the button, which prevents
 * tooltips showing https://atlassian.design/components/button/usage#disabled-buttons.
 * When you require a disabled button to show a tooltip on hover then the button should be wrapped in this element.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0be296db7657e907$var$DisabledButtonWithTooltip = /*#__PURE__*/ (0, $cdbP5.default).span.withConfig({
    componentId: "yhjexx-0"
})({
    display: 'inline-flex'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isDisabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $cdbP5.css)({
        cursor: 'not-allowed',
        // Disable pointer events for the button element which means 'event.preventDefault()' will not be
        // called from AK. This allows pointer events to bubble from our wrapping span element.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> button': {
            pointerEvents: 'none'
        }
    }) : '');
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0be296db7657e907$export$2e2bcd8739ae039 = $0be296db7657e907$var$DisabledButtonWithTooltip;

});

parcelRegister("21Au6", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea084c23b4d940a9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ea084c23b4d940a9$var$messages = (0, $7qGN1.defineMessages)({
    nextButton: {
        "id": "native-issue-table.footer-renderer.pagination-controls.next-button",
        "defaultMessage": "Next page"
    },
    prevButton: {
        "id": "native-issue-table.footer-renderer.pagination-controls.prev-button",
        "defaultMessage": "Previous page"
    },
    pageButtonPrefix: {
        "id": "native-issue-table.footer-renderer.pagination-controls.page-button-prefix",
        "defaultMessage": "Page {page}"
    },
    disabledButtonTooltip: {
        "id": "native-issue-table.footer-renderer.pagination-controls.disabled-button-tooltip",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more issues."
    },
    disabledButtonTooltipIssueTermRefresh: {
        "id": "native-issue-table.footer-renderer.pagination-controls.disabled-button-tooltip-issue-term-refresh",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more work."
    }
});
var $ea084c23b4d940a9$export$2e2bcd8739ae039 = $ea084c23b4d940a9$var$messages;

});



parcelRegister("4aaY3", function(module, exports) {
$parcel$export(module.exports, "IssueFetchQueryVariables", () => $93e181c8fcc95804$export$2cef1066f7674208);

var $9BSmv = parcelRequire("9BSmv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5NEjg = parcelRequire("5NEjg");
const $93e181c8fcc95804$export$2cef1066f7674208 = ({ children: children, columns: columns })=>{
    const columnsData = (0, $j4oe4.useFragment)((0, $9BSmv.default), columns);
    const fieldSetIds = (0, $eJOHy.useMemo)(()=>columnsData.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        columnsData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5NEjg.IssueFetchQueryVariablesContainer), {
        fieldSetIds: fieldSetIds
    }, children);
};

});
parcelRegister("9BSmv", function(module, exports) {
$parcel$export(module.exports, "default", () => $362ccffcd8f97da4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d2cee26b7663287c8321469996d018f0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $362ccffcd8f97da4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueFetchQueryVariables",
    "selections": [
        {
            "concreteType": "JiraIssueSearchFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fieldSetId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueSearchFieldSetConnection"
};
$362ccffcd8f97da4$var$node.hash = "23fe80fc33e4a75a483fe224b74c4665";
var $362ccffcd8f97da4$export$2e2bcd8739ae039 = $362ccffcd8f97da4$var$node;

});


parcelRegister("aUa0f", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5cbb6ab0c87c7db$export$2e2bcd8739ae039);

var $lnYYP = parcelRequire("lnYYP");

var $5sAXj = parcelRequire("5sAXj");

var $atjPP = parcelRequire("atjPP");

var $kUlqv = parcelRequire("kUlqv");

var $4bj3W = parcelRequire("4bj3W");

var $4oZZX = parcelRequire("4oZZX");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $1jdzZ = parcelRequire("1jdzZ");

var $lRq8t = parcelRequire("lRq8t");

var $jBNts = parcelRequire("jBNts");

var $jE8Tu = parcelRequire("jE8Tu");

var $gM8ln = parcelRequire("gM8ln");

var $9RE4U = parcelRequire("9RE4U");

var $6TGzt = parcelRequire("6TGzt");

var $7n9BS = parcelRequire("7n9BS");

var $8jOO7 = parcelRequire("8jOO7");

var $hnyyS = parcelRequire("hnyyS");

var $34oCh = parcelRequire("34oCh");

var $Kdcei = parcelRequire("Kdcei");

var $pZqvR = parcelRequire("pZqvR");

var $hHg7L = parcelRequire("hHg7L");

var $9r0oq = parcelRequire("9r0oq");

var $f8QUz = parcelRequire("f8QUz");

var $d2QWN = parcelRequire("d2QWN");

var $eI4dM = parcelRequire("eI4dM");

var $l00LF = parcelRequire("l00LF");

var $kaSuB = parcelRequire("kaSuB");

var $l7U99 = parcelRequire("l7U99");

var $7WpdI = parcelRequire("7WpdI");

var $kmVLU = parcelRequire("kmVLU");
const $f5cbb6ab0c87c7db$var$emptyArray = []; // We use rowsCount=50 by default to set the minimum table height until virtualizer reads it from DOM
const $f5cbb6ab0c87c7db$var$getInitialTableHeight = (rowsCount = 50)=>(0, $8jOO7.ROW_HEIGHT) * rowsCount + (0, $8jOO7.HEADER_HEIGHT);
const $f5cbb6ab0c87c7db$var$IssueTable = ({ view: view, columnPickerProps: columnPickerProps, columns: columns, NoIssues: NoIssues, canViewColumnConfiguration: canViewColumnConfiguration, canEditColumnConfiguration: canEditColumnConfiguration, issueResults: issueResults, groupResults: groupResults, project: project, rankField: rankField, loading: loading, NoColumns: NoColumns, onColumnsChange: onColumnsChange, onResizeColumn: onResizeColumn, onFreezeColumn: onFreezeColumn, tableInjectedProps: tableInjectedProps, tableRef: tableRef, isGroupingSupported: isGroupingSupported, isCompactColumnEnabled: isCompactColumnEnabled = false, onIssueFlatListUpdated: onIssueFlatListUpdated, tableBorderRadius: tableBorderRadius, ifcConfig: ifcConfig, columnsQueryRef: columnsQueryRef, enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn, isDraggingRowFaded: isDraggingRowFaded, mergedColumnMinWidth: mergedColumnMinWidth, tableRole: tableRole, formattingRules: formattingRules, rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields, resizeHandleType: resizeHandleType, topLevelIssueCreateConfig: topLevelIssueCreateConfig, initialPopulateConnectionArgs: initialPopulateConnectionArgs })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [resizingColumnIndex, setResizingColumnIndex] = (0, $eJOHy.useState)();
    const isConditionalFormattingEnabled = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4cTDP.fg)('jira_list_conditional_formatting') && (0, $34oCh.useIsConditionalFormattingEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const timelineCustomComponents = (0, $9r0oq.useTimelineCustomComponents)();
    const InitializeVirtualizer = timelineCustomComponents?.InitializeVirtualizer ?? ((0, $4cTDP.fg)('jira_list_reduce_re_renders') ? (0, $kmVLU.InitializeVirtualizer) : (0, $7WpdI.InitializeVirtualizer));
    const viewData = (0, $j4oe4.useFragment)((0, $4oZZX.default), view ?? null);
    const issueResultsData = (0, $j4oe4.useFragment)((0, $4bj3W.default), issueResults);
    const groupResultsData = (0, $j4oe4.useFragment)((0, $kUlqv.default), groupResults);
    const projectData = (0, $j4oe4.useFragment)((0, $atjPP.default), project);
    const formattingRulesData = (0, $j4oe4.useFragment)((0, $5sAXj.default), formattingRules);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $lnYYP.default), rankField);
    let flatList = $f5cbb6ab0c87c7db$var$emptyArray;
    if (!(0, $4cTDP.fg)('jira_list_reduce_re_renders')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        flatList = (0, $jE8Tu.useFlatList)(); // eslint-disable-next-line react-hooks/rules-of-hooks
        const flatListIssueKeys = (0, $jE8Tu.useFlatListIssueKeys)(); // eslint-disable-next-line react-hooks/rules-of-hooks
        const flatListIssueIds = (0, $jE8Tu.useIssueIds)();
        const flatListChildIssueIds = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $jE8Tu.useChildIssueIds)() : []; // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eJOHy.useEffect)(()=>{
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            onIssueFlatListUpdated?.(flatListIssueKeys.filter(Boolean), flatListIssueIds, flatListChildIssueIds);
        }, [
            flatList,
            flatListIssueIds,
            flatListIssueKeys,
            onIssueFlatListUpdated,
            flatListChildIssueIds
        ]);
    } // initialFlatList is currently only guaranteed to keep virtualiser props stable while flatList is empty
    // If flatList is no longer empty, initialFlatList should be ignored
    const initialFlatList = (0, $eJOHy.useMemo)(()=>{
        if (!(flatList?.length <= 0 && (0, $4cTDP.fg)('mimic_flatlist_rss_while_uninitialised'))) return [];
        if (issueResultsData && issueResultsData.edges) return issueResultsData.edges.map((edge)=>edge?.node?.issueId).filter(Boolean).map((issueId)=>(0, $jBNts.getFlatListKey)({
                itemId: issueId
            }));
        if (groupResultsData && groupResultsData.firstGroup && groupResultsData?.firstGroup?.id) {
            const firstGroupId = groupResultsData.firstGroup.id;
            return [
                (0, $jBNts.getFlatListKey)({
                    itemId: firstGroupId,
                    groupId: firstGroupId
                }),
                ...(groupResultsData.firstGroup.issues?.edges ?? []).map((edge)=>edge?.node?.issueId).filter(Boolean).map((issueId)=>(0, $jBNts.getFlatListKey)({
                        itemId: issueId,
                        groupId: firstGroupId
                    })),
                ...groupResultsData.firstGroup.issues?.pageInfo?.hasNextPage ? [
                    (0, $jBNts.getFlatListKey)({
                        itemId: (0, $jE8Tu.getShowMoreItemKey)(firstGroupId),
                        groupId: firstGroupId
                    })
                ] : [],
                ...(groupResultsData.edges ?? []).map((edge)=>edge?.node?.id).filter((id)=>id !== firstGroupId).filter(Boolean).map((id)=>(0, $jBNts.getFlatListKey)({
                        itemId: id,
                        groupId: id
                    }))
            ];
        }
        return [];
    }, [
        flatList?.length,
        groupResultsData,
        issueResultsData
    ]); // Represents a stable list of item keys between first render (i.e. flat list is empty) and after flat list has been initialised in RSS.
    const readyFlatList = flatList?.length === 0 && (0, $4cTDP.fg)('mimic_flatlist_rss_while_uninitialised') ? initialFlatList : flatList; /** @deprecated remove when jira_list_reduce_re_renders is cleaned up */ 
    const getItemKey = (0, $eJOHy.useCallback)((index)=>readyFlatList[index] ?? index, [
        readyFlatList
    ]); /** @deprecated remove when jira_list_reduce_re_renders is cleaned up */ 
    const totalSizeRef = (0, $eJOHy.useRef)($f5cbb6ab0c87c7db$var$getInitialTableHeight((0, $4cTDP.fg)('mimic_flatlist_rss_while_uninitialised') ? readyFlatList.length : issueResultsData?.edges?.length));
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const showNoIssues = issueResultsData && !issueResultsData.edges?.length;
    const showNoGroupingIssues = isGroupingSupported && groupResultsData && !groupResultsData.edges?.length;
    let isMergedColumnVisible = false;
    if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnVisible = (0, $34oCh.useIsMergedColumnVisible)();
    const showNoColumns = columns.filter((col)=>!(0, $8jOO7.ACTION_COLUMNS).includes(col.id)).length === 0 && !isMergedColumnVisible;
    const { getScrollInfo: getScrollInfo } = (0, $7n9BS.useScrollStateActions)();
    let isStickyColumnsVisible = false; // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $4cTDP.fg)('issue_table_frozen_columns') && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
    const modifier = (0, $eJOHy.useMemo)(()=>// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4cTDP.fg)('issue_table_frozen_columns') && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? (0, $6TGzt.getInlineEditModifier)({
            columns: columns,
            getScrollInfo: getScrollInfo,
            isStickyColumnsVisible: isStickyColumnsVisible
        }) : ()=>[], [
        columns,
        getScrollInfo,
        isStickyColumnsVisible
    ]);
    const isVirtualizationEnabled = (0, $34oCh.useIsVirtualizationEnabled)();
    const { handleMouseOver: handleMouseOver, handleMouseLeave: handleMouseLeave } = (0, $hHg7L.useEventDelegator)();
    const isPageHydrating = (0, $9RE4U.useIsHydrateRenderMode)();
    const displaySsrPlaceholderAttrs = (0, $9RE4U.useSsrPlaceholders)();
    const resizeHandler = resizeHandleType ?? (showNoIssues || showNoColumns ? (0, $8jOO7.COLUMN_RESIZE_HANDLE_HEADER_ONLY) : (0, $8jOO7.COLUMN_RESIZE_HANDLE_FULL_HEIGHT));
    const resizeHandlerOld = (showNoIssues || showNoColumns) && !isTimelineEnabled ? (0, $8jOO7.COLUMN_RESIZE_HANDLE_HEADER_ONLY) : (0, $8jOO7.COLUMN_RESIZE_HANDLE_FULL_HEIGHT);
    const tableHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $pZqvR.IFCConfigContextProviderComponent), {
        ifcConfig: ifcConfig,
        columns: columns,
        onColumnsChange: columnPickerProps?.onChange,
        queryRef: issueResultsData ?? null,
        columnsQueryRef: columnsQueryRef ?? null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2QWN.Header), {
        view: viewData,
        columnPickerProps: columnPickerProps,
        columns: columns,
        canViewColumnConfiguration: canViewColumnConfiguration,
        canEditColumnConfiguration: canEditColumnConfiguration,
        isCompactColumnEnabled: isCompactColumnEnabled,
        resizeHandleType: (0, $4cTDP.fg)('refactor_issue_table_for_timline') ? resizeHandler : resizeHandlerOld,
        onColumnsChange: onColumnsChange,
        onResizeColumn: onResizeColumn,
        onFreezeColumn: onFreezeColumn,
        tableRef: tableRef,
        tableBorderRadius: tableBorderRadius,
        showNoColumns: showNoColumns,
        ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
            resizingColumnIndex: resizingColumnIndex,
            setResizingColumnIndex: setResizingColumnIndex
        },
        enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn,
        mergedColumnMinWidth: mergedColumnMinWidth
    }));
    if (showNoIssues || showNoGroupingIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f5cbb6ab0c87c7db$export$36d41a08d3c6eb45, {
        isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
        "aria-label": formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eI4dM.default).issuesTableLabelIssueTermRefresh : (0, $eI4dM.default).issuesTableLabel),
        ref: tableRef
    }, tableHeader), !isTimelineEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kaSuB.default), {
        NoIssues: NoIssues,
        isLoading: loading
    }));
    if (showNoColumns) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, canViewColumnConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f5cbb6ab0c87c7db$export$36d41a08d3c6eb45, {
        isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
        "aria-label": formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eI4dM.default).issuesTableLabelIssueTermRefresh : (0, $eI4dM.default).issuesTableLabel),
        ref: tableRef
    }, tableHeader), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l00LF.default), {
        NoColumns: NoColumns,
        hasColumnConfiguration: canViewColumnConfiguration,
        isLoading: loading
    }));
    const renderTableBody = ()=>{
        if (isGroupingSupported && groupResultsData && !issueResultsData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f8QUz.default), {
            groupResults: groupResultsData,
            rankField: rankFieldData ?? null,
            columns: columns,
            tableInjectedProps: tableInjectedProps,
            project: projectData ?? null,
            loading: loading,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            formattingRules: formattingRulesData ?? null,
            rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
            ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
                resizingColumnIndex: resizingColumnIndex
            }
        });
        if (issueResultsData == null) return null;
        const tableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l7U99.default), {
            topLevelIssueCreateConfig: topLevelIssueCreateConfig,
            issueResults: issueResultsData,
            columns: columns,
            tableInjectedProps: tableInjectedProps,
            project: projectData ?? null,
            rankField: rankFieldData ?? null,
            isGroupingSupported: isGroupingSupported,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            isDraggingRowFaded: isDraggingRowFaded,
            formattingRules: formattingRulesData ?? null,
            ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
                resizingColumnIndex: resizingColumnIndex
            },
            rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
            initialPopulateConnectionArgs: initialPopulateConnectionArgs
        });
        return tableBody;
    };
    const renderTable = (style)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1jdzZ.EditViewPopupModifiersProvider), {
            modifiers: modifier
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f5cbb6ab0c87c7db$export$36d41a08d3c6eb45, {
            ...style ? {
                style: style
            } : {},
            role: (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting') ? tableRole : undefined,
            isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
            "aria-label": formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eI4dM.default).issuesTableLabelIssueTermRefresh : (0, $eI4dM.default).issuesTableLabel),
            ref: tableRef,
            "aria-rowcount": issueResultsData?.totalIssueSearchResultCount && issueResultsData?.totalIssueSearchResultCount > 0 ? issueResultsData?.totalIssueSearchResultCount : undefined,
            "data-vc": `issue-table${false && !isPageHydrating ? '-ssr' : ''}`,
            onMouseOver: handleMouseOver,
            onMouseLeave: handleMouseLeave,
            ...false && displaySsrPlaceholderAttrs && (0, $4cTDP.fg)('additional_nin_ssr_placeholders') && {
                'data-ssr-placeholder': 'issue-table-placeholder'
            },
            ...!false && displaySsrPlaceholderAttrs && (0, $4cTDP.fg)('additional_nin_ssr_placeholders') && {
                'data-ssr-placeholder-replace': 'issue-table-placeholder'
            }
        }, tableHeader, renderTableBody(), loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f5cbb6ab0c87c7db$var$TableFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", null, (0, $4cTDP.fg)('add_nin_press_interactions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hnyyS.Overlay), {
            interactionName: "issue-table-renderer-overlay"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hnyyS.OverlayOld), null)))) : null, isSingleLineRowHeightEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gM8ln.HoverPopoverWithDelegator), null)));
    }; /** @deprecated remove when jira_list_reduce_re_renders is cleaned up */ 
    // eslint-disable-next-line no-nested-ternary
    const rowsCount = (0, $4cTDP.fg)('mimic_flatlist_rss_while_uninitialised') ? readyFlatList.length : flatList?.length > 0 ? flatList?.length : issueResultsData?.edges?.length;
    if (isVirtualizationEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Kdcei.VirtualizationContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(InitializeVirtualizer, {
        rows: rowsCount ?? 0,
        getItemKey: getItemKey,
        totalSizeRef: totalSizeRef,
        issueResults: issueResultsData,
        groupResults: groupResultsData
    }), renderTable({
        width: '100%',
        position: 'relative'
    }));
    return renderTable();
};
var $f5cbb6ab0c87c7db$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f5cbb6ab0c87c7db$var$IssueTable;
const $f5cbb6ab0c87c7db$export$36d41a08d3c6eb45 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "table", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFixedTableLayoutEnabled: isFixedTableLayoutEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3it94y _kqswh2mm _yq5h18uv _btyzidpf",
            __cmplp.isFixedTableLayoutEnabled && "_1kqm1n9t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
const $f5cbb6ab0c87c7db$var$TableFooter = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "tfoot", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itglyw _p4liidpf _owipidpf _6autidpf _1pqwidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lnYYP", function(module, exports) {
$parcel$export(module.exports, "default", () => $b902de1fb90918ce$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4df7c297b49260138292153459fcd81d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b902de1fb90918ce$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueTable_rankField",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TableBody_rankField"
        },
        {
            "kind": "FragmentSpread",
            "name": "GroupTableBody_rankField"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$b902de1fb90918ce$var$node.hash = "27d4e25cfd3c3a4e630c5db59dd935a9";
var $b902de1fb90918ce$export$2e2bcd8739ae039 = $b902de1fb90918ce$var$node;

});

parcelRegister("5sAXj", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5972f94954da26d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0ef108bc27d4820650e1346e8894df8b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b5972f94954da26d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueTable_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "GroupTableBody_rules"
        },
        {
            "kind": "FragmentSpread",
            "name": "TableBody_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$b5972f94954da26d$var$node.hash = "d1ada0c226e54cad77408668ddb89aab";
var $b5972f94954da26d$export$2e2bcd8739ae039 = $b5972f94954da26d$var$node;

});

parcelRegister("atjPP", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c00937b75c5cdc6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6515383f83bf568fde7e7b1372a7cefd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2c00937b75c5cdc6$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "IssueTable_project",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "GroupTableBody_project"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "TableBody_project"
            }
        ],
        "type": "JiraProject"
    };
}();
$2c00937b75c5cdc6$var$node.hash = "1323da9301cd486842312425cd722a4f";
var $2c00937b75c5cdc6$export$2e2bcd8739ae039 = $2c00937b75c5cdc6$var$node;

});

parcelRegister("kUlqv", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a51e4a75862e47d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8f29bc5785a3bbe90288138c017484c5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4a51e4a75862e47d$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "Variable",
        "name": "viewConfigInput",
        "variableName": "viewConfigInput"
    }, v2 = {
        "kind": "Variable",
        "name": "isPaginating",
        "variableName": "isPaginating"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isEditableSyncLoaded"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isPaginating"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isRemoteLinkedIssuesEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "viewConfigInput"
            }
        ],
        "kind": "Fragment",
        "name": "IssueTable_spreadsheetGroupConnection",
        "selections": [
            {
                "concreteType": "JiraSpreadsheetGroupEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "isPaginating",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraSpreadsheetGroup",
                                "kind": "LinkedField",
                                "name": "firstGroup",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "fieldSetsInput",
                                                "variableName": "fieldSetsInput"
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 50
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "scope",
                                                "variableName": "fieldSetsScope"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "settings",
                                                "variableName": "settings"
                                            },
                                            v1 /*: any*/ 
                                        ],
                                        "concreteType": "JiraIssueConnection",
                                        "kind": "LinkedField",
                                        "name": "issues",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "issueId"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasNextPage"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isConditionalFormattingEnabled",
                        "variableName": "isConditionalFormattingEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isDensityFull",
                        "variableName": "isDensityFull"
                    },
                    {
                        "kind": "Variable",
                        "name": "isEditableSyncLoaded",
                        "variableName": "isEditableSyncLoaded"
                    },
                    {
                        "kind": "Variable",
                        "name": "isInlineEditingEnabled",
                        "variableName": "isInlineEditingEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isLinkRelationshipFieldEnabled",
                        "variableName": "isLinkRelationshipFieldEnabled"
                    },
                    v2 /*: any*/ ,
                    {
                        "kind": "Variable",
                        "name": "isRemoteLinkedIssuesEnabled",
                        "variableName": "isRemoteLinkedIssuesEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isTimelineEnabled",
                        "variableName": "isTimelineEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "projectKey",
                        "variableName": "projectKey"
                    },
                    {
                        "kind": "Variable",
                        "name": "projectKeys",
                        "variableName": "projectKeys"
                    },
                    v1 /*: any*/ 
                ],
                "kind": "FragmentSpread",
                "name": "GroupTableBody"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            v2 /*: any*/ 
                        ],
                        "kind": "FragmentSpread",
                        "name": "InitializeVirtualizer_groupResults"
                    }
                ]
            }
        ],
        "type": "JiraSpreadsheetGroupConnection"
    };
}();
$4a51e4a75862e47d$var$node.hash = "668e6a599d7fab184ae518f2e70cb08e";
var $4a51e4a75862e47d$export$2e2bcd8739ae039 = $4a51e4a75862e47d$var$node;

});

parcelRegister("4bj3W", function(module, exports) {
$parcel$export(module.exports, "default", () => $da4627444447d625$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ef4919e3be39b5edc08ad32530e4b422>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $da4627444447d625$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRemoteLinkedIssuesEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "IssueTable_issueConnection",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "issueId"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isEditableSyncLoaded",
                    "variableName": "isEditableSyncLoaded"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isRemoteLinkedIssuesEnabled",
                    "variableName": "isRemoteLinkedIssuesEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "TableBodyTableBody"
        },
        {
            "kind": "FragmentSpread",
            "name": "context_nativeIssueTable_IFCConfigContextProvider_queryRef"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "InitializeVirtualizer_issueResults"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$da4627444447d625$var$node.hash = "1c267ba2710d7daaa4f7653171cd4e32";
var $da4627444447d625$export$2e2bcd8739ae039 = $da4627444447d625$var$node;

});

parcelRegister("4oZZX", function(module, exports) {
$parcel$export(module.exports, "default", () => $a33cd0cea9645322$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3489699a2d3cfbd514f802edc141599f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a33cd0cea9645322$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueTableIssueTable",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "HeaderCellContainer"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$a33cd0cea9645322$var$node.hash = "4c9fad0b83db602b39e7619ec2ef4dfb";
var $a33cd0cea9645322$export$2e2bcd8739ae039 = $a33cd0cea9645322$var$node;

});

parcelRegister("1jdzZ", function(module, exports) {
$parcel$export(module.exports, "EditViewPopupModifiersProvider", () => $2eb28ffca848904a$export$7605340c70fd949e);
$parcel$export(module.exports, "useEditViewPopupModifiersContext", () => $2eb28ffca848904a$export$9e8df37d8f62801b);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $f2JN3 = parcelRequire("f2JN3");
const $2eb28ffca848904a$var$EditViewPopupModifiersContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $2eb28ffca848904a$var$EditViewPopupModifiersProviderBase = ({ children: children, modifiers: modifiers })=>{
    const contextValue = {
        modifiers: modifiers
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2eb28ffca848904a$var$EditViewPopupModifiersContext.Provider, {
        value: contextValue
    }, children);
};
const $2eb28ffca848904a$var$EditViewPopupModifiersProviderDisabled = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
const $2eb28ffca848904a$export$7605340c70fd949e = (0, $f2JN3.componentWithCondition)(// eslint-disable-next-line jira/ff/no-preconditioning
()=>(0, $4cTDP.fg)('issue_table_frozen_columns') && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix'), $2eb28ffca848904a$var$EditViewPopupModifiersProviderBase, $2eb28ffca848904a$var$EditViewPopupModifiersProviderDisabled);
const $2eb28ffca848904a$export$9e8df37d8f62801b = ()=>{
    const context = (0, $eJOHy.useContext)($2eb28ffca848904a$var$EditViewPopupModifiersContext);
    // Gracefully fallback to empty modifiers if no provider is rendered
    if (context === null) return [];
    return context?.modifiers() || [];
};

});

parcelRegister("gM8ln", function(module, exports) {
$parcel$export(module.exports, "HoverPopoverWithDelegator", () => $45aab2dddaf31bc3$export$9b1830049d07a4b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $67YQP = parcelRequire("67YQP");

var $8qmYl = parcelRequire("8qmYl");

var $5vQ2T = parcelRequire("5vQ2T");

var $4EKqI = parcelRequire("4EKqI");

var $bYhG9 = parcelRequire("bYhG9");


var $1VYeC = parcelRequire("1VYeC");
const $45aab2dddaf31bc3$export$9b1830049d07a4b = ()=>{
    const { hoverPopoverState: hoverPopoverState } = (0, $bYhG9.useHoverPopoverState)();
    const { isOpen: isOpen, content: content, contentElement: contentElement, alwaysShow: alwaysShow, cellRef: cellRef, onHoverOut: onHoverOut, shouldRenderToContent: shouldRenderToContent } = hoverPopoverState;
    const refToRenderTo = shouldRenderToContent ? contentElement : cellRef;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isOpen && refToRenderTo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $67YQP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "jira-list-hover-popover",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "jira-list-hover-popover",
        packageName: (0, $05f3bc586d738eb3$export$b8b9d90f9e5bd72b),
        teamName: (0, $05f3bc586d738eb3$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8qmYl.Popper), {
        placement: "bottom-start",
        referenceElement: refToRenderTo
    }, ({ ref: ref, style: style, update: update, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            ref: ref,
            // Style is required for react-popper to apply positioning correctly (allows it to render to parent)
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
            style: style,
            className: (0, $hcewu.default)([
                shouldRenderToContent && "_19pku2gc _18u0x0bf"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1VYeC.PopoverInternal), {
            content: content,
            contentElement: contentElement,
            onUpdate: update,
            isReferenceHidden: isReferenceHidden,
            alwaysShow: alwaysShow,
            onHoverOut: onHoverOut
        })))))));
};
const $45aab2dddaf31bc3$var$renderToContentStyles = null;

});
const $05f3bc586d738eb3$export$d57b6b390e78d90f = 'jira-yurree';
const $05f3bc586d738eb3$export$b8b9d90f9e5bd72b = '@atlassian/jira-hover-popover';

parcelRegister("1VYeC", function(module, exports) {
$parcel$export(module.exports, "PopoverInternal", () => $f2c475c7a9bd946f$export$681e33c5421549b0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9CHGV = parcelRequire("9CHGV");

var $hX7Ca = parcelRequire("hX7Ca");
const $f2c475c7a9bd946f$var$CELL_HOVER_DELAY = 200;
const $f2c475c7a9bd946f$export$681e33c5421549b0 = ({ content: content, contentElement: contentElement, onUpdate: onUpdate, isReferenceHidden: isReferenceHidden, alwaysShow: alwaysShow, onHoverOut: onHoverOut })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $eJOHy.useState)(false);
    const hoverTimeoutRef = (0, $eJOHy.useRef)(null);
    hoverTimeoutRef.current = setTimeout(()=>{
        if (alwaysShow) setIsPopupOpen(true);
        const elementWithTextContent = contentElement ? (0, $hX7Ca.getClosestTextElement)(contentElement) : undefined;
        const clientWidth = elementWithTextContent?.clientWidth || 0;
        const scrollWidth = elementWithTextContent?.scrollWidth || 0;
        const isClamped = (0, $hX7Ca.checkIsClamped)(elementWithTextContent);
        if (!contentElement || scrollWidth > clientWidth || isClamped) setIsPopupOpen(true);
    }, $f2c475c7a9bd946f$var$CELL_HOVER_DELAY);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
            if (onHoverOut) onHoverOut();
        };
    }, [
        onHoverOut
    ]);
    if (isPopupOpen && content && !isReferenceHidden) return /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            "_j7hq1ida _tzy4idpf _5sag1yx9 _1pgl1v42 _1o51q7pw _p12f1mjv _lcxvglyw"
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $9CHGV.PopupContent), {
        update: onUpdate
    }, content));
};
const $f2c475c7a9bd946f$var$fadeIn = null;
const $f2c475c7a9bd946f$var$containerStyles = null;

});
parcelRegister("9CHGV", function(module, exports) {
$parcel$export(module.exports, "PopupContent", () => $95ad311b87a00fc3$export$2a2c7ba12d3231e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $1OHZM = parcelRequire("1OHZM");

var $4B7rn = parcelRequire("4B7rn");
const $95ad311b87a00fc3$var$PopupContentComponent = ({ children: children, update: update, isInteractive: isInteractive, analyticsAttributes: analyticsAttributes })=>{
    const componentRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const mountTimeRef = (0, $eJOHy.useRef)(Date.now());
    (0, $1OHZM.useResizeObserver)({
        ref: componentRef,
        onResize: update
    });
    (0, $eJOHy.useEffect)(()=>{
        const mountTime = mountTimeRef.current;
        return ()=>{
            const duration = Date.now() - mountTime;
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'popup displayed', 'hoverPopover', {
                isInteractive: isInteractive,
                duration: duration,
                ...analyticsAttributes
            });
        };
    }, [
        createAnalyticsEvent,
        isInteractive,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        ref: componentRef,
        "data-testid": "hover-popover.ui.popup-content.hover-popover-content",
        "aria-hidden": !isInteractive,
        // eslint-disable-next-line @atlassian/a11y/no-noninteractive-tabindex
        tabIndex: isInteractive ? 0 : undefined,
        className: (0, $hcewu.default)([
            "_2rko12b0 _1reo1wug _18m91wug _18zrutpp _1rjc12x7 _bfhk1bhr _16qs130s _qv3h2smr _k48pi7a9 _1i4q1hna _c71l1mjv _1nmz1hna _y2mv7g83 _1bg4v77o"
        ])
    }, children, /*#__PURE__*/ $eJOHy.createElement((0, $4B7rn.default), null));
};
const $95ad311b87a00fc3$export$2a2c7ba12d3231e3 = /*#__PURE__*/ (0, $eJOHy.memo)($95ad311b87a00fc3$var$PopupContentComponent);
const $95ad311b87a00fc3$var$popoverStyles = null;

});
parcelRegister("1OHZM", function(module, exports) {
$parcel$export(module.exports, "createResizeObserverHook", () => $7c1c433db2df08f5$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $7c1c433db2df08f5$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $7c1c433db2df08f5$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $7c1c433db2df08f5$export$e58143dc89297272);

var $eJOHy = parcelRequire("eJOHy");

var $cOhmL = parcelRequire("cOhmL");
function $7c1c433db2df08f5$export$87a9d3e287304ae4(params) {
    const group = new (0, $cOhmL.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $eJOHy.useRef)(onResize);
        (0, $eJOHy.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $eJOHy.useCallback)(()=>onResizeRef.current(), []);
        (0, $eJOHy.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $7c1c433db2df08f5$export$683480f191c0e3ea, flushResizeObservers: $7c1c433db2df08f5$export$a181ef2a6d0a1bb6 } = $7c1c433db2df08f5$export$87a9d3e287304ae4();
function $7c1c433db2df08f5$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $7c1c433db2df08f5$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $eJOHy.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("cOhmL", function(module, exports) {
$parcel$export(module.exports, "ResizeObserverGroup", () => $4b26b203cb8a861d$export$607798bbe2869c0);

var $aQK2r = parcelRequire("aQK2r");

var $3s8bj = parcelRequire("3s8bj");
class $4b26b203cb8a861d$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $aQK2r.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});





parcelRegister("6TGzt", function(module, exports) {
$parcel$export(module.exports, "getInlineEditModifier", () => $f112f64b95db9ff9$export$aebe598173adea57);

var $8jOO7 = parcelRequire("8jOO7");

var $8FfYE = parcelRequire("8FfYE");
const $f112f64b95db9ff9$var$INLINE_EDIT_POPUP_SCROLL_MARGIN = 8;
const $f112f64b95db9ff9$var$isWithinStickyTableCell = (state)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const triggerEl = state.elements.reference;
    const closestTd = triggerEl.closest('td');
    // Check if the closest <td> element has an inline z-index style applied.
    // Frozen columns have a z-index, so if found, skip further handling
    // to avoid affecting frozen column inline edit behavior.
    if (closestTd) return globalThis.window.getComputedStyle(closestTd).position === 'sticky';
    return false;
};
const $f112f64b95db9ff9$export$aebe598173adea57 = ({ columns: columns, getScrollInfo: getScrollInfo, isStickyColumnsVisible: isStickyColumnsVisible })=>{
    const stickyColumnsWidth = (0, $8FfYE.calculateStickyColumnsWidth)(columns);
    return ()=>[
            {
                name: 'closeOnThreshold',
                enabled: true,
                phase: 'write',
                // When inline edit popup is open and the table is being scrolled,
                // hide the popup if it moves outside the table’s visible boundary.
                // No need to check popups from frozen columns.
                fn: ({ state: state })=>{
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const isSticky = $f112f64b95db9ff9$var$isWithinStickyTableCell(state);
                    if (isSticky) return;
                    const { scrollElement: scrollElement, isScrolling: isScrolling, isSmallScreen: isSmallScreen } = getScrollInfo();
                    const totalWidth = isStickyColumnsVisible && !isSmallScreen ? stickyColumnsWidth : 0;
                    const scrollRect = scrollElement?.getBoundingClientRect();
                    if (!scrollRect) return;
                    const referenceElementRect = state.elements.reference.getBoundingClientRect();
                    const shoudHide = referenceElementRect.left < scrollRect.left + totalWidth || referenceElementRect.top < scrollRect.top + (0, $8jOO7.HEADER_HEIGHT) || referenceElementRect.bottom > scrollRect.bottom;
                    if (shoudHide && isScrolling) // eslint-disable-next-line no-param-reassign
                    state.elements.popper.style.display = 'none';
                },
                // When the popup is closed and a field is partially hidden (behind merged columns),
                // auto-scroll the table to bring that field back into view.
                // No need to check popups from frozen columns.
                effect: ({ state: state })=>{
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const isSticky = $f112f64b95db9ff9$var$isWithinStickyTableCell(state);
                    if (isSticky) return;
                    const { scrollElement: scrollElement, isSmallScreen: isSmallScreen } = getScrollInfo();
                    const totalWidth = isStickyColumnsVisible && !isSmallScreen ? stickyColumnsWidth : 0;
                    const scrollRect = scrollElement?.getBoundingClientRect();
                    if (!scrollRect) return;
                    const referenceElementRect = state.elements.reference.getBoundingClientRect();
                    const isPartiallyHidden = referenceElementRect.left < scrollRect.left + totalWidth;
                    if (scrollElement && isPartiallyHidden && state.elements.popper.style.display !== 'none') {
                        // When clicking a partially hidden field, auto-scrolls it back into the table view
                        // and leaves an 8px margin on the left side of the field.
                        const scrollAmount = scrollRect.left + totalWidth - referenceElementRect.left + $f112f64b95db9ff9$var$INLINE_EDIT_POPUP_SCROLL_MARGIN;
                        scrollElement.scrollBy({
                            left: -scrollAmount,
                            behavior: 'auto'
                        });
                    }
                }
            }
        ];
};

});
parcelRegister("8FfYE", function(module, exports) {
$parcel$export(module.exports, "calculateStickyColumnsWidth", () => $e44637d13c1cefce$export$7a1e6dffa7beebd2);

var $j8Km1 = parcelRequire("j8Km1");

var $8jOO7 = parcelRequire("8jOO7");
const $e44637d13c1cefce$export$7a1e6dffa7beebd2 = (columns)=>{
    let totalWidth = 0;
    for (const column of columns){
        const { id: id, isColumnSticky: isColumnSticky, defaultWidth: defaultWidth, customWidth: customWidth } = column;
        if (id === (0, $j8Km1.COLUMN_ID_CHECKBOX) || id === (0, $j8Km1.COLUMN_ID_EXPAND_BUTTON) || id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) || isColumnSticky) {
            if (id === (0, $j8Km1.COLUMN_ID_EXPAND_BUTTON)) totalWidth += defaultWidth + (0, $8jOO7.EXPAND_CELL_PADDING);
            else totalWidth += customWidth ?? defaultWidth;
        } else break;
    }
    return totalWidth;
};

});


parcelRegister("hnyyS", function(module, exports) {
$parcel$export(module.exports, "Overlay", () => $2263ce5e083f2a0f$export$c6fdb837b070b4ff);
$parcel$export(module.exports, "OverlayOld", () => $2263ce5e083f2a0f$export$3dff7b29487a2410);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dLR8J = parcelRequire("dLR8J");

var $bJscI = parcelRequire("bJscI");
const $2263ce5e083f2a0f$export$c6fdb837b070b4ff = ({ interactionName: interactionName })=>{
    return(// We are intentionally ignoring jira/ufo/valid-labels because we have a valid use case
    // for an encapsulated generic component, similar to generic AK components.
    // eslint-disable-next-line jira/ufo/valid-labels
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: interactionName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2263ce5e083f2a0f$var$StyledOverlay, null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $2263ce5e083f2a0f$var$StyledOverlayOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _bfhk1dpa _tzy4txnc _1sb2b3bt",
            __cmplp.className
        ])
    });
});
const $2263ce5e083f2a0f$var$StyledOverlayNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _bfhk1dpa _tzy4txnc _1sb2b3bt _1pby37uc",
            __cmplp.className
        ])
    });
});
const $2263ce5e083f2a0f$var$StyledOverlay = (0, $bJscI.componentWithFG)('issue_table_frozen_columns', $2263ce5e083f2a0f$var$StyledOverlayNew, $2263ce5e083f2a0f$var$StyledOverlayOld);
const $2263ce5e083f2a0f$export$3dff7b29487a2410 = $2263ce5e083f2a0f$var$StyledOverlay;

});

parcelRegister("Kdcei", function(module, exports) {
$parcel$export(module.exports, "VirtualizationContainer", () => $29e00bcf5213eb76$export$6f4d8b0593660d4a);
$parcel$export(module.exports, "useVirtualizationActions", () => $29e00bcf5213eb76$export$2d20df04c90a6b4d);
$parcel$export(module.exports, "useVirtualization", () => $29e00bcf5213eb76$export$8c88e6c844ce8aa0);
$parcel$export(module.exports, "useVirtualItemsMap", () => $29e00bcf5213eb76$export$48859eaeca922cb5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $29e00bcf5213eb76$var$initialState = {
    virtualizer: null,
    virtualItemsMap: {}
};
const $29e00bcf5213eb76$var$actions = {
    setVirtualizer: (virtualizer)=>({ setState: setState })=>{
            setState({
                virtualizer: virtualizer
            });
        },
    setVirtualItemsMap: (virtualItemsMap)=>({ setState: setState })=>{
            setState({
                virtualItemsMap: virtualItemsMap
            });
        }
};
const $29e00bcf5213eb76$export$6f4d8b0593660d4a = (0, $6E16M.createContainer)();
const $29e00bcf5213eb76$var$Store = (0, $GtRbT.createStore)({
    initialState: $29e00bcf5213eb76$var$initialState,
    actions: $29e00bcf5213eb76$var$actions,
    name: 'VirtualizerStore',
    containedBy: $29e00bcf5213eb76$export$6f4d8b0593660d4a
});
const $29e00bcf5213eb76$export$2d20df04c90a6b4d = (0, $iJq0l.createActionsHook)($29e00bcf5213eb76$var$Store);
const $29e00bcf5213eb76$export$88d9b12c2ccec7b9 = (0, $iJq0l.createHook)($29e00bcf5213eb76$var$Store);
const $29e00bcf5213eb76$var$getVirtualizerSelector = (state)=>state.virtualizer;
const $29e00bcf5213eb76$export$8c88e6c844ce8aa0 = (0, $iJq0l.createStateHook)($29e00bcf5213eb76$var$Store, {
    selector: $29e00bcf5213eb76$var$getVirtualizerSelector
});
const $29e00bcf5213eb76$var$getVirtualItemsMapSelector = (state)=>state.virtualItemsMap;
const $29e00bcf5213eb76$export$48859eaeca922cb5 = (0, $iJq0l.createStateHook)($29e00bcf5213eb76$var$Store, {
    selector: $29e00bcf5213eb76$var$getVirtualItemsMapSelector
});

});

parcelRegister("hHg7L", function(module, exports) {
$parcel$export(module.exports, "useEventDelegator", () => $a9d2dac88d84964b$export$d7391873b7d90fb9);
$parcel$export(module.exports, "useEventDelegatorRef", () => $a9d2dac88d84964b$export$5213ba3182c7ed61);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $3OT15 = parcelRequire("3OT15");

var $bYhG9 = parcelRequire("bYhG9");
const $a9d2dac88d84964b$var$HOVER_DEBOUNCE_DURATION = 100;
const $a9d2dac88d84964b$export$d7391873b7d90fb9 = ()=>{
    const { setPopoverClosed: setPopoverClosed, setPopoverOpen: setPopoverOpen } = (0, $bYhG9.useHoverPopoverSetter)();
    const { getCellIdByRef: getCellIdByRef } = (0, $3OT15.useHoverPopoverContent)();
    const currentHoveredCellFieldIdRef = (0, $eJOHy.useRef)(null);
    const debouncedSetHoverFocusStateRef = (0, $eJOHy.useRef)(null);
    const clearHoverFocusState = (0, $eJOHy.useCallback)(()=>{
        debouncedSetHoverFocusStateRef.current?.cancel();
        setPopoverClosed();
        currentHoveredCellFieldIdRef.current = null;
    }, [
        setPopoverClosed
    ]);
    const setHoverFocusState = (0, $eJOHy.useCallback)((fieldId, cell)=>{
        setPopoverOpen({
            fieldId: fieldId,
            cell: cell,
            clearHoverFocusState: clearHoverFocusState
        });
    }, [
        setPopoverOpen,
        clearHoverFocusState
    ]);
    const handleMouseOver = (0, $eJOHy.useCallback)((event)=>{
        if (event.target instanceof HTMLElement) {
            const target = event.target;
            // Get closest cell that is being hovered over
            const cell = target.closest('td');
            // If no cell is found, clear the hover state and return
            if (!cell || !(cell instanceof HTMLTableCellElement)) {
                clearHoverFocusState();
                return;
            }
            const fieldId = getCellIdByRef(cell);
            // If there is a cell but no field id, clear the hover state and return
            if (!fieldId) {
                clearHoverFocusState();
                return;
            }
            // If the cell is the same as the current hovered cell, return
            if (fieldId !== currentHoveredCellFieldIdRef.current) {
                // If the cell is different from the current hovered cell, clear the previous hover state
                if (currentHoveredCellFieldIdRef.current) clearHoverFocusState();
                // Finally, set the hover state for the new cell
                currentHoveredCellFieldIdRef.current = fieldId;
                debouncedSetHoverFocusStateRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>setHoverFocusState(fieldId, cell), $a9d2dac88d84964b$var$HOVER_DEBOUNCE_DURATION);
                debouncedSetHoverFocusStateRef.current();
            }
        }
    }, [
        clearHoverFocusState,
        getCellIdByRef,
        setHoverFocusState
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        clearHoverFocusState();
        debouncedSetHoverFocusStateRef.current?.cancel();
    }, [
        clearHoverFocusState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (currentHoveredCellFieldIdRef.current) clearHoverFocusState();
            debouncedSetHoverFocusStateRef.current?.cancel();
        };
    }, [
        clearHoverFocusState
    ]);
    return {
        handleMouseLeave: handleMouseLeave,
        handleMouseOver: handleMouseOver
    };
};
const $a9d2dac88d84964b$export$5213ba3182c7ed61 = (fieldId)=>{
    const lastNode = (0, $eJOHy.useRef)(null);
    const { setCellIdByRef: setCellIdByRef, deleteCellIdByRef: deleteCellIdByRef } = (0, $3OT15.useHoverPopoverContent)();
    const tableCellRef = (0, $eJOHy.useCallback)((node)=>{
        if (node && fieldId) {
            setCellIdByRef(node, fieldId);
            lastNode.current = node;
        } else if (lastNode.current) {
            deleteCellIdByRef(lastNode.current);
            lastNode.current = null;
        }
    }, [
        fieldId,
        setCellIdByRef,
        deleteCellIdByRef
    ]);
    return tableCellRef;
};

});

parcelRegister("f8QUz", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1feeb10764a3558$export$2e2bcd8739ae039);

var $bEvJj = parcelRequire("bEvJj");

var $egYtH = parcelRequire("egYtH");

var $gF35y = parcelRequire("gF35y");

var $PGBM9 = parcelRequire("PGBM9");

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $jPROM = parcelRequire("jPROM");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $jBNts = parcelRequire("jBNts");

var $6d9QY = parcelRequire("6d9QY");

var $4cTDP = parcelRequire("4cTDP");

var $jE8Tu = parcelRequire("jE8Tu");

var $cNwIG = parcelRequire("cNwIG");

var $l6qXI = parcelRequire("l6qXI");

var $NWRt9 = parcelRequire("NWRt9");

var $bJscI = parcelRequire("bJscI");

var $cgCO4 = parcelRequire("cgCO4");

var $7n9BS = parcelRequire("7n9BS");

var $1q3Q0 = parcelRequire("1q3Q0");

var $34oCh = parcelRequire("34oCh");

var $jNv5I = parcelRequire("jNv5I");

var $km3XC = parcelRequire("km3XC");

var $8jOO7 = parcelRequire("8jOO7");

var $bKlUQ = parcelRequire("bKlUQ");

var $aNnbk = parcelRequire("aNnbk");

var $kfIml = parcelRequire("kfIml");

var $9r0oq = parcelRequire("9r0oq");
const $b1feeb10764a3558$export$4771958ed7a6df02 = ({ groupResults: groupResults, project: project, columns: columns, rankField: rankField, loading: loading, isConditionalFormattingEnabled: isConditionalFormattingEnabled, formattingRules: formattingRules, rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields, ...tableBodyProps })=>{
    const ChildIssueCreateRowComponent = (0, $9r0oq.useTimelineCustomComponents)()?.ChildIssueCreateRow;
    const groupsData = (0, $j4oe4.useFragment)((0, $PGBM9.default), groupResults);
    const projectData = (0, $j4oe4.useFragment)((0, $gF35y.default), project);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $egYtH.default), rankField);
    const rankFieldTerms = (0, $eJOHy.useMemo)(()=>({
            jqlTerm: rankFieldData?.jqlTerm ?? null,
            aliases: rankFieldData?.aliases ? Array.from(rankFieldData.aliases) : null
        }), [
        rankFieldData
    ]);
    const formattingRulesData = (0, $j4oe4.useFragment)((0, $bEvJj.default), formattingRules);
    const groupConnectionId = groupsData.__id;
    const { populateConnection: populateConnection } = (0, $jE8Tu.useHierarchyActions)();
    const populateConnectionArgs = (0, $eJOHy.useMemo)(()=>({
            parentItemId: 'root',
            itemsConnectionId: groupConnectionId,
            parentConnectionId: groupConnectionId,
            list: groupsData?.edges?.map((edge)=>edge?.node && {
                    itemId: edge.node.id,
                    key: null,
                    groupId: edge.node.id
                }).filter(Boolean) ?? []
        }), [
        groupConnectionId,
        groupsData.edges
    ]);
    const prevPopulateConnectionArgs = (0, $6d9QY.usePrevious)(populateConnectionArgs);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(populateConnectionArgs, prevPopulateConnectionArgs)) populateConnection(populateConnectionArgs);
    /**
   * Passing those values down to ChildRowsLoader as props to avoid direct imports
   */ const jql = (0, $34oCh.useJql)();
    const sortField = (0, $34oCh.useSortField)();
    const sortDirection = (0, $34oCh.useSortDirection)();
    const isReparentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const isHideDoneItemsEnabled = (0, $34oCh.useIsHideDoneItemsEnabled)();
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const width = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.width);
    const isIssueRankDescending = (0, $34oCh.useIsIssueRankDescending)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    const isIssueCreateEnabled = (0, $34oCh.useIsIssueCreateEnabled)();
    const isLinkRelationshipFieldEnabled = (0, $34oCh.useIsRelationshipFieldEnabled)();
    const isRemoteLinkedIssuesEnabled = (0, $34oCh.useIsRemoteLinkedIssuesEnabled)();
    const isEditableSyncLoaded = (0, $34oCh.useIsEditableSyncLoaded)();
    const cellBorderStyle = (0, $34oCh.useCellBorderStyle)();
    const isInlineEditingEnabled = (0, $4cTDP.fg)('jira_timeline_disable_child_inline_editing') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $34oCh.useIsInlineEditingEnabled)() : true;
    let isStickyColumnsVisible = false;
    let isAutoUnstickyOnSmallScreenEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isAutoUnstickyOnSmallScreenEnabled = (0, $34oCh.useIsAutoUnstickyOnSmallScreenEnabled)();
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { isStickyColumnsVisible: isStickyColumnsVisibleOld } = (0, $cgCO4.useShouldApplyFrozenColumns)();
        isStickyColumnsVisible = isStickyColumnsVisibleOld;
    }
    const renderDraggableWrapper = (0, $eJOHy.useCallback)((props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kfIml.DraggableRowsContainer), {
            issueConnectionId: props.issueConnectionId,
            instanceId: props.instanceId
        }, props.children);
    }, []);
    const renderChildRows = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNwIG.ChildRows), {
            ...props,
            projectKey: projectData?.key,
            isGroupingSupported: true,
            childItemsExperience: (0, $8jOO7.GROUPED_ITEMS_EXPERIENCE),
            childItemsLoadMoreExperience: (0, $8jOO7.GROUPED_LOAD_MORE_EXPERIENCE),
            analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE),
            renderChildRowsLoader: (childRowsLoaderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l6qXI.ChildRowsLoader), {
                    ...childRowsLoaderProps,
                    jql: jql,
                    width: width,
                    sortField: sortField,
                    sortDirection: sortDirection,
                    columns: columns,
                    amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
                    actionColumns: (0, $8jOO7.ACTION_COLUMNS),
                    pageSize: (0, $8jOO7.CHILD_QUERY_PAGE_SIZE),
                    isReparentingEnabled: isReparentingEnabled,
                    isTimelineEnabled: isTimelineEnabled,
                    isIssueRankDescending: isIssueRankDescending,
                    isHideDoneItemsEnabled: isHideDoneItemsEnabled,
                    isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
                    rankFieldId: rankFieldData?.fieldId ?? null,
                    renderRows: (rowProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1q3Q0.default), {
                            project: projectData,
                            groupContextFieldInput: (0, $4cTDP.fg)('group_by_any_field_sibling_inline_issue_create') ? props.groupContextField : undefined,
                            formattingRules: formattingRulesData,
                            rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
                            ...rowProps
                        }),
                    isStickyColumnsVisible: isStickyColumnsVisible,
                    renderTableCell: (tableCellProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), tableCellProps),
                    renderCreateIssueController: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aNnbk.CreateIssueController), {
                            ...args,
                            groupContextFieldInput: props.groupContextField,
                            jql: jql,
                            rankFieldTerms: rankFieldTerms
                        }),
                    renderDraggableWrapper: renderDraggableWrapper,
                    isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                    isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
                    ChildIssueCreateRowComponent: ChildIssueCreateRowComponent,
                    isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
                    isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
                    isEditableSyncLoaded: isEditableSyncLoaded,
                    cellBorderStyle: cellBorderStyle,
                    isInlineEditingEnabled: isInlineEditingEnabled
                })
        }), [
        projectData,
        jql,
        width,
        sortField,
        sortDirection,
        columns,
        isReparentingEnabled,
        isTimelineEnabled,
        isIssueRankDescending,
        isHideDoneItemsEnabled,
        isFixedTableLayoutEnabled,
        rankFieldData?.fieldId,
        isStickyColumnsVisible,
        renderDraggableWrapper,
        isConditionalFormattingEnabled,
        isInlineFieldConfigEnabled,
        ChildIssueCreateRowComponent,
        isLinkRelationshipFieldEnabled,
        isRemoteLinkedIssuesEnabled,
        isEditableSyncLoaded,
        cellBorderStyle,
        isInlineEditingEnabled,
        formattingRulesData,
        rowInlineCreateCanShowAdditionalFields,
        rankFieldTerms
    ]);
    const renderRows = (0, $eJOHy.useCallback)((rowProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1q3Q0.default), {
            project: projectData,
            formattingRules: formattingRulesData,
            rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
            ...rowProps
        }), [
        projectData,
        formattingRulesData,
        rowInlineCreateCanShowAdditionalFields
    ]);
    const renderCreateIssueController = (0, $eJOHy.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aNnbk.CreateIssueController), {
            ...args,
            jql: jql
        }), [
        jql
    ]);
    const numFirstGroupIssues = groupsData?.firstGroup?.issues?.edges?.length;
    const isFirstGroupEmpty = (0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(numFirstGroupIssues) || numFirstGroupIssues === 0;
    const renderGroups = (0, $eJOHy.useCallback)((isItemVirtual)=>groupsData?.edges?.map((group, index)=>group?.node && // We need to render the first group separately because it requires initialization during the table rendering process.
            // Additionally, it bypasses the ChildRowLoader and directly uses ChildRowsPagination, as the data is already available in data.firstGroup.
            (groupsData?.firstGroup && group.node.id === groupsData.firstGroup.id && !isFirstGroupEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jNv5I.RowContextProvider), {
                key: groupsData.firstGroup.id,
                groupId: groupsData.firstGroup.id,
                groupConnectionId: (0, $4cTDP.fg)('jsc_list_hide_done_items') ? groupConnectionId : undefined,
                ...tableBodyProps,
                columns: columns
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $NWRt9.FirstGroupRow), {
                firstGroupRow: groupsData.firstGroup,
                rankField: rankFieldData ?? null,
                groupConnectionId: groupConnectionId,
                loading: loading,
                isVirtual: isItemVirtual?.((0, $jBNts.getFlatListKey)({
                    itemId: groupsData.firstGroup.id,
                    groupId: groupsData.firstGroup.id
                })) ?? true,
                isGroupAtTop: index === 0,
                projectKey: projectData?.key,
                isHideDoneItemsEnabled: isHideDoneItemsEnabled,
                isIssueRankDescending: isIssueRankDescending,
                isTimelineEnabled: isTimelineEnabled,
                columns: columns,
                width: width,
                amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
                actionColumns: (0, $8jOO7.ACTION_COLUMNS),
                pageSize: (0, $8jOO7.CHILD_QUERY_PAGE_SIZE),
                childItemsExperience: (0, $8jOO7.GROUPED_ITEMS_EXPERIENCE),
                childItemsLoadMoreExperience: (0, $8jOO7.GROUPED_LOAD_MORE_EXPERIENCE),
                analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE),
                renderRows: renderRows,
                renderCreateIssueController: renderCreateIssueController,
                isIssueCreateEnabled: isIssueCreateEnabled,
                isGridNavigationEnabled: isGridNavigationEnabled,
                renderDraggableWrapper: renderDraggableWrapper,
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
                isStickyColumnsVisible: isStickyColumnsVisible,
                isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled,
                ChildIssueCreateRowComponent: ChildIssueCreateRowComponent,
                isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
                isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
                isEditableSyncLoaded: isEditableSyncLoaded,
                isInlineEditingEnabled: isInlineEditingEnabled
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jNv5I.RowContextProvider), {
                key: group.node.id,
                groupId: group.node.id,
                groupConnectionId: (0, $4cTDP.fg)('jsc_list_hide_done_items') ? groupConnectionId : undefined,
                ...tableBodyProps,
                columns: columns,
                renderChildRows: renderChildRows
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $NWRt9.GroupRow), {
                groupRow: group.node,
                groupConnectionId: groupConnectionId,
                isVirtual: isItemVirtual?.((0, $jBNts.getFlatListKey)({
                    itemId: group.node.id,
                    groupId: group.node.id
                })) ?? true,
                isGroupAtTop: index === 0,
                projectKey: projectData?.key,
                columns: columns,
                renderChildRows: renderChildRows,
                isIssueCreateEnabled: isIssueCreateEnabled,
                isGridNavigationEnabled: isGridNavigationEnabled,
                isStickyColumnsVisible: isStickyColumnsVisible,
                isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled
            })))), [
        groupsData?.edges,
        groupsData.firstGroup,
        isFirstGroupEmpty,
        groupConnectionId,
        tableBodyProps,
        columns,
        rankFieldData,
        loading,
        projectData?.key,
        isHideDoneItemsEnabled,
        isIssueRankDescending,
        isTimelineEnabled,
        width,
        renderRows,
        renderCreateIssueController,
        isIssueCreateEnabled,
        isGridNavigationEnabled,
        renderDraggableWrapper,
        isConditionalFormattingEnabled,
        isInlineFieldConfigEnabled,
        isStickyColumnsVisible,
        isAutoUnstickyOnSmallScreenEnabled,
        ChildIssueCreateRowComponent,
        isLinkRelationshipFieldEnabled,
        isRemoteLinkedIssuesEnabled,
        isEditableSyncLoaded,
        isInlineEditingEnabled,
        renderChildRows
    ]);
    const isVirtualizationEnabled = (0, $34oCh.useIsVirtualizationEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "tbody",
        xcss: $b1feeb10764a3558$var$tableBodyStyles
    }, isVirtualizationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $km3XC.VirtualizedRows), {
        hasSpacers: true,
        columnsCount: columns.length
    }, renderGroups) : renderGroups());
};
const $b1feeb10764a3558$var$GroupTableBody = (0, $bJscI.componentWithFG)('memoise_issuetable_components', /*#__PURE__*/ (0, $eJOHy.memo)($b1feeb10764a3558$export$4771958ed7a6df02), $b1feeb10764a3558$export$4771958ed7a6df02);
var $b1feeb10764a3558$export$2e2bcd8739ae039 = $b1feeb10764a3558$var$GroupTableBody;
const $b1feeb10764a3558$var$tableBodyStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderBottom: 'none',
    overflowX: 'hidden'
});

});
parcelRegister("bEvJj", function(module, exports) {
$parcel$export(module.exports, "default", () => $03bca71c50c114fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ee9b1c43ee52b2896dc1936afd8576fd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $03bca71c50c114fe$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "GroupTableBody_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Rows_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$03bca71c50c114fe$var$node.hash = "ff07da1a4c4e233045c0b3166944b4fb";
var $03bca71c50c114fe$export$2e2bcd8739ae039 = $03bca71c50c114fe$var$node;

});

parcelRegister("egYtH", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2db5a58ae05b747$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eb5afbef507f250b2eefe731f5eeed67>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f2db5a58ae05b747$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "GroupTableBody_rankField",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "jqlTerm"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "aliases"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "FirstGroupRow_rankField"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$f2db5a58ae05b747$var$node.hash = "94b2b65f192e8494f5d4b70bec387bd5";
var $f2db5a58ae05b747$export$2e2bcd8739ae039 = $f2db5a58ae05b747$var$node;

});

parcelRegister("gF35y", function(module, exports) {
$parcel$export(module.exports, "default", () => $77e2c9db9fbf3151$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d83e695be6319708d2c7acdd040809d1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $77e2c9db9fbf3151$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "GroupTableBody_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "Rows_project"
        }
    ],
    "type": "JiraProject"
};
$77e2c9db9fbf3151$var$node.hash = "b1bf39d9e47d705fe4c5f720da27e3ef";
var $77e2c9db9fbf3151$export$2e2bcd8739ae039 = $77e2c9db9fbf3151$var$node;

});

parcelRegister("PGBM9", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b3b3da2ee43091b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4cc8d94d4dd6902931728a04b3cf4478>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5b3b3da2ee43091b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "Variable",
        "name": "viewConfigInput",
        "variableName": "viewConfigInput"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isEditableSyncLoaded"
            },
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isPaginating"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isRemoteLinkedIssuesEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "viewConfigInput"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "firstGroup",
                        "issues"
                    ]
                }
            ]
        },
        "name": "GroupTableBody",
        "selections": [
            {
                "condition": "isPaginating",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "firstGroup",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "alias": "issues",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "fieldSetsInput",
                                        "variableName": "fieldSetsInput"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "scope",
                                        "variableName": "fieldSetsScope"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "settings",
                                        "variableName": "settings"
                                    },
                                    v1 /*: any*/ 
                                ],
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "__firstGroupSection_nativeIssueTable__issues_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v2 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            },
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v2 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "isConditionalFormattingEnabled",
                                        "variableName": "isConditionalFormattingEnabled"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isDensityFull",
                                        "variableName": "isDensityFull"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isEditableSyncLoaded",
                                        "variableName": "isEditableSyncLoaded"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isInlineEditingEnabled",
                                        "variableName": "isInlineEditingEnabled"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isLinkRelationshipFieldEnabled",
                                        "variableName": "isLinkRelationshipFieldEnabled"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isRemoteLinkedIssuesEnabled",
                                        "variableName": "isRemoteLinkedIssuesEnabled"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isTimelineEnabled",
                                        "variableName": "isTimelineEnabled"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "projectKey",
                                        "variableName": "projectKey"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "projectKeys",
                                        "variableName": "projectKeys"
                                    },
                                    v1 /*: any*/ 
                                ],
                                "kind": "FragmentSpread",
                                "name": "FirstGroupRow"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "JiraSpreadsheetGroupEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "FragmentSpread",
                                "name": "FirstGroupRow_GroupRow"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ],
        "type": "JiraSpreadsheetGroupConnection"
    };
}();
$5b3b3da2ee43091b$var$node.hash = "ea98fd266d36d7d52d0d2835e94674f1";
var $5b3b3da2ee43091b$export$2e2bcd8739ae039 = $5b3b3da2ee43091b$var$node;

});

parcelRegister("cNwIG", function(module, exports) {
$parcel$export(module.exports, "ChildRows", () => $c306099c2e91dd3b$export$d1ec222e220e369e);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $5vQ2T = parcelRequire("5vQ2T");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $jE8Tu = parcelRequire("jE8Tu");


var $eYYOy = parcelRequire("eYYOy");
const $c306099c2e91dd3b$var$PACKAGE_LOCATION = 'jira-issue-table-hierarchy-child-rows';
const $c306099c2e91dd3b$export$5881677fb314e6d9 = 'issue-table-child-rows-entrypoint-container';
const $c306099c2e91dd3b$export$d1ec222e220e369e = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const [isExpanded] = (0, $jE8Tu.useIsItemExpanded)({
        itemId: props.parentItemId,
        itemsConnectionId: props.itemsConnectionId,
        groupId: props.groupId
    });
    if (!isExpanded) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c306099c2e91dd3b$var$ChildRowsInner, props);
});
const $c306099c2e91dd3b$var$ChildRowsInner = (props)=>{
    const { parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, type: type, parentItemConnectionId: parentItemConnectionId, depth: depth, groupId: groupId, renderChildRowsLoader: renderChildRowsLoader } = props;
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: props.childItemsExperience,
        analyticsSource: props.analyticsSource
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: props.childItemsExperience,
        attributes: {}
    });
    (0, $eJOHy.useEffect)(()=>{
        onExperienceStart();
    }, [
        onExperienceStart
    ]);
    const { setIsItemExpanded: setIsItemExpanded } = (0, $jE8Tu.useHierarchyActions)();
    const { showFlag: showFlag, hasFlag: hasFlag } = (0, $cSXp8.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleError = (0, $eJOHy.useCallback)((error)=>{
        setIsItemExpanded({
            itemId: parentItemId,
            itemsConnectionId: itemsConnectionId,
            groupId: groupId
        }, false);
        if (!hasFlag?.($c306099c2e91dd3b$export$5881677fb314e6d9)) {
            const isGrouping = groupId && depth === 0;
            showFlag({
                id: $c306099c2e91dd3b$export$5881677fb314e6d9,
                title: formatMessage(isGrouping ? (0, $eYYOy.default).errorFlagGroupingTitle : (0, $eYYOy.default).errorFlagTitle),
                description: formatMessage(isGrouping ? (0, $eYYOy.default).errorFlagGroupingDescription : (0, $eYYOy.default).errorFlagDescription),
                type: 'error',
                messageId: `issue-table-hierarchy.ui.child-rows.showFlag.${$c306099c2e91dd3b$export$5881677fb314e6d9}`,
                messageType: 'transactional'
            });
        }
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'issue-table-child-rows-container',
                packageName: (0, $313deb82db1bb5f5$export$b8b9d90f9e5bd72b),
                teamName: (0, $313deb82db1bb5f5$export$d57b6b390e78d90f)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail($c306099c2e91dd3b$var$PACKAGE_LOCATION, error);
        return null;
    }, [
        formatMessage,
        hasFlag,
        itemsConnectionId,
        onExperienceFail,
        parentItemId,
        setIsItemExpanded,
        showFlag,
        depth,
        groupId
    ]);
    const connectionMetadata = (0, $eJOHy.useMemo)(()=>{
        if (type === 'PARENT_CHILDREN' && parentItemConnectionId) return {
            type: type,
            parentRelayId: parentItemConnectionId,
            parentId: parentItemId
        };
        if (type === 'GROUP_CHILDREN' && groupId) return {
            type: type,
            fieldValue: props.groupFieldValue,
            groupId: groupId,
            jql: props.groupJql
        };
        return undefined;
    }, [
        type,
        parentItemConnectionId,
        groupId,
        props.groupFieldValue,
        props.groupJql,
        parentItemId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: $c306099c2e91dd3b$var$PACKAGE_LOCATION,
        packageName: (0, $313deb82db1bb5f5$export$b8b9d90f9e5bd72b),
        teamName: (0, $313deb82db1bb5f5$export$d57b6b390e78d90f),
        onError: (_, error)=>handleError(error)
    }, renderChildRowsLoader({
        ...props,
        connectionMetadata: connectionMetadata
    }));
};

});
const $313deb82db1bb5f5$export$b8b9d90f9e5bd72b = 'jira-issue-table-hierarchy';
const $313deb82db1bb5f5$export$d57b6b390e78d90f = 'keystone';

parcelRegister("eYYOy", function(module, exports) {
$parcel$export(module.exports, "default", () => $cde560affa26929e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cde560affa26929e$var$messages = (0, $7qGN1.defineMessages)({
    errorFlagTitle: {
        "id": "native-issue-table.rows.child-rows.error-flag-title",
        "defaultMessage": "We couldn't expand hierarchy"
    },
    errorFlagDescription: {
        "id": "native-issue-table.rows.child-rows.error-flag-description",
        "defaultMessage": "Someone may have deleted a task or changed access to the parent. Try again or contact an admin."
    },
    errorFlagGroupingTitle: {
        "id": "native-issue-table.rows.child-rows.error-flag-grouping-title",
        "defaultMessage": "We couldn't expand the group"
    },
    errorFlagGroupingDescription: {
        "id": "native-issue-table.rows.child-rows.error-flag-grouping-description",
        "defaultMessage": "Refresh the page and try again."
    }
});
var $cde560affa26929e$export$2e2bcd8739ae039 = $cde560affa26929e$var$messages;

});


parcelRegister("l6qXI", function(module, exports) {
$parcel$export(module.exports, "ChildRowsLoader", () => $dfa944b5917963ac$export$148a4cf18f2e069b);

var $cmXbL = parcelRequire("cmXbL");

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $2imLM = parcelRequire("2imLM");

var $4cTDP = parcelRequire("4cTDP");

var $cHtIB = parcelRequire("cHtIB");

var $9AekN = parcelRequire("9AekN");

var $hCzdk = parcelRequire("hCzdk");

var $eoeem = parcelRequire("eoeem");
const $dfa944b5917963ac$export$148a4cf18f2e069b = (props)=>{
    const [issueSearch, loadQuery, dispose] = (0, $j4oe4.useQueryLoader)((0, $cmXbL.default));
    const cloudId = (0, $cHtIB.useCloudId)();
    const { sortField: sortField, sortDirection: sortDirection, jql: jql, columns: columns, isReparentingEnabled: isReparentingEnabled, isTimelineEnabled: isTimelineEnabled, isGroupingSupported: isGroupingSupported, pageSize: pageSize, amountOfColumns: amountOfColumns, actionColumns: actionColumns, isHideDoneItemsEnabled: isHideDoneItemsEnabled, projectKey: projectKey, isConditionalFormattingEnabled: isConditionalFormattingEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isStickyColumnsVisible: isStickyColumnsVisible, isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled, isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled, isEditableSyncLoaded: isEditableSyncLoaded, isInlineEditingEnabled: isInlineEditingEnabled, shouldQuerySprints: shouldQuerySprints } = props;
    const variables = (0, $eJOHy.useMemo)(()=>props.type === 'GROUP_CHILDREN' ? (0, $9AekN.getChildQueryVariablesForJql)({
            cloudId: cloudId,
            columns: columns,
            jql: props.groupJql,
            isReparentingEnabled: false,
            isTimelineEnabled: isTimelineEnabled,
            actionColumns: actionColumns,
            amountOfColumns: amountOfColumns,
            pageSize: pageSize,
            isHideDoneItemsEnabled: isHideDoneItemsEnabled,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            projectKey: projectKey,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
            isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
            isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
            isEditableSyncLoaded: isEditableSyncLoaded,
            isInlineEditingEnabled: isInlineEditingEnabled
        }) : (0, $9AekN.getChildQueryVariablesForParentIssue)({
            cloudId: cloudId,
            columns: columns,
            parentIssueKey: props.issueKey,
            sortDirection: sortDirection,
            sortField: sortField,
            jql: jql,
            isReparentingEnabled: isReparentingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            actionColumns: actionColumns,
            amountOfColumns: amountOfColumns,
            pageSize: pageSize,
            isHideDoneItemsEnabled: isHideDoneItemsEnabled,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
            isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
            isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
            isEditableSyncLoaded: isEditableSyncLoaded,
            isInlineEditingEnabled: isInlineEditingEnabled,
            shouldQuerySprints: shouldQuerySprints
        }), [
        props.type,
        props.groupJql,
        props.issueKey,
        cloudId,
        columns,
        actionColumns,
        amountOfColumns,
        pageSize,
        sortDirection,
        sortField,
        jql,
        isConditionalFormattingEnabled,
        isHideDoneItemsEnabled,
        isReparentingEnabled,
        isTimelineEnabled,
        projectKey,
        isInlineFieldConfigEnabled,
        isLinkRelationshipFieldEnabled,
        isRemoteLinkedIssuesEnabled,
        isEditableSyncLoaded,
        isInlineEditingEnabled,
        shouldQuerySprints
    ]);
    const prevIssueSearchInput = (0, $eJOHy.useRef)(variables.issueSearchInput);
    (0, $eJOHy.useEffect)(()=>{
        // This check prevents performing another network request for child items when the issue query changes
        // (which is unused as we re-fetch the issues when this happens). This is due to a race condition where
        // this component has not yet been unmounted when the issue query changes.
        if (props.isGroupingSupported && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(variables.issueSearchInput, prevIssueSearchInput.current)) return;
        loadQuery(variables);
        if (props.isGroupingSupported) prevIssueSearchInput.current = variables.issueSearchInput;
        return ()=>{
            dispose();
        };
    }, [
        variables,
        loadQuery,
        dispose,
        props.isGroupingSupported
    ]);
    if (!issueSearch) return null;
    const { groupId: groupId, depth: depth, parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, parentIssueAri: parentIssueAri, parentItemConnectionId: parentItemConnectionId, parentIssueRelayConnectionId: parentIssueRelayConnectionId, parentIssueHierarchyLevel: parentIssueHierarchyLevel, connectionMetadata: connectionMetadata, isFormVisible: isFormVisible, formProps: formProps, rankFieldId: rankFieldId, childItemsExperience: childItemsExperience, childItemsLoadMoreExperience: childItemsLoadMoreExperience, analyticsSource: analyticsSource, width: width, isIssueRankDescending: isIssueRankDescending, renderRows: renderRows, renderCreateIssueController: renderCreateIssueController, renderDraggableWrapper: renderDraggableWrapper, ChildIssueCreateRowComponent: ChildIssueCreateRowComponent } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "native-issue-table-child-rows-query",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hCzdk.default), {
            itemId: parentItemId,
            groupId: groupId,
            columnsCount: columns.length,
            ...isStickyColumnsVisible && (0, $4cTDP.fg)('issue_table_frozen_columns') && {
                stickyColumnConfigs: columns.map((column)=>({
                        stickyOffsets: column.stickyOffsets,
                        isColumnSticky: column.isColumnSticky
                    }))
            },
            isFixedTableLayoutEnabled: props.isFixedTableLayoutEnabled,
            renderTableCell: props.renderTableCell,
            cellBorderStyle: props.cellBorderStyle
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dfa944b5917963ac$export$410977b2c408dd5d, {
        issueSearch: issueSearch,
        depth: depth,
        parentItemId: parentItemId,
        itemsConnectionId: itemsConnectionId,
        parentIssueAri: parentIssueAri,
        parentItemConnectionId: parentItemConnectionId,
        parentIssueRelayConnectionId: parentIssueRelayConnectionId,
        parentIssueHierarchyLevel: parentIssueHierarchyLevel,
        connectionMetadata: connectionMetadata,
        isFormVisible: isFormVisible,
        formProps: formProps,
        projectKey: projectKey,
        isGroupingSupported: isGroupingSupported,
        childItemsExperience: childItemsExperience,
        childItemsLoadMoreExperience: childItemsLoadMoreExperience,
        analyticsSource: analyticsSource,
        pageSize: pageSize,
        width: width,
        isIssueRankDescending: isIssueRankDescending,
        renderRows: renderRows,
        renderCreateIssueController: renderCreateIssueController,
        groupId: groupId,
        columns: columns,
        rankFieldId: rankFieldId,
        renderDraggableWrapper: renderDraggableWrapper,
        ChildIssueCreateRowComponent: ChildIssueCreateRowComponent,
        isTimelineEnabled: isTimelineEnabled
    }));
};
const $dfa944b5917963ac$export$410977b2c408dd5d = ({ issueSearch: issueSearch, ...rest })=>{
    const queryData = (0, $j4oe4.usePreloadedQuery)((0, $cmXbL.default), issueSearch);
    if (rest.isGroupingSupported && queryData?.jira?.issueSearch?.issueSearchError?.__typename) switch(queryData.jira.issueSearch.issueSearchError.__typename){
        case 'JiraInvalidJqlError':
            throw new Error(queryData.jira.issueSearch.issueSearchError.messages?.[0] ?? 'Invalid JQL');
        case 'JiraInvalidSyntaxError':
        case 'JiraServerError':
            throw new Error(queryData.jira.issueSearch.issueSearchError.message ?? 'Unknown Error');
        default:
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eoeem.ChildRowsPagination), {
        ...rest,
        query: queryData
    });
};

});
parcelRegister("cmXbL", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5a5ecfbda76fefb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dee71d86175f39c5b91295575515ec88>>
 * @relayHash 42fe865e30fc2482d5efef3e2c6f9e1b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b65bec3d4b1ee893df9ed33c1e9e4457ad82c3c2db8e96dd0639f40da76bd40d

var $3Bt2F = parcelRequire("3Bt2F");

var $3jVIX = parcelRequire("3jVIX");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $lS5zB = parcelRequire("lS5zB");

var $2Z4v6 = parcelRequire("2Z4v6");

var $hRj2m = parcelRequire("hRj2m");

var $6AioA = parcelRequire("6AioA");

var $04qit = parcelRequire("04qit");

var $jvWSl = parcelRequire("jvWSl");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $1fipb = parcelRequire("1fipb");

var $iOvkB = parcelRequire("iOvkB");

var $FU9UR = parcelRequire("FU9UR");
const $a5a5ecfbda76fefb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isEditableSyncLoaded"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isInlineEditingEnabled"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLinkRelationshipFieldEnabled"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRemoteLinkedIssuesEnabled"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isReparentingEnabled"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v20 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v21 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ], v22 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v23 = [
        {
            "kind": "ScalarField",
            "name": "message"
        }
    ], v24 = {
        "kind": "LinkedField",
        "name": "issueSearchError",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v23 /*: any*/ ,
                "type": "JiraServerError"
            },
            {
                "kind": "InlineFragment",
                "selections": v23 /*: any*/ ,
                "type": "JiraInvalidSyntaxError"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "messages"
                    }
                ],
                "type": "JiraInvalidJqlError"
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v26 = {
        "kind": "ScalarField",
        "name": "id"
    }, v27 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v28 = {
        "kind": "ScalarField",
        "name": "key"
    }, v29 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v30 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v31 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v32 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v33 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v32 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v34 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "name"
    }, v36 = [
        v35 /*: any*/ 
    ], v37 = {
        "kind": "ScalarField",
        "name": "isRemoteIssue"
    }, v38 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v39 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v40 = [
        v35 /*: any*/ ,
        v26 /*: any*/ 
    ], v41 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v42 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v43 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v44 = {
        "kind": "ScalarField",
        "name": "type"
    }, v45 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v46 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v47 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v48 = {
        "kind": "ScalarField",
        "name": "value"
    }, v49 = [
        v48 /*: any*/ ,
        v26 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v50 = {
        "condition": "isInlineEditingEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lazyIsEditableInIssueView"
                    }
                ]
            }
        ]
    }, v51 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v52 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v53 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v54 = {
        "kind": "ScalarField",
        "name": "date"
    }, v55 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v56 = {
        "kind": "ScalarField",
        "name": "text"
    }, v57 = {
        "condition": "isEditableSyncLoaded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditableInIssueView"
            }
        ]
    }, v58 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v26 /*: any*/ 
        ]
    }, v59 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v60 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v56 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v61 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v62 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v63 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v64 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v65 = [
        {
            "kind": "ScalarField",
            "name": "appType"
        }
    ], v66 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v67 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v68 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v69 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v70 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v71 = [
        v26 /*: any*/ 
    ], v72 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v71 /*: any*/ 
    }, v73 = {
        "kind": "ClientExtension",
        "selections": [
            v39 /*: any*/ 
        ]
    }, v74 = {
        "kind": "ScalarField",
        "name": "href"
    }, v75 = [
        v74 /*: any*/ 
    ], v76 = {
        "kind": "ScalarField",
        "name": "direction"
    }, v77 = {
        "concreteType": "JiraIssueType",
        "kind": "LinkedField",
        "name": "issueType",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            v29 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v78 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v79 = {
        "kind": "InlineFragment",
        "selections": [
            v54 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v80 = [
        v22 /*: any*/ ,
        v47 /*: any*/ ,
        v79 /*: any*/ ,
        v26 /*: any*/ 
    ], v81 = [
        v22 /*: any*/ ,
        v79 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": v71 /*: any*/ ,
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ], v82 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "issue",
                    "plural": false,
                    "selections": [
                        v26 /*: any*/ ,
                        v27 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                                v77 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraParentIssueField",
                            "kind": "LinkedField",
                            "name": "parentIssueField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "parentIssue",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                },
                                v26 /*: any*/ 
                            ]
                        },
                        v28 /*: any*/ ,
                        v34 /*: any*/ ,
                        {
                            "concreteType": "JiraSingleSelectUserPickerField",
                            "kind": "LinkedField",
                            "name": "assigneeField",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v22 /*: any*/ ,
                                        v62 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                },
                                v26 /*: any*/ 
                            ]
                        },
                        {
                            "args": v78 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "startDateViewField",
                            "plural": false,
                            "selections": v80 /*: any*/ ,
                            "storageKey": "startDateViewField(viewId:\"list_default\")"
                        },
                        {
                            "args": v78 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "endDateViewField",
                            "plural": false,
                            "selections": v80 /*: any*/ ,
                            "storageKey": "endDateViewField(viewId:\"list_default\")"
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "aggregatedStartDateViewField",
                                    "plural": false,
                                    "selections": v81 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "aggregatedEndDateViewField",
                                    "plural": false,
                                    "selections": v81 /*: any*/ 
                                }
                            ],
                            "type": "JiraAggregatedTimelineField"
                        }
                    ]
                }
            ],
            "type": "JiraTimelineVirtualField",
            "abstractKey": "__isJiraTimelineVirtualField"
        }
    ], v83 = [
        v22 /*: any*/ ,
        v26 /*: any*/ 
    ], v84 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v85 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v86 = [
        v22 /*: any*/ ,
        v79 /*: any*/ ,
        v26 /*: any*/ 
    ], v87 = {
        "args": v78 /*: any*/ ,
        "kind": "LinkedField",
        "name": "startDateViewField",
        "plural": false,
        "selections": v86 /*: any*/ ,
        "storageKey": "startDateViewField(viewId:\"list_default\")"
    }, v88 = {
        "args": v78 /*: any*/ ,
        "kind": "LinkedField",
        "name": "endDateViewField",
        "plural": false,
        "selections": v86 /*: any*/ ,
        "storageKey": "endDateViewField(viewId:\"list_default\")"
    }, v89 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ChildRowsPreloadedQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isConditionalFormattingEnabled",
                            "variableName": "isConditionalFormattingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isEditableSyncLoaded",
                            "variableName": "isEditableSyncLoaded"
                        },
                        {
                            "kind": "Variable",
                            "name": "isInlineEditingEnabled",
                            "variableName": "isInlineEditingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isLinkRelationshipFieldEnabled",
                            "variableName": "isLinkRelationshipFieldEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isRemoteLinkedIssuesEnabled",
                            "variableName": "isRemoteLinkedIssuesEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isReparentingEnabled",
                            "variableName": "isReparentingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isTimelineEnabled",
                            "variableName": "isTimelineEnabled"
                        },
                        v20 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKeys",
                            "variableName": "projectKeys"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldQueryHasChildren",
                            "variableName": "shouldQueryHasChildren"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "ChildRowsPagination"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v21 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                v24 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v12 /*: any*/ ,
                v4 /*: any*/ ,
                v13 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v14 /*: any*/ ,
                v3 /*: any*/ ,
                v16 /*: any*/ ,
                v15 /*: any*/ ,
                v19 /*: any*/ ,
                v18 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v17 /*: any*/ ,
                v5 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiratimelinecustomissuelinkrelationnamesenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ChildRowsPreloadedQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v21 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v22 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        v26 /*: any*/ 
                                                    ]
                                                },
                                                v30 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": v36 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isRemoteLinkedIssuesEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v37 /*: any*/ ,
                                                        v38 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v39 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isLinkRelationshipFieldEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v37 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": v40 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isReparentingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v41 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v42 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v36 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v43 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v44 /*: any*/ ,
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v46 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        v22 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v44 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "serviceId"
                                                                                                                        },
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraAffectedServicesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "cascadingOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v49 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "childOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v49 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCascadingSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "objectId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "label"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "clientId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "fileId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "url48"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "QueryError",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "errors",
                                                                                                            "plural": true,
                                                                                                            "selections": v23 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCMDBField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedComponentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v53 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v54 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v55 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDatePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "dateTime"
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraEpic",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "epic",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v41 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color"
                                                                                                        },
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraEpicLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "renderedFieldHtml"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFallbackField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v56 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v31 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v32 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedLabelsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v58 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraLabelsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v42 /*: any*/ ,
                                                                                                        v35 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraColorField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueColorField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v58 /*: any*/ ,
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueTypeField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v59 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v60 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "issuetype",
                                                                                                                                "project",
                                                                                                                                "summary",
                                                                                                                                "status"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                v56 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        v61 /*: any*/ ,
                                                                                                                                                        v35 /*: any*/ ,
                                                                                                                                                        v59 /*: any*/ ,
                                                                                                                                                        v29 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "status",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "statusCategory",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v26 /*: any*/ ,
                                                                                                                                                                v31 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraStatusField"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v61 /*: any*/ ,
                                                                                                                                v29 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "summaryField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v47 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v33 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraParentIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "large"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraResolution",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "resolution",
                                                                                                    "plural": false,
                                                                                                    "selections": v40 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraResolutionField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedSprintsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "sprintId"
                                                                                                                        },
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "state"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "endDate"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSprintField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        v35 /*: any*/ ,
                                                                                                        v62 /*: any*/ ,
                                                                                                        v63 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v64 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "TypeDiscriminator",
                                                                                                                    "abstractKey": "__isUser"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": v65 /*: any*/ ,
                                                                                                                    "type": "AppUser"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": v65 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "AppUser"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v55 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraRichText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "richText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraADF",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "adfValue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "convertedPlainText",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "plainText"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRichTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "requestType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v59 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "first",
                                                                                                            "value": 1
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLinkConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "statusCategory"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v32 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                        },
                                                                                                                                                        v26 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        v30 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v26 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v66 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isStoryPointField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "number"
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "formatConfig",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatStyle"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatUnit"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraNumberField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "commentSummary",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canAddComment"
                                                                                                        },
                                                                                                        v46 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCommentSummaryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "uri"
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraUrlField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v48 /*: any*/ ,
                                                                                                        v58 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v67 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v48 /*: any*/ ,
                                                                                                                        v67 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v48 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCheckboxesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedUsersConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v64 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v62 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v63 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "email"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraTeamView",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedTeam",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedId"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedName"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraTeamViewField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v50 /*: any*/ ,
                                                                                                                        v68 /*: any*/ ,
                                                                                                                        v69 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v44 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v68 /*: any*/ ,
                                                                                                                        v69 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v44 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v50 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "label",
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "value"
                                                                                                        },
                                                                                                        v26 /*: any*/ ,
                                                                                                        v52 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraRadioSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v53 /*: any*/ ,
                                                                                                                        v70 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                v72 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGoals",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                v35 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "status"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v73 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                },
                                                                                                v50 /*: any*/ ,
                                                                                                v73 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraGoalsField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v72 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isLinkEditable"
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraTownsquareProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v26 /*: any*/ ,
                                                                                                                {
                                                                                                                    "alias": "atlasProjectName",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "name"
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": "atlasProjectKey",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "key"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "privateProject"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "hasPermission"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWorkspaceActive"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconName"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v50 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTownsquareProjectField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v74 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "pageContent",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": v75 /*: any*/ ,
                                                                                                                                            "type": "JiraConfluencePageContentDetails"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v46 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGroupsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "groupId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraFlag",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "flag",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isFlagged"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFlagField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraWatch",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "watch",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "count"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isWatching"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraWatchesField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "isLinkRelationshipFieldEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLink",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v26 /*: any*/ ,
                                                                                                                v76 /*: any*/ ,
                                                                                                                v66 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "type",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v71 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v57 /*: any*/ ,
                                                                                                        v50 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkRelationshipTypeField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "isTimelineEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": v82 /*: any*/ ,
                                                                                                    "type": "JiraTimelineField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": v82 /*: any*/ ,
                                                                                                    "type": "JiraAggregatedTimelineField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v73 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isConditionalFormattingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v51 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "componentId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "priorityId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "projectId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersion",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "version",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v70 /*: any*/ ,
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v61 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v83 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSelectableValueConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValues",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v83 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldSets(first:500)"
                                        },
                                        {
                                            "condition": "shouldQueryHasChildren",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "filterByProjectKeys",
                                                            "variableName": "projectKeys"
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "hasChildren"
                                                },
                                                {
                                                    "args": [
                                                        v20 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "canHaveChildIssues"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isRemoteLinkedIssuesEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "issueError",
                                                    "plural": false,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "errorType"
                                                                },
                                                                {
                                                                    "concreteType": "JiraRemoteLinkedIssueRepairLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "repairLink",
                                                                    "plural": false,
                                                                    "selections": v75 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraRemoteLinkedIssueError"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v73 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v84 /*: any*/ ,
                                        v85 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasPreviousPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startCursor"
                                        }
                                    ]
                                },
                                v24 /*: any*/ ,
                                {
                                    "condition": "isTimelineEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v43 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v45 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v87 /*: any*/ ,
                                                                                                                v88 /*: any*/ ,
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraTimelineField"
                                                                                                },
                                                                                                v26 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                            "kind": "LinkedField",
                                                            "name": "assigneeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                },
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        v77 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraParentIssueField",
                                                            "kind": "LinkedField",
                                                            "name": "parentIssueField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                },
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraStatusField",
                                                            "kind": "LinkedField",
                                                            "name": "statusField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": v36 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        v60 /*: any*/ ,
                                                        {
                                                            "args": v89 /*: any*/ ,
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinks",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiratimelinecustomissuelinkrelationnamesenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        v76 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v26 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v87 /*: any*/ ,
                                                                                        v88 /*: any*/ ,
                                                                                        v27 /*: any*/ ,
                                                                                        v28 /*: any*/ ,
                                                                                        v26 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiratimelinecustomissuelinkrelationnamesenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": false,
                                                                                    "selections": [
                                                                                        v66 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v22 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v25 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "PageInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "pageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v84 /*: any*/ ,
                                                                        v85 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinks(first:10)"
                                                        },
                                                        {
                                                            "args": v89 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "timeline_jira_issueLinks",
                                                            "kind": "LinkedHandle",
                                                            "name": "issueLinks"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v73 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v43 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v73 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v73 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v21 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "issueSearchInput",
                                "options",
                                "fieldSetsInput",
                                "viewConfigInput",
                                "scope"
                            ],
                            "handle": "connection",
                            "key": "hierarchy_nativeIssueTable__issueSearch",
                            "kind": "LinkedHandle",
                            "name": "issueSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b65bec3d4b1ee893df9ed33c1e9e4457ad82c3c2db8e96dd0639f40da76bd40d",
            "metadata": {},
            "name": "ChildRowsPreloadedQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": (0, $04qit.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $6AioA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": (0, $1fipb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiratimelinecustomissuelinkrelationnamesenabledrelayprovider": (0, $lS5zB.default)
            }
        }
    };
}();
$a5a5ecfbda76fefb$var$node.hash = "33582b4eb32c2b8ac1b2570822c6b07f";
var $a5a5ecfbda76fefb$export$2e2bcd8739ae039 = $a5a5ecfbda76fefb$var$node;

});
parcelRegister("lS5zB", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6784e7248bd5148$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $b6784e7248bd5148$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jira_timeline_custom_issue_link_relation_names');
    }
};

});


parcelRegister("9AekN", function(module, exports) {
$parcel$export(module.exports, "getChildQueryVariablesForJql", () => $014130e7555c3d46$export$e5b06f7246d135e);
$parcel$export(module.exports, "getChildQueryVariablesForParentIssue", () => $014130e7555c3d46$export$e350acffa980a984);

var $4cTDP = parcelRequire("4cTDP");

var $j8Km1 = parcelRequire("j8Km1");

var $awWeA = parcelRequire("awWeA");
const $014130e7555c3d46$var$getProjectKeyFromIssueKey = (issueKey)=>{
    return issueKey.split('-')[0];
};
const $014130e7555c3d46$var$getChildQueryVariablesBase = ({ cloudId: cloudId, columns: columns, isReparentingEnabled: isReparentingEnabled, isTimelineEnabled: isTimelineEnabled, actionColumns: actionColumns, amountOfColumns: amountOfColumns, pageSize: pageSize, projectKey: projectKey, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isInlineEditingEnabled: isInlineEditingEnabled })=>{
    let fieldSetIds = columns.filter((column)=>!!column.id && !actionColumns.includes(column.id)).map((column)=>column.id).sort();
    const mergedColumnsIds = (0, $4cTDP.fg)('jira_list_merged_column_gate') ? (columns.find((col)=>col?.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN))?.mergedColumns ?? []).map((col)=>col.id) : [];
    fieldSetIds = [
        ...mergedColumnsIds,
        ...fieldSetIds
    ];
    const operationScope = (0, $awWeA.getOperationScope)(projectKey);
    let fieldSetsScope = null;
    if ((0, $4cTDP.fg)('jira_nin_last_used_jql')) fieldSetsScope = {
        operationScope: operationScope,
        projectKey: projectKey ?? null
    };
    else if (isInlineFieldConfigEnabled) fieldSetsScope = {
        operationScope: operationScope,
        projectKey: projectKey
    };
    return {
        cloudId: cloudId,
        amountOfColumns: amountOfColumns,
        fieldSetsInput: {
            fieldSetIds: fieldSetIds
        },
        fieldSetIds: fieldSetIds,
        first: pageSize,
        namespace: '',
        shouldQueryFieldSetsById: true,
        filterId: null,
        viewId: null,
        isReparentingEnabled: isReparentingEnabled,
        isTimelineEnabled: isTimelineEnabled,
        scope: fieldSetsScope,
        isInlineEditingEnabled: isInlineEditingEnabled
    };
};
const $014130e7555c3d46$export$e5b06f7246d135e = ({ cloudId: cloudId, columns: columns, jql: jql, isReparentingEnabled: isReparentingEnabled, isTimelineEnabled: isTimelineEnabled, actionColumns: actionColumns, amountOfColumns: amountOfColumns, pageSize: pageSize, isHideDoneItemsEnabled: isHideDoneItemsEnabled, isConditionalFormattingEnabled: isConditionalFormattingEnabled, projectKey: projectKey, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled, isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled, isEditableSyncLoaded: isEditableSyncLoaded, isInlineEditingEnabled: isInlineEditingEnabled })=>{
    return {
        ...$014130e7555c3d46$var$getChildQueryVariablesBase({
            cloudId: cloudId,
            columns: columns,
            isReparentingEnabled: isReparentingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            actionColumns: actionColumns,
            amountOfColumns: amountOfColumns,
            pageSize: pageSize,
            projectKey: projectKey,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
            isInlineEditingEnabled: isInlineEditingEnabled
        }),
        issueSearchInput: {
            jql: jql
        },
        shouldQueryHasChildren: false,
        isConditionalFormattingEnabled: isConditionalFormattingEnabled,
        isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
        isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
        isEditableSyncLoaded: isEditableSyncLoaded,
        ...isHideDoneItemsEnabled && (0, $4cTDP.fg)('jsc_list_hide_done_items') && {
            viewConfigInput: {
                staticViewInput: {
                    isHideDoneEnabled: true
                }
            }
        }
    };
};
const $014130e7555c3d46$export$e350acffa980a984 = ({ cloudId: cloudId, columns: columns, parentIssueKey: parentIssueKey, jql: jql, isReparentingEnabled: isReparentingEnabled, isTimelineEnabled: isTimelineEnabled, isHideDoneItemsEnabled: isHideDoneItemsEnabled, actionColumns: actionColumns, amountOfColumns: amountOfColumns, pageSize: pageSize, isConditionalFormattingEnabled: isConditionalFormattingEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled, isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled, isEditableSyncLoaded: isEditableSyncLoaded, isInlineEditingEnabled: isInlineEditingEnabled, shouldQuerySprints: shouldQuerySprints })=>{
    const projectKey = $014130e7555c3d46$var$getProjectKeyFromIssueKey(parentIssueKey);
    return {
        ...$014130e7555c3d46$var$getChildQueryVariablesBase({
            cloudId: cloudId,
            columns: columns,
            isReparentingEnabled: isReparentingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            actionColumns: actionColumns,
            amountOfColumns: amountOfColumns,
            pageSize: pageSize,
            projectKey: projectKey,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
            isInlineEditingEnabled: isInlineEditingEnabled
        }),
        issueSearchInput: {
            childIssuesInput: {
                parentIssueKey: parentIssueKey,
                filterByProjectKeys: [
                    projectKey
                ],
                ...jql ? {
                    jql: jql
                } : {},
                ...(0, $4cTDP.fg)('jsc_list_hide_done_items') && {
                    namespace: 'ISSUE_NAVIGATOR'
                }
            }
        },
        projectKeys: [
            projectKey
        ],
        projectKey: projectKey,
        viewConfigInput: {
            staticViewInput: {
                isHierarchyEnabled: true,
                isGroupingEnabled: false,
                ...(0, $4cTDP.fg)('jsc_list_hide_done_items') && {
                    isHideDoneEnabled: isHideDoneItemsEnabled
                }
            }
        },
        shouldQueryHasChildren: true,
        ...(0, $4cTDP.fg)('timeline_harmonisation_m3_targeting') && {
            shouldQuerySprints: !!shouldQuerySprints
        },
        isConditionalFormattingEnabled: isConditionalFormattingEnabled,
        isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
        isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
        isEditableSyncLoaded: isEditableSyncLoaded
    };
};

});

parcelRegister("hCzdk", function(module, exports) {
$parcel$export(module.exports, "default", () => $f47963be7d20baa6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $jE8Tu = parcelRequire("jE8Tu");
const $f47963be7d20baa6$var$LoadingIssueRow = ({ itemId: itemId, groupId: groupId, columnsCount: columnsCount, stickyColumnConfigs: stickyColumnConfigs, isFixedTableLayoutEnabled: isFixedTableLayoutEnabled, cellBorderStyle: cellBorderStyle = 'FULL_BORDER', renderTableCell: renderTableCell })=>{
    const { setItemIsLoading: setItemIsLoading } = (0, $jE8Tu.useHierarchyActions)();
    (0, $eJOHy.useEffect)(()=>{
        setItemIsLoading({
            itemId: itemId,
            groupId: groupId,
            isLoading: true
        });
        return ()=>{
            setItemIsLoading({
                itemId: itemId,
                groupId: groupId,
                isLoading: false
            });
        };
    }, [
        itemId,
        groupId,
        setItemIsLoading
    ]);
    const columns = Array.from({
        length: columnsCount
    });
    const colSpans = columns.map((_, index)=>{
        const isLastColumn = index === columns.length - 1;
        return 1 + (isLastColumn && isFixedTableLayoutEnabled ? 1 : 0);
    });
    return /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        as: "tr",
        xcss: [
            (0, $4cTDP.fg)('issue_table_frozen_columns') ? $f47963be7d20baa6$var$wrapperStyles : $f47963be7d20baa6$var$wrapperOldStyles
        ]
    }, columns.map((_, i)=>renderTableCell({
            key: `${itemId}-${i}`,
            colSpan: colSpans[i],
            border: (0, $4cTDP.fg)('jira_timeline_cell_border_style') ? [
                $f47963be7d20baa6$var$baseCellBorderStyles,
                $f47963be7d20baa6$var$cellBorderLocationStyleMap[cellBorderStyle],
                i === columnsCount - 1 && $f47963be7d20baa6$var$lastCellBorderStyles
            ] : [
                $f47963be7d20baa6$var$cellBorderStyles,
                i === columnsCount - 1 && $f47963be7d20baa6$var$lastCellBorderStyles
            ],
            children: /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
                xcss: $f47963be7d20baa6$var$loadingCellStyles
            }),
            ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
                isColumnSticky: stickyColumnConfigs?.[i].isColumnSticky,
                stickyOffsets: stickyColumnConfigs?.[i].stickyOffsets
            }
        })));
};
var $f47963be7d20baa6$export$2e2bcd8739ae039 = $f47963be7d20baa6$var$LoadingIssueRow;
const $f47963be7d20baa6$var$wrapperOldStyles = (0, $1DXK0.xcss)({
    height: '40px'
});
const $f47963be7d20baa6$var$wrapperStyles = (0, $1DXK0.xcss)({
    height: '40px',
    background: "var(--ds-surface, #FFFFFF)"
});
// TODO: Remove this with cleanup of jira_timeline_cell_border_style
const $f47963be7d20baa6$var$cellBorderStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderBottomWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderLeftWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightWidth: 'border.width'
});
const $f47963be7d20baa6$var$lastCellBorderStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightWidth: '0'
});
const $f47963be7d20baa6$var$baseCellBorderStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderBottomWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderLeftWidth: '0'
});
const $f47963be7d20baa6$var$fullCellBorderStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightWidth: 'border.width'
});
const $f47963be7d20baa6$var$noColumnCellBorderStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightWidth: '0'
});
const $f47963be7d20baa6$var$noRowCellBorderStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightWidth: 'border.width'
});
const $f47963be7d20baa6$var$cellBorderLocationStyleMap = {
    FULL_BORDER: $f47963be7d20baa6$var$fullCellBorderStyles,
    NO_COLUMN_BORDER: $f47963be7d20baa6$var$noColumnCellBorderStyles,
    ROW_BORDER_FOR_EXPANDED_TOP_LEVEL_ONLY: $f47963be7d20baa6$var$noRowCellBorderStyles
};
const $f47963be7d20baa6$var$loadingCellStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-radius-small, 3px)",
    padding: 'space.150',
    width: '100%'
});

});

parcelRegister("eoeem", function(module, exports) {
$parcel$export(module.exports, "ChildRowsPagination", () => $be4eddbd2c1894e4$export$74d2c2d9ae144c85);

var $iwVRt = parcelRequire("iwVRt");

var $421q3 = parcelRequire("421q3");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $jE8Tu = parcelRequire("jE8Tu");

var $dLXgn = parcelRequire("dLXgn");

var $4gytc = parcelRequire("4gytc");

var $7Slu4 = parcelRequire("7Slu4");
const $be4eddbd2c1894e4$var$PACKAGE_LOCATION = 'jira-issue-table-hierarchy-child-rows-pagination';
const $be4eddbd2c1894e4$export$74d2c2d9ae144c85 = ({ query: query, depth: depth, parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, parentIssueAri: parentIssueAri, parentItemConnectionId: parentItemConnectionId, parentIssueRelayConnectionId: parentIssueRelayConnectionId, parentIssueHierarchyLevel: parentIssueHierarchyLevel, isFormVisible: isFormVisible, formProps: formProps, connectionMetadata: connectionMetadata, projectKey: projectKey, pageSize: pageSize, childItemsExperience: childItemsExperience, childItemsLoadMoreExperience: childItemsLoadMoreExperience, analyticsSource: analyticsSource, isIssueRankDescending: isIssueRankDescending, groupId: groupId, width: width, columns: columns, rankFieldId: rankFieldId, renderRows: renderRows, renderCreateIssueController: renderCreateIssueController, renderDraggableWrapper: renderDraggableWrapper, ChildIssueCreateRowComponent: ChildIssueCreateRowComponent, isTimelineEnabled: isTimelineEnabled })=>{
    const { data: queryData, loadNext: loadNext, isLoadingNext: isLoadingNext, hasNext: hasNext } = (0, $j4oe4.usePaginationFragment)((0, $421q3.default), query);
    const issueResultsData = (0, $j4oe4.useFragment)((0, $iwVRt.default), queryData?.jira?.issueSearch);
    const { type: type } = connectionMetadata || {};
    const isGroupChildren = type === 'GROUP_CHILDREN';
    const onCreateIssueRef = (0, $eJOHy.useRef)();
    const setOnCreateIssue = (0, $eJOHy.useCallback)((onCreateIssue)=>{
        onCreateIssueRef.current = onCreateIssue;
    }, []);
    // Set the issue count on the group record if needed
    (0, $4gytc.useUpdateGroupIssueCountOnExpand)({
        groupId: groupId,
        isGroupChildren: isGroupChildren,
        totalIssueSearchResultCount: issueResultsData.totalIssueSearchResultCount || 0,
        isCappingIssueSearchResult: issueResultsData.isCappingIssueSearchResult ?? false
    });
    const onExperienceLoadMoreStart = (0, $8Uqf3.useExperienceStart)({
        experience: childItemsLoadMoreExperience,
        analyticsSource: analyticsSource
    });
    const onExperienceLoadMoreFail = (0, $aqnJa.useExperienceFail)({
        experience: childItemsLoadMoreExperience,
        attributes: {}
    });
    const onExperienceLoadMoreSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: childItemsLoadMoreExperience,
        attributes: {}
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: childItemsExperience,
        attributes: {}
    });
    (0, $eJOHy.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    const childConnectionId = issueResultsData.__id;
    const [isSelected] = (0, $jE8Tu.useIsSelected)({
        itemsConnectionId: itemsConnectionId,
        groupId: groupId,
        itemId: parentItemId
    });
    const siblingIssueId = issueResultsData.edges?.[0]?.node?.id;
    const isChildIssueCreateRowVisible = isSelected && !!formProps && isFormVisible;
    if ((0, $cxKOj.expVal)('jira_list_realtime_updates_with_queue', 'isEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4gytc.useUpdateHierarchyHasChildrenOnExpand)({
        connectionMetadata: connectionMetadata,
        projectKey: projectKey,
        childCount: issueResultsData.edges?.length ?? 0
    });
    const connectionDetails = (0, $eJOHy.useMemo)(()=>{
        if (issueResultsData?.edges?.length === undefined || issueResultsData.edges.length === 0 && !isChildIssueCreateRowVisible || !connectionMetadata) return undefined;
        return {
            connectionId: childConnectionId,
            // This is the value the backend uses to fetch the issue list for realtime updates. It should be the connection length + 1
            // to ensure a potentially newly created issue is also fetched and included in the results.
            first: issueResultsData.edges.length + 1,
            ...connectionMetadata,
            ...(0, $4cTDP.fg)('jira_inline_field_config_gate') ? {
                fieldSetsData: queryData?.jira?.issueSearch
            } : {}
        };
    }, [
        childConnectionId,
        connectionMetadata,
        isChildIssueCreateRowVisible,
        issueResultsData.edges?.length,
        queryData?.jira?.issueSearch
    ]);
    (0, $dLXgn.useRegisterConnection)(connectionDetails);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onCompleteLoadNextItems = (0, $eJOHy.useCallback)((error)=>{
        if (!error) onExperienceLoadMoreSuccess();
        else onExperienceLoadMoreFail($be4eddbd2c1894e4$var$PACKAGE_LOCATION, error);
    }, [
        onExperienceLoadMoreFail,
        onExperienceLoadMoreSuccess
    ]);
    const loadNextItems = (0, $eJOHy.useCallback)(()=>{
        onExperienceLoadMoreStart();
        const actionSubjectId = isGroupChildren ? 'groupingLoadMore' : 'hierarchyLoadMore';
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', actionSubjectId);
        loadNext(pageSize, {
            onComplete: onCompleteLoadNextItems
        });
    }, [
        pageSize,
        onExperienceLoadMoreStart,
        isGroupChildren,
        createAnalyticsEvent,
        loadNext,
        onCompleteLoadNextItems
    ]);
    const renderChildIssueCreateRow = (0, $eJOHy.useCallback)(()=>{
        if (!isChildIssueCreateRowVisible || !onCreateIssueRef.current) return null;
        // Use custom child issue create row component if available, otherwise fallback to default
        const ResolvedChildIssueCreateRowComponent = ChildIssueCreateRowComponent ?? (0, $7Slu4.ChildIssueCreateRow);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ResolvedChildIssueCreateRowComponent, {
            canShowAdditionalFields: !isTimelineEnabled,
            depth: depth,
            parentIssueAri: parentIssueAri,
            siblingIssueId: siblingIssueId,
            isFormVisible: isFormVisible ?? false,
            ...formProps,
            width: width,
            isIssueRankDescending: isIssueRankDescending,
            onCreateIssue: onCreateIssueRef.current,
            columns: columns,
            rankFieldId: rankFieldId,
            isGrouping: !!groupId && (0, $4cTDP.fg)('jira_list_merged_column_gate')
        });
    }, [
        ChildIssueCreateRowComponent,
        groupId,
        isChildIssueCreateRowVisible,
        depth,
        parentIssueAri,
        siblingIssueId,
        isFormVisible,
        formProps,
        width,
        isIssueRankDescending,
        columns,
        rankFieldId,
        isTimelineEnabled
    ]);
    const renderChildRowsBody = (0, $eJOHy.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderCreateIssueController({
            childConnectionId: issueResultsData.__id,
            parentItemConnectionId: parentItemConnectionId,
            setOnCreateIssue: setOnCreateIssue,
            ...(0, $4cTDP.fg)('jira_timeline_analytics_harmonization_v2') && {
                location: 'childCreateForm'
            }
        }), renderRows({
            issueResults: issueResultsData,
            depth: depth + 1,
            parentItemId: parentItemId,
            itemsConnectionId: itemsConnectionId,
            parentIssueAri: parentIssueAri,
            parentItemConnectionId: parentItemConnectionId,
            parentIssueHierarchyLevel: parentIssueHierarchyLevel,
            isLoadingNext: isLoadingNext,
            hasNext: hasNext,
            rankFieldId: rankFieldId,
            onLoadNextItems: loadNextItems,
            renderChildIssueCreateRow: renderChildIssueCreateRow,
            isChildIssueCreateRowVisible: isChildIssueCreateRowVisible,
            parentIssueRelayConnectionId: parentIssueRelayConnectionId,
            ...(0, $4cTDP.fg)('jsc_list_reparenting') ? {
                projectKey: projectKey
            } : {}
        }));
    }, [
        renderCreateIssueController,
        issueResultsData,
        parentItemConnectionId,
        setOnCreateIssue,
        renderRows,
        depth,
        parentItemId,
        itemsConnectionId,
        parentIssueAri,
        parentIssueHierarchyLevel,
        isLoadingNext,
        hasNext,
        rankFieldId,
        loadNextItems,
        renderChildIssueCreateRow,
        isChildIssueCreateRowVisible,
        parentIssueRelayConnectionId,
        projectKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderDraggableWrapper ? renderDraggableWrapper({
        instanceId: issueResultsData?.__id,
        issueConnectionId: childConnectionId,
        children: renderChildRowsBody()
    }) : renderChildRowsBody());
};

});
parcelRegister("iwVRt", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b6ce500613f9b6f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1b9698876d560ce474eec32b7ab079e1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6b6ce500613f9b6f$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRemoteLinkedIssuesEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "ChildRowsPagination_issues",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        },
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isEditableSyncLoaded",
                    "variableName": "isEditableSyncLoaded"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isRemoteLinkedIssuesEnabled",
                    "variableName": "isRemoteLinkedIssuesEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "Rows"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$6b6ce500613f9b6f$var$node.hash = "b41b28271e30b6150b5a8c8974c3f123";
var $6b6ce500613f9b6f$export$2e2bcd8739ae039 = $6b6ce500613f9b6f$var$node;

});

parcelRegister("421q3", function(module, exports) {
$parcel$export(module.exports, "default", () => $676a896a1f35c26c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3584899a04f97d7b36b8766f7bb7f630>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $bbOzl = parcelRequire("bbOzl");
const $676a896a1f35c26c$var$node = function() {
    var v0 = [
        "jira",
        "issueSearch"
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isEditableSyncLoaded"
            },
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isRemoteLinkedIssuesEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $bbOzl.default)
            }
        },
        "name": "ChildRowsPagination",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "issueSearch",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "fieldSetsInput",
                                        "variableName": "fieldSetsInput"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "issueSearchInput",
                                        "variableName": "issueSearchInput"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "options",
                                        "variableName": "options"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "scope",
                                        "variableName": "scope"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "viewConfigInput",
                                        "variableName": "viewConfigInput"
                                    }
                                ],
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "__hierarchy_nativeIssueTable__issueSearch_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            },
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v1 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "isConditionalFormattingEnabled",
                                                "variableName": "isConditionalFormattingEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isDensityFull",
                                                "variableName": "isDensityFull"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isEditableSyncLoaded",
                                                "variableName": "isEditableSyncLoaded"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isInlineEditingEnabled",
                                                "variableName": "isInlineEditingEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isLinkRelationshipFieldEnabled",
                                                "variableName": "isLinkRelationshipFieldEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isRemoteLinkedIssuesEnabled",
                                                "variableName": "isRemoteLinkedIssuesEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isReparentingEnabled",
                                                "variableName": "isReparentingEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isTimelineEnabled",
                                                "variableName": "isTimelineEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "projectKey",
                                                "variableName": "projectKey"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "projectKeys",
                                                "variableName": "projectKeys"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "shouldQueryHasChildren",
                                                "variableName": "shouldQueryHasChildren"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "ChildRowsPagination_issues"
                                    },
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "InlineDataFragmentSpread",
                                                "name": "getSelectedOptions",
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "first",
                                                                        "value": 500
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueFieldSetConnection",
                                                                "kind": "LinkedField",
                                                                "name": "fieldSets",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueFieldSetEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueFieldSet",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v2 /*: any*/ ,
                                                                                    {
                                                                                        "concreteType": "JiraIssueFieldConnection",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "fields",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssueFieldEdge",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "edges",
                                                                                                "plural": true,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "node",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v1 /*: any*/ ,
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "fieldId"
                                                                                                            },
                                                                                                            v2 /*: any*/ ,
                                                                                                            {
                                                                                                                "kind": "InlineFragment",
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "concreteType": "JiraOptionConnection",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "selectedOptions",
                                                                                                                        "plural": false,
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "concreteType": "JiraOptionEdge",
                                                                                                                                "kind": "LinkedField",
                                                                                                                                "name": "edges",
                                                                                                                                "plural": true,
                                                                                                                                "selections": [
                                                                                                                                    {
                                                                                                                                        "concreteType": "JiraOption",
                                                                                                                                        "kind": "LinkedField",
                                                                                                                                        "name": "node",
                                                                                                                                        "plural": false,
                                                                                                                                        "selections": [
                                                                                                                                            {
                                                                                                                                                "kind": "ScalarField",
                                                                                                                                                "name": "id"
                                                                                                                                            },
                                                                                                                                            {
                                                                                                                                                "kind": "ScalarField",
                                                                                                                                                "name": "value"
                                                                                                                                            }
                                                                                                                                        ]
                                                                                                                                    },
                                                                                                                                    v3 /*: any*/ 
                                                                                                                                ]
                                                                                                                            }
                                                                                                                        ]
                                                                                                                    }
                                                                                                                ],
                                                                                                                "type": "JiraCheckboxesField"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "InlineFragment",
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "concreteType": "JiraOption",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "fieldOption",
                                                                                                                        "plural": false,
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "kind": "ScalarField",
                                                                                                                                "name": "optionId"
                                                                                                                            }
                                                                                                                        ]
                                                                                                                    }
                                                                                                                ],
                                                                                                                "type": "JiraSingleSelectField"
                                                                                                            },
                                                                                                            v3 /*: any*/ 
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    v3 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "fieldSets(first:500)"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "argumentDefinitions": []
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasPreviousPage"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "startCursor"
                                            }
                                        ]
                                    },
                                    v3 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.issueSearch"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$676a896a1f35c26c$var$node.hash = "7f004c25a1c439aa277ae00a3fd220b3";
var $676a896a1f35c26c$export$2e2bcd8739ae039 = $676a896a1f35c26c$var$node;

});
parcelRegister("bbOzl", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ed5f211adfb19db$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3851a5f5cb4a338d52efb204cf47f71d>>
 * @relayHash 985947e4f99db2a58ae5604e5807717a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c897c1640cefb4d61df56b5b0474272e60f41dcd0209f1141eb1b8cdeaeeda2d

var $3Bt2F = parcelRequire("3Bt2F");

var $3jVIX = parcelRequire("3jVIX");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $lS5zB = parcelRequire("lS5zB");

var $2Z4v6 = parcelRequire("2Z4v6");

var $hRj2m = parcelRequire("hRj2m");

var $6AioA = parcelRequire("6AioA");

var $04qit = parcelRequire("04qit");

var $jvWSl = parcelRequire("jvWSl");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $1fipb = parcelRequire("1fipb");

var $iOvkB = parcelRequire("iOvkB");

var $FU9UR = parcelRequire("FU9UR");
const $7ed5f211adfb19db$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isDensityFull"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isEditableSyncLoaded"
    }, v8 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "isInlineEditingEnabled"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJscIFCEnabled"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLinkRelationshipFieldEnabled"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRemoteLinkedIssuesEnabled"
    }, v12 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isReparentingEnabled"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v22 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v23 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ], v24 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v25 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v26 = {
        "kind": "ScalarField",
        "name": "id"
    }, v27 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v28 = {
        "kind": "ScalarField",
        "name": "key"
    }, v29 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v30 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v31 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v32 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v33 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v32 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v34 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "name"
    }, v36 = [
        v35 /*: any*/ 
    ], v37 = {
        "kind": "ScalarField",
        "name": "isRemoteIssue"
    }, v38 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v39 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v40 = [
        v35 /*: any*/ ,
        v26 /*: any*/ 
    ], v41 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v42 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v43 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v44 = {
        "kind": "ScalarField",
        "name": "type"
    }, v45 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v46 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v47 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v48 = {
        "kind": "ScalarField",
        "name": "value"
    }, v49 = [
        v48 /*: any*/ ,
        v26 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v50 = {
        "condition": "isInlineEditingEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lazyIsEditableInIssueView"
                    }
                ]
            }
        ]
    }, v51 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v52 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v53 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v54 = {
        "kind": "ScalarField",
        "name": "date"
    }, v55 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v56 = {
        "kind": "ScalarField",
        "name": "text"
    }, v57 = {
        "condition": "isEditableSyncLoaded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditableInIssueView"
            }
        ]
    }, v58 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v26 /*: any*/ 
        ]
    }, v59 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v60 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v56 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v61 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v62 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v63 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v64 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v65 = [
        {
            "kind": "ScalarField",
            "name": "appType"
        }
    ], v66 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v67 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v68 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v69 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v70 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v71 = [
        v26 /*: any*/ 
    ], v72 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v71 /*: any*/ 
    }, v73 = {
        "kind": "ClientExtension",
        "selections": [
            v39 /*: any*/ 
        ]
    }, v74 = {
        "kind": "ScalarField",
        "name": "href"
    }, v75 = [
        v74 /*: any*/ 
    ], v76 = {
        "kind": "ScalarField",
        "name": "direction"
    }, v77 = {
        "concreteType": "JiraIssueType",
        "kind": "LinkedField",
        "name": "issueType",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            v29 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v78 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v79 = {
        "kind": "InlineFragment",
        "selections": [
            v54 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v80 = [
        v24 /*: any*/ ,
        v47 /*: any*/ ,
        v79 /*: any*/ ,
        v26 /*: any*/ 
    ], v81 = [
        v24 /*: any*/ ,
        v79 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": v71 /*: any*/ ,
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ], v82 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "issue",
                    "plural": false,
                    "selections": [
                        v26 /*: any*/ ,
                        v27 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                                v77 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraParentIssueField",
                            "kind": "LinkedField",
                            "name": "parentIssueField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "parentIssue",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                },
                                v26 /*: any*/ 
                            ]
                        },
                        v28 /*: any*/ ,
                        v34 /*: any*/ ,
                        {
                            "concreteType": "JiraSingleSelectUserPickerField",
                            "kind": "LinkedField",
                            "name": "assigneeField",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        v62 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                },
                                v26 /*: any*/ 
                            ]
                        },
                        {
                            "args": v78 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "startDateViewField",
                            "plural": false,
                            "selections": v80 /*: any*/ ,
                            "storageKey": "startDateViewField(viewId:\"list_default\")"
                        },
                        {
                            "args": v78 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "endDateViewField",
                            "plural": false,
                            "selections": v80 /*: any*/ ,
                            "storageKey": "endDateViewField(viewId:\"list_default\")"
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "aggregatedStartDateViewField",
                                    "plural": false,
                                    "selections": v81 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "aggregatedEndDateViewField",
                                    "plural": false,
                                    "selections": v81 /*: any*/ 
                                }
                            ],
                            "type": "JiraAggregatedTimelineField"
                        }
                    ]
                }
            ],
            "type": "JiraTimelineVirtualField",
            "abstractKey": "__isJiraTimelineVirtualField"
        }
    ], v83 = [
        v24 /*: any*/ ,
        v26 /*: any*/ 
    ], v84 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v85 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v86 = [
        v24 /*: any*/ ,
        v79 /*: any*/ ,
        v26 /*: any*/ 
    ], v87 = {
        "args": v78 /*: any*/ ,
        "kind": "LinkedField",
        "name": "startDateViewField",
        "plural": false,
        "selections": v86 /*: any*/ ,
        "storageKey": "startDateViewField(viewId:\"list_default\")"
    }, v88 = {
        "args": v78 /*: any*/ ,
        "kind": "LinkedField",
        "name": "endDateViewField",
        "plural": false,
        "selections": v86 /*: any*/ ,
        "storageKey": "endDateViewField(viewId:\"list_default\")"
    }, v89 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "tableBody_issueTableHierarchy_childIssuesPaginationQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isConditionalFormattingEnabled",
                            "variableName": "isConditionalFormattingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isDensityFull",
                            "variableName": "isDensityFull"
                        },
                        {
                            "kind": "Variable",
                            "name": "isEditableSyncLoaded",
                            "variableName": "isEditableSyncLoaded"
                        },
                        {
                            "kind": "Variable",
                            "name": "isInlineEditingEnabled",
                            "variableName": "isInlineEditingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isLinkRelationshipFieldEnabled",
                            "variableName": "isLinkRelationshipFieldEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isRemoteLinkedIssuesEnabled",
                            "variableName": "isRemoteLinkedIssuesEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isReparentingEnabled",
                            "variableName": "isReparentingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isTimelineEnabled",
                            "variableName": "isTimelineEnabled"
                        },
                        v22 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKeys",
                            "variableName": "projectKeys"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldQueryHasChildren",
                            "variableName": "shouldQueryHasChildren"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "ChildRowsPagination"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiratimelinecustomissuelinkrelationnamesenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "tableBody_issueTableHierarchy_childIssuesPaginationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v23 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v24 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        v26 /*: any*/ 
                                                    ]
                                                },
                                                v30 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": v36 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isRemoteLinkedIssuesEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v37 /*: any*/ ,
                                                        v38 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v39 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isDensityFull",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canBeExported"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isLinkRelationshipFieldEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v37 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": v40 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isReparentingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v41 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v42 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v36 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v43 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v44 /*: any*/ ,
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v46 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        v24 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v44 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "serviceId"
                                                                                                                        },
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraAffectedServicesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "cascadingOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v49 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "childOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v49 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCascadingSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "objectId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "label"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "clientId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "fileId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "url48"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "QueryError",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "errors",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "message"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCMDBField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedComponentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v53 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v54 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v55 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDatePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "dateTime"
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraEpic",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "epic",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v41 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color"
                                                                                                        },
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraEpicLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "renderedFieldHtml"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFallbackField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v56 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v31 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v32 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedLabelsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v58 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraLabelsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v42 /*: any*/ ,
                                                                                                        v35 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraColorField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueColorField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v58 /*: any*/ ,
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueTypeField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v59 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v60 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "issuetype",
                                                                                                                                "project",
                                                                                                                                "summary",
                                                                                                                                "status"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v24 /*: any*/ ,
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                v56 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        v61 /*: any*/ ,
                                                                                                                                                        v35 /*: any*/ ,
                                                                                                                                                        v59 /*: any*/ ,
                                                                                                                                                        v29 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "status",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "statusCategory",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v26 /*: any*/ ,
                                                                                                                                                                v31 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraStatusField"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v61 /*: any*/ ,
                                                                                                                                v29 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "summaryField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v47 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v33 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraParentIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "large"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraResolution",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "resolution",
                                                                                                    "plural": false,
                                                                                                    "selections": v40 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraResolutionField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedSprintsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "sprintId"
                                                                                                                        },
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "state"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "endDate"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSprintField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v24 /*: any*/ ,
                                                                                                        v35 /*: any*/ ,
                                                                                                        v62 /*: any*/ ,
                                                                                                        v63 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v64 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "TypeDiscriminator",
                                                                                                                    "abstractKey": "__isUser"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": v65 /*: any*/ ,
                                                                                                                    "type": "AppUser"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": v65 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "AppUser"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v55 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraRichText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "richText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraADF",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "adfValue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "isDensityFull",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "isDensityFull",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "json"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRichTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "requestType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v59 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "first",
                                                                                                            "value": 1
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLinkConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "statusCategory"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v24 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v32 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                        },
                                                                                                                                                        v26 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        v30 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v26 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v66 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isStoryPointField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "number"
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "formatConfig",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatStyle"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatUnit"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraNumberField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "commentSummary",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canAddComment"
                                                                                                        },
                                                                                                        v46 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCommentSummaryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "uri"
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraUrlField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v48 /*: any*/ ,
                                                                                                        v58 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v67 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v48 /*: any*/ ,
                                                                                                                        v67 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v48 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCheckboxesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedUsersConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v24 /*: any*/ ,
                                                                                                                        v64 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v62 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v63 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "email"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraTeamView",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedTeam",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedId"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedName"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraTeamViewField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v50 /*: any*/ ,
                                                                                                                        v68 /*: any*/ ,
                                                                                                                        v69 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v44 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v68 /*: any*/ ,
                                                                                                                        v69 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v44 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v50 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "label",
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "value"
                                                                                                        },
                                                                                                        v26 /*: any*/ ,
                                                                                                        v52 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraRadioSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v53 /*: any*/ ,
                                                                                                                        v70 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                v72 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGoals",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                v35 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "status"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v73 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                },
                                                                                                v50 /*: any*/ ,
                                                                                                v73 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraGoalsField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v72 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isLinkEditable"
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraTownsquareProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v26 /*: any*/ ,
                                                                                                                {
                                                                                                                    "alias": "atlasProjectName",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "name"
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": "atlasProjectKey",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "key"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "privateProject"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "hasPermission"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWorkspaceActive"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconName"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v50 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTownsquareProjectField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v74 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "pageContent",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v24 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": v75 /*: any*/ ,
                                                                                                                                            "type": "JiraConfluencePageContentDetails"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v46 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGroupsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "groupId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraFlag",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "flag",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isFlagged"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFlagField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraWatch",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "watch",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "count"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isWatching"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraWatchesField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "isLinkRelationshipFieldEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLink",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v26 /*: any*/ ,
                                                                                                                v76 /*: any*/ ,
                                                                                                                v66 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "type",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v71 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v57 /*: any*/ ,
                                                                                                        v50 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkRelationshipTypeField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "isTimelineEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": v82 /*: any*/ ,
                                                                                                    "type": "JiraTimelineField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": v82 /*: any*/ ,
                                                                                                    "type": "JiraAggregatedTimelineField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v73 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isConditionalFormattingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v51 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "componentId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "priorityId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "projectId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersion",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "version",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v70 /*: any*/ ,
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v61 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v83 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSelectableValueConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValues",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v83 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldSets(first:500)"
                                        },
                                        {
                                            "condition": "shouldQueryHasChildren",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "filterByProjectKeys",
                                                            "variableName": "projectKeys"
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "hasChildren"
                                                },
                                                {
                                                    "args": [
                                                        v22 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "canHaveChildIssues"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isRemoteLinkedIssuesEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "issueError",
                                                    "plural": false,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "errorType"
                                                                },
                                                                {
                                                                    "concreteType": "JiraRemoteLinkedIssueRepairLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "repairLink",
                                                                    "plural": false,
                                                                    "selections": v75 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraRemoteLinkedIssueError"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v73 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v84 /*: any*/ ,
                                        v85 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasPreviousPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startCursor"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isTimelineEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v43 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v45 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v24 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v87 /*: any*/ ,
                                                                                                                v88 /*: any*/ ,
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraTimelineField"
                                                                                                },
                                                                                                v26 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                            "kind": "LinkedField",
                                                            "name": "assigneeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                },
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        v77 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraParentIssueField",
                                                            "kind": "LinkedField",
                                                            "name": "parentIssueField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                },
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraStatusField",
                                                            "kind": "LinkedField",
                                                            "name": "statusField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": v36 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        v60 /*: any*/ ,
                                                        {
                                                            "args": v89 /*: any*/ ,
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinks",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiratimelinecustomissuelinkrelationnamesenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        v76 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v26 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v87 /*: any*/ ,
                                                                                        v88 /*: any*/ ,
                                                                                        v27 /*: any*/ ,
                                                                                        v28 /*: any*/ ,
                                                                                        v26 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiratimelinecustomissuelinkrelationnamesenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": false,
                                                                                    "selections": [
                                                                                        v66 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v24 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v25 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "PageInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "pageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v84 /*: any*/ ,
                                                                        v85 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinks(first:10)"
                                                        },
                                                        {
                                                            "args": v89 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "timeline_jira_issueLinks",
                                                            "kind": "LinkedHandle",
                                                            "name": "issueLinks"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v73 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v43 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v73 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v73 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v23 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "issueSearchInput",
                                "options",
                                "fieldSetsInput",
                                "viewConfigInput",
                                "scope"
                            ],
                            "handle": "connection",
                            "key": "hierarchy_nativeIssueTable__issueSearch",
                            "kind": "LinkedHandle",
                            "name": "issueSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c897c1640cefb4d61df56b5b0474272e60f41dcd0209f1141eb1b8cdeaeeda2d",
            "metadata": {},
            "name": "tableBody_issueTableHierarchy_childIssuesPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "isJscIFCEnabled": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": (0, $04qit.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $6AioA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": (0, $1fipb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiratimelinecustomissuelinkrelationnamesenabledrelayprovider": (0, $lS5zB.default)
            }
        }
    };
}();
$7ed5f211adfb19db$var$node.hash = "7f004c25a1c439aa277ae00a3fd220b3";
var $7ed5f211adfb19db$export$2e2bcd8739ae039 = $7ed5f211adfb19db$var$node;

});


parcelRegister("4gytc", function(module, exports) {
$parcel$export(module.exports, "useUpdateHierarchyHasChildrenOnExpand", () => $c9ddcf47968a6013$export$7ab3d5838740f061);
$parcel$export(module.exports, "useUpdateGroupIssueCountOnExpand", () => $c9ddcf47968a6013$export$60baf22d0466329d);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kqd31 = parcelRequire("kqd31");
const $c9ddcf47968a6013$export$7ab3d5838740f061 = ({ connectionMetadata: connectionMetadata, projectKey: projectKey, childCount: childCount })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    (0, $eJOHy.useEffect)(()=>{
        if (connectionMetadata?.type === 'PARENT_CHILDREN' && childCount === 0) (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            const parentIssueRecord = store.get(connectionMetadata.parentRelayId);
            const updateArgs = projectKey ? {
                filterByProjectKeys: [
                    projectKey
                ]
            } : undefined;
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            if (parentIssueRecord && parentIssueRecord.getValue('hasChildren', updateArgs) === true) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            parentIssueRecord.setValue(false, 'hasChildren', updateArgs);
        });
    }, [
        childCount,
        connectionMetadata,
        environment,
        projectKey
    ]);
};
const $c9ddcf47968a6013$export$60baf22d0466329d = ({ groupId: groupId, isGroupChildren: isGroupChildren, totalIssueSearchResultCount: totalIssueSearchResultCount, isCappingIssueSearchResult: isCappingIssueSearchResult })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    // we need to update the group only once when the component mounts which happens on first expand
    // Other changes to issue count will be handled by realtime connection updates
    // also, we don't need to update the "firstGroup" field in the group record as it's expanded on default and realtime event always updates it
    const hasIssueCountUpdated = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (!hasIssueCountUpdated.current && groupId && isGroupChildren) (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            const relayId = (0, $kqd31.default)({
                id: groupId
            }, 'JiraSpreadsheetGroup');
            if (!relayId) return;
            const groupRecord = store.get(relayId);
            if (groupRecord?.getValue('issueCount') !== totalIssueSearchResultCount && !isCappingIssueSearchResult) groupRecord?.setValue(totalIssueSearchResultCount, 'issueCount');
        });
        hasIssueCountUpdated.current = true;
    }, [
        environment,
        groupId,
        isCappingIssueSearchResult,
        isGroupChildren,
        totalIssueSearchResultCount
    ]);
};

});

parcelRegister("7Slu4", function(module, exports) {
$parcel$export(module.exports, "ChildIssueCreateRow", () => $ab6d35972ebfb79a$export$3a3a78b432b7032f);

var $eJOHy = parcelRequire("eJOHy");

var $gOwRD = parcelRequire("gOwRD");
const $ab6d35972ebfb79a$export$3a3a78b432b7032f = ({ isFormVisible: isFormVisible, ...props })=>{
    return isFormVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gOwRD.IssueCreateCell), props));
};

});
parcelRegister("gOwRD", function(module, exports) {
$parcel$export(module.exports, "IssueCreateCell", () => $1a3532c480c6bbee$export$2337c3632571bf46);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6xIZT = parcelRequire("6xIZT");
const $1a3532c480c6bbee$export$2337c3632571bf46 = ({ parentIssueAri: parentIssueAri, siblingIssueId: siblingIssueId, depth: depth, isIssueRankDescending: isIssueRankDescending, width: width, onCreateIssue: onCreateIssue, rankFieldId: rankFieldId, ...props })=>{
    const formContextualFields = (0, $eJOHy.useMemo)(()=>isIssueRankDescending ? {
            rankAfterIssueId: siblingIssueId,
            rankFieldId: rankFieldId
        } : {
            rankBeforeIssueId: siblingIssueId,
            rankFieldId: rankFieldId
        }, [
        isIssueRankDescending,
        siblingIssueId,
        rankFieldId
    ]);
    const handleIssueCreate = (0, $eJOHy.useCallback)((issueToCreate, contextualFields)=>{
        onCreateIssue(issueToCreate, {
            ...contextualFields,
            parentIssueAri: parentIssueAri
        }, {
            insertAfter: false,
            insertNodeId: siblingIssueId
        });
    }, [
        onCreateIssue,
        parentIssueAri,
        siblingIssueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "td",
        xcss: $1a3532c480c6bbee$var$cellStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $1a3532c480c6bbee$var$boxStyles,
        style: {
            width: `${width}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6xIZT.default), {
        contextualFields: formContextualFields,
        onCreateIssue: handleIssueCreate,
        depth: depth + 1,
        rankFieldId: rankFieldId,
        ...props
    })));
};
const $1a3532c480c6bbee$var$cellStyles = (0, $1DXK0.xcss)({
    height: '40px',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.0',
    position: 'sticky',
    zIndex: 'card'
});
const $1a3532c480c6bbee$var$boxStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});

});




parcelRegister("NWRt9", function(module, exports) {
$parcel$export(module.exports, "FirstGroupRow", () => $ba5c06f69d989bc8$export$ac1801bcb8e0f256);
$parcel$export(module.exports, "GroupRow", () => $ba5c06f69d989bc8$export$84aac6ac2cec7eed);

var $7HQTV = parcelRequire("7HQTV");

var $2cJIS = parcelRequire("2cJIS");

var $gJArL = parcelRequire("gJArL");

var $eJOHy = parcelRequire("eJOHy");

var $8sbs2 = parcelRequire("8sbs2");

var $j4oe4 = parcelRequire("j4oe4");

var $68iTT = parcelRequire("68iTT");

var $cHtIB = parcelRequire("cHtIB");

var $4cTDP = parcelRequire("4cTDP");

var $jE8Tu = parcelRequire("jE8Tu");

var $9AekN = parcelRequire("9AekN");

var $3mZMJ = parcelRequire("3mZMJ");

var $8ntPR = parcelRequire("8ntPR");

var $a23vo = parcelRequire("a23vo");

var $4k0Ma = parcelRequire("4k0Ma");

var $hqK6S = parcelRequire("hqK6S");
const $ba5c06f69d989bc8$var$toGroupContextFieldInput = ({ fieldId: fieldId, fieldValue: fieldValue, groupId: groupId, fieldType: fieldType, fieldSetId: fieldSetId })=>{
    const groupFieldValueBase = {
        fieldId: fieldId,
        groupId: groupId,
        optimisticResponse: fieldSetId ? $ba5c06f69d989bc8$export$6afa27f3196791b2({
            fieldType: fieldType,
            fieldSetId: fieldSetId,
            fieldValue: fieldValue
        }) : undefined
    };
    switch(fieldValue?.__typename){
        case 'JiraJqlPriorityFieldValue':
            return {
                ...groupFieldValueBase,
                fieldType: (0, $3mZMJ.PRIORITY_TYPE),
                fieldValue: fieldValue?.priority?.priorityId ?? null
            };
        case 'JiraJqlUserFieldValue':
            return (0, $8ntPR.isUserFieldType)(fieldType) ? {
                ...groupFieldValueBase,
                fieldType: fieldType,
                fieldValue: fieldValue?.user?.accountId ?? null
            } : undefined;
        case 'JiraJqlStatusFieldValue':
            return {
                ...groupFieldValueBase,
                fieldType: (0, $3mZMJ.STATUS_TYPE),
                fieldValue: fieldValue?.status?.id ?? null
            };
        case 'JiraJqlNumberFieldValue':
            return {
                ...groupFieldValueBase,
                fieldType: (0, $3mZMJ.NUMBER_CF_TYPE),
                fieldValue: fieldValue?.number ?? null
            };
        case 'JiraJqlOptionFieldValue':
            return (0, $8ntPR.isOptionFieldType)(fieldType) ? {
                ...groupFieldValueBase,
                fieldType: fieldType,
                fieldValue: fieldValue?.option?.optionId ?? null
            } : undefined;
        case 'JiraJqlSprintFieldValue':
            return {
                ...groupFieldValueBase,
                fieldType: (0, $3mZMJ.SPRINT_TYPE),
                fieldValue: fieldValue?.sprint?.sprintId ?? null
            };
        case 'JiraJqlLabelFieldValue':
            return (0, $8ntPR.isLabelFieldType)(fieldType) ? {
                ...groupFieldValueBase,
                fieldType: fieldType,
                fieldValue: fieldValue?.label?.name ?? null
            } : undefined;
        case 'JiraJqlGroupFieldValue':
            return (0, $8ntPR.isGroupPickerFieldType)(fieldType) ? {
                ...groupFieldValueBase,
                fieldType: fieldType,
                fieldValue: fieldValue?.group?.name ?? null
            } : undefined;
        case 'JiraJqlVersionFieldValue':
            return (0, $8ntPR.isVersionFieldType)(fieldType) ? {
                ...groupFieldValueBase,
                fieldType: fieldType,
                fieldValue: fieldValue?.version?.versionId ?? null
            } : undefined;
        default:
            return undefined;
    }
};
const $ba5c06f69d989bc8$export$6afa27f3196791b2 = ({ fieldType: fieldType, fieldSetId: fieldSetId, fieldValue: fieldValue })=>{
    if (!fieldSetId) return undefined;
    switch(fieldType){
        case 0, $3mZMJ.PRIORITY_TYPE:
            if (fieldValue?.__typename === 'JiraJqlPriorityFieldValue' && fieldValue?.priority) return {
                type: (0, $3mZMJ.PRIORITY_TYPE),
                fieldSetId: fieldSetId,
                priority: {
                    id: fieldValue.priority.priorityId,
                    name: fieldValue.priority.name,
                    iconUrl: fieldValue.priority.iconUrl
                }
            };
            break;
        case 0, $3mZMJ.ASSIGNEE_TYPE:
        case 0, $3mZMJ.REPORTER_TYPE:
        case 0, $3mZMJ.USER_CF_TYPE:
            return {
                type: fieldType,
                fieldSetId: fieldSetId,
                user: fieldValue?.__typename === 'JiraJqlUserFieldValue' && fieldValue?.user ? {
                    id: fieldValue.user.accountId,
                    accountId: fieldValue.user.accountId,
                    name: fieldValue.user.name,
                    picture: fieldValue.user.picture
                } : null
            };
        case 0, $3mZMJ.STATUS_TYPE:
            if (fieldValue?.__typename === 'JiraJqlStatusFieldValue' && fieldValue?.status && fieldValue?.status.statusCategory) return {
                type: (0, $3mZMJ.STATUS_TYPE),
                fieldSetId: fieldSetId,
                status: {
                    id: fieldValue.status.id,
                    name: fieldValue.status.name,
                    statusId: fieldValue.status.id,
                    statusCategory: {
                        statusCategoryId: fieldValue.status.statusCategory.statusCategoryId,
                        id: fieldValue.status.statusCategory.id
                    }
                }
            };
            break;
        case 0, $3mZMJ.SELECT_CF_TYPE:
        case 0, $3mZMJ.MULTI_SELECT_CF_TYPE:
        case 0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE:
        case 0, $3mZMJ.RADIO_BUTTONS_CF_TYPE:
        case 0, $3mZMJ.CATEGORY_TYPE:
            return {
                type: fieldType,
                fieldSetId: fieldSetId,
                option: fieldValue?.__typename === 'JiraJqlOptionFieldValue' && fieldValue?.option ? {
                    id: fieldValue.option.optionId,
                    value: fieldValue.option.value,
                    optionId: fieldValue.option.optionId,
                    color: fieldValue.option.color ? {
                        colorKey: fieldValue.option.color.colorKey,
                        id: fieldValue.option.color.id
                    } : undefined
                } : null
            };
        case 0, $3mZMJ.SPRINT_TYPE:
            return {
                type: (0, $3mZMJ.SPRINT_TYPE),
                fieldSetId: fieldSetId,
                sprint: fieldValue?.__typename === 'JiraJqlSprintFieldValue' && fieldValue?.sprint ? {
                    id: fieldValue.sprint.sprintId,
                    sprintId: fieldValue.sprint.sprintId,
                    name: fieldValue.sprint.name,
                    state: fieldValue.sprint.state,
                    endDate: fieldValue.sprint.endDate
                } : null
            };
        case 0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE:
            return {
                type: (0, $3mZMJ.NUMBER_CF_TYPE),
                value: fieldValue?.__typename === 'JiraJqlNumberFieldValue' ? fieldValue.number : null,
                fieldSetId: fieldSetId
            };
        case 0, $3mZMJ.NUMBER_CF_TYPE:
            return {
                type: (0, $3mZMJ.NUMBER_CF_TYPE),
                value: fieldValue?.__typename === 'JiraJqlNumberFieldValue' ? fieldValue.number : null,
                fieldSetId: fieldSetId,
                isStoryPointField: true
            };
        case 0, $3mZMJ.LABELS_TYPE:
        case 0, $3mZMJ.LABELS_CF_TYPE:
            return {
                type: (0, $4cTDP.fg)('group_by_any_field') ? fieldType : (0, $3mZMJ.LABELS_TYPE),
                value: fieldValue?.__typename === 'JiraJqlLabelFieldValue' ? fieldValue.label?.name ?? null : null,
                fieldSetId: fieldSetId
            };
        case 0, $3mZMJ.MULTI_GROUP_CF_TYPE:
            return {
                type: (0, $3mZMJ.MULTI_GROUP_CF_TYPE),
                value: fieldValue?.__typename === 'JiraJqlGroupFieldValue' && fieldValue?.group ? {
                    id: fieldValue.group.id,
                    groupId: fieldValue.group.groupId,
                    name: fieldValue.group.name
                } : null,
                fieldSetId: fieldSetId
            };
        case 0, $3mZMJ.MULTI_VERSION_CF_TYPE:
        case 0, $3mZMJ.AFFECTS_VERSIONS_TYPE:
        case 0, $3mZMJ.FIX_VERSIONS_TYPE:
            return {
                type: fieldType,
                fieldSetId: fieldSetId,
                version: fieldValue?.__typename === 'JiraJqlVersionFieldValue' && fieldValue?.version ? {
                    id: fieldValue.version.id,
                    name: fieldValue.version.name ?? '',
                    versionId: fieldValue.version.versionId
                } : null
            };
        default:
            return undefined;
    }
};
const $ba5c06f69d989bc8$export$ac1801bcb8e0f256 = /*#__PURE__*/ (0, $eJOHy.memo)(({ firstGroupRow: firstGroupRow, rankField: rankField, groupConnectionId: groupConnectionId, isVirtual: isVirtual, loading: loading, isGroupAtTop: isGroupAtTop, projectKey: projectKey = null, columns: columns, actionColumns: actionColumns, amountOfColumns: amountOfColumns, isHideDoneItemsEnabled: isHideDoneItemsEnabled, isTimelineEnabled: isTimelineEnabled, pageSize: pageSize, childItemsExperience: childItemsExperience, childItemsLoadMoreExperience: childItemsLoadMoreExperience, analyticsSource: analyticsSource, width: width, isIssueRankDescending: isIssueRankDescending, isIssueCreateEnabled: isIssueCreateEnabled, isGridNavigationEnabled: isGridNavigationEnabled, renderRows: renderRows, renderCreateIssueController: renderCreateIssueController, renderDraggableWrapper: renderDraggableWrapper, isConditionalFormattingEnabled: isConditionalFormattingEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isStickyColumnsVisible: isStickyColumnsVisible, isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled, ChildIssueCreateRowComponent: ChildIssueCreateRowComponent, isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled, isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled, isEditableSyncLoaded: isEditableSyncLoaded, isInlineEditingEnabled: isInlineEditingEnabled })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const firstGroupRowData = (0, $j4oe4.useFragment)((0, $gJArL.default), firstGroupRow);
    const variables = (0, $eJOHy.useMemo)(()=>{
        return {
            ...(0, $9AekN.getChildQueryVariablesForJql)({
                cloudId: cloudId,
                columns: columns,
                jql: firstGroupRowData.jql,
                isReparentingEnabled: false,
                isTimelineEnabled: isTimelineEnabled,
                actionColumns: actionColumns,
                amountOfColumns: amountOfColumns,
                pageSize: pageSize,
                isHideDoneItemsEnabled: isHideDoneItemsEnabled,
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
                isInlineEditingEnabled: isInlineEditingEnabled,
                isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
                isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
                isEditableSyncLoaded: isEditableSyncLoaded
            }),
            shouldQueryFieldSetsById: false,
            namespace: 'ISSUE_NAVIGATOR',
            shouldQueryHasChildren: false,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled
        };
    }, [
        cloudId,
        columns,
        firstGroupRowData.jql,
        isTimelineEnabled,
        actionColumns,
        amountOfColumns,
        pageSize,
        isConditionalFormattingEnabled,
        isHideDoneItemsEnabled,
        isInlineFieldConfigEnabled,
        isInlineEditingEnabled,
        isLinkRelationshipFieldEnabled,
        isRemoteLinkedIssuesEnabled,
        isEditableSyncLoaded
    ]);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $2cJIS.default), rankField);
    const baseProps = [
        'cloudId',
        'issueSearchInput',
        'fieldSetsInput',
        'scope'
    ];
    const propsWithViewConfigInput = [
        ...baseProps,
        'viewConfigInput'
    ];
    const hasInitialised = (0, $4k0Ma.useInitialiseFirstGroupIssues)({
        groupId: firstGroupRowData.id,
        groupConnectionId: groupConnectionId,
        firstGroupItemsConnectionId: firstGroupRowData.issues?.__id ?? null,
        issueSearchVariables: (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(variables, ...isHideDoneItemsEnabled ? propsWithViewConfigInput : baseProps),
        loading: loading
    });
    const [isExpanded] = (0, $jE8Tu.useIsItemExpanded)({
        itemId: firstGroupRowData.id,
        groupId: firstGroupRowData.id,
        itemsConnectionId: groupConnectionId
    });
    const inlineCreateHandlers = (0, $68iTT.useInlineCreateHandlers)({
        projectKey: projectKey,
        defaultAssigneeId: firstGroupRowData.fieldType === (0, $3mZMJ.ASSIGNEE_TYPE) ? firstGroupRowData.fieldValue?.user?.id : undefined,
        minHierarchyLevel: 0
    });
    const { fieldId: fieldId, fieldType: fieldType } = firstGroupRowData;
    let groupContextFieldInput;
    if (fieldId && fieldType) groupContextFieldInput = $ba5c06f69d989bc8$var$toGroupContextFieldInput({
        fieldType: fieldType,
        fieldId: fieldId,
        fieldValue: firstGroupRowData.fieldValue,
        groupId: firstGroupRowData.id,
        fieldSetId: firstGroupRowData.fieldSetId
    });
    const renderChildIssueControllerWithGroupContextField = (0, $eJOHy.useCallback)((args)=>{
        return renderCreateIssueController?.({
            ...args,
            groupContextFieldInput: groupContextFieldInput
        });
    }, [
        renderCreateIssueController,
        groupContextFieldInput
    ]);
    const renderRowsWithGroupContextField = (0, $eJOHy.useCallback)((args)=>{
        return renderRows?.({
            ...args,
            groupContextFieldInput: groupContextFieldInput
        });
    }, [
        renderRows,
        groupContextFieldInput
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isVirtual && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hqK6S.GroupHeader), {
        projectKey: projectKey,
        groupHeader: firstGroupRowData,
        groupConnectionId: groupConnectionId,
        isGroupAtTop: isGroupAtTop,
        createChildTriggerProps: inlineCreateHandlers?.triggerProps,
        columnsCount: columns.length,
        groupId: firstGroupRowData.id,
        isIssueCreateEnabled: isIssueCreateEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isStickyColumnsVisible: isStickyColumnsVisible,
        isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled
    }), hasInitialised && isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a23vo.FirstGroupIssues), {
        variables: variables,
        rankField: rankFieldData ?? null,
        groupId: firstGroupRowData.id,
        groupConnectionId: groupConnectionId,
        groupFieldValue: firstGroupRowData.fieldValue?.jqlTerm ?? null,
        formProps: inlineCreateHandlers?.formProps,
        isFormVisible: inlineCreateHandlers?.isFormVisible,
        pageSize: pageSize,
        width: width,
        isIssueRankDescending: isIssueRankDescending,
        childItemsExperience: childItemsExperience,
        childItemsLoadMoreExperience: childItemsLoadMoreExperience,
        analyticsSource: analyticsSource,
        renderRows: (0, $4cTDP.fg)('group_by_any_field_sibling_inline_issue_create') ? renderRowsWithGroupContextField : renderRows,
        renderCreateIssueController: renderChildIssueControllerWithGroupContextField,
        renderDraggableWrapper: renderDraggableWrapper,
        ChildIssueCreateRowComponent: ChildIssueCreateRowComponent,
        isTimelineEnabled: isTimelineEnabled
    }));
});
const $ba5c06f69d989bc8$export$84aac6ac2cec7eed = /*#__PURE__*/ (0, $eJOHy.memo)(({ groupRow: groupRow, groupConnectionId: groupConnectionId, isVirtual: isVirtual, projectKey: projectKey = null, columns: columns, isIssueCreateEnabled: isIssueCreateEnabled, isGridNavigationEnabled: isGridNavigationEnabled, isStickyColumnsVisible: isStickyColumnsVisible, isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled, renderChildRows: renderChildRows })=>{
    const groupRowData = (0, $j4oe4.useFragment)((0, $7HQTV.default), groupRow);
    const inlineCreateHandlers = (0, $68iTT.useInlineCreateHandlers)({
        projectKey: projectKey,
        defaultAssigneeId: groupRowData.fieldType === (0, $3mZMJ.ASSIGNEE_TYPE) ? groupRowData.fieldValue?.user?.id : undefined,
        minHierarchyLevel: 0
    });
    const { fieldId: fieldId, fieldType: fieldType } = groupRowData;
    let groupContextField;
    if (fieldId && fieldType) groupContextField = $ba5c06f69d989bc8$var$toGroupContextFieldInput({
        fieldType: fieldType,
        fieldId: fieldId,
        fieldValue: groupRowData.fieldValue,
        groupId: groupRowData.id,
        fieldSetId: groupRowData.fieldSetId
    });
    return groupRowData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isVirtual && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hqK6S.GroupHeader), {
        projectKey: projectKey,
        groupHeader: groupRowData,
        groupConnectionId: groupConnectionId,
        createChildTriggerProps: inlineCreateHandlers?.triggerProps,
        columnsCount: columns.length,
        groupId: groupRowData.id,
        isIssueCreateEnabled: isIssueCreateEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isStickyColumnsVisible: isStickyColumnsVisible,
        isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled
    }), renderChildRows?.({
        parentItemId: groupRowData.id,
        itemsConnectionId: groupConnectionId,
        depth: 0,
        type: 'GROUP_CHILDREN',
        groupFieldValue: groupRowData.fieldValue?.jqlTerm ?? null,
        groupJql: groupRowData.jql,
        formProps: inlineCreateHandlers?.formProps,
        isFormVisible: inlineCreateHandlers?.isFormVisible,
        groupId: groupRowData.id,
        groupContextField: groupContextField
    }));
});

});
parcelRegister("7HQTV", function(module, exports) {
$parcel$export(module.exports, "default", () => $d832e05cf37e4c0b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4707d11394ed8d1871a152ce55c7af1c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d832e05cf37e4c0b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "FirstGroupRow_GroupRow",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "jql"
                },
                "action": "THROW",
                "path": "jql"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "fieldType"
            },
            {
                "kind": "ScalarField",
                "name": "fieldSetId"
            },
            {
                "kind": "LinkedField",
                "name": "fieldValue",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jqlTerm"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "priorityId"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "iconUrl"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlPriorityFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlUserFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "statusCategoryId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlStatusFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ],
                        "type": "JiraJqlNumberFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "option",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "optionId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            },
                                            v0 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlOptionFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "sprint",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlSprintFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "label",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlLabelFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "group",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "groupId"
                                    },
                                    v1 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlGroupFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "versionId"
                                    },
                                    v1 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlVersionFieldValue"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "GroupHeader"
            }
        ],
        "type": "JiraSpreadsheetGroup"
    };
}();
$d832e05cf37e4c0b$var$node.hash = "a52879ddb058e5a555c580af3ede9fbe";
var $d832e05cf37e4c0b$export$2e2bcd8739ae039 = $d832e05cf37e4c0b$var$node;

});

parcelRegister("2cJIS", function(module, exports) {
$parcel$export(module.exports, "default", () => $d59184d91d299e01$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3d7e5d20e0b6fe59f2b9427e40e88324>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d59184d91d299e01$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "FirstGroupRow_rankField",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "FirstGroupIssues"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$d59184d91d299e01$var$node.hash = "7036d2690ec547661beb6083ae77c4c9";
var $d59184d91d299e01$export$2e2bcd8739ae039 = $d59184d91d299e01$var$node;

});

parcelRegister("gJArL", function(module, exports) {
$parcel$export(module.exports, "default", () => $284aa56021077a67$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cc546f19888560bf73ee6e3a63f3bb9b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $284aa56021077a67$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isEditableSyncLoaded"
            },
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isRemoteLinkedIssuesEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "viewConfigInput"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "issues"
                    ]
                }
            ]
        },
        "name": "FirstGroupRow",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "jql"
                },
                "action": "THROW",
                "path": "jql"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "fieldType"
            },
            {
                "kind": "ScalarField",
                "name": "fieldSetId"
            },
            {
                "kind": "LinkedField",
                "name": "fieldValue",
                "plural": false,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "jqlTerm"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "priorityId"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "iconUrl"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlPriorityFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlUserFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "statusCategoryId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlStatusFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ],
                        "type": "JiraJqlNumberFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "option",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "optionId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            },
                                            v0 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlOptionFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "sprint",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlSprintFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "label",
                                "plural": false,
                                "selections": [
                                    v2 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlLabelFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "group",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "groupId"
                                    },
                                    v2 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlGroupFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "versionId"
                                    },
                                    v2 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlVersionFieldValue"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "GroupHeader"
            },
            {
                "alias": "issues",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "fieldSetsInput",
                        "variableName": "fieldSetsInput"
                    },
                    {
                        "kind": "Variable",
                        "name": "scope",
                        "variableName": "fieldSetsScope"
                    },
                    {
                        "kind": "Variable",
                        "name": "settings",
                        "variableName": "settings"
                    },
                    {
                        "kind": "Variable",
                        "name": "viewConfigInput",
                        "variableName": "viewConfigInput"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "__firstGroupSection_nativeIssueTable__issues_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "isConditionalFormattingEnabled",
                                "variableName": "isConditionalFormattingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "isDensityFull",
                                "variableName": "isDensityFull"
                            },
                            {
                                "kind": "Variable",
                                "name": "isEditableSyncLoaded",
                                "variableName": "isEditableSyncLoaded"
                            },
                            {
                                "kind": "Variable",
                                "name": "isInlineEditingEnabled",
                                "variableName": "isInlineEditingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "isLinkRelationshipFieldEnabled",
                                "variableName": "isLinkRelationshipFieldEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "isRemoteLinkedIssuesEnabled",
                                "variableName": "isRemoteLinkedIssuesEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "isReparentingEnabled",
                                "variableName": "isReparentingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "isTimelineEnabled",
                                "variableName": "isTimelineEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            },
                            {
                                "kind": "Literal",
                                "name": "shouldQueryHasChildren",
                                "value": false
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "ChildRowsPagination_issues"
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__id"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraSpreadsheetGroup"
    };
}();
$284aa56021077a67$var$node.hash = "7aa28decab9e13929ded4f5e22d3d8bf";
var $284aa56021077a67$export$2e2bcd8739ae039 = $284aa56021077a67$var$node;

});

parcelRegister("a23vo", function(module, exports) {
$parcel$export(module.exports, "FirstGroupIssues", () => $78949f6f69c2e45e$export$e2f0ecb1fcdc2610);

var $ap45P = parcelRequire("ap45P");

var $lswHj = parcelRequire("lswHj");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $eoeem = parcelRequire("eoeem");
const $78949f6f69c2e45e$export$e2f0ecb1fcdc2610 = ({ variables: variables, rankField: rankField, groupId: groupId, groupConnectionId: groupConnectionId, groupFieldValue: groupFieldValue, isFormVisible: isFormVisible, formProps: formProps, childItemsExperience: childItemsExperience, childItemsLoadMoreExperience: childItemsLoadMoreExperience, analyticsSource: analyticsSource, pageSize: pageSize, width: width, isIssueRankDescending: isIssueRankDescending, renderRows: renderRows, renderCreateIssueController: renderCreateIssueController, renderDraggableWrapper: renderDraggableWrapper, ChildIssueCreateRowComponent: ChildIssueCreateRowComponent, isTimelineEnabled: isTimelineEnabled })=>{
    const data = (0, $j4oe4.useLazyLoadQuery)((0, $lswHj.default), variables, {
        fetchPolicy: 'store-only'
    });
    const rankFieldData = (0, $j4oe4.useFragment)((0, $ap45P.default), rankField);
    const connectionMetadata = (0, $eJOHy.useMemo)(()=>variables.issueSearchInput.jql ? {
            type: 'GROUP_CHILDREN',
            fieldValue: groupFieldValue,
            groupId: groupId,
            jql: variables.issueSearchInput.jql
        } : undefined, [
        groupFieldValue,
        groupId,
        variables.issueSearchInput.jql
    ]);
    // Ensure relay cache is in correct state
    if (!data?.jira?.issueSearch?.edges) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eoeem.ChildRowsPagination), {
        query: data,
        depth: 0,
        parentItemId: groupId,
        groupId: groupId,
        itemsConnectionId: groupConnectionId,
        connectionMetadata: connectionMetadata,
        width: width,
        isIssueRankDescending: isIssueRankDescending,
        pageSize: pageSize,
        childItemsExperience: childItemsExperience,
        childItemsLoadMoreExperience: childItemsLoadMoreExperience,
        analyticsSource: analyticsSource,
        rankFieldId: rankFieldData?.fieldId ?? null,
        renderRows: renderRows,
        renderCreateIssueController: renderCreateIssueController,
        renderDraggableWrapper: renderDraggableWrapper,
        isFormVisible: isFormVisible,
        formProps: formProps,
        ChildIssueCreateRowComponent: ChildIssueCreateRowComponent,
        isTimelineEnabled: isTimelineEnabled
    });
};

});
parcelRegister("ap45P", function(module, exports) {
$parcel$export(module.exports, "default", () => $dce2ae318aaf183d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0c679e0018346be6c2b20c2cf821164d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dce2ae318aaf183d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "FirstGroupIssues",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$dce2ae318aaf183d$var$node.hash = "07fdb734208e30b5f6168c7a0d56cad5";
var $dce2ae318aaf183d$export$2e2bcd8739ae039 = $dce2ae318aaf183d$var$node;

});

parcelRegister("lswHj", function(module, exports) {
$parcel$export(module.exports, "default", () => $4361a5dfb5f12ff1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<018b5e3c606dffc47138f6469e1d82b6>>
 * @relayHash 3198ce47ff486e4328a676f5bb4d9a6c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5c4b1337b2d97bec2472669dd66c23ed8046d55a815ea0b653f894edaaad521

var $3Bt2F = parcelRequire("3Bt2F");

var $3jVIX = parcelRequire("3jVIX");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $lS5zB = parcelRequire("lS5zB");

var $2Z4v6 = parcelRequire("2Z4v6");

var $hRj2m = parcelRequire("hRj2m");

var $6AioA = parcelRequire("6AioA");

var $04qit = parcelRequire("04qit");

var $jvWSl = parcelRequire("jvWSl");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $1fipb = parcelRequire("1fipb");

var $iOvkB = parcelRequire("iOvkB");

var $FU9UR = parcelRequire("FU9UR");
const $4361a5dfb5f12ff1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isEditableSyncLoaded"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLinkRelationshipFieldEnabled"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRemoteLinkedIssuesEnabled"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v16 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v17 = {
        "kind": "Variable",
        "name": "fieldSetsInput",
        "variableName": "fieldSetsInput"
    }, v18 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v19 = {
        "kind": "Variable",
        "name": "options",
        "variableName": "options"
    }, v20 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v21 = {
        "kind": "Variable",
        "name": "viewConfigInput",
        "variableName": "viewConfigInput"
    }, v22 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v23 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v24 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v25 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v26 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v24 /*: any*/ ,
            v25 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            },
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v27 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v18 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ 
    ], v28 = {
        "kind": "ScalarField",
        "name": "id"
    }, v29 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "key"
    }, v31 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v32 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v33 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v34 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v35 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v34 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v36 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v37 = {
        "kind": "ScalarField",
        "name": "name"
    }, v38 = [
        v37 /*: any*/ 
    ], v39 = {
        "kind": "ScalarField",
        "name": "isRemoteIssue"
    }, v40 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v41 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v42 = [
        v37 /*: any*/ ,
        v28 /*: any*/ 
    ], v43 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v44 = {
        "kind": "ScalarField",
        "name": "type"
    }, v45 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v46 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v47 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v48 = {
        "kind": "ScalarField",
        "name": "value"
    }, v49 = [
        v48 /*: any*/ ,
        v28 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v50 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v51 = {
        "kind": "ClientExtension",
        "selections": [
            v50 /*: any*/ 
        ]
    }, v52 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v53 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v54 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v55 = {
        "kind": "ScalarField",
        "name": "date"
    }, v56 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v57 = {
        "kind": "ScalarField",
        "name": "text"
    }, v58 = {
        "condition": "isEditableSyncLoaded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditableInIssueView"
            }
        ]
    }, v59 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v28 /*: any*/ 
        ]
    }, v60 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v61 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v57 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v62 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v63 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v64 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v65 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v66 = [
        {
            "kind": "ScalarField",
            "name": "appType"
        }
    ], v67 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v68 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v69 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v70 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v71 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v72 = [
        v28 /*: any*/ 
    ], v73 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v72 /*: any*/ 
    }, v74 = {
        "kind": "ClientExtension",
        "selections": [
            v41 /*: any*/ 
        ]
    }, v75 = {
        "kind": "ScalarField",
        "name": "href"
    }, v76 = [
        v75 /*: any*/ 
    ], v77 = {
        "kind": "ScalarField",
        "name": "direction"
    }, v78 = {
        "concreteType": "JiraIssueType",
        "kind": "LinkedField",
        "name": "issueType",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            v31 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v79 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v80 = {
        "kind": "InlineFragment",
        "selections": [
            v55 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v81 = [
        v22 /*: any*/ ,
        v47 /*: any*/ ,
        v80 /*: any*/ ,
        v28 /*: any*/ 
    ], v82 = [
        v22 /*: any*/ ,
        v80 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": v72 /*: any*/ ,
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ], v83 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "issue",
                    "plural": false,
                    "selections": [
                        v28 /*: any*/ ,
                        v29 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                                v78 /*: any*/ ,
                                v28 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraParentIssueField",
                            "kind": "LinkedField",
                            "name": "parentIssueField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "parentIssue",
                                    "plural": false,
                                    "selections": [
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        v28 /*: any*/ 
                                    ]
                                },
                                v28 /*: any*/ 
                            ]
                        },
                        v30 /*: any*/ ,
                        v36 /*: any*/ ,
                        {
                            "concreteType": "JiraSingleSelectUserPickerField",
                            "kind": "LinkedField",
                            "name": "assigneeField",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v22 /*: any*/ ,
                                        v63 /*: any*/ ,
                                        v28 /*: any*/ 
                                    ]
                                },
                                v28 /*: any*/ 
                            ]
                        },
                        {
                            "args": v79 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "startDateViewField",
                            "plural": false,
                            "selections": v81 /*: any*/ ,
                            "storageKey": "startDateViewField(viewId:\"list_default\")"
                        },
                        {
                            "args": v79 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "endDateViewField",
                            "plural": false,
                            "selections": v81 /*: any*/ ,
                            "storageKey": "endDateViewField(viewId:\"list_default\")"
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "aggregatedStartDateViewField",
                                    "plural": false,
                                    "selections": v82 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "aggregatedEndDateViewField",
                                    "plural": false,
                                    "selections": v82 /*: any*/ 
                                }
                            ],
                            "type": "JiraAggregatedTimelineField"
                        }
                    ]
                }
            ],
            "type": "JiraTimelineVirtualField",
            "abstractKey": "__isJiraTimelineVirtualField"
        }
    ], v84 = [
        v22 /*: any*/ ,
        v28 /*: any*/ 
    ], v85 = [
        v22 /*: any*/ ,
        v80 /*: any*/ ,
        v28 /*: any*/ 
    ], v86 = {
        "args": v79 /*: any*/ ,
        "kind": "LinkedField",
        "name": "startDateViewField",
        "plural": false,
        "selections": v85 /*: any*/ ,
        "storageKey": "startDateViewField(viewId:\"list_default\")"
    }, v87 = {
        "args": v79 /*: any*/ ,
        "kind": "LinkedField",
        "name": "endDateViewField",
        "plural": false,
        "selections": v85 /*: any*/ ,
        "storageKey": "endDateViewField(viewId:\"list_default\")"
    }, v88 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FirstGroupIssuesQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isConditionalFormattingEnabled",
                            "variableName": "isConditionalFormattingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isEditableSyncLoaded",
                            "variableName": "isEditableSyncLoaded"
                        },
                        {
                            "kind": "Variable",
                            "name": "isLinkRelationshipFieldEnabled",
                            "variableName": "isLinkRelationshipFieldEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isRemoteLinkedIssuesEnabled",
                            "variableName": "isRemoteLinkedIssuesEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isTimelineEnabled",
                            "variableName": "isTimelineEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldQueryHasChildren",
                            "variableName": "shouldQueryHasChildren"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "ChildRowsPagination"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "issueSearch",
                            "args": [
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "__hierarchy_nativeIssueTable__issueSearch_connection",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v10 /*: any*/ ,
                v4 /*: any*/ ,
                v11 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v12 /*: any*/ ,
                v3 /*: any*/ ,
                v15 /*: any*/ ,
                v14 /*: any*/ ,
                v9 /*: any*/ ,
                v13 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiratimelinecustomissuelinkrelationnamesenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "FirstGroupIssuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v27 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v31 /*: any*/ ,
                                                                v28 /*: any*/ 
                                                            ]
                                                        },
                                                        v28 /*: any*/ 
                                                    ]
                                                },
                                                v32 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": v38 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isRemoteLinkedIssuesEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v39 /*: any*/ ,
                                                        v40 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v41 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isLinkRelationshipFieldEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v39 /*: any*/ ,
                                                        v40 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": v42 /*: any*/ 
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v43 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v44 /*: any*/ ,
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v46 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v28 /*: any*/ ,
                                                                                        v22 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v44 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "serviceId"
                                                                                                                        },
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v28 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraAffectedServicesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "cascadingOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v49 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "childOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v49 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCascadingSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "objectId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "label"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "clientId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "fileId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "url48"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "QueryError",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "errors",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "message"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCMDBField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v52 /*: any*/ ,
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedComponentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v53 /*: any*/ ,
                                                                                                                        v54 /*: any*/ ,
                                                                                                                        v28 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v55 /*: any*/ ,
                                                                                                v37 /*: any*/ ,
                                                                                                v56 /*: any*/ ,
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDatePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "dateTime"
                                                                                                },
                                                                                                v37 /*: any*/ ,
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraEpic",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "epic",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "summary"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color"
                                                                                                        },
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraEpicLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "renderedFieldHtml"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFallbackField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v57 /*: any*/ ,
                                                                                                v37 /*: any*/ ,
                                                                                                v58 /*: any*/ ,
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v37 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v37 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v34 /*: any*/ ,
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v52 /*: any*/ ,
                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedLabelsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v59 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                },
                                                                                                v37 /*: any*/ ,
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraLabelsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "small"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v37 /*: any*/ ,
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraColorField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueColorField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v59 /*: any*/ ,
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueTypeField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v60 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v28 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v61 /*: any*/ ,
                                                                                                        v28 /*: any*/ ,
                                                                                                        v29 /*: any*/ ,
                                                                                                        v40 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "issuetype",
                                                                                                                                "project",
                                                                                                                                "summary",
                                                                                                                                "status"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                        v28 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                v57 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v28 /*: any*/ ,
                                                                                                                                                        v62 /*: any*/ ,
                                                                                                                                                        v37 /*: any*/ ,
                                                                                                                                                        v60 /*: any*/ ,
                                                                                                                                                        v31 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "status",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v28 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "statusCategory",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v28 /*: any*/ ,
                                                                                                                                                                v33 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraStatusField"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v62 /*: any*/ ,
                                                                                                                                v31 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "summaryField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v47 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v35 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v37 /*: any*/ ,
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraParentIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v37 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v37 /*: any*/ ,
                                                                                                v58 /*: any*/ ,
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v37 /*: any*/ ,
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "large"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraResolution",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "resolution",
                                                                                                    "plural": false,
                                                                                                    "selections": v42 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraResolutionField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedSprintsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "sprintId"
                                                                                                                        },
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "state"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "endDate"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v37 /*: any*/ ,
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSprintField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        v37 /*: any*/ ,
                                                                                                        v63 /*: any*/ ,
                                                                                                        v64 /*: any*/ ,
                                                                                                        v28 /*: any*/ ,
                                                                                                        v65 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "TypeDiscriminator",
                                                                                                                    "abstractKey": "__isUser"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": v66 /*: any*/ ,
                                                                                                                    "type": "AppUser"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": v66 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "AppUser"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v56 /*: any*/ ,
                                                                                                v58 /*: any*/ ,
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraRichText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "richText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraADF",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "adfValue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "convertedPlainText",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "plainText"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRichTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "requestType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v37 /*: any*/ ,
                                                                                                        v60 /*: any*/ ,
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "first",
                                                                                                            "value": 1
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLinkConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v40 /*: any*/ ,
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "statusCategory"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v34 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                        },
                                                                                                                                                        v28 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        v32 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v28 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v67 /*: any*/ ,
                                                                                                                        v28 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isStoryPointField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "number"
                                                                                                },
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "formatConfig",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatStyle"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatUnit"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraNumberField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "commentSummary",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canAddComment"
                                                                                                        },
                                                                                                        v46 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCommentSummaryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "uri"
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraUrlField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v48 /*: any*/ ,
                                                                                                        v59 /*: any*/ ,
                                                                                                        v28 /*: any*/ ,
                                                                                                        v68 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v48 /*: any*/ ,
                                                                                                                        v68 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v48 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCheckboxesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedUsersConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v65 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v63 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v64 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "email"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraTeamView",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedTeam",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedId"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedName"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraTeamViewField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v69 /*: any*/ ,
                                                                                                                        v70 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v44 /*: any*/ ,
                                                                                                                        v51 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v69 /*: any*/ ,
                                                                                                                        v70 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v44 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v51 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "label",
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "value"
                                                                                                        },
                                                                                                        v28 /*: any*/ ,
                                                                                                        v53 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraRadioSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v52 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v53 /*: any*/ ,
                                                                                                                        v54 /*: any*/ ,
                                                                                                                        v71 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                v73 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v52 /*: any*/ ,
                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGoals",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v30 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                v37 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "status"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v74 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ClientExtension",
                                                                                                    "selections": [
                                                                                                        v41 /*: any*/ ,
                                                                                                        v50 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraGoalsField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v37 /*: any*/ ,
                                                                                                        v73 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isLinkEditable"
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraTownsquareProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                {
                                                                                                                    "alias": "atlasProjectName",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "name"
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": "atlasProjectKey",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "key"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "privateProject"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "hasPermission"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWorkspaceActive"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconName"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v51 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTownsquareProjectField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v52 /*: any*/ ,
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v75 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "pageContent",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": v76 /*: any*/ ,
                                                                                                                                            "type": "JiraConfluencePageContentDetails"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v46 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGroupsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "groupId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraFlag",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "flag",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isFlagged"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFlagField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraWatch",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "watch",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "count"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isWatching"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraWatchesField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "isLinkRelationshipFieldEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v37 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLink",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                v77 /*: any*/ ,
                                                                                                                v67 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "type",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v72 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v58 /*: any*/ ,
                                                                                                        v51 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkRelationshipTypeField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "isTimelineEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": v83 /*: any*/ ,
                                                                                                    "type": "JiraTimelineField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": v83 /*: any*/ ,
                                                                                                    "type": "JiraAggregatedTimelineField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v74 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isConditionalFormattingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v52 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "componentId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "priorityId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "projectId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersion",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "version",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v71 /*: any*/ ,
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v62 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v84 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSelectableValueConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValues",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v84 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldSets(first:500)"
                                        },
                                        {
                                            "condition": "shouldQueryHasChildren",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasChildren"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canHaveChildIssues"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isRemoteLinkedIssuesEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "issueError",
                                                    "plural": false,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "errorType"
                                                                },
                                                                {
                                                                    "concreteType": "JiraRemoteLinkedIssueRepairLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "repairLink",
                                                                    "plural": false,
                                                                    "selections": v76 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraRemoteLinkedIssueError"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v74 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                v26 /*: any*/ ,
                                {
                                    "condition": "isTimelineEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v43 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v45 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v86 /*: any*/ ,
                                                                                                                v87 /*: any*/ ,
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraTimelineField"
                                                                                                },
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                            "kind": "LinkedField",
                                                            "name": "assigneeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        v37 /*: any*/ ,
                                                                        v28 /*: any*/ 
                                                                    ]
                                                                },
                                                                v28 /*: any*/ 
                                                            ]
                                                        },
                                                        v78 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraParentIssueField",
                                                            "kind": "LinkedField",
                                                            "name": "parentIssueField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v29 /*: any*/ ,
                                                                        v28 /*: any*/ 
                                                                    ]
                                                                },
                                                                v28 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraStatusField",
                                                            "kind": "LinkedField",
                                                            "name": "statusField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": v38 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        v61 /*: any*/ ,
                                                        {
                                                            "args": v88 /*: any*/ ,
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinks",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiratimelinecustomissuelinkrelationnamesenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        v77 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v28 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v86 /*: any*/ ,
                                                                                        v87 /*: any*/ ,
                                                                                        v29 /*: any*/ ,
                                                                                        v30 /*: any*/ ,
                                                                                        v28 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiratimelinecustomissuelinkrelationnamesenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": false,
                                                                                    "selections": [
                                                                                        v67 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v22 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v23 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "PageInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "pageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        v25 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinks(first:10)"
                                                        },
                                                        {
                                                            "args": v88 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "timeline_jira_issueLinks",
                                                            "kind": "LinkedHandle",
                                                            "name": "issueLinks"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v74 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v43 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v74 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v74 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v27 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "issueSearchInput",
                                "options",
                                "fieldSetsInput",
                                "viewConfigInput",
                                "scope"
                            ],
                            "handle": "connection",
                            "key": "hierarchy_nativeIssueTable__issueSearch",
                            "kind": "LinkedHandle",
                            "name": "issueSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f5c4b1337b2d97bec2472669dd66c23ed8046d55a815ea0b653f894edaaad521",
            "metadata": {
                "connection": [
                    {
                        "count": null,
                        "cursor": null,
                        "direction": "bidirectional",
                        "path": [
                            "jira",
                            "issueSearch"
                        ]
                    }
                ]
            },
            "name": "FirstGroupIssuesQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": (0, $04qit.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $6AioA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": (0, $1fipb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiratimelinecustomissuelinkrelationnamesenabledrelayprovider": (0, $lS5zB.default)
            }
        }
    };
}();
$4361a5dfb5f12ff1$var$node.hash = "9aafb51c23bd65f5f8abb1f8f2b25741";
var $4361a5dfb5f12ff1$export$2e2bcd8739ae039 = $4361a5dfb5f12ff1$var$node;

});


parcelRegister("4k0Ma", function(module, exports) {
$parcel$export(module.exports, "useInitialiseFirstGroupIssues", () => $dd008cff549f4f94$export$3e4eaea282025a37);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $jE8Tu = parcelRequire("jE8Tu");
const $dd008cff549f4f94$var$JIRA = 'jira';
const $dd008cff549f4f94$var$HIERARCHY_ISSUE_SEARCH_CONNECTION = 'hierarchy_nativeIssueTable__issueSearch';
const $dd008cff549f4f94$var$JIRA_ISSUE_CONNECTION_TYPE = 'JiraIssueConnection';
const $dd008cff549f4f94$var$CONNECTION = 'connection';
const $dd008cff549f4f94$export$3e4eaea282025a37 = ({ groupId: groupId, groupConnectionId: groupConnectionId, firstGroupItemsConnectionId: firstGroupItemsConnectionId, issueSearchVariables: issueSearchVariables, loading: loading })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const hasInitialised = (0, $eJOHy.useRef)(false);
    const prevGroupConnectionId = (0, $eJOHy.useRef)(groupConnectionId);
    const prevFieldSetsInput = (0, $eJOHy.useRef)(issueSearchVariables.fieldSetsInput);
    const prevViewConfigInput = (0, $eJOHy.useRef)(issueSearchVariables.viewConfigInput);
    const prevLoading = (0, $eJOHy.useRef)(loading);
    const { setIsItemExpanded: setIsItemExpanded } = (0, $jE8Tu.useHierarchyActions)();
    // When firstGroupItemsConnectionId is available, if the groupConnectionId changes, fieldSetsInput change or view has finished loading, trigger re-initialisation
    if (!!firstGroupItemsConnectionId && (!loading && prevLoading.current || prevGroupConnectionId.current !== groupConnectionId || !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevFieldSetsInput.current, issueSearchVariables.fieldSetsInput) || !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevViewConfigInput.current, issueSearchVariables.viewConfigInput))) {
        hasInitialised.current = false;
        prevGroupConnectionId.current = groupConnectionId;
        prevFieldSetsInput.current = issueSearchVariables.fieldSetsInput;
        prevViewConfigInput.current = issueSearchVariables.viewConfigInput;
        prevLoading.current = loading;
    }
    if (!hasInitialised.current) {
        setIsItemExpanded({
            itemId: groupId,
            groupId: groupId,
            itemsConnectionId: groupConnectionId
        }, true);
        (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
            const firstGroupIssuesConnection = store.get(firstGroupItemsConnectionId ?? '');
            const jiraRecord = store.getRoot().getLinkedRecord($dd008cff549f4f94$var$JIRA);
            if (!firstGroupIssuesConnection || !jiraRecord) return;
            const connectionId = (0, $37Ewn.ConnectionHandler).getConnectionID(jiraRecord.getDataID(), $dd008cff549f4f94$var$HIERARCHY_ISSUE_SEARCH_CONNECTION, issueSearchVariables);
            // If connection already exists, update it with the latest data. This ensures the field sets are correct.
            let connection = store.get(connectionId);
            if (!connection) connection = store.create(connectionId, $dd008cff549f4f94$var$JIRA_ISSUE_CONNECTION_TYPE);
            connection.copyFieldsFrom(firstGroupIssuesConnection);
            jiraRecord.setLinkedRecord(connection, (0, $37Ewn.getRelayHandleKey)($dd008cff549f4f94$var$CONNECTION, $dd008cff549f4f94$var$HIERARCHY_ISSUE_SEARCH_CONNECTION), issueSearchVariables);
            hasInitialised.current = true;
        });
    }
    return hasInitialised.current;
};

});

parcelRegister("hqK6S", function(module, exports) {
$parcel$export(module.exports, "GroupHeader", () => $05c7b3019429c04e$export$58d63a2875c58fc8);

var $9RHmA = parcelRequire("9RHmA");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $jPROM = parcelRequire("jPROM");

var $j4oe4 = parcelRequire("j4oe4");

var $lT9x0 = parcelRequire("lT9x0");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $6efFi = parcelRequire("6efFi");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $lRq8t = parcelRequire("lRq8t");

var $3mZMJ = parcelRequire("3mZMJ");

var $4cTDP = parcelRequire("4cTDP");

var $jE8Tu = parcelRequire("jE8Tu");

var $2XtSM = parcelRequire("2XtSM");

var $3Ldj6 = parcelRequire("3Ldj6");

var $8ntPR = parcelRequire("8ntPR");

var $1W85r = parcelRequire("1W85r");

var $5FAgT = parcelRequire("5FAgT");

var $98A5p = parcelRequire("98A5p");

var $iqCxS = parcelRequire("iqCxS");

var $aaLj4 = parcelRequire("aaLj4");

var $k29Y8 = parcelRequire("k29Y8");

var $jiKXd = parcelRequire("jiKXd");

var $b8Nt1 = parcelRequire("b8Nt1");

var $cKV4K = parcelRequire("cKV4K");

var $9jwn7 = parcelRequire("9jwn7");

var $aLKjs = parcelRequire("aLKjs");

var $immik = parcelRequire("immik");

var $2mFVu = parcelRequire("2mFVu");

var $4zhkx = parcelRequire("4zhkx");

var $e0hmq = parcelRequire("e0hmq");

var $4z3Ld = parcelRequire("4z3Ld");
const $05c7b3019429c04e$var$isCompletedSprintGroup = (data)=>data?.fieldValue?.__typename === 'JiraJqlSprintFieldValue' && data.fieldValue.sprint?.state === 'CLOSED';
const $05c7b3019429c04e$var$isSubtaskGroup = (data)=>{
    return data.fieldValue?.__typename === 'JiraJqlIssueTypeFieldValue' && data.fieldValue.issueTypes?.[0]?.hierarchy?.level === -1;
};
const $05c7b3019429c04e$var$getGroupIssueTypeId = (data)=>{
    switch(data.fieldType){
        case 0, $3mZMJ.ISSUE_TYPE:
            return data.fieldValue?.issueTypes?.[0]?.issueTypeId;
        default:
            return null;
    }
};
const $05c7b3019429c04e$var$ONBOARDING_TARGET_NAME = 'issue-navigator-create-issue-in-group';
const $05c7b3019429c04e$export$58d63a2875c58fc8 = ({ groupHeader: groupHeader, groupConnectionId: groupConnectionId, createChildTriggerProps: createChildTriggerProps, isGroupAtTop: isGroupAtTop = false, columnsCount: columnsCount, groupId: groupId, isIssueCreateEnabled: isIssueCreateEnabled = true, isGridNavigationEnabled: isGridNavigationEnabled = false, isStickyColumnsVisible: isStickyColumnsVisible, isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const tableRowRef = (0, $eJOHy.useRef)(null);
    const data = (0, $j4oe4.useFragment)((0, $9RHmA.default), groupHeader);
    const itemDetails = (0, $eJOHy.useMemo)(()=>data ? {
            itemsConnectionId: groupConnectionId,
            itemId: data.id,
            groupId: groupId
        } : null, [
        data,
        groupConnectionId,
        groupId
    ]);
    const list = (0, $jE8Tu.useFlatList)();
    const [isSelected, { setSelectedRow: setSelectedRow }] = (0, $jE8Tu.useIsSelected)(itemDetails);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Scroll the table row into view (if needed - block: nearest) when it becomes selected
        if (isSelected) tableRowRef.current?.scrollIntoView({
            block: 'nearest'
        });
    }, [
        isSelected
    ]);
    const { setDefaultIssueType: setDefaultIssueType } = (0, $1W85r.useIICConfigActions)();
    const groupIssueTypeId = $05c7b3019429c04e$var$getGroupIssueTypeId(data);
    const focusCurrentRow = (0, $eJOHy.useCallback)(()=>{
        if (groupIssueTypeId && projectKey && (0, $4cTDP.fg)('group_by_any_field_issue_type_iic_fix')) setDefaultIssueType(projectKey, groupIssueTypeId);
        return setSelectedRow(itemDetails);
    }, [
        setSelectedRow,
        itemDetails,
        groupIssueTypeId,
        projectKey,
        setDefaultIssueType
    ]);
    const groupHeaderView = (0, $eJOHy.useMemo)(()=>{
        switch(data.fieldType){
            case 0, $3mZMJ.PRIORITY_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqCxS.PriorityGroupHeader), {
                    priorityGroupHeader: data.fieldValue ?? null
                });
            case 0, $3mZMJ.REPORTER_TYPE:
            case 0, $3mZMJ.ASSIGNEE_TYPE:
            case 0, $3mZMJ.USER_CF_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4zhkx.UserGroupHeader), {
                    userGroupHeader: data.fieldValue ?? null,
                    fieldType: data.fieldType
                });
            case 0, $3mZMJ.STATUS_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k29Y8.StatusGroupHeader), {
                    statusGroupHeader: data.fieldValue ?? null
                });
            case 0, $3mZMJ.NUMBER_CF_TYPE:
            case 0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jiKXd.StoryPointsGroupHeader), {
                    storyPointsGroupHeader: data.fieldValue ?? null
                });
            case 0, $3mZMJ.GOALS_CF_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b8Nt1.GoalGroupHeader), {
                    goalGroupHeader: data.fieldValue ?? null
                });
            case 0, $3mZMJ.ATLAS_PROJECT_CF_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4z3Ld.AtlasProjectGroupHeader), {
                    atlasProjectGroupHeader: data.fieldValue ?? null
                });
            case 0, $3mZMJ.CATEGORY_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5FAgT.CategoryGroupHeader), {
                    categoryGroupHeader: data.fieldValue ?? null
                });
            case 0, $3mZMJ.SELECT_CF_TYPE:
            case 0, $3mZMJ.MULTI_SELECT_CF_TYPE:
            case 0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE:
            case 0, $3mZMJ.RADIO_BUTTONS_CF_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $immik.OptionGroupHeader), {
                    optionGroupHeader: data.fieldValue ?? null,
                    fieldType: data.fieldType
                });
            case 0, $3mZMJ.SPRINT_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaLj4.SprintGroupHeader), {
                    sprintGroupHeader: data.fieldValue ?? null
                });
            case 0, $3mZMJ.LABELS_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cKV4K.LabelGroupHeader), {
                    labelGroupHeader: data.fieldValue ?? null
                });
            // TODO: combine with LABELS_TYPE once we've cleaned up the group_by_any_field flags
            case 0, $3mZMJ.LABELS_CF_TYPE:
                return (0, $4cTDP.fg)('group_by_any_field') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cKV4K.LabelGroupHeader), {
                    labelGroupHeader: data.fieldValue ?? null
                }) : null;
            case 0, $3mZMJ.ISSUE_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9jwn7.IssueTypeGroupHeader), {
                    issueTypeGroupHeader: data.fieldValue ?? null
                });
            case 0, $3mZMJ.GROUP_CF_TYPE:
            case 0, $3mZMJ.MULTI_GROUP_CF_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLKjs.GroupPickerGroupHeader), {
                    groupPickerGroupHeader: data.fieldValue ?? null
                });
            case 0, $3mZMJ.VERSION_CF_TYPE:
            case 0, $3mZMJ.MULTI_VERSION_CF_TYPE:
            case 0, $3mZMJ.AFFECTS_VERSIONS_TYPE:
            case 0, $3mZMJ.FIX_VERSIONS_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mFVu.VersionGroupHeader), {
                    versionGroupHeader: data.fieldValue ?? null,
                    fieldType: data.fieldType
                });
            case 0, $3mZMJ.RESOLUTION_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e0hmq.ResolutionGroupHeader), {
                    resolutionGroupHeader: data.fieldValue ?? null
                });
            default:
                // should never happen
                return null;
        }
    }, [
        data
    ]);
    const groupMetadata = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, groupHeaderView, !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(data?.issueCount) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            color: "color.text.subtlest"
        }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $98A5p.default).issuesIssueTermRefresh : (0, $98A5p.default).issues, {
            count: data.issueCount
        })));
    }, [
        data.issueCount,
        formatMessage,
        groupHeaderView
    ]);
    const [isExpanded, { toggleIsItemExpanded: toggleIsItemExpanded }] = (0, $jE8Tu.useIsItemExpanded)(itemDetails);
    const onCreateChildClick = (0, $eJOHy.useCallback)(()=>{
        if (groupIssueTypeId && projectKey && !(0, $4cTDP.fg)('group_by_any_field_issue_type_iic_fix')) setDefaultIssueType(projectKey, groupIssueTypeId);
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'groupCreateChildButton');
        if (!isExpanded) toggleIsItemExpanded(itemDetails, 0);
        createChildTriggerProps?.onClick();
    }, [
        createAnalyticsEvent,
        isExpanded,
        toggleIsItemExpanded,
        itemDetails,
        createChildTriggerProps,
        setDefaultIssueType,
        groupIssueTypeId,
        projectKey
    ]);
    const headerContent = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data.issueCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2XtSM.ExpandButton), {
            itemId: data.id,
            itemsConnectionId: groupConnectionId,
            depth: 0,
            isGroupButton: true,
            groupId: groupId
        }) : null, groupMetadata, isIssueCreateEnabled && (0, $8ntPR.isCreateIssueSupportedForFieldType)(data.fieldType) && !$05c7b3019429c04e$var$isCompletedSprintGroup(data) && !$05c7b3019429c04e$var$isSubtaskGroup(data) && (isGroupAtTop ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
            name: $05c7b3019429c04e$var$ONBOARDING_TARGET_NAME
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            className: (0, $hcewu.default)([
                "_kqswh2mm _yt1xcs5v"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Ldj6.default), {
            onClick: onCreateChildClick,
            ref: createChildTriggerProps?.ref,
            isCreateWorkItem: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lT9x0.EngagementSpotlight), {
            engagementId: $05c7b3019429c04e$var$ONBOARDING_TARGET_NAME
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            className: (0, $hcewu.default)([
                "_kqswh2mm _yt1xcs5v"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Ldj6.default), {
            onClick: onCreateChildClick,
            ref: createChildTriggerProps?.ref,
            isCreateWorkItem: true
        }))));
    }, [
        data,
        groupConnectionId,
        groupId,
        groupMetadata,
        isIssueCreateEnabled,
        isGroupAtTop,
        onCreateChildClick,
        createChildTriggerProps?.ref
    ]);
    const rowIndex = itemDetails ? list.indexOf(`${itemDetails.itemId}::${itemDetails.itemId}`) + 1 : -1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", {
        role: "row",
        tabIndex: -1,
        ...rowIndex > 0 && isGridNavigationEnabled && {
            'aria-rowindex': rowIndex
        },
        onFocus: focusCurrentRow,
        "data-testid": "issue-table-grouping.ui.group-row.group-header.tr",
        "aria-selected": isSelected,
        ref: tableRowRef,
        className: (0, $hcewu.default)([
            "_nt751r31 _49pcglyw _1hvw1o36 _irr319i6",
            isSelected && !isGridNavigationEnabled && "_bfhk15s3 _irr3ufnl",
            isGridNavigationEnabled && "_10j715s3 _1p0pufnl"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "td" // Additional column for configure columns menu & issue actions
        ,
        colSpan: columnsCount + 1,
        xcss: [
            $05c7b3019429c04e$var$borderStyles,
            isGroupAtTop && $05c7b3019429c04e$var$removeTopBorder,
            $05c7b3019429c04e$var$rowHeight,
            $05c7b3019429c04e$var$removeBottomBorder
        ],
        ...isGridNavigationEnabled && {
            tabIndex: -1
        }
    }, isStickyColumnsVisible && (0, $4cTDP.fg)('issue_table_frozen_columns') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "issue-table-grouping.ui.group-row.group-header.sticky-header",
        xcss: // eslint-disable-next-line no-nested-ternary
        (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? isAutoUnstickyOnSmallScreenEnabled ? $05c7b3019429c04e$var$stickyContainerResponsiveStyles : $05c7b3019429c04e$var$stickyContainerStyles : $05c7b3019429c04e$var$stickyContainerStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: [
            $05c7b3019429c04e$var$inlineStyles,
            !data.issueCount && $05c7b3019429c04e$var$placeholderStyles
        ],
        space: "space.100"
    }, headerContent)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: [
            $05c7b3019429c04e$var$inlineStyles,
            !data.issueCount && $05c7b3019429c04e$var$placeholderStyles
        ],
        space: "space.100"
    }, headerContent)));
};
const $05c7b3019429c04e$var$inlineStyles = (0, $1DXK0.xcss)({
    paddingInline: 'space.150',
    alignItems: 'center',
    gap: 'space.100'
});
const $05c7b3019429c04e$var$placeholderStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginLeft: 'space.400'
});
const $05c7b3019429c04e$var$stickyContainerStylesOld = (0, $1DXK0.xcss)({
    position: 'sticky',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.0',
    width: 'fit-content'
});
const $05c7b3019429c04e$var$stickyContainerStyles = (0, $1DXK0.xcss)({
    position: 'sticky',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.0',
    width: 'fit-content'
});
const $05c7b3019429c04e$var$stickyContainerResponsiveStyles = (0, $1DXK0.xcss)({
    [(0, $6efFi.media).above.md]: {
        position: 'sticky',
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        left: 'space.0',
        width: 'fit-content'
    }
});
const $05c7b3019429c04e$var$borderStyles = (0, $1DXK0.xcss)({
    border: 0,
    borderColor: 'color.border',
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderBottomWidth: 'border.width'
});
const $05c7b3019429c04e$var$removeTopBorder = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: '0'
});
const $05c7b3019429c04e$var$removeBottomBorder = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderBottomWidth: '0'
});
const $05c7b3019429c04e$var$headerRowStyles = null;
const $05c7b3019429c04e$var$headerRowKeyboardNavigationStyles = null;
const $05c7b3019429c04e$var$activeRowStyles = null;
const $05c7b3019429c04e$var$raiseOnHoverStyles = null;
const $05c7b3019429c04e$var$rowHeight = (0, $1DXK0.xcss)({
    height: "var(--ds-space-500, 40px)"
});

});
parcelRegister("9RHmA", function(module, exports) {
$parcel$export(module.exports, "default", () => $26276a63f6704493$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c30c64201d8c447494d4d8cf97eef649>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $26276a63f6704493$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "GroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldType"
        },
        {
            "kind": "ScalarField",
            "name": "issueCount"
        },
        {
            "kind": "LinkedField",
            "name": "fieldValue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "PriorityGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "UserGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "StatusGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "CategoryGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "OptionGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "VersionGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "SprintGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "StoryPointsGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "GoalGroupHeader"
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "AtlasProjectGroupHeader"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "LabelGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "IssueTypeGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "GroupPickerGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "ResolutionGroupHeader"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueTypes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                },
                                {
                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                    "kind": "LinkedField",
                                    "name": "hierarchy",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "level"
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "type": "JiraJqlIssueTypeFieldValue"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "JiraSprint",
                            "kind": "LinkedField",
                            "name": "sprint",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "state"
                                }
                            ]
                        }
                    ],
                    "type": "JiraJqlSprintFieldValue"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroup"
};
$26276a63f6704493$var$node.hash = "41baca64a8150960836113c6c55178c3";
var $26276a63f6704493$export$2e2bcd8739ae039 = $26276a63f6704493$var$node;

});

parcelRegister("2XtSM", function(module, exports) {
$parcel$export(module.exports, "ExpandButton", () => $e99284d207f534ad$export$5663c8f5aeb8c1c4);
$parcel$export(module.exports, "CreateChildButtonWithExpandToggle", () => $e99284d207f534ad$export$86df7a8824b06d6e);
$parcel$export(module.exports, "ExpandButtonWithCreateChildButton", () => $e99284d207f534ad$export$b921667debd4e0cb);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $1OQKp = parcelRequire("1OQKp");

var $cQxBL = parcelRequire("cQxBL");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $3Ldj6 = parcelRequire("3Ldj6");

var $jE8Tu = parcelRequire("jE8Tu");

var $d8783 = parcelRequire("d8783");

var $5XgIy = parcelRequire("5XgIy");
const $e99284d207f534ad$var$ICON_WIDTH = 24;
const $e99284d207f534ad$var$EXTRA_PADDING_ROW_WITHOUT_EXPAND = 8;
const $e99284d207f534ad$export$5663c8f5aeb8c1c4 = ({ itemId: itemId, itemsConnectionId: itemsConnectionId, depth: depth, isGroupButton: isGroupButton, groupId: groupId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isExpanded, { toggleIsItemExpanded: toggleIsItemExpanded }] = (0, $jE8Tu.useIsItemExpanded)({
        itemId: itemId,
        groupId: groupId,
        itemsConnectionId: itemsConnectionId
    });
    const onExpandClick = (0, $eJOHy.useCallback)(()=>{
        const actionSubjectId = isGroupButton ? 'groupExpandButton' : 'hierarchyExpandButton';
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', actionSubjectId);
        toggleIsItemExpanded({
            itemId: itemId,
            itemsConnectionId: itemsConnectionId,
            groupId: groupId
        }, depth);
    }, [
        createAnalyticsEvent,
        depth,
        itemId,
        itemsConnectionId,
        toggleIsItemExpanded,
        isGroupButton,
        groupId
    ]);
    const label = (0, $eJOHy.useMemo)(()=>{
        if (isGroupButton) return formatMessage(isExpanded ? (0, $d8783.default).collapseGroup : (0, $d8783.default).expandGroup);
        return formatMessage(isExpanded ? (0, $d8783.default).collapseIssue : (0, $d8783.default).expandIssue);
    }, [
        formatMessage,
        isExpanded,
        isGroupButton
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        spacing: "compact",
        appearance: "subtle",
        label: label,
        "aria-expanded": isExpanded,
        testId: "issue-table-hierarchy.ui.expand-button.expand-button",
        icon: (iconProps)=>isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                ...iconProps,
                size: "small"
            }),
        onClick: onExpandClick,
        isTooltipDisabled: false
    });
};
const $e99284d207f534ad$export$86df7a8824b06d6e = ({ itemId: itemId, groupId: groupId, itemsConnectionId: itemsConnectionId, isCreateChildFormVisible: isCreateChildFormVisible, depth: depth, isGroupButton: isGroupButton, createChildTriggerProps: createChildTriggerProps, renderIcon: renderIcon })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isInlineCreateChildOpen, setIsInlineCreateChildOpen] = (0, $eJOHy.useState)(false);
    const [isExpanded, { toggleIsItemExpanded: toggleIsItemExpanded }] = (0, $jE8Tu.useIsItemExpanded)({
        itemId: itemId,
        groupId: groupId,
        itemsConnectionId: itemsConnectionId
    });
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-reset-all-state-on-prop-change
    (0, $eJOHy.useEffect)(()=>{
        if (!isCreateChildFormVisible) // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
        setIsInlineCreateChildOpen(false);
    }, [
        isCreateChildFormVisible
    ]);
    const onCreateChildClick = (0, $eJOHy.useCallback)(()=>{
        const actionSubjectId = isGroupButton ? 'groupCreateChildButton' : 'hierarchyCreateChildButton';
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', actionSubjectId);
        if (!isExpanded) toggleIsItemExpanded({
            itemId: itemId,
            itemsConnectionId: itemsConnectionId
        }, depth);
        if (!isCreateChildFormVisible) createChildTriggerProps?.onClick();
        setIsInlineCreateChildOpen(true);
    }, [
        createAnalyticsEvent,
        createChildTriggerProps,
        depth,
        isCreateChildFormVisible,
        isExpanded,
        itemId,
        itemsConnectionId,
        toggleIsItemExpanded,
        isGroupButton
    ]);
    return !isInlineCreateChildOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Ldj6.default), {
        onClick: onCreateChildClick,
        ref: createChildTriggerProps?.ref,
        renderIcon: renderIcon
    });
};
const $e99284d207f534ad$export$b921667debd4e0cb = ({ itemId: itemId, itemsConnectionId: itemsConnectionId, depth: depth, hasChildren: hasChildren = true, isRowHoveredOrSelected: isRowHoveredOrSelected, showCreateChildButton: showCreateChildButton, createChildTriggerProps: createChildTriggerProps, isCreateChildFormVisible: isCreateChildFormVisible, isGroupButton: isGroupButton, groupId: groupId })=>{
    if (hasChildren) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        tabIndex: isRowHoveredOrSelected ? 0 : -1,
        xcss: [
            $e99284d207f534ad$var$cellStyle,
            !isGroupButton && $e99284d207f534ad$var$cellPaddingStyle
        ],
        "data-vc": "expand-button-with-create-child-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5XgIy.default), {
        depth: depth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $e99284d207f534ad$var$cellWrapperStyles,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            paddingLeft: `${$e99284d207f534ad$var$ICON_WIDTH * depth}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e99284d207f534ad$export$5663c8f5aeb8c1c4, {
        itemId: itemId,
        itemsConnectionId: itemsConnectionId,
        depth: depth,
        isGroupButton: isGroupButton,
        groupId: groupId
    })), showCreateChildButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e99284d207f534ad$export$86df7a8824b06d6e, {
        depth: depth,
        itemId: itemId,
        groupId: groupId,
        isGroupButton: isGroupButton,
        itemsConnectionId: itemsConnectionId,
        createChildTriggerProps: createChildTriggerProps,
        isCreateChildFormVisible: isCreateChildFormVisible
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        tabIndex: 0,
        xcss: $e99284d207f534ad$var$cellSizeStyle,
        "data-vc": "expand-button-with-create-child-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5XgIy.default), {
        depth: depth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $e99284d207f534ad$var$cellPaddingStyle,
        style: {
            paddingLeft: `${$e99284d207f534ad$var$ICON_WIDTH * depth + $e99284d207f534ad$var$ICON_WIDTH + $e99284d207f534ad$var$EXTRA_PADDING_ROW_WITHOUT_EXPAND}px`
        }
    }, showCreateChildButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e99284d207f534ad$export$86df7a8824b06d6e, {
        depth: depth,
        itemId: itemId,
        groupId: groupId,
        isGroupButton: isGroupButton,
        itemsConnectionId: itemsConnectionId,
        createChildTriggerProps: createChildTriggerProps,
        isCreateChildFormVisible: isCreateChildFormVisible
    })));
};
const $e99284d207f534ad$var$cellWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $e99284d207f534ad$var$cellSizeStyle = (0, $1DXK0.xcss)({
    height: '100%'
});
const $e99284d207f534ad$var$cellStyle = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
});
const $e99284d207f534ad$var$cellPaddingStyle = (0, $1DXK0.xcss)({
    padding: 'space.100'
});

});
parcelRegister("3Ldj6", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7c1775e33e0cf91$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dcLzM = parcelRequire("dcLzM");

var $Ay1uj = parcelRequire("Ay1uj");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $2DRCb = parcelRequire("2DRCb");
const $b7c1775e33e0cf91$var$getWorkItemMessage = ()=>(0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $2DRCb.default).createWorkItem : (0, $2DRCb.default).createIssue;
const $b7c1775e33e0cf91$var$CreateChildButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, isCreateWorkItem: isCreateWorkItem, renderIcon: renderIcon }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const defaultIcon = (0, $eJOHy.useCallback)((iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
            ...iconProps,
            size: "small"
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        spacing: "compact",
        appearance: "subtle",
        label: isCreateWorkItem ? formatMessage($b7c1775e33e0cf91$var$getWorkItemMessage()) : formatMessage((0, $2DRCb.default).createChildItem),
        testId: "issue-table-hierarchy.ui.create-child-button.create",
        icon: renderIcon && (0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style') ? renderIcon : defaultIcon,
        onClick: onClick,
        isTooltipDisabled: false,
        ref: ref
    });
});
var $b7c1775e33e0cf91$export$2e2bcd8739ae039 = $b7c1775e33e0cf91$var$CreateChildButton;

});
parcelRegister("2DRCb", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7a4d5368b16f278$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c7a4d5368b16f278$var$messages = (0, $7qGN1.defineMessages)({
    createChildItem: {
        "id": "issue-table-hierarchy.ui.create-child-button.create-child-item",
        "defaultMessage": "Create child item"
    },
    createWorkItem: {
        "id": "issue-table-hierarchy.ui.create-child-button.create-work-item",
        "defaultMessage": "Create work item"
    },
    createIssue: {
        "id": "issue-table-hierarchy.ui.create-child-button.create-issue",
        "defaultMessage": "Create issue"
    }
});
var $c7a4d5368b16f278$export$2e2bcd8739ae039 = $c7a4d5368b16f278$var$messages;

});


parcelRegister("d8783", function(module, exports) {
$parcel$export(module.exports, "default", () => $0995f9578d4dea24$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0995f9578d4dea24$var$messages = (0, $7qGN1.defineMessages)({
    expandIssue: {
        "id": "native-issue-table.expand-button.expand-issue-hierarchy",
        "defaultMessage": "Expand hierarchy"
    },
    collapseIssue: {
        "id": "native-issue-table.expand-button.collapse",
        "defaultMessage": "Collapse hierarchy"
    },
    expandGroup: {
        "id": "native-issue-table.expand-button.expand-group-issue-hierarchy",
        "defaultMessage": "Expand group"
    },
    collapseGroup: {
        "id": "native-issue-table.expand-button.collapse-group",
        "defaultMessage": "Collapse group"
    }
});
var $0995f9578d4dea24$export$2e2bcd8739ae039 = $0995f9578d4dea24$var$messages;

});

parcelRegister("5XgIy", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cda404939b0af13$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $8cda404939b0af13$var$ICON_WIDTH = 24;
const $8cda404939b0af13$var$INDENTED_PADDING = 8;
const $8cda404939b0af13$var$IndentedIcon = ({ depth: depth })=>{
    if (depth <= 0) return null;
    const left = depth > 1 ? (depth - 1) * $8cda404939b0af13$var$ICON_WIDTH + $8cda404939b0af13$var$INDENTED_PADDING : $8cda404939b0af13$var$INDENTED_PADDING;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            left: `${left}px`
        },
        xcss: $8cda404939b0af13$var$imgContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $8cda404939b0af13$var$imgStyles,
        testId: "issue-table-hierarchy.ui.expand-button.indented-icon.indented-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 0V9.5C1 10.3284 1.67157 11 2.5 11H12V12H2.5C1.11929 12 0 10.8807 0 9.5V0H1Z",
        fill: "var(--ds-border, #0B120E24)"
    }))));
};
const $8cda404939b0af13$var$imgStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)"
});
const $8cda404939b0af13$var$imgContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    height: '100%'
});
var $8cda404939b0af13$export$2e2bcd8739ae039 = $8cda404939b0af13$var$IndentedIcon;

});


parcelRegister("5FAgT", function(module, exports) {
$parcel$export(module.exports, "CategoryGroupHeader", () => $e3e89f6b5aceb5e9$export$fc0707d1ce99fe4d);

var $bAWc1 = parcelRequire("bAWc1");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $ivVFT = parcelRequire("ivVFT");

var $lRq8t = parcelRequire("lRq8t");

var $ldHGO = parcelRequire("ldHGO");
const $e3e89f6b5aceb5e9$export$fc0707d1ce99fe4d = ({ categoryGroupHeader: categoryGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $bAWc1.default), categoryGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return data != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivVFT.default), {
        categoryColor: data?.option?.color?.colorKey ?? null,
        categoryName: data?.displayName,
        isInteractive: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $ldHGO.default).noCategory));
};

});
parcelRegister("bAWc1", function(module, exports) {
$parcel$export(module.exports, "default", () => $cddcd255ba621c3b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5432b30245a6345c5d41d0875b65f74d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cddcd255ba621c3b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "CategoryGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "option",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraColor",
                    "kind": "LinkedField",
                    "name": "color",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "colorKey"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraJqlOptionFieldValue"
};
$cddcd255ba621c3b$var$node.hash = "adc155d7b590635f8d7c06317caf565c";
var $cddcd255ba621c3b$export$2e2bcd8739ae039 = $cddcd255ba621c3b$var$node;

});

parcelRegister("ivVFT", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd752ee372910218$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $4KSRb = parcelRequire("4KSRb");
const $fd752ee372910218$var$CategoryTag = ({ categoryName: categoryName, categoryColor: categoryColor, isInteractive: isInteractive = true })=>{
    const { backgroundColor: tagColor } = (0, $4KSRb.getColorMetadata)(categoryColor);
    return /*#__PURE__*/ $eJOHy.createElement($fd752ee372910218$var$CategoryTagWrapper, {
        isInteractive: isInteractive,
        textColor: "var(--ds-text, #292A2E)",
        "aria-label": categoryName,
        "data-testid": "business-categories.ui.category-form.category-tag.category-tag-wrapper"
    }, /*#__PURE__*/ $eJOHy.createElement($fd752ee372910218$var$StyledTag, {
        color: tagColor
    }, categoryName));
};
var $fd752ee372910218$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($fd752ee372910218$var$CategoryTag);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fd752ee372910218$var$CategoryTagWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { textColor: textColor, isInteractive: isInteractive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qrlcdp": (0, $awdRS.default)(__cmplp.textColor)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v564188d _1e0c116y _1bah1e5h _4cvr1h6o _p12f1osq _1ul9idpf _1tkeidpf _syazijt0",
            __cmplp.isInteractive ? "_d0altlke" : "_d0al73ad",
            __cmplp.className
        ])
    });
});
const $fd752ee372910218$var$StyledTag = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_14v0t1n": (0, $awdRS.default)(`1px solid ${__cmplp.color}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko3gvi _19it11we _11c82smr _1reo15vq _18m915vq _bfhk18uv _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _vwz4kb7n _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4KSRb", function(module, exports) {
$parcel$export(module.exports, "getRandomColor", () => $3bcf16c800b16b64$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $3bcf16c800b16b64$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $3bcf16c800b16b64$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $3bcf16c800b16b64$export$49fce7fdcf55f26d);

var $jHxAK = parcelRequire("jHxAK");
const $3bcf16c800b16b64$export$e4369cabd7e84cd9 = ()=>{
    const randomIndex = Math.floor(Math.random() * (0, $jHxAK.CATEGORY_THEMES).length);
    return (0, $jHxAK.CATEGORY_THEMES)[randomIndex].name;
};
const $3bcf16c800b16b64$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $jHxAK.CATEGORY_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $3bcf16c800b16b64$export$9eff62e8ee2aaa2c = (colorName)=>(0, $jHxAK.CATEGORY_THEMES).find((item)=>item.name === colorName)?.backgroundColor ?? '';
const $3bcf16c800b16b64$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $jHxAK.GREY_LIGHTEST_META;
    return (0, $jHxAK.CATEGORY_THEMES).find((item)=>item.name === colorName) ?? (0, $jHxAK.GREY_LIGHTEST_META);
};
const $3bcf16c800b16b64$export$4ef6b7574883e63d = ()=>(0, $jHxAK.CATEGORY_THEMES).map((item)=>item.name);

});
parcelRegister("jHxAK", function(module, exports) {
$parcel$export(module.exports, "GREY_LIGHTEST_META", () => $c24cfcc605338ece$export$cb19a604bb399a88);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $c24cfcc605338ece$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $c24cfcc605338ece$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "CATEGORY_THEMES", () => $c24cfcc605338ece$export$845e69f3af4133a6);

var $2hJG2 = parcelRequire("2hJG2");
const $c24cfcc605338ece$export$cb19a604bb399a88 = {
    name: 'GREY_LIGHTEST',
    backgroundColor: "var(--ds-background-neutral, #0515240F)",
    textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
    messageLabel: (0, $2hJG2.default).greyLightest
};
const $c24cfcc605338ece$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #0B120E24)",
    textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
    messageLabel: (0, $2hJG2.default).greyLighter
};
const $c24cfcc605338ece$var$GREY_META = {
    name: 'GREY',
    backgroundColor: "var(--ds-background-neutral-pressed, #080F214A)",
    textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
    messageLabel: (0, $2hJG2.default).grey
};
const $c24cfcc605338ece$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    backgroundColor: "var(--ds-background-neutral-bold, #292A2E)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).greyDarker
};
const $c24cfcc605338ece$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: "var(--ds-background-neutral-bold-pressed, #505258)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).greyDarkest
};
const $c24cfcc605338ece$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    textColor: "var(--ds-text-accent-purple-bolder, #48245D)",
    messageLabel: (0, $2hJG2.default).purpleLightest
};
const $c24cfcc605338ece$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    textColor: "var(--ds-text-accent-purple-bolder, #48245D)",
    messageLabel: (0, $2hJG2.default).purpleLighter
};
const $c24cfcc605338ece$var$PURPLE_META = {
    name: 'PURPLE',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
    textColor: "var(--ds-text-accent-purple-bolder, #48245D)",
    messageLabel: (0, $2hJG2.default).purple
};
const $c24cfcc605338ece$var$PURPLE_DARKER_META = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #803FA5)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).purpleDarker
};
const $c24cfcc605338ece$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #48245D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).purpleDarkest
};
const $c24cfcc605338ece$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    textColor: "var(--ds-text-accent-blue-bolder, #123263)",
    messageLabel: (0, $2hJG2.default).blueLightest
};
const $c24cfcc605338ece$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    textColor: "var(--ds-text-accent-blue-bolder, #123263)",
    messageLabel: (0, $2hJG2.default).blueLighter
};
const $c24cfcc605338ece$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
    textColor: "var(--ds-text-accent-blue-bolder, #123263)",
    messageLabel: (0, $2hJG2.default).blue
};
const $c24cfcc605338ece$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #1558BC)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).blueDarker
};
const $c24cfcc605338ece$var$BLUE_DARKEST_META = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #123263)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).blueDarkest
};
const $c24cfcc605338ece$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $2hJG2.default).tealLightest
};
const $c24cfcc605338ece$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $2hJG2.default).tealLighter
};
const $c24cfcc605338ece$var$TEAL_META = {
    name: 'TEAL',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $2hJG2.default).teal
};
const $c24cfcc605338ece$var$TEAL_DARKER_META = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).tealDarker
};
const $c24cfcc605338ece$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).tealDarkest
};
const $c24cfcc605338ece$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $2hJG2.default).greenLightest
};
const $c24cfcc605338ece$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $2hJG2.default).greenLighter
};
const $c24cfcc605338ece$var$GREEN_META = {
    name: 'GREEN',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $2hJG2.default).green
};
const $c24cfcc605338ece$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).greenDarker
};
const $c24cfcc605338ece$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).greenDarkest
};
const $c24cfcc605338ece$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $2hJG2.default).limeLightest
};
const $c24cfcc605338ece$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $2hJG2.default).limeLighter
};
const $c24cfcc605338ece$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $2hJG2.default).lime
};
const $c24cfcc605338ece$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).limeDarker
};
const $c24cfcc605338ece$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).limeDarkest
};
const $c24cfcc605338ece$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $2hJG2.default).yellowLightest
};
const $c24cfcc605338ece$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $2hJG2.default).yellowLighter
};
const $c24cfcc605338ece$var$YELLOW_META = {
    name: 'YELLOW',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $2hJG2.default).yellow
};
const $c24cfcc605338ece$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).yellowDarker
};
const $c24cfcc605338ece$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).yellowDarkest
};
const $c24cfcc605338ece$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    textColor: "var(--ds-text-accent-orange-bolder, #693200)",
    messageLabel: (0, $2hJG2.default).orangeLightest
};
const $c24cfcc605338ece$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    textColor: "var(--ds-text-accent-orange-bolder, #693200)",
    messageLabel: (0, $2hJG2.default).orangeLighter
};
const $c24cfcc605338ece$var$ORANGE_META = {
    name: 'ORANGE',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
    textColor: "var(--ds-text-accent-orange-bolder, #693200)",
    messageLabel: (0, $2hJG2.default).orange
};
const $c24cfcc605338ece$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #BD5B00)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).orangeDarker
};
const $c24cfcc605338ece$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #693200)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).orangeDarkest
};
const $c24cfcc605338ece$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $2hJG2.default).redLightest
};
const $c24cfcc605338ece$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $2hJG2.default).redLighter
};
const $c24cfcc605338ece$var$RED_META = {
    name: 'RED',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $2hJG2.default).red
};
const $c24cfcc605338ece$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).redDarker
};
const $c24cfcc605338ece$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).redDarkest
};
const $c24cfcc605338ece$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $2hJG2.default).magentaLightest
};
const $c24cfcc605338ece$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $2hJG2.default).magentaLighter
};
const $c24cfcc605338ece$var$MAGENTA_META = {
    name: 'MAGENTA',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $2hJG2.default).magenta
};
const $c24cfcc605338ece$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).magentaDarker
};
const $c24cfcc605338ece$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).magentaDarkest
};
const $c24cfcc605338ece$export$270aee965367aeb3 = "var(--ds-text-inverse, #FFFFFF)";
const $c24cfcc605338ece$export$941ef40ef5fdd2b1 = "var(--ds-text, #292A2E)";
const $c24cfcc605338ece$export$845e69f3af4133a6 = [
    $c24cfcc605338ece$export$cb19a604bb399a88,
    $c24cfcc605338ece$var$PURPLE_LIGHTEST_META,
    $c24cfcc605338ece$var$BLUE_LIGHTEST_META,
    $c24cfcc605338ece$var$TEAL_LIGHTEST_META,
    $c24cfcc605338ece$var$GREEN_LIGHTEST_META,
    $c24cfcc605338ece$var$LIME_LIGHTEST_META,
    $c24cfcc605338ece$var$YELLOW_LIGHTEST_META,
    $c24cfcc605338ece$var$ORANGE_LIGHTEST_META,
    $c24cfcc605338ece$var$RED_LIGHTEST_META,
    $c24cfcc605338ece$var$MAGENTA_LIGHTEST_META,
    $c24cfcc605338ece$var$GREY_LIGHTER_META,
    $c24cfcc605338ece$var$PURPLE_LIGHTER_META,
    $c24cfcc605338ece$var$BLUE_LIGHTER_META,
    $c24cfcc605338ece$var$TEAL_LIGHTER_META,
    $c24cfcc605338ece$var$GREEN_LIGHTER_META,
    $c24cfcc605338ece$var$LIME_LIGHTER_META,
    $c24cfcc605338ece$var$YELLOW_LIGHTER_META,
    $c24cfcc605338ece$var$ORANGE_LIGHTER_META,
    $c24cfcc605338ece$var$RED_LIGHTER_META,
    $c24cfcc605338ece$var$MAGENTA_LIGHTER_META,
    $c24cfcc605338ece$var$GREY_META,
    $c24cfcc605338ece$var$PURPLE_META,
    $c24cfcc605338ece$var$BLUE_META,
    $c24cfcc605338ece$var$TEAL_META,
    $c24cfcc605338ece$var$GREEN_META,
    $c24cfcc605338ece$var$LIME_META,
    $c24cfcc605338ece$var$YELLOW_META,
    $c24cfcc605338ece$var$ORANGE_META,
    $c24cfcc605338ece$var$RED_META,
    $c24cfcc605338ece$var$MAGENTA_META,
    $c24cfcc605338ece$var$GREY_DARKER_META,
    $c24cfcc605338ece$var$PURPLE_DARKER_META,
    $c24cfcc605338ece$var$BLUE_DARKER_META,
    $c24cfcc605338ece$var$TEAL_DARKER_META,
    $c24cfcc605338ece$var$GREEN_DARKER_META,
    $c24cfcc605338ece$var$LIME_DARKER_META,
    $c24cfcc605338ece$var$YELLOW_DARKER_META,
    $c24cfcc605338ece$var$ORANGE_DARKER_META,
    $c24cfcc605338ece$var$RED_DARKER_META,
    $c24cfcc605338ece$var$MAGENTA_DARKER_META,
    $c24cfcc605338ece$var$GREY_DARKEST_META,
    $c24cfcc605338ece$var$PURPLE_DARKEST_META,
    $c24cfcc605338ece$var$BLUE_DARKEST_META,
    $c24cfcc605338ece$var$TEAL_DARKEST_META,
    $c24cfcc605338ece$var$GREEN_DARKEST_META,
    $c24cfcc605338ece$var$LIME_DARKEST_META,
    $c24cfcc605338ece$var$YELLOW_DARKEST_META,
    $c24cfcc605338ece$var$ORANGE_DARKEST_META,
    $c24cfcc605338ece$var$RED_DARKEST_META,
    $c24cfcc605338ece$var$MAGENTA_DARKEST_META
];

});
parcelRegister("2hJG2", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4a201e1872b1174$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f4a201e1872b1174$var$messages = (0, $7qGN1.defineMessages)({
    greyLightest: {
        "id": "business-categories.category-form.category-color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "business-categories.category-form.category-color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "business-categories.category-form.category-color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "business-categories.category-form.category-color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "business-categories.category-form.category-color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "business-categories.category-form.category-color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "business-categories.category-form.category-color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "business-categories.category-form.category-color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "business-categories.category-form.category-color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "business-categories.category-form.category-color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "business-categories.category-form.category-color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "business-categories.category-form.category-color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "business-categories.category-form.category-color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "business-categories.category-form.category-color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "business-categories.category-form.category-color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "business-categories.category-form.category-color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "business-categories.category-form.category-color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "business-categories.category-form.category-color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "business-categories.category-form.category-color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "business-categories.category-form.category-color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "business-categories.category-form.category-color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "business-categories.category-form.category-color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "business-categories.category-form.category-color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "business-categories.category-form.category-color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "business-categories.category-form.category-color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "business-categories.category-form.category-color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "business-categories.category-form.category-color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "business-categories.category-form.category-color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "business-categories.category-form.category-color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "business-categories.category-form.category-color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "business-categories.category-form.category-color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "business-categories.category-form.category-color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "business-categories.category-form.category-color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "business-categories.category-form.category-color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "business-categories.category-form.category-color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "business-categories.category-form.category-color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "business-categories.category-form.category-color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "business-categories.category-form.category-color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "business-categories.category-form.category-color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "business-categories.category-form.category-color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "business-categories.category-form.category-color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "business-categories.category-form.category-color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "business-categories.category-form.category-color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "business-categories.category-form.category-color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "business-categories.category-form.category-color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "business-categories.category-form.category-color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "business-categories.category-form.category-color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "business-categories.category-form.category-color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "business-categories.category-form.category-color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "business-categories.category-form.category-color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});
var $f4a201e1872b1174$export$2e2bcd8739ae039 = $f4a201e1872b1174$var$messages;

});




parcelRegister("ldHGO", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a2b1fb7f562b512$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0a2b1fb7f562b512$var$messages = (0, $7qGN1.defineMessages)({
    noCategory: {
        "id": "issue-table-grouping.group-row.group-header.category-group-header.no-category",
        "defaultMessage": "Uncategorized"
    }
});
var $0a2b1fb7f562b512$export$2e2bcd8739ae039 = $0a2b1fb7f562b512$var$messages;

});


parcelRegister("98A5p", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f23a688be5d03c8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7f23a688be5d03c8$var$messages = (0, $7qGN1.defineMessages)({
    issues: {
        "id": "issue-table-grouping.group-row.group-header.issues",
        "defaultMessage": "{count, plural, one {# issue} other {# issues}}"
    },
    issuesIssueTermRefresh: {
        "id": "issue-table-grouping.group-row.group-header.issues-issue-term-refresh",
        "defaultMessage": "{count, plural, one {# work item} other {# work items}}"
    }
});
var $7f23a688be5d03c8$export$2e2bcd8739ae039 = $7f23a688be5d03c8$var$messages;

});

parcelRegister("iqCxS", function(module, exports) {
$parcel$export(module.exports, "PriorityGroupHeader", () => $8eae647b702880ec$export$3d9fbda3fab02eba);

var $dp9tt = parcelRequire("dp9tt");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $2gIth = parcelRequire("2gIth");
const $8eae647b702880ec$export$3d9fbda3fab02eba = ({ priorityGroupHeader: priorityGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $dp9tt.default), priorityGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data?.priority.iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "img",
        src: data.priority.iconUrl,
        xcss: $8eae647b702880ec$var$iconStyles,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), null, data?.displayName ?? formatMessage((0, $2gIth.default).noPriority)));
};
const $8eae647b702880ec$var$iconStyles = (0, $1DXK0.xcss)({
    width: "var(--ds-space-250, 20px)",
    height: "var(--ds-space-250, 20px)"
});

});
parcelRegister("dp9tt", function(module, exports) {
$parcel$export(module.exports, "default", () => $066f2a43ba1e9795$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5567a39166b30a4ff19c7b0a56c6571b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $066f2a43ba1e9795$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PriorityGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                }
            ]
        }
    ],
    "type": "JiraJqlPriorityFieldValue"
};
$066f2a43ba1e9795$var$node.hash = "005933ac841dded3cda21a36de7b85e9";
var $066f2a43ba1e9795$export$2e2bcd8739ae039 = $066f2a43ba1e9795$var$node;

});

parcelRegister("2gIth", function(module, exports) {
$parcel$export(module.exports, "default", () => $a64d8ab52717dcf9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a64d8ab52717dcf9$var$messages = (0, $7qGN1.defineMessages)({
    noPriority: {
        "id": "issue-table-grouping.group-row.group-header.priority-group-header.no-priority",
        "defaultMessage": "No priority"
    }
});
var $a64d8ab52717dcf9$export$2e2bcd8739ae039 = $a64d8ab52717dcf9$var$messages;

});


parcelRegister("aaLj4", function(module, exports) {
$parcel$export(module.exports, "SprintGroupHeader", () => $5d3af1987d3a79a0$export$c4bf8cf8359b52ab);

var $j2ipd = parcelRequire("j2ipd");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $ewOxf = parcelRequire("ewOxf");

var $lRq8t = parcelRequire("lRq8t");

var $52CBb = parcelRequire("52CBb");
const $5d3af1987d3a79a0$export$c4bf8cf8359b52ab = ({ sprintGroupHeader: sprintGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $j2ipd.default), sprintGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    let text;
    if (!data) text = formatMessage((0, $52CBb.default).backlog);
    else if (data.sprint?.state === 'CLOSED') text = formatMessage((0, $52CBb.default).completedSprint);
    else text = data.displayName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
        text: text
    });
};

});
parcelRegister("j2ipd", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0cf394d929c03f5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<857c2638fd8131352864d77dbbcc21dd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b0cf394d929c03f5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SprintGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraSprint",
            "kind": "LinkedField",
            "name": "sprint",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "state"
                }
            ]
        }
    ],
    "type": "JiraJqlSprintFieldValue"
};
$b0cf394d929c03f5$var$node.hash = "c2d9817a445caaca4793868218a63862";
var $b0cf394d929c03f5$export$2e2bcd8739ae039 = $b0cf394d929c03f5$var$node;

});

parcelRegister("52CBb", function(module, exports) {
$parcel$export(module.exports, "default", () => $19f4af068b811078$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $19f4af068b811078$var$messages = (0, $7qGN1.defineMessages)({
    completedSprint: {
        "id": "issue-table-grouping.group-row.group-header.sprint-group-header.completed-sprint",
        "defaultMessage": "Completed sprint"
    },
    backlog: {
        "id": "issue-table-grouping.group-row.group-header.sprint-group-header.backlog",
        "defaultMessage": "Backlog"
    }
});
var $19f4af068b811078$export$2e2bcd8739ae039 = $19f4af068b811078$var$messages;

});


parcelRegister("k29Y8", function(module, exports) {
$parcel$export(module.exports, "StatusGroupHeader", () => $0df23d6d0711eea2$export$47d603da63417bb);

var $fqBmi = parcelRequire("fqBmi");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jx0Vw = parcelRequire("jx0Vw");

var $jdqdp = parcelRequire("jdqdp");
const $0df23d6d0711eea2$var$appearanceMap = {
    [(0, $jx0Vw.UNDEFINED)]: 'default',
    [(0, $jx0Vw.TODO)]: 'default',
    [(0, $jx0Vw.DONE)]: 'success',
    [(0, $jx0Vw.IN_PROGRESS)]: 'inprogress'
};
const $0df23d6d0711eea2$export$47d603da63417bb = ({ statusGroupHeader: statusGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $fqBmi.default), statusGroupHeader);
    const appearance = data?.statusCategory.statusCategoryId != null ? $0df23d6d0711eea2$var$appearanceMap[(0, $jx0Vw.statusCategoryForId)(data?.statusCategory.statusCategoryId)] : $0df23d6d0711eea2$var$appearanceMap[0, $jx0Vw.UNDEFINED];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: appearance
    }, data?.displayName);
};

});
parcelRegister("fqBmi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b69f1c13052a4358$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8e00aec2e4e2d02156f37016fd5ac9eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b69f1c13052a4358$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StatusGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "statusCategoryId"
                }
            ]
        }
    ],
    "type": "JiraJqlStatusFieldValue"
};
$b69f1c13052a4358$var$node.hash = "cdc8aa737da69440878c7ee8e5c447e6";
var $b69f1c13052a4358$export$2e2bcd8739ae039 = $b69f1c13052a4358$var$node;

});

parcelRegister("jx0Vw", function(module, exports) {
$parcel$export(module.exports, "UNDEFINED", () => $89523e1d4dcff547$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $89523e1d4dcff547$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $89523e1d4dcff547$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $89523e1d4dcff547$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $89523e1d4dcff547$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $89523e1d4dcff547$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $89523e1d4dcff547$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $89523e1d4dcff547$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $89523e1d4dcff547$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $89523e1d4dcff547$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $89523e1d4dcff547$export$d928f247c903643a);
const $89523e1d4dcff547$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $89523e1d4dcff547$export$aa456a5030160740 = 'TODO';
const $89523e1d4dcff547$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $89523e1d4dcff547$export$71efb3495f6084f2 = 'DONE';
const $89523e1d4dcff547$export$d9119300f9d9a815 = [
    $89523e1d4dcff547$export$6db089fe7b26f5b6,
    $89523e1d4dcff547$export$aa456a5030160740,
    $89523e1d4dcff547$export$5a9ac66c2785cc13,
    $89523e1d4dcff547$export$71efb3495f6084f2
];
const $89523e1d4dcff547$var$statusCategories = [
    {
        id: '1',
        statusCategory: $89523e1d4dcff547$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $89523e1d4dcff547$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $89523e1d4dcff547$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $89523e1d4dcff547$export$71efb3495f6084f2
    }
];
const $89523e1d4dcff547$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $89523e1d4dcff547$export$3f42f49c284d5b58 = Object.freeze({
    [$89523e1d4dcff547$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$89523e1d4dcff547$export$5d42a08d46cffe7.NEW]: 2,
    [$89523e1d4dcff547$export$5d42a08d46cffe7.DONE]: 3,
    [$89523e1d4dcff547$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $89523e1d4dcff547$export$f3f919dc0f56d9eb = Object.values($89523e1d4dcff547$export$5d42a08d46cffe7);
const $89523e1d4dcff547$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $89523e1d4dcff547$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $89523e1d4dcff547$export$6db089fe7b26f5b6;
};
const $89523e1d4dcff547$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $89523e1d4dcff547$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $89523e1d4dcff547$export$d928f247c903643a = (key)=>$89523e1d4dcff547$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});


parcelRegister("jiKXd", function(module, exports) {
$parcel$export(module.exports, "StoryPointsGroupHeader", () => $60c96ff097c46bfb$export$67c95e3a82fabe13);

var $aQnMy = parcelRequire("aQnMy");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7q9BG = parcelRequire("7q9BG");

var $lRq8t = parcelRequire("lRq8t");

var $6qVOj = parcelRequire("6qVOj");
const $60c96ff097c46bfb$export$67c95e3a82fabe13 = ({ storyPointsGroupHeader: storyPointsGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $aQnMy.default), storyPointsGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
        appearance: "default"
    }, typeof data?.number === 'number' ? formatMessage((0, $6qVOj.default).storyPoints, {
        points: data?.number
    }) : formatMessage((0, $6qVOj.default).noStoryPoints));
};

});
parcelRegister("aQnMy", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1cdb6744a8eb0f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b2335196e7ec7a803624759c68802955>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e1cdb6744a8eb0f8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StoryPointsGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "number"
        }
    ],
    "type": "JiraJqlNumberFieldValue"
};
$e1cdb6744a8eb0f8$var$node.hash = "2d04d7c6471553920e11294e9de46cab";
var $e1cdb6744a8eb0f8$export$2e2bcd8739ae039 = $e1cdb6744a8eb0f8$var$node;

});

parcelRegister("6qVOj", function(module, exports) {
$parcel$export(module.exports, "default", () => $9524c98beda18117$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9524c98beda18117$var$messages = (0, $7qGN1.defineMessages)({
    storyPoints: {
        "id": "issue-table-grouping.group-row.group-header.story-points-group-header.story-points",
        "defaultMessage": "{points, plural, one {# point} other {# points}}"
    },
    noStoryPoints: {
        "id": "issue-table-grouping.group-row.group-header.story-points-group-header.no-story-points",
        "defaultMessage": "No points"
    }
});
var $9524c98beda18117$export$2e2bcd8739ae039 = $9524c98beda18117$var$messages;

});


parcelRegister("b8Nt1", function(module, exports) {
$parcel$export(module.exports, "GoalGroupHeader", () => $d9a50531439f16f6$export$2fac2323394ec085);

var $kUpXl = parcelRequire("kUpXl");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $jdqdp = parcelRequire("jdqdp");

var $lRq8t = parcelRequire("lRq8t");

var $jsdaB = parcelRequire("jsdaB");

var $jsdaB = parcelRequire("jsdaB");

var $4cTDP = parcelRequire("4cTDP");

var $byUzi = parcelRequire("byUzi");

var $3PRLs = parcelRequire("3PRLs");

var $dlGxm = parcelRequire("dlGxm");

var $7D7Pd = parcelRequire("7D7Pd");
const $d9a50531439f16f6$var$goalStatusToLabelMap = {
    ARCHIVED: (0, $dlGxm.default).statusLabelArchived,
    PENDING: (0, $dlGxm.default).statusLabelPending,
    IN_PROGRESS: (0, $dlGxm.default).statusLabelInProgress,
    COMPLETED: (0, $dlGxm.default).statusLabelCompleted,
    DONE: (0, $dlGxm.default).statusLabelCompleted,
    ON_TRACK: (0, $dlGxm.default).statusLabelOnTrack,
    PAUSED: (0, $dlGxm.default).statusLabelPaused,
    AT_RISK: (0, $dlGxm.default).statusLabelAtRisk,
    OFF_TRACK: (0, $dlGxm.default).statusLabelOffTrack,
    CANCELLED: (0, $dlGxm.default).statusLabelCancelled
};
const $d9a50531439f16f6$var$goalStatusToLozengeAppearanceMap = {
    ARCHIVED: 'default',
    PENDING: 'default',
    IN_PROGRESS: 'inprogress',
    COMPLETED: 'success',
    DONE: 'success',
    ON_TRACK: 'success',
    PAUSED: 'moved',
    AT_RISK: 'moved',
    OFF_TRACK: 'removed',
    CANCELLED: 'removed'
};
const $d9a50531439f16f6$export$2fac2323394ec085 = ({ goalGroupHeader: goalGroupHeader })=>{
    const constructGoalUrl = (0, $byUzi.useGoalUrlConstructor)();
    const data = (0, $j4oe4.useFragment)((0, $kUpXl.default), goalGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const displayName = data?.displayName ?? formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $dlGxm.default).noGoalsDisplayNameIssueTermRefresh : (0, $dlGxm.default).noGoalsDisplayName);
    const status = formatMessage($d9a50531439f16f6$var$goalStatusToLabelMap[data?.goal?.status || 'PENDING']);
    const appearance = (0, $jsdaB.normalizeGoalAppearance)(data?.goal?.status || 'PENDING');
    const goalUrl = (0, $eJOHy.useMemo)(()=>data?.goal.id && data?.goal.key && (0, $4cTDP.fg)('goal_group_header_smart_link') ? constructGoalUrl({
            ari: data?.goal.id,
            key: data?.goal.key
        }) : undefined, [
        constructGoalUrl,
        data?.goal.id,
        data?.goal.key
    ]);
    const placeholderDataForSmartCard = (0, $eJOHy.useMemo)(()=>{
        return goalUrl && data?.goal?.name && data?.goal?.status && (0, $4cTDP.fg)('goal_group_header_smart_link') ? (0, $7D7Pd.generatePlaceholderData)(goalUrl, data?.goal?.name, data?.goal?.status) : undefined;
    }, [
        data?.goal?.name,
        data?.goal?.status,
        goalUrl
    ]);
    if (goalUrl && (0, $4cTDP.fg)('goal_group_header_smart_link')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3PRLs.SimpleInlineSmartLink), {
        anchorTarget: "_blank",
        url: goalUrl,
        placeholderData: placeholderDataForSmartCard,
        isSimplifiedUI: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data?.goal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jsdaB.GoalIcon), {
        size: "16",
        appearance: appearance,
        goalIconKey: "GOAL"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d9a50531439f16f6$var$goalTextStyles
    }, displayName), data?.goal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: $d9a50531439f16f6$var$goalStatusToLozengeAppearanceMap[data.goal.status || 'PENDING']
    }, status, data.goal.score && ` - ${data.goal.score || ''}`));
};
const $d9a50531439f16f6$var$goalTextStyles = (0, $1DXK0.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});
parcelRegister("kUpXl", function(module, exports) {
$parcel$export(module.exports, "default", () => $b980680bf7e2c2ec$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ca6b71edee50e32a074002bc55ff3d1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b980680bf7e2c2ec$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "GoalGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraGoal",
            "kind": "LinkedField",
            "name": "goal",
            "plural": false,
            "selections": [
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "kind": "ScalarField",
                    "name": "score"
                }
            ]
        }
    ],
    "type": "JiraJqlGoalsFieldValue"
};
$b980680bf7e2c2ec$var$node.hash = "79831ca506d15357a3f5270b01ab437f";
var $b980680bf7e2c2ec$export$2e2bcd8739ae039 = $b980680bf7e2c2ec$var$node;

});

parcelRegister("jsdaB", function(module, exports) {
$parcel$export(module.exports, "GoalIcon", () => $a7b2c6cc6d0f42bb$export$134cbcd70c6693b8);
$parcel$export(module.exports, "normalizeGoalAppearance", () => $a7b2c6cc6d0f42bb$export$f1b3ca93191ce5cc);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $6IK2z = parcelRequire("6IK2z");

var $9qes7 = parcelRequire("9qes7");

var $9RMYL = parcelRequire("9RMYL");

var $1wxug = parcelRequire("1wxug");

var $dVVwX = parcelRequire("dVVwX");

var $h8rwk = parcelRequire("h8rwk");
const $a7b2c6cc6d0f42bb$var$appearanceToColorMap = {
    DEFAULT: 'gray',
    MENU: 'gray',
    OFF_TRACK: 'red',
    AT_RISK: 'yellow',
    ON_TRACK: 'green'
};
const $a7b2c6cc6d0f42bb$var$appearanceToNewColorMap = {
    MENU: "var(--ds-icon, #292A2E)",
    DEFAULT: "var(--ds-icon-accent-gray, #7D818A)",
    OFF_TRACK: "var(--ds-icon-danger, #C9372C)",
    AT_RISK: "var(--ds-icon-warning, #E06C00)",
    ON_TRACK: "var(--ds-icon-success, #6A9A23)"
};
const $a7b2c6cc6d0f42bb$var$keyToIconMap = {
    GOAL: (0, (/*@__PURE__*/$parcel$interopDefault($9qes7))),
    OBJECTIVE: (0, (/*@__PURE__*/$parcel$interopDefault($1wxug))),
    KEY_RESULT: (0, (/*@__PURE__*/$parcel$interopDefault($9RMYL)))
};
const $a7b2c6cc6d0f42bb$var$getLabel = (intl, label, localizedLabel)=>{
    if (label) return label;
    if (localizedLabel && (0, $h8rwk.isMessageId)(localizedLabel?.messageId)) return intl.formatMessage((0, $h8rwk.messages)[localizedLabel.messageId]);
    return '';
};
const $a7b2c6cc6d0f42bb$export$134cbcd70c6693b8 = ({ appearance: appearance, size: size, localizedLabel: localizedLabel, goalIconKey: goalIconKey = 'GOAL', isVisualRefresh: isVisualRefresh = false, visualRefreshSpacing: visualRefreshSpacing = 'none', label: label, shouldScale: shouldScale = false })=>{
    const intl = (0, $lRq8t.default)();
    const iconLabel = $a7b2c6cc6d0f42bb$var$getLabel(intl, label, localizedLabel);
    const Icon = $a7b2c6cc6d0f42bb$var$keyToIconMap[goalIconKey] ?? $a7b2c6cc6d0f42bb$var$keyToIconMap.GOAL;
    if (isVisualRefresh) {
        const ResizableIcon = Icon;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(ResizableIcon, {
            shouldScale: shouldScale,
            color: $a7b2c6cc6d0f42bb$var$appearanceToNewColorMap[appearance],
            label: iconLabel,
            spacing: visualRefreshSpacing
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        size: size,
        icon: Icon,
        label: iconLabel,
        appearance: $a7b2c6cc6d0f42bb$var$appearanceToColorMap[appearance]
    });
};
const $a7b2c6cc6d0f42bb$export$f1b3ca93191ce5cc = (statusValue)=>{
    const appearanceUppercase = statusValue.toLocaleUpperCase();
    return (0, $dVVwX.isGoalAppearance)(appearanceUppercase) ? appearanceUppercase : 'DEFAULT';
};

});
parcelRegister("9RMYL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ac5dd9d18e58065415ed9f773e6c5a23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72ef0e7f955dc8ab$var$_react = $72ef0e7f955dc8ab$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $72ef0e7f955dc8ab$var$_baseNew = $72ef0e7f955dc8ab$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $72ef0e7f955dc8ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "KeyResult".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing key results.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72ef0e7f955dc8ab$var$KeyResultIcon = (props)=>/*#__PURE__*/ $72ef0e7f955dc8ab$var$_react.default.createElement($72ef0e7f955dc8ab$var$_baseNew.default, Object.assign({
        name: "KeyResultIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.435.001a.75.75 0 0 1 .547.194l3.023 2.75-1.01 1.11-2.437-2.217A10.2 10.2 0 0 0 7.527 7.25h3.163l1.28-1.28a.75.75 0 0 1 .53-.22h2.75a.75.75 0 0 1 .671 1.085L15.339 8l.582 1.165a.75.75 0 0 1-.67 1.085H12.5a.75.75 0 0 1-.531-.22l-1.28-1.28H7.528c.149 2.02.895 3.88 2.051 5.41l2.414-2.213 1.014 1.106-3 2.75a.75.75 0 0 1-1.07-.059A11.75 11.75 0 0 1 6.023 8.75H2.756l1.361 1.184-.984 1.132-2.875-2.5a.75.75 0 0 1 0-1.132l2.875-2.5.984 1.132L2.755 7.25h3.269A11.7 11.7 0 0 1 8.914.255a.75.75 0 0 1 .52-.254m2.626 8 .75.749h1.226l-.208-.414a.75.75 0 0 1 0-.671l.208-.415H12.81z" clip-rule="evenodd"/>`
    }, props));
$72ef0e7f955dc8ab$var$KeyResultIcon.displayName = 'KeyResultIcon';
var $72ef0e7f955dc8ab$var$_default = module.exports.default = $72ef0e7f955dc8ab$var$KeyResultIcon;

});

parcelRegister("1wxug", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83da9dd00c73d6526faf1963ee50c72a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $11c2c178697c4d79$var$_react = $11c2c178697c4d79$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $11c2c178697c4d79$var$_baseNew = $11c2c178697c4d79$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $11c2c178697c4d79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Objective".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for objectives.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $11c2c178697c4d79$var$ObjectiveIcon = (props)=>/*#__PURE__*/ $11c2c178697c4d79$var$_react.default.createElement($11c2c178697c4d79$var$_baseNew.default, Object.assign({
        name: "ObjectiveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.422.02a.75.75 0 0 1 .54.493l.38 1.144 1.145.381a.75.75 0 0 1 .293 1.242l-2 2a.75.75 0 0 1-.53.22h-1.69L8.03 9.03 6.97 7.97l3.53-3.53V2.75a.75.75 0 0 1 .22-.53l2-2a.75.75 0 0 1 .702-.2M12 4h.94l.922-.922-.35-.116a.75.75 0 0 1-.473-.475l-.117-.349-.922.923zM8 1.5A6.5 6.5 0 1 0 14.5 8H16a8 8 0 1 1-8-8zM8 5a3 3 0 1 0 3 3h1.5A4.5 4.5 0 1 1 8 3.5z" clip-rule="evenodd"/>`
    }, props));
$11c2c178697c4d79$var$ObjectiveIcon.displayName = 'ObjectiveIcon';
var $11c2c178697c4d79$var$_default = module.exports.default = $11c2c178697c4d79$var$ObjectiveIcon;

});

parcelRegister("dVVwX", function(module, exports) {
$parcel$export(module.exports, "isGoalAppearance", () => $5f59c3cc5e299b8b$export$86d2476abee3806b);
$parcel$export(module.exports, "isGoalIconKey", () => $5f59c3cc5e299b8b$export$51f87e2f4bd9e4bf);
const $5f59c3cc5e299b8b$export$d6870ac5e959c0f5 = [
    'DEFAULT',
    'ON_TRACK',
    'AT_RISK',
    'OFF_TRACK',
    'MENU'
];
const $5f59c3cc5e299b8b$export$86d2476abee3806b = (value)=>$5f59c3cc5e299b8b$export$d6870ac5e959c0f5.includes(value);
const $5f59c3cc5e299b8b$export$d7b4c6a971e28318 = [
    'ON_TRACK',
    'AT_RISK',
    'OFF_TRACK',
    'PENDING',
    'DONE',
    'CANCELLED',
    'PAUSED',
    'ARCHIVED'
];
const $5f59c3cc5e299b8b$export$a65140e49f013a96 = [
    'GOAL',
    'OBJECTIVE',
    'KEY_RESULT'
];
const $5f59c3cc5e299b8b$export$51f87e2f4bd9e4bf = (value)=>$5f59c3cc5e299b8b$export$a65140e49f013a96.includes(value);

});

parcelRegister("h8rwk", function(module, exports) {
$parcel$export(module.exports, "isMessageId", () => $874dea3760057f53$export$d28699f9b486207b);
$parcel$export(module.exports, "messages", () => $874dea3760057f53$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $874dea3760057f53$var$MESSAGE_IDS = [
    'townsquare.api.goal-state.on-track',
    'townsquare.api.goal-state.off-track',
    'townsquare.api.goal-state.at-risk',
    'townsquare.api.goal-state.pending',
    'townsquare.api.goal-state.completed',
    'townsquare.api.goal-state.cancelled',
    'townsquare.api.goal-state.paused'
];
const $874dea3760057f53$export$d28699f9b486207b = (value)=>$874dea3760057f53$var$MESSAGE_IDS.includes(value);
const $874dea3760057f53$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    'townsquare.api.goal-state.on-track': {
        id: 'Goals.icon.label.on-track',
        defaultMessage: 'On track',
        description: 'The label for the "on track" goal status'
    },
    'townsquare.api.goal-state.off-track': {
        id: 'Goals.icon.label.off-track',
        defaultMessage: 'Off track',
        description: 'The label for the "off track" goal status'
    },
    'townsquare.api.goal-state.at-risk': {
        id: 'Goals.icon.label.at-risk',
        defaultMessage: 'At risk',
        description: 'The label for the "at risk" goal status'
    },
    'townsquare.api.goal-state.pending': {
        id: 'Goals.icon.label.pending',
        defaultMessage: 'Pending',
        description: 'The label for the "pending" goal status'
    },
    'townsquare.api.goal-state.completed': {
        id: 'Goals.icon.label.completed',
        defaultMessage: 'Completed',
        description: 'The label for the "completed" goal status'
    },
    'townsquare.api.goal-state.cancelled': {
        id: 'Goals.icon.label.cancelled',
        defaultMessage: 'Cancelled',
        description: 'The label for the "cancelled" goal status'
    },
    'townsquare.api.goal-state.paused': {
        id: 'Goals.icon.label.paused',
        defaultMessage: 'Paused',
        description: 'The label for the "paused" goal status'
    }
});

});


parcelRegister("byUzi", function(module, exports) {
$parcel$export(module.exports, "useGoalUrlConstructor", () => $3db898fb705dc57f$export$141a926c45c15603);
$parcel$export(module.exports, "getGoalKeyFromUrl", () => $3db898fb705dc57f$export$9bf22e4fb9891a0d);

var $eJOHy = parcelRequire("eJOHy");

var $g9Vr6 = parcelRequire("g9Vr6");

var $cHtIB = parcelRequire("cHtIB");

var $hxEoB = parcelRequire("hxEoB");

var $4cTDP = parcelRequire("4cTDP");

var $kyq27 = parcelRequire("kyq27");

const $3db898fb705dc57f$export$141a926c45c15603 = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const isStagingOrDevOrLocal = (0, $kyq27.useIsStagingOrDevOrLocal)();
    const atlassianHomeUrl = isStagingOrDevOrLocal ? (0, $07a8c3e317a6072d$export$46b5a4e5fbe6e304) : (0, $07a8c3e317a6072d$export$732915c664dff395);
    return (0, $eJOHy.useCallback)(({ ari: ari, key: key })=>{
        if ((0, $4cTDP.fg)('jira_nin_goals_smart_link_fix')) {
            const siteId = (0, $hxEoB.TownsquareGoalAri).parse(ari).siteId;
            return `${atlassianHomeUrl}/o/${orgId}/s/${siteId}/goal/${key}`;
        }
        return `${atlassianHomeUrl}/o/${orgId}/s/${cloudId}/goal/${key}`;
    }, [
        atlassianHomeUrl,
        cloudId,
        orgId
    ]);
};
const $3db898fb705dc57f$export$9bf22e4fb9891a0d = (url)=>url.split('/').pop();

});
parcelRegister("hxEoB", function(module, exports) {
$parcel$export(module.exports, "TownsquareGoalAri", () => $cc54da830a83e212$export$e45ea1bd9a289a4f);

var $fU8Xu = parcelRequire("fU8Xu");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/townsquare/goal/manifest.ts
var $cc54da830a83e212$var$townsquareGoalAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $fU8Xu.TownsquareGoalAriResourceOwner),
    resourceType: (0, $fU8Xu.TownsquareGoalAriResourceType),
    resourceIdSlug: "{goalUuid}",
    resourceIdSegmentFormats: {
        goalUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/goal/index.ts
var $cc54da830a83e212$export$e45ea1bd9a289a4f = class _TownsquareGoalAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._goalUuid = opts.resourceIdSegmentValues.goalUuid;
    }
    get siteId() {
        return this._siteId;
    }
    get goalUuid() {
        return this._goalUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $cc54da830a83e212$var$townsquareGoalAriStaticOpts.qualifier,
            platformQualifier: $cc54da830a83e212$var$townsquareGoalAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $cc54da830a83e212$var$townsquareGoalAriStaticOpts.resourceOwner,
            resourceType: $cc54da830a83e212$var$townsquareGoalAriStaticOpts.resourceType,
            resourceId: `${opts.goalUuid}`,
            resourceIdSegmentValues: {
                goalUuid: opts.goalUuid
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $cc54da830a83e212$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $cc54da830a83e212$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            goalUuid: this.goalUuid
        };
    }
};

});
parcelRegister("fU8Xu", function(module, exports) {
$parcel$export(module.exports, "TownsquareGoalAriResourceOwner", () => $b94308f9cc97b4c4$export$947838268868cc57);
$parcel$export(module.exports, "TownsquareGoalAriResourceType", () => $b94308f9cc97b4c4$export$935b9c2af9d62e80);
// src/townsquare/goal/types.ts
var $b94308f9cc97b4c4$export$947838268868cc57 = "townsquare", $b94308f9cc97b4c4$export$935b9c2af9d62e80 = "goal";

});


const $07a8c3e317a6072d$export$732915c664dff395 = 'https://home.atlassian.com';
const $07a8c3e317a6072d$export$46b5a4e5fbe6e304 = 'https://home.stg.atlassian.com';


parcelRegister("3PRLs", function(module, exports) {
$parcel$export(module.exports, "SimpleInlineSmartLink", () => $6ee98882ad11c6d7$export$e918b96127f4d56b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $18DG7 = parcelRequire("18DG7");
var $5NtHI = parcelRequire("5NtHI");
var $fqBfo = parcelRequire("fqBfo");

var $8YHJ2 = parcelRequire("8YHJ2");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $7Bn2k = parcelRequire("7Bn2k");
const $6ee98882ad11c6d7$var$uiOptions = {
    clickableContainer: true,
    hideBackground: true,
    hideElevation: true,
    hidePadding: true,
    size: (0, $5NtHI.SmartLinkSize).Medium
};
const $6ee98882ad11c6d7$var$uiOptionsWithPlaceholder = {
    ...$6ee98882ad11c6d7$var$uiOptions,
    removeBlockRestriction: true
};
const $6ee98882ad11c6d7$var$actionOptions = {
    hide: false,
    exclude: [
        (0, $18DG7.CardAction).ChangeStatusAction
    ]
};
const $6ee98882ad11c6d7$export$e918b96127f4d56b = ({ onRemove: onRemove, url: url, anchorTarget: anchorTarget, showHoverPreview: showHoverPreview = true, text: text, anchorRef: anchorRef, onError: onError, placeholderData: placeholderData, metadata: metadata, actions: actions, hideRetry: hideRetry, hoverPreviewOptions: hoverPreviewOptions, isSimplifiedUI: isSimplifiedUI = false, icon: icon, onResolve: onResolve })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.025",
        paddingInline: "space.050",
        xcss: isSimplifiedUI ? $6ee98882ad11c6d7$var$simplifiedInlineStyles : $6ee98882ad11c6d7$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8YHJ2.CardSSR), {
        appearance: "inline",
        url: url,
        ui: {
            ...(0, $4cTDP.fg)('jfp-magma-fix-url-field-ssr-hydration') || placeholderData && (0, $4cTDP.fg)('goals_ssr_smart_card') ? $6ee98882ad11c6d7$var$uiOptionsWithPlaceholder : $6ee98882ad11c6d7$var$uiOptions,
            theme: isSimplifiedUI ? (0, $5NtHI.SmartLinkTheme).Black : undefined
        },
        actionOptions: $6ee98882ad11c6d7$var$actionOptions,
        showHoverPreview: showHoverPreview,
        placeholderData: placeholderData,
        onError: onError,
        hoverPreviewOptions: hoverPreviewOptions,
        onResolve: onResolve
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fqBfo.default), {
        hideTitleTooltip: true,
        maxLines: 1,
        metadata: metadata || [
            {
                name: (0, $5NtHI.ElementName).State
            }
        ],
        anchorTarget: anchorTarget ?? '_self',
        text: text,
        anchorRef: anchorRef,
        ...(0, $4cTDP.fg)('goals_ssr_smart_card') ? {
            hideIconLoadingSkeleton: !!placeholderData
        } : {},
        ...isSimplifiedUI ? {
            position: (0, $5NtHI.SmartLinkPosition).Center
        } : {},
        actions: actions,
        icon: icon,
        hideRetry: hideRetry,
        className: (0, $hcewu.default)([
            isSimplifiedUI ? "_zulp1b66 _4t3igktf _c71lgktf _1tkegktf _1e0c1txw _4cvr1h6o _1bah1h6o _11zf9jpi _1k81v77o _cvypi8nm _1mmvplhp _1j7hr5cr _1vabv77o _n2w6v77o" : "_zulp1b66"
        ])
    })), onRemove && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Bn2k.RemoveButton), {
        onClick: onRemove
    }));
};
const $6ee98882ad11c6d7$var$inlineStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface.raised',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderRadius: 'radius.small',
    display: 'inline-flex',
    gap: 'space.050'
});
const $6ee98882ad11c6d7$var$titleBlockStyles = null;
const $6ee98882ad11c6d7$var$simplifiedInlineStyles = (0, $1DXK0.xcss)({
    marginBlock: 'space.025',
    backgroundColor: 'elevation.surface.raised',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderRadius: 'radius.small',
    display: 'inline-flex',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered'
    },
    paddingInlineStart: 'space.025',
    paddingInlineEnd: 'space.0',
    paddingBlock: 'space.0'
});
const $6ee98882ad11c6d7$var$simplifiedTitleBlockStyles = null;

});
parcelRegister("7Bn2k", function(module, exports) {
$parcel$export(module.exports, "RemoveButton", () => $0d8083ad70c45c39$export$4e9d5ce1e6c22a94);

var $eJOHy = parcelRequire("eJOHy");

var $6zhpo = parcelRequire("6zhpo");

var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $bWlv0 = parcelRequire("bWlv0");
const $0d8083ad70c45c39$export$4e9d5ce1e6c22a94 = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleClick = (0, $eJOHy.useCallback)((e)=>{
        e.stopPropagation();
        onClick();
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $bWlv0.default).removeTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
            ...tooltipProps,
            "aria-label": formatMessage((0, $bWlv0.default).removeTooltip),
            onClick: handleClick,
            padding: "space.0",
            xcss: $0d8083ad70c45c39$var$pressableStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
            color: "var(--ds-icon, #292A2E)",
            spacing: "compact",
            label: "",
            size: "small"
        })));
};
const $0d8083ad70c45c39$var$pressableStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'radius.small',
    display: 'flex',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});

});
parcelRegister("bWlv0", function(module, exports) {
$parcel$export(module.exports, "default", () => $90667d3202671c6f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $90667d3202671c6f$var$messages = (0, $7qGN1.defineMessages)({
    removeTooltip: {
        "id": "issue-smart-links-popup-edit-view.smart-link-options-trigger.remove-button.remove-all-tooltip",
        "defaultMessage": "Remove"
    }
});
var $90667d3202671c6f$export$2e2bcd8739ae039 = $90667d3202671c6f$var$messages;

});



parcelRegister("dlGxm", function(module, exports) {
$parcel$export(module.exports, "default", () => $632cb9afa5d02bed$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $632cb9afa5d02bed$var$messages = (0, $7qGN1.defineMessages)({
    noGoalsDisplayName: {
        "id": "issue-table-grouping.group-row.group-header.goal-group-header.no-goals-display-name",
        "defaultMessage": "Issues without goals"
    },
    noGoalsDisplayNameIssueTermRefresh: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.no-goals-display-name-issue-term-refresh",
        "defaultMessage": "Work items without goals"
    },
    statusLabelArchived: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-archived",
        "defaultMessage": "Archived"
    },
    statusLabelPending: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-pending",
        "defaultMessage": "Pending"
    },
    statusLabelInProgress: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-in-progress",
        "defaultMessage": "In progress"
    },
    statusLabelCompleted: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-completed",
        "defaultMessage": "Completed"
    },
    statusLabelOnTrack: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-on-track",
        "defaultMessage": "On track"
    },
    statusLabelPaused: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-paused",
        "defaultMessage": "Paused"
    },
    statusLabelAtRisk: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-at-risk",
        "defaultMessage": "At risk"
    },
    statusLabelOffTrack: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-off-track",
        "defaultMessage": "Off track"
    },
    statusLabelCancelled: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-cancelled",
        "defaultMessage": "Cancelled"
    }
});
var $632cb9afa5d02bed$export$2e2bcd8739ae039 = $632cb9afa5d02bed$var$messages;

});

parcelRegister("7D7Pd", function(module, exports) {
$parcel$export(module.exports, "generatePlaceholderData", () => $5cdfaab984b31e39$export$5d49eb8909604ac1);

var $1QRVx = parcelRequire("1QRVx");
var $2xJv1 = parcelRequire("2xJv1");
const $5cdfaab984b31e39$export$5d49eb8909604ac1 = (url, name, status)=>{
    let icon = '';
    switch(status){
        case 'ON_TRACK':
            icon = 'data:image/png;base64,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';
            break;
        case 'AT_RISK':
            icon = 'data:image/png;base64,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';
            break;
        case 'OFF_TRACK':
            icon = 'data:image/png;base64,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';
            break;
        default:
            icon = 'data:image/png;base64,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';
            break;
    }
    // `atlassian:state` is not typed in SmartLinkResponse, so we needed to forcibly set data to JsonLd.Data.Goal
    const data = {
        '@context': {
            '@vocab': 'https://www.w3.org/ns/activitystreams#',
            atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
            schema: 'http://schema.org/'
        },
        generator: {
            '@type': 'Application',
            '@id': 'https://www.atlassian.com/#TeamCentral',
            name: 'Goals'
        },
        '@type': [
            'Object',
            'atlassian:Goal'
        ],
        url: url,
        icon: {
            '@type': 'Image',
            url: icon
        },
        name: name,
        'atlassian:state': {
            '@type': 'Object',
            name: (0, $2xJv1.getGoalStatusLabel)(status).defaultMessage,
            appearance: (0, $1QRVx.getGoalStatusAppearance)(status)
        }
    };
    return {
        meta: {
            auth: [],
            definitionId: 'watermelon-object-provider',
            product: 'townsquare',
            visibility: 'restricted',
            access: 'granted',
            key: 'watermelon-object-provider'
        },
        data: data
    };
};

});
parcelRegister("1QRVx", function(module, exports) {
$parcel$export(module.exports, "getGoalStatusAppearance", () => $cfcdcb252e61ba2c$export$f3c978edf3168c96);

var $7yljC = parcelRequire("7yljC");
const $cfcdcb252e61ba2c$export$f3c978edf3168c96 = (status)=>{
    switch(status){
        case (0, $7yljC.goalStatusValues).ON_TRACK:
            return 'success';
        case (0, $7yljC.goalStatusValues).AT_RISK:
            return 'moved';
        case (0, $7yljC.goalStatusValues).OFF_TRACK:
            return 'removed';
        default:
            return 'default';
    }
};

});
parcelRegister("7yljC", function(module, exports) {
$parcel$export(module.exports, "goalStatusValues", () => $98181fc84d73c663$export$d7b4c6a971e28318);
const $98181fc84d73c663$export$d7b4c6a971e28318 = {
    ON_TRACK: 'ON_TRACK',
    AT_RISK: 'AT_RISK',
    OFF_TRACK: 'OFF_TRACK',
    PENDING: 'PENDING',
    DONE: 'DONE',
    CANCELLED: 'CANCELLED',
    PAUSED: 'PAUSED',
    ARCHIVED: 'ARCHIVED',
    COMPLETED: 'COMPLETED'
};

});


parcelRegister("2xJv1", function(module, exports) {
$parcel$export(module.exports, "getGoalStatusLabel", () => $9bb15c56309bfd49$export$9d87710a33c624b0);

var $gEcrN = parcelRequire("gEcrN");
const $9bb15c56309bfd49$export$9d87710a33c624b0 = (status)=>{
    switch(status){
        case 'ON_TRACK':
            return (0, $gEcrN.messages).ON_TRACK;
        case 'OFF_TRACK':
            return (0, $gEcrN.messages).OFF_TRACK;
        case 'AT_RISK':
            return (0, $gEcrN.messages).AT_RISK;
        case 'PENDING':
            return (0, $gEcrN.messages).PENDING;
        case 'COMPLETED':
        case 'DONE':
            return (0, $gEcrN.messages).COMPLETED;
        case 'CANCELLED':
            return (0, $gEcrN.messages).CANCELLED;
        case 'PAUSED':
            return (0, $gEcrN.messages).PAUSED;
        case 'ARCHIVED':
            return (0, $gEcrN.messages).ARCHIVED;
        default:
            // Fallback to displaying the raw status text if it's unrecognized
            return {
                defaultMessage: status
            };
    }
};

});
parcelRegister("gEcrN", function(module, exports) {
$parcel$export(module.exports, "messages", () => $ef9378426989bfd3$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");

var $7yljC = parcelRequire("7yljC");
const $ef9378426989bfd3$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    [(0, $7yljC.goalStatusValues).ON_TRACK]: {
        id: 'Goals.label.on-track',
        defaultMessage: 'On track',
        description: 'The label for the "on track" goal status'
    },
    [(0, $7yljC.goalStatusValues).OFF_TRACK]: {
        id: 'Goals.label.off-track',
        defaultMessage: 'Off track',
        description: 'The label for the "off track" goal status'
    },
    [(0, $7yljC.goalStatusValues).AT_RISK]: {
        id: 'Goals.label.at-risk',
        defaultMessage: 'At risk',
        description: 'The label for the "at risk" goal status'
    },
    [(0, $7yljC.goalStatusValues).PENDING]: {
        id: 'Goals.label.pending',
        defaultMessage: 'Pending',
        description: 'The label for the "pending" goal status'
    },
    [(0, $7yljC.goalStatusValues).COMPLETED]: {
        id: 'Goals.label.completed',
        defaultMessage: 'Completed',
        description: 'The label for the "completed" goal status'
    },
    [(0, $7yljC.goalStatusValues).DONE]: {
        id: 'Goals.label.completed',
        defaultMessage: 'Completed',
        description: 'The label for the "completed" goal status'
    },
    [(0, $7yljC.goalStatusValues).CANCELLED]: {
        id: 'Goals.label.cancelled',
        defaultMessage: 'Cancelled',
        description: 'The label for the "cancelled" goal status'
    },
    [(0, $7yljC.goalStatusValues).PAUSED]: {
        id: 'Goals.label.paused',
        defaultMessage: 'Paused',
        description: 'The label for the "paused" goal status'
    },
    [(0, $7yljC.goalStatusValues).ARCHIVED]: {
        id: 'Goals.label.archived',
        defaultMessage: 'Archived',
        description: 'The label for the "archived" goal status'
    }
});

});




parcelRegister("cKV4K", function(module, exports) {
$parcel$export(module.exports, "LabelGroupHeader", () => $f82594f1a021ae46$export$18b1d108a714e82e);

var $8JNua = parcelRequire("8JNua");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $cxKOj = parcelRequire("cxKOj");

var $aCFLd = parcelRequire("aCFLd");

var $051tO = parcelRequire("051tO");

var $aIng6 = parcelRequire("aIng6");

var $7hEnC = parcelRequire("7hEnC");
const $f82594f1a021ae46$var$isColorfulLabelsEnabled = ()=>(0, $cxKOj.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) || (0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false);
// Logic inherited from src/packages/issue/fields/platform/labels/readview-full/src/ui/labels/index.tsx
const $f82594f1a021ae46$var$getLabelColor = (label)=>{
    if ((0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
        const colorName = label?.color?.colorKey;
        if (!colorName) return (0, $aCFLd.memoizeGetAutoGeneratedColorForLabelsTag)(label?.name || '');
        const { tagColor: tagColor } = (0, $051tO.getColorMetadata)(colorName);
        return tagColor;
    }
    if ((0, $cxKOj.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false)) return (0, $aCFLd.memoizeGetAutoGeneratedColorForLabelsTag)(label?.name || '');
};
const $f82594f1a021ae46$export$18b1d108a714e82e = ({ labelGroupHeader: labelGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $8JNua.default), labelGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIng6.TagGroupHeaderContent), {
        text: data?.label?.name,
        color: data?.label ? $f82594f1a021ae46$var$getLabelColor(data.label) : undefined,
        isColored: $f82594f1a021ae46$var$isColorfulLabelsEnabled(),
        noValueText: formatMessage((0, $7hEnC.default).noLabel)
    });
};

});
parcelRegister("8JNua", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c21d63911eb6379$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<70e7f722477a95b8a80b65e0cc80f9e5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4c21d63911eb6379$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "LabelGroupHeader",
    "selections": [
        {
            "concreteType": "JiraLabel",
            "kind": "LinkedField",
            "name": "label",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "JiraColor",
                    "kind": "LinkedField",
                    "name": "color",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "colorKey"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraJqlLabelFieldValue"
};
$4c21d63911eb6379$var$node.hash = "a8bfa525dbc0a2dfd874d9659eb9c96d";
var $4c21d63911eb6379$export$2e2bcd8739ae039 = $4c21d63911eb6379$var$node;

});

parcelRegister("aCFLd", function(module, exports) {
$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabels", () => $3bdc301abc6592d1$export$8100203285e9ab92);
$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabelsTag", () => $3bdc301abc6592d1$export$a80529ae8ec44f02);

var $5PQOA = parcelRequire("5PQOA");

var $cNNNb = parcelRequire("cNNNb");

var $1mQND = parcelRequire("1mQND");

var $eFge8 = parcelRequire("eFge8");
const $3bdc301abc6592d1$export$97056d4b28203ee9 = (option)=>{
    if (option) {
        const hashValue = (0, $1mQND.getHashValueForText)(option);
        const randomIndex = (0, $eFge8.getRandomIndex)(hashValue);
        return (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
    }
    return (0, $cNNNb.GREY_META).name;
};
const $3bdc301abc6592d1$export$a3f5334e7a13e57a = (option)=>{
    if (option) {
        const hashValue = (0, $1mQND.getHashValueForText)(option);
        const randomIndex = (0, $eFge8.getRandomIndex)(hashValue);
        return (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].tagColor;
    }
    return (0, $cNNNb.GREY_META).tagColor;
};
const $3bdc301abc6592d1$export$8100203285e9ab92 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))($3bdc301abc6592d1$export$97056d4b28203ee9);
const $3bdc301abc6592d1$export$a80529ae8ec44f02 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))($3bdc301abc6592d1$export$a3f5334e7a13e57a);

});
parcelRegister("cNNNb", function(module, exports) {
$parcel$export(module.exports, "GREY_META", () => $711a16afce0bfcb3$export$11b75436f568ab00);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $711a16afce0bfcb3$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $711a16afce0bfcb3$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "OPTION_COLOR_THEMES", () => $711a16afce0bfcb3$export$7f42563469df7e01);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT", () => $711a16afce0bfcb3$export$2c649adf8351b065);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_COLORFUL_DARKER_SINGLE_SELECT", () => $711a16afce0bfcb3$export$20b2b274810f728a);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_MAP", () => $711a16afce0bfcb3$export$7c14120abebd4749);

var $isE62 = parcelRequire("isE62");
const $711a16afce0bfcb3$var$GREY_LIGHTEST_META = {
    name: 'GREY_LIGHTEST',
    backgroundColor: "var(--ds-background-neutral, #0515240F)",
    borderColor: "var(--ds-background-neutral, #0515240F)",
    textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
    messageLabel: (0, $isE62.default).greyLightest
};
const $711a16afce0bfcb3$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #0B120E24)",
    borderColor: "var(--ds-background-neutral-hovered, #0B120E24)",
    textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
    messageLabel: (0, $isE62.default).greyLighter
};
const $711a16afce0bfcb3$export$11b75436f568ab00 = {
    name: 'GREY',
    tagColor: 'grey',
    backgroundColor: "var(--ds-background-neutral-pressed, #080F214A)",
    borderColor: "var(--ds-background-neutral-pressed, #080F214A)",
    textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
    messageLabel: (0, $isE62.default).grey
};
const $711a16afce0bfcb3$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    tagColor: 'greyDarker',
    backgroundColor: "var(--ds-background-neutral-bold, #292A2E)",
    borderColor: "var(--ds-border-accent-gray, #7D818A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greyDarker
};
const $711a16afce0bfcb3$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: "var(--ds-background-neutral-bold-pressed, #505258)",
    borderColor: "var(--ds-background-neutral-bold, #292A2E)",
    // grey700
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greyDarkest
};
const $711a16afce0bfcb3$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    borderColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    textColor: "var(--ds-text-accent-purple-bolder, #48245D)",
    messageLabel: (0, $isE62.default).purpleLightest
};
const $711a16afce0bfcb3$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    borderColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    textColor: "var(--ds-text-accent-purple-bolder, #48245D)",
    messageLabel: (0, $isE62.default).purpleLighter
};
const $711a16afce0bfcb3$var$PURPLE_META = {
    name: 'PURPLE',
    tagColor: 'purple',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
    borderColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
    textColor: "var(--ds-text-accent-purple-bolder, #48245D)",
    messageLabel: (0, $isE62.default).purple
};
const $711a16afce0bfcb3$export$7c314e2461a7241b = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #803FA5)",
    borderColor: "var(--ds-border-accent-purple, #AF59E1)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).purpleDarker
};
const $711a16afce0bfcb3$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #48245D)",
    borderColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).purpleDarkest
};
const $711a16afce0bfcb3$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    borderColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    textColor: "var(--ds-text-accent-blue-bolder, #123263)",
    messageLabel: (0, $isE62.default).blueLightest
};
const $711a16afce0bfcb3$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    borderColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    textColor: "var(--ds-text-accent-blue-bolder, #123263)",
    messageLabel: (0, $isE62.default).blueLighter
};
const $711a16afce0bfcb3$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
    borderColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
    textColor: "var(--ds-text-accent-blue-bolder, #123263)",
    messageLabel: (0, $isE62.default).blue
};
const $711a16afce0bfcb3$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #1558BC)",
    borderColor: "var(--ds-border-accent-blue, #357DE8)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).blueDarker
};
const $711a16afce0bfcb3$export$69c4eac71b813fba = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #123263)",
    borderColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).blueDarkest
};
const $711a16afce0bfcb3$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    borderColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $isE62.default).tealLightest
};
const $711a16afce0bfcb3$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    borderColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $isE62.default).tealLighter
};
const $711a16afce0bfcb3$var$TEAL_META = {
    name: 'TEAL',
    tagColor: 'teal',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    borderColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $isE62.default).teal
};
const $711a16afce0bfcb3$export$6daaa1cc3f46f41 = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    borderColor: "var(--ds-border-accent-teal, #2898BD)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).tealDarker
};
const $711a16afce0bfcb3$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    borderColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).tealDarkest
};
const $711a16afce0bfcb3$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    borderColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $isE62.default).greenLightest
};
const $711a16afce0bfcb3$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    borderColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $isE62.default).greenLighter
};
const $711a16afce0bfcb3$var$GREEN_META = {
    name: 'GREEN',
    tagColor: 'green',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    borderColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $isE62.default).green
};
const $711a16afce0bfcb3$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    borderColor: "var(--ds-border-accent-green, #22A06B)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greenDarker
};
const $711a16afce0bfcb3$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    borderColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greenDarkest
};
const $711a16afce0bfcb3$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    borderColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $isE62.default).limeLightest
};
const $711a16afce0bfcb3$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    borderColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $isE62.default).limeLighter
};
const $711a16afce0bfcb3$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    borderColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $isE62.default).lime
};
const $711a16afce0bfcb3$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    borderColor: "var(--ds-border-accent-lime, #6A9A23)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).limeDarker
};
const $711a16afce0bfcb3$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    borderColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).limeDarkest
};
const $711a16afce0bfcb3$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    borderColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $isE62.default).yellowLightest
};
const $711a16afce0bfcb3$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    borderColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $isE62.default).yellowLighter
};
const $711a16afce0bfcb3$var$YELLOW_META = {
    name: 'YELLOW',
    tagColor: 'yellow',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
    borderColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $isE62.default).yellow
};
const $711a16afce0bfcb3$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    borderColor: "var(--ds-border-accent-yellow, #B38600)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).yellowDarker
};
const $711a16afce0bfcb3$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    borderColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).yellowDarkest
};
const $711a16afce0bfcb3$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    borderColor: "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    textColor: "var(--ds-text-accent-orange-bolder, #693200)",
    messageLabel: (0, $isE62.default).orangeLightest
};
const $711a16afce0bfcb3$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    borderColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    textColor: "var(--ds-text-accent-orange-bolder, #693200)",
    messageLabel: (0, $isE62.default).orangeLighter
};
const $711a16afce0bfcb3$var$ORANGE_META = {
    name: 'ORANGE',
    tagColor: 'orange',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
    borderColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
    textColor: "var(--ds-text-accent-orange-bolder, #693200)",
    messageLabel: (0, $isE62.default).orange
};
const $711a16afce0bfcb3$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #BD5B00)",
    borderColor: "var(--ds-border-accent-orange, #E06C00)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).orangeDarker
};
const $711a16afce0bfcb3$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #693200)",
    borderColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).orangeDarkest
};
const $711a16afce0bfcb3$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    borderColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $isE62.default).redLightest
};
const $711a16afce0bfcb3$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    borderColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $isE62.default).redLighter
};
const $711a16afce0bfcb3$var$RED_META = {
    name: 'RED',
    tagColor: 'red',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    borderColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $isE62.default).red
};
const $711a16afce0bfcb3$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    borderColor: "var(--ds-border-accent-red, #E2483D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).redDarker
};
const $711a16afce0bfcb3$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    borderColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).redDarkest
};
const $711a16afce0bfcb3$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    borderColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $isE62.default).magentaLightest
};
const $711a16afce0bfcb3$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    borderColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $isE62.default).magentaLighter
};
const $711a16afce0bfcb3$var$MAGENTA_META = {
    name: 'MAGENTA',
    tagColor: 'magenta',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    borderColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $isE62.default).magenta
};
const $711a16afce0bfcb3$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    borderColor: "var(--ds-border-accent-magenta, #CD519D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).magentaDarker
};
const $711a16afce0bfcb3$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    borderColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).magentaDarkest
};
const $711a16afce0bfcb3$export$270aee965367aeb3 = "var(--ds-text-inverse, #FFFFFF)";
const $711a16afce0bfcb3$export$941ef40ef5fdd2b1 = "var(--ds-text, #292A2E)";
const $711a16afce0bfcb3$export$7f42563469df7e01 = [
    $711a16afce0bfcb3$var$GREY_LIGHTEST_META,
    $711a16afce0bfcb3$var$PURPLE_LIGHTEST_META,
    $711a16afce0bfcb3$var$BLUE_LIGHTEST_META,
    $711a16afce0bfcb3$var$TEAL_LIGHTEST_META,
    $711a16afce0bfcb3$var$GREEN_LIGHTEST_META,
    $711a16afce0bfcb3$var$LIME_LIGHTEST_META,
    $711a16afce0bfcb3$var$YELLOW_LIGHTEST_META,
    $711a16afce0bfcb3$var$ORANGE_LIGHTEST_META,
    $711a16afce0bfcb3$var$RED_LIGHTEST_META,
    $711a16afce0bfcb3$var$MAGENTA_LIGHTEST_META,
    $711a16afce0bfcb3$var$GREY_LIGHTER_META,
    $711a16afce0bfcb3$var$PURPLE_LIGHTER_META,
    $711a16afce0bfcb3$var$BLUE_LIGHTER_META,
    $711a16afce0bfcb3$var$TEAL_LIGHTER_META,
    $711a16afce0bfcb3$var$GREEN_LIGHTER_META,
    $711a16afce0bfcb3$var$LIME_LIGHTER_META,
    $711a16afce0bfcb3$var$YELLOW_LIGHTER_META,
    $711a16afce0bfcb3$var$ORANGE_LIGHTER_META,
    $711a16afce0bfcb3$var$RED_LIGHTER_META,
    $711a16afce0bfcb3$var$MAGENTA_LIGHTER_META,
    $711a16afce0bfcb3$export$11b75436f568ab00,
    $711a16afce0bfcb3$var$PURPLE_META,
    $711a16afce0bfcb3$var$BLUE_META,
    $711a16afce0bfcb3$var$TEAL_META,
    $711a16afce0bfcb3$var$GREEN_META,
    $711a16afce0bfcb3$var$LIME_META,
    $711a16afce0bfcb3$var$YELLOW_META,
    $711a16afce0bfcb3$var$ORANGE_META,
    $711a16afce0bfcb3$var$RED_META,
    $711a16afce0bfcb3$var$MAGENTA_META,
    $711a16afce0bfcb3$var$GREY_DARKER_META,
    $711a16afce0bfcb3$export$7c314e2461a7241b,
    $711a16afce0bfcb3$var$BLUE_DARKER_META,
    $711a16afce0bfcb3$export$6daaa1cc3f46f41,
    $711a16afce0bfcb3$var$GREEN_DARKER_META,
    $711a16afce0bfcb3$var$LIME_DARKER_META,
    $711a16afce0bfcb3$var$YELLOW_DARKER_META,
    $711a16afce0bfcb3$var$ORANGE_DARKER_META,
    $711a16afce0bfcb3$var$RED_DARKER_META,
    $711a16afce0bfcb3$var$MAGENTA_DARKER_META,
    $711a16afce0bfcb3$var$GREY_DARKEST_META,
    $711a16afce0bfcb3$var$PURPLE_DARKEST_META,
    $711a16afce0bfcb3$export$69c4eac71b813fba,
    $711a16afce0bfcb3$var$TEAL_DARKEST_META,
    $711a16afce0bfcb3$var$GREEN_DARKEST_META,
    $711a16afce0bfcb3$var$LIME_DARKEST_META,
    $711a16afce0bfcb3$var$YELLOW_DARKEST_META,
    $711a16afce0bfcb3$var$ORANGE_DARKEST_META,
    $711a16afce0bfcb3$var$RED_DARKEST_META,
    $711a16afce0bfcb3$var$MAGENTA_DARKEST_META
];
const $711a16afce0bfcb3$export$2c649adf8351b065 = [
    $711a16afce0bfcb3$var$PURPLE_META,
    $711a16afce0bfcb3$var$YELLOW_META,
    $711a16afce0bfcb3$var$GREEN_META,
    $711a16afce0bfcb3$var$TEAL_META,
    $711a16afce0bfcb3$var$RED_META,
    $711a16afce0bfcb3$var$ORANGE_META,
    $711a16afce0bfcb3$var$MAGENTA_META,
    $711a16afce0bfcb3$var$GREY_DARKER_META,
    $711a16afce0bfcb3$export$11b75436f568ab00
];
const $711a16afce0bfcb3$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP = {};
$711a16afce0bfcb3$export$2c649adf8351b065.forEach((option)=>{
    $711a16afce0bfcb3$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP[option.name] = option;
});
const $711a16afce0bfcb3$export$20b2b274810f728a = [
    $711a16afce0bfcb3$export$7c314e2461a7241b,
    $711a16afce0bfcb3$var$YELLOW_DARKER_META,
    $711a16afce0bfcb3$var$GREEN_DARKER_META,
    $711a16afce0bfcb3$export$6daaa1cc3f46f41,
    $711a16afce0bfcb3$var$RED_DARKER_META,
    $711a16afce0bfcb3$var$ORANGE_DARKER_META,
    $711a16afce0bfcb3$var$MAGENTA_DARKER_META,
    $711a16afce0bfcb3$var$GREY_DARKER_META,
    $711a16afce0bfcb3$var$GREY_DARKEST_META
];
const $711a16afce0bfcb3$export$7c14120abebd4749 = {};
$711a16afce0bfcb3$export$7f42563469df7e01.forEach((option)=>{
    $711a16afce0bfcb3$export$7c14120abebd4749[option.name] = option;
});

});
parcelRegister("isE62", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ddc0b3065e46f63$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2ddc0b3065e46f63$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    greyLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});


parcelRegister("1mQND", function(module, exports) {
$parcel$export(module.exports, "getHashValueForText", () => $682ff2f1c6e48764$export$e352defce701b36e);

const $682ff2f1c6e48764$export$e352defce701b36e = (text)=>{
    let hashValue = 0;
    for(let i = 0; i < text.length; i++)hashValue = (hashValue * (0, $12800e69511f991d$export$d15e38bcd75fda7c) + text.charCodeAt(i)) % (0, $12800e69511f991d$export$e143f4b09221a374);
    return hashValue;
};

});
/*
 * This is used to calculate the hash value of the provided text,
 * allowing us to generate random hash values for the options in the Labels field.
 * As a result, we enhance the randomization of color assignments to Labels.
 */ const $12800e69511f991d$export$d15e38bcd75fda7c = 256;
const $12800e69511f991d$export$e143f4b09221a374 = 1000000007;


parcelRegister("eFge8", function(module, exports) {
$parcel$export(module.exports, "getRandomIndex", () => $e4e4b7d26b0de284$export$cb0dffe2d2ae675a);

var $cNNNb = parcelRequire("cNNNb");
const $e4e4b7d26b0de284$export$cb0dffe2d2ae675a = (hashValue)=>{
    const colorThemesLength = (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length;
    const randomIndex = hashValue % colorThemesLength;
    return randomIndex;
};

});


parcelRegister("051tO", function(module, exports) {
$parcel$export(module.exports, "getRandomColor", () => $3b3f14c0d0659bfe$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $3b3f14c0d0659bfe$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $3b3f14c0d0659bfe$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $3b3f14c0d0659bfe$export$49fce7fdcf55f26d);

var $cNNNb = parcelRequire("cNNNb");
const $3b3f14c0d0659bfe$export$e4369cabd7e84cd9 = ({ colorPaletteVariant: colorPaletteVariant = '' } = {})=>{
    // usign colorPaletteVariant to determine which color palette to use for random color selection
    const palette = colorPaletteVariant === 'newDarker' ? (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_DARKER_SINGLE_SELECT) : (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT);
    const randomIndex = Math.floor(Math.random() * palette.length);
    return palette[randomIndex].name;
};
const $3b3f14c0d0659bfe$export$b5ccbadd112d8ce9 = (colorValue, colorCardVariant = 'fill')=>{
    if (colorCardVariant === 'outline') return (0, $cNNNb.OPTION_COLOR_THEMES).find((item)=>item.borderColor === colorValue)?.name ?? '';
    return (0, $cNNNb.OPTION_COLOR_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
};
const $3b3f14c0d0659bfe$export$9eff62e8ee2aaa2c = (colorName, colorCardVariant = 'fill')=>{
    if (colorCardVariant === 'outline') return (0, $cNNNb.OPTION_COLOR_THEMES_MAP)[colorName]?.borderColor ?? '';
    return (0, $cNNNb.OPTION_COLOR_THEMES_MAP)[colorName]?.backgroundColor ?? '';
};
const $3b3f14c0d0659bfe$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $cNNNb.GREY_META;
    return (0, $cNNNb.OPTION_COLOR_THEMES_MAP)[colorName] ?? (0, $cNNNb.GREY_META);
};
const $3b3f14c0d0659bfe$export$4ef6b7574883e63d = ()=>(0, $cNNNb.OPTION_COLOR_THEMES).map((item)=>item.name);

});

parcelRegister("aIng6", function(module, exports) {
$parcel$export(module.exports, "TagGroupHeaderContent", () => $ca486725032725d5$export$be4c68ded587a8de);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");

var $1tX0c = parcelRequire("1tX0c");

var $4cTDP = parcelRequire("4cTDP");
const $ca486725032725d5$export$be4c68ded587a8de = ({ text: text, noValueText: noValueText, ...colorProps })=>{
    return text ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1tX0c.TagItem), {
        name: text,
        ...colorProps,
        isHoverPopoverEnabled: (0, $4cTDP.fg)('group_by_any_field_tag_tooltip')
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, noValueText);
};

});
parcelRegister("1tX0c", function(module, exports) {
$parcel$export(module.exports, "TagItem", () => $99a66faf131dedf1$export$32a09b7581f7fd80);
$parcel$export(module.exports, "TagItemPopupContentWrapper", () => $99a66faf131dedf1$export$c9925310d93bfb2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $2TCFC = parcelRequire("2TCFC");
var $5DgXR = parcelRequire("5DgXR");
var $lC3pF = parcelRequire("lC3pF");

var $cgxPA = parcelRequire("cgxPA");

var $ewOxf = parcelRequire("ewOxf");

var $cxKOj = parcelRequire("cxKOj");

var $iyBBa = parcelRequire("iyBBa");

var $ibVOD = parcelRequire("ibVOD");

var $9Mapt = parcelRequire("9Mapt");

var $bzbsd = parcelRequire("bzbsd");

var $gybMp = parcelRequire("gybMp");
const $99a66faf131dedf1$var$AVATAR_SIZE = 'xsmall';
const $99a66faf131dedf1$var$AVATAR_APPEARANCE = 'square';
const $99a66faf131dedf1$var$tagMarginFixStyles = null;
const $99a66faf131dedf1$var$tagMarginInlineFixStyles = null;
const $99a66faf131dedf1$var$strikethroughStyles = null;
const $99a66faf131dedf1$var$TagItemAvatar = ({ src: src, testId: testId = 'list-with-popup.ui.tag-item.avatar' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: $99a66faf131dedf1$var$AVATAR_APPEARANCE,
        size: $99a66faf131dedf1$var$AVATAR_SIZE,
        src: src,
        borderColor: "transparent",
        testId: testId
    });
const $99a66faf131dedf1$var$TagItemMediaImage = /*#__PURE__*/ (0, $eJOHy.memo)(({ mediaImage: mediaImage, fallbackSrc: fallbackSrc })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cgxPA.MediaImageWithErrorBoundary), {
        identifier: mediaImage.identifier,
        mediaClientConfig: mediaImage.mediaClientConfig,
        apiConfig: {
            ...mediaImage.apiConfig,
            width: (0, $2TCFC.AVATAR_SIZES)[$99a66faf131dedf1$var$AVATAR_SIZE],
            height: (0, $2TCFC.AVATAR_SIZES)[$99a66faf131dedf1$var$AVATAR_SIZE]
        }
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lC3pF.default), {
            appearance: $99a66faf131dedf1$var$AVATAR_APPEARANCE,
            size: $99a66faf131dedf1$var$AVATAR_SIZE
        });
        if (error || !data?.src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a66faf131dedf1$var$TagItemAvatar, {
            src: fallbackSrc,
            testId: "list-with-popup.ui.tag-item.media-image-error"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a66faf131dedf1$var$TagItemAvatar, {
            src: data?.src,
            testId: "list-with-popup.ui.tag-item.media-image-avatar"
        });
    }));
const $99a66faf131dedf1$var$TagItemIcon = ({ icon: icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, icon.mediaImage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a66faf131dedf1$var$TagItemMediaImage, {
        mediaImage: icon.mediaImage,
        fallbackSrc: icon.url
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a66faf131dedf1$var$TagItemAvatar, {
        src: icon.url
    }));
const $99a66faf131dedf1$export$32a09b7581f7fd80 = ({ name: name, href: href, icon: icon, shouldDisplayStrikethrough: shouldDisplayStrikethrough, isColored: isColored, color: color, isHoverPopoverEnabled: isHoverPopoverEnabled = false, isOnlyOneItem: isOnlyOneItem })=>{
    const tagRef = (0, $eJOHy.useRef)(null);
    if (isHoverPopoverEnabled) {
        const renderTagContent = (ref, props)=>{
            return isColored ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iyBBa.ColoredTag), {
                labelName: name,
                href: href,
                actionSubjectId: "listWithPopup",
                containerXcss: $99a66faf131dedf1$var$extraColoredTagStyles,
                contentXcss: $99a66faf131dedf1$var$extraColoredTagTextStyles,
                analyticsAttributes: {
                    isHoverPopoverEnabled: isHoverPopoverEnabled
                },
                ref: ref,
                ...color && (0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? {
                    color: color
                } : {},
                ...props
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1ule _1ul9ze3t"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
                "data-testid": "list-with-popup.ui.tag-item.tag-item",
                ...props,
                className: (0, $hcewu.default)([
                    "_1e0c1o8l _19pkr5cr _otyrr5cr _p12f1osq _l9z01osq",
                    "_2hwxr5cr _18u0r5cr",
                    shouldDisplayStrikethrough && "_59381r81 _yha21cog _1nmzvv82"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
                elemBefore: icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a66faf131dedf1$var$TagItemIcon, {
                    icon: icon
                }) : undefined,
                text: name,
                href: href,
                linkComponent: (0, $gybMp.default),
                ref: ref
            })));
        };
        const hoverPopoverContent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
                contentRef: tagRef,
                content: name
            }, ({ ref: ref })=>renderTagContent((0, $bzbsd.mergeRefs)(tagRef, ref), props));
        if (isOnlyOneItem) return hoverPopoverContent();
        // If there are more then one tag, different popovers need to be rendered on the tag and the see more button.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, ({ onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>hoverPopoverContent({
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave
            })));
    }
    if (isColored) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iyBBa.ColoredTag), {
        labelName: name,
        href: href,
        actionSubjectId: "listWithPopup",
        containerXcss: $99a66faf131dedf1$var$extraColoredTagStyles,
        contentXcss: $99a66faf131dedf1$var$extraColoredTagTextStyles,
        ...color && (0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? {
            color: color
        } : {}
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": "list-with-popup.ui.tag-item.tag-item",
        className: (0, $hcewu.default)([
            "_1e0c1o8l _19pkr5cr _otyrr5cr _p12f1osq _l9z01osq",
            "_2hwxr5cr _18u0r5cr",
            shouldDisplayStrikethrough && "_59381r81 _yha21cog _1nmzvv82"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
        elemBefore: icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a66faf131dedf1$var$TagItemIcon, {
            icon: icon
        }) : undefined,
        text: name,
        href: href,
        linkComponent: (0, $gybMp.default)
    }));
};
const $99a66faf131dedf1$export$c9925310d93bfb2 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        shouldWrap: true
    }, children);
const $99a66faf131dedf1$var$extraColoredTagTextStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%'
});
const $99a66faf131dedf1$var$extraColoredTagStyles = (0, $1DXK0.xcss)({
    marginInline: 'space.0',
    minWidth: '0px'
});
const $99a66faf131dedf1$var$hoverPopoverStyles = null;

});
parcelRegister("lC3pF", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd8f08acdf78d9e1$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");
const $fd8f08acdf78d9e1$var$bgColorCssVar = '--avatar-skeleton-background-color';
const $fd8f08acdf78d9e1$var$styles = {
    root: "_2rko1qll _189e1dm9 _1dqonqa1 _1h6d3acm _1e0c1o8l _bfhk1r8p _tzy4nh7s",
    square: "_2rkol0p1",
    hexagon: "_mkrz1k6g",
    strongOpacity: "_tzy4clii"
};
const $fd8f08acdf78d9e1$var$sizeStyles = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $fd8f08acdf78d9e1$var$borderRadiusMap = {
    xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rko12b0",
    large: "_2rko12b0",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $fd8f08acdf78d9e1$var$Skeleton = ({ size: size, appearance: appearance, color: color, weight: weight })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            [$fd8f08acdf78d9e1$var$bgColorCssVar]: color ?? 'currentColor'
        },
        className: (0, $hcewu.default)([
            $fd8f08acdf78d9e1$var$styles.root,
            $fd8f08acdf78d9e1$var$sizeStyles[size ?? 'medium'],
            appearance === 'square' && !(0, $eGOwo.fg)('platform_dst_avatar_tile') && $fd8f08acdf78d9e1$var$borderRadiusMap[size ?? 'medium'],
            appearance === 'square' && (0, $eGOwo.fg)('platform_dst_avatar_tile') && $fd8f08acdf78d9e1$var$styles.square,
            appearance === 'hexagon' && $fd8f08acdf78d9e1$var$styles.hexagon,
            weight === 'strong' && $fd8f08acdf78d9e1$var$styles.strongOpacity
        ])
    });
var $fd8f08acdf78d9e1$export$2e2bcd8739ae039 = $fd8f08acdf78d9e1$var$Skeleton;

});

parcelRegister("cgxPA", function(module, exports) {
$parcel$export(module.exports, "MediaImageWithErrorBoundary", () => $4d10e61645f59e88$export$758a2fef95a29ad0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $iDkaD = parcelRequire("iDkaD");
const $4d10e61645f59e88$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: props.children({
                loading: false,
                error: true
            })
        }),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iDkaD.MediaImageWithMediaClient), {
            ...props
        })
    });

});
parcelRegister("iDkaD", function(module, exports) {
$parcel$export(module.exports, "MediaImageWithMediaClient", () => $124670e45144e8f4$export$8acd7eecc88dfeb5);
/* mediaImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cu5Ae = parcelRequire("cu5Ae");

var $iN7PZ = parcelRequire("iN7PZ");

var $eGOwo = parcelRequire("eGOwo");
const $124670e45144e8f4$var$copyDivStyles = null;
const $124670e45144e8f4$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $iN7PZ.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            children({
                loading: status === 'loading',
                error: status === 'error',
                data: status === 'succeeded' ? {
                    status: status,
                    src: preview?.dataURI
                } : undefined
            }),
            (0, $eGOwo.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ref: copyNodeRef,
                className: (0, $hcewu.default)([
                    "_1e0cglyw"
                ])
            }),
            getSsrScriptProps && /*#__PURE__*/ (0, $gt9Am.jsx)("script", {
                ...getSsrScriptProps()
            })
        ]
    });
};
const $124670e45144e8f4$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $eJOHy.useMemo)(()=>(0, $cu5Ae.withMediaClient)($124670e45144e8f4$var$MediaImageBase), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(MediaImageComponent, {
        ...props
    });
};

});
parcelRegister("cu5Ae", function(module, exports) {
$parcel$export(module.exports, "withMediaClient", () => $5bfc4058bddc627f$export$9f7977d4a2561bee);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $AIyOt = parcelRequire("AIyOt");

var $aRuva = parcelRequire("aRuva");

var $93R6D = parcelRequire("93R6D");
const $5bfc4058bddc627f$export$9f7977d4a2561bee = (Component)=>(0, $AIyOt.componentWithCondition)(()=>(0, $eGOwo.fg)('media-perf-uplift-mutation-fix'), ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>{
        const existingMediaClient = (0, $eJOHy.useContext)((0, $93R6D.MediaClientContext));
        const mediaClient = (0, $eJOHy.useMemo)(()=>existingMediaClient ?? (0, $aRuva.getMediaClient)(mediaClientConfig), [
            mediaClientConfig,
            existingMediaClient
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientContext).Provider, {
            value: mediaClient,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                ...otherProps,
                mediaClient: mediaClient
            })
        });
    }, ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientContext).Consumer, {
            children: (value)=>value ? /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    ...otherProps,
                    mediaClient: value
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientProvider), {
                    clientConfig: mediaClientConfig,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientContext).Consumer, {
                        children: (client)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                                ...otherProps,
                                mediaClient: client
                            })
                    })
                })
        }));

});

parcelRegister("iN7PZ", function(module, exports) {
$parcel$export(module.exports, "useFilePreview", () => $e54d3f9e11f733f6$export$4eaebdef02112fe4);

var $eJOHy = parcelRequire("eJOHy");

var $bbNl0 = parcelRequire("bbNl0");
var $4rKJa = parcelRequire("4rKJa");

var $kCvcX = parcelRequire("kCvcX");
var $djK7X = parcelRequire("djK7X");
var $3cc2J = parcelRequire("3cc2J");

var $fK3MF = parcelRequire("fK3MF");

var $eGOwo = parcelRequire("eGOwo");

var $7aoMz = parcelRequire("7aoMz");

var $e2t9t = parcelRequire("e2t9t");

var $33YQ1 = parcelRequire("33YQ1");

var $k9eRE = parcelRequire("k9eRE");
var $hNvWT = parcelRequire("hNvWT");
var $9Mg12 = parcelRequire("9Mg12");

var $i0gVY = parcelRequire("i0gVY");
var $8Dv9L = parcelRequire("8Dv9L");

var $3c1p9 = parcelRequire("3c1p9");
// invisible gif for SSR preview to show the underlying spinner until the src is replaced by
// the actual image src in the inline script
const $e54d3f9e11f733f6$var$DEFAULT_SSR_PREVIEW = {
    dataURI: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    dimensions: {
        width: 100,
        height: 100
    },
    source: 'ssr-server'
};
const $e54d3f9e11f733f6$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, useSrcSet: useSrcSet = false, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const [status, setStatus] = (0, $eJOHy.useState)('loading');
    const [error, setError] = (0, $eJOHy.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $eJOHy.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $eJOHy.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $eJOHy.useState)('not-resolved');
    const ssrReliabilityRef = (0, $eJOHy.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const ufoContext = (0, $7aoMz.useInteractionContext)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (isLoading && (0, $eGOwo.fg)('platform_close_image_blindspot_2')) return ufoContext?.hold('img-loading');
    }, [
        ufoContext,
        isLoading
    ]);
    const requestDimensions = (0, $eJOHy.useMemo)(()=>dimensions ? (0, $3c1p9.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $3c1p9.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $9Mg12.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $8Dv9L.getSSRData)(identifier, resizeMode);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $k9eRE.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $e2t9t.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI, srcSet: srcSet } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data',
                    srcSet: srcSet
                };
            }
        }
    };
    const [preview, setPreview] = (0, $eJOHy.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $djK7X.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $bbNl0.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $eJOHy.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $33YQ1.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $33YQ1.MediaFilePreviewError)('metadata-fetch', (0, $4rKJa.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // SSR Loading
    //----------------------------------------------------------------
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $eGOwo.fg)('media-perf-uplift-mutation-fix')) return;
        const loadPromise = (0, $8Dv9L.getSSRData)(identifier, resizeMode)?.loadPromise;
        if (preview && (0, $k9eRE.isSSRDataPreview)(preview) && loadPromise) loadPromise.then(()=>{
            setStatus('complete');
        }).catch(()=>{
            setPreview(undefined);
        });
    }, [
        preview,
        identifier,
        resizeMode
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $3c1p9.useCurrentValueRef)(()=>{
        return (0, $k9eRE.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $eJOHy.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            setIsLoading(true);
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $3c1p9.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setIsLoading(false);
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $3c1p9.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $eJOHy.useEffect)(()=>{
        const cachedPreview = (0, $9Mg12.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $3c1p9.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $hNvWT.isSupportedLocalPreview)(mediaType) && (0, $fK3MF.isMimeTypeSupportedByBrowser)(mimeType || '')) {
            // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
            // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
            // Then, local Preview NOT available
            setIsLoading(true);
            (0, $k9eRE.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
                setIsBannedLocalPreview(true);
                // CXP-2723 TODO: We might have to wrap this error in MediaCardError
                setNonCriticalError(e);
            }).finally(()=>{
                setIsLoading(false);
            });
        } else if (!error && !nonCriticalError && (!preview || (0, $3c1p9.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $k9eRE.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) {
            // If the preview is SSR, we can skip the refetch as it will be handled by the global scope promise
            if (preview && (0, $k9eRE.isSSRPreview)(preview) && (0, $eGOwo.fg)('media-perf-uplift-mutation-fix')) return;
            setIsLoading(true);
            getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
                const wrappedError = (0, $33YQ1.ensureMediaFilePreviewError)('preview-fetch', e);
                if (!preview) {
                    setStatus('error');
                    setError(wrappedError);
                } else // If there is already a preview, we consider it a non-critical error
                setNonCriticalError(wrappedError);
            }).finally(()=>{
                setIsLoading(false);
            });
        }
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $eJOHy.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $k9eRE.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
        const isSSR = (0, $k9eRE.isSSRDataPreview)(failedPreview) || ((0, $eGOwo.fg)('jfp-magma-fix-failed-ssr-preview-load') ? (0, $k9eRE.isSSRClientPreview)(failedPreview) : false);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if (isSSR) {
            ssrReliabilityRef.current.server = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $k9eRE.isLocalPreview)(failedPreview);
        const isRemote = (0, $k9eRE.isRemotePreview)(failedPreview);
        if (isLocal || isRemote || isSSR) {
            const error = new (0, $33YQ1.ImageLoadError)(failedPreview?.source);
            (0, $9Mg12.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $eJOHy.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $k9eRE.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $k9eRE.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $i0gVY.generateScriptProps)(identifier, preview?.dataURI, resizeMode, preview?.srcSet, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined, {
            'media-perf-uplift-mutation-fix': (0, $eGOwo.fg)('media-perf-uplift-mutation-fix')
        }) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $kCvcX.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: ssr === 'server' && useSrcSet && (0, $eGOwo.fg)('media-perf-uplift-mutation-fix') ? $e54d3f9e11f733f6$var$DEFAULT_SSR_PREVIEW : preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("kCvcX", function(module, exports) {
$parcel$export(module.exports, "useCopyIntent", () => $556b9eb703c9e12d$export$46fd859414de9d62);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $3cc2J = parcelRequire("3cc2J");

var $bMoFA = parcelRequire("bMoFA");

var $b7hyt = parcelRequire("b7hyt");
function $556b9eb703c9e12d$var$useCurrentValueRef(value) {
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
}
const $556b9eb703c9e12d$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const innerRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const registerCopyIntentRef = $556b9eb703c9e12d$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $bMoFA.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $bMoFA.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $eJOHy.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $eGOwo.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $eJOHy.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $eGOwo.fg)('platform_media_cross_client_copy')) (0, $b7hyt.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $b7hyt.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("3cc2J", function(module, exports) {
$parcel$export(module.exports, "useMediaClient", () => $d8e7b96ea4671e74$export$8b3e87ea56c3a345);

var $eJOHy = parcelRequire("eJOHy");

var $93R6D = parcelRequire("93R6D");

var $f7iZ0 = parcelRequire("f7iZ0");
const $d8e7b96ea4671e74$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $93R6D.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $f7iZ0.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};

});
parcelRegister("f7iZ0", function(module, exports) {
$parcel$export(module.exports, "MediaContext", () => $b977b15c2bc7301b$export$c94ff18a59d4c4d);
$parcel$export(module.exports, "MediaProvider", () => $b977b15c2bc7301b$export$57164260bc1f1218);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aRuva = parcelRequire("aRuva");

var $lMkQs = parcelRequire("lMkQs");
const $b977b15c2bc7301b$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
const $b977b15c2bc7301b$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $eJOHy.useMemo)(()=>(0, $aRuva.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $lMkQs.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($b977b15c2bc7301b$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};

});
parcelRegister("lMkQs", function(module, exports) {
$parcel$export(module.exports, "useMediaParsedSettings", () => $e0ef7db6f81da61d$export$d54af28440a5efc0);

var $eJOHy = parcelRequire("eJOHy");

var $4iDQM = parcelRequire("4iDQM");
const $e0ef7db6f81da61d$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $eJOHy.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $4iDQM.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};

});
parcelRegister("4iDQM", function(module, exports) {
$parcel$export(module.exports, "defaultMediaUserPreferences", () => $fd3af50559080092$export$2d23ed2854ac1650);
// Currently only supports boolean, string. Uncomment below to support number
const $fd3af50559080092$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $fd3af50559080092$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($fd3af50559080092$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $fd3af50559080092$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $fd3af50559080092$export$2d23ed2854ac1650 = $fd3af50559080092$export$7e209e67b965bc63($fd3af50559080092$var$defaultUserPreferences);

});




parcelRegister("bMoFA", function(module, exports) {
$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $93f079c5c30deecd$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $93f079c5c30deecd$export$aacb463551da2e8f);

var $h3W10 = parcelRequire("h3W10");
const $93f079c5c30deecd$var$getRequestErrorDetails = (err)=>{
    if ((0, $h3W10.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
    return undefined;
};
const $93f079c5c30deecd$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $h3W10.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$93f079c5c30deecd$var$getRequestErrorDetails(error)
        }
    };
};
const $93f079c5c30deecd$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("b7hyt", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $b67882b47b14e094$export$f65ca476c09acec0);
const $b67882b47b14e094$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("djK7X", function(module, exports) {
$parcel$export(module.exports, "useFileState", () => $5a07b53d359ee7c3$export$90ff537b0999afb);

var $eJOHy = parcelRequire("eJOHy");

var $3cc2J = parcelRequire("3cc2J");

var $kNd6B = parcelRequire("kNd6B");
function $5a07b53d359ee7c3$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const fileState = (0, $kNd6B.useMediaStore)((state)=>state.files[id]);
    (0, $eJOHy.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("kNd6B", function(module, exports) {
$parcel$export(module.exports, "useMediaStore", () => $d5b1e147a2796345$export$8a9cc8c330400af8);

var $eOVQp = parcelRequire("eOVQp");

var $3cc2J = parcelRequire("3cc2J");
const $d5b1e147a2796345$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $eOVQp.useStore)(store, selector, equals);
function $d5b1e147a2796345$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $d5b1e147a2796345$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("eOVQp", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $aca29ade4cd157ce$export$6ccbb43953eebf8);
$parcel$export(module.exports, "create", () => $aca29ade4cd157ce$export$185802fd694ee1f5);

var $96y8R = parcelRequire("96y8R");

var $eJOHy = parcelRequire("eJOHy");

var $iHcr1 = parcelRequire("iHcr1");
var $aca29ade4cd157ce$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $aca29ade4cd157ce$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy)));
const { useSyncExternalStoreWithSelector: $aca29ade4cd157ce$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($iHcr1)));
let $aca29ade4cd157ce$var$didWarnAboutEqualityFn = false;
const $aca29ade4cd157ce$var$identity = (arg)=>arg;
function $aca29ade4cd157ce$export$6ccbb43953eebf8(api, selector = $aca29ade4cd157ce$var$identity, equalityFn) {
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$aca29ade4cd157ce$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $aca29ade4cd157ce$var$didWarnAboutEqualityFn = true;
    }
    const slice = $aca29ade4cd157ce$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $aca29ade4cd157ce$var$useDebugValue(slice);
    return slice;
}
const $aca29ade4cd157ce$var$createImpl = (createState)=>{
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $96y8R.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$aca29ade4cd157ce$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $aca29ade4cd157ce$export$185802fd694ee1f5 = (createState)=>createState ? $aca29ade4cd157ce$var$createImpl(createState) : $aca29ade4cd157ce$var$createImpl;
var $aca29ade4cd157ce$export$2e2bcd8739ae039 = (createState)=>{
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $aca29ade4cd157ce$export$185802fd694ee1f5(createState);
};

});



parcelRegister("e2t9t", function(module, exports) {
$parcel$export(module.exports, "extractErrorInfo", () => $3f058c26ca766723$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $3f058c26ca766723$export$768c370ed0dbaeb3);

var $4rKJa = parcelRequire("4rKJa");

var $33YQ1 = parcelRequire("33YQ1");
const $3f058c26ca766723$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $3f058c26ca766723$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $3f058c26ca766723$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $3f058c26ca766723$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $3f058c26ca766723$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $3f058c26ca766723$export$4af9d71992e89714(error),
        error: $3f058c26ca766723$export$88c61dcad53762da(error),
        errorDetail: $3f058c26ca766723$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $3f058c26ca766723$export$29aa614726672b2e(error)
    };
};
const $3f058c26ca766723$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$3f058c26ca766723$export$74aaf4784c2edb2c(new (0, $33YQ1.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("33YQ1", function(module, exports) {
$parcel$export(module.exports, "MediaFilePreviewError", () => $ba556c1ff2a47bc7$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $ba556c1ff2a47bc7$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $ba556c1ff2a47bc7$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $ba556c1ff2a47bc7$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $ba556c1ff2a47bc7$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $ba556c1ff2a47bc7$export$7156ce7b78b49bd7);
class $ba556c1ff2a47bc7$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $ba556c1ff2a47bc7$export$2c035820a31723e extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $ba556c1ff2a47bc7$export$10ab445310d30114 extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $ba556c1ff2a47bc7$export$18e89b7e50818288 extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $ba556c1ff2a47bc7$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $ba556c1ff2a47bc7$export$d0a45ab59b4606b extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(source){
        super($ba556c1ff2a47bc7$var$getImageLoadPrimaryReason(source));
    }
}
function $ba556c1ff2a47bc7$export$553696a6e769784c(err) {
    return err instanceof $ba556c1ff2a47bc7$export$96e559194c287cf4;
}
const $ba556c1ff2a47bc7$export$b380593ba3516c6f = (err)=>err instanceof $ba556c1ff2a47bc7$export$2c035820a31723e;
const $ba556c1ff2a47bc7$export$e1d87830b3784f94 = (err)=>err instanceof $ba556c1ff2a47bc7$export$10ab445310d30114;
const $ba556c1ff2a47bc7$export$443aeb298d35d79d = (err)=>$ba556c1ff2a47bc7$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $ba556c1ff2a47bc7$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($ba556c1ff2a47bc7$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $ba556c1ff2a47bc7$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $ba556c1ff2a47bc7$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("k9eRE", function(module, exports) {
$parcel$export(module.exports, "getSSRPreview", () => $acdcd6198e7dee1d$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $acdcd6198e7dee1d$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $acdcd6198e7dee1d$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $acdcd6198e7dee1d$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $acdcd6198e7dee1d$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $acdcd6198e7dee1d$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $acdcd6198e7dee1d$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $acdcd6198e7dee1d$export$98e935d981c884d);

var $bajro = parcelRequire("bajro");

var $33YQ1 = parcelRequire("33YQ1");

var $9Mg12 = parcelRequire("9Mg12");

var $hNvWT = parcelRequire("hNvWT");
const $acdcd6198e7dee1d$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $bajro.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $9Mg12.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $acdcd6198e7dee1d$var$getDataUri = (mediaClient, id, params, mediaBlobUrlAttrs)=>{
    const rawDataURI = mediaClient.getImageUrlSync(id, params);
    return mediaBlobUrlAttrs ? (0, $bajro.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
};
const $acdcd6198e7dee1d$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    try {
        const dataURI = $acdcd6198e7dee1d$var$getDataUri(mediaClient, id, params, mediaBlobUrlAttrs);
        let srcSet = `${dataURI} 1x`;
        if (params.width) {
            const doubleDataURI = $acdcd6198e7dee1d$var$getDataUri(mediaClient, id, {
                ...params,
                width: params.width * 2,
                height: params.height && params.height * 2
            }, mediaBlobUrlAttrs);
            // We want to embed some meta context into dataURI for Copy/Paste to work.
            srcSet += `, ${doubleDataURI} 2x`;
        }
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1,
            srcSet: srcSet
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $33YQ1.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $acdcd6198e7dee1d$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $acdcd6198e7dee1d$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $acdcd6198e7dee1d$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $hNvWT.getRemotePreview)(mediaClient, id, params, traceContext);
    return $acdcd6198e7dee1d$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $acdcd6198e7dee1d$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $hNvWT.getLocalPreview)(filePreview);
    return $acdcd6198e7dee1d$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("9Mg12", function(module, exports) {
$parcel$export(module.exports, "mediaFilePreviewCache", () => $d9909271b08294f2$export$b7e8ee3f7a41459);

var $4ZQua = parcelRequire("4ZQua");
const $d9909271b08294f2$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $d9909271b08294f2$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $d9909271b08294f2$export$b7e8ee3f7a41459 = new $d9909271b08294f2$export$7b50526c091bb915((0, $4ZQua.createObjectURLCache)());

});
parcelRegister("4ZQua", function(module, exports) {
$parcel$export(module.exports, "createObjectURLCache", () => $7640c7504dcb2ad6$export$ba71be67d5c32535);

var $adK77 = parcelRequire("adK77");

var $7xkt0 = parcelRequire("7xkt0");
const $7640c7504dcb2ad6$export$36d0f9859761643d = 50;
class $7640c7504dcb2ad6$var$ExtendedLRUCache extends (0, $7xkt0.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $adK77.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $7640c7504dcb2ad6$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $7640c7504dcb2ad6$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $7640c7504dcb2ad6$export$ba71be67d5c32535 = ()=>new $7640c7504dcb2ad6$export$75d1c8c9ba1d0773($7640c7504dcb2ad6$export$36d0f9859761643d);

});


parcelRegister("hNvWT", function(module, exports) {
$parcel$export(module.exports, "isSupportedLocalPreview", () => $3247cef0fce3851d$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3247cef0fce3851d$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3247cef0fce3851d$export$bfe20bd01db02b3);

var $5JVfG = parcelRequire("5JVfG");

var $cK5G4 = parcelRequire("cK5G4");

var $33YQ1 = parcelRequire("33YQ1");

var $heXDA = parcelRequire("heXDA");
const $3247cef0fce3851d$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3247cef0fce3851d$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $cK5G4.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3247cef0fce3851d$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $heXDA.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3247cef0fce3851d$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $5JVfG.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3247cef0fce3851d$var$getImageLocalPreview(value);
            case 'video':
                return $3247cef0fce3851d$var$getVideoLocalPreview(value);
            default:
                throw new (0, $33YQ1.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $33YQ1.LocalPreviewError)('local-preview-unsupported');
};
const $3247cef0fce3851d$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $33YQ1.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("cK5G4", function(module, exports) {
$parcel$export(module.exports, "getImageInfo", () => $4622caaad73ce041$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $4622caaad73ce041$export$67689507e8404821);

var $9PgO0 = parcelRequire("9PgO0");

var $f8uqC = parcelRequire("f8uqC");

var $fOXQV = parcelRequire("fOXQV");

var $kHzU5 = parcelRequire("kHzU5");
const { Orientation: $4622caaad73ce041$var$Orientation, XResolution: $4622caaad73ce041$var$XResolution } = (0, $9PgO0.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $4622caaad73ce041$var$DPI_WEB_BASELINE = 72;
async function $4622caaad73ce041$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $4622caaad73ce041$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $4622caaad73ce041$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $4622caaad73ce041$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $4622caaad73ce041$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $4622caaad73ce041$var$DPI_WEB_BASELINE;
        else return $4622caaad73ce041$export$268f92356524130b(tags, $4622caaad73ce041$var$XResolution, $4622caaad73ce041$var$DPI_WEB_BASELINE) / $4622caaad73ce041$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $4622caaad73ce041$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$4622caaad73ce041$var$Orientation]) {
        const tagValue = tags[$4622caaad73ce041$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $9PgO0.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $4622caaad73ce041$export$67689507e8404821(file) {
    const tags = await (0, $f8uqC.readImageMetaTags)(file);
    return $4622caaad73ce041$var$getOrientationFromTags(tags);
}
function $4622caaad73ce041$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $4622caaad73ce041$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $4622caaad73ce041$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $f8uqC.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $4622caaad73ce041$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $4622caaad73ce041$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $fOXQV.loadImage)(src);
        const { width: width, height: height } = (0, $fOXQV.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("9PgO0", function(module, exports) {
$parcel$export(module.exports, "ImageType", () => $c8d64cb551bef33f$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $c8d64cb551bef33f$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $c8d64cb551bef33f$export$f6ea0c89fd7d156);
var $c8d64cb551bef33f$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $c8d64cb551bef33f$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $c8d64cb551bef33f$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("f8uqC", function(module, exports) {
$parcel$export(module.exports, "readImageMetaTags", () => $80e2aeeb99751964$export$41982b5c7acb23c4);

var $9PgO0 = parcelRequire("9PgO0");

var $dCEVY = parcelRequire("dCEVY");

var $7BlyC = parcelRequire("7BlyC");

var $3yAnp = parcelRequire("3yAnp");
async function $80e2aeeb99751964$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $9PgO0.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $7BlyC.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $3yAnp.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $9PgO0.ImageType).JPEG) return await (0, $dCEVY.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("dCEVY", function(module, exports) {
$parcel$export(module.exports, "readJPEGExifMetaData", () => $ff103de7f6ab6f18$export$556b2ccec62d7f2a);

var $9PgO0 = parcelRequire("9PgO0");
const { XResolution: $ff103de7f6ab6f18$var$XResolution, YResolution: $ff103de7f6ab6f18$var$YResolution } = (0, $9PgO0.SupportedImageMetaTag);
let $ff103de7f6ab6f18$var$loadImage;

function $ff103de7f6ab6f18$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$ff103de7f6ab6f18$var$loadImage) {
            const module = await (parcelRequire("lm4Lq"));
            $ff103de7f6ab6f18$var$loadImage = module.default || module;
        }
        $ff103de7f6ab6f18$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $ff103de7f6ab6f18$var$XResolution || key === $ff103de7f6ab6f18$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("lm4Lq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2HU4O").then(()=>parcelRequire('4Mu1O'));

});


parcelRegister("7BlyC", function(module, exports) {
$parcel$export(module.exports, "readPNGXMPMetaData", () => $e9cd4ca7c89b16ee$export$5fb37736440fca6f);

var $fOXQV = parcelRequire("fOXQV");
let $e9cd4ca7c89b16ee$var$pngChunksExtract;

async function $e9cd4ca7c89b16ee$export$5fb37736440fca6f(file) {
    if (!$e9cd4ca7c89b16ee$var$pngChunksExtract) {
        const module = await (parcelRequire("6FWCb"));
        $e9cd4ca7c89b16ee$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $fOXQV.fileToArrayBuffer)(file);
    const chunks = $e9cd4ca7c89b16ee$var$pngChunksExtract(buffer);
    return await $e9cd4ca7c89b16ee$export$9185743fdd58ce45(chunks);
}
async function $e9cd4ca7c89b16ee$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("fOXQV", function(module, exports) {
$parcel$export(module.exports, "dataURItoFile", () => $cb7adf01e70d1e12$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $cb7adf01e70d1e12$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $cb7adf01e70d1e12$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $cb7adf01e70d1e12$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $cb7adf01e70d1e12$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $cb7adf01e70d1e12$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $cb7adf01e70d1e12$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $cb7adf01e70d1e12$export$61a1de0822e2820);

var $6OBnQ = parcelRequire("6OBnQ");

var $2Pj0H = parcelRequire("2Pj0H");

var $jb8ZN = parcelRequire("jb8ZN");

var $4w1Xx = parcelRequire("4w1Xx");

var $heBKY = parcelRequire("heBKY");

var $jP9Cl = parcelRequire("jP9Cl");

var $gAsmN = parcelRequire("gAsmN");

var $iqmbF = parcelRequire("iqmbF");

var $hLw8T = parcelRequire("hLw8T");

var $jpYYq = parcelRequire("jpYYq");

var $4SXVP = parcelRequire("4SXVP");

var $91IX3 = parcelRequire("91IX3");

var $i9oSq = parcelRequire("i9oSq");

var $1TONM = parcelRequire("1TONM");

var $3LgN4 = parcelRequire("3LgN4");

var $jmdLl = parcelRequire("jmdLl");
function $cb7adf01e70d1e12$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $cb7adf01e70d1e12$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $cb7adf01e70d1e12$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $cb7adf01e70d1e12$export$849633012686f7ee(file)
    };
}
async function $cb7adf01e70d1e12$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $cb7adf01e70d1e12$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $cb7adf01e70d1e12$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $cb7adf01e70d1e12$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $cb7adf01e70d1e12$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $cb7adf01e70d1e12$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $cb7adf01e70d1e12$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6OBnQ)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hLw8T)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SXVP)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hLw8T)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jpYYq)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iqmbF)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4w1Xx)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1TONM)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jb8ZN)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2Pj0H)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i9oSq)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($91IX3)))
    }
];
function $cb7adf01e70d1e12$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $cb7adf01e70d1e12$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $jmdLl.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3LgN4)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($heBKY)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jP9Cl)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gAsmN)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("6OBnQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $4f6469314c3d6ff1$var$_react = $4f6469314c3d6ff1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $4f6469314c3d6ff1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f6469314c3d6ff1$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $4f6469314c3d6ff1$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$4f6469314c3d6ff1$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $4f6469314c3d6ff1$var$_default = module.exports.default = $4f6469314c3d6ff1$var$PdfDocument24Icon;

});

parcelRegister("2Pj0H", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $20ef173efcc507e4$var$_react = $20ef173efcc507e4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $20ef173efcc507e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $20ef173efcc507e4$var$Gif24Icon = (props)=>/*#__PURE__*/ $20ef173efcc507e4$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$20ef173efcc507e4$var$Gif24Icon.displayName = 'Gif24Icon';
var $20ef173efcc507e4$var$_default = module.exports.default = $20ef173efcc507e4$var$Gif24Icon;

});

parcelRegister("jb8ZN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $df6605c69004c362$var$_react = $df6605c69004c362$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $df6605c69004c362$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $df6605c69004c362$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $df6605c69004c362$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$df6605c69004c362$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $df6605c69004c362$var$_default = module.exports.default = $df6605c69004c362$var$PowerpointPresentation24Icon;

});

parcelRegister("4w1Xx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $349babaa4a8a09e8$var$_react = $349babaa4a8a09e8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $349babaa4a8a09e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $349babaa4a8a09e8$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $349babaa4a8a09e8$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$349babaa4a8a09e8$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $349babaa4a8a09e8$var$_default = module.exports.default = $349babaa4a8a09e8$var$WordDocument24Icon;

});

parcelRegister("heBKY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c8c1082e5cae77c8$var$_react = $c8c1082e5cae77c8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $c8c1082e5cae77c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c8c1082e5cae77c8$var$Sketch24Icon = (props)=>/*#__PURE__*/ $c8c1082e5cae77c8$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c8c1082e5cae77c8$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $c8c1082e5cae77c8$var$_default = module.exports.default = $c8c1082e5cae77c8$var$Sketch24Icon;

});

parcelRegister("jP9Cl", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e6ea3d8b8f4b0c1d$var$_react = $e6ea3d8b8f4b0c1d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $e6ea3d8b8f4b0c1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e6ea3d8b8f4b0c1d$var$Figma24Icon = (props)=>/*#__PURE__*/ $e6ea3d8b8f4b0c1d$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e6ea3d8b8f4b0c1d$var$Figma24Icon.displayName = 'Figma24Icon';
var $e6ea3d8b8f4b0c1d$var$_default = module.exports.default = $e6ea3d8b8f4b0c1d$var$Figma24Icon;

});

parcelRegister("gAsmN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c1360329a45292df$var$_react = $c1360329a45292df$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $c1360329a45292df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c1360329a45292df$var$Executable24Icon = (props)=>/*#__PURE__*/ $c1360329a45292df$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c1360329a45292df$var$Executable24Icon.displayName = 'Executable24Icon';
var $c1360329a45292df$var$_default = module.exports.default = $c1360329a45292df$var$Executable24Icon;

});

parcelRegister("iqmbF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d69bdda0af90a430$var$_react = $d69bdda0af90a430$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $d69bdda0af90a430$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d69bdda0af90a430$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $d69bdda0af90a430$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d69bdda0af90a430$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $d69bdda0af90a430$var$_default = module.exports.default = $d69bdda0af90a430$var$GoogleDoc24Icon;

});

parcelRegister("hLw8T", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ceefc245c72865b3$var$_react = $ceefc245c72865b3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $ceefc245c72865b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ceefc245c72865b3$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $ceefc245c72865b3$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$ceefc245c72865b3$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $ceefc245c72865b3$var$_default = module.exports.default = $ceefc245c72865b3$var$GoogleForm24Icon;

});

parcelRegister("jpYYq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e22fa632d0a47674$var$_react = $e22fa632d0a47674$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $e22fa632d0a47674$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e22fa632d0a47674$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $e22fa632d0a47674$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e22fa632d0a47674$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $e22fa632d0a47674$var$_default = module.exports.default = $e22fa632d0a47674$var$GoogleSheet24Icon;

});

parcelRegister("4SXVP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $38eab1c43401fe51$var$_react = $38eab1c43401fe51$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $38eab1c43401fe51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $38eab1c43401fe51$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $38eab1c43401fe51$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$38eab1c43401fe51$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $38eab1c43401fe51$var$_default = module.exports.default = $38eab1c43401fe51$var$GoogleSlide24Icon;

});

parcelRegister("91IX3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $69271380a604c514$var$_react = $69271380a604c514$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $69271380a604c514$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $69271380a604c514$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $69271380a604c514$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$69271380a604c514$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $69271380a604c514$var$_default = module.exports.default = $69271380a604c514$var$ExcelSpreadsheet24Icon;

});

parcelRegister("3LgN4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2bd2c91c79a3039e$var$_react = $2bd2c91c79a3039e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $2bd2c91c79a3039e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2bd2c91c79a3039e$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $2bd2c91c79a3039e$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2bd2c91c79a3039e$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $2bd2c91c79a3039e$var$_default = module.exports.default = $2bd2c91c79a3039e$var$SourceCode24Icon;

});

parcelRegister("jmdLl", function(module, exports) {
$parcel$export(module.exports, "getExtension", () => $d6ba8b104df87d35$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $d6ba8b104df87d35$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $d6ba8b104df87d35$export$ba4368c844580f9e);

var $eGOwo = parcelRequire("eGOwo");
function $d6ba8b104df87d35$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $d6ba8b104df87d35$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $d6ba8b104df87d35$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $d6ba8b104df87d35$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $d6ba8b104df87d35$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $d6ba8b104df87d35$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $d6ba8b104df87d35$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            if (mimetype === 'text/plain' && (0, $eGOwo.fg)('platform_media-default-code-viewer-for-plain-text')) return 'text';
            return null;
    }
}

});


parcelRegister("6FWCb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fWdHm").then(()=>parcelRequire('6TwJU'));

});


parcelRegister("3yAnp", function(module, exports) {
$parcel$export(module.exports, "parseXMPMetaData", () => $a54c683875c3acaa$export$55c3bc9841b19de2);
function $a54c683875c3acaa$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("kHzU5", function(module, exports) {
$parcel$export(module.exports, "isRotated", () => $d080920ecf648ea4$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $d080920ecf648ea4$export$43142f95b8de7a91);
const $d080920ecf648ea4$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $d080920ecf648ea4$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $d080920ecf648ea4$export$43142f95b8de7a91 = (orientation)=>{
    return $d080920ecf648ea4$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("heXDA", function(module, exports) {
$parcel$export(module.exports, "takeSnapshot", () => $e7f813388d1815ac$export$4269d30173168e5c);
const $e7f813388d1815ac$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("i0gVY", function(module, exports) {
$parcel$export(module.exports, "getMediaCardSSR", () => $c6ffe105f3de4b84$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $c6ffe105f3de4b84$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $c6ffe105f3de4b84$export$de7c49925e44d75d);

var $itX9h = parcelRequire("itX9h");
const $c6ffe105f3de4b84$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $c6ffe105f3de4b84$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $c6ffe105f3de4b84$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $c6ffe105f3de4b84$var$dashed = (param)=>param ? `-${param}` : '';
const $c6ffe105f3de4b84$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey }, resizeMode)=>`${id}${$c6ffe105f3de4b84$var$dashed(collectionName)}${$c6ffe105f3de4b84$var$dashed(occurrenceKey)}${$c6ffe105f3de4b84$var$dashed(resizeMode)}`;
const $c6ffe105f3de4b84$export$4310981e0aa4ce67 = (key, paramDataURI, paramMode, paramSrcSet, dimensions, error, featureFlags = {}, globalScope = window)=>{
    const mediaCardSsr = $c6ffe105f3de4b84$export$ede93d4564eaa8da(globalScope);
    if (featureFlags['media-perf-uplift-mutation-fix']) {
        const prevData = mediaCardSsr[key];
        const isPreviousImageLarger = prevData?.mode === paramMode && prevData && prevData.dimensions?.width && dimensions?.width && prevData.dimensions.width > dimensions.width;
        const srcSet = isPreviousImageLarger ? prevData?.srcSet : paramSrcSet;
        const dataURI = isPreviousImageLarger ? prevData?.dataURI : paramDataURI;
        const img = script?.parentElement?.querySelector('img');
        if (img && dataURI) img.src = dataURI;
        if (img && srcSet) img.srcset = srcSet;
        const loadPromise = new Promise((resolve, reject)=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            img?.addEventListener('load', ()=>{
                resolve(void 0);
            });
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            img?.addEventListener('error', ()=>{
                reject(new Error('Failed to load image'));
            });
        });
        mediaCardSsr[key] = isPreviousImageLarger ? prevData : {
            dataURI: dataURI,
            dimensions: dimensions,
            error: error,
            srcSet: srcSet,
            loadPromise: loadPromise
        };
    } else mediaCardSsr[key] = {
        dataURI: paramDataURI,
        dimensions: dimensions,
        error: error
    };
};
const $c6ffe105f3de4b84$var$generateScript = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>{
    const functionCall = (0, $itX9h.printFunctionCall)($c6ffe105f3de4b84$export$4310981e0aa4ce67, $c6ffe105f3de4b84$export$a47fb462a08de82f(identifier, mode), dataURI, mode, srcSet, dimensions, error, featureFlags);
    return (0, $itX9h.printScript)([
        $c6ffe105f3de4b84$export$ede93d4564eaa8da.toString(),
        $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $c6ffe105f3de4b84$export$de7c49925e44d75d = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>({
        dangerouslySetInnerHTML: {
            __html: $c6ffe105f3de4b84$var$generateScript(identifier, dataURI, mode, srcSet, dimensions, error, featureFlags)
        }
    });

});
parcelRegister("itX9h", function(module, exports) {
$parcel$export(module.exports, "printFunctionCall", () => $58d2f85efd2afaca$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $58d2f85efd2afaca$export$8b902fb69a2f17c1);
const $58d2f85efd2afaca$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $58d2f85efd2afaca$var$printParams = (args)=>args.map((arg)=>$58d2f85efd2afaca$var$printParam(arg)).join(',');
const $58d2f85efd2afaca$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$58d2f85efd2afaca$var$printParams(args)});`;
const $58d2f85efd2afaca$export$8b902fb69a2f17c1 = (statements)=>`(function(){
			 let script = document.currentScript;
 			 ${statements.join(';')}
			 document.currentScript.remove();
		})();
		`;

});


parcelRegister("8Dv9L", function(module, exports) {
$parcel$export(module.exports, "getSSRData", () => $2f30a37781c6f0c3$export$d3a890b0f7844b6f);

var $i0gVY = parcelRequire("i0gVY");
const $2f30a37781c6f0c3$export$d3a890b0f7844b6f = (identifier, resizeMode)=>{
    const mediaCardSsr = (0, $i0gVY.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $i0gVY.getKey)(identifier, resizeMode)];
};

});

parcelRegister("3c1p9", function(module, exports) {
$parcel$export(module.exports, "isBigger", () => $f93a7743871712e9$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $f93a7743871712e9$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $f93a7743871712e9$export$b3e10e1f0fbb71db);

var $eJOHy = parcelRequire("eJOHy");
const $f93a7743871712e9$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $f93a7743871712e9$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $f93a7743871712e9$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $f93a7743871712e9$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $f93a7743871712e9$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
}

});




parcelRegister("iyBBa", function(module, exports) {
$parcel$export(module.exports, "ColoredTag", () => $edbc1f1c5365a1cc$export$526384205b143b58);

var $eJOHy = parcelRequire("eJOHy");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $051tO = parcelRequire("051tO");

var $aCFLd = parcelRequire("aCFLd");
const $edbc1f1c5365a1cc$export$526384205b143b58 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ labelName: labelName, href: href, actionSubjectId: actionSubjectId, containerXcss: containerXcss, contentXcss: contentXcss, analyticsAttributes: analyticsAttributes, color: color, ...restProps }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { backgroundColor: borderColor } = (0, $051tO.getColorMetadata)((0, $aCFLd.memoizeGetAutoGeneratedColorForLabels)(labelName));
    const onHandleClickForAnchor = (0, $eJOHy.useCallback)(()=>{
        if (actionSubjectId) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            attributes: analyticsAttributes
        }), actionSubjectId);
    }, [
        actionSubjectId,
        createAnalyticsEvent,
        analyticsAttributes
    ]);
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ref: ref,
        xcss: [
            $edbc1f1c5365a1cc$var$tagStyles,
            $edbc1f1c5365a1cc$var$hoverStyles,
            $edbc1f1c5365a1cc$var$anchorTextStyles,
            ...containerXcss ? [
                containerXcss
            ] : []
        ],
        href: href,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            borderColor: color || borderColor
        },
        onClick: onHandleClickForAnchor,
        ...restProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $edbc1f1c5365a1cc$var$tagTextStyles,
            ...contentXcss ? [
                contentXcss
            ] : []
        ]
    }, labelName));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: ref,
        xcss: [
            $edbc1f1c5365a1cc$var$tagStyles,
            ...containerXcss ? [
                containerXcss
            ] : []
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            borderColor: color || borderColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $edbc1f1c5365a1cc$var$tagTextStyles,
            ...contentXcss ? [
                contentXcss
            ] : []
        ]
    }, labelName));
});
const $edbc1f1c5365a1cc$var$tagStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    backgroundColor: 'color.background.neutral.subtle',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingInline: 'space.050',
    paddingBlock: '0',
    font: 'font.body',
    marginBlock: 'space.050',
    marginInline: 'space.050',
    height: '20px',
    alignItems: 'center',
    maxWidth: '100%'
});
const $edbc1f1c5365a1cc$var$hoverStyles = (0, $1DXK0.xcss)({
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered',
        textDecoration: 'underline'
    }
});
const $edbc1f1c5365a1cc$var$tagTextStyles = (0, $1DXK0.xcss)({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '180px'
});
const $edbc1f1c5365a1cc$var$anchorTextStyles = (0, $1DXK0.xcss)({
    color: 'color.text',
    textDecoration: 'none',
    ':hover': {
        color: 'color.text'
    }
});

});

parcelRegister("ibVOD", function(module, exports) {
$parcel$export(module.exports, "useCellHoverCallbacks", () => $72d9a29ee2941367$export$793f17026bd5d1b4);
$parcel$export(module.exports, "CellHoverProvider", () => $72d9a29ee2941367$export$d427879c5002c548);
$parcel$export(module.exports, "useCellHoverHandlers", () => $72d9a29ee2941367$export$5ac0a932365e8caa);

var $eJOHy = parcelRequire("eJOHy");

var $hX7Ca = parcelRequire("hX7Ca");
const $72d9a29ee2941367$export$7c2be23b3b8e5093 = 200;
const $72d9a29ee2941367$export$1e4bd5ddbd3e82e5 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $72d9a29ee2941367$var$onShowPopup = ({ contentRef: contentRef, onPopupToggle: onPopupToggle, shouldGetParentRef: shouldGetParentRef })=>{
    const elementWithTextContent = contentRef?.current ? (0, $hX7Ca.getClosestTextElement)(shouldGetParentRef ? contentRef?.current.parentElement : contentRef?.current) : undefined;
    const clientWidth = elementWithTextContent?.clientWidth || 0;
    const scrollWidth = elementWithTextContent?.scrollWidth || 0;
    const isClamped = (0, $hX7Ca.checkIsClamped)(elementWithTextContent);
    // If contentRef is not provided then the popover should always be visible on hover.
    if (!contentRef?.current || scrollWidth > clientWidth || isClamped) onPopupToggle(true);
};
const $72d9a29ee2941367$export$793f17026bd5d1b4 = ({ contentRef: contentRef, onPreload: onPreload, onPopupToggle: onPopupToggle, onLoad: onLoad, shouldGetParentRef: shouldGetParentRef, onHoverOut: onHoverOut, onChangePopupState: onChangePopupState })=>{
    const handlers = (0, $eJOHy.useContext)($72d9a29ee2941367$export$1e4bd5ddbd3e82e5);
    const onHidePopup = (0, $eJOHy.useCallback)(()=>{
        onPopupToggle(false);
    }, [
        onPopupToggle
    ]);
    if (!handlers) return;
    if (handlers.onPreload) handlers.onPreload.current = onPreload || null;
    if (handlers.onLoad) handlers.onLoad.current = onLoad || null;
    if (handlers.onChangePopupState) handlers.onChangePopupState.current = onChangePopupState || null;
    handlers.onShowPopup.current = ()=>$72d9a29ee2941367$var$onShowPopup({
            contentRef: contentRef,
            onPopupToggle: onPopupToggle,
            shouldGetParentRef: shouldGetParentRef
        });
    handlers.onHidePopup.current = ()=>{
        onHidePopup();
        onHoverOut?.();
    };
};
const $72d9a29ee2941367$export$d427879c5002c548 = ({ children: children, delay: delay = $72d9a29ee2941367$export$7c2be23b3b8e5093 })=>{
    const hoverTimeoutRef = (0, $eJOHy.useRef)(null);
    const onPreloadRef = (0, $eJOHy.useRef)(null);
    const onLoadRef = (0, $eJOHy.useRef)(null);
    const onShowPopupRef = (0, $eJOHy.useRef)(null);
    const onHidePopupRef = (0, $eJOHy.useRef)(null);
    const onChangePopupStateRef = (0, $eJOHy.useRef)(null);
    const cleanUpTimeout = (0, $eJOHy.useCallback)(()=>{
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
        }
    }, []);
    const handleMouseEnter = (0, $eJOHy.useCallback)(()=>{
        if (hoverTimeoutRef.current) return;
        onPreloadRef.current?.();
        hoverTimeoutRef.current = setTimeout(()=>{
            onLoadRef.current?.();
            onShowPopupRef.current?.();
        }, delay);
    }, [
        delay
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        cleanUpTimeout();
        onHidePopupRef.current?.();
    }, [
        cleanUpTimeout
    ]);
    const handleToggle = (0, $eJOHy.useCallback)(()=>{
        onLoadRef.current?.();
        onChangePopupStateRef.current?.();
    }, []);
    const handers = (0, $eJOHy.useMemo)(()=>({
            handleMouseEnter: handleMouseEnter,
            handleMouseLeave: handleMouseLeave,
            onPreload: onPreloadRef,
            onLoad: onLoadRef,
            onShowPopup: onShowPopupRef,
            onHidePopup: onHidePopupRef,
            handleToggle: handleToggle,
            onChangePopupState: onChangePopupStateRef
        }), [
        handleMouseEnter,
        handleMouseLeave,
        handleToggle
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return cleanUpTimeout;
    }, [
        cleanUpTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($72d9a29ee2941367$export$1e4bd5ddbd3e82e5.Provider, {
        value: handers
    }, children);
};
const $72d9a29ee2941367$export$5ac0a932365e8caa = ()=>{
    const handlers = (0, $eJOHy.useContext)($72d9a29ee2941367$export$1e4bd5ddbd3e82e5);
    if (handlers === null) throw new Error('useCellHoverHandlers must be used within a CellHoverProvider');
    return handlers;
};

});

parcelRegister("9Mapt", function(module, exports) {
$parcel$export(module.exports, "HoverPopoverWithContext", () => $356133080582a054$export$34da0ae4eaeabe16);
$parcel$export(module.exports, "CellHoverRenderer", () => $356133080582a054$export$15e55631babd0ec5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $kJsb4 = parcelRequire("kJsb4");

var $5vQ2T = parcelRequire("5vQ2T");

var $4EKqI = parcelRequire("4EKqI");

var $ibVOD = parcelRequire("ibVOD");


var $9CHGV = parcelRequire("9CHGV");
const $356133080582a054$var$PopupComponentInternal = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: popupChildren, isReferenceHidden: isReferenceHidden, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, ...restProps }, ref)=>{
    const { isFixedWidth: isFixedWidth, isInteractive: isInteractive, setIsPopupOpen: setIsPopupOpen } = (0, $eJOHy.useContext)($356133080582a054$var$HoverPopoverContext);
    return !isReferenceHidden ? /*#__PURE__*/ $eJOHy.createElement("div", {
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: ()=>isInteractive && setIsPopupOpen(true),
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: ()=>isInteractive && setIsPopupOpen(false),
        ...restProps,
        ref: ref,
        className: (0, $hcewu.default)([
            "_1mouu2gc _j7hq1ida _tzy4idpf _5sag1yx9 _1pgl1v42 _1o51q7pw _p12f1mjv _lcxvglyw",
            "_1pbycs5v",
            isInteractive && "_1moux0bf _1rjcutpp _lcxv1wug",
            isFixedWidth && "_1bsb1mjv"
        ])
    }, popupChildren) : null;
});
const $356133080582a054$var$HoverPopoverContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isFixedWidth: false,
    isInteractive: false,
    setIsPopupOpen: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});
const $356133080582a054$var$HoverPopoverComponent = ({ content: content, children: children, contentRef: contentRef, entryPointActions: entryPointActions, isInteractive: isInteractive, shouldGetParentRef: shouldGetParentRef, isFixedWidth: isFixedWidth, onHoverOut: onHoverOut, hidePopover: hidePopover, analyticsAttributes: analyticsAttributes })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $eJOHy.useState)(false);
    const togglePopup = (0, $eJOHy.useCallback)(()=>{
        setIsPopupOpen(!isPopupOpen);
    }, [
        isPopupOpen
    ]);
    (0, $ibVOD.useCellHoverCallbacks)({
        contentRef: contentRef,
        onPreload: entryPointActions?.preload,
        onLoad: entryPointActions?.load,
        onPopupToggle: setIsPopupOpen,
        shouldGetParentRef: shouldGetParentRef,
        onHoverOut: onHoverOut,
        onChangePopupState: togglePopup
    });
    if (content && isPopupOpen) return /*#__PURE__*/ $eJOHy.createElement((0, $4EKqI.default), {
        name: "jira-list-hover-popover",
        mode: "list"
    }, /*#__PURE__*/ $eJOHy.createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "jira-list-hover-popover",
        packageName: (0, $05f3bc586d738eb3$export$b8b9d90f9e5bd72b),
        teamName: (0, $05f3bc586d738eb3$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ $eJOHy.createElement($356133080582a054$var$HoverPopoverContext.Provider, {
        value: {
            isFixedWidth: isFixedWidth,
            isInteractive: isInteractive,
            setIsPopupOpen: setIsPopupOpen
        }
    }, /*#__PURE__*/ $eJOHy.createElement((0, $kJsb4.Popup), {
        // eslint-disable-next-line jira/import/no-direct-popup
        content: ({ update: update })=>/*#__PURE__*/ $eJOHy.createElement((0, $9CHGV.PopupContent), {
                isInteractive: isInteractive,
                update: update,
                analyticsAttributes: analyticsAttributes
            }, content),
        popupComponent: $356133080582a054$var$PopupComponentInternal,
        autoFocus: false,
        isOpen: !hidePopover && isPopupOpen,
        onClose: ()=>setIsPopupOpen(false),
        trigger: ({ ref: ref })=>children({
                ref: ref,
                ariaExpanded: isPopupOpen
            }),
        placement: "bottom-start"
    }))));
    return typeof children === 'function' ? children({
        ref: null
    }) : children;
};
const $356133080582a054$export$34da0ae4eaeabe16 = /*#__PURE__*/ (0, $eJOHy.memo)($356133080582a054$var$HoverPopoverComponent);
const $356133080582a054$export$15e55631babd0ec5 = ({ children: children })=>{
    const { handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, handleToggle: handleToggle } = (0, $ibVOD.useCellHoverHandlers)();
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (event.code === 'Space' || event.code === 'Enter') {
            // Prevent default is needed to prevent the table from scrolling down on space/enter press
            event.preventDefault();
            handleToggle();
        }
    }, [
        handleToggle
    ]);
    return children({
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onKeyDown: handleKeyDown
    });
};
const $356133080582a054$var$fadeIn = null;
const $356133080582a054$var$interactiveStyles = null;
const $356133080582a054$var$containerStyles = null;
const $356133080582a054$var$renderToParentStyles = null;
const $356133080582a054$var$fixedWidthStyles = null;

});

parcelRegister("gybMp", function(module, exports) {
$parcel$export(module.exports, "default", () => $03a1c6c7f1e563da$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $c9uTK = parcelRequire("c9uTK");

var $jiTA8 = parcelRequire("jiTA8");
const $03a1c6c7f1e563da$var$Link = ({ onClick: onClick, wordBreak: wordBreak = true, shouldDisplayStrikethrough: shouldDisplayStrikethrough = false, ...rest })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isEmbedMode = (0, $jiTA8.useIsEmbedMode)();
    const onClickWithAnalytics = (0, $eJOHy.useCallback)((e)=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        }), 'listWithPopup');
        onClick && onClick(e);
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($03a1c6c7f1e563da$var$StyledLink, {
        wordBreak: wordBreak,
        shouldDisplayStrikethrough: shouldDisplayStrikethrough,
        ...rest,
        onClick: onClickWithAnalytics,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    });
};
// Fix for Compiled bug where invalid props are passed on to the underlying DOM element when using inheritance.
const $03a1c6c7f1e563da$var$PropFilteredLink = ({ wordBreak: wordBreak, shouldDisplayStrikethrough: shouldDisplayStrikethrough, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), rest);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03a1c6c7f1e563da$var$StyledLink = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $03a1c6c7f1e563da$var$PropFilteredLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.wordBreak && "_1nmz1hna",
            __cmplp.shouldDisplayStrikethrough && "_4bfu1r81 _1hms1cog _ajmmvv82",
            __cmplp.className
        ])
    });
});
var $03a1c6c7f1e563da$export$2e2bcd8739ae039 = $03a1c6c7f1e563da$var$Link;

});



parcelRegister("7hEnC", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d49520d2b77e8f2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4d49520d2b77e8f2$var$messages = (0, $7qGN1.defineMessages)({
    noLabel: {
        "id": "issue-table-grouping.group-row.group-header.label-group-header.no-label",
        "defaultMessage": "No labels"
    }
});
var $4d49520d2b77e8f2$export$2e2bcd8739ae039 = $4d49520d2b77e8f2$var$messages;

});


parcelRegister("9jwn7", function(module, exports) {
$parcel$export(module.exports, "IssueTypeGroupHeader", () => $8f5648bc49997554$export$dccf116a86b73229);

var $hwqqP = parcelRequire("hwqqP");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $8wyVH = parcelRequire("8wyVH");
const $8f5648bc49997554$export$dccf116a86b73229 = ({ issueTypeGroupHeader: issueTypeGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $hwqqP.default), issueTypeGroupHeader);
    const issueType = data?.issueTypes[0]; // note: we are expecting only one issue type per group
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, issueType?.avatar?.small && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8wyVH.default), {
        height: "var(--ds-space-200, 16px)",
        width: "var(--ds-space-200, 16px)",
        src: issueType.avatar.small,
        alt: issueType.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, issueType?.name));
};

});
parcelRegister("hwqqP", function(module, exports) {
$parcel$export(module.exports, "default", () => $145b84c62bb14958$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c3f3a0dba8222a1de29670a2c85f820>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $145b84c62bb14958$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueTypeGroupHeader",
    "selections": [
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueTypes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "small"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraJqlIssueTypeFieldValue"
};
$145b84c62bb14958$var$node.hash = "c41ff0fec0474c5d560ad8876417768f";
var $145b84c62bb14958$export$2e2bcd8739ae039 = $145b84c62bb14958$var$node;

});


parcelRegister("aLKjs", function(module, exports) {
$parcel$export(module.exports, "GroupPickerGroupHeader", () => $6f95f7a561762d92$export$310ade6d89d65120);

var $i7Frx = parcelRequire("i7Frx");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $6w3tC = parcelRequire("6w3tC");

var $1wrYf = parcelRequire("1wrYf");
const $6f95f7a561762d92$export$310ade6d89d65120 = ({ groupPickerGroupHeader: groupPickerGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $i7Frx.default), groupPickerGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6w3tC.TextGroupHeaderContent), {
        text: data?.group?.name,
        noValueText: formatMessage((0, $1wrYf.default).noGroup)
    });
};

});
parcelRegister("i7Frx", function(module, exports) {
$parcel$export(module.exports, "default", () => $6da8cf122512dfcf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aa2503a8ad6b351d6c052591d78c4b50>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6da8cf122512dfcf$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "GroupPickerGroupHeader",
    "selections": [
        {
            "concreteType": "JiraGroup",
            "kind": "LinkedField",
            "name": "group",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraJqlGroupFieldValue"
};
$6da8cf122512dfcf$var$node.hash = "08fb8e73749f71d49ccd999fc7f864e0";
var $6da8cf122512dfcf$export$2e2bcd8739ae039 = $6da8cf122512dfcf$var$node;

});

parcelRegister("6w3tC", function(module, exports) {
$parcel$export(module.exports, "TextGroupHeaderContent", () => $258f99b95fda91d0$export$902945573f65d5a4);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");
const $258f99b95fda91d0$export$902945573f65d5a4 = ({ text: text, noValueText: noValueText })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, text ?? noValueText);
};

});

parcelRegister("1wrYf", function(module, exports) {
$parcel$export(module.exports, "default", () => $cee3bd62c7572fb0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cee3bd62c7572fb0$var$messages = (0, $7qGN1.defineMessages)({
    noGroup: {
        "id": "issue-table-grouping.group-row.group-header.group-picker-group-header.no-group",
        "defaultMessage": "No group"
    }
});
var $cee3bd62c7572fb0$export$2e2bcd8739ae039 = $cee3bd62c7572fb0$var$messages;

});


parcelRegister("immik", function(module, exports) {
$parcel$export(module.exports, "OptionGroupHeader", () => $6be13b415b00c9d9$export$100e8d6eda7c9ebc);

var $9RiLs = parcelRequire("9RiLs");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $3mZMJ = parcelRequire("3mZMJ");

var $6w3tC = parcelRequire("6w3tC");

var $aIng6 = parcelRequire("aIng6");

var $3QRBm = parcelRequire("3QRBm");
const $6be13b415b00c9d9$export$100e8d6eda7c9ebc = ({ optionGroupHeader: optionGroupHeader, fieldType: fieldType })=>{
    const data = (0, $j4oe4.useFragment)((0, $9RiLs.default), optionGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return fieldType === (0, $3mZMJ.RADIO_BUTTONS_CF_TYPE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6w3tC.TextGroupHeaderContent), {
        text: data?.displayName || data?.option?.value,
        noValueText: formatMessage((0, $3QRBm.default).noOption)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIng6.TagGroupHeaderContent), {
        text: data?.displayName || data?.option?.value,
        noValueText: formatMessage((0, $3QRBm.default).noOption)
    });
};

});
parcelRegister("9RiLs", function(module, exports) {
$parcel$export(module.exports, "default", () => $46253e77847c78ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f1f82cc0fae6280d93f9065afb2bf7c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $46253e77847c78ca$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "OptionGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "option",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ],
    "type": "JiraJqlOptionFieldValue"
};
$46253e77847c78ca$var$node.hash = "c4db465dc3b0a691a209bbf2635a74ed";
var $46253e77847c78ca$export$2e2bcd8739ae039 = $46253e77847c78ca$var$node;

});

parcelRegister("3QRBm", function(module, exports) {
$parcel$export(module.exports, "default", () => $7965b3ff7c3d2b69$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7965b3ff7c3d2b69$var$messages = (0, $7qGN1.defineMessages)({
    noOption: {
        "id": "issue-table-grouping.group-row.group-header.option-group-header.no-option",
        "defaultMessage": "No value"
    }
});
var $7965b3ff7c3d2b69$export$2e2bcd8739ae039 = $7965b3ff7c3d2b69$var$messages;

});


parcelRegister("2mFVu", function(module, exports) {
$parcel$export(module.exports, "VersionGroupHeader", () => $82a52f5cd88544fa$export$e72e2cdf797c0426);

var $lVYqV = parcelRequire("lVYqV");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $3mZMJ = parcelRequire("3mZMJ");

var $6w3tC = parcelRequire("6w3tC");

var $aIng6 = parcelRequire("aIng6");

var $4z91V = parcelRequire("4z91V");
const $82a52f5cd88544fa$export$e72e2cdf797c0426 = ({ versionGroupHeader: versionGroupHeader, fieldType: fieldType })=>{
    const data = (0, $j4oe4.useFragment)((0, $lVYqV.default), versionGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return fieldType === (0, $3mZMJ.VERSION_CF_TYPE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6w3tC.TextGroupHeaderContent), {
        text: data?.displayName || data?.version?.name,
        noValueText: formatMessage((0, $4z91V.default).noVersion)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIng6.TagGroupHeaderContent), {
        text: data?.displayName || data?.version?.name,
        noValueText: formatMessage((0, $4z91V.default).noVersion)
    });
};

});
parcelRegister("lVYqV", function(module, exports) {
$parcel$export(module.exports, "default", () => $5334cb1f684ac665$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<75233030ab85ba580c52460467caeeb7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5334cb1f684ac665$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "VersionGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraVersion",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraJqlVersionFieldValue"
};
$5334cb1f684ac665$var$node.hash = "f5808a1ed0cb4468ba0571f25b813167";
var $5334cb1f684ac665$export$2e2bcd8739ae039 = $5334cb1f684ac665$var$node;

});

parcelRegister("4z91V", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc58f19fb4ae2242$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $fc58f19fb4ae2242$var$messages = (0, $7qGN1.defineMessages)({
    noVersion: {
        "id": "issue-table-grouping.group-row.group-header.version-group-header.no-version",
        "defaultMessage": "No version"
    }
});
var $fc58f19fb4ae2242$export$2e2bcd8739ae039 = $fc58f19fb4ae2242$var$messages;

});


parcelRegister("4zhkx", function(module, exports) {
$parcel$export(module.exports, "UserGroupHeader", () => $b02527eca9c682fb$export$6a5bbfbd8cc048b3);

var $eO7Ff = parcelRequire("eO7Ff");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5DgXR = parcelRequire("5DgXR");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $4UiGa = parcelRequire("4UiGa");

var $3mZMJ = parcelRequire("3mZMJ");

var $8vugl = parcelRequire("8vugl");
const $b02527eca9c682fb$export$6a5bbfbd8cc048b3 = ({ userGroupHeader: userGroupHeader, fieldType: fieldType })=>{
    const data = (0, $j4oe4.useFragment)((0, $eO7Ff.default), userGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    let noValueText;
    switch(fieldType){
        case 0, $3mZMJ.ASSIGNEE_TYPE:
            noValueText = formatMessage((0, $8vugl.default).unassignedDisplayName);
            break;
        case 0, $3mZMJ.USER_CF_TYPE:
            noValueText = formatMessage((0, $8vugl.default).noUserDisplayName);
            break;
        case 0, $3mZMJ.REPORTER_TYPE:
            noValueText = formatMessage((0, $8vugl.default).anonymousDisplayName);
            break;
        default:
            noValueText = null;
    }
    const displayName = data?.displayName ?? noValueText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4UiGa.AvatarLite), {
        avatarUrl: data.user?.picture
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: "circle",
        src: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, displayName));
};

});
parcelRegister("eO7Ff", function(module, exports) {
$parcel$export(module.exports, "default", () => $f203ba87f4835413$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5eea95fc344aef76f38578e37f8ff9a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f203ba87f4835413$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "UserGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "picture"
                }
            ]
        }
    ],
    "type": "JiraJqlUserFieldValue"
};
$f203ba87f4835413$var$node.hash = "08198f06ef3106202be1a9d0e7e7aeea";
var $f203ba87f4835413$export$2e2bcd8739ae039 = $f203ba87f4835413$var$node;

});

parcelRegister("4UiGa", function(module, exports) {
$parcel$export(module.exports, "AvatarLite", () => $cb3b12b2e97c8824$export$8b9560cc4e12c651);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $cb3b12b2e97c8824$var$AVATAR_SIZE = 24;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb3b12b2e97c8824$var$Avatar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { avatarUrl: avatarUrl, isHighlighted: isHighlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fzlxay": (0, $awdRS.default)(`url(${__cmplp.avatarUrl})`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1rr0 _12ji1r31 _1qu2glyw _12y3idpf _1itk1v7f _ouxl1ssb _12vemgnk _1lrw1dfr _bfhk18uv _vchh18uv _4t3i1tcg _1bsb1tcg _1ul91tcg _1tke1tcg _1e0c1o8l _kqswh2mm _80om1kw7 _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            __cmplp.isHighlighted ? "_16qsbw1l" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $cb3b12b2e97c8824$var$hasKeywords = (name)=>(keyword)=>name && keyword && name.toLowerCase().includes(keyword.toLowerCase());
const $cb3b12b2e97c8824$export$8b9560cc4e12c651 = /*#__PURE__*/ (0, $eJOHy.memo)(({ avatarUrl: avatarUrl, name: name = '', highlight: highlight, testId: testId })=>{
    const isHighlighted = highlight && highlight.some($cb3b12b2e97c8824$var$hasKeywords(name));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cb3b12b2e97c8824$var$Avatar, {
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        avatarUrl: avatarUrl,
        title: name,
        // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
        isHighlighted: isHighlighted,
        "data-testid": testId
    });
});

});

parcelRegister("8vugl", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9aa0597a71f459f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f9aa0597a71f459f$var$messages = (0, $7qGN1.defineMessages)({
    unassignedDisplayName: {
        "id": "issue-table-grouping.group-row.group-header.assignee-group-header.unassigned-display-name",
        "defaultMessage": "Unassigned"
    },
    noUserDisplayName: {
        "id": "issue-table-grouping.group-row.group-header.user-group-header.no-user-display-name",
        "defaultMessage": "No user"
    },
    anonymousDisplayName: {
        "id": "issue-table-grouping.group-row.group-header.user-group-header.anonymous-display-name",
        "defaultMessage": "Anonymous"
    }
});
var $f9aa0597a71f459f$export$2e2bcd8739ae039 = $f9aa0597a71f459f$var$messages;

});


parcelRegister("e0hmq", function(module, exports) {
$parcel$export(module.exports, "ResolutionGroupHeader", () => $6217e59746f60130$export$d4278b92a1d7dd0c);

var $fVVKy = parcelRequire("fVVKy");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $6w3tC = parcelRequire("6w3tC");

var $gA8Ur = parcelRequire("gA8Ur");
const $6217e59746f60130$export$d4278b92a1d7dd0c = ({ resolutionGroupHeader: resolutionGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $fVVKy.default), resolutionGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6w3tC.TextGroupHeaderContent), {
        text: data?.displayName || data?.resolution?.name || data?.resolution?.id,
        noValueText: formatMessage((0, $gA8Ur.default).noResolution)
    });
};

});
parcelRegister("fVVKy", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f281d91c59713f7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f28a6fec148280a5485288e085be8006>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4f281d91c59713f7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ResolutionGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraResolution",
            "kind": "LinkedField",
            "name": "resolution",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraJqlResolutionFieldValue"
};
$4f281d91c59713f7$var$node.hash = "69c557634138dcd08dae628cc8eb1510";
var $4f281d91c59713f7$export$2e2bcd8739ae039 = $4f281d91c59713f7$var$node;

});

parcelRegister("gA8Ur", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ffefe9700680e82$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9ffefe9700680e82$var$messages = (0, $7qGN1.defineMessages)({
    noResolution: {
        "id": "issue-table-grouping.group-row.group-header.resolution-group-header.no-resolution",
        "defaultMessage": "No resolution"
    }
});
var $9ffefe9700680e82$export$2e2bcd8739ae039 = $9ffefe9700680e82$var$messages;

});


parcelRegister("4z3Ld", function(module, exports) {
$parcel$export(module.exports, "AtlasProjectGroupHeader", () => $9206c2bdf85db90f$export$86103fc11f7604c4);

var $6op0Z = parcelRequire("6op0Z");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");

var $5NtHI = parcelRequire("5NtHI");

var $lRq8t = parcelRequire("lRq8t");

var $lAN5p = parcelRequire("lAN5p");

var $fRm4z = parcelRequire("fRm4z");

var $bCxCS = parcelRequire("bCxCS");
const $9206c2bdf85db90f$var$styles = {
    textStyles: "_1reo15vq _18m915vq _o5721q9c _1bto1l2s"
};
const $9206c2bdf85db90f$export$86103fc11f7604c4 = ({ atlasProjectGroupHeader: atlasProjectGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $6op0Z.default), atlasProjectGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const constructAtlasProjectUrl = (0, $fRm4z.useProjectUrlConstructor)();
    if (data?.project) {
        const url = constructAtlasProjectUrl({
            ari: data.project.id ?? '',
            projectKey: data.project.key ?? ''
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lAN5p.SimpleInlineSmartLink), {
            url: url,
            text: data.project.name ?? '',
            metadata: [
                {
                    name: (0, $5NtHI.ElementName).State
                }
            ],
            projectAri: data.project.id ?? '',
            isPrivate: data.project.privateProject ?? false,
            initialHasNoAccess: data.project.hasPermission === false,
            emojiName: data.project.iconName || undefined
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9206c2bdf85db90f$var$styles.textStyles
    }, formatMessage((0, $bCxCS.default).noAtlasProjectDisplayName));
};

});
parcelRegister("6op0Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $49c488e9c185dd5f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2805087545b94a870e49b267b77cae67>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $49c488e9c185dd5f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AtlasProjectGroupHeader",
    "selections": [
        {
            "concreteType": "JiraTownsquareProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "privateProject"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasPermission"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "iconName"
                }
            ]
        }
    ],
    "type": "JiraJqlTownsquareProjectFieldValue"
};
$49c488e9c185dd5f$var$node.hash = "3b0a883c54b5f776f64f188781ae4e7a";
var $49c488e9c185dd5f$export$2e2bcd8739ae039 = $49c488e9c185dd5f$var$node;

});

parcelRegister("lAN5p", function(module, exports) {
$parcel$export(module.exports, "SimpleInlineSmartLink", () => $2746fa02047bd6ae$export$e918b96127f4d56b);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $jstc7 = parcelRequire("jstc7");

var $g9Vr6 = parcelRequire("g9Vr6");

var $e6YEs = parcelRequire("e6YEs");

var $8rl2J = parcelRequire("8rl2J");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $cSWVe = parcelRequire("cSWVe");

var $aJTdT = parcelRequire("aJTdT");

var $3Gg8D = parcelRequire("3Gg8D");

var $jMHWF = parcelRequire("jMHWF");

var $4v12d = parcelRequire("4v12d");

var $lX89l = parcelRequire("lX89l");
const $2746fa02047bd6ae$export$e918b96127f4d56b = ({ initialHasNoAccess: initialHasNoAccess = false, showNoAccessPopup: showNoAccessPopup = true, isPrivate: isPrivate = false, onHandleNoAccess: onHandleNoAccess, ...props })=>{
    const [hasNoAccess, setHasNoAccess] = (0, $eJOHy.useState)(initialHasNoAccess || isPrivate);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleError = (0, $eJOHy.useCallback)((arg)=>{
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'atlasProjectSmartLink failed', {
            errorStatus: arg.status,
            isPrivate: isPrivate,
            initialHasNoAccess: initialHasNoAccess,
            hasNoAccess: hasNoAccess
        });
        if (arg?.status === 'forbidden' || arg?.status === 'errored') {
            setHasNoAccess(true);
            onHandleNoAccess?.();
        }
    }, [
        createAnalyticsEvent,
        isPrivate,
        initialHasNoAccess,
        onHandleNoAccess,
        hasNoAccess
    ]);
    const handleResolve = (0, $eJOHy.useCallback)(()=>{
        setHasNoAccess(false);
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'atlasProjectRestrictedSmartLink resolved', {
            isPrivate: isPrivate,
            initialHasNoAccess: initialHasNoAccess
        });
    }, [
        createAnalyticsEvent,
        isPrivate,
        initialHasNoAccess
    ]);
    if (hasNoAccess) {
        if ((0, $4cTDP.fg)('smart-link-custom-hover-card-content')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2746fa02047bd6ae$var$RestrictedSmartLink, {
            ...props,
            initialHasNoAccess: initialHasNoAccess,
            showNoAccessPopup: showNoAccessPopup,
            isPrivate: isPrivate,
            onResolve: handleResolve,
            onError: handleError
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2746fa02047bd6ae$var$OldRestrictedSmartLink, {
            ...props,
            initialHasNoAccess: initialHasNoAccess,
            showNoAccessPopup: showNoAccessPopup,
            isPrivate: isPrivate,
            onResolve: handleResolve,
            onError: handleError
        });
    }
    if ((0, $4cTDP.fg)('anip-217_use_common_smartlink_for_atlas_projects')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lX89l.CommonInlineSmartLink), {
        ...props,
        onError: handleError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4v12d.InlineSmartLink), {
        ...props,
        onError: handleError
    });
};
const $2746fa02047bd6ae$var$RestrictedSmartLink = ({ initialHasNoAccess: initialHasNoAccess, projectAri: projectAri, showNoAccessPopup: showNoAccessPopup, isPrivate: isPrivate, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const accountId = (0, $e6YEs.useAccountId)();
    const cloudId = projectAri ? (0, $8rl2J.TownsquareProjectAri).parse(projectAri).siteId : undefined;
    // only show private project popup if the project is private and initially the user has site access
    const showPrivateProject = isPrivate && !initialHasNoAccess;
    if ((0, $4cTDP.fg)('anip-217_use_common_smartlink_for_atlas_projects')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: {
            hoverCardName: showPrivateProject ? 'atlasProjectPrivateProjectPopup' : 'atlasProjectProjectsAccessPopup'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lX89l.CommonInlineSmartLink), {
        ...props,
        text: formatMessage((0, $aJTdT.default).restrictedProject),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cSWVe.RestrictedIcon), null),
        hideRetry: true,
        showHoverPreview: showNoAccessPopup,
        hoverPreviewOptions: {
            render: ()=>showPrivateProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMHWF.PrivateProjectPopup), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jstc7.ProjectsAccess), {
                    orgId: orgId,
                    accountId: accountId ?? undefined,
                    requestAccessSimplifiedUI: false,
                    cloudId: cloudId
                })
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: {
            hoverCardName: showPrivateProject ? 'atlasProjectPrivateProjectPopup' : 'atlasProjectProjectsAccessPopup'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4v12d.InlineSmartLink), {
        ...props,
        text: formatMessage((0, $aJTdT.default).restrictedProject),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cSWVe.RestrictedIcon), null),
        hideRetry: true,
        showHoverPreview: showNoAccessPopup,
        hoverPreviewOptions: {
            render: ()=>showPrivateProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMHWF.PrivateProjectPopup), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jstc7.ProjectsAccess), {
                    orgId: orgId,
                    accountId: accountId ?? undefined,
                    requestAccessSimplifiedUI: false,
                    cloudId: cloudId
                })
        }
    }));
};
const $2746fa02047bd6ae$var$OldRestrictedSmartLink = ({ initialHasNoAccess: initialHasNoAccess, projectAri: projectAri, showNoAccessPopup: showNoAccessPopup, isPrivate: isPrivate, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const renderNoAccessSmartLink = (0, $4cTDP.fg)('anip-217_use_common_smartlink_for_atlas_projects') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lX89l.CommonInlineSmartLink), {
        ...props,
        text: formatMessage((0, $aJTdT.default).restrictedProject),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cSWVe.RestrictedIcon), null),
        hideRetry: true,
        showHoverPreview: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4v12d.InlineSmartLink), {
        ...props,
        text: formatMessage((0, $aJTdT.default).restrictedProject),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cSWVe.RestrictedIcon), null),
        hideRetry: true,
        showHoverPreview: false
    });
    if (!showNoAccessPopup) return renderNoAccessSmartLink;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2746fa02047bd6ae$var$HoverPopupIfRestricted, {
        projectAri: projectAri,
        // only show private project popup if the project is private and initially the user has site access
        showPrivateProject: isPrivate && !initialHasNoAccess
    }, renderNoAccessSmartLink);
};
const $2746fa02047bd6ae$var$HoverPopupIfRestricted = ({ projectAri: projectAri, showPrivateProject: showPrivateProject, children: children })=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const accountId = (0, $e6YEs.useAccountId)();
    const cloudId = projectAri ? (0, $8rl2J.TownsquareProjectAri).parse(projectAri).siteId : undefined;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleVisibilityChange = (0, $eJOHy.useCallback)((isVisible)=>{
        if (isVisible) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'atlasProjectAccessPopup viewed', {
            showPrivateProject: showPrivateProject
        });
    }, [
        createAnalyticsEvent,
        showPrivateProject
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Gg8D.HoverPopup), {
        renderContent: showPrivateProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMHWF.PrivateProjectPopup), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jstc7.ProjectsAccess), {
            orgId: orgId,
            accountId: accountId ?? undefined,
            requestAccessSimplifiedUI: false,
            cloudId: cloudId
        }),
        onVisibilityChange: handleVisibilityChange
    }, children);
};

});
parcelRegister("jstc7", function(module, exports) {
$parcel$export(module.exports, "ProjectsAccess", () => $20ccd5e606873e3f$export$81863c54cac77212);
/* ProjectsAccess.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6X7AJ = parcelRequire("6X7AJ");
var $dNnxZ = parcelRequire("dNnxZ");

var $lRq8t = parcelRequire("lRq8t");

var $lc0OY = parcelRequire("lc0OY");
var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");

var $dLR8J = parcelRequire("dLR8J");

var $8RHPx = parcelRequire("8RHPx");

var $ikkcZ = parcelRequire("ikkcZ");

var $eGjjZ = parcelRequire("eGjjZ");

var $6aXz6 = parcelRequire("6aXz6");

var $3uHC5 = parcelRequire("3uHC5");

var $gwjUU = parcelRequire("gwjUU");

var $gKJfP = parcelRequire("gKJfP");
const $20ccd5e606873e3f$var$styles = {
    container: "_1bsb1mjv _19bv1ejb _u5f31ejb _ca0qpxbi _n3tdpxbi"
};
const $20ccd5e606873e3f$var$getTownsquareUrl = ({ orgId: orgId, cloudId: cloudId })=>`https://${(0, $8RHPx.getATLContextDomain)('admin')}/o/${orgId}/townsquare?cloudId=${cloudId}&isSignup=true`;
const $20ccd5e606873e3f$export$81863c54cac77212 = ({ accountId: accountId, cloudId: cloudId, orgId: orgId, product: product, requestAccessSimplifiedUI: requestAccessSimplifiedUI = true })=>{
    const crossFlow = (0, $6X7AJ.useCrossFlow)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isOrgAdmin: isOrgAdmin, loading: loading, hasErrorOccurred: hasErrorOccurred } = (0, $gwjUU.useOrgAdminPermission)(orgId, accountId);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ikkcZ.useFireAnalyticEvent)();
    (0, $eJOHy.useEffect)(()=>{
        fireAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'townsquareProjectPicker',
            eventType: 'ui',
            analyticsAttributes: {
                screen: 'PROJECTS_ACCESS',
                isOrgAdmin: isOrgAdmin,
                isProjectFieldEmpty: requestAccessSimplifiedUI
            }
        });
    }, [
        fireAnalyticsEvent,
        isOrgAdmin,
        requestAccessSimplifiedUI
    ]);
    const onRequestAccess = (0, $eJOHy.useCallback)(async ()=>{
        if (crossFlow.isEnabled) await crossFlow.api.open({
            journey: (0, $6X7AJ.Journeys).GET_STARTED,
            sourceComponent: 'project-picker',
            sourceContext: product ?? 'jira',
            targetProduct: (0, $dNnxZ.Targets).ATLAS
        });
    }, [
        crossFlow,
        product
    ]);
    if (hasErrorOccurred) throw new Error('Error checking org admin permissions');
    if (loading) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
        name: (0, $eGjjZ.UFOSegmentNames).ProjectAdminAccessCheckLoading,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3uHC5.ProjectPickerLoadingSkeleton), {
            testId: "projects-access-loading"
        })
    });
    if (isOrgAdmin) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6aXz6.EmptyState), {
        heading: formatMessage((0, $gKJfP.messages).genericPermissionsStateHeading),
        description: formatMessage((0, $gKJfP.messages).turnOnProjectsDescription),
        buttonLabel: formatMessage((0, $gKJfP.messages).turnOnProjectsButtonLabel),
        onClick: ()=>{
            if (orgId && cloudId) window.open($20ccd5e606873e3f$var$getTownsquareUrl({
                orgId: orgId,
                cloudId: cloudId
            }), '_blank');
        }
    });
    if (requestAccessSimplifiedUI) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $20ccd5e606873e3f$var$styles.container,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
            space: "space.100",
            children: [
                formatMessage((0, $gKJfP.messages).requestAccessDescription),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lc0OY.default), {
                    href: "#",
                    onClick: onRequestAccess,
                    children: formatMessage((0, $gKJfP.messages).requestAccessLink)
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6aXz6.EmptyState), {
        heading: formatMessage((0, $gKJfP.messages).requestAccessHeading),
        description: formatMessage((0, $gKJfP.messages).requestAccessFullDescription),
        buttonLabel: formatMessage((0, $gKJfP.messages).requestAccessLink),
        onClick: onRequestAccess
    });
};

});
parcelRegister("ikkcZ", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_TAGS", () => $3dd4eb5dca70c07c$export$5c5dde904519fd9b);
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3dd4eb5dca70c07c$export$85183a312807388d);
$parcel$export(module.exports, "useFireAnalyticEvent", () => $3dd4eb5dca70c07c$export$2ed04b34b7f5fc7f);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $ezqmt = parcelRequire("ezqmt");
const $3dd4eb5dca70c07c$export$5c5dde904519fd9b = [
    'townsquare'
];
const $3dd4eb5dca70c07c$export$85183a312807388d = 'atlas';
const $3dd4eb5dca70c07c$export$2ed04b34b7f5fc7f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const baseAnalyticsAttributes = (0, $ezqmt.useAnalyticsAttributes)();
    const fireAnalyticsEvent = (0, $eJOHy.useCallback)(({ analyticsAttributes: analyticsAttributes, eventType: eventType, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            eventType: eventType,
            tags: $3dd4eb5dca70c07c$export$5c5dde904519fd9b,
            attributes: {
                ...baseAnalyticsAttributes,
                ...analyticsAttributes
            }
        });
        analyticsEvent.fire($3dd4eb5dca70c07c$export$85183a312807388d);
    }, [
        baseAnalyticsAttributes,
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};

});
parcelRegister("ezqmt", function(module, exports) {
$parcel$export(module.exports, "ProjectPickerContext", () => $776b4ebe50bb91ea$export$43bcce6abe53342f);
$parcel$export(module.exports, "useProjectPicker", () => $776b4ebe50bb91ea$export$8fe735c15635f461);
$parcel$export(module.exports, "useAnalyticsAttributes", () => $776b4ebe50bb91ea$export$1fd8522aeddaccda);

var $eJOHy = parcelRequire("eJOHy");
const $776b4ebe50bb91ea$export$43bcce6abe53342f = /*#__PURE__*/ (0, $eJOHy.createContext)({
    linkedProject: undefined,
    siteIds: [],
    analyticsAttributes: undefined,
    hasProjectCreateAccess: false,
    onCreateProject: undefined,
    onProjectSelect: undefined,
    onProjectUnlink: undefined
});
const $776b4ebe50bb91ea$export$8fe735c15635f461 = ()=>{
    const context = (0, $eJOHy.useContext)($776b4ebe50bb91ea$export$43bcce6abe53342f);
    return {
        linkedProject: context.linkedProject,
        siteIds: context.siteIds,
        hasProjectCreateAccess: context.hasProjectCreateAccess,
        onCreateProject: context.onCreateProject,
        onProjectSelect: context.onProjectSelect,
        onProjectUnlink: context.onProjectUnlink
    };
};
const $776b4ebe50bb91ea$export$1fd8522aeddaccda = ()=>{
    const context = (0, $eJOHy.useContext)($776b4ebe50bb91ea$export$43bcce6abe53342f);
    return context.analyticsAttributes;
};

});


parcelRegister("eGjjZ", function(module, exports) {
$parcel$export(module.exports, "UFOSegmentNames", () => $0f9b5cb48ea7f7e2$export$a239e9f23c560e05);
const $0f9b5cb48ea7f7e2$export$a239e9f23c560e05 = {
    ProjectPicker: 'townsquare-project-picker',
    ProjectPickerLoading: 'townsquare-project-picker-loading',
    RecentProjectsLoading: 'townsquare-project-picker-recent-projects-loading',
    ProjectAdminAccessCheckLoading: 'townsquare-project-admin-access-check-loading'
};

});

parcelRegister("6aXz6", function(module, exports) {
$parcel$export(module.exports, "EmptyState", () => $b41bd195e70f12e8$export$fddf379e22a74b00);
/* EmptyState.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $5CSKW = parcelRequire("5CSKW");

var $806LH = parcelRequire("806LH");

var $8wyVH = parcelRequire("8wyVH");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $2cAMY = parcelRequire("2cAMY");

var $8EmRQ = parcelRequire("8EmRQ");
const $b41bd195e70f12e8$var$styles = {
    container: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q _1bsb1gwv",
    projectCardImage: "_1e0c1txw _1bsb1wdt _c71l1lit"
};
const $b41bd195e70f12e8$export$fddf379e22a74b00 = ({ heading: heading, description: description, buttonLabel: buttonLabel, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $b41bd195e70f12e8$var$styles.container,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
            space: "space.300",
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: $b41bd195e70f12e8$var$styles.projectCardImage,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wyVH.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2cAMY))),
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                    size: "small",
                    children: heading || formatMessage((0, $8EmRQ.messages).genericEmptyStateHeading)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    color: "color.text.subtle",
                    align: "center",
                    size: "medium",
                    children: description
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                    appearance: "primary",
                    onClick: onClick,
                    children: buttonLabel || formatMessage((0, $8EmRQ.messages).createProjectButtonLabel)
                })
            ]
        })
    });
};

});
parcelRegister("2cAMY", function(module, exports) {
module.exports = new URL("ProductCardImage.40570c61.png", import.meta.url).toString();

});

parcelRegister("8EmRQ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $96df03f7aaf6c82a$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $96df03f7aaf6c82a$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    genericEmptyStateHeading: {
        id: 'project-picker.empty-state.generic-heading',
        defaultMessage: 'Get started with projects',
        description: 'Heading displayed on picker empty state when there are no projects available or projects are not turned on'
    },
    createProjectButtonLabel: {
        id: 'project-picker.empty-state.create-project-button-label',
        defaultMessage: 'Create project',
        description: 'Label for button to create a new project'
    }
});

});


parcelRegister("3uHC5", function(module, exports) {
$parcel$export(module.exports, "ProjectPickerLoadingSkeleton", () => $5bb839bf86555fad$export$51ac0a45c0e1cc2d);
/* ProjectPickerLoadingSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");

var $jjS5D = parcelRequire("jjS5D");

var $cABXr = parcelRequire("cABXr");

var $in42L = parcelRequire("in42L");
const $5bb839bf86555fad$var$styles = {
    headerSkeleton: "_otyr12x7 _ca0qutpp _u5f3utpp _19bvutpp",
    createButtonSkeleton: "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
const $5bb839bf86555fad$export$c698677b82bddd68 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
        columnGap: "space.100",
        alignItems: "center",
        xcss: $5bb839bf86555fad$var$styles.createButtonSkeleton,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                height: "20px",
                width: "20px",
                isShimmering: true
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                height: "20px",
                width: "120px",
                isShimmering: true
            })
        ]
    });
const $5bb839bf86555fad$export$51ac0a45c0e1cc2d = ({ testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $cABXr.ProjectPickerLayout), {
        testId: testId,
        createButton: /*#__PURE__*/ (0, $gt9Am.jsx)($5bb839bf86555fad$export$c698677b82bddd68, {}),
        showCreateButton: true,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $5bb839bf86555fad$var$styles.headerSkeleton,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                    height: "15px",
                    width: "140px",
                    isShimmering: true
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $in42L.ProjectListSkeleton), {
                itemCount: 5
            })
        ]
    });
};

});
parcelRegister("cABXr", function(module, exports) {
$parcel$export(module.exports, "ProjectPickerLayout", () => $f091b1db16c2e463$export$260453b9031bce9d);
/* ProjectPickerLayout.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $ezqmt = parcelRequire("ezqmt");

var $ahaT5 = parcelRequire("ahaT5");
const $f091b1db16c2e463$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _1bsb1gwv _bfhk1bhr",
    content: "_n3td12x7",
    title: "_ca0qpxbi _19bvpxbi _u5f3pxbi _n3td12x7",
    titleWithUnlinkButton: "_ca0q12x7",
    createButton: "_x3doia51 _1bsb1osq _ca0q1b66 _n3td1b66",
    unlinkButton: "_1bsb1osq _ca0q1b66"
};
const $f091b1db16c2e463$export$260453b9031bce9d = ({ title: title, createButton: createButton, children: children, unlinkButton: unlinkButton, testId: testId, showCreateButton: showCreateButton })=>{
    const { onCreateProject: onCreateProject, hasProjectCreateAccess: hasProjectCreateAccess } = (0, $ezqmt.useProjectPicker)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
        xcss: $f091b1db16c2e463$var$styles.container,
        testId: testId,
        children: [
            unlinkButton && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $f091b1db16c2e463$var$styles.unlinkButton,
                children: unlinkButton
            }),
            title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: (0, $k0ahr.cx)($f091b1db16c2e463$var$styles.title, unlinkButton && $f091b1db16c2e463$var$styles.titleWithUnlinkButton),
                role: "heading",
                "aria-level": 6,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    color: "color.text.subtlest",
                    weight: "bold",
                    size: "small",
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $f091b1db16c2e463$var$styles.content,
                children: children
            }),
            (hasProjectCreateAccess || showCreateButton) && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $f091b1db16c2e463$var$styles.createButton,
                children: createButton ? createButton : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ahaT5.CreateProjectButton), {
                    onClick: onCreateProject
                })
            })
        ]
    });
};

});
parcelRegister("ahaT5", function(module, exports) {
$parcel$export(module.exports, "CreateProjectButton", () => $2e137bea86c1158b$export$e6ababadbbc5e958);
/* CreateProjectButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $dcLzM = parcelRequire("dcLzM");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $46R8N = parcelRequire("46R8N");
var $3cMgR = parcelRequire("3cMgR");

var $ikkcZ = parcelRequire("ikkcZ");

var $j6ecc = parcelRequire("j6ecc");
const $2e137bea86c1158b$var$styles = {
    createButton: "_kqswh2mm _1bsb1osq _19bvutpp _u5f3utpp _ca0q12x7 _n3td12x7 _bfhk1bhr _1n1j1hof _1kt9b3bt _1cs8stnw _qnecze3t _1aukze3t _19woze3t _1mp4yh40 _18oh15vq _pgk1ewfl _olafewfl _1mg8ewfl _jomr1dpa _mizu1r31 _ra3xglyw _128m1o36 _irr31dpa _1di6fcek",
    iconWrapper: "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o"
};
const $2e137bea86c1158b$export$e6ababadbbc5e958 = ({ onClick: onClick, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ikkcZ.useFireAnalyticEvent)();
    const handleClick = (...onClickArgs)=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'townsquareProjectPickerCreateProjectButton'
        });
        onClick?.(...onClickArgs);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        xcss: $2e137bea86c1158b$var$styles.createButton,
        onClick: handleClick,
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.100",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: $2e137bea86c1158b$var$styles.iconWrapper,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                        label: "",
                        spacing: "none",
                        color: "var(--ds-icon)"
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    children: formatMessage((0, $j6ecc.messages).createProjectButtonLabel)
                })
            ]
        })
    });
};

});
parcelRegister("j6ecc", function(module, exports) {
$parcel$export(module.exports, "messages", () => $998672da8795038b$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $998672da8795038b$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    createProjectButtonLabel: {
        id: 'project-picker.create-project-button-label',
        defaultMessage: 'Create project',
        description: 'Label for the button to create a new project within the project picker'
    }
});

});



parcelRegister("in42L", function(module, exports) {
$parcel$export(module.exports, "ProjectListSkeleton", () => $899e2b64e9a847d0$export$372edd920d1be0da);
/* ProjectListSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $78OnL = parcelRequire("78OnL");

var $8y9ad = parcelRequire("8y9ad");
const $899e2b64e9a847d0$var$styles = {
    projectItemList: "_ca0q12x7 _u5f3pxbi _19bvpxbi _n3td12x7"
};
const $899e2b64e9a847d0$export$372edd920d1be0da = ({ itemCount: itemCount, space: space = 'space.150', ...stackProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $78OnL.default), {
        xcss: $899e2b64e9a847d0$var$styles.projectItemList,
        space: space,
        ...stackProps,
        children: Array.from({
            length: itemCount
        }, (_, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8y9ad.ProjectItemSkeleton), {}, index))
    });

});
parcelRegister("8y9ad", function(module, exports) {
$parcel$export(module.exports, "ProjectItemSkeleton", () => $69f4a7cba3f35e0a$export$10720e04af30dc0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $78OnL = parcelRequire("78OnL");

var $jjS5D = parcelRequire("jjS5D");
const $69f4a7cba3f35e0a$export$10720e04af30dc0 = ({ titleLength: titleLength = '270px', subtitleLength: subtitleLength = '100px' })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
            columnGap: "space.100",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                    height: "24px",
                    width: "24px",
                    isShimmering: true
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                    space: "space.050",
                    grow: "fill",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                            height: "20px",
                            width: titleLength,
                            isShimmering: true
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                            height: "16px",
                            width: subtitleLength,
                            isShimmering: true
                        })
                    ]
                })
            ]
        })
    });

});



parcelRegister("gwjUU", function(module, exports) {
$parcel$export(module.exports, "useOrgAdminPermission", () => $13d4e40028079537$export$ce7c8ae41ffe3315);

var $eJOHy = parcelRequire("eJOHy");
const $13d4e40028079537$var$getUserOrgPermissions = async (orgId, userId)=>{
    const data = {
        resourceId: `ari:cloud:platform::org/${orgId}`,
        principalId: `ari:cloud:identity::user/${userId}`,
        permissionId: 'manage-users'
    };
    const response = await fetch('/gateway/api/permissions/permitted', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    return (await response.json()).permitted;
};
const $13d4e40028079537$export$ce7c8ae41ffe3315 = (orgId, userId)=>{
    const [data, setData] = (0, $eJOHy.useState)(null);
    const [loading, setLoading] = (0, $eJOHy.useState)(true);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const fetchIsOrgAdmin = (0, $eJOHy.useCallback)(async ()=>{
        if (!userId || !orgId) return false;
        setError(null);
        try {
            const permitted = await $13d4e40028079537$var$getUserOrgPermissions(orgId, userId);
            setData(permitted);
        } catch (err) {
            setError(err);
            setData(null);
        } finally{
            setLoading(false);
        }
    }, [
        orgId,
        userId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (orgId && userId) fetchIsOrgAdmin();
    }, [
        orgId,
        userId,
        fetchIsOrgAdmin
    ]);
    return {
        isOrgAdmin: !!data,
        loading: loading,
        hasErrorOccurred: !!error
    };
};

});

parcelRegister("gKJfP", function(module, exports) {
$parcel$export(module.exports, "messages", () => $395f4f974a592139$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $395f4f974a592139$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    genericPermissionsStateHeading: {
        id: 'project-picker.request-access.generic-heading',
        defaultMessage: 'Get started with projects',
        description: 'Heading displayed on picker when projects are not available in the site or user has not access to projects'
    },
    turnOnProjectsDescription: {
        id: 'project-picker.request-access.turn-on-projects-description',
        defaultMessage: "Link work items to a project for a clearer view of your team\u2019s progress and an easier way to share updates.",
        description: 'Description to turn on projects'
    },
    requestAccessDescription: {
        id: 'project-picker.request-access.request-access-description',
        defaultMessage: 'Ask your admin for access to projects so you can track work and share updates with your team.',
        description: 'Description to request access'
    },
    turnOnProjectsButtonLabel: {
        id: 'project-picker.request-access.turn-on-projects-button-label',
        defaultMessage: 'Turn on projects',
        description: 'Label for button to turn on projects'
    },
    requestAccessLink: {
        id: 'project-picker.request-access.request-access-link',
        defaultMessage: 'Request access',
        description: 'Label for link to request access'
    },
    requestAccessHeading: {
        id: 'project-picker.request-access.restricted-project-heading',
        defaultMessage: 'Get access to the Projects app',
        description: 'Heading displayed on picker when user has no access to the Project App'
    },
    requestAccessFullDescription: {
        id: 'project-picker.request-access.restricted-project-description',
        defaultMessage: "To view and track work in this project, you\u2019ll need access from your admin.",
        description: 'Description displayed on picker when user has no access to the Project App'
    }
});

});


parcelRegister("cSWVe", function(module, exports) {
$parcel$export(module.exports, "RestrictedIcon", () => $232f9b4ae549ebbf$export$fb0d481c8f77ba99);
$parcel$export(module.exports, "RestrictedAlikeSmartLink", () => $232f9b4ae549ebbf$export$b7ba52991f8ac979);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $9QgTI = parcelRequire("9QgTI");

var $8IeH1 = parcelRequire("8IeH1");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $8OdFP = parcelRequire("8OdFP");

var $aJTdT = parcelRequire("aJTdT");
const $232f9b4ae549ebbf$var$styles = {
    popupEditViewStyle: "_n7zl1w13 _x3do1w13 _19bvu2gc _ca0q1b66 _n3td1b66"
};
const $232f9b4ae549ebbf$export$fb0d481c8f77ba99 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
        label: formatMessage((0, $aJTdT.default).restrictedProject),
        size: "small",
        color: "var(--ds-icon-danger, #C9372C)"
    });
};
const $232f9b4ae549ebbf$export$b7ba52991f8ac979 = ({ popupEditView: popupEditView = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'atlasProjectRestrictedAlikeSmartLink viewed', {
            popupEditView: popupEditView
        });
    }, [
        createAnalyticsEvent,
        popupEditView
    ]);
    const linkContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8OdFP.AlikeSmartLink), {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($232f9b4ae549ebbf$export$fb0d481c8f77ba99, null),
            content: formatMessage((0, $aJTdT.default).restrictedProject)
        });
    return popupEditView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $232f9b4ae549ebbf$var$styles.popupEditViewStyle
    }, linkContent()) : linkContent();
};

});
parcelRegister("8OdFP", function(module, exports) {
$parcel$export(module.exports, "AlikeSmartLink", () => $9f253e03aac3e6ac$export$de7d290bc101b437);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
const $9f253e03aac3e6ac$var$styles = {
    containerStyle: "_4bfu18uv _1hmsglyw _ajmmnqa1 _2rko12b0 _zulp12x7 _11c82smr _1h6d1l7x _189ee4h9 _1dqonqa1 _syazi7uo _1e0c1txw _1ul9idpf _1bsb1ns9 _4t3iqslr _80omtlke _bfhkvuon _u5f3v77o _19bv1b66 _ca0qv77o _n3tdv77o _4cvr1h6o _1a3b18uv _4fpr8stv _5goinqa1 _f8pji7uo _9oik18uv _1bnx8stv _jf4cnqa1 _30l3i7uo",
    nameStyle: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _1bto1l2s _o5721q9c _1ul9idpf"
};
const $9f253e03aac3e6ac$export$de7d290bc101b437 = ({ icon: icon, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        xcss: $9f253e03aac3e6ac$var$styles.containerStyle
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $9f253e03aac3e6ac$var$styles.nameStyle
    }, content));
};

});

parcelRegister("aJTdT", function(module, exports) {
$parcel$export(module.exports, "default", () => $0dfa601ba9e2949b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0dfa601ba9e2949b$var$messages = (0, $7qGN1.defineMessages)({
    restrictedProject: {
        "id": "issue-field-atlas-project-common.restricted.restricted-project",
        "defaultMessage": "Restricted project"
    }
});
var $0dfa601ba9e2949b$export$2e2bcd8739ae039 = $0dfa601ba9e2949b$var$messages;

});


parcelRegister("3Gg8D", function(module, exports) {
$parcel$export(module.exports, "HoverPopup", () => $4f1fa3f565c4b710$export$1671b398b5e36be4);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");

var $kJsb4 = parcelRequire("kJsb4");
const $4f1fa3f565c4b710$var$FADE_IN_DELAY = 500;
const $4f1fa3f565c4b710$var$FADE_OUT_DELAY = 300;
const $4f1fa3f565c4b710$export$1671b398b5e36be4 = ({ children: children, renderContent: popupContent, canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = 510, noFadeDelay: noFadeDelay = false, fadeInDelay: customFadeInDelay, onVisibilityChange: onVisibilityChange })=>{
    const fadeInDelay = customFadeInDelay ?? $4f1fa3f565c4b710$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const fadeOutTimeoutId = (0, $eJOHy.useRef)();
    const fadeInTimeoutId = (0, $eJOHy.useRef)();
    const mousePos = (0, $eJOHy.useRef)();
    const popupOffset = (0, $eJOHy.useRef)();
    const parentSpan = (0, $eJOHy.useRef)(null);
    const handleSetIsOpen = (0, $eJOHy.useCallback)((open)=>{
        setIsOpen(open);
        onVisibilityChange?.(open);
    }, [
        onVisibilityChange
    ]);
    const setMousePosition = (0, $eJOHy.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        // If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            const CARD_GAP_PX = 8;
            popupOffset.current = [
                mousePos.current.x - left + CARD_GAP_PX,
                mousePos.current.y - bottom + CARD_GAP_PX
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $eJOHy.useCallback)(()=>{
        handleSetIsOpen(false);
    }, [
        handleSetIsOpen
    ]);
    const initHideCard = (0, $eJOHy.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            fadeInTimeoutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $4f1fa3f565c4b710$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                fadeInTimeoutId.current = undefined;
            }
        };
    }, []);
    const initShowCard = (0, $eJOHy.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        if ('clientX' in event && 'clientY' in event) {
            const mouseEvent = event; // eslint-disable-line @typescript-eslint/consistent-type-assertions
            setMousePosition(mouseEvent);
        }
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) handleSetIsOpen(true);
            else fadeInTimeoutId.current = setTimeout(()=>{
                handleSetIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay,
        handleSetIsOpen
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $eJOHy.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $eJOHy.useCallback)(({ update: update })=>{
        const contentElement = typeof popupContent === 'function' ? popupContent(update) : popupContent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            onMouseEnter: initShowCard,
            onFocus: initShowCard,
            onMouseLeave: initHideCard,
            onBlur: initHideCard
        }, contentElement);
    }, [
        initShowCard,
        initHideCard,
        popupContent
    ]);
    const trigger = (0, $eJOHy.useCallback)(({ 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "span",
            ref: parentSpan
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "span",
            ...triggerProps,
            onMouseEnter: initShowCard,
            onFocus: initShowCard,
            onMouseLeave: initHideCard,
            onBlur: initHideCard,
            onMouseMove: setMousePosition,
            onClick: onChildClick,
            onContextMenu: onContextMenuClick,
            testId: "issue-field-atlas-project-common.ui.hover-popup.hover-popup-trigger-wrapper"
        }, children)), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJsb4.default), {
        testId: "issue-field-atlas-project-common.ui.hover-popup.hover-popup",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex
    });
};

});

parcelRegister("jMHWF", function(module, exports) {
$parcel$export(module.exports, "PrivateProjectPopup", () => $a18a74dc8fc2636d$export$e6b64042204c6064);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $806LH = parcelRequire("806LH");

var $b3VL6 = parcelRequire("b3VL6");

var $lRq8t = parcelRequire("lRq8t");

var $8l31g = parcelRequire("8l31g");
const $a18a74dc8fc2636d$var$styles = {
    containerStyles: "_zulppxbi _4cvr1h6o _p12f1kdj _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1h6o",
    textBlockStyles: "_zulpu2gc _4cvr1h6o"
};
const $a18a74dc8fc2636d$export$e6b64042204c6064 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        xcss: $a18a74dc8fc2636d$var$styles.containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b3VL6.default), {
        alt: formatMessage((0, $8l31g.default).iconLabel),
        height: 96,
        width: 96
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        xcss: $a18a74dc8fc2636d$var$styles.textBlockStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, formatMessage((0, $8l31g.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text"
    }, formatMessage((0, $8l31g.default).description))));
};

});
parcelRegister("b3VL6", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dad21cdeed809b0$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// https://orangedam.atlassian.com/asset-management/2UWGDND5OCL7

var $c4huj = parcelRequire("c4huj");

var $cA8I6 = parcelRequire("cA8I6");

var $gNTkX = parcelRequire("gNTkX");
const $7dad21cdeed809b0$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($gNTkX)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($cA8I6))
});
var $7dad21cdeed809b0$export$2e2bcd8739ae039 = $7dad21cdeed809b0$var$Illustration;
const $7dad21cdeed809b0$export$a179c88182cb9d56 = [
    0,
    0,
    210,
    160
];

});
parcelRegister("cA8I6", function(module, exports) {
module.exports = new URL("data-privacy-darkmode.1a06626c.svg", import.meta.url).toString();

});

parcelRegister("gNTkX", function(module, exports) {
module.exports = new URL("data-privacy.b24f52d9.svg", import.meta.url).toString();

});


parcelRegister("8l31g", function(module, exports) {
$parcel$export(module.exports, "default", () => $274ef57e904ce2d8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $274ef57e904ce2d8$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-field-atlas-project-common.private-project-popup.title",
        "defaultMessage": "This is a private project"
    },
    description: {
        "id": "issue-field-atlas-project-common.private-project-popup.description",
        "defaultMessage": "Only contributors or people the project is shared with can view this private project. Contact your admin to see if you can get access."
    },
    iconLabel: {
        "id": "issue-field-atlas-project-common.private-project-popup.icon-label",
        "defaultMessage": "Private project"
    }
});
var $274ef57e904ce2d8$export$2e2bcd8739ae039 = $274ef57e904ce2d8$var$messages;

});


parcelRegister("4v12d", function(module, exports) {
$parcel$export(module.exports, "InlineSmartLink", () => $23fd05e7d06ef6ea$export$51f4ac8749fbbc36);
/* InlineSmartLink.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $18DG7 = parcelRequire("18DG7");
var $5NtHI = parcelRequire("5NtHI");
var $fqBfo = parcelRequire("fqBfo");

var $8YHJ2 = parcelRequire("8YHJ2");

var $4IKFn = parcelRequire("4IKFn");

var $lRq8t = parcelRequire("lRq8t");

var $cHtIB = parcelRequire("cHtIB");

var $dV1IY = parcelRequire("dV1IY");

var $aJTdT = parcelRequire("aJTdT");

var $7Lq4F = parcelRequire("7Lq4F");
const $23fd05e7d06ef6ea$var$styles = {
    inlineStyles: "_2rko12b0 _1mouv77o _1h6d1l7x _1dqonqa1 _189ee4h9 _bfhkhp5a _1e0c116y _bozgv77o _irr3116u",
    titleBlockStyles: "_zulp1b66 _4t3igktf _c71lgktf _1tkegktf _1e0c1txw _4cvr1h6o _1bah1h6o _11zf9jpi _1k81v77o _cvypi8nm _1mmvplhp _1j7hr5cr _1vabv77o _n2w6v77o",
    emojiWrapper: "_1xdi1txw _18vq1h6o _mata1crf"
};
const $23fd05e7d06ef6ea$var$uiOptions = {
    clickableContainer: true,
    hideBackground: true,
    hideElevation: true,
    hidePadding: true,
    size: (0, $5NtHI.SmartLinkSize).Medium,
    theme: (0, $5NtHI.SmartLinkTheme).Black
};
const $23fd05e7d06ef6ea$var$uiOptionsWithPlaceholder = {
    ...$23fd05e7d06ef6ea$var$uiOptions,
    removeBlockRestriction: true
};
const $23fd05e7d06ef6ea$var$actionOptions = {
    hide: false,
    exclude: [
        (0, $18DG7.CardAction).ChangeStatusAction
    ]
};
const $23fd05e7d06ef6ea$export$51f4ac8749fbbc36 = ({ url: url, anchorTarget: anchorTarget, showHoverPreview: showHoverPreview = true, text: text, anchorRef: anchorRef, onError: onError, onResolve: onResolve, metadata: metadata = [
    {
        name: (0, $5NtHI.ElementName).State
    }
], position: position = (0, $5NtHI.SmartLinkPosition).Center, actions: actions, icon: icon, hideRetry: hideRetry, hoverPreviewOptions: hoverPreviewOptions, emojiName: emojiName })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const placeholderData = (0, $eJOHy.useMemo)(()=>{
        if (!url) return undefined;
        return (0, $7Lq4F.generatePlaceholderData)(url, formatMessage((0, $aJTdT.default).restrictedProject), text);
    }, [
        formatMessage,
        text,
        url
    ]);
    const emojiProvider = (0, $eJOHy.useMemo)(()=>(0, $dV1IY.getEmojiProvider)(), []);
    const emoji = (0, $eJOHy.useMemo)(()=>{
        if (emojiProvider && emojiName) {
            const emojiUri = emojiName.startsWith(':') ? emojiName.slice(1, -1) : emojiName;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                className: (0, $hcewu.default)([
                    $23fd05e7d06ef6ea$var$styles.emojiWrapper
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4IKFn.default), {
                emojiProvider: emojiProvider,
                emojiId: {
                    shortName: emojiName
                },
                fitToHeight: 12,
                optimisticImageURL: `/gateway/api/emoji/${cloudId}/${emojiUri}/path?scale=MDPI`
            }));
        }
    }, [
        cloudId,
        emojiName,
        emojiProvider
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $23fd05e7d06ef6ea$var$styles.inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8YHJ2.CardSSR), {
        appearance: "inline",
        url: url,
        ui: placeholderData ? $23fd05e7d06ef6ea$var$uiOptionsWithPlaceholder : $23fd05e7d06ef6ea$var$uiOptions,
        actionOptions: $23fd05e7d06ef6ea$var$actionOptions,
        showHoverPreview: showHoverPreview,
        onError: onError,
        onResolve: onResolve,
        placeholderData: placeholderData,
        hoverPreviewOptions: hoverPreviewOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fqBfo.default), {
        hideTitleTooltip: true,
        maxLines: 1,
        metadata: metadata,
        anchorTarget: anchorTarget ?? '_self',
        text: text,
        icon: icon || emoji,
        anchorRef: anchorRef,
        position: position,
        actions: actions,
        hideRetry: hideRetry,
        hideIconLoadingSkeleton: !!placeholderData,
        className: (0, $hcewu.default)([
            $23fd05e7d06ef6ea$var$styles.titleBlockStyles
        ])
    })));
};

});
parcelRegister("dV1IY", function(module, exports) {
$parcel$export(module.exports, "getEmojiProvider", () => $9a75dbe340213ba1$export$8210f5f78c0bcf27);
$parcel$export(module.exports, "getEmojiProviderWithCustomEmoji", () => $9a75dbe340213ba1$export$f9c5a1e85ff0cb72);
$parcel$export(module.exports, "getEmojiProviderWithCustomEmojiUploadDisabled", () => $9a75dbe340213ba1$export$7cda0fc535c2710f);
$parcel$export(module.exports, "fetchEmojiProvider", () => $9a75dbe340213ba1$export$12c2b0bd175ad5c1);

var $53MhD = parcelRequire("53MhD");

var $kFrAe = parcelRequire("kFrAe");
const $9a75dbe340213ba1$var$baseProviders = (serviceBaseUrl)=>[
        {
            url: `${serviceBaseUrl}/emoji/standard`
        },
        {
            url: `${serviceBaseUrl}/emoji/atlassian`
        }
    ];
const $9a75dbe340213ba1$export$8210f5f78c0bcf27 = ()=>(0, $kFrAe.getServiceProvider)((0, $kFrAe.EMOJI_SERVICEID), (serviceBaseUrl)=>{
        const emojiResource = new (0, $53MhD.default)({
            providers: $9a75dbe340213ba1$var$baseProviders(serviceBaseUrl)
        });
        return emojiResource.getEmojiProvider();
    });
const $9a75dbe340213ba1$export$f9c5a1e85ff0cb72 = (cloudId, accountId, // fetchAtStart allows you to delay emoji fetching
// however, if it is used in an editor, remember to call `fetchEmojiProvider` on mount
// because typing `:` does not trigger emoji fetching
fetchAtStart = true)=>(0, $kFrAe.getServiceProvider)((0, $kFrAe.EMOJI_WITH_CUSTOM_SERVICEID), (serviceBaseUrl)=>{
        const providers = cloudId ? [
            ...$9a75dbe340213ba1$var$baseProviders(serviceBaseUrl),
            {
                url: `${serviceBaseUrl}/emoji/${cloudId}/site`
            }
        ] : $9a75dbe340213ba1$var$baseProviders(serviceBaseUrl);
        const emojiResource = new (0, $53MhD.default)({
            providers: providers,
            allowUpload: true,
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            currentUser: {
                id: accountId
            }
        });
        return emojiResource.getEmojiProvider({
            fetchAtStart: fetchAtStart
        });
    });
const $9a75dbe340213ba1$export$7cda0fc535c2710f = (cloudId, accountId, // fetchAtStart allows you to delay emoji fetching
// however, if it is used in an editor, remember to call `fetchEmojiProvider` on mount
// because typing `:` does not trigger emoji fetching
fetchAtStart = true)=>(0, $kFrAe.getServiceProvider)((0, $kFrAe.EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID), (serviceBaseUrl)=>{
        const providers = cloudId ? [
            ...$9a75dbe340213ba1$var$baseProviders(serviceBaseUrl),
            {
                url: `${serviceBaseUrl}/emoji/${cloudId}/site`
            }
        ] : $9a75dbe340213ba1$var$baseProviders(serviceBaseUrl);
        const emojiResource = new (0, $53MhD.default)({
            providers: providers,
            allowUpload: false,
            // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string'.
            currentUser: {
                id: accountId
            }
        });
        return emojiResource.getEmojiProvider({
            fetchAtStart: fetchAtStart
        });
    });
const $9a75dbe340213ba1$export$12c2b0bd175ad5c1 = async (emojiProviderPromise)=>{
    (await emojiProviderPromise)?.fetchEmojiProvider();
};

});
parcelRegister("kFrAe", function(module, exports) {
$parcel$export(module.exports, "EMOJI_SERVICEID", () => $041d4deb698c5fda$export$f3c4ed49c0fff3de);
$parcel$export(module.exports, "EMOJI_WITH_CUSTOM_SERVICEID", () => $041d4deb698c5fda$export$f8b39b441e3e8eb2);
$parcel$export(module.exports, "EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID", () => $041d4deb698c5fda$export$2cdcb9248b6d4704);
$parcel$export(module.exports, "getServiceProvider", () => $041d4deb698c5fda$export$a4c27db78169052e);
$parcel$export(module.exports, "default", () => $041d4deb698c5fda$export$2e2bcd8739ae039);

var $hWeHP = parcelRequire("hWeHP");
const $041d4deb698c5fda$var$providersRepository = {};
const $041d4deb698c5fda$export$f3c4ed49c0fff3de = 'emoji';
const $041d4deb698c5fda$export$f8b39b441e3e8eb2 = 'emoji-with-custom';
const $041d4deb698c5fda$export$2cdcb9248b6d4704 = 'emoji-with-custom-upload-disabled';
const $041d4deb698c5fda$var$getServiceBaseUrl = (serviceId)=>{
    if (serviceId === $041d4deb698c5fda$export$f8b39b441e3e8eb2 || serviceId === $041d4deb698c5fda$export$2cdcb9248b6d4704) return (0, $hWeHP.default)('ajs-fabric-emoji-url');
    return (0, $hWeHP.default)(`ajs-fabric-${serviceId}-url`);
};
const $041d4deb698c5fda$export$a4c27db78169052e = (serviceId, serviceProviderGenerator)=>{
    try {
        let serviceProvider = $041d4deb698c5fda$var$providersRepository[serviceId];
        if (serviceProvider === undefined) {
            const serviceBaseUrl = $041d4deb698c5fda$var$getServiceBaseUrl(serviceId);
            if (serviceBaseUrl) {
                serviceProvider = Promise.resolve(serviceProviderGenerator(serviceBaseUrl));
                $041d4deb698c5fda$var$providersRepository[serviceId] = serviceProvider;
            }
        }
        return serviceProvider;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
};
const $041d4deb698c5fda$export$59790759c19337ec = ()=>{
    Object.keys($041d4deb698c5fda$var$providersRepository).forEach((key)=>{
        delete $041d4deb698c5fda$var$providersRepository[key];
    });
};
var $041d4deb698c5fda$export$2e2bcd8739ae039 = $041d4deb698c5fda$var$getServiceBaseUrl;

});


parcelRegister("7Lq4F", function(module, exports) {
$parcel$export(module.exports, "generatePlaceholderData", () => $b7ec6bb16f1d2c5a$export$5d49eb8909604ac1);
const $b7ec6bb16f1d2c5a$export$5d49eb8909604ac1 = (url, restrictedName, name)=>{
    return {
        meta: {
            auth: [],
            definitionId: 'watermelon-object-provider',
            product: 'townsquare',
            visibility: 'restricted',
            access: 'granted',
            key: 'watermelon-object-provider'
        },
        data: {
            '@context': {
                '@vocab': 'https://www.w3.org/ns/activitystreams#',
                atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
                schema: 'http://schema.org/'
            },
            generator: {
                '@type': 'Application',
                '@id': 'https://www.atlassian.com/#TeamCentral',
                name: 'Projects'
            },
            '@type': [
                'Object',
                'atlassian:Project'
            ],
            url: url,
            name: name || restrictedName
        }
    };
};

});


parcelRegister("lX89l", function(module, exports) {
$parcel$export(module.exports, "CommonInlineSmartLink", () => $9c0068c39f34cd38$export$d1b440fe4331a59c);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $3PRLs = parcelRequire("3PRLs");

var $aJTdT = parcelRequire("aJTdT");

var $7Lq4F = parcelRequire("7Lq4F");
const $9c0068c39f34cd38$export$d1b440fe4331a59c = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { url: url, text: text } = props;
    const placeholderData = (0, $eJOHy.useMemo)(()=>{
        if (!url) return undefined;
        return (0, $7Lq4F.generatePlaceholderData)(url, formatMessage((0, $aJTdT.default).restrictedProject), text);
    }, [
        formatMessage,
        text,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3PRLs.SimpleInlineSmartLink), {
        ...props,
        isSimplifiedUI: true,
        placeholderData: placeholderData
    });
};

});


parcelRegister("fRm4z", function(module, exports) {
$parcel$export(module.exports, "useProjectUrlConstructor", () => $80656e7520d9f842$export$b90dbdb6cfc4b7d0);

var $eJOHy = parcelRequire("eJOHy");

var $g9Vr6 = parcelRequire("g9Vr6");

var $kyq27 = parcelRequire("kyq27");

var $8rl2J = parcelRequire("8rl2J");

const $80656e7520d9f842$export$b90dbdb6cfc4b7d0 = ()=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const isStagingOrDevOrLocal = (0, $kyq27.useIsStagingOrDevOrLocal)();
    return (0, $eJOHy.useCallback)(({ ari: ari, projectKey: projectKey })=>{
        const atlassianHomeUrl = isStagingOrDevOrLocal ? (0, $3bc23e8d20cc37b7$export$46b5a4e5fbe6e304) : (0, $3bc23e8d20cc37b7$export$732915c664dff395);
        const siteId = (0, $8rl2J.TownsquareProjectAri).parse(ari).siteId;
        return `${atlassianHomeUrl}/o/${orgId}/s/${siteId}/project/${projectKey}`;
    }, [
        isStagingOrDevOrLocal,
        orgId
    ]);
};
const $80656e7520d9f842$export$9cce062687913114 = (url)=>url.split('/').pop();

});
const $3bc23e8d20cc37b7$export$732915c664dff395 = 'https://home.atlassian.com';
const $3bc23e8d20cc37b7$export$46b5a4e5fbe6e304 = 'https://home.stg.atlassian.com';


parcelRegister("bCxCS", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac2994246833a05e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ac2994246833a05e$var$messages = (0, $7qGN1.defineMessages)({
    noAtlasProjectDisplayName: {
        "id": "ui.groupHeader.atlasProjectGroupHeader.noAtlasProjectDisplayName",
        "defaultMessage": "No project"
    }
});
var $ac2994246833a05e$export$2e2bcd8739ae039 = $ac2994246833a05e$var$messages;

});




parcelRegister("cgCO4", function(module, exports) {
$parcel$export(module.exports, "useShouldApplyFrozenColumns", () => $b2dad0224ea212bd$export$26a13b614880b279);

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");

var $7n9BS = parcelRequire("7n9BS");

var $8jOO7 = parcelRequire("8jOO7");
const $b2dad0224ea212bd$export$26a13b614880b279 = ()=>{
    if (!(0, $4cTDP.fg)('issue_table_frozen_columns')) return {
        isStickyColumnsVisible: false,
        isSmallScreen: false
    };
    // eslint-disable-next-line  react-hooks/rules-of-hooks
    const isAutoUnstickyOnSmallScreenEnabled = (0, $34oCh.useIsAutoUnstickyOnSmallScreenEnabled)();
    // eslint-disable-next-line  react-hooks/rules-of-hooks
    const { hasScrolled: hasScrolled, tableWidth: tableWidth } = (0, $7n9BS.useScrollStateSelector)((state)=>({
            hasScrolled: state.hasScrolled,
            tableWidth: state.width
        }));
    const isSmallScreen = isAutoUnstickyOnSmallScreenEnabled && tableWidth < (0, $8jOO7.SMALL_TABLE_WIDTH) && tableWidth !== 0;
    // eslint-disable-next-line  react-hooks/rules-of-hooks
    let isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
    if (isStickyColumnsVisible) isStickyColumnsVisible = hasScrolled ? !isSmallScreen : true;
    return {
        isStickyColumnsVisible: isStickyColumnsVisible,
        isSmallScreen: isSmallScreen
    };
};

});

parcelRegister("1q3Q0", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ef615d8a7f688f1$export$2e2bcd8739ae039);

var $6Ya8m = parcelRequire("6Ya8m");

var $g5la6 = parcelRequire("g5la6");

var $29Yve = parcelRequire("29Yve");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $68iTT = parcelRequire("68iTT");

var $kGj4V = parcelRequire("kGj4V");

var $2ApNu = parcelRequire("2ApNu");

var $jBNts = parcelRequire("jBNts");

var $6d9QY = parcelRequire("6d9QY");

var $jE8Tu = parcelRequire("jE8Tu");

var $bJscI = parcelRequire("bJscI");

var $cgCO4 = parcelRequire("cgCO4");

var $aqT6C = parcelRequire("aqT6C");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $4ukXD = parcelRequire("4ukXD");

var $f9D6R = parcelRequire("f9D6R");

var $jNv5I = parcelRequire("jNv5I");

var $km3XC = parcelRequire("km3XC");
const $7ef615d8a7f688f1$var$HierarchyRow = /*#__PURE__*/ (0, $eJOHy.memo)(({ project: project, depth: depth, itemsConnectionId: itemsConnectionId, rankFieldId: rankFieldId, parentItemConnectionId: parentItemConnectionId, parentIssueAri: parentIssueAri, parentIssueHierarchyLevel: parentIssueHierarchyLevel, rowsData: rowsData, index: index, isVirtual: isVirtual, isIssueHierarchyEnabled: isIssueHierarchyEnabled, measureElement: measureElement, projectKey: projectKey, previousItemId: previousItemId, isDraggingRowFaded: isDraggingRowFaded, isStickyColumnsVisible: isStickyColumnsVisible, formattingRules: formattingRules, rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields, topLevelIssueCreateConfig: topLevelIssueCreateConfig })=>{
    const issueRow = rowsData?.edges?.[index];
    const hierarchyLevel = issueRow?.node?.issueTypeField?.issueType?.hierarchy?.level;
    const { renderChildRows: renderChildRows } = (0, $jNv5I.useRowContext)();
    const { isFormVisible: isFormVisible, formProps: formProps, triggerProps: triggerProps } = (0, $68iTT.useInlineCreateHandlers)({
        projectKey: (0, $34oCh.useProjectContext)(),
        ...hierarchyLevel != null && {
            minHierarchyLevel: hierarchyLevel - 1,
            maxHierarchyLevel: hierarchyLevel - 1
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: {
            rowIndex: index,
            tableRowNumber: index,
            ...(0, $4cTDP.fg)('timeline-issue-table-additional-analytics') && {
                issueId: issueRow?.node?.issueId,
                parentId: parentIssueAri ? (0, $2ApNu.JiraIssueAri).parse(parentIssueAri).issueId : undefined,
                issueHierarchy: hierarchyLevel
            }
        }
    }, isVirtual && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ukXD.default), {
        project: project,
        rankFieldId: rankFieldId,
        rowIndex: index,
        itemsConnectionId: rowsData.__id,
        issueEdge: issueRow ?? null,
        fieldSets: issueRow?.fieldSets ?? null,
        depth: depth,
        parentIssueAri: parentIssueAri,
        parentItemConnectionId: parentItemConnectionId,
        parentIssueRelayConnectionId: itemsConnectionId,
        parentIssueHierarchyLevel: parentIssueHierarchyLevel,
        triggerProps: triggerProps,
        isFormVisible: isFormVisible,
        measureElement: measureElement,
        previousItemId: previousItemId,
        isDraggingRowFaded: isDraggingRowFaded,
        isStickyColumnsVisible: isStickyColumnsVisible,
        formattingRules: formattingRules,
        topLevelIssueCreateConfig: topLevelIssueCreateConfig,
        rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
        ...(0, $4cTDP.fg)('jsc_list_reparenting') ? {
            hierarchyLevel: hierarchyLevel,
            issueKey: issueRow?.node?.key,
            projectKey: projectKey
        } : {}
    }), issueRow?.node?.issueId && isIssueHierarchyEnabled && renderChildRows?.({
        issueKey: issueRow?.node?.key,
        parentItemId: issueRow?.node?.issueId,
        itemsConnectionId: rowsData.__id,
        depth: depth,
        parentIssueAri: issueRow?.node?.id,
        parentItemConnectionId: issueRow?.__id,
        parentIssueRelayConnectionId: itemsConnectionId,
        parentIssueHierarchyLevel: hierarchyLevel,
        type: 'PARENT_CHILDREN',
        isFormVisible: isFormVisible,
        formProps: formProps,
        hasChildren: issueRow?.hasChildren ?? false
    }));
});
const $7ef615d8a7f688f1$export$c0febbacdd540b37 = ({ project: project, projectKey: projectKey, issueResults: issueResults, rankFieldId: rankFieldId, depth: depth = 0, parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, parentIssueAri: parentIssueAri, parentItemConnectionId: parentItemConnectionId, parentIssueRelayConnectionId: parentIssueRelayConnectionId, parentIssueHierarchyLevel: parentIssueHierarchyLevel, isLoadingNext: isLoadingNext, hasNext: hasNext, isChildIssueCreateRowVisible: isChildIssueCreateRowVisible, onLoadNextItems: onLoadNextItems, renderChildIssueCreateRow: renderChildIssueCreateRow, isDraggingRowFaded: isDraggingRowFaded, formattingRules: formattingRules, groupContextFieldInput: groupContextFieldInput, rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields, topLevelIssueCreateConfig: topLevelIssueCreateConfig, initialPopulateConnectionArgs: initialPopulateConnectionArgs })=>{
    const rowsData = (0, $j4oe4.useFragment)((0, $29Yve.default), issueResults);
    const projectData = (0, $j4oe4.useFragment)((0, $g5la6.default), project ?? null);
    const formattingRulesData = (0, $j4oe4.useFragment)((0, $6Ya8m.default), formattingRules ?? null);
    const isIssueHierarchyEnabled = (0, $34oCh.useIsIssueHierarchyEnabled)();
    const { populateConnection: populateConnection } = (0, $jE8Tu.useHierarchyActions)();
    const { columns: columns, groupId: groupId } = (0, $jNv5I.useRowContext)();
    let isStickyColumnsVisible = false;
    if ((0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
    else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { isStickyColumnsVisible: isStickyColumnsVisibleOld } = (0, $cgCO4.useShouldApplyFrozenColumns)();
        isStickyColumnsVisible = isStickyColumnsVisibleOld;
    }
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const hasCheckboxColumn = columns.length > 0 && columns[0].id === (0, $8jOO7.COLUMN_ID_CHECKBOX);
    const populateConnectionArgs = (0, $eJOHy.useMemo)(()=>({
            parentItemId: parentItemId,
            itemsConnectionId: rowsData.__id,
            parentConnectionId: itemsConnectionId,
            list: rowsData?.edges?.map((edge)=>edge?.node && {
                    key: edge.node.key,
                    itemId: edge.node.issueId,
                    groupId: groupId
                }).filter(Boolean) ?? [],
            hasNext: hasNext,
            groupId: groupId,
            isChildIssueCreateRowVisible: isChildIssueCreateRowVisible
        }), [
        parentItemId,
        itemsConnectionId,
        rowsData.__id,
        rowsData?.edges,
        hasNext,
        groupId,
        isChildIssueCreateRowVisible
    ]);
    /*
   *  initialPopulateConnectionArgs is used to initialise the hierarchy store container for root connections, and will
   *  hence prevent calling populateConnection for root connections if the root connection matches populateConnectionArgs.
   *
   *  On initial load, Rows.tsx can be rendered as root connection for hierarchy on/off.
   *  However, for grouping, Rows.tsx is used to render the first group connection, which is difficult to initialise
   *  as there's a store-only lazy loaded query FirstGroupIssuesQuery we'd need to mimic to get the right itemsConnectionId.
   *  So for now, we'll allow populateConnection to proceed for the first group rows, which will cause later render.
   *
   *  If the connection arguments mismatch for any reason, we gracefully populateConnection, but will pay a render interruption penalty.
   */ const prevPopulateConnectArgs = (0, $6d9QY.usePrevious)(populateConnectionArgs) ?? // eslint-disable-next-line jira/ff/no-preconditioning
    ((0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store') && initialPopulateConnectionArgs ? initialPopulateConnectionArgs.find((args)=>args.parentItemId === 'root') : undefined);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(populateConnectionArgs, prevPopulateConnectArgs)) populateConnection(populateConnectionArgs);
    const renderRowItem = (0, $eJOHy.useCallback)((index, measureElement)=>{
        const issueRow = rowsData?.edges?.[index];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
            key: issueRow?.node?.key || index,
            attributes: {
                rowIndex: index,
                tableRowNumber: index,
                ...(0, $4cTDP.fg)('timeline-issue-table-additional-analytics') && {
                    issueId: issueRow?.node?.issueId,
                    parentId: parentIssueAri ? (0, $2ApNu.JiraIssueAri).parse(parentIssueAri).issueId : undefined,
                    issueHierarchy: issueRow?.node?.issueTypeField?.issueType?.hierarchy?.level
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ukXD.default), {
            project: projectData,
            rowIndex: index,
            rankFieldId: rankFieldId,
            itemsConnectionId: rowsData.__id,
            issueEdge: issueRow ?? null,
            fieldSets: issueRow?.fieldSets ?? null,
            depth: depth,
            parentIssueAri: parentIssueAri,
            parentItemConnectionId: parentItemConnectionId,
            parentIssueRelayConnectionId: parentIssueRelayConnectionId,
            parentIssueHierarchyLevel: parentIssueHierarchyLevel,
            measureElement: measureElement,
            isDraggingRowFaded: isDraggingRowFaded,
            isStickyColumnsVisible: isStickyColumnsVisible,
            formattingRules: formattingRulesData,
            ...(0, $4cTDP.fg)('jsc_list_reparenting') ? {
                projectKey: projectKey,
                issueKey: issueRow?.node?.key
            } : {},
            ...(0, $4cTDP.fg)('group_by_any_field_sibling_inline_issue_create') && {
                groupContextFieldInput: groupContextFieldInput
            },
            rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields
        }));
    }, [
        rowsData?.edges,
        rowsData.__id,
        projectData,
        rankFieldId,
        depth,
        parentIssueAri,
        parentItemConnectionId,
        parentIssueRelayConnectionId,
        parentIssueHierarchyLevel,
        isDraggingRowFaded,
        isStickyColumnsVisible,
        formattingRulesData,
        projectKey,
        groupContextFieldInput,
        rowInlineCreateCanShowAdditionalFields
    ]);
    const renderRows = (0, $eJOHy.useCallback)((isItemVirtual, measureElement)=>{
        const childIssueCreateItemId = (0, $jBNts.getFlatListKey)({
            itemId: (0, $jE8Tu.getChildIssueCreateItemKey)(parentItemId),
            groupId: groupId
        });
        const isChildIssueCreateRowVirtual = isItemVirtual?.(childIssueCreateItemId) ?? true;
        const showMoreItemId = (0, $jBNts.getFlatListKey)({
            itemId: (0, $jE8Tu.getShowMoreItemKey)(parentItemId),
            groupId: groupId
        });
        const isShowMoreItemVirtual = isItemVirtual?.(showMoreItemId) ?? true;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isChildIssueCreateRowVirtual && renderChildIssueCreateRow?.(), rowsData?.edges?.map((edge, index)=>{
            const flatListIssueId = (0, $jBNts.getFlatListKey)({
                itemId: edge?.node?.issueId ?? '',
                groupId: groupId
            });
            let isVirtual = isItemVirtual?.(flatListIssueId) ?? true;
            // we're using row index as virtualisation key fallback when flatList is empty
            // hence the check includes both itemId and index to avoid rows flickering on transition
            if ((0, $4cTDP.fg)('jira_list_isvirtual_by_index')) isVirtual = (isItemVirtual?.(flatListIssueId) || isItemVirtual?.(`${index}`)) ?? true;
            const previousItemId = index > 0 && (0, $4cTDP.fg)('jira_timeline_cell_border_style') ? rowsData?.edges?.[index - 1]?.node?.issueId : undefined;
            return isIssueHierarchyEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef615d8a7f688f1$var$HierarchyRow, {
                project: projectData,
                key: flatListIssueId,
                rankFieldId: rankFieldId,
                itemsConnectionId: itemsConnectionId,
                isVirtual: isVirtual,
                index: index,
                rowsData: rowsData,
                depth: depth,
                parentItemConnectionId: parentItemConnectionId ?? '',
                parentIssueAri: parentIssueAri ?? '',
                parentIssueHierarchyLevel: parentIssueHierarchyLevel,
                isIssueHierarchyEnabled: isIssueHierarchyEnabled,
                measureElement: measureElement,
                projectKey: projectKey,
                previousItemId: previousItemId,
                isDraggingRowFaded: isDraggingRowFaded,
                isStickyColumnsVisible: isStickyColumnsVisible,
                formattingRules: formattingRulesData,
                rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
                topLevelIssueCreateConfig: topLevelIssueCreateConfig
            }) : isVirtual && renderRowItem(index, measureElement);
        }), hasNext && isShowMoreItemVirtual && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aqT6C.default), {
            isLoadingNext: isLoadingNext,
            columnsCount: columns.length,
            loadNext: onLoadNextItems ?? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            isStickyColumnsVisible: isStickyColumnsVisible,
            ...isTimelineEnabled || (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_issue_table_updates') ? {
                hasCheckboxColumn: hasCheckboxColumn
            } : {}
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9D6R.RowsAdditionalContentRenderer), {
            depth: depth,
            groupId: groupId,
            issues: rowsData
        }));
    }, [
        parentItemId,
        groupId,
        renderChildIssueCreateRow,
        rowsData,
        hasNext,
        isLoadingNext,
        columns.length,
        onLoadNextItems,
        isStickyColumnsVisible,
        isTimelineEnabled,
        hasCheckboxColumn,
        depth,
        isIssueHierarchyEnabled,
        projectData,
        rankFieldId,
        itemsConnectionId,
        parentItemConnectionId,
        parentIssueAri,
        parentIssueHierarchyLevel,
        projectKey,
        isDraggingRowFaded,
        formattingRulesData,
        rowInlineCreateCanShowAdditionalFields,
        topLevelIssueCreateConfig,
        renderRowItem
    ]);
    const isVirtualizationEnabled = (0, $34oCh.useIsVirtualizationEnabled)();
    if (isVirtualizationEnabled) {
        const isGrouping = Boolean(groupId);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $km3XC.VirtualizedRows), {
            hasSpacers: depth === 0 && !isGrouping,
            columnsCount: columns.length
        }, renderRows);
    }
    return renderRows();
};
const $7ef615d8a7f688f1$var$Rows = (0, $bJscI.componentWithFG)('memoise_issuetable_components', /*#__PURE__*/ (0, $eJOHy.memo)($7ef615d8a7f688f1$export$c0febbacdd540b37), $7ef615d8a7f688f1$export$c0febbacdd540b37);
var $7ef615d8a7f688f1$export$2e2bcd8739ae039 = $7ef615d8a7f688f1$var$Rows;

});
parcelRegister("6Ya8m", function(module, exports) {
$parcel$export(module.exports, "default", () => $4655d78eca486378$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fa34ba6f472e0b8148f1264eff626129>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4655d78eca486378$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Rows_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Row_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$4655d78eca486378$var$node.hash = "b4b335939ad75aad9e255c08b8521ec5";
var $4655d78eca486378$export$2e2bcd8739ae039 = $4655d78eca486378$var$node;

});

parcelRegister("g5la6", function(module, exports) {
$parcel$export(module.exports, "default", () => $69892f039c803b93$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b512891704b7282f1fa80d7a954947f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $69892f039c803b93$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "Rows_project",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "Row_project"
        }
    ],
    "type": "JiraProject"
};
$69892f039c803b93$var$node.hash = "6529dd7b2cd4ebb69d9c7a29ad22a15d";
var $69892f039c803b93$export$2e2bcd8739ae039 = $69892f039c803b93$var$node;

});

parcelRegister("29Yve", function(module, exports) {
$parcel$export(module.exports, "default", () => $7049a42f4e36051e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dcb239721bc32add0f4fa291fb4cf3b7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7049a42f4e36051e$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "isDensityFull",
        "variableName": "isDensityFull"
    }, v1 = {
        "kind": "Variable",
        "name": "isLinkRelationshipFieldEnabled",
        "variableName": "isLinkRelationshipFieldEnabled"
    }, v2 = {
        "kind": "Variable",
        "name": "isTimelineEnabled",
        "variableName": "isTimelineEnabled"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isEditableSyncLoaded"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isRemoteLinkedIssuesEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "Rows",
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "args": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ ,
                            {
                                "kind": "Variable",
                                "name": "isRemoteLinkedIssuesEnabled",
                                "variableName": "isRemoteLinkedIssuesEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "isReparentingEnabled",
                                "variableName": "isReparentingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            },
                            {
                                "kind": "Variable",
                                "name": "shouldQueryHasChildren",
                                "variableName": "shouldQueryHasChildren"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "Row_issueEdge"
                    },
                    {
                        "condition": "shouldQueryHasChildren",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "filterByProjectKeys",
                                        "variableName": "projectKeys"
                                    }
                                ],
                                "kind": "ScalarField",
                                "name": "hasChildren"
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "id"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "issueId"
                            },
                            {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueTypeHierarchyLevel",
                                                "kind": "LinkedField",
                                                "name": "hierarchy",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "level"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 500
                            }
                        ],
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "isConditionalFormattingEnabled",
                                        "variableName": "isConditionalFormattingEnabled"
                                    },
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "isEditableSyncLoaded",
                                        "variableName": "isEditableSyncLoaded"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isInlineEditingEnabled",
                                        "variableName": "isInlineEditingEnabled"
                                    },
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ 
                                ],
                                "kind": "FragmentSpread",
                                "name": "Row_fieldSets"
                            }
                        ],
                        "storageKey": "fieldSets(first:500)"
                    },
                    v3 /*: any*/ 
                ]
            },
            {
                "args": [
                    v2 /*: any*/ 
                ],
                "kind": "FragmentSpread",
                "name": "RowsAdditionalContentRenderer"
            },
            v3 /*: any*/ 
        ],
        "type": "JiraIssueConnection"
    };
}();
$7049a42f4e36051e$var$node.hash = "5fe1f1794b2f08dfbbbf913d2d4839d2";
var $7049a42f4e36051e$export$2e2bcd8739ae039 = $7049a42f4e36051e$var$node;

});

parcelRegister("aqT6C", function(module, exports) {
$parcel$export(module.exports, "default", () => $1118dff792cb08d1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $bJscI = parcelRequire("bJscI");

var $bKlUQ = parcelRequire("bKlUQ");

var $34oCh = parcelRequire("34oCh");

var $aIvQb = parcelRequire("aIvQb");
const $1118dff792cb08d1$var$ROW_HEIGHT = 40;
const $1118dff792cb08d1$export$68a5941629c7f57a = ({ loadNext: loadNext, isLoadingNext: isLoadingNext = false, columnsCount: columnsCount, isStickyColumnsVisible: isStickyColumnsVisible, hasCheckboxColumn: hasCheckboxColumn })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cellBorderStyle = (0, $34oCh.useCellBorderStyle)();
    let isAutoUnstickyOnSmallScreenEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) // eslint-disable-next-line  react-hooks/rules-of-hooks
    isAutoUnstickyOnSmallScreenEnabled = (0, $34oCh.useIsAutoUnstickyOnSmallScreenEnabled)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        spacing: "compact",
        isDisabled: isLoadingNext,
        onClick: loadNext
    }, isLoadingNext ? formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $aIvQb.default).loadingMoreItemsIssueTermRefresh : (0, $aIvQb.default).loadingMoreItems) : formatMessage((0, $aIvQb.default).showMore));
    const cellBorderStyles = (0, $eJOHy.useMemo)(()=>{
        return (0, $4cTDP.fg)('jira_timeline_cell_border_style') ? [
            (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $1118dff792cb08d1$var$baseCellBorderStylesRTL : $1118dff792cb08d1$var$baseCellBorderStyles,
            (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $1118dff792cb08d1$var$cellBorderLocationStyleMap[cellBorderStyle] : $1118dff792cb08d1$var$cellBorderLocationStyleMapOld[cellBorderStyle]
        ] : [
            $1118dff792cb08d1$var$cellBorderStylesOld
        ];
    }, [
        cellBorderStyle
    ]);
    const isColumnSticky = isStickyColumnsVisible && (0, $4cTDP.fg)('issue_table_frozen_columns');
    const stickyButton = (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "native-issue-table.common.ui.load-more-items-row.load-more-wrapper",
        xcss: // eslint-disable-next-line no-nested-ternary
        (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? isAutoUnstickyOnSmallScreenEnabled ? $1118dff792cb08d1$var$stickyContainerResponsiveStylesRTL : $1118dff792cb08d1$var$stickyContainerStylesRTL : $1118dff792cb08d1$var$stickyContainerStylesOldRTL
    }, button) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "native-issue-table.common.ui.load-more-items-row.load-more-wrapper",
        xcss: // eslint-disable-next-line no-nested-ternary
        (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? isAutoUnstickyOnSmallScreenEnabled ? $1118dff792cb08d1$var$stickyContainerResponsiveStyles : $1118dff792cb08d1$var$stickyContainerStyles : $1118dff792cb08d1$var$stickyContainerStylesOld
    }, button);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "tr",
        xcss: $1118dff792cb08d1$var$rowStyles
    }, isColumnSticky && hasCheckboxColumn === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        hasRightShadow: true,
        spacing: $1118dff792cb08d1$var$firstColumnSpacingStyles,
        border: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $1118dff792cb08d1$var$firstColumnBorderStyles : $1118dff792cb08d1$var$firstColumnBorderStylesOld,
        isColumnSticky: isColumnSticky
    }, stickyButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        border: cellBorderStyles,
        isColumnSticky: isColumnSticky
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        border: cellBorderStyles,
        colSpan: columnsCount
    }, isColumnSticky ? stickyButton : button)));
};
const $1118dff792cb08d1$var$LoadMoreItemsRow = (0, $bJscI.componentWithFG)('memoise_issuetable_components', /*#__PURE__*/ (0, $eJOHy.memo)($1118dff792cb08d1$export$68a5941629c7f57a), $1118dff792cb08d1$export$68a5941629c7f57a);
var $1118dff792cb08d1$export$2e2bcd8739ae039 = $1118dff792cb08d1$var$LoadMoreItemsRow;
const $1118dff792cb08d1$var$rowStyles = (0, $1DXK0.xcss)({
    height: `${$1118dff792cb08d1$var$ROW_HEIGHT}px`,
    backgroundColor: 'elevation.surface'
});
// TODO: Remove this with cleanup of jira_timeline_cell_border_style
const $1118dff792cb08d1$var$cellBorderStylesOld = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderBottomWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderLeftWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightWidth: '0'
});
const $1118dff792cb08d1$var$baseCellBorderStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderBottomWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderLeftWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightWidth: '0'
});
const $1118dff792cb08d1$var$baseCellBorderStylesRTL = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderBlockEndWidth: '0',
    borderInlineStartWidth: '0',
    borderInlineEndWidth: '0'
});
const $1118dff792cb08d1$var$topCellBorderStylesOld = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: 'border.width'
});
const $1118dff792cb08d1$var$topCellBorderStyles = (0, $1DXK0.xcss)({
    borderBlockStartWidth: 'border.width'
});
const $1118dff792cb08d1$var$noRowCellBorderStylesOld = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: '0'
});
const $1118dff792cb08d1$var$noRowCellBorderStyles = (0, $1DXK0.xcss)({
    borderBlockStartWidth: '0'
});
const $1118dff792cb08d1$var$cellBorderLocationStyleMapOld = {
    FULL_BORDER: $1118dff792cb08d1$var$topCellBorderStylesOld,
    NO_COLUMN_BORDER: $1118dff792cb08d1$var$topCellBorderStylesOld,
    ROW_BORDER_FOR_EXPANDED_TOP_LEVEL_ONLY: $1118dff792cb08d1$var$noRowCellBorderStylesOld
};
const $1118dff792cb08d1$var$cellBorderLocationStyleMap = {
    FULL_BORDER: $1118dff792cb08d1$var$topCellBorderStyles,
    NO_COLUMN_BORDER: $1118dff792cb08d1$var$topCellBorderStyles,
    ROW_BORDER_FOR_EXPANDED_TOP_LEVEL_ONLY: $1118dff792cb08d1$var$noRowCellBorderStyles
};
const $1118dff792cb08d1$var$stickyContainerStylesOld = (0, $1DXK0.xcss)({
    position: 'sticky',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.600',
    width: 'fit-content'
});
const $1118dff792cb08d1$var$stickyContainerStylesOldRTL = (0, $1DXK0.xcss)({
    position: 'sticky',
    insetInlineStart: 'space.600',
    width: 'fit-content'
});
const $1118dff792cb08d1$var$stickyContainerStyles = (0, $1DXK0.xcss)({
    position: 'sticky',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.600',
    width: 'fit-content'
});
const $1118dff792cb08d1$var$stickyContainerStylesRTL = (0, $1DXK0.xcss)({
    position: 'sticky',
    insetInlineStart: 'space.600',
    width: 'fit-content'
});
const $1118dff792cb08d1$var$stickyContainerResponsiveStyles = (0, $1DXK0.xcss)({
    [(0, $6efFi.media).above.md]: {
        position: 'sticky',
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        left: 'space.600',
        width: 'fit-content'
    }
});
const $1118dff792cb08d1$var$stickyContainerResponsiveStylesRTL = (0, $1DXK0.xcss)({
    [(0, $6efFi.media).above.md]: {
        position: 'sticky',
        insetInlineStart: 'space.600',
        width: 'fit-content'
    }
});
const $1118dff792cb08d1$var$firstColumnSpacingStyles = (0, $1DXK0.xcss)({
    padding: '0'
});
const $1118dff792cb08d1$var$firstColumnBorderStylesOld = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightColor: 'color.border',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightStyle: 'solid',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightWidth: 'border.width'
});
const $1118dff792cb08d1$var$firstColumnBorderStyles = (0, $1DXK0.xcss)({
    borderInlineEndColor: 'color.border',
    borderInlineEndStyle: 'solid',
    borderInlineEndWidth: 'border.width'
});

});
parcelRegister("bKlUQ", function(module, exports) {
$parcel$export(module.exports, "TableCell", () => $939ec101f3206f90$export$1e4baea7053fc0e3);

var $eJOHy = parcelRequire("eJOHy");

var $buoPQ = parcelRequire("buoPQ");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $johMb = parcelRequire("johMb");

var $34oCh = parcelRequire("34oCh");

var $hHg7L = parcelRequire("hHg7L");

var $8jOO7 = parcelRequire("8jOO7");
const $939ec101f3206f90$export$1e4baea7053fc0e3 = ({ children: children, border: border, spacing: spacing, formatting: formatting, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, isColumnResizing: isColumnResizing, hasRightShadow: hasRightShadow, fieldId: fieldId, onFocusHandler: onFocusHandler, onBlurHandler: onBlurHandler, ...htmlAttributes })=>{
    const spacingStyles = spacing !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($buoPQ)))(spacing) : [
        (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $939ec101f3206f90$var$defaultSpacingStyles : $939ec101f3206f90$var$defaultSpacingStylesOld
    ];
    const borderStyles = border !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($buoPQ)))(border) : [];
    const formattingStyles = formatting !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($buoPQ)))(formatting) : [];
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const eventDelegatorRef = isSingleLineRowHeightEnabled ? (0, $hHg7L.useEventDelegatorRef)(fieldId) : null;
    let isAutoUnstickyOnSmallScreenEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isAutoUnstickyOnSmallScreenEnabled = (0, $34oCh.useIsAutoUnstickyOnSmallScreenEnabled)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const isConditionalFormattingEnabled = (0, $34oCh.useIsConditionalFormattingEnabled)();
    const stickyColumnZIndex = stickyOffsets === 0 ? (0, $8jOO7.Z_INDEX_STICKY_COLUMN) + 1 : (0, $8jOO7.Z_INDEX_STICKY_COLUMN);
    const stickyResponsiveStylesFG = (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $939ec101f3206f90$var$stickyResponsiveStyles : $939ec101f3206f90$var$stickyResponsiveStylesOld;
    const shadowResponsiveStylesFG = (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $939ec101f3206f90$var$shadowResponsiveStyles : $939ec101f3206f90$var$shadowResponsiveStylesOld;
    const shadowStylesFG = (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $939ec101f3206f90$var$shadowStylesNew : $939ec101f3206f90$var$shadowStyles;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "td",
        xcss: [
            $939ec101f3206f90$var$baseStyles,
            (0, $4cTDP.fg)('nin_issue_table_rtl_fix') && $939ec101f3206f90$var$textAlignInherit,
            ...spacingStyles,
            ...borderStyles,
            ...isConditionalFormattingEnabled ? formattingStyles : [],
            isGridNavigationEnabled && $939ec101f3206f90$var$keyboardNavigationStyles,
            // eslint-disable-next-line no-nested-ternary
            ...isColumnSticky && (0, $4cTDP.fg)('issue_table_frozen_columns') ? (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? [
                isAutoUnstickyOnSmallScreenEnabled ? stickyResponsiveStylesFG : $939ec101f3206f90$var$stickyStyles
            ] : [
                $939ec101f3206f90$var$stickyStylesOld
            ] : [],
            // eslint-disable-next-line no-nested-ternary
            ...hasRightShadow && (0, $4cTDP.fg)('issue_table_frozen_columns') ? (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? [
                isAutoUnstickyOnSmallScreenEnabled ? shadowResponsiveStylesFG : shadowStylesFG
            ] : [
                $939ec101f3206f90$var$shadowStylesOld
            ] : [],
            // eslint-disable-next-line no-nested-ternary
            ...isColumnSticky && (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? stickyOffsets === 0 ? [
                $939ec101f3206f90$var$stickyColumnZIndexFirst
            ] : [
                $939ec101f3206f90$var$stickyColumnZIndexBase
            ] : []
        ],
        ...htmlAttributes,
        ...isGridNavigationEnabled && {
            tabIndex: -1
        },
        ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
            style: {
                ...htmlAttributes.style,
                left: isColumnSticky ? (0, $johMb.getColumnOffset)(stickyOffsets ?? 0, !!isColumnResizing) : undefined,
                // Adjust zIndex for the first sticky column to ensure the inline create indicator line
                // is displayed above it. Previously, zIndex was 7 (greater than CHART_PREVIEW_BAR_Z_INDEX = 6).
                // Now, for the first column (stickyOffsets === 0), we set zIndex to 8.
                // This ensures the indicator line is not hidden behind the second sticky column,
                // whose zIndex remains lower (7).
                zIndex: isColumnSticky && !(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? stickyColumnZIndex : undefined,
                height: isTimelineEnabled ? `${0, $8jOO7.ROW_HEIGHT}px` : undefined
            }
        },
        ...eventDelegatorRef && {
            ref: eventDelegatorRef
        },
        ...onFocusHandler && (0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') ? {
            onFocus: onFocusHandler
        } : {},
        ...onBlurHandler && (0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') ? {
            onBlur: onBlurHandler
        } : {}
    }, children);
};
const $939ec101f3206f90$var$baseStyles = (0, $1DXK0.xcss)({
    background: 'inherit',
    // Cross-browser CSS hack to allow inline editable fields to fill the entire space of their `td`. The
    // preferred long-term solution is to adopt a flexbox layout, but until then, please do extensive
    // cross-browser testing before you update this rule.
    height: '100%',
    position: 'relative'
});
const $939ec101f3206f90$var$textAlignInherit = (0, $1DXK0.xcss)({
    textAlign: 'inherit'
});
// Sticky column z-index styles - only elevates to z-Index 9 on hover when profile card wrapper exists
// so that the profile card is positioned above the sticky column header
const $939ec101f3206f90$var$stickyColumnZIndexBase = (0, $1DXK0.xcss)({
    // @ts-expect-error - zIndex as number is valid but type doesn't allow it
    zIndex: 7,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':hover:has([data-vc*="profilecard-wrapper"])': {
        zIndex: 9
    },
    ':focus-within': {
        // @ts-expect-error - zIndex as number is valid but type doesn't allow it
        zIndex: 8
    }
});
// ZIndex is 8 so that it is above the stickyColumnZIndexBase which is 7
const $939ec101f3206f90$var$stickyColumnZIndexFirst = (0, $1DXK0.xcss)({
    // @ts-expect-error - zIndex as number is valid but type doesn't allow it
    zIndex: 8
});
const $939ec101f3206f90$var$keyboardNavigationStyles = (0, $1DXK0.xcss)({
    position: 'relative',
    ':focus': {
        outline: 'unset'
    },
    ':focus::before': {
        display: 'block',
        content: '" "',
        position: 'absolute',
        height: '100%',
        width: '100%',
        inset: '0px',
        borderColor: 'color.border.focused',
        borderWidth: 'border.width.focused',
        borderStyle: 'solid',
        boxSizing: 'border-box',
        pointerEvents: 'none'
    }
});
const $939ec101f3206f90$var$defaultSpacingStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        paddingInlineStart: 'space.100'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        paddingInlineEnd: 'space.100'
    }
});
const $939ec101f3206f90$var$defaultSpacingStylesOld = (0, $1DXK0.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        paddingLeft: 'space.100'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        paddingRight: 'space.100'
    }
});
const $939ec101f3206f90$var$stickyStyles = (0, $1DXK0.xcss)({
    position: 'sticky'
});
const $939ec101f3206f90$var$stickyResponsiveStyles = (0, $1DXK0.xcss)({
    position: 'sticky',
    // @ts-expect-error doesn't support media.md yet
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    [(0, $6efFi.media).below.md]: {
        insetInlineStart: '0 !important',
        position: 'relative'
    }
});
const $939ec101f3206f90$var$stickyResponsiveStylesOld = (0, $1DXK0.xcss)({
    position: 'sticky',
    // @ts-expect-error doesn't support media.md yet
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/design-system/no-physical-properties
    [(0, $6efFi.media).below.md]: {
        left: '0 !important',
        position: 'relative'
    }
});
const $939ec101f3206f90$var$stickyStylesOld = (0, $1DXK0.xcss)({
    position: 'sticky'
});
const $939ec101f3206f90$var$shadowStylesOld = (0, $1DXK0.xcss)({
    '::after': {
        height: '100%',
        width: '4px',
        content: "''",
        opacity: 0.5,
        transition: 'opacity 0.25s',
        background: 'linear-gradient(90deg, #0000001a 0%, #0000)',
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        right: '-5px',
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        top: 'space.0'
    }
});
const $939ec101f3206f90$var$shadowStylesNew = (0, $1DXK0.xcss)({
    '::after': {
        height: '100%',
        width: '4px',
        content: "''",
        opacity: 0.5,
        transition: 'opacity 0.25s',
        background: 'linear-gradient(90deg, #0000001a 0%, #0000)',
        position: 'absolute',
        insetInlineEnd: '-5px',
        insetBlockStart: 'space.0'
    }
});
const $939ec101f3206f90$var$shadowStyles = (0, $1DXK0.xcss)({
    '::after': {
        height: '100%',
        width: '4px',
        content: "''",
        opacity: 0.5,
        transition: 'opacity 0.25s',
        background: 'linear-gradient(90deg, #0000001a 0%, #0000)',
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        right: '-5px',
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        top: 'space.0'
    }
});
const $939ec101f3206f90$var$shadowResponsiveStyles = (0, $1DXK0.xcss)({
    [(0, $6efFi.media).above.md]: {
        '::after': {
            height: '100%',
            width: '4px',
            content: "''",
            opacity: 0.5,
            transition: 'opacity 0.25s',
            background: 'linear-gradient(90deg, #0000001a 0%, #0000)',
            position: 'absolute',
            insetInlineEnd: '-5px',
            insetBlockStart: 'space.0'
        }
    }
});
const $939ec101f3206f90$var$shadowResponsiveStylesOld = (0, $1DXK0.xcss)({
    [(0, $6efFi.media).above.md]: {
        '::after': {
            height: '100%',
            width: '4px',
            content: "''",
            opacity: 0.5,
            transition: 'opacity 0.25s',
            background: 'linear-gradient(90deg, #0000001a 0%, #0000)',
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
            right: '-5px',
            // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
            top: 'space.0'
        }
    }
});

});
parcelRegister("johMb", function(module, exports) {
$parcel$export(module.exports, "getExpandColumnWidth", () => $20ef55c956fe2fc8$export$6344c84966147aa0);
$parcel$export(module.exports, "getColumnOffset", () => $20ef55c956fe2fc8$export$3e2d9135e2882f1d);

var $8jOO7 = parcelRequire("8jOO7");
const $20ef55c956fe2fc8$export$6344c84966147aa0 = (depth)=>depth * (0, $8jOO7.DEPTH_WIDTH) + (0, $8jOO7.EXPAND_BUTTON_WIDTH) + (0, $8jOO7.CREATE_CHILD_BUTTON_WIDTH) + (0, $8jOO7.EXPAND_CELL_PADDING);
const $20ef55c956fe2fc8$export$3e2d9135e2882f1d = (stickyOffsets, isResizing)=>{
    if (isResizing) return `calc(${stickyOffsets}px + var(--local-resizing-offset, 0px))`;
    return `${stickyOffsets}px`;
};

});


parcelRegister("aIvQb", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7f7f80423ad6969$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a7f7f80423ad6969$var$messages = (0, $7qGN1.defineMessages)({
    showMore: {
        "id": "native-issue-table.common.load-more-items-row.show-more",
        "defaultMessage": "Show more"
    },
    loadingMoreItems: {
        "id": "native-issue-table.common.load-more-items-row.loading-more-items",
        "defaultMessage": "Loading more issues"
    },
    loadingMoreItemsIssueTermRefresh: {
        "id": "native-issue-table.common.load-more-items-row.loading-more-items-issue-term-refresh",
        "defaultMessage": "Loading more"
    }
});
var $a7f7f80423ad6969$export$2e2bcd8739ae039 = $a7f7f80423ad6969$var$messages;

});


parcelRegister("4ukXD", function(module, exports) {
$parcel$export(module.exports, "default", () => $27642a2bda62ee3e$export$2e2bcd8739ae039);

var $dNMQL = parcelRequire("dNMQL");

var $8wuJw = parcelRequire("8wuJw");

var $l5gzh = parcelRequire("l5gzh");

var $lvBhf = parcelRequire("lvBhf");

var $2ZWhP = parcelRequire("2ZWhP");

var $kDTHb = parcelRequire("kDTHb");

var $3giUV = parcelRequire("3giUV");

var $asan2 = parcelRequire("asan2");

var $feA6h = parcelRequire("feA6h");

var $6rTNk = parcelRequire("6rTNk");

var $fr19a = parcelRequire("fr19a");

var $hwifT = parcelRequire("hwifT");

var $h2mBx = parcelRequire("h2mBx");

var $3ieF5 = parcelRequire("3ieF5");

var $lWAiZ = parcelRequire("lWAiZ");

var $ggv55 = parcelRequire("ggv55");

var $7UQOV = parcelRequire("7UQOV");

var $fECRH = parcelRequire("fECRH");

var $eQ9nx = parcelRequire("eQ9nx");

var $9pTSx = parcelRequire("9pTSx");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $1DXK0 = parcelRequire("1DXK0");

var $4EKqI = parcelRequire("4EKqI");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $68iTT = parcelRequire("68iTT");

var $bzbsd = parcelRequire("bzbsd");

var $6d9QY = parcelRequire("6d9QY");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $jE8Tu = parcelRequire("jE8Tu");

var $jBNts = parcelRequire("jBNts");

var $bJscI = parcelRequire("bJscI");

var $9RE4U = parcelRequire("9RE4U");

var $l4EsH = parcelRequire("l4EsH");

var $7n9BS = parcelRequire("7n9BS");

var $34oCh = parcelRequire("34oCh");

var $3TtKq = parcelRequire("3TtKq");

var $4NiKr = parcelRequire("4NiKr");

var $3F6xT = parcelRequire("3F6xT");

var $jNv5I = parcelRequire("jNv5I");

var $fZpej = parcelRequire("fZpej");

var $29rOm = parcelRequire("29rOm");

var $7EMZm = parcelRequire("7EMZm");

var $6P9sy = parcelRequire("6P9sy");

var $c3pb3 = parcelRequire("c3pb3");

var $8zNZc = parcelRequire("8zNZc");
const $27642a2bda62ee3e$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-row",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $27642a2bda62ee3e$var$RowWithSiblingCreate = (props)=>{
    const { itemsConnectionId: itemsConnectionId, rowIndex: rowIndex, parentIssueAri: parentIssueAri, rankFieldId: rankFieldId, parentIssueHierarchyLevel: parentIssueHierarchyLevel, groupContextFieldInput: groupContextFieldInput, rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields, topLevelIssueCreateConfig: topLevelIssueCreateConfig } = props;
    const projectRef = (0, $j4oe4.useFragment)((0, $9pTSx.default), props.project);
    const formattingRulesRef = (0, $j4oe4.useFragment)((0, $eQ9nx.default), props.formattingRules);
    const issueRowEdgeData = (0, $j4oe4.useFragment)((0, $fECRH.default), props.issueEdge);
    const issueRowData = issueRowEdgeData?.node;
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $7UQOV.default), props.fieldSets);
    const { onMouseLeave: onMouseLeave, onMouseMove: onMouseMove } = (0, $4NiKr.useSiblingIssueCreateHandler)(itemsConnectionId, rowIndex);
    const projectContext = (0, $34oCh.useProjectContext)();
    let inlineCreateHandlersInput;
    if (parentIssueHierarchyLevel != null && (0, $4cTDP.fg)('jsc_list_reranking_gate')) inlineCreateHandlersInput = {
        projectKey: projectContext,
        minHierarchyLevel: parentIssueHierarchyLevel - 1,
        maxHierarchyLevel: parentIssueHierarchyLevel - 1
    };
    else if (parentIssueHierarchyLevel == null && (0, $4cTDP.fg)('timeline_harmonisation_m3_targeting')) inlineCreateHandlersInput = {
        projectKey: projectContext,
        maxHierarchyLevel: topLevelIssueCreateConfig?.maxHierarchyLevel,
        minHierarchyLevel: topLevelIssueCreateConfig?.minHierarchyLevel ?? 0
    };
    else inlineCreateHandlersInput = {
        projectKey: projectContext,
        minHierarchyLevel: 0
    };
    const { isFormVisible: isFormVisible, formProps: formProps, triggerProps: triggerProps } = (0, $68iTT.useInlineCreateHandlers)(inlineCreateHandlersInput);
    const issueCreateRowContext = (0, $eJOHy.useMemo)(()=>({
            isFormVisible: isFormVisible,
            triggerProps: triggerProps
        }), [
        isFormVisible,
        triggerProps
    ]);
    const { groupId: groupId } = (0, $jNv5I.useRowContext)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    let setIsSiblingCreateVisible = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    if ((0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting')) // eslint-disable-next-line react-hooks/rules-of-hooks
    setIsSiblingCreateVisible = (0, $jE8Tu.useHierarchyActions)().setIsSiblingCreateVisible;
     // Reset the sibling create visibility when form is closed of row is unmounted
    const prevIsFormVisible = (0, $eJOHy.useRef)(isFormVisible);
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting')) return;
        const itemId = issueRowData?.issueId;
        if (itemId && prevIsFormVisible.current && isFormVisible === false) setIsSiblingCreateVisible?.({
            itemsConnectionId: itemsConnectionId,
            itemId: itemId,
            groupId: groupId
        }, false);
        prevIsFormVisible.current = isFormVisible;
        return ()=>{
            if (isFormVisible && itemId) setIsSiblingCreateVisible?.({
                itemsConnectionId: itemsConnectionId,
                itemId: itemId,
                groupId: groupId
            }, false);
        };
    }, [
        isFormVisible,
        setIsSiblingCreateVisible,
        itemsConnectionId,
        groupId,
        issueRowData?.issueId
    ]);
    const issueCreateRow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7EMZm.IssueCreateRow), {
        canShowAdditionalFields: (0, $4cTDP.fg)('refactor_issue_table_for_timline') ? rowInlineCreateCanShowAdditionalFields : !isTimelineEnabled,
        depth: 0,
        isGrouping: !!groupId && (0, $4cTDP.fg)('jira_list_merged_column_gate'),
        isFormVisible: isFormVisible,
        issuesConnectionId: itemsConnectionId,
        siblingIssueId: issueRowData?.id ?? '',
        rankFieldId: rankFieldId,
        parentIssueAri: parentIssueAri,
        ...(0, $4cTDP.fg)('jsc_list_reranking_gate') && {
            location: 'siblingCreateForm'
        },
        ...(0, $4cTDP.fg)('group_by_any_field_sibling_inline_issue_create') && {
            groupContextFieldInput: groupContextFieldInput
        },
        ...formProps
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NiKr.SiblingIssueCreateRowContext).Provider, {
        value: issueCreateRowContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27642a2bda62ee3e$var$MaybeRowWithDragAndDrop, {
        ...props,
        project: projectRef,
        formattingRules: formattingRulesRef,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        beforeRow: issueCreateRow
    }));
};
const $27642a2bda62ee3e$var$RowWithDragAndDrop = (props)=>{
    const projectRef = (0, $j4oe4.useFragment)((0, $ggv55.default), props.project);
    const formattingRulesRef = (0, $j4oe4.useFragment)((0, $lWAiZ.default), props.formattingRules);
    const issueRowEdgeData = (0, $j4oe4.useFragment)((0, $3ieF5.default), props.issueEdge);
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $h2mBx.default), props.fieldSets);
    const issueRowData = issueRowEdgeData?.node;
    const draggableRef = (0, $l4EsH.useDraggableRow)({
        edgeIndex: props.rowIndex,
        issueId: issueRowData?.id ?? '',
        hierarchyLevel: props.hierarchyLevel,
        parentIssueAri: props.parentIssueAri,
        parentIssueEdgeRelayId: props.parentItemConnectionId,
        parentIssueConnectionId: props.parentIssueRelayConnectionId,
        issueEdgeRelayId: issueRowEdgeData?.__id,
        depth: props.depth,
        itemsConnectionId: props.itemsConnectionId,
        projectKey: props.projectKey,
        hasChildren: Boolean(issueRowEdgeData?.hasChildren),
        issueKey: props.issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27642a2bda62ee3e$var$MaybeMemoRowInner, {
        ...props,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        project: projectRef,
        formattingRules: formattingRulesRef,
        ref: draggableRef
    });
};
const $27642a2bda62ee3e$var$MaybeRowWithDragAndDrop = (props)=>{
    const isDragAndDropEnabled = (0, $34oCh.useIsDragAndDropEnabled)();
    const projectRef = (0, $j4oe4.useFragment)((0, $hwifT.default), props.project);
    const formattingRulesRef = (0, $j4oe4.useFragment)((0, $fr19a.default), props.formattingRules);
    const issueRowEdgeData = (0, $j4oe4.useFragment)((0, $6rTNk.default), props.issueEdge);
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $feA6h.default), props.fieldSets);
    if (isDragAndDropEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27642a2bda62ee3e$var$RowWithDragAndDrop, {
        ...props,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        project: projectRef,
        formattingRules: formattingRulesRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27642a2bda62ee3e$var$MaybeMemoRowInner, {
        ...props,
        project: projectRef,
        formattingRules: formattingRulesRef,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null
    });
};
const $27642a2bda62ee3e$var$RowInner = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, forwardedRef)=>{
    const { rowIndex: rowIndex, project: project, issueEdge: issueEdge, fieldSets: fieldSets, itemsConnectionId: itemsConnectionId, depth: depth, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, beforeRow: beforeRow, triggerProps: triggerProps, isFormVisible: isFormVisible, parentIssueAri: parentIssueAri, parentIssueRelayConnectionId: parentIssueRelayConnectionId, measureElement: measureElement = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), hierarchyLevel: hierarchyLevel, issueKey: issueKey, projectKey: projectKey, previousItemId: previousItemId, isDraggingRowFaded: isDraggingRowFaded, isStickyColumnsVisible: isStickyColumnsVisible, formattingRules: formattingRules } = props;
    const tableRowRef = (0, $eJOHy.useRef)(null);
    const { groupId: groupId } = (0, $jNv5I.useRowContext)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const isConditionalFormattingEnabled = (0, $34oCh.useIsConditionalFormattingEnabled)();
    const cellBorderStyle = (0, $34oCh.useCellBorderStyle)();
    const projectRef = (0, $j4oe4.useFragment)((0, $asan2.default), project);
    const formattingRulesRef = (0, $j4oe4.useFragment)((0, $3giUV.default), formattingRules);
    const issueRowEdgeData = (0, $j4oe4.useFragment)((0, $kDTHb.default), issueEdge);
    const issueRowData = issueRowEdgeData?.node;
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $2ZWhP.default), fieldSets);
    const itemDetails = (0, $eJOHy.useMemo)(()=>issueRowData ? {
            itemsConnectionId: itemsConnectionId,
            itemId: issueRowData.issueId,
            groupId: groupId
        } : null, [
        issueRowData,
        itemsConnectionId,
        groupId
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    const list = isGridNavigationEnabled ? (0, $jE8Tu.useFlatList)() : [];
    const [isSelected, { setSelectedRow: setSelectedRow }] = (0, $jE8Tu.useIsSelected)(itemDetails);
    const prevIsSelected = (0, $6d9QY.usePreviousWithInitial)(isSelected);
    const [isFocused, { resetFocus: resetFocus }] = (0, $jE8Tu.useIsFocused)(itemDetails);
    const [isRowHovered, setIsRowHovered] = (0, $eJOHy.useState)(false);
    const isDragAndDropEnabled = (0, $34oCh.useIsDragAndDropEnabled)();
    const isEntireRowDraggable = (0, $34oCh.useIsEntireRowDraggable)();
    const isReParentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    const [currentDraggingRow, setCurrentDraggingRow] = (0, $eJOHy.useState)(null);
    const isScrolling = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.isScrolling);
    const isIssueSelected = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3TtKq.useIsIssueSelected)({
        rowIndex: rowIndex,
        issueId: issueRowData?.issueId ?? '',
        depth: depth
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3TtKq.useIsIssueSelectedOld)(issueRowEdgeData?.node?.issueId ?? '');
    (0, $eJOHy.useEffect)(()=>{
        // Explicitly reset our internal state to track which row is focused. We do this to prevent the DOM element being re-focused unintentionally when the component is re-rendered.
        if (isFocused) resetFocus();
    }, [
        isFocused,
        resetFocus
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isIssueHierarchyEnabled = (0, $34oCh.useIsIssueHierarchyEnabled)();
    const onMouseOverHandler = (0, $eJOHy.useCallback)(()=>{
        if (!isScrolling && (isIssueHierarchyEnabled || isConditionalFormattingEnabled || isDragAndDropEnabled || isGridNavigationEnabled && (0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style'))) setIsRowHovered(true);
    }, [
        isScrolling,
        isIssueHierarchyEnabled,
        isConditionalFormattingEnabled,
        isDragAndDropEnabled,
        isGridNavigationEnabled
    ]);
    const onMouseLeaveHandler = (0, $eJOHy.useCallback)((e)=>{
        onMouseLeave?.(e);
        if (isIssueHierarchyEnabled || isConditionalFormattingEnabled || isDragAndDropEnabled || isGridNavigationEnabled && (0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style')) setIsRowHovered(false);
    }, [
        onMouseLeave,
        isIssueHierarchyEnabled,
        isConditionalFormattingEnabled,
        isDragAndDropEnabled,
        isGridNavigationEnabled
    ]);
    const focusCurrentRow = (0, $eJOHy.useCallback)(()=>setSelectedRow(itemDetails), [
        setSelectedRow,
        itemDetails
    ]);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        const clickAnalytics = createAnalyticsEvent({});
        const actionSubjectId = issueRowData ? 'issueRow' : 'blankRow';
        (0, $kRgKj.fireUIAnalytics)(clickAnalytics, 'rowItem clicked', actionSubjectId);
    }, [
        createAnalyticsEvent,
        issueRowData
    ]);
    const isColumnBordersEnabled = (0, $34oCh.useIsColumnBordersEnabled)();
    let showBorderOnTopLevelItem = false;
    if ((0, $4cTDP.fg)('jira_timeline_cell_border_style')) {
        let isExpanded = false;
        if ((0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting')) // eslint-disable-next-line react-hooks/rules-of-hooks
        isExpanded = (0, $jE8Tu.useIsItemVisuallyExpanded)(itemDetails);
        else // eslint-disable-next-line react-hooks/rules-of-hooks
        [isExpanded] = (0, $jE8Tu.useIsItemExpanded)(itemDetails);
        const previousItemDetails = previousItemId ? {
            itemsConnectionId: itemsConnectionId,
            itemId: previousItemId,
            groupId: groupId
        } : null;
        let isPreviousItemExpanded = false;
        if ((0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting')) // eslint-disable-next-line react-hooks/rules-of-hooks
        isPreviousItemExpanded = (0, $jE8Tu.useIsItemVisuallyExpanded)(previousItemDetails);
        else // eslint-disable-next-line react-hooks/rules-of-hooks
        [isPreviousItemExpanded] = (0, $jE8Tu.useIsItemExpanded)(previousItemDetails);
        showBorderOnTopLevelItem = cellBorderStyle === 'ROW_BORDER_FOR_EXPANDED_TOP_LEVEL_ONLY' && depth === 0 && (isExpanded || isPreviousItemExpanded);
    }
    const isGrouping = !!groupId;
    const cellBorder = (0, $eJOHy.useMemo)(()=>(0, $4cTDP.fg)('jira_timeline_cell_border_style') ? [
            $27642a2bda62ee3e$var$baseCellBorderStyles,
            $27642a2bda62ee3e$var$cellBorderLocationStyleMap[cellBorderStyle],
            showBorderOnTopLevelItem && $27642a2bda62ee3e$var$topCellBorderStyles,
            rowIndex === 0 && !parentIssueAri && !isGrouping && $27642a2bda62ee3e$var$firstRowCellBorderStyles
        ] : [
            isColumnBordersEnabled ? $27642a2bda62ee3e$var$cellBorderStyles : $27642a2bda62ee3e$var$cellBorderStylesWithNoColumn,
            rowIndex === 0 && !parentIssueAri && !isGrouping && $27642a2bda62ee3e$var$firstRowCellBorderStyles
        ], [
        cellBorderStyle,
        showBorderOnTopLevelItem,
        rowIndex,
        parentIssueAri,
        isGrouping,
        isColumnBordersEnabled
    ]);
    const beforeFirstCell = (0, $4cTDP.fg)('memoise_issuetable_components') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>{
        if (issueRowEdgeData?.node) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fZpej.BeforeFirstCell), {
            edgeIndex: rowIndex,
            issueId: issueRowEdgeData?.node.id,
            itemsConnectionId: itemsConnectionId,
            hierarchyLevel: hierarchyLevel,
            parentIssueAri: parentIssueAri,
            parentIssueConnectionId: parentIssueRelayConnectionId,
            issueKey: issueKey,
            projectKey: projectKey,
            ...isDragAndDropEnabled ? {
                isRowHovered: isRowHovered
            } : {},
            ...isReParentingEnabled ? {
                issueRowData: issueRowEdgeData?.node || null,
                setCurrentDraggingRow: setCurrentDraggingRow
            } : {
                issueRowData: null
            }
        });
        return null;
    }, [
        rowIndex,
        itemsConnectionId,
        hierarchyLevel,
        parentIssueAri,
        parentIssueRelayConnectionId,
        issueKey,
        projectKey,
        isDragAndDropEnabled,
        isRowHovered,
        isReParentingEnabled,
        issueRowEdgeData?.node
    ]) : null;
    const getRowContent = ()=>{
        /**
     * Fix for flicker during optimistic issue creation caused by Relay fragment race condition.
     *
     * When Relay replaces an optimistic issue with real server data, there's a brief moment where
     * issueEdge.node exists but issueRowEdgeData (from useFragment) is temporarily unavailable.
     * Returning null prevents the flicker: IssueRow → BlankIssueRow → IssueRow.
     */ if (!issueRowEdgeData?.node && issueEdge && 'node' in issueEdge && issueEdge.node && (0, $4cTDP.fg)('jira_list_fragment_data_race_condition_fix')) {
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueRowEdgeDataFragmentHydration failed');
            return null;
        }
        if (issueRowEdgeData?.node) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c3pb3.IssueRow), {
            project: projectRef,
            issueEdge: issueRowEdgeData ?? null,
            fieldSets: fieldSetsData ?? null,
            cellBorder: cellBorder,
            isStickyColumnsVisible: isStickyColumnsVisible,
            beforeFirstCell: (0, $4cTDP.fg)('memoise_issuetable_components') ? beforeFirstCell : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fZpej.BeforeFirstCell), {
                edgeIndex: rowIndex,
                issueId: issueRowEdgeData?.node.id,
                itemsConnectionId: itemsConnectionId,
                hierarchyLevel: hierarchyLevel,
                parentIssueAri: parentIssueAri,
                parentIssueConnectionId: parentIssueRelayConnectionId,
                issueKey: issueKey,
                projectKey: projectKey,
                ...isDragAndDropEnabled ? {
                    isRowHovered: isRowHovered
                } : {},
                ...isReParentingEnabled ? {
                    issueRowData: issueRowEdgeData?.node || null,
                    setCurrentDraggingRow: setCurrentDraggingRow
                } : {
                    issueRowData: null
                }
            }),
            itemsConnectionId: itemsConnectionId,
            depth: depth,
            isRowHoveredOrSelected: isFocused || isSelected || isRowHovered,
            rowIndex: rowIndex,
            triggerProps: triggerProps,
            isFormVisible: isFormVisible,
            formattingRules: formattingRulesRef
        });
        if (issueRowEdgeData?.issueError && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6P9sy.default), {
            isSelected: isSelected,
            cellBorder: cellBorder,
            errorRef: issueRowEdgeData.issueError,
            issueKey: issueKey
        });
         // Default to blank row
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $29rOm.default), {
            isSelected: isSelected,
            cellBorder: cellBorder
        });
    };
    const rowContent = getRowContent(); /**
                                       * Only scroll table row into view when it's a _newly_ selected row.
                                       *
                                       * We keep track of the prev selected state to avoid jumping to the selected row on mount. This issue
                                       * was introduced when we enabled virtualization as part of the infinite scroll work.
                                       * @see https://getsupport.atlassian.com/browse/PCS-359806
                                       */ 
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (isSelected && isSelected !== prevIsSelected) tableRowRef.current?.scrollIntoView({
            block: 'nearest'
        });
    }, [
        isSelected,
        prevIsSelected
    ]);
    const highlightFadeOut = (0, $eJOHy.useRef)(false);
    const onInterceptionItemRef = (0, $3F6xT.useObserveItem)(issueRowData?.id);
    let trRef = (0, $bzbsd.default)(onInterceptionItemRef, tableRowRef, forwardedRef);
    const isHighlighted = issueRowData?.isHighlightedIssueRow ?? false;
    const prevIsHighlighted = (0, $6d9QY.usePrevious)(isHighlighted); // Begin fade out animation when isHighlighted changes to false
    if (prevIsHighlighted && !isHighlighted) highlightFadeOut.current = true;
    trRef = (0, $bzbsd.default)(trRef, measureElement);
    let itemKey = null;
    if (itemsConnectionId && issueRowData?.id) itemKey = (0, $jE8Tu.getItemKey)(itemsConnectionId, issueRowData.id);
    const overallRowIndex = itemDetails && isGridNavigationEnabled ? list.indexOf((0, $jBNts.getFlatListKey)(itemDetails)) + 1 : -1; // eslint-disable-next-line no-nested-ternary
    const color = (0, $4cTDP.fg)('jira_list_conditional_formatting') ? (0, $4cTDP.fg)('saved_list_view_technical_changes') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8zNZc.useRowColor)(fieldSetsData, null, formattingRulesRef) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8zNZc.useRowColor)(fieldSetsData, projectRef) : undefined; // placeholder for what will be const color = useRowColor in the future.
    // TODO: Move inside `css` prop on `jsc-2065-unify-onrowreorder` cleanup
    const shouldHaveDraggableRowStyles = (0, $4cTDP.fg)('jsc-2065-unify-onrowreorder') ? isDragAndDropEnabled && isEntireRowDraggable : isEntireRowDraggable;
    const isPageHydrating = (0, $9RE4U.useIsHydrateRenderMode)();
    const displaySsrPlaceholderAttrs = (0, $9RE4U.useSsrPlaceholders)();
    if (!rowContent && (0, $4cTDP.fg)('jira_list_fragment_data_race_condition_fix')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, beforeRow, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27642a2bda62ee3e$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr" // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    , {
        "data-testid": "native-issue-table.ui.issue-row",
        "aria-selected": isIssueSelected && isGridNavigationEnabled || isSelected,
        ...overallRowIndex > 0 && isGridNavigationEnabled && {
            'aria-rowindex': overallRowIndex
        },
        role: "row",
        onAnimationEnd: ()=>{
            /*
        Animation set using @compiled may be inadvertently started when the scripting engine applies
        new styles (e.g. after a new issue row is appended). We need to set the animation duration
        to 0s once the animation has completed to prevent the animation restarting.
        See https://drafts.csswg.org/css-animations-1/#animations
         */ if (tableRowRef.current) tableRowRef.current.style.animationDuration = '0s';
        },
        onFocus: focusCurrentRow,
        onClick: onClick,
        onMouseOver: onMouseOverHandler,
        onMouseMove: onMouseMove,
        onMouseLeave: onMouseLeaveHandler,
        tabIndex: -1,
        ...isConditionalFormattingEnabled && color && {
            style: {
                backgroundColor: isRowHovered ? color.hoverValue : color.value
            }
        },
        'data-index': rowIndex,
        ref: trRef,
        "data-vc": `issue-row${false && !isPageHydrating ? '-ssr' : ''}`,
        ...false && displaySsrPlaceholderAttrs && (0, $4cTDP.fg)('additional_nin_ssr_placeholders') && {
            'data-ssr-placeholder': 'issue-row-placeholder'
        },
        ...!false && displaySsrPlaceholderAttrs && (0, $4cTDP.fg)('additional_nin_ssr_placeholders') && {
            'data-ssr-placeholder-replace': 'issue-row-placeholder'
        },
        className: (0, $hcewu.default)([
            "_4t3i1ylp _kqswh2mm _bfhkvuon _nt751r31 _49pcglyw _1hvw1o36 _7psyru3m _irr319i6",
            isGridNavigationEnabled && "_qj5iru3m _10j715s3 _1p0pufnl",
            highlightFadeOut.current && "",
            highlightFadeOut.current && "_j7hq4k5t _5sagymdr _1pgl6ui8",
            isIssueSelected && "_5sagru3m _bfhk15s3 _irr3ufnl",
            isHighlighted && "_bfhk1s93",
            shouldHaveDraggableRowStyles && "_80om1qgj _1qam5szm",
            currentDraggingRow !== null && currentDraggingRow === itemKey && (isDraggingRowFaded || !(0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting')) && (0, $4cTDP.fg)('jsc_list_reparenting') && "_tzy41ou4"
        ])
    }, rowContent)));
});
const $27642a2bda62ee3e$var$MaybeMemoRowInner = /*#__PURE__*/ (0, $eJOHy.memo)($27642a2bda62ee3e$var$RowInner);
const $27642a2bda62ee3e$var$RowNonMemoized = (props)=>{
    const issueRowEdgeData = (0, $j4oe4.useFragment)((0, $lvBhf.default), props.issueEdge);
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $l5gzh.default), props.fieldSets);
    const project = (0, $j4oe4.useFragment)((0, $8wuJw.default), props.project);
    const formattingRulesData = (0, $j4oe4.useFragment)((0, $dNMQL.default), props.formattingRules);
    const isSiblingIssueCreateEnabled = (0, $34oCh.useIsSiblingIssueCreateEnabled)();
    if (isSiblingIssueCreateEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27642a2bda62ee3e$var$RowWithSiblingCreate, {
        ...props,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        project: project,
        formattingRules: formattingRulesData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27642a2bda62ee3e$var$MaybeRowWithDragAndDrop, {
        ...props,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        project: project,
        formattingRules: formattingRulesData
    });
};
const $27642a2bda62ee3e$var$Row = (0, $bJscI.componentWithFG)('memoise_issuetable_components', /*#__PURE__*/ (0, $eJOHy.memo)($27642a2bda62ee3e$var$RowNonMemoized), $27642a2bda62ee3e$var$RowNonMemoized);
var $27642a2bda62ee3e$export$2e2bcd8739ae039 = $27642a2bda62ee3e$var$Row;
const $27642a2bda62ee3e$var$ROW_HEIGHT = 40; // TODO: Remove with clean up of jira_timeline_cell_border_style
const $27642a2bda62ee3e$var$cellBorderStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderBlockStartWidth: 'border.width',
    borderBlockEndWidth: '0',
    borderInlineStartWidth: '0',
    borderInlineEndWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        borderInlineEndWidth: '0'
    }
}); // TODO: Remove with clean up of jira_timeline_cell_border_style
const $27642a2bda62ee3e$var$cellBorderStylesWithNoColumn = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderBlockStartWidth: 'border.width',
    borderBlockEndWidth: '0',
    borderInlineStartWidth: '0',
    borderInlineEndWidth: '0'
});
const $27642a2bda62ee3e$var$firstRowCellBorderStyles = (0, $1DXK0.xcss)({
    borderBlockStartWidth: '0'
});
const $27642a2bda62ee3e$var$baseCellBorderStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderBlockEndWidth: '0',
    borderInlineStartWidth: '0',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        borderInlineEndWidth: '0'
    }
});
const $27642a2bda62ee3e$var$fullCellBorderStyles = (0, $1DXK0.xcss)({
    borderBlockStartWidth: 'border.width',
    borderInlineEndWidth: 'border.width'
});
const $27642a2bda62ee3e$var$noColumnCellBorderStyles = (0, $1DXK0.xcss)({
    borderBlockStartWidth: 'border.width',
    borderInlineEndWidth: '0'
});
const $27642a2bda62ee3e$var$noRowCellBorderStyles = (0, $1DXK0.xcss)({
    borderBlockStartWidth: '0',
    borderInlineEndWidth: 'border.width'
});
const $27642a2bda62ee3e$var$topCellBorderStyles = (0, $1DXK0.xcss)({
    borderBlockStartWidth: 'border.width'
});
const $27642a2bda62ee3e$var$cellBorderLocationStyleMap = {
    FULL_BORDER: $27642a2bda62ee3e$var$fullCellBorderStyles,
    NO_COLUMN_BORDER: $27642a2bda62ee3e$var$noColumnCellBorderStyles,
    ROW_BORDER_FOR_EXPANDED_TOP_LEVEL_ONLY: $27642a2bda62ee3e$var$noRowCellBorderStyles
};
const $27642a2bda62ee3e$var$fadeOut = null;
const $27642a2bda62ee3e$var$rowStyles = null;
const $27642a2bda62ee3e$var$rowStylesKeyboardNavigation = null;
const $27642a2bda62ee3e$var$draggableRowStyles = null;
const $27642a2bda62ee3e$var$activeRowStyles = null;
const $27642a2bda62ee3e$var$highlightRowStyles = null;
const $27642a2bda62ee3e$var$draggingRowFadedStyles = null;
const $27642a2bda62ee3e$var$highlightFadeOutStyles = null;

});
parcelRegister("dNMQL", function(module, exports) {
$parcel$export(module.exports, "default", () => $dffaa4e5f6e2ef26$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<931b8a8e2d118f3bc5a3772b6e630d17>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dffaa4e5f6e2ef26$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Row_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "RowMaybeWithDragAndDrop_rules"
        },
        {
            "kind": "FragmentSpread",
            "name": "RowWithSiblingCreate_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$dffaa4e5f6e2ef26$var$node.hash = "7dff2c26d095d5e3683d5477fc25813c";
var $dffaa4e5f6e2ef26$export$2e2bcd8739ae039 = $dffaa4e5f6e2ef26$var$node;

});

parcelRegister("8wuJw", function(module, exports) {
$parcel$export(module.exports, "default", () => $72cad2b9d6a9013d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<575237eb5c039abf0810a572b4b54219>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $72cad2b9d6a9013d$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "Row_project",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowMaybeWithDragAndDrop_project"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowWithSiblingCreate_project"
            }
        ],
        "type": "JiraProject"
    };
}();
$72cad2b9d6a9013d$var$node.hash = "29bc757a62493204a08d7359797abc9b";
var $72cad2b9d6a9013d$export$2e2bcd8739ae039 = $72cad2b9d6a9013d$var$node;

});

parcelRegister("l5gzh", function(module, exports) {
$parcel$export(module.exports, "default", () => $24eadf2602844eb7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<409000e83557fda1696afaefcb0bc0cc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $24eadf2602844eb7$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
        },
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        },
        {
            "kind": "Variable",
            "name": "isEditableSyncLoaded",
            "variableName": "isEditableSyncLoaded"
        },
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        },
        {
            "kind": "Variable",
            "name": "isLinkRelationshipFieldEnabled",
            "variableName": "isLinkRelationshipFieldEnabled"
        },
        {
            "kind": "Variable",
            "name": "isTimelineEnabled",
            "variableName": "isTimelineEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isEditableSyncLoaded"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "Row_fieldSets",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowInner_fieldSets"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowWithSiblingCreate_fieldSets"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowMaybeWithDragAndDrop_fieldSets"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowWithDragAndDrop_fieldSets"
            },
            {
                "condition": "isConditionalFormattingEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "useRowColor"
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$24eadf2602844eb7$var$node.hash = "0018309ff3a83209b2cf9935ef8f2458";
var $24eadf2602844eb7$export$2e2bcd8739ae039 = $24eadf2602844eb7$var$node;

});

parcelRegister("lvBhf", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2ab3afa15a35b65$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4efd5a53413717b0d68f9e9748182492>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a2ab3afa15a35b65$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        },
        {
            "kind": "Variable",
            "name": "isLinkRelationshipFieldEnabled",
            "variableName": "isLinkRelationshipFieldEnabled"
        },
        {
            "kind": "Variable",
            "name": "isRemoteLinkedIssuesEnabled",
            "variableName": "isRemoteLinkedIssuesEnabled"
        },
        {
            "kind": "Variable",
            "name": "isReparentingEnabled",
            "variableName": "isReparentingEnabled"
        },
        {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
        },
        {
            "kind": "Variable",
            "name": "projectKeys",
            "variableName": "projectKeys"
        },
        {
            "kind": "Variable",
            "name": "shouldQueryHasChildren",
            "variableName": "shouldQueryHasChildren"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isRemoteLinkedIssuesEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "Row_issueEdge",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowInner_issueEdge"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowWithSiblingCreate_issueEdge"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowMaybeWithDragAndDrop_issueEdge"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowWithDragAndDrop_issueEdge"
            },
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    }
                ]
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$a2ab3afa15a35b65$var$node.hash = "d9df20eb58b51c0f60df6f3b02d6583f";
var $a2ab3afa15a35b65$export$2e2bcd8739ae039 = $a2ab3afa15a35b65$var$node;

});

parcelRegister("2ZWhP", function(module, exports) {
$parcel$export(module.exports, "default", () => $10eb90de9bc6edc0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5eb0dae690d1c33d596523393a5dbca0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $10eb90de9bc6edc0$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "RowInner_fieldSets",
    "selections": [
        {
            "condition": "isConditionalFormattingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useRowColor"
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isEditableSyncLoaded",
                    "variableName": "isEditableSyncLoaded"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "IssueRow_fieldSets"
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$10eb90de9bc6edc0$var$node.hash = "9882f56e8bb49695f4d3d789cf350d24";
var $10eb90de9bc6edc0$export$2e2bcd8739ae039 = $10eb90de9bc6edc0$var$node;

});

parcelRegister("kDTHb", function(module, exports) {
$parcel$export(module.exports, "default", () => $4670ba489209acf4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<86a5cd7eb22cde3262f246e638dd75f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4670ba489209acf4$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRemoteLinkedIssuesEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "RowInner_issueEdge",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isRemoteLinkedIssuesEnabled",
                    "variableName": "isRemoteLinkedIssuesEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "IssueRowWithFragments_issueEdge"
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "issueId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isReparentingEnabled",
                            "variableName": "isReparentingEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "BeforeFirstCell"
                },
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isHighlightedIssueRow"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "isRemoteLinkedIssuesEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "issueError",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "remoteIssueErrorRow_nativeIssueTable"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$4670ba489209acf4$var$node.hash = "72b6c32de647f01cd45e824ded332d3f";
var $4670ba489209acf4$export$2e2bcd8739ae039 = $4670ba489209acf4$var$node;

});

parcelRegister("3giUV", function(module, exports) {
$parcel$export(module.exports, "default", () => $d63dde35adcfcb71$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d584e1b8f1dbe67e3b1d4db631a9101b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d63dde35adcfcb71$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "RowInner_rules",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useRowColor_savedView_rules"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "IssueRow_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$d63dde35adcfcb71$var$node.hash = "9ebb21229d16cd8d8f5a9e2d4f85a37e";
var $d63dde35adcfcb71$export$2e2bcd8739ae039 = $d63dde35adcfcb71$var$node;

});

parcelRegister("asan2", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cba6ce80ed81109$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<059fd63b15cc735c824bb62e5ac23eff>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7cba6ce80ed81109$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "RowInner_project",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "condition": "isConditionalFormattingEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "useRowColor_rules"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "IssueRow"
        }
    ],
    "type": "JiraProject"
};
$7cba6ce80ed81109$var$node.hash = "8be14ee957ae4ac1000f061823c57081";
var $7cba6ce80ed81109$export$2e2bcd8739ae039 = $7cba6ce80ed81109$var$node;

});

parcelRegister("feA6h", function(module, exports) {
$parcel$export(module.exports, "default", () => $427ef5f74c83e7b5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5fd4f77b4a159dc64c7069ee9f6d2e53>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $427ef5f74c83e7b5$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
        },
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        },
        {
            "kind": "Variable",
            "name": "isEditableSyncLoaded",
            "variableName": "isEditableSyncLoaded"
        },
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        },
        {
            "kind": "Variable",
            "name": "isLinkRelationshipFieldEnabled",
            "variableName": "isLinkRelationshipFieldEnabled"
        },
        {
            "kind": "Variable",
            "name": "isTimelineEnabled",
            "variableName": "isTimelineEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isEditableSyncLoaded"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "RowMaybeWithDragAndDrop_fieldSets",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowInner_fieldSets"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowWithDragAndDrop_fieldSets"
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$427ef5f74c83e7b5$var$node.hash = "cd09469225ea664ec221e4c1ecb8938f";
var $427ef5f74c83e7b5$export$2e2bcd8739ae039 = $427ef5f74c83e7b5$var$node;

});

parcelRegister("6rTNk", function(module, exports) {
$parcel$export(module.exports, "default", () => $df5bb0957cfb7ad2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c02c3cca022cac91e0fbd4e30e2ba0f3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $df5bb0957cfb7ad2$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        },
        {
            "kind": "Variable",
            "name": "isLinkRelationshipFieldEnabled",
            "variableName": "isLinkRelationshipFieldEnabled"
        },
        {
            "kind": "Variable",
            "name": "isRemoteLinkedIssuesEnabled",
            "variableName": "isRemoteLinkedIssuesEnabled"
        },
        {
            "kind": "Variable",
            "name": "isReparentingEnabled",
            "variableName": "isReparentingEnabled"
        },
        {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
        },
        {
            "kind": "Variable",
            "name": "projectKeys",
            "variableName": "projectKeys"
        },
        {
            "kind": "Variable",
            "name": "shouldQueryHasChildren",
            "variableName": "shouldQueryHasChildren"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isRemoteLinkedIssuesEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "RowMaybeWithDragAndDrop_issueEdge",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowInner_issueEdge"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowWithDragAndDrop_issueEdge"
            },
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    }
                ]
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$df5bb0957cfb7ad2$var$node.hash = "ac91377160a49d398209c4ab8f0dad27";
var $df5bb0957cfb7ad2$export$2e2bcd8739ae039 = $df5bb0957cfb7ad2$var$node;

});

parcelRegister("fr19a", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb1423a2be8cb4cd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b5f5fc2b314adffc8928163d18f02f9b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fb1423a2be8cb4cd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RowMaybeWithDragAndDrop_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "RowWithDragAndDrop_rules"
        },
        {
            "kind": "FragmentSpread",
            "name": "RowInner_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$fb1423a2be8cb4cd$var$node.hash = "08b9aeb323501268f81c92713a749c54";
var $fb1423a2be8cb4cd$export$2e2bcd8739ae039 = $fb1423a2be8cb4cd$var$node;

});

parcelRegister("hwifT", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8fb7039b1b810f3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<43f19697759d9e7d6bd573958bc13de2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d8fb7039b1b810f3$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "RowMaybeWithDragAndDrop_project",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowWithDragAndDrop_project"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowInner_project"
            }
        ],
        "type": "JiraProject"
    };
}();
$d8fb7039b1b810f3$var$node.hash = "7b2fa8240809ed877a350cb43191a25e";
var $d8fb7039b1b810f3$export$2e2bcd8739ae039 = $d8fb7039b1b810f3$var$node;

});

parcelRegister("h2mBx", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f5249cdb7383247$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<28ae15ef0b76f2cfab974ccdec5838f1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1f5249cdb7383247$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "RowWithDragAndDrop_fieldSets",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isEditableSyncLoaded",
                    "variableName": "isEditableSyncLoaded"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "RowInner_fieldSets"
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$1f5249cdb7383247$var$node.hash = "c33ee218a603532c93608b35fa4ba2a8";
var $1f5249cdb7383247$export$2e2bcd8739ae039 = $1f5249cdb7383247$var$node;

});

parcelRegister("3ieF5", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4c3ee20486819e0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<38032053a9a7f2df1dcf4d00ffbe3e9c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a4c3ee20486819e0$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRemoteLinkedIssuesEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "RowWithDragAndDrop_issueEdge",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isRemoteLinkedIssuesEnabled",
                    "variableName": "isRemoteLinkedIssuesEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "RowInner_issueEdge"
        },
        {
            "condition": "shouldQueryHasChildren",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "filterByProjectKeys",
                            "variableName": "projectKeys"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "hasChildren"
                }
            ]
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$a4c3ee20486819e0$var$node.hash = "d2e8902f955173a824707a1e4a160629";
var $a4c3ee20486819e0$export$2e2bcd8739ae039 = $a4c3ee20486819e0$var$node;

});

parcelRegister("lWAiZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d392bb9456475709$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0fe38090b498f56a6896bae60efc1efe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d392bb9456475709$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RowWithDragAndDrop_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "RowInner_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$d392bb9456475709$var$node.hash = "411d45a42f6096614da4ec8427974ed3";
var $d392bb9456475709$export$2e2bcd8739ae039 = $d392bb9456475709$var$node;

});

parcelRegister("ggv55", function(module, exports) {
$parcel$export(module.exports, "default", () => $205ddbf99c233108$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<655f873df16294d2f8d6f122ac29210e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $205ddbf99c233108$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "RowWithDragAndDrop_project",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "RowInner_project"
        }
    ],
    "type": "JiraProject"
};
$205ddbf99c233108$var$node.hash = "600d8dce94ac71f00862105938b2962a";
var $205ddbf99c233108$export$2e2bcd8739ae039 = $205ddbf99c233108$var$node;

});

parcelRegister("7UQOV", function(module, exports) {
$parcel$export(module.exports, "default", () => $19b4706c10890fcb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1485f35ae641007e4b05c10db225e103>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $19b4706c10890fcb$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "RowWithSiblingCreate_fieldSets",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isEditableSyncLoaded",
                    "variableName": "isEditableSyncLoaded"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "RowMaybeWithDragAndDrop_fieldSets"
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$19b4706c10890fcb$var$node.hash = "f1999205364d01468f86cc16002a6b48";
var $19b4706c10890fcb$export$2e2bcd8739ae039 = $19b4706c10890fcb$var$node;

});

parcelRegister("fECRH", function(module, exports) {
$parcel$export(module.exports, "default", () => $126de9c4f8f804ae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<51e25c856826096602ce978535432799>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $126de9c4f8f804ae$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRemoteLinkedIssuesEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "RowWithSiblingCreate_issueEdge",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isRemoteLinkedIssuesEnabled",
                    "variableName": "isRemoteLinkedIssuesEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "RowMaybeWithDragAndDrop_issueEdge"
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "issueId"
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$126de9c4f8f804ae$var$node.hash = "3b1fe3bbefc4839f3ccefb18c4157ecd";
var $126de9c4f8f804ae$export$2e2bcd8739ae039 = $126de9c4f8f804ae$var$node;

});

parcelRegister("eQ9nx", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b931b3e987b43c4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f051b0f3bc2a436aa842355fafd91f46>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2b931b3e987b43c4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RowWithSiblingCreate_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "RowMaybeWithDragAndDrop_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$2b931b3e987b43c4$var$node.hash = "bf0fac83a25d23ffe38288db84bbe828";
var $2b931b3e987b43c4$export$2e2bcd8739ae039 = $2b931b3e987b43c4$var$node;

});

parcelRegister("9pTSx", function(module, exports) {
$parcel$export(module.exports, "default", () => $508edb60e7f19d21$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f60d02c7a28a1c92a33e779c4f66dda>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $508edb60e7f19d21$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "RowWithSiblingCreate_project",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "RowMaybeWithDragAndDrop_project"
        }
    ],
    "type": "JiraProject"
};
$508edb60e7f19d21$var$node.hash = "4aa0ed8501f38926bbd2f9ec7930aec3";
var $508edb60e7f19d21$export$2e2bcd8739ae039 = $508edb60e7f19d21$var$node;

});

parcelRegister("l4EsH", function(module, exports) {
$parcel$export(module.exports, "useDraggableRows", () => $97cccd1c556c1005$export$1e4d2f7e506c2b7d);
$parcel$export(module.exports, "useDraggableRow", () => $97cccd1c556c1005$export$a878804271d34ba8);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $3nrCN = parcelRequire("3nrCN");

var $dROq6 = parcelRequire("dROq6");

var $iJoDE = parcelRequire("iJoDE");

var $1l4lS = parcelRequire("1l4lS");

var $bGx3v = parcelRequire("bGx3v");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $iJq0l = parcelRequire("iJq0l");

var $2ApNu = parcelRequire("2ApNu");
var $3pSHx = parcelRequire("3pSHx");

var $cHtIB = parcelRequire("cHtIB");

var $3mZMJ = parcelRequire("3mZMJ");

var $4cTDP = parcelRequire("4cTDP");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $443cm = parcelRequire("443cm");

var $j5Wzv = parcelRequire("j5Wzv");

var $15Apk = parcelRequire("15Apk");

var $jNv5I = parcelRequire("jNv5I");

var $kfIml = parcelRequire("kfIml");

var $t5ecZ = parcelRequire("t5ecZ");
const $97cccd1c556c1005$var$ATTACH_INSTRUCTION_MODE = 'standard';
const $97cccd1c556c1005$var$SUPPORTED_TYPES = new Set([
    (0, $8jOO7.MAKE_CHILD),
    (0, $8jOO7.REORDER_ABOVE),
    (0, $8jOO7.REORDER_BELOW)
]);
const $97cccd1c556c1005$var$CHECKBOX_COLUMN_WIDTH = 42;
const $97cccd1c556c1005$var$INDENT_PER_LEVEL = 12;
const $97cccd1c556c1005$export$1e4d2f7e506c2b7d = (0, $iJq0l.createHook)((0, $kfIml.Store));
const $97cccd1c556c1005$var$isDraggableRowData = (data)=>data != null && typeof data === 'object' && 'operation' in data && data.operation === (0, $8jOO7.ROW_OPERATION_REORDER);
const $97cccd1c556c1005$export$a878804271d34ba8 = (props)=>{
    const { edgeIndex: edgeIndex, issueId: issueId, hierarchyLevel: hierarchyLevel, parentIssueAri: parentIssueAri, parentIssueEdgeRelayId: parentIssueEdgeRelayId, parentIssueConnectionId: parentIssueConnectionId, issueEdgeRelayId: issueEdgeRelayId, issueKey: issueKey } = props;
    const isDragAndDropEnabled = (0, $34oCh.useIsDragAndDropEnabled)();
    const isEntireRowDraggable = (0, $34oCh.useIsEntireRowDraggable)();
    let isRowReorderingEnabled = false;
    if (!(0, $4cTDP.fg)('jsc-2065-unify-onrowreorder')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isRowReorderingEnabled = (0, $34oCh.useIsRowReorderingEnabled)();
    const isIssueRankingEnabled = (0, $34oCh.useIsIssueRankingEnabled)();
    const isReParentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    const rankIssues = (0, $j5Wzv.useIssuesRanker)();
    let sortDirection;
    let getBlockedInstructions = (0, $t5ecZ.getBlockedInstructionsOld);
    if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) {
        getBlockedInstructions = (0, $t5ecZ.getBlockedInstructions);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        sortDirection = (0, $34oCh.useSortDirection)();
    }
    const [{ instanceId: instanceId, onRowReorder: onRowReorderHandler }, { registerItem: registerItem, setDropTarget: setDropTarget, unregisterItem: unregisterItem }] = $97cccd1c556c1005$export$1e4d2f7e506c2b7d();
    let reparent = null;
    if ((0, $4cTDP.fg)('jsc_list_reparenting')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ reparent: reparent } = (0, $443cm.useUpdateParent)());
    const cloudId = (0, $cHtIB.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onRowReorder = isIssueRankingEnabled ? rankIssues : onRowReorderHandler;
    // TODO: Use `rankIssues` directly on jsc-2065-unify-onrowreorder cleanup
    const onRankIssues = (0, $4cTDP.fg)('jsc-2065-unify-onrowreorder') ? rankIssues : onRowReorder;
    const cleanupFnRef = (0, $eJOHy.useRef)(null);
    const { groupId: groupId, columns: columns } = (0, $jNv5I.useRowContext)();
    const hasCheckboxColumn = columns.length > 0 && columns[0].id === (0, $8jOO7.COLUMN_ID_CHECKBOX);
    const attachDraggableElement = (0, $eJOHy.useCallback)((rowElement)=>isEntireRowDraggable ? (0, $bGx3v.draggable)({
            element: rowElement,
            getInitialData () {
                return {
                    operation: (0, $8jOO7.ROW_OPERATION_REORDER),
                    instanceId: instanceId,
                    issueId: issueId,
                    hierarchyLevel: hierarchyLevel,
                    parentIssueAri: parentIssueAri,
                    parentIssueEdgeRelayId: parentIssueEdgeRelayId,
                    parentIssueConnectionId: parentIssueConnectionId,
                    issueEdgeRelayId: issueEdgeRelayId,
                    rowIndex: edgeIndex,
                    itemsConnectionId: props.itemsConnectionId,
                    issueKey: issueKey,
                    groupId: groupId
                };
            },
            onDragStart () {
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'dragged',
                    actionSubject: 'useDraggableRow',
                    actionSubjectId: 'jscDraggableIssue'
                }));
            },
            onDrop () {
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'dropped',
                    actionSubject: 'useDraggableRow',
                    actionSubjectId: 'jscDraggableIssue'
                }));
            }
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), [
        isEntireRowDraggable,
        instanceId,
        issueId,
        hierarchyLevel,
        parentIssueAri,
        parentIssueEdgeRelayId,
        parentIssueConnectionId,
        issueEdgeRelayId,
        edgeIndex,
        props.itemsConnectionId,
        issueKey,
        groupId,
        createAnalyticsEvent
    ]);
    const attachDropTargetElement = (0, $eJOHy.useCallback)((rowElement)=>(0, $bGx3v.dropTargetForElements)({
            element: rowElement,
            canDrop ({ source: source }) {
                return source.data.operation === (0, $8jOO7.ROW_OPERATION_REORDER) && source.data.issueId !== issueId;
            },
            getData ({ input: input, element: element, source: source }) {
                const data = {
                    operation: (0, $8jOO7.ROW_OPERATION_REORDER),
                    instanceId: instanceId,
                    issueId: issueId,
                    parentIssueAri: parentIssueAri,
                    parentIssueConnectionId: parentIssueConnectionId,
                    issueEdgeRelayId: issueEdgeRelayId,
                    parentIssueEdgeRelayId: parentIssueEdgeRelayId,
                    rowIndex: edgeIndex,
                    itemsConnectionId: props.itemsConnectionId,
                    hasChildren: Boolean(props.hasChildren),
                    groupId: groupId
                };
                if ((0, $4cTDP.fg)('jsc_list_reparenting')) {
                    const blockedInstructions = $97cccd1c556c1005$var$isDraggableRowData(source.data) ? getBlockedInstructions({
                        dropTarget: {
                            ...data,
                            ...props
                        },
                        draggedItem: source.data,
                        isRowReorderingEnabled: isRowReorderingEnabled,
                        isIssueRankingEnabled: isIssueRankingEnabled
                    }) : [
                        (0, $8jOO7.MAKE_CHILD),
                        (0, $8jOO7.REORDER_BELOW),
                        (0, $8jOO7.REORDER_BELOW)
                    ];
                    // currentLevel is used purely to calculate the indentation of the row using currentLevel * indentPerLevel
                    // when hasCheckboxColumn is true, the desired indentation = currentDepth * indentPerLevel + checkboxColumnWidth
                    // since we need a uniform value for the indentPerLevel, we adjust the currentLevel value.
                    const currentDepth = props.depth || 0;
                    const adjustedCurrentLevel = currentDepth + $97cccd1c556c1005$var$CHECKBOX_COLUMN_WIDTH / $97cccd1c556c1005$var$INDENT_PER_LEVEL;
                    return (0, $iJoDE.attachInstruction)(data, {
                        input: input,
                        element: element,
                        mode: $97cccd1c556c1005$var$ATTACH_INSTRUCTION_MODE,
                        indentPerLevel: $97cccd1c556c1005$var$INDENT_PER_LEVEL,
                        currentLevel: hasCheckboxColumn ? adjustedCurrentLevel : currentDepth,
                        block: blockedInstructions
                    });
                }
                return (0, $3nrCN.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            onDrag ({ self: self, source: source }) {
                // Don't set drop edge if source target is the same as this row instance
                if (issueId === source.data.issueId) return;
                if ((0, $4cTDP.fg)('jsc_list_reparenting')) {
                    const extractedInstruction = (0, $iJoDE.extractInstruction)(self.data);
                    extractedInstruction && setDropTarget({
                        issueId: issueId,
                        dropInstruction: extractedInstruction
                    });
                    return;
                }
                const closestEdge = (0, $3nrCN.extractClosestEdge)(self.data);
                closestEdge && setDropTarget({
                    issueId: issueId,
                    dropEdge: closestEdge
                });
            },
            onDragLeave () {
                setDropTarget(null);
            },
            onDrop ({ source: source, location: location }) {
                const [destination] = location.current.dropTargets;
                setDropTarget(null);
                if (!$97cccd1c556c1005$var$isDraggableRowData(source.data) || !$97cccd1c556c1005$var$isDraggableRowData(destination?.data)) return;
                let closestEdgeOfTarget;
                let extractedInstruction;
                if ((0, $4cTDP.fg)('jsc_list_reparenting')) {
                    extractedInstruction = (0, $iJoDE.extractInstruction)(destination.data);
                    closestEdgeOfTarget = extractedInstruction?.type === (0, $8jOO7.REORDER_ABOVE) ? 'top' : 'bottom';
                } else closestEdgeOfTarget = (0, $3nrCN.extractClosestEdge)(destination.data);
                const dragItemParent = source.data?.parentIssueAri;
                const dropTargetParent = props?.parentIssueAri;
                const isWithinSameParent = dragItemParent === dropTargetParent;
                // We are dropping at specific edge but not changing parent, meaning only reranking
                const isRerankingOnly = (extractedInstruction?.type === (0, $8jOO7.REORDER_ABOVE) || extractedInstruction?.type === (0, $8jOO7.REORDER_BELOW)) && isWithinSameParent;
                const shouldRerank = (0, $4cTDP.fg)('jsc_list_reranking_gate') ? isRerankingOnly && (isRowReorderingEnabled || isIssueRankingEnabled) : isRowReorderingEnabled;
                const shouldReparent = (0, $4cTDP.fg)('jsc_list_reranking_gate') ? !isRerankingOnly && isReParentingEnabled : isReParentingEnabled;
                if (shouldRerank) {
                    if (!closestEdgeOfTarget) return;
                    const startIndex = source.data.rowIndex;
                    const finishIndex = (0, $1l4lS.getReorderDestinationIndex)({
                        axis: 'vertical',
                        closestEdgeOfTarget: closestEdgeOfTarget,
                        startIndex: startIndex,
                        indexOfTarget: destination.data.rowIndex
                    });
                    if (startIndex === finishIndex) return;
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                        action: 'updatedRanking',
                        actionSubject: 'dragActionsButton',
                        actionSubjectId: 'jscDraggableIssue'
                    }));
                    const edge = isIssueRankingEnabled ? (0, $15Apk.getEdgeForRerank)(startIndex, finishIndex, sortDirection) : closestEdgeOfTarget;
                    onRankIssues?.({
                        source: {
                            issueIds: [
                                source.data.issueId
                            ],
                            rowIndex: startIndex
                        },
                        destination: {
                            relativeToIssueId: destination.data.issueId,
                            rowIndex: finishIndex
                        },
                        edge: edge
                    });
                }
                if (shouldReparent) {
                    if (extractedInstruction && $97cccd1c556c1005$var$SUPPORTED_TYPES.has(extractedInstruction.type)) {
                        const issueIdToReparent = (0, $2ApNu.JiraIssueAri).parse(source.data.issueId).issueId;
                        const issueFieldAriToReparent = (0, $3pSHx.JiraIssuefieldvalueAri).create({
                            siteId: cloudId,
                            issueId: issueIdToReparent,
                            fieldId: (0, $3mZMJ.PARENT_TYPE)
                        }).toString();
                        const oldParentId = source.data.parentIssueAri && (0, $2ApNu.JiraIssueAri).parse(source.data.parentIssueAri).issueId;
                        const newParentAri = extractedInstruction.type === (0, $8jOO7.MAKE_CHILD) ? destination.data.issueId : destination.data.parentIssueAri;
                        const newParentId = newParentAri ? (0, $2ApNu.JiraIssueAri).parse(newParentAri).issueId : undefined;
                        const newParentEdgeId = extractedInstruction?.type === (0, $8jOO7.MAKE_CHILD) ? destination.data.issueEdgeRelayId : destination.data.parentIssueEdgeRelayId;
                        let dropIndex = 0;
                        if (extractedInstruction?.type === (0, $8jOO7.REORDER_ABOVE)) dropIndex = destination.data.rowIndex;
                        else if (extractedInstruction?.type === (0, $8jOO7.REORDER_BELOW)) dropIndex = destination.data.rowIndex + 1;
                        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'field updated', {
                            isJscReparenting: true
                        });
                        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueParent updated', {
                            isJscReparenting: true
                        });
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                            action: 'updatedParent',
                            actionSubject: 'dragActionsButton',
                            actionSubjectId: 'jscDraggableIssue'
                        }), {
                            reparentingMethod: extractedInstruction.type,
                            isAddingParent: !oldParentId,
                            isUnparenting: !newParentAri,
                            droppedIssueHierarchyLevel: source.data.hierarchyLevel
                        });
                        reparent?.({
                            issueId: source.data.issueId,
                            issueAri: issueFieldAriToReparent,
                            oldParentId: oldParentId,
                            newParentId: newParentId,
                            newParentAri: newParentAri || null,
                            newParentEdgeId: newParentEdgeId,
                            index: dropIndex,
                            projectKey: props.projectKey,
                            issueKey: source.data.issueKey
                        });
                    }
                }
            }
        }), [
        instanceId,
        issueId,
        parentIssueAri,
        parentIssueConnectionId,
        issueEdgeRelayId,
        parentIssueEdgeRelayId,
        edgeIndex,
        props,
        groupId,
        getBlockedInstructions,
        isRowReorderingEnabled,
        isIssueRankingEnabled,
        setDropTarget,
        isReParentingEnabled,
        createAnalyticsEvent,
        sortDirection,
        onRankIssues,
        cloudId,
        reparent,
        hasCheckboxColumn
    ]);
    const registerDraggableRow = (0, $eJOHy.useCallback)(()=>{
        registerItem(edgeIndex, issueId);
    }, [
        edgeIndex,
        issueId,
        registerItem
    ]);
    const unregisterDraggableRow = (0, $eJOHy.useCallback)(()=>{
        unregisterItem(edgeIndex);
    }, [
        edgeIndex,
        unregisterItem
    ]);
    const attachDraggableRow = (0, $eJOHy.useCallback)((rowElement)=>{
        // If there's an existing ref, clean up before attaching
        cleanupFnRef.current?.();
        if (!rowElement) return;
        cleanupFnRef.current = (0, $dROq6.combine)(attachDraggableElement(rowElement), attachDropTargetElement(rowElement), ()=>{
            // Reset the ref to null so that the cleanup function is not called again
            cleanupFnRef.current = null;
        });
    }, [
        attachDraggableElement,
        attachDropTargetElement
    ]);
    (0, $eJOHy.useEffect)(()=>()=>cleanupFnRef.current?.(), []);
    (0, $eJOHy.useEffect)(()=>{
        registerDraggableRow();
        return ()=>{
            unregisterDraggableRow();
        };
    }, [
        registerDraggableRow,
        unregisterDraggableRow
    ]);
    return isDragAndDropEnabled ? attachDraggableRow : null;
};

});
parcelRegister("iJoDE", function(module, exports) {
$parcel$export(module.exports, "attachInstruction", () => $438e65d4c84faf14$export$267ad49d812c2c7f);
$parcel$export(module.exports, "extractInstruction", () => $438e65d4c84faf14$export$c8ffecbe249dc8f8);

var $d2foH = parcelRequire("d2foH");
// using a symbol so we can guarantee a key with a unique value
const $438e65d4c84faf14$var$uniqueKey = Symbol('tree-item-instruction');
function $438e65d4c84faf14$var$getCenter(rect) {
    return {
        x: (rect.right + rect.left) / 2,
        y: (rect.bottom + rect.top) / 2
    };
}
function $438e65d4c84faf14$var$standardHitbox({ client: client, borderBox: borderBox }) {
    const quarterOfHeight = borderBox.height / 4;
    // In the top 1/4: reorder-above
    // On the line = in the top 1/4 to give this zone a bit more space
    if (client.y <= borderBox.top + quarterOfHeight) return 'reorder-above';
    // In the bottom 1/4: reorder-below
    // On the line = in the bottom 1/4 to give this zone a bit more space
    if (client.y >= borderBox.bottom - quarterOfHeight) return 'reorder-below';
    return 'make-child';
}
function $438e65d4c84faf14$var$getInstruction({ element: element, input: input, currentLevel: currentLevel, indentPerLevel: indentPerLevel, mode: mode }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    if (mode === 'standard') {
        const type = $438e65d4c84faf14$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            type: type,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    const center = $438e65d4c84faf14$var$getCenter(borderBox);
    if (mode === 'expanded') {
        // leveraging "standard" hitbox to ensure that the 'reorder-above' hit zone is
        // exactly the same for "standard" and "expanded" items
        const type = $438e65d4c84faf14$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            // Use the "standard" hitbox for "reorder above",
            // The rest of the item is "make-child"
            type: type === 'reorder-above' ? type : 'make-child',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // `mode` is "last-in-group"
    const visibleInset = indentPerLevel * currentLevel;
    // Before the left edge of the visible item
    if (client.x < borderBox.left + visibleInset) {
        // Above the center: `reorder-above`
        if (client.y < center.y) return {
            type: 'reorder-above',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
        // On or below the center: `reparent`
        // On the center = `reparent` as we are giving a slightly bigger hitbox to this
        // action as it is the only place a user can do it
        const rawLevel = (client.x - borderBox.left) / indentPerLevel;
        // We can get sub pixel negative numbers as getBoundingClientRect gives sub-pixel accuracy,
        // where as clientX is rounded to the nearest pixel.
        // Using Math.max() ensures we can never get a negative level
        const desiredLevel = Math.max(Math.floor(rawLevel), 0);
        return {
            type: 'reparent',
            desiredLevel: desiredLevel,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // On the visible item
    return {
        type: $438e65d4c84faf14$var$standardHitbox({
            borderBox: borderBox,
            client: client
        }),
        indentPerLevel: indentPerLevel,
        currentLevel: currentLevel
    };
}
function $438e65d4c84faf14$var$areInstructionsEqual(a, b) {
    // Shortcut
    if (a.type !== b.type) return false;
    if (a.type === 'instruction-blocked' && b.type === 'instruction-blocked') return $438e65d4c84faf14$var$areInstructionsEqual(a.desired, b.desired);
    return (0, $d2foH.isShallowEqual)(a, b);
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $438e65d4c84faf14$var$memoizeInstruction = (0, $d2foH.stable)($438e65d4c84faf14$var$areInstructionsEqual);
function $438e65d4c84faf14$var$applyInstructionBlock({ desired: desired, block: block }) {
    if (block?.includes(desired.type) && desired.type !== 'instruction-blocked') {
        const blocked = {
            type: 'instruction-blocked',
            desired: desired
        };
        return blocked;
    }
    return desired;
}
function $438e65d4c84faf14$export$267ad49d812c2c7f(userData, { block: block, ...rest }) {
    const desired = $438e65d4c84faf14$var$getInstruction(rest);
    const withBlock = $438e65d4c84faf14$var$applyInstructionBlock({
        desired: desired,
        block: block
    });
    const memoized = $438e65d4c84faf14$var$memoizeInstruction(withBlock);
    return {
        ...userData,
        [$438e65d4c84faf14$var$uniqueKey]: memoized
    };
}
function $438e65d4c84faf14$export$c8ffecbe249dc8f8(userData) {
    return userData[$438e65d4c84faf14$var$uniqueKey] ?? null;
}

});

parcelRegister("1l4lS", function(module, exports) {
$parcel$export(module.exports, "getReorderDestinationIndex", () => $f0909d4a1662ae03$export$846f792f51b92b6e);
function $f0909d4a1662ae03$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}

});

parcelRegister("443cm", function(module, exports) {
$parcel$export(module.exports, "useUpdateParent", () => $7516b102f870f621$export$d767b1cfe1a164d3);

var $jIfSd = parcelRequire("jIfSd");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $kqd31 = parcelRequire("kqd31");

var $cSXp8 = parcelRequire("cSXp8");

var $8Uqf3 = parcelRequire("8Uqf3");

var $3mZMJ = parcelRequire("3mZMJ");

var $3bSs8 = parcelRequire("3bSs8");

var $d2AGn = parcelRequire("d2AGn");

var $aqnJa = parcelRequire("aqnJa");

var $4ctwv = parcelRequire("4ctwv");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4SjAP = parcelRequire("4SjAP");

var $lRq8t = parcelRequire("lRq8t");

var $2ApNu = parcelRequire("2ApNu");

var $4cTDP = parcelRequire("4cTDP");

var $8jOO7 = parcelRequire("8jOO7");

var $8SzGK = parcelRequire("8SzGK");

var $8pBFu = parcelRequire("8pBFu");

var $adrlS = parcelRequire("adrlS");
const $7516b102f870f621$export$d767b1cfe1a164d3 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const intl = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { onIssueReparent: onIssueReparent } = (0, $8SzGK.useEventHandlers)();
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $8pBFu.REPARENTING_EXPERIENCE),
        analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE)
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $8pBFu.REPARENTING_EXPERIENCE)
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $8pBFu.REPARENTING_EXPERIENCE)
    });
    const [commitMutation, loading] = (0, $j4oe4.useMutation)((0, $jIfSd.default));
    const handleError = (0, $eJOHy.useCallback)((error)=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'issueTableReparentMutation',
                packageName: (0, $8jOO7.PACKAGE_NAME),
                teamName: (0, $8jOO7.TEAM_NAME)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail((0, $8jOO7.PACKAGE_NAME), error);
        showFlag((0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG));
    }, [
        onExperienceFail,
        showFlag
    ]);
    const updater = (0, $adrlS.useGetReparentUpdater)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const highlightIssue = (0, $eJOHy.useCallback)(({ issueId: issueId, store: store })=>{
        // Highlight the row
        const issueRelayID = (0, $kqd31.default)({
            id: issueId
        }, (0, $adrlS.JIRA_ISSUE_TYPENAME));
        if (issueRelayID) {
            const node = store.get(issueRelayID);
            if (node) node?.setValue(true, 'isHighlightedIssueRow');
        }
    }, []);
    const reparent = (0, $eJOHy.useCallback)(({ issueId: issueId, issueAri: issueAri, oldParentId: oldParentId, newParentId: newParentId, newParentAri: newParentAri, newParentEdgeId: newParentEdgeId, index: index, projectKey: projectKey, issueKey: issueKey })=>{
        const input = {
            id: issueAri,
            operation: {
                operation: 'SET',
                id: newParentAri
            }
        };
        onExperienceStart();
        if ((0, $4cTDP.fg)('jira_timeline_analytics_harmonization')) (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $3mZMJ.PARENT_TYPE), {
            analytics: createAnalyticsEvent({}),
            attributes: {
                issueId: (0, $2ApNu.JiraIssueAri).parse(issueId).issueId,
                fieldType: (0, $3bSs8.FIELD_TYPE_MAP)[0, $3mZMJ.PARENT_TYPE],
                oldValId: oldParentId,
                newValId: newParentId
            }
        });
        commitMutation({
            variables: {
                input: input
            },
            optimisticUpdater: (store)=>{
                updater({
                    store: store,
                    issueId: issueId,
                    oldParentId: oldParentId,
                    newParentId: newParentId,
                    newParentEdgeId: newParentEdgeId,
                    index: index,
                    projectKey: projectKey
                });
                // Highlight the row
                highlightIssue({
                    store: store,
                    issueId: issueId
                });
            },
            updater: (store, response)=>{
                if (response?.jira?.updateParentField?.success) {
                    updater({
                        store: store,
                        issueId: issueId,
                        oldParentId: oldParentId,
                        newParentId: newParentId,
                        newParentEdgeId: newParentEdgeId,
                        index: index,
                        projectKey: projectKey
                    });
                    highlightIssue({
                        store: store,
                        issueId: issueId
                    });
                    const issueRelayID = (0, $kqd31.default)({
                        id: issueId
                    }, (0, $adrlS.JIRA_ISSUE_TYPENAME));
                    if (issueRelayID) setTimeout(()=>{
                        (0, $j4oe4.commitLocalUpdate)(environment, (currentStore)=>{
                            const node = currentStore.get(issueRelayID);
                            node?.setValue(false, 'isHighlightedIssueRow');
                        });
                    }, (0, $8jOO7.HIGHLIGHT_LINGER_DURATION_MS));
                }
            },
            onCompleted: (response)=>{
                const { errors: errors } = response?.jira?.updateParentField ?? {};
                if (errors && errors.length > 0) {
                    const error = new (0, $4SjAP.MutationError)(errors[0]);
                    const statusCode = error.statusCode;
                    const clientSideErrorMessage = (0, $adrlS.getFlagDetails)(statusCode, intl, issueKey);
                    if (clientSideErrorMessage) {
                        showFlag(clientSideErrorMessage);
                        onExperienceSuccess();
                        return;
                    }
                    handleError(error);
                    return;
                }
                (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue reparented', (0, $8pBFu.ACTION_SUBJECT_ID));
                onExperienceSuccess();
                if (onIssueReparent && (0, $4cTDP.fg)('timeline_rollups_issue_table_callbacks')) {
                    const numericIssueId = (0, $2ApNu.JiraIssueAri).parse(issueId).issueId;
                    onIssueReparent(numericIssueId, oldParentId, newParentId);
                }
            },
            onError: (error)=>{
                const err = new (0, $4SjAP.MutationError)(error);
                handleError(err);
            }
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        environment,
        handleError,
        highlightIssue,
        onExperienceStart,
        onExperienceSuccess,
        onIssueReparent,
        showFlag,
        updater,
        intl
    ]);
    return {
        reparent: reparent,
        loading: loading
    };
};

});
parcelRegister("jIfSd", function(module, exports) {
$parcel$export(module.exports, "default", () => $2189071d41c41ee8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a14b547dc80db979d18a2f6b7caad927>>
 * @relayHash 912b3665801859ed64b357f816488c18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5822dc5c39bb3263eb89e5efb2750a9fb42f5c4f74af60f422e877ecfaac2766
const $2189071d41c41ee8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "JiraParentIssueField",
        "kind": "LinkedField",
        "name": "field",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "reparentMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraParentFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateParentField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "reparentMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraParentFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateParentField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5822dc5c39bb3263eb89e5efb2750a9fb42f5c4f74af60f422e877ecfaac2766",
            "metadata": {},
            "name": "reparentMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$2189071d41c41ee8$var$node.hash = "8010fe7d0e37915f076661fa947a0546";
var $2189071d41c41ee8$export$2e2bcd8739ae039 = $2189071d41c41ee8$var$node;

});

parcelRegister("8pBFu", function(module, exports) {
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG", () => $abcfa65d938eed87$export$e80b28191e1d3602);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG", () => $abcfa65d938eed87$export$29d372313e7a3d7b);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM_GALAXIA", () => $abcfa65d938eed87$export$e40785c138c2ad43);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM", () => $abcfa65d938eed87$export$a75bfbb3fb2f437c);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_404_FLAG", () => $abcfa65d938eed87$export$6a4ca5120f2baf63);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_404_FLAG_WITH_ISSUE_TERM", () => $abcfa65d938eed87$export$4cba4bafd925e182);
$parcel$export(module.exports, "REPARENTING_EXPERIENCE", () => $abcfa65d938eed87$export$4c7c3fa9c49bb0d7);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $abcfa65d938eed87$export$9957974f8b4d8f74);

var $f55DR = parcelRequire("f55DR");
const $abcfa65d938eed87$export$e80b28191e1d3602 = {
    type: 'error',
    title: (0, $f55DR.default).updateIssueParentErrorTitle,
    description: (0, $f55DR.default).updateIssueParentGenericErrorDescription,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-generic-flag.error.flag.update-item-parent-fail-generic',
    messageType: 'transactional'
};
const $abcfa65d938eed87$export$29d372313e7a3d7b = {
    type: 'error',
    title: (0, $f55DR.default).updateIssueParentErrorTitle,
    description: (0, $f55DR.default).updateIssueParent400ErrorDescription,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-400-flag.error.flag.update-issue-parent400error',
    messageType: 'transactional'
};
const $abcfa65d938eed87$export$e40785c138c2ad43 = {
    type: 'error',
    title: (0, $f55DR.default).updateIssueParentErrorTitle,
    description: (0, $f55DR.default).updateIssueParent400ErrorDescriptionIssueTermRefreshGalaxia,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-400-flag-with-issue-term-galaxia.error',
    messageType: 'transactional'
};
const $abcfa65d938eed87$export$a75bfbb3fb2f437c = {
    type: 'error',
    title: (0, $f55DR.default).updateIssueParentErrorTitle,
    description: (0, $f55DR.default).updateIssueParent400ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-400-flag-with-issue-term.error.flag.update-issue-parent400error-issue-term-refresh',
    messageType: 'transactional'
};
const $abcfa65d938eed87$export$6a4ca5120f2baf63 = {
    type: 'error',
    title: (0, $f55DR.default).updateIssueParentErrorTitle,
    description: (0, $f55DR.default).updateIssueParent404ErrorDescription,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-404-flag.error.flag.update-issue-parent404error',
    messageType: 'transactional'
};
const $abcfa65d938eed87$export$4cba4bafd925e182 = {
    type: 'error',
    title: (0, $f55DR.default).updateIssueParentErrorTitle,
    description: (0, $f55DR.default).updateIssueParent404ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-404-flag-with-issue-term.error.flag.update-issue-parent404error-issue-term-refresh',
    messageType: 'transactional'
};
const $abcfa65d938eed87$export$4c7c3fa9c49bb0d7 = 'updateParent';
const $abcfa65d938eed87$export$11823571c61d4d02 = 'SUCCEEDED';
const $abcfa65d938eed87$export$d71930f7f5807a72 = 'FAILED';
const $abcfa65d938eed87$export$f3390a0e172fee41 = 'useUpdateParent';
const $abcfa65d938eed87$export$9957974f8b4d8f74 = 'issueTableUpdateIssueParent';

});
parcelRegister("f55DR", function(module, exports) {
$parcel$export(module.exports, "default", () => $60f7f21fe7d4c781$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $60f7f21fe7d4c781$var$messages = (0, $7qGN1.defineMessages)({
    updateIssueParentErrorTitle: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-error-title",
        "defaultMessage": "Something's gone wrong"
    },
    updateIssueParentGenericErrorDescription: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-generic-error-description",
        "defaultMessage": "Refresh the page and try again."
    },
    updateIssueParent400ErrorDescription: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-description",
        "defaultMessage": "You don\u2019t have permission to update this issue. Contact a project admin."
    },
    updateIssueParent404ErrorDescription: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-404-error-description",
        "defaultMessage": "We\u2019re having trouble updating this issue. To continue, refresh the page."
    },
    updateIssueParent400ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-description-issue-term-refresh",
        "defaultMessage": "You don\u2019t have permission to update this work item. Contact a project admin."
    },
    updateIssueParent400ErrorTitleIssueTerminologyRefreshM4: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-title-issue-terminology-refresh-m4",
        "defaultMessage": "You don\u2019t have permission to update {issueKey}"
    },
    updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-description-issue-terminology-refresh-m4",
        "defaultMessage": "Contact your project admin."
    },
    updateIssueParent404ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-404-error-description-issue-term-refresh",
        "defaultMessage": "We\u2019re having trouble updating this work item. To continue, refresh the page."
    },
    updateIssueParent404ErrorTitleIssueTerminologyRefreshM4: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-404-error-title-issue-terminology-refresh-m4",
        "defaultMessage": "We\u2019re having trouble updating {issueKey}"
    },
    updateIssueParent404ErrorDescriptionIssueTerminologyRefreshM4: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-404-error-description-issue-terminology-refresh-m4",
        "defaultMessage": "Refresh and try again."
    },
    updateIssueParent400ErrorDescriptionIssueTermRefreshGalaxia: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-description-issue-term-refresh-galaxia",
        "defaultMessage": "You don\u2019t have permission to update this work item. Contact a space admin."
    },
    updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4Galaxia: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-description-issue-terminology-refresh-m4-galaxia",
        "defaultMessage": "Contact your space admin."
    }
});
var $60f7f21fe7d4c781$export$2e2bcd8739ae039 = $60f7f21fe7d4c781$var$messages;

});


parcelRegister("adrlS", function(module, exports) {
$parcel$export(module.exports, "getFlagDetails", () => $d54f04439f880b90$export$e0141c03826f0c2c);
$parcel$export(module.exports, "JIRA_ISSUE_TYPENAME", () => $d54f04439f880b90$export$8df31253ff7294c9);
$parcel$export(module.exports, "useGetReparentUpdater", () => $d54f04439f880b90$export$b3f12c98c1f443a);

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");

var $cxKOj = parcelRequire("cxKOj");

var $kqd31 = parcelRequire("kqd31");

var $dLXgn = parcelRequire("dLXgn");

var $57Nys = parcelRequire("57Nys");

var $f55DR = parcelRequire("f55DR");

var $8pBFu = parcelRequire("8pBFu");
const $d54f04439f880b90$export$e0141c03826f0c2c = (statusCode, intl, issueKey)=>{
    switch(statusCode){
        case 400:
            if (issueKey && (0, $cxKOj.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return $d54f04439f880b90$export$2aa1f96ba5bf0010(intl, issueKey);
            if ((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) {
                if ((0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false)) return 0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM_GALAXIA;
                return 0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM;
            }
            return 0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_400_FLAG;
        case 404:
            if (issueKey && (0, $cxKOj.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return $d54f04439f880b90$export$c7d107a3107d23fd(intl, issueKey);
            return (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_404_FLAG_WITH_ISSUE_TERM) : (0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_404_FLAG);
        default:
            return null;
    }
};
const $d54f04439f880b90$export$2aa1f96ba5bf0010 = (intl, issueKey)=>{
    const updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4Galaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $f55DR.default).updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4Galaxia : (0, $f55DR.default).updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4;
    return {
        type: 'error',
        title: intl.formatMessage((0, $f55DR.default).updateIssueParent400ErrorTitleIssueTerminologyRefreshM4, {
            issueKey: issueKey
        }),
        description: intl.formatMessage(updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4Galaxia, {
            issueKey: issueKey
        }),
        messageId: 'native-issue-table.services.reparent-mutation.flag.error.update-item-parent-fail-generic-flag.error.flag.update-item-parent-fail-generic.1.1',
        messageType: 'transactional'
    };
};
const $d54f04439f880b90$export$c7d107a3107d23fd = (intl, issueKey)=>{
    return {
        type: 'error',
        title: intl.formatMessage((0, $f55DR.default).updateIssueParent404ErrorTitleIssueTerminologyRefreshM4, {
            issueKey: issueKey
        }),
        description: intl.formatMessage((0, $f55DR.default).updateIssueParent404ErrorDescriptionIssueTerminologyRefreshM4, {
            issueKey: issueKey
        }),
        messageId: 'native-issue-table.services.reparent-mutation.flag.error.update-item-parent-fail-generic-flag.error.flag.update-item-parent-fail-generic.1.1.1',
        messageType: 'transactional'
    };
};
const $d54f04439f880b90$export$8df31253ff7294c9 = 'JiraIssue';
const $d54f04439f880b90$export$b3f12c98c1f443a = ()=>{
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const updateConnectionDetails = (0, $57Nys.useUpdateConnectionDetails)();
    const getConection = (0, $eJOHy.useCallback)(({ issueId: issueId })=>Object.values(connections).find((connection)=>{
            if (issueId) return connection.type === 'PARENT_CHILDREN' && connection.parentId === issueId;
            return connection.type === 'ROOT_ISSUES';
        }), [
        connections
    ]);
    const updater = (0, $eJOHy.useCallback)(({ store: store, issueId: issueId, oldParentId: oldParentId, newParentId: newParentId, newParentEdgeId: newParentEdgeId, index: index = 0, projectKey: projectKey })=>{
        const relayId = (0, $kqd31.default)({
            id: issueId
        }, $d54f04439f880b90$export$8df31253ff7294c9);
        if (!relayId) return;
        const oldConnection = getConection({
            issueId: oldParentId
        });
        const newConnection = getConection({
            issueId: newParentId
        });
        if (!oldConnection) // Since the issue has to be visible to be repartented, this case should not occur
        return;
        const oldConnectionRecord = store.get(oldConnection.connectionId);
        if (!oldConnectionRecord) return;
        if (newParentEdgeId) (0, $57Nys.updateParentHasChildren)({
            store: store,
            parentIssueEdgeRecordId: newParentEdgeId,
            connectionId: newConnection?.connectionId,
            hasChildren: true,
            projectKey: projectKey
        });
        if (newConnection) {
            const newConnectionRecord = store.get(newConnection.connectionId);
            if (!newConnectionRecord) return;
            const existingEdge = oldConnectionRecord.getLinkedRecords('edges')?.find((edge)=>edge?.getLinkedRecord('node')?.getDataID() === relayId);
            // no before or after implies an empty conneciton, verify then create the edges list
            const { EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
            const edges = newConnectionRecord.getLinkedRecords(EDGES);
            if (!edges || !existingEdge) return;
            const nextEdges = edges.slice(0, index).concat(existingEdge).concat(edges.slice(index));
            newConnectionRecord.setLinkedRecords(nextEdges, EDGES);
            updateConnectionDetails({
                store: store,
                connection: newConnection,
                netChangeInIssueCount: 1,
                remainingIssueCount: newConnectionRecord.getLinkedRecords('edges')?.length,
                projectKey: projectKey
            });
        }
        if (oldConnection) // remove the issue from the old connection
        {
            if (oldConnectionRecord.getLinkedRecords('edges')?.some((edge)=>edge?.getLinkedRecord('node')?.getDataID() === relayId)) {
                (0, $37Ewn.ConnectionHandler).deleteNode(oldConnectionRecord, relayId);
                updateConnectionDetails({
                    store: store,
                    connection: oldConnection,
                    netChangeInIssueCount: -1,
                    remainingIssueCount: oldConnectionRecord.getLinkedRecords('edges')?.length,
                    projectKey: projectKey
                });
            }
        }
    }, [
        getConection,
        updateConnectionDetails
    ]);
    return updater;
};

});


parcelRegister("j5Wzv", function(module, exports) {
$parcel$export(module.exports, "useIssuesRanker", () => $5e8d51b9b9659210$export$40f5e450e8552c78);

var $3S53J = parcelRequire("3S53J");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $isfFo = parcelRequire("isfFo");

var $ftN6c = parcelRequire("ftN6c");

var $8Uqf3 = parcelRequire("8Uqf3");

var $aqnJa = parcelRequire("aqnJa");

var $4ctwv = parcelRequire("4ctwv");

var $4cTDP = parcelRequire("4cTDP");

var $cSXp8 = parcelRequire("cSXp8");

var $3mZMJ = parcelRequire("3mZMJ");

var $3bSs8 = parcelRequire("3bSs8");

var $d2AGn = parcelRequire("d2AGn");

var $4SjAP = parcelRequire("4SjAP");

var $kRgKj = parcelRequire("kRgKj");

var $2ApNu = parcelRequire("2ApNu");

var $8jOO7 = parcelRequire("8jOO7");

var $kfIml = parcelRequire("kfIml");

var $dPwlR = parcelRequire("dPwlR");

var $1jyN6 = parcelRequire("1jyN6");

var $ikiN2 = parcelRequire("ikiN2");
const $5e8d51b9b9659210$var$getRankMutationEdge = (edge)=>{
    switch(edge){
        case 'top':
            return 'TOP';
        case 'bottom':
            return 'BOTTOM';
        default:
            // Unsupported edge
            return null;
    }
};
const $5e8d51b9b9659210$export$40f5e450e8552c78 = ()=>{
    const [issueConnectionId] = (0, $kfIml.useDraggableRowsConnectionId)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $dPwlR.RE_RANKING_EXPERIENCE),
        analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE)
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $dPwlR.RE_RANKING_EXPERIENCE)
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $dPwlR.RE_RANKING_EXPERIENCE)
    });
    const [rankIssuesMutation] = (0, $j4oe4.useMutation)((0, $3S53J.default));
    const showErrorFlag = (0, $eJOHy.useCallback)(()=>{
        showFlag({
            type: 'error',
            title: (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $ikiN2.default).reorderErrorTitleIssueTermRefresh : (0, $ikiN2.default).reorderErrorTitle,
            description: (0, $ikiN2.default).reorderErrorDescription,
            isAutoDismiss: true,
            messageId: 'native-issue-table.services.rank-mutation.show-flag.error.use-issues-ranker.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag
    ]);
    const reorderIssuesUpdater = (0, $eJOHy.useCallback)((store, startIndex, finishIndex)=>{
        const issueConnection = store.get(issueConnectionId);
        if (!issueConnection) return;
        const edges = issueConnection.getLinkedRecords('edges');
        if (!edges) return;
        const reorderedEdges = (0, $isfFo.reorder)({
            list: edges,
            startIndex: startIndex,
            finishIndex: finishIndex
        });
        issueConnection.setLinkedRecords(reorderedEdges, 'edges');
    }, [
        issueConnectionId
    ]);
    const handleError = (0, $eJOHy.useCallback)((error)=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'commitRankIssuesMutationError',
                packageName: (0, $8jOO7.PACKAGE_NAME),
                teamName: (0, $8jOO7.TEAM_NAME)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail((0, $8jOO7.PACKAGE_NAME), error);
        showErrorFlag();
    }, [
        onExperienceFail,
        showErrorFlag
    ]);
    const rankIssues = (0, $eJOHy.useCallback)((payload)=>{
        const { source: source, destination: destination, edge: edge } = payload;
        const rankMutationEdge = $5e8d51b9b9659210$var$getRankMutationEdge(edge);
        onExperienceStart();
        // 1event does not currently support bulk analytics
        if ((0, $4cTDP.fg)('jira_timeline_analytics_harmonization')) {
            if (payload.source.issueIds.length === 1) (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $3mZMJ.RANK_CF_TYPE), {
                analytics: createAnalyticsEvent({}),
                attributes: {
                    issueId: (0, $2ApNu.JiraIssueAri).parse(payload.source.issueIds[0]).issueId,
                    fieldType: (0, $3bSs8.FIELD_TYPE_MAP)[0, $3mZMJ.RANK_CF_TYPE]
                }
            });
        }
        if (rankMutationEdge == null) {
            showErrorFlag();
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'commitRankIssuesError',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                },
                error: new Error(`Edge "${edge}" is unsupported in JiraMutation.rankIssues`),
                sendToPrivacyUnsafeSplunk: true
            });
            return;
        }
        rankIssuesMutation({
            variables: {
                rankInput: {
                    issues: source.issueIds,
                    relativeToIssue: destination.relativeToIssueId,
                    edge: rankMutationEdge
                }
            },
            optimisticUpdater (store) {
                reorderIssuesUpdater(store, source.rowIndex, destination.rowIndex);
            },
            updater (store, data) {
                // Rollback update if mutation fails
                if (!data?.jira?.rankIssues?.success) return;
                reorderIssuesUpdater(store, source.rowIndex, destination.rowIndex);
            },
            onCompleted (data) {
                const { errors: errors } = data?.jira?.rankIssues ?? {};
                if (errors && errors.length > 0) {
                    const error = new (0, $4SjAP.MutationError)(errors[0]);
                    const statusCode = error.statusCode;
                    const clientSideErrorMessage = (0, $1jyN6.getFlagDetails)(statusCode);
                    if (clientSideErrorMessage) {
                        showFlag(clientSideErrorMessage);
                        onExperienceSuccess();
                        return;
                    }
                    handleError(error);
                    return;
                }
                if (!data.jira?.rankIssues?.success) {
                    const error = new Error(errors?.[0]?.message ?? 'Failed to reorder issues: Unknown Error occurred');
                    handleError(error);
                    return;
                }
                onExperienceSuccess();
                (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue updated', 'issueTableUpdateIssueRank');
            },
            onError (error) {
                handleError(error);
            }
        });
    }, [
        createAnalyticsEvent,
        handleError,
        onExperienceStart,
        onExperienceSuccess,
        rankIssuesMutation,
        reorderIssuesUpdater,
        showErrorFlag,
        showFlag
    ]);
    return rankIssues;
};

});
parcelRegister("3S53J", function(module, exports) {
$parcel$export(module.exports, "default", () => $99f8f175dd3fbd81$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e8dca5785751aa5f70f854c54040a53f>>
 * @relayHash 3c50fcdcb26a2dd5e3d81a1c04369a89
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b99aeae9f0df6a7bca9414b7ce6f013700af4287f820cc74b0dfd95403d65cb2
const $99f8f175dd3fbd81$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "rankInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "rankInput",
            "variableName": "rankInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIssuesRankerMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRankMutationPayload",
                            "kind": "LinkedField",
                            "name": "rankIssues",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIssuesRankerMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRankMutationPayload",
                            "kind": "LinkedField",
                            "name": "rankIssues",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b99aeae9f0df6a7bca9414b7ce6f013700af4287f820cc74b0dfd95403d65cb2",
            "metadata": {},
            "name": "useIssuesRankerMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$99f8f175dd3fbd81$var$node.hash = "824e5e71233747b29ef715625b9350f2";
var $99f8f175dd3fbd81$export$2e2bcd8739ae039 = $99f8f175dd3fbd81$var$node;

});

parcelRegister("dPwlR", function(module, exports) {
$parcel$export(module.exports, "REORDER_ITEM_FAIL_400_FLAG", () => $411491f5dedc5b65$export$c58c5fc634df2e30);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM_GALAXIA", () => $411491f5dedc5b65$export$ecb799b5eeb91e4e);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM", () => $411491f5dedc5b65$export$d37d45ebdf6e6be4);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_404_FLAG", () => $411491f5dedc5b65$export$d9fdb4939efc3fa9);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_404_FLAG_WITH_ISSUE_TERM", () => $411491f5dedc5b65$export$83a2ceb0732d655a);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_409_FLAG", () => $411491f5dedc5b65$export$3b5b9901de703a5a);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_409_FLAG_WITH_ISSUE_TERM", () => $411491f5dedc5b65$export$b57a01d3fd8405a5);
$parcel$export(module.exports, "RE_RANKING_EXPERIENCE", () => $411491f5dedc5b65$export$cb50c1de8dfcf0a5);

var $ikiN2 = parcelRequire("ikiN2");
const $411491f5dedc5b65$export$9aa93234f179f11b = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitle,
    description: (0, $ikiN2.default).reorderErrorDescription,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-generic-flag.error.update-item-parent-fail-generic-flag.error.reparent-mutation.update-item-parent-fail-generic-flag.error.flag.update-item-parent-fail-generic',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$c58c5fc634df2e30 = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitle,
    description: (0, $ikiN2.default).reorderIssue400ErrorDescription,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-400-flag.error.update-item-parent-fail-400-flag.error.reparent-mutation.update-item-parent-fail-400-flag.error.flag.update-issue-parent400error',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$ecb799b5eeb91e4e = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitleIssueTermRefresh,
    description: (0, $ikiN2.default).reorderIssue400ErrorDescriptionIssueTermRefreshGalaxia,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-400-flag-with-issue-term-galaxia.error.reorder-item-fail-400-flag-with-issue-term-gal-axia.error.reorder-item-fail-400-flag-with-issue-term.error.update-item-parent-fail-400-flag-with-issue-term.error.reparent-mutation.update-item-parent-fail-400-flag-with-issue-term.error.flag.update-issue-parent400error-issue-term-refresh-galaxia',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$d37d45ebdf6e6be4 = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitleIssueTermRefresh,
    description: (0, $ikiN2.default).reorderIssue400ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-400-flag-with-issue-term.error.update-item-parent-fail-400-flag-with-issue-term.error.reparent-mutation.update-item-parent-fail-400-flag-with-issue-term.error.flag.update-issue-parent400error-issue-term-refresh',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$d9fdb4939efc3fa9 = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitle,
    description: (0, $ikiN2.default).reorderIssue404ErrorDescription,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-404-flag.error.update-item-parent-fail-404-flag.error.reparent-mutation.update-item-parent-fail-404-flag.error.flag.update-issue-parent404error',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$83a2ceb0732d655a = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitleIssueTermRefresh,
    description: (0, $ikiN2.default).reorderIssue404ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-404-flag-with-issue-term.error.update-item-parent-fail-404-flag-with-issue-term.error.reparent-mutation.update-item-parent-fail-404-flag-with-issue-term.error.flag.update-issue-parent404error-issue-term-refresh',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$3b5b9901de703a5a = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitle,
    description: (0, $ikiN2.default).reorderIssue409ErrorDescription,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-409-flag.error.reorder-item-fail-404-flag.error.update-item-parent-fail-404-flag.error.reparent-mutation.update-item-parent-fail-404-flag.error.flag.update-issue-parent404error',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$b57a01d3fd8405a5 = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitleIssueTermRefresh,
    description: (0, $ikiN2.default).reorderIssue409ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-409-flag-with-issue-term.error.reorder-item-fail-404-flag-with-issue-term.error.update-item-parent-fail-404-flag-with-issue-term.error.reparent-mutation.update-item-parent-fail-404-flag-with-issue-term.error.flag.update-issue-parent404error-issue-term-refresh',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$cb50c1de8dfcf0a5 = 'reRankIssue';

});
parcelRegister("ikiN2", function(module, exports) {
$parcel$export(module.exports, "default", () => $22f0324d073f2689$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $22f0324d073f2689$var$messages = (0, $7qGN1.defineMessages)({
    reorderErrorTitle: {
        "id": "native-issue-table.services.rank-mutation.reorder-error-title",
        "defaultMessage": "We couldn't reorder those issues"
    },
    reorderErrorDescription: {
        "id": "native-issue-table.services.rank-mutation.reorder-error-description",
        "defaultMessage": "Wait a few moments, then give it another try."
    },
    reorderErrorTitleIssueTermRefresh: {
        "id": "native-issue-table.services.rank-mutation.reorder-error-title-issue-term-refresh",
        "defaultMessage": "We couldn't reorder those work items"
    },
    reorderIssue400ErrorDescription: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-400-error-description",
        "defaultMessage": "You don\u2019t have permission to reorder this issue. Contact a project admin."
    },
    reorderIssue404ErrorDescription: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-404-error-description",
        "defaultMessage": "We\u2019re having trouble reordering this issue. To continue, refresh the page."
    },
    reorderIssue409ErrorDescription: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-409-error-description",
        "defaultMessage": "There was a conflict reordering those issues. Please try again."
    },
    reorderIssue400ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-400-error-description-issue-term-refresh",
        "defaultMessage": "You don\u2019t have permission to reorder this work item. Contact a project admin."
    },
    reorderIssue404ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-404-error-description-issue-term-refresh",
        "defaultMessage": "We\u2019re having trouble reordering this work item. To continue, refresh the page."
    },
    reorderIssue409ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-409-error-description-issue-term-refresh",
        "defaultMessage": "There was a conflict reordering those work items. Please try again."
    },
    reorderIssue400ErrorDescriptionIssueTermRefreshGalaxia: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-400-error-description-issue-term-refresh-galaxia",
        "defaultMessage": "You don\u2019t have permission to reorder this work item. Contact a space admin."
    }
});
var $22f0324d073f2689$export$2e2bcd8739ae039 = $22f0324d073f2689$var$messages;

});


parcelRegister("1jyN6", function(module, exports) {
$parcel$export(module.exports, "getFlagDetails", () => $fb1754413aaa4816$export$e0141c03826f0c2c);

var $4cTDP = parcelRequire("4cTDP");

var $cxKOj = parcelRequire("cxKOj");

var $dPwlR = parcelRequire("dPwlR");
const $fb1754413aaa4816$export$e0141c03826f0c2c = (statusCode)=>{
    switch(statusCode){
        case 400:
            if ((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3')) {
                if ((0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false)) return 0, $dPwlR.REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM_GALAXIA;
                return 0, $dPwlR.REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM;
            }
            return 0, $dPwlR.REORDER_ITEM_FAIL_400_FLAG;
        case 404:
            return (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $dPwlR.REORDER_ITEM_FAIL_404_FLAG_WITH_ISSUE_TERM) : (0, $dPwlR.REORDER_ITEM_FAIL_404_FLAG);
        case 409:
            return (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $dPwlR.REORDER_ITEM_FAIL_409_FLAG_WITH_ISSUE_TERM) : (0, $dPwlR.REORDER_ITEM_FAIL_409_FLAG);
        default:
            return null;
    }
};

});


parcelRegister("15Apk", function(module, exports) {
$parcel$export(module.exports, "getEdgeForRerank", () => $c1d6810499cb70fa$export$6bd827e42c9b2c6f);
const $c1d6810499cb70fa$export$6bd827e42c9b2c6f = (sourceIndex, destinationIndex, sortDirection)=>{
    // When sorting DESC, the visual direction is inverted
    // Moving up visually (lower index) means moving down in ascending order
    if (sortDirection === 'DESC') return sourceIndex > destinationIndex ? 'bottom' : 'top';
    // ASC: normal logic
    return sourceIndex > destinationIndex ? 'top' : 'bottom';
};

});

parcelRegister("jNv5I", function(module, exports) {
$parcel$export(module.exports, "useRowContext", () => $ab12d7ac2653f245$export$7a486b5630cc7522);
$parcel$export(module.exports, "RowContextProvider", () => $ab12d7ac2653f245$export$81ecc1ee96e0504e);

var $eJOHy = parcelRequire("eJOHy");
const $ab12d7ac2653f245$var$RowContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $ab12d7ac2653f245$export$7a486b5630cc7522 = ()=>{
    const context = (0, $eJOHy.useContext)($ab12d7ac2653f245$var$RowContext);
    if (!context) throw new Error('useRowContext must be used within RowContextProvider');
    return context;
};
const $ab12d7ac2653f245$export$81ecc1ee96e0504e = ({ children: children, columns: columns, tableInjectedProps: tableInjectedProps, renderChildRows: renderChildRows, groupId: groupId, groupConnectionId: groupConnectionId, resizingColumnIndex: resizingColumnIndex })=>{
    const props = (0, $eJOHy.useMemo)(()=>({
            columns: columns,
            tableInjectedProps: tableInjectedProps,
            renderChildRows: renderChildRows,
            groupId: groupId,
            groupConnectionId: groupConnectionId,
            resizingColumnIndex: resizingColumnIndex
        }), [
        columns,
        tableInjectedProps,
        renderChildRows,
        groupId,
        groupConnectionId,
        resizingColumnIndex
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ab12d7ac2653f245$var$RowContext.Provider, {
        value: props
    }, children);
};

});

parcelRegister("t5ecZ", function(module, exports) {
$parcel$export(module.exports, "getBlockedInstructions", () => $f79d815e41b917a5$export$44539271c2e3abc8);
$parcel$export(module.exports, "getBlockedInstructionsOld", () => $f79d815e41b917a5$export$704f71e2437b55b4);

var $lBtjB = parcelRequire("lBtjB");

var $8jOO7 = parcelRequire("8jOO7");
const $f79d815e41b917a5$export$acc17f62bededcaf = ({ dropTarget: dropTarget, draggedItem: draggedItem, isIssueRankingEnabled: isIssueRankingEnabled })=>{
    const draggedItemLevel = draggedItem?.hierarchyLevel;
    const dropTargetLevel = dropTarget?.hierarchyLevel;
    const draggedItemHasParent = !!draggedItem?.parentIssueAri;
    const dropTargetHasParent = !!dropTarget?.parentIssueAri;
    const draggedItemGrouping = draggedItem?.groupId;
    const dropTargetGrouping = dropTarget?.groupId;
    // CASE 1: Grouping information does not match
    if (draggedItemGrouping !== dropTargetGrouping) return {
        [(0, $8jOO7.COMBINE)]: 'blocked',
        [(0, $8jOO7.REORDER_BEFORE)]: 'blocked',
        [(0, $8jOO7.REORDER_AFTER)]: 'blocked'
    };
    // CASE 2: Both items have no hierarchy information
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(dropTargetLevel) || !(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(draggedItemLevel)) {
        // Still consider if they're are in the first depth, but prevent combining
        if (dropTarget?.depth === 0 && draggedItem?.depth === 0) return {
            [(0, $8jOO7.COMBINE)]: 'not-available',
            [(0, $8jOO7.REORDER_BEFORE)]: 'available',
            [(0, $8jOO7.REORDER_AFTER)]: 'available'
        };
        return {
            [(0, $8jOO7.COMBINE)]: 'available',
            [(0, $8jOO7.REORDER_BEFORE)]: 'available',
            [(0, $8jOO7.REORDER_AFTER)]: 'available'
        };
    }
    const draggedItemParentIsDropTarget = String(dropTarget?.issueId) === String(draggedItem?.parentIssueAri);
    const isSiblingOfDropTarget = String(dropTarget?.parentIssueAri) === String(draggedItem?.parentIssueAri);
    const droppingToSameParent = draggedItem?.parentIssueAri !== '' && draggedItem?.parentIssueAri != null && (isSiblingOfDropTarget || draggedItemParentIsDropTarget);
    // CASE 3: Both items have parent information
    if (droppingToSameParent) {
        if (isIssueRankingEnabled && isSiblingOfDropTarget) return {
            [(0, $8jOO7.COMBINE)]: 'blocked',
            [(0, $8jOO7.REORDER_BEFORE)]: 'available',
            [(0, $8jOO7.REORDER_AFTER)]: 'available'
        };
        if (draggedItemParentIsDropTarget && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) return {
            [(0, $8jOO7.COMBINE)]: 'blocked',
            [(0, $8jOO7.REORDER_BEFORE)]: 'available',
            [(0, $8jOO7.REORDER_AFTER)]: 'available'
        };
        return {
            [(0, $8jOO7.COMBINE)]: 'blocked',
            [(0, $8jOO7.REORDER_BEFORE)]: 'blocked',
            [(0, $8jOO7.REORDER_AFTER)]: 'blocked'
        };
    }
    // CASE 4: Reparenting if there's a difference in hierarchy levels
    if (dropTargetLevel !== draggedItemLevel + 1) {
        // If drop target is of same level as drag item and drop target has parent,
        // do not block reorder as we are reordering to reparent
        if (dropTargetLevel === draggedItemLevel && dropTargetHasParent) return {
            [(0, $8jOO7.COMBINE)]: 'blocked',
            [(0, $8jOO7.REORDER_BEFORE)]: 'available',
            [(0, $8jOO7.REORDER_AFTER)]: 'available'
        };
        // If we are dropping to a top level issue (unparenting or reranking), we should not block reordering
        if (dropTarget?.depth === 0 && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) {
            if (draggedItemHasParent || isIssueRankingEnabled) return {
                [(0, $8jOO7.COMBINE)]: 'blocked',
                [(0, $8jOO7.REORDER_BEFORE)]: 'available',
                [(0, $8jOO7.REORDER_AFTER)]: 'available'
            };
        }
        if (draggedItemLevel === (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) return {
            [(0, $8jOO7.COMBINE)]: 'blocked',
            [(0, $8jOO7.REORDER_BEFORE)]: 'blocked',
            [(0, $8jOO7.REORDER_AFTER)]: 'blocked'
        };
        // Any other actions is an invalid drop onto an item
        return {
            [(0, $8jOO7.COMBINE)]: 'blocked',
            [(0, $8jOO7.REORDER_BEFORE)]: 'blocked',
            [(0, $8jOO7.REORDER_AFTER)]: 'blocked'
        };
    }
    // CASE 5: We cannot unparent a subtask that does not have a parent
    if (draggedItemLevel === (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) return {
        [(0, $8jOO7.COMBINE)]: 'available',
        [(0, $8jOO7.REORDER_BEFORE)]: 'blocked',
        [(0, $8jOO7.REORDER_AFTER)]: 'blocked'
    };
    // CASE 6: Unparenting any non-subtask
    if (dropTarget?.depth === 0 && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL) && draggedItemHasParent) return {
        [(0, $8jOO7.COMBINE)]: 'available',
        [(0, $8jOO7.REORDER_BEFORE)]: 'available',
        [(0, $8jOO7.REORDER_AFTER)]: 'available'
    };
    // Default case: Drop target is valid
    return {
        [(0, $8jOO7.COMBINE)]: 'available',
        [(0, $8jOO7.REORDER_BEFORE)]: 'available',
        [(0, $8jOO7.REORDER_AFTER)]: 'available'
    };
};
const $f79d815e41b917a5$export$44539271c2e3abc8 = ({ dropTarget: dropTarget, draggedItem: draggedItem, isIssueRankingEnabled: isIssueRankingEnabled })=>{
    const draggedItemLevel = draggedItem?.hierarchyLevel;
    const dropTargetLevel = dropTarget?.hierarchyLevel;
    const dragItemHasParent = !!draggedItem?.parentIssueAri;
    const dropTargetHasParent = !!dropTarget?.parentIssueAri;
    const draggedItemGrouping = draggedItem?.groupId;
    const dropTargeGrouping = dropTarget?.groupId;
    if (draggedItemGrouping !== dropTargeGrouping) return [
        (0, $8jOO7.MAKE_CHILD),
        (0, $8jOO7.REORDER_BELOW),
        (0, $8jOO7.REORDER_ABOVE)
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(dropTargetLevel) || !(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(draggedItemLevel)) return [];
    const dragItemParentIsDropTarget = String(dropTarget?.issueId) === String(draggedItem?.parentIssueAri);
    const isSiblingOfDropTarget = String(dropTarget?.parentIssueAri) === String(draggedItem?.parentIssueAri);
    const droppingToSameParent = // Do not take into account when both drag item and drop target do not have parent, in which case
    // they have an equal parent value but is not reparenting to same parent
    draggedItem?.parentIssueAri !== '' && draggedItem?.parentIssueAri != null && (isSiblingOfDropTarget || dragItemParentIsDropTarget);
    if (droppingToSameParent) {
        if (isIssueRankingEnabled && isSiblingOfDropTarget) return [
            (0, $8jOO7.MAKE_CHILD)
        ];
        if (dragItemParentIsDropTarget && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) return [
            (0, $8jOO7.MAKE_CHILD)
        ];
        return [
            (0, $8jOO7.MAKE_CHILD),
            (0, $8jOO7.REORDER_BELOW),
            (0, $8jOO7.REORDER_ABOVE)
        ];
    }
    // if the difference is not of one level up, we could be reparenting by dragging
    if (dropTargetLevel !== draggedItemLevel + 1) {
        // If drop target is of same level as drag item and drop target has parent,
        // do not block reorder as we are reordering to reparent
        if (dropTargetLevel === draggedItemLevel && dropTargetHasParent) return [
            (0, $8jOO7.MAKE_CHILD)
        ];
        // If we are dropping to a top level issue (unparenting or reranking), we should not block reordering
        if (dropTarget?.depth === 0 && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) {
            if (dragItemHasParent || isIssueRankingEnabled) return [
                (0, $8jOO7.MAKE_CHILD)
            ];
        }
        if (draggedItemLevel === (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) return [
            (0, $8jOO7.MAKE_CHILD),
            (0, $8jOO7.REORDER_BELOW),
            (0, $8jOO7.REORDER_ABOVE)
        ];
        // Any other actions is an invalid drop onto an item
        return [
            (0, $8jOO7.MAKE_CHILD),
            (0, $8jOO7.REORDER_BELOW),
            (0, $8jOO7.REORDER_ABOVE)
        ];
    }
    // we cannot unparent a subtask nor an item that already does not have a parent
    if (draggedItemLevel === (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) return [
        (0, $8jOO7.REORDER_BELOW),
        (0, $8jOO7.REORDER_ABOVE)
    ];
    // Unparenting any non-subtask issue type
    if (dropTarget?.depth === 0 && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL) && dragItemHasParent) return [];
    // we are dropping to a valid parent
    return [];
};
const $f79d815e41b917a5$export$704f71e2437b55b4 = ({ dropTarget: dropTarget, draggedItem: draggedItem, isRowReorderingEnabled: isRowReorderingEnabled })=>{
    // We don't support reordering and reparenting
    if (isRowReorderingEnabled) return [
        (0, $8jOO7.MAKE_CHILD)
    ];
    const draggedItemLevel = draggedItem?.hierarchyLevel;
    const dropTargetLevel = dropTarget?.hierarchyLevel;
    const dragItemHasParent = !!draggedItem?.parentIssueAri;
    const dropTargetHasParent = !!dropTarget?.parentIssueAri;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(dropTargetLevel) || !(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(draggedItemLevel)) return [];
    const dragItemParentIsDropTarget = String(dropTarget?.issueId) === String(draggedItem?.parentIssueAri);
    const isSiblingOfDropTarget = String(dropTarget?.parentIssueAri) === String(draggedItem?.parentIssueAri);
    const droppingToSameParent = // Do not take into account when both drag item and drop target do not have parent, in which case
    // they have an equal parent value but is not reparenting to same parent
    draggedItem?.parentIssueAri !== '' && draggedItem?.parentIssueAri != null && (isSiblingOfDropTarget || dragItemParentIsDropTarget);
    if (droppingToSameParent) return [
        (0, $8jOO7.MAKE_CHILD),
        (0, $8jOO7.REORDER_BELOW),
        (0, $8jOO7.REORDER_ABOVE)
    ];
    // if the difference is not of one level up, we could be reparenting by dragging
    if (dropTargetLevel !== draggedItemLevel + 1) {
        // If drop target is of same level as drag item and drop target has parent,
        // do not block reorder as we are reordering to reparent
        if (dropTargetLevel === draggedItemLevel && dropTargetHasParent) return [
            (0, $8jOO7.MAKE_CHILD)
        ];
        // If we are dropping to a top level issue (unparenting), we should not block reordering
        if (dropTarget?.depth === 0 && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL) && dragItemHasParent) return [
            (0, $8jOO7.MAKE_CHILD)
        ];
        // Any other actions are invalid
        return [
            (0, $8jOO7.MAKE_CHILD),
            (0, $8jOO7.REORDER_BELOW),
            (0, $8jOO7.REORDER_ABOVE)
        ];
    }
    // we cannot unparent a subtask nor an item that already does not have a parent
    if (draggedItemLevel === (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL) || !dragItemHasParent) return [
        (0, $8jOO7.REORDER_BELOW),
        (0, $8jOO7.REORDER_ABOVE)
    ];
    // Unparenting any non-subtask issue type
    if (dropTarget?.depth === 0 && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL) && dragItemHasParent) return [];
    // we are dropping to a valid parent
    return [
        (0, $8jOO7.REORDER_BELOW),
        (0, $8jOO7.REORDER_ABOVE)
    ];
};

});
parcelRegister("lBtjB", function(module, exports) {

var $1O9y6 = parcelRequire("1O9y6");

var $7gKgM = parcelRequire("7gKgM");
/** `Object#toString` result references. */ var $fba3cb134bd6d57d$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $fba3cb134bd6d57d$var$isNumber(value) {
    return typeof value == 'number' || $7gKgM(value) && $1O9y6(value) == $fba3cb134bd6d57d$var$numberTag;
}
module.exports = $fba3cb134bd6d57d$var$isNumber;

});



parcelRegister("4NiKr", function(module, exports) {
$parcel$export(module.exports, "SiblingIssueCreateRowContext", () => $519225a615dc40ac$export$93b3e64bc25dd687);
$parcel$export(module.exports, "useSiblingIssueCreateRow", () => $519225a615dc40ac$export$4d2a6b6549dc23e8);
$parcel$export(module.exports, "useSiblingIssueCreateHandler", () => $519225a615dc40ac$export$6dac168b5104cc);
$parcel$export(module.exports, "useSiblingIssueCreateOnScroll", () => $519225a615dc40ac$export$2dfe9712a7a20bc9);

var $eJOHy = parcelRequire("eJOHy");

var $6DCNy = parcelRequire("6DCNy");

var $34oCh = parcelRequire("34oCh");

var $6LwYU = parcelRequire("6LwYU");

const $519225a615dc40ac$var$MOUSE_MOVE_THROTTLE = 16;
const $519225a615dc40ac$var$SIBLING_CREATE_HOVER_AREA = 12;
const $519225a615dc40ac$export$93b3e64bc25dd687 = /*#__PURE__*/ (0, $eJOHy.createContext)({});
const $519225a615dc40ac$export$4d2a6b6549dc23e8 = ()=>{
    const context = (0, $eJOHy.useContext)($519225a615dc40ac$export$93b3e64bc25dd687);
    const isSiblingIssueCreateEnabled = (0, $34oCh.useIsSiblingIssueCreateEnabled)();
    return isSiblingIssueCreateEnabled ? context : {};
};
const $519225a615dc40ac$export$6dac168b5104cc = (connectionId, edgeIndex)=>{
    const isSiblingIssueCreateEnabled = (0, $34oCh.useIsSiblingIssueCreateEnabled)();
    const { setIndex: setIndex, clearIndex: clearIndex, clearIndexAfterDelay: clearIndexAfterDelay } = (0, $6LwYU.useSiblingCreateActiveIndexActions)();
    const calculateRowIndex = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))((event)=>{
            const currentRow = event.currentTarget;
            if (!currentRow) return;
            // Calculate the y position of the mouse relative to the top of the current row.
            const currentRowRect = currentRow.getBoundingClientRect();
            // This calculation ranges from -1 to 39, instead of 0 to 40, potentially due to the row's border.
            // For this reason, we add 1 to ensure the value is correct.
            const currentRowMouseVerticalOffset = event.clientY - currentRowRect.top + 1;
            if (currentRowMouseVerticalOffset >= 0 && currentRowMouseVerticalOffset <= $519225a615dc40ac$var$SIBLING_CREATE_HOVER_AREA) // When hovering the top part of a row, the trigger should be rendered at the top of the current row.
            setIndex((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8), [
                connectionId,
                edgeIndex
            ]);
            else if (currentRowMouseVerticalOffset > currentRowRect.height - $519225a615dc40ac$var$SIBLING_CREATE_HOVER_AREA) // When hovering the bottom part of a row, the trigger should be rendered at the top of the next row.
            setIndex((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8), [
                connectionId,
                edgeIndex + 1
            ]);
            else // When hovering the middle part of a row, the trigger should not be rendered.
            clearIndex((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8));
        }, $519225a615dc40ac$var$MOUSE_MOVE_THROTTLE), [
        connectionId,
        edgeIndex,
        clearIndex,
        setIndex
    ]);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        clearIndexAfterDelay((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8));
    }, [
        clearIndexAfterDelay
    ]);
    const onMouseMove = (0, $eJOHy.useCallback)((event)=>{
        calculateRowIndex(event);
    }, [
        calculateRowIndex
    ]);
    return isSiblingIssueCreateEnabled ? {
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove
    } : {};
};
const $519225a615dc40ac$export$2dfe9712a7a20bc9 = ()=>{
    const isSiblingIssueCreateEnabled = (0, $34oCh.useIsSiblingIssueCreateEnabled)();
    const { clearIndex: clearIndex } = (0, $6LwYU.useSiblingCreateActiveIndexActions)();
    return (0, $eJOHy.useMemo)(()=>isSiblingIssueCreateEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))(()=>{
            clearIndex((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8));
        }, $519225a615dc40ac$var$MOUSE_MOVE_THROTTLE) : undefined, [
        clearIndex,
        isSiblingIssueCreateEnabled
    ]);
};

});
const $a11b3ba2d46b97f5$export$76a449e52fa0e1e8 = 'issue';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $a11b3ba2d46b97f5$var$FIELD = 'field';


parcelRegister("fZpej", function(module, exports) {
$parcel$export(module.exports, "BeforeFirstCell", () => $287a9a214985335d$export$bcb733e1e43aa5a8);

var $6HelM = parcelRequire("6HelM");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");

var $4NiKr = parcelRequire("4NiKr");

var $6LwYU = parcelRequire("6LwYU");

var $8h5Ee = parcelRequire("8h5Ee");

var $aTzcv = parcelRequire("aTzcv");
const $287a9a214985335d$export$bcb733e1e43aa5a8 = ({ edgeIndex: edgeIndex, issueId: issueId, itemsConnectionId: itemsConnectionId, hierarchyLevel: hierarchyLevel, parentIssueAri: parentIssueAri, parentIssueConnectionId: parentIssueConnectionId, issueKey: issueKey, projectKey: projectKey, isRowHovered: isRowHovered, issueRowData: issueRowData, setCurrentDraggingRow: setCurrentDraggingRow })=>{
    const { isFormVisible: isFormVisible } = (0, $4NiKr.useSiblingIssueCreateRow)();
    const firstCellData = (0, $j4oe4.useFragment)((0, $6HelM.default), issueRowData);
    const isDragAndDropEnabled = (0, $34oCh.useIsDragAndDropEnabled)();
    let isReparentingEnabled = false;
    if ((0, $4cTDP.fg)('jsc_list_reparenting')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isReparentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    let isAdjacentInlineIssueCreateActive = false;
    if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isInlineIssueCreateActive] = (0, $6LwYU.useIsSiblingIssueCreateActive)([
            itemsConnectionId,
            edgeIndex
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isInlineIssueCreateActiveRowBelow] = (0, $6LwYU.useIsSiblingIssueCreateActive)([
            itemsConnectionId,
            edgeIndex + 1
        ]);
        isAdjacentInlineIssueCreateActive = isInlineIssueCreateActive || isInlineIssueCreateActiveRowBelow;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, // Check value instead of truthiness because it can be `undefined` if sibling issue create is disabled
    isFormVisible === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aTzcv.SiblingIssueCreateButton), {
        edgeIndex: edgeIndex,
        issuesConnectionId: itemsConnectionId,
        issue: firstCellData
    }), isDragAndDropEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8h5Ee.DragActionsButton), {
        edgeIndex: edgeIndex,
        issueId: issueId,
        isRowHovered: isRowHovered && !isAdjacentInlineIssueCreateActive,
        parentIssueConnectionId: parentIssueConnectionId,
        ...isReparentingEnabled ? {
            hierarchyLevel: hierarchyLevel,
            parentIssueAri: parentIssueAri,
            issueKey: issueKey,
            projectKey: projectKey,
            firstCellData: firstCellData ?? null,
            itemsConnectionId: itemsConnectionId,
            setCurrentDraggingRow: setCurrentDraggingRow
        } : {
            firstCellData: null
        }
    }));
};

});
parcelRegister("6HelM", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0e37fa770adbdd7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8353713c0bee4b6aad98f970a91e4d33>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e0e37fa770adbdd7$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "BeforeFirstCell",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "DragActionsButton"
        },
        {
            "kind": "FragmentSpread",
            "name": "siblingIssueCreateButton_nativeIssueTable"
        }
    ],
    "type": "JiraIssue"
};
$e0e37fa770adbdd7$var$node.hash = "bd3217e88c79f770b5aec35587e91367";
var $e0e37fa770adbdd7$export$2e2bcd8739ae039 = $e0e37fa770adbdd7$var$node;

});

parcelRegister("8h5Ee", function(module, exports) {
$parcel$export(module.exports, "DragActionsButton", () => $c0fd66e97582aa66$export$d55b3c0033758134);

var $8KF3b = parcelRequire("8KF3b");

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $5k2HF = parcelRequire("5k2HF");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $dX4g9 = parcelRequire("dX4g9");

var $aHiGM = parcelRequire("aHiGM");

var $6qaBj = parcelRequire("6qaBj");

var $bGx3v = parcelRequire("bGx3v");

var $3mZMJ = parcelRequire("3mZMJ");

var $3bSs8 = parcelRequire("3bSs8");

var $d2AGn = parcelRequire("d2AGn");

var $2ApNu = parcelRequire("2ApNu");

var $d1S9l = parcelRequire("d1S9l");

var $bzbsd = parcelRequire("bzbsd");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $lRq8t = parcelRequire("lRq8t");

var $cHtIB = parcelRequire("cHtIB");

var $4cTDP = parcelRequire("4cTDP");

var $jE8Tu = parcelRequire("jE8Tu");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");

var $aBHUF = parcelRequire("aBHUF");

var $6pTKw = parcelRequire("6pTKw");

var $l4EsH = parcelRequire("l4EsH");

var $gbzqX = parcelRequire("gbzqX");

var $4AddX = parcelRequire("4AddX");

var $j5Wzv = parcelRequire("j5Wzv");

var $15Apk = parcelRequire("15Apk");

var $jNv5I = parcelRequire("jNv5I");

var $gCGxb = parcelRequire("gCGxb");

var $h4EQn = parcelRequire("h4EQn");

var $bCFDb = parcelRequire("bCFDb");
const $c0fd66e97582aa66$var$styles = {
    button: "_1dqonqa1 _1h6d1l7x _189ee4h9 _4t3i7vkz _1bsbdlk8 _16qs130s _bfhkhp5a _syazi7uo _80om1qgj _irr3116u _1di6npx7 _9h8h12zz _1qam5szm"
}; // Negatively offset by 1px to account for the cell border
const $c0fd66e97582aa66$var$offset = [
    (0, $8jOO7.ROW_HEIGHT) / 2 - 1,
    -1
];
const $c0fd66e97582aa66$var$BUTTON_SIZE = 16;
const $c0fd66e97582aa66$var$IDLE_DRAGGABLE_STATE = 'idle';
const $c0fd66e97582aa66$var$PREVIEW_DRAGGABLE_STATE = 'preview';
const $c0fd66e97582aa66$var$DRAGGING_DRAGGABLE_STATE = 'dragging';
const $c0fd66e97582aa66$var$isDropEdgeTarget = (dropTarget)=>'dropEdge' in dropTarget;
const $c0fd66e97582aa66$export$d55b3c0033758134 = ({ edgeIndex: edgeIndex, issueId: issueId, hierarchyLevel: hierarchyLevel, parentIssueAri: parentIssueAri, parentIssueConnectionId: parentIssueConnectionId, issueKey: issueKey, projectKey: projectKey, isRowHovered: isRowHovered, firstCellData: firstCellData, itemsConnectionId: itemsConnectionId, setCurrentDraggingRow: setCurrentDraggingRow })=>{
    const dragPreviewData = (0, $j4oe4.useFragment)((0, $8KF3b.default), firstCellData);
    const buttonRef = (0, $eJOHy.useRef)(null);
    const [buttonState, setButtonState] = (0, $eJOHy.useState)($c0fd66e97582aa66$var$IDLE_DRAGGABLE_STATE);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eJOHy.useState)(false);
    const [{ currentDropTarget: currentDropTarget, instanceId: instanceId, items: items }, { reorderRows: reorderRows }] = (0, $l4EsH.useDraggableRows)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    let isRowReorderingEnabled = false;
    if (!(0, $4cTDP.fg)('jsc-2065-unify-onrowreorder')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isRowReorderingEnabled = (0, $34oCh.useIsRowReorderingEnabled)();
    const isIssueRankingEnabled = (0, $34oCh.useIsIssueRankingEnabled)();
    const isReparentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    let rankIssues = null;
    let sortDirection;
    if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        rankIssues = (0, $j5Wzv.useIssuesRanker)(); // eslint-disable-next-line react-hooks/rules-of-hooks
        sortDirection = (0, $34oCh.useSortDirection)();
    }
    let fireAnalyticsStart = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    if ((0, $4cTDP.fg)('jira_timeline_analytics_harmonization')) // eslint-disable-next-line react-hooks/rules-of-hooks
    fireAnalyticsStart = (0, $eJOHy.useCallback)((fieldKeys, editType)=>{
        fieldKeys.forEach((fieldKey)=>{
            (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart(fieldKey, {
                analytics: createAnalyticsEvent({}),
                attributes: {
                    issueId: (0, $2ApNu.JiraIssueAri).parse(issueId).issueId,
                    parentId: parentIssueAri ? (0, $2ApNu.JiraIssueAri).parse(parentIssueAri).issueId : undefined,
                    issueType: dragPreviewData?.issueTypeField?.issueType?.name,
                    issueHierarchy: hierarchyLevel,
                    isDragEditing: editType === 'dragEditing',
                    isContextMenuEditing: editType === 'contextMenuEditing',
                    fieldType: (0, $3bSs8.FIELD_TYPE_MAP)[fieldKey]
                }
            });
        });
    }, [
        createAnalyticsEvent,
        dragPreviewData?.issueTypeField?.issueType?.name,
        hierarchyLevel,
        issueId,
        parentIssueAri
    ]);
    const onRankIssuesNew = (0, $eJOHy.useCallback)((sourceIndex, destinationIndex)=>{
        const edge = (0, $15Apk.getEdgeForRerank)(sourceIndex, destinationIndex, sortDirection);
        return rankIssues?.({
            source: {
                issueIds: [
                    items.get(sourceIndex) ?? ''
                ],
                rowIndex: sourceIndex
            },
            destination: {
                relativeToIssueId: items.get(destinationIndex) ?? '',
                rowIndex: destinationIndex
            },
            edge: edge
        });
    }, [
        items,
        sortDirection,
        rankIssues
    ]);
    const onReorderRows = isIssueRankingEnabled ? onRankIssuesNew : reorderRows; // Note: It will use the `isIssueRankingEnabled` condition in the dropdown items instead
    // TODO: Use `onRankIssuesNew` directly on jsc-2065-unify-onrowreorder cleanup
    const onRankIssues = (0, $4cTDP.fg)('jsc-2065-unify-onrowreorder') ? onRankIssuesNew : onReorderRows;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isVisible = isDropdownOpen || isRowHovered || buttonState === $c0fd66e97582aa66$var$DRAGGING_DRAGGABLE_STATE;
    const isDropTarget = currentDropTarget?.issueId === issueId;
    const [draggableState, setDraggableState] = (0, $eJOHy.useState)({
        type: $c0fd66e97582aa66$var$IDLE_DRAGGABLE_STATE
    });
    const cloudId = (0, $cHtIB.useCloudId)();
    const { groupId: groupId } = (0, $jNv5I.useRowContext)();
    (0, $eJOHy.useEffect)(()=>{
        if (!buttonRef.current) return;
        return (0, $bGx3v.draggable)({
            element: buttonRef.current,
            getInitialData () {
                return {
                    operation: (0, $8jOO7.ROW_OPERATION_REORDER),
                    instanceId: instanceId,
                    issueId: issueId,
                    rowIndex: edgeIndex,
                    hierarchyLevel: hierarchyLevel,
                    parentIssueAri: parentIssueAri,
                    parentIssueConnectionId: parentIssueConnectionId,
                    itemsConnectionId: itemsConnectionId,
                    issueKey: issueKey,
                    groupId: groupId
                };
            },
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage }) {
                // We need to make sure that the element not obfuscated by the sticky header
                (0, $aHiGM.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $dX4g9.pointerOutsideOfPreview)({
                        x: "var(--ds-space-250, 20px)",
                        y: "var(--ds-space-250, 20px)"
                    }),
                    render ({ container: container }) {
                        setDraggableState({
                            type: $c0fd66e97582aa66$var$PREVIEW_DRAGGABLE_STATE,
                            container: container
                        });
                        return ()=>setDraggableState({
                                type: $c0fd66e97582aa66$var$IDLE_DRAGGABLE_STATE
                            });
                    }
                });
            },
            onDragStart () {
                if (isReparentingEnabled && itemsConnectionId && (0, $4cTDP.fg)('jsc_list_reparenting')) {
                    const itemKey = (0, $jE8Tu.getItemKey)(itemsConnectionId, issueId);
                    setCurrentDraggingRow && setCurrentDraggingRow(itemKey);
                }
                setButtonState('dragging');
                if ((0, $4cTDP.fg)('jira_timeline_analytics_harmonization')) {
                    const fieldKeys = [
                        (isIssueRankingEnabled || isRowReorderingEnabled) && (0, $3mZMJ.RANK_CF_TYPE),
                        isReparentingEnabled && (0, $4cTDP.fg)('jsc_list_reparenting') && (0, $3mZMJ.PARENT_TYPE)
                    ].filter(Boolean);
                    fireAnalyticsStart(fieldKeys, 'dragEditing');
                }
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'dragged',
                    actionSubject: 'dragActionsButton',
                    actionSubjectId: 'jscDraggableIssue'
                }));
            },
            onDrop () {
                if (isReparentingEnabled && (0, $4cTDP.fg)('jsc_list_reparenting')) setCurrentDraggingRow && setCurrentDraggingRow(null);
                buttonRef.current?.blur();
                setButtonState('idle');
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'dropped',
                    actionSubject: 'dragActionsButton',
                    actionSubjectId: 'jscDraggableIssue'
                }));
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $4cTDP.fg)('jira_timeline_analytics_harmonization') ? [
        createAnalyticsEvent,
        edgeIndex,
        issueId,
        hierarchyLevel,
        parentIssueAri,
        instanceId,
        itemsConnectionId,
        parentIssueConnectionId,
        setCurrentDraggingRow,
        isReparentingEnabled,
        isRowReorderingEnabled,
        isIssueRankingEnabled,
        issueKey,
        groupId,
        fireAnalyticsStart
    ] : [
        createAnalyticsEvent,
        edgeIndex,
        issueId,
        hierarchyLevel,
        parentIssueAri,
        instanceId,
        itemsConnectionId,
        parentIssueConnectionId,
        setCurrentDraggingRow,
        isReparentingEnabled,
        issueKey,
        groupId
    ]);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        if (parentIssueAri) (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'changeParent');
        else (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'addParent');
    }, [
        createAnalyticsEvent,
        parentIssueAri
    ]);
    const isFirstRow = edgeIndex === 0 && !parentIssueAri;
    const [isOnboardingVisible, setIsOnboardingVisible] = (0, $eJOHy.useState)(false);
    let handleSubmitReparenting;
    if ((0, $4cTDP.fg)('jsc_list_reparenting')) // eslint-disable-next-line react-hooks/rules-of-hooks
    handleSubmitReparenting = (0, $gbzqX.useReparentingFromModal)({
        projectKey: projectKey
    });
    const modalEntryPointProps = (0, $eJOHy.useMemo)(()=>({
            issueId: issueId,
            parentIssueAri: parentIssueAri,
            issueKey: issueKey,
            hierarchyLevel: hierarchyLevel,
            onSubmit: handleSubmitReparenting
        }), [
        handleSubmitReparenting,
        hierarchyLevel,
        issueId,
        issueKey,
        parentIssueAri
    ]);
    const handleMoveToTop = (0, $eJOHy.useCallback)(()=>{
        onRankIssues(edgeIndex, 0);
        if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'rankIssue', {
            action: 'moveToTop'
        });
    }, [
        createAnalyticsEvent,
        edgeIndex,
        onRankIssues
    ]);
    const handleMoveUp = (0, $eJOHy.useCallback)(()=>{
        onRankIssues(edgeIndex, edgeIndex - 1);
        if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'rankIssue', {
            action: 'moveUp'
        });
    }, [
        createAnalyticsEvent,
        edgeIndex,
        onRankIssues
    ]);
    const handleMoveDown = (0, $eJOHy.useCallback)(()=>{
        onRankIssues(edgeIndex, edgeIndex + 1);
        if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'rankIssue', {
            action: 'moveDown'
        });
    }, [
        createAnalyticsEvent,
        edgeIndex,
        onRankIssues
    ]);
    const handleMoveToBottom = (0, $eJOHy.useCallback)(()=>{
        onRankIssues(edgeIndex, items.size - 1);
        if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'rankIssue', {
            action: 'moveToBottom'
        });
    }, [
        createAnalyticsEvent,
        edgeIndex,
        items.size,
        onRankIssues
    ]);
    if (!issueKey && isReparentingEnabled && (0, $4cTDP.fg)('jsc_list_reparenting')) // if the issue key is empty, it indicates that it’s an optimistic row so we should not render the drag handler
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        isOpen: isDropdownOpen,
        onOpenChange: (attrs)=>{
            if (attrs.isOpen && (0, $4cTDP.fg)('jira_timeline_analytics_harmonization')) {
                const fieldKeys = [
                    (isIssueRankingEnabled || isRowReorderingEnabled) && items.size > 1 && (0, $3mZMJ.RANK_CF_TYPE),
                    isReparentingEnabled && (0, $4cTDP.fg)('jsc_list_reparenting') && (0, $3mZMJ.PARENT_TYPE)
                ].filter(Boolean);
                fireAnalyticsStart(fieldKeys, 'contextMenuEditing');
            }
            setIsDropdownOpen(attrs.isOpen);
        },
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6pTKw.RowPopupButton), {
                alignToYAxis: true,
                buttonSize: $c0fd66e97582aa66$var$BUTTON_SIZE,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5k2HF))), {
                    label: "",
                    size: "small"
                }),
                isVisible: isVisible || isOnboardingVisible,
                label: formatMessage((0, $bCFDb.default).label),
                offset: $c0fd66e97582aa66$var$offset,
                ref: (0, $bzbsd.mergeRefs)(triggerRef, buttonRef),
                xcss: (0, $6qaBj.cx)($c0fd66e97582aa66$var$styles.button),
                onClick: triggerProps.onClick
            }),
        testId: "native-issue-table.ui.row.before-first-cell.drag-actions-button.dropdown-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        "data-testid": "native-issue-table.ui.row.before-first-cell.drag-actions-button.reorder-menu-items"
    }, (isRowReorderingEnabled || isIssueRankingEnabled) && items.size > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isIssueRankingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        isDisabled: edgeIndex === 0,
        onClick: handleMoveToTop
    }, formatMessage((0, $bCFDb.default).moveToTop)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        isDisabled: edgeIndex === 0,
        onClick: handleMoveUp
    }, formatMessage((0, $bCFDb.default).moveUp)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        isDisabled: edgeIndex === items.size - 1,
        onClick: handleMoveDown
    }, formatMessage((0, $bCFDb.default).moveDown)), isIssueRankingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        isDisabled: edgeIndex === items.size - 1,
        onClick: handleMoveToBottom
    }, formatMessage((0, $bCFDb.default).moveToBottom))), projectKey && (0, $4cTDP.fg)('jsc_list_reparenting') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d1S9l.ModalEntryPointDropdownItemTrigger), {
        entryPoint: (0, $4AddX.reparentModalEntryPoint),
        entryPointProps: modalEntryPointProps,
        entryPointParams: {
            cloudId: cloudId,
            projectKey: projectKey
        },
        interactionName: "open-reparent-issue-modal",
        useInternalModal: true,
        onClick: handleClick
    }, parentIssueAri ? formatMessage((0, $bCFDb.default).changeParent) : formatMessage((0, $bCFDb.default).addParent)))), isDropTarget && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aBHUF.RowDropIndicator), $c0fd66e97582aa66$var$isDropEdgeTarget(currentDropTarget) ? {
        edge: currentDropTarget.dropEdge
    } : {
        instruction: currentDropTarget.dropInstruction
    }), draggableState.type === $c0fd66e97582aa66$var$PREVIEW_DRAGGABLE_STATE && isReparentingEnabled && dragPreviewData && /*#__PURE__*/ (0, $aQK2r.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h4EQn.DragPreview), {
        issueId: (0, $2ApNu.JiraIssueAri).parse(issueId).issueId,
        itemsConnectionId: itemsConnectionId,
        summary: dragPreviewData.summary,
        issueTypeAvatarUrl: dragPreviewData.issueTypeField?.issueType?.avatar?.small
    }), draggableState.container), isFirstRow && isReparentingEnabled && buttonRef.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gCGxb.ReparentingOnboarding), {
        buttonElement: buttonRef.current,
        setIsOnboardingVisible: setIsOnboardingVisible
    }));
};

});
parcelRegister("8KF3b", function(module, exports) {
$parcel$export(module.exports, "default", () => $57131a4864c6348f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<79f9bfcc37cd62f909d1301b9a0ba3ac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $57131a4864c6348f$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "DragActionsButton",
    "selections": [
        {
            "condition": "isReparentingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "summary"
                },
                {
                    "concreteType": "JiraIssueTypeField",
                    "kind": "LinkedField",
                    "name": "issueTypeField",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "small"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$57131a4864c6348f$var$node.hash = "393733eb40041d691aec62e761940301";
var $57131a4864c6348f$export$2e2bcd8739ae039 = $57131a4864c6348f$var$node;

});

parcelRegister("5k2HF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::976c79b56a8fa85b795a69d54376c6cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e00ead02e99da4c$var$_react = $3e00ead02e99da4c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $3e00ead02e99da4c$var$_baseNew = $3e00ead02e99da4c$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $3e00ead02e99da4c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e00ead02e99da4c$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $3e00ead02e99da4c$var$_react.default.createElement($3e00ead02e99da4c$var$_baseNew.default, Object.assign({
        name: "DragHandleVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$3e00ead02e99da4c$var$DragHandleVerticalIcon.displayName = 'DragHandleVerticalIcon';
var $3e00ead02e99da4c$var$_default = module.exports.default = $3e00ead02e99da4c$var$DragHandleVerticalIcon;

});

parcelRegister("aBHUF", function(module, exports) {
$parcel$export(module.exports, "RowDropIndicator", () => $fe45d0eb6b7ca840$export$fa88485e37d4f027);

var $eJOHy = parcelRequire("eJOHy");

var $hM0gG = parcelRequire("hM0gG");

var $igtYB = parcelRequire("igtYB");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $7n9BS = parcelRequire("7n9BS");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $fe45d0eb6b7ca840$export$feefd628b4f4feb5 = ({ instruction: instruction })=>{
    const width = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.scrollWidth - (0, $8jOO7.EXTRA_SPACE_PER_LEVEL));
    const isReParentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "native-issue-table.common.ui.row-drop-indicator.box",
        xcss: [
            (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $fe45d0eb6b7ca840$var$boxStyles : $fe45d0eb6b7ca840$var$boxStylesOld,
            (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $fe45d0eb6b7ca840$var$dropIndicatorStyles : $fe45d0eb6b7ca840$var$dropIndicatorStylesOld
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: `${width}px`
        },
        "data-row-drop-indicator": true
    }, isReParentingEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hM0gG.DropIndicator), {
        instruction: instruction
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $igtYB.DropIndicator), {
        edge: instruction.type === (0, $8jOO7.REORDER_ABOVE) ? 'top' : 'bottom',
        ...(0, $4cTDP.fg)('jsc_list_reranking_gate') ? {
            appearance: instruction.type === (0, $8jOO7.INSTRUCTION_BLOCKED) ? 'warning' : 'default'
        } : {}
    }));
};
const $fe45d0eb6b7ca840$export$d508f4eb766c5ef8 = ({ edge: edge })=>{
    const width = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.width);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "native-issue-table.common.ui.row-drop-indicator.box",
        xcss: [
            (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $fe45d0eb6b7ca840$var$boxStyles : $fe45d0eb6b7ca840$var$boxStylesOld
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: `${width}px`
        },
        "data-row-drop-indicator": true
    }, edge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $igtYB.DropIndicator), {
        edge: edge
    }));
};
const $fe45d0eb6b7ca840$export$fa88485e37d4f027 = /*#__PURE__*/ (0, $eJOHy.memo)(({ edge: edge, instruction: instruction })=>{
    if (instruction && (0, $4cTDP.fg)('jsc_list_reparenting')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fe45d0eb6b7ca840$export$feefd628b4f4feb5, {
        instruction: instruction
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fe45d0eb6b7ca840$export$d508f4eb766c5ef8, {
        edge: edge
    });
});
const $fe45d0eb6b7ca840$var$boxStylesOld = (0, $1DXK0.xcss)({
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    bottom: 'space.0',
    // Negatively offset by 1px to account for the cell border
    insetInlineStart: '-1px',
    pointerEvents: 'none'
});
const $fe45d0eb6b7ca840$var$boxStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    insetBlockStart: 'space.0',
    insetBlockEnd: 'space.0',
    // Negatively offset by 1px to account for the cell border
    insetInlineStart: '-1px',
    pointerEvents: 'none'
});
const $fe45d0eb6b7ca840$var$dropIndicatorStylesOld = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.050',
    width: '100%',
    zIndex: 'tooltip'
});
const $fe45d0eb6b7ca840$var$dropIndicatorStyles = (0, $1DXK0.xcss)({
    insetInlineStart: 'space.050',
    width: '100%',
    zIndex: 'tooltip'
});

});
parcelRegister("hM0gG", function(module, exports) {
$parcel$export(module.exports, "DropIndicator", () => $eab1d74837eadd45$export$62ed72bc21f6b8a6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5HaAt = parcelRequire("5HaAt");

var $igtYB = parcelRequire("igtYB");
function $eab1d74837eadd45$var$getElement({ instruction: instruction, isBlocked: isBlocked }) {
    const indent = `${instruction.currentLevel * instruction.indentPerLevel}px`;
    const appearance = isBlocked ? 'warning' : 'default';
    if (instruction.type === 'reorder-above') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $igtYB.DropIndicator), {
        edge: "top",
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'reorder-below') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $igtYB.DropIndicator), {
        edge: "bottom",
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'make-child') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5HaAt.DropIndicator), {
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'reparent') {
        const reparentIndent = `${instruction.desiredLevel * instruction.indentPerLevel}px`;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $igtYB.DropIndicator), {
            edge: "bottom",
            appearance: appearance,
            indent: reparentIndent
        });
    }
    return null;
}
function $eab1d74837eadd45$export$62ed72bc21f6b8a6({ instruction: instruction }) {
    if (instruction.type === 'instruction-blocked') return $eab1d74837eadd45$var$getElement({
        instruction: instruction.desired,
        isBlocked: true
    });
    return $eab1d74837eadd45$var$getElement({
        instruction: instruction,
        isBlocked: false
    });
}

});


parcelRegister("6pTKw", function(module, exports) {
$parcel$export(module.exports, "RowPopupButton", () => $a86e6d6da2b92676$export$960d0282617d39c3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $6qaBj = parcelRequire("6qaBj");

var $6G5P1 = parcelRequire("6G5P1");
var $azjc1 = parcelRequire("azjc1");

var $8nu6j = parcelRequire("8nu6j");

var $46R8N = parcelRequire("46R8N");

var $k71qx = parcelRequire("k71qx");

var $bzbsd = parcelRequire("bzbsd");

var $8cv11 = parcelRequire("8cv11");

var $4cTDP = parcelRequire("4cTDP");
const $a86e6d6da2b92676$var$styles = {
    referenceOld: "_1ltvze3t _154ize3t",
    reference: "_1e02ze3t _152tze3t",
    visuallyHiddenOld: "_19itglyw _1reo15vq _18m915vq _1bsbt94y _4t3it94y _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _kqswstnw _mkrz1ly6 _o5721q9c",
    visuallyHidden: "_19itglyw _1reo15vq _18m915vq _1bsbt94y _4t3it94y _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _kqswstnw _mkrz1ly6 _o5721q9c"
};
const $a86e6d6da2b92676$var$buttonStyles = {
    root: "_1e0c1txw _1bah1h6o _4cvr1h6o _1pby1nn1",
    default: "_2rko12b0 _bfhk1bhr _80omtlke _irr36o2t _1di6m8nx"
};
const $a86e6d6da2b92676$var$constantModifiers = [
    {
        name: 'flip',
        enabled: false
    }
];
// Height/width of the popup button
const $a86e6d6da2b92676$var$DEFAULT_BUTTON_SIZE = 24;
// Height/width of the reference element the popup button is anchored to
const $a86e6d6da2b92676$var$REFERENCE_SIZE = 1;
const $a86e6d6da2b92676$export$960d0282617d39c3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, forwardedRef)=>{
    const { icon: icon, isVisible: isVisible, label: label, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, tooltipContent: tooltipContent, tooltipPosition: tooltipPosition, alignToYAxis: alignToYAxis = true, buttonSize: buttonSize = $a86e6d6da2b92676$var$DEFAULT_BUTTON_SIZE, offset: offset = [
        0,
        0
    ], xcss: xcss } = props;
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const updateRef = (0, $eJOHy.useRef)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Recompute popup position when the button is shown
        isVisible && updateRef.current?.();
    }, [
        isVisible
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Recompute popup position when the button is focused
        isFocused && updateRef.current?.();
    }, [
        isFocused
    ]);
    const [along, away] = offset;
    const finalOffset = (0, $eJOHy.useMemo)(()=>// Negatively offset the popup by the button + reference size to center the button on the secondary axis
        [
            along,
            away - (buttonSize + $a86e6d6da2b92676$var$REFERENCE_SIZE) / 2
        ], [
        along,
        away,
        buttonSize
    ]);
    const modifiers = (0, $eJOHy.useMemo)(()=>{
        // Adjust the overflow calculation for the primary axis so it is relative to the center of the button.
        const alongCenterOffset = -(buttonSize / 2);
        // Retain the provided offset for the secondary axis
        const padding = alignToYAxis ? {
            left: finalOffset[1],
            top: alongCenterOffset,
            bottom: alongCenterOffset
        } : {
            top: finalOffset[1],
            left: alongCenterOffset,
            right: alongCenterOffset
        };
        return [
            ...$a86e6d6da2b92676$var$constantModifiers,
            {
                name: 'preventOverflow',
                options: {
                    mainAxis: true,
                    altAxis: true,
                    padding: padding,
                    altBoundary: true,
                    rootBoundary: 'viewport',
                    tether: false
                }
            },
            {
                name: 'eventListeners',
                options: {
                    // Only recompute position on scroll/resize events while the button is focused to reduce CPU load
                    scroll: isFocused,
                    resize: isFocused
                }
            }
        ];
    }, [
        alignToYAxis,
        buttonSize,
        finalOffset,
        isFocused
    ]);
    // Ensure a stable ref function is passed through to the trigger button
    const memoizedMergeRefs = (0, $eJOHy.useMemo)(()=>(0, $LFmXM.default)((0, $bzbsd.mergeRefs)), []);
    const isVisuallyHidden = !isVisible && !isFocused;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6G5P1.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $azjc1.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: (0, $6qaBj.cx)((0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $a86e6d6da2b92676$var$styles.reference : $a86e6d6da2b92676$var$styles.referenceOld, (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $a86e6d6da2b92676$var$styles.visuallyHidden : $a86e6d6da2b92676$var$styles.visuallyHiddenOld),
            ref: ref
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8cv11.JiraPopper), {
        placement: alignToYAxis ? 'right' : 'bottom',
        modifiers: modifiers,
        offset: finalOffset,
        messageId: "native-issue-table.common.ui.row-popup-button.popper",
        messageType: "transactional"
    }, ({ ref: ref, style: style, update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            position: tooltipPosition,
            content: tooltipContent,
            canAppear: ()=>tooltipContent != null
        }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $46R8N.default), {
                ...triggerProps,
                "aria-label": label,
                testId: `native-issue-table.common.ui.row-popup-button.pressable${isVisuallyHidden ? '-hidden' : ''}`,
                xcss: (0, $6qaBj.cx)($a86e6d6da2b92676$var$buttonStyles.root, $a86e6d6da2b92676$var$buttonStyles.default, // See https://atlassian.design/components/css/overview#building-reusable-components
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                xcss, isVisuallyHidden && $a86e6d6da2b92676$var$styles.visuallyHidden),
                onClick: (e, analyticEvent)=>{
                    onClick?.(e, analyticEvent);
                    triggerProps.onClick(e);
                },
                onFocus: (e)=>{
                    setIsFocused(true);
                    triggerProps.onFocus(e);
                },
                onBlur: (e)=>{
                    setIsFocused(false);
                    triggerProps.onBlur(e);
                },
                onMouseMove: (e)=>{
                    // Stop propagation so the button isn't inadvertently hidden when hovering
                    e.stopPropagation();
                    triggerProps.onMouseMove?.(e);
                },
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                ref: memoizedMergeRefs(ref, triggerProps.ref, forwardedRef),
                // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
                style: style
            }, icon));
    }));
});

});

parcelRegister("gbzqX", function(module, exports) {
$parcel$export(module.exports, "useReparentingFromModal", () => $69b98f49ec4fd4fd$export$7ed8dfd115f70801);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $9pTd3 = parcelRequire("9pTd3");

var $2ApNu = parcelRequire("2ApNu");

var $ftN6c = parcelRequire("ftN6c");

var $3mZMJ = parcelRequire("3mZMJ");

var $3bSs8 = parcelRequire("3bSs8");

var $d2AGn = parcelRequire("d2AGn");

var $cHtIB = parcelRequire("cHtIB");

var $cSXp8 = parcelRequire("cSXp8");

var $4cTDP = parcelRequire("4cTDP");

var $adrlS = parcelRequire("adrlS");

var $8jOO7 = parcelRequire("8jOO7");

var $8pBFu = parcelRequire("8pBFu");

var $8SzGK = parcelRequire("8SzGK");
const $69b98f49ec4fd4fd$export$7ed8dfd115f70801 = ({ projectKey: projectKey })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { onIssueReparent: onIssueReparent } = (0, $8SzGK.useEventHandlers)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const updateParentConnections = (0, $adrlS.useGetReparentUpdater)();
    let createAnalyticsEvent;
    if ((0, $4cTDP.fg)('jira_timeline_analytics_harmonization')) // eslint-disable-next-line  react-hooks/rules-of-hooks
    createAnalyticsEvent = (0, $ftN6c.useAnalyticsEvents)().createAnalyticsEvent;
    return (0, $eJOHy.useCallback)((updatedIssues, newParentId, newIssueParent, requestPromise)=>{
        if (updatedIssues.length) {
            const updatedIssue = updatedIssues[0];
            if (updatedIssue.id) {
                const ariIssueId = (0, $2ApNu.JiraIssueAri).create({
                    issueId: updatedIssue.id,
                    siteId: cloudId
                }).toString();
                if (createAnalyticsEvent && (0, $4cTDP.fg)('jira_timeline_analytics_harmonization')) (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $3mZMJ.PARENT_TYPE), {
                    analytics: createAnalyticsEvent({}),
                    attributes: {
                        issueId: updatedIssue.id,
                        fieldType: (0, $3bSs8.FIELD_TYPE_MAP)[0, $3mZMJ.PARENT_TYPE],
                        oldValId: updatedIssue.parentId,
                        newValId: newParentId
                    }
                });
                (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
                    updateParentConnections({
                        store: store,
                        issueId: ariIssueId,
                        oldParentId: updatedIssue.parentId,
                        newParentId: newParentId,
                        index: 0,
                        projectKey: projectKey
                    });
                });
                requestPromise.then(()=>{
                    if (onIssueReparent && updatedIssue.id && (0, $4cTDP.fg)('timeline_rollups_issue_table_callbacks')) onIssueReparent(updatedIssue.id, // old parent
                    updatedIssue.parentId || undefined, // new parent
                    newParentId || undefined);
                }).catch((error)=>{
                    // Rollback
                    (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
                        updateParentConnections({
                            store: store,
                            issueId: ariIssueId,
                            oldParentId: newParentId,
                            newParentId: updatedIssue.parentId,
                            index: 0,
                            projectKey: projectKey
                        });
                    });
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: 'issueTableReparentMutationFromModal',
                            packageName: (0, $8jOO7.PACKAGE_NAME),
                            teamName: (0, $8jOO7.TEAM_NAME)
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    showFlag((0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG));
                });
            }
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        environment,
        onIssueReparent,
        projectKey,
        showFlag,
        updateParentConnections
    ]);
};

});

parcelRegister("4AddX", function(module, exports) {
$parcel$export(module.exports, "reparentModalEntryPoint", () => $10fd1aa1388ec33e$export$e5e5cbbac06953a1);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $cvMpq = parcelRequire("cvMpq");

const $10fd1aa1388ec33e$export$e5e5cbbac06953a1 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("bJuhx")), {
        moduleId: "92cce941",
        moduleName: "ReparentModalEntryPoint",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>({
            queries: {
                projectData: {
                    parameters: $cvMpq.default,
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("bJuhx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b25oZ").then(()=>parcelRequire('fe43f'));

});


parcelRegister("gCGxb", function(module, exports) {
$parcel$export(module.exports, "ReparentingOnboarding", () => $77a5b7e391e34013$export$18bcadaeddef642);

var $eJOHy = parcelRequire("eJOHy");

var $7UDun = parcelRequire("7UDun");

var $d2s5v = parcelRequire("d2s5v");

var $8IeH1 = parcelRequire("8IeH1");

var $58yRG = parcelRequire("58yRG");

var $6zxfT = parcelRequire("6zxfT");

var $9zZj0 = parcelRequire("9zZj0");

var $lRq8t = parcelRequire("lRq8t");

var $iC2Fk = parcelRequire("iC2Fk");

var $cHtIB = parcelRequire("cHtIB");

var $kyq27 = parcelRequire("kyq27");

var $jie4g = parcelRequire("jie4g");

var $cOh4b = parcelRequire("cOh4b");

var $2TobG = parcelRequire("2TobG");
const $77a5b7e391e34013$export$ae06398c30161061 = 'jira-list-nin-reparent-onboarding-stg';
const $77a5b7e391e34013$export$c63f3f365035b47c = 'jira-list-nin-reparent-onboarding';
const $77a5b7e391e34013$var$ENV_STAGING = 'staging';
const $77a5b7e391e34013$var$STARGATE_URL = '/gateway/api';
const $77a5b7e391e34013$export$18bcadaeddef642 = ({ buttonElement: buttonElement, setIsOnboardingVisible: setIsOnboardingVisible })=>{
    const ONBOARDING_ENGAGEMENT_ID = (0, $kyq27.useEnvironment)() === $77a5b7e391e34013$var$ENV_STAGING ? $77a5b7e391e34013$export$ae06398c30161061 : $77a5b7e391e34013$export$c63f3f365035b47c;
    const cloudId = (0, $cHtIB.useCloudId)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const spotlight = colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($2TobG))) : (0, (/*@__PURE__*/$parcel$interopDefault($cOh4b)));
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eJOHy.useState)(false);
    const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, $77a5b7e391e34013$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isEnrolled, stopEnrolment] = (0, $7UDun.useCoordination)(coordinationClient, ONBOARDING_ENGAGEMENT_ID);
    (0, $eJOHy.useEffect)(()=>{
        if (isEnrolled) {
            setIsOnboardingVisible(true);
            stopEnrolment(false);
            setTimeout(()=>{
                setIsSpotlightActive(true);
            }, 50);
        }
    }, [
        isEnrolled,
        setIsOnboardingVisible,
        stopEnrolment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6zxfT.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, isSpotlightActive && buttonElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        onMouseOver: (event)=>{
            event.stopPropagation();
        },
        onMouseLeave: (event)=>{
            event.stopPropagation();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2Fk.JiraSpotlight), {
        image: spotlight,
        messageId: "native-issue-table.ui.row.before-first-cell.drag-actions-button.reparenting-onboarding.jira-spotlight.expand-column-header",
        messageType: "engagement",
        actions: [
            {
                onClick: ()=>{
                    setIsSpotlightActive(false);
                    setIsOnboardingVisible(false);
                },
                text: formatMessage((0, $jie4g.default).dismiss)
            }
        ],
        dialogWidth: 270,
        heading: formatMessage((0, $jie4g.default).onboardingHeading),
        targetNode: buttonElement,
        targetRadius: 3,
        key: "reparenting-onboarding"
    }, formatMessage((0, $jie4g.default).onboardingDescription)))));
};

});
parcelRegister("jie4g", function(module, exports) {
$parcel$export(module.exports, "default", () => $825ad67642b58329$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $825ad67642b58329$var$messages = (0, $7qGN1.defineMessages)({
    onboardingHeading: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.reparenting-onboarding.onboarding-heading",
        "defaultMessage": "Re-parent work items"
    },
    onboardingDescription: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.reparenting-onboarding.onboarding-description",
        "defaultMessage": "Select and move a work item to add, or change, the parent."
    },
    dismiss: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.reparenting-onboarding.dismiss",
        "defaultMessage": "Dismiss"
    }
});
var $825ad67642b58329$export$2e2bcd8739ae039 = $825ad67642b58329$var$messages;

});

parcelRegister("cOh4b", function(module, exports) {
module.exports = new URL("reparent-onboarding-light.f5faa58e.gif", import.meta.url).toString();

});

parcelRegister("2TobG", function(module, exports) {
module.exports = new URL("reparent-onboarding-dark.ad59f27a.gif", import.meta.url).toString();

});


parcelRegister("h4EQn", function(module, exports) {
$parcel$export(module.exports, "DragPreview", () => $aba8ee8166d92834$export$905ab40ac2179daa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $jE8Tu = parcelRequire("jE8Tu");
const $aba8ee8166d92834$var$MAX_ISSUE_COUNT = 99;
const $aba8ee8166d92834$export$905ab40ac2179daa = ({ summary: summary, issueTypeAvatarUrl: issueTypeAvatarUrl, issueId: issueId, itemsConnectionId: itemsConnectionId })=>{
    const [{ listMetadata: listMetadata, connectionMap: connectionMap, connectionItems: connectionItems }] = (0, $jE8Tu.useHierarchyStore)();
    const [isExpanded] = (0, $jE8Tu.useIsItemExpanded)({
        itemId: issueId,
        itemsConnectionId: itemsConnectionId || ''
    });
    const childCount = (0, $eJOHy.useMemo)(()=>{
        if (isExpanded) {
            const itemKey = listMetadata.find((element)=>element.itemId === issueId)?.key || '';
            const keyConnection = connectionMap[itemKey];
            const itemConnectionItems = keyConnection ? connectionItems[keyConnection] || [] : [];
            return itemConnectionItems.length ? (0, $jE8Tu.filterNonIssueItems)(itemConnectionItems.map((item)=>item.itemId)).length || 0 : 0;
        }
        return 0;
    }, [
        connectionItems,
        connectionMap,
        isExpanded,
        issueId,
        listMetadata
    ]);
    const showChildIssues = childCount > 0;
    const hasMoreThanOneChild = childCount > 1;
    const countIncludingParent = childCount > 0 ? childCount + 1 : 0;
    const hasLessThanMaxIssueCount = countIncludingParent < $aba8ee8166d92834$var$MAX_ISSUE_COUNT;
    const roundedIssueCount = hasLessThanMaxIssueCount ? countIncludingParent : $aba8ee8166d92834$var$MAX_ISSUE_COUNT;
    return summary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $aba8ee8166d92834$var$rootStyles
    }, showChildIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, hasMoreThanOneChild ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $aba8ee8166d92834$var$listItemStyles,
            $aba8ee8166d92834$var$child2Styles
        ]
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $aba8ee8166d92834$var$listItemStyles,
            $aba8ee8166d92834$var$child1Styles
        ]
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $aba8ee8166d92834$var$listItemStyles,
            $aba8ee8166d92834$var$primaryItemStyles
        ]
    }, showChildIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: hasLessThanMaxIssueCount ? $aba8ee8166d92834$var$badgeStyles : [
            $aba8ee8166d92834$var$badgeStyles,
            $aba8ee8166d92834$var$smallContentStyles
        ],
        alignItems: "center",
        justifyContent: "center"
    }, hasLessThanMaxIssueCount ? roundedIssueCount : `${roundedIssueCount}+`) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $aba8ee8166d92834$var$innerStyles,
        space: "space.200",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center"
    }, issueTypeAvatarUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: issueTypeAvatarUrl,
        alt: "",
        className: (0, $hcewu.default)([
            "_4t3ipxbi _1bsbpxbi"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $aba8ee8166d92834$var$textStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        maxLines: 1
    }, summary)))))) : null;
};
const $aba8ee8166d92834$var$MAX_WIDTH = 300;
const $aba8ee8166d92834$var$rootStyles = (0, $1DXK0.xcss)({
    position: 'relative',
    width: `${$aba8ee8166d92834$var$MAX_WIDTH}px`
});
const $aba8ee8166d92834$var$listItemStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface',
    boxShadow: 'elevation.shadow.overlay',
    position: 'absolute',
    height: 'size.400',
    width: `${$aba8ee8166d92834$var$MAX_WIDTH}px`
});
const $aba8ee8166d92834$var$primaryItemStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    paddingLeft: 'space.200',
    backgroundColor: 'color.background.input'
});
const $aba8ee8166d92834$var$innerStyles = (0, $1DXK0.xcss)({
    height: '100%'
});
const $aba8ee8166d92834$var$textStyle = (0, $1DXK0.xcss)({
    maxWidth: '220px'
});
const $aba8ee8166d92834$var$imageStyles = null;
const $aba8ee8166d92834$var$child1Styles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.075',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.075'
});
const $aba8ee8166d92834$var$child2Styles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.150',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.150'
});
const $aba8ee8166d92834$var$badgeStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.negative.150',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    right: 'space.negative.150',
    borderRadius: 'radius.full',
    backgroundColor: 'color.background.accent.red.bolder',
    width: 'size.200',
    height: 'size.200',
    color: 'color.text.inverse'
});
const $aba8ee8166d92834$var$smallContentStyles = (0, $1DXK0.xcss)({
    font: 'font.body.small'
});

});

parcelRegister("bCFDb", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4ec151de2659cca$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d4ec151de2659cca$var$messages = (0, $7qGN1.defineMessages)({
    label: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.label",
        "defaultMessage": "Actions"
    },
    addParent: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.add-parent",
        "defaultMessage": "Add parent"
    },
    changeParent: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.change-parent",
        "defaultMessage": "Change parent"
    },
    moveToTop: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.move-to-top",
        "defaultMessage": "Move to top"
    },
    moveUp: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.move-up",
        "defaultMessage": "Move up"
    },
    moveDown: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.move-down",
        "defaultMessage": "Move down"
    },
    moveToBottom: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.move-to-bottom",
        "defaultMessage": "Move to bottom"
    }
});
var $d4ec151de2659cca$export$2e2bcd8739ae039 = $d4ec151de2659cca$var$messages;

});


parcelRegister("aTzcv", function(module, exports) {
$parcel$export(module.exports, "SiblingIssueCreateButton", () => $d33708464bf5704f$export$76f0c0887f3df38d);

var $6AuSh = parcelRequire("6AuSh");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $dcLzM = parcelRequire("dcLzM");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $jE8Tu = parcelRequire("jE8Tu");

var $4cTDP = parcelRequire("4cTDP");

var $aBHUF = parcelRequire("aBHUF");

var $6pTKw = parcelRequire("6pTKw");

var $6LwYU = parcelRequire("6LwYU");


var $4NiKr = parcelRequire("4NiKr");

var $jNv5I = parcelRequire("jNv5I");

var $e980u = parcelRequire("e980u");
const $d33708464bf5704f$var$styles = {
    button: "_1dqonqa1 _189ee4h9 _1h6d1l7x _4t3i1tcg _1bsb1tcg _kqswh2mm _16qs130s"
};
const $d33708464bf5704f$var$offset = [
    -1,
    -1
]; /**
                                            * Display a 'Create' popup button positioned relative to the nearest containing block that will appear when hovering
                                            * between issue rows.
                                            */ 
const $d33708464bf5704f$export$76f0c0887f3df38d = ({ issuesConnectionId: issuesConnectionId, edgeIndex: edgeIndex, issue: issue })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    let groupId;
    let setIsSiblingCreateVisible = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    if ((0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        setIsSiblingCreateVisible = (0, $jE8Tu.useHierarchyActions)().setIsSiblingCreateVisible; // eslint-disable-next-line react-hooks/rules-of-hooks
        groupId = (0, $jNv5I.useRowContext)().groupId;
    }
    const issueData = (0, $j4oe4.useFragment)((0, $6AuSh.default), issue);
    const [isInlineIssueCreateActive, { lockIndex: lockIndex, clearIndexAfterDelay: clearIndexAfterDelay }] = (0, $6LwYU.useIsSiblingIssueCreateActive)([
        issuesConnectionId,
        edgeIndex
    ]);
    const [isMouseOverSiblingCreate, setIsMouseOverSiblingCreate] = (0, $eJOHy.useState)(false);
    const { triggerProps: triggerProps } = (0, $4NiKr.useSiblingIssueCreateRow)();
    const handleMouseEnter = (0, $eJOHy.useCallback)(()=>{
        setIsMouseOverSiblingCreate(true);
        lockIndex((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8));
    }, [
        lockIndex
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        setIsMouseOverSiblingCreate(false);
        clearIndexAfterDelay((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8));
    }, [
        clearIndexAfterDelay
    ]);
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        triggerProps?.onClick();
        if (issueData?.issueId && (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting')) setIsSiblingCreateVisible?.({
            itemsConnectionId: issuesConnectionId,
            itemId: issueData.issueId,
            groupId: groupId
        }, true);
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'siblingIssueCreateButton');
    }, [
        createAnalyticsEvent,
        groupId,
        issueData?.issueId,
        issuesConnectionId,
        setIsSiblingCreateVisible,
        triggerProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6pTKw.RowPopupButton), {
        alignToYAxis: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
            label: ""
        }),
        isVisible: isInlineIssueCreateActive,
        label: formatMessage((0, $e980u.default).createLabel),
        offset: $d33708464bf5704f$var$offset,
        onClick: handleOnClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ref: triggerProps?.ref,
        tooltipContent: formatMessage((0, $e980u.default).createLabel),
        tooltipPosition: "left",
        xcss: $d33708464bf5704f$var$styles.button
    }), isMouseOverSiblingCreate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aBHUF.RowDropIndicator), {
        edge: "top"
    }));
};

});
parcelRegister("6AuSh", function(module, exports) {
$parcel$export(module.exports, "default", () => $b87d5e8271c39618$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<16ceb52b98514a7346dd29733ae7e258>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b87d5e8271c39618$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "siblingIssueCreateButton_nativeIssueTable",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "issueId"
        }
    ],
    "type": "JiraIssue"
};
$b87d5e8271c39618$var$node.hash = "6aee15b0398ae80100f4770b20226da4";
var $b87d5e8271c39618$export$2e2bcd8739ae039 = $b87d5e8271c39618$var$node;

});

parcelRegister("e980u", function(module, exports) {
$parcel$export(module.exports, "default", () => $17e444ad74de1b00$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $17e444ad74de1b00$var$messages = (0, $7qGN1.defineMessages)({
    createLabel: {
        "id": "native-issue-table.ui.row.before-first-cell.sibling-issue-create-button.create-label",
        "defaultMessage": "Create"
    }
});
var $17e444ad74de1b00$export$2e2bcd8739ae039 = $17e444ad74de1b00$var$messages;

});



parcelRegister("29rOm", function(module, exports) {
$parcel$export(module.exports, "default", () => $0cc4cd5321bb6155$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $eS29z = parcelRequire("eS29z");

var $bKlUQ = parcelRequire("bKlUQ");

var $34oCh = parcelRequire("34oCh");

var $jNv5I = parcelRequire("jNv5I");

var $8jOO7 = parcelRequire("8jOO7");

var $c2eR8 = parcelRequire("c2eR8");
const $0cc4cd5321bb6155$var$BlankIssueRow = ({ isSelected: isSelected, cellBorder: cellBorder })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { columns: columns } = (0, $jNv5I.useRowContext)();
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const hasSpacerColumn = (0, $eJOHy.useMemo)(()=>isFixedTableLayoutEnabled && columns.some((c)=>c.id === (0, $8jOO7.COLUMN_ID_MEATBALL_MENU)), [
        isFixedTableLayoutEnabled,
        columns
    ]);
    const shouldAddSpacerColumn = (0, $4cTDP.fg)('fix_whitespace_shown') ? hasSpacerColumn : isFixedTableLayoutEnabled;
    const colSpan = columns.length + (shouldAddSpacerColumn ? 1 : 0); // Extra column added to account for the blank spacer column added to the table
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        colSpan: colSpan,
        border: cellBorder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0cc4cd5321bb6155$var$Text, {
        isSelected: isSelected
    }, formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $c2eR8.default).blankRowTextWithArchiveIssueIssueTermRefresh : (0, $c2eR8.default).blankRowTextWithArchiveIssue)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "blankIssue"
    }));
};
var $0cc4cd5321bb6155$export$2e2bcd8739ae039 = $0cc4cd5321bb6155$var$BlankIssueRow;
const $0cc4cd5321bb6155$var$textColorActiveState = "var(--ds-text-selected, #1868DB)";
const $0cc4cd5321bb6155$var$textColor = "var(--ds-text, #292A2E)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0cc4cd5321bb6155$var$Text = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19bv1b66 _80om73ad",
            __cmplp.isSelected ? "_syaz6x5g" : "_syazi7uo",
            __cmplp.className
        ])
    });
});

});
parcelRegister("c2eR8", function(module, exports) {
$parcel$export(module.exports, "default", () => $0299e96509ca7ed3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0299e96509ca7ed3$var$messages = (0, $7qGN1.defineMessages)({
    blankRow: {
        "id": "native-issue-table.issue-row.blank-row.blank-row",
        "defaultMessage": "We can't display this issue"
    },
    blankRowText: {
        "id": "native-issue-table.row.blank-row.blank-row-text",
        "defaultMessage": "This issue cannot be opened because it may have been deleted or you do not have access to it"
    },
    blankRowTextWithArchiveIssue: {
        "id": "native-issue-table.row.blank-row.blank-row-text-with-archive-issue",
        "defaultMessage": "This issue can\u2019t be opened because it may have been archived or deleted, or you don\u2019t have access to it."
    },
    blankRowTextWithArchiveIssueIssueTermRefresh: {
        "id": "native-issue-table.row.blank-row.blank-row-text-with-archive-issue-issue-term-refresh",
        "defaultMessage": "This work item can\u2019t be opened because it may have been archived or deleted, or you don\u2019t have access to it."
    },
    tooltip: {
        "id": "native-issue-table.issue-row.blank-row.tooltip",
        "defaultMessage": "Either this issue has been deleted, or you don\u2019t have access to it."
    },
    blankRowIssueTermRefresh: {
        "id": "native-issue-table.row.blank-row.blank-row-issue-term-refresh",
        "defaultMessage": "We can't display this work item"
    },
    blankRowTextIssueTermRefresh: {
        "id": "native-issue-table.row.blank-row.blank-row-text-issue-term-refresh",
        "defaultMessage": "This work item cannot be opened because it may have been deleted or you do not have access to it."
    },
    tooltipIssueTermRefresh: {
        "id": "native-issue-table.row.blank-row.tooltip-issue-term-refresh",
        "defaultMessage": "Either this work item has been deleted, or you don\u2019t have access to it."
    }
});
var $0299e96509ca7ed3$export$2e2bcd8739ae039 = $0299e96509ca7ed3$var$messages;

});


parcelRegister("7EMZm", function(module, exports) {
$parcel$export(module.exports, "IssueCreateRow", () => $566ff58d0f75b900$export$a7c20b50f3f5d02c);

var $eJOHy = parcelRequire("eJOHy");

var $es8uT = parcelRequire("es8uT");
const $566ff58d0f75b900$export$a7c20b50f3f5d02c = ({ isFormVisible: isFormVisible, ...props })=>{
    return isFormVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $es8uT.IssueCreateCell), props));
};

});
parcelRegister("es8uT", function(module, exports) {
$parcel$export(module.exports, "IssueCreateCell", () => $c269d40757de226d$export$2337c3632571bf46);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6xIZT = parcelRequire("6xIZT");

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");

var $7n9BS = parcelRequire("7n9BS");

var $9r0oq = parcelRequire("9r0oq");

var $aNnbk = parcelRequire("aNnbk");
const $c269d40757de226d$export$2337c3632571bf46 = ({ issuesConnectionId: issuesConnectionId, siblingIssueId: siblingIssueId, rankFieldId: rankFieldId, parentIssueAri: parentIssueAri, location: location, groupContextFieldInput: groupContextFieldInput, ...props })=>{
    const width = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.width);
    const jql = (0, $34oCh.useJql)();
    const isIssueRankDescending = (0, $34oCh.useIsIssueRankDescending)();
    // JSC-169 Set rankFieldId into formContextualFields so correct rank is set for GIC fallback
    const formContextualFields = (0, $eJOHy.useMemo)(()=>isIssueRankDescending ? {
            rankAfterIssueId: siblingIssueId,
            rankFieldId: rankFieldId
        } : {
            rankBeforeIssueId: siblingIssueId,
            rankFieldId: rankFieldId
        }, [
        isIssueRankDescending,
        siblingIssueId,
        rankFieldId
    ]);
    const onCreateIssue = (0, $aNnbk.useIssueCreateMutation)({
        issueConnectionId: issuesConnectionId,
        jql: jql,
        ...(0, $4cTDP.fg)('group_by_any_field_sibling_inline_issue_create') && {
            groupContextFieldInput: groupContextFieldInput
        },
        ...(0, $4cTDP.fg)('jsc_list_reranking_gate') && {
            location: location
        }
    });
    const handleIssueCreate = (0, $eJOHy.useCallback)((issueToCreate, contextualFields)=>{
        onCreateIssue(issueToCreate, {
            ...contextualFields,
            ...parentIssueAri && {
                parentIssueAri: parentIssueAri
            }
        }, {
            insertAfter: false,
            insertNodeId: siblingIssueId
        });
    }, [
        onCreateIssue,
        parentIssueAri,
        siblingIssueId
    ]);
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const form = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6xIZT.default), {
        contextualFields: formContextualFields,
        onCreateIssue: handleIssueCreate,
        rankFieldId: rankFieldId,
        location: location,
        ...props
    });
    if (isTimelineEnabled || (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_issue_table_updates')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c269d40757de226d$var$CustomisableIssueCreateCellWrapper, {
        width: width
    }, form);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "td",
        xcss: $c269d40757de226d$var$cellStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $c269d40757de226d$var$boxStyles,
        style: {
            width: `${width}px`
        }
    }, form));
};
const $c269d40757de226d$export$2eff3f295c9bc2ba = ({ children: children, width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "td",
        xcss: $c269d40757de226d$var$cellStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $c269d40757de226d$var$boxStyles,
        style: {
            width: `${width}px`
        }
    }, children));
const $c269d40757de226d$var$CustomisableIssueCreateCellWrapper = ({ children: children, width: width })=>{
    const timelineCustomComponents = (0, $9r0oq.useTimelineCustomComponents)();
    const Wrapper = timelineCustomComponents?.IssueCreateCellWrapper ?? $c269d40757de226d$export$2eff3f295c9bc2ba;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapper, {
        width: width
    }, children);
};
const $c269d40757de226d$var$cellStyles = (0, $1DXK0.xcss)({
    height: '40px',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.0',
    position: 'sticky',
    zIndex: 'card'
});
const $c269d40757de226d$var$boxStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});

});


parcelRegister("6P9sy", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f275defbc93e5d7$export$2e2bcd8739ae039);

var $jYakz = parcelRequire("jYakz");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");

var $eJ9f5 = parcelRequire("eJ9f5");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $kRgKj = parcelRequire("kRgKj");
var $eS29z = parcelRequire("eS29z");
var $ftN6c = parcelRequire("ftN6c");

var $gPQL9 = parcelRequire("gPQL9");

var $kRgKj = parcelRequire("kRgKj");

var $244Ix = parcelRequire("244Ix");

var $34oCh = parcelRequire("34oCh");

var $jNv5I = parcelRequire("jNv5I");

var $bKlUQ = parcelRequire("bKlUQ");

var $8jOO7 = parcelRequire("8jOO7");

var $j9Qlh = parcelRequire("j9Qlh");
const $9f275defbc93e5d7$var$APPLINK_MISSING = 'APPLINK_MISSING';
const $9f275defbc93e5d7$var$APPLINK_REQ_AUTH = 'APPLINK_REQ_AUTH';
const $9f275defbc93e5d7$var$RemoteIssueErrorRow = ({ isSelected: isSelected, cellBorder: cellBorder, errorRef: errorRef, issueKey: issueKey, onAuthenticationClick: onAuthenticationClick })=>{
    // Define fragment inside the component to satisfy Relay linting rules
    const error = (0, $j4oe4.useFragment)((0, $jYakz.default), errorRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { columns: columns, tableInjectedProps: tableInjectedProps } = (0, $jNv5I.useRowContext)();
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const hasSpacerColumn = (0, $eJOHy.useMemo)(()=>isFixedTableLayoutEnabled && columns.some((c)=>c.id === (0, $8jOO7.COLUMN_ID_MEATBALL_MENU)), [
        isFixedTableLayoutEnabled,
        columns
    ]);
    // Extract remoteServerHostname from repairLink.href
    const remoteServerHostname = (0, $eJOHy.useMemo)(()=>{
        if (error?.repairLink?.href) try {
            return new URL(error.repairLink.href).hostname;
        } catch  {
            return null;
        }
        return null;
    }, [
        error?.repairLink?.href
    ]);
    const getAttributes = (0, $eJOHy.useCallback)(()=>({
            errorType: error?.errorType || 'NONE',
            issueKey: issueKey || 'UNKNOWN',
            remoteServerHostname: remoteServerHostname || 'UNKNOWN',
            isSelected: isSelected,
            hasRepairLink: !!error?.repairLink?.href,
            hasError: !!error,
            isRemote: !!remoteServerHostname,
            component: 'RemoteIssueErrorRow',
            context: 'issue-table'
        }), [
        error,
        issueKey,
        remoteServerHostname,
        isSelected
    ]);
    const handleUserClickAnalytics = (0, $eJOHy.useCallback)((actionSubjectId)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'issueView.ErrorIssueRow'
        });
        const attributes = getAttributes();
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
    }, [
        createAnalyticsEvent,
        getAttributes
    ]);
    const handleAuthentication = (0, $eJOHy.useCallback)(async ()=>{
        // Track authentication click analytics
        handleUserClickAnalytics('errorIssueRow.authenticationLink');
        const analyticsEvent = createAnalyticsEvent({
            action: 'authenticate',
            actionSubject: 'errorIssueRow.authenticationLink'
        });
        // Check if error has repairLink
        if (error?.repairLink?.href) try {
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'applink authenticate', {
                authStatus: 'start'
            });
            await (0, $244Ix.default)(error.repairLink.href);
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'applink authenticate', {
                authStatus: 'success'
            });
            // On successful authentication, refetch the table data
            if (tableInjectedProps.onIssueRefetch) tableInjectedProps.onIssueRefetch(issueKey || '');
        } catch (authError) {
            // Track authentication failure for Splunk monitoring
            if (authError instanceof Error || authError instanceof TypeError) (0, $gPQL9.trackOrLogClientError)('remote-issue-error-row', 'Failed to authenticate with applinks', authError);
        }
        else if (onAuthenticationClick) // Fallback to the original authentication click handler
        onAuthenticationClick();
    }, [
        error,
        issueKey,
        tableInjectedProps,
        onAuthenticationClick,
        handleUserClickAnalytics,
        createAnalyticsEvent
    ]);
    const renderContent = (0, $eJOHy.useMemo)(()=>{
        switch(error?.errorType){
            case $9f275defbc93e5d7$var$APPLINK_REQ_AUTH:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                    color: isSelected ? 'color.text.selected' : 'color.text'
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
                    ...(0, $j9Qlh.default).linkedWorkItemAuthRequiredWithCta,
                    values: {
                        cta: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                            href: error.repairLink?.href || '#',
                            onClick: (e)=>{
                                e.preventDefault();
                                handleAuthentication();
                            }
                        }, formatMessage((0, $j9Qlh.default).linkedWorkItemAuthRequiredCta))
                    }
                }));
            case $9f275defbc93e5d7$var$APPLINK_MISSING:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                    color: "color.text.danger"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
                    ...(0, $j9Qlh.default).linkedWorkItemMissingApplinkWithCta,
                    values: {
                        cta: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                            href: "/plugins/servlet/applinks/listApplicationLinks",
                            target: "_blank",
                            onClick: ()=>handleUserClickAnalytics('errorIssueRow.projectSettingsLink')
                        }, formatMessage((0, $j9Qlh.default).linkedWorkItemMissingApplinkCta))
                    }
                }));
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                    color: isSelected ? 'color.text.selected' : 'color.text'
                }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $j9Qlh.default).remoteLinkGeneralErrorIssueTermRefresh : (0, $j9Qlh.default).remoteLinkGeneralError));
        }
    }, [
        error,
        formatMessage,
        handleAuthentication,
        isSelected,
        handleUserClickAnalytics
    ]);
    // Extra column added to account for the blank spacer column added to the table
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        colSpan: columns.length + (hasSpacerColumn ? 1 : 0),
        border: cellBorder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingInlineStart: "space.050"
    }, renderContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "errorRemoteIssue"
    }));
};
var $9f275defbc93e5d7$export$2e2bcd8739ae039 = $9f275defbc93e5d7$var$RemoteIssueErrorRow;

});
parcelRegister("jYakz", function(module, exports) {
$parcel$export(module.exports, "default", () => $940449db6a8d76bc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e49a0d171cf204c0b601fbf996d84ae3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $940449db6a8d76bc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "remoteIssueErrorRow_nativeIssueTable",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "errorType"
        },
        {
            "concreteType": "JiraRemoteLinkedIssueRepairLink",
            "kind": "LinkedField",
            "name": "repairLink",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "href"
                }
            ]
        }
    ],
    "type": "JiraRemoteLinkedIssueError"
};
$940449db6a8d76bc$var$node.hash = "4b0b11002505554c4dfc4885dad1c880";
var $940449db6a8d76bc$export$2e2bcd8739ae039 = $940449db6a8d76bc$var$node;

});

parcelRegister("gPQL9", function(module, exports) {
$parcel$export(module.exports, "trackOrLogClientError", () => $10ba3674ae190436$export$2fc29872103bf255);

var $9pTd3 = parcelRequire("9pTd3");

var $eSnSE = parcelRequire("eSnSE");

var $dMM78 = parcelRequire("dMM78");
const $10ba3674ae190436$export$c392d6295c0a29c7 = (location, message, error)=>{
    (0, $9pTd3.fireErrorAnalytics)({
        error: error,
        attributes: {
            message: message
        },
        meta: {
            id: location,
            packageName: 'jiraIssueViewCommonUtils'
        }
    });
};
const $10ba3674ae190436$export$2fc29872103bf255 = (location, message, error)=>{
    if (error instanceof TypeError && (0, $dMM78.isClientFetchError)(error)) $10ba3674ae190436$export$c392d6295c0a29c7(location, message, error);
    else (0, $eSnSE.default).safeErrorWithoutCustomerData(location, message, error);
};

});

parcelRegister("244Ix", function(module, exports) {
$parcel$export(module.exports, "default", () => $981ba3ecf8731a91$export$2e2bcd8739ae039);
/**
    This function is in order to encapsulate the behavior of the AppLinksUtils functionality

    AppLinksUtils is an Atlassian Plugin.

    AppLinks repository: https://bitbucket.org/atlassian/application-links
 */ /**
    The following function implements the same interface as the [OAuthCallback object](https://bitbucket.org/atlassian/application-links/src/02de9b212e57ff72a3a44744ed6cabc5ff359874/applinks-plugin/src/main/resources/applinks/internal/feature/oauth/oauth-callback.js?at=master)

    It creates the object, assigns the object to a global variable in window and calls the plugin in a new window

    Once the Authentication dance is perform, the opened window will call success or failure callbacks from the window.opener.oauthCallback (https://bitbucket.org/atlassian/application-links/src/02de9b212e57ff72a3a44744ed6cabc5ff359874/applinks-oauth-plugin/src/main/resources/com/atlassian/applinks/oauth/auth/oauth-dance.js?at=master)
 */ const $981ba3ecf8731a91$var$authenticateUsingAppLinks = (url)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.oauthCallback) // preventing opening more than one authentication at the time.
    return null;
    const result = new Promise((resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reject)=>{
        let oauthWindow;
        let timer;
        let isPending = true;
        const oauthCallback = {
            success: ()=>{
                clearInterval(timer);
                // @ts-expect-error - TS2794 - Expected 1 arguments, but got 0. Did you forget to include 'void' in your type argument to 'Promise'?
                resolve();
                isPending = false;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                delete window.oauthCallback;
                oauthWindow && oauthWindow.close();
            },
            failure: ()=>{
                clearInterval(timer);
                reject(Error('Failed to authenticate with applinks'));
                isPending = false;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                delete window.oauthCallback;
                oauthWindow && oauthWindow.close();
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.oauthCallback = oauthCallback;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        oauthWindow = window.open(url, 'com_atlassian_applinks_authentication');
        timer = setInterval(()=>{
            if (oauthWindow && oauthWindow.closed && isPending) {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                delete window.oauthCallback;
                reject(Error('Failed to authenticate with applinks'));
                clearInterval(timer);
            }
        }, 500);
    });
    return result;
};
var $981ba3ecf8731a91$export$2e2bcd8739ae039 = $981ba3ecf8731a91$var$authenticateUsingAppLinks;

});

parcelRegister("j9Qlh", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cf380362dad6239$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5cf380362dad6239$var$messages = (0, $7qGN1.defineMessages)({
    remoteLinkGeneralErrorIssueTermRefresh: {
        "id": "issues.issue-links.remote-issue-link-error.general-error-issue-term-refresh",
        "defaultMessage": "Failed to load work item"
    },
    remoteLinkGeneralError: {
        "id": "issues.issue-links.remote-issue-link-error.general-error",
        "defaultMessage": "Failed to load remote issue"
    },
    // Copy for linked work items error row
    linkedWorkItemAuthRequiredCta: {
        "id": "native-issue-table.remote-issue-error.linked-work-item-auth-required.cta",
        "defaultMessage": "Authenticate"
    },
    // Combined text + CTA with placeholder for proper spacing/i18n handling
    linkedWorkItemAuthRequiredWithCta: {
        "id": "native-issue-table.remote-issue-error.linked-work-item-auth-required.with-cta",
        "defaultMessage": "This linked work item belongs to a separate Jira site that's not authenticated. {cta}"
    },
    linkedWorkItemMissingApplinkCta: {
        "id": "native-issue-table.remote-issue-error.linked-work-item-missing-applink.cta",
        "defaultMessage": "Go to Project settings to link"
    },
    // Combined text + CTA with placeholder for proper spacing/i18n handling
    linkedWorkItemMissingApplinkWithCta: {
        "id": "native-issue-table.remote-issue-error.linked-work-item-missing-applink.with-cta",
        "defaultMessage": "This linked work item belongs to a separate Jira site that\u2019s not linked. {cta}"
    }
});
var $5cf380362dad6239$export$2e2bcd8739ae039 = $5cf380362dad6239$var$messages;

});


parcelRegister("c3pb3", function(module, exports) {
$parcel$export(module.exports, "IssueRow", () => $da6c3c43cb5f64c3$export$29013dcb6d1b879d);

var $9Ik9l = parcelRequire("9Ik9l");

var $fHG3l = parcelRequire("fHG3l");

var $jycb2 = parcelRequire("jycb2");

var $9R4GG = parcelRequire("9R4GG");

var $eJOHy = parcelRequire("eJOHy");

var $buoPQ = parcelRequire("buoPQ");

var $12DRg = parcelRequire("12DRg");

var $5PQOA = parcelRequire("5PQOA");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $j8Km1 = parcelRequire("j8Km1");

var $cxKOj = parcelRequire("cxKOj");

var $ftN6c = parcelRequire("ftN6c");

var $7n9BS = parcelRequire("7n9BS");

var $8jOO7 = parcelRequire("8jOO7");

var $kJbAU = parcelRequire("kJbAU");

var $auNiK = parcelRequire("auNiK");

var $1iVG2 = parcelRequire("1iVG2");

var $lqvgs = parcelRequire("lqvgs");

var $9ZBXb = parcelRequire("9ZBXb");

var $1pe67 = parcelRequire("1pe67");

var $g3S5f = parcelRequire("g3S5f");

var $wJcwZ = parcelRequire("wJcwZ");

var $40Xgt = parcelRequire("40Xgt");

var $dQN02 = parcelRequire("dQN02");

var $l17Xm = parcelRequire("l17Xm");

var $avymT = parcelRequire("avymT");

var $4mhLJ = parcelRequire("4mhLJ");

var $crxno = parcelRequire("crxno");

var $kHiWE = parcelRequire("kHiWE");

var $2Oa4s = parcelRequire("2Oa4s");

var $dBL3m = parcelRequire("dBL3m");

var $5eN53 = parcelRequire("5eN53");

var $aa1Tw = parcelRequire("aa1Tw");

var $arQXy = parcelRequire("arQXy");

var $69Ju5 = parcelRequire("69Ju5");

var $fqa5Z = parcelRequire("fqa5Z");

var $jG8is = parcelRequire("jG8is");

var $acnWs = parcelRequire("acnWs");

var $fjuAd = parcelRequire("fjuAd");

var $1LuaS = parcelRequire("1LuaS");

var $h0Klc = parcelRequire("h0Klc");

var $8lV7c = parcelRequire("8lV7c");

var $iCclW = parcelRequire("iCclW");

var $fr65p = parcelRequire("fr65p");

var $5U6Sf = parcelRequire("5U6Sf");

var $36qKB = parcelRequire("36qKB");

var $j5nH8 = parcelRequire("j5nH8");

var $fAn1n = parcelRequire("fAn1n");

var $gfFaI = parcelRequire("gfFaI");

var $48WLd = parcelRequire("48WLd");

var $aqqsA = parcelRequire("aqqsA");

var $fj3ot = parcelRequire("fj3ot");

var $g6JiP = parcelRequire("g6JiP");

var $bKlUQ = parcelRequire("bKlUQ");

var $P01So = parcelRequire("P01So");

var $34oCh = parcelRequire("34oCh");

var $jNv5I = parcelRequire("jNv5I");

var $9wlkB = parcelRequire("9wlkB");

var $4UEvW = parcelRequire("4UEvW");

var $81JsW = parcelRequire("81JsW");

var $jT7JX = parcelRequire("jT7JX");

var $100iH = parcelRequire("100iH");

var $01wyE = parcelRequire("01wyE");

var $9FoLd = parcelRequire("9FoLd");

var $ajiOP = parcelRequire("ajiOP");

var $jQO5F = parcelRequire("jQO5F");

var $cOqgG = parcelRequire("cOqgG");

var $gToWi = parcelRequire("gToWi");

var $4XMye = parcelRequire("4XMye");

var $69bTC = parcelRequire("69bTC");
const $da6c3c43cb5f64c3$export$cc10a6916fdb60c = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((typename, createAnalyticsEvent)=>{
    (0, $9pTd3.fireErrorAnalytics)({
        meta: {
            id: 'tableCellUnhandledGraphQLType',
            packageName: (0, $8jOO7.PACKAGE_NAME),
            teamName: (0, $8jOO7.TEAM_NAME)
        },
        error: new Error(`Unhandled GraphQL type ${typename} when trying to render issue field.`),
        event: createAnalyticsEvent({}),
        attributes: {
            typename: typename
        }
    });
});
const $da6c3c43cb5f64c3$export$b1e360b45a7ed518 = ({ project: project, issueEdge: issueEdge, fieldSets: fieldSets, cellBorder: cellBorder, beforeFirstCell: beforeFirstCell, itemsConnectionId: itemsConnectionId, depth: depth, isRowHoveredOrSelected: isRowHoveredOrSelected, rowIndex: rowIndex, triggerProps: triggerProps, isFormVisible: isFormVisible, isStickyColumnsVisible: isStickyColumnsVisible, formattingRules: formattingRules })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    // State for managing merged cell focus
    const [isMergedCellFocused, setIsMergedCellFocused] = (0, $eJOHy.useState)(false);
    const projectRef = (0, $j4oe4.useFragment)((0, $9R4GG.default), project);
    const formattingRulesRef = (0, $j4oe4.useFragment)((0, $jycb2.default), formattingRules);
    const issueEdgeData = (0, $j4oe4.useFragment)((0, $fHG3l.default), issueEdge);
    const issueData = issueEdgeData?.node;
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $9Ik9l.default), fieldSets);
    // eslint-disable-next-line no-nested-ternary
    const colorForId = (0, $4cTDP.fg)('jira_list_conditional_formatting') ? (0, $4cTDP.fg)('saved_list_view_technical_changes') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jQO5F.useCellsConditionalFormatting)(null, fieldSetsData, formattingRulesRef) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jQO5F.useCellsConditionalFormatting)(projectRef, fieldSetsData) : {}; // placeholder for what will soon be const color = ...
    const isCreateSubTaskAllowed = issueData && issueData.issueTypeField?.issueType?.hierarchy?.level === 0;
    const { columns: columns, tableInjectedProps: tableInjectedProps, groupConnectionId: groupConnectionId, groupId: groupId, resizingColumnIndex: resizingColumnIndex } = (0, $jNv5I.useRowContext)();
    const columnConfigByIdMap = (0, $eJOHy.useMemo)(()=>{
        const result = new Map();
        columns.forEach((columnConfig)=>{
            result.set(columnConfig.id, columnConfig);
        });
        return result;
    }, [
        columns
    ]);
    const onFocusHandler = (0, $eJOHy.useCallback)(()=>setIsMergedCellFocused(true), []);
    const onBlurHandler = (0, $eJOHy.useCallback)((e)=>{
        const currentTarget = e.currentTarget;
        const relatedTarget = e.relatedTarget;
        // Check if focus is staying within the merged cell
        if (relatedTarget && currentTarget.contains(relatedTarget)) return;
        // Check if this cell has a menu trigger (for portal-rendered menus)
        const menuTriggerInCell = currentTarget.querySelector('[aria-haspopup="true"], [aria-haspopup="menu"]');
        if (menuTriggerInCell) {
            // Check if the menu is currently open
            if (menuTriggerInCell.getAttribute('aria-expanded') === 'true') return;
            // Check if focus moved to the menu/menuitem in a portal
            if (relatedTarget instanceof HTMLElement) {
                const isMenuOrMenuItem = relatedTarget.closest('[role="menu"], [role="menuitem"]') || relatedTarget.querySelector('[role="menu"], [role="menuitem"]');
                if (isMenuOrMenuItem) return;
            }
        }
        // Focus has left the merged cell system entirely
        setIsMergedCellFocused(false);
    }, []);
    const isIssueHierarchyEnabled = (0, $34oCh.useIsIssueHierarchyEnabled)();
    let handleStatusUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $4cTDP.fg)('jsc_list_hide_done_items') && !(0, $4cTDP.fg)('memoise_issuetable_components')) // eslint-disable-next-line react-hooks/rules-of-hooks
    handleStatusUpdate = (0, $jT7JX.useHideDoneItems)({
        itemsConnectionId: itemsConnectionId,
        recordId: issueData?.__id,
        projectKey: issueData?.key && (0, $P01So.getProjectKeyFromIssueKey)(issueData.key),
        groupConnectionId: groupConnectionId
    });
    let isMergedColumnEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnEnabled = (0, $34oCh.useIsMergedColumnEnabled)();
    const handleUpdateCacheNew = (0, $eJOHy.useCallback)((issueKey, fieldName, field)=>{
        tableInjectedProps.onUpdateCache?.(issueKey, fieldName, field);
        handleStatusUpdate(field);
    }, [
        handleStatusUpdate,
        tableInjectedProps
    ]);
    const handleUpdateCache = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('jsc_list_hide_done_items') && !(0, $4cTDP.fg)('memoise_issuetable_components') ? handleUpdateCacheNew : tableInjectedProps.onUpdateCache;
    const isIssueOperationMeatballMenuEnabled = (0, $34oCh.useIsIssueOperationMeatballMenuEnabled)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const fieldElementByIdMap = (0, $eJOHy.useMemo)(()=>{
        // Map all issue fields into their respective cell type keyed by fieldSetId. This will be used as a lookup when
        // mapping table columns in the row.
        const result = new Map();
        if (isIssueHierarchyEnabled && issueEdgeData && !(isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate'))) {
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gToWi.default), {
                isRowHoveredOrSelected: Boolean(isRowHoveredOrSelected),
                itemsConnectionId: itemsConnectionId,
                depth: depth,
                issueRef: issueEdgeData,
                triggerProps: triggerProps,
                isFormVisible: isFormVisible
            });
            result.set((0, $8jOO7.COLUMN_ID_EXPAND_BUTTON), {
                cellElement: element,
                spacing: $da6c3c43cb5f64c3$var$noSpacingStyles
            });
        }
        if (issueEdgeData && isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate')) {
            const { issueTypeField: issueTypeField, issueKeyField: issueKeyField, summaryField: summaryField, fieldId: fieldId } = (0, $69bTC.getMergedFields)(fieldSetsData);
            const isHierarchyEnabled = isIssueHierarchyEnabled;
            if (isHierarchyEnabled || issueTypeField || issueKeyField || summaryField) {
                const mergedColumns = columns.find(({ id: id })=>id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN))?.mergedColumns?.map(({ id: id })=>id) ?? [];
                const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4XMye.MergedCell), {
                    key: (0, $j8Km1.COLUMN_ID_MERGED_COLUMN),
                    itemsConnectionId: itemsConnectionId,
                    depth: depth,
                    issueRef: issueEdgeData,
                    isRowHoveredOrSelected: Boolean(isRowHoveredOrSelected),
                    isCreateChildFormVisible: isFormVisible,
                    createChildTriggerProps: triggerProps,
                    groupId: groupId,
                    isHierarchyEnabled: isHierarchyEnabled,
                    ...(0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') && {
                        isFocused: isMergedCellFocused
                    },
                    renderContent: ({ actionButtons: actionButtons, isMergedCellFocusedOrHovered: isMergedCellFocusedOrHovered })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, issueTypeField && mergedColumns.includes('issuetype') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                            xcss: isHierarchyEnabled ? $da6c3c43cb5f64c3$var$typeCellStyles : $da6c3c43cb5f64c3$var$typeCellNoHierarchyStyles
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $69Ju5.IssueTypeCell), {
                            fieldRef: issueTypeField
                        })), issueKeyField && mergedColumns.includes('issuekey') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kHiWE.IssueKeyCell), {
                            fieldRef: issueKeyField,
                            issueRef: issueData,
                            onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected,
                            isRowHoveredOrSelected: (0, $4cTDP.fg)('jsc-2733-copy_link_from_issue_key') ? Boolean(isRowHoveredOrSelected) : undefined,
                            isTruncated: Boolean(summaryField) === false
                        }), !summaryField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                            xcss: $da6c3c43cb5f64c3$var$childCreateButtonStyle
                        }, actionButtons), summaryField && mergedColumns.includes('summary') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $arQXy.IssueSummaryCell), {
                            fieldRef: summaryField,
                            issueRef: issueData,
                            onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected,
                            isRowHoveredOrSelected: Boolean(isRowHoveredOrSelected),
                            readViewHighlightOnHover: false,
                            ...(0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') && {
                                isMergedCellFocusedOrHovered: isMergedCellFocusedOrHovered
                            }
                        }, actionButtons))
                });
                result.set((0, $j8Km1.COLUMN_ID_MERGED_COLUMN), {
                    cellElement: element,
                    spacing: $da6c3c43cb5f64c3$var$noSpacingStyles,
                    multipleFieldLayoutAdjustment: true,
                    columnIds: mergedColumns,
                    ...fieldId ? {
                        fieldId: fieldId
                    } : {}
                });
            }
        }
        fieldSetsData?.edges?.map((edge)=>edge?.node).filter((0, $P01So.isNonNullish)).forEach((fieldSet)=>{
            // @ts-expect-error - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | null'.
            const columnConfig = columnConfigByIdMap.get(fieldSet.fieldSetId);
            if (!fieldSet.fieldSetId || !columnConfig) return;
            const projectKey = (0, $P01So.getProjectKeyFromIssueKey)(issueData.key);
            // Handle Collapsed Fields on a single issue (rare) by simply rendering a node for each field.
            const fieldElements = [];
            // Allow td spacing to be configured for the given field type
            let spacing;
            // Stop gap fix to wrap inline editable field elements in styled containers when there are multiple
            // fields within a single cell. This is necessary as inline editable fields have min-height: 100% by
            // default.
            // TODO JSC-1783 This approach will need to be revised as part of single row height once we gather data
            //  on prevalence of this edge case.
            let multipleFieldLayoutAdjustment;
            let fieldId;
            const hasDuplicates = (fieldSet.fields?.totalCount ?? 1) > 1;
            fieldSet.fields?.edges?.forEach((fieldEdge, count)=>{
                // True if it is the first occuring cell
                const isFirstField = count === 0;
                fieldId = fieldEdge?.node?.id;
                switch(fieldEdge?.node?.__typename){
                    case 'JiraAffectedServicesField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJbAU.AffectedServicesCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraCascadingSelectField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $wJcwZ.CascadingSelectCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraCMDBField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1pe67.CmdbObjectsCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraCheckboxesField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9ZBXb.CheckboxSelectCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraComponentsField':
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g3S5f.ComponentsInlineEditCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            jqlTerm: columnConfig.jqlTerm,
                            projectKey: projectKey
                        }));
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraTimelineField':
                        if (isTimelineEnabled) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $01wyE.TimelineCellRenderer), {
                                key: fieldEdge.node.fieldId,
                                depth: depth,
                                groupId: groupId,
                                fieldRef: fieldEdge.node
                            }));
                            spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        }
                        break;
                    case 'JiraAggregatedTimelineField':
                        if (isTimelineEnabled && (0, $4cTDP.fg)('jira_timeline_rollups_technical_gate')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $01wyE.TimelineCellRenderer), {
                                key: fieldEdge.node.fieldId,
                                depth: depth,
                                groupId: groupId,
                                fieldRef: fieldEdge.node
                            }));
                            spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        }
                        break;
                    case 'JiraDatePickerField':
                        if (isInlineEditingExtendedFieldSupportEnabled) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $40Xgt.DateInlineEditCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isFirstField: isFirstField,
                                hasDuplicates: hasDuplicates
                            }));
                            spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        } else {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $40Xgt.DateCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node
                            }));
                            if (fieldEdge.node.fieldId === (0, $j8Km1.KNOWN_COLUMN_TYPES).DUE_DATE) spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        }
                        break;
                    case 'JiraDateTimePickerField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dQN02.DateTimeCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraEpicLinkField':
                        // This field is deprecated; this field will show text "Replaced by Parent field" as content
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l17Xm.EpicLinkCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraFallbackField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $avymT.FallbackCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        break;
                    case 'JiraIssueTypeField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $69Ju5.IssueTypeCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraLabelsField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fqa5Z.LabelsCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraMultipleSelectField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jG8is.MultiSelectCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraMultipleSelectUserPickerField':
                        // This field is not treated with single line row height since the read view
                        // is using <AvatarGroup> component from @atlaskit/avatar-group. Until this component is modified,
                        // or rebuilt, right truncation will not be applied.
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $acnWs.MultiUserPickerCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraMultipleGroupPickerField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $100iH.MultiGroupPickerCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        break;
                    case 'JiraNumberField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1LuaS.NumberCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraParentIssueField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8lV7c.ParentCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            fieldType: fieldEdge.node.type
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraPriorityField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fr65p.PriorityCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraProjectField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5U6Sf.ProjectCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isRequired: fieldEdge.node.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).PROJECT
                        }));
                        break;
                    case 'JiraResolutionField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fAn1n.ResolutionCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraRichTextField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gfFaI.RichTextCell), {
                            issueKey: issueData.key,
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueRef: issueData,
                            isFirstField: isFirstField
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraSingleLineTextField':
                        if (fieldEdge.node.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kHiWE.IssueKeyCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                issueRef: issueData,
                                isRowHoveredOrSelected: (0, $4cTDP.fg)('jsc-2733-copy_link_from_issue_key') ? Boolean(isRowHoveredOrSelected) : undefined,
                                onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
                            }));
                            spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        } else if (fieldEdge.node.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $arQXy.IssueSummaryCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                issueRef: issueData,
                                onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
                            }));
                            spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        } else {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iCclW.PlainTextCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isFirstField: isFirstField,
                                hasDuplicates: hasDuplicates
                            }));
                            multipleFieldLayoutAdjustment = true;
                            spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        }
                        break;
                    case 'JiraSingleSelectUserPickerField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g6JiP.UserCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            projectKey: projectKey,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates,
                            ...(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') && {
                                isColumnSticky: columnConfig?.isColumnSticky
                            }
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraSingleSelectField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48WLd.SingleSelectCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraSprintField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aqqsA.SprintCell), {
                            key: fieldEdge.node.fieldId,
                            projectKey: projectKey,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            jqlTerm: columnConfig.jqlTerm
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraStatusCategoryField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5eN53.IssueStatusCategoryCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraStatusField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aa1Tw.IssueStatusCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueKey: issueData.key,
                            issueId: issueData.issueId,
                            onUpdateCache: handleUpdateCache,
                            recordId: issueData?.__id,
                            itemsConnectionId: itemsConnectionId,
                            groupConnectionId: groupConnectionId,
                            ...(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') && {
                                isColumnSticky: columnConfig?.isColumnSticky
                            }
                        }));
                        break;
                    case 'JiraServiceManagementRequestTypeField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j5nH8.RequestTypeCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraTeamViewField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fj3ot.TeamCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraIssueLinkField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Oa4s.IssueLinksCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            issueKey: issueData.key
                        }));
                        break;
                    case 'JiraCommentSummaryField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wlkB.CommentSummaryCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueKey: issueData.key,
                            onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        break;
                    case 'JiraUrlField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4UEvW.UrlCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraOriginalTimeEstimateField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h0Klc.OriginalEstimateCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraRadioSelectField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $36qKB.RadioSelectCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraMultipleVersionPickerField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $81JsW.MultiVersionPickerCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraGoalsField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $crxno.GoalsCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraTownsquareProjectField':
                        if ((0, $cxKOj.expValEquals)('atlassian_projects_-_native_integration', 'cohort', 'variation', 'control')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $auNiK.AtlasProjectCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node
                            }));
                            spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraConfluenceRemoteIssueLinksField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fjuAd.ConfluencePagesCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraFlagField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4mhLJ.FlagCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraWatchesField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9FoLd.WatchersCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraIssueLinkRelationshipTypeField':
                        if ((0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajiOP.LinkRelationshipTypeCell), {
                                key: fieldEdge.node.fieldId,
                                issueRef: issueData,
                                fieldRef: fieldEdge.node,
                                onIssueUnlink: tableInjectedProps.onIssueDelete,
                                issueStoreId: issueData?.__id,
                                itemsConnectionId: itemsConnectionId
                            }));
                            spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        }
                        break;
                    default:
                        if (fieldEdge?.node?.__typename) $da6c3c43cb5f64c3$export$cc10a6916fdb60c(fieldEdge?.node?.__typename, createAnalyticsEvent);
                        break;
                }
            });
            if (fieldElements.length) result.set(fieldSet.fieldSetId, {
                cellElement: fieldElements,
                spacing: spacing,
                multipleFieldLayoutAdjustment: multipleFieldLayoutAdjustment,
                ...fieldId ? {
                    fieldId: fieldId
                } : {}
            });
        });
        // Always include the Issue Operations meatball menu cell.
        // But show it empty if isIssueOperationMeatballMenuEnabled is false
        result.set((0, $8jOO7.COLUMN_ID_MEATBALL_MENU), {
            cellElement: isIssueOperationMeatballMenuEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dBL3m.IssueOperations), {
                key: (0, $8jOO7.COLUMN_ID_MEATBALL_MENU),
                workType: issueData?.issueTypeField?.issueType?.name,
                issueId: Number(issueData.issueId),
                issueKey: issueData.key,
                onIssueRefetch: tableInjectedProps.onIssueRefetch,
                onIssueDelete: tableInjectedProps.onIssueDelete,
                isCreateSubTaskAllowed: isCreateSubTaskAllowed
            })
        });
        result.set((0, $8jOO7.COLUMN_ID_CHECKBOX), {
            cellElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lqvgs.CheckboxCell), {
                issueId: issueData.issueId,
                rowIndex: rowIndex,
                ...(0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) && {
                    depth: depth
                }
            })
        });
        return result;
    }, [
        isIssueHierarchyEnabled,
        issueEdgeData,
        isMergedColumnEnabled,
        fieldSetsData,
        isIssueOperationMeatballMenuEnabled,
        issueData,
        tableInjectedProps.onIssueRefetch,
        tableInjectedProps.onIssueDelete,
        tableInjectedProps.onIssueLinkSelected,
        tableInjectedProps.issueSearchBaseUrl,
        isCreateSubTaskAllowed,
        rowIndex,
        isRowHoveredOrSelected,
        itemsConnectionId,
        depth,
        triggerProps,
        isFormVisible,
        groupId,
        columnConfigByIdMap,
        isTimelineEnabled,
        isInlineEditingExtendedFieldSupportEnabled,
        handleUpdateCache,
        createAnalyticsEvent,
        columns,
        isMergedCellFocused,
        groupConnectionId
    ]);
    const cellBorderWithNoInlineBordersStyles = (0, $eJOHy.useMemo)(()=>{
        if (cellBorder === undefined) return $da6c3c43cb5f64c3$var$noInlineBordersStyles;
        return [
            ...(0, (/*@__PURE__*/$parcel$interopDefault($buoPQ)))(cellBorder),
            $da6c3c43cb5f64c3$var$noInlineBordersStyles
        ];
    }, [
        cellBorder
    ]);
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const isConditionalFormattingEnabled = (0, $34oCh.useIsConditionalFormattingEnabled)();
    let scrollLeft = 0;
    let hasScrolledHorizontally = false;
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $4cTDP.fg)('issue_table_frozen_columns') && !(0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) // eslint-disable-next-line react-hooks/rules-of-hooks
    scrollLeft = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.scrollLeft) || 0;
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $4cTDP.fg)('issue_table_frozen_columns') && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) // eslint-disable-next-line react-hooks/rules-of-hooks
    hasScrolledHorizontally = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.scrollLeft > 0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, columns.map(({ id: id, type: type, isPlaceHolderField: isPlaceHolderField, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, isLastStickyColumn: isLastStickyColumn, title: title }, index)=>{
        const field = fieldElementByIdMap.get(id);
        const columnIds = field?.columnIds; /* when cells are merged, multiple column ids */ 
        const formatting = (()=>{
            if (!(0, $4cTDP.fg)('jira_list_conditional_formatting')) return undefined;
            if (!isConditionalFormattingEnabled) return undefined;
            /* merged cell is 1 column, many fields. check each columnId for the column's rules -> find first rule */ if (columnIds) {
                const rules = columnIds.map((columnId)=>colorForId[columnId]).filter(Boolean);
                if (!rules.length) return undefined;
                const appliedRuleIndex = Math.min(...rules.map(({ index: i })=>i));
                /* find rule with lowest index */ return rules.find(({ index: i })=>appliedRuleIndex === i);
            }
            return colorForId[id];
        })();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
            key: id
        }, // TODO: EM-7165 – Update the extra filler cell logic when refactoring the column picker column
        // Empty cell to fill remainig space if configured columns are not wide enough to fill the table
        isFixedTableLayoutEnabled && id === (0, $8jOO7.COLUMN_ID_MEATBALL_MENU) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
            border: cellBorderWithNoInlineBordersStyles,
            "aria-hidden": true,
            ...isConditionalFormattingEnabled && {
                formatting: $da6c3c43cb5f64c3$var$formattingStyles,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                style: {
                    '--issue-row-bg': formatting?.value,
                    '--issue-row-hover-bg': formatting?.hoverValue
                }
            }
        }), isPlaceHolderField && (0, $4cTDP.fg)('jira_inline_field_config_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1iVG2.LoadingCell), {
            cellBorder: cellBorder,
            ...isStickyColumnsVisible && (0, $4cTDP.fg)('issue_table_frozen_columns') && {
                isColumnSticky: isColumnSticky,
                stickyOffsets: stickyOffsets,
                hasRightShadow: (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? isLastStickyColumn && hasScrolledHorizontally : isLastStickyColumn && scrollLeft > 0
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cOqgG.default), {
            type: type,
            ...(0, $4cTDP.fg)('nin_duplicated_fields_info_a11y_fix') && {
                issueKey: issueData?.key,
                fieldName: title
            },
            beforeElement: index === 0 ? beforeFirstCell : undefined,
            cellElement: field?.cellElement,
            spacing: field?.spacing,
            multipleFieldLayoutAdjustment: field?.multipleFieldLayoutAdjustment,
            border: cellBorder,
            ...isConditionalFormattingEnabled && {
                formatting: (0, $4cTDP.fg)('issue_table_frozen_columns') ? $da6c3c43cb5f64c3$var$formattingStyles : $da6c3c43cb5f64c3$var$formattingStylesOld,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                style: {
                    '--issue-row-bg': formatting?.value,
                    '--issue-row-hover-bg': formatting?.hoverValue
                }
            },
            ...isStickyColumnsVisible && (0, $4cTDP.fg)('issue_table_frozen_columns') && {
                isColumnSticky: isColumnSticky,
                stickyOffsets: stickyOffsets,
                hasRightShadow: (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? isLastStickyColumn && hasScrolledHorizontally : isLastStickyColumn && scrollLeft > 0,
                isColumnResizing: isColumnSticky && (resizingColumnIndex ?? 0) < index && (0, $4cTDP.fg)('issue_table_frozen_columns')
            },
            ...field?.fieldId && {
                fieldId: field.fieldId
            },
            ...id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) && (0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') && {
                onFocusHandler: onFocusHandler,
                onBlurHandler: onBlurHandler
            }
        }));
    }));
};
const $da6c3c43cb5f64c3$var$noSpacingStyles = (0, $1DXK0.xcss)({
    padding: 'space.0'
});
const $da6c3c43cb5f64c3$var$noInlineBordersStyles = (0, $1DXK0.xcss)({
    borderInlineStartWidth: '0',
    borderInlineEndWidth: '0'
});
const $da6c3c43cb5f64c3$var$formattingStyles = (0, $1DXK0.xcss)({
    // @ts-expect-error XCSS typings don't allow css variables
    backgroundColor: 'var(--issue-row-bg, inherit)',
    ':hover': {
        // @ts-expect-error XCSS typings don't allow css variables
        backgroundColor: 'var(--issue-row-hover-bg, inherit)'
    }
});
const $da6c3c43cb5f64c3$var$formattingStylesOld = (0, $1DXK0.xcss)({
    // @ts-expect-error XCSS typings don't allow css variables
    backgroundColor: 'var(--issue-row-bg)',
    ':hover': {
        // @ts-expect-error XCSS typings don't allow css variables
        backgroundColor: 'var(--issue-row-hover-bg)'
    }
});
const $da6c3c43cb5f64c3$var$typeCellStyles = (0, $1DXK0.xcss)({
    paddingInlineStart: 'space.050'
});
const $da6c3c43cb5f64c3$var$typeCellNoHierarchyStyles = (0, $1DXK0.xcss)({
    paddingInlineStart: 'space.100'
});
const $da6c3c43cb5f64c3$var$childCreateButtonStyle = (0, $1DXK0.xcss)({
    marginInlineStart: 'auto',
    marginInlineEnd: 'space.100'
});
const $da6c3c43cb5f64c3$export$29013dcb6d1b879d = /*#__PURE__*/ (0, $eJOHy.memo)($da6c3c43cb5f64c3$export$b1e360b45a7ed518);

});
parcelRegister("9Ik9l", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c0814e2116517c3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<91c22bfef0147c1d94e611523ace0f19>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9c0814e2116517c3$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "type"
    }, v1 = {
        "kind": "Variable",
        "name": "isInlineEditingEnabled",
        "variableName": "isInlineEditingEnabled"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = [
        {
            "kind": "Variable",
            "name": "isEditableSyncLoaded",
            "variableName": "isEditableSyncLoaded"
        },
        v1 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isEditableSyncLoaded"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "IssueRow_fieldSets",
        "selections": [
            {
                "condition": "isConditionalFormattingEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "useCellsConditionalFormatting"
                    }
                ]
            },
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "fieldSetId"
                            },
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "totalCount"
                                    },
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fieldId"
                                                    },
                                                    v0 /*: any*/ ,
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "AffectedServicesCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "CascadingSelectCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "CmdbObjectsCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "ComponentsCell_ComponentsInlineEditCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "DateInlineEditCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "DateInlineEditCell_DateInlineEditCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "DateTimeCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "EpicLinkCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "FallbackCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "IssueKeyCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "IssueStatusCategoryCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "IssueStatusCell"
                                                    },
                                                    {
                                                        "args": v3 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "IssueSummaryCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "LabelsCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "IssueTypeCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "ParentCell"
                                                    },
                                                    {
                                                        "args": v3 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "PriorityCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ProjectCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ResolutionCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "SprintCell"
                                                    },
                                                    {
                                                        "args": v3 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "UserCellInternal"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "PlainTextCellOld"
                                                    },
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Variable",
                                                                "name": "isDensityFull",
                                                                "variableName": "isDensityFull"
                                                            }
                                                        ],
                                                        "kind": "FragmentSpread",
                                                        "name": "RichTextCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "RequestTypeCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "IssueLinksCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "NumberCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "CommentSummaryCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "UrlCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "SingleSelectCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "MultiSelectCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "CheckboxSelectCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "MultiUserPickerCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "TeamCell"
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": false,
                                                        "selections": [
                                                            {
                                                                "args": v2 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "OriginalEstimateCell"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "args": v2 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "OriginalEstimateCell_OriginalEstimateCellNew"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "RadioSelectCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "MultiVersionPickerCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "GoalsCell"
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "args": v2 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "AtlasProjectCell"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "ConfluencePagesCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "MultiGroupPickerCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "FlagCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "WatchersCell"
                                                    },
                                                    {
                                                        "condition": "isLinkRelationshipFieldEnabled",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "args": v3 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "LinkRelationshipTypeCell_fieldRef"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Variable",
                                                                "name": "isTimelineEnabled",
                                                                "variableName": "isTimelineEnabled"
                                                            }
                                                        ],
                                                        "kind": "FragmentSpread",
                                                        "name": "TimelineCellRenderer"
                                                    },
                                                    {
                                                        "kind": "ClientExtension",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "__id"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$9c0814e2116517c3$var$node.hash = "1a723aacdbbf7f366e4e0e6d9464bb44";
var $9c0814e2116517c3$export$2e2bcd8739ae039 = $9c0814e2116517c3$var$node;

});

parcelRegister("fHG3l", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3590f7e8fd834af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8d8296bdde7a062ba5a542bc4642fbca>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f3590f7e8fd834af$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
        },
        {
            "kind": "Variable",
            "name": "projectKeys",
            "variableName": "projectKeys"
        },
        {
            "kind": "Variable",
            "name": "shouldQueryHasChildren",
            "variableName": "shouldQueryHasChildren"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "isRemoteLinkedIssuesEnabled",
            "variableName": "isRemoteLinkedIssuesEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isRemoteLinkedIssuesEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "IssueRowWithFragments_issueEdge",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "FirstColumnCell"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": v0 /*: any*/ ,
                        "kind": "FragmentSpread",
                        "name": "MergedCell"
                    }
                ]
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "issueId"
                        },
                        {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                            "kind": "LinkedField",
                                            "name": "hierarchy",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "level"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "IssueSummaryCell_issue"
                        },
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "IssueKeyCell_fields"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isDensityFull",
                                    "variableName": "isDensityFull"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "RichTextCell_issue"
                        },
                        {
                            "condition": "isLinkRelationshipFieldEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "LinkRelationshipTypeCell_issueRef"
                                }
                            ]
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "node"
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$f3590f7e8fd834af$var$node.hash = "3bfecaefd0275dc7cffe81ed403403e2";
var $f3590f7e8fd834af$export$2e2bcd8739ae039 = $f3590f7e8fd834af$var$node;

});

parcelRegister("jycb2", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3fc26803bf50deb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<215b0940296c014942340277189a073f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a3fc26803bf50deb$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "IssueRow_rules",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useCellsConditionalFormatting_savedView_rules"
                }
            ]
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$a3fc26803bf50deb$var$node.hash = "e4507afd0584d23bc2b3f6adb1c45a91";
var $a3fc26803bf50deb$export$2e2bcd8739ae039 = $a3fc26803bf50deb$var$node;

});

parcelRegister("9R4GG", function(module, exports) {
$parcel$export(module.exports, "default", () => $59fced90fe0ece08$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<275dc094b2586e9c667521dd3eebd79e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $59fced90fe0ece08$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "IssueRow",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "condition": "isConditionalFormattingEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "useCellsConditionalFormatting_rules"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$59fced90fe0ece08$var$node.hash = "8bb10e5786d1690e677fdb7b7af7715c";
var $59fced90fe0ece08$export$2e2bcd8739ae039 = $59fced90fe0ece08$var$node;

});

parcelRegister("kJbAU", function(module, exports) {
$parcel$export(module.exports, "AffectedServicesCell", () => $158a6dcf4de806f6$export$e6c0da3971931bb1);

var $bJxYm = parcelRequire("bJxYm");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $P01So = parcelRequire("P01So");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");

var $1vkmT = parcelRequire("1vkmT");
const $158a6dcf4de806f6$export$e6c0da3971931bb1 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $bJxYm.default), fieldRef);
    const affectedServices = data.selectedAffectedServicesConnection?.edges;
    const filteredAffectedServices = affectedServices?.map((edge)=>edge?.node?.name != null ? {
            key: edge.node.serviceId,
            name: edge.node.name
        } : null).filter((0, $P01So.isNonNullish)) ?? [];
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    if (!affectedServices || affectedServices.length !== filteredAffectedServices.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "affectedServices",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: filteredAffectedServices,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $1vkmT.default).triggerButton),
        isHoverPopoverEnabled: isSingleLineRowHeightEnabled
    });
});

});
parcelRegister("bJxYm", function(module, exports) {
$parcel$export(module.exports, "default", () => $1706a79a4fb97231$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0c6a37e015fc2e5292f85a578b495973>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1706a79a4fb97231$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AffectedServicesCell",
    "selections": [
        {
            "concreteType": "JiraAffectedServiceConnection",
            "kind": "LinkedField",
            "name": "selectedAffectedServicesConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraAffectedServiceEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraAffectedService",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "serviceId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraAffectedServicesField"
};
$1706a79a4fb97231$var$node.hash = "035c17386bbefd01aae50ed77503a32e";
var $1706a79a4fb97231$export$2e2bcd8739ae039 = $1706a79a4fb97231$var$node;

});

parcelRegister("2j0d2", function(module, exports) {
$parcel$export(module.exports, "default", () => $1696def9371c7de3$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $ibVOD = parcelRequire("ibVOD");

var $f8qFy = parcelRequire("f8qFy");
const $1696def9371c7de3$var$ListWithPopup = ({ items: items, ItemComponent: ItemComponent, maxLimit: maxLimit, initialIsOpen: initialIsOpen, isHoverPopoverEnabled: isHoverPopoverEnabled, ...restProps })=>{
    const [firstItem, ...restItems] = items;
    const ShowMorePopupRenderer = (0, $eJOHy.useCallback)(()=>isHoverPopoverEnabled ? /*#__PURE__*/ $eJOHy.createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ $eJOHy.createElement((0, $f8qFy.default), {
            items: restItems,
            maxLimit: maxLimit,
            ItemComponent: ItemComponent,
            initialIsOpen: initialIsOpen,
            isHoverPopoverEnabled: isHoverPopoverEnabled,
            ...restProps
        })) : /*#__PURE__*/ $eJOHy.createElement((0, $f8qFy.default), {
            items: restItems,
            maxLimit: maxLimit,
            ItemComponent: ItemComponent,
            initialIsOpen: initialIsOpen,
            isHoverPopoverEnabled: isHoverPopoverEnabled,
            ...restProps
        }), [
        ItemComponent,
        initialIsOpen,
        isHoverPopoverEnabled,
        maxLimit,
        restItems,
        restProps
    ]);
    if (items.length === 0) return null;
    return /*#__PURE__*/ $eJOHy.createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center",
        shouldWrap: !isHoverPopoverEnabled,
        xcss: isHoverPopoverEnabled && $1696def9371c7de3$var$hoverPopoverStyles
    }, /*#__PURE__*/ $eJOHy.createElement(ItemComponent, {
        ...firstItem,
        isHoverPopoverEnabled: isHoverPopoverEnabled,
        className: (0, $hcewu.default)([
            isHoverPopoverEnabled && "_1ul9ze3t"
        ])
    }), restItems.length >= 1 && ShowMorePopupRenderer());
};
const $1696def9371c7de3$var$hoverPopoverStyles = (0, $1DXK0.xcss)({
    paddingRight: 'space.050',
    width: '100%'
});
const $1696def9371c7de3$var$hoverPopoverItemStyles = null;
var $1696def9371c7de3$export$2e2bcd8739ae039 = $1696def9371c7de3$var$ListWithPopup;

});
parcelRegister("f8qFy", function(module, exports) {
$parcel$export(module.exports, "default", () => $4966e4da02c2cf85$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $4B7rn = parcelRequire("4B7rn");

var $8nMzv = parcelRequire("8nMzv");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $9Mapt = parcelRequire("9Mapt");
const $4966e4da02c2cf85$var$ShowMorePopup = ({ showMoreTooltip: showMoreTooltip, items: items, ItemComponent: ItemComponent, PopupContentWrapper: PopupContentWrapper = (0, $eJOHy.Fragment), maxLimit: maxLimit = 99, OverrideContentComponent: OverrideContentComponent, initialIsOpen: initialIsOpen = false, isHoverPopoverEnabled: isHoverPopoverEnabled = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(initialIsOpen);
    const list = items.slice(0, maxLimit);
    const content = (0, $eJOHy.useCallback)(()=>list.map(({ key: key, ...item })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ItemComponent, item))), [
        ItemComponent,
        list
    ]);
    if (items.length === 0) return null;
    const onClickTrigger = ()=>{
        setIsOpen(!isOpen);
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'listWithPopup');
    };
    const contentWithWrapper = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: [
                $4966e4da02c2cf85$var$ContainerDialogStyles,
                $4966e4da02c2cf85$var$ContainerDialogBorderStyles
            ]
        }, OverrideContentComponent === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PopupContentWrapper, null, content()) : OverrideContentComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null));
    if (isHoverPopoverEnabled) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const hoverPopoverContent = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $4966e4da02c2cf85$var$HoverPopoverContainerDialogStyles
            }, OverrideContentComponent === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PopupContentWrapper, null, content()) : OverrideContentComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null)), [
            OverrideContentComponent,
            PopupContentWrapper,
            content
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
                content: hoverPopoverContent,
                isInteractive: true
            }, ({ ref: ref, ariaExpanded: ariaExpanded })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                    isSelected: isOpen,
                    spacing: "none",
                    testId: "list-with-popup.ui.show-more-popup.items-count",
                    "aria-expanded": ariaExpanded,
                    ref: ref,
                    ...props
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4966e4da02c2cf85$var$ItemsCount, null, "+", list.length))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom",
        content: contentWithWrapper,
        testId: "list-with-popup.ui.show-more-popup",
        messageId: "list-with-popup.ui.show-more-popup.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                key: "triggerLinksDialog",
                content: showMoreTooltip,
                tag: $4966e4da02c2cf85$var$TooltipContainer,
                position: "top"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: onClickTrigger,
                spacing: "none",
                testId: "list-with-popup.ui.show-more-popup.items-count"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4966e4da02c2cf85$var$ItemsCount, null, "+", list.length)))
    });
};
const $4966e4da02c2cf85$var$TooltipContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ...props,
        ref: ref,
        as: "span",
        xcss: $4966e4da02c2cf85$var$tooltipContainerStyles
    }));
const $4966e4da02c2cf85$var$ContainerDialogStyles = (0, $1DXK0.xcss)({
    width: '240px',
    maxHeight: '220px',
    overflow: 'auto',
    padding: 'space.100'
});
const $4966e4da02c2cf85$var$HoverPopoverContainerDialogStyles = (0, $1DXK0.xcss)({
    maxHeight: '220px',
    overflow: 'auto',
    padding: 'space.050'
});
const $4966e4da02c2cf85$var$ContainerDialogBorderStyles = (0, $1DXK0.xcss)({
    border: `2px solid ${"var(--ds-border-focused, #4688EC)"}`
});
const $4966e4da02c2cf85$var$tooltipContainerStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4966e4da02c2cf85$var$ItemsCount = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18zr1b66 _k48pi7a9 _vwz4v47k",
            __cmplp.className
        ])
    });
});
var $4966e4da02c2cf85$export$2e2bcd8739ae039 = $4966e4da02c2cf85$var$ShowMorePopup;

});


parcelRegister("86BUM", function(module, exports) {
$parcel$export(module.exports, "default", () => $ceecc2739c875115$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $9pTd3 = parcelRequire("9pTd3");

var $d8UFE = parcelRequire("d8UFE");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $8jOO7 = parcelRequire("8jOO7");

var $80M6O = parcelRequire("80M6O");
const $ceecc2739c875115$var$fireAnalyticsCache = {};
const $ceecc2739c875115$var$fireAnalyticsDebouncedByCellType = (cellType, reason, event)=>{
    if (!(cellType in $ceecc2739c875115$var$fireAnalyticsCache)) $ceecc2739c875115$var$fireAnalyticsCache[cellType] = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))($ceecc2739c875115$var$fireAnalytics);
    $ceecc2739c875115$var$fireAnalyticsCache[cellType](cellType, reason, event);
};
const $ceecc2739c875115$var$fireAnalytics = (cellType, reason, event)=>{
    const options = reason instanceof Error ? {
        cause: reason
    } : undefined;
    const error = new Error(`Failed to render cell data for the ${cellType} cell type. Reason: ${reason}`, options);
    (0, $9pTd3.fireErrorAnalytics)({
        meta: {
            id: 'errorCell',
            packageName: (0, $8jOO7.PACKAGE_NAME),
            teamName: (0, $8jOO7.TEAM_NAME)
        },
        error: error,
        event: event,
        attributes: {
            cellType: cellType
        },
        sendToPrivacyUnsafeSplunk: true
    });
    // Clean up debounced function after flush
    delete $ceecc2739c875115$var$fireAnalyticsCache[cellType];
};
const $ceecc2739c875115$var$ErrorCell = ({ cellType: cellType, reason: reason })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>setIsHovered(true), []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>setIsHovered(false), []);
    const iconColor = isHovered ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-subtle, #505258)";
    const message = formatMessage((0, $80M6O.default).tooltip);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $4cTDP.fg)('empanada_error_cell_logging')) return;
        const timerId = setTimeout(()=>$ceecc2739c875115$var$fireAnalyticsDebouncedByCellType(cellType, reason, createAnalyticsEvent({})));
        // Cancel any pending events on unmount. This prevents sending an error event when the cell was mounted
        // due to an intermediary render. We've observed this when new columns are committed to the Relay store
        // in a separate render before issue field sets are aligned.
        return ()=>clearTimeout(timerId);
    // Only fire on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $4cTDP.fg)('empanada_error_cell_logging')) return;
        const sendAnalytics = ()=>{
            const error = new Error(`Failed to render cell data for the ${cellType} cell type. Reason: ${reason}`);
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'errorCell',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                },
                error: error,
                event: createAnalyticsEvent({}),
                attributes: {
                    cellType: cellType
                },
                sendToPrivacyUnsafeSplunk: true
            });
        };
        const sendAnalyticsDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(sendAnalytics);
        sendAnalyticsDebounced();
        // Cancel any debounced events on unmount. This prevents sending an error event when the cell was mounted
        // due to an intermediary render. We've observed this when new columns are committed to the Relay store
        // in a separate render before issue field sets are aligned.
        return ()=>{
            sendAnalyticsDebounced.cancel();
        };
    // Only fire on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const cellContent = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "native-issue-table.common.error-cell.tooltip-target",
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseEnter: onMouseEnter,
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseLeave: onMouseLeave,
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8UFE))), {
            color: iconColor,
            label: message,
            spacing: "spacious"
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: message,
        position: "bottom-start"
    }, cellContent());
};
var $ceecc2739c875115$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($ceecc2739c875115$var$ErrorCell);

});
parcelRegister("80M6O", function(module, exports) {
$parcel$export(module.exports, "default", () => $83096c771fe45e4d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $83096c771fe45e4d$var$messages = (0, $7qGN1.defineMessages)({
    tooltip: {
        "id": "native-issue-table.common.error-cell.tooltip",
        "defaultMessage": "We couldn\u2019t load this field\u2019s details. Refresh and try again."
    }
});
var $83096c771fe45e4d$export$2e2bcd8739ae039 = $83096c771fe45e4d$var$messages;

});


parcelRegister("1vkmT", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf4715a793d93265$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $bf4715a793d93265$var$messages = (0, $7qGN1.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.affected-services.trigger-button",
        "defaultMessage": "See more affected services"
    }
});
var $bf4715a793d93265$export$2e2bcd8739ae039 = $bf4715a793d93265$var$messages;

});


parcelRegister("auNiK", function(module, exports) {
$parcel$export(module.exports, "AtlasProjectCell", () => $dbc1d58f57ea4eb3$export$7333563cf8787197);

var $cFDNd = parcelRequire("cFDNd");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $bthRw = parcelRequire("bthRw");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");
const $dbc1d58f57ea4eb3$export$7333563cf8787197 = ({ fieldRef: fieldRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $cFDNd.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = isInlineEditingExtendedFieldSupportEnabled && 'lazyIsEditableInIssueView' in data && data.lazyIsEditableInIssueView;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bthRw.AtlasProjectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: !!isEditable,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        popupPlacement: "bottom-start"
    });
};

});
parcelRegister("cFDNd", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ae7fff66e4681ce$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d77fcd05d7a2eced9a8437e774adc766>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8ae7fff66e4681ce$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "AtlasProjectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraTownsquareProjectField"
};
$8ae7fff66e4681ce$var$node.hash = "1fb64e8e716aa47668f59a4da7d571a6";
var $8ae7fff66e4681ce$export$2e2bcd8739ae039 = $8ae7fff66e4681ce$var$node;

});

parcelRegister("bthRw", function(module, exports) {
$parcel$export(module.exports, "AtlasProjectInlineEditViewWithIsEditable", () => $24b675dda3555a96$export$95490dcdca861bf1);
$parcel$export(module.exports, "AtlasProjectInlineEditView", () => $24b675dda3555a96$export$2bbd2b55549b58de);

var $9yUDN = parcelRequire("9yUDN");

var $1gOgp = parcelRequire("1gOgp");

var $8ZmCQ = parcelRequire("8ZmCQ");

var $YeWAW = parcelRequire("YeWAW");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $956it = parcelRequire("956it");

var $4EKqI = parcelRequire("4EKqI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $kqd31 = parcelRequire("kqd31");

var $cSXp8 = parcelRequire("cSXp8");

var $ftN6c = parcelRequire("ftN6c");

var $g9Vr6 = parcelRequire("g9Vr6");

var $9McQo = parcelRequire("9McQo");

var $47YLd = parcelRequire("47YLd");

var $cHtIB = parcelRequire("cHtIB");

var $bJscI = parcelRequire("bJscI");

var $auNLL = parcelRequire("auNLL");

var $lRq8t = parcelRequire("lRq8t");

var $cSWVe = parcelRequire("cSWVe");

var $jXGTZ = parcelRequire("jXGTZ");

var $ebGhx = parcelRequire("ebGhx");


var $5mlwW = parcelRequire("5mlwW");

var $8htSu = parcelRequire("8htSu");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $24b675dda3555a96$var$isEqualOption = (a, b)=>a?.id === b?.id;
const $24b675dda3555a96$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-atlas-project-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $24b675dda3555a96$export$95490dcdca861bf1 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, popupPlacement: popupPlacement = 'bottom-end', spacing: spacing = 'compact' })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $YeWAW.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commitLinkMutation] = (0, $j4oe4.useMutation)((0, $8ZmCQ.default));
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commitUnlinkMutation] = (0, $j4oe4.useMutation)((0, $1gOgp.default));
    // #endregion Relay
    // #region Common state
    const { id: uniqueFieldId, name: name, type: fieldType, project: project, issue: issue, isLinkEditable: isLinkEditable } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>project ? {
            id: project.id,
            name: project.atlasProjectName ?? '',
            key: project.atlasProjectKey ?? '',
            isPrivate: !!project.privateProject
        } : null, [
        project
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const hasNoInitialAccess = project?.hasPermission === false || project?.isWorkspaceActive === false;
    const [hasNoAccess, setHasNoAccess] = (0, $eJOHy.useState)(hasNoInitialAccess);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isRestricted = hasNoAccess && !!project?.privateProject && !hasNoInitialAccess;
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable && isLinkEditable !== false && !hasNoInitialAccess), [
        overrideIsEditable,
        isEditable,
        isLinkEditable,
        hasNoInitialAccess
    ]);
    const handleNoAccess = (0, $eJOHy.useCallback)(()=>{
        setHasNoAccess(()=>true);
    }, []);
    // #endregion Common state
    // #region Mutation handlers
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireAtlasProjectAnalyticsEvent: fireAtlasProjectAnalyticsEvent } = (0, $8htSu.useAtlasProjectAnalyticsEvent)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagService)();
    const [showConfirmatonModal, setShowConfirmationModal] = (0, $eJOHy.useState)(false);
    const replaceChildLinks = (0, $eJOHy.useRef)(false);
    const handleMutationError = (0, $eJOHy.useCallback)(({ errorType: errorType, canReplace: canReplace, onFail: onFail, onFireAnalyticsEvent: onFireAnalyticsEvent })=>{
        if (errorType === (0, $jXGTZ.LINK_MUTATION_ERROR_TYPES).CHILD_ITEMS_LINKED_TO_ANOTHER_PROJECT) {
            if (canReplace) setShowConfirmationModal(true);
            else {
                showFlag({
                    type: 'error',
                    title: formatMessage((0, $ebGhx.default).childIssueAlreadyLinkedNoReplaceTitle),
                    description: formatMessage((0, $ebGhx.default).childIssueAlreadyLinkedNoReplaceDescription),
                    isAutoDismiss: false,
                    messageId: 'issue-field-atlas-project-inline-edit-full.ui.atlas-project.show-flag.error.child-issue-already-linked-to-another-project',
                    messageType: 'transactional',
                    actions: [
                        {
                            content: formatMessage((0, $ebGhx.default).childIssueAlreadyLinkedNoReplaceAction),
                            href: (0, $a1452414e695131e$export$228ddfe2e1c9e3bf),
                            target: '_blank'
                        }
                    ]
                });
                // Only fire analytics event if we are not displaying the confirmation modal
                onFireAnalyticsEvent();
            }
            return;
        }
        if (errorType === (0, $jXGTZ.LINK_MUTATION_ERROR_TYPES).NO_PROJECT_EDIT_PERMS) {
            onFail(undefined, formatMessage((0, $ebGhx.default).noProjectEditPermsErrorMessage));
            onFireAnalyticsEvent();
            return;
        }
        // Unhandled error scenarios
        onFail();
        onFireAnalyticsEvent();
    }, [
        formatMessage,
        showFlag
    ]);
    const updater = (0, $eJOHy.useCallback)(({ store: store, projectId: projectId, mutation: mutation, value: value })=>{
        const projectDataId = (0, $kqd31.default)({
            id: projectId
        }, 'TownsquareProject');
        const fieldDataId = (0, $kqd31.default)({
            id: uniqueFieldId
        }, 'JiraTownsquareProjectField');
        if (!projectDataId || !fieldDataId) return;
        const fieldRecord = store.get(fieldDataId);
        if (!fieldRecord) return;
        if (mutation === 'link' && value) {
            let projectRecord = store.get(projectDataId);
            if (!projectRecord) projectRecord = store.create(projectDataId, 'TownsquareProject');
            projectRecord.setValue(projectId, 'id');
            projectRecord.setValue(value.name, 'name');
            projectRecord.setValue(value.key, 'key');
            fieldRecord.setLinkedRecord(projectRecord, 'project');
        } else fieldRecord.setValue(null, 'project');
    }, [
        uniqueFieldId
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        // Early return if no change
        if ($24b675dda3555a96$var$isEqualOption(value, initialValue)) return;
        const issueId = issue?.id;
        // If linking, the value.id will be the projectId being linked.
        // If unlinking, the value will be null so we fall back to the currently linked project id.
        const projectId = value?.id || project?.id;
        const shouldReplaceChildLinks = replaceChildLinks.current;
        // Reset replaceChildLinks ref
        replaceChildLinks.current = false;
        // Early return if we don't have the required IDs to call the mutation
        if (!issueId || !projectId) {
            onFail();
            return;
        }
        onSubmit?.(value);
        if (value === null) commitUnlinkMutation({
            variables: {
                input: {
                    workItemId: issueId,
                    projectId: projectId
                }
            },
            onCompleted: (response, graphqlErrors)=>{
                if (graphqlErrors && graphqlErrors.length > 0) {
                    fireAtlasProjectAnalyticsEvent({
                        event: 'operational',
                        action: 'unlinked-failed',
                        analyticsAttributes: {
                            error: graphqlErrors?.[0],
                            linkedWorkItemId: issueId,
                            projectId: projectId
                        }
                    });
                    onFail();
                    return;
                }
                const mutationResponse = response.projects_removeJiraWorkItemLink;
                if (mutationResponse?.success) {
                    fireAtlasProjectAnalyticsEvent({
                        event: 'track',
                        action: 'unlinked',
                        analyticsAttributes: {
                            linkedWorkItemId: issueId,
                            projectId: projectId
                        }
                    });
                    onSuccess();
                    return;
                }
                const { errorType: errorType, statusCode: statusCode } = mutationResponse?.errors?.[0]?.extensions || {};
                const errorMessage = mutationResponse?.errors?.[0]?.message || '';
                fireAtlasProjectAnalyticsEvent({
                    event: 'track',
                    action: 'unlinked-failed',
                    analyticsAttributes: {
                        error: {
                            message: errorMessage,
                            errorType: errorType,
                            statusCode: statusCode
                        },
                        projectId: projectId
                    }
                });
                onFail();
            },
            onError: (error)=>{
                fireAtlasProjectAnalyticsEvent({
                    event: 'operational',
                    action: 'unlinked-failed',
                    analyticsAttributes: {
                        error: {
                            message: error.message,
                            stack: error.stack
                        },
                        linkedWorkItemId: issueId,
                        projectId: projectId
                    }
                });
                onFail(error);
            },
            optimisticUpdater: (store)=>{
                updater({
                    store: store,
                    projectId: projectId,
                    value: value,
                    mutation: 'unlink'
                });
            },
            updater: (store, response)=>{
                // Do not update the store if the mutation was not successful
                if (!response?.projects_removeJiraWorkItemLink?.success) return;
                updater({
                    store: store,
                    projectId: projectId,
                    value: value,
                    mutation: 'unlink'
                });
            }
        });
        else commitLinkMutation({
            variables: {
                input: {
                    workItemId: issueId,
                    projectId: projectId,
                    // This should always be true, as on Jira, users should always be able to replace the project attached to a work item
                    replaceCurrentWorkItemLink: true,
                    replaceChildWorkItemLinks: shouldReplaceChildLinks
                }
            },
            onCompleted: (response, graphqlErrors)=>{
                if (graphqlErrors && graphqlErrors.length > 0) {
                    fireAtlasProjectAnalyticsEvent({
                        event: 'operational',
                        action: 'linked-failed',
                        analyticsAttributes: {
                            error: graphqlErrors?.[0],
                            linkedWorkItemId: issueId,
                            projectId: projectId
                        }
                    });
                    onFail();
                    return;
                }
                const mutationResponse = response.projects_addJiraWorkItemLink;
                if (mutationResponse?.success) {
                    onSuccess();
                    fireAtlasProjectAnalyticsEvent({
                        event: 'track',
                        action: 'linked',
                        analyticsAttributes: {
                            linkedWorkItemId: issueId,
                            projectId: projectId
                        }
                    });
                    return;
                }
                const { errorType: errorType, statusCode: statusCode, canReplace: canReplace } = mutationResponse?.errors?.[0]?.extensions || {};
                const errorMessage = mutationResponse?.errors?.[0]?.message || '';
                const error = {
                    message: errorMessage,
                    errorType: errorType,
                    statusCode: statusCode
                };
                handleMutationError({
                    errorType: errorType,
                    canReplace: canReplace,
                    onFail: onFail,
                    onFireAnalyticsEvent: ()=>{
                        fireAtlasProjectAnalyticsEvent({
                            event: 'track',
                            action: 'linked-failed',
                            analyticsAttributes: {
                                error: error,
                                projectId: projectId
                            }
                        });
                    }
                });
            },
            onError: (error)=>{
                fireAtlasProjectAnalyticsEvent({
                    event: 'operational',
                    action: 'linked-failed',
                    analyticsAttributes: {
                        error: {
                            message: error.message,
                            stack: error.stack
                        },
                        linkedWorkItemId: issueId,
                        projectId: projectId
                    }
                });
                onFail(error);
            },
            optimisticUpdater: (store)=>{
                updater({
                    store: store,
                    projectId: projectId,
                    value: value,
                    mutation: 'link'
                });
            },
            updater: (store, response)=>{
                // Do not update the store if the mutation was not successful
                if (!response?.projects_addJiraWorkItemLink?.success) return;
                updater({
                    store: store,
                    projectId: projectId,
                    value: value,
                    mutation: 'link'
                });
            }
        });
    }, [
        initialValue,
        issue?.id,
        project?.id,
        onSubmit,
        commitUnlinkMutation,
        fireAtlasProjectAnalyticsEvent,
        updater,
        commitLinkMutation,
        handleMutationError
    ]);
    // #endregion Mutation handlers
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $24b675dda3555a96$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: ()=>{
            // Reset the updated value to the initial value on submit failure to allow the user to make another selection
            setUpdatedValue(initialValue);
            onSubmitFailed?.();
        },
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue
    });
    // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($24b675dda3555a96$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $47YLd.AtlasProjectReadView), {
            fragmentRef: data,
            onHandleNoAccess: handleNoAccess
        }));
    // #endregion
    // #region Edit view
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const editViewEntryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const getEditViewProps = (fieldProps)=>{
        return {
            ...fieldProps,
            onClose: ()=>{
                // This is needed as the project picker needs to stay open even when the edit view loses the focus, which is enabled via keepEditViewOpenOnBlur
                // This is to allow users to interact with the project create form, which will be rendered within the project picker
                // Copied from src/packages/platform/ui/inline-edit-lite/src/ui/use-inline-edit/index.tsx
                handleCancel(createAnalyticsEvent({
                    action: 'canceled',
                    actionSubject: 'inlineEdit'
                }));
            },
            onProjectSelect: handleChangeAndConfirm,
            onProjectUnlink: ()=>handleChangeAndConfirm(null),
            linkedProject: initialValue || undefined,
            isCompact: spacing === 'compact',
            popupProps: {
                placement: popupPlacement
            },
            cloudId: cloudId,
            orgId: orgId,
            product: 'jira',
            emptyView: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $47YLd.AtlasProjectEmptytView), null),
            restrictedView: isRestricted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cSWVe.RestrictedAlikeSmartLink), {
                popupEditView: true
            }) : null
        };
    };
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $9McQo.projectPickerEntrypoint),
        editViewEntryPointParams: editViewEntryPointParams,
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        // Not invoking handleConfirm here as the value updates are handled via onProjectSelect in getEditViewProps and confirmed with handleChangeAndConfirm
        // This is to ensure that Form submit events from the project picker do not interfere with the inline edit confirm flow
        onConfirm: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onEdit: handleEdit,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        keepEditViewOpenOnBlur: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, showConfirmatonModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5mlwW.LinkConfirmationModal), {
        onClose: ()=>setShowConfirmationModal(false),
        onLink: ()=>{
            replaceChildLinks.current = true;
            handleConfirm(createAnalyticsEvent({
                action: 'confirmed',
                actionSubject: 'inlineEdit'
            }));
            setShowConfirmationModal(false);
        }
    })));
};
const $24b675dda3555a96$export$2bbd2b55549b58de = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $9yUDN.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($24b675dda3555a96$export$95490dcdca861bf1, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("9yUDN", function(module, exports) {
$parcel$export(module.exports, "default", () => $974c2d07d06332c4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c78edf816bb0e32c61021a0d8a256f02>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $974c2d07d06332c4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraTownsquareProjectField"
};
$974c2d07d06332c4$var$node.hash = "a65462d58befdde3cf6398f90e5e70ca";
var $974c2d07d06332c4$export$2e2bcd8739ae039 = $974c2d07d06332c4$var$node;

});

parcelRegister("1gOgp", function(module, exports) {
$parcel$export(module.exports, "default", () => $b92777e7bdb839eb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ae635e0e4634f6ea9cbfc7c6e23cdf0>>
 * @relayHash 545f444aaf5274101b6a492dce4cdb6d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b289ca2f1d3807b2db74e7ab190beb6ba0f0e196b16fec755ef4206276a699b4
const $b92777e7bdb839eb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_UnlinkProjectFromWorkItemMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareProjectsRemoveJiraWorkItemLinkPayload",
                    "kind": "LinkedField",
                    "name": "projects_removeJiraWorkItemLink",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_UnlinkProjectFromWorkItemMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareProjectsRemoveJiraWorkItemLinkPayload",
                    "kind": "LinkedField",
                    "name": "projects_removeJiraWorkItemLink",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b289ca2f1d3807b2db74e7ab190beb6ba0f0e196b16fec755ef4206276a699b4",
            "metadata": {},
            "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_UnlinkProjectFromWorkItemMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$b92777e7bdb839eb$var$node.hash = "81a581954454862ea2506465764ef409";
var $b92777e7bdb839eb$export$2e2bcd8739ae039 = $b92777e7bdb839eb$var$node;

});

parcelRegister("8ZmCQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6648fb9118a6648$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<316a004180f3d949fb9cf8ce0ffb97dc>>
 * @relayHash 044e27832145774d49d0d615ef03b9d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 720b4f7aa278046d69b3c13196f405b79dee8a76ea1d4ee85d9345f0c1ff2dce
const $c6648fb9118a6648$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canReplace"
            }
        ],
        "type": "TownsquareProjectsChildWorkItemsAlreadyLinkedMutationErrorExtension"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareProjectsAddJiraWorkItemLinkPayload",
                    "kind": "LinkedField",
                    "name": "projects_addJiraWorkItemLink",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareProjectsAddJiraWorkItemLinkPayload",
                    "kind": "LinkedField",
                    "name": "projects_addJiraWorkItemLink",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "720b4f7aa278046d69b3c13196f405b79dee8a76ea1d4ee85d9345f0c1ff2dce",
            "metadata": {},
            "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c6648fb9118a6648$var$node.hash = "c423f19e22ae55b49c7da9df767fe9b1";
var $c6648fb9118a6648$export$2e2bcd8739ae039 = $c6648fb9118a6648$var$node;

});

parcelRegister("YeWAW", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b9b486c08eaeb53$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<449660548732f66d65437a7b6b067e4a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3b9b486c08eaeb53$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "isLinkEditable"
            },
            {
                "concreteType": "JiraTownsquareProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "alias": "atlasProjectName",
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "alias": "atlasProjectKey",
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "privateProject"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "hasPermission"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isWorkspaceActive"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView"
            }
        ],
        "type": "JiraTownsquareProjectField"
    };
}();
$3b9b486c08eaeb53$var$node.hash = "f4f8d3d0048964da5915281582597f79";
var $3b9b486c08eaeb53$export$2e2bcd8739ae039 = $3b9b486c08eaeb53$var$node;

});

parcelRegister("4s7iN", function(module, exports) {
$parcel$export(module.exports, "useFieldInlineEditActions", () => $d37bf9db13197a19$export$ad535fb3592a66ff);

var $eJOHy = parcelRequire("eJOHy");

var $1IiSl = parcelRequire("1IiSl");

var $d2AGn = parcelRequire("d2AGn");

var $8c3Yt = parcelRequire("8c3Yt");

var $9XwQG = parcelRequire("9XwQG");

var $6jOZV = parcelRequire("6jOZV");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $3mxJ5 = parcelRequire("3mxJ5");

var $78Ere = parcelRequire("78Ere");

var $kB1g4 = parcelRequire("kB1g4");

var $aIlUW = parcelRequire("aIlUW");

var $SKIZT = parcelRequire("SKIZT");

var $4cTDP = parcelRequire("4cTDP");
const $d37bf9db13197a19$var$defaultIsEquals = (a, b)=>a === b;
const $d37bf9db13197a19$export$ad535fb3592a66ff = ({ attributes: attributes, fieldId: fieldId, fieldName: fieldName, fieldType: fieldType, initialValue: initialValue, isValueEqual: isValueEqual = $d37bf9db13197a19$var$defaultIsEquals, onCancel: onCancel, onEdit: onEdit, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, onUpdateValue: onUpdateValue, startWithEditViewOpen: startWithEditViewOpen = false, updatedValue: updatedValue, validator: validator, setAnalyticsAttributes: setAnalyticsAttributes, analyticsFieldType: analyticsFieldType, clipboardComponentType: clipboardComponentType, onUnchangedSubmit: onUnchangedSubmit })=>{
    const [isEditing, setIsEditing] = (0, $8c3Yt.useOptionallyControlledEditingState)(startWithEditViewOpen, fieldId, (0, $eJOHy.useMemo)(()=>({
            // Ensure our updatedValue is re-initialised if editing is enabled via an external store update
            onSharedChange: (sharedIsEditing)=>sharedIsEditing && onUpdateValue(initialValue, true)
        }), [
        onUpdateValue,
        initialValue
    ]));
    const [{ isRealTimeCommentUpdated: isRealTimeCommentUpdated }] = (0, $SKIZT.useRealTimeComments)();
    const [invalidMessage, { validateChange: validateChange, validateSubmit: validateSubmit, clearValidation: clearValidation }] = (0, $9XwQG.useClientValidationHandler)(validator);
    const [hasServerValidationError, { handleSubmitFailed: handleSubmitFailed, clearServerValidation: clearServerValidation }] = (0, $6jOZV.useServerValidationHandler)(fieldName, setIsEditing, onSubmitFailed);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    /** Clear any validation errors and transition to read view. */ const onStopEditing = (0, $eJOHy.useCallback)(()=>{
        clearValidation();
        clearServerValidation();
        setIsEditing(false);
    }, [
        clearServerValidation,
        clearValidation,
        setIsEditing
    ]);
    /** Handler to validate and submit the updated value for a field. */ const handleSubmit = (0, $eJOHy.useCallback)((value, analyticsEvent, event)=>{
        // Early exit if a validation error is present
        if (validateSubmit(value) === 'error') return;
        onStopEditing();
        // Skip mutation if value is unchanged
        if (isValueEqual(initialValue, value)) {
            (0, $4cTDP.fg)('jira_inline_edit_unchanged_submit_prop') && onUnchangedSubmit?.();
            return;
        }
        onSubmit(value, {
            onSuccess: ()=>{
                // Field updated event is a core action used to track MCU as defined in https://hello.atlassian.net/wiki/spaces/ANALYTICS/pages/3767029088/Monthly+Core+User+MCU+Definition
                (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'field updated', {
                    ...attributes,
                    fieldKey: fieldId,
                    fieldType: fieldType,
                    isRealTimeCommentUpdated: !!isRealTimeCommentUpdated
                });
                onSubmitSucceeded?.(value);
            },
            onFail: (error, message)=>{
                handleSubmitFailed(error, message);
            }
        }, event);
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent);
    }, [
        attributes,
        createAnalyticsEvent,
        fieldId,
        fieldType,
        handleSubmitFailed,
        initialValue,
        isValueEqual,
        onStopEditing,
        onSubmit,
        onSubmitSucceeded,
        validateSubmit,
        isRealTimeCommentUpdated,
        onUnchangedSubmit
    ]);
    /** Exits `editView` and switches back to `readView`. This is called when the cancel action button (x) is clicked. */ const handleCancel = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        onStopEditing();
        onCancel?.();
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent);
    }, [
        onCancel,
        onStopEditing
    ]);
    /** Handler called when readView is clicked. */ const handleEdit = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        // Re-initialise the edit view value unless there is a server error, in which case we want to preserve the
        // previous dirty value.
        if (!hasServerValidationError) onUpdateValue(initialValue, true);
        setIsEditing(true);
        onEdit?.();
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent);
        const fieldIdWithoutAri = (0, $1IiSl.getFieldIdFromAri)(fieldId);
        const fieldTypeAttribute = analyticsFieldType ?? fieldType;
        if (fieldIdWithoutAri && fieldTypeAttribute) (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart(fieldIdWithoutAri, {
            analytics: createAnalyticsEvent({}),
            attributes: {
                ...(0, $4cTDP.fg)('timeline-issue-table-additional-analytics') ? attributes : {},
                fieldType: fieldTypeAttribute
            }
        });
    }, [
        hasServerValidationError,
        setIsEditing,
        onEdit,
        fieldId,
        fieldType,
        onUpdateValue,
        initialValue,
        createAnalyticsEvent,
        analyticsFieldType,
        attributes
    ]);
    /** Saves and confirms the value entered into the field. It exits `editView` and returns to `readView`. */ const handleConfirm = (0, $eJOHy.useCallback)((analyticsEvent, event)=>{
        handleSubmit(updatedValue, analyticsEvent, event);
    }, [
        handleSubmit,
        updatedValue
    ]);
    /**
	 * Handler called when the `editView` is updated by the user. This will validate the input and call
	 * `onUpdateValue` to update the value in state.
	 */ const handleChange = (0, $eJOHy.useCallback)((value)=>{
        validateChange(value);
        onUpdateValue(value, false);
        setAnalyticsAttributes?.(value);
    }, [
        onUpdateValue,
        setAnalyticsAttributes,
        validateChange
    ]);
    /**
	 * Handler called when the `editView` is updated by the user which will immediately confirm the value and return to
	 * `readView`.
	 *
	 * Note that this **will not** run any `change` validator functions. Consumers should instead define a `submit`
	 * validator function if required.
	 */ const handleChangeAndConfirm = (0, $eJOHy.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'confirmed',
            actionSubject: 'inlineEdit'
        });
        onUpdateValue(value, false);
        if ((0, $4cTDP.fg)('timeline-issue-table-additional-analytics')) setAnalyticsAttributes?.(value);
        handleSubmit(value, analyticsEvent);
        if (!(0, $4cTDP.fg)('timeline-issue-table-additional-analytics')) setAnalyticsAttributes?.(value);
    }, [
        createAnalyticsEvent,
        handleSubmit,
        onUpdateValue,
        setAnalyticsAttributes
    ]);
    const reportClipboardError = (0, $kB1g4.useClipboardErrorReporting)(fieldName, fieldType);
    /**
	 * Attempt to submit changes to a field in the background (i.e. while remaining in `readView`). If the updated
	 * value fails `change` or `submit` validation then we forcibly switch to `editView` to allow users to correct
	 * their changes.
	 */ const handleBackgroundSubmit = (0, $eJOHy.useCallback)((value)=>{
        if (validateChange(value) === 'error' || validateSubmit(value) === 'error') {
            onUpdateValue(value, false);
            setIsEditing(true);
        } else handleChangeAndConfirm(value);
    }, [
        handleChangeAndConfirm,
        setIsEditing,
        onUpdateValue,
        validateChange,
        validateSubmit
    ]);
    const copyToClipboard = (0, $eJOHy.useMemo)(()=>{
        return clipboardComponentType !== undefined ? (0, $3mxJ5.getOnCopyHandler)(clipboardComponentType, /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
					 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        initialValue) : undefined;
    }, [
        clipboardComponentType,
        initialValue
    ]);
    const handleCopy = (0, $eJOHy.useMemo)(()=>{
        return ()=>{
            if (copyToClipboard) {
                copyToClipboard();
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clipboardCopy',
                    actionSubject: 'inlineEdit'
                }));
                // Signal the copy event has been explicitly handled
                return true;
            }
            reportClipboardError((0, $78Ere.ClipboardValidationError).copyOperationUnsupported());
            return false;
        };
    }, [
        copyToClipboard,
        createAnalyticsEvent,
        reportClipboardError
    ]);
    const handleCut = (0, $eJOHy.useMemo)(()=>{
        return ()=>{
            if (clipboardComponentType !== undefined && copyToClipboard) {
                copyToClipboard();
                if ((0, $aIlUW.isNullableComponentType)(clipboardComponentType)) /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
					 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                handleBackgroundSubmit(null);
                else if ((0, $aIlUW.isStringComponentType)(clipboardComponentType)) /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
					 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                handleBackgroundSubmit('');
                else if ((0, $aIlUW.isArrayComponentType)(clipboardComponentType)) /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
					 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                handleBackgroundSubmit([]);
                else reportClipboardError((0, $78Ere.ClipboardValidationError).cutNonEditableError(clipboardComponentType));
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clipboardCut',
                    actionSubject: 'inlineEdit'
                }));
                // Signal the copy event has been explicitly handled
                return true;
            }
            reportClipboardError((0, $78Ere.ClipboardValidationError).cutOperationUnsupported());
            return false;
        };
    }, [
        clipboardComponentType,
        copyToClipboard,
        createAnalyticsEvent,
        handleBackgroundSubmit,
        reportClipboardError
    ]);
    const handlePaste = (0, $eJOHy.useMemo)(()=>{
        if (clipboardComponentType !== undefined) {
            const onPaste = (0, $3mxJ5.getOnPasteHandler)(clipboardComponentType);
            return (e)=>{
                try {
                    const value = onPaste(e);
                    if (value !== undefined) {
                        /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
						 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        handleBackgroundSubmit(value);
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                            action: 'clipboardPaste',
                            actionSubject: 'inlineEdit'
                        }));
                        // Signal the paste event has been explicitly handled
                        return true;
                    }
                } catch (error) {
                    reportClipboardError(error instanceof Error ? error : undefined);
                }
                return false;
            };
        }
        return ()=>{
            reportClipboardError((0, $78Ere.ClipboardValidationError).pasteOperationUnsupported());
            return false;
        };
    }, [
        clipboardComponentType,
        createAnalyticsEvent,
        handleBackgroundSubmit,
        reportClipboardError
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            handleCancel: handleCancel,
            handleEdit: handleEdit,
            handleConfirm: handleConfirm,
            handleChange: handleChange,
            handleChangeAndConfirm: handleChangeAndConfirm,
            hasServerValidationError: hasServerValidationError,
            handleCopy: handleCopy,
            handleCut: handleCut,
            handlePaste: handlePaste,
            invalidMessage: invalidMessage,
            isEditing: isEditing
        }), [
        handleCancel,
        handleChange,
        handleChangeAndConfirm,
        handleConfirm,
        handleEdit,
        handleCopy,
        handleCut,
        handlePaste,
        hasServerValidationError,
        invalidMessage,
        isEditing
    ]);
};

});
parcelRegister("1IiSl", function(module, exports) {
$parcel$export(module.exports, "getFieldIdFromAri", () => $dc5becc3ae3f43e9$export$4ae913a052c0d582);
$parcel$export(module.exports, "getPriorityIdFromAri", () => $dc5becc3ae3f43e9$export$d3f3dc1a70aa9a8);
$parcel$export(module.exports, "getUserIdFromAri", () => $dc5becc3ae3f43e9$export$364d97890ac491af);
$parcel$export(module.exports, "getIssueIdFromAri", () => $dc5becc3ae3f43e9$export$ebe1484fefbc3f5d);
const $dc5becc3ae3f43e9$var$FIELD_ID_ARI_REGEX = /ari:cloud:jira:.*?:issuefieldvalue\/.*?\/(.*)/;
const $dc5becc3ae3f43e9$var$PRIORITY_ID_ARI_REGEX = /ari:cloud:jira:.*?:priority\/activation\/.*?\/(.*)/;
const $dc5becc3ae3f43e9$var$USER_ID_ARI_REGEX = /ari:cloud:identity::user\/(.*)/;
const $dc5becc3ae3f43e9$var$ISSUE_ID_REGEX = /ari:cloud:jira:.*?:issue\/(.*)/;
const $dc5becc3ae3f43e9$export$4ae913a052c0d582 = (fieldIdOrAri)=>{
    const match = fieldIdOrAri?.match($dc5becc3ae3f43e9$var$FIELD_ID_ARI_REGEX);
    return match ? match[1] : fieldIdOrAri;
};
const $dc5becc3ae3f43e9$export$d3f3dc1a70aa9a8 = (priorityIdOrAri)=>{
    const match = priorityIdOrAri?.match($dc5becc3ae3f43e9$var$PRIORITY_ID_ARI_REGEX);
    return match ? match[1] : priorityIdOrAri;
};
const $dc5becc3ae3f43e9$export$364d97890ac491af = (userIdOrAri)=>{
    const match = userIdOrAri?.match($dc5becc3ae3f43e9$var$USER_ID_ARI_REGEX);
    return match ? match[1] : userIdOrAri;
};
const $dc5becc3ae3f43e9$export$ebe1484fefbc3f5d = (issueIdOrAri)=>{
    const match = issueIdOrAri?.match($dc5becc3ae3f43e9$var$ISSUE_ID_REGEX);
    return match ? match[1] : issueIdOrAri;
};

});

parcelRegister("8c3Yt", function(module, exports) {
$parcel$export(module.exports, "IssueContext", () => $d33da18a7f7219ac$export$c436e295255cfd98);
$parcel$export(module.exports, "IssueFieldEditingContextProvider", () => $d33da18a7f7219ac$export$4bdcf555c5e0921f);
$parcel$export(module.exports, "useOptionallyControlledEditingState", () => $d33da18a7f7219ac$export$db1e18c2e86e1a50);

var $eJOHy = parcelRequire("eJOHy");

var $bGobh = parcelRequire("bGobh");
const $d33da18a7f7219ac$export$c436e295255cfd98 = /*#__PURE__*/ (0, $eJOHy.createContext)('localStateMode');
const $d33da18a7f7219ac$export$4bdcf555c5e0921f = ({ children: children, scope: scope })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d33da18a7f7219ac$export$c436e295255cfd98.Provider, {
        value: "sharedStateMode"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bGobh.FieldEditingContainer), {
        scope: scope
    }, children));
const $d33da18a7f7219ac$export$db1e18c2e86e1a50 = (initialState, fieldId, { onLocalChange: onLocalChange, onChange: onChange, onSharedChange: onSharedChange } = {})=>{
    const editingContext = (0, $eJOHy.useContext)($d33da18a7f7219ac$export$c436e295255cfd98);
    const isLocalStateMode = editingContext !== 'sharedStateMode';
    const [sharedState, { setFieldEditingState: setFieldEditingState }] = (0, $bGobh.useFieldIsEditing)(fieldId);
    const [localState, setLocalState] = (0, $eJOHy.useState)(isLocalStateMode ? initialState : sharedState);
    const unifiedOnChange = (0, $eJOHy.useCallback)((newValue)=>{
        onLocalChange?.(newValue, localState);
        onChange?.(newValue, localState);
        setLocalState(newValue);
        if (!isLocalStateMode) setFieldEditingState(fieldId, newValue);
    }, [
        onLocalChange,
        localState,
        onChange,
        isLocalStateMode,
        setFieldEditingState,
        fieldId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // If sharedState updates to a value that is different from localState, it's a shared state update.
        // Otherwise, it's just the shared state following a locally triggered state update
        if (!isLocalStateMode && sharedState !== localState) {
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            onSharedChange?.(sharedState, !sharedState);
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            onChange?.(sharedState, !sharedState);
            setLocalState(sharedState);
        }
    // We want to ensure this useEffect is only called when the sharedState changes, not when any other dependencies change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sharedState
    ]);
    const resultState = isLocalStateMode ? localState : sharedState;
    return [
        resultState,
        unifiedOnChange
    ];
};

});
parcelRegister("bGobh", function(module, exports) {
$parcel$export(module.exports, "useFieldIsEditing", () => $c643e2de6411b40d$export$3734a1b20e979e6e);
$parcel$export(module.exports, "useFieldIsEditingActions", () => $c643e2de6411b40d$export$a4850d650526df2e);
$parcel$export(module.exports, "FieldEditingContainer", () => $c643e2de6411b40d$export$4301025b8d3e0255);

var $huH03 = parcelRequire("huH03");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $c643e2de6411b40d$var$Store = (0, $GtRbT.createStore)({
    initialState: {},
    actions: {
        setFieldEditingState: (fieldId, isEditing)=>({ setState: setState })=>{
                setState({
                    [fieldId]: isEditing
                });
            },
        toggleFieldEditingState: (fieldId)=>({ setState: setState, getState: getState })=>{
                if (getState()[fieldId] == null) return undefined;
                const toggledValue = !getState()[fieldId];
                setState({
                    [fieldId]: toggledValue
                });
                return toggledValue;
            },
        getFieldEditingState: (fieldId)=>({ getState: getState })=>getState()[fieldId],
        resetFieldEditingStateStore: ()=>({ setState: setState, getState: getState })=>{
                setState((0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(getState(), ()=>false));
            }
    },
    name: 'FieldEditingState'
});
const $c643e2de6411b40d$export$3734a1b20e979e6e = (0, $iJq0l.createHook)($c643e2de6411b40d$var$Store, {
    selector: (state, arg)=>state[arg] != null ? state[arg] : false
});
const $c643e2de6411b40d$export$a4850d650526df2e = (0, $iJq0l.createActionsHook)($c643e2de6411b40d$var$Store);
const $c643e2de6411b40d$export$4301025b8d3e0255 = (0, $6E16M.createContainer)($c643e2de6411b40d$var$Store);

});
parcelRegister("huH03", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $75Jcs = parcelRequire("75Jcs");

var $1lM9j = parcelRequire("1lM9j");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $cbc697e9f663ba19$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $1lM9j(iteratee, 3);
    $75Jcs(object, function(value, key, object) {
        $iBJlb(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $cbc697e9f663ba19$var$mapValues;

});



parcelRegister("9XwQG", function(module, exports) {
$parcel$export(module.exports, "useClientValidationHandler", () => $2dafbdf964d3724b$export$f57c10638969fb77);

var $eJOHy = parcelRequire("eJOHy");
/** Return an `ValidationStatus` for a given validation message. */ const $2dafbdf964d3724b$var$getValidationStatus = (message)=>message ? message.type : 'success';
// Priority order for ValidationStatus. Higher value = higher priority.
const $2dafbdf964d3724b$var$invalidStatusPriority = {
    success: 0,
    warning: 1,
    error: 2
};
/**
 * Return the higher priority message of `messageA` and `messageB`. If the priority is equal then `messageA` will be
 * returned.
 */ const $2dafbdf964d3724b$var$getHigherPriorityMessage = (messageA, messageB)=>{
    const statusA = $2dafbdf964d3724b$var$getValidationStatus(messageA);
    const statusB = $2dafbdf964d3724b$var$getValidationStatus(messageB);
    return $2dafbdf964d3724b$var$invalidStatusPriority[statusA] >= $2dafbdf964d3724b$var$invalidStatusPriority[statusB] ? messageA : messageB;
};
const $2dafbdf964d3724b$export$f57c10638969fb77 = (validator)=>{
    const [invalidEvent, setInvalidEvent] = (0, $eJOHy.useState)(null);
    const { change: change, submit: submit } = validator ?? {};
    const validateChange = (0, $eJOHy.useCallback)((value)=>{
        // If no change validator is defined then the value is considered valid
        const message = change ? change(value) : null;
        setInvalidEvent(message ? {
            action: 'change',
            state: message
        } : null);
        return $2dafbdf964d3724b$var$getValidationStatus(message);
    }, [
        change
    ]);
    const validateSubmit = (0, $eJOHy.useCallback)((value)=>{
        // If no submit validator is defined then the value is considered valid
        const message = submit ? submit(value) : null;
        const changeInvalidMessage = invalidEvent?.action === 'change' ? invalidEvent.state : null;
        // Only update the change event invalid state if a higher priority message is returned
        const higherPriorityMessage = $2dafbdf964d3724b$var$getHigherPriorityMessage(message, changeInvalidMessage);
        setInvalidEvent(higherPriorityMessage ? {
            action: 'submit',
            state: higherPriorityMessage
        } : null);
        return $2dafbdf964d3724b$var$getValidationStatus(higherPriorityMessage);
    }, [
        invalidEvent,
        submit
    ]);
    const clearValidation = (0, $eJOHy.useCallback)(()=>{
        setInvalidEvent(null);
    }, []);
    const actions = (0, $eJOHy.useMemo)(()=>({
            validateChange: validateChange,
            validateSubmit: validateSubmit,
            clearValidation: clearValidation
        }), [
        clearValidation,
        validateChange,
        validateSubmit
    ]);
    return [
        invalidEvent?.state ?? null,
        actions
    ];
};

});

parcelRegister("6jOZV", function(module, exports) {
$parcel$export(module.exports, "useServerValidationHandler", () => $1ed3149aae721e64$export$1bf5fbbc94f09320);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $3Kttn = parcelRequire("3Kttn");
const $1ed3149aae721e64$export$1bf5fbbc94f09320 = (fieldName, setIsEditing, onSubmitFailed)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { dismissFlag: dismissFlag, showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [hasServerValidationError, setHasServerValidationError] = (0, $eJOHy.useState)(false);
    const handleSubmitFailed = (0, $eJOHy.useCallback)((error, message)=>{
        setHasServerValidationError(true);
        const flagId = showFlag({
            type: 'error',
            title: formatMessage((0, $3Kttn.default).submitFailedTitle, {
                fieldName: fieldName
            }),
            description: message ?? formatMessage((0, $3Kttn.default).submitFailedDescription),
            testId: 'issue-field-validation-handler.controllers.server-validation-handler.submit-failed-flag',
            messageId: 'issue-field-validation-handler.controllers.server-validation-handler.show-flag.error.submit-failed',
            messageType: 'transactional',
            onDismissed: ()=>{
                setHasServerValidationError(false);
            },
            actions: setIsEditing ? [
                {
                    content: (0, $3Kttn.default).submitFailedTryAgain,
                    onClick: ()=>{
                        setIsEditing(true);
                        flagId && dismissFlag(flagId);
                    }
                }
            ] : undefined
        });
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'serverValidationHandler',
                packageName: 'jiraIssueFieldValidationHandler',
                teamName: 'empanada'
            },
            event: createAnalyticsEvent({}),
            error: error,
            attributes: {
                fieldName: fieldName
            },
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: true
        });
        onSubmitFailed?.(error);
    }, [
        dismissFlag,
        fieldName,
        formatMessage,
        onSubmitFailed,
        setIsEditing,
        showFlag,
        createAnalyticsEvent
    ]);
    const clearServerValidation = (0, $eJOHy.useCallback)(()=>setHasServerValidationError(false), []);
    return (0, $eJOHy.useMemo)(()=>[
            hasServerValidationError,
            {
                handleSubmitFailed: handleSubmitFailed,
                clearServerValidation: clearServerValidation
            }
        ], [
        hasServerValidationError,
        handleSubmitFailed,
        clearServerValidation
    ]);
};

});
parcelRegister("3Kttn", function(module, exports) {
$parcel$export(module.exports, "default", () => $663c31e87c1dd7c6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
// Keep up to date with jira/src/packages/issue/keyboard-shortcuts/src/services/assign-to-me-or-unassign/messages.tsx
const $663c31e87c1dd7c6$var$messages = (0, $7qGN1.defineMessages)({
    submitFailedTitle: {
        "id": "issue-field-validation-handler.controllers.server-validation-handler.submit-failed-title-new",
        "defaultMessage": "We couldn\u2019t update the {fieldName} value"
    },
    submitFailedDescription: {
        "id": "issue-field-validation-handler.controllers.server-validation-handler.submit-failed-description",
        "defaultMessage": "You can try again in a few minutes, or refresh the page."
    },
    submitFailedTryAgain: {
        "id": "issue-field-validation-handler.controllers.server-validation-handler.submit-failed-try-again",
        "defaultMessage": "Try editing the field again"
    }
});
var $663c31e87c1dd7c6$export$2e2bcd8739ae039 = $663c31e87c1dd7c6$var$messages;

});


parcelRegister("3mxJ5", function(module, exports) {
$parcel$export(module.exports, "getOnCopyHandler", () => $7f34b51931f27aa7$export$ce96a952c1e6691a);
$parcel$export(module.exports, "getOnPasteHandler", () => $7f34b51931f27aa7$export$66ac6a407d63bc45);

var $hGArn = parcelRequire("hGArn");

var $i6t0v = parcelRequire("i6t0v");

var $67o6i = parcelRequire("67o6i");

var $78Ere = parcelRequire("78Ere");
/** Returns a sanitised HTML string with the provided `componentType` and `value` set as HTML attributes. */ const $7f34b51931f27aa7$var$safelyAddRichValueToHtml = (componentType, value)=>{
    try {
        const html = `<div data-type="table-cell" data-component-type="${componentType}" />`;
        const DOM = new DOMParser().parseFromString(html, 'text/html');
        DOM.body?.querySelector('div')?.setAttribute('data-field-value', JSON.stringify(value));
        return DOM.body?.innerHTML || '';
    } catch (e) {
        return null;
    }
};
function $7f34b51931f27aa7$export$89af511f3acca517(componentType, value, textSerialiser) {
    const clipboardItems = {
        'text/plain': new globalThis.window.Blob([
            textSerialiser(value)
        ], {
            type: 'text/plain'
        })
    };
    const html = $7f34b51931f27aa7$var$safelyAddRichValueToHtml(componentType, value);
    if (html) clipboardItems['text/html'] = new globalThis.window.Blob([
        html
    ], {
        type: 'text/html'
    });
    const clipboardItem = new globalThis.window.ClipboardItem(clipboardItems);
    globalThis.navigator.clipboard.write([
        clipboardItem
    ]);
}
const $7f34b51931f27aa7$export$29418a91c5daf3d9 = (e)=>{
    const html = e.clipboardData?.getData('text/html');
    if (!html) return null;
    try {
        const clipboardDocument = new DOMParser().parseFromString(html, 'text/html');
        const data = clipboardDocument.body?.querySelector('div')?.dataset;
        if (!data || !data.componentType || !data.fieldValue) return null;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            componentType: data.componentType,
            value: JSON.parse(data.fieldValue)
        };
    } catch (error) {
        return null;
    }
};
const $7f34b51931f27aa7$export$ce96a952c1e6691a = (componentType, value)=>{
    const textSerialiser = (0, $hGArn.getDefaultClipboardTextSerialiser)();
    return ()=>$7f34b51931f27aa7$export$89af511f3acca517(componentType, value, textSerialiser);
};
const $7f34b51931f27aa7$export$66ac6a407d63bc45 = (componentType)=>{
    const parser = (0, $i6t0v.getDefaultClipboardParser)(componentType);
    return (e)=>{
        let caughtError;
        const metadata = $7f34b51931f27aa7$export$29418a91c5daf3d9(e);
        if (metadata) try {
            return parser(metadata);
        } catch (error) {
            // Silently ignore and fallthrough
            caughtError = error;
        }
        const plainText = e.clipboardData?.getData('text/plain');
        if (plainText) try {
            if (componentType === 'text') return (0, $67o6i.stringClipboardTextParser)(plainText);
            return (0, $67o6i.defaultClipboardTextParser)(plainText);
        } catch (error) {
            // Silently ignore and fallthrough
            caughtError = caughtError ?? error;
        }
        if (caughtError instanceof (0, $78Ere.ClipboardValidationError)) throw caughtError;
    };
};

});
parcelRegister("hGArn", function(module, exports) {
$parcel$export(module.exports, "getDefaultClipboardTextSerialiser", () => $58f0868807ff38e7$export$2bbd2e5056252b1d);
const $58f0868807ff38e7$export$2bbd2e5056252b1d = ()=>{
    return (value)=>{
        switch(typeof value){
            case 'string':
            case 'number':
            case 'boolean':
                return String(value);
            default:
                return '';
        }
    };
};

});

parcelRegister("i6t0v", function(module, exports) {
$parcel$export(module.exports, "getDefaultClipboardParser", () => $7b612785ecca3e27$export$b221956cf03526aa);

var $78Ere = parcelRequire("78Ere");
const $7b612785ecca3e27$var$isComponentType = (meta, type)=>meta.componentType === type;
const $7b612785ecca3e27$export$b221956cf03526aa = (expectedComponentType)=>{
    return (meta)=>{
        if ($7b612785ecca3e27$var$isComponentType(meta, expectedComponentType)) return meta.value;
        throw (0, $78Ere.ClipboardValidationError).pasteUnexpectedComponentType(meta.componentType, expectedComponentType);
    };
};

});
parcelRegister("78Ere", function(module, exports) {
$parcel$export(module.exports, "ClipboardValidationError", () => $927996358e9f15b0$export$41262351255fc0fe);
class $927996358e9f15b0$export$41262351255fc0fe extends Error {
    constructor(type, message){
        super(message);
        this.name = 'ClipboardValidationError';
        this.type = type;
    }
    static copyOperationUnsupported() {
        return new $927996358e9f15b0$export$41262351255fc0fe('copyOperationUnsupported', 'Copy operation not supported.');
    }
    static cutOperationUnsupported() {
        return new $927996358e9f15b0$export$41262351255fc0fe('cutOperationUnsupported', 'Cut operation not supported.');
    }
    static cutNonEditableError(actual) {
        return new $927996358e9f15b0$export$41262351255fc0fe('cutNonEditableError', `Received component type '${actual}' cannot be cut.`);
    }
    static pasteOperationUnsupported() {
        return new $927996358e9f15b0$export$41262351255fc0fe('pasteOperationUnsupported', 'Paste operation not supported.');
    }
    static pasteUnexpectedComponentType(actual, expected) {
        return new $927996358e9f15b0$export$41262351255fc0fe('pasteUnexpectedComponentType', `Received component type '${actual}' when '${expected}' was expected.`);
    }
    static pasteUnsupportedFormat(format) {
        return new $927996358e9f15b0$export$41262351255fc0fe('pasteUnsupportedFormat', `Unsupported data transfer format '${format}'.`);
    }
}

});


parcelRegister("67o6i", function(module, exports) {
$parcel$export(module.exports, "defaultClipboardTextParser", () => $99079690e1495c78$export$eaf687a0cd453100);
$parcel$export(module.exports, "stringClipboardTextParser", () => $99079690e1495c78$export$95f020f7a1102e64);

var $78Ere = parcelRequire("78Ere");
const $99079690e1495c78$export$eaf687a0cd453100 = ()=>{
    throw (0, $78Ere.ClipboardValidationError).pasteUnsupportedFormat('text/plain');
};
const $99079690e1495c78$export$95f020f7a1102e64 = (plainText)=>plainText;

});


parcelRegister("kB1g4", function(module, exports) {
$parcel$export(module.exports, "useClipboardErrorReporting", () => $f82dd9dc823d71e4$export$a3594035e6545378);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $jn1Cb = parcelRequire("jn1Cb");
var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $48Ylx = parcelRequire("48Ylx");

var $78Ere = parcelRequire("78Ere");
const $f82dd9dc823d71e4$var$uniqueFlagId = (0, $jn1Cb.toFlagId)('JSC_COPY_PASTE_FLAG');
const $f82dd9dc823d71e4$var$assertUnreachable = (_)=>{
    throw new Error('Unreachable code reached');
};
const $f82dd9dc823d71e4$var$useGetErrorFlag = (fieldName)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return (0, $eJOHy.useCallback)((errorType)=>{
        switch(errorType){
            case 'copyOperationUnsupported':
                return {
                    type: 'error',
                    title: formatMessage((0, $48Ylx.default).copyErrorTitle),
                    description: formatMessage((0, $48Ylx.default).copyValidationError, {
                        name: fieldName
                    }),
                    messageId: 'issue-field-copy-paste.controller.flag.error.copy-validation-error',
                    messageType: 'transactional'
                };
            case 'cutOperationUnsupported':
                return {
                    type: 'error',
                    title: formatMessage((0, $48Ylx.default).cutErrorTitle),
                    description: formatMessage((0, $48Ylx.default).cutValidationError, {
                        name: fieldName
                    }),
                    messageId: 'issue-field-copy-paste.controller.flag.error.cut-validation-error',
                    messageType: 'transactional'
                };
            case 'cutNonEditableError':
                return {
                    type: 'error',
                    title: formatMessage((0, $48Ylx.default).cutErrorTitle),
                    description: formatMessage((0, $48Ylx.default).cutNonEditableError, {
                        name: fieldName
                    }),
                    messageId: 'issue-field-copy-paste.controller.flag.error.cut-non-editable-error',
                    messageType: 'transactional'
                };
            case 'pasteOperationUnsupported':
            case 'pasteUnexpectedComponentType':
            case 'pasteUnsupportedFormat':
                return {
                    type: 'error',
                    title: formatMessage((0, $48Ylx.default).pasteErrorTitle),
                    description: formatMessage((0, $48Ylx.default).pasteUnsupportedError, {
                        name: fieldName
                    }),
                    messageId: 'issue-field-copy-paste.controller.flag.error.paste-unsupported-error',
                    messageType: 'transactional'
                };
            default:
                return $f82dd9dc823d71e4$var$assertUnreachable(errorType);
        }
    }, [
        fieldName,
        formatMessage
    ]);
};
const $f82dd9dc823d71e4$export$a3594035e6545378 = (fieldName, fieldType)=>{
    const { dismissFlag: dismissFlag, showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const getErrorFlag = $f82dd9dc823d71e4$var$useGetErrorFlag(fieldName);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((error)=>{
        if (error instanceof (0, $78Ere.ClipboardValidationError)) {
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'inlineEdit clipboardValidationError', {
                clipboardValidationErrorType: error.type,
                fieldType: fieldType
            });
            dismissFlag($f82dd9dc823d71e4$var$uniqueFlagId);
            showFlag({
                ...getErrorFlag(error.type),
                id: $f82dd9dc823d71e4$var$uniqueFlagId
            });
        } else {
            const ugcSafeMessage = `Failed to perform clipboard operation for field of type ${fieldType}`;
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'clipboardOperationError',
                    packageName: 'jiraIssueFieldCopyPaste',
                    teamName: 'empanada'
                },
                attributes: {
                    message: ugcSafeMessage,
                    fieldType: fieldType
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        createAnalyticsEvent,
        dismissFlag,
        fieldType,
        getErrorFlag,
        showFlag
    ]);
};

});
parcelRegister("48Ylx", function(module, exports) {
$parcel$export(module.exports, "default", () => $c28fb312260a79a6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c28fb312260a79a6$var$messages = (0, $7qGN1.defineMessages)({
    copyErrorTitle: {
        "id": "issue-field-copy-paste.controller.copy-error-title",
        "defaultMessage": "Unable to copy"
    },
    copyValidationError: {
        "id": "issue-field-copy-paste.controller.copy-validation-error",
        "defaultMessage": "{name} can't be copied."
    },
    cutErrorTitle: {
        "id": "issue-field-cut-paste.controller.cut-error-title",
        "defaultMessage": "Unable to cut"
    },
    cutValidationError: {
        "id": "issue-field-cut-paste.controller.cut-validation-error",
        "defaultMessage": "{name} can't be cut."
    },
    cutNonEditableError: {
        "id": "business-list.controllers.clipboard.cut-non-editable-error",
        "defaultMessage": "{name} is copied to your clipboard instead."
    },
    pasteErrorTitle: {
        "id": "issue-field-copy-paste.controller.paste-error-title",
        "defaultMessage": "Unable to paste"
    },
    pasteUnsupportedError: {
        "id": "issue-field-copy-paste.controller.paste-unsupported-error",
        "defaultMessage": "This can't be pasted on {name}."
    }
});
var $c28fb312260a79a6$export$2e2bcd8739ae039 = $c28fb312260a79a6$var$messages;

});


parcelRegister("aIlUW", function(module, exports) {
$parcel$export(module.exports, "isNullableComponentType", () => $746cf1207b9950e2$export$caeca7da2724234c);
$parcel$export(module.exports, "isStringComponentType", () => $746cf1207b9950e2$export$6e42f8250885ab5b);
$parcel$export(module.exports, "isArrayComponentType", () => $746cf1207b9950e2$export$1c384554b943e9d8);
/**
 * Exhaustive assertion that will throw for all component types that do not support a `null` value. If a new
 * `ClipboardComponentType` is defined that **does not** support `null` values then it must be added to the below switch
 * case.
 */ const $746cf1207b9950e2$var$assertIsNullableComponentType = (type)=>{
    switch(type){
        case 'number':
        case 'boolean':
        case 'text':
        case 'priority':
        case 'labels':
        case 'originalEstimate':
            throw new Error(`Type '${type}' does not support null values`);
        default:
            return type;
    }
};
const $746cf1207b9950e2$export$caeca7da2724234c = (type)=>{
    try {
        $746cf1207b9950e2$var$assertIsNullableComponentType(type);
        return true;
    } catch  {
        return false;
    }
};
/**
 * Exhaustive assertion that will throw for all component types that do not support a `string` value. If a new
 * `ClipboardComponentType` is defined that **does not** support `string` values then it must be added to the below
 * switch case.
 */ const $746cf1207b9950e2$var$assertIsStringComponentType = (type)=>{
    switch(type){
        case 'number':
        case 'boolean':
        case 'checkboxSelect':
        case 'numberNullable':
        case 'priority':
        case 'sprint':
        case 'singleUser':
        case 'labels':
        case 'singleSelect':
        case 'multiUserPicker':
        case 'multiSelect':
        case 'multiGroupPicker':
        case 'cascadingSelect':
        case 'radioSelect':
        case 'components':
        case 'team':
        case 'multiVersionSelect':
        case 'parent':
            throw new Error(`Type '${type}' does not support string values`);
        default:
            return type;
    }
};
const $746cf1207b9950e2$export$6e42f8250885ab5b = (type)=>{
    try {
        $746cf1207b9950e2$var$assertIsStringComponentType(type);
        return true;
    } catch  {
        return false;
    }
};
/**
 * Exhaustive assertion that will throw for all component types that do not support an `array` value. If a new
 * `ClipboardComponentType` is defined that **does not** support `array` values then it must be added to the below
 * switch case.
 */ const $746cf1207b9950e2$var$assertIsArrayComponentType = (type)=>{
    switch(type){
        case 'date':
        case 'dateTime':
        case 'text':
        case 'number':
        case 'numberNullable':
        case 'boolean':
        case 'sprint':
        case 'originalEstimate':
        case 'singleUser':
        case 'singleSelect':
        case 'url':
        case 'priority':
        case 'cascadingSelect':
        case 'radioSelect':
        case 'team':
        case 'parent':
            throw new Error(`Type '${type}' does not support array values`);
        default:
            return type;
    }
};
const $746cf1207b9950e2$export$1c384554b943e9d8 = (type)=>{
    try {
        $746cf1207b9950e2$var$assertIsArrayComponentType(type);
        return true;
    } catch  {
        return false;
    }
};

});

parcelRegister("SKIZT", function(module, exports) {
$parcel$export(module.exports, "useRealTimeComments", () => $b2344957e97b16de$export$77846b359c3804dd);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $b2344957e97b16de$var$initialState = {
    isRealTimeCommentUpdated: false
};
const $b2344957e97b16de$var$actions = {
    setRealTimeCommentUpdated: (isRealTimeCommentUpdated)=>({ setState: setState })=>{
            setState({
                isRealTimeCommentUpdated: isRealTimeCommentUpdated
            });
        }
};
const $b2344957e97b16de$var$store = (0, $GtRbT.createStore)({
    name: 'issue-view.controllers.realtime-comments',
    initialState: $b2344957e97b16de$var$initialState,
    actions: $b2344957e97b16de$var$actions
});
const $b2344957e97b16de$export$77846b359c3804dd = (0, $iJq0l.createHook)($b2344957e97b16de$var$store);

});


parcelRegister("99gun", function(module, exports) {
$parcel$export(module.exports, "FieldInlineEditLiteWithEntryPoint", () => $a603698b24549ac2$export$d14ba912eb773f8d);

var $eJOHy = parcelRequire("eJOHy");

var $dllpM = parcelRequire("dllpM");

var $dZ3jN = parcelRequire("dZ3jN");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $tYLUh = parcelRequire("tYLUh");

var $8uEpk = parcelRequire("8uEpk");

var $6TknG = parcelRequire("6TknG");

const $a603698b24549ac2$export$d14ba912eb773f8d = ({ editViewEntryPoint: editViewEntryPoint, editViewEntryPointParams: editViewEntryPointParams, getEditViewProps: getEditViewProps, ...props })=>{
    const { hideEditButton: hideEditButton, isEditable: isEditable, isEditing: isEditing, readView: readView, readViewFitContainerHeight: readViewFitContainerHeight, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled, disableReadViewAppearanceOnHoverOnly: disableReadViewAppearanceOnHoverOnly = false, readViewHighlightOnHover: readViewHighlightOnHover } = props;
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const pressTrace = (0, $dllpM.default)('issue.field.inline-edit-lite');
    // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)(editViewEntryPoint, editViewEntryPointParams);
    const entryPointEventMap = (0, $eJOHy.useMemo)(()=>{
        const actions = (0, $dZ3jN.getDefaultEntrypointActionEventMap)(entryPointActions);
        const { click: click } = actions;
        actions.click = (e)=>{
            pressTrace();
            click(e);
        };
        return actions;
    }, [
        entryPointActions,
        pressTrace
    ]);
    const readViewTrigger = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions, true, entryPointEventMap);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        // This component can be mounted in an editing state or toggled externally, so we need to ensure the entrypoint
        // is always explicitly loaded when entering edit view.
        if (isEditing) entryPointActions.load();
    }, [
        isEditing,
        entryPointActions
    ]);
    const renderEditView = (fieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "editView",
            packageName: "jiraIssueFieldInlineEditLite",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6TknG.ReadViewNonEditable), {
                hideEditButton: hideEditButton,
                isLoading: true,
                readViewFitContainerHeight: readViewFitContainerHeight,
                readViewHighlightOnHover: readViewHighlightOnHover
            }, readView()),
            runtimeProps: getEditViewProps(fieldProps)
        });
    const renderedOutsideIssueView = readViewFitContainerHeight && props.editViewPopup && props.editViewPopupAlignBlock === 'center';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8uEpk.default), {
        ...props,
        ...isExperimentEnabled && {
            value: renderedOutsideIssueView || disableReadViewAppearanceOnHoverOnly ? true : getEditViewProps()?.value || getEditViewProps()?.defaultValue
        },
        readViewContainerRef: isEditable ? readViewTrigger : undefined,
        editView: renderEditView,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled
    });
};

});
parcelRegister("tYLUh", function(module, exports) {
$parcel$export(module.exports, "useBespokeEmptyFieldTextExperiment", () => $6e661923caaee82d$export$5a7b1bb3c8ba459f);

var $FhXEJ = parcelRequire("FhXEJ");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $bmoS1 = parcelRequire("bmoS1");

var $bNexr = parcelRequire("bNexr");
const $6e661923caaee82d$var$useIsExperimentEligible = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    /* Some URL patterns where Issue view is rendered either in a modal or full page or in a sidebar
	The common pattern is presence of issue key in the URL pathname or search params
	1. /browse/TEST-1
	2. /issues/TEST-1
	3. /jira/software/c/projects/TEST/issues/TEST-1
	4. /jira/software/c/projects/TEST/boards/1?selectedIssue=TEST-1
	5. /jira/software/c/projects/TEST/boards/1/backlog?selectedIssue=TEST-1
	6. /jira/software/c/projects/TEST/list?selectedIssue=TEST-1
	*/ const ISSUE_KEY_REGEX = /[A-Z][A-Z0-9]+-\d+/;
    let isFieldRenderedInIssueView = false;
    try {
        isFieldRenderedInIssueView = // eslint-disable-next-line no-restricted-globals
        ISSUE_KEY_REGEX.test(location.search) || ISSUE_KEY_REGEX.test(location.pathname);
    } catch (error) {
        // If regex test fails for some reason, default to false
        isFieldRenderedInIssueView = false;
    }
    return (projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.CORE_PROJECT) && (0, $4cTDP.fg)('fg_bespoke-placeholder-experiment-ga')) && isFieldRenderedInIssueView && (0, $4cTDP.fg)('bespoke-empty-field-text-gate');
};
const $6e661923caaee82d$export$5a7b1bb3c8ba459f = ()=>{
    const isExperimentEligible = $6e661923caaee82d$var$useIsExperimentEligible();
    const isVisibleAlways = isExperimentEligible && (0, $cxKOj.expValEquals)('bespoke_empty_field_text_experiment', 'showBespokeFieldText', 'always', 'never');
    const isVisibleOnHover = isExperimentEligible && (0, $cxKOj.expValEquals)('bespoke_empty_field_text_experiment', 'showBespokeFieldText', 'hover', 'never');
    return {
        bespokeEmptyFieldTextExperimentVariant: isExperimentEligible ? (0, $cxKOj.expVal)('bespoke_empty_field_text_experiment', 'showBespokeFieldText', 'never') : null,
        isExperimentEnabled: isVisibleAlways || isVisibleOnHover,
        isVisibleAlways: isVisibleAlways,
        isVisibleOnHover: isVisibleOnHover
    };
};

});

parcelRegister("8uEpk", function(module, exports) {
$parcel$export(module.exports, "default", () => $166556c5a2840ca0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $f4cRx = parcelRequire("f4cRx");

var $lRq8t = parcelRequire("lRq8t");

var $tYLUh = parcelRequire("tYLUh");

var $dA2s3 = parcelRequire("dA2s3");

var $2TDKv = parcelRequire("2TDKv");

var $2KSbM = parcelRequire("2KSbM");

var $ew20k = parcelRequire("ew20k");

// Fallback placements to be used for the validation popover if it overflows its clipping parent
const $166556c5a2840ca0$var$fallbackPlacements = [
    'left',
    'top-start',
    'auto'
];
/**
 * Component leveraging `@atlassian/jira-inline-edit-lite` to provide consistent spacing and validation UX for issue
 * fields.
 */ const $166556c5a2840ca0$var$FieldInlineEditLite = ({ editView: editView, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupMinWidth: editViewPopupMinWidth, editViewPopupTarget: editViewPopupTarget, fieldName: fieldName, hasUnsubmittedChanges: hasUnsubmittedChanges, hideActionButtons: hideActionButtons, hideEditButton: hideEditButton, invalidMessage: invalidMessage, isEditable: isEditable, isEditing: isEditing, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur, onCancel: onCancel, onConfirm: onConfirm, onEdit: onEdit, onCopy: onCopy, onCut: onCut, onPaste: onPaste, readViewFitContainerHeight: readViewFitContainerHeight, readViewContainerRef: readViewContainerRef, readView: readView, readViewContainerTarget: readViewContainerTarget, confirmButtonLabel: confirmButtonLabelProp, cancelButtonLabel: cancelButtonLabelProp, editButtonLabel: editButtonLabelProp, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled, value: value })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const { context: context, refs: refs } = (0, $f4cRx.useInlineEdit)({
        isEditing: isEditing,
        onCancel: onCancel,
        onConfirm: onConfirm,
        onEdit: onEdit
    });
    const confirmButtonLabel = confirmButtonLabelProp ?? formatMessage((0, $2KSbM.default).confirmButtonLabel, {
        fieldName: fieldName
    });
    const cancelButtonLabel = cancelButtonLabelProp ?? formatMessage((0, $2KSbM.default).cancelButtonLabel, {
        fieldName: fieldName
    });
    const editButtonLabel = editButtonLabelProp ?? formatMessage((0, $2KSbM.default).editButtonLabel, {
        fieldName: fieldName
    });
    if (isEditing && isEditable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2TDKv.EditView), {
        cancelButtonLabel: cancelButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        context: context,
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: editViewPopupMinWidth,
        editViewPopupTarget: editViewPopupTarget,
        hideActionButtons: hideActionButtons,
        keepEditViewOpenOnBlur: keepEditViewOpenOnBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dA2s3.default), {
        message: invalidMessage,
        trigger: (triggerProps)=>editView(triggerProps),
        placement: "right",
        fallbackPlacements: $166556c5a2840ca0$var$fallbackPlacements
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ew20k.ReadView), {
        context: context,
        editButtonLabel: editButtonLabel,
        editButtonRef: refs.editButton,
        hideEditButton: hideEditButton,
        isEditInteractionEnabled: isEditable,
        isInvalid: hasUnsubmittedChanges,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readViewContainerRef: readViewContainerRef,
        onCopy: onCopy,
        onCut: onCut,
        onPaste: onPaste,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled,
        ...isExperimentEnabled && {
            value: value
        },
        readViewContainerTarget: readViewContainerTarget
    }, readView());
};
var $166556c5a2840ca0$export$2e2bcd8739ae039 = $166556c5a2840ca0$var$FieldInlineEditLite;

});
parcelRegister("f4cRx", function(module, exports) {
$parcel$export(module.exports, "useInlineEdit", () => $82c0f5b6e77ac78a$export$4059f16ba5dcb4e1);

var $eJOHy = parcelRequire("eJOHy");

var $6d9QY = parcelRequire("6d9QY");

var $ftN6c = parcelRequire("ftN6c");
const $82c0f5b6e77ac78a$var$actionSubject = 'inlineEdit';
const $82c0f5b6e77ac78a$export$4059f16ba5dcb4e1 = ({ isEditing: isEditing, onCancel: onCancelOption, onConfirm: onConfirmOption, onEdit: onEditOption })=>{
    const editButtonRef = (0, $eJOHy.useRef)(null);
    const preventFocusOnEditButtonRef = (0, $eJOHy.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const prevIsEditing = (0, $6d9QY.usePrevious)(isEditing);
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !isEditing) {
            if (preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else editButtonRef.current?.focus();
        }
    }, [
        prevIsEditing,
        isEditing
    ]);
    const onCancel = (0, $eJOHy.useCallback)((preventFocusReturn = true)=>{
        preventFocusOnEditButtonRef.current = preventFocusReturn;
        const analyticsEvent = createAnalyticsEvent({
            action: 'canceled',
            actionSubject: $82c0f5b6e77ac78a$var$actionSubject
        });
        onCancelOption(analyticsEvent);
    }, [
        createAnalyticsEvent,
        onCancelOption
    ]);
    const onConfirm = (0, $eJOHy.useCallback)((preventFocusReturn = true, event)=>{
        preventFocusOnEditButtonRef.current = preventFocusReturn;
        const analyticsEvent = createAnalyticsEvent({
            action: 'confirmed',
            actionSubject: $82c0f5b6e77ac78a$var$actionSubject
        });
        onConfirmOption(analyticsEvent, event);
    }, [
        createAnalyticsEvent,
        onConfirmOption
    ]);
    const onEdit = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'focused',
            actionSubject: $82c0f5b6e77ac78a$var$actionSubject
        });
        onEditOption(analyticsEvent);
    }, [
        createAnalyticsEvent,
        onEditOption
    ]);
    const context = (0, $eJOHy.useMemo)(()=>({
            onCancel: onCancel,
            onConfirm: onConfirm,
            onEdit: onEdit
        }), [
        onCancel,
        onConfirm,
        onEdit
    ]);
    const refs = (0, $eJOHy.useMemo)(()=>({
            editButton: editButtonRef
        }), []);
    return (0, $eJOHy.useMemo)(()=>({
            context: context,
            refs: refs
        }), [
        context,
        refs
    ]);
};

});

parcelRegister("dA2s3", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f07c4c3cece0ae1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $iGn6g = parcelRequire("iGn6g");
/**
 * Popup component to display a validation message for inline editable fields. The message will be displayed when the
 * user focuses the trigger attached to this component (which should be an interactive form field), and hidden when the
 * trigger is blurred.
 *
 * Why do we have a custom popup instead of using an existing `@atlaskit` component? There are a couple of caveats from
 * the existing components which makes them unsuitable for our use case:
 * 1. `@atlaskit/popup` - Creates a focus lock within the popup preventing the user from tab navigating to and from the
 * popup content.
 * 2. `@atlaskit/inline-dialog` - Deprecated in favour of `@atlaskit/popup`.
 * 3. `@atlaskit/tooltip` - Does not allow visibility to be controlled via a prop and attaches to mouseover events,
 * which is undesired.
 */ const $7f07c4c3cece0ae1$var$ValidationPopup = ({ message: message, placement: placement, fallbackPlacements: fallbackPlacements, trigger: trigger })=>{
    const [isVisuallyHidden, setIsVisuallyHidden] = (0, $eJOHy.useState)(true);
    const wasFocusReceivedSinceLastBlurRef = (0, $eJOHy.useRef)(false);
    const triggerRef = (0, $eJOHy.useRef)();
    const onFocus = ()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
        setIsVisuallyHidden(false);
    };
    const onBlur = ()=>{
        wasFocusReceivedSinceLastBlurRef.current = false;
        setTimeout(()=>{
            if (!wasFocusReceivedSinceLastBlurRef.current) setIsVisuallyHidden(true);
        }, 0);
    };
    const popupContentId = (0, $eJOHy.useMemo)(()=>`${(0, $aXKmr.v4)()}-validation-popup`, []);
    const fieldProps = {
        ref: triggerRef,
        onFocus: onFocus,
        onBlur: onBlur,
        'aria-describedby': isVisuallyHidden ? undefined : popupContentId
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, trigger(fieldProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iGn6g.default), {
        id: popupContentId,
        isVisuallyHidden: isVisuallyHidden,
        message: message,
        onFocus: onFocus,
        onBlur: onBlur,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        referenceElement: triggerRef?.current
    }));
};
var $7f07c4c3cece0ae1$export$2e2bcd8739ae039 = $7f07c4c3cece0ae1$var$ValidationPopup;

});
parcelRegister("iGn6g", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1c2d5c88d4613b7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $Ys7jv = parcelRequire("Ys7jv");
var $2rPSy = parcelRequire("2rPSy");

var $IW7jS = parcelRequire("IW7jS");

var $9cbmy = parcelRequire("9cbmy");

var $8cv11 = parcelRequire("8cv11");

var $efqhN = parcelRequire("efqhN");
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param position - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $b1c2d5c88d4613b7$var$getDirectionFromPlacement = (placement)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    placement.split('-')[0];
// Inverts motion direction
const $b1c2d5c88d4613b7$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
const $b1c2d5c88d4613b7$var$ValidationPopper = ({ id: id, isVisuallyHidden: isVisuallyHidden, message: message, onFocus: onFocus, onBlur: onBlur, placement: placement, fallbackPlacements: fallbackPlacements, referenceElement: referenceElement })=>{
    const updateRef = (0, $eJOHy.useRef)();
    const modifiers = (0, $eJOHy.useMemo)(()=>[
            {
                name: 'flip',
                options: {
                    fallbackPlacements: fallbackPlacements
                }
            }
        ], [
        fallbackPlacements
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Since we are applying visually hidden styles instead of unmounting the popup for accessibility reasons,
        // there will be cases where the popup placement is calculated while it's visually hidden (e.g. when a
        // validation occurs on blur). While visually hidden, popup size is 1px x 1px, and this can make Popper
        // think that the popup fits in a placement where it doesn't actually fit, and end up overflowing the
        // viewport. To prevent this from happening, we ask Popper to recompute popup position when it becomes visible.
        !isVisuallyHidden && updateRef.current?.();
    }, [
        isVisuallyHidden
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ys7jv.default), {
        appear: true
    }, message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8cv11.JiraPopper), {
        placement: placement,
        referenceElement: referenceElement,
        strategy: "absolute",
        modifiers: modifiers,
        messageId: "issue-field-validation-popup.ui.validation-popper.popper",
        messageType: "transactional"
    }, ({ ref: ref, style: style, placement: finalPlacement, update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2rPSy.default), {
            entranceDirection: $b1c2d5c88d4613b7$var$invertedDirection[$b1c2d5c88d4613b7$var$getDirectionFromPlacement(finalPlacement)]
        }, ({ className: className })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                ref: ref,
                // eslint-disable-next-line jira/react/no-style-attribute
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    ...style,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    ...isVisuallyHidden && (0, $9cbmy.visuallyHiddenStyles),
                    zIndex: (0, $IW7jS.layers).layer()
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $efqhN.default), {
                ...message,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                id: id,
                onFocus: onFocus,
                onBlur: onBlur,
                "data-testid": "issue-field-validation-popup.ui.validation-popper.popup-content",
                testId: `issue-field-validation-popup.ui.validation-popper.popup-content${isVisuallyHidden ? '-hidden' : ''}`
            })));
    }));
};
var $b1c2d5c88d4613b7$export$2e2bcd8739ae039 = $b1c2d5c88d4613b7$var$ValidationPopper;

});
parcelRegister("efqhN", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa2564887d15946d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $80DPg = parcelRequire("80DPg");

var $d8UFE = parcelRequire("d8UFE");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $iyBj8 = parcelRequire("iyBj8");
const $fa2564887d15946d$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
const $fa2564887d15946d$var$useIcon = (type)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    switch(type){
        case 'error':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
                spacing: "spacious",
                label: formatMessage((0, $iyBj8.default).errorLabel),
                color: "var(--ds-icon-danger, #C9372C)"
            });
        case 'warning':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8UFE))), {
                spacing: "spacious",
                label: formatMessage((0, $iyBj8.default).warningLabel),
                color: "var(--ds-icon-warning, #E06C00)"
            });
        default:
            $fa2564887d15946d$var$assertUnreachable(type);
    }
};
const $fa2564887d15946d$var$PopupContent = ({ className: className, id: id, message: message, onFocus: onFocus, onBlur: onBlur, testId: testId, title: title, type: type })=>{
    const icon = $fa2564887d15946d$var$useIcon(type);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fa2564887d15946d$var$Content // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        role: "alert",
        id: id,
        hasTitle: !!title,
        onFocus: onFocus,
        onBlur: onBlur,
        "data-testid": testId
    }, icon, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlockEnd: "space.075",
        xcss: $fa2564887d15946d$var$titleStyles
    }, title), message) : message);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa2564887d15946d$var$Content = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasTitle: hasTitle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1e0c1txw _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _vchhusvi _p12f1feq _bfhk1bhr _16qs130s _1bsb1ns9",
            __cmplp.hasTitle ? "_zulppxbi" : "_zulp12x7 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $fa2564887d15946d$var$titleStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtle',
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px'
});
var $fa2564887d15946d$export$2e2bcd8739ae039 = $fa2564887d15946d$var$PopupContent;

});
parcelRegister("iyBj8", function(module, exports) {
$parcel$export(module.exports, "default", () => $699d6029843e778e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $699d6029843e778e$var$messages = (0, $7qGN1.defineMessages)({
    errorLabel: {
        "id": "issue-field-validation-popup.validation-popper.popup-content.error-label",
        "defaultMessage": "Error"
    },
    warningLabel: {
        "id": "issue-field-validation-popup.validation-popper.popup-content.warning-label",
        "defaultMessage": "Warning"
    }
});
var $699d6029843e778e$export$2e2bcd8739ae039 = $699d6029843e778e$var$messages;

});




parcelRegister("2TDKv", function(module, exports) {
$parcel$export(module.exports, "EditView", () => $589496f4abd155cb$export$280eb2fbab4e5389);

var $eJOHy = parcelRequire("eJOHy");

var $2tS6J = parcelRequire("2tS6J");

var $3Js2r = parcelRequire("3Js2r");
const $589496f4abd155cb$export$280eb2fbab4e5389 = ({ cancelButtonLabel: cancelButtonLabel, children: children, confirmButtonLabel: confirmButtonLabel, context: context, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupMinWidth: editViewPopupMinWidth, editViewPopupTarget: editViewPopupTarget, hideActionButtons: hideActionButtons, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur })=>{
    const form = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2tS6J.Form), {
        cancelButtonLabel: cancelButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        context: context,
        hideActionButtons: hideActionButtons,
        keepEditViewOpenOnBlur: keepEditViewOpenOnBlur
    }, children);
    if (editViewPopup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Js2r.EditViewPopup), {
        alignBlock: editViewPopupAlignBlock,
        width: editViewPopupWidth,
        minWidth: editViewPopupMinWidth,
        target: editViewPopupTarget
    }, form);
    return form;
};

});
parcelRegister("2tS6J", function(module, exports) {
$parcel$export(module.exports, "Form", () => $101e08a54c1b522e$export$a7fed597f4b8afd8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4cTDP = parcelRequire("4cTDP");

var $46mQ4 = parcelRequire("46mQ4");
const $101e08a54c1b522e$export$a7fed597f4b8afd8 = ({ cancelButtonLabel: cancelButtonLabel, children: children, confirmButtonLabel: confirmButtonLabel, context: context, hideActionButtons: hideActionButtons, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur })=>{
    const { onCancel: onCancel, onConfirm: onConfirm } = context;
    const wasFocusReceivedSinceLastBlurRef = (0, $eJOHy.useRef)(false);
    const formRef = (0, $eJOHy.useRef)(null);
    /** If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
   *  confirms the value, if the focus is not transferred to the action buttons
   *
   *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
   *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
   *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
   *  `autoSubmitWhenBlur`.
   *
   *  There are two paths here the function can be triggered:
   *
   *  - focus on input first, and then use keyboard to `submit`
   *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save)
   */ const onBlur = (0, $eJOHy.useCallback)((event)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            setTimeout(()=>{
                // Check the form hasn't unmounted before attempting to auto-submit
                !wasFocusReceivedSinceLastBlurRef.current && formRef.current && onConfirm(true, event);
            }, 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        onConfirm
    ]);
    /** Gets called when focus is transferred to the editView, or action buttons
   *
   * There are three paths here the function can be called:
   *
   * - when a user click the `editView`
   * - when a user use keyboard to tab into `editView`
   * - when a user use keyboard to tab into `submit` when they were on input field
   */ const onFocus = (0, $eJOHy.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const onSubmit = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
        onConfirm(false, event);
    }, [
        onConfirm
    ]);
    const onKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) onSubmit(event);
        if (event.key === 'Esc' || event.key === 'Escape') {
            onCancel(false);
            if ((0, $4cTDP.fg)('jira_issue_view_esc_behaviour_fix')) event.stopPropagation();
        }
    }, [
        onCancel,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($101e08a54c1b522e$var$StyledForm, {
        ref: formRef,
        role: "presentation",
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onSubmit: onSubmit
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $46mQ4.FormControls), {
        cancelButtonLabel: cancelButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        context: context,
        hideActionButtons: hideActionButtons
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $101e08a54c1b522e$var$StyledForm = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f1osq _kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("46mQ4", function(module, exports) {
$parcel$export(module.exports, "FormControls", () => $36c7b7a5b7d284f3$export$9b13823dba16e7d1);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bGUQI = parcelRequire("bGUQI");

var $83PoE = parcelRequire("83PoE");
const $36c7b7a5b7d284f3$export$9b13823dba16e7d1 = ({ cancelButtonLabel: cancelButtonLabel, confirmButtonLabel: confirmButtonLabel, context: { onCancel: onCancel }, hideActionButtons: hideActionButtons })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return !hideActionButtons ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $83PoE.default), {
        cancelButtonLabel: cancelButtonLabel ?? formatMessage((0, $bGUQI.default).cancelButtonLabel),
        confirmButtonLabel: confirmButtonLabel ?? formatMessage((0, $bGUQI.default).confirmButtonLabel),
        onCancelClick: ()=>onCancel(false)
    }) : /** This is to allow Ctrl + Enter to submit without action buttons */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("button", {
        hidden: true,
        type: "submit",
        "aria-label": formatMessage((0, $bGUQI.default).submitButtonLabel)
    });
};

});
parcelRegister("bGUQI", function(module, exports) {
$parcel$export(module.exports, "default", () => $785a91e9889ee2a9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $785a91e9889ee2a9$var$messages = (0, $7qGN1.defineMessages)({
    editButtonLabel: {
        "id": "inline-edit-lite.read-view.edit-button-label",
        "defaultMessage": "Edit"
    },
    confirmButtonLabel: {
        "id": "inline-edit-lite.edit-view.confirm-button-label",
        "defaultMessage": "Confirm"
    },
    cancelButtonLabel: {
        "id": "inline-edit-lite.edit-view.cancel-button-label",
        "defaultMessage": "Cancel"
    },
    submitButtonLabel: {
        "id": "inline-edit-lite.edit-view.submit-button-label",
        "defaultMessage": "Submit"
    }
});
var $785a91e9889ee2a9$export$2e2bcd8739ae039 = $785a91e9889ee2a9$var$messages;

});

parcelRegister("83PoE", function(module, exports) {
$parcel$export(module.exports, "default", () => $b29521711d40a0dd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $lwpci = parcelRequire("lwpci");

var $6zhpo = parcelRequire("6zhpo");
const $b29521711d40a0dd$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b29521711d40a0dd$var$ButtonsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b29521711d40a0dd$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        "aria-label": confirmButtonLabel,
        type: "submit",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lwpci))), {
            label: confirmButtonLabel
        }),
        shouldFitContainer: true,
        onMouseDown: onMouseDown
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b29521711d40a0dd$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        "aria-label": cancelButtonLabel,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
            label: cancelButtonLabel
        }),
        onClick: onCancelClick,
        shouldFitContainer: true,
        onMouseDown: onMouseDown
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b29521711d40a0dd$var$ButtonsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1pfh12x7 _kqswstnw _152t1osq _rjxpidpf _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $b29521711d40a0dd$var$ButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs130s _1mpy1b66 _1nlx1bhr _l2uv6o2t _7mfvm8nx _szlbi7uo",
            __cmplp.className
        ])
    });
});
var $b29521711d40a0dd$export$2e2bcd8739ae039 = $b29521711d40a0dd$var$Buttons;

});



parcelRegister("3Js2r", function(module, exports) {
$parcel$export(module.exports, "EditViewPopup", () => $685159e43c153664$export$3ce17fd683f703eb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $LFmXM = parcelRequire("LFmXM");

var $6G5P1 = parcelRequire("6G5P1");
var $azjc1 = parcelRequire("azjc1");

var $bzbsd = parcelRequire("bzbsd");

var $8cv11 = parcelRequire("8cv11");

var $4cTDP = parcelRequire("4cTDP");

var $1jdzZ = parcelRequire("1jdzZ");
const $685159e43c153664$var$getModifiers = (alignBlock)=>[
        {
            name: 'offset',
            enabled: alignBlock === 'center',
            options: {
                // Use negative offset of half the popper height to vertically center the content
                offset: ({ popper: popper })=>[
                        0,
                        -popper.height / 2
                    ]
            }
        },
        {
            name: 'flip',
            enabled: false
        },
        {
            name: 'computeStyles',
            options: {
                // Prevent use of 3D transforms to avoid creating a new stacking context for fixed position children
                gpuAcceleration: false
            }
        },
        {
            name: 'preventOverflow',
            options: {
                padding: 0,
                rootBoundary: 'viewport',
                // Allow the popup to remain within the clipping parent when overflowing the Y axis
                altAxis: true
            }
        }
    ];
/** Map the provided alignment to the appropriate popper placement. */ const $685159e43c153664$var$toPopperPlacement = (alignBlock)=>{
    switch(alignBlock){
        case 'end':
            return 'top-start';
        default:
            return 'bottom-start';
    }
};
/** Map the provided min width breakpoint to a pixel value. */ const $685159e43c153664$var$toMinWidth = (minWidth)=>{
    switch(minWidth){
        case 'large':
            return '400px';
        case 'medium':
            return '200px';
        default:
            return '140px';
    }
};
const $685159e43c153664$export$3ce17fd683f703eb = ({ alignBlock: alignBlock = 'start', width: width, minWidth: minWidth = 'medium', target: target, children: children })=>{
    const updateRef = (0, $eJOHy.useRef)();
    const resizeObserver = (0, $eJOHy.useRef)();
    const modifiersFromContext = (0, $1jdzZ.useEditViewPopupModifiersContext)();
    const additionalModifiers = (0, $eJOHy.useMemo)(()=>{
        // eslint-disable-next-line jira/ff/no-preconditioning
        return (0, $4cTDP.fg)('issue_table_frozen_columns') && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? modifiersFromContext : [];
    }, [
        modifiersFromContext
    ]);
    // Cleanup the resize observer when the component is unmounted
    (0, $eJOHy.useEffect)(()=>()=>resizeObserver.current?.disconnect(), []);
    const resizeRef = (0, $eJOHy.useCallback)((el)=>{
        if (el) {
            // Update popup positioning whenever content is resized
            resizeObserver.current = new ResizeObserver(()=>updateRef.current?.());
            resizeObserver.current.observe(el);
        }
    }, []);
    const Target = (0, $eJOHy.useMemo)(()=>target != null ? target : $685159e43c153664$var$DefaultTarget, [
        target
    ]);
    // Ensure a stable ref function is passed through to the popup content
    const memoizedMergeRefs = (0, $eJOHy.useMemo)(()=>(0, $LFmXM.default)((0, $bzbsd.mergeRefs)), []);
    const modifiers = (0, $eJOHy.useMemo)(()=>[
            ...$685159e43c153664$var$getModifiers(alignBlock),
            ...additionalModifiers
        ], [
        alignBlock,
        additionalModifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6G5P1.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $azjc1.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Target, {
            ref: ref
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8cv11.JiraPopper), {
        placement: $685159e43c153664$var$toPopperPlacement(alignBlock),
        strategy: "absolute",
        modifiers: modifiers,
        messageId: "issue-field-inline-edit-lite.ui.field-inline-edit-lite.edit-view.edit-view-popup.popper",
        messageType: "transactional"
    }, ({ ref: ref, style: style, update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($685159e43c153664$var$Content, {
            ref: memoizedMergeRefs(ref, resizeRef),
            width: width,
            minWidth: minWidth,
            /* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style
        }, children);
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $685159e43c153664$var$DefaultTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbidpf",
            __cmplp.className
        ])
    });
});
const $685159e43c153664$var$Content = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minWidth: minWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_19fgw0l": (0, $awdRS.default)((()=>{
                return __cmplp.width ? '0px' : `max(100%, ${$685159e43c153664$var$toMinWidth(__cmplp.minWidth)})`;
            })()),
            "--_1vcp0mh": (0, $awdRS.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ul91oyu _p12fkbql _1pby16oo",
            __cmplp.width ? "_1bsb1efm" : "_1bsb1ris",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2KSbM", function(module, exports) {
$parcel$export(module.exports, "default", () => $b248572e32a7e865$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b248572e32a7e865$var$messages = (0, $7qGN1.defineMessages)({
    confirmButtonLabel: {
        "id": "issue-field-inline-edit-lite.field-inline-edit-lite.confirm-button-label",
        "defaultMessage": "Confirm {fieldName}"
    },
    cancelButtonLabel: {
        "id": "issue-field-inline-edit-lite.field-inline-edit-lite.cancel-button-label",
        "defaultMessage": "Cancel {fieldName}"
    },
    editButtonLabel: {
        "id": "issue-field-inline-edit-lite.field-inline-edit-lite.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    }
});
var $b248572e32a7e865$export$2e2bcd8739ae039 = $b248572e32a7e865$var$messages;

});

parcelRegister("ew20k", function(module, exports) {
$parcel$export(module.exports, "ReadView", () => $ab3c7684ddf42ea0$export$a4b5824ec1e018e1);

var $eJOHy = parcelRequire("eJOHy");

var $64Dbx = parcelRequire("64Dbx");

var $tYLUh = parcelRequire("tYLUh");

var $k4Rl5 = parcelRequire("k4Rl5");

var $kjtxW = parcelRequire("kjtxW");
const $ab3c7684ddf42ea0$export$a4b5824ec1e018e1 = ({ children: children, context: context, editButtonLabel: editButtonLabel, editButtonRef: editButtonRef, hideEditButton: hideEditButton, isEditInteractionEnabled: isEditInteractionEnabled, isInvalid: isInvalid, isLoading: isLoading, readViewContainerRef: readViewContainerRef, readViewFitContainerHeight: readViewFitContainerHeight, readViewContainerTarget: readViewContainerTarget, onCopy: onCopy, onCut: onCut, onPaste: onPaste, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled, value: value })=>{
    const { isEditButtonFocused: isEditButtonFocused, onClick: onClick, onMouseDown: onMouseDown, onEditButtonBlur: onEditButtonBlur, onEditButtonFocus: onEditButtonFocus } = (0, $64Dbx.useInlineEditReadViewContainer)(context, isEditInteractionEnabled);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const { onFocus: onFocus, onBlur: onBlur, lastCopiedTarget: isCopied } = (0, $kjtxW.useCopyPasteTarget)({
        onCopy: onCopy,
        onCut: onCut,
        // Don't allow paste interaction for non-editable fields
        onPaste: isEditInteractionEnabled ? onPaste : undefined
    });
    const handleEditButtonBlur = (0, $eJOHy.useCallback)((e)=>{
        onEditButtonBlur(e);
        onBlur(e);
    }, [
        onEditButtonBlur,
        onBlur
    ]);
    const handleEditButtonFocus = (0, $eJOHy.useCallback)((e)=>{
        onEditButtonFocus(e);
        onFocus(e);
    }, [
        onEditButtonFocus,
        onFocus
    ]);
    if (readViewContainerTarget) {
        const Target = readViewContainerTarget;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Target, {
            context: context,
            editButtonLabel: editButtonLabel,
            editButtonRef: editButtonRef,
            hideEditButton: hideEditButton,
            isEditable: isEditInteractionEnabled,
            isLoading: isLoading,
            isInvalid: isInvalid,
            onClick: onClick,
            editViewPreloadTriggerRef: readViewContainerRef
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k4Rl5.default), {
        context: context,
        editButtonLabel: editButtonLabel,
        editButtonRef: editButtonRef,
        hideEditButton: hideEditButton,
        isEditInteractionEnabled: isEditInteractionEnabled,
        isEditButtonFocused: isEditButtonFocused,
        isCopied: isCopied,
        // Highlight the field as invalid to notify the user if there was an error attempting to submit changes.
        isInvalid: isInvalid,
        isLoading: isLoading,
        onClick: onClick,
        onMouseDown: onMouseDown,
        onEditButtonBlur: handleEditButtonBlur,
        onEditButtonFocus: handleEditButtonFocus,
        readViewFitContainerHeight: readViewFitContainerHeight,
        ref: readViewContainerRef,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled,
        ...isExperimentEnabled && {
            value: value
        }
    }, children);
};

});
parcelRegister("64Dbx", function(module, exports) {
$parcel$export(module.exports, "useInlineEditReadViewContainer", () => $8db9de8130ba3246$export$49374f374d70ab51);

var $eJOHy = parcelRequire("eJOHy");
const $8db9de8130ba3246$var$DRAG_THRESHOLD = 5;
const $8db9de8130ba3246$var$isLinkOrButton = (element)=>element.closest('a') != null || element.closest('button') != null;
const $8db9de8130ba3246$export$49374f374d70ab51 = ({ onEdit: onEdit }, isEditInteractionEnabled = true)=>{
    const startX = (0, $eJOHy.useRef)(0);
    const startY = (0, $eJOHy.useRef)(0);
    const [isEditButtonFocused, setEditButtonFocused] = (0, $eJOHy.useState)(false);
    const mouseHasMovedAfterMouseDown = (0, $eJOHy.useCallback)((event)=>Math.abs(startX.current - event.clientX) >= $8db9de8130ba3246$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $8db9de8130ba3246$var$DRAG_THRESHOLD, []);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        const element = event.target;
        /** If a link or button is clicked in the read view, default action should be taken */ if (element instanceof HTMLElement && !$8db9de8130ba3246$var$isLinkOrButton(element) && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEdit();
        }
    }, [
        mouseHasMovedAfterMouseDown,
        onEdit
    ]);
    const onMouseDown = (0, $eJOHy.useCallback)((event)=>{
        startX.current = event.clientX;
        startY.current = event.clientY;
    }, []);
    const onEditButtonBlur = (0, $eJOHy.useCallback)(()=>setEditButtonFocused(false), []);
    const onEditButtonFocus = (0, $eJOHy.useCallback)(()=>setEditButtonFocused(true), []);
    return {
        isEditButtonFocused: isEditButtonFocused,
        onClick: isEditInteractionEnabled ? onClick : undefined,
        onMouseDown: isEditInteractionEnabled ? onMouseDown : undefined,
        onEditButtonBlur: onEditButtonBlur,
        onEditButtonFocus: onEditButtonFocus
    };
};

});

parcelRegister("k4Rl5", function(module, exports) {
$parcel$export(module.exports, "default", () => $6dcf29bcd23ed8fd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8dH3d = parcelRequire("8dH3d");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $4cTDP = parcelRequire("4cTDP");

var $gFFoY = parcelRequire("gFFoY");

var $ejhcC = parcelRequire("ejhcC");

var $jCuWH = parcelRequire("jCuWH");

var $tYLUh = parcelRequire("tYLUh");
const $6dcf29bcd23ed8fd$var$borderStyles = {
    focused: "_1h6d1v1w",
    invalid: "_1h6d1bqt",
    copied: "_1h6d1v1w _1dqogq9o",
    none: "_1h6d3acm"
};
const $6dcf29bcd23ed8fd$var$getBorderStyle = ({ isFocusRingVisible: isFocusRingVisible, isInvalid: isInvalid, isCopied: isCopied })=>{
    if (isFocusRingVisible) return 'focused';
    if (isInvalid) return 'invalid';
    if (isCopied) return 'copied';
    return 'none';
};
/**
 * This component is designed to be rendered within the `readView` of a `FieldInlineEditLite` component. This can be
 * rendered in a 'read-only' layout by omitting the `context` prop which is provided by `useInlineEdit` in
 * `@atlassian/jira-inline-edit-lite`. This ensures consistent spacing for consumers when a field is conditionally
 * editable.
 */ const $6dcf29bcd23ed8fd$var$InlineEditReadViewContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, context: context, editButtonLabel: editButtonLabel, editButtonRef: editButtonRef, hideEditButton: hideEditButton = true, isCopied: isCopied = false, isEditButtonFocused: isEditButtonFocused = false, isEditInteractionEnabled: isEditInteractionEnabled = true, isLoading: isLoading = false, isInvalid: isInvalid = false, onClick: onClick, onMouseDown: onMouseDown, onEditButtonBlur: onEditButtonBlur, onEditButtonFocus: onEditButtonFocus, readViewFitContainerHeight: readViewFitContainerHeight = false, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled = false, value: value, readViewHighlightOnHover: readViewHighlightOnHover = true }, ref)=>{
    const isHiddenButtonFocused = hideEditButton && isEditButtonFocused;
    const isFocusRingVisible = isHiddenButtonFocused || isLoading;
    const isEditable = Boolean(context) && isEditInteractionEnabled;
    const { isVisibleOnHover: isVisibleOnHover } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const [isMouseOver, setIsMouseOver] = (0, $eJOHy.useState)(false);
    const handleOnHover = (0, $eJOHy.useCallback)(()=>setIsMouseOver(true), []);
    const handleOnLeave = (0, $eJOHy.useCallback)(()=>setIsMouseOver(false), []);
    const borderStyle = $6dcf29bcd23ed8fd$var$getBorderStyle({
        isFocusRingVisible: isFocusRingVisible,
        isInvalid: isInvalid,
        isCopied: isCopied
    });
    const childrenToRender = !isVisibleOnHover || value?.toString() || !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(value) || isMouseOver ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6dcf29bcd23ed8fd$var$readViewHiddenUntilHoverStyle
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6dcf29bcd23ed8fd$var$Container, {
        "data-testid": "issue-field-inline-edit-read-view-container.ui.container",
        "data-vc": "issue-field-inline-edit-read-view-container",
        readViewFitContainerHeight: readViewFitContainerHeight,
        isEditable: isEditable,
        onClick: onClick,
        onMouseDown: onMouseDown,
        role: "presentation",
        ref: ref,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled,
        showOverflow: hasReadViewTruncateDisabled && !(0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting'),
        onFocus: handleOnHover,
        onBlur: handleOnLeave,
        onMouseEnter: handleOnHover,
        onMouseLeave: handleOnLeave,
        // Consumers may currently update non-visual styles dynamically based off isEditable prop.
        // Here we allow consumers to exclude the attachment of edit styles from VC calculation.
        // Learn more about why this has been introduced https://jplat.atlassian.net/browse/EM-9211
        "data-vc-nvs": (0, $4cTDP.fg)('ignore_inline_edit_cell'),
        readViewHighlightOnHover: readViewHighlightOnHover,
        className: (0, $hcewu.default)([
            borderStyle && $6dcf29bcd23ed8fd$var$borderStyles[borderStyle]
        ])
    }, hideEditButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ejhcC.EditButtonHidden), {
        ref: editButtonRef,
        context: context ?? (0, $gFFoY.EMPTY_INLINE_EDIT_CONTEXT),
        isDisabled: !isEditable,
        label: editButtonLabel,
        onBlur: onEditButtonBlur,
        onFocus: onEditButtonFocus
    }), isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6dcf29bcd23ed8fd$var$LoadingOverlay, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6dcf29bcd23ed8fd$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null))) : childrenToRender, !hideEditButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jCuWH.EditButton), {
        ref: editButtonRef,
        context: context ?? (0, $gFFoY.EMPTY_INLINE_EDIT_CONTEXT),
        isDisabled: !isEditable,
        label: editButtonLabel,
        onBlur: onEditButtonBlur,
        onFocus: onEditButtonFocus,
        // In future providing CSS variables *may* be something that makes its way into the design system, but
        // for now this is an acceptable override to prevent managing additional state with JS.
        // More context here https://atlassian.slack.com/archives/C060GTVV988/p1703214250865779?thread_ts=1703212675.166419&cid=C060GTVV988
        /* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766, */ style: $6dcf29bcd23ed8fd$var$editButtonStyles
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6dcf29bcd23ed8fd$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { readViewFitContainerHeight: readViewFitContainerHeight, showOverflow: showOverflow, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled, isEditable: isEditable, readViewHighlightOnHover: readViewHighlightOnHover, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _zulpu2gc _189e1dm9 _1dqonqa1 _ca0qidpf _u5f312x7 _n3tdidpf _19bv12x7 _1e0c1txw _4cvr1h6o _vchhusvi _p12f1osq _kqswh2mm _16jlkb7n",
            __cmplp.readViewFitContainerHeight ? "_1tke1osq" : "_1tkezwfg",
            __cmplp.showOverflow ? "_1reoewfl _18m9ewfl" : "_1reo15vq _18m915vq",
            __cmplp.hasReadViewTruncateDisabled ? "_1bton7od" : "_1bto1l2s",
            __cmplp.isEditable && "_v56412tl",
            __cmplp.isEditable && __cmplp.readViewHighlightOnHover && "_irr31dpa",
            __cmplp.isEditable && "_yyosidpf _37uft94y _1rr4t94y",
            __cmplp.className
        ])
    });
});
const $6dcf29bcd23ed8fd$var$editButtonStyles = {
    flexShrink: 0,
    marginLeft: 'auto',
    opacity: 'var(--edit-button-opacity, 0)'
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6dcf29bcd23ed8fd$var$LoadingOverlay = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_lcxvglyw _tzy4n2vs",
            __cmplp.className
        ])
    });
});
const $6dcf29bcd23ed8fd$var$SpinnerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _1ltv1ssb _154i1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
const $6dcf29bcd23ed8fd$var$readViewHiddenUntilHoverStyle = (0, $1DXK0.xcss)({
    visibility: 'hidden'
});
var $6dcf29bcd23ed8fd$export$2e2bcd8739ae039 = $6dcf29bcd23ed8fd$var$InlineEditReadViewContainer;

});
parcelRegister("gFFoY", function(module, exports) {
$parcel$export(module.exports, "EMPTY_INLINE_EDIT_CONTEXT", () => $01d5176cdfd5ecd4$export$817cfe3c303a8a15);

var $12DRg = parcelRequire("12DRg");
const $01d5176cdfd5ecd4$export$817cfe3c303a8a15 = {
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onConfirm: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onEdit: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};

});

parcelRegister("ejhcC", function(module, exports) {
$parcel$export(module.exports, "EditButtonHidden", () => $c9cbb95271b5bc33$export$c2bd955fafbef8bc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bGUQI = parcelRequire("bGUQI");
const $c9cbb95271b5bc33$export$c2bd955fafbef8bc = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ context: { onEdit: onEdit }, isDisabled: isDisabled, label: label, onBlur: onBlur, onFocus: onFocus }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const finalEditButtonLabel = label ?? formatMessage((0, $bGUQI.default).editButtonLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c9cbb95271b5bc33$var$HiddenButton, {
        "aria-label": finalEditButtonLabel,
        disabled: isDisabled,
        "aria-hidden": isDisabled,
        onBlur: onBlur,
        onFocus: onFocus,
        onClick: onEdit,
        ref: ref,
        type: "button"
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/no-html-button -- Ignored via go/DSP-18766
const $c9cbb95271b5bc33$var$HiddenButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jCuWH", function(module, exports) {
$parcel$export(module.exports, "EditButton", () => $b4e433ce880239a1$export$a8d3280cb45e38b8);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $gTr6H = parcelRequire("gTr6H");

var $lRq8t = parcelRequire("lRq8t");

var $bGUQI = parcelRequire("bGUQI");
const $b4e433ce880239a1$export$a8d3280cb45e38b8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ context: { onEdit: onEdit }, isDisabled: isDisabled, label: label, onBlur: onBlur, onFocus: onFocus, style: style }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const finalEditButtonLabel = label ?? formatMessage((0, $bGUQI.default).editButtonLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        "data-vc": "inline-edit-lite-edit-button",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gTr6H))), {
            spacing: "spacious",
            label: finalEditButtonLabel,
            color: "var(--ds-icon, #292A2E)"
        }),
        isDisabled: isDisabled,
        "aria-hidden": isDisabled,
        onClick: onEdit,
        onBlur: onBlur,
        onFocus: onFocus,
        ref: ref,
        spacing: "none",
        // In future providing CSS variables *may* be something that makes its way into the design system, but
        // for now this is an acceptable override to prevent managing additional state with JS.
        // More context here https://atlassian.slack.com/archives/C060GTVV988/p1703214250865779?thread_ts=1703212675.166419&cid=C060GTVV988
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, jira/react/no-style-attribute -- Ignored via go/DSP-18766
        style: style
    });
});

});


parcelRegister("kjtxW", function(module, exports) {
$parcel$export(module.exports, "CopyPasteContextProvider", () => $cafc82d5a6cd54a2$export$1afe5f1aa41cba74);
$parcel$export(module.exports, "useCopyPasteTarget", () => $cafc82d5a6cd54a2$export$6bdcb2980d85cb0f);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $cafc82d5a6cd54a2$var$CopyPasteContext = /*#__PURE__*/ (0, $eJOHy.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($12DRg))));
const $cafc82d5a6cd54a2$export$1afe5f1aa41cba74 = ({ children: children })=>{
    const copyPasteTarget = (0, $eJOHy.useRef)(null);
    const lastCopiedTarget = (0, $eJOHy.useRef)(null);
    const updateCopyPasteTarget = (0, $eJOHy.useCallback)((handlers)=>{
        copyPasteTarget.current = handlers;
    }, []);
    /** Update the last copied target if the copy event is explicitly handled. */ const updateLastCopiedTargetWhenHandled = (0, $eJOHy.useCallback)((handled, nextTarget)=>{
        if (!handled) return;
        // Clear previously copied target
        lastCopiedTarget.current?.onLastCopiedTarget(false);
        // Set next copied target
        nextTarget?.onLastCopiedTarget(true);
        lastCopiedTarget.current = nextTarget;
    }, []);
    const onCopy = (0, $eJOHy.useCallback)((event)=>{
        updateLastCopiedTargetWhenHandled(copyPasteTarget.current?.onCopy(event) ?? false, copyPasteTarget.current);
    }, [
        updateLastCopiedTargetWhenHandled
    ]);
    const onCut = (0, $eJOHy.useCallback)((event)=>{
        updateLastCopiedTargetWhenHandled(copyPasteTarget.current?.onCut(event) ?? false, copyPasteTarget.current);
    }, [
        updateLastCopiedTargetWhenHandled
    ]);
    const onPaste = (0, $eJOHy.useCallback)((event)=>{
        updateLastCopiedTargetWhenHandled(copyPasteTarget.current?.onPaste(event) ?? false, null);
    }, [
        updateLastCopiedTargetWhenHandled
    ]);
    (0, $eJOHy.useEffect)(()=>{
        globalThis.document.addEventListener('copy', onCopy);
        globalThis.document.addEventListener('cut', onCut);
        globalThis.document.addEventListener('paste', onPaste, true);
        return ()=>{
            globalThis.document.removeEventListener('copy', onCopy);
            globalThis.document.removeEventListener('cut', onCut);
            globalThis.document.removeEventListener('paste', onPaste, true);
        };
    }, [
        onCopy,
        onCut,
        onPaste
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cafc82d5a6cd54a2$var$CopyPasteContext.Provider, {
        value: updateCopyPasteTarget
    }, children);
};
const $cafc82d5a6cd54a2$export$6bdcb2980d85cb0f = ({ onCopy: onCopy, onCut: onCut, onPaste: onPaste })=>{
    const updateCopyPasteTarget = (0, $eJOHy.useContext)($cafc82d5a6cd54a2$var$CopyPasteContext);
    const [lastCopiedTarget, setLastCopiedTarget] = (0, $eJOHy.useState)(false);
    // Track callbacks as refs so they can be invoked using a stable function reference
    const onCopyRef = (0, $eJOHy.useRef)(onCopy);
    onCopyRef.current = onCopy;
    const onCutRef = (0, $eJOHy.useRef)(onCut);
    onCutRef.current = onCut;
    const onPasteRef = (0, $eJOHy.useRef)(onPaste);
    onPasteRef.current = onPaste;
    const onFocus = (0, $eJOHy.useCallback)(()=>{
        // Ensure stable function reference is provided as the callback functions are only bound to the document once
        const stableCopy = (event)=>onCopyRef.current?.(event) ?? false;
        const stableCut = (event)=>onCutRef.current?.(event) ?? false;
        const stablePaste = (event)=>onPasteRef.current?.(event) ?? false;
        /* Queue as a microtask to ensure the blur callback is emitted before calling updateCopyPasteTarget when
		 * navigating between targets. */ queueMicrotask(()=>{
            updateCopyPasteTarget({
                onCopy: stableCopy,
                onCut: stableCut,
                onPaste: stablePaste,
                onLastCopiedTarget: setLastCopiedTarget
            });
        });
    }, [
        updateCopyPasteTarget
    ]);
    const onBlur = (0, $eJOHy.useCallback)(()=>{
        updateCopyPasteTarget(null);
    }, [
        updateCopyPasteTarget
    ]);
    return {
        lastCopiedTarget: lastCopiedTarget,
        onFocus: onFocus,
        onBlur: onBlur
    };
};

});



parcelRegister("6TknG", function(module, exports) {
$parcel$export(module.exports, "ReadViewNonEditable", () => $cf90f517f772227d$export$4efb4956550fac52);

var $eJOHy = parcelRequire("eJOHy");

var $k4Rl5 = parcelRequire("k4Rl5");
const $cf90f517f772227d$export$4efb4956550fac52 = ({ children: children, hideEditButton: hideEditButton, isLoading: isLoading, readViewFitContainerHeight: readViewFitContainerHeight, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled, readViewHighlightOnHover: readViewHighlightOnHover })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k4Rl5.default), {
        hideEditButton: hideEditButton,
        isLoading: isLoading,
        readViewFitContainerHeight: readViewFitContainerHeight,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled,
        readViewHighlightOnHover: readViewHighlightOnHover
    }, children);

});


parcelRegister("9McQo", function(module, exports) {
$parcel$export(module.exports, "projectPickerEntrypoint", () => $c4b26cf04f7c5c0b$export$942637108617a018);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $4OtOO = parcelRequire("4OtOO");
const $c4b26cf04f7c5c0b$var$fetchPolicy = 'store-or-network';

const $c4b26cf04f7c5c0b$export$942637108617a018 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("4Y3yH")).then(({ ProjectPickerWithEntrypoint: ProjectPickerWithEntrypoint })=>ProjectPickerWithEntrypoint), {
        moduleId: "49b4106c",
        moduleName: "ProjectPicker",
        priority: "interaction",
        moduleId: 'project-picker-entrypoint'
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                projectPickerQuery: {
                    parameters: (0, $4OtOO.default),
                    variables: {
                        cloudId: cloudId
                    },
                    options: {
                        fetchPolicy: $c4b26cf04f7c5c0b$var$fetchPolicy
                    }
                }
            }
        })
});

});
parcelRegister("4OtOO", function(module, exports) {
$parcel$export(module.exports, "default", () => $900151cd3a581f9d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d364fb3d7691afc7a9753da59d0a91af>>
 * @relayHash fe6ed7432af1a3342bf7ae86b5667b67
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 74f3acf7195af915f9968961a5fb9e989f33a9b3cba830de48d0aab93c7eec51
const $900151cd3a581f9d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ProjectPickerAtlasQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "ProjectPicker_Atlas"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ProjectPickerAtlasQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                },
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareUnshardedWorkspaceSummaryConnection",
                    "kind": "LinkedField",
                    "name": "townsquareUnsharded_allWorkspaceSummariesForOrg",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "TownsquareUnshardedWorkspaceSummaryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "TownsquareUnshardedWorkspaceSummary",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "cloudId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "concreteType": "TownsquareUnshardedUserCapabilities",
                                            "kind": "LinkedField",
                                            "name": "userCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareUnshardedCapability",
                                                    "kind": "LinkedField",
                                                    "name": "capabilities",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "capability"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "capabilityContainer"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "74f3acf7195af915f9968961a5fb9e989f33a9b3cba830de48d0aab93c7eec51",
            "metadata": {},
            "name": "ProjectPickerAtlasQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$900151cd3a581f9d$var$node.hash = "2948919b46c076b76def512ee4c32b35";
var $900151cd3a581f9d$export$2e2bcd8739ae039 = $900151cd3a581f9d$var$node;

});

parcelRegister("4Y3yH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7mXtG").then(()=>parcelRequire('aECgo'));

});


parcelRegister("47YLd", function(module, exports) {
$parcel$export(module.exports, "AtlasProjectEmptytView", () => $fb18749c66bfb73c$export$c37c7436101c336a);
$parcel$export(module.exports, "AtlasProjectReadView", () => $fb18749c66bfb73c$export$5d49fcebb0d1908b);

var $kanA8 = parcelRequire("kanA8");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8IeH1 = parcelRequire("8IeH1");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $cuxZE = parcelRequire("cuxZE");

var $9yG0T = parcelRequire("9yG0T");
const $fb18749c66bfb73c$var$styles = {
    container: "_ca0qv77o _u5f3u2gc _n3tdv77o _19bvu2gc _4t3izwfg _1bsb1osq _y3gn1e5h _1e0c1txw _4cvr1h6o"
};
const $fb18749c66bfb73c$export$c37c7436101c336a = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $fb18749c66bfb73c$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: formatMessage((0, $9yG0T.default).emptyFieldText)
    }));
}; /**
    * The AtlasProjectReadView will show a read only view of AtlasProject field.
    * @param props [AtlasProjectReadViewProps](./types.tsx)
    */ 
const $fb18749c66bfb73c$export$5d49fcebb0d1908b = ({ fragmentRef: fragmentRef, onHandleNoAccess: onHandleNoAccess })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { project: project, isLinkEditable: isLinkEditable, issue: issue } = (0, $j4oe4.useFragment)((0, $kanA8.default), fragmentRef);
    if (!project) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: formatMessage((0, $9yG0T.default).emptyFieldText)
    });
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cuxZE.AtlasProjectSmartLink), {
        projectAri: project.id,
        projectKey: project.atlasProjectKey,
        name: project.atlasProjectName,
        emojiName: project.iconName,
        isPrivate: !!project.privateProject,
        isInherited: isLinkEditable === false,
        issueAri: issue?.id,
        initialHasNoAccess: project?.hasPermission === false || project?.isWorkspaceActive === false,
        onHandleNoAccess: onHandleNoAccess
    });
    return content;
};

});
parcelRegister("kanA8", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5512d90c6b07e08$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fd23184f3a684a9b15d101a674edd4be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c5512d90c6b07e08$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isLinkEditable"
            },
            {
                "concreteType": "JiraTownsquareProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": v0 /*: any*/ ,
                        "action": "THROW",
                        "path": "project.id"
                    },
                    {
                        "alias": "atlasProjectKey",
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "alias": "atlasProjectName",
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "privateProject"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "hasPermission"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isWorkspaceActive"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "iconName"
                    }
                ]
            },
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": v0 /*: any*/ ,
                        "action": "THROW",
                        "path": "issue.id"
                    }
                ]
            }
        ],
        "type": "JiraTownsquareProjectField"
    };
}();
$c5512d90c6b07e08$var$node.hash = "693786d9ccf62aac7155070182663912";
var $c5512d90c6b07e08$export$2e2bcd8739ae039 = $c5512d90c6b07e08$var$node;

});

parcelRegister("d9T1A", function(module, exports) {
$parcel$export(module.exports, "EmptyFieldText", () => $dd0e40972cfd3cc1$export$f6d716da5f11cd01);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $3Lkm9 = parcelRequire("3Lkm9");
const $dd0e40972cfd3cc1$export$f6d716da5f11cd01 = ({ emptyText: emptyText, placeholderText: placeholderText })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dd0e40972cfd3cc1$var$EmptyValueStyleWrapper, null, emptyText ?? formatMessage(placeholderText ?? (0, $3Lkm9.default).emptyFieldText));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $dd0e40972cfd3cc1$var$EmptyValueStyleWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _syaz1rpy _1bto1l2s _p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3Lkm9", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4a1e0054ae710f1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a4a1e0054ae710f1$var$messages = (0, $7qGN1.defineMessages)({
    emptyFieldText: {
        "id": "issue-empty-field-text.empty-field-text",
        "defaultMessage": "None"
    },
    bespokenDateTimePlaceholderEmptyFieldText: {
        "id": "issue-empty-field-text.bespoken-date-time-placeholder-empty-field-text",
        "defaultMessage": "Add date"
    },
    bespokenSingleGroupPickerPlaceholderEmptyFieldText: {
        "id": "issue-empty-field-text.bespoken-single-group-placeholder-empty-field-text",
        "defaultMessage": "Add group"
    },
    bespokenMultiGroupPickerPlaceholderEmptyFieldText: {
        "id": "issue-empty-field-text.bespoken-multi-group-placeholder-empty-field-text",
        "defaultMessage": "Add groups"
    },
    bespokenCascadingSelectPlaceholderEmptyFieldText: {
        "id": "issue-empty-field-text.bespoken-cascading-select-placeholder-empty-field-text",
        "defaultMessage": "Add option"
    },
    bespokenSingleSelectPlaceholderEmptyFieldText: {
        "id": "issue-empty-field-text.bespoken-single-select-placeholder-empty-field-text",
        "defaultMessage": "Add option"
    },
    bespokenUrlPlaceholderEmptyFieldText: {
        "id": "issue-empty-field-text.bespoken-url-placeholder-empty-field-text",
        "defaultMessage": "Add URL"
    },
    bespokenTextPlaceholderEmptyFieldText: {
        "id": "issue-empty-field-text.bespoken-text-placeholder-empty-field-text",
        "defaultMessage": "Add text"
    },
    bespokenMultiSelectPlaceholderEmptyFieldText: {
        "id": "issue-empty-field-text.bespoken-multi-select-placeholder-empty-field-text",
        "defaultMessage": "Add options"
    }
});
var $a4a1e0054ae710f1$export$2e2bcd8739ae039 = $a4a1e0054ae710f1$var$messages;

});


parcelRegister("cuxZE", function(module, exports) {
$parcel$export(module.exports, "AtlasProjectSmartLink", () => $de9b775b07545d7a$export$63acba7661050605);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $lRq8t = parcelRequire("lRq8t");

var $b8OI0 = parcelRequire("b8OI0");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $fRm4z = parcelRequire("fRm4z");

var $baxj2 = parcelRequire("baxj2");

var $90YnL = parcelRequire("90YnL");

var $k3JEF = parcelRequire("k3JEF");

var $cSWVe = parcelRequire("cSWVe");

var $lAN5p = parcelRequire("lAN5p");

var $evtSI = parcelRequire("evtSI");
const $de9b775b07545d7a$var$styles = {
    container: "_y4tiu2gc"
};
const $de9b775b07545d7a$var$EntryPointWrapper = ({ children: children, onClose: onClose, onInheritancePopupOpen: onInheritancePopupOpen, issueAri: issueAri, linkedProject: linkedProject })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b8OI0.PopupTrigger), {
        entryPoint: (0, $baxj2.inheritancePopupEntryPoint),
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $90YnL.InheritancePopupSkeleton), null),
        errorFallback: (0, $k3JEF.InheritancePopupErrorFallback),
        entryPointProps: {
            onInheritancePopupOpen: onInheritancePopupOpen,
            issueAri: issueAri,
            linkedProject: linkedProject
        },
        entryPointParams: {
            issueId: issueAri
        },
        onClose: onClose,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default // eslint-disable-next-line react/jsx-props-no-spreading
            ), triggerProps, children),
        placement: "bottom",
        shouldUseCaptureOnOutsideClick: true,
        zIndex: 600
    });
};
const $de9b775b07545d7a$export$63acba7661050605 = ({ emojiName: emojiName, projectAri: projectAri, projectKey: projectKey, isInherited: isInherited, isPrivate: isPrivate, issueAri: issueAri, initialHasNoAccess: initialHasNoAccess, onHandleNoAccess: onHandleNoAccess, name: name })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const constructAtlasProjectUrl = (0, $fRm4z.useProjectUrlConstructor)();
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const [isPinned, setIsPinned] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const containerRef = (0, $eJOHy.useRef)(null);
    const shouldShowActions = isInherited && (isHovered || isFocused || isPinned);
    const projectUrl = (0, $eJOHy.useMemo)(()=>projectKey ? constructAtlasProjectUrl({
            ari: projectAri,
            projectKey: projectKey
        }) : null, [
        constructAtlasProjectUrl,
        projectAri,
        projectKey
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>{
        if (!issueAri || !isInherited) return [];
        return [
            {
                name: (0, $5NtHI.ActionName).CustomAction,
                onClick: ()=>{
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'inheritedButton'
                    }));
                },
                content: formatMessage((0, $evtSI.default).inheritedProject),
                tooltipMessage: formatMessage((0, $evtSI.default).inheritedProjectTooltip),
                hideIcon: true,
                entryPointWrapper: (p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($de9b775b07545d7a$var$EntryPointWrapper, {
                        ...p,
                        onClose: ()=>{
                            setIsPinned(false);
                            setIsFocused(false);
                            setIsHovered(false);
                        },
                        onInheritancePopupOpen: ()=>setIsPinned(true),
                        issueAri: issueAri,
                        linkedProject: {
                            projectUrl: projectUrl,
                            isRestricted: initialHasNoAccess
                        }
                    })
            }
        ];
    }, [
        issueAri,
        isInherited,
        formatMessage,
        createAnalyticsEvent,
        projectUrl,
        initialHasNoAccess
    ]);
    if (projectUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        ref: containerRef,
        testId: "issue-field-atlas-project-common.ui.atlas-project-smart-link.container",
        xcss: !isInherited && $de9b775b07545d7a$var$styles.container,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onMouseDown: ()=>{
            // this is covering an edge case where user clicks inherit button to close the popup, it won't lose focus so we have to help it a little
            if (isPinned) setIsFocused(false);
        },
        onFocus: ()=>setIsFocused(true),
        onBlur: (event)=>{
            // Check if focus is moving outside the container
            if (containerRef.current && !containerRef.current.contains(event.relatedTarget)) setIsFocused(false);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lAN5p.SimpleInlineSmartLink), {
        anchorTarget: "_blank",
        url: projectUrl,
        metadata: [],
        actions: shouldShowActions ? actions : undefined,
        initialHasNoAccess: initialHasNoAccess,
        projectAri: projectAri,
        showNoAccessPopup: isInherited === false,
        isPrivate: isPrivate,
        onHandleNoAccess: onHandleNoAccess,
        text: name || undefined,
        emojiName: emojiName || undefined
    }));
     // handle no project key returned
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cSWVe.RestrictedAlikeSmartLink), null);
};

});
parcelRegister("baxj2", function(module, exports) {
$parcel$export(module.exports, "inheritancePopupEntryPoint", () => $ea2016e2a194da4e$export$8a532031d2a56f2b);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $3NEFY = parcelRequire("3NEFY");
const $ea2016e2a194da4e$var$fetchPolicy = 'network-only';

const $ea2016e2a194da4e$export$8a532031d2a56f2b = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("7r0eb")), {
        moduleId: "23f80e0f",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                inheritancePopupQuery: {
                    parameters: (0, $3NEFY.default),
                    variables: {
                        issueId: issueId
                    },
                    options: {
                        fetchPolicy: $ea2016e2a194da4e$var$fetchPolicy
                    }
                }
            }
        })
});

});
parcelRegister("3NEFY", function(module, exports) {
$parcel$export(module.exports, "default", () => $530cbeaeaa4e8ea3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0be8da337a05a02cca34308a95fc576a>>
 * @relayHash b08192541f6dadc77d4bacab16163a55
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 207bfd7c801f72741185aa635e9c24c24c7bcd9a889d5f6ecfaa69eeeb0d35ce
const $530cbeaeaa4e8ea3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "issueId",
            "variableName": "issueId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "inheritancePopupQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueTownsquareProjectLink",
                            "kind": "LinkedField",
                            "name": "getProjectLinkInheritanceSources",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "inheritancePopup_issueFieldAtlasProjectCommon_InheritancePopupContent"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "inheritancePopupQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueTownsquareProjectLink",
                            "kind": "LinkedField",
                            "name": "getProjectLinkInheritanceSources",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "summary"
                                        },
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "xsmall"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                v2 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "webUrl"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "linkType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "207bfd7c801f72741185aa635e9c24c24c7bcd9a889d5f6ecfaa69eeeb0d35ce",
            "metadata": {},
            "name": "inheritancePopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$530cbeaeaa4e8ea3$var$node.hash = "600dd4544a21bd6cf3876c430837d737";
var $530cbeaeaa4e8ea3$export$2e2bcd8739ae039 = $530cbeaeaa4e8ea3$var$node;

});

parcelRegister("7r0eb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("c0oLq").then(()=>parcelRequire('eFczo'));

});


parcelRegister("90YnL", function(module, exports) {
$parcel$export(module.exports, "InheritancePopupSkeleton", () => $fdcb45bd89f527a1$export$87daa27b1369b050);
/* skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");

var $jjS5D = parcelRequire("jjS5D");
const $fdcb45bd89f527a1$var$styles = {
    container: "_1bsb1byl",
    topSection: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    bottomSection: "_1bsb1byl _4t3ip3fh _mrkb1mok _1o0z1mok _bfhkizff"
};
const $fdcb45bd89f527a1$export$87daa27b1369b050 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $fdcb45bd89f527a1$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.200",
        xcss: $fdcb45bd89f527a1$var$styles.topSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "170px",
        height: "24px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "426px",
        height: "16px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "344px",
        height: "16px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "152px",
        height: "16px"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $fdcb45bd89f527a1$var$styles.bottomSection
    }));

});

parcelRegister("k3JEF", function(module, exports) {
$parcel$export(module.exports, "InheritancePopupErrorFallback", () => $617b2940a3c56b8b$export$cafc10054684fdbb);
/* error-fallback.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $iHPvF = parcelRequire("iHPvF");

var $8IeH1 = parcelRequire("8IeH1");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $59JiD = parcelRequire("59JiD");
const $617b2940a3c56b8b$var$styles = {
    container: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $617b2940a3c56b8b$export$cafc10054684fdbb = ()=>{
    const intl = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'inheritancePopup'
        }), {
            hasError: true
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $617b2940a3c56b8b$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "error",
        title: intl.formatMessage((0, $59JiD.default).errorLoadingInheritancePopupTitle)
    }, intl.formatMessage((0, $59JiD.default).errorLoadingInheritancePopupMessage)));
};

});
parcelRegister("59JiD", function(module, exports) {
$parcel$export(module.exports, "default", () => $acfd36dd9b68efaa$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $acfd36dd9b68efaa$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-field-atlas-project-common.inheritance-popup.title",
        "defaultMessage": "Inherited project"
    },
    description: {
        "id": "issue-field-atlas-project-common.inheritance-popup.description",
        "defaultMessage": "This work item\u2019s project comes from its parent work item. To change the project, select {workItemKey} below."
    },
    restrictedDescriptionTwoLevels: {
        "id": "issue-field-atlas-project-common.inheritance-popup.restricted-description-two-levels",
        "defaultMessage": "This project comes from its parent work item, which you don\u2019t have access to. Contact your admin if you want to change this project."
    },
    restrictedDescriptionThreeOrMoreLevels: {
        "id": "issue-field-atlas-project-common.inheritance-popup.restricted-description-three-or-more-levels",
        "defaultMessage": "This project comes from a work item that you don\u2019t have access to. Contact your admin if you want to change this project."
    },
    moreInformation: {
        "id": "issue-field-atlas-project-common.inheritance-popup.more-information",
        "defaultMessage": "More on project inheritance"
    },
    errorLoadingInheritancePopupTitle: {
        "id": "issue-field-atlas-project-common.inheritance-popup.error-loading.title",
        "defaultMessage": "We couldn't load the inheritance details"
    },
    errorLoadingInheritancePopupMessage: {
        "id": "issue-field-atlas-project-common.inheritance-popup.error-loading.message",
        "defaultMessage": "Check your connection, then try again."
    }
});
var $acfd36dd9b68efaa$export$2e2bcd8739ae039 = $acfd36dd9b68efaa$var$messages;

});


parcelRegister("evtSI", function(module, exports) {
$parcel$export(module.exports, "default", () => $cde4f3074d53482f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cde4f3074d53482f$var$messages = (0, $7qGN1.defineMessages)({
    inheritedProject: {
        "id": "issue-field-atlas-project-common.atlas-project-smart-link.inherited-project",
        "defaultMessage": "Inherited"
    },
    inheritedProjectTooltip: {
        "id": "issue-field-atlas-project-common.atlas-project-smart-link.inherited-project.tooltip",
        "defaultMessage": "Learn where this project comes from"
    }
});
var $cde4f3074d53482f$export$2e2bcd8739ae039 = $cde4f3074d53482f$var$messages;

});


parcelRegister("9yG0T", function(module, exports) {
$parcel$export(module.exports, "default", () => $17b53aeccf8f2dd1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $17b53aeccf8f2dd1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    emptyFieldText: {
        "id": "issue-field-atlas-project-readview-full.atlas-project.empty-field-text",
        "defaultMessage": "Add project"
    }
});

});


parcelRegister("auNLL", function(module, exports) {
$parcel$export(module.exports, "InlineEditFieldInjectionsContext", () => $24da2a466c96bb11$export$5b3426c89ef7f7de);
$parcel$export(module.exports, "useInlineEditFieldInjections", () => $24da2a466c96bb11$export$23de4844126025dd);

var $eJOHy = parcelRequire("eJOHy");

var $kLKe4 = parcelRequire("kLKe4");
const $24da2a466c96bb11$var$initialValue = {
    overriding: {
        overrideLabel: (0, $kLKe4.identity),
        overrideDescription: (0, $kLKe4.identity),
        overrideIsEditable: (0, $kLKe4.identity),
        overrideFieldOptionsFilter: (0, $kLKe4.identity)
    }
};
const $24da2a466c96bb11$export$5b3426c89ef7f7de = /*#__PURE__*/ (0, $eJOHy.createContext)($24da2a466c96bb11$var$initialValue);
const $24da2a466c96bb11$export$23de4844126025dd = ()=>(0, $eJOHy.useContext)($24da2a466c96bb11$export$5b3426c89ef7f7de);

});
parcelRegister("kLKe4", function(module, exports) {
$parcel$export(module.exports, "identity", () => $f351f1a309dc1227$export$f0954fd7d5368655);
$parcel$export(module.exports, "FieldInjectionsContext", () => $f351f1a309dc1227$export$a6ff76841695c6c0);

var $eJOHy = parcelRequire("eJOHy");
// Replace empty function with noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $f351f1a309dc1227$var$noop = ()=>{};
const $f351f1a309dc1227$export$f0954fd7d5368655 = (x)=>x;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f351f1a309dc1227$var$initialValue = {
    capturing: {
        captureAllowedValues: $f351f1a309dc1227$var$noop,
        captureDescription: $f351f1a309dc1227$var$noop,
        captureFieldId: $f351f1a309dc1227$var$noop,
        captureFieldType: $f351f1a309dc1227$var$noop,
        captureIsDisabled: $f351f1a309dc1227$var$noop,
        captureIsRequired: $f351f1a309dc1227$var$noop,
        captureLabel: $f351f1a309dc1227$var$noop,
        captureRenderer: $f351f1a309dc1227$var$noop
    },
    overriding: {
        overrideLabel: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideElementAfterLabel: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideIsRequired: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideIsDisabled: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideAllowedValues: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideFieldOptionsFilter: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideOnChange: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideOnBlur: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideDescription: $f351f1a309dc1227$export$f0954fd7d5368655
    }
};
const $f351f1a309dc1227$export$a6ff76841695c6c0 = /*#__PURE__*/ (0, $eJOHy.createContext)($f351f1a309dc1227$var$initialValue);

});


parcelRegister("jXGTZ", function(module, exports) {
$parcel$export(module.exports, "LINK_MUTATION_ERROR_TYPES", () => $2206d6e13172df60$export$180e4e80606c5318);
const $2206d6e13172df60$export$180e4e80606c5318 = {
    CHILD_ITEMS_LINKED_TO_ANOTHER_PROJECT: 'CHILD_ITEMS_LINKED_TO_ANOTHER_PROJECT',
    NO_PROJECT_EDIT_PERMS: 'NO_PROJECT_EDIT_PERMS'
};

});

parcelRegister("ebGhx", function(module, exports) {
$parcel$export(module.exports, "default", () => $c49ad0ad0cfe8a9a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c49ad0ad0cfe8a9a$var$messages = (0, $7qGN1.defineMessages)({
    childIssueAlreadyLinkedNoReplaceTitle: {
        "id": "issue-field-atlas-project-inline-edit-full.ui.atlas-project.show-flag.error.child-issue-already-linked-to-another-project.title",
        "defaultMessage": "Can't link project"
    },
    childIssueAlreadyLinkedNoReplaceDescription: {
        "id": "issue-field-atlas-project-inline-edit-full.ui.atlas-project.show-flag.error.child-issue-already-linked-to-another-project.description",
        "defaultMessage": "This work item has child items linked to another project. Since you don't have permission to edit those child items, this project can't be linked here. "
    },
    childIssueAlreadyLinkedNoReplaceAction: {
        "id": "issue-field-atlas-project-inline-edit-full.ui.atlas-project.show-flag.error.child-issue-already-linked-to-another-project.action",
        "defaultMessage": "More on project inheritance"
    },
    noProjectEditPermsErrorMessage: {
        "id": "issue-field-atlas-project-inline-edit-full.ui.atlas-project.show-flag.error.no-project-edit-perms.message",
        "defaultMessage": "You need edit permission on the project to link it to this work item."
    }
});
var $c49ad0ad0cfe8a9a$export$2e2bcd8739ae039 = $c49ad0ad0cfe8a9a$var$messages;

});

const $a1452414e695131e$export$228ddfe2e1c9e3bf = 'https://support.atlassian.com/platform-experiences/docs/link-goals-and-projects-to-work-in-jira/';

parcelRegister("5mlwW", function(module, exports) {
$parcel$export(module.exports, "LinkConfirmationModal", () => $f6eda955cd1add2e$export$c3ca8865f7a1438f);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $3cMgR = parcelRequire("3cMgR");

var $eJ9f5 = parcelRequire("eJ9f5");

var $lJKII = parcelRequire("lJKII");

var $lRq8t = parcelRequire("lRq8t");


var $eTfPS = parcelRequire("eTfPS");
const $f6eda955cd1add2e$export$c3ca8865f7a1438f = ({ onClose: onClose, onLink: onLink })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
        messageId: "issue-field-atlas-project-inline-edit-full.ui.atlas-project.link-confirmation-modal.modal-dialog.confirmation-modal",
        messageType: "transactional",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "warning"
    }, formatMessage((0, $eTfPS.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $eTfPS.default).description, {
        Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                href: (0, $a1452414e695131e$export$228ddfe2e1c9e3bf),
                target: "_blank"
            }, chunks)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $eTfPS.default).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "warning",
        onClick: onLink
    }, formatMessage((0, $eTfPS.default).linkButton))));
};

});
parcelRegister("eTfPS", function(module, exports) {
$parcel$export(module.exports, "default", () => $304c467e938d6cd3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $304c467e938d6cd3$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-field-atlas-project-inline-edit-full.ui.atlas-project.link-confirmation-modal.title",
        "defaultMessage": "Some child items are linked to other projects"
    },
    description: {
        "id": "issue-field-atlas-project-inline-edit-full.ui.atlas-project.link-confirmation-modal.description",
        "defaultMessage": "Linking this project will also replace the project for all child items under this work item. <Link>More on project inheritance</Link>"
    },
    cancelButton: {
        "id": "issue-field-atlas-project-inline-edit-full.ui.atlas-project.link-confirmation-modal.cancel-button",
        "defaultMessage": "Cancel"
    },
    linkButton: {
        "id": "issue-field-atlas-project-inline-edit-full.ui.atlas-project.link-confirmation-modal.link-button",
        "defaultMessage": "Link work item"
    }
});
var $304c467e938d6cd3$export$2e2bcd8739ae039 = $304c467e938d6cd3$var$messages;

});


parcelRegister("8htSu", function(module, exports) {
$parcel$export(module.exports, "useAtlasProjectAnalyticsEvent", () => $623688ff325eecfa$export$15a2c3c010ae5556);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $623688ff325eecfa$var$DEFAULT_ACTION_SUBJECT = 'project';
const $623688ff325eecfa$export$15a2c3c010ae5556 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireAtlasProjectAnalyticsEvent = (0, $eJOHy.useCallback)(({ event: event, analyticsAttributes: analyticsAttributes, action: action, actionSubject: actionSubject = $623688ff325eecfa$var$DEFAULT_ACTION_SUBJECT })=>{
        if (event === 'operational') {
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), `${actionSubject} ${action}`, analyticsAttributes);
            return;
        }
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), `${actionSubject} ${action}`, analyticsAttributes);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAtlasProjectAnalyticsEvent: fireAtlasProjectAnalyticsEvent
    };
};

});


parcelRegister("4vHFI", function(module, exports) {
$parcel$export(module.exports, "INLINE_EDIT_ANALYTICS_ATTRIBUTES", () => $91288825d5f914de$export$a659dfe9528cfc57);
// Attributes for inline editing track events
const $91288825d5f914de$export$a659dfe9528cfc57 = {
    // If the update was made inline (and not via the issue view)
    isInlineEditing: true
};

});


parcelRegister("1iVG2", function(module, exports) {
$parcel$export(module.exports, "LoadingCell", () => $be7d804ab43d5c91$export$5191481abee8295e);

var $eJOHy = parcelRequire("eJOHy");

var $1DXK0 = parcelRequire("1DXK0");

var $jjS5D = parcelRequire("jjS5D");

var $4cTDP = parcelRequire("4cTDP");

var $bKlUQ = parcelRequire("bKlUQ");
const $be7d804ab43d5c91$export$5191481abee8295e = ({ cellBorder: cellBorder, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, hasRightShadow: hasRightShadow })=>{
    const cellBorderStylesFg = (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $be7d804ab43d5c91$var$cellBorderStyles : $be7d804ab43d5c91$var$cellBorderStylesOld;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        border: cellBorder ?? cellBorderStylesFg,
        isColumnSticky: isColumnSticky,
        stickyOffsets: stickyOffsets,
        hasRightShadow: hasRightShadow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        testId: "native-issue-table.common.ui.issue-cells.loading-cell",
        height: "16px",
        width: "100%",
        borderRadius: "3px"
    }));
};
const $be7d804ab43d5c91$var$cellBorderStylesOld = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderBottomWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderLeftWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightWidth: 'border.width'
});
const $be7d804ab43d5c91$var$cellBorderStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderBlockStartWidth: '0',
    borderBlockEndWidth: 'border.width',
    borderInlineStartWidth: '0',
    borderInlineEndWidth: 'border.width'
});

});

parcelRegister("9ZBXb", function(module, exports) {
$parcel$export(module.exports, "CheckboxSelectCell", () => $0c9ab47539bc080b$export$1fd5a9db1fedc6bb);

var $d54gp = parcelRequire("d54gp");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4l5Js = parcelRequire("4l5Js");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $0c9ab47539bc080b$export$1fd5a9db1fedc6bb = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $d54gp.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4l5Js.CheckboxSelectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $0c9ab47539bc080b$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        isTruncated: true,
        isSingleLineRowHeightEnabled: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4l5Js.CheckboxSelectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        menuPosition: "fixed",
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isTruncated: true,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
    });
};
const $0c9ab47539bc080b$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $0c9ab47539bc080b$var$customTargetStyles : $0c9ab47539bc080b$var$customTargetStylesOld,
        ref: ref
    });
});
const $0c9ab47539bc080b$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $0c9ab47539bc080b$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("d54gp", function(module, exports) {
$parcel$export(module.exports, "default", () => $2caa3849901f255e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<79139860b4500454d765dbfc4a21186e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2caa3849901f255e$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "CheckboxSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraCheckboxesField"
};
$2caa3849901f255e$var$node.hash = "c8b91de26aff0acbf897cc9f413e2f3a";
var $2caa3849901f255e$export$2e2bcd8739ae039 = $2caa3849901f255e$var$node;

});

parcelRegister("4l5Js", function(module, exports) {
$parcel$export(module.exports, "CheckboxSelectInlineEditViewWithIsEditable", () => $d58acf5f3ab7c8b2$export$1b3be05b9a6273f2);
$parcel$export(module.exports, "CheckboxSelectInlineEditView", () => $d58acf5f3ab7c8b2$export$110d4fbf3ef97d6);

var $72tu6 = parcelRequire("72tu6");

var $4eDqi = parcelRequire("4eDqi");

var $fZC4X = parcelRequire("fZC4X");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $8Y7vF = parcelRequire("8Y7vF");

var $ifQgt = parcelRequire("ifQgt");

var $auNLL = parcelRequire("auNLL");
const $d58acf5f3ab7c8b2$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-checkbox-select-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $d58acf5f3ab7c8b2$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.value));
    return b.every((option)=>aIdSet.has(option.value));
};
const $d58acf5f3ab7c8b2$export$1b3be05b9a6273f2 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupTarget: editViewPopupTarget, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled })=>{
    const data = (0, $j4oe4.useFragment)((0, $fZC4X.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $4eDqi.default));
    const { id: uniqueFieldId, name: name, selectedOptions: selectedOptions, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedOptions?.edges) return null;
        return selectedOptions.edges.map((edge)=>({
                value: edge?.node?.id ?? '',
                label: edge?.node?.value ?? ''
            }));
    }, [
        selectedOptions?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.value) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateCheckboxesField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateCheckboxesField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedOptions: {
                                edges: values?.map((edge)=>({
                                        node: {
                                            id: edge.value ?? '',
                                            value: edge.label ?? ''
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $d58acf5f3ab7c8b2$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'checkboxSelect'
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d58acf5f3ab7c8b2$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ifQgt.CheckboxSelectReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            isHoverPopoverEnabled: isSingleLineRowHeightEnabled
        })), [
        data,
        isTruncated,
        isSingleLineRowHeightEnabled
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            fetchSuggestionsOnMount: true,
            spacing: spacing
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $8Y7vF.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled
    });
};
const $d58acf5f3ab7c8b2$export$110d4fbf3ef97d6 = ({ fragmentRef: fragmentRef, ...props })=>{
    /**
   * This fragment should spread the inner InlineEditViewWithIsEditable fragment and read the isEditable flag from the
   * fieldConfig.
   */ const data = (0, $j4oe4.useFragment)((0, $72tu6.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d58acf5f3ab7c8b2$export$1b3be05b9a6273f2, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("72tu6", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b7b45e414c57296$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<865dcb3c94a5735613636474e65b5c54>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7b7b45e414c57296$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraCheckboxesField"
};
$7b7b45e414c57296$var$node.hash = "578907f93847166d177912bba783cc44";
var $7b7b45e414c57296$export$2e2bcd8739ae039 = $7b7b45e414c57296$var$node;

});

parcelRegister("4eDqi", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a55ba8d8d66f9f0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a674bc11003d5a4f6042bd041448c62>>
 * @relayHash 2f2935fb2f2e43d33d4c8ed1e1b2cd67
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8540386bf8ddcde1b4f569318aad611087a8b356d205fa2274ec5675ba438f8e
const $6a55ba8d8d66f9f0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "checkboxSelect_issueFieldCheckboxSelect_CheckboxSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCheckboxesFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCheckboxesField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCheckboxesField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "checkboxSelect_issueFieldCheckboxSelect_CheckboxSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCheckboxesFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCheckboxesField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCheckboxesField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedOptions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOptionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8540386bf8ddcde1b4f569318aad611087a8b356d205fa2274ec5675ba438f8e",
            "metadata": {},
            "name": "checkboxSelect_issueFieldCheckboxSelect_CheckboxSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$6a55ba8d8d66f9f0$var$node.hash = "8471c6b898ae5a82094ee733778542d4";
var $6a55ba8d8d66f9f0$export$2e2bcd8739ae039 = $6a55ba8d8d66f9f0$var$node;

});

parcelRegister("fZC4X", function(module, exports) {
$parcel$export(module.exports, "default", () => $63c1a21d2203c5f7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4e85c1b6294972f8a4727536d560cd70>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $63c1a21d2203c5f7$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "checkboxSelect_issueFieldCheckboxSelectReadviewFull_CheckboxSelectReadView"
            },
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCheckboxesField"
    };
}();
$63c1a21d2203c5f7$var$node.hash = "949a32b9c93f1898a846b4634eca9e93";
var $63c1a21d2203c5f7$export$2e2bcd8739ae039 = $63c1a21d2203c5f7$var$node;

});

parcelRegister("8Y7vF", function(module, exports) {
$parcel$export(module.exports, "default", () => $76c3753d64a477f9$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $76c3753d64a477f9$var$CheckboxSelectEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("izioT")), {
        moduleId: "6225fccd",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $76c3753d64a477f9$export$2e2bcd8739ae039 = $76c3753d64a477f9$var$CheckboxSelectEditViewEntryPoint;

});
parcelRegister("izioT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("561TQ").then(()=>parcelRequire('cg7du'));

});


parcelRegister("ifQgt", function(module, exports) {
$parcel$export(module.exports, "CheckboxSelectReadView", () => $660041d08f4602e0$export$9aaea694d3042383);

var $jVxed = parcelRequire("jVxed");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $ewOxf = parcelRequire("ewOxf");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $fI7RQ = parcelRequire("fI7RQ");
const $660041d08f4602e0$export$9aaea694d3042383 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated, isHoverPopoverEnabled: isHoverPopoverEnabled })=>{
    const data = (0, $j4oe4.useFragment)((0, $jVxed.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const selectedOptions = data?.selectedOptions?.edges?.filter((edge)=>Boolean(edge?.node?.value)).map((edge)=>({
            name: edge?.node?.value || '',
            key: edge?.node?.id || ''
        })) || [];
    if (!selectedOptions?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        xcss: isHoverPopoverEnabled && $660041d08f4602e0$var$widthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: selectedOptions,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $fI7RQ.default).showMoreTooltip),
        isHoverPopoverEnabled: isHoverPopoverEnabled
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $660041d08f4602e0$var$containerWithNegativeMarginOffset
    }, selectedOptions.map((value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
            key: value.key,
            text: value.name
        })));
};
const $660041d08f4602e0$var$containerWithNegativeMarginOffset = (0, $1DXK0.xcss)({
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    // Tag has a built-in margin of 4px, so we use a negative side margin to allow tags to align with their parent.
    marginTop: 'space.0',
    marginRight: 'space.negative.050',
    marginBottom: 'space.0',
    marginLeft: 'space.negative.050'
});
const $660041d08f4602e0$var$widthStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("jVxed", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e63bc5f47a25054$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e66798db69b7174dc3e67181cb94bce4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2e63bc5f47a25054$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "checkboxSelect_issueFieldCheckboxSelectReadviewFull_CheckboxSelectReadView",
    "selections": [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraCheckboxesField"
};
$2e63bc5f47a25054$var$node.hash = "d4b0ebe1c72d70b5bd1191947a37e196";
var $2e63bc5f47a25054$export$2e2bcd8739ae039 = $2e63bc5f47a25054$var$node;

});

parcelRegister("fI7RQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $178b1865ab14869a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $178b1865ab14869a$var$messages = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-checkbox-select-readview-full.checkbox-select.truncated.show-more-tooltip",
        "defaultMessage": "See more items"
    }
});
var $178b1865ab14869a$export$2e2bcd8739ae039 = $178b1865ab14869a$var$messages;

});




parcelRegister("1pe67", function(module, exports) {
$parcel$export(module.exports, "CmdbObjectsCell", () => $bb7d4c8fd6edd603$export$eebc6db46b17b7b3);

var $lDKtD = parcelRequire("lDKtD");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $bYOuG = parcelRequire("bYOuG");

var $P01So = parcelRequire("P01So");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");

var $lIbdr = parcelRequire("lIbdr");

var $aVDPt = parcelRequire("aVDPt");
const $bb7d4c8fd6edd603$var$CELL_TYPE = 'cmdbObjects';
const $bb7d4c8fd6edd603$export$eebc6db46b17b7b3 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $lDKtD.default), fieldRef);
    const errors = data?.selectedCmdbObjectsConnection?.errors?.map((error)=>error?.message);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (errors?.length) // At time of writing, these errors are not wired up on the issue backend. However we will maintain this
    // logging so that it is present if/when it is wired up so we can get error information immediately.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: $bb7d4c8fd6edd603$var$CELL_TYPE,
        reason: `Errors present: ${errors.length} - ${errors.join(', ')}; Edges present: ${data?.selectedCmdbObjectsConnection?.edges?.length}`
    });
    const objects = data?.selectedCmdbObjectsConnection?.edges;
    const filteredObjectsWithMedia = objects?.map((edge)=>{
        if (!edge?.node?.label) return null;
        let mediaImage;
        const iconUrl = edge.node.avatar?.url48 ?? undefined;
        if (edge.node.avatar?.mediaClientConfig?.clientId && edge.node.avatar?.mediaClientConfig?.fileId && edge.node.avatar?.mediaClientConfig?.mediaBaseUrl && edge.node.avatar?.mediaClientConfig?.mediaJwtToken) {
            const identifier = {
                id: edge.node.avatar.mediaClientConfig.fileId,
                mediaItemType: 'file'
            };
            const clientBasedAuth = {
                clientId: edge.node.avatar.mediaClientConfig.clientId,
                token: edge.node.avatar.mediaClientConfig.mediaJwtToken,
                baseUrl: edge.node.avatar.mediaClientConfig.mediaBaseUrl
            };
            const mediaClientConfig = {
                authProvider: ()=>Promise.resolve(clientBasedAuth)
            };
            mediaImage = {
                identifier: identifier,
                mediaClientConfig: mediaClientConfig
            };
        }
        return {
            key: edge.node.objectId || 'missingId',
            name: edge.node.label,
            href: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $bYOuG.createObjectDetailUrl)(edge.node.objectId || '') : (0, $lIbdr.createObjectDetailUrl)(edge.node.objectId || ''),
            icon: {
                url: !mediaImage ? iconUrl : undefined,
                mediaImage: mediaImage
            }
        };
    }).filter((0, $P01So.isNonNullish)) ?? [];
    if (!objects || objects.length !== filteredObjectsWithMedia.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: $bb7d4c8fd6edd603$var$CELL_TYPE,
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: filteredObjectsWithMedia,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $aVDPt.default).triggerButton),
        isHoverPopoverEnabled: isSingleLineRowHeightEnabled && !isReadOnlyWithoutHoverPopover
    });
});

});
parcelRegister("lDKtD", function(module, exports) {
$parcel$export(module.exports, "default", () => $d498c98ed994da84$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a781bd8aa19ad1604b8c0ca03d22f712>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d498c98ed994da84$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "CmdbObjectsCell",
    "selections": [
        {
            "concreteType": "JiraCmdbObjectConnection",
            "kind": "LinkedField",
            "name": "selectedCmdbObjectsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraCmdbObjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraCmdbObject",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "objectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "label"
                                },
                                {
                                    "concreteType": "JiraCmdbAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCmdbMediaClientConfig",
                                            "kind": "LinkedField",
                                            "name": "mediaClientConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "clientId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fileId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "mediaBaseUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "mediaJwtToken"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "url48"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraCMDBField"
};
$d498c98ed994da84$var$node.hash = "62b9469a8713e4f595123c2f627a6aec";
var $d498c98ed994da84$export$2e2bcd8739ae039 = $d498c98ed994da84$var$node;

});

parcelRegister("lIbdr", function(module, exports) {
$parcel$export(module.exports, "createObjectDetailUrl", () => $4bcc9ec1645a5953$export$51e4229f2c7d3866);
// Hardcoded values from @atlassian/jira-servicedesk-insight-urls
const $4bcc9ec1645a5953$var$ASSETS_ROUTE_PREFIX = '/jira/servicedesk/assets';
const $4bcc9ec1645a5953$export$51e4229f2c7d3866 = (objectId)=>`${$4bcc9ec1645a5953$var$ASSETS_ROUTE_PREFIX}/object/${objectId}`;

});

parcelRegister("aVDPt", function(module, exports) {
$parcel$export(module.exports, "default", () => $8748f15801c24aca$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8748f15801c24aca$var$messages = (0, $7qGN1.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.cmdb-objects.trigger-button",
        "defaultMessage": "See more assets"
    }
});
var $8748f15801c24aca$export$2e2bcd8739ae039 = $8748f15801c24aca$var$messages;

});


parcelRegister("g3S5f", function(module, exports) {
$parcel$export(module.exports, "ComponentsInlineEditCell", () => $02df092dfe81a3d5$export$b3c67e48ecea06e4);

var $jUaY3 = parcelRequire("jUaY3");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $f26C8 = parcelRequire("f26C8");
var $jPlb3 = parcelRequire("jPlb3");
var $1jiqw = parcelRequire("1jiqw");

var $ho4SO = parcelRequire("ho4SO");

var $P01So = parcelRequire("P01So");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");
/**
 * Expected JQL Output: `project = ${projectKey} AND ${jqlTerm} = ${name}`
 */ const $02df092dfe81a3d5$var$getLinkJql = (projectKey, jqlTerm, name)=>{
    const jast = (0, $f26C8.default).jast((0, $f26C8.default).query((0, $f26C8.default).compoundClause((0, $f26C8.default).compoundOperator((0, $f6415dda43b7f459$export$6d6d48d210d3ca97)), [
        (0, $f26C8.default).terminalClause((0, $f26C8.default).field('project'), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)), (0, $f26C8.default).valueOperand(projectKey)),
        (0, $f26C8.default).terminalClause((0, $f26C8.default).field((0, $P01So.escapeBackslashes)(jqlTerm)), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)), (0, $f26C8.default).valueOperand((0, $P01So.escapeBackslashes)(name)))
    ])));
    return (0, $1jiqw.print)(jast, {
        operatorCase: 'upper'
    });
};
const $02df092dfe81a3d5$export$b3c67e48ecea06e4 = ({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, jqlTerm: jqlTerm, projectKey: projectKey })=>{
    const data = (0, $j4oe4.useFragment)((0, $jUaY3.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const formatComponentJql = (0, $eJOHy.useCallback)((componentName)=>$02df092dfe81a3d5$var$getLinkJql(projectKey, jqlTerm, componentName), [
        jqlTerm,
        projectKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ho4SO.ComponentsInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        baseSearchUrl: issueSearchBaseUrl,
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        formatComponentJql: formatComponentJql,
        fragmentRef: data,
        isTruncated: true,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncatedWithHoverPopover: isSingleLineRowHeightEnabled
    });
};

});
parcelRegister("jUaY3", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5aeb39b1c72905c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e33b0850f20d78ac500bca95b6a39f05>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a5aeb39b1c72905c$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "ComponentsCell_ComponentsInlineEditCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraComponentsField"
};
$a5aeb39b1c72905c$var$node.hash = "039baef83cb8ffecbd5b697cd1ab09e0";
var $a5aeb39b1c72905c$export$2e2bcd8739ae039 = $a5aeb39b1c72905c$var$node;

});

const $f6415dda43b7f459$export$6d6d48d210d3ca97 = 'and';
const $f6415dda43b7f459$export$7b8f0a728d79a753 = 'or';

parcelRegister("ho4SO", function(module, exports) {
$parcel$export(module.exports, "ComponentsInlineEditViewWithIsEditable", () => $699cbb166c13207d$export$32ccb5f0cb497709);
$parcel$export(module.exports, "ComponentsInlineEditView", () => $699cbb166c13207d$export$bbb45a0e0da9bd53);

var $70onb = parcelRequire("70onb");

var $gEQfR = parcelRequire("gEQfR");

var $7mPEs = parcelRequire("7mPEs");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $lCtpC = parcelRequire("lCtpC");

var $5SZDT = parcelRequire("5SZDT");

var $auNLL = parcelRequire("auNLL");
const $699cbb166c13207d$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-components-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $699cbb166c13207d$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.value));
    return b.every((option)=>aIdSet.has(option.value));
};
const $699cbb166c13207d$export$32ccb5f0cb497709 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, baseSearchUrl: baseSearchUrl, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncatedWithHoverPopover: isTruncatedWithHoverPopover, formatComponentJql: formatComponentJql })=>{
    const data = (0, $j4oe4.useFragment)((0, $7mPEs.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $gEQfR.default));
    const { id: uniqueFieldId, name: name, selectedComponentsConnection: selectedOptions, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedOptions?.edges) return null;
        return selectedOptions.edges.map((edge)=>({
                value: edge?.node?.value ?? '',
                label: edge?.node?.label ?? ''
            }));
    }, [
        selectedOptions?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.value) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateComponentsField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateComponentsField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedComponentsConnection: {
                                edges: values?.map((edge)=>({
                                        node: {
                                            id: edge.value ?? '',
                                            label: edge.label ?? '',
                                            value: edge.value ?? ''
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChange: handleChange } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $699cbb166c13207d$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'components'
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($699cbb166c13207d$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5SZDT.ComponentsReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            baseSearchUrl: baseSearchUrl,
            isTruncatedWithHoverPopover: isTruncatedWithHoverPopover,
            formatComponentJql: formatComponentJql
        })), [
        data,
        baseSearchUrl,
        isTruncated,
        isTruncatedWithHoverPopover,
        formatComponentJql
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    (values, actionMeta)=>{
        const mutableOptions = values?.map((i)=>({
                label: i.label,
                value: i.value || ''
            })) || null;
        handleChange(mutableOptions);
    }, [
        handleChange
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleOnChange,
            fetchSuggestionsOnMount: true,
            spacing: spacing
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $lCtpC.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isTruncatedWithHoverPopover
    });
};
const $699cbb166c13207d$export$bbb45a0e0da9bd53 = ({ fragmentRef: fragmentRef, ...props })=>{
    /**
   * This fragment should spread the inner InlineEditViewWithIsEditable fragment and read the isEditable flag from the
   * fieldConfig.
   */ const data = (0, $j4oe4.useFragment)((0, $70onb.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($699cbb166c13207d$export$32ccb5f0cb497709, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("70onb", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf8cc1ba6eaf1d06$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d752273960d62c97543fd5c98cc9b483>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cf8cc1ba6eaf1d06$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraComponentsField"
};
$cf8cc1ba6eaf1d06$var$node.hash = "616223369097ff7023289b730e24e390";
var $cf8cc1ba6eaf1d06$export$2e2bcd8739ae039 = $cf8cc1ba6eaf1d06$var$node;

});

parcelRegister("gEQfR", function(module, exports) {
$parcel$export(module.exports, "default", () => $85603605741a612c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a287f8603250d4bcfa340f08a133c0c>>
 * @relayHash 7fdc4a8b53b49ddfa954865ceb36f19e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 37d268d7e189244c2485e7f63d82c6610aa4201a00aec643ec30383b07b411b3
const $85603605741a612c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "components_issueFieldComponents_ComponentsField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraComponentsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateComponentsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraComponentsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "components_issueFieldComponents_ComponentsField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraComponentsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateComponentsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraComponentsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000
                                                }
                                            ],
                                            "concreteType": "JiraComponentConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedComponentsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraComponentEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraComponent",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": "value",
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                },
                                                                {
                                                                    "alias": "label",
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "37d268d7e189244c2485e7f63d82c6610aa4201a00aec643ec30383b07b411b3",
            "metadata": {},
            "name": "components_issueFieldComponents_ComponentsField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$85603605741a612c$var$node.hash = "55d6de75b11bbe1bea570947ba244198";
var $85603605741a612c$export$2e2bcd8739ae039 = $85603605741a612c$var$node;

});

parcelRegister("7mPEs", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e081dc4c99718dd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<176cf950f3063d94accb5a37ad63e7ce>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2e081dc4c99718dd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "FragmentSpread",
            "name": "components_issueFieldComponentsReadviewFull_ComponentsReadView"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "value",
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "alias": "label",
                                        "kind": "ScalarField",
                                        "name": "name"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            "action": "THROW",
            "path": "selectedComponentsConnection"
        }
    ],
    "type": "JiraComponentsField"
};
$2e081dc4c99718dd$var$node.hash = "7d58e8d795b9134c31920723b434efe7";
var $2e081dc4c99718dd$export$2e2bcd8739ae039 = $2e081dc4c99718dd$var$node;

});

parcelRegister("lCtpC", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2539dfc09599984$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $d2539dfc09599984$var$ComponentsEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("7I5QK")), {
        moduleId: "09bac631",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $d2539dfc09599984$export$2e2bcd8739ae039 = $d2539dfc09599984$var$ComponentsEditViewEntryPoint;

});
parcelRegister("7I5QK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dXOpn").then(()=>parcelRequire('kb00V'));

});


parcelRegister("5SZDT", function(module, exports) {
$parcel$export(module.exports, "ComponentsReadView", () => $e07554ca3e796e3f$export$1841519927c4fa28);

var $7HKm7 = parcelRequire("7HKm7");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $ar6fB = parcelRequire("ar6fB");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $bnIBr = parcelRequire("bnIBr");

var $caakL = parcelRequire("caakL");
const $e07554ca3e796e3f$export$e2150facc9f107aa = (componentName)=>`component = ${(0, $bnIBr.toQuotedString)(componentName)}`;
const $e07554ca3e796e3f$export$12458b8497b0a890 = (componentJql, baseSearchUrl = '/issues/')=>`${baseSearchUrl}?jql=${encodeURIComponent(componentJql)}`;
const $e07554ca3e796e3f$export$1841519927c4fa28 = ({ baseSearchUrl: baseSearchUrl, fragmentRef: fragmentRef, isTruncated: isTruncated, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover, formatComponentJql: formatComponentJql = $e07554ca3e796e3f$export$e2150facc9f107aa })=>{
    const data = (0, $j4oe4.useFragment)((0, $7HKm7.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const selectedComponents = data?.selectedComponentsConnection?.edges?.filter((edge)=>Boolean(edge?.node?.label)).map((item)=>{
        const href = item?.node?.label ? $e07554ca3e796e3f$export$12458b8497b0a890(formatComponentJql(item?.node?.label), baseSearchUrl) : undefined;
        return {
            name: item?.node?.label || '',
            key: item?.node?.value || '',
            href: href
        };
    }) || [];
    if (!selectedComponents?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        xcss: isTruncatedWithHoverPopover && $e07554ca3e796e3f$var$widthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: selectedComponents,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $caakL.default).showMoreTooltip),
        isHoverPopoverEnabled: isTruncatedWithHoverPopover
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $e07554ca3e796e3f$var$containerWithNegativeMarginOffset
    }, selectedComponents.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ar6fB.default), {
            key: item.key,
            isRemovable: false,
            text: item.name,
            href: item.href
        })));
};
const $e07554ca3e796e3f$var$containerWithNegativeMarginOffset = (0, $1DXK0.xcss)({
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    // Tag has a built-in margin of 4px, so we use a negative side margin to allow tags to align with their parent.
    marginTop: 'space.0',
    marginRight: 'space.negative.050',
    marginBottom: 'space.0',
    marginLeft: 'space.negative.050'
});
const $e07554ca3e796e3f$var$widthStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("7HKm7", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d04b681ada86739$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<309f4d62bd850a58613b75bc1e5b17ac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5d04b681ada86739$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "components_issueFieldComponentsReadviewFull_ComponentsReadView",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "value",
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "alias": "label",
                                        "kind": "ScalarField",
                                        "name": "name"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            "action": "THROW",
            "path": "selectedComponentsConnection"
        }
    ],
    "type": "JiraComponentsField"
};
$5d04b681ada86739$var$node.hash = "35b9643b76a914d7422dfb3f74901db8";
var $5d04b681ada86739$export$2e2bcd8739ae039 = $5d04b681ada86739$var$node;

});

parcelRegister("ar6fB", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bf2340f5bdb4d38$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $315a7 = parcelRequire("315a7");

var $gyJTO = parcelRequire("gyJTO");

var $3Vuhz = parcelRequire("3Vuhz");

var $Ys7jv = parcelRequire("Ys7jv");
var $lncqW = parcelRequire("lncqW");

var $1fStw = parcelRequire("1fStw");

var $40nZT = parcelRequire("40nZT");

var $6UE2q = parcelRequire("6UE2q");

var $h89xH = parcelRequire("h89xH");
const $7bf2340f5bdb4d38$var$textLinkCssVar = '--ds-ctl';
const $7bf2340f5bdb4d38$var$textDefaultCssVar = '--ds-ct';
const $7bf2340f5bdb4d38$var$textActiveCssVar = '--ds-ctp';
const $7bf2340f5bdb4d38$var$backgroundHoverCssVar = '--ds-cbh';
const $7bf2340f5bdb4d38$var$backgroundActiveCssVar = '--ds-cba';
var $7bf2340f5bdb4d38$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($7bf2340f5bdb4d38$var$TagStatus || {});
const $7bf2340f5bdb4d38$var$packageName = "platform-pkg";
const $7bf2340f5bdb4d38$var$packageVersion = "0.0.0-use.local";
const $7bf2340f5bdb4d38$var$defaultBeforeRemoveAction = ()=>true; /**
                                               * These hide the focus ring for the tag when its remove button is focused,
                                               * preventing a double focus ring.
                                               */ 
const $7bf2340f5bdb4d38$var$removingStyles = null;
const $7bf2340f5bdb4d38$var$RemovableTagComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $7bf2340f5bdb4d38$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $3Vuhz.default), linkComponent: linkComponent }, ref)=>{
    const [status, setStatus] = (0, $eJOHy.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $eJOHy.useState)(false);
    const onAfterRemoveActionWithAnalytics = (0, $315a7.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $7bf2340f5bdb4d38$var$packageName,
            packageVersion: $7bf2340f5bdb4d38$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $eJOHy.useCallback)(()=>{
        onAfterRemoveActionWithAnalytics(text);
        setStatus("removed");
    }, [
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    const handleRemoveRequest = (0, $eJOHy.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $eJOHy.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $eJOHy.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $eJOHy.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $eJOHy.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $eJOHy.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h89xH.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${text}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined;
    const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6UE2q.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
        // Tag background color on hover
        [$7bf2340f5bdb4d38$var$backgroundHoverCssVar]: undefined,
        // Tag background color on press
        [$7bf2340f5bdb4d38$var$backgroundActiveCssVar]: undefined,
        // The tag text on hover of remove button
        [$7bf2340f5bdb4d38$var$textDefaultCssVar]: undefined,
        // 'elemBefore' text on press of remove button
        [$7bf2340f5bdb4d38$var$textActiveCssVar]: undefined,
        // The tag link text on hover of remove button
        [$7bf2340f5bdb4d38$var$textLinkCssVar]: undefined
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ys7jv.default), {
        children: !(status === "removed") && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lncqW.default), {
            children: (motion)=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1fStw.default), {
                    ref: (0, $gyJTO.default)([
                        motion.ref,
                        ref
                    ]),
                    appearance: appearance,
                    color: color,
                    testId: testId,
                    style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
                    "data-removable": true,
                    "data-removing": status === "removing",
                    "data-ishoverclosebutton": isHoverCloseButton,
                    href: href,
                    before: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $40nZT.default), {
                        elemBefore: elemBefore
                    }),
                    contentElement: content,
                    after: removeButton,
                    className: (0, $hcewu.default)([
                        status === "removing" && "_z30c1r31 _twwiglyw _1pka1o36 _bqht1nip"
                    ])
                });
            }
        })
    });
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $7bf2340f5bdb4d38$var$RemovableTag = /*#__PURE__*/ (0, $eJOHy.memo)($7bf2340f5bdb4d38$var$RemovableTagComponent);
var $7bf2340f5bdb4d38$export$2e2bcd8739ae039 = $7bf2340f5bdb4d38$var$RemovableTag;

});
parcelRegister("lncqW", function(module, exports) {
$parcel$export(module.exports, "default", () => $10f384baaa61acd2$export$2e2bcd8739ae039);

var $34ZNB = parcelRequire("34ZNB");

var $gcrIE = parcelRequire("gcrIE");

var $grWPV = parcelRequire("grWPV");

var $5mfrv = parcelRequire("5mfrv");

var $Ys7jv = parcelRequire("Ys7jv");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $10f384baaa61acd2$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $grWPV.useElementRef)();
    const exiting = (0, $Ys7jv.useExitingPersistence)();
    const requestAnimationFrame = (0, $gcrIE.useRequestAnimationFrame)();
    const setTimeout = (0, $gcrIE.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $5mfrv.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $34ZNB.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $34ZNB.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $10f384baaa61acd2$export$2e2bcd8739ae039 = $10f384baaa61acd2$var$ShrinkOut;

});

parcelRegister("h89xH", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebeaa36c6c332ef4$export$2e2bcd8739ae039);
/* remove-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $5wxTT = parcelRequire("5wxTT");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");
const $ebeaa36c6c332ef4$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i7vkz _1bsb7vkz _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhk1w7a _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah31i6y _irr31dpa _1di6fcek"
};
const $ebeaa36c6c332ef4$var$removeButtonStylesOldIcon = {
    root: "_rjxpze3t"
};
const $ebeaa36c6c332ef4$var$removeButtonStylesNewIcon = {
    root: "_rjxpv77o"
};
const $ebeaa36c6c332ef4$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        xcss: (0, $6qaBj.cx)($ebeaa36c6c332ef4$var$removeButtonStyles.root, $ebeaa36c6c332ef4$var$removeButtonStylesOldIcon.root, (0, $eGOwo.fg)('platform-visual-refresh-icons') && $ebeaa36c6c332ef4$var$removeButtonStylesNewIcon.root),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        testId: testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5wxTT))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "small",
            size: "small"
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ebeaa36c6c332ef4$export$2e2bcd8739ae039 = $ebeaa36c6c332ef4$var$RemoveButton;

});


parcelRegister("bnIBr", function(module, exports) {
$parcel$export(module.exports, "toQuotedString", () => $a183e8d5995c289a$export$dbeab020a4aa404);
$parcel$export(module.exports, "createProjectAllWorkUri", () => $a183e8d5995c289a$export$497544a08e0b5e51);
$parcel$export(module.exports, "createAllWorkUrl", () => $a183e8d5995c289a$export$ca075a1255c9a76d);

var $4cTDP = parcelRequire("4cTDP");
const $a183e8d5995c289a$var$ENCODE_MAP = {
    '\t': '\\t',
    '\n': '\\n',
    '\r': '\\r',
    '"': '\\"',
    "'": "\\'",
    '\\': '\\\\'
};
const $a183e8d5995c289a$export$946fe289c25510be = (character, ignoredCharacter)=>{
    if (character === ignoredCharacter) return character;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly '\t': "\\t"; readonly '\n': "\\n"; readonly '\r': "\\r"; readonly '"': "\\\""; readonly "'": "\\'"; readonly '\\': "\\\\"; }'.
    return $a183e8d5995c289a$var$ENCODE_MAP[character] || character;
};
const $a183e8d5995c289a$export$dbeab020a4aa404 = (parameter)=>{
    let escaped = '';
    for(let position = 0; position < parameter.length; position += 1)escaped += $a183e8d5995c289a$export$946fe289c25510be(parameter[position], "'");
    return `"${escaped}"`;
};
const $a183e8d5995c289a$export$497544a08e0b5e51 = (jql)=>(0, $4cTDP.fg)('jira_list_nin_merge') ? `/list/?jql=${encodeURIComponent(jql)}` : `/issues/?jql=${encodeURIComponent(jql)}`;
const $a183e8d5995c289a$export$ca075a1255c9a76d = (jql)=>`/issues/?jql=${encodeURIComponent(jql)}`;

});

parcelRegister("caakL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6b87dd9236836a3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c6b87dd9236836a3$var$messages = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-components-readview-full.components.truncated.show-more-tooltip",
        "defaultMessage": "See more items"
    }
});
var $c6b87dd9236836a3$export$2e2bcd8739ae039 = $c6b87dd9236836a3$var$messages;

});




parcelRegister("wJcwZ", function(module, exports) {
$parcel$export(module.exports, "CascadingSelectCell", () => $4a8feacfce5feb7b$export$4f505fdc26f544f5);

var $cw2gd = parcelRequire("cw2gd");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $alVoT = parcelRequire("alVoT");

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");

var $8jOO7 = parcelRequire("8jOO7");
const $4a8feacfce5feb7b$export$4f505fdc26f544f5 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $cw2gd.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const shouldRenderHoverPopover = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && shouldRenderHoverPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alVoT.CascadingSelectInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $4a8feacfce5feb7b$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        isTruncated: true,
        shouldRenderHoverPopover: isFirstField && shouldRenderHoverPopover
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alVoT.CascadingSelectInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: $4a8feacfce5feb7b$var$CustomTarget,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        menuPosition: "fixed",
        isTruncated: true,
        shouldRenderHoverPopover: shouldRenderHoverPopover
    });
};
const $4a8feacfce5feb7b$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $4a8feacfce5feb7b$var$customTargetStyles : $4a8feacfce5feb7b$var$customTargetStylesOld,
        ref: ref
    });
});
const $4a8feacfce5feb7b$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: '0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $4a8feacfce5feb7b$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: '0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("cw2gd", function(module, exports) {
$parcel$export(module.exports, "default", () => $0830a6095eb9629d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6ebb0f7e5de3e0258d4718e93a459f4b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0830a6095eb9629d$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "CascadingSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraCascadingSelectField"
};
$0830a6095eb9629d$var$node.hash = "1112734932f045893d2130ef6f9132f5";
var $0830a6095eb9629d$export$2e2bcd8739ae039 = $0830a6095eb9629d$var$node;

});

parcelRegister("alVoT", function(module, exports) {
$parcel$export(module.exports, "CascadingSelectInlineEditViewIsEditable", () => $a381d2d31fb89055$export$d3164c915fdde2ef);
$parcel$export(module.exports, "CascadingSelectInlineEditView", () => $a381d2d31fb89055$export$c72b86275efea41a);

var $67xrj = parcelRequire("67xrj");

var $gOIjY = parcelRequire("gOIjY");

var $dzO3b = parcelRequire("dzO3b");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $9j9do = parcelRequire("9j9do");

var $99gun = parcelRequire("99gun");

var $dG41I = parcelRequire("dG41I");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $tYLUh = parcelRequire("tYLUh");
const $a381d2d31fb89055$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-cascading-select-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment)); /** Check if the new selected value is equal to the old value */ 
const $a381d2d31fb89055$var$isEqualSelection = (a, b)=>a?.parentOptionValue?.value === b?.parentOptionValue?.value && a?.childOptionValue?.value === b?.childOptionValue?.value;
const $a381d2d31fb89055$var$EditViewWrapper = ({ children: children })=>{
    // This needs to be fixed by DST: go/DSP-22083
    // Dropdown z-index is 1, action bar is 200
    // Bento fixes this by wrapping dropdown into a new 300 stack context
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $a381d2d31fb89055$var$wrapperStyles
    }, children);
}; /**
    * Inline edit will handle the switching behaviour between the 'readView' and 'editView' components.
    *
    * @param props [CascadingSelectInlineEditViewProps](./types.tsx)
    */ 
const $a381d2d31fb89055$export$d3164c915fdde2ef = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, readViewFitContainerHeight: readViewFitContainerHeight, hideActionButtons: hideActionButtons = false, menuPosition: menuPosition, fragmentRef: fragmentRef, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, spacing: spacing = 'default', isTruncated: isTruncated = false, isEditable: isEditable = false, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)(); // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $dzO3b.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $gOIjY.default));
    const { id: uniqueFieldId, cascadingOption: cascadingOption, name: name, fieldId: fieldId, type: fieldType } = data; // #endregion
    // #region State
    const initialValue = (0, $eJOHy.useMemo)(()=>({
            parentOptionValue: cascadingOption?.parentOptionValue ? {
                id: cascadingOption?.parentOptionValue?.id ?? '',
                value: cascadingOption?.parentOptionValue?.value ?? '',
                isDisabled: cascadingOption?.parentOptionValue?.isDisabled
            } : null,
            childOptionValue: cascadingOption?.childOptionValue ? {
                id: cascadingOption?.childOptionValue?.id ?? '',
                value: cascadingOption?.childOptionValue?.value ?? '',
                isDisabled: cascadingOption?.childOptionValue?.isDisabled
            } : null
        }), [
        cascadingOption?.childOptionValue,
        cascadingOption?.parentOptionValue
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]); // #endregion
    // #region Action
    const handleSubmit = (0, $eJOHy.useCallback)((newOption, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newOption); // note: If these objects happen to include more than what is expected, Relay will complain.
        const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = newOption || {};
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        parentOption: parentOptionValue?.id || null,
                        childOption: childOptionValue?.id || null
                    }
                }
            },
            onCompleted: (response)=>{
                if (response.jira?.updateCascadingSelectField?.success) onSuccess();
                else onFail();
            },
            onError: (error)=>onFail(error, error.message),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            optimisticResponse: {
                jira: {
                    updateCascadingSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            cascadingOption: newOption
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const actions = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        isValueEqual: $a381d2d31fb89055$var$isEqualSelection,
        clipboardComponentType: 'cascadingSelect'
    });
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChange: handleChange, invalidMessage: invalidMessage, isEditing: isEditing } = actions; // #endregion Action
    // #region View
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a381d2d31fb89055$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dG41I.CascadingSelectReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        })), [
        data,
        isTruncated,
        shouldRenderHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            wrapper: $a381d2d31fb89055$var$EditViewWrapper,
            fieldId: uniqueFieldId,
            autoFocus: true,
            parentOptionValue: updatedValue?.parentOptionValue,
            childOptionValue: updatedValue?.childOptionValue,
            menuPosition: menuPosition,
            onChange: handleChange,
            spacing: spacing,
            ...isExperimentEnabled && {
                value: !updatedValue || !updatedValue.parentOptionValue?.id ? null : updatedValue
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $9j9do.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: hideActionButtons,
        hasReadViewTruncateDisabled: shouldRenderHoverPopover
    }); // #endregion Action
};
const $a381d2d31fb89055$export$c72b86275efea41a = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $67xrj.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a381d2d31fb89055$export$d3164c915fdde2ef, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};
const $a381d2d31fb89055$var$wrapperStyles = (0, $1DXK0.xcss)({
    zIndex: 'modal',
    position: 'relative'
});

});
parcelRegister("67xrj", function(module, exports) {
$parcel$export(module.exports, "default", () => $535989099ce96234$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<391d228206c5d2da2084fd47967509e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $535989099ce96234$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraCascadingSelectField"
};
$535989099ce96234$var$node.hash = "e2f7106f0e284e4683ba8bf8fd5fa780";
var $535989099ce96234$export$2e2bcd8739ae039 = $535989099ce96234$var$node;

});

parcelRegister("gOIjY", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a0239c4b4a6b9cc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<536cc6e4be6a9e008fa89cd2d190dd49>>
 * @relayHash d4f2fd55ec1cda569c82f3a78e17226c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3430325e9d7c639fc8979955e4f2694766d816c7b02d5f34ceb0cb60423e7ce9
const $8a0239c4b4a6b9cc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCascadingSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCascadingSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCascadingSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCascadingSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCascadingSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCascadingSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraCascadingOption",
                                            "kind": "LinkedField",
                                            "name": "cascadingOption",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "parentOptionValue",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "childOptionValue",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3430325e9d7c639fc8979955e4f2694766d816c7b02d5f34ceb0cb60423e7ce9",
            "metadata": {},
            "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$8a0239c4b4a6b9cc$var$node.hash = "792c8e7af6ed535746e17a76dc52564b";
var $8a0239c4b4a6b9cc$export$2e2bcd8739ae039 = $8a0239c4b4a6b9cc$var$node;

});

parcelRegister("dzO3b", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bf31d3760af15d8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6ae6d5401514d5954c10b2c3baa89186>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2bf31d3760af15d8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        v0 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView"
            },
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v1 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v1 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraCascadingSelectField"
    };
}();
$2bf31d3760af15d8$var$node.hash = "afadb43a696a96b327cd8181443d429b";
var $2bf31d3760af15d8$export$2e2bcd8739ae039 = $2bf31d3760af15d8$var$node;

});

parcelRegister("9j9do", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d63c91c286e9e61$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $9d63c91c286e9e61$var$CascadingEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("bwgf1")), {
        moduleId: "d23a4651",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $9d63c91c286e9e61$export$2e2bcd8739ae039 = $9d63c91c286e9e61$var$CascadingEditViewEntryPoint;

});
parcelRegister("bwgf1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dnyoG").then(()=>parcelRequire('lOgAb'));

});


parcelRegister("dG41I", function(module, exports) {
$parcel$export(module.exports, "CascadingSelectReadView", () => $1a98731018f28a4c$export$4b0478fdeeb1c69);

var $ffwZ0 = parcelRequire("ffwZ0");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $d9T1A = parcelRequire("d9T1A");

var $3OT15 = parcelRequire("3OT15");

var $3Lkm9 = parcelRequire("3Lkm9");

var $k6Nau = parcelRequire("k6Nau");

var $9Ndu3 = parcelRequire("9Ndu3");
const $1a98731018f28a4c$var$getFieldValueAsText = (cascadingOption)=>{
    if (!cascadingOption || !cascadingOption?.parentOptionValue) return null;
    if (!cascadingOption?.childOptionValue) return cascadingOption.parentOptionValue.value;
    return `${cascadingOption.parentOptionValue.value} - ${cascadingOption.childOptionValue.value}`;
};
const $1a98731018f28a4c$export$4b0478fdeeb1c69 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated = false, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $ffwZ0.default), fragmentRef);
    const { cascadingOption: cascadingOption } = data;
    const fieldValueAsText = $1a98731018f28a4c$var$getFieldValueAsText(cascadingOption);
    const hoverPopoverRefFactory = shouldRenderHoverPopover ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: fieldValueAsText
    });
    const isBespokeEmptyFieldTextGA = (0, $k6Nau.useBespokeEmptyFieldTextGA)();
    if (!fieldValueAsText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), isBespokeEmptyFieldTextGA && {
        placeholderText: (0, $3Lkm9.default).bespokenCascadingSelectPlaceholderEmptyFieldText
    });
    if (isTruncated) {
        if (shouldRenderHoverPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Ndu3.CascadingSelectOptionTruncated), {
            value: fieldValueAsText,
            ref: hoverPopoverRef
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Ndu3.CascadingSelectOptionTruncated), {
            value: fieldValueAsText
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, fieldValueAsText);
};

});
parcelRegister("ffwZ0", function(module, exports) {
$parcel$export(module.exports, "default", () => $f63fcfe8e175e987$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a989a5fab7a00d0dd8cf9e21787bea2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f63fcfe8e175e987$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraCascadingSelectField"
    };
}();
$f63fcfe8e175e987$var$node.hash = "ff5454b1cc5b1b18150500d392d7759f";
var $f63fcfe8e175e987$export$2e2bcd8739ae039 = $f63fcfe8e175e987$var$node;

});

parcelRegister("k6Nau", function(module, exports) {
$parcel$export(module.exports, "useBespokeEmptyFieldTextGA", () => $0f6d5c201f25ecc0$export$742913b25ea3560e);

var $FhXEJ = parcelRequire("FhXEJ");

var $cxKOj = parcelRequire("cxKOj");

var $bmoS1 = parcelRequire("bmoS1");

var $bNexr = parcelRequire("bNexr");
const $0f6d5c201f25ecc0$var$useIsExperimentEligible = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    /* Some URL patterns where Issue view is rendered either in a modal or full page or in a sidebar
	The common pattern is presence of issue key in the URL pathname or search params
	1. /browse/TEST-1
	2. /issues/TEST-1
	3. /jira/software/c/projects/TEST/issues/TEST-1
	4. /jira/software/c/projects/TEST/boards/1?selectedIssue=TEST-1
	5. /jira/software/c/projects/TEST/boards/1/backlog?selectedIssue=TEST-1
	6. /jira/software/c/projects/TEST/list?selectedIssue=TEST-1
	*/ const ISSUE_KEY_REGEX = /[A-Z][A-Z0-9]+-\d+/;
    let isFieldRenderedInIssueView = false;
    try {
        isFieldRenderedInIssueView = // eslint-disable-next-line no-restricted-globals
        ISSUE_KEY_REGEX.test(location.search) || ISSUE_KEY_REGEX.test(location.pathname);
    } catch (error) {
        // If regex test fails for some reason, default to false
        isFieldRenderedInIssueView = false;
    }
    return (projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.CORE_PROJECT)) && isFieldRenderedInIssueView;
};
const $0f6d5c201f25ecc0$export$742913b25ea3560e = ()=>{
    const isExperimentEligible = $0f6d5c201f25ecc0$var$useIsExperimentEligible();
    const isBespokePlaceholderEnabled = isExperimentEligible && (0, $cxKOj.expVal)('bespoke-placeholder-experiment-ga', 'isEnabled', false);
    return isBespokePlaceholderEnabled;
};

});

parcelRegister("9Ndu3", function(module, exports) {
$parcel$export(module.exports, "CascadingSelectOptionTruncated", () => $d5a65d8f464678ec$export$8691872cfdb45f29);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $d5a65d8f464678ec$export$8691872cfdb45f29 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ value: value }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: $d5a65d8f464678ec$var$cascadingValueStylesTruncated,
        ref: ref
    }, value);
});
const $d5a65d8f464678ec$var$cascadingValueStylesTruncated = (0, $1DXK0.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    width: '100%'
});

});




parcelRegister("40Xgt", function(module, exports) {
$parcel$export(module.exports, "DateCell", () => $d91a8d1b3542e6b2$export$64a69967f353bb7c);
$parcel$export(module.exports, "DateInlineEditCell", () => $d91a8d1b3542e6b2$export$976ea8051f04575);

var $ju4m0 = parcelRequire("ju4m0");

var $aiInN = parcelRequire("aiInN");

var $eJOHy = parcelRequire("eJOHy");

var $kQ82p = parcelRequire("kQ82p");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7qGN1 = parcelRequire("7qGN1");

var $5gpGG = parcelRequire("5gpGG");

var $j8Km1 = parcelRequire("j8Km1");

var $4cTDP = parcelRequire("4cTDP");

var $eqbO4 = parcelRequire("eqbO4");

var $86BUM = parcelRequire("86BUM");

var $4vHFI = parcelRequire("4vHFI");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $d91a8d1b3542e6b2$var$parseDate = (dateString)=>{
    if (dateString !== null && dateString !== '') {
        const date = (0, $kQ82p.default)(dateString);
        if (date.toString() !== 'Invalid Date') return date;
    }
    return null;
};
const $d91a8d1b3542e6b2$var$formattedDate = (dateString)=>{
    const date = $d91a8d1b3542e6b2$var$parseDate(dateString);
    if (!date) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7qGN1.FormattedDate), {
        value: date,
        year: "numeric",
        month: "short",
        day: "numeric"
    });
};
const $d91a8d1b3542e6b2$export$64a69967f353bb7c = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isRequired: isRequired })=>{
    const data = (0, $j4oe4.useFragment)((0, $aiInN.default), fieldRef);
    if (data.__typename === 'JiraDatePickerField' && data.fieldId === (0, $j8Km1.KNOWN_COLUMN_TYPES).DUE_DATE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d91a8d1b3542e6b2$export$976ea8051f04575, {
        fieldRef: data
    });
    let date = null;
    if (data.__typename === 'JiraDatePickerField') date = data.date ?? null;
    else if (data.__typename === 'JiraDateTimePickerField') date = data.dateTime ?? null;
    if (isRequired && date == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "date",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d91a8d1b3542e6b2$var$wrapperStyles
    }, $d91a8d1b3542e6b2$var$formattedDate(date));
});
const $d91a8d1b3542e6b2$export$976ea8051f04575 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $ju4m0.default), fieldRef);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5gpGG.DateInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $d91a8d1b3542e6b2$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        shouldShowHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5gpGG.DateInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        shouldShowHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $d91a8d1b3542e6b2$var$wrapperStyles = (0, $1DXK0.xcss)({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $d91a8d1b3542e6b2$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $d91a8d1b3542e6b2$var$customTargetStyles : $d91a8d1b3542e6b2$var$customTargetStylesOld,
        ref: ref
    });
});
const $d91a8d1b3542e6b2$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $d91a8d1b3542e6b2$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("ju4m0", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf03d0848f9da0fb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a6a8c71f5f1afa282471b7c614b7a657>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cf03d0848f9da0fb$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "DateInlineEditCell_DateInlineEditCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraDatePickerField"
};
$cf03d0848f9da0fb$var$node.hash = "1b7d630d3dcbf1130faba8a093d7e599";
var $cf03d0848f9da0fb$export$2e2bcd8739ae039 = $cf03d0848f9da0fb$var$node;

});

parcelRegister("aiInN", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c20c99e7760e58d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8b7a86ed570e1710e3b96774dd68b700>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4c20c99e7760e58d$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "DateInlineEditCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "date"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isInlineEditingEnabled",
                            "variableName": "isInlineEditingEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "DateInlineEditCell_DateInlineEditCell"
                }
            ],
            "type": "JiraDatePickerField"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "dateTime"
                }
            ],
            "type": "JiraDateTimePickerField"
        }
    ],
    "type": "JiraIssueField",
    "abstractKey": "__isJiraIssueField"
};
$4c20c99e7760e58d$var$node.hash = "08f283612324c48c575ea0eab88bb740";
var $4c20c99e7760e58d$export$2e2bcd8739ae039 = $4c20c99e7760e58d$var$node;

});

parcelRegister("5gpGG", function(module, exports) {
$parcel$export(module.exports, "DateInlineEditViewWithIsEditable", () => $da48bca7bd3c96b9$export$af387cb7b19f78a3);
$parcel$export(module.exports, "DateInlineEditView", () => $da48bca7bd3c96b9$export$d1623660a0dc5b59);

var $dWVnw = parcelRequire("dWVnw");

var $bW41r = parcelRequire("bW41r");

var $hyu6H = parcelRequire("hyu6H");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $FhXEJ = parcelRequire("FhXEJ");

var $h6i8k = parcelRequire("h6i8k");

var $4cTDP = parcelRequire("4cTDP");

var $l11m9 = parcelRequire("l11m9");

var $bekdN = parcelRequire("bekdN");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $cxKOj = parcelRequire("cxKOj");

var $8oOr4 = parcelRequire("8oOr4");

var $6pncb = parcelRequire("6pncb");

var $bmoS1 = parcelRequire("bmoS1");

var $fkc6h = parcelRequire("fkc6h");

var $bNexr = parcelRequire("bNexr");

var $ftN6c = parcelRequire("ftN6c");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $k745d = parcelRequire("k745d");
const $da48bca7bd3c96b9$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-date-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $da48bca7bd3c96b9$var$RecurWorkItemContainerEmpty = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $da48bca7bd3c96b9$export$af387cb7b19f78a3 = (props)=>{
    const { attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupTarget: editViewPopupTarget, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, isEditing: isEditingProp = false, isEditable: isEditable, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, fragmentRef: fragmentRef, readViewFitContainerHeight: readViewFitContainerHeight, includeUrgencyTreatment: includeUrgencyTreatment, context: context, shouldShowHoverPopover: shouldShowHoverPopover } = props;
    const data = (0, $j4oe4.useFragment)((0, $hyu6H.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $bW41r.default));
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const { enrichCommitWithIssueExperienceMonitoring: enrichCommitWithIssueExperienceMonitoring } = (0, $fkc6h.useIssueExperienceMonitoring)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name, fieldConfig: fieldConfig } = data;
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const fieldName = overriding.overrideLabel(name);
    const isFieldEditable = overriding.overrideIsEditable(isEditable);
    const isFieldRequired = fieldConfig?.isRequired ?? false;
    const validator = (0, $k745d.useDateValidator)(fieldName, isFieldRequired);
    const initialValue = data.date ?? null;
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail }, event)=>{
        (0, $h6i8k.default)('issue.field.date.edit', event?.timeStamp);
        onSubmit?.(value);
        commit(enrichCommitWithIssueExperienceMonitoring({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        date: value,
                        operation: 'SET'
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateDateField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateDateField: {
                        success: true,
                        errors: null,
                        field: {
                            date: value,
                            id: uniqueFieldId
                        }
                    }
                }
            }
        }, 'date_issueFieldDate_DateField_Mutation', {
            sendUFOEvent: true
        }));
    }, [
        commit,
        onSubmit,
        uniqueFieldId,
        enrichCommitWithIssueExperienceMonitoring
    ]);
    const handleSubmitSucceeded = (0, $eJOHy.useCallback)((value)=>{
        onSubmitSucceeded?.(value);
    }, [
        onSubmitSucceeded
    ]);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: handleSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: isEditingProp,
        updatedValue: updatedValue,
        validator: validator,
        clipboardComponentType: 'date'
    });
    const isRecurWorkItemEnabled = (projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.CORE_PROJECT)) && context === 'ISSUE_DETAIL' && fieldId === (0, $8oOr4.DUE_DATE) && (0, $cxKOj.expVal)('jira-recur-single-work-item-on-sched-due-date-exp', 'showRecurringWorkPopup', false);
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da48bca7bd3c96b9$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bekdN.DateReadView), {
            fragmentRef: data,
            includeUrgencyTreatment: includeUrgencyTreatment,
            ...(0, $4cTDP.fg)('issue_view_due_date_colored_field_targeting_gate') ? {
                fieldId: fieldId
            } : {},
            shouldShowRecurWorkIcon: isRecurWorkItemEnabled && (0, $cxKOj.expVal)('jira-recur-single-work-item-on-sched-due-date-exp', 'showRecurWorkIconInDueDate', false),
            shouldShowHoverPopover: shouldShowHoverPopover
        })), [
        data,
        fieldId,
        includeUrgencyTreatment,
        isRecurWorkItemEnabled,
        shouldShowHoverPopover
    ]);
    const RecurWorkItemContainer = isRecurWorkItemEnabled ? (0, $6pncb.RecurWorkItemContainer) : $da48bca7bd3c96b9$var$RecurWorkItemContainerEmpty;
    // copied from @atlassian/jira-inline-edit-lite/src/ui/use-inline-edit/index.tsx
    const handleCancelWithEvent = (0, $eJOHy.useCallback)(()=>handleCancel(createAnalyticsEvent({
            action: 'canceled',
            actionSubject: 'inlineEdit'
        })), [
        handleCancel,
        createAnalyticsEvent
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            value: updatedValue,
            onChange: handleChange,
            isInvalid: !!invalidMessage,
            autoFocus: true,
            label: fieldName,
            ...isRecurWorkItemEnabled && {
                issueKey: issueKey,
                isRecurWorkItemEnabled: isRecurWorkItemEnabled,
                onCancel: handleCancelWithEvent
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(RecurWorkItemContainer, {
        issueKey: issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $l11m9.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        invalidMessage: invalidMessage,
        hideActionButtons: true
    }));
};
const $da48bca7bd3c96b9$export$d1623660a0dc5b59 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $dWVnw.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da48bca7bd3c96b9$export$af387cb7b19f78a3, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("dWVnw", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c2fb052fa7c020f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c7e4c91cc0608cf472bd3e81527b427>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0c2fb052fa7c020f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "date_issueFieldDateInlineEditFull_DateInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraDatePickerField"
};
$0c2fb052fa7c020f$var$node.hash = "0548aa5d7a0a6ecdbe8581123c90487f";
var $0c2fb052fa7c020f$export$2e2bcd8739ae039 = $0c2fb052fa7c020f$var$node;

});

parcelRegister("bW41r", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b227cb7a65ec32e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4b134f64f11ffd1a4cc70559f78e71c9>>
 * @relayHash cb875b164e467c388678144a56847c99
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c4a8e2a313c01273300fc41c78b263d8655ffa36feab8671b8a00e403ffdb829
const $0b227cb7a65ec32e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "date"
    }, v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "date_issueFieldDate_DateField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraDatePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "date_issueFieldDate_DateField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraDatePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c4a8e2a313c01273300fc41c78b263d8655ffa36feab8671b8a00e403ffdb829",
            "metadata": {},
            "name": "date_issueFieldDate_DateField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0b227cb7a65ec32e$var$node.hash = "210cf117686622e3bb1cfb655e147341";
var $0b227cb7a65ec32e$export$2e2bcd8739ae039 = $0b227cb7a65ec32e$var$node;

});

parcelRegister("hyu6H", function(module, exports) {
$parcel$export(module.exports, "default", () => $e067654b9d8ad03c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9e77458cde4889443c861d0d7069e28b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e067654b9d8ad03c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "date_issueFieldDateReadviewFull_DateReadView"
        },
        {
            "kind": "ScalarField",
            "name": "date"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        }
    ],
    "type": "JiraDatePickerField"
};
$e067654b9d8ad03c$var$node.hash = "2d11e23373a2a9517c8a8ac5a6bfe366";
var $e067654b9d8ad03c$export$2e2bcd8739ae039 = $e067654b9d8ad03c$var$node;

});

parcelRegister("l11m9", function(module, exports) {
$parcel$export(module.exports, "default", () => $28e41e4dc412b477$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $28e41e4dc412b477$var$DateEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("bPnKn")), {
        moduleId: "652b5c22",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $28e41e4dc412b477$export$2e2bcd8739ae039 = $28e41e4dc412b477$var$DateEditViewEntryPoint;

});
parcelRegister("bPnKn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("lx5kZ")
]).then(()=>parcelRequire('7tcPf'));

});


parcelRegister("bekdN", function(module, exports) {
$parcel$export(module.exports, "DateReadView", () => $5f9b76cb43e378fb$export$c663acc1a0b7c5a9);

var $2difO = parcelRequire("2difO");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $bemI6 = parcelRequire("bemI6");

var $lBRZk = parcelRequire("lBRZk");

var $dVT0O = parcelRequire("dVT0O");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $tYLUh = parcelRequire("tYLUh");

var $3NHJr = parcelRequire("3NHJr");

var $8oOr4 = parcelRequire("8oOr4");

var $6pncb = parcelRequire("6pncb");

var $9Vf8k = parcelRequire("9Vf8k");

var $3OT15 = parcelRequire("3OT15");

var $chMwR = parcelRequire("chMwR");

var $7y0HS = parcelRequire("7y0HS");
const $5f9b76cb43e378fb$var$RecurringWorkItemIcon = ({ useUrgentColour: useUrgentColour })=>{
    const { issueProperties: issueProperties, isUpdatingRule: isUpdatingRule } = (0, $6pncb.useRecurWorkItemState)();
    if (!issueProperties && !isUpdatingRule || (0, $9Vf8k.isRecurOnCompleteToggleRule)(issueProperties)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bemI6))), {
        label: "",
        testId: "issue-field-date-readview-full.ui.date.recur-work-icon",
        ...useUrgentColour ? {
            color: "var(--ds-icon-danger, #C9372C)"
        } : {}
    });
};
const $5f9b76cb43e378fb$var$EmptyContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $5f9b76cb43e378fb$export$c663acc1a0b7c5a9 = ({ fragmentRef: fragmentRef, fieldId: fieldId, includeUrgencyTreatment: includeUrgencyTreatment, shouldShowRecurWorkIcon: shouldShowRecurWorkIcon = false, shouldShowHoverPopover: shouldShowHoverPopover })=>{
    const { formatDateOnly: formatDateOnly } = (0, $3NHJr.useDateTimeFormatter)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const noValueTextExperiment = formatMessage(fieldId === (0, $8oOr4.DUE_DATE) ? (0, $7y0HS.default).noValueTextExperimentDueDate : (0, $7y0HS.default).noValueTextExperiment);
    const data = (0, $j4oe4.useFragment)((0, $2difO.default), fragmentRef);
    const { date: date } = data || {};
    const hoverPopoverRefFactory = shouldShowHoverPopover ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (!date) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    });
    const daysSinceDate = (0, $chMwR.getNoOfDaysSinceUTCDateString)(date);
    const isDatePast = daysSinceDate != null && daysSinceDate > 0;
    const isDueToday = daysSinceDate === 0;
    const renderColoredDueDate = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lBRZk.ColoredDueDate), {
            dateString: date,
            pastDue: isDatePast && Boolean(includeUrgencyTreatment) && fieldId === (0, $8oOr4.DUE_DATE),
            dueToday: isDueToday && Boolean(includeUrgencyTreatment) && fieldId === (0, $8oOr4.DUE_DATE),
            warningIconTestId: "date-field.warning-icon",
            clockIconTestId: "date-field.clock-icon",
            calendarIconTestId: "date-field.calendar-icon",
            maybeShowRecurIcon: shouldShowRecurWorkIcon,
            recurIconTestId: "date-field.recur-icon"
        });
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: formatDateOnly(date)
    });
    const renderedValue = includeUrgencyTreatment && fieldId === (0, $8oOr4.DUE_DATE) && (0, $cxKOj.expVal)('due_date_colured_field', 'showUrgencyIndicator', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dVT0O.DateWithUrgencyIndicator), {
        value: date
    }) : formatDateOnly(date);
    const Container = shouldShowRecurWorkIcon ? (0, $3Wh6p.default) : $5f9b76cb43e378fb$var$EmptyContainer;
    /**
   * Hover popover is only enabled on NIN, GNIN, and CHIN and hence the conditional rendering of
   * other formatted dates is ignroed
   */ if (shouldShowHoverPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Container, {
        space: "space.075",
        alignBlock: "center",
        testId: "issue-field-date-readview-full.ui.date.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: [
            $5f9b76cb43e378fb$var$dateReadViewStyles,
            $5f9b76cb43e378fb$var$singleLineStyles
        ],
        ref: hoverPopoverRef
    }, formatDateOnly(date)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Container, {
        space: "space.075",
        alignBlock: "center",
        testId: "issue-field-date-readview-full.ui.date.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: [
            $5f9b76cb43e378fb$var$dateReadViewStyles,
            !(includeUrgencyTreatment && fieldId === (0, $8oOr4.DUE_DATE) && (0, $cxKOj.expVal)('color_due_date_all_views', 'showColoredDueDate', false)) && $5f9b76cb43e378fb$var$clampStyles
        ]
    }, includeUrgencyTreatment && fieldId === (0, $8oOr4.DUE_DATE) && (0, $cxKOj.expVal)('color_due_date_all_views', 'showColoredDueDate', false) ? renderColoredDueDate() : renderedValue), !(0, $cxKOj.expVal)('color_due_date_all_views', 'showColoredDueDate', false) && shouldShowRecurWorkIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f9b76cb43e378fb$var$RecurringWorkItemIcon, {
        useUrgentColour: (isDatePast || isDueToday) && !!includeUrgencyTreatment && (0, $cxKOj.expVal)('due_date_colured_field', 'showUrgencyIndicator', false)
    }));
};
const $5f9b76cb43e378fb$var$dateReadViewStyles = (0, $1DXK0.xcss)({
    display: '-webkit-box',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $5f9b76cb43e378fb$var$clampStyles = (0, $1DXK0.xcss)({
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2
});
const $5f9b76cb43e378fb$var$singleLineStyles = (0, $1DXK0.xcss)({
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1
});

});
parcelRegister("2difO", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5de42fbf9c7486f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a35fee1cfaa8a326bc1500f46687768>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a5de42fbf9c7486f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "date_issueFieldDateReadviewFull_DateReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "date"
        }
    ],
    "type": "JiraDatePickerField"
};
$a5de42fbf9c7486f$var$node.hash = "9249ac9d622710a08c9de2f57a3e7b89";
var $a5de42fbf9c7486f$export$2e2bcd8739ae039 = $a5de42fbf9c7486f$var$node;

});

parcelRegister("bemI6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a0b019b9a1703ba836e9431143f4089a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $82d29e52dbda888e$var$_react = $82d29e52dbda888e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $82d29e52dbda888e$var$_baseNew = $82d29e52dbda888e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $82d29e52dbda888e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Repeat".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for setting objects to recur (eg Work items, Forms)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $82d29e52dbda888e$var$RepeatIcon = (props)=>/*#__PURE__*/ $82d29e52dbda888e$var$_react.default.createElement($82d29e52dbda888e$var$_baseNew.default, Object.assign({
        name: "RepeatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m8.78 3.72-3-3-1.06 1.06L6.44 3.5H4.5a4.5 4.5 0 0 0 0 9h1V11h-1a3 3 0 0 1 0-6h1.94L4.72 6.72l1.06 1.06 3-3a.75.75 0 0 0 0-1.06M11.5 5a3 3 0 1 1 0 6H9.56l1.72-1.72-1.06-1.06-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72h1.94a4.5 4.5 0 1 0 0-9h-1V5z" clip-rule="evenodd"/>`
    }, props));
$82d29e52dbda888e$var$RepeatIcon.displayName = 'RepeatIcon';
var $82d29e52dbda888e$var$_default = module.exports.default = $82d29e52dbda888e$var$RepeatIcon;

});

parcelRegister("lBRZk", function(module, exports) {
$parcel$export(module.exports, "ColoredDueDate", () => $a14336caaa0d75c4$export$63c54814247cca36);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $bemI6 = parcelRequire("bemI6");

var $btkTq = parcelRequire("btkTq");

var $i5stJ = parcelRequire("i5stJ");

var $leOHG = parcelRequire("leOHG");

var $k71qx = parcelRequire("k71qx");

var $1M2hR = parcelRequire("1M2hR");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $6pncb = parcelRequire("6pncb");

var $9Vf8k = parcelRequire("9Vf8k");

var $kPKM4 = parcelRequire("kPKM4");
const $a14336caaa0d75c4$var$RecurringWorkItemIcon = ({ testId: testId })=>{
    const { issueProperties: issueProperties, isUpdatingRule: isUpdatingRule } = (0, $6pncb.useRecurWorkItemState)();
    if (!issueProperties && !isUpdatingRule || (0, $9Vf8k.isRecurOnCompleteToggleRule)(issueProperties)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bemI6))), {
        label: "",
        testId: testId
    });
};
const $a14336caaa0d75c4$export$63c54814247cca36 = ({ dateString: dateString, pastDue: pastDue, dueToday: dueToday, warningIconTestId: warningIconTestId, clockIconTestId: clockIconTestId, calendarIconTestId: calendarIconTestId, tooltipTestId: tooltipTestId, isShortFormat: isShortFormat = false, maybeShowRecurIcon: maybeShowRecurIcon = false, recurIconTestId: recurIconTestId })=>{
    const locale = (0, $1M2hR.useLocale)();
    const localeString = locale.replace('_', '-');
    const formatter = new Intl.DateTimeFormat(localeString, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC'
    });
    const parts = formatter.formatToParts(new Date(dateString));
    const formatDateParts = ({ dateParts: dateParts, includeYear: includeYear = true })=>{
        let result = '';
        dateParts.forEach((part, index)=>{
            const isYearLiteralInShortFormat = part.type === 'literal' && (dateParts[index + 1]?.type === 'year' || dateParts[index - 1]?.type === 'year') && !includeYear;
            if (part.type === 'year' && includeYear || part.type !== 'year' && !isYearLiteralInShortFormat) result += part.value;
        });
        return result;
    };
    const displayDate = isShortFormat ? formatDateParts({
        dateParts: parts,
        includeYear: false
    }) : formatDateParts({
        dateParts: parts
    });
    const tooltipDate = formatDateParts({
        dateParts: parts,
        includeYear: true
    });
    const dueMessage = pastDue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $kPKM4.messages).overdue,
        values: {
            date: tooltipDate
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $kPKM4.messages).due,
        values: {
            date: tooltipDate
        }
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const iconLabel = pastDue ? formatMessage((0, $kPKM4.messages).overdue, {
        date: tooltipDate
    }) : formatMessage((0, $kPKM4.messages).due, {
        date: tooltipDate
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: dueMessage,
        position: "top",
        testId: tooltipTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $a14336caaa0d75c4$var$styles.dateTag,
            $a14336caaa0d75c4$var$styles.flexContainer,
            pastDue ? $a14336caaa0d75c4$var$styles.overdue : undefined,
            dueToday ? $a14336caaa0d75c4$var$styles.dueToday : undefined,
            !pastDue && !dueToday ? $a14336caaa0d75c4$var$styles.normalDate : undefined
        ],
        testId: "coloured-due-date.ui.colored-due-date-container",
        tabIndex: 0,
        role: "button",
        "aria-label": iconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $a14336caaa0d75c4$var$styles.dueDateIcon,
        testId: "coloured-due-date.ui.tooltip-container"
    }, pastDue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($leOHG))), {
        LEGACY_size: "medium",
        label: iconLabel,
        color: "var(--ds-text-danger, #AE2E24)",
        testId: warningIconTestId
    }), dueToday && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))), {
        LEGACY_size: "medium",
        label: iconLabel,
        color: "var(--ds-text-warning, #9E4C00)",
        testId: clockIconTestId
    }), !dueToday && !pastDue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($btkTq))), {
        label: iconLabel,
        color: "var(--ds-text, #292A2E)",
        testId: calendarIconTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "aria-hidden": "true"
    }, displayDate), maybeShowRecurIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a14336caaa0d75c4$var$RecurringWorkItemIcon, {
        testId: recurIconTestId
    })));
};
const $a14336caaa0d75c4$var$styles = {
    dateTag: (0, $1DXK0.xcss)({
        paddingLeft: 'space.075',
        paddingRight: 'space.075',
        borderStyle: 'solid',
        borderRadius: 'radius.small',
        borderWidth: 'border.width',
        color: 'color.text',
        cursor: 'pointer'
    }),
    dateTagNoBorder: (0, $1DXK0.xcss)({
        cursor: 'pointer'
    }),
    flexContainer: (0, $1DXK0.xcss)({
        display: 'flex',
        alignItems: 'center',
        gap: 'space.050'
    }),
    overdue: (0, $1DXK0.xcss)({
        color: 'color.text.danger',
        borderColor: 'color.border.danger'
    }),
    dueToday: (0, $1DXK0.xcss)({
        color: 'color.text.warning',
        borderColor: 'color.border.warning'
    }),
    normalDate: (0, $1DXK0.xcss)({
        color: 'color.text',
        borderColor: 'color.border'
    }),
    dueDateIcon: (0, $1DXK0.xcss)({
        display: 'flex',
        alignItems: 'center'
    })
};

});
parcelRegister("leOHG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d51e4a53b773461fcacb3f2ef49e80e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7623c787bc0988e$var$_react = $f7623c787bc0988e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f7623c787bc0988e$var$_baseNew = $f7623c787bc0988e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f7623c787bc0988e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7623c787bc0988e$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $f7623c787bc0988e$var$_react.default.createElement($f7623c787bc0988e$var$_baseNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$f7623c787bc0988e$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $f7623c787bc0988e$var$_default = module.exports.default = $f7623c787bc0988e$var$WarningOutlineIcon;

});

parcelRegister("6pncb", function(module, exports) {
$parcel$export(module.exports, "RecurWorkItemContainer", () => $c7179b3f6e81c7a6$export$32458a51e0870d6c);
$parcel$export(module.exports, "useRecurWorkItemState", () => $c7179b3f6e81c7a6$export$5730c874dfb9803f);
$parcel$export(module.exports, "useRecurWorkItemActions", () => $c7179b3f6e81c7a6$export$eb9ad4e1e739768e);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $cHtIB = parcelRequire("cHtIB");

var $kyq27 = parcelRequire("kyq27");

var $bNexr = parcelRequire("bNexr");

var $3MbOI = parcelRequire("3MbOI");

var $eSnSE = parcelRequire("eSnSE");

var $5Ix22 = parcelRequire("5Ix22");

var $as8tn = parcelRequire("as8tn");
const $c7179b3f6e81c7a6$var$RecurWorkItemStoreContainer = (0, $6E16M.createContainer)();
const $c7179b3f6e81c7a6$export$32458a51e0870d6c = ({ children: children, issueKey: issueKey })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const environment = (0, $kyq27.useEnvironment)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectId = (0, $bNexr.useProjectId)(projectKey);
    const { data: currentUser } = (0, $3MbOI.useCurrentUser)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (!projectId) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jira-recur-work-item.src.controllers.RecurWorkItemContainer', 'Error initialising RecurWorkItemContainer, could not retrieve projectId');
        return children;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7179b3f6e81c7a6$var$RecurWorkItemStoreContainer, {
        scope: `recur-${issueKey}`,
        issueKey: issueKey,
        environment: environment,
        cloudId: cloudId,
        currentUserAccountId: currentUser.user.accountId,
        projectId: projectId,
        createAnalyticsEvent: createAnalyticsEvent
    }, children);
};
const $c7179b3f6e81c7a6$var$Store = (0, $GtRbT.createStore)({
    name: 'RecurWorkItemStore',
    initialState: (0, $as8tn.INITIAL_STATE),
    actions: $5Ix22.actions,
    containedBy: $c7179b3f6e81c7a6$var$RecurWorkItemStoreContainer,
    handlers: {
        onInit: ()=>async ({ dispatch: dispatch })=>{
                await dispatch((0, $5Ix22.actions).fetch());
            }
    }
});
const $c7179b3f6e81c7a6$export$5730c874dfb9803f = (0, $iJq0l.createStateHook)($c7179b3f6e81c7a6$var$Store);
const $c7179b3f6e81c7a6$export$eb9ad4e1e739768e = (0, $iJq0l.createActionsHook)($c7179b3f6e81c7a6$var$Store);

});
parcelRegister("5Ix22", function(module, exports) {
$parcel$export(module.exports, "actions", () => $13cafe401ee5ee68$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1Lz15 = parcelRequire("1Lz15");

var $2ZEsM = parcelRequire("2ZEsM");

var $b7KsF = parcelRequire("b7KsF");

var $f0czN = parcelRequire("f0czN");
const $13cafe401ee5ee68$export$5153917efea4a83d = (issueProperties)=>({ setState: setState })=>{
        setState({
            issueProperties: issueProperties
        });
    };
const $13cafe401ee5ee68$export$e324594224ef24da = {
    fetch: $1Lz15.fetch,
    setIssueProperties: $13cafe401ee5ee68$export$5153917efea4a83d,
    setAsNonRecurringIssue: $2ZEsM.setAsNonRecurringIssue,
    setAsRecurringIssue: $b7KsF.setAsRecurringIssue,
    updateRule: $f0czN.updateRule
};

});
parcelRegister("1Lz15", function(module, exports) {
$parcel$export(module.exports, "fetch", () => $92eb5cf7fd76697f$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4cTDP = parcelRequire("4cTDP");

var $k9ldc = parcelRequire("k9ldc");

var $g7LgB = parcelRequire("g7LgB");

var $f3jI4 = parcelRequire("f3jI4");

var $9riZR = parcelRequire("9riZR");

var $9Vf8k = parcelRequire("9Vf8k");
const $92eb5cf7fd76697f$export$e7aa7bc5c1b3cfb3 = ()=>async ({ setState: setState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId, currentUserAccountId: currentUserAccountId })=>{
        setState({
            isFetching: true,
            errors: null
        });
        try {
            // First fetch issue-properties
            const { value: issueProperties } = await (0, $9riZR.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $k9ldc.fetchIssueProperties)(issueKey), 'fetchIssueProperties');
            let ruleSummary;
            // Only fetch rule summary if a rule exists in issue-properties and not a grandfathered recur-on-complete rule
            if (issueProperties?.automationRuleUuid) {
                ruleSummary = await (0, $9riZR.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $k9ldc.fetchRuleSummary)(environment, cloudId, projectId, issueProperties.automationRuleUuid), 'fetchRuleSummary');
                // If rule doesn't exist or is disabled, delete issue-properties
                if (!ruleSummary || ruleSummary?.ruleState === (0, $g7LgB.RuleState).DISABLED) {
                    await (0, $9riZR.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $f3jI4.deleteIssueProperties)({
                        issueKey: issueKey
                    }), 'deleteIssueProperties');
                    setState({
                        isFetching: false,
                        hasFetched: true,
                        issueProperties: null
                    });
                    return;
                }
            }
            let isRuleOwner;
            if ((0, $9Vf8k.isRecurOnCompleteToggleRule)(issueProperties)) isRuleOwner = true;
            else if (ruleSummary) isRuleOwner = ruleSummary.authorAccountId === currentUserAccountId;
            else isRuleOwner = null;
            setState({
                isFetching: false,
                hasFetched: true,
                issueProperties: issueProperties,
                isRuleOwner: isRuleOwner,
                ...(0, $4cTDP.fg)('jira-recur-single-work-item-on-sched-due-date-gate') && {
                    hasBootstrapError: false
                }
            });
        } catch (error) {
            setState({
                isFetching: false,
                hasFetched: true,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    error
                ],
                hasBootstrapError: true
            });
        }
    };

});
parcelRegister("k9ldc", function(module, exports) {
$parcel$export(module.exports, "fetchIssueProperties", () => $5469679b83f8a32d$export$efa35964e975bd30);
$parcel$export(module.exports, "fetchRuleSummary", () => $5469679b83f8a32d$export$3cada9835f092161);

var $jbPE2 = parcelRequire("jbPE2");

var $14RSn = parcelRequire("14RSn");

var $keOPi = parcelRequire("keOPi");
const $5469679b83f8a32d$export$efa35964e975bd30 = async (issueKey)=>{
    const recurrenceConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    try {
        return await (0, $keOPi.performIssueGetRequest)(recurrenceConfigEndpoint, undefined, 'recur-work-item/src/services/fetch-rule');
    } catch (error) {
        if (error instanceof (0, $14RSn.default) && error.statusCode === 404) return Promise.resolve({
            value: null
        });
        throw error;
    }
};
const $5469679b83f8a32d$export$3cada9835f092161 = async (environment, cloudId, projectId, ruleUuid)=>{
    const automationStack = await (0, $jbPE2.getAutomationStack)(environment, cloudId);
    const summaryEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/summary`;
    try {
        return await (0, $keOPi.performIssueGetRequest)(summaryEndpoint, undefined, 'recur-work-item/src/services/fetch-rule');
    } catch (error) {
        if (error instanceof (0, $14RSn.default) && error.statusCode === 404) return null;
        throw error;
    }
};

});
parcelRegister("jbPE2", function(module, exports) {
$parcel$export(module.exports, "getAutomationStack", () => $192a6ea715d806e4$export$6123178d3f5fb24d);
$parcel$export(module.exports, "getAutomationRecommendationsUrl", () => $192a6ea715d806e4$export$38f41aa7b608011d);
$parcel$export(module.exports, "getBaseAutomationUrl", () => $192a6ea715d806e4$export$8e479e490e1e69bc);

var $3hRxq = parcelRequire("3hRxq");

var $4cTDP = parcelRequire("4cTDP");
const $192a6ea715d806e4$var$localStorage = (0, $3hRxq.createLocalStorageProvider)('automation-menu');
const $192a6ea715d806e4$var$getLatestStack = async (cloudId)=>fetch(`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`).then((response)=>response.json()).then((response)=>{
        const stacks = response.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        return stacks.length > 0 ? stacks[0] : null;
    }).catch(()=>null);
const $192a6ea715d806e4$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') {
        if ((0, $4cTDP.fg)('automation-platform-pre-prod-instance')) {
            const stack = await $192a6ea715d806e4$var$getLatestStack(cloudId);
            return stack ?? 'pro';
        }
        return 'pro';
    }
    // Set this manually to your Automation dev stack e.g. devesukmajaya. The full key is: __storejs_automation-menu_automationStack
    const stackOverride = $192a6ea715d806e4$var$localStorage.get('automationStack');
    return stackOverride || 'staging';
};
const $192a6ea715d806e4$export$45ce04a98782e28a = async (env, cloudId, projectId)=>{
    const automationStack = await $192a6ea715d806e4$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${projectId}`;
};
const $192a6ea715d806e4$export$f8e019b45a22d26a = async (env, cloudId, ruleId)=>{
    const automationStack = await $192a6ea715d806e4$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${ruleId}`;
};
const $192a6ea715d806e4$export$38f41aa7b608011d = async ({ env: env, cloudId: cloudId, target: target })=>{
    const automationStack = await $192a6ea715d806e4$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/v1/recommendation/templates?target=${target}`;
};
const $192a6ea715d806e4$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if ((0, $4cTDP.fg)('jcs_project_type_m3')) switch(projectType){
        case 'customer_service':
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
    switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});

parcelRegister("keOPi", function(module, exports) {
$parcel$export(module.exports, "performIssuePostRequest", () => $1d9dfe6a518cff33$export$f0d7c3d034d5811a);
$parcel$export(module.exports, "performIssuePutRequest", () => $1d9dfe6a518cff33$export$2167f099a5e216f1);
$parcel$export(module.exports, "performIssueDeleteRequest", () => $1d9dfe6a518cff33$export$cf3e603eb3bc78ab);
$parcel$export(module.exports, "performIssueGetRequest", () => $1d9dfe6a518cff33$export$36671e08961872af);
// Stryker disable all

var $3ugTQ = parcelRequire("3ugTQ");

var $4cTDP = parcelRequire("4cTDP");

var $biGll = parcelRequire("biGll");
const $1d9dfe6a518cff33$export$f0d7c3d034d5811a = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performPostRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performPostRequest)(url, options);
};
const $1d9dfe6a518cff33$export$2167f099a5e216f1 = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performPutRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performPutRequest)(url, options);
};
const $1d9dfe6a518cff33$export$cf3e603eb3bc78ab = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performDeleteRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performDeleteRequest)(url, options);
};
const $1d9dfe6a518cff33$export$36671e08961872af = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performGetRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performGetRequest)(url, options);
};

});
parcelRegister("biGll", function(module, exports) {
$parcel$export(module.exports, "performIssueRequest", () => $00dfaa7a2eaf401f$export$2fba6590b0f30cb2);
// Stryker disable all

var $3ibpe = parcelRequire("3ibpe");

var $14RSn = parcelRequire("14RSn");
const $00dfaa7a2eaf401f$var$isGiraUrl = (url)=>url.startsWith('/rest/gira/1/');
const $00dfaa7a2eaf401f$export$2fba6590b0f30cb2 = async (requestFn, url, options = {}, path = 'unknown')=>{
    const defaultExperienceDescription = {
        experience: $00dfaa7a2eaf401f$var$isGiraUrl(url) ? 'issueGira' : 'issueRest',
        analyticsSource: $00dfaa7a2eaf401f$var$isGiraUrl(url) ? 'issue-gira' : 'issue-rest',
        application: null,
        edition: null
    };
    try {
        const response = await requestFn(url, options);
        return response;
    } catch (error) {
        let traceId;
        let statusCode;
        let errorMessage;
        if (error instanceof Error || error instanceof (0, $14RSn.default) || error instanceof (0, $14RSn.ValidationError) || error instanceof TypeError) errorMessage = error.message;
        if (error instanceof (0, $14RSn.default) || error instanceof (0, $14RSn.ValidationError)) {
            traceId = error.traceId;
            statusCode = error.statusCode;
        }
        const additionalAttributes = {
            statusCode: statusCode || 0,
            errorMessage: errorMessage || 'unknown',
            traceId: traceId || 'unknown',
            path: path
        };
        if (statusCode && statusCode >= 400 && statusCode < 500 || error instanceof Error && error.cause instanceof TypeError) {
            (0, $3ibpe.sendExperienceAnalytics)({
                ...defaultExperienceDescription,
                action: 'taskAbort',
                additionalAttributes: additionalAttributes
            });
            throw error;
        }
        (0, $3ibpe.sendExperienceAnalytics)({
            ...defaultExperienceDescription,
            action: 'taskFail',
            additionalAttributes: additionalAttributes
        });
        throw error;
    }
};

});



parcelRegister("g7LgB", function(module, exports) {
$parcel$export(module.exports, "RuleState", () => $fc4f058c04244dcc$export$c22ef3527b5f5563);
$parcel$export(module.exports, "CONDITION", () => $fc4f058c04244dcc$export$1cfe08df32bc8f76);
$parcel$export(module.exports, "FORM_TITLE_ID", () => $fc4f058c04244dcc$export$66f4c6e4b9206abf);
$parcel$export(module.exports, "SOFTWARE_END_USER_TEMPLATE_2", () => $fc4f058c04244dcc$export$c07ca23c166d6344);
$parcel$export(module.exports, "LAST_DAY_OF_MONTH", () => $fc4f058c04244dcc$export$bc23682b85e0250c);
const $fc4f058c04244dcc$export$c22ef3527b5f5563 = {
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED',
    MISSING_PERMS: 'MISSING_PERMS'
};
const $fc4f058c04244dcc$export$1cfe08df32bc8f76 = {
    SCHEDULE: 'SCHEDULE',
    SCHEDULE_IF_COMPLETE: 'SCHEDULE_IF_COMPLETE'
};
const $fc4f058c04244dcc$export$66f4c6e4b9206abf = 'recur-work-item-form-title';
const $fc4f058c04244dcc$export$c07ca23c166d6344 = 'software_end_user_template_2';
const $fc4f058c04244dcc$export$bc23682b85e0250c = -1;

});

parcelRegister("f3jI4", function(module, exports) {
$parcel$export(module.exports, "deleteRule", () => $e4bbd2fe0788cecd$export$988cba38e738f27d);
$parcel$export(module.exports, "deleteIssueProperties", () => $e4bbd2fe0788cecd$export$3906c12f20991cd1);
$parcel$export(module.exports, "disableRule", () => $e4bbd2fe0788cecd$export$44bd9fdb7edbb04a);

var $jbPE2 = parcelRequire("jbPE2");

var $keOPi = parcelRequire("keOPi");

var $3ugTQ = parcelRequire("3ugTQ");
const $e4bbd2fe0788cecd$export$988cba38e738f27d = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $jbPE2.getAutomationStack)(environment, cloudId);
    const DELETE_RULE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}`;
    return (0, $keOPi.performIssueDeleteRequest)(DELETE_RULE_URL, undefined, 'recur-work-item/src/services/set-non-recurring');
};
const $e4bbd2fe0788cecd$export$3906c12f20991cd1 = async ({ issueKey: issueKey })=>{
    const ruleConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    return (0, $keOPi.performIssueDeleteRequest)(ruleConfigEndpoint, undefined, 'recur-work-item/src/services/set-non-recurring');
};
const $e4bbd2fe0788cecd$export$44bd9fdb7edbb04a = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $jbPE2.getAutomationStack)(environment, cloudId);
    const disableRuleEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/disable`;
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performPatchRequest)(disableRuleEndpoint);
};

});

parcelRegister("9riZR", function(module, exports) {
$parcel$export(module.exports, "callServiceWithAnalytics", () => $6b2665faae66cf06$export$7ad2acdaf7d8c23c);

var $14RSn = parcelRequire("14RSn");

var $kRgKj = parcelRequire("kRgKj");
const $6b2665faae66cf06$var$getErrorAttributes = (error)=>{
    if (error instanceof Error) return {
        errorMessage: error.message,
        ...error instanceof (0, $14RSn.default) && {
            statusCode: error.statusCode
        }
    };
    return {};
};
const $6b2665faae66cf06$export$7ad2acdaf7d8c23c = async (analyticsEvent, requestPromise, requestName, attributes = {})=>{
    try {
        const response = await requestPromise;
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, `${requestName} succeeded`, {
            ...attributes
        });
        return response;
    } catch (err) {
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, `${requestName} failed`, {
            ...attributes,
            ...$6b2665faae66cf06$var$getErrorAttributes(err)
        });
        throw err;
    }
};

});

parcelRegister("9Vf8k", function(module, exports) {
$parcel$export(module.exports, "mapFrequencyToRRule", () => $aefb7d8338ffa0c9$export$e01411a3db8dd3d7);
$parcel$export(module.exports, "mapFrequencyToSmartOffsetValue", () => $aefb7d8338ffa0c9$export$777fffdd861d4f20);
$parcel$export(module.exports, "getFrequencyFromRRule", () => $aefb7d8338ffa0c9$export$71b17ee07540e13b);
$parcel$export(module.exports, "getRecurMenuItemLabel", () => $aefb7d8338ffa0c9$export$c7198a7e75d4478b);
$parcel$export(module.exports, "getSuccessFlagContent", () => $aefb7d8338ffa0c9$export$8eef89c3d24cb712);
$parcel$export(module.exports, "isRecurOnCompleteToggleRule", () => $aefb7d8338ffa0c9$export$b57843f38b80b500);
$parcel$export(module.exports, "hasRuleChanged", () => $aefb7d8338ffa0c9$export$8dc77b9e863f46b);
$parcel$export(module.exports, "applyUserTimezone", () => $aefb7d8338ffa0c9$export$555109634e8a63b6);

var $cSmYj = parcelRequire("cSmYj");

var $5IPrF = parcelRequire("5IPrF");

var $8RQlO = parcelRequire("8RQlO");

var $e3Aqb = parcelRequire("e3Aqb");

var $fBF7C = parcelRequire("fBF7C");
var $h5cuQ = parcelRequire("h5cuQ");

var $9RPB3 = parcelRequire("9RPB3");

var $4cTDP = parcelRequire("4cTDP");

var $g7LgB = parcelRequire("g7LgB");

var $b5IjV = parcelRequire("b5IjV");
const $aefb7d8338ffa0c9$export$e01411a3db8dd3d7 = (timeframe, recurWeeklyConfig, recurDayOfMonth)=>{
    switch(timeframe){
        case 'DAILY':
            return {
                frequency: (0, $9RPB3.Frequencies).DAILY,
                interval: 1
            };
        case 'WEEKDAY':
            return {
                frequency: (0, $9RPB3.Frequencies).DAILY,
                byDay: [
                    (0, $9RPB3.Days).MO,
                    (0, $9RPB3.Days).TU,
                    (0, $9RPB3.Days).WE,
                    (0, $9RPB3.Days).TH,
                    (0, $9RPB3.Days).FR
                ],
                interval: 1
            };
        case 'WEEKLY':
            return {
                frequency: (0, $9RPB3.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 1
            };
        case 'FORTNIGHTLY':
            // There is no native FORTNIGHTLY frequency for ical, so we need to combine WEEKLY with interval 2
            return {
                frequency: (0, $9RPB3.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 2
            };
        case 'MONTHLY':
            return {
                frequency: (0, $9RPB3.Frequencies).MONTHLY,
                byMonthDay: recurDayOfMonth ? [
                    recurDayOfMonth
                ] : [],
                interval: 1
            };
        default:
            throw new Error(`Unknown timeframe: ${timeframe}`);
    }
};
const $aefb7d8338ffa0c9$export$777fffdd861d4f20 = (timeframe)=>{
    switch(timeframe){
        case 'DAILY':
            return '{{now.plusDays(1)}}';
        case 'WEEKDAY':
            return '{{now.plusBusinessDays(1)}}';
        case 'WEEKLY':
            return '{{now.plusWeeks(1)}}';
        case 'FORTNIGHTLY':
            return '{{now.plusWeeks(2)}}';
        case 'MONTHLY':
            return '{{now.plusMonths(1)}}';
        default:
            throw new Error(`Could not calculate due date smart offset value: ${timeframe}`);
    }
};
const $aefb7d8338ffa0c9$export$71b17ee07540e13b = (rrule)=>{
    if (rrule.frequency === (0, $9RPB3.Frequencies).DAILY) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(rrule.byDay, [
            (0, $9RPB3.Days).MO,
            (0, $9RPB3.Days).TU,
            (0, $9RPB3.Days).WE,
            (0, $9RPB3.Days).TH,
            (0, $9RPB3.Days).FR
        ])) return 'WEEKDAY';
        return 'DAILY';
    }
    if (rrule.frequency === (0, $9RPB3.Frequencies).WEEKLY) {
        if (rrule.interval === 2) return 'FORTNIGHTLY';
        return 'WEEKLY';
    }
    if (rrule.frequency === (0, $9RPB3.Frequencies).MONTHLY && rrule.interval === 1) return 'MONTHLY';
};
const $aefb7d8338ffa0c9$export$c7198a7e75d4478b = (rrule, isRecurOnComplete = false)=>{
    if (isRecurOnComplete) return (0, $b5IjV.default).recursOnComplete;
    const frequency = $aefb7d8338ffa0c9$export$71b17ee07540e13b(rrule);
    // Every business day (Monday to Friday)
    if (frequency === 'WEEKDAY') return (0, $b5IjV.default).recursEveryWeekday;
    // Daily
    if (frequency === 'DAILY') return (0, $b5IjV.default).recursDaily;
    // Fortnightly
    if (frequency === 'FORTNIGHTLY') return (0, $b5IjV.default).recursEveryTwoWeeks;
    // Weekly
    if (frequency === 'WEEKLY') return (0, $b5IjV.default).recursWeekly;
    // Monthly
    if (frequency === 'MONTHLY') return (0, $b5IjV.default).recursMonthly;
    return (0, $b5IjV.default).setToRecur;
};
const $aefb7d8338ffa0c9$var$byDayOptions = Object.values((0, $9RPB3.Days));
const $aefb7d8338ffa0c9$var$getWeekDayNameFromByDay = (byDayValue, intl)=>{
    const dayIndex = $aefb7d8338ffa0c9$var$byDayOptions.indexOf(byDayValue);
    if (dayIndex < 0) throw new Error(`Invalid ByDay value provided: ${byDayValue}. Valid options: ${$aefb7d8338ffa0c9$var$byDayOptions}`);
    const firstDayOfWeek = (0, $5IPrF.default)(new Date(), {
        weekStartsOn: 1
    });
    const day = (0, $8RQlO.default)(firstDayOfWeek, dayIndex);
    return intl.formatDate(day, {
        weekday: 'long'
    });
};
const $aefb7d8338ffa0c9$export$5c6d45150d1588c0 = ({ byDayValues: byDayValues, intl: intl, standardizedLocale: standardizedLocale })=>new Intl.ListFormat(standardizedLocale, {
        style: 'long',
        type: 'conjunction'
    }).format(Array.from(byDayValues, (byDayValue)=>$aefb7d8338ffa0c9$var$getWeekDayNameFromByDay(byDayValue, intl)));
const $aefb7d8338ffa0c9$export$8eef89c3d24cb712 = ({ frequency: frequency, recurCondition: recurCondition, recurWeeklyConfig: recurWeeklyConfig, recurDayOfMonth: recurDayOfMonth, intl: intl, standardizedLocale: standardizedLocale, issueKey: issueKey, issueType: issueType })=>{
    const issueTypeLowercase = issueType.toLocaleLowerCase(standardizedLocale);
    switch(recurCondition){
        case 'SCHEDULE_IF_COMPLETE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleIfCompleteDaily, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteDaily, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleIfCompleteWeekday, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekday, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleIfCompleteWeekly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $aefb7d8338ffa0c9$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleIfCompleteFortnightly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteFortnightly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $aefb7d8338ffa0c9$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'MONTHLY':
                    if (!recurDayOfMonth) throw new Error('A monthly recurring rule requires a recurDayOfMonth');
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleIfCompleteMonthly, {
                            issueKey: issueKey
                        }),
                        description: recurDayOfMonth === (0, $g7LgB.LAST_DAY_OF_MONTH) ? intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteMonthlyLastDay, {
                            issueType: issueTypeLowercase
                        }) : intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteMonthly, {
                            issueType: issueTypeLowercase,
                            dayOfMonth: recurDayOfMonth
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        case 'SCHEDULE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleDaily, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleWeekday, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleWeekly, {
                            issueKey: issueKey,
                            weekDayNames: $aefb7d8338ffa0c9$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleFortnightly, {
                            issueKey: issueKey,
                            weekDayNames: $aefb7d8338ffa0c9$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'MONTHLY':
                    if (!recurDayOfMonth) throw new Error('A monthly recurring rule requires a recurDayOfMonth');
                    return {
                        title: recurDayOfMonth === (0, $g7LgB.LAST_DAY_OF_MONTH) ? intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleMonthlyLastDay, {
                            issueKey: issueKey
                        }) : intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleMonthly, {
                            issueKey: issueKey,
                            dayOfMonth: recurDayOfMonth
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        default:
            throw new Error(`Unknown recur condition: ${recurCondition}`);
    }
};
const $aefb7d8338ffa0c9$export$b57843f38b80b500 = (issueProperties)=>{
    return !!issueProperties && !!issueProperties.token && (issueProperties.recurOnScheduleConfig === null || issueProperties.recurOnScheduleConfig === undefined);
};
const $aefb7d8338ffa0c9$var$areByDaysEqual = ({ byDays: byDays, anotherByDays: anotherByDays })=>{
    // assumes lists have a consistent order
    if (byDays === undefined) return anotherByDays === undefined;
    if (anotherByDays === undefined) return false;
    if (byDays.length !== anotherByDays.length) return false;
    return byDays.every((byDay, index)=>byDay === anotherByDays[index]);
};
const $aefb7d8338ffa0c9$var$areDatesEqual = (date1, date2)=>{
    if (date1 === undefined || date2 === undefined) return date1 === date2;
    // We only care about checking the date equality, not the time
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
const $aefb7d8338ffa0c9$export$8dc77b9e863f46b = ({ formInput: formInput, formOutput: formOutput })=>{
    // comparing 2 recur-on-schedule rules
    if (formInput.frequency !== formOutput.frequency || formInput.condition !== formOutput.condition || !$aefb7d8338ffa0c9$var$areDatesEqual(formInput.endsOn, formOutput.endsOn)) return true;
    if (formInput.frequency === 'WEEKLY' || formInput.frequency === 'FORTNIGHTLY') return (0, $4cTDP.fg)('jira-monthly-recurring-work-item-option') ? !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(formInput.byDay, formOutput.byDay) : !$aefb7d8338ffa0c9$var$areByDaysEqual({
        byDays: formInput.byDay,
        anotherByDays: formOutput.byDay
    });
    if (formInput.frequency === 'MONTHLY') return formInput.dayOfMonth !== formOutput.dayOfMonth;
    return false;
};
const $aefb7d8338ffa0c9$export$555109634e8a63b6 = (date, browserTimezone, userTimezone)=>{
    const browserTimezoneOffsetMs = (0, $e3Aqb.default)(browserTimezone);
    const userTimezoneOffsetMs = (0, $e3Aqb.default)(userTimezone);
    return (0, $fBF7C.default)((0, $h5cuQ.default)(date, browserTimezoneOffsetMs), userTimezoneOffsetMs);
};

});
parcelRegister("9RPB3", function(module, exports) {
$parcel$export(module.exports, "NEWLINE_REGEX", () => $0c0ab4669e06d62e$export$665ca7211e0c33c);
$parcel$export(module.exports, "FOLD_LINES_REGEX", () => $0c0ab4669e06d62e$export$4b7f22f32fbb5949);
$parcel$export(module.exports, "LF", () => $0c0ab4669e06d62e$export$606cfc2a8896c91f);
$parcel$export(module.exports, "NewlineCharacters", () => $0c0ab4669e06d62e$export$ccae594c20078277);
$parcel$export(module.exports, "NewlineCharacterValues", () => $0c0ab4669e06d62e$export$c3edd2b21ac02f88);
$parcel$export(module.exports, "Frequencies", () => $0c0ab4669e06d62e$export$895ee510b2e84ade);
$parcel$export(module.exports, "Days", () => $0c0ab4669e06d62e$export$d3134eff2123aadb);
$parcel$export(module.exports, "BEGIN_VEVENT", () => $0c0ab4669e06d62e$export$67de00e87412dc6f);
$parcel$export(module.exports, "END_VEVENT", () => $0c0ab4669e06d62e$export$987d86d2e891c4cb);
$parcel$export(module.exports, "DTSTART", () => $0c0ab4669e06d62e$export$fd1a0e011a586e26);
$parcel$export(module.exports, "RRULE", () => $0c0ab4669e06d62e$export$d86ed937a45b0291);
$parcel$export(module.exports, "ICalSpecificationFields", () => $0c0ab4669e06d62e$export$98eba4d8ff00c139);
$parcel$export(module.exports, "ICalSupportedFields", () => $0c0ab4669e06d62e$export$38b1323f325ffd22);
$parcel$export(module.exports, "TZID", () => $0c0ab4669e06d62e$export$5b9a78912028c06d);
$parcel$export(module.exports, "DTStartProperties", () => $0c0ab4669e06d62e$export$20184b745430719e);
$parcel$export(module.exports, "FREQ", () => $0c0ab4669e06d62e$export$fb124b4fa837b262);
$parcel$export(module.exports, "UNTIL", () => $0c0ab4669e06d62e$export$4cc4f35131ed029c);
$parcel$export(module.exports, "INTERVAL", () => $0c0ab4669e06d62e$export$7dea0e6e08f87a8a);
$parcel$export(module.exports, "BYHOUR", () => $0c0ab4669e06d62e$export$a764ed9c4884f76d);
$parcel$export(module.exports, "BYMINUTE", () => $0c0ab4669e06d62e$export$7a96578de7a037b6);
$parcel$export(module.exports, "BYSECOND", () => $0c0ab4669e06d62e$export$55bcca3bd8d3041f);
$parcel$export(module.exports, "BYDAY", () => $0c0ab4669e06d62e$export$f512ea3e90612d03);
$parcel$export(module.exports, "BYMONTH", () => $0c0ab4669e06d62e$export$b3203f635d74ce88);
$parcel$export(module.exports, "BYMONTHDAY", () => $0c0ab4669e06d62e$export$15623ad945e92c4c);
$parcel$export(module.exports, "RRuleProperties", () => $0c0ab4669e06d62e$export$7898bd020dba0a27);
$parcel$export(module.exports, "MISSING", () => $0c0ab4669e06d62e$export$64c81710c321f252);
$parcel$export(module.exports, "EMPTY", () => $0c0ab4669e06d62e$export$ccb33e29d92c9a58);
$parcel$export(module.exports, "INVALID", () => $0c0ab4669e06d62e$export$9a105a556e65c2c0);
$parcel$export(module.exports, "VALID", () => $0c0ab4669e06d62e$export$f3abe3d006c81602);
const $0c0ab4669e06d62e$export$665ca7211e0c33c = /\r?\n/;
const $0c0ab4669e06d62e$export$4b7f22f32fbb5949 = /\r?\n[ \t]/g; // match line breaks followed by a whitespace character (space or tab)
const $0c0ab4669e06d62e$export$ae9ea0d00d3d8982 = 'CRLF';
const $0c0ab4669e06d62e$export$a1f3f1ef020bdc3a = '\r\n';
const $0c0ab4669e06d62e$export$606cfc2a8896c91f = 'LF';
const $0c0ab4669e06d62e$export$477fea8aa280bb1e = '\n';
const $0c0ab4669e06d62e$export$ccae594c20078277 = {
    CRLF: $0c0ab4669e06d62e$export$ae9ea0d00d3d8982,
    LF: $0c0ab4669e06d62e$export$606cfc2a8896c91f
};
const $0c0ab4669e06d62e$export$c3edd2b21ac02f88 = {
    [$0c0ab4669e06d62e$export$ae9ea0d00d3d8982]: $0c0ab4669e06d62e$export$a1f3f1ef020bdc3a,
    [$0c0ab4669e06d62e$export$606cfc2a8896c91f]: $0c0ab4669e06d62e$export$477fea8aa280bb1e
};
const $0c0ab4669e06d62e$export$895ee510b2e84ade = {
    SECONDLY: 'SECONDLY',
    MINUTELY: 'MINUTELY',
    HOURLY: 'HOURLY',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
const $0c0ab4669e06d62e$export$d3134eff2123aadb = {
    MO: 'MO',
    TU: 'TU',
    WE: 'WE',
    TH: 'TH',
    FR: 'FR',
    SA: 'SA',
    SU: 'SU'
};
const $0c0ab4669e06d62e$export$f62540a8bebc4ed3 = 'BEGIN';
const $0c0ab4669e06d62e$export$32239d68d9c6cb49 = 'END';
const $0c0ab4669e06d62e$export$67de00e87412dc6f = 'BEGIN:VEVENT';
const $0c0ab4669e06d62e$export$987d86d2e891c4cb = 'END:VEVENT';
const $0c0ab4669e06d62e$export$fd1a0e011a586e26 = 'DTSTART';
const $0c0ab4669e06d62e$export$d86ed937a45b0291 = 'RRULE';
const $0c0ab4669e06d62e$export$913055729e1380b2 = 'SUMMARY';
const $0c0ab4669e06d62e$export$87d0ca22edb7493a = 'LOCATION';
const $0c0ab4669e06d62e$export$d44826c816b5619b = 'DESCRIPTION';
const $0c0ab4669e06d62e$export$c8b4a4d253b84ce0 = 'UID';
const $0c0ab4669e06d62e$export$34694f8d8b23ee2a = 'SEQUENCE';
const $0c0ab4669e06d62e$export$e50006273435e7d4 = 'STATUS';
const $0c0ab4669e06d62e$export$36034111438e3f25 = 'TRANSP';
const $0c0ab4669e06d62e$export$bb34f3538ba26c7e = 'PRIORITY';
const $0c0ab4669e06d62e$export$30dbcad954808285 = 'DTEND';
const $0c0ab4669e06d62e$export$bacc88974c736870 = 'DURATION';
const $0c0ab4669e06d62e$export$da3a32b38cbf59ba = 'ATTACH';
const $0c0ab4669e06d62e$export$5e0bdf8bba8d5088 = 'ATTENDEE';
const $0c0ab4669e06d62e$export$a513ea61a7bee91c = 'CATEGORIES';
const $0c0ab4669e06d62e$export$a29989082612d0d9 = 'COMMENT';
const $0c0ab4669e06d62e$export$11038cc09fdccb91 = 'CONTACT';
const $0c0ab4669e06d62e$export$133ffe3c8efbf133 = 'EXDATE';
const $0c0ab4669e06d62e$export$7e27a94778a9d7d7 = 'EXRULE';
const $0c0ab4669e06d62e$export$3d166b1dacd2503a = 'RDATE';
const $0c0ab4669e06d62e$export$47a1d4cd38dddc05 = 'RELATED-TO';
const $0c0ab4669e06d62e$export$4e841128923ef26 = 'RESOURCES';
const $0c0ab4669e06d62e$export$1c0dd28c42f2741e = 'RECURRENCE-ID';
const $0c0ab4669e06d62e$export$61abde59b50deb8e = 'URL';
const $0c0ab4669e06d62e$export$ff39ebd4bb12b718 = 'CREATED';
const $0c0ab4669e06d62e$export$2ebcefe61501d5fe = 'DTSTAMP';
const $0c0ab4669e06d62e$export$90812500f628da64 = 'LAST-MODIFIED';
const $0c0ab4669e06d62e$export$5409f4c14bda7ac = 'ORGANIZER';
const $0c0ab4669e06d62e$export$9fe99b3b71be9378 = 'REQUEST-STATUS';
const $0c0ab4669e06d62e$export$98eba4d8ff00c139 = {
    BEGIN: $0c0ab4669e06d62e$export$f62540a8bebc4ed3,
    END: $0c0ab4669e06d62e$export$32239d68d9c6cb49,
    BEGIN_VEVENT: $0c0ab4669e06d62e$export$67de00e87412dc6f,
    END_VEVENT: $0c0ab4669e06d62e$export$987d86d2e891c4cb,
    SUMMARY: $0c0ab4669e06d62e$export$913055729e1380b2,
    LOCATION: $0c0ab4669e06d62e$export$87d0ca22edb7493a,
    DESCRIPTION: $0c0ab4669e06d62e$export$d44826c816b5619b,
    UID: $0c0ab4669e06d62e$export$c8b4a4d253b84ce0,
    SEQUENCE: $0c0ab4669e06d62e$export$34694f8d8b23ee2a,
    STATUS: $0c0ab4669e06d62e$export$e50006273435e7d4,
    TRANSP: $0c0ab4669e06d62e$export$36034111438e3f25,
    PRIORITY: $0c0ab4669e06d62e$export$bb34f3538ba26c7e,
    DTSTART: $0c0ab4669e06d62e$export$fd1a0e011a586e26,
    RRULE: $0c0ab4669e06d62e$export$d86ed937a45b0291,
    DTEND: $0c0ab4669e06d62e$export$30dbcad954808285,
    DURATION: $0c0ab4669e06d62e$export$bacc88974c736870,
    ATTACH: $0c0ab4669e06d62e$export$da3a32b38cbf59ba,
    ATTENDEE: $0c0ab4669e06d62e$export$5e0bdf8bba8d5088,
    CATEGORIES: $0c0ab4669e06d62e$export$a513ea61a7bee91c,
    COMMENT: $0c0ab4669e06d62e$export$a29989082612d0d9,
    CONTACT: $0c0ab4669e06d62e$export$11038cc09fdccb91,
    EXDATE: $0c0ab4669e06d62e$export$133ffe3c8efbf133,
    EXRULE: $0c0ab4669e06d62e$export$7e27a94778a9d7d7,
    RDATE: $0c0ab4669e06d62e$export$3d166b1dacd2503a,
    RELATED_TO: $0c0ab4669e06d62e$export$47a1d4cd38dddc05,
    RESOURCES: $0c0ab4669e06d62e$export$4e841128923ef26,
    RECURRENCE_ID: $0c0ab4669e06d62e$export$1c0dd28c42f2741e,
    URL: $0c0ab4669e06d62e$export$61abde59b50deb8e,
    CREATED: $0c0ab4669e06d62e$export$ff39ebd4bb12b718,
    DTSTAMP: $0c0ab4669e06d62e$export$2ebcefe61501d5fe,
    LAST_MODIFIED: $0c0ab4669e06d62e$export$90812500f628da64,
    ORGANIZER: $0c0ab4669e06d62e$export$5409f4c14bda7ac,
    REQUEST_STATUS: $0c0ab4669e06d62e$export$9fe99b3b71be9378
};
const $0c0ab4669e06d62e$export$38b1323f325ffd22 = {
    DTSTART: $0c0ab4669e06d62e$export$fd1a0e011a586e26,
    RRULE: $0c0ab4669e06d62e$export$d86ed937a45b0291
};
const $0c0ab4669e06d62e$export$5b9a78912028c06d = 'TZID';
const $0c0ab4669e06d62e$export$20184b745430719e = {
    DTSTART: $0c0ab4669e06d62e$export$fd1a0e011a586e26,
    TZID: $0c0ab4669e06d62e$export$5b9a78912028c06d
};
const $0c0ab4669e06d62e$export$fb124b4fa837b262 = 'FREQ';
const $0c0ab4669e06d62e$export$4cc4f35131ed029c = 'UNTIL';
const $0c0ab4669e06d62e$export$7dea0e6e08f87a8a = 'INTERVAL';
const $0c0ab4669e06d62e$export$a764ed9c4884f76d = 'BYHOUR';
const $0c0ab4669e06d62e$export$7a96578de7a037b6 = 'BYMINUTE';
const $0c0ab4669e06d62e$export$55bcca3bd8d3041f = 'BYSECOND';
const $0c0ab4669e06d62e$export$f512ea3e90612d03 = 'BYDAY';
const $0c0ab4669e06d62e$export$b3203f635d74ce88 = 'BYMONTH';
const $0c0ab4669e06d62e$export$15623ad945e92c4c = 'BYMONTHDAY';
const $0c0ab4669e06d62e$export$7898bd020dba0a27 = {
    FREQ: $0c0ab4669e06d62e$export$fb124b4fa837b262,
    UNTIL: $0c0ab4669e06d62e$export$4cc4f35131ed029c,
    INTERVAL: $0c0ab4669e06d62e$export$7dea0e6e08f87a8a,
    BYHOUR: $0c0ab4669e06d62e$export$a764ed9c4884f76d,
    BYMINUTE: $0c0ab4669e06d62e$export$7a96578de7a037b6,
    BYSECOND: $0c0ab4669e06d62e$export$55bcca3bd8d3041f,
    BYDAY: $0c0ab4669e06d62e$export$f512ea3e90612d03,
    BYMONTH: $0c0ab4669e06d62e$export$b3203f635d74ce88,
    BYMONTHDAY: $0c0ab4669e06d62e$export$15623ad945e92c4c
};
const $0c0ab4669e06d62e$export$64c81710c321f252 = 'MISSING';
const $0c0ab4669e06d62e$export$ccb33e29d92c9a58 = 'EMPTY';
const $0c0ab4669e06d62e$export$9a105a556e65c2c0 = 'INVALID';
const $0c0ab4669e06d62e$export$f3abe3d006c81602 = 'VALID';

});

parcelRegister("b5IjV", function(module, exports) {
$parcel$export(module.exports, "default", () => $129c4b3b6b9310c5$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var // https://atlassian.slack.com/archives/CL2SG8ZEE/p1762312451085199?thread_ts=1762163166.509469&cid=CL2SG8ZEE
// eslint-disable-next-line @atlassian/i18n/blocklist-elements
$129c4b3b6b9310c5$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    formTitle: {
        "id": "recur-work-item.form-title",
        "defaultMessage": "Set to recur"
    },
    saveButtonText: {
        "id": "recur-work-item.save-button-text",
        "defaultMessage": "Save"
    },
    cancelButtonText: {
        "id": "recur-work-item.cancel-button-text",
        "defaultMessage": "Cancel"
    },
    deleteButtonText: {
        "id": "recur-work-item.delete-button-text",
        "defaultMessage": "Delete"
    },
    recurFieldsLabel: {
        "id": "recur-work-item.recur-fields-label",
        "defaultMessage": "Recur"
    },
    setToRecur: {
        "id": "recur-work-item.set-to-recur",
        "defaultMessage": "Set to recur"
    },
    recursDaily: {
        "id": "recur-work-item.recurs-daily",
        "defaultMessage": "Recurs daily"
    },
    recursEveryWeekday: {
        "id": "recur-work-item.recurs-every-weekday",
        "defaultMessage": "Every weekday (Monday to Friday)"
    },
    recursWeekly: {
        "id": "recur-work-item.recurs-weekly",
        "defaultMessage": "Recurs weekly"
    },
    recursEveryTwoWeeks: {
        "id": "recur-work-item.recurs-every-two-weeks",
        "defaultMessage": "Recurs every 2 weeks"
    },
    recursMonthly: {
        "id": "recur-work-item.recurs-monthly",
        "defaultMessage": "Recurs monthly"
    },
    recursOnComplete: {
        "id": "recur-work-item.recurs-on-complete",
        "defaultMessage": "Recurs when completed"
    },
    successFlagTitleRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "{issueKey} recurs every week"
    },
    successFlagTitleRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks"
    },
    successFlagTitleRecurOnScheduleIfCompleteMonthly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-monthly",
        "defaultMessage": "{issueKey} recurs every month"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-daily",
        "defaultMessage": "This {issueType} recurs daily when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "This {issueType} recurs every weekday when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "This {issueType} recurs weekly on {weekDayNames} when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "This {issueType} recurs every 2 weeks on {weekDayNames} when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteMonthly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-monthly",
        "defaultMessage": "This {issueType} recurs on the {dayOfMonth, selectordinal, one {#st} two {#nd} few {#rd} other{#th}} day of the month when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteMonthlyLastDay: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-monthly-last-day",
        "defaultMessage": "This {issueType} recurs on the last day of the month when completed"
    },
    successFlagTitleRecurOnScheduleDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekly",
        "defaultMessage": "{issueKey} recurs every week on {weekDayNames}"
    },
    successFlagTitleRecurOnScheduleFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks on {weekDayNames}"
    },
    successFlagTitleRecurOnScheduleMonthly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-monthly",
        "defaultMessage": "{issueKey} recurs on the {dayOfMonth, selectordinal, one {#st} two {#nd} few {#rd} other{#th}} day of the month"
    },
    successFlagTitleRecurOnScheduleMonthlyLastDay: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-monthly-last-day",
        "defaultMessage": "{issueKey} recurs on the last day of the month"
    },
    goBackLabel: {
        "id": "recur-work-item.go-back-label",
        "defaultMessage": "Go back"
    },
    errorFlagReloadPageButton: {
        "id": "recur-work-item.error-flag-reload-page-button",
        "defaultMessage": "Reload page"
    },
    errorFlagDescription: {
        "id": "recur-work-item.error-flag-description",
        "defaultMessage": "If this keeps happening, share this information with your admin, who should <link>contact support</link>."
    },
    errorFlagTitle: {
        "id": "recur-work-item.error-flag-title",
        "defaultMessage": "Something went wrong on our end"
    }
});

});



parcelRegister("2ZEsM", function(module, exports) {
$parcel$export(module.exports, "setAsNonRecurringIssue", () => $215cf24c960383d9$export$7b76980c59e9a391);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $kRgKj = parcelRequire("kRgKj");

var $as8tn = parcelRequire("as8tn");

var $f3jI4 = parcelRequire("f3jI4");

var $9riZR = parcelRequire("9riZR");
const $215cf24c960383d9$export$7b76980c59e9a391 = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, skipDeletingIssueProperties: skipDeletingIssueProperties = false })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { issueProperties: issueProperties, errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        // this can't be !automationRuleUuid because recur-on-complete rules won't have an
        // automationRuleUuid, but they will have issueProperties
        if (!issueProperties) {
            const error = new Error('User is trying to delete a rule before the rule data has been stored.');
            setState({
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (!isSiteAdmin && !isProjectAdmin && !isRuleOwner) {
            const error = new Error('User does not have permission to set issue as non-recurring.');
            setState({
                // TODO: decide if we want to be appending to this list or overwriting it
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId, recurOnScheduleConfig: recurOnScheduleConfig } = issueProperties;
        if (skipDeletingIssueProperties && !ruleUuid) // nothing to do
        return;
        setState({
            isDeletingRule: true
        });
        const analyticsEvent = createAnalyticsEvent({});
        // delete or disable the rule if we know the rule UUID
        if (ruleUuid) try {
            if (isRuleOwner || isSiteAdmin) {
                await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $f3jI4.deleteRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'deleteRule');
                (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'recurringRule deleted', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            } else {
                await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $f3jI4.disableRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'disableRule');
                (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'recurringRule disabled', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            }
        } catch (error) {
            // abort if the rule cannot be deleted/disabled
            setState({
                isDeletingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (skipDeletingIssueProperties) {
            // we only get here if we've successfully deleted/disabled a recur-on-schedule rule.
            // it's not possible to re-enable disabled rules, so we can assume that the rule will
            // no longer generate future work items. this means that the issue's issue properties
            // are no longer important to store.
            setState({
                isDeletingRule: false,
                ...(0, $as8tn.NO_RULE_PARTIAL_STATE)
            });
            return;
        }
        try {
            await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $f3jI4.deleteIssueProperties)({
                issueKey: issueKey
            }), 'deleteIssueProperties');
            setState({
                isDeletingRule: false,
                ...(0, $as8tn.NO_RULE_PARTIAL_STATE)
            });
        } catch (error) {
            if (!ruleUuid) {
                // in this case, we haven't deleted or disabled the rule, so the rule can still generate
                // future work items. we leave the rule stored in state unchanged and rethrow the error.
                setState({
                    isDeletingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
                throw error;
            }
            // don't rethrow because from the user's perspective, the work item is no longer recurring.
            setState({
                isDeletingRule: false,
                ...(0, $as8tn.NO_RULE_PARTIAL_STATE),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
        }
    };

});
parcelRegister("as8tn", function(module, exports) {
$parcel$export(module.exports, "INITIAL_STATE", () => $924bedb187db69de$export$36d128238e6b60f5);
$parcel$export(module.exports, "NO_RULE_PARTIAL_STATE", () => $924bedb187db69de$export$a1b15f9b9ceb0f70);
const $924bedb187db69de$export$36d128238e6b60f5 = {
    hasFetched: false,
    isFetching: false,
    isCreatingRule: false,
    isDeletingRule: false,
    isUpdatingRule: false,
    errors: null,
    hasBootstrapError: false,
    isRuleOwner: null,
    issueProperties: null
};
const $924bedb187db69de$export$a1b15f9b9ceb0f70 = {
    isRuleOwner: null,
    issueProperties: null
};

});


parcelRegister("b7KsF", function(module, exports) {
$parcel$export(module.exports, "setAsRecurringIssue", () => $480578f2ddd18139$export$5d9cc8e9f9314f21);

var $aXKmr = parcelRequire("aXKmr");

var $kRgKj = parcelRequire("kRgKj");

var $bPEVb = parcelRequire("bPEVb");

var $g7LgB = parcelRequire("g7LgB");

var $9riZR = parcelRequire("9riZR");
const $480578f2ddd18139$export$5d9cc8e9f9314f21 = ({ recurOnScheduleConfig: { rRule: rRule, recurCondition: recurCondition, dueDateOffsetSmartValue: dueDateOffsetSmartValue } })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        setState({
            isCreatingRule: true
        });
        const recurrenceToken = (0, $aXKmr.v4)();
        const templateId = (0, $g7LgB.SOFTWARE_END_USER_TEMPLATE_2);
        const analyticsEvent = createAnalyticsEvent({});
        try {
            const createTemplateResponse = await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $bPEVb.createTemplate)({
                environment: environment,
                cloudId: cloudId,
                projectId: projectId,
                recurrenceToken: recurrenceToken,
                recurCondition: recurCondition,
                rRule: rRule,
                dueDateOffsetSmartValue: dueDateOffsetSmartValue
            }), 'createTemplate');
            if (createTemplateResponse?.ruleUuid) {
                await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $bPEVb.setIssueProperties)({
                    issueKey: issueKey,
                    recurrenceToken: recurrenceToken,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    recurCondition: recurCondition,
                    rRule: rRule,
                    templateId: templateId,
                    dueDateOffsetSmartValue: dueDateOffsetSmartValue
                }), 'setIssueProperties');
                (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'recurringRule created', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    templateId: templateId,
                    recurCondition: recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
                const issueProperties = {
                    automationRuleUuid: createTemplateResponse.ruleUuid,
                    token: recurrenceToken,
                    templateId: templateId,
                    recurOnScheduleConfig: {
                        rRule: rRule,
                        dueDateOffsetSmartValue: dueDateOffsetSmartValue,
                        recurCondition: recurCondition
                    }
                };
                setState({
                    isCreatingRule: false,
                    issueProperties: issueProperties,
                    isRuleOwner: true
                });
            } else throw new Error('New rule failed to be created.');
        } catch (error) {
            setState({
                isCreatingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
    };

});
parcelRegister("bPEVb", function(module, exports) {
$parcel$export(module.exports, "createTemplate", () => $688cd7c66c97ef2e$export$7b7ae612b60e1630);
$parcel$export(module.exports, "setIssueProperties", () => $688cd7c66c97ef2e$export$5153917efea4a83d);

var $3osLr = parcelRequire("3osLr");

var $jbPE2 = parcelRequire("jbPE2");

var $keOPi = parcelRequire("keOPi");

var $g7LgB = parcelRequire("g7LgB");
const $688cd7c66c97ef2e$export$7b7ae612b60e1630 = async ({ environment: environment, cloudId: cloudId, projectId: projectId, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const automationStack = await (0, $jbPE2.getAutomationStack)(environment, cloudId);
    const CREATE_TEMPLATE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/public/rest/v1/template/create`;
    const ruleHomeARI = (0, $3osLr.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(projectId)
    });
    const payload = {
        ruleHome: ruleHomeARI,
        templateId: (0, $g7LgB.SOFTWARE_END_USER_TEMPLATE_2),
        parameters: {
            recurrenceToken: {
                value: recurrenceToken,
                type: 'TEXT'
            },
            rRule: {
                value: rRule,
                type: 'TEXT'
            },
            dueDateOffsetSmartValue: {
                value: dueDateOffsetSmartValue,
                type: 'TEXT'
            },
            recurCondition: {
                value: recurCondition,
                type: 'TEXT'
            }
        }
    };
    return (0, $keOPi.performIssuePostRequest)(CREATE_TEMPLATE_URL, {
        body: JSON.stringify(payload)
    }, 'recur-work-item/src/services/set-recurring');
};
const $688cd7c66c97ef2e$export$5153917efea4a83d = async ({ issueKey: issueKey, ruleUuid: ruleUuid, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, templateId: templateId, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const issuePropertiesEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    const requestBody = {
        automationRuleUuid: ruleUuid,
        token: recurrenceToken,
        templateId: templateId,
        recurOnScheduleConfig: {
            rRule: rRule,
            dueDateOffsetSmartValue: dueDateOffsetSmartValue,
            recurCondition: recurCondition
        }
    };
    return (0, $keOPi.performIssuePutRequest)(issuePropertiesEndpoint, {
        body: JSON.stringify(requestBody)
    }, 'recur-work-item/src/services/set-recurring');
};

});


parcelRegister("f0czN", function(module, exports) {
$parcel$export(module.exports, "updateRule", () => $d769bcc7f9751998$export$b2ebf395d72c5a4c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $kRgKj = parcelRequire("kRgKj");

var $f3jI4 = parcelRequire("f3jI4");

var $9riZR = parcelRequire("9riZR");

var $b7KsF = parcelRequire("b7KsF");

var $2ZEsM = parcelRequire("2ZEsM");
const $d769bcc7f9751998$export$b2ebf395d72c5a4c = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, recurOnScheduleConfig: recurOnScheduleConfig })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey })=>{
        const { issueProperties: issueProperties, errors: errors } = getState();
        if (!issueProperties) {
            // if there is no existing rule, then create a new rule and update issue properties
            await dispatch((0, $b7KsF.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            return;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId } = issueProperties;
        setState({
            isUpdatingRule: true
        });
        try {
            await dispatch((0, $2ZEsM.setAsNonRecurringIssue)({
                isProjectAdmin: isProjectAdmin,
                isRuleOwner: isRuleOwner,
                isSiteAdmin: isSiteAdmin,
                // we'll update issue properties later
                skipDeletingIssueProperties: true
            }));
        } catch (error) {
            // don't need to save the error to state because setAsNonRecurringIssue should already do this
            setState({
                isUpdatingRule: false
            });
            throw error;
        }
        // create the new rule
        try {
            await dispatch((0, $b7KsF.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'recurringRule updated', {
                issueKey: // TODO: add ruleId attribute
                issueKey,
                ruleUuid: ruleUuid,
                templateId: templateId,
                recurCondition: recurOnScheduleConfig?.recurCondition,
                isUpdateForExistingRule: true
            });
            setState({
                isUpdatingRule: false
            });
        } catch (error) {
            // if we fail to create the rule and update issue properties, then we need to go back and remove the
            // original recurring rule config from issue properties
            try {
                setState({
                    isDeletingRule: true
                });
                await (0, $9riZR.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $f3jI4.deleteIssueProperties)({
                    issueKey: issueKey
                }), 'deleteIssueProperties');
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    issueProperties: null,
                    isRuleOwner: null,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
            } catch (anotherError) {
                // we've made no changes to the rule config since we called `setAsNonRecurringIssue` above,
                // so we don't need to update ruleSummary or issueProperties.
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error,
                        anotherError
                    ]
                });
                throw anotherError;
            }
            // we've just successfully deleted the existing rule; we haven't actually created a new one.
            throw error;
        }
    };

});



parcelRegister("kPKM4", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a82ad686544dfbb0$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $a82ad686544dfbb0$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    overdue: {
        "id": "business.list.ui.list-view.date-cell.overdue",
        "defaultMessage": "Overdue since {date}"
    },
    due: {
        "id": "business.list.ui.list-view.date-cell.due",
        "defaultMessage": "Due on {date}"
    }
});

});


parcelRegister("dVT0O", function(module, exports) {
$parcel$export(module.exports, "DateWithUrgencyIndicator", () => $89428acd7cb12298$export$31bba0fc7d099434);

var $eJOHy = parcelRequire("eJOHy");

var $i5stJ = parcelRequire("i5stJ");

var $d8UFE = parcelRequire("d8UFE");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $3NHJr = parcelRequire("3NHJr");

var $iemGy = parcelRequire("iemGy");

var $2cNSz = parcelRequire("2cNSz");
const $89428acd7cb12298$export$31bba0fc7d099434 = ({ value: value, formattedDateString: formattedDateString })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { formatDateOnly: formatDateOnly } = (0, $3NHJr.useDateTimeFormatter)();
    const daysBetweenTodayAndValue = (0, $eJOHy.useMemo)(()=>(0, $iemGy.getNoOfDaysSinceUTCDateString)(value), [
        value
    ]);
    const formattedDate = (0, $eJOHy.useMemo)(()=>formattedDateString || formatDateOnly(value), [
        formattedDateString,
        formatDateOnly,
        value
    ]);
    const dueMessage = daysBetweenTodayAndValue === 0 ? formatMessage((0, $2cNSz.default).dueToday) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $2cNSz.default).dueIn,
        values: {
            daysBetween: daysBetweenTodayAndValue
        }
    });
    const isDatePast = daysBetweenTodayAndValue != null && daysBetweenTodayAndValue >= 0;
    const Icon = daysBetweenTodayAndValue === 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))) : (0, (/*@__PURE__*/$parcel$interopDefault($d8UFE)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        testId: "date-with-urgency-indicator.container",
        gap: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $89428acd7cb12298$var$baseStyles,
            isDatePast ? $89428acd7cb12298$var$redBackgroundStyle : false
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: isDatePast ? 'color.text.accent.red' : 'color.text.accent.gray.bolder'
    }, formattedDate)), isDatePast && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: dueMessage,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
        LEGACY_size: "medium",
        label: "",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: "date-with-urgency-indicator.warning-icon"
    })));
};
const $89428acd7cb12298$var$baseStyles = (0, $1DXK0.xcss)({
    padding: 'space.025',
    borderRadius: 'radius.small'
});
const $89428acd7cb12298$var$redBackgroundStyle = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.accent.red.subtlest',
    ':hover': {
        backgroundColor: 'color.background.accent.red.subtlest.hovered'
    },
    minWidth: '92px'
});

});
parcelRegister("3NHJr", function(module, exports) {
$parcel$export(module.exports, "useDateTimeFormatter", () => $c04f3d2981f71a59$export$163f492669f74d5b);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $3MbOI = parcelRequire("3MbOI");

var $1M2hR = parcelRequire("1M2hR");

var $gKm6m = parcelRequire("gKm6m");

var $iw2hI = parcelRequire("iw2hI");
const $c04f3d2981f71a59$export$163f492669f74d5b = (overrideTimeZone)=>{
    (0, $gRw8I.di)(Intl);
    const { data: { // @ts-expect-error - TS2339 - Property 'timeZone' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
    user: { timeZone: timeZonePreference } } } = (0, $3MbOI.useCurrentUser)();
    const timeZone = overrideTimeZone ?? timeZonePreference;
    const jiraLocal = (0, $1M2hR.useLocale)();
    const standardizedLocale = (0, $iw2hI.standardizeLocale)(jiraLocal);
    const verifiedTimeZone = (0, $iw2hI.verifyTimeZone)(timeZone);
    const dateTimeFormatter = (0, $eJOHy.useMemo)(()=>new Intl.DateTimeFormat(standardizedLocale, {
            ...(0, $gKm6m.longDateTimeFormat),
            timeZone: verifiedTimeZone
        }), [
        standardizedLocale,
        verifiedTimeZone
    ]);
    const dateOnlyFormatter = (0, $eJOHy.useMemo)(()=>new Intl.DateTimeFormat(standardizedLocale, {
            ...(0, $gKm6m.longDateOnlyFormat),
            timeZone: 'UTC'
        }), [
        standardizedLocale
    ]);
    const formatDateTime = (0, $eJOHy.useCallback)((date)=>{
        const rawValue = typeof date === 'string' ? new Date(date) : date;
        return dateTimeFormatter.format(rawValue);
    }, [
        dateTimeFormatter
    ]);
    const formatDateOnly = (0, $eJOHy.useCallback)((date)=>dateOnlyFormatter.format(new Date(date)), [
        dateOnlyFormatter
    ]);
    return {
        formatDateTime: /**
		 * Returns the long form of a date value with respect to the user's locale and timezone preferences
		 *
		 * @param {string|number|date} date Value as either an [ISO8601 string](https://www.w3.org/TR/NOTE-datetime) (eg `"1997-07-16T19:20:30.45+01:00"`), epoch number (eg `1615431020`), or vanilla `Date` object
		 *
		 * ## Examples
		 *
		 * ```js
		 * // returns Jan 22, 2021, 1:11 PM
		 * formatDateTime(1611281490857) // where user locale is "en-US"
		 *
		 * // returns 2021年1月22日 午後1:11
		 * formatDateTime(1611281490857) // where user locale is "ja-JP"
		 * ```
		 */ formatDateTime,
        formatDateOnly: /**
		 * Returns the long form of a date without time value with respect to the user's locale. Timezones do not apply to these dates.
		 *
		 * @param {string} date Value as a 'YYYY-MM-DD' string (eg `"1997-07-16"`)
		 *
		 * ## Examples
		 *
		 * ```js
		 * // returns Jan 22, 2021
		 * formatDateOnly('2021-01-22') // where user locale is "en-US"
		 *
		 * // returns 2021年1月22日
		 * formatDateOnly('2021-01-22') // where user locale is "ja-JP"
		 * ```
		 */ formatDateOnly
    };
};

});
parcelRegister("gKm6m", function(module, exports) {
$parcel$export(module.exports, "longDateTimeFormat", () => $3c5abb5b9eb6dd5e$export$f2f390060309965);
$parcel$export(module.exports, "longDateOnlyFormat", () => $3c5abb5b9eb6dd5e$export$51f819d50bcd4ae1);
/**
 * If this file gets changed, please update platform/packages/proforma/proforma-common-core/src/form-system/components/questions/common/defaultDateTimeFormats.tsx or let the owners know via #jsm-request-intake.
 *
 * Proforma wants to stay consistent with Jira date and time format options.
 *
 * Later on Proforma will introduce React Context to pass config props, and this will be removed.
 */ /**
 * Long format of a date time, eg "Jun 16, 1971, 2:34 AM" with 12h/24h formatting resolved from locale
 */ const $3c5abb5b9eb6dd5e$export$f2f390060309965 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};
const $3c5abb5b9eb6dd5e$export$51f819d50bcd4ae1 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
};

});

parcelRegister("iw2hI", function(module, exports) {
$parcel$export(module.exports, "standardizeLocale", () => $07e147bc3d7cc59d$export$ca06804549ae25fb);
$parcel$export(module.exports, "verifyTimeZone", () => $07e147bc3d7cc59d$export$93ff13646da25bd);

var $jbr6p = parcelRequire("jbr6p");

var $eSnSE = parcelRequire("eSnSE");
const $07e147bc3d7cc59d$var$FALLBACK_LOCALE = 'en-US';
const $07e147bc3d7cc59d$export$ca06804549ae25fb = (jiraLocale)=>{
    if (typeof jiraLocale !== 'string') {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jira-issue-format-date.standardize-locale', `Invalid input type for locale was passed in: ${jiraLocale}. Falling back to ${$07e147bc3d7cc59d$var$FALLBACK_LOCALE}.`);
        return $07e147bc3d7cc59d$var$FALLBACK_LOCALE;
    }
    const standardizedLocale = jiraLocale.replace('_', '-');
    switch(standardizedLocale){
        case 'en':
            return 'en-US';
        case 'en-UK':
            return 'en-GB';
        default:
            if (!(0, $jbr6p.default).includes(jiraLocale)) (0, $eSnSE.default).safeWarnWithoutCustomerData('jira-issue-format-date.standardize-locale', `Discovered unsupported locale: ${jiraLocale}. This value was not modified, but its use may lead to unpredictable behaviour for formatting.`);
            return standardizedLocale;
    }
};
const $07e147bc3d7cc59d$export$93ff13646da25bd = (timeZone)=>{
    try {
        Intl.DateTimeFormat($07e147bc3d7cc59d$var$FALLBACK_LOCALE, {
            timeZone: timeZone
        });
        return timeZone;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jira-issue-format-date.verify-time-zone', `Invalid timeZone: ${String(timeZone)}. Date time formatting cannot be performed with this value. Falling back to undefined`, error);
        return undefined;
    }
};

});


parcelRegister("iemGy", function(module, exports) {
$parcel$export(module.exports, "getNoOfDaysSinceUTCDateString", () => $6350001782ddbd27$export$7f4e2d0c87567b43);

var $fSCkM = parcelRequire("fSCkM");
/**
 * Normalizes a given date by removing the time component.
 *
 * @param {Date} date - The date to be normalized.
 * @returns {Date} - The normalized date without the time component.
 */ const $6350001782ddbd27$var$normalizeDate = (date)=>new Date(date.getFullYear(), date.getMonth(), date.getDate());
/**
 * Adds a specified number of days to a given date.
 *
 * @param date - The date to which the days should be added.
 * @param days - The number of days to add.
 * @returns The new date after adding the specified number of days.
 */ const $6350001782ddbd27$var$datePlusXDays = (date, days)=>$6350001782ddbd27$var$normalizeDate(new Date(date.getTime() + days * 86400000));
const $6350001782ddbd27$export$9417a5d0968b488e = (dateString, dueDaysOffset = 7)=>{
    if (!dateString) return {
        isDueDatePast: false,
        isDueSoon: false
    };
    const date = $6350001782ddbd27$var$normalizeDate(new Date(dateString));
    if (Number.isNaN(date.getTime())) return {
        isDueDatePast: false,
        isDueSoon: false
    };
    const TODAY = $6350001782ddbd27$var$normalizeDate(new Date());
    const TODAY_PLUS_DUE_DAYS_OFFSET = $6350001782ddbd27$var$datePlusXDays(TODAY, dueDaysOffset);
    const isDueDatePast = date.getTime() === TODAY.getTime() || date < TODAY;
    const isDueSoon = !isDueDatePast && date < TODAY_PLUS_DUE_DAYS_OFFSET;
    return {
        isDueDatePast: isDueDatePast,
        isDueSoon: isDueSoon
    };
};
const $6350001782ddbd27$export$3d094644d6bd82b9 = (dateString, dueDaysOffset = 7)=>{
    if (!dateString) return {
        isDueDatePast: false,
        isDueSoon: false
    };
    let inputDateInISO;
    try {
        inputDateInISO = (0, $fSCkM.DateOnly).fromISODateString(dateString).toLocalDate();
    } catch (e) {
        return {
            isDueDatePast: false,
            isDueSoon: false
        };
    }
    const TODAY = (0, $fSCkM.DateOnly).fromDateAccordingToLocalTime(new Date()).toLocalDate();
    const TODAY_PLUS_DUE_DAYS_OFFSET = $6350001782ddbd27$var$datePlusXDays(TODAY, dueDaysOffset);
    const isDueDatePast = inputDateInISO.getTime() === TODAY.getTime() || inputDateInISO < TODAY;
    const isDueSoon = !isDueDatePast && inputDateInISO < TODAY_PLUS_DUE_DAYS_OFFSET;
    return {
        isDueDatePast: isDueDatePast,
        isDueSoon: isDueSoon
    };
};
const $6350001782ddbd27$export$7f4e2d0c87567b43 = (dateString)=>{
    if (!dateString) return null;
    let inputDateInISO;
    try {
        inputDateInISO = (0, $fSCkM.DateOnly).fromISODateString(dateString).toLocalDate();
    } catch (e) {
        return null;
    }
    const TODAY = (0, $fSCkM.DateOnly).fromDateAccordingToLocalTime(new Date()).toLocalDate();
    const daysBetween = Math.floor((TODAY.getTime() - inputDateInISO.getTime()) / 86400000);
    return daysBetween;
};

});
parcelRegister("fSCkM", function(module, exports) {
$parcel$export(module.exports, "DateOnly", () => $f890d9b837113be1$export$988b361b394263b6);
$parcel$export(module.exports, "toDateOnly", () => $f890d9b837113be1$export$b0961ad8aee63b8b);
const $f890d9b837113be1$export$9cda9b56d134780f = 'Invalid date or date format';
const $f890d9b837113be1$var$toISOString = (year, month, day)=>`${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
const $f890d9b837113be1$var$isLeapYear = (year)=>year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
const $f890d9b837113be1$var$daysInMonth = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
/**
 Returns a boolean to indicate that the date specified is valid.

 Note: Dates before Year zero are treated to be invalid.
 */ const $f890d9b837113be1$var$isDateValid = (year, month, day)=>{
    if ([
        year,
        month,
        day
    ].findIndex((n)=>typeof n !== 'number' || Number.isNaN(n)) !== -1) return false;
    if (year < 0) return false;
    if (month < 1 || month > 12) return false;
    if (day < 1) return false;
    if (day > (month === 2 && $f890d9b837113be1$var$isLeapYear(year) ? 29 : $f890d9b837113be1$var$daysInMonth[month - 1])) return false;
    return true;
};
const $f890d9b837113be1$var$dateFormatRegExp = /^([0-9][0-9][0-9][0-9])-([0-1][0-9])-([0-3][0-9])$/;
class $f890d9b837113be1$export$988b361b394263b6 {
    /**
	 * Return true if the string is a valid ISO date string in the format 'YYYY-MM-DD'.
	 * @param dateString
	 * @returns {boolean}
	 */ static isISODateString(dateString) {
        try {
            $f890d9b837113be1$export$988b361b394263b6.fromISODateString(dateString);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e?.message === $f890d9b837113be1$export$9cda9b56d134780f) return false;
            throw e;
        }
        return true;
    }
    /**
	 * Create a DateOnly object from a string in the format 'YYYY-MM-DD'.
	 */ // go/jfe-eslint
    static fromISODateString(dateString) {
        const matches = $f890d9b837113be1$var$dateFormatRegExp.exec(dateString);
        if (matches === null) throw new Error($f890d9b837113be1$export$9cda9b56d134780f);
        const [, year, month, day] = matches;
        // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
        return new $f890d9b837113be1$export$988b361b394263b6(...[
            year,
            month,
            day
        ].map((s)=>Number.parseInt(s, 10)));
    }
    /**
	 * DISCLAIMER:
	 * Date() does NOT store timezone information.
	 *
	 * Date.prototype.toString() leverages the system's timezone to serialize it into a string according to local time.
	 * Methods getDate(), getMonth(), getFullYear() behave the same and also return values according to local time.
	 *
	 * Methods toUTCString(), getUTCDate(), getUTCMonth(), getUTCFullYear() return values according to universal time.
	 *
	 * Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
	 */ /**
	 * Create a DateOnly object that reflects the local year, month & day for the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToLocalTime(date) {
        return new $f890d9b837113be1$export$988b361b394263b6(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }
    /**
	 * Create a DateOnly object that reflects the UTC year, month & day of the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToUTC(date) {
        return new $f890d9b837113be1$export$988b361b394263b6(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
    }
    /**
	 * Compare 2 DateOnly objects.
	 *
	 * (Similar to the TC39 proposal Temporal.PlainDate.compare).
	 *
	 * If a comes before b, return -1.
	 * If a is equal to b, return 0.
	 * If a is greater than b, return 1.
	 */ static compare(a, b) {
        if (a.year === b.year) {
            if (a.month === b.month) {
                if (a.day === b.day) return 0;
                return a.day < b.day ? -1 : 1;
            }
            return a.month < b.month ? -1 : 1;
        }
        return a.year < b.year ? -1 : 1;
    }
    /**
	 * Create a DateOnly object which represents a day. It does not have a time component.
	 * @param year - A year, ranging between 0 and 9999 inclusive.
	 * @param month - A month, ranging between 1 and 12 inclusive.
	 * @param day - A day of the month, ranging between 1 and 31 inclusive.
	 */ constructor(year, month, day){
        if (!$f890d9b837113be1$var$isDateValid(year, month, day)) throw new Error($f890d9b837113be1$export$9cda9b56d134780f);
        this.year = year;
        this.month = month;
        this.day = day;
    }
    getYear() {
        return this.year;
    }
    getMonth() {
        return this.month;
    }
    getDay() {
        return this.day;
    }
    toISOString() {
        return $f890d9b837113be1$var$toISOString(this.year, this.month, this.day);
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 which corresponds to the UTC timezone.
	 */ toUTCDate() {
        return new Date(Date.UTC(this.year, this.month - 1, this.day));
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 for the local timezone.
	 */ toLocalDate() {
        // take the current date (e.g. 1.06.2020)
        const localDate = new Date();
        // store current month in a const to compare below
        const currentMonth = localDate.getMonth();
        // set the year
        localDate.setFullYear(this.year);
        localDate.setHours(0);
        localDate.setMinutes(0);
        localDate.setSeconds(0);
        localDate.setMilliseconds(0);
        localDate.setDate(this.day);
        // if this.day doesn't exist in the current month (e.g. 31 doesn't exist in June ),
        // it will set the month to July instead. We need to make sure setDate doesn't change the month
        if (localDate.getMonth() !== currentMonth) {
            localDate.setMonth(this.month - 1);
            // reset the date after updating the month
            localDate.setDate(this.day);
        } else localDate.setMonth(this.month - 1);
        return localDate;
    }
    equals(dateOnly) {
        return $f890d9b837113be1$export$988b361b394263b6.compare(this, dateOnly) === 0;
    }
}
const $f890d9b837113be1$export$b0961ad8aee63b8b = (date)=>typeof date === 'string' ? $f890d9b837113be1$export$988b361b394263b6.fromISODateString(date.replace(/T.*/, '')) : null;

});


parcelRegister("2cNSz", function(module, exports) {
$parcel$export(module.exports, "default", () => $9601b7655c62666f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9601b7655c62666f$var$messages = (0, $7qGN1.defineMessages)({
    dueToday: {
        "id": "date-with-urgency-indicator.due-today",
        "defaultMessage": "Due today"
    },
    dueIn: {
        "id": "date-with-urgency-indicator.due-in",
        "defaultMessage": "{daysBetween} {daysBetween, plural, one {day} other {days}} overdue"
    }
});
var $9601b7655c62666f$export$2e2bcd8739ae039 = $9601b7655c62666f$var$messages;

});


parcelRegister("chMwR", function(module, exports) {
$parcel$export(module.exports, "getNoOfDaysSinceUTCDateString", () => $acc777e3d2c5b893$export$7f4e2d0c87567b43);

var $fSCkM = parcelRequire("fSCkM");
/**
 * Normalizes a given date by removing the time component.
 *
 * @param {Date} date - The date to be normalized.
 * @returns {Date} - The normalized date without the time component.
 */ const $acc777e3d2c5b893$var$normalizeDate = (date)=>new Date(date.getFullYear(), date.getMonth(), date.getDate());
/**
 * Adds a specified number of days to a given date.
 *
 * @param date - The date to which the days should be added.
 * @param days - The number of days to add.
 * @returns The new date after adding the specified number of days.
 */ const $acc777e3d2c5b893$var$datePlusXDays = (date, days)=>$acc777e3d2c5b893$var$normalizeDate(new Date(date.getTime() + days * 86400000));
const $acc777e3d2c5b893$export$9417a5d0968b488e = (dateString, dueDaysOffset = 7)=>{
    if (!dateString) return {
        isDueDatePast: false,
        isDueSoon: false
    };
    const date = $acc777e3d2c5b893$var$normalizeDate(new Date(dateString));
    if (Number.isNaN(date.getTime())) return {
        isDueDatePast: false,
        isDueSoon: false
    };
    const TODAY = $acc777e3d2c5b893$var$normalizeDate(new Date());
    const TODAY_PLUS_DUE_DAYS_OFFSET = $acc777e3d2c5b893$var$datePlusXDays(TODAY, dueDaysOffset);
    const isDueDatePast = date.getTime() === TODAY.getTime() || date < TODAY;
    const isDueSoon = !isDueDatePast && date < TODAY_PLUS_DUE_DAYS_OFFSET;
    return {
        isDueDatePast: isDueDatePast,
        isDueSoon: isDueSoon
    };
};
const $acc777e3d2c5b893$export$3d094644d6bd82b9 = (dateString, dueDaysOffset = 7)=>{
    if (!dateString) return {
        isDueDatePast: false,
        isDueSoon: false
    };
    let inputDateInISO;
    try {
        inputDateInISO = (0, $fSCkM.DateOnly).fromISODateString(dateString).toLocalDate();
    } catch (e) {
        return {
            isDueDatePast: false,
            isDueSoon: false
        };
    }
    const TODAY = (0, $fSCkM.DateOnly).fromDateAccordingToLocalTime(new Date()).toLocalDate();
    const TODAY_PLUS_DUE_DAYS_OFFSET = $acc777e3d2c5b893$var$datePlusXDays(TODAY, dueDaysOffset);
    const isDueDatePast = inputDateInISO.getTime() === TODAY.getTime() || inputDateInISO < TODAY;
    const isDueSoon = !isDueDatePast && inputDateInISO < TODAY_PLUS_DUE_DAYS_OFFSET;
    return {
        isDueDatePast: isDueDatePast,
        isDueSoon: isDueSoon
    };
};
const $acc777e3d2c5b893$export$7f4e2d0c87567b43 = (dateString)=>{
    if (!dateString) return null;
    let inputDateInISO;
    try {
        inputDateInISO = (0, $fSCkM.DateOnly).fromISODateString(dateString).toLocalDate();
    } catch (e) {
        return null;
    }
    const TODAY = (0, $fSCkM.DateOnly).fromDateAccordingToLocalTime(new Date()).toLocalDate();
    const daysBetween = Math.floor((TODAY.getTime() - inputDateInISO.getTime()) / 86400000);
    return daysBetween;
};

});

parcelRegister("7y0HS", function(module, exports) {
$parcel$export(module.exports, "default", () => $d326cc713d411d8c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d326cc713d411d8c$var$messages = (0, $7qGN1.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-date-readview-full.date.no-value-text-experiment",
        "defaultMessage": "Add date"
    },
    noValueTextExperimentDueDate: {
        "id": "issue-field-date-readview-full.date.no-value-text-experiment-due-date",
        "defaultMessage": "Add due date"
    }
});
var $d326cc713d411d8c$export$2e2bcd8739ae039 = $d326cc713d411d8c$var$messages;

});


parcelRegister("fkc6h", function(module, exports) {
$parcel$export(module.exports, "useIssueExperienceMonitoring", () => $512cbef46162db63$export$316dd354b9e65dba);

var $eJOHy = parcelRequire("eJOHy");

var $d0Gew = parcelRequire("d0Gew");

var $2QO3b = parcelRequire("2QO3b");

var $2gvG4 = parcelRequire("2gvG4");

var $mjinE = parcelRequire("mjinE");

var $bpkMB = parcelRequire("bpkMB");

var $14RSn = parcelRequire("14RSn");

var $ePvyd = parcelRequire("ePvyd");

var $bNexr = parcelRequire("bNexr");

var $bmoS1 = parcelRequire("bmoS1");

var $7wFII = parcelRequire("7wFII");

var $3ibpe = parcelRequire("3ibpe");

var $e9OSL = parcelRequire("e9OSL");
const $512cbef46162db63$var$isExtensions = (value)=>{
    return typeof value === 'object' && value !== null && 'gateway' in value && typeof value.gateway === 'object' && value.gateway !== null && 'trace_id' in value.gateway && typeof value.gateway.trace_id === 'string';
};
const $512cbef46162db63$var$isAGGResponse = (value)=>{
    return typeof value === 'object' && value !== null && ('jira' in value && typeof value.jira === 'object' && value.jira !== null || 'errors' in value && typeof value.errors === 'object');
};
const $512cbef46162db63$var$extractError = (response)=>{
    if (response.errors) return response.errors;
    for(const key in response.jira)if (response.jira[key]) {
        const value = response.jira[key];
        if (value.errors) return value.errors;
    }
    return [];
};
const $512cbef46162db63$var$stopCapturingAndGetTraceId = (mutationName)=>{
    const [extensions] = (0, $ePvyd.getExtensions)(mutationName);
    (0, $ePvyd.stopCapturingExtensions)(mutationName);
    return $512cbef46162db63$var$isExtensions(extensions) ? extensions.gateway.trace_id : 'unknown';
};
const $512cbef46162db63$var$isAbortableStatusCode = (statusCode)=>{
    return statusCode && statusCode >= 400 && statusCode < 500;
};
const $512cbef46162db63$var$stopCapturingAndGetMetaData = (mutationName, response, error)=>{
    const traceId = $512cbef46162db63$var$stopCapturingAndGetTraceId(mutationName);
    const aggError = error?.[0] || (response ? $512cbef46162db63$var$extractError(response)[0] : undefined);
    const statusCode = aggError?.extensions?.statusCode;
    const errorMessage = aggError?.message;
    return {
        traceId: traceId,
        errorMessage: errorMessage,
        statusCode: statusCode,
        aggError: aggError
    };
};
const $512cbef46162db63$var$maybeSendUFOErrorAndReleaseHold = (activeInteraction, ufoHoldCleanup, traceId, sendUFOEvent, hasError, statusCode, errorMessage)=>{
    if (sendUFOEvent) {
        if (hasError && activeInteraction?.ufoName) {
            (0, $2gvG4.addUFOCustomData)({
                traceId: traceId,
                statusCode: statusCode
            });
            (0, $bpkMB.setInteractionError)(activeInteraction?.ufoName, {
                errorMessage: errorMessage || 'unknown',
                name: errorMessage || 'unknown'
            });
        }
        ufoHoldCleanup?.();
    }
};
const $512cbef46162db63$export$316dd354b9e65dba = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const application = (0, $bNexr.useApplication)(projectKey, true);
    const edition = (0, $bNexr.useEdition)(projectKey, true);
    const analyticsSource = (0, $bmoS1.useAnalyticsSource)();
    const context = (0, $eJOHy.useContext)((0, $d0Gew.default));
    /**
	 * Enriches React Relay mutation commits with comprehensive experience monitoring and analytics.
	 *
	 * This function wraps Relay mutation configurations to automatically:
	 * - Capture gateway trace IDs for debugging
	 * - Send UFO (performance) events with error handling
	 * - Track experience analytics with success/failure states
	 * - Handle both AGG API responses and network errors
	 *
	 * @param commitArgs - The original React Relay mutation configuration
	 * @param mutationName - Unique identifier for the mutation (used for trace capture)
	 * @param options - Configuration object for monitoring behavior
	 * @param options.sendUFOEvent - Whether to send UFO performance events (default: false)
	 * @param options.additionalAttributes - Extra analytics attributes to include
	 * @param options.task - Experience name for analytics (string or function that takes success boolean)
	 * @param options.overrideAttributesCallback - !Use with CAUTION! Function to override entire analytics attributes based on error and success attributes
	 *   Called with (isSuccess, mandatoryAttributes, errorObjects) and should return additional attributes.
	 *   Use this to add context-specific data like field names, validation errors, or business logic results.
	 * @param shouldWrapWithAnalytics - Function to conditionally enable monitoring (default: () => true)
	 *
	 * @returns Enhanced configuration for Relay commit with monitoring wrapped around onCompleted/onError
	 *
	 * @example
	 * ```tsx
	 * const [commit] = useMutation(UpdateIssueMutation);
	 * const { enrichCommitWithIssueExperienceMonitoring } = useIssueExperienceMonitoring();
	 *
	 * const handleUpdate = () => {
	 *   commit(enrichCommitWithIssueExperienceMonitoring({
	 *     variables: { input: { issueId, status: 'Done' } },
	 *     onCompleted: (response) => console.log('Success!'),
	 *   }, 'updateIssueStatus', {
	 *     sendUFOEvent: true,
	 *     task: 'issue.update.status',
	 *     additionalAttributes: { statusType: 'Done' }
	 *   }));
	 * };
	 * ```
	 */ const enrichCommitWithIssueExperienceMonitoring = (0, $eJOHy.useCallback)((commitArgs, mutationName, { sendUFOEvent: sendUFOEvent, additionalAttributes: additionalAttributes, task: task, overrideAttributesCallback: overrideAttributesCallback } = {}, shouldWrapWithAnalytics = ()=>true)=>{
        if (!shouldWrapWithAnalytics()) return commitArgs;
        (0, $ePvyd.startCapturingExtensions)(mutationName);
        let activeInteraction;
        let ufoHoldCleanup;
        if (sendUFOEvent) {
            activeInteraction = (0, $2QO3b.getActiveInteraction)();
            ufoHoldCleanup = context?.hold(activeInteraction?.ufoName);
            (0, $2gvG4.addUFOCustomData)({
                application: (0, $mjinE.transformApplication)(application || null),
                edition: (0, $mjinE.transformEdition)(edition || null)
            });
        }
        const defaultExperienceArgs = {
            analyticsSource: analyticsSource || 'unknown',
            application: application || null,
            edition: edition || null,
            additionalAttributes: additionalAttributes
        };
        return {
            ...commitArgs,
            onCompleted: (response, error)=>{
                const aggResponse = $512cbef46162db63$var$isAGGResponse(response) ? response : undefined;
                const { traceId: traceId, aggError: aggError, errorMessage: errorMessage, statusCode: statusCode } = $512cbef46162db63$var$stopCapturingAndGetMetaData(mutationName, aggResponse, error);
                let action = 'taskSuccess';
                if (aggError) action = $512cbef46162db63$var$isAbortableStatusCode(statusCode) ? 'taskAbort' : 'taskFail';
                commitArgs.onCompleted?.(response, error);
                $512cbef46162db63$var$maybeSendUFOErrorAndReleaseHold(activeInteraction, ufoHoldCleanup, traceId, sendUFOEvent, !!aggError, statusCode, errorMessage);
                const additionalAttributesWithErrorProperties = {
                    ...additionalAttributes,
                    ...action !== 'taskSuccess' && {
                        traceId: traceId,
                        ...errorMessage !== undefined && {
                            errorMessage: errorMessage
                        },
                        ...statusCode !== undefined && {
                            statusCode: statusCode
                        }
                    }
                };
                const overrideAttributes = overrideAttributesCallback ? overrideAttributesCallback(!aggError, additionalAttributesWithErrorProperties, {}) : {};
                if (task || overrideAttributes?.task) (0, $3ibpe.sendExperienceAnalytics)({
                    ...defaultExperienceArgs,
                    experience: task || String(overrideAttributes?.task),
                    action: action,
                    additionalAttributes: additionalAttributesWithErrorProperties,
                    ...overrideAttributes
                });
            },
            onError: (error)=>{
                const traceId = $512cbef46162db63$var$stopCapturingAndGetTraceId(mutationName);
                const aggError = (0, $e9OSL.extractFirstErrorFromRelayError)(error);
                const errorMessage = aggError?.message || error?.message;
                const statusCode = (0, $14RSn.isFetchError)(error) ? error?.statusCode : aggError?.statusCode;
                const hasError = !!aggError || !!(0, $14RSn.isFetchError)(error);
                const action = (0, $7wFII.isAbortableError)(error) || $512cbef46162db63$var$isAbortableStatusCode(statusCode) ? 'taskAbort' : 'taskFail';
                commitArgs.onError?.(error);
                $512cbef46162db63$var$maybeSendUFOErrorAndReleaseHold(activeInteraction, ufoHoldCleanup, traceId, sendUFOEvent, hasError, statusCode, errorMessage);
                const overrideAttributes = overrideAttributesCallback ? overrideAttributesCallback(false, additionalAttributes, {
                    aggError: aggError,
                    networkError: hasError,
                    statusCode: statusCode,
                    rawError: error
                }) : {};
                if (task || overrideAttributes?.task) (0, $3ibpe.sendExperienceAnalytics)({
                    ...defaultExperienceArgs,
                    experience: task || String(overrideAttributes.task),
                    action: action,
                    additionalAttributes: {
                        ...additionalAttributes,
                        traceId: traceId,
                        ...errorMessage !== undefined && {
                            errorMessage: errorMessage
                        },
                        ...statusCode !== undefined && {
                            statusCode: statusCode
                        }
                    },
                    ...overrideAttributes
                });
            }
        };
    }, [
        analyticsSource,
        application,
        edition,
        context
    ]);
    return {
        enrichCommitWithIssueExperienceMonitoring: enrichCommitWithIssueExperienceMonitoring
    };
};

});
parcelRegister("7wFII", function(module, exports) {
$parcel$export(module.exports, "isAbortableError", () => $a93b392b7e4fefa9$export$e05e0fb17c2ab75a);

var $6NFx3 = parcelRequire("6NFx3");

var $9Dhvc = parcelRequire("9Dhvc");

var $14RSn = parcelRequire("14RSn");

var $dMM78 = parcelRequire("dMM78");

var $4cTDP = parcelRequire("4cTDP");
const $a93b392b7e4fefa9$export$e05e0fb17c2ab75a = (error)=>{
    const statusCode = $a93b392b7e4fefa9$var$extractStatusCode(error);
    if ((0, $dMM78.isHttpClientErrorStatusCode)(statusCode) || !statusCode && (0, $dMM78.isClientFetchError)(error) || error?.name === (0, $14RSn.VALIDATION_ERROR_NAME)) return true;
    return false;
};
const $a93b392b7e4fefa9$var$getStatusCodeFromGraphQLErrors = (graphQLErrors)=>{
    const statusCodes = graphQLErrors.map((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(e, [
            'extensions',
            'statusCode'
        ])).filter((statusCode)=>!!statusCode);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($6NFx3)))(statusCodes);
    return statusCode || null;
};
const $a93b392b7e4fefa9$var$extractStatusCode = (error)=>{
    const errorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'statusCode'
    ], null);
    const graphQLErrors = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'graphQLErrors'
    ], null);
    const networkError = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'networkError'
    ], null);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(networkError, [
        'statusCode'
    ], null);
    const relayErrors = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'source',
        'errors'
    ], null);
    if (typeof errorStatusCode === 'number') return errorStatusCode;
    if (typeof statusCode === 'number') return statusCode;
    if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) return $a93b392b7e4fefa9$var$getStatusCodeFromGraphQLErrors(graphQLErrors);
    if (Array.isArray(relayErrors) && relayErrors.length > 0 && (0, $4cTDP.fg)('improve_abortable_errors_experience_tracker')) return $a93b392b7e4fefa9$var$getStatusCodeFromGraphQLErrors(relayErrors);
    return null;
};

});
parcelRegister("6NFx3", function(module, exports) {

var $dbOsL = parcelRequire("dbOsL");

var $9wRNl = parcelRequire("9wRNl");

var $d7YnM = parcelRequire("d7YnM");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $4f3789168d11a4da$var$max(array) {
    return array && array.length ? $dbOsL(array, $d7YnM, $9wRNl) : undefined;
}
module.exports = $4f3789168d11a4da$var$max;

});
parcelRegister("dbOsL", function(module, exports) {

var $9D78T = parcelRequire("9D78T");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $99a3725aea015bd0$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$9D78T(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $99a3725aea015bd0$var$baseExtremum;

});

parcelRegister("9wRNl", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $6f00d4c0b88cefe1$var$baseGt(value, other) {
    return value > other;
}
module.exports = $6f00d4c0b88cefe1$var$baseGt;

});



parcelRegister("e9OSL", function(module, exports) {
$parcel$export(module.exports, "useFieldExperienceTracking", () => $4a9350ba25b6d2c6$export$94c85d2216d24740);
$parcel$export(module.exports, "extractFirstErrorFromRelayError", () => $4a9350ba25b6d2c6$export$1e49248e7b3f98d6);
/**
 * Based on jira/src/packages/issue/issue-view/src/epics/experience-tracking/field-experience-tracking-epic.tsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $7wFII = parcelRequire("7wFII");

var $bmoS1 = parcelRequire("bmoS1");

var $3ibpe = parcelRequire("3ibpe");

var $bNexr = parcelRequire("bNexr");
const $4a9350ba25b6d2c6$export$94c85d2216d24740 = ({ fieldId: fieldId })=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const application = (0, $bNexr.useApplication)(projectKey, true);
    const edition = (0, $bNexr.useEdition)(projectKey, true);
    const analyticsSource = (0, $bmoS1.useAnalyticsSource)();
    const getEditEventPayload = (0, $eJOHy.useCallback)(({ hasSuccess: hasSuccess, hasEdit: hasEdit, errorMessage: errorMessage, traceId: traceId, statusCode: statusCode, action: action })=>{
        const additionalAttributes = {};
        if (errorMessage != null) additionalAttributes.errorMessage = errorMessage;
        if (traceId != null) additionalAttributes.traceId = traceId;
        if (statusCode) additionalAttributes.statusCode = statusCode;
        return {
            experience: 'editIssue',
            analyticsSource: analyticsSource || 'unknown',
            application: application || null,
            edition: edition || null,
            wasExperienceSuccesful: hasSuccess,
            field: fieldId,
            hasEdit: hasEdit,
            additionalAttributes: additionalAttributes,
            action: action
        };
    }, [
        analyticsSource,
        application,
        edition,
        fieldId
    ]);
    const sendSubmitSucceededExperienceEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $3ibpe.sendExperienceAnalytics)(getEditEventPayload({
            hasSuccess: true,
            hasEdit: true
        }));
    }, [
        getEditEventPayload
    ]);
    const sendSubmitFailedExperienceEvent = (0, $eJOHy.useCallback)((error)=>{
        if (!error) return;
        const match = error?.message?.match(/response: (\d+)/);
        const statusCode = match ? parseInt(match[1], 10) : undefined;
        if (statusCode && statusCode >= 400 && statusCode < 500) (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'issue.issue-view.editIssue',
                teamName: 'obsidian'
            },
            attributes: {
                experience: 'editIssue',
                analyticsSource: analyticsSource || 'unknown',
                application: application || null,
                edition: edition || null,
                wasExperienceSuccesful: false,
                field: fieldId,
                hasEdit: true,
                traceId: 'traceId' in error ? String(error?.traceId) : undefined
            }
        });
        const action = (0, $7wFII.isAbortableError)(error) ? 'taskAbort' : 'taskFail';
        (0, $3ibpe.sendExperienceAnalytics)(getEditEventPayload({
            hasSuccess: (0, $7wFII.isAbortableError)(error),
            hasEdit: true,
            errorMessage: 'statusCode' in error ? `${error.statusCode} - ${error.message}` : error.message,
            traceId: 'traceId' in error ? String(error?.traceId) : undefined,
            statusCode: 'statusCode' in error && typeof error?.statusCode === 'number' ? error.statusCode : undefined,
            action: action
        }));
    }, [
        getEditEventPayload,
        analyticsSource,
        application,
        edition,
        fieldId
    ]);
    const sendEditCancelExperienceEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $3ibpe.sendExperienceAnalytics)(getEditEventPayload({
            hasSuccess: true,
            hasEdit: false
        }));
    }, [
        getEditEventPayload
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            sendSubmitSucceededExperienceEvent: sendSubmitSucceededExperienceEvent,
            sendSubmitFailedExperienceEvent: sendSubmitFailedExperienceEvent,
            sendEditCancelExperienceEvent: sendEditCancelExperienceEvent
        }), [
        sendEditCancelExperienceEvent,
        sendSubmitFailedExperienceEvent,
        sendSubmitSucceededExperienceEvent
    ]);
};
const $4a9350ba25b6d2c6$export$1e49248e7b3f98d6 = (error)=>{
    if (!('source' in error)) return null;
    const errorSource = error.source;
    const errors = typeof errorSource === 'object' && errorSource != null && 'errors' in errorSource && errorSource.errors;
    const firstError = Array.isArray(errors) ? errors[0] : null;
    const statusCode = firstError?.extensions?.statusCode;
    const message = firstError?.message;
    return statusCode ? {
        statusCode: statusCode,
        message: message
    } : null;
};

});


parcelRegister("k745d", function(module, exports) {
$parcel$export(module.exports, "useDateValidator", () => $8853f60cb6101294$export$bb028423d75e7237);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $cwGo1 = parcelRequire("cwGo1");
const $8853f60cb6101294$export$bb028423d75e7237 = (fieldName, isRequired)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const submit = (0, $eJOHy.useCallback)((value)=>{
        if (isRequired && (!value || value.trim().length === 0)) return {
            type: 'error',
            message: formatMessage((0, $cwGo1.messages).requiredErrorMessage, {
                fieldName: fieldName
            })
        };
        return null;
    }, [
        fieldName,
        formatMessage,
        isRequired
    ]);
    return {
        submit: submit
    };
};

});
parcelRegister("cwGo1", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a28e04ebf5c72bb6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $a28e04ebf5c72bb6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    requiredErrorMessage: {
        "id": "issue-field-date-inline-edit-full.date.required-error-message",
        "defaultMessage": "{fieldName} is required"
    }
});

});




parcelRegister("dQN02", function(module, exports) {
$parcel$export(module.exports, "DateTimeCell", () => $2f1fdd96ec7a68b5$export$372b87ceae2922a4);

var $XccP9 = parcelRequire("XccP9");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $aIRHL = parcelRequire("aIRHL");

var $j8Km1 = parcelRequire("j8Km1");

var $4cTDP = parcelRequire("4cTDP");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $2f1fdd96ec7a68b5$export$372b87ceae2922a4 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $XccP9.default), fieldRef);
    const isCreatedOrUpdated = data.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).CREATED || data.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).UPDATED;
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isInlineEditingSupported = !isCreatedOrUpdated && isInlineEditingExtendedFieldSupportEnabled;
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    // We can also disable editability of the created/updated fields as they are never editable.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingSupported ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIRHL.DateTimeInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $2f1fdd96ec7a68b5$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isAutoFocusFixEnabled: true,
        shouldRenderHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIRHL.DateTimeInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isAutoFocusFixEnabled: true,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $2f1fdd96ec7a68b5$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $2f1fdd96ec7a68b5$var$customTargetStyles : $2f1fdd96ec7a68b5$var$customTargetStylesOld,
        ref: ref
    });
});
const $2f1fdd96ec7a68b5$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $2f1fdd96ec7a68b5$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("XccP9", function(module, exports) {
$parcel$export(module.exports, "default", () => $250a1d8cd2cb6225$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<713daee6cb5caf5614ea1870c045f17f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $250a1d8cd2cb6225$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "DateTimeCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$250a1d8cd2cb6225$var$node.hash = "cd275eca12ae208ba73a8e77c5e6c544";
var $250a1d8cd2cb6225$export$2e2bcd8739ae039 = $250a1d8cd2cb6225$var$node;

});

parcelRegister("aIRHL", function(module, exports) {
$parcel$export(module.exports, "DateTimeInlineEditViewWithIsEditable", () => $03d97e1e763124f7$export$40278230a655efcf);
$parcel$export(module.exports, "DateTimeInlineEditView", () => $03d97e1e763124f7$export$2044e876297ff5d7);

var $1IIld = parcelRequire("1IIld");

var $dp8AU = parcelRequire("dp8AU");

var $eRTQU = parcelRequire("eRTQU");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $4EKqI = parcelRequire("4EKqI");

var $cxKOj = parcelRequire("cxKOj");

var $gQeix = parcelRequire("gQeix");

var $b3Emp = parcelRequire("b3Emp");

var $auNLL = parcelRequire("auNLL");

var $1M2hR = parcelRequire("1M2hR");

var $iw2hI = parcelRequire("iw2hI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $bJscI = parcelRequire("bJscI");

var $3wIGE = parcelRequire("3wIGE");
const $03d97e1e763124f7$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-date-time-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $03d97e1e763124f7$export$40278230a655efcf = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, timeZone: timeZone, isAutoFocusFixEnabled: isAutoFocusFixEnabled, readViewDateOnlyFormat: readViewDateOnlyFormat, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $eRTQU.default), fragmentRef);
    const { id: uniqueFieldId, fieldId: fieldId, name: fieldName, type: type, dateTime: dateTime } = data;
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $dp8AU.default));
    // #endregion
    // #region Common state
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const locale = (0, $1M2hR.useLocale)();
    const initialValue = dateTime ?? null;
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overriding.overrideIsEditable(isEditable), [
        isEditable,
        overriding
    ]);
    // #endregion
    // #region Handle new value
    const handleSubmit = (0, $eJOHy.useCallback)((newDateTime, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newDateTime);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        datetime: newDateTime ?? null,
                        operation: 'SET'
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateDateTimeField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateDateTimeField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            dateTime: newDateTime
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        clipboardComponentType: 'dateTime'
    });
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($03d97e1e763124f7$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b3Emp.DateTimeReadView), {
            fragmentRef: data,
            timeZone: timeZone,
            isDateOnlyFormat: readViewDateOnlyFormat,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        })), [
        data,
        timeZone,
        readViewDateOnlyFormat,
        shouldRenderHoverPopover
    ]);
    // #endregion
    // #region Edit view
    const timePlaceholder = (0, $eJOHy.useMemo)(()=>{
        const standardizedLocale = (0, $iw2hI.standardizeLocale)(locale);
        return (0, $3wIGE.getNext30MinuteInterval)(undefined, standardizedLocale);
    }, [
        locale
    ]);
    const datePlaceholder = (0, $eJOHy.useMemo)(()=>{
        let formattedDate = '';
        try {
            formattedDate = (0, $3wIGE.getFormattedDate)(locale);
        } catch (dateFormatError) {
            (0, $9pTd3.fireErrorAnalytics)({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: dateFormatError,
                meta: {
                    packageName: 'dateTimeFieldInlineEdit',
                    id: 'formatDateError'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return formattedDate;
    }, [
        locale
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: isAutoFocusFixEnabled,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            timeZone: timeZone,
            ...(0, $cxKOj.expValEquals)('jira_issue_view_date_time_picker_experiment_new', 'isEnabled', true) ? {
                autoFocus: true,
                spacing: spacing,
                datePlaceholder: datePlaceholder,
                timePlaceholder: timePlaceholder
            } : {}
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewEntryPoint: (0, $gQeix.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
};
const $03d97e1e763124f7$export$2044e876297ff5d7 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $1IIld.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($03d97e1e763124f7$export$40278230a655efcf, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("1IIld", function(module, exports) {
$parcel$export(module.exports, "default", () => $178e803523ac2a4d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<49f946ae62813e18b283e25b40bb99be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $178e803523ac2a4d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraDateTimePickerField"
};
$178e803523ac2a4d$var$node.hash = "3ebe6796584f81815d1e09db6e20b21f";
var $178e803523ac2a4d$export$2e2bcd8739ae039 = $178e803523ac2a4d$var$node;

});

parcelRegister("dp8AU", function(module, exports) {
$parcel$export(module.exports, "default", () => $166e51463a12ab6a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<35b0d1b8dda4ba883b598557010413d2>>
 * @relayHash b962bde817ae9133f076383673744639
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52b99b4d5da7ae41fc7cea0050d5a473435a64cac29f4d8502862f446fbffbc0
const $166e51463a12ab6a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "dateTime"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "dateTime_issueFieldDateTime_DateTimeField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateTimeFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateTimeField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraDateTimePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "dateTime_issueFieldDateTime_DateTimeField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateTimeFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateTimeField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraDateTimePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "52b99b4d5da7ae41fc7cea0050d5a473435a64cac29f4d8502862f446fbffbc0",
            "metadata": {},
            "name": "dateTime_issueFieldDateTime_DateTimeField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$166e51463a12ab6a$var$node.hash = "e0c0e1ca810b79fb98a05142a47ace9e";
var $166e51463a12ab6a$export$2e2bcd8739ae039 = $166e51463a12ab6a$var$node;

});

parcelRegister("eRTQU", function(module, exports) {
$parcel$export(module.exports, "default", () => $488783d46b87ccd1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf046c3fc1d1cb9d3c8a8b0339c689f5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $488783d46b87ccd1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "dateTime"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$488783d46b87ccd1$var$node.hash = "e7911508d34079b211453d8cdb4bbc3d";
var $488783d46b87ccd1$export$2e2bcd8739ae039 = $488783d46b87ccd1$var$node;

});

parcelRegister("gQeix", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef2e1b73562b3d0c$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $ef2e1b73562b3d0c$var$DateTimeEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("cClR4")), {
        moduleId: "60a5161a",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $ef2e1b73562b3d0c$export$2e2bcd8739ae039 = $ef2e1b73562b3d0c$var$DateTimeEditViewEntryPoint;

});
parcelRegister("cClR4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aF0RO").then(()=>parcelRequire('ejuPL'));

});


parcelRegister("b3Emp", function(module, exports) {
$parcel$export(module.exports, "DateTimeReadView", () => $4ca1d1549d29cfd8$export$962e920a3f993096);

var $clFuC = parcelRequire("clFuC");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $d9T1A = parcelRequire("d9T1A");

var $3NHJr = parcelRequire("3NHJr");

var $k6Nau = parcelRequire("k6Nau");

var $3OT15 = parcelRequire("3OT15");

var $3Lkm9 = parcelRequire("3Lkm9");
const $4ca1d1549d29cfd8$export$962e920a3f993096 = (props)=>{
    const { fragmentRef: fragmentRef, timeZone: overrideTimeZone, isDateOnlyFormat: isDateOnlyFormat = false, shouldRenderHoverPopover: shouldRenderHoverPopover = false } = props;
    const data = (0, $j4oe4.useFragment)((0, $clFuC.default), fragmentRef);
    const { dateTime: dateTime } = data || {};
    const { formatDateTime: formatDateTime, formatDateOnly: formatDateOnly } = (0, $3NHJr.useDateTimeFormatter)(overrideTimeZone);
    const hoverPopoverRefFactory = shouldRenderHoverPopover ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data?.id) : null;
    let hoverPopoverRef = null;
    const isBespokeEmptyFieldTextGA = (0, $k6Nau.useBespokeEmptyFieldTextGA)();
    if (!dateTime) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), isBespokeEmptyFieldTextGA && {
        placeholderText: (0, $3Lkm9.default).bespokenDateTimePlaceholderEmptyFieldText
    });
    let content;
    try {
        content = isDateOnlyFormat ? formatDateOnly(dateTime) : formatDateTime(dateTime);
    } catch (err) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    }
    if (shouldRenderHoverPopover && dateTime) {
        if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
            content: content
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            maxLines: 1,
            ref: hoverPopoverRef
        }, content);
    }
    return content;
};

});
parcelRegister("clFuC", function(module, exports) {
$parcel$export(module.exports, "default", () => $e65e99f2ede64b79$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f43566eb6285cd6f11a8e08e8d33a3be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e65e99f2ede64b79$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "dateTime"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$e65e99f2ede64b79$var$node.hash = "60be07d95cc7946b937010e24a94ffe0";
var $e65e99f2ede64b79$export$2e2bcd8739ae039 = $e65e99f2ede64b79$var$node;

});


parcelRegister("3wIGE", function(module, exports) {
$parcel$export(module.exports, "getNext30MinuteInterval", () => $9162a9d29e7f73f1$export$84c10da5aad3dff1);
$parcel$export(module.exports, "getFormattedDate", () => $9162a9d29e7f73f1$export$92521769c5df59ad);

var $57raR = parcelRequire("57raR");
var $ibLUB = parcelRequire("ibLUB");
var $cT05m = parcelRequire("cT05m");

var $2Jz68 = parcelRequire("2Jz68");

var $dO9h7 = parcelRequire("dO9h7");
function $9162a9d29e7f73f1$var$getLocalisedTimeString(intervalTime, intervalString, userLocale) {
    if (userLocale) {
        const normalizedLocale = userLocale.replace(/_/g, '-');
        return new Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(intervalTime);
    }
    return intervalString;
}
function $9162a9d29e7f73f1$export$84c10da5aad3dff1(date, userLocale) {
    // Get the current date and time
    const now = date ?? new Date();
    // Format current time to 'HH:mm'
    const currentTime = (0, $57raR.default)(now, 'HH:mm');
    // Find the next interval
    for (const interval of (0, $2Jz68.default)){
        // Parse the interval time to a Date object
        const intervalTime = (0, $cT05m.default)(interval, 'HH:mm', now);
        // Check if the interval is after the current time
        if ((0, $ibLUB.default)(intervalTime, now) || interval === currentTime) return $9162a9d29e7f73f1$var$getLocalisedTimeString(intervalTime, interval, userLocale);
    }
    const intervalTime = (0, $cT05m.default)((0, $2Jz68.default)[0], 'HH:mm', now);
    // If no interval is found that is after the current time, return the first interval of the next day
    return $9162a9d29e7f73f1$var$getLocalisedTimeString(intervalTime, (0, $2Jz68.default)[0], userLocale);
}
const $9162a9d29e7f73f1$export$92521769c5df59ad = (userLocale)=>{
    return (0, $dO9h7.formatWithLocale)(new Date(), 'P', userLocale);
};

});
parcelRegister("2Jz68", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7849d24320f1c75$export$2e2bcd8739ae039);
const $c7849d24320f1c75$var$availableTimes = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];
var $c7849d24320f1c75$export$2e2bcd8739ae039 = $c7849d24320f1c75$var$availableTimes;

});




parcelRegister("l17Xm", function(module, exports) {
$parcel$export(module.exports, "EpicLinkCell", () => $bb6aace6a451e72f$export$6c1071448075813f);

var $kFvsf = parcelRequire("kFvsf");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $4cTDP = parcelRequire("4cTDP");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $8URAw = parcelRequire("8URAw");

var $1wTTU = parcelRequire("1wTTU");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");

var $bBiKm = parcelRequire("bBiKm");
const $bb6aace6a451e72f$var$getLozengeThemes = (0, $1wTTU.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $bb6aace6a451e72f$var$getLozengeThemeByColor = (color = (0, $8URAw.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $bb6aace6a451e72f$var$getLozengeThemes[color] ?? $bb6aace6a451e72f$var$getLozengeThemes[0, $8URAw.DEFAULT_EPIC_COLOR]; // type assertion is fine as the record key is of type Color
const $bb6aace6a451e72f$var$findColor = (color)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys((0, $8URAw.MAP_COLOR_TO_AK_COLOR)).find((key)=>(0, $8URAw.MAP_COLOR_TO_AK_COLOR)[key] === color);
const $bb6aace6a451e72f$export$6c1071448075813f = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { epic: epic } = (0, $j4oe4.useFragment)((0, $kFvsf.default), fieldRef);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)(); /**
                                                                           * As part of the initiative to remove "Epic Link" and "Parent Link" fields from Jira,
                                                                           * we're rendering a "Replaced by Parent field" deprecation message in the "Epic Link" cell.
                                                                           * At the time of writing this comment, "Epic Link" is still used in ~6% of issue tables, and
                                                                           * we hope this message will help these users migrate and use the "Parent" field from now on.
                                                                           */ 
    if ((0, $4cTDP.fg)('replace-epic-parent-link-by-depreca-message-in-nin')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "span",
        color: "color.text.subtlest",
        maxLines: isSingleLineRowHeightEnabled ? 1 : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $bBiKm.default).replacedByParentField,
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                    as: "strong"
                }, chunks)
        }
    }));
    if (!epic) return null;
    if (epic.key == null || epic.summary == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "epicLink",
        reason: "Missing required fields"
    });
    const epicColor = (0, $1wTTU.asColor)(epic.color);
    const tagColor = (0, $8URAw.MAP_COLOR_TO_AK_COLOR)[epicColor];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bb6aace6a451e72f$var$TagWrapper, {
        href: `/browse/${epic.key}`,
        "aria-label": `${formatMessage((0, $bBiKm.default).epicTitle)} ${epic.summary}`,
        style: $bb6aace6a451e72f$var$getLozengeThemeByColor($bb6aace6a451e72f$var$findColor(tagColor)),
        onClick: ()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'tableIssueLink');
        }
    }, epic.summary);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb6aace6a451e72f$var$TagWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _1reo15vq _18m915vq _2rkofajl _1e0c1o8l _s7n4nkob _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _vwz4kb7n _1bto1l2s _o5721q9c _p12f1osq _vchhusvi _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kFvsf", function(module, exports) {
$parcel$export(module.exports, "default", () => $cea7339fdc2bb203$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a56aaf62e03d0f4bfd42e5aa14827ccf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cea7339fdc2bb203$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "EpicLinkCell",
    "selections": [
        {
            "concreteType": "JiraEpic",
            "kind": "LinkedField",
            "name": "epic",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "summary"
                },
                {
                    "kind": "ScalarField",
                    "name": "color"
                }
            ]
        }
    ],
    "type": "JiraEpicLinkField"
};
$cea7339fdc2bb203$var$node.hash = "cbc046611b6b7cab39bbe7c2ae02d46d";
var $cea7339fdc2bb203$export$2e2bcd8739ae039 = $cea7339fdc2bb203$var$node;

});

parcelRegister("8URAw", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $f89c7f0e34657bc4$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $f89c7f0e34657bc4$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $f89c7f0e34657bc4$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $f89c7f0e34657bc4$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $f89c7f0e34657bc4$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $f89c7f0e34657bc4$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $f89c7f0e34657bc4$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $f89c7f0e34657bc4$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $f89c7f0e34657bc4$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $f89c7f0e34657bc4$export$82fc3b0b98905453);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $f89c7f0e34657bc4$export$92b6aebfb522f0d9);

var $2IQEX = parcelRequire("2IQEX");


var $38IWH = parcelRequire("38IWH");
const $f89c7f0e34657bc4$export$c2357bec51c5cf5b = 'PURPLE';
const $f89c7f0e34657bc4$export$db33d74b098e3da9 = {
    [(0, $38IWH.PURPLE)]: "var(--ds-background-accent-purple-subtle, #C97CF4)",
    [(0, $38IWH.BLUE)]: "var(--ds-background-accent-blue-subtle, #669DF1)",
    [(0, $38IWH.GREEN)]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $38IWH.TEAL)]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $38IWH.YELLOW)]: "var(--ds-background-accent-yellow-subtle, #EED12B)",
    [(0, $38IWH.ORANGE)]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $38IWH.GREY)]: "var(--ds-background-accent-gray-subtle, #8C8F97)",
    [(0, $38IWH.DARK_PURPLE)]: "var(--ds-background-accent-purple-bolder, #964AC0)",
    [(0, $38IWH.DARK_BLUE)]: "var(--ds-background-accent-blue-bolder, #1868DB)",
    [(0, $38IWH.DARK_GREEN)]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $38IWH.DARK_TEAL)]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $38IWH.DARK_YELLOW)]: "var(--ds-background-accent-orange-bolder, #BD5B00)",
    [(0, $38IWH.DARK_ORANGE)]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $38IWH.DARK_GREY)]: "var(--ds-background-accent-gray-bolder, #6B6E76)"
};
const $f89c7f0e34657bc4$export$fc5fe4213a5703f1 = {
    [(0, $7bb4c1736002a04a$exports).P200]: "var(--ds-background-accent-purple-subtle, #C97CF4)",
    [(0, $7bb4c1736002a04a$exports).B200]: "var(--ds-background-accent-blue-subtle, #669DF1)",
    [(0, $7bb4c1736002a04a$exports).G200]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $7bb4c1736002a04a$exports).T200]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $7bb4c1736002a04a$exports).Y200]: "var(--ds-background-accent-yellow-subtle, #EED12B)",
    [(0, $7bb4c1736002a04a$exports).R200]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $7bb4c1736002a04a$exports).N200]: "var(--ds-background-accent-gray-subtle, #8C8F97)",
    [(0, $7bb4c1736002a04a$exports).P400]: "var(--ds-background-accent-purple-bolder, #964AC0)",
    [(0, $7bb4c1736002a04a$exports).B400]: "var(--ds-background-accent-blue-bolder, #1868DB)",
    [(0, $7bb4c1736002a04a$exports).G400]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $7bb4c1736002a04a$exports).T400]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $7bb4c1736002a04a$exports).Y400]: "var(--ds-background-accent-orange-bolder, #BD5B00)",
    [(0, $7bb4c1736002a04a$exports).R400]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $7bb4c1736002a04a$exports).N700]: "var(--ds-background-accent-gray-bolder, #6B6E76)"
};
const $f89c7f0e34657bc4$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))($f89c7f0e34657bc4$export$db33d74b098e3da9);
const $f89c7f0e34657bc4$export$43264b0781f10167 = {
    [(0, $38IWH.SERVER_PURPLE)]: (0, $38IWH.PURPLE),
    [(0, $38IWH.SERVER_DARK_PURPLE)]: (0, $38IWH.DARK_PURPLE),
    [(0, $38IWH.SERVER_BLUE)]: (0, $38IWH.BLUE),
    [(0, $38IWH.SERVER_DARK_BLUE)]: (0, $38IWH.DARK_BLUE),
    [(0, $38IWH.SERVER_GREEN)]: (0, $38IWH.GREEN),
    [(0, $38IWH.SERVER_DARK_GREEN)]: (0, $38IWH.DARK_GREEN),
    [(0, $38IWH.SERVER_TEAL)]: (0, $38IWH.TEAL),
    [(0, $38IWH.SERVER_DARK_TEAL)]: (0, $38IWH.DARK_TEAL),
    [(0, $38IWH.SERVER_YELLOW)]: (0, $38IWH.YELLOW),
    [(0, $38IWH.SERVER_DARK_YELLOW)]: (0, $38IWH.DARK_YELLOW),
    [(0, $38IWH.SERVER_ORANGE)]: (0, $38IWH.ORANGE),
    [(0, $38IWH.SERVER_DARK_ORANGE)]: (0, $38IWH.DARK_ORANGE),
    [(0, $38IWH.SERVER_GREY)]: (0, $38IWH.GREY),
    [(0, $38IWH.SERVER_DARK_GREY)]: (0, $38IWH.DARK_GREY)
};
const $f89c7f0e34657bc4$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))($f89c7f0e34657bc4$export$43264b0781f10167);
const $f89c7f0e34657bc4$export$fb5d051fe1b2bccc = {
    [(0, $38IWH.GHX_LABEL_1)]: (0, $38IWH.DARK_GREY),
    [(0, $38IWH.GHX_LABEL_2)]: (0, $38IWH.DARK_YELLOW),
    [(0, $38IWH.GHX_LABEL_3)]: (0, $38IWH.YELLOW),
    [(0, $38IWH.GHX_LABEL_4)]: (0, $38IWH.DARK_BLUE),
    [(0, $38IWH.GHX_LABEL_5)]: (0, $38IWH.DARK_TEAL),
    [(0, $38IWH.GHX_LABEL_6)]: (0, $38IWH.GREEN),
    [(0, $38IWH.GHX_LABEL_7)]: (0, $38IWH.PURPLE),
    [(0, $38IWH.GHX_LABEL_8)]: (0, $38IWH.DARK_PURPLE),
    [(0, $38IWH.GHX_LABEL_9)]: (0, $38IWH.ORANGE),
    [(0, $38IWH.GHX_LABEL_10)]: (0, $38IWH.BLUE),
    [(0, $38IWH.GHX_LABEL_11)]: (0, $38IWH.TEAL),
    [(0, $38IWH.GHX_LABEL_12)]: (0, $38IWH.GREY),
    [(0, $38IWH.GHX_LABEL_13)]: (0, $38IWH.DARK_GREEN),
    [(0, $38IWH.GHX_LABEL_14)]: (0, $38IWH.DARK_ORANGE)
};
const $f89c7f0e34657bc4$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))($f89c7f0e34657bc4$export$fb5d051fe1b2bccc);
const $f89c7f0e34657bc4$export$994d3ffa39be04fd = {
    [(0, $38IWH.AGILE_COLOR_1)]: (0, $38IWH.DARK_GREY),
    [(0, $38IWH.AGILE_COLOR_2)]: (0, $38IWH.DARK_YELLOW),
    [(0, $38IWH.AGILE_COLOR_3)]: (0, $38IWH.YELLOW),
    [(0, $38IWH.AGILE_COLOR_4)]: (0, $38IWH.DARK_BLUE),
    [(0, $38IWH.AGILE_COLOR_5)]: (0, $38IWH.DARK_TEAL),
    [(0, $38IWH.AGILE_COLOR_6)]: (0, $38IWH.GREEN),
    [(0, $38IWH.AGILE_COLOR_7)]: (0, $38IWH.PURPLE),
    [(0, $38IWH.AGILE_COLOR_8)]: (0, $38IWH.DARK_PURPLE),
    [(0, $38IWH.AGILE_COLOR_9)]: (0, $38IWH.ORANGE),
    [(0, $38IWH.AGILE_COLOR_10)]: (0, $38IWH.BLUE),
    [(0, $38IWH.AGILE_COLOR_11)]: (0, $38IWH.TEAL),
    [(0, $38IWH.AGILE_COLOR_12)]: (0, $38IWH.GREY),
    [(0, $38IWH.AGILE_COLOR_13)]: (0, $38IWH.DARK_GREEN),
    [(0, $38IWH.AGILE_COLOR_14)]: (0, $38IWH.DARK_ORANGE)
};
const $f89c7f0e34657bc4$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))($f89c7f0e34657bc4$export$994d3ffa39be04fd);
const $f89c7f0e34657bc4$export$1fdd5a248b5f697c = {
    [(0, $38IWH.GHX_LABEL_1)]: (0, $38IWH.AGILE_COLOR_1),
    [(0, $38IWH.GHX_LABEL_2)]: (0, $38IWH.AGILE_COLOR_2),
    [(0, $38IWH.GHX_LABEL_3)]: (0, $38IWH.AGILE_COLOR_3),
    [(0, $38IWH.GHX_LABEL_4)]: (0, $38IWH.AGILE_COLOR_4),
    [(0, $38IWH.GHX_LABEL_5)]: (0, $38IWH.AGILE_COLOR_5),
    [(0, $38IWH.GHX_LABEL_6)]: (0, $38IWH.AGILE_COLOR_6),
    [(0, $38IWH.GHX_LABEL_7)]: (0, $38IWH.AGILE_COLOR_7),
    [(0, $38IWH.GHX_LABEL_8)]: (0, $38IWH.AGILE_COLOR_8),
    [(0, $38IWH.GHX_LABEL_9)]: (0, $38IWH.AGILE_COLOR_9),
    [(0, $38IWH.GHX_LABEL_10)]: (0, $38IWH.AGILE_COLOR_10),
    [(0, $38IWH.GHX_LABEL_11)]: (0, $38IWH.AGILE_COLOR_11),
    [(0, $38IWH.GHX_LABEL_12)]: (0, $38IWH.AGILE_COLOR_12),
    [(0, $38IWH.GHX_LABEL_13)]: (0, $38IWH.AGILE_COLOR_13),
    [(0, $38IWH.GHX_LABEL_14)]: (0, $38IWH.AGILE_COLOR_14)
};
const $f89c7f0e34657bc4$export$82fc3b0b98905453 = {
    [(0, $38IWH.DARK_GREY)]: 'grey',
    [(0, $38IWH.DARK_YELLOW)]: 'yellow',
    [(0, $38IWH.YELLOW)]: 'yellowLight',
    [(0, $38IWH.DARK_BLUE)]: 'blue',
    [(0, $38IWH.DARK_TEAL)]: 'teal',
    [(0, $38IWH.GREEN)]: 'greenLight',
    [(0, $38IWH.PURPLE)]: 'purpleLight',
    [(0, $38IWH.DARK_PURPLE)]: 'purple',
    [(0, $38IWH.ORANGE)]: 'redLight',
    [(0, $38IWH.BLUE)]: 'blueLight',
    [(0, $38IWH.TEAL)]: 'tealLight',
    [(0, $38IWH.GREY)]: 'greyLight',
    [(0, $38IWH.DARK_GREEN)]: 'green',
    [(0, $38IWH.DARK_ORANGE)]: 'red'
};
const $f89c7f0e34657bc4$export$703aca53c431bb88 = {
    [(0, $38IWH.AGILE_COLOR_1)]: 'grey',
    [(0, $38IWH.AGILE_COLOR_2)]: 'yellow',
    [(0, $38IWH.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $38IWH.AGILE_COLOR_4)]: 'blue',
    [(0, $38IWH.AGILE_COLOR_5)]: 'teal',
    [(0, $38IWH.AGILE_COLOR_6)]: 'greenLight',
    [(0, $38IWH.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $38IWH.AGILE_COLOR_8)]: 'purple',
    [(0, $38IWH.AGILE_COLOR_9)]: 'redLight',
    [(0, $38IWH.AGILE_COLOR_10)]: 'blueLight',
    [(0, $38IWH.AGILE_COLOR_11)]: 'tealLight',
    [(0, $38IWH.AGILE_COLOR_12)]: 'greyLight',
    [(0, $38IWH.AGILE_COLOR_13)]: 'green',
    [(0, $38IWH.AGILE_COLOR_14)]: 'red'
};
const $f89c7f0e34657bc4$export$92b6aebfb522f0d9 = {
    [(0, $38IWH.PURPLE)]: {
        primary: "var(--ds-background-accent-purple-subtle, #C97CF4)",
        secondary: "var(--ds-background-accent-purple-bolder, #964AC0)",
        text: "var(--ds-text-accent-purple, #803FA5)",
        textBackground: "var(--ds-background-accent-purple-subtler, #EED7FC)",
        border: "var(--ds-border-accent-purple, #AF59E1)",
        line: "var(--ds-border-accent-purple, #AF59E1)",
        primaryGradient: "var(--ds-background-accent-purple-subtler, #EED7FC)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.BLUE)]: {
        primary: "var(--ds-background-accent-blue-subtle, #669DF1)",
        secondary: "var(--ds-background-accent-blue-bolder, #1868DB)",
        text: "var(--ds-text-accent-blue, #1558BC)",
        textBackground: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        border: "var(--ds-border-accent-blue, #357DE8)",
        line: "var(--ds-border-accent-blue, #357DE8)",
        primaryGradient: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.GREEN)]: {
        primary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        secondary: "var(--ds-background-accent-green-bolder, #1F845A)",
        text: "var(--ds-text-accent-green, #216E4E)",
        textBackground: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.TEAL)]: {
        primary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        secondary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        text: "var(--ds-text-accent-teal, #206A83)",
        textBackground: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.YELLOW)]: {
        primary: "var(--ds-background-accent-yellow-subtle, #EED12B)",
        secondary: "var(--ds-background-accent-yellow-bolder, #946F00)",
        text: "var(--ds-text-accent-yellow, #7F5F01)",
        textBackground: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        border: "var(--ds-border-accent-yellow, #B38600)",
        line: "var(--ds-border-accent-yellow, #B38600)",
        primaryGradient: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.ORANGE)]: {
        primary: "var(--ds-background-accent-red-subtle, #F87168)",
        secondary: "var(--ds-background-accent-red-bolder, #C9372C)",
        text: "var(--ds-text-accent-red, #AE2E24)",
        textBackground: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        border: "var(--ds-border-accent-red, #E2483D)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.GREY)]: {
        primary: "var(--ds-background-accent-gray-subtle, #8C8F97)",
        secondary: "var(--ds-background-accent-gray-bolder, #6B6E76)",
        text: "var(--ds-text-accent-gray, #505258)",
        textBackground: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
        border: "var(--ds-border-accent-gray, #7D818A)",
        line: "var(--ds-border-accent-gray, #7D818A)",
        primaryGradient: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.DARK_PURPLE)]: {
        primary: "var(--ds-background-accent-purple-bolder, #964AC0)",
        secondary: "var(--ds-background-accent-purple-subtle, #C97CF4)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-purple-bolder, #964AC0)",
        border: "var(--ds-border-accent-purple, #AF59E1)",
        line: "var(--ds-border-accent-purple, #AF59E1)",
        primaryGradient: "var(--ds-background-accent-purple-subtle, #C97CF4)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_BLUE)]: {
        primary: "var(--ds-background-accent-blue-bolder, #1868DB)",
        secondary: "var(--ds-background-accent-blue-subtle, #669DF1)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-blue-bolder, #1868DB)",
        border: "var(--ds-border-accent-blue, #357DE8)",
        line: "var(--ds-border-accent-blue, #357DE8)",
        primaryGradient: "var(--ds-background-accent-blue-subtle, #669DF1)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_GREEN)]: {
        primary: "var(--ds-background-accent-green-bolder, #1F845A)",
        secondary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-green-bolder, #1F845A)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtle, #4BCE97)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_TEAL)]: {
        primary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        secondary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-teal-bolder, #227D9B)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_YELLOW)]: {
        primary: "var(--ds-background-accent-orange-bolder, #BD5B00)",
        secondary: "var(--ds-background-accent-orange-subtle, #FCA700)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-orange-bolder, #BD5B00)",
        border: "var(--ds-background-accent-orange-subtle, #FCA700)",
        line: "var(--ds-border-accent-orange, #E06C00)",
        primaryGradient: "var(--ds-background-accent-orange-subtle, #FCA700)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_ORANGE)]: {
        primary: "var(--ds-background-accent-red-bolder, #C9372C)",
        secondary: "var(--ds-background-accent-red-subtle, #F87168)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-red-bolder, #C9372C)",
        border: "var(--ds-background-accent-red-subtle, #F87168)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtle, #F87168)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_GREY)]: {
        primary: "var(--ds-background-accent-gray-bolder, #6B6E76)",
        secondary: "var(--ds-background-accent-gray-subtle, #8C8F97)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-gray-bolder, #6B6E76)",
        border: "var(--ds-background-accent-gray-subtle, #8C8F97)",
        line: "var(--ds-border-accent-gray, #7D818A)",
        primaryGradient: "var(--ds-background-accent-gray-subtle, #8C8F97)",
        hasContrastSecondaryGradient: false
    }
};

});
parcelRegister("2IQEX", function(module, exports) {

var $9hKkF = parcelRequire("9hKkF");

var $h3TKx = parcelRequire("h3TKx");

var $d7YnM = parcelRequire("d7YnM");
/** Used for built-in method references. */ var $1fb889f558f23ac4$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1fb889f558f23ac4$var$nativeObjectToString = $1fb889f558f23ac4$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $1fb889f558f23ac4$var$invert = $h3TKx(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $1fb889f558f23ac4$var$nativeObjectToString.call(value);
    result[value] = key;
}, $9hKkF($d7YnM));
module.exports = $1fb889f558f23ac4$var$invert;

});
parcelRegister("h3TKx", function(module, exports) {

var $8uipj = parcelRequire("8uipj");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $c6bdf63192b21f8e$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $8uipj(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = $c6bdf63192b21f8e$var$createInverter;

});
parcelRegister("8uipj", function(module, exports) {

var $75Jcs = parcelRequire("75Jcs");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $62df67589f85c449$var$baseInverter(object, setter, iteratee, accumulator) {
    $75Jcs(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = $62df67589f85c449$var$baseInverter;

});



var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';

parcelRegister("38IWH", function(module, exports) {
$parcel$export(module.exports, "PURPLE", () => $92f22b7535e1838e$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $92f22b7535e1838e$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $92f22b7535e1838e$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $92f22b7535e1838e$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $92f22b7535e1838e$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $92f22b7535e1838e$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $92f22b7535e1838e$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $92f22b7535e1838e$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $92f22b7535e1838e$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $92f22b7535e1838e$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $92f22b7535e1838e$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $92f22b7535e1838e$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $92f22b7535e1838e$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $92f22b7535e1838e$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $92f22b7535e1838e$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $92f22b7535e1838e$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $92f22b7535e1838e$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $92f22b7535e1838e$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $92f22b7535e1838e$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $92f22b7535e1838e$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $92f22b7535e1838e$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $92f22b7535e1838e$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $92f22b7535e1838e$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $92f22b7535e1838e$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $92f22b7535e1838e$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $92f22b7535e1838e$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $92f22b7535e1838e$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $92f22b7535e1838e$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $92f22b7535e1838e$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $92f22b7535e1838e$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $92f22b7535e1838e$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $92f22b7535e1838e$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $92f22b7535e1838e$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $92f22b7535e1838e$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $92f22b7535e1838e$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $92f22b7535e1838e$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $92f22b7535e1838e$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $92f22b7535e1838e$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $92f22b7535e1838e$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $92f22b7535e1838e$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $92f22b7535e1838e$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $92f22b7535e1838e$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $92f22b7535e1838e$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $92f22b7535e1838e$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $92f22b7535e1838e$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $92f22b7535e1838e$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $92f22b7535e1838e$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $92f22b7535e1838e$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $92f22b7535e1838e$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $92f22b7535e1838e$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $92f22b7535e1838e$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $92f22b7535e1838e$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $92f22b7535e1838e$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $92f22b7535e1838e$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $92f22b7535e1838e$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $92f22b7535e1838e$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $92f22b7535e1838e$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $92f22b7535e1838e$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $92f22b7535e1838e$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $92f22b7535e1838e$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $92f22b7535e1838e$export$4b7407b8700035bd);
/**
 * @fileoverview This file was moved from `@atlassian/jira-issue-epic-color-types`
 * so that these types do not require atlaskit dependencies.
 *
 * Color constants
 */ const $92f22b7535e1838e$export$7ffdeca4b2f927a2 = 'PURPLE';
const $92f22b7535e1838e$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $92f22b7535e1838e$export$738c3b9a44c87ecc = 'BLUE';
const $92f22b7535e1838e$export$1225f83626261b80 = 'DARK_BLUE';
const $92f22b7535e1838e$export$48d4b2cd5bc0e88b = 'GREEN';
const $92f22b7535e1838e$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $92f22b7535e1838e$export$d0446fe88325854e = 'TEAL';
const $92f22b7535e1838e$export$bb848c92687e69dc = 'DARK_TEAL';
const $92f22b7535e1838e$export$aab610c505c06a8f = 'YELLOW';
const $92f22b7535e1838e$export$466af87757d343a2 = 'DARK_YELLOW';
const $92f22b7535e1838e$export$3de5e29ed1757f9b = 'ORANGE';
const $92f22b7535e1838e$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $92f22b7535e1838e$export$7d278ca694634874 = 'GREY';
const $92f22b7535e1838e$export$26453300bfc61cb8 = 'DARK_GREY';
const $92f22b7535e1838e$export$56d196d2844d1ca1 = [
    $92f22b7535e1838e$export$7ffdeca4b2f927a2,
    $92f22b7535e1838e$export$c815fe495e8174a0,
    $92f22b7535e1838e$export$738c3b9a44c87ecc,
    $92f22b7535e1838e$export$1225f83626261b80,
    $92f22b7535e1838e$export$48d4b2cd5bc0e88b,
    $92f22b7535e1838e$export$c6f4cf2e5768eb78,
    $92f22b7535e1838e$export$d0446fe88325854e,
    $92f22b7535e1838e$export$bb848c92687e69dc,
    $92f22b7535e1838e$export$aab610c505c06a8f,
    $92f22b7535e1838e$export$466af87757d343a2,
    $92f22b7535e1838e$export$3de5e29ed1757f9b,
    $92f22b7535e1838e$export$da02e4820b6ab753,
    $92f22b7535e1838e$export$7d278ca694634874,
    $92f22b7535e1838e$export$26453300bfc61cb8
];
const $92f22b7535e1838e$export$792af22a0198af8d = 'purple';
const $92f22b7535e1838e$export$588af712afdcb006 = 'dark_purple';
const $92f22b7535e1838e$export$84c4918645391802 = 'blue';
const $92f22b7535e1838e$export$b8f1f5838352a33a = 'dark_blue';
const $92f22b7535e1838e$export$9384b7e350ee6542 = 'green';
const $92f22b7535e1838e$export$87d3fb8d8656d38b = 'dark_green';
const $92f22b7535e1838e$export$b0b4ce3e99e66aae = 'teal';
const $92f22b7535e1838e$export$a89b77a449bd223e = 'dark_teal';
const $92f22b7535e1838e$export$9a33b5e3cde94885 = 'yellow';
const $92f22b7535e1838e$export$33253d7862bceb8a = 'dark_yellow';
const $92f22b7535e1838e$export$6609c2b23fc42f39 = 'orange';
const $92f22b7535e1838e$export$cd994662b5911917 = 'dark_orange';
const $92f22b7535e1838e$export$1793d43e13e078c5 = 'grey';
const $92f22b7535e1838e$export$487a6e9145526564 = 'dark_grey';
const $92f22b7535e1838e$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $92f22b7535e1838e$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $92f22b7535e1838e$export$94ac87c81ed074a7 = 'ghx-label-3';
const $92f22b7535e1838e$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $92f22b7535e1838e$export$610a2c132b6fcf96 = 'ghx-label-5';
const $92f22b7535e1838e$export$8e4997dba71f1c40 = 'ghx-label-6';
const $92f22b7535e1838e$export$18a545b4e69b27b4 = 'ghx-label-7';
const $92f22b7535e1838e$export$27fff1a0d295292a = 'ghx-label-8';
const $92f22b7535e1838e$export$e57aa662a56724e1 = 'ghx-label-9';
const $92f22b7535e1838e$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $92f22b7535e1838e$export$457ecb9560f2bf83 = 'ghx-label-11';
const $92f22b7535e1838e$export$a866db37165a696c = 'ghx-label-12';
const $92f22b7535e1838e$export$9b18447c1168a1b6 = 'ghx-label-13';
const $92f22b7535e1838e$export$93b9ad4020e271b7 = 'ghx-label-14';
const $92f22b7535e1838e$export$5cd2af17b34de3e3 = 'color_1';
const $92f22b7535e1838e$export$987671fa69482a7b = 'color_2';
const $92f22b7535e1838e$export$70ba8a5b1f4c7446 = 'color_3';
const $92f22b7535e1838e$export$fcd1c42d8d3ebd36 = 'color_4';
const $92f22b7535e1838e$export$f80a5bd2fa0ba256 = 'color_5';
const $92f22b7535e1838e$export$37ad5ce8d2aeaf78 = 'color_6';
const $92f22b7535e1838e$export$9dc62d5d151cb355 = 'color_7';
const $92f22b7535e1838e$export$1ed15b30f5663f92 = 'color_8';
const $92f22b7535e1838e$export$5d23a84d55ac1644 = 'color_9';
const $92f22b7535e1838e$export$bf08c9a6ed42e349 = 'color_10';
const $92f22b7535e1838e$export$66c5d8f0b5ff279c = 'color_11';
const $92f22b7535e1838e$export$da30755a37c3a597 = 'color_12';
const $92f22b7535e1838e$export$721cf84faff6bf19 = 'color_13';
const $92f22b7535e1838e$export$4b8f8666bd7b61dd = 'color_14';
const $92f22b7535e1838e$export$c537fa0d021d010b = {
    PURPLE: $92f22b7535e1838e$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $92f22b7535e1838e$export$c815fe495e8174a0,
    BLUE: $92f22b7535e1838e$export$738c3b9a44c87ecc,
    DARK_BLUE: $92f22b7535e1838e$export$1225f83626261b80,
    GREEN: $92f22b7535e1838e$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $92f22b7535e1838e$export$c6f4cf2e5768eb78,
    TEAL: $92f22b7535e1838e$export$d0446fe88325854e,
    DARK_TEAL: $92f22b7535e1838e$export$bb848c92687e69dc,
    YELLOW: $92f22b7535e1838e$export$aab610c505c06a8f,
    DARK_YELLOW: $92f22b7535e1838e$export$466af87757d343a2,
    ORANGE: $92f22b7535e1838e$export$3de5e29ed1757f9b,
    DARK_ORANGE: $92f22b7535e1838e$export$da02e4820b6ab753,
    GREY: $92f22b7535e1838e$export$7d278ca694634874,
    DARK_GREY: $92f22b7535e1838e$export$26453300bfc61cb8
};
const $92f22b7535e1838e$export$d33d39828a18210a = {
    SERVER_PURPLE: $92f22b7535e1838e$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $92f22b7535e1838e$export$588af712afdcb006,
    SERVER_BLUE: $92f22b7535e1838e$export$84c4918645391802,
    SERVER_DARK_BLUE: $92f22b7535e1838e$export$b8f1f5838352a33a,
    SERVER_GREEN: $92f22b7535e1838e$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $92f22b7535e1838e$export$87d3fb8d8656d38b,
    SERVER_TEAL: $92f22b7535e1838e$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $92f22b7535e1838e$export$a89b77a449bd223e,
    SERVER_YELLOW: $92f22b7535e1838e$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $92f22b7535e1838e$export$33253d7862bceb8a,
    SERVER_ORANGE: $92f22b7535e1838e$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $92f22b7535e1838e$export$cd994662b5911917,
    SERVER_GREY: $92f22b7535e1838e$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $92f22b7535e1838e$export$487a6e9145526564
};
const $92f22b7535e1838e$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $92f22b7535e1838e$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $92f22b7535e1838e$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $92f22b7535e1838e$export$94ac87c81ed074a7,
    GHX_LABEL_4: $92f22b7535e1838e$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $92f22b7535e1838e$export$610a2c132b6fcf96,
    GHX_LABEL_6: $92f22b7535e1838e$export$8e4997dba71f1c40,
    GHX_LABEL_7: $92f22b7535e1838e$export$18a545b4e69b27b4,
    GHX_LABEL_8: $92f22b7535e1838e$export$27fff1a0d295292a,
    GHX_LABEL_9: $92f22b7535e1838e$export$e57aa662a56724e1,
    GHX_LABEL_10: $92f22b7535e1838e$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $92f22b7535e1838e$export$457ecb9560f2bf83,
    GHX_LABEL_12: $92f22b7535e1838e$export$a866db37165a696c,
    GHX_LABEL_13: $92f22b7535e1838e$export$9b18447c1168a1b6,
    GHX_LABEL_14: $92f22b7535e1838e$export$93b9ad4020e271b7
};
const $92f22b7535e1838e$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $92f22b7535e1838e$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $92f22b7535e1838e$export$987671fa69482a7b,
    AGILE_COLOR_3: $92f22b7535e1838e$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $92f22b7535e1838e$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $92f22b7535e1838e$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $92f22b7535e1838e$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $92f22b7535e1838e$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $92f22b7535e1838e$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $92f22b7535e1838e$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $92f22b7535e1838e$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $92f22b7535e1838e$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $92f22b7535e1838e$export$da30755a37c3a597,
    AGILE_COLOR_13: $92f22b7535e1838e$export$721cf84faff6bf19,
    AGILE_COLOR_14: $92f22b7535e1838e$export$4b8f8666bd7b61dd
};

});


parcelRegister("1wTTU", function(module, exports) {
$parcel$export(module.exports, "asColor", () => $b36086cea9eb1a24$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $b36086cea9eb1a24$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $b36086cea9eb1a24$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $b36086cea9eb1a24$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $b36086cea9eb1a24$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $b36086cea9eb1a24$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $b36086cea9eb1a24$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $b36086cea9eb1a24$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $b36086cea9eb1a24$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $b36086cea9eb1a24$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $b36086cea9eb1a24$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $b36086cea9eb1a24$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $b36086cea9eb1a24$export$e4369cabd7e84cd9);

var $38IWH = parcelRequire("38IWH");

var $8URAw = parcelRequire("8URAw");

var $efpPR = parcelRequire("efpPR");
const $b36086cea9eb1a24$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $38IWH.Colors).PURPLE;
    if (color in (0, $38IWH.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $8URAw.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $8URAw.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $38IWH.Colors).PURPLE;
};
const $b36086cea9eb1a24$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $38IWH.ServerColors).SERVER_PURPLE;
    if (color in (0, $38IWH.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $8URAw.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_AGILE_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $8URAw.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $38IWH.ServerColors).SERVER_PURPLE;
};
const $b36086cea9eb1a24$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $38IWH.Colors).PURPLE];
    if (color in (0, $38IWH.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $8URAw.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $8URAw.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $8URAw.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_AGILE_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $8URAw.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $38IWH.Colors).PURPLE];
};
const $b36086cea9eb1a24$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $8URAw.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $38IWH.Colors)));
    return extendedColors.reduce((obj, color)=>Object.assign(obj, {
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $b36086cea9eb1a24$export$a00423580059ae28 = (color)=>(0, $8URAw.MAP_COLORS_TO_VALUE)[color] || (0, $8URAw.MAP_COLORS_TO_VALUE)[0, $38IWH.PURPLE];
/**
 * Normalizes a token value by extracting just the CSS variable name,
 * ignoring the fallback color which can differ between environments.
 * E.g., "var(--ds-color, #123)" becomes "var(--ds-color)"
 */ const $b36086cea9eb1a24$var$normalizeTokenValue = (value)=>{
    if (!value.startsWith('var(')) return value;
    const commaIndex = value.indexOf(',');
    if (commaIndex === -1) return value;
    return `${value.substring(0, commaIndex)})`;
};
// Create a normalized inverted map that ignores fallback values
const $b36086cea9eb1a24$var$createNormalizedInvertedMap = ()=>{
    const result = {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys((0, $8URAw.MAP_COLORS_TO_VALUE)).forEach((color)=>{
        const normalizedValue = $b36086cea9eb1a24$var$normalizeTokenValue((0, $8URAw.MAP_COLORS_TO_VALUE)[color]);
        result[normalizedValue] = color;
    });
    return result;
};
const $b36086cea9eb1a24$var$NORMALIZED_MAP_VALUE_TO_COLOR = $b36086cea9eb1a24$var$createNormalizedInvertedMap();
const $b36086cea9eb1a24$export$6d14528e40cbe34b = (value)=>$b36086cea9eb1a24$var$NORMALIZED_MAP_VALUE_TO_COLOR[$b36086cea9eb1a24$var$normalizeTokenValue(value)] || (0, $38IWH.PURPLE);
const $b36086cea9eb1a24$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $8URAw.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $38IWH.PURPLE);
const $b36086cea9eb1a24$export$47af25386a01de1 = (color)=>(0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $b36086cea9eb1a24$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $38IWH.PURPLE);
const $b36086cea9eb1a24$export$28fb68bb1de025d5 = (color)=>(0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $b36086cea9eb1a24$var$paletteColorValues = $b36086cea9eb1a24$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $b36086cea9eb1a24$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $efpPR.default).purpleLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $efpPR.default).blueLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).BLUE]
        },
        {
            label: formatMessage((0, $efpPR.default).greenLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).GREEN]
        },
        {
            label: formatMessage((0, $efpPR.default).tealLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).TEAL]
        },
        {
            label: formatMessage((0, $efpPR.default).yellowLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $efpPR.default).orangeLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $efpPR.default).greyLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).GREY]
        },
        {
            label: formatMessage((0, $efpPR.default).darkPurpleLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $efpPR.default).darkBlueLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $efpPR.default).darkGreenLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $efpPR.default).darkTealLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $efpPR.default).darkYellowLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $efpPR.default).darkOrangeLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $efpPR.default).darkGreyLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_GREY]
        }
    ];
const $b36086cea9eb1a24$var$getLozengeThemes = $b36086cea9eb1a24$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $b36086cea9eb1a24$export$949dc67535a8ff2 = (color = (0, $8URAw.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $b36086cea9eb1a24$var$getLozengeThemes[color] ?? $b36086cea9eb1a24$var$getLozengeThemes[0, $8URAw.DEFAULT_EPIC_COLOR];
const $b36086cea9eb1a24$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $38IWH.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("efpPR", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5a8789e55bcd8e1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f5a8789e55bcd8e1$var$messages = (0, $7qGN1.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "Purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "Blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "Green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "Teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "Yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "Orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "Grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "Dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "Dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "Dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "Dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "Dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "Dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "Dark grey"
    }
});
var $f5a8789e55bcd8e1$export$2e2bcd8739ae039 = $f5a8789e55bcd8e1$var$messages;

});


parcelRegister("bBiKm", function(module, exports) {
$parcel$export(module.exports, "default", () => $3241fb4419868a9b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3241fb4419868a9b$var$messages = (0, $7qGN1.defineMessages)({
    epicTitle: {
        "id": "native-issue-table.common.issue-cells.epic-link.epic-title",
        "defaultMessage": "Click to visit"
    },
    replacedByParentField: {
        "id": "issue-create-commons.common.fields.epic-link-parent-link-disabled.replaced-by-parent-field",
        "defaultMessage": "Replaced by <strong>Parent</strong> field"
    }
});
var $3241fb4419868a9b$export$2e2bcd8739ae039 = $3241fb4419868a9b$var$messages;

});


parcelRegister("avymT", function(module, exports) {
$parcel$export(module.exports, "FallbackCell", () => $b016b9d3e5546a5f$export$de9d519be820a473);

var $6M5vY = parcelRequire("6M5vY");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $9Mapt = parcelRequire("9Mapt");

var $bzbsd = parcelRequire("bzbsd");

var $3OT15 = parcelRequire("3OT15");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");
const $b016b9d3e5546a5f$var$TYPES_TO_REMOVE_TITLE = new Set([
    'lastViewed'
]); /**
                                                        * Render fallback version of the issue field cell that is generated by the backend.
                                                        * We trust the backend to do all HTML entity encoding and other sanitization.
                                                        */ 
const $b016b9d3e5546a5f$export$de9d519be820a473 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $6M5vY.default), fieldRef);
    const { renderedFieldHtml: renderedFieldHtml, type: type } = data;
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const contentRef = (0, $eJOHy.useRef)(null);
    const removeTitleAttributeRef = (0, $eJOHy.useCallback)((el)=>{
        if (!$b016b9d3e5546a5f$var$TYPES_TO_REMOVE_TITLE.has(type)) return;
        el?.querySelectorAll('[title]').forEach((node)=>{
            node.removeAttribute('title');
        });
    }, [
        type
    ]);
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (renderedFieldHtml == null) return /*#__PURE__*/ $eJOHy.createElement((0, $86BUM.default), {
        cellType: "fallback",
        reason: "Missing required fields"
    });
    if (!renderedFieldHtml.trim().length) return null;
    let hoverPopoverRef = null;
    switch(type){
        case 'thumbnail':
            if (isSingleLineRowHeightEnabled) {
                if (hoverPopoverRefFactory) {
                    hoverPopoverRef = hoverPopoverRefFactory({
                        content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                        , {
                            dangerouslySetInnerHTML: {
                                __html: renderedFieldHtml
                            },
                            className: (0, $hcewu.default)([
                                "_1jpx1f51 _rtys1osq _19l31osq"
                            ])
                        }),
                        alwaysShow: true
                    });
                    return /*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$AttachmentFallbackContainer, {
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.attachment-fallback-container",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                        ref: hoverPopoverRef
                    });
                }
                return /*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.HoverPopoverWithContext), {
                    content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                    , {
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        className: (0, $hcewu.default)([
                            "_1jpx1f51 _rtys1osq _19l31osq"
                        ])
                    })
                }, ({ ref: ref })=>/*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$AttachmentFallbackContainer, {
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.attachment-fallback-container",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                        ref: ref
                    }));
            }
            return /*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$AttachmentFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.attachment-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                },
                isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
            });
        case 'progress':
        case 'aggregateprogress':
            // No need for hover popover for progress as contents (graphic) is responsive to cell width
            return /*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$ProgressFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.progress-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
        case 'com.atlassian.servicedesk:sd-request-feedback':
            if (isSingleLineRowHeightEnabled) {
                if (hoverPopoverRefFactory) {
                    hoverPopoverRef = hoverPopoverRefFactory({
                        content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                        , {
                            dangerouslySetInnerHTML: {
                                __html: renderedFieldHtml
                            }
                        })
                    });
                    return /*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$SatisfactionFallbackContainer, {
                        ref: hoverPopoverRef,
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.satisfaction-fallback-container",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                    });
                }
                return /*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.HoverPopoverWithContext), {
                    contentRef: contentRef,
                    content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                    , {
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        }
                    })
                }, ({ ref: ref })=>/*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$SatisfactionFallbackContainer, {
                        ref: (0, $bzbsd.mergeRefs)(contentRef, ref),
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.satisfaction-fallback-container",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                    }));
            }
            return /*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$SatisfactionFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.satisfaction-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
        case 'com.atlassian.servicedesk:sd-sla-field':
            if (isSingleLineRowHeightEnabled) {
                if (hoverPopoverRefFactory) {
                    hoverPopoverRef = hoverPopoverRefFactory({
                        content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                        , {
                            dangerouslySetInnerHTML: {
                                __html: renderedFieldHtml
                            }
                        })
                    });
                    return /*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$SlaFallbackContainer, {
                        ref: hoverPopoverRef,
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.sla-fallback-container",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                    });
                }
                return /*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.HoverPopoverWithContext), {
                    contentRef: contentRef,
                    content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                    , {
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        }
                    })
                }, ({ ref: ref })=>/*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$SlaFallbackContainer, {
                        ref: (0, $bzbsd.mergeRefs)(contentRef, ref),
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.sla-fallback-container",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                    }));
            }
            return /*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$SlaFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.sla-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
        default:
            if (isSingleLineRowHeightEnabled) {
                if (hoverPopoverRefFactory) {
                    hoverPopoverRef = hoverPopoverRefFactory({
                        content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                        , {
                            dangerouslySetInnerHTML: {
                                __html: renderedFieldHtml
                            }
                        })
                    });
                    return /*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$FallbackContainer, {
                        ref: (0, $bzbsd.mergeRefs)(hoverPopoverRef, removeTitleAttributeRef),
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.div",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                    });
                }
                return /*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.HoverPopoverWithContext), {
                    contentRef: contentRef,
                    content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                    , {
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        }
                    })
                }, ({ ref: ref })=>/*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$FallbackContainer, {
                        ref: (0, $bzbsd.mergeRefs)(contentRef, ref, removeTitleAttributeRef),
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.div",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                    }));
            }
            return /*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$FallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.div",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
    }
});
/**
 * Disabling selector eslint rules because we must provide the fallback style overrides this way due
 * to the markup and base styles coming from the monolith.
 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b016b9d3e5546a5f$var$FallbackContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1rjc1b66 _18zru2gc _p12f1osq _1bto1l2s _bna71wug _rtys1osq",
            __cmplp && "_o5721q9c _wmb415vq _12ev15vq _5c4l1l2s _1e4iglyw",
            __cmplp.className
        ])
    });
});
const $b016b9d3e5546a5f$var$attachmentPopoverStyle = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b016b9d3e5546a5f$var$AttachmentFallbackContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $b016b9d3e5546a5f$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_bna71wug _19l3uuw1 _mezj1wug _rtys1osq",
            __cmplp && "_1rjcv77o _1e0c1txw _1bah1h6o _4cvr1h6o _19l31ul9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b016b9d3e5546a5f$var$ProgressFallbackContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $b016b9d3e5546a5f$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_vwz4idpf _1lms18uv _xu7xt94y _19jqt94y _iv7lt94y _18m0t94y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b016b9d3e5546a5f$var$SatisfactionFallbackContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $b016b9d3e5546a5f$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_nmi71oqg _17go1rpy",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b016b9d3e5546a5f$var$SlaFallbackContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $b016b9d3e5546a5f$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1xngu2gc _1kss1txw _1v441h6o _1fecusic _1op7t9kd _i95c17hp _c4xnnbxb _1mf81q3r _10ku8uof _m1tonbxb _g3h81j6y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6M5vY", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ca65dfa925f6f76$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7f6556eba348c4e1df94ffe1af75e7a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8ca65dfa925f6f76$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "FallbackCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "renderedFieldHtml"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        }
    ],
    "type": "JiraFallbackField"
};
$8ca65dfa925f6f76$var$node.hash = "5a44333782fe000d835b0ea393cc6a88";
var $8ca65dfa925f6f76$export$2e2bcd8739ae039 = $8ca65dfa925f6f76$var$node;

});


parcelRegister("4mhLJ", function(module, exports) {
$parcel$export(module.exports, "FlagCell", () => $1a7c562f013d4ae8$export$be4c47c19457cd1e);

var $jsh7K = parcelRequire("jsh7K");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $kePo9 = parcelRequire("kePo9");
const $1a7c562f013d4ae8$export$be4c47c19457cd1e = ({ fieldRef: fieldRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $jsh7K.default), fieldRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return data.flag?.isFlagged && formatMessage((0, $kePo9.default).flagged);
};

});
parcelRegister("jsh7K", function(module, exports) {
$parcel$export(module.exports, "default", () => $be594268a6add2c6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e161f484d39cb7060e7fafe9b975774>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $be594268a6add2c6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "FlagCell",
    "selections": [
        {
            "concreteType": "JiraFlag",
            "kind": "LinkedField",
            "name": "flag",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFlagged"
                }
            ]
        }
    ],
    "type": "JiraFlagField"
};
$be594268a6add2c6$var$node.hash = "a132d27c76c2fbd37572315422c76c0c";
var $be594268a6add2c6$export$2e2bcd8739ae039 = $be594268a6add2c6$var$node;

});

parcelRegister("kePo9", function(module, exports) {
$parcel$export(module.exports, "default", () => $44166ff552e5c007$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $44166ff552e5c007$var$messages = (0, $7qGN1.defineMessages)({
    flagged: {
        "id": "native-issue-table.common.issue-cells.flag.flagged",
        "defaultMessage": "Impediment"
    }
});
var $44166ff552e5c007$export$2e2bcd8739ae039 = $44166ff552e5c007$var$messages;

});


parcelRegister("crxno", function(module, exports) {
$parcel$export(module.exports, "GoalsCell", () => $87d28259df048411$export$aea87ff07be8100d);

var $508vf = parcelRequire("508vf");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $dHPoe = parcelRequire("dHPoe");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");
const $87d28259df048411$export$aea87ff07be8100d = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $508vf.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled && data.lazyIsEditableInIssueView;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const shouldTruncate = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dHPoe.GoalsInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncated: shouldTruncate
    });
};

});
parcelRegister("508vf", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cf38cf1106f43f6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3785c96450d71659edfe05fdcad96d83>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2cf38cf1106f43f6$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "GoalsCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraGoalsField"
};
$2cf38cf1106f43f6$var$node.hash = "3bef28866cbc81a4082bd51e2208be0f";
var $2cf38cf1106f43f6$export$2e2bcd8739ae039 = $2cf38cf1106f43f6$var$node;

});

parcelRegister("dHPoe", function(module, exports) {
$parcel$export(module.exports, "GoalsInlineEditViewWithIsEditable", () => $b69d8ff6824a40f6$export$16ba9f62f4ede1d3);

var $lXcLD = parcelRequire("lXcLD");

var $6fc0a = parcelRequire("6fc0a");

var $fGRI3 = parcelRequire("fGRI3");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $kqd31 = parcelRequire("kqd31");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $jZbQD = parcelRequire("jZbQD");

var $cHtIB = parcelRequire("cHtIB");

var $byUzi = parcelRequire("byUzi");

var $auNLL = parcelRequire("auNLL");

var $knIOf = parcelRequire("knIOf");

var $4cTDP = parcelRequire("4cTDP");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $b69d8ff6824a40f6$var$isEqualOption = (a, b)=>{
    if (a.length !== b.length) return false;
    const aUrlSet = new Set(a.map((option)=>option.url));
    return b.every((option)=>aUrlSet.has(option.url));
};
const $b69d8ff6824a40f6$var$JIRA_GOAL_TYPENAME = 'JiraGoal';
const $b69d8ff6824a40f6$var$JIRA_GOAL_EDGE_TYPENAME = 'JiraGoalEdge';
const $b69d8ff6824a40f6$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-goals-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $b69d8ff6824a40f6$export$16ba9f62f4ede1d3 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncated: isTruncated })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $fGRI3.default), fragmentRef);
    // for the mutation, only need to worry about the deletion / removal
    // don't worry about insertion as that's handled by the townsquare goal picker
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $6fc0a.default));
    // #endregion Relay
    // #region State
    const constructGoalUrl = (0, $byUzi.useGoalUrlConstructor)();
    const { __id: __id, id: uniqueFieldId, name: name, type: fieldType, selectedGoals: selectedGoals, issue: issue } = data;
    const selectedGoalsConnectionId = selectedGoals?.__id;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        const nodes = selectedGoals?.edges?.map((edge)=>edge?.node)?.filter((node)=>Boolean(node?.key)) ?? [];
        return nodes.map((node)=>({
                id: node.id,
                url: constructGoalUrl({
                    ari: node.id,
                    key: node.key
                })
            }));
    }, [
        constructGoalUrl,
        selectedGoals?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    // #region Action
    const updater = (0, $eJOHy.useCallback)((store, value)=>{
        const connection = selectedGoalsConnectionId ? store.get(selectedGoalsConnectionId) : null;
        if (!connection) return;
        const { EDGES: EDGES, NODE: NODE } = (0, $37Ewn.ConnectionInterface).get();
        const edges = connection.getLinkedRecords(EDGES) ?? [];
        const edgesByNodeId = {};
        edges.forEach((edge)=>{
            const nodeId = edge.getLinkedRecord(NODE)?.getValue('id');
            if (typeof nodeId === 'string') edgesByNodeId[nodeId] = edge;
        });
        const nextEdges = [];
        value.forEach(({ id: id, url: url })=>{
            if (id && id in edgesByNodeId) nextEdges.push(edgesByNodeId[id]);
            else {
                const nodeRelayDataId = (0, $kqd31.default)({
                    id: id
                }, $b69d8ff6824a40f6$var$JIRA_GOAL_TYPENAME);
                const key = (0, $byUzi.getGoalKeyFromUrl)(url);
                if (nodeRelayDataId) {
                    let node = store.get(nodeRelayDataId);
                    if (!node) {
                        node = store.create(nodeRelayDataId, $b69d8ff6824a40f6$var$JIRA_GOAL_TYPENAME);
                        (0, $4cTDP.fg)('jira_nin_goals_smart_link_fix') ? node.setValue(id, 'id') : node.setValue(nodeRelayDataId, 'id');
                    }
                    if (key) node.setValue(key, 'key');
                    const edge = (0, $j4oe4.ConnectionHandler).createEdge(store, connection, node, $b69d8ff6824a40f6$var$JIRA_GOAL_EDGE_TYPENAME);
                    nextEdges.push(edge);
                }
            }
        });
        connection.setLinkedRecords(nextEdges, EDGES);
    }, [
        selectedGoalsConnectionId
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        const initialIds = initialValue.map(({ id: id })=>id).filter(Boolean);
        const initialIdSet = new Set(initialIds);
        const updatedIds = value.map(({ id: id })=>id).filter(Boolean);
        const updatedIdSet = new Set(updatedIds);
        const deletedRelationships = initialIds.filter((id)=>!updatedIdSet.has(id)).map((id)=>({
                from: issue.id,
                to: id
            }));
        const createdRelationships = updatedIds.filter((id)=>!initialIdSet.has(id)).map((id)=>({
                from: issue.id,
                to: id
            }));
        commit({
            variables: {
                createInput: {
                    relationships: createdRelationships
                },
                deleteInput: {
                    relationships: deletedRelationships
                }
            },
            updater: (store)=>updater(store, value),
            optimisticUpdater: (store)=>updater(store, value),
            onCompleted (mutationData) {
                if (mutationData.townsquare?.createRelationships?.success && mutationData.townsquare?.deleteRelationships?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                townsquare: {
                    createRelationships: {
                        success: true,
                        relationships: createdRelationships
                    },
                    deleteRelationships: {
                        success: true,
                        relationships: deletedRelationships
                    }
                }
            }
        });
    }, [
        onSubmit,
        initialValue,
        commit,
        issue.id,
        updater
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $b69d8ff6824a40f6$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue
    });
    // #endregion Action
    // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b69d8ff6824a40f6$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $knIOf.GoalsReadView), {
            fragmentRef: data,
            isTruncated: isTruncated
        }));
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            issueAri: issue.id,
            initialIsOpen: true,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            spacing: spacing
        });
    const cloudId = (0, $cHtIB.useCloudId)();
    const editViewEntryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            issueAri: issue.id
        }), [
        cloudId,
        issue.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $jZbQD.default),
        editViewEntryPointParams: editViewEntryPointParams,
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
// #endregion Edit View
};
const $b69d8ff6824a40f6$export$fc2645c54795e7e6 = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $lXcLD.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b69d8ff6824a40f6$export$16ba9f62f4ede1d3, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("lXcLD", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d620d728d1f4db8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7542446408a11d8dcd6f34ea8741757a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7d620d728d1f4db8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraGoalsField"
};
$7d620d728d1f4db8$var$node.hash = "d698a934047d8a1aef53370ee1f7570c";
var $7d620d728d1f4db8$export$2e2bcd8739ae039 = $7d620d728d1f4db8$var$node;

});

parcelRegister("6fc0a", function(module, exports) {
$parcel$export(module.exports, "default", () => $59872d21d3ffbe34$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<57d11f4e2332b19d87c403e7d64ec868>>
 * @relayHash f896f939a1918da6870fd74a26e67107
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8dbb1de2807924cc75847f0e6cb98eddad0909f975f61d85473712a94f60740f
const $59872d21d3ffbe34$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "createInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "deleteInput"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "success"
        },
        {
            "concreteType": "TownsquareRelationship",
            "kind": "LinkedField",
            "name": "relationships",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "from"
                },
                {
                    "kind": "ScalarField",
                    "name": "to"
                }
            ]
        }
    ], v2 = [
        {
            "concreteType": "TownsquareMutationApi",
            "kind": "LinkedField",
            "name": "townsquare",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "createInput"
                        }
                    ],
                    "concreteType": "TownsquareCreateRelationshipsPayload",
                    "kind": "LinkedField",
                    "name": "createRelationships",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "deleteInput"
                        }
                    ],
                    "concreteType": "TownsquareDeleteRelationshipsPayload",
                    "kind": "LinkedField",
                    "name": "deleteRelationships",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "8dbb1de2807924cc75847f0e6cb98eddad0909f975f61d85473712a94f60740f",
            "metadata": {},
            "name": "goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$59872d21d3ffbe34$var$node.hash = "d5d407c381c2f478408ef64adaf27177";
var $59872d21d3ffbe34$export$2e2bcd8739ae039 = $59872d21d3ffbe34$var$node;

});

parcelRegister("fGRI3", function(module, exports) {
$parcel$export(module.exports, "default", () => $77a7b0f8fcb39409$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6b806e0d4bbf68b8eb5cca1fbda58643>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $77a7b0f8fcb39409$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "issue",
                    "plural": false,
                    "selections": [
                        v0 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "issue"
            },
            {
                "kind": "FragmentSpread",
                "name": "goals_issueFieldGoalsReadviewFull_GoalsReadView"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraGoalConnection",
                "kind": "LinkedField",
                "name": "selectedGoals",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "key"
                                    }
                                ]
                            }
                        ]
                    },
                    v1 /*: any*/ 
                ],
                "storageKey": "selectedGoals(first:1000)"
            },
            v1 /*: any*/ 
        ],
        "type": "JiraGoalsField"
    };
}();
$77a7b0f8fcb39409$var$node.hash = "46c4ce64c1ccf9c7ee8dc2090f374288";
var $77a7b0f8fcb39409$export$2e2bcd8739ae039 = $77a7b0f8fcb39409$var$node;

});

parcelRegister("jZbQD", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b571ab63a42dd1e$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $95Yrm = parcelRequire("95Yrm");

const $7b571ab63a42dd1e$var$GoalsEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("gUwIV")), {
        moduleId: "8bcf8112",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, issueAri: issueAri })=>({
            queries: {
                GoalsPopupQuery: {
                    parameters: (0, $95Yrm.default),
                    variables: {
                        cloudId: cloudId,
                        issueAri: issueAri
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});
var $7b571ab63a42dd1e$export$2e2bcd8739ae039 = $7b571ab63a42dd1e$var$GoalsEditViewEntryPoint;

});
parcelRegister("95Yrm", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e338b7504ff52ce$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ce58d611252b9956cb488acbd8175ebf>>
 * @relayHash e100e4608f0f09869a047dc4d2e25a56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 937157055e12959c4a5dedd3877600cd0531fb0e4b7826db78fa93e5143aa6d7
const $6e338b7504ff52ce$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "concreteType": "TownsquareUnshardedUserCapabilities",
        "kind": "LinkedField",
        "name": "userCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareUnshardedCapability",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "capability"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "capabilityContainer"
                    }
                ]
            }
        ]
    }, v5 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "issueAri"
    }, v6 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        v5 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = [
        v8 /*: any*/ 
    ], v11 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v12 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v13 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v14 = [
        "id"
    ], v15 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        v5 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GoalsPopupQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "issueGoals_AtlassianGoalPicker"
                },
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareUnshardedWorkspaceSummaryConnection",
                    "kind": "LinkedField",
                    "name": "townsquareUnsharded_allWorkspaceSummariesForOrg",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "TownsquareUnshardedWorkspaceSummaryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "TownsquareUnshardedWorkspaceSummary",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GoalsPopupQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection",
                            "kind": "LinkedField",
                            "name": "jiraEpicContributesToAtlasGoal",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "url"
                                                        },
                                                        v9 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareLocalizationField",
                                                                    "kind": "LinkedField",
                                                                    "name": "localizedLabel",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "messageId"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareGoalIcon",
                                                            "kind": "LinkedField",
                                                            "name": "icon",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appearance"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "TownsquareGoal"
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v13 /*: any*/ 
                            ]
                        },
                        {
                            "args": v6 /*: any*/ ,
                            "filters": v14 /*: any*/ ,
                            "handle": "connection",
                            "key": "LinkedGoals_jiraEpicContributesToAtlasGoal",
                            "kind": "LinkedHandle",
                            "name": "jiraEpicContributesToAtlasGoal"
                        },
                        {
                            "alias": "issueGoalPicker",
                            "args": v15 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection",
                            "kind": "LinkedField",
                            "name": "jiraEpicContributesToAtlasGoal",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v10 /*: any*/ ,
                                                    "type": "TownsquareGoal"
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v13 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "issueGoalPicker",
                            "args": v15 /*: any*/ ,
                            "filters": v14 /*: any*/ ,
                            "handle": "connection",
                            "key": "Goals_issueGoalPicker",
                            "kind": "LinkedHandle",
                            "name": "jiraEpicContributesToAtlasGoal"
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareUnshardedWorkspaceSummaryConnection",
                    "kind": "LinkedField",
                    "name": "townsquareUnsharded_allWorkspaceSummariesForOrg",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "TownsquareUnshardedWorkspaceSummaryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "TownsquareUnshardedWorkspaceSummary",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "937157055e12959c4a5dedd3877600cd0531fb0e4b7826db78fa93e5143aa6d7",
            "metadata": {},
            "name": "GoalsPopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6e338b7504ff52ce$var$node.hash = "6b6483c49f35e89caf438218f946dd41";
var $6e338b7504ff52ce$export$2e2bcd8739ae039 = $6e338b7504ff52ce$var$node;

});

parcelRegister("gUwIV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("9ZmDf")
]).then(()=>parcelRequire('8gn0t'));

});


parcelRegister("knIOf", function(module, exports) {
$parcel$export(module.exports, "GoalsReadView", () => $1ca37a34ff4fe805$export$7f51e00c35102426);

var $jvsdg = parcelRequire("jvsdg");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $byUzi = parcelRequire("byUzi");

var $8lb7o = parcelRequire("8lb7o");

var $3PRLs = parcelRequire("3PRLs");

var $d9T1A = parcelRequire("d9T1A");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $dLVMI = parcelRequire("dLVMI");

var $w8hPK = parcelRequire("w8hPK");

var $2jdpt = parcelRequire("2jdpt");
const $1ca37a34ff4fe805$export$7f51e00c35102426 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const constructGoalUrl = (0, $byUzi.useGoalUrlConstructor)();
    const { selectedGoals: selectedGoals } = (0, $j4oe4.useFragment)((0, $jvsdg.default), fragmentRef);
    const { firstGoal: firstGoal, totalGoalsCount: totalGoalsCount } = (0, $eJOHy.useMemo)(()=>{
        const nodes = selectedGoals?.edges?.map((edge)=>edge?.node)?.filter((node)=>Boolean(node?.key)) ?? [];
        const transformedNodes = nodes.map((node)=>({
                ...node,
                key: node.id,
                url: constructGoalUrl({
                    ari: node.id,
                    key: node.key
                })
            }));
        return {
            firstGoal: transformedNodes[0],
            totalGoalsCount: transformedNodes.length
        };
    }, [
        constructGoalUrl,
        selectedGoals?.edges
    ]);
    const placeholderDataForSmartCard = (0, $eJOHy.useMemo)(()=>{
        return firstGoal && (0, $4cTDP.fg)('goals_ssr_smart_card') ? (0, $2jdpt.generatePlaceholderData)(firstGoal.url, firstGoal.name, firstGoal.status) : undefined;
    }, [
        firstGoal
    ]);
    if (totalGoalsCount === 0 || !selectedGoals) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8lb7o.ItemWithEntryPointPopup), {
        ItemComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3PRLs.SimpleInlineSmartLink), {
            anchorTarget: "_blank",
            url: firstGoal.url,
            ...(0, $4cTDP.fg)('goals_ssr_smart_card') ? {
                placeholderData: placeholderDataForSmartCard
            } : {}
        }),
        totalItems: totalGoalsCount,
        isTruncated: isTruncated,
        entryPoint: (0, $dLVMI.goalsPopupContentEntryPoint),
        entryPointParams: {},
        entryPointRuntimeProps: {
            fragmentRef: selectedGoals
        },
        showMoreTooltip: formatMessage((0, $w8hPK.default).showMoreTooltip),
        actionSubjectIdPrefix: "goals"
    });
};

});
parcelRegister("jvsdg", function(module, exports) {
$parcel$export(module.exports, "default", () => $86f923001178c983$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cca8185d4e99740aa617bbb52991dbaf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $86f923001178c983$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "goals_issueFieldGoalsReadviewFull_GoalsReadView",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraGoalConnection",
            "kind": "LinkedField",
            "name": "selectedGoals",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "popupContent_issueFieldGoalsReadviewFull"
                },
                {
                    "concreteType": "JiraGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraGoal",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "selectedGoals(first:1000)"
        }
    ],
    "type": "JiraGoalsField"
};
$86f923001178c983$var$node.hash = "e8e15ade4d6e6ee4a59b31ff82e7a584";
var $86f923001178c983$export$2e2bcd8739ae039 = $86f923001178c983$var$node;

});

parcelRegister("8lb7o", function(module, exports) {
$parcel$export(module.exports, "ItemWithEntryPointPopup", () => $14af9ae86efae763$export$15750a4e92a11aeb);

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $7ep4S = parcelRequire("7ep4S");

var $dZ3jN = parcelRequire("dZ3jN");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $l1Evt = parcelRequire("l1Evt");

var $l8oUV = parcelRequire("l8oUV");
const $14af9ae86efae763$export$15750a4e92a11aeb = ({ entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointRuntimeProps: entryPointRuntimeProps, ...props })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)(entryPoint, entryPointParams);
    const [retryKey, setRetryKey] = (0, $eJOHy.useState)(0);
    const triggerRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l1Evt.default), {
        isOpen: isOpen,
        onSetIsOpen: setIsOpen,
        triggerRefCallback: triggerRef,
        entryPointActions: entryPointActions,
        PopupComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            key: retryKey,
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "popup-content",
            packageName: "jiraItemWithPopup",
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l8oUV.ErrorFallback), {
                    onClick: ()=>setRetryKey((prev)=>prev + 1)
                }),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                padding: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                size: "medium"
            })),
            runtimeProps: entryPointRuntimeProps
        }),
        ...props
    });
};

});
parcelRegister("l1Evt", function(module, exports) {
$parcel$export(module.exports, "default", () => $9039846db754c967$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6djmC = parcelRequire("6djmC");

var $ibVOD = parcelRequire("ibVOD");

var $1O6K6 = parcelRequire("1O6K6");
const $9039846db754c967$var$ItemWithPopup = ({ ItemComponent: ItemComponent, showMoreTooltip: showMoreTooltip, totalItems: totalItems, PopupComponent: PopupComponent, isOpen: isOpen, onSetIsOpen: onSetIsOpen, triggerRefCallback: triggerRefCallback, actionSubjectIdPrefix: actionSubjectIdPrefix, isTruncated: isTruncated = false, entryPointActions: entryPointActions })=>{
    if (ItemComponent === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.100",
        alignBlock: "center",
        shouldWrap: !isTruncated
    }, ItemComponent, totalItems > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1O6K6.default), {
        showMoreTooltip: showMoreTooltip,
        totalItems: totalItems - 1,
        PopupComponent: PopupComponent,
        isOpen: isOpen,
        onSetIsOpen: onSetIsOpen,
        triggerRefCallback: triggerRefCallback,
        actionSubjectIdPrefix: actionSubjectIdPrefix,
        isTruncated: isTruncated,
        entryPointActions: entryPointActions
    })));
};
var $9039846db754c967$export$2e2bcd8739ae039 = $9039846db754c967$var$ItemWithPopup;

});
parcelRegister("1O6K6", function(module, exports) {
$parcel$export(module.exports, "default", () => $db629c491ab3411a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $4B7rn = parcelRequire("4B7rn");

var $8nMzv = parcelRequire("8nMzv");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $9Mapt = parcelRequire("9Mapt");
const $db629c491ab3411a$var$ShowMorePopup = ({ showMoreTooltip: showMoreTooltip, totalItems: totalItems, PopupComponent: PopupComponent, isOpen: isOpen, onSetIsOpen: onSetIsOpen, triggerRefCallback: triggerRefCallback, actionSubjectIdPrefix: actionSubjectIdPrefix, isTruncated: isTruncated, entryPointActions: entryPointActions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (totalItems === 0) return null;
    const onClickTrigger = ()=>{
        onSetIsOpen(!isOpen);
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), `${actionSubjectIdPrefix}ItemWithPopup`);
    };
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $db629c491ab3411a$var$ContainerDialogStyles
        }, PopupComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null));
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (hoverProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: PopupComponent,
            entryPointActions: entryPointActions,
            isInteractive: true
        }, ({ ref: ref, ariaExpanded: ariaExpanded })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
                "aria-label": `${showMoreTooltip} +${totalItems}`,
                isSelected: isOpen,
                spacing: "none",
                "aria-expanded": ariaExpanded,
                testId: "item-with-popup.ui.item-with-popup.show-more-popup.button",
                ref: ref,
                ...hoverProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                as: "span",
                xcss: $db629c491ab3411a$var$itemsCountStyles,
                paddingInline: "space.050"
            }, "+", totalItems)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>onSetIsOpen(false),
        placement: "bottom",
        content: content,
        testId: "item-with-popup.ui.item-with-popup.show-more-popup.show-more-popup",
        messageId: "item-with-popup.ui.item-with-popup.show-more-popup.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                key: "triggerLinksDialog",
                content: showMoreTooltip,
                tag: $db629c491ab3411a$var$TooltipContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...triggerProps,
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
                "aria-label": `${showMoreTooltip} +${totalItems}`,
                isSelected: isOpen,
                onClick: onClickTrigger,
                spacing: "none",
                ref: (element)=>{
                    triggerRefCallback && triggerRefCallback(element);
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                as: "span",
                xcss: $db629c491ab3411a$var$itemsCountStyles,
                paddingInline: "space.050"
            }, "+", totalItems)))
    });
};
const $db629c491ab3411a$var$TooltipContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ...props,
        ref: ref,
        as: "span",
        xcss: $db629c491ab3411a$var$tooltipContainerStyles
    }));
const $db629c491ab3411a$var$ContainerDialogStyles = (0, $1DXK0.xcss)({
    width: '240px',
    maxHeight: '220px',
    overflow: 'auto',
    padding: 'space.100',
    border: `2px solid ${"var(--ds-border-focused, #4688EC)"}`,
    borderRadius: 'radius.small'
});
const $db629c491ab3411a$var$tooltipContainerStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%'
});
const $db629c491ab3411a$var$itemsCountStyles = (0, $1DXK0.xcss)({
    fontWeight: "var(--ds-font-weight-regular, 400)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-250, 20px)"
});
var $db629c491ab3411a$export$2e2bcd8739ae039 = $db629c491ab3411a$var$ShowMorePopup;

});


parcelRegister("l8oUV", function(module, exports) {
$parcel$export(module.exports, "ErrorFallback", () => $374ab770514ac6b8$export$8a7ad05c3ee0c78a);

var $eJOHy = parcelRequire("eJOHy");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $80DPg = parcelRequire("80DPg");

var $5CSKW = parcelRequire("5CSKW");

var $lRq8t = parcelRequire("lRq8t");

var $447R4 = parcelRequire("447R4");
const $374ab770514ac6b8$export$8a7ad05c3ee0c78a = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        alignInline: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "strong"
    }, formatMessage((0, $447R4.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        onClick: onClick,
        spacing: "compact"
    }, formatMessage((0, $447R4.default).retryMessage)));
};

});
parcelRegister("447R4", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd7cd7f56cf414b6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cd7cd7f56cf414b6$var$messages = (0, $7qGN1.defineMessages)({
    retryMessage: {
        "id": "item-with-popup.ui.item-with-entrypoint-popup.error-fallback.retry-message",
        "defaultMessage": "Click to retry"
    },
    errorMessage: {
        "id": "item-with-popup.ui.item-with-entrypoint-popup.error-fallback.error-message",
        "defaultMessage": "Failed to load content"
    }
});
var $cd7cd7f56cf414b6$export$2e2bcd8739ae039 = $cd7cd7f56cf414b6$var$messages;

});



parcelRegister("dLVMI", function(module, exports) {
$parcel$export(module.exports, "goalsPopupContentEntryPoint", () => $7628b25b096ee0c0$export$dc38dd29dc6b8559);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $7628b25b096ee0c0$export$dc38dd29dc6b8559 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("kg2fg")), {
        moduleId: "e7e5e5c1",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kg2fg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bihbw").then(()=>parcelRequire('aH7r4'));

});


parcelRegister("w8hPK", function(module, exports) {
$parcel$export(module.exports, "default", () => $33c1064efeb698b8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $33c1064efeb698b8$var$messages = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-goals-readview-full.goals.show-more-tooltip",
        "defaultMessage": "See more selected goals"
    }
});
var $33c1064efeb698b8$export$2e2bcd8739ae039 = $33c1064efeb698b8$var$messages;

});

parcelRegister("2jdpt", function(module, exports) {
$parcel$export(module.exports, "generatePlaceholderData", () => $9e440d9012e18f03$export$5d49eb8909604ac1);

var $1QRVx = parcelRequire("1QRVx");
var $2xJv1 = parcelRequire("2xJv1");
const $9e440d9012e18f03$export$5d49eb8909604ac1 = (url, name, status)=>{
    // TODO - Remove name and status checks when cleaning goals_ssr_smart_card (ANIP-459)
    if (!url || !name || !status) return undefined;
    let icon = '';
    switch(status){
        case 'ON_TRACK':
            icon = 'data:image/png;base64,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';
            break;
        case 'AT_RISK':
            icon = 'data:image/png;base64,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';
            break;
        case 'OFF_TRACK':
            icon = 'data:image/png;base64,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';
            break;
        default:
            icon = 'data:image/png;base64,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';
            break;
    }
    // `atlassian:state` is not typed in SmartLinkResponse, so we needed to forcibly set data to JsonLd.Data.Goal
    const data = {
        '@context': {
            '@vocab': 'https://www.w3.org/ns/activitystreams#',
            atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
            schema: 'http://schema.org/'
        },
        generator: {
            '@type': 'Application',
            '@id': 'https://www.atlassian.com/#TeamCentral',
            name: 'Goals'
        },
        '@type': [
            'Object',
            'atlassian:Goal'
        ],
        url: url,
        icon: {
            '@type': 'Image',
            url: icon
        },
        name: name,
        'atlassian:state': {
            '@type': 'Object',
            name: (0, $2xJv1.getGoalStatusLabel)(status).defaultMessage,
            appearance: (0, $1QRVx.getGoalStatusAppearance)(status)
        }
    };
    return {
        meta: {
            auth: [],
            definitionId: 'watermelon-object-provider',
            product: 'townsquare',
            visibility: 'restricted',
            access: 'granted',
            key: 'watermelon-object-provider'
        },
        data: data
    };
};

});




parcelRegister("kHiWE", function(module, exports) {
$parcel$export(module.exports, "IssueKeyCell", () => $307c1eca8f25f6fc$export$a6c835c7dffd9abf);

var $84fOP = parcelRequire("84fOP");

var $bVWsY = parcelRequire("bVWsY");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jx0Vw = parcelRequire("jx0Vw");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $bzbsd = parcelRequire("bzbsd");

var $lRq8t = parcelRequire("lRq8t");

var $jCEKQ = parcelRequire("jCEKQ");

var $6XJko = parcelRequire("6XJko");

var $4cTDP = parcelRequire("4cTDP");

var $jiTA8 = parcelRequire("jiTA8");

var $3OT15 = parcelRequire("3OT15");

var $6bLlX = parcelRequire("6bLlX");

var $deFVD = parcelRequire("deFVD");

var $34oCh = parcelRequire("34oCh");

var $86BUM = parcelRequire("86BUM");

var $88mo0 = parcelRequire("88mo0");

var $89fzG = parcelRequire("89fzG");

var $bofXS = parcelRequire("bofXS");

var $84lUd = parcelRequire("84lUd");
const $307c1eca8f25f6fc$export$a6c835c7dffd9abf = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isRowHoveredOrSelected: isRowHoveredOrSelected, isTruncated: isTruncated, issueRef: issueRef, onIssueLinkSelected: onIssueLinkSelected })=>{
    const intl = (0, $lRq8t.default)();
    const issueKeyData = (0, $j4oe4.useFragment)((0, $bVWsY.default), fieldRef);
    const { text: issueKey } = issueKeyData;
    const fieldsByIdFragment = (0, $j4oe4.useFragment)((0, $84fOP.default), issueRef || null);
    const isRemoteIssue = fieldsByIdFragment?.isRemoteIssue;
    const webUrl = fieldsByIdFragment?.webUrl;
    let toolTipContent = issueKey || '';
    if (isRemoteIssue && webUrl && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) {
        let remoteServerHostname = '';
        try {
            remoteServerHostname = new URL(webUrl).hostname;
        } catch (e) {
        /* empty */ }
        toolTipContent = remoteServerHostname || toolTipContent;
    }
    const issueAriId = fieldsByIdFragment?.id;
    const issueUrl = isRemoteIssue && webUrl && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate') ? webUrl : `/browse/${issueKey}`;
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    let showCopyIssueLink = false;
    if ((0, $4cTDP.fg)('jsc-2733-copy_link_from_issue_key')) showCopyIssueLink = !!isRowHoveredOrSelected;
    const tableCellLinkRef = (0, $eJOHy.useRef)(null);
    let isMergedColumnVisible = false;
    if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnVisible = (0, $34oCh.useIsMergedColumnVisible)();
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(issueKeyData.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: issueKey
    });
    const isEmbedMode = (0, $jiTA8.useIsEmbedMode)();
    let shouldShowIframePreviewPanel = (0, $eJOHy.useCallback)(()=>{
        return false;
    }, []);
    let openIframePreviewPanel = (0, $eJOHy.useCallback)(()=>{
    /* empty */ }, []);
    if ((0, $4cTDP.fg)('issue_preview_panel_issue_view_subtask')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const shouldShowIssueInIframePreviewPanel = (0, $deFVD.useShouldShowIframeIssuePreviewPanel)();
        shouldShowIframePreviewPanel = shouldShowIssueInIframePreviewPanel;
    }
    if (shouldShowIframePreviewPanel()) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { openPreviewPanel: openPreviewPanel } = (0, $6bLlX.useGlobalObjectPreviewPanels)();
        openIframePreviewPanel = openPreviewPanel;
    }
    const onClick = (0, $eJOHy.useCallback)((e)=>{
        if (isRemoteIssue && webUrl && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) return;
        // Use default browser event handling when a modifier key is pressed during the click event
        const isModifierKeyUsed = e.ctrlKey || e.shiftKey || e.metaKey;
        if (shouldShowIframePreviewPanel() && !isModifierKeyUsed) {
            e.preventDefault();
            openIframePreviewPanel({
                ari: issueAriId || '',
                url: issueUrl,
                name: 'jira-issue'
            });
            return;
        }
        const handled = !isEmbedMode && !isModifierKeyUsed && onIssueLinkSelected !== undefined && issueKey && onIssueLinkSelected(issueKey);
        if (handled) e.preventDefault();
    }, [
        isRemoteIssue,
        webUrl,
        shouldShowIframePreviewPanel,
        isEmbedMode,
        onIssueLinkSelected,
        issueKey,
        openIframePreviewPanel,
        issueAriId,
        issueUrl
    ]);
    const issueKeyWithHoverPopover = (0, $eJOHy.useCallback)(({ link: link })=>{
        return link(hoverPopoverRef);
    }, [
        hoverPopoverRef
    ]);
    if (!issueKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "issueKey",
        reason: "Missing required fields"
    });
    const issueStrikeThroughProps = {};
    const statusField = fieldsByIdFragment?.statusField?.status;
    const statusCategoryId = statusField?.statusCategory?.statusCategoryId;
    const isResolved = fieldsByIdFragment?.isResolved ?? undefined;
    const isIssueResolved = (0, $jCEKQ.shouldDisplayStrikethrough)(isResolved, (0, $jx0Vw.statusCategoryForId)(statusCategoryId));
    issueStrikeThroughProps.shouldDisplayStrikethrough = isIssueResolved;
    issueStrikeThroughProps['aria-label'] = intl.formatMessage((0, $84lUd.default).issueKeyWithResolution, {
        issueKey: issueKey,
        isResolved: isIssueResolved
    });
    const getWrapperStyles = ()=>{
        if (isDensityFull) return (0, $6XJko.isVisualRefreshEnabled)() ? $307c1eca8f25f6fc$var$wrapperStylesFull : $307c1eca8f25f6fc$var$wrapperStylesFullOld;
        return (0, $6XJko.isVisualRefreshEnabled)() ? $307c1eca8f25f6fc$var$wrapperStylesCompact : $307c1eca8f25f6fc$var$wrapperStylesCompactOld;
    };
    if (isInlineEditingExtendedFieldSupportEnabled) {
        const issueKeyLink = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $88mo0.TableCellLink), {
                ...issueStrikeThroughProps,
                href: issueUrl,
                isTruncated: !isDensityFull || isSingleLineRowHeightEnabled,
                onClick: onClick,
                ref: (0, $bzbsd.mergeRefs)(tableCellLinkRef, ref),
                testId: "native-issue-table.common.ui.issue-cells.issue-key.issue-key-cell"
            }, issueKey);
        const issueKeyLinkWithWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            paddingBlock: "space.050",
            paddingInline: isMergedColumnVisible ? 'space.050' : 'space.100',
            "data-vc": "native-issue-table-ui-issue-key-cell",
            xcss: [
                isMergedColumnVisible && isTruncated && $307c1eca8f25f6fc$var$overflowHiddenStyles
            ]
        }, isSingleLineRowHeightEnabled ? issueKeyWithHoverPopover({
            link: issueKeyLink
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: toolTipContent
        }, issueKeyLink()));
        return (0, $4cTDP.fg)('jsc-2733-copy_link_from_issue_key') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $89fzG.ActionContainer), null, issueKeyLinkWithWrapper, showCopyIssueLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bofXS.CopyIssueLink), {
            issueKey: issueKey
        })) : issueKeyLinkWithWrapper;
    }
    const issueKeyLink = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $88mo0.TableCellDiscreteLink), {
            href: issueUrl,
            "data-testid": "native-issue-table.common.ui.issue-cells.issue-key.issue-key-cell",
            ...issueStrikeThroughProps,
            isSubtle: true,
            ref: (0, $bzbsd.mergeRefs)(tableCellLinkRef, ref),
            onClick: onClick
        }, issueKey);
    const issueKeyLinkWithWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        paddingInline: isMergedColumnVisible ? 'space.050' : 'space.100',
        xcss: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            getWrapperStyles(),
            isSingleLineRowHeightEnabled && $307c1eca8f25f6fc$var$singleLineRowHeightStyles,
            isMergedColumnVisible && !isTruncated && $307c1eca8f25f6fc$var$overflowVisibleStyles
        ],
        "data-vc": "native-issue-table-ui-issue-key-cell"
    }, isSingleLineRowHeightEnabled ? issueKeyWithHoverPopover({
        link: issueKeyLink
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: toolTipContent
    }, issueKeyLink()));
    return (0, $4cTDP.fg)('jsc-2733-copy_link_from_issue_key') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $89fzG.ActionContainer), null, issueKeyLinkWithWrapper, showCopyIssueLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bofXS.CopyIssueLink), {
        issueKey: issueKey
    })) : issueKeyLinkWithWrapper;
});
const $307c1eca8f25f6fc$var$singleLineRowHeightStyles = (0, $1DXK0.xcss)({
    textOverflow: 'ellipsis'
});
const $307c1eca8f25f6fc$var$wrapperStylesCompactOld = (0, $1DXK0.xcss)({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    maxWidth: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $307c1eca8f25f6fc$var$wrapperStylesCompact = (0, $1DXK0.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    maxWidth: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $307c1eca8f25f6fc$var$wrapperStylesFullOld = (0, $1DXK0.xcss)({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    maxWidth: '100%'
});
const $307c1eca8f25f6fc$var$wrapperStylesFull = (0, $1DXK0.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    maxWidth: '100%'
});
const $307c1eca8f25f6fc$var$overflowVisibleStyles = (0, $1DXK0.xcss)({
    overflow: 'visible'
});
const $307c1eca8f25f6fc$var$overflowHiddenStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden'
});

});
parcelRegister("84fOP", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb1278d3a3066e9d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dfbdab2f00717e1d38ac2f235d1e87ae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fb1278d3a3066e9d$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRemoteLinkedIssuesEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "IssueKeyCell_fields",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "isResolved"
        },
        {
            "concreteType": "JiraStatusField",
            "kind": "LinkedField",
            "name": "statusField",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraStatus",
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraStatusCategory",
                            "kind": "LinkedField",
                            "name": "statusCategory",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "statusCategoryId"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "isRemoteLinkedIssuesEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isRemoteIssue"
                },
                {
                    "kind": "ScalarField",
                    "name": "webUrl"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$fb1278d3a3066e9d$var$node.hash = "a1753ba360213f4a7ae012c6019ee10d";
var $fb1278d3a3066e9d$export$2e2bcd8739ae039 = $fb1278d3a3066e9d$var$node;

});

parcelRegister("bVWsY", function(module, exports) {
$parcel$export(module.exports, "default", () => $d29e9da147c66ef5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6ed19731780bdad3d52e95d62b84f1a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d29e9da147c66ef5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueKeyCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "text"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$d29e9da147c66ef5$var$node.hash = "da780fe572d68360177cd1d738e295b6";
var $d29e9da147c66ef5$export$2e2bcd8739ae039 = $d29e9da147c66ef5$var$node;

});

parcelRegister("jCEKQ", function(module, exports) {
$parcel$export(module.exports, "shouldDisplayStrikethrough", () => $71a3d2c694c5502c$export$1e1e848245d3a6f7);

var $jx0Vw = parcelRequire("jx0Vw");
const { DONE: $71a3d2c694c5502c$var$DONE } = (0, $jx0Vw);
const $71a3d2c694c5502c$export$1e1e848245d3a6f7 = (isResolved, statusCategory)=>{
    if (isResolved !== undefined) return isResolved;
    // In JSW, the strikethrough must now only depend on resolution. However we have to keep
    // this logic because there is a consumer of issue-line-card in JSM that displays
    // the strikethrough based on status src/packages/servicedesk/post-incident-review/src/ui/primary-incident/index.tsx
    return statusCategory === $71a3d2c694c5502c$var$DONE;
};

});

parcelRegister("deFVD", function(module, exports) {
$parcel$export(module.exports, "useGetIssueAriId", () => $7dab99ed1e58ce52$export$3d3ea5770fee9878);
$parcel$export(module.exports, "useShouldShowIframeIssuePreviewPanel", () => $7dab99ed1e58ce52$export$ad255876e5b7c30a);
$parcel$export(module.exports, "useShouldShowNativeIssuePreviewPanel", () => $7dab99ed1e58ce52$export$b0fbfff1091392b6);
$parcel$export(module.exports, "useOpenNativeIssuePreviewPanel", () => $7dab99ed1e58ce52$export$1ca477344eac8cb1);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $4cTDP = parcelRequire("4cTDP");

var $fLy7J = parcelRequire("fLy7J");

var $6bLlX = parcelRequire("6bLlX");

var $eWzpp = parcelRequire("eWzpp");

var $cHtIB = parcelRequire("cHtIB");

var $8oKDI = parcelRequire("8oKDI");

var $kfvK2 = parcelRequire("kfvK2");
var $95O7y = parcelRequire("95O7y");
const $7dab99ed1e58ce52$export$2e131fc4108f9106 = (0, $kfvK2.createRouterSelector)(({ route: route })=>{
    return route?.name === 'issue';
});
const $7dab99ed1e58ce52$export$3d3ea5770fee9878 = (issueId)=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const issueAriId = (0, $eJOHy.useMemo)(()=>{
        if (!issueId || !cloudId) return '';
        return (0, $8oKDI.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'issue',
            resourceId: issueId
        });
    }, [
        issueId,
        cloudId
    ]);
    return issueAriId;
};
const $7dab99ed1e58ce52$export$ad255876e5b7c30a = ()=>{
    const isFullPageIssueView = $7dab99ed1e58ce52$export$2e131fc4108f9106();
    const isPreviewPanelContextAvailable = !!(0, $eJOHy.useContext)((0, $6bLlX.JiraPreviewPanelsContext));
    const { data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $FhXEJ.toProjectType)(project?.type);
    const isJSMOrJPDProject = projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT) || projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT);
    const shouldShowIframePreviewPanel = (0, $eJOHy.useCallback)(()=>{
        const isIssueEmbedPreviewPanel = (0, $fLy7J.isIssueEmbedPreviewPanelOpen)();
        if (// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4cTDP.fg)('issue_preview_panel_issue_view_subtask') && (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') && (0, $4cTDP.fg)('jira-glance-panel') && isPreviewPanelContextAvailable && ((0, $4cTDP.fg)('jsm_enable_preview_panel') || !isJSMOrJPDProject)) return isFullPageIssueView && (0, $4cTDP.fg)('gpp_child_linked_full_page_issue_view') || isIssueEmbedPreviewPanel;
        return false;
    }, [
        isPreviewPanelContextAvailable,
        isJSMOrJPDProject,
        isFullPageIssueView
    ]);
    return shouldShowIframePreviewPanel;
};
const $7dab99ed1e58ce52$export$b0fbfff1091392b6 = ()=>{
    const isPreviewPanelContextAvailable = !!(0, $eJOHy.useContext)((0, $6bLlX.JiraPreviewPanelsContext));
    const { data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $FhXEJ.toProjectType)(project?.type);
    const isJSMOrJPDProject = projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT) || projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT);
    const isIssueNativePreviewPanel = (0, $fLy7J.useIsNativeIssueViewPreviewPanel)();
    const shouldShowNativeIssuePreviewPanel = (0, $eJOHy.useCallback)(()=>{
        if (// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4cTDP.fg)('issue_preview_panel_issue_view_subtask') && (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') && (0, $4cTDP.fg)('jira-glance-panel') && isPreviewPanelContextAvailable && ((0, $4cTDP.fg)('jsm_enable_preview_panel') || !isJSMOrJPDProject)) return isIssueNativePreviewPanel;
        return false;
    }, [
        isPreviewPanelContextAvailable,
        isJSMOrJPDProject,
        isIssueNativePreviewPanel
    ]);
    return shouldShowNativeIssuePreviewPanel;
};
const $7dab99ed1e58ce52$export$1ca477344eac8cb1 = ()=>{
    const [, setSelectedIssue] = (0, $95O7y.useQueryParam)('selectedIssue');
    const openNativeIssuePreviewPanel = (0, $eJOHy.useCallback)((issueKey)=>{
        if (!issueKey) return;
        setSelectedIssue(issueKey);
    }, [
        setSelectedIssue
    ]);
    return openNativeIssuePreviewPanel;
};

});
parcelRegister("fLy7J", function(module, exports) {
$parcel$export(module.exports, "useIsIssuePreviewPanelOpen", () => $b587122c15ef9343$export$39416963f8c85a8a);
$parcel$export(module.exports, "isIssueEmbedPreviewPanelOpen", () => $b587122c15ef9343$export$b0a8938f24ab6382);
$parcel$export(module.exports, "useIsNativeIssueViewPreviewPanel", () => $b587122c15ef9343$export$cf8b981318c31dcc);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $jZ41J = parcelRequire("jZ41J");

var $6bLlX = parcelRequire("6bLlX");
const $b587122c15ef9343$export$39416963f8c85a8a = ()=>{
    const panel = (0, $jZ41J.useCurrentPreviewPanel)();
    return panel !== null && panel.type === 'jira-issue';
};
// Helper function to detect if we're in an iframe
const $b587122c15ef9343$var$isInIframe = ()=>{
    (0, $gRw8I.di)(window);
    if (false) return false;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window !== window.top;
};
const $b587122c15ef9343$export$b0a8938f24ab6382 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return $b587122c15ef9343$var$isInIframe() && window.location.search.includes('previewPanels');
};
const $b587122c15ef9343$export$521182cda3e1f453 = ()=>{
    const context = (0, $eJOHy.useContext)((0, $6bLlX.JiraPreviewPanelsContext));
    return !!context;
};
const $b587122c15ef9343$export$cf8b981318c31dcc = ()=>{
    const panel = (0, $jZ41J.useCurrentPreviewPanel)();
    return panel?.type === 'jira-issue' && panel?.id?.startsWith('jira-issue/');
};

});


parcelRegister("88mo0", function(module, exports) {
$parcel$export(module.exports, "TableCellDiscreteLink", () => $89c9752ede73cfdb$export$4e03936e0e9409e2);
$parcel$export(module.exports, "TableCellLink", () => $89c9752ede73cfdb$export$fce640eb3bd348ea);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lL4G9 = parcelRequire("lL4G9");
var $1DXK0 = parcelRequire("1DXK0");

var $f2JN3 = parcelRequire("f2JN3");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $c9uTK = parcelRequire("c9uTK");

var $jiTA8 = parcelRequire("jiTA8");

var $34oCh = parcelRequire("34oCh");
const $89c9752ede73cfdb$export$4e03936e0e9409e2 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const onClickWithAnalytics = (0, $eJOHy.useCallback)((e)=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        }), 'tableIssueLink');
        onClick && onClick(e);
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    const isEmbedMode = (0, $jiTA8.useIsEmbedMode)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89c9752ede73cfdb$var$StyledLink, {
        ...rest,
        onClick: onClickWithAnalytics,
        ref: ref,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    });
});
const $89c9752ede73cfdb$export$fce640eb3bd348ea = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ 'aria-label': ariaLabel, children: children, href: href, isTruncated: isTruncated, onClick: onClick, shouldDisplayStrikethrough: shouldDisplayStrikethrough, testId: testId }, ref)=>{
    const onClickWithAnalytics = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'tableIssueLink');
        onClick && onClick(e);
    }, [
        onClick
    ]);
    const isEmbedMode = (0, $jiTA8.useIsEmbedMode)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        "aria-label": ariaLabel,
        href: href,
        onClick: onClickWithAnalytics,
        ref: ref,
        testId: testId,
        xcss: [
            $89c9752ede73cfdb$var$linkDefaultStyles,
            isTruncated && $89c9752ede73cfdb$var$linkTruncatedStyles,
            shouldDisplayStrikethrough && $89c9752ede73cfdb$var$linkStrikethroughStyles
        ],
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, children);
});
// Fix for Compiled bug where invalid props are passed on to the underlying DOM element when using inheritance.
const $89c9752ede73cfdb$var$PropFilteredLink = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ innerFocusOutline: innerFocusOutline, shouldDisplayStrikethrough: shouldDisplayStrikethrough, isSubtle: isSubtle, ...rest }, ref)=>// eslint-disable-next-line @atlassian/a11y/anchor-has-content -- See https://go/a11y-anchor-has-content for more details
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
        ...rest,
        ref: ref
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89c9752ede73cfdb$var$StyledLinkOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $89c9752ede73cfdb$var$PropFilteredLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1nmz1hna",
            __cmplp.innerFocusOutline && "_1ah31i6y",
            __cmplp.shouldDisplayStrikethrough && "_4bfu18uv _1hms1911 _ajmmnqa1",
            __cmplp.isSingleLineRowHeightEnabled && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1e0c1ule",
            __cmplp.className
        ])
    });
});
const $89c9752ede73cfdb$var$StyledLinkNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $89c9752ede73cfdb$var$PropFilteredLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1nmz1hna",
            __cmplp.isSubtle ? "_syazazsu" : "_syazi7uo",
            __cmplp.innerFocusOutline && "_1ah31i6y",
            __cmplp.shouldDisplayStrikethrough && "_4bfu18uv _1hms1911 _ajmmnqa1",
            __cmplp.isSingleLineRowHeightEnabled && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1e0c1ule",
            __cmplp.className
        ])
    });
});
const $89c9752ede73cfdb$var$linkDefaultStyles = (0, $1DXK0.xcss)({
    cursor: 'pointer',
    display: 'block',
    font: 'font.body',
    overflow: 'hidden',
    textDecoration: 'underline',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word'
});
const $89c9752ede73cfdb$var$linkTruncatedStyles = (0, $1DXK0.xcss)({
    whiteSpace: 'nowrap'
});
const $89c9752ede73cfdb$var$linkStrikethroughStyles = (0, $1DXK0.xcss)({
    textDecoration: 'line-through',
    ':hover': {
        textDecoration: 'line-through'
    }
});
const $89c9752ede73cfdb$var$StyledLink = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $89c9752ede73cfdb$var$StyledLinkNew, $89c9752ede73cfdb$var$StyledLinkOld);

});

parcelRegister("89fzG", function(module, exports) {
$parcel$export(module.exports, "ActionContainer", () => $35c61a9c86e8e23b$export$37ab3bdebc286ca);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $35c61a9c86e8e23b$export$37ab3bdebc286ca = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "native-issue-table.common.ui.issue-cells.issue-key.action-container",
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _bp4dglyw _7iw51txw _1yzlt94y _s1241txw _fx2mt94y"
        ])
    }, children);
};
const $35c61a9c86e8e23b$var$containerStyles = null;

});

parcelRegister("bofXS", function(module, exports) {
$parcel$export(module.exports, "CopyIssueLink", () => $bdb8672f6634ddb7$export$8ac20de618d64f5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $Ay1uj = parcelRequire("Ay1uj");

var $cV8sz = parcelRequire("cV8sz");

var $3wl9L = parcelRequire("3wl9L");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $8jOO7 = parcelRequire("8jOO7");

var $eRxrG = parcelRequire("eRxrG");
const $bdb8672f6634ddb7$export$3fee15f76e8cacc7 = 3000;
const $bdb8672f6634ddb7$export$8ac20de618d64f5 = ({ issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isCopied, setCopied] = (0, $eJOHy.useState)(false);
    const handleCopy = async (e, analyticsEvent)=>{
        e.preventDefault();
        e.stopPropagation();
        const url = typeof window !== 'undefined' ? `${window.location.origin}/browse/${issueKey}` : '';
        try {
            await globalThis.navigator.clipboard.writeText(url);
            setCopied(true);
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'tableCopyIssueLink');
        } catch (error) {
            setCopied(false);
            (0, $9pTd3.fireErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'copyIssueLink',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                }
            });
        }
    };
    (0, $eJOHy.useEffect)(()=>{
        const copyTimer = isCopied ? setTimeout(()=>setCopied(false), $bdb8672f6634ddb7$export$3fee15f76e8cacc7) : undefined;
        return ()=>copyTimer && clearTimeout(copyTimer);
    }, [
        isCopied
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1e0c18j6 _tzy4pcxq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        spacing: "compact",
        isTooltipDisabled: false,
        onClick: handleCopy,
        label: formatMessage(isCopied ? (0, $eRxrG.default).copied : (0, $eRxrG.default).copy),
        icon: (iconProps)=>isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3wl9L))), {
                ...iconProps,
                size: "small",
                color: "var(--ds-icon-success, #6A9A23)"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cV8sz))), {
                ...iconProps,
                size: "small"
            })
    }));
};
const $bdb8672f6634ddb7$var$wrapperStyles = null;

});
parcelRegister("eRxrG", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a8715e060277f5f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6a8715e060277f5f$var$messages = (0, $7qGN1.defineMessages)({
    copy: {
        "id": "native-issue-table.common.issue-cells.issue-key.copy-issue-link.copy",
        "defaultMessage": "Copy link"
    },
    copied: {
        "id": "native-issue-table.common.issue-cells.issue-key.copy-issue-link.copied",
        "defaultMessage": "Copied"
    }
});
var $6a8715e060277f5f$export$2e2bcd8739ae039 = $6a8715e060277f5f$var$messages;

});


parcelRegister("84lUd", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f69130195f8c718$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5f69130195f8c718$var$messages = (0, $7qGN1.defineMessages)({
    issueKeyWithResolution: {
        "id": "native-issue-table.common.issue-cells.issue-key.issue-key-with-resolution",
        "defaultMessage": "{issueKey} is {isResolved, select, \n            true {resolved}\n            false {not resolved}\n            other {}\n        }"
    }
});
var $5f69130195f8c718$export$2e2bcd8739ae039 = $5f69130195f8c718$var$messages;

});


parcelRegister("2Oa4s", function(module, exports) {
$parcel$export(module.exports, "IssueLinksCell", () => $9fbe8ab73e77d900$export$75aa2ccc20dd7954);

var $hUWVH = parcelRequire("hUWVH");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8IeH1 = parcelRequire("8IeH1");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $8lb7o = parcelRequire("8lb7o");

var $1tX0c = parcelRequire("1tX0c");

var $cHtIB = parcelRequire("cHtIB");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");

var $5O293 = parcelRequire("5O293");

var $kwfkD = parcelRequire("kwfkD");
const $9fbe8ab73e77d900$export$75aa2ccc20dd7954 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, issueKey: issueKey, accordionInitialIsOpen: accordionInitialIsOpen = false, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $hUWVH.default), fieldRef);
    const cloudId = (0, $cHtIB.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            issueKey: issueKey,
            cloudId: cloudId
        }), [
        issueKey,
        cloudId
    ]);
    const issueLinks = data?.issueLinkConnection?.edges;
    const totalCount = data?.issueLinkConnection?.totalCount;
    const filteredIssueLinks = (0, $eJOHy.useMemo)(()=>issueLinks?.map((edge)=>edge?.node?.issue?.key != null ? {
                key: edge.node.issue?.key || 'missingId',
                name: edge.node.issue?.key,
                href: edge.node.issue?.webUrl || '',
                relationName: edge.node.relationName,
                shouldDisplayStrikethrough: (0, $4cTDP.fg)('nin-strikethrough-resolution-update') ? edge.node.issue?.isResolved === true : edge.node.issue?.fieldsById?.edges?.[0]?.node?.statusCategory?.statusCategoryId === '3' || false
            } : null).filter(Boolean) ?? [], [
        issueLinks
    ]);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            issueKey: issueKey,
            issueSearchBaseUrl: issueSearchBaseUrl,
            accordionInitialIsOpen: accordionInitialIsOpen
        }), [
        issueKey,
        issueSearchBaseUrl,
        accordionInitialIsOpen
    ]);
    if (!issueLinks) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "issueLinks",
        reason: "Missing issue links field"
    });
    if (issueLinks.length !== filteredIssueLinks.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "issueLinks",
        reason: "Missing fields on issue links"
    });
    if (totalCount === undefined || totalCount === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "issueLinks",
        reason: "Missing total count"
    });
    if (totalCount < 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "issueLinks",
        reason: "Invalid total count"
    });
    if (totalCount > 0 && filteredIssueLinks.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "issueLinks",
        reason: "Total count valid but no issue links given"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8lb7o.ItemWithEntryPointPopup), {
        entryPoint: (0, $5O293.issueLinksPopUpContentEntryPoint),
        entryPointParams: entryPointParams,
        entryPointRuntimeProps: runtimeProps,
        totalItems: Math.min(totalCount, 1000),
        ItemComponent: totalCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1tX0c.TagItem), {
            name: filteredIssueLinks[0].name,
            href: filteredIssueLinks[0].href,
            shouldDisplayStrikethrough: filteredIssueLinks[0].shouldDisplayStrikethrough,
            key: filteredIssueLinks[0].key,
            isHoverPopoverEnabled: isSingleLineRowHeightEnabled,
            isOnlyOneItem: totalCount === 1
        }) : undefined,
        showMoreTooltip: formatMessage((0, $kwfkD.default).triggerButton),
        actionSubjectIdPrefix: "issueLinks",
        isTruncated: isSingleLineRowHeightEnabled
    }));
});

});
parcelRegister("hUWVH", function(module, exports) {
$parcel$export(module.exports, "default", () => $c436007df12635a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<edee2d7a833365702ebf47b935d8763e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c436007df12635a9$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "IssueLinksCell",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                }
            ],
            "concreteType": "JiraIssueLinkConnection",
            "kind": "LinkedField",
            "name": "issueLinkConnection",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                {
                    "concreteType": "JiraIssueLinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueLink",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "webUrl"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "ids",
                                                    "value": [
                                                        "statusCategory"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsById",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "statusCategoryId"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraStatusCategoryField"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isResolved"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "relationName"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "issueLinkConnection(first:1)"
        }
    ],
    "type": "JiraIssueLinkField"
};
$c436007df12635a9$var$node.hash = "6f8544377bd3253e00a7282eb15fe7f9";
var $c436007df12635a9$export$2e2bcd8739ae039 = $c436007df12635a9$var$node;

});

parcelRegister("5O293", function(module, exports) {
$parcel$export(module.exports, "issueLinksPopUpContentEntryPoint", () => $e0267059e9a46e26$export$94cbcdadb553c314);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $4cTDP = parcelRequire("4cTDP");

var $fTbpa = parcelRequire("fTbpa");

const $e0267059e9a46e26$export$94cbcdadb553c314 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("d3bw0")), {
        moduleId: "a490a919",
        moduleName: "IssueLinksPopUpContent",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueKey: issueKey, cloudId: cloudId })=>({
            queries: {
                links: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $fTbpa.default,
                    variables: {
                        issueKey: issueKey,
                        cloudId: cloudId,
                        isNinStrikethroughResolutionUpdateEnabled: (0, $4cTDP.fg)('nin-strikethrough-resolution-update')
                    }
                }
            }
        })
});

});
parcelRegister("fTbpa", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d0bc09e0726e104$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<40103709839894f4f600f4230241eb3f>>
 * @relayHash 47462afc0ebf26ecf33671324e3c8ebe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15ef48ce3d4b994e09c46825fbb643f76a3bce05b8e6f2d677841b8d309fe9bb
const $1d0bc09e0726e104$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "15ef48ce3d4b994e09c46825fbb643f76a3bce05b8e6f2d677841b8d309fe9bb",
        "metadata": {},
        "name": "IssueLinksPopUpContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1d0bc09e0726e104$export$2e2bcd8739ae039 = $1d0bc09e0726e104$var$node;

});

parcelRegister("d3bw0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2DJ8B").then(()=>parcelRequire('a8JgW'));

});


parcelRegister("kwfkD", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6704bed28e4bf44$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a6704bed28e4bf44$var$messages = (0, $7qGN1.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.issue-links.trigger-button",
        "defaultMessage": "See more"
    },
    showMoreLink: {
        "id": "native-issue-table.common.issue-cells.issue-links.show-more-link",
        "defaultMessage": "Go to all linked issues"
    },
    showMoreLinkIssueTermRefresh: {
        "id": "native-issue-table.common.issue-cells.issue-links.show-more-link-issue-term-refresh",
        "defaultMessage": "Go to all linked work items"
    }
});
var $a6704bed28e4bf44$export$2e2bcd8739ae039 = $a6704bed28e4bf44$var$messages;

});


parcelRegister("dBL3m", function(module, exports) {
$parcel$export(module.exports, "IssueOperations", () => $a53c21bf66ddff69$export$125bc3f55de1b4bd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");


const $a53c21bf66ddff69$var$BaseIssueOperations = (parcelRequire("4rVHQ")).default;
const $a53c21bf66ddff69$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-cell-issue-operations",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $a53c21bf66ddff69$export$125bc3f55de1b4bd = /*#__PURE__*/ (0, $eJOHy.memo)(({ issueKey: issueKey, issueId: issueId, workType: workType, onIssueRefetch: onIssueRefetch, onIssueDelete: onIssueDelete, isCreateSubTaskAllowed: isCreateSubTaskAllowed })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a53c21bf66ddff69$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a53c21bf66ddff69$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a53c21bf66ddff69$var$BaseIssueOperations, {
        issueId: issueId,
        issueKey: issueKey,
        workType: workType,
        isCreateSubTaskAllowed: isCreateSubTaskAllowed,
        onIssueRefetch: onIssueRefetch,
        onIssueDelete: onIssueDelete
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a53c21bf66ddff69$var$ButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko12b0 _bfhk1w7a _1bsb1ns9 _18u01wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4rVHQ", function(module, exports) {


module.exports = (parcelRequire("g81qY"))('empanada_nin_convert_issue_ops_to_entrypoint', function() {
    return parcelRequire('lWS5G');
}, function() {
    return parcelRequire('3NFLp');
}, {
    l: (parcelRequire("bbrhz")),
    i: [
        "gD3cg",
        "e01ok"
    ]
});

});
parcelRegister("g81qY", function(module, exports) {
"use strict";

var $9VDxJ = parcelRequire("9VDxJ");
var $bbde81794392820b$require$getBundleURL = $9VDxJ.getBundleURL;

var $iTG8W = parcelRequire("iTG8W");
var $bbde81794392820b$require$resolve = $iTG8W.resolve;
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            globalThis.__ATLASPACK_ERRORS = globalThis.__ATLASPACK_ERRORS || [];
            globalThis.__ATLASPACK_ERRORS.push(new Error(`Sync dependency fallback triggered for condition "${cond}": ${err.message}`));
            for (const id of fallback.i)fallback.l(new URL($bbde81794392820b$require$resolve(id), $bbde81794392820b$require$getBundleURL(id)).toString());
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});
parcelRegister("9VDxJ", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", () => $73a81c5f1e1fde26$export$bdfd709ae4826697, (v) => $73a81c5f1e1fde26$export$bdfd709ae4826697 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73a81c5f1e1fde26$export$5a759dc7a1cfb72a;
var $73a81c5f1e1fde26$export$bdfd709ae4826697;
var $73a81c5f1e1fde26$export$c9e73fbda7da57b6;
"use strict";
const $73a81c5f1e1fde26$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $73a81c5f1e1fde26$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $73a81c5f1e1fde26$var$getBundleURLCached(id, inputError) {
    let value = $73a81c5f1e1fde26$var$bundleURL[id];
    if (!value) {
        value = $73a81c5f1e1fde26$var$getBundleURL(inputError);
        $73a81c5f1e1fde26$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $73a81c5f1e1fde26$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $73a81c5f1e1fde26$var$getBundleURL(inputError) {
    try {
        throw inputError ?? new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($73a81c5f1e1fde26$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $73a81c5f1e1fde26$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $73a81c5f1e1fde26$var$getOrigin(url) {
    return new URL(url).origin;
}
$73a81c5f1e1fde26$export$5a759dc7a1cfb72a = $73a81c5f1e1fde26$var$getOrigin;
$73a81c5f1e1fde26$export$bdfd709ae4826697 = $73a81c5f1e1fde26$var$getBundleURLCached;
$73a81c5f1e1fde26$export$c9e73fbda7da57b6 = $73a81c5f1e1fde26$var$getBaseURL;

});


parcelRegister("bbrhz", function(module, exports) {
"use strict";
module.exports = function loadJSBundle(bundle) {
    // Don't insert the same script twice (e.g. if it was already in the HTML)
    let existingScripts = document.getElementsByTagName('script');
    let isCurrentBundle = function(script) {
        return script.src === bundle;
    };
    if ([].concat(existingScripts).some(isCurrentBundle)) return;
    // Request using XHR because it's synchronous and we can't use promises here
    // This has extremely poor performance because we're idle during this fetch, so we only use this so that the app won't crash
    const xhr = new XMLHttpRequest();
    xhr.open('GET', bundle, false);
    try {
        xhr.send();
        if (xhr.status === 200) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.text = xhr.responseText;
            // Execute the script synchronously
            document.head.appendChild(script);
        } else throw new TypeError(`Failed to fetch dynamically imported module: ${bundle}. Status: ${xhr.status}`);
    } catch (e) {
        throw new TypeError(`Failed to fetch dynamically imported module: ${bundle}. Error: ${e.message}`);
    }
};

});



parcelRegister("5eN53", function(module, exports) {
$parcel$export(module.exports, "IssueStatusCategoryCell", () => $34f57cfe240d8d06$export$663286ccb241374c);

var $bOIZ1 = parcelRequire("bOIZ1");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $hRhIm = parcelRequire("hRhIm");

var $3OT15 = parcelRequire("3OT15");

var $4cTDP = parcelRequire("4cTDP");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");
const $34f57cfe240d8d06$export$663286ccb241374c = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $bOIZ1.default), fieldRef);
    const { statusCategory: statusCategory } = data;
    const { name: name } = statusCategory;
    const statusCategoryId = parseInt(statusCategory.statusCategoryId, 10);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: statusCategory.name
    });
    if (Number.isNaN(statusCategoryId) || statusCategoryId === -1 || !name?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "statusCategory",
        reason: "Missing required fields"
    });
    if (!isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $34f57cfe240d8d06$var$alignmentFixStyles : $34f57cfe240d8d06$var$alignmentFixStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
        value: {
            id: '',
            name: name,
            statusCategory: {
                id: statusCategoryId
            }
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $34f57cfe240d8d06$var$alignmentFixStyles : $34f57cfe240d8d06$var$alignmentFixStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
        value: {
            id: '',
            name: name,
            statusCategory: {
                id: statusCategoryId
            }
        },
        contentRef: hoverPopoverRef
    }));
});
// Status lozenges have a 2px invisible border around them to keep them in the same place if they enter an "error" state (where a border colour is added).
// Refer to: src/packages/issue/fields/status/src/common/ui/status-lozenge/main.tsx
const $34f57cfe240d8d06$var$alignmentFixStylesOld = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginLeft: 'space.negative.025'
});
const $34f57cfe240d8d06$var$alignmentFixStyles = (0, $1DXK0.xcss)({
    marginInlineStart: 'space.negative.025'
});

});
parcelRegister("bOIZ1", function(module, exports) {
$parcel$export(module.exports, "default", () => $939ed9c6a569111a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9616e526ed63460518841a4209c90070>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $939ed9c6a569111a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueStatusCategoryCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "statusCategoryId"
                }
            ]
        }
    ],
    "type": "JiraStatusCategoryField"
};
$939ed9c6a569111a$var$node.hash = "572521b74cb1e5c0d987e2f909d90e33";
var $939ed9c6a569111a$export$2e2bcd8739ae039 = $939ed9c6a569111a$var$node;

});

parcelRegister("hRhIm", function(module, exports) {
$parcel$export(module.exports, "StatusLozenge", () => $7b782d104096cf08$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "StatusLozengeWithDropdownIndicator", () => $7b782d104096cf08$export$9f5070a985b0679b);

var $eJOHy = parcelRequire("eJOHy");

var $6UBwj = parcelRequire("6UBwj");
const $7b782d104096cf08$export$f72db4ad1e9b3e6d = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UBwj.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        contentRef: props.contentRef
    });
};
const $7b782d104096cf08$export$9f5070a985b0679b = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UBwj.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        shouldShowDropdownIndication: true
    });
};

});
parcelRegister("6UBwj", function(module, exports) {
$parcel$export(module.exports, "TEST_ID_PREFIX", () => $517c92a4e3fff9f6$export$9cbc201c09a37b3f);
$parcel$export(module.exports, "StatusLozenge", () => $517c92a4e3fff9f6$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "WrappedStatusLozenge", () => $517c92a4e3fff9f6$export$69ea4907eefa8e7b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $fWpUz = parcelRequire("fWpUz");
const $517c92a4e3fff9f6$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
const $517c92a4e3fff9f6$var$CustomChevronDownCustomIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: 12,
        height: 12,
        viewBox: "5 5 13 13",
        "aria-label": props.label || undefined,
        role: props.label ? 'img' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $517c92a4e3fff9f6$export$f72db4ad1e9b3e6d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StatusContentWrapper, {
        "data-testid": `${$517c92a4e3fff9f6$export$9cbc201c09a37b3f}${statusCategory.id}`,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ref: ref
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fWpUz.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StyledLozengeContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center"
    }, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$CustomChevronDownCustomIcon, {
        label: ""
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fWpUz.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, name)), hasHoverState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $517c92a4e3fff9f6$var$hoverOverlayStyles
    })));
const $517c92a4e3fff9f6$export$69ea4907eefa8e7b = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, contentRef: contentRef, triggerProps: triggerProps = {}, ...others } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $517c92a4e3fff9f6$var$pressableStyles,
        ref: targetRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        // When the popup is open we don't want to track the click on this button as it solely closes
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$export$f72db4ad1e9b3e6d, {
        ...others,
        isEditable: isEditable,
        ref: contentRef
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $517c92a4e3fff9f6$var$StyledLozengeContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1bgi",
            __cmplp.className
        ])
    });
});
const $517c92a4e3fff9f6$var$StatusContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $517c92a4e3fff9f6$var$pressableStyles = (0, $1DXK0.xcss)({
    border: 'none',
    padding: 'space.0',
    borderRadius: 'radius.small',
    background: 'transparent',
    position: 'relative',
    maxWidth: '100%',
    marginLeft: 'space.025'
});
const $517c92a4e3fff9f6$var$hoverOverlayStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    inset: '0',
    borderRadius: 'radius.small',
    marginRight: 'space.025',
    ':hover': {
        opacity: 0.3,
        backgroundColor: 'color.background.inverse.subtle'
    }
});

});
parcelRegister("fWpUz", function(module, exports) {
$parcel$export(module.exports, "Lozenge", () => $b5ac3d09b389e3b4$export$a31cbe1bf5463979);

var $eJOHy = parcelRequire("eJOHy");

var $cHj0f = parcelRequire("cHj0f");

var $jdqdp = parcelRequire("jdqdp");

const $b5ac3d09b389e3b4$export$a31cbe1bf5463979 = ({ children: children, statusCategoryId: statusCategoryId, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        appearance: (0, $cHj0f.statusCategoryToThemeMap)[statusCategoryId],
        isBold: true,
        ...isDisabled ? {
            style: {
                color: (0, $cHj0f.disabledColor).text,
                backgroundColor: (0, $cHj0f.disabledColor).bg
            }
        } : {}
    }, children);

});
parcelRegister("cHj0f", function(module, exports) {
$parcel$export(module.exports, "statusCategoryToThemeMap", () => $5aaba5cc62f3cdbe$export$d9e35f42afe1e488);
$parcel$export(module.exports, "disabledColor", () => $5aaba5cc62f3cdbe$export$b70f10fc4a6ba453);
const $5aaba5cc62f3cdbe$export$61137dce61763ec3 = 'default';
const $5aaba5cc62f3cdbe$export$132676d06d92ad48 = 'success';
const $5aaba5cc62f3cdbe$export$5c1f3b72419aa125 = 'inprogress';
const $5aaba5cc62f3cdbe$export$d9e35f42afe1e488 = {
    '1': $5aaba5cc62f3cdbe$export$61137dce61763ec3,
    '2': $5aaba5cc62f3cdbe$export$61137dce61763ec3,
    '3': $5aaba5cc62f3cdbe$export$132676d06d92ad48,
    '4': $5aaba5cc62f3cdbe$export$5c1f3b72419aa125
};
const $5aaba5cc62f3cdbe$export$7dcbec377a25efc6 = {
    [$5aaba5cc62f3cdbe$export$61137dce61763ec3]: "var(--ds-background-neutral, #0515240F)",
    [$5aaba5cc62f3cdbe$export$132676d06d92ad48]: "var(--ds-background-success, #EFFFD6)",
    [$5aaba5cc62f3cdbe$export$5c1f3b72419aa125]: "var(--ds-background-information, #E9F2FE)"
};
const $5aaba5cc62f3cdbe$export$32f78bffcd82ff28 = {
    [$5aaba5cc62f3cdbe$export$61137dce61763ec3]: "var(--ds-text-subtle, #505258)",
    [$5aaba5cc62f3cdbe$export$132676d06d92ad48]: "var(--ds-text-success, #4C6B1F)",
    [$5aaba5cc62f3cdbe$export$5c1f3b72419aa125]: "var(--ds-text-information, #1558BC)"
};
const $5aaba5cc62f3cdbe$export$26ac04004fa4ead4 = {
    [$5aaba5cc62f3cdbe$export$61137dce61763ec3]: "var(--ds-text, #292A2E)",
    [$5aaba5cc62f3cdbe$export$132676d06d92ad48]: "var(--ds-text-success, #4C6B1F)",
    [$5aaba5cc62f3cdbe$export$5c1f3b72419aa125]: "var(--ds-text-information, #1558BC)"
};
const $5aaba5cc62f3cdbe$export$69fdf3ba928b4c77 = {
    [$5aaba5cc62f3cdbe$export$61137dce61763ec3]: "var(--ds-background-neutral-hovered, #0B120E24)",
    [$5aaba5cc62f3cdbe$export$132676d06d92ad48]: "var(--ds-background-success-hovered, #D3F1A7)",
    [$5aaba5cc62f3cdbe$export$5c1f3b72419aa125]: "var(--ds-background-information-hovered, #CFE1FD)"
};
const $5aaba5cc62f3cdbe$export$99ec0cf2cf1b2082 = {
    [$5aaba5cc62f3cdbe$export$61137dce61763ec3]: "var(--ds-text, #292A2E)",
    [$5aaba5cc62f3cdbe$export$132676d06d92ad48]: "var(--ds-text-success, #4C6B1F)",
    [$5aaba5cc62f3cdbe$export$5c1f3b72419aa125]: "var(--ds-text-information, #1558BC)"
};
const $5aaba5cc62f3cdbe$export$b70f10fc4a6ba453 = {
    bg: "var(--ds-background-neutral, #0515240F)",
    text: "var(--ds-text-disabled, #080F214A)"
};

});





parcelRegister("aa1Tw", function(module, exports) {
$parcel$export(module.exports, "IssueStatusCell", () => $e390628a0a08524c$export$58e0df5bb69dbb83);

var $cDNhn = parcelRequire("cDNhn");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $1jVV7 = parcelRequire("1jVV7");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6BnaS = parcelRequire("6BnaS");

var $hRhIm = parcelRequire("hRhIm");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $9Mapt = parcelRequire("9Mapt");

var $4cTDP = parcelRequire("4cTDP");

var $3OT15 = parcelRequire("3OT15");

var $1jdzZ = parcelRequire("1jdzZ");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");

var $jT7JX = parcelRequire("jT7JX");

var $P01So = parcelRequire("P01So");

var $7Gpga = parcelRequire("7Gpga");
const $e390628a0a08524c$export$58e0df5bb69dbb83 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueKey: issueKeyProp, issueId: issueId, onUpdateCache: onUpdateCacheProp, recordId: recordId, itemsConnectionId: itemsConnectionId, groupConnectionId: groupConnectionId, isColumnSticky: isColumnSticky })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    let handleStatusUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $4cTDP.fg)('jsc_list_hide_done_items') && (0, $4cTDP.fg)('memoise_issuetable_components')) // eslint-disable-next-line react-hooks/rules-of-hooks
    handleStatusUpdate = (0, $jT7JX.useHideDoneItems)({
        itemsConnectionId: itemsConnectionId,
        recordId: recordId,
        projectKey: issueKeyProp && (0, $P01So.getProjectKeyFromIssueKey)(issueKeyProp),
        groupConnectionId: groupConnectionId
    });
    const handleUpdateCache = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('jsc_list_hide_done_items') && (0, $4cTDP.fg)('memoise_issuetable_components') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useCallback)((issueKey, fieldName, field)=>{
        onUpdateCacheProp?.(issueKey, fieldName, field);
        handleStatusUpdate(field);
    }, [
        handleStatusUpdate,
        onUpdateCacheProp
    ]) : onUpdateCacheProp;
    const data = (0, $j4oe4.useFragment)((0, $cDNhn.default), fieldRef);
    const { status: status } = data;
    const [value, setValue] = (0, $eJOHy.useState)(status);
    const [isEditing, setIsEditing] = (0, $eJOHy.useState)(false);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const contentRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        setValue(status);
    }, [
        status
    ]);
    const onSubmit = (0, $eJOHy.useCallback)((oldValue, newValue, meta, event)=>{
        // Mirrors the updated event fired from the issue view (with the addition of `isInlineEditing: true`) to
        // be used for core action tracking as defined in https://hello.atlassian.net/wiki/spaces/ANALYTICS/pages/3767029088/Monthly+Core+User+MCU+Definition
        (0, $kRgKj.fireTrackAnalytics)(event, 'issueStatus updated', {
            oldValId: oldValue.id,
            oldStatusCategoryId: oldValue.statusCategory.id,
            newValId: newValue.id,
            newStatusCategoryId: newValue.statusCategory.id,
            hasScreen: meta.transition.hasScreen,
            isConditional: meta.transition.isConditional,
            isInlineEditing: true
        });
    }, []);
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    const modifiersFromContext = (0, $1jdzZ.useEditViewPopupModifiersContext)();
    const popperProps = (0, $eJOHy.useMemo)(()=>{
        const hasBasicFrozenColumns = // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4cTDP.fg)('issue_table_frozen_columns') && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix');
        const isStickyColumn = (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') && isColumnSticky;
        if (isStickyColumn && hasBasicFrozenColumns) return {
            modifiers: [
                {
                    name: 'preventOverflow',
                    enabled: false
                }
            ],
            strategy: 'absolute',
            innerRef: (element)=>{
                if (element) // setting the zIndex to ensure the dropdown is not on top of the workflow modal
                // eslint-disable-next-line no-param-reassign
                element.style.zIndex = String((0, $1jVV7.layers).modal - 1);
            }
        };
        return hasBasicFrozenColumns ? {
            modifiers: modifiersFromContext
        } : undefined;
    }, [
        modifiersFromContext,
        isColumnSticky
    ]);
    if (value?.statusCategory?.statusCategoryId === undefined || !value?.name?.length || !value?.statusId?.length) {
        if ((0, $4cTDP.fg)('issue-table-status-cell-error-logs')) (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issue-table-status-error-cell rendered', {
            statusId: value?.statusId,
            statusCategoryId: value?.statusCategory?.statusCategoryId,
            statusNameExists: Boolean(value?.name),
            ...(0, $4cTDP.fg)('relay_migration_children_issues_section') ? {
                frameworkType: 'relay'
            } : {}
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
            cellType: "status",
            reason: "Missing required fields"
        });
    }
    const onSuccess = (newStatus)=>{
        const transformedStatus = (0, $7Gpga.toJiraStatusField)(newStatus);
        setValue(transformedStatus);
        handleUpdateCache && handleUpdateCache(issueKeyProp, 'status', transformedStatus);
    };
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: (0, $7Gpga.toStatusValue)(value).name
    });
    // If the property does not exist in fragment data then we know it has been conditionally excluded because
    // inline editing is disabled. In future this should follow the same design/deferred loading strategy of
    // other inline editable fields, however this would require a larger effort to decompose the status field.
    const isEditable = data && typeof data.id === 'string';
    if (!isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $e390628a0a08524c$var$alignmentFixStyles : $e390628a0a08524c$var$alignmentFixStylesOld,
        "data-vc": "native-issue-table-ui-issue-status-box"
    }, isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6BnaS.AsyncIssueStatusField), {
        issueKey: issueKeyProp,
        issueId: issueId && issueId,
        appearance: "lozenge",
        value: (0, $7Gpga.toStatusValue)(value),
        onSubmit: onSubmit,
        onSuccess: onSuccess
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
        value: (0, $7Gpga.toStatusValue)(value)
    }));
    return hoverPopoverRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $e390628a0a08524c$var$alignmentFixStyles : $e390628a0a08524c$var$alignmentFixStylesOld,
        "data-vc": "native-issue-table-ui-issue-status-box",
        ref: isEditing ? ()=>hoverPopoverRef(null) : hoverPopoverRef
    }, isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6BnaS.AsyncIssueStatusField), {
        popperProps: popperProps,
        issueKey: issueKeyProp,
        issueId: issueId && issueId,
        appearance: "lozenge",
        value: (0, $7Gpga.toStatusValue)(value),
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onEditStart: ()=>setIsEditing(true),
        onEditCancel: ()=>setIsEditing(false),
        shouldCaptureEscape: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
        value: (0, $7Gpga.toStatusValue)(value)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
        content: (0, $7Gpga.toStatusValue)(value).name,
        contentRef: contentRef,
        hidePopover: isEditing
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $e390628a0a08524c$var$alignmentFixStyles : $e390628a0a08524c$var$alignmentFixStylesOld,
            "data-vc": "native-issue-table-ui-issue-status-box",
            ref: ref
        }, isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6BnaS.AsyncIssueStatusField), {
            issueKey: issueKeyProp,
            issueId: issueId && issueId,
            appearance: "lozenge",
            value: (0, $7Gpga.toStatusValue)(value),
            onSubmit: onSubmit,
            onSuccess: onSuccess,
            statusButtonRef: contentRef,
            onEditStart: ()=>setIsEditing(true),
            onEditCancel: ()=>setIsEditing(false),
            shouldCaptureEscape: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
            value: (0, $7Gpga.toStatusValue)(value)
        })));
});
// Status lozenges have a 2px invisible border around them to keep them in the same place if they enter an "error" state (where a border colour is added).
// Refer to: src/packages/issue/fields/status/src/common/ui/status-lozenge/main.tsx
const $e390628a0a08524c$var$alignmentFixStyles = (0, $1DXK0.xcss)({
    marginInlineStart: 'space.negative.025'
});
const $e390628a0a08524c$var$alignmentFixStylesOld = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginLeft: 'space.negative.025'
});

});
parcelRegister("cDNhn", function(module, exports) {
$parcel$export(module.exports, "default", () => $0303ee87ee2d5cde$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<92c5d77b9fb3628068374d2bcf387330>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0303ee87ee2d5cde$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "IssueStatusCell",
    "selections": [
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "concreteType": "JiraStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "statusId"
                },
                {
                    "concreteType": "JiraStatusCategory",
                    "kind": "LinkedField",
                    "name": "statusCategory",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCategoryId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraStatusField"
};
$0303ee87ee2d5cde$var$node.hash = "437005b12e4b057a438ab749ffd12538";
var $0303ee87ee2d5cde$export$2e2bcd8739ae039 = $0303ee87ee2d5cde$var$node;

});

parcelRegister("6BnaS", function(module, exports) {
$parcel$export(module.exports, "AsyncIssueStatusField", () => $d4bd70c5964975e8$export$ddd324b06f34200);
$parcel$export(module.exports, "IssueStatusFieldBoundary", () => $d4bd70c5964975e8$export$dba9e9c892560f60);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $hRhIm = parcelRequire("hRhIm");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d4bd70c5964975e8$var$AsyncLazyIssueStatusField = (0, $bQWwW.lazy)(()=>(parcelRequire("b0kUq")), {
    moduleId: "./src/packages/issue/fields/status/src/ui/main.tsx"
});
const $d4bd70c5964975e8$export$ddd324b06f34200 = (props)=>{
    const { initialValue: initialValue, value: value } = props;
    const errorProps = {
        initialValue: initialValue,
        value: value
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue-field-status",
        packageName: "jira-issue-field-status",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "issue-status-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d4bd70c5964975e8$var$AsyncLazyIssueStatusField, props)));
};
const $d4bd70c5964975e8$export$dba9e9c892560f60 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue-status-field",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "issue-status-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("b0kUq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("kvhnd")
]).then(()=>parcelRequire('d8WYQ'));

});


parcelRegister("jT7JX", function(module, exports) {
$parcel$export(module.exports, "useHideDoneItems", () => $ceb2e86724727d09$export$c2cb7b17819b92d4);

var $eJOHy = parcelRequire("eJOHy");

var $dLXgn = parcelRequire("dLXgn");

var $iN7UY = parcelRequire("iN7UY");

var $34oCh = parcelRequire("34oCh");

var $57Nys = parcelRequire("57Nys");
// For status update with hide done it will always be a single work item that is removed
const $ceb2e86724727d09$var$NET_CHANGE_ISSUE_COUNT = -1;
function $ceb2e86724727d09$export$c2cb7b17819b92d4({ groupConnectionId: groupConnectionId, itemsConnectionId: itemsConnectionId, recordId: recordId, projectKey: projectKey }) {
    const isHideDoneEnabled = (0, $34oCh.useIsHideDoneItemsEnabled)();
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const getConnectionDetails = (0, $eJOHy.useCallback)(()=>Object.values(connections).find((connection)=>{
            return connection.connectionId === itemsConnectionId;
        }), [
        connections,
        itemsConnectionId
    ]);
    const updateConnectionDetails = (0, $57Nys.useUpdateConnectionDetails)();
    const removeConnection = (0, $eJOHy.useCallback)(({ store: store, remainingIssueCount: remainingIssueCount })=>{
        const connectionDetails = getConnectionDetails();
        if (!connectionDetails) return;
        updateConnectionDetails({
            store: store,
            connection: connectionDetails,
            remainingIssueCount: remainingIssueCount,
            netChangeInIssueCount: $ceb2e86724727d09$var$NET_CHANGE_ISSUE_COUNT,
            groupConnectionId: groupConnectionId,
            projectKey: projectKey
        });
    }, [
        getConnectionDetails,
        groupConnectionId,
        projectKey,
        updateConnectionDetails
    ]);
    const handler = (0, $iN7UY.useHandleStatusUpdate)(itemsConnectionId, recordId, removeConnection, {
        isHideDoneEnabled: isHideDoneEnabled
    });
    return handler;
}

});
parcelRegister("iN7UY", function(module, exports) {
$parcel$export(module.exports, "useHandleStatusUpdate", () => $b0dddbd9500361a0$export$9b67a4661b4d570a);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");


var $fRHdC = parcelRequire("fRHdC");

var $3bmN3 = parcelRequire("3bmN3");
const $b0dddbd9500361a0$var$DEFAULT_OPTIONS = {
    isHideDoneEnabled: false
};
function $b0dddbd9500361a0$export$9b67a4661b4d570a(itemsConnectionId, recordId, removeConnection, options = $b0dddbd9500361a0$var$DEFAULT_OPTIONS) {
    const updater = (0, $fRHdC.useDeleteRecord)(itemsConnectionId, recordId, removeConnection);
    const handler = (0, $3bmN3.useCommitLocalUpdate)(updater, options);
    return (0, $eJOHy.useCallback)((field)=>{
        try {
            handler(field);
        } catch (error) {
            if (error instanceof Error) (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'issue-table-hide-done-status-update',
                    packageName: (0, $54713f11448e89c8$export$b8b9d90f9e5bd72b),
                    teamName: (0, $54713f11448e89c8$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    }, [
        handler
    ]);
}

});
const $54713f11448e89c8$export$b8b9d90f9e5bd72b = 'jiraIssueTableHideDoneToggle';
const $54713f11448e89c8$export$d57b6b390e78d90f = 'keystone';
const $54713f11448e89c8$export$6a7d6ab86cfdfcdc = 'hideDoneToggle';
const $54713f11448e89c8$export$f7109619a5e9e0d6 = 'jira-native-issue-table';

parcelRegister("fRHdC", function(module, exports) {
$parcel$export(module.exports, "useDeleteRecord", () => $5aaaec4fac311dfb$export$4495a148dad9d147);

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");
function $5aaaec4fac311dfb$export$4495a148dad9d147(itemsConnectionId, recordId, removeConnection) {
    return (0, $eJOHy.useCallback)((store)=>{
        $5aaaec4fac311dfb$var$assert(itemsConnectionId, 'itemsConnectionId');
        $5aaaec4fac311dfb$var$assert(recordId, 'recordId');
        const connectionRecord = store.get(itemsConnectionId);
        if (!connectionRecord) return;
        (0, $37Ewn.ConnectionHandler).deleteNode(connectionRecord, recordId);
        removeConnection({
            store: store,
            remainingIssueCount: connectionRecord.getLinkedRecords('edges')?.length ?? 0
        });
    }, [
        itemsConnectionId,
        recordId,
        removeConnection
    ]);
}
function $5aaaec4fac311dfb$var$assertString(value, paramName) {
    if (typeof value !== 'string') throw new Error(`${paramName} must be a string`);
}
function $5aaaec4fac311dfb$var$assertNotEmpty(value, paramName) {
    if (value.trim().length === 0) throw new Error(`${paramName} must not be an empty string`);
}
function $5aaaec4fac311dfb$var$assert(value, paramName) {
    $5aaaec4fac311dfb$var$assertString(value, paramName);
    $5aaaec4fac311dfb$var$assertNotEmpty(value, paramName);
}

});

parcelRegister("3bmN3", function(module, exports) {
$parcel$export(module.exports, "useCommitLocalUpdate", () => $c3e4ffd5f883a42d$export$f0d146dc82ca0c9c);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jx0Vw = parcelRequire("jx0Vw");
function $c3e4ffd5f883a42d$export$f0d146dc82ca0c9c(updater, { isHideDoneEnabled: isHideDoneEnabled }) {
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useCallback)((field)=>{
        if (!isHideDoneEnabled) return;
        if ((0, $jx0Vw.statusCategoryForId)(field.statusCategory?.statusCategoryId) !== (0, $jx0Vw.DONE)) return;
        (0, $j4oe4.commitLocalUpdate)(environment, updater);
    }, [
        environment,
        isHideDoneEnabled,
        updater
    ]);
}

});



parcelRegister("7Gpga", function(module, exports) {
$parcel$export(module.exports, "toJiraStatusField", () => $0f7719130d68fc56$export$54bbdde829b87b5c);
$parcel$export(module.exports, "toStatusValue", () => $0f7719130d68fc56$export$2950d85c450ec19d);
const $0f7719130d68fc56$export$54bbdde829b87b5c = (statusValue)=>({
        statusId: statusValue.id,
        name: statusValue.name,
        statusCategory: {
            statusCategoryId: `${statusValue.statusCategory.id}`
        }
    });
const $0f7719130d68fc56$export$2950d85c450ec19d = (jiraStatusField)=>({
        id: jiraStatusField.statusId,
        name: jiraStatusField.name ?? '',
        statusCategory: {
            id: parseInt(jiraStatusField.statusCategory?.statusCategoryId ?? '', 10)
        }
    });

});


parcelRegister("arQXy", function(module, exports) {
$parcel$export(module.exports, "IssueSummaryCell", () => $80aa29a1c195fc8f$export$4da280f2973efc5c);

var $5uDkF = parcelRequire("5uDkF");

var $aEJbL = parcelRequire("aEJbL");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $9t1Xl = parcelRequire("9t1Xl");

var $4cTDP = parcelRequire("4cTDP");

var $jiTA8 = parcelRequire("jiTA8");

var $3OT15 = parcelRequire("3OT15");

var $6bLlX = parcelRequire("6bLlX");

var $deFVD = parcelRequire("deFVD");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $86BUM = parcelRequire("86BUM");

var $88mo0 = parcelRequire("88mo0");

var $4vHFI = parcelRequire("4vHFI");

var $8jOO7 = parcelRequire("8jOO7");

var $9r0oq = parcelRequire("9r0oq");

var $fQPwz = parcelRequire("fQPwz");

var $8fpTm = parcelRequire("8fpTm");

var $5TzMU = parcelRequire("5TzMU");
const $80aa29a1c195fc8f$export$4da280f2973efc5c = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueRef: issueRef, children: children, isRowHoveredOrSelected: isRowHoveredOrSelected, onIssueLinkSelected: onIssueLinkSelected, readViewHighlightOnHover: readViewHighlightOnHover, isMergedCellFocusedOrHovered: isMergedCellFocusedOrHovered })=>{
    const timelineCustomComponents = (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $9r0oq.useTimelineCustomComponents)() : null;
    const SummaryCellContentComponent = timelineCustomComponents?.SummaryCellContent;
    const isEmbedMode = (0, $jiTA8.useIsEmbedMode)();
    const data = (0, $j4oe4.useFragment)((0, $aEJbL.default), fieldRef);
    const issueData = (0, $j4oe4.useFragment)((0, $5uDkF.default), issueRef);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const updateIssueSummary = (0, $4cTDP.fg)('jsc_list_reparenting') ? (0, $fQPwz.useUpdateIssueSummary)() : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    const issueAriId = issueData?.id;
    let shouldShowIframePreviewPanel = (0, $eJOHy.useCallback)(()=>{
        return false;
    }, []);
    let openIframePreviewPanel = (0, $eJOHy.useCallback)(()=>{
    /* empty */ }, []);
    if ((0, $4cTDP.fg)('issue_preview_panel_issue_view_subtask')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const shouldShowIssueInIframePreviewPanel = (0, $deFVD.useShouldShowIframeIssuePreviewPanel)();
        shouldShowIframePreviewPanel = shouldShowIssueInIframePreviewPanel;
    }
    if (shouldShowIframePreviewPanel()) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { openPreviewPanel: openPreviewPanel } = (0, $6bLlX.useGlobalObjectPreviewPanels)();
        openIframePreviewPanel = openPreviewPanel;
    }
    const isOpenIssueLinkEnabled = (0, $4cTDP.fg)('jira_issue_table_open_issue_link_config') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $34oCh.useIsOpenIssueLinkEnabled)() : true;
    const onSubmitSucceeded = (0, $eJOHy.useCallback)((value)=>{
        if (issueData?.__id && (0, $4cTDP.fg)('jsc_list_reparenting')) updateIssueSummary(issueData.__id, value);
    }, [
        issueData?.__id,
        updateIssueSummary
    ]);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    let isEditable = false;
    if ('isEditableInIssueView' in data) isEditable = data.isEditableInIssueView;
    else if ('lazyIsEditableInIssueView' in data) isEditable = data.lazyIsEditableInIssueView;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isDensityCompact = !(0, $34oCh.useIsDensityFull)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const issueUrl = issueData?.isRemoteIssue && issueData?.webUrl && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate') ? issueData.webUrl : `/browse/${issueData.key}`;
    const onLinkClick = (0, $eJOHy.useCallback)((e)=>{
        if (issueData?.isRemoteIssue && issueData?.webUrl && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) return;
        // Use default browser event handling when a modifier key is pressed during the click event
        const isModifierKeyUsed = e.ctrlKey || e.shiftKey || e.metaKey;
        if (shouldShowIframePreviewPanel() && !isModifierKeyUsed) {
            e.preventDefault();
            openIframePreviewPanel({
                ari: issueAriId || '',
                url: issueUrl,
                name: 'jira-issue'
            });
            return;
        }
        const handled = !isEmbedMode && !isModifierKeyUsed && onIssueLinkSelected !== undefined && onIssueLinkSelected(issueData.key);
        if (handled) e.preventDefault();
    }, [
        issueData?.isRemoteIssue,
        issueData?.webUrl,
        issueData.key,
        shouldShowIframePreviewPanel,
        isEmbedMode,
        onIssueLinkSelected,
        openIframePreviewPanel,
        issueAriId,
        issueUrl
    ]);
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    let showOpenIssueLink = isOpenIssueLinkEnabled;
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    isGridNavigationEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate') && (0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style')) {
        if ((0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility')) showOpenIssueLink = isOpenIssueLinkEnabled && !!isMergedCellFocusedOrHovered;
        else showOpenIssueLink = isOpenIssueLinkEnabled && !!isRowHoveredOrSelected;
    }
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    const renderCustomReadView = (0, $eJOHy.useCallback)((text)=>{
        if (!text) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
            cellType: "summary",
            reason: "Missing required fields"
        });
        let hoverPopoverRef = null;
        if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
            content: text,
            shouldRenderToContent: true
        });
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $88mo0.TableCellDiscreteLink), {
            innerFocusOutline: true,
            href: issueUrl,
            isSubtle: false,
            onClick: onLinkClick,
            "data-testid": "native-issue-table.common.ui.issue-cells.issue-summary.issue-summary-cell",
            ...isEmbedMode && {
                target: '_blank',
                rel: 'noopener'
            }
        }, text);
        if (isInlineEditingExtendedFieldSupportEnabled && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            ref: hoverPopoverRef,
            testId: "native-issue-table.common.ui.issue-cells.issue-summary.issue-summary-cell",
            maxLines: (0, $8jOO7.MAX_LINE_WRAP_NEW)
        }, text), (0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $80aa29a1c195fc8f$var$actionButtonsWrapStyles
        }, showOpenIssueLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5TzMU.OpenIssueLink), {
            issueKey: issueData.key,
            url: issueUrl,
            onClick: onLinkClick
        }), (0, $4cTDP.fg)('jira_list_merged_column_gate') && children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showOpenIssueLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5TzMU.OpenIssueLink), {
            issueKey: issueData.key,
            url: issueUrl,
            onClick: onLinkClick
        }), (0, $4cTDP.fg)('jira_list_merged_column_gate') && children));
        if (isInlineEditingExtendedFieldSupportEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            testId: "native-issue-table.common.ui.issue-cells.issue-summary.issue-summary-cell",
            maxLines: isDensityCompact ? 2 : undefined
        }, text), (0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $80aa29a1c195fc8f$var$actionButtonsWrapStyles
        }, showOpenIssueLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5TzMU.OpenIssueLink), {
            issueKey: issueData.key,
            url: issueUrl,
            onClick: onLinkClick
        }), (0, $4cTDP.fg)('jira_list_merged_column_gate') && children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showOpenIssueLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5TzMU.OpenIssueLink), {
            issueKey: issueData.key,
            url: issueUrl,
            onClick: onLinkClick
        }), (0, $4cTDP.fg)('jira_list_merged_column_gate') && children));
        // Span is necessary here to ensure only link text is clickable for multiline summaries, rather than the
        // entire content box.
        return isDensityCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "span",
            xcss: $80aa29a1c195fc8f$var$textOverflowStyles
        }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, content);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_issue_table_updates') ? [
        children,
        isDensityCompact,
        isEmbedMode,
        isInlineEditingExtendedFieldSupportEnabled,
        isSingleLineRowHeightEnabled,
        issueData.key,
        onLinkClick,
        showOpenIssueLink,
        hoverPopoverRefFactory,
        SummaryCellContentComponent
    ] : [
        children,
        isDensityCompact,
        isEmbedMode,
        isInlineEditingExtendedFieldSupportEnabled,
        isSingleLineRowHeightEnabled,
        issueData.key,
        onLinkClick,
        showOpenIssueLink,
        hoverPopoverRefFactory
    ]);
    let node = null;
    if (!(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns')) node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9t1Xl.SingleLineTextInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: $80aa29a1c195fc8f$var$EditViewPopupTarget,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        isRequired: true,
        maxLength: 255,
        readViewFitContainerHeight: true,
        renderCustomReadView: renderCustomReadView,
        hideEditButton: isInlineEditingExtendedFieldSupportEnabled,
        onSubmitSucceeded: (0, $4cTDP.fg)('jsc_list_reparenting') ? onSubmitSucceeded : undefined,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled,
        readViewHighlightOnHover: readViewHighlightOnHover
    });
    else {
        const commonProps = {
            attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
            spacing: 'default',
            editViewPopup: true,
            editViewPopupAlignBlock: 'center',
            fragmentRef: data,
            isRequired: true,
            maxLength: 255,
            readViewFitContainerHeight: true,
            renderCustomReadView: renderCustomReadView,
            hideEditButton: isInlineEditingExtendedFieldSupportEnabled,
            onSubmitSucceeded: (0, $4cTDP.fg)('jsc_list_reparenting') ? onSubmitSucceeded : undefined,
            hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled,
            readViewHighlightOnHover: readViewHighlightOnHover,
            isEditable: isEditable ?? false
        };
        if (SummaryCellContentComponent) node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SummaryCellContentComponent, {
            ...commonProps,
            // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
            editViewPopupTarget: $80aa29a1c195fc8f$var$EditViewPopupTarget,
            isMergedCellFocusedOrHovered: isMergedCellFocusedOrHovered,
            issueKey: issueData.key,
            onLinkClick: onLinkClick,
            hoverPopoverRefFactory: hoverPopoverRefFactory
        }, children);
        else node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9t1Xl.SingleLineTextInlineEditViewWithIsEditable), {
            ...commonProps,
            // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
            editViewPopupTarget: $80aa29a1c195fc8f$var$EditViewPopupTarget
        });
    }
    if (isInlineEditingExtendedFieldSupportEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8fpTm.ActionContainer), null, node);
    return node;
});
const $80aa29a1c195fc8f$var$EditViewPopupTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $80aa29a1c195fc8f$var$customTargetStyles,
        ref: ref
    });
});
// We have an extra flex container around our inline edit component so we can show the open issue link button. We need
// to explicitly center align the edit view popup target to ensure consistent alignment in the table cell.
const $80aa29a1c195fc8f$var$customTargetStyles = (0, $1DXK0.xcss)({
    alignSelf: 'center',
    width: '0'
});
const $80aa29a1c195fc8f$var$textOverflowStyles = (0, $1DXK0.xcss)({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word'
});
const $80aa29a1c195fc8f$var$actionButtonsWrapStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    gap: 'space.050'
});

});
parcelRegister("5uDkF", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec9c5a738f346e03$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3823e14d417b69e84ad7482411f3902e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ec9c5a738f346e03$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRemoteLinkedIssuesEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "IssueSummaryCell_issue",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "condition": "isRemoteLinkedIssuesEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isRemoteIssue"
                },
                {
                    "kind": "ScalarField",
                    "name": "webUrl"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$ec9c5a738f346e03$var$node.hash = "94c423e4276945fd081d35286ac16a82";
var $ec9c5a738f346e03$export$2e2bcd8739ae039 = $ec9c5a738f346e03$var$node;

});

parcelRegister("aEJbL", function(module, exports) {
$parcel$export(module.exports, "default", () => $68d01e17a4979926$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9399fe6e98d55949bf8063754d2960fd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $68d01e17a4979926$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "IssueSummaryCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isEditableSyncLoaded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditableInIssueView"
                }
            ]
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$68d01e17a4979926$var$node.hash = "6f8d06a4f8a9d249a760bf0f1397534f";
var $68d01e17a4979926$export$2e2bcd8739ae039 = $68d01e17a4979926$var$node;

});

parcelRegister("9t1Xl", function(module, exports) {
$parcel$export(module.exports, "SingleLineTextInlineEditViewWithIsEditable", () => $05ffceec1b992bab$export$f267c8aeb8112733);
$parcel$export(module.exports, "SingleLineTextInlineEditView", () => $05ffceec1b992bab$export$ad603a514b680587);

var $hYtXq = parcelRequire("hYtXq");

var $azRyH = parcelRequire("azRyH");

var $6gbFp = parcelRequire("6gbFp");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $77rtG = parcelRequire("77rtG");

var $beyOl = parcelRequire("beyOl");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $4cTDP = parcelRequire("4cTDP");

var $gBHYt = parcelRequire("gBHYt");
const $05ffceec1b992bab$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-single-line-text-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $05ffceec1b992bab$export$f267c8aeb8112733 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen, isRequired: isRequired = false, hideEditButton: hideEditButton, maxLength: maxLength, onCancel: onCancel, onEdit: onEdit, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, renderCustomReadView: renderCustomReadView, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled = false, readViewHighlightOnHover: readViewHighlightOnHover = true, onUnchangedSubmit: onUnchangedSubmit })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $6gbFp.default), fragmentRef);
    const { id: uniqueFieldId, fieldId: fieldId, type: type, text: text, name: name } = data;
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $azRyH.default));
    // #endregion
    // #region Common state
    const initialValue = text ?? '';
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    // #endregion
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overriding ? overriding.overrideIsEditable(isEditable) : isEditable, [
        isEditable,
        overriding
    ]);
    const fieldName = (0, $eJOHy.useMemo)(()=>overriding ? overriding.overrideLabel(name) : name, [
        name,
        overriding
    ]);
    const validator = (0, $gBHYt.useSingleLineTextValidator)(fieldName, isRequired, maxLength);
    /**
   * This will execute the GraphQL mutation.
   */ const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        text: value,
                        operation: 'SET'
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateSingleLineTextField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateSingleLineTextField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            text: value
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        initialValue: initialValue,
        updatedValue: updatedValue,
        validator: validator,
        clipboardComponentType: 'text',
        onUnchangedSubmit: (0, $4cTDP.fg)('jira_inline_edit_unchanged_submit_prop') ? onUnchangedSubmit : undefined
    });
    const onChange = (0, $eJOHy.useCallback)((event)=>{
        handleChange(event.target.value);
    }, [
        handleChange
    ]);
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($05ffceec1b992bab$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $beyOl.SingleLineTextReadView), {
            fragmentRef: data,
            renderCustomReadView: renderCustomReadView
        })), [
        data,
        renderCustomReadView
    ]);
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            value: updatedValue,
            onChange: onChange,
            isInvalid: !!invalidMessage,
            autoFocus: true,
            ariaLabel: fieldName
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "large",
        editViewPopupTarget: editViewPopupTarget,
        editViewEntryPoint: (0, $77rtG.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        hideEditButton: hideEditButton,
        invalidMessage: invalidMessage ?? undefined,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled,
        readViewHighlightOnHover: readViewHighlightOnHover
    });
};
const $05ffceec1b992bab$export$ad603a514b680587 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $hYtXq.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($05ffceec1b992bab$export$f267c8aeb8112733, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("hYtXq", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e6168a5045fbba8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5603fda12586c734accd519f63ebd761>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1e6168a5045fbba8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleLineTextField"
};
$1e6168a5045fbba8$var$node.hash = "834bf98c01966c210bc0a4f6e9f0f4a7";
var $1e6168a5045fbba8$export$2e2bcd8739ae039 = $1e6168a5045fbba8$var$node;

});

parcelRegister("azRyH", function(module, exports) {
$parcel$export(module.exports, "default", () => $265cfff0836406df$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f87bbae0df7928fcb860f8d696c8c51>>
 * @relayHash 029277561796d9f13acaef1dbb085ee8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6baebfa2f37e676d26595f29fc232725ad41353c9fcd04168be34a6b616f152
const $265cfff0836406df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSingleLineTextFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateSingleLineTextField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraSingleLineTextField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "text"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "singleLineText_issueFieldSingleLineText_SingleLineTextField_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "singleLineText_issueFieldSingleLineText_SingleLineTextField_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a6baebfa2f37e676d26595f29fc232725ad41353c9fcd04168be34a6b616f152",
            "metadata": {},
            "name": "singleLineText_issueFieldSingleLineText_SingleLineTextField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$265cfff0836406df$var$node.hash = "7910ed923271af0f6fe2fd325e2358de";
var $265cfff0836406df$export$2e2bcd8739ae039 = $265cfff0836406df$var$node;

});

parcelRegister("6gbFp", function(module, exports) {
$parcel$export(module.exports, "default", () => $4aee1b4a0274d581$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ebc67ee0e5b1d19577ad84dec6dd3022>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4aee1b4a0274d581$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextReadviewFull_SingleLineTextReadView"
        },
        {
            "kind": "ScalarField",
            "name": "text"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$4aee1b4a0274d581$var$node.hash = "fa64e21466cd3e14f917674796ea3359";
var $4aee1b4a0274d581$export$2e2bcd8739ae039 = $4aee1b4a0274d581$var$node;

});

parcelRegister("77rtG", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c81c30a47fc76fc$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $1c81c30a47fc76fc$var$SingleLineTextEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("dp5GT")), {
        moduleId: "c6bbf997",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $1c81c30a47fc76fc$export$2e2bcd8739ae039 = $1c81c30a47fc76fc$var$SingleLineTextEditViewEntryPoint;

});
parcelRegister("dp5GT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8WF7X").then(()=>parcelRequire('2sEmv'));

});


parcelRegister("beyOl", function(module, exports) {
$parcel$export(module.exports, "SingleLineTextReadView", () => $2f2fb34322581dfc$export$5a145b2225896aea);

var $dT0AP = parcelRequire("dT0AP");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $guChT = parcelRequire("guChT");

var $eNS8S = parcelRequire("eNS8S");

var $cxKOj = parcelRequire("cxKOj");

var $d9T1A = parcelRequire("d9T1A");

var $8UsZ0 = parcelRequire("8UsZ0");

var $4cTDP = parcelRequire("4cTDP");

var $3Lkm9 = parcelRequire("3Lkm9");

var $k6Nau = parcelRequire("k6Nau");
const $2f2fb34322581dfc$export$5a145b2225896aea = ({ fragmentRef: fragmentRef, renderFieldContentWrapper: FieldContentWrapper, renderCustomReadView: renderCustomReadView })=>{
    const { text: text = null, fieldId: fieldId } = (0, $j4oe4.useFragment)((0, $dT0AP.default), fragmentRef);
    const isBespokeEmptyFieldTextGA = (0, $k6Nau.useBespokeEmptyFieldTextGA)();
    const getReadView = (0, $eJOHy.useCallback)(()=>{
        if (renderCustomReadView) return renderCustomReadView(text);
        if (!text) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), isBespokeEmptyFieldTextGA && {
            placeholderText: (0, $3Lkm9.default).bespokenTextPlaceholderEmptyFieldText
        });
        const testId = `issue.views.field.single-line-text.read-view.${fieldId}`;
        if ((0, $eNS8S.default)(text, true) && (0, $cxKOj.expValEquals)('jsw_perf_format-links-in-custom-fields', 'issue-view', true)) {
            if ((0, $4cTDP.fg)('enable_redaction_support_in_jira_issue_view')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
                name: `redaction-marker-${fieldId}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f2fb34322581dfc$var$ReadViewContainer, {
                "data-testid": testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8UsZ0.LazySmartLink), {
                appearance: "inline",
                url: text
            })));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f2fb34322581dfc$var$ReadViewContainer, {
                "data-testid": testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8UsZ0.LazySmartLink), {
                appearance: "inline",
                url: text
            }));
        }
        if ((0, $4cTDP.fg)('enable_redaction_support_in_jira_issue_view')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
            name: `redaction-marker-${fieldId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f2fb34322581dfc$var$ReadViewContainer, {
            "data-testid": testId
        }, text));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f2fb34322581dfc$var$ReadViewContainer, {
            "data-testid": testId
        }, text);
    }, [
        renderCustomReadView,
        text,
        fieldId,
        isBespokeEmptyFieldTextGA
    ]);
    if (FieldContentWrapper) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldContentWrapper, null, getReadView());
    return getReadView();
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2f2fb34322581dfc$var$ReadViewContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _vwz4gktf _1nmz1hna _kqswh2mm _1bsb1osq _1eog1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dT0AP", function(module, exports) {
$parcel$export(module.exports, "default", () => $b342c91717865db8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<28cc3f1e512619502f58cc6e1fc159db>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b342c91717865db8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleLineText_issueFieldSingleLineTextReadviewFull_SingleLineTextReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "text"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$b342c91717865db8$var$node.hash = "5f51bd1526b02ac7cd91c57eec827a2f";
var $b342c91717865db8$export$2e2bcd8739ae039 = $b342c91717865db8$var$node;

});

parcelRegister("eNS8S", function(module, exports) {
$parcel$export(module.exports, "isValidUrl", () => $ae6a7d95440d0325$export$bef94a5618bf18bf);
$parcel$export(module.exports, "default", () => $ae6a7d95440d0325$export$2e2bcd8739ae039);
/**
 * The URL standard regex for spec.: RFC 3986
 * https://tools.ietf.org/html/rfc3986#page-51
 */ const $ae6a7d95440d0325$var$URLStandardRegex = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?');
/**
 * Full Domain name limits as per RFC is 256 characters
 * TLD limit as per RFC 1035 is 63 characters. Although, TLDs can contain numbers, since none of the existing popular TLDs are numbers, we are not allowing numbers in TLD.
 * Any characters allowed in protocol and query string. Domain name needs to be alphanumeric with hyphens allowed.
 */ const $ae6a7d95440d0325$var$stricterURLRegex = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?[-a-zA-Z0-9@:.]{2,256}.[a-z]{2,63}\\b([-a-zA-Z0-9@:%_+.~#?&//=]*)');
const $ae6a7d95440d0325$var$protocolRegex = new RegExp('^(http|https|ftp)://.*|^//[^/]*?');
function $ae6a7d95440d0325$export$bef94a5618bf18bf(string, strict = false) {
    // Have to be string
    if (!string || typeof string !== 'string') return false;
    // Exit early if there is a space, no need to regex that
    if (string.indexOf(' ') >= 0 || string.length === 0) return false;
    // Localhost is bit different, doesn't need a dot but others likely should
    if (string.indexOf('localhost') === -1 && string.indexOf('.') === -1) return false;
    if (strict === true) return $ae6a7d95440d0325$var$stricterURLRegex.test(string) || $ae6a7d95440d0325$var$protocolRegex.test(string);
    return $ae6a7d95440d0325$var$URLStandardRegex.test(string);
}
var $ae6a7d95440d0325$export$2e2bcd8739ae039 = $ae6a7d95440d0325$export$bef94a5618bf18bf;

});

parcelRegister("8UsZ0", function(module, exports) {
$parcel$export(module.exports, "LazySmartLink", () => $8977add9d34e6e7b$export$fe7f8e391b2babff);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $6qmxl = parcelRequire("6qmxl");
const $8977add9d34e6e7b$var$entryPointParams = {};
const $8977add9d34e6e7b$export$fe7f8e391b2babff = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $6qmxl.SmartLinkEntryPoint), $8977add9d34e6e7b$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jira.issue-field.smart-link",
        packageName: "issue-field-smart-link",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("6qmxl", function(module, exports) {
$parcel$export(module.exports, "SmartLinkEntryPoint", () => $caa0557c78d97e7a$export$29454edb61a1a57e);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $caa0557c78d97e7a$export$29454edb61a1a57e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("hMHOW")).then((module)=>module.SmartLink), {
        moduleId: "3da73bc4",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hMHOW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("91SIJ").then(()=>parcelRequire('bmeQi'));

});




parcelRegister("gBHYt", function(module, exports) {
$parcel$export(module.exports, "useSingleLineTextValidator", () => $d52f5e0d730f9978$export$6955d95abfe9109c);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $g2Uiq = parcelRequire("g2Uiq");
const $d52f5e0d730f9978$export$6955d95abfe9109c = (fieldName, isRequired, maxLength)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const change = (0, $eJOHy.useCallback)((value)=>{
        if (maxLength && maxLength > 0 && value.length > maxLength) return {
            type: 'error',
            message: formatMessage((0, $g2Uiq.default).maxLengthErrorMessage, {
                maxLength: maxLength
            })
        };
        return null;
    }, [
        formatMessage,
        maxLength
    ]);
    const submit = (0, $eJOHy.useCallback)((value)=>{
        if (isRequired && value.trim().length === 0) return {
            type: 'error',
            message: formatMessage((0, $g2Uiq.default).requiredErrorMessage, {
                fieldName: fieldName
            })
        };
        return null;
    }, [
        fieldName,
        formatMessage,
        isRequired
    ]);
    return {
        change: change,
        submit: submit
    };
};

});
parcelRegister("g2Uiq", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebe796aeade62014$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ebe796aeade62014$var$messages = (0, $7qGN1.defineMessages)({
    maxLengthErrorMessage: {
        "id": "issue-field-single-line-text-inline-edit-full.single-line-text.max-length-error-message",
        "defaultMessage": "{maxLength} character limit"
    },
    requiredErrorMessage: {
        "id": "issue-field-single-line-text-inline-edit-full.single-line-text.required-error-message",
        "defaultMessage": "{fieldName} is required"
    }
});
var $ebe796aeade62014$export$2e2bcd8739ae039 = $ebe796aeade62014$var$messages;

});



parcelRegister("fQPwz", function(module, exports) {
$parcel$export(module.exports, "useUpdateIssueSummary", () => $67b77c5a2df6a013$export$8664a69d14346ead);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");
const $67b77c5a2df6a013$export$8664a69d14346ead = ()=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useCallback)((issueRelayId, summary)=>{
        (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
            const issueEntry = store.get(issueRelayId);
            if (issueEntry) issueEntry.setValue(summary, 'summary');
        });
    }, [
        environment
    ]);
};

});

parcelRegister("8fpTm", function(module, exports) {
$parcel$export(module.exports, "ActionContainer", () => $9c426a359ad88357$export$37ab3bdebc286ca);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");
const $9c426a359ad88357$export$37ab3bdebc286ca = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "native-issue-table.common.ui.issue-cells.issue-summary.action-container",
        className: (0, $hcewu.default)([
            (0, $4cTDP.fg)('jira_list_merged_column_gate') ? (0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style') ? "_1e0c1txw _16jlkb7n _1tke1osq _ic7gglyw _1ufvglyw _lt0o1yb4 _17mg1txw _1w9r1txw _ev7t1txw _z5tv1txw" : "_1e0c1txw _16jlkb7n _1tke1osq _ic7gglyw _18wjidpf _lt0o1yb4 _17mg1txw _1se1t94y _nouyt94y _ev7t1txw _1aszt94y _12nht94y" : "_1e0c1txw _16jlkb7n _1tke1osq _155eidpf _nouyt94y _12nht94y"
        ])
    }, children);
};
const $9c426a359ad88357$var$containerStylesNew = null;
const $9c426a359ad88357$var$containerStyles = null;
/**
 * @deprecated remove when jira_list_merged_column_gate is removed
 */ const $9c426a359ad88357$var$containerStylesOld = null;

});

parcelRegister("5TzMU", function(module, exports) {
$parcel$export(module.exports, "OpenIssueLink", () => $9a4c8f9eda00c36f$export$8f0bae95f8140072);

var $eJOHy = parcelRequire("eJOHy");

var $lL4G9 = parcelRequire("lL4G9");
var $1DXK0 = parcelRequire("1DXK0");

var $ac080 = parcelRequire("ac080");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $jiTA8 = parcelRequire("jiTA8");

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");

var $dD4QM = parcelRequire("dD4QM");
const $9a4c8f9eda00c36f$export$8f0bae95f8140072 = ({ issueKey: issueKey, onClick: onClick, url: url })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const isEmbedMode = (0, $jiTA8.useIsEmbedMode)();
    const handleClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'tableIssueLink');
        onClick?.(e);
    }, [
        onClick
    ]);
    let style;
    if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) {
        if ((0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style')) {
            if (!isGridNavigationEnabled) style = $9a4c8f9eda00c36f$var$openIssueLinkStyle;
        } else style = $9a4c8f9eda00c36f$var$buttonOpacityVariableStyle;
    } else style = $9a4c8f9eda00c36f$var$buttonOpacityVariableStyleOld;
    const linkUrl = url && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate') ? url : `/browse/${issueKey}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: (0, $4cTDP.fg)('nin_list_summary_cta_tooltip_change') ? formatMessage((0, $dD4QM.default).openTooltipNew) : formatMessage((0, $dD4QM.default).openTooltip)
    }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
            ...triggerProps,
            "aria-label": (0, $4cTDP.fg)('nin_list_summary_cta_tooltip_change') ? formatMessage((0, $dD4QM.default).openLabelNew, {
                issueKey: issueKey
            }) : formatMessage((0, $dD4QM.default).openLabel, {
                issueKey: issueKey
            }),
            href: linkUrl,
            onClick: handleClick,
            xcss: (0, $4cTDP.fg)('jira_list_merged_column_gate') ? $9a4c8f9eda00c36f$var$buttonStyles : $9a4c8f9eda00c36f$var$buttonStylesOld,
            // Cannot provide CSS variable as a compile time value due to various type constraints between
            // primitives + compiled.
            // eslint-disable-next-line jira/react/no-style-attribute,@atlaskit/ui-styling-standard/enforce-style-prop
            style: style,
            ...isEmbedMode && {
                target: '_blank',
                rel: 'noopener'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ac080))), {
            label: "",
            ...(0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style') && {
                size: 'small'
            }
        })));
};
const $9a4c8f9eda00c36f$var$buttonOpacityVariableStyle = {
    display: 'var(--open-button-display, "none")'
};
const $9a4c8f9eda00c36f$var$openIssueLinkStyle = {
    display: 'var(--open-button-display, "flex")'
};
/**
 * @deprecated remove when jira_list_merged_column_gate is removed
 */ const $9a4c8f9eda00c36f$var$buttonOpacityVariableStyleOld = {
    opacity: 'var(--open-button-opacity, 0)'
};
const $9a4c8f9eda00c36f$var$buttonStyles = (0, $1DXK0.xcss)({
    alignItems: 'center',
    borderRadius: 'radius.small',
    borderStyle: 'none',
    borderColor: 'color.border',
    borderWidth: '0',
    color: 'color.text',
    display: 'inline-flex',
    height: '24px',
    justifyContent: 'center',
    marginInlineStart: 'auto',
    padding: 'space.050',
    width: '24px',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        color: 'color.text'
    },
    ':focus': {
        color: 'color.text'
    },
    ':active': {
        color: 'color.text'
    }
});
/**
 * @deprecated remove when jira_list_merged_column_gate is removed
 */ const $9a4c8f9eda00c36f$var$buttonStylesOld = (0, $1DXK0.xcss)({
    alignItems: 'center',
    borderRadius: 'radius.small',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderWidth: 'border.width',
    color: 'color.text',
    display: 'inline-flex',
    height: '24px',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginLeft: 'auto',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    paddingTop: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    paddingRight: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    paddingBottom: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    paddingLeft: 'space.050',
    width: '24px',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        color: 'color.text'
    },
    ':focus': {
        color: 'color.text'
    },
    ':active': {
        color: 'color.text'
    }
});

});
parcelRegister("dD4QM", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f0b787aedc47989$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5f0b787aedc47989$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    openTooltip: {
        "id": "native-issue-table.common.issue-cells.issue-summary.open-issue-link.open-tooltip",
        "defaultMessage": "Select work item"
    },
    openLabel: {
        "id": "native-issue-table.common.issue-cells.issue-summary.open-issue-link.open-label",
        "defaultMessage": "Select work item {issueKey}"
    },
    openTooltipNew: {
        "id": "native-issue-table.common.issue-cells.issue-summary.open-issue-link.open-tooltip-new",
        "defaultMessage": "Open work item"
    },
    openLabelNew: {
        "id": "native-issue-table.common.issue-cells.issue-summary.open-issue-link.open-label-new",
        "defaultMessage": "Open work item {issueKey}"
    }
});

});



parcelRegister("69Ju5", function(module, exports) {
$parcel$export(module.exports, "IssueTypeCell", () => $45eb161bb048aee0$export$75b44b408924c851);

var $4uj9d = parcelRequire("4uj9d");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7PXBL = parcelRequire("7PXBL");
const $45eb161bb048aee0$export$75b44b408924c851 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $4uj9d.default), fieldRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7PXBL.IconCell), {
        fragmentRef: data,
        showErrorIconWhenEmpty: true
    });
});

});
parcelRegister("4uj9d", function(module, exports) {
$parcel$export(module.exports, "default", () => $51e9b757eada9f78$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<edda4e3dd30ca8cf6adeddd3dbc8df0b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $51e9b757eada9f78$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueTypeCell",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "IconCell"
        }
    ],
    "type": "JiraIssueTypeField"
};
$51e9b757eada9f78$var$node.hash = "877c101cf6c61ca9ea0f6a9dfeefabab";
var $51e9b757eada9f78$export$2e2bcd8739ae039 = $51e9b757eada9f78$var$node;

});

parcelRegister("7PXBL", function(module, exports) {
$parcel$export(module.exports, "IconCell", () => $009899e793dea9f9$export$5ffd26a2d6f7e2d);

var $abh0f = parcelRequire("abh0f");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $k71qx = parcelRequire("k71qx");

var $4cTDP = parcelRequire("4cTDP");

var $9Mapt = parcelRequire("9Mapt");

var $3OT15 = parcelRequire("3OT15");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");
const $009899e793dea9f9$export$5ffd26a2d6f7e2d = /*#__PURE__*/ (0, $eJOHy.memo)(({ nameOld: nameOld, iconUrlOld: iconUrlOld, showErrorIconWhenEmpty: showErrorIconWhenEmpty, fragmentRef: fragmentRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $abh0f.default), fragmentRef);
    const iconUrl = iconUrlOld ?? data?.issueType?.avatar?.small;
    const name = nameOld ?? data?.issueType?.name;
    const isSingleLineRowHeightFeatureEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const hoverPopoverRefFactory = isSingleLineRowHeightFeatureEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data?.id) : null;
    let isMergedColumnVisible = false;
    if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnVisible = (0, $34oCh.useIsMergedColumnVisible)();
    const isSingleLineRowHeightEnabled = isSingleLineRowHeightFeatureEnabled && !isMergedColumnVisible;
    if (!name?.length || !iconUrl?.length) return showErrorIconWhenEmpty ? /*#__PURE__*/ $eJOHy.createElement((0, $86BUM.default), {
        cellType: "icon",
        reason: "Missing required fields"
    }) : null; // aka an empty cell
    const imgComponent = (ref = null)=>/*#__PURE__*/ $eJOHy.createElement("img", {
            height: "16",
            width: "16",
            src: iconUrl,
            alt: name,
            "data-vc": "native-issue-table-ui-icon-cell-img",
            ref: ref,
            className: (0, $hcewu.default)([
                isSingleLineRowHeightEnabled && "_1e0c1ule"
            ])
        });
    if (isSingleLineRowHeightEnabled) {
        let hoverPopoverRef = null;
        if (hoverPopoverRefFactory) {
            hoverPopoverRef = hoverPopoverRefFactory({
                content: name,
                alwaysShow: true
            });
            return imgComponent(hoverPopoverRef);
        }
        return /*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: name
        }, ({ ref: ref })=>imgComponent(ref));
    }
    return(// @ts-expect-error Incompatible ref type in tooltip (AK needs "HTMLElement", Compiled provides "HTMLDivElement" somehow these are not compatible in Typescript)
    /*#__PURE__*/ $eJOHy.createElement((0, $k71qx.default), {
        content: name,
        tag: $009899e793dea9f9$var$AlignmentFix
    }, imgComponent()));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $009899e793dea9f9$var$AlignmentFix = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $009899e793dea9f9$var$imgStyles = null;

});
parcelRegister("abh0f", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b441de5ad5ace79$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c49622331b3d7750ce8d5e4b34b7ed85>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2b441de5ad5ace79$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IconCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueType",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "small"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraIssueTypeField"
};
$2b441de5ad5ace79$var$node.hash = "08d51c88eaef04241b1eefa353f8f767";
var $2b441de5ad5ace79$export$2e2bcd8739ae039 = $2b441de5ad5ace79$var$node;

});



parcelRegister("fqa5Z", function(module, exports) {
$parcel$export(module.exports, "LabelsCell", () => $0ebc834caf937d66$export$b1db1ca9063ebfb8);

var $ipwaE = parcelRequire("ipwaE");

var $i5Pcm = parcelRequire("i5Pcm");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $i45OY = parcelRequire("i45OY");

var $j8Km1 = parcelRequire("j8Km1");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");

var $8jOO7 = parcelRequire("8jOO7");
const $0ebc834caf937d66$export$b1db1ca9063ebfb8 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $i5Pcm.default), fieldRef);
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0ebc834caf937d66$export$194e7ceec6d29085, {
        fieldRef: data,
        issueSearchBaseUrl: issueSearchBaseUrl,
        isTruncated: !isDensityFull,
        isHoverPopoverEnabled: isSingleLineRowHeightEnabled,
        isFirstField: isFirstField,
        hasDuplicates: hasDuplicates
    });
});
const $0ebc834caf937d66$export$194e7ceec6d29085 = ({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, isTruncated: isTruncated, menuPortalTarget: menuPortalTarget, isHoverPopoverEnabled: isHoverPopoverEnabled, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $ipwaE.default), fieldRef);
    const isLabelsSystemField = data.fieldId === (0, $j8Km1.KNOWN_COLUMN_TYPES).LABELS;
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isInlineEditingSupported = isLabelsSystemField || isInlineEditingExtendedFieldSupportEnabled;
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingSupported ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isHoverPopoverEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i45OY.LabelsInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        baseSearchUrl: issueSearchBaseUrl,
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $0ebc834caf937d66$var$CustomTarget : undefined,
        fragmentRef: data,
        isTruncated: isTruncated,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        menuPortalTarget: menuPortalTarget,
        readViewFitContainerHeight: true,
        isHoverPopoverEnabled: isFirstField && isHoverPopoverEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i45OY.LabelsInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        baseSearchUrl: issueSearchBaseUrl,
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isTruncated: isTruncated,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        menuPortalTarget: menuPortalTarget,
        readViewFitContainerHeight: true,
        isHoverPopoverEnabled: isHoverPopoverEnabled
    });
};
const $0ebc834caf937d66$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $0ebc834caf937d66$var$customTargetStyles : $0ebc834caf937d66$var$customTargetStylesOld,
        ref: ref
    });
});
const $0ebc834caf937d66$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $0ebc834caf937d66$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("ipwaE", function(module, exports) {
$parcel$export(module.exports, "default", () => $04144edb9f19a5aa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<017b43c8a8aafd39977ff72be5268a38>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $04144edb9f19a5aa$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "LabelsCell_LabelsInlineEditCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraLabelsField"
};
$04144edb9f19a5aa$var$node.hash = "4b2d18a610614313c48c9aa8c73d40ed";
var $04144edb9f19a5aa$export$2e2bcd8739ae039 = $04144edb9f19a5aa$var$node;

});

parcelRegister("i5Pcm", function(module, exports) {
$parcel$export(module.exports, "default", () => $545a3bdb76978264$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ad84ef0696da43eb9dcae70ba90e75b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $545a3bdb76978264$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "LabelsCell",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "LabelsCell_LabelsInlineEditCell"
        }
    ],
    "type": "JiraLabelsField"
};
$545a3bdb76978264$var$node.hash = "5b6e5c66a83c717ab1a01b371fce907d";
var $545a3bdb76978264$export$2e2bcd8739ae039 = $545a3bdb76978264$var$node;

});

parcelRegister("i45OY", function(module, exports) {
$parcel$export(module.exports, "LabelsInlineEditViewWithIsEditable", () => $08b033632138b934$export$f00c136eadca5f4b);
$parcel$export(module.exports, "LabelsInlineEditView", () => $08b033632138b934$export$f066b3edf0d7cd25);

var $lpDHk = parcelRequire("lpDHk");

var $1YP6z = parcelRequire("1YP6z");

var $kgEIa = parcelRequire("kgEIa");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $aXKmr = parcelRequire("aXKmr");

var $eSnSE = parcelRequire("eSnSE");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $bJscI = parcelRequire("bJscI");

var $4EKqI = parcelRequire("4EKqI");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $1j4Y6 = parcelRequire("1j4Y6");

var $chD07 = parcelRequire("chD07");

var $h67Wd = parcelRequire("h67Wd");

var $ftN6c = parcelRequire("ftN6c");

var $cNNNb = parcelRequire("cNNNb");

var $fAZgY = parcelRequire("fAZgY");

var $5UIJ7 = parcelRequire("5UIJ7");
const $08b033632138b934$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-labels-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $08b033632138b934$var$FIELD_KEY = 'labels';
const $08b033632138b934$var$FIELD_TYPE = 'labels';
const $08b033632138b934$export$1b05898090f57b12 = 'issue-field.save-value';
const $08b033632138b934$export$3f27bc10068ef877 = `Failed to update field ${$08b033632138b934$var$FIELD_KEY} of type ${$08b033632138b934$var$FIELD_TYPE}`;
const $08b033632138b934$var$transformAggToAtlaskitOption = (connection)=>{
    const labelValues = connection?.edges?.map((edge)=>edge?.node ?? null).filter(Boolean).filter((label)=>label && label.name != null) || [];
    const labelOptions = labelValues.map((label)=>({
            label: label.name || '',
            value: label.name || '',
            ...label.color ? {
                color: label.color.colorKey
            } : {}
        }));
    return labelOptions;
};
const $08b033632138b934$var$transformAtlaskitOptionToAgg = (value)=>({
        totalCount: value.length,
        edges: value.map((label)=>({
                node: {
                    name: label.value,
                    ...label.color ? {
                        color: {
                            colorKey: label.color
                        }
                    } : {
                        color: null
                    }
                }
            }))
    });
const $08b033632138b934$var$transformLabelsOptionsToLabelNames = (value)=>value?.map((labelOption)=>labelOption.value) ?? [];
const $08b033632138b934$var$transformLabelsOptionsToColoredLabels = (labels)=>{
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'JiraOptionColorInput | null | undefined'.
    return labels?.map(({ value: value, color: color, __isNew__: __isNew__ })=>{
        if (color) return {
            name: value,
            color: color
        };
        return {
            name: value,
            ...__isNew__ ? {
                color: (0, $cNNNb.GREY_META).name
            } : {}
        };
    }) ?? [];
};
const $08b033632138b934$var$transformOptionsOperationsIntoAggOperationInput = (operations)=>operations.map(({ operation: operation, value: value })=>{
        if ((0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
            const coloredLabels = $08b033632138b934$var$transformLabelsOptionsToColoredLabels(value);
            return {
                operation: operation,
                labels: coloredLabels?.map((label)=>label.name) || [],
                labelProperties: coloredLabels
            };
        }
        return {
            operation: operation,
            labels: $08b033632138b934$var$transformLabelsOptionsToLabelNames(value)
        };
    });
const $08b033632138b934$var$isEqualLabels = (a, b)=>a.length === b.length && a.every((option, index)=>option.label === b[index].label && option.value === b[index].value);
const $08b033632138b934$export$f00c136eadca5f4b = ({ attributes: attributes, spacing: spacing = 'compact', baseSearchUrl: baseSearchUrl, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, isTruncated: isTruncated, isEditable: isEditable, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldScrollIntoView: menuShouldScrollIntoView, onCancel: onCancel, onEdit: onEdit, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceededProp, onSubmitFailed: onSubmitFailedProp, fragmentRef: fragmentRef, readViewFitContainerHeight: readViewFitContainerHeight, shouldShowProjectScopedCheckbox: shouldShowProjectScopedCheckbox, shouldPrefetchSuggestions: shouldPrefetchSuggestions = false, isHoverPopoverEnabled: isHoverPopoverEnabled })=>{
    const sessionId = (0, $eJOHy.useRef)((0, $aXKmr.v4)());
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const [currentProjectOnly, setCurrentProjectOnly] = (0, $eJOHy.useState)((0, $5UIJ7.getProjectScopeLabelCheckboxValueFromLocalStorage));
    (0, $eJOHy.useEffect)(()=>{
        (0, $4cTDP.fg)('labels_restricted_to_project_experiment') && (0, $5UIJ7.setProjectScopeLabelCheckboxValueFromLocalStorage)(currentProjectOnly);
    }, [
        currentProjectOnly
    ]);
    const data = (0, $j4oe4.useFragment)((0, $kgEIa.default), fragmentRef);
    const { id: uniqueFieldId, name: fieldNameNoOverrides, fieldId: fieldId, type: type } = data;
    const isFieldEditable = overriding.overrideIsEditable(isEditable);
    const fieldName = overriding.overrideLabel(fieldNameNoOverrides);
    const initialValue = (0, $eJOHy.useMemo)(()=>$08b033632138b934$var$transformAggToAtlaskitOption(data?.selectedLabelsConnection), [
        data?.selectedLabelsConnection
    ]);
    const [newValue, setNewValue] = (0, $eJOHy.useState)(initialValue);
    const [cachedLabels, { addToCache: addToCache }] = (0, $h67Wd.useLabelsCache)(fieldId);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $1YP6z.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const validator = (0, $5UIJ7.useLabelsValidator)();
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        const updatedValue = $08b033632138b934$var$transformLabelsOptionsToLabelNames(value);
        const updatedColoredValue = $08b033632138b934$var$transformLabelsOptionsToColoredLabels(value);
        addToCache((0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? updatedColoredValue : updatedValue);
        onSubmit?.((0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? updatedColoredValue : updatedValue);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: $08b033632138b934$var$transformOptionsOperationsIntoAggOperationInput([
                        {
                            operation: 'SET',
                            value: value
                        }
                    ])
                }
            },
            optimisticResponse: {
                jira: {
                    updateLabelsField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            type: type,
                            fieldId: fieldId,
                            // @ts-expect-error - ts2322 - Property 'id' is missing in type '{ readonly colorKey: string | null | undefined; }' but required in type '{ readonly colorKey: string | null | undefined; readonly id: string | null | undefined; }'.
                            selectedLabelsConnection: $08b033632138b934$var$transformAtlaskitOptionToAgg(value)
                        }
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData?.jira?.updateLabelsField?.success) onSuccess();
                else {
                    const errorMessage = mutationData?.jira?.updateLabelsField?.errors?.[0]?.message ?? undefined;
                    onFail(undefined, errorMessage);
                    (0, $eSnSE.default).safeErrorWithoutCustomerData($08b033632138b934$export$1b05898090f57b12, `Failed to update field ${fieldId} of type ${$08b033632138b934$var$FIELD_TYPE}`);
                }
            },
            onError (error) {
                onFail(error, error.message);
                (0, $eSnSE.default).safeErrorWithoutCustomerData($08b033632138b934$export$1b05898090f57b12, `Failed to update field ${fieldId} of type ${$08b033632138b934$var$FIELD_TYPE}`);
            }
        });
    }, // PLEASE CONFIRM THESE DEPENDENCIES ARE CORRECT
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        addToCache,
        onSubmit,
        commit,
        uniqueFieldId,
        fieldName,
        type,
        fieldId,
        createAnalyticsEvent
    ]);
    const handleSubmitSucceeded = (0, $fAZgY.useCallbackWithCondition)((value)=>{
        // onSubmitSucceededProp expects a list of strings so we must map our updated value accordingly.
        onSubmitSucceededProp?.((0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? $08b033632138b934$var$transformLabelsOptionsToColoredLabels(value) : $08b033632138b934$var$transformLabelsOptionsToLabelNames(value));
    }, [
        onSubmitSucceededProp
    ], ()=>(0, $4cTDP.fg)('jfp-magma-stability-issue-view-2'));
    const [config] = (0, $cxKOj.UNSAFE_noExposureExp)('labels_restricted_to_project');
    const memoizedAttributes = (0, $fAZgY.useMemoWithCondition)(()=>({
            ...attributes,
            ...(0, $4cTDP.fg)('labels_restricted_to_project_experiment') ? {
                hasProjectScopedLabels: config.get('showProjectFilter', false),
                currentProjectOnly: currentProjectOnly
            } : {}
        }), [
        attributes,
        config,
        currentProjectOnly
    ], ()=>(0, $4cTDP.fg)('jfp-magma-stability-issue-view-2'));
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: memoizedAttributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $08b033632138b934$var$isEqualLabels,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitSucceeded: handleSubmitSucceeded,
        onSubmitFailed: onSubmitFailedProp,
        onUpdateValue: setNewValue,
        updatedValue: newValue,
        validator: validator,
        clipboardComponentType: 'labels'
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08b033632138b934$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $chD07.LabelsReadView), {
            baseSearchUrl: baseSearchUrl,
            fragmentRef: data,
            isTruncated: isTruncated,
            isHoverPopoverEnabled: isHoverPopoverEnabled
        })), [
        baseSearchUrl,
        data,
        isTruncated,
        isHoverPopoverEnabled
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            ariaLabel: fieldName,
            spacing: spacing,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            onChange: handleChange,
            value: newValue,
            cachedOptions: cachedLabels,
            nodeIdFragment: data,
            isInvalid: !!invalidMessage,
            sessionId: sessionId.current,
            testId: 'issue-field-labels-inline-edit-view-full.ui.labels.edit-view',
            shouldShowProjectScopedCheckbox: shouldShowProjectScopedCheckbox,
            ...(0, $4cTDP.fg)('labels_restricted_to_project_experiment') ? {
                currentProjectOnly: currentProjectOnly,
                setCurrentProjectOnly: setCurrentProjectOnly
            } : {}
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewEntryPoint: (0, $1j4Y6.default),
        editViewEntryPointParams: shouldPrefetchSuggestions ? {
            id: uniqueFieldId
        } : {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        invalidMessage: invalidMessage,
        isEditable: isFieldEditable,
        isEditing: isEditing,
        hasReadViewTruncateDisabled: isHoverPopoverEnabled,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        hasUnsubmittedChanges: hasServerValidationError
    });
};
const $08b033632138b934$export$f066b3edf0d7cd25 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)(/* eslint-disable @atlassian/relay/graphql-naming */ // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    (0, $lpDHk.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08b033632138b934$export$f00c136eadca5f4b, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("lpDHk", function(module, exports) {
$parcel$export(module.exports, "default", () => $59d069640f6c5b5c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a5d785db9d94536cfc54c642b914993>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $59d069640f6c5b5c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditView",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraLabelsField"
};
$59d069640f6c5b5c$var$node.hash = "83c0a65ee08db15e69b7b1d990bb3c2d";
var $59d069640f6c5b5c$export$2e2bcd8739ae039 = $59d069640f6c5b5c$var$node;

});

parcelRegister("1YP6z", function(module, exports) {
$parcel$export(module.exports, "default", () => $219b23193c263165$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7947fae5515817c329d71de17e81921>>
 * @relayHash c63fef829683257621ca44c6de704569
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID decd3960fcb949b4372ef20ce095b3faec3c8a144d2c1b402c746b261e027e87
const $219b23193c263165$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateLabelsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraLabelsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateLabelsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraLabelsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000
                                                }
                                            ],
                                            "concreteType": "JiraLabelConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedLabelsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalCount"
                                                },
                                                {
                                                    "concreteType": "JiraLabelEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraLabel",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraColor",
                                                                    "kind": "LinkedField",
                                                                    "name": "color",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "colorKey"
                                                                        },
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                        },
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "decd3960fcb949b4372ef20ce095b3faec3c8a144d2c1b402c746b261e027e87",
            "metadata": {},
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$219b23193c263165$var$node.hash = "b7c0af684826341f4d5d5b319e095b51";
var $219b23193c263165$export$2e2bcd8739ae039 = $219b23193c263165$var$node;

});

parcelRegister("kgEIa", function(module, exports) {
$parcel$export(module.exports, "default", () => $b12fe3092811acb1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f260bad90f08e590a093963f832701b0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b12fe3092811acb1$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "labels_issueFieldLabelsReadviewFull_LabelsReadView"
            },
            {
                "kind": "FragmentSpread",
                "name": "labels_issueFieldLabelsEditviewFull_LabelsEditView_nodeIdFragment"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1000
                        }
                    ],
                    "concreteType": "JiraLabelConnection",
                    "kind": "LinkedField",
                    "name": "selectedLabelsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        {
                            "concreteType": "JiraLabelEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraLabel",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v0 /*: any*/ ,
                                        {
                                            "concreteType": "JiraColor",
                                            "kind": "LinkedField",
                                            "name": "color",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "colorKey"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "storageKey": "selectedLabelsConnection(first:1000)"
                },
                "action": "THROW",
                "path": "selectedLabelsConnection"
            }
        ],
        "type": "JiraLabelsField"
    };
}();
$b12fe3092811acb1$var$node.hash = "36e5976ba7a2feeb9ac95152dd750aef";
var $b12fe3092811acb1$export$2e2bcd8739ae039 = $b12fe3092811acb1$var$node;

});

parcelRegister("1j4Y6", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a5de43dc26a37ed$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $lezTV = parcelRequire("lezTV");

const $3a5de43dc26a37ed$var$LabelsEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("cX6lF")), {
        moduleId: "f49080b6",
        priority: "interaction"
    }),
    getPreloadProps: ({ id: id })=>id ? {
            queries: {
                labelsSuggestionsData: {
                    parameters: $lezTV.default,
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    variables: {
                        id: id
                    }
                }
            }
        } : {}
});
var $3a5de43dc26a37ed$export$2e2bcd8739ae039 = $3a5de43dc26a37ed$var$LabelsEditViewEntryPoint;

});
parcelRegister("lezTV", function(module, exports) {
$parcel$export(module.exports, "default", () => $23c9f5a4c3ae7ab7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1812ef87b1f80def77b88faa395f28a5>>
 * @relayHash cf60cab627fd5a4526b86847467cc927
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 16a655da0b16a10ad930e84f8f7bfc022914d3262cbdef1fd962c0f5bc00523e
const $23c9f5a4c3ae7ab7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        },
        {
            "kind": "Literal",
            "name": "suggested",
            "value": true
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "labels_issueFieldLabelsEditviewFull_LabelsEditViewQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "labels_issueFieldLabelsEditviewFull_LabelsEditViewWithSuggestionsFragment_suggestionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "labels_issueFieldLabelsEditviewFull_LabelsEditViewQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraLabelConnection",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraLabelEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraLabel",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "color",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "colorKey"
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "labels(first:50,searchBy:\"\",suggested:true)"
                                },
                                {
                                    "args": v3 /*: any*/ ,
                                    "filters": [
                                        "suggested",
                                        "searchBy",
                                        "currentProjectOnly"
                                    ],
                                    "handle": "connection",
                                    "key": "labels_issueFieldLabelsEditviewFull_LabelsEditViewWithSuggestionsFragmentSearch__labels",
                                    "kind": "LinkedHandle",
                                    "name": "labels"
                                }
                            ],
                            "type": "JiraLabelsField"
                        },
                        v4 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "16a655da0b16a10ad930e84f8f7bfc022914d3262cbdef1fd962c0f5bc00523e",
            "metadata": {},
            "name": "labels_issueFieldLabelsEditviewFull_LabelsEditViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$23c9f5a4c3ae7ab7$var$node.hash = "f7c0efbc6f8dee59af5c37b02898ac3e";
var $23c9f5a4c3ae7ab7$export$2e2bcd8739ae039 = $23c9f5a4c3ae7ab7$var$node;

});

parcelRegister("cX6lF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8L4O3").then(()=>parcelRequire('i1Kmk'));

});


parcelRegister("chD07", function(module, exports) {
$parcel$export(module.exports, "LabelsReadView", () => $908eb3b1fb928d18$export$79e9d2357368ec9e);

var $1ClZA = parcelRequire("1ClZA");

var $bNhhZ = parcelRequire("bNhhZ");

var $8grad = parcelRequire("8grad");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $ar6fB = parcelRequire("ar6fB");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $tYLUh = parcelRequire("tYLUh");

var $aCFLd = parcelRequire("aCFLd");

var $051tO = parcelRequire("051tO");

var $iiHt1 = parcelRequire("iiHt1");

var $fjnDV = parcelRequire("fjnDV");

var $gZJc1 = parcelRequire("gZJc1");
const $908eb3b1fb928d18$var$getLabelTagColor = (label)=>{
    if ((0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
        const colorName = label?.color?.colorKey;
        if (!colorName) return (0, $aCFLd.memoizeGetAutoGeneratedColorForLabelsTag)(label?.name || '');
        const { tagColor: tagColor } = (0, $051tO.getColorMetadata)(colorName);
        return tagColor;
    }
    if ((0, $cxKOj.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false)) return (0, $aCFLd.memoizeGetAutoGeneratedColorForLabelsTag)(label.name);
};
const $908eb3b1fb928d18$export$79e9d2357368ec9e = (0, $1ClZA.isReactCompilerForLabelsFieldEnabled)() ? (t0)=>{
    const $ = (0, $bNhhZ.c)(13);
    const { baseSearchUrl: baseSearchUrl, fragmentRef: fragmentRef, isTruncated: isTruncated, isHoverPopoverEnabled: isHoverPopoverEnabled } = t0;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $gZJc1.default).noValueTextExperiment);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    const noValueTextExperiment = t1;
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const data = (0, $j4oe4.useFragment)((0, $8grad.default), fragmentRef);
    const { selectedLabelsConnection: labels, fieldId: fieldId } = data;
    if (labels.totalCount !== 0) {
        let t2;
        if ($[2] !== baseSearchUrl || $[3] !== fieldId || $[4] !== isHoverPopoverEnabled || $[5] !== isTruncated || $[6] !== labels.edges) {
            t2 = Symbol.for("react.early_return_sentinel");
            bb0: {
                const labelValues = labels?.edges?.filter(Boolean).map($908eb3b1fb928d18$var$_temp).filter($908eb3b1fb928d18$var$_temp2) || [];
                if (labelValues.length !== 0) {
                    if (isTruncated) {
                        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fjnDV.LabelsTruncatedReadView), {
                            baseSearchUrl: baseSearchUrl,
                            fieldId: fieldId,
                            labelValues: labelValues,
                            isHoverPopoverEnabled: isHoverPopoverEnabled
                        });
                        break bb0;
                    }
                    let t3;
                    if ($[8] !== baseSearchUrl || $[9] !== fieldId) {
                        t3 = (label_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ar6fB.default), {
                                key: label_0.name,
                                isRemovable: false,
                                text: label_0.name,
                                href: (0, $iiHt1.getLabelHref)(fieldId, label_0.name, baseSearchUrl),
                                color: $908eb3b1fb928d18$var$getLabelTagColor(label_0)
                            });
                        $[8] = baseSearchUrl;
                        $[9] = fieldId;
                        $[10] = t3;
                    } else t3 = $[10];
                    t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($908eb3b1fb928d18$var$GroupWithNegativeMarginOffset, null, labelValues.map(t3));
                    break bb0;
                }
            }
            $[2] = baseSearchUrl;
            $[3] = fieldId;
            $[4] = isHoverPopoverEnabled;
            $[5] = isTruncated;
            $[6] = labels.edges;
            $[7] = t2;
        } else t2 = $[7];
        if (t2 !== Symbol.for("react.early_return_sentinel")) return t2;
    }
    const t2 = isExperimentEnabled ? noValueTextExperiment : undefined;
    let t3;
    if ($[11] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
            emptyText: t2
        });
        $[11] = t2;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : ({ baseSearchUrl: baseSearchUrl, fragmentRef: fragmentRef, isTruncated: isTruncated, isHoverPopoverEnabled: isHoverPopoverEnabled })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const noValueTextExperiment = formatMessage((0, $gZJc1.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const data = (0, $j4oe4.useFragment)((0, $8grad.default), fragmentRef);
    const { selectedLabelsConnection: labels, fieldId: fieldId } = data;
    if (labels.totalCount !== 0) {
        const labelValues = labels?.edges?.filter(Boolean).map((edge)=>edge.node).filter((label)=>label != null && label.name != null) || [];
        if (labelValues.length !== 0) {
            if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fjnDV.LabelsTruncatedReadView), {
                baseSearchUrl: baseSearchUrl,
                fieldId: fieldId,
                labelValues: labelValues,
                isHoverPopoverEnabled: isHoverPopoverEnabled
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($908eb3b1fb928d18$var$GroupWithNegativeMarginOffset, null, labelValues.map((label_0)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ar6fB.default), {
                    key: label_0.name,
                    isRemovable: false,
                    text: label_0.name,
                    href: (0, $iiHt1.getLabelHref)(fieldId, label_0.name, baseSearchUrl),
                    color: $908eb3b1fb928d18$var$getLabelTagColor(label_0)
                });
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $908eb3b1fb928d18$var$GroupWithNegativeMarginOffset = /*#__PURE__*/ (0, $eJOHy.forwardRef)((0, $1ClZA.isReactCompilerForLabelsFieldEnabled)() ? (t0, __cmplr)=>{
    const $ = (0, $bNhhZ.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq _1n261g80 _1bah1y6m _19pkidpf _2hwxr5cr _otyridpf _18u0r5cr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq _1n261g80 _1bah1y6m _19pkidpf _2hwxr5cr _otyridpf _18u0r5cr",
            __cmplp.className
        ])
    });
});
function $908eb3b1fb928d18$var$_temp(edge) {
    return edge.node;
}
function $908eb3b1fb928d18$var$_temp2(label) {
    return label != null && label.name != null;
}

});
parcelRegister("1ClZA", function(module, exports) {
$parcel$export(module.exports, "isReactCompilerForLabelsFieldEnabled", () => $580a25047c74a1a0$export$cc47643e818fe2c1);

var $4cTDP = parcelRequire("4cTDP");
function $580a25047c74a1a0$export$cc47643e818fe2c1() {
    if ((0, $4cTDP.fg)('react_compiler_for_labels_field')) return true;
    return false;
}

});

parcelRegister("bNhhZ", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @lightSyntaxTransform
 * @noflow
 * @nolint
 * @preventMunge
 * @preserve-invariant-messages
 */ "use no memo";
"use strict";
var $8961ae8e4b5337af$var$__create = Object.create;
var $8961ae8e4b5337af$var$__defProp = Object.defineProperty;
var $8961ae8e4b5337af$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $8961ae8e4b5337af$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $8961ae8e4b5337af$var$__getProtoOf = Object.getPrototypeOf;
var $8961ae8e4b5337af$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8961ae8e4b5337af$var$__export = (target, all)=>{
    for(var name in all)$8961ae8e4b5337af$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $8961ae8e4b5337af$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $8961ae8e4b5337af$var$__getOwnPropNames(from))if (!$8961ae8e4b5337af$var$__hasOwnProp.call(to, key) && key !== except) $8961ae8e4b5337af$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $8961ae8e4b5337af$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $8961ae8e4b5337af$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $8961ae8e4b5337af$var$__create($8961ae8e4b5337af$var$__getProtoOf(mod)) : {}, $8961ae8e4b5337af$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $8961ae8e4b5337af$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $8961ae8e4b5337af$var$__toCommonJS = (mod)=>$8961ae8e4b5337af$var$__copyProps($8961ae8e4b5337af$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/index.ts
var $8961ae8e4b5337af$var$index_exports = {};
$8961ae8e4b5337af$var$__export($8961ae8e4b5337af$var$index_exports, {
    $dispatcherGuard: ()=>$8961ae8e4b5337af$var$$dispatcherGuard,
    $makeReadOnly: ()=>$8961ae8e4b5337af$var$$makeReadOnly,
    $reset: ()=>$8961ae8e4b5337af$var$$reset,
    $structuralCheck: ()=>$8961ae8e4b5337af$var$$structuralCheck,
    c: ()=>$8961ae8e4b5337af$var$c,
    clearRenderCounterRegistry: ()=>$8961ae8e4b5337af$var$clearRenderCounterRegistry,
    renderCounterRegistry: ()=>$8961ae8e4b5337af$var$renderCounterRegistry,
    useRenderCounter: ()=>$8961ae8e4b5337af$var$useRenderCounter
});
module.exports = $8961ae8e4b5337af$var$__toCommonJS($8961ae8e4b5337af$var$index_exports);

var $8961ae8e4b5337af$var$React = $8961ae8e4b5337af$var$__toESM((parcelRequire("eJOHy")));
var { useRef: $8961ae8e4b5337af$var$useRef, useEffect: $8961ae8e4b5337af$var$useEffect, isValidElement: $8961ae8e4b5337af$var$isValidElement } = $8961ae8e4b5337af$var$React;
var $8961ae8e4b5337af$var$_a;
var $8961ae8e4b5337af$var$ReactSecretInternals = //@ts-ignore
($8961ae8e4b5337af$var$_a = $8961ae8e4b5337af$var$React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE) != null ? $8961ae8e4b5337af$var$_a : $8961ae8e4b5337af$var$React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
var $8961ae8e4b5337af$var$$empty = Symbol.for("react.memo_cache_sentinel");
var $8961ae8e4b5337af$var$_a2;
var $8961ae8e4b5337af$var$c = // @ts-expect-error
typeof (($8961ae8e4b5337af$var$_a2 = $8961ae8e4b5337af$var$React.__COMPILER_RUNTIME) == null ? void 0 : $8961ae8e4b5337af$var$_a2.c) === "function" ? // @ts-expect-error
$8961ae8e4b5337af$var$React.__COMPILER_RUNTIME.c : function c2(size) {
    return $8961ae8e4b5337af$var$React.useMemo(()=>{
        const $ = new Array(size);
        for(let ii = 0; ii < size; ii++)$[ii] = $8961ae8e4b5337af$var$$empty;
        $[$8961ae8e4b5337af$var$$empty] = true;
        return $;
    }, []);
};
var $8961ae8e4b5337af$var$LazyGuardDispatcher = {};
[
    "readContext",
    "useCallback",
    "useContext",
    "useEffect",
    "useImperativeHandle",
    "useInsertionEffect",
    "useLayoutEffect",
    "useMemo",
    "useReducer",
    "useRef",
    "useState",
    "useDebugValue",
    "useDeferredValue",
    "useTransition",
    "useMutableSource",
    "useSyncExternalStore",
    "useId",
    "unstable_isNewReconciler",
    "getCacheSignal",
    "getCacheForType",
    "useCacheRefresh"
].forEach((name)=>{
    $8961ae8e4b5337af$var$LazyGuardDispatcher[name] = ()=>{
        throw new Error(`[React] Unexpected React hook call (${name}) from a React compiled function. Check that all hooks are called directly and named according to convention ('use[A-Z]') `);
    };
});
var $8961ae8e4b5337af$var$originalDispatcher = null;
$8961ae8e4b5337af$var$LazyGuardDispatcher["useMemoCache"] = (count)=>{
    if ($8961ae8e4b5337af$var$originalDispatcher == null) throw new Error("React Compiler internal invariant violation: unexpected null dispatcher");
    else return $8961ae8e4b5337af$var$originalDispatcher.useMemoCache(count);
};
function $8961ae8e4b5337af$var$setCurrent(newDispatcher) {
    $8961ae8e4b5337af$var$ReactSecretInternals.ReactCurrentDispatcher.current = newDispatcher;
    return $8961ae8e4b5337af$var$ReactSecretInternals.ReactCurrentDispatcher.current;
}
var $8961ae8e4b5337af$var$guardFrames = [];
function $8961ae8e4b5337af$var$$dispatcherGuard(kind) {
    const curr = $8961ae8e4b5337af$var$ReactSecretInternals.ReactCurrentDispatcher.current;
    if (kind === 0 /* PushGuardContext */ ) {
        $8961ae8e4b5337af$var$guardFrames.push(curr);
        if ($8961ae8e4b5337af$var$guardFrames.length === 1) $8961ae8e4b5337af$var$originalDispatcher = curr;
        if (curr === $8961ae8e4b5337af$var$LazyGuardDispatcher) throw new Error(`[React] Unexpected call to custom hook or component from a React compiled function. Check that (1) all hooks are called directly and named according to convention ('use[A-Z]') and (2) components are returned as JSX instead of being directly invoked.`);
        $8961ae8e4b5337af$var$setCurrent($8961ae8e4b5337af$var$LazyGuardDispatcher);
    } else if (kind === 1 /* PopGuardContext */ ) {
        const lastFrame = $8961ae8e4b5337af$var$guardFrames.pop();
        if (lastFrame == null) throw new Error("React Compiler internal error: unexpected null in guard stack");
        if ($8961ae8e4b5337af$var$guardFrames.length === 0) $8961ae8e4b5337af$var$originalDispatcher = null;
        $8961ae8e4b5337af$var$setCurrent(lastFrame);
    } else if (kind === 2 /* PushExpectHook */ ) {
        $8961ae8e4b5337af$var$guardFrames.push(curr);
        $8961ae8e4b5337af$var$setCurrent($8961ae8e4b5337af$var$originalDispatcher);
    } else if (kind === 3 /* PopExpectHook */ ) {
        const lastFrame = $8961ae8e4b5337af$var$guardFrames.pop();
        if (lastFrame == null) throw new Error("React Compiler internal error: unexpected null in guard stack");
        $8961ae8e4b5337af$var$setCurrent(lastFrame);
    } else throw new Error("React Compiler internal error: unreachable block" + kind);
}
function $8961ae8e4b5337af$var$$reset($) {
    for(let ii = 0; ii < $.length; ii++)$[ii] = $8961ae8e4b5337af$var$$empty;
}
function $8961ae8e4b5337af$var$$makeReadOnly() {
    throw new Error("TODO: implement $makeReadOnly in react-compiler-runtime");
}
var $8961ae8e4b5337af$var$renderCounterRegistry = /* @__PURE__ */ new Map();
function $8961ae8e4b5337af$var$clearRenderCounterRegistry() {
    for (const counters of $8961ae8e4b5337af$var$renderCounterRegistry.values())counters.forEach((counter)=>{
        counter.count = 0;
    });
}
function $8961ae8e4b5337af$var$registerRenderCounter(name, val) {
    let counters = $8961ae8e4b5337af$var$renderCounterRegistry.get(name);
    if (counters == null) {
        counters = /* @__PURE__ */ new Set();
        $8961ae8e4b5337af$var$renderCounterRegistry.set(name, counters);
    }
    counters.add(val);
}
function $8961ae8e4b5337af$var$removeRenderCounter(name, val) {
    const counters = $8961ae8e4b5337af$var$renderCounterRegistry.get(name);
    if (counters == null) return;
    counters.delete(val);
}
function $8961ae8e4b5337af$var$useRenderCounter(name) {
    const val = $8961ae8e4b5337af$var$useRef(null);
    if (val.current != null) val.current.count += 1;
    $8961ae8e4b5337af$var$useEffect(()=>{
        if (val.current == null) {
            const counter = {
                count: 0
            };
            $8961ae8e4b5337af$var$registerRenderCounter(name, counter);
            val.current = counter;
        }
        return ()=>{
            if (val.current !== null) $8961ae8e4b5337af$var$removeRenderCounter(name, val.current);
        };
    });
}
var $8961ae8e4b5337af$var$seenErrors = /* @__PURE__ */ new Set();
function $8961ae8e4b5337af$var$$structuralCheck(oldValue, newValue, variableName, fnName, kind, loc) {
    function error(l, r, path, depth) {
        const str = `${fnName}:${loc} [${kind}] ${variableName}${path} changed from ${l} to ${r} at depth ${depth}`;
        if ($8961ae8e4b5337af$var$seenErrors.has(str)) return;
        $8961ae8e4b5337af$var$seenErrors.add(str);
        console.error(str);
    }
    const depthLimit = 2;
    function recur(oldValue2, newValue2, path, depth) {
        if (depth > depthLimit) return;
        else if (oldValue2 === newValue2) return;
        else if (typeof oldValue2 !== typeof newValue2) error(`type ${typeof oldValue2}`, `type ${typeof newValue2}`, path, depth);
        else if (typeof oldValue2 === "object") {
            const oldArray = Array.isArray(oldValue2);
            const newArray = Array.isArray(newValue2);
            if (oldValue2 === null && newValue2 !== null) error("null", `type ${typeof newValue2}`, path, depth);
            else if (newValue2 === null) error(`type ${typeof oldValue2}`, "null", path, depth);
            else if (oldValue2 instanceof Map) {
                if (!(newValue2 instanceof Map)) error(`Map instance`, `other value`, path, depth);
                else if (oldValue2.size !== newValue2.size) error(`Map instance with size ${oldValue2.size}`, `Map instance with size ${newValue2.size}`, path, depth);
                else {
                    for (const [k, v] of oldValue2)if (!newValue2.has(k)) error(`Map instance with key ${k}`, `Map instance without key ${k}`, path, depth);
                    else recur(v, newValue2.get(k), `${path}.get(${k})`, depth + 1);
                }
            } else if (newValue2 instanceof Map) error("other value", `Map instance`, path, depth);
            else if (oldValue2 instanceof Set) {
                if (!(newValue2 instanceof Set)) error(`Set instance`, `other value`, path, depth);
                else if (oldValue2.size !== newValue2.size) error(`Set instance with size ${oldValue2.size}`, `Set instance with size ${newValue2.size}`, path, depth);
                else {
                    for (const v of newValue2)if (!oldValue2.has(v)) error(`Set instance without element ${v}`, `Set instance with element ${v}`, path, depth);
                }
            } else if (newValue2 instanceof Set) error("other value", `Set instance`, path, depth);
            else if (oldArray || newArray) {
                if (oldArray !== newArray) error(`type ${oldArray ? "array" : "object"}`, `type ${newArray ? "array" : "object"}`, path, depth);
                else if (oldValue2.length !== newValue2.length) error(`array with length ${oldValue2.length}`, `array with length ${newValue2.length}`, path, depth);
                else for(let ii = 0; ii < oldValue2.length; ii++)recur(oldValue2[ii], newValue2[ii], `${path}[${ii}]`, depth + 1);
            } else if ($8961ae8e4b5337af$var$isValidElement(oldValue2) || $8961ae8e4b5337af$var$isValidElement(newValue2)) {
                if ($8961ae8e4b5337af$var$isValidElement(oldValue2) !== $8961ae8e4b5337af$var$isValidElement(newValue2)) error(`type ${$8961ae8e4b5337af$var$isValidElement(oldValue2) ? "React element" : "object"}`, `type ${$8961ae8e4b5337af$var$isValidElement(newValue2) ? "React element" : "object"}`, path, depth);
                else if (oldValue2.type !== newValue2.type) error(`React element of type ${oldValue2.type}`, `React element of type ${newValue2.type}`, path, depth);
                else recur(oldValue2.props, newValue2.props, `[props of ${path}]`, depth + 1);
            } else {
                for(const key in newValue2)if (!(key in oldValue2)) error(`object without key ${key}`, `object with key ${key}`, path, depth);
                for(const key in oldValue2)if (!(key in newValue2)) error(`object with key ${key}`, `object without key ${key}`, path, depth);
                else recur(oldValue2[key], newValue2[key], `${path}.${key}`, depth + 1);
            }
        } else if (typeof oldValue2 === "function") return;
        else if (isNaN(oldValue2) || isNaN(newValue2)) {
            if (isNaN(oldValue2) !== isNaN(newValue2)) error(`${isNaN(oldValue2) ? "NaN" : "non-NaN value"}`, `${isNaN(newValue2) ? "NaN" : "non-NaN value"}`, path, depth);
        } else if (oldValue2 !== newValue2) error(oldValue2, newValue2, path, depth);
    }
    recur(oldValue, newValue, "", 0);
}

});

parcelRegister("8grad", function(module, exports) {
$parcel$export(module.exports, "default", () => $e59e66559aecbcf7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7dec5d911d8d729060e7c86a5f17d210>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e59e66559aecbcf7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "labels_issueFieldLabelsReadviewFull_LabelsReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    },
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            "action": "THROW",
            "path": "selectedLabelsConnection"
        }
    ],
    "type": "JiraLabelsField"
};
$e59e66559aecbcf7$var$node.hash = "3f7bd1f7c0b3da8b1c1b35313d9735b4";
var $e59e66559aecbcf7$export$2e2bcd8739ae039 = $e59e66559aecbcf7$var$node;

});

parcelRegister("iiHt1", function(module, exports) {
$parcel$export(module.exports, "getLabelHref", () => $95a0728e309b1229$export$a1200807f331a4bd);

var $bnIBr = parcelRequire("bnIBr");
const $95a0728e309b1229$var$CUSTOM_FIELD_PREFIX = 'customfield_';
const $95a0728e309b1229$export$faff4881e53b3cb6 = (fieldId)=>{
    if (fieldId.startsWith($95a0728e309b1229$var$CUSTOM_FIELD_PREFIX)) {
        const customId = fieldId.substring($95a0728e309b1229$var$CUSTOM_FIELD_PREFIX.length, fieldId.length);
        return `cf[${customId}]`;
    }
    return fieldId;
};
const $95a0728e309b1229$export$a1200807f331a4bd = (fieldId, label, baseSearchUrl = '/issues/')=>{
    const jqlEncodedValue = encodeURIComponent(`${$95a0728e309b1229$export$faff4881e53b3cb6(fieldId)} = ${(0, $bnIBr.toQuotedString)(label)}`);
    return `${baseSearchUrl}?jql=${jqlEncodedValue}`;
};

});

parcelRegister("fjnDV", function(module, exports) {
$parcel$export(module.exports, "LabelsTruncatedReadView", () => $d18877e75f12e55a$export$95d698e57184b56c);

var $1ClZA = parcelRequire("1ClZA");

var $bNhhZ = parcelRequire("bNhhZ");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $tYLUh = parcelRequire("tYLUh");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $aCFLd = parcelRequire("aCFLd");

var $051tO = parcelRequire("051tO");

var $iiHt1 = parcelRequire("iiHt1");

var $gZJc1 = parcelRequire("gZJc1");
const $d18877e75f12e55a$export$627d17b212b38ee0 = (label)=>{
    if ((0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
        const colorName = label?.color?.colorKey;
        const { backgroundColor: color } = (0, $051tO.getColorMetadata)(colorName || (0, $aCFLd.memoizeGetAutoGeneratedColorForLabels)(label.name));
        return color;
    }
    if ((0, $cxKOj.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false)) {
        const { backgroundColor: color } = (0, $051tO.getColorMetadata)((0, $aCFLd.memoizeGetAutoGeneratedColorForLabels)(label.name));
        return color;
    }
};
const $d18877e75f12e55a$export$95d698e57184b56c = (0, $1ClZA.isReactCompilerForLabelsFieldEnabled)() ? (t0)=>{
    const $ = (0, $bNhhZ.c)(17);
    const { baseSearchUrl: baseSearchUrl, fieldId: fieldId, labelValues: labelValues, isHoverPopoverEnabled: isHoverPopoverEnabled } = t0;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $gZJc1.default).noValueTextExperiment);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    const noValueTextExperiment = t1;
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    if (labelValues.length === 0) {
        const t2 = isExperimentEnabled ? noValueTextExperiment : undefined;
        let t3;
        if ($[2] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
                emptyText: t2
            });
            $[2] = t2;
            $[3] = t3;
        } else t3 = $[3];
        return t3;
    }
    let t2;
    if ($[4] !== baseSearchUrl || $[5] !== fieldId || $[6] !== labelValues) {
        let t3;
        if ($[8] !== baseSearchUrl || $[9] !== fieldId) {
            t3 = (label)=>{
                if ((0, $cxKOj.expVal)("adding-color-to-labels-field-in-jira-experiment", "isColoredLabelsEnabled", false) || (0, $cxKOj.expVal)("adding-color-to-labels-field-experiment-milestone2", "isColorfulNewLabelsEnabled", false)) return {
                    name: label.name,
                    key: label.name,
                    href: (0, $iiHt1.getLabelHref)(fieldId, label.name, baseSearchUrl),
                    isColored: true,
                    ...(0, $cxKOj.expVal)("adding-color-to-labels-field-experiment-milestone2", "isColorfulNewLabelsEnabled", false) ? {
                        color: $d18877e75f12e55a$export$627d17b212b38ee0(label)
                    } : {}
                };
                return {
                    name: label.name,
                    key: label.name,
                    href: (0, $iiHt1.getLabelHref)(fieldId, label.name, baseSearchUrl)
                };
            };
            $[8] = baseSearchUrl;
            $[9] = fieldId;
            $[10] = t3;
        } else t3 = $[10];
        t2 = labelValues.map(t3);
        $[4] = baseSearchUrl;
        $[5] = fieldId;
        $[6] = labelValues;
        $[7] = t2;
    } else t2 = $[7];
    const items = t2;
    let t3;
    if ($[11] !== formatMessage) {
        t3 = formatMessage((0, $gZJc1.default).showMoreTooltip);
        $[11] = formatMessage;
        $[12] = t3;
    } else t3 = $[12];
    let t4;
    if ($[13] !== isHoverPopoverEnabled || $[14] !== items || $[15] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            paddingBlock: "space.050",
            xcss: $d18877e75f12e55a$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
            items: items,
            ItemComponent: (0, $1tX0c.TagItem),
            PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
            showMoreTooltip: t3,
            isHoverPopoverEnabled: isHoverPopoverEnabled
        }));
        $[13] = isHoverPopoverEnabled;
        $[14] = items;
        $[15] = t3;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
} : ({ baseSearchUrl: baseSearchUrl, fieldId: fieldId, labelValues: labelValues, isHoverPopoverEnabled: isHoverPopoverEnabled })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const noValueTextExperiment = formatMessage((0, $gZJc1.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    if (labelValues.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    });
    const items = labelValues.map((label)=>{
        if ((0, $cxKOj.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) || (0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) return {
            name: label.name,
            key: label.name,
            href: (0, $iiHt1.getLabelHref)(fieldId, label.name, baseSearchUrl),
            isColored: true,
            ...(0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? {
                color: $d18877e75f12e55a$export$627d17b212b38ee0(label)
            } : {}
        };
        return {
            name: label.name,
            key: label.name,
            href: (0, $iiHt1.getLabelHref)(fieldId, label.name, baseSearchUrl)
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        xcss: $d18877e75f12e55a$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: items,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $gZJc1.default).showMoreTooltip),
        isHoverPopoverEnabled: isHoverPopoverEnabled
    }));
};
const $d18877e75f12e55a$var$containerStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%'
});

});
parcelRegister("gZJc1", function(module, exports) {
$parcel$export(module.exports, "default", () => $9950418b3a51d36e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9950418b3a51d36e$var$messages = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-labels-readview-full.labels.compact.show-more-tooltip",
        "defaultMessage": "See more labels"
    },
    noValueTextExperiment: {
        "id": "issue-field-labels-readview-full.labels.compact.no-value-text-experiment",
        "defaultMessage": "Add labels"
    }
});
var $9950418b3a51d36e$export$2e2bcd8739ae039 = $9950418b3a51d36e$var$messages;

});



parcelRegister("h67Wd", function(module, exports) {
$parcel$export(module.exports, "useLabelsCache", () => $4950fca072871133$export$18b2bd971a089d24);

var $eJOHy = parcelRequire("eJOHy");

var $jKTNh = parcelRequire("jKTNh");

var $eSnSE = parcelRequire("eSnSE");

var $4cTDP = parcelRequire("4cTDP");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $aCTqO = parcelRequire("aCTqO");
const $4950fca072871133$var$useRerenderTrigger = ()=>{
    const [token, setSymbol] = (0, $eJOHy.useState)(Symbol('useRerenderTrigger_initial'));
    const refreshToken = (0, $eJOHy.useCallback)(()=>setSymbol(Symbol('useRerenderTrigger_rerender')), []);
    return [
        token,
        refreshToken
    ];
};
const $4950fca072871133$var$isStringArray = (labels)=>{
    return labels.length > 0 && typeof labels[0] === 'string';
};
const $4950fca072871133$var$isColoredLabelArray = (labels)=>{
    return labels.length > 0 && typeof labels[0] !== 'string';
};
const $4950fca072871133$export$18b2bd971a089d24 = (fieldId)=>{
    const labelsCache = (0, $jKTNh.getLabelsCache)(fieldId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [cachedLabels, setCachedLabels] = (0, $eJOHy.useState)([]);
    const [cacheRefreshToken, refreshCache] = $4950fca072871133$var$useRerenderTrigger();
    const addToCache = (0, $eJOHy.useCallback)((labels)=>{
        // Filter out labels with spaces upfront if feature flag is enabled
        let labelsToProcess;
        if (!(0, $4cTDP.fg)('kenji-jjj-fix-spaced-label-recommendation')) labelsToProcess = labels;
        else if (labels.length === 0) labelsToProcess = labels;
        else if ($4950fca072871133$var$isStringArray(labels)) // String array - filter out labels with spaces
        labelsToProcess = labels.filter((label)=>!label.includes(' '));
        else if ($4950fca072871133$var$isColoredLabelArray(labels)) // ColoredLabel array - filter out labels with spaces
        labelsToProcess = labels.filter((label)=>!label.name?.includes(' '));
        else labelsToProcess = labels;
        Promise.all(labelsToProcess.map(async (label)=>{
            try {
                if (typeof label !== 'string') {
                    const cachedOption = await labelsCache.get(label.name);
                    (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'labelPickerCache set', {
                        isFromCache: Boolean(cachedOption?.label)
                    });
                    return label && labelsCache.set(`${label.name}`, {
                        label: label.name,
                        ...label.color ? {
                            color: label.color
                        } : {}
                    });
                }
                const cachedOption = await labelsCache.get(label);
                (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'labelPickerCache set', {
                    isFromCache: Boolean(cachedOption?.label)
                });
                return label && labelsCache.set(`${label}`, {
                    label: label
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view.labels.cache.set', error.message);
            }
            return undefined;
        })).then(()=>{
            refreshCache(); // trigger an update of the returned cached labels value
        });
    }, [
        createAnalyticsEvent,
        labelsCache,
        refreshCache
    ]);
    const removeFromCache = (0, $eJOHy.useCallback)((labels)=>{
        Promise.all(labels.map(async (label)=>{
            try {
                const cachedOption = await labelsCache.get(label);
                if (cachedOption) {
                    (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'labelPickerCache removed');
                    return cachedOption && labelsCache.remove(`${cachedOption.label}`);
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view.labels.cache.remove', error.message);
            }
            return undefined;
        })).then(()=>{
            refreshCache(); // trigger an update of the returned cached labels value
        });
    }, [
        createAnalyticsEvent,
        labelsCache,
        refreshCache
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const getCachedLabels = async ()=>{
            const cachedItems = await labelsCache.getAll();
            // Filter out labels with spaces before processing
            const filteredCachedItems = (0, $4cTDP.fg)('kenji-jjj-fix-spaced-label-recommendation') ? cachedItems.filter((item)=>{
                return item.label && !item.label.includes(' ');
            }) : cachedItems;
            const transformedCachedItems = (0, $aCTqO.transformCacheEntries)(filteredCachedItems);
            const labelOptions = (0, $aCTqO.mapCachedItemsToLabelOptions)(transformedCachedItems);
            setCachedLabels(labelOptions);
        };
        getCachedLabels();
    // Having cacheRefreshToken in the deps array allows us to retrigger a loading of the cached values whenever refreshCache is called
    }, [
        cacheRefreshToken,
        labelsCache
    ]);
    return [
        cachedLabels,
        {
            addToCache: addToCache,
            removeFromCache: removeFromCache
        }
    ];
};

});
parcelRegister("jKTNh", function(module, exports) {
$parcel$export(module.exports, "getLabelsCache", () => $f4c5914506d97267$export$f7e90ae127ed72ef);

var $gB3jQ = parcelRequire("gB3jQ");

var $bKn7P = parcelRequire("bKn7P");
const $f4c5914506d97267$var$labelsCaches = {};
const $f4c5914506d97267$export$f7e90ae127ed72ef = (labelsFieldId)=>{
    const cacheKey = labelsFieldId || (0, $bKn7P.props).cacheKey;
    if (!$f4c5914506d97267$var$labelsCaches[cacheKey]) $f4c5914506d97267$var$labelsCaches[cacheKey] = (0, $gB3jQ.default)({
        ...(0, $bKn7P.props),
        cacheKey: cacheKey
    });
    return $f4c5914506d97267$var$labelsCaches[cacheKey];
};

});
parcelRegister("bKn7P", function(module, exports) {
$parcel$export(module.exports, "props", () => $734b627f60d019d2$export$8128bb6492cf3de7);

const $734b627f60d019d2$var$MAX_RESULTS = 10;
const $734b627f60d019d2$var$CACHE_SIZE = $734b627f60d019d2$var$MAX_RESULTS * 2;
const $734b627f60d019d2$var$LABELS_CACHE_KEY = 'labels';
const $734b627f60d019d2$export$8128bb6492cf3de7 = {
    size: $734b627f60d019d2$var$CACHE_SIZE,
    cacheKey: $734b627f60d019d2$var$LABELS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $08db7ac9f9f525e1$export$2670cb7d5d4f7184)
};

});
const $08db7ac9f9f525e1$export$7271276960377470 = 'common-cache';
const $08db7ac9f9f525e1$export$a61768fefd33fcb1 = 'capacity exceeded';
const $08db7ac9f9f525e1$export$6c4d37c7f376a1de = 'clear';
const $08db7ac9f9f525e1$export$e271b26eefe41db8 = 'update';
const $08db7ac9f9f525e1$export$4bd2facc4a3e6aa1 = 'delete';
const $08db7ac9f9f525e1$export$26d12233004a7a60 = 'delete stale entry';
const $08db7ac9f9f525e1$export$1bb358554aac31c1 = 'get';
const $08db7ac9f9f525e1$export$61f74127e2b53cbe = 'hydrate';
const $08db7ac9f9f525e1$export$5e8f180ef0142226 = 'set';
const $08db7ac9f9f525e1$export$9eb68924983e00fb = 'get entries';
const $08db7ac9f9f525e1$export$bf340b99118a1511 = 'memory';
const $08db7ac9f9f525e1$export$2670cb7d5d4f7184 = 'local';
const $08db7ac9f9f525e1$export$b796061ff0c82e1a = 'session';



parcelRegister("aCTqO", function(module, exports) {
$parcel$export(module.exports, "mapCachedItemsToLabelOptions", () => $a0b3ef3b5b5776a6$export$9ba85e25262c8a32);
$parcel$export(module.exports, "transformCacheEntries", () => $a0b3ef3b5b5776a6$export$64c1e7aa265973f8);

const $a0b3ef3b5b5776a6$export$9ba85e25262c8a32 = (items)=>items.map((item)=>({
            label: item.label,
            value: item.label,
            ...item.color ? {
                color: item.color
            } : {}
        }));
const $a0b3ef3b5b5776a6$export$64c1e7aa265973f8 = (items)=>items.slice(-1 * (0, $c663f6eba89f5eed$export$f6b2881bc1090cea)).reverse();

});
const $c663f6eba89f5eed$export$ffb1c0893bcc2c13 = 'customfield_';
const $c663f6eba89f5eed$export$f6b2881bc1090cea = 5;



parcelRegister("5UIJ7", function(module, exports) {
$parcel$export(module.exports, "useLabelsValidator", () => $5feb26d49619397f$export$990e7f2d0da9a96a);
$parcel$export(module.exports, "getProjectScopeLabelCheckboxValueFromLocalStorage", () => $5feb26d49619397f$export$6181698b046b748f);
$parcel$export(module.exports, "setProjectScopeLabelCheckboxValueFromLocalStorage", () => $5feb26d49619397f$export$9e31f8fbc2feb98f);

var $eJOHy = parcelRequire("eJOHy");

var $3hRxq = parcelRequire("3hRxq");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");


var $at2Tf = parcelRequire("at2Tf");
const $5feb26d49619397f$export$990e7f2d0da9a96a = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const change = (0, $eJOHy.useCallback)((newValues)=>{
        for(let i = newValues.length - 1; i >= 0; i -= 1){
            const { __isNew__: __isNew__, value: value } = newValues[i];
            if (__isNew__ === true) {
                if (value.includes(' ')) return {
                    type: 'error',
                    message: formatMessage((0, $at2Tf.default).newLabelContainsSpacesError)
                };
                if (value.length > (0, $705a9ff31bc3258c$export$e85fda072a12fed9)) return {
                    type: 'error',
                    message: formatMessage((0, $at2Tf.default).newLabelTooLongError, {
                        maxLength: (0, $705a9ff31bc3258c$export$e85fda072a12fed9)
                    })
                };
            }
        }
        if (newValues.length > (0, $705a9ff31bc3258c$export$45f4d7adca48db10)) return {
            type: 'warning',
            message: formatMessage((0, $at2Tf.default).maximumNumberOfLabelsExceededError, {
                maxNumberOfLabels: (0, $705a9ff31bc3258c$export$45f4d7adca48db10)
            })
        };
        return null;
    }, [
        formatMessage
    ]);
    return {
        change: change
    };
};
const $5feb26d49619397f$export$f04a317778b8db56 = 'restrict_labels_to_projects_checkbox_value';
const $5feb26d49619397f$export$b19885560047617b = (0, $3hRxq.createLocalStorageProvider)('project-scoped-labels');
const $5feb26d49619397f$export$6181698b046b748f = ()=>{
    if (!(0, $4cTDP.fg)('labels_restricted_to_project_experiment')) return false;
    return $5feb26d49619397f$export$b19885560047617b.get($5feb26d49619397f$export$f04a317778b8db56) || false;
};
const $5feb26d49619397f$export$9e31f8fbc2feb98f = (value)=>{
    return $5feb26d49619397f$export$b19885560047617b.set($5feb26d49619397f$export$f04a317778b8db56, value);
};

});
const $705a9ff31bc3258c$export$45f4d7adca48db10 = 55;
const $705a9ff31bc3258c$export$e85fda072a12fed9 = 255;

parcelRegister("at2Tf", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d6558214ceb0917$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0d6558214ceb0917$var$messages = (0, $7qGN1.defineMessages)({
    errorTitle: {
        "id": "issue-field-labels-inline-edit-view-full.labels.error-title",
        "defaultMessage": "We couldn't set the labels value"
    },
    errorMessage: {
        "id": "issue-field-labels-inline-edit-view-full.labels.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    noValueText: {
        "id": "issue-field-labels-inline-edit-view-full.labels.no-value-text",
        "defaultMessage": "None"
    },
    newLabelTooLongError: {
        "id": "issue-field-labels-inline-edit-view-full.labels.new-label-too-long-error",
        "defaultMessage": "Labels can't be more than {maxLength} characters."
    },
    newLabelContainsSpacesError: {
        "id": "issue-field-labels-inline-edit-view-full.labels.new-label-contains-spaces-error",
        "defaultMessage": "Labels can't have spaces."
    },
    maximumNumberOfLabelsExceededError: {
        "id": "issue-field-labels-inline-edit-view-full.labels.maximum-number-of-labels-exceeded-error",
        "defaultMessage": "Can't have more than {maxNumberOfLabels} labels."
    }
});
var $0d6558214ceb0917$export$2e2bcd8739ae039 = $0d6558214ceb0917$var$messages;

});




parcelRegister("jG8is", function(module, exports) {
$parcel$export(module.exports, "MultiSelectCell", () => $aebfac5a3d8db8f6$export$4ae427e87d8482e2);

var $gn9Az = parcelRequire("gn9Az");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cqb3z = parcelRequire("cqb3z");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $aebfac5a3d8db8f6$export$4ae427e87d8482e2 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $gn9Az.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cqb3z.MultiSelectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $aebfac5a3d8db8f6$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cqb3z.MultiSelectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $aebfac5a3d8db8f6$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $aebfac5a3d8db8f6$var$customTargetStyles : $aebfac5a3d8db8f6$var$customTargetStylesOld,
        ref: ref
    });
});
const $aebfac5a3d8db8f6$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $aebfac5a3d8db8f6$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("gn9Az", function(module, exports) {
$parcel$export(module.exports, "default", () => $2241b2a947f9a96d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<30280ee8bff5652917405813a15cc39e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2241b2a947f9a96d$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "MultiSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraMultipleSelectField"
};
$2241b2a947f9a96d$var$node.hash = "46d86714fadeb62e9681c95e4741f478";
var $2241b2a947f9a96d$export$2e2bcd8739ae039 = $2241b2a947f9a96d$var$node;

});

parcelRegister("cqb3z", function(module, exports) {
$parcel$export(module.exports, "MultiSelectInlineEditViewWithIsEditable", () => $b97be3da31764f0c$export$2dcdfc567a992efd);

var $1Hoca = parcelRequire("1Hoca");

var $cpNwb = parcelRequire("cpNwb");

var $3lp3n = parcelRequire("3lp3n");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4EKqI = parcelRequire("4EKqI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $8xlP3 = parcelRequire("8xlP3");

var $l8r9T = parcelRequire("l8r9T");

var $auNLL = parcelRequire("auNLL");

var $bJscI = parcelRequire("bJscI");
const $b97be3da31764f0c$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-multi-select-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $b97be3da31764f0c$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.id));
    return b.every((option)=>aIdSet.has(option.id));
};
const $b97be3da31764f0c$export$2dcdfc567a992efd = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $3lp3n.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $cpNwb.default));
    // #endregion Relay
    // #region Common state
    const { id: uniqueFieldId, name: name, selectedOptions: selectedOptions, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedOptions?.edges) return null;
        return selectedOptions.edges.map((edge)=>({
                id: edge?.node?.id ?? '',
                optionId: edge?.node?.optionId ?? '',
                value: edge?.node?.value ?? '',
                selectableLabel: edge?.node?.value ?? '',
                selectableGroupKey: null,
                selectableIconUrl: null
            }));
    }, [
        selectedOptions?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable, overrideFieldOptionsFilter: overrideFieldOptionsFilter } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const filterOptionsById = (0, $eJOHy.useMemo)(()=>overrideFieldOptionsFilter(null), [
        overrideFieldOptionsFilter
    ]);
    // #endregion Common state
    // #region Actions
    const handleSubmit = (0, $eJOHy.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.id) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateMultipleSelectField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateMultipleSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedOptions: {
                                edges: values?.map((edge)=>({
                                        node: {
                                            id: edge.id ?? '',
                                            value: edge.selectableLabel ?? '',
                                            optionId: edge.optionId ?? ''
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $b97be3da31764f0c$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'multiSelect'
    });
    // #endregion Actions
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b97be3da31764f0c$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l8r9T.MultiSelectReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            isTruncatedWithHoverPopover: isTruncatedWithHoverPopover
        })), [
        data,
        isTruncated,
        isTruncatedWithHoverPopover
    ]);
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            filterOptionsById: filterOptionsById,
            openMenuOnFocus: true,
            spacing: spacing
        });
    // #endregion Edit view
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $8xlP3.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isTruncatedWithHoverPopover
    });
};
const $b97be3da31764f0c$export$9d754a44e976e46a = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $1Hoca.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b97be3da31764f0c$export$2dcdfc567a992efd, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("1Hoca", function(module, exports) {
$parcel$export(module.exports, "default", () => $882b91ee763e9470$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c8784dc5c6cf0181fba42792ac91445>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $882b91ee763e9470$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraMultipleSelectField"
};
$882b91ee763e9470$var$node.hash = "d32e2ded197d2b2b4bc30729f9587a62";
var $882b91ee763e9470$export$2e2bcd8739ae039 = $882b91ee763e9470$var$node;

});

parcelRegister("cpNwb", function(module, exports) {
$parcel$export(module.exports, "default", () => $19ff3609cca9ec46$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab89800218576513b704c68f8ce1ac28>>
 * @relayHash b4af6905e862873a8846fa4a71f56a57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12ff733a258befd165b334ced2a9a4ad512afe20c3502276964dc077438a292d
const $19ff3609cca9ec46$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "multiSelect_issueFieldMultiSelect_MultiSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "multiSelect_issueFieldMultiSelect_MultiSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedOptions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOptionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "optionId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "12ff733a258befd165b334ced2a9a4ad512afe20c3502276964dc077438a292d",
            "metadata": {},
            "name": "multiSelect_issueFieldMultiSelect_MultiSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$19ff3609cca9ec46$var$node.hash = "cb08d7ecaba6a03f3f00edae8eb1b5a3";
var $19ff3609cca9ec46$export$2e2bcd8739ae039 = $19ff3609cca9ec46$var$node;

});

parcelRegister("3lp3n", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c8142a40d92c9ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<357beb53165a8a4df485e730345c9792>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4c8142a40d92c9ca$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "multiSelect_issueFieldMultiSelectReadviewFull_MultiSelectReadView"
            },
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "optionId"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleSelectField"
    };
}();
$4c8142a40d92c9ca$var$node.hash = "51442265271466c01819bfe490c82976";
var $4c8142a40d92c9ca$export$2e2bcd8739ae039 = $4c8142a40d92c9ca$var$node;

});

parcelRegister("8xlP3", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6be29c11818f392$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $a6be29c11818f392$var$MultiSelectEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("gmJhf")), {
        moduleId: "f60cd571",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $a6be29c11818f392$export$2e2bcd8739ae039 = $a6be29c11818f392$var$MultiSelectEditViewEntryPoint;

});
parcelRegister("gmJhf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5k4Zc").then(()=>parcelRequire('1CasD'));

});


parcelRegister("l8r9T", function(module, exports) {
$parcel$export(module.exports, "MultiSelectReadView", () => $3094c29efbad1630$export$ecebbf80cc7a07f1);

var $8no8w = parcelRequire("8no8w");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $kp5kj = parcelRequire("kp5kj");

var $1tX0c = parcelRequire("1tX0c");

var $2j0d2 = parcelRequire("2j0d2");

var $k6Nau = parcelRequire("k6Nau");

var $3Lkm9 = parcelRequire("3Lkm9");

var $hIfdw = parcelRequire("hIfdw");
const $3094c29efbad1630$export$ecebbf80cc7a07f1 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $8no8w.default), fragmentRef);
    const transformedSelectedOptions = (0, $eJOHy.useMemo)(()=>{
        if (!data?.selectedOptions?.edges) return null;
        const selectedOptions = data.selectedOptions.edges.map((edge)=>edge?.node).filter((node)=>Boolean(node?.value));
        return selectedOptions.map((node)=>({
                key: node.id,
                name: node.value,
                color: null,
                isInteractive: false
            }));
    }, [
        data?.selectedOptions?.edges
    ]);
    const isBespokeEmptyFieldTextGA = (0, $k6Nau.useBespokeEmptyFieldTextGA)();
    if (!transformedSelectedOptions?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), isBespokeEmptyFieldTextGA && {
        placeholderText: (0, $3Lkm9.default).bespokenMultiSelectPlaceholderEmptyFieldText
    });
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        role: "group",
        xcss: isTruncatedWithHoverPopover && $3094c29efbad1630$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: transformedSelectedOptions,
        ItemComponent: (0, $kp5kj.OptionTag),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $hIfdw.default).showMoreTooltip),
        isHoverPopoverEnabled: isTruncatedWithHoverPopover
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        role: "group",
        shouldWrap: true
    }, transformedSelectedOptions.map(({ key: key, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp5kj.OptionTag), {
            key: key,
            ...restProps
        })));
};
const $3094c29efbad1630$var$inlineStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("8no8w", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f7780570eddd454$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<24f8ea29f5b0a9e715aebdeec184bd0b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7f7780570eddd454$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiSelect_issueFieldMultiSelectReadviewFull_MultiSelectReadView",
    "selections": [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraMultipleSelectField"
};
$7f7780570eddd454$var$node.hash = "30f1fb233423b8843508f947cb7c3c09";
var $7f7780570eddd454$export$2e2bcd8739ae039 = $7f7780570eddd454$var$node;

});

parcelRegister("kp5kj", function(module, exports) {
$parcel$export(module.exports, "OptionTag", () => $3f06606f2017e535$export$5991b62d89f5cc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $cxKOj = parcelRequire("cxKOj");

var $051tO = parcelRequire("051tO");
const $3f06606f2017e535$export$5991b62d89f5cc = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ name: name, color: color, isInteractive: isInteractive = true, showTooltip: showTooltip = false, isColoredLabel: isColoredLabel }, ref)=>{
    const { backgroundColor: tagColor } = (0, $051tO.getColorMetadata)(color);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $3f06606f2017e535$var$tagWrapperStyles,
            isInteractive && $3f06606f2017e535$var$interactiveStyles
        ],
        "aria-label": name,
        testId: "option-color-picker.option-tag.field-tag-wrapper",
        ref: ref
    }, isColoredLabel && (0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: `option-color-picker.option-tag.${color || 'default'}`,
        xcss: $3f06606f2017e535$var$styledTagsStyles,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            borderColor: tagColor
        }
    }, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3f06606f2017e535$var$StyledTag, {
        "data-testid": `option-color-picker.option-tag.${color || 'default'}`,
        color: tagColor
    }, name));
    return showTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3f06606f2017e535$var$tooltipStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: name
    }, content)) : content;
}));
const $3f06606f2017e535$var$tooltipStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden'
});
const $3f06606f2017e535$var$tagWrapperStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    justifyContent: 'left',
    alignItems: 'center',
    transition: '0.3s',
    maxWidth: '100%',
    minWidth: '0',
    minHeight: '0',
    color: 'color.text'
});
const $3f06606f2017e535$var$interactiveStyles = (0, $1DXK0.xcss)({
    ':hover': {
        cursor: 'pointer'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3f06606f2017e535$var$StyledTagBase = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _1reo15vq _18m915vq _vwz4f6fq _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});
const $3f06606f2017e535$var$StyledTag = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $3f06606f2017e535$var$StyledTagBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_14v0t1n": (0, $awdRS.default)(`1px solid ${__cmplp.color}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko3gvi _19it11we _bfhk18uv _u5f31b66 _19bv1b66",
            __cmplp.className
        ])
    });
});
const $3f06606f2017e535$var$styledTagsStyles = (0, $1DXK0.xcss)({
    font: 'font.body',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    borderRadius: 'radius.small',
    backgroundColor: 'color.background.neutral.subtle',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    paddingRight: 'space.050',
    paddingLeft: 'space.050',
    maxWidth: '180px'
});

});

parcelRegister("hIfdw", function(module, exports) {
$parcel$export(module.exports, "default", () => $4db827a084446152$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4db827a084446152$var$messages = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-multi-select-readview-full.multi-select.compact.show-more-tooltip",
        "defaultMessage": "See more selected options"
    }
});
var $4db827a084446152$export$2e2bcd8739ae039 = $4db827a084446152$var$messages;

});




parcelRegister("acnWs", function(module, exports) {
$parcel$export(module.exports, "MultiUserPickerCell", () => $1d87a0fc1026ff5f$export$900adf2a2bd19e48);

var $3BlIc = parcelRequire("3BlIc");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $1b9aE = parcelRequire("1b9aE");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $1d87a0fc1026ff5f$export$900adf2a2bd19e48 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $3BlIc.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1b9aE.MultiUserPickerInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $1d87a0fc1026ff5f$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1b9aE.MultiUserPickerInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        menuPosition: "fixed",
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true
    });
};
const $1d87a0fc1026ff5f$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $1d87a0fc1026ff5f$var$customTargetStyles : $1d87a0fc1026ff5f$var$customTargetStylesOld,
        ref: ref
    });
});
const $1d87a0fc1026ff5f$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $1d87a0fc1026ff5f$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("3BlIc", function(module, exports) {
$parcel$export(module.exports, "default", () => $1846aa5cb291418c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bdf07695cbe24b3c9dcff7c7fb6f4a74>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1846aa5cb291418c$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "MultiUserPickerCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraMultipleSelectUserPickerField"
};
$1846aa5cb291418c$var$node.hash = "b122136283417cdc5ffc57377984a2bb";
var $1846aa5cb291418c$export$2e2bcd8739ae039 = $1846aa5cb291418c$var$node;

});

parcelRegister("1b9aE", function(module, exports) {
$parcel$export(module.exports, "MultiUserPickerInlineEditViewWithIsEditable", () => $bd008b5eaa50c36c$export$2d98458340508c60);
$parcel$export(module.exports, "MultiUserPickerInlineEditView", () => $bd008b5eaa50c36c$export$117723181a3f3b6b);

var $6rsao = parcelRequire("6rsao");

var $3YYqq = parcelRequire("3YYqq");

var $8pmQp = parcelRequire("8pmQp");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $22FmW = parcelRequire("22FmW");

var $flmqW = parcelRequire("flmqW");

var $8y7U1 = parcelRequire("8y7U1");

var $auNLL = parcelRequire("auNLL");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");
const $bd008b5eaa50c36c$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-multi-user-picker-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $bd008b5eaa50c36c$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.id));
    return b.every((option)=>aIdSet.has(option.id));
};
const $bd008b5eaa50c36c$export$2d98458340508c60 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact' })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $8pmQp.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $3YYqq.default));
    // #endregion
    // #region Common state
    const { id: uniqueFieldId, name: name, selectedUsersConnection: selectedUsersConnection, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedUsersConnection?.edges) return null;
        return selectedUsersConnection?.edges?.map((edge)=>edge?.node).filter(Boolean) ?? [];
    }, [
        selectedUsersConnection?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    // #endregion Common state
    // #region Actions
    const handleSubmit = (0, $eJOHy.useCallback)((users, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(users);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: users?.map((user)=>user.id) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateMultipleSelectUserPickerField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateMultipleSelectUserPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedUsersConnection: {
                                edges: users?.map((user)=>({
                                        node: {
                                            __typename: 'AtlassianAccountUser',
                                            ...user
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $bd008b5eaa50c36c$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'multiUserPicker'
    });
    // #endregion Actions
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd008b5eaa50c36c$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8y7U1.MultiUserPickerReadView), {
            fragmentRef: data
        })), [
        data
    ]);
    // #endregion
    // #region Edit view
    const transformedEditViewValue = (0, $eJOHy.useMemo)(()=>{
        if (!updatedValue) return null;
        return updatedValue.map((0, $22FmW.transformAggToUserOption));
    }, [
        updatedValue
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            value: transformedEditViewValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            spacing: spacing,
            inputId: uniqueFieldId,
            ariaLabel: fieldName
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $flmqW.default),
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupTarget: editViewPopupTarget,
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
};
const $bd008b5eaa50c36c$export$117723181a3f3b6b = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $6rsao.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd008b5eaa50c36c$export$2d98458340508c60, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("6rsao", function(module, exports) {
$parcel$export(module.exports, "default", () => $50ce74ea6f1978f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c4638e38e1d56970af022bce2a6a8dc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $50ce74ea6f1978f8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraMultipleSelectUserPickerField"
};
$50ce74ea6f1978f8$var$node.hash = "cce81be96601eacce28b3398c7aff2e6";
var $50ce74ea6f1978f8$export$2e2bcd8739ae039 = $50ce74ea6f1978f8$var$node;

});

parcelRegister("3YYqq", function(module, exports) {
$parcel$export(module.exports, "default", () => $22e1ecc4d2467595$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e8bd4e0e5d9e1acf3340c27b0e3b8df1>>
 * @relayHash 562b3a946b93846046a2c880c621d019
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c0d7fe195cdf6fa0ec9c4cc82b4535cfebcbdf6f940b25c2dd411f4d2a0ff25f
const $22e1ecc4d2467595$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraUserConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedUsersConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraUserEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "accountId"
                                                                },
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "picture"
                                                                },
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "accountStatus"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "email"
                                                                        }
                                                                    ],
                                                                    "type": "AtlassianAccountUser"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c0d7fe195cdf6fa0ec9c4cc82b4535cfebcbdf6f940b25c2dd411f4d2a0ff25f",
            "metadata": {},
            "name": "multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$22e1ecc4d2467595$var$node.hash = "66516ecfc9f74fa693150553eb2bae7f";
var $22e1ecc4d2467595$export$2e2bcd8739ae039 = $22e1ecc4d2467595$var$node;

});

parcelRegister("8pmQp", function(module, exports) {
$parcel$export(module.exports, "default", () => $381ab40f022295f1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<87c2e0fc25d3c82a0a376ce7418f273f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $381ab40f022295f1$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "multiUserPicker_issueFieldMultiUserPickerReadviewFull_MultiUserPickerReadView"
            },
            {
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "selectedUsersConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraUserEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "accountStatus"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "email"
                                            }
                                        ],
                                        "type": "AtlassianAccountUser"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleSelectUserPickerField"
    };
}();
$381ab40f022295f1$var$node.hash = "b0466005c00a3d3242fa4c867100b929";
var $381ab40f022295f1$export$2e2bcd8739ae039 = $381ab40f022295f1$var$node;

});

parcelRegister("22FmW", function(module, exports) {
$parcel$export(module.exports, "transformAggToUserOption", () => $0a955f742f9dce61$export$e466b9791a3fee63);
const $0a955f742f9dce61$export$e466b9791a3fee63 = (user)=>({
        avatarUrl: user.picture,
        id: user.id,
        accountId: user.accountId,
        name: user.name,
        active: user.accountStatus === 'active',
        byline: user.email ?? undefined,
        appType: user.appType
    });

});

parcelRegister("flmqW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8227025ef6ca891a$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $8227025ef6ca891a$var$MultiUserPickerEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("6Q5wh")), {
        moduleId: "d8224b35",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $8227025ef6ca891a$export$2e2bcd8739ae039 = $8227025ef6ca891a$var$MultiUserPickerEditViewEntryPoint;

});
parcelRegister("6Q5wh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("74Iit").then(()=>parcelRequire('dfmeK'));

});


parcelRegister("8y7U1", function(module, exports) {
$parcel$export(module.exports, "MultiUserPickerReadView", () => $84ea473a7b6539c0$export$183c102b43ea6c63);

var $cmeRZ = parcelRequire("cmeRZ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gqBnP = parcelRequire("gqBnP");

var $d9T1A = parcelRequire("d9T1A");

var $4cTDP = parcelRequire("4cTDP");

var $9yHlD = parcelRequire("9yHlD");
const $84ea473a7b6539c0$export$183c102b43ea6c63 = ({ fragmentRef: fragmentRef })=>{
    const { selectedUsersConnection: selectedUsersConnection } = (0, $j4oe4.useFragment)((0, $cmeRZ.default), fragmentRef);
    const transformedData = (0, $eJOHy.useMemo)(()=>{
        const filteredEdges = selectedUsersConnection?.edges?.filter((edge)=>Boolean(edge?.node)) ?? [];
        return filteredEdges.map((edge)=>({
                name: edge.node.name,
                key: edge.node.accountId,
                src: edge.node.picture
            }));
    }, [
        selectedUsersConnection?.edges
    ]);
    if ((0, $4cTDP.fg)('jsc_inline_edit_fast_follow_field_types')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9yHlD.UserConnectionReadView), {
        fragmentRef: selectedUsersConnection ?? null
    });
    if (transformedData.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gqBnP.default), {
        data: transformedData,
        size: "small"
    });
};

});
parcelRegister("cmeRZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $693b6b79a3b23343$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0909847a960d2365b5bf01eca759700d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $693b6b79a3b23343$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiUserPicker_issueFieldMultiUserPickerReadviewFull_MultiUserPickerReadView",
    "selections": [
        {
            "concreteType": "JiraUserConnection",
            "kind": "LinkedField",
            "name": "selectedUsersConnection",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "UserConnectionReadView"
                },
                {
                    "concreteType": "JiraUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraMultipleSelectUserPickerField"
};
$693b6b79a3b23343$var$node.hash = "e7c567c090efcaaf1ee9f347df482399";
var $693b6b79a3b23343$export$2e2bcd8739ae039 = $693b6b79a3b23343$var$node;

});

parcelRegister("9yHlD", function(module, exports) {
$parcel$export(module.exports, "UserConnectionReadView", () => $5755e0fcc33e5d35$export$9e5ab932424a081a);

var $g5qsh = parcelRequire("g5qsh");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gqBnP = parcelRequire("gqBnP");

var $d9T1A = parcelRequire("d9T1A");
const $5755e0fcc33e5d35$export$9e5ab932424a081a = ({ avatarGroupOverrides: avatarGroupOverrides, fragmentRef: fragmentRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $g5qsh.default), fragmentRef);
    const transformedData = (0, $eJOHy.useMemo)(()=>{
        const filteredEdges = data?.edges?.filter((edge)=>Boolean(edge?.node)) ?? [];
        return filteredEdges.map((edge)=>({
                name: edge.node.name,
                key: edge.node.accountId,
                src: edge.node.picture
            }));
    }, [
        data?.edges
    ]);
    if (transformedData.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gqBnP.default), {
        data: transformedData,
        overrides: avatarGroupOverrides,
        size: "small"
    });
};

});
parcelRegister("g5qsh", function(module, exports) {
$parcel$export(module.exports, "default", () => $694631bf76ea749f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a90643615e98ab2e1349de4e54e3754>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $694631bf76ea749f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "UserConnectionReadView",
    "selections": [
        {
            "concreteType": "JiraUserEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraUserConnection"
};
$694631bf76ea749f$var$node.hash = "cfc79c27bbbda8b9e1a6bde015d76c82";
var $694631bf76ea749f$export$2e2bcd8739ae039 = $694631bf76ea749f$var$node;

});





parcelRegister("fjuAd", function(module, exports) {
$parcel$export(module.exports, "ConfluencePagesCell", () => $46d7fc6ea1d42d7c$export$486bd1bbeaa77e1b);

var $g8Kny = parcelRequire("g8Kny");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lIUOF = parcelRequire("lIUOF");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");
const $46d7fc6ea1d42d7c$export$486bd1bbeaa77e1b = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $g8Kny.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const shouldTruncate = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lIUOF.ConfluencePagesInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        isTruncated: shouldTruncate,
        menuPosition: "fixed",
        readViewFitContainerHeight: true
    });
};

});
parcelRegister("g8Kny", function(module, exports) {
$parcel$export(module.exports, "default", () => $34298fb829ac63cb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f85988df5b4096f46127ec23619e48b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $34298fb829ac63cb$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "ConfluencePagesCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_ConfluencePagesInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraConfluenceRemoteIssueLinksField"
};
$34298fb829ac63cb$var$node.hash = "4feb137c78c79dda7d51e4a768ceade1";
var $34298fb829ac63cb$export$2e2bcd8739ae039 = $34298fb829ac63cb$var$node;

});

parcelRegister("lIUOF", function(module, exports) {
$parcel$export(module.exports, "ConfluencePagesInlineEditViewWithIsEditable", () => $cdb3021b77eb3aaa$export$efa01917dd201830);

var $23Jc1 = parcelRequire("23Jc1");

var $dsUqZ = parcelRequire("dsUqZ");

var $jawdt = parcelRequire("jawdt");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $aXKmr = parcelRequire("aXKmr");

var $4cTDP = parcelRequire("4cTDP");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $99gun = parcelRequire("99gun");

var $4s7iN = parcelRequire("4s7iN");

var $42SRb = parcelRequire("42SRb");

var $gGrR8 = parcelRequire("gGrR8");
const $cdb3021b77eb3aaa$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-confluence-pages-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $cdb3021b77eb3aaa$var$isEqualOption = (a, b)=>{
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.url));
    return b.every((option)=>aIdSet.has(option.url));
};
const $cdb3021b77eb3aaa$export$efa01917dd201830 = ({ editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncated: isTruncated })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $jawdt.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $dsUqZ.default));
    // #endregion
    // #region Common state
    const { id: uniqueFieldId, name: fieldName, type: fieldType, confluenceRemoteIssueLinks: confluenceRemoteIssueLinks } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>confluenceRemoteIssueLinks?.edges?.map((edge)=>edge?.node).filter(Boolean).map((node)=>{
            const url = (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') ? node.pageContent?.href ?? node.href ?? '' : node.href ?? '';
            return {
                id: node.id,
                url: url
            };
        }) ?? [], [
        confluenceRemoteIssueLinks
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            // Retain the ID of existing linked pages and use the URL for new links to add.
                            links: value.map(({ id: id, url: url })=>id ? {
                                    id: id
                                } : {
                                    href: url
                                }),
                            operation: 'SET'
                        }
                    ]
                },
                isJiraConfluencePageContentEnabled: (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout')
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateConfluenceRemoteIssueLinksField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateConfluenceRemoteIssueLinksField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            confluenceRemoteIssueLinks: {
                                totalCount: value.length,
                                edges: value.map((option)=>({
                                        node: {
                                            id: option.id ?? (0, $aXKmr.v4)(),
                                            href: option.url,
                                            pageContent: (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') ? {
                                                __typename: 'JiraConfluencePageContentDetails',
                                                href: option.url
                                            } : null
                                        }
                                    }))
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange } = (0, $4s7iN.useFieldInlineEditActions)({
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $cdb3021b77eb3aaa$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue
    });
    // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cdb3021b77eb3aaa$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gGrR8.ConfluencePagesReadView), {
            isTruncated: isTruncated,
            fragmentRef: data
        }));
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            initialIsOpen: true,
            value: updatedValue,
            menuPosition: menuPosition,
            onChange: handleChange,
            spacing: spacing
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $42SRb.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hasReadViewTruncateDisabled: isTruncated,
        hideActionButtons: true
    });
};
const $cdb3021b77eb3aaa$export$f4b4c94c27bd1239 = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $23Jc1.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cdb3021b77eb3aaa$export$efa01917dd201830, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("23Jc1", function(module, exports) {
$parcel$export(module.exports, "default", () => $97db96ad83ab6d66$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<af30466501d29bf9367df09283f83219>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $97db96ad83ab6d66$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_ConfluencePagesInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_ConfluencePagesInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraConfluenceRemoteIssueLinksField"
};
$97db96ad83ab6d66$var$node.hash = "b82ba55e135c40c22b29327df36827d2";
var $97db96ad83ab6d66$export$2e2bcd8739ae039 = $97db96ad83ab6d66$var$node;

});

parcelRegister("dsUqZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf811190dcf53ca3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<169509d56041966e298998cb87a38e17>>
 * @relayHash 356127a3390d1de988ecf2b4a1c1a03c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c7b140651da7182c815fbb41a5ffa4914e5873e27f703bb3bf555585dc1ffb61

var $jvWSl = parcelRequire("jvWSl");
const $bf811190dcf53ca3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJiraConfluencePageContentEnabled"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v5 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "href"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "JiraConfluencePageContentDetails"
    }, v9 = [
        {
            "kind": "LinkedField",
            "name": "pageContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                v8 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraUpdateConfluenceRemoteIssueLinksFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateConfluenceRemoteIssueLinksField",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraConfluenceRemoteIssueLinksField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView"
                                        },
                                        {
                                            "args": v5 /*: any*/ ,
                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                            "kind": "LinkedField",
                                            "name": "confluenceRemoteIssueLinks",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "condition": "isJiraConfluencePageContentEnabled",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "pageContent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraUpdateConfluenceRemoteIssueLinksFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateConfluenceRemoteIssueLinksField",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraConfluenceRemoteIssueLinksField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v5 /*: any*/ ,
                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                            "kind": "LinkedField",
                                            "name": "confluenceRemoteIssueLinks",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": v9 /*: any*/ 
                                                                },
                                                                {
                                                                    "condition": "isJiraConfluencePageContentEnabled",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": v9 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalCount"
                                                }
                                            ],
                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c7b140651da7182c815fbb41a5ffa4914e5873e27f703bb3bf555585dc1ffb61",
            "metadata": {},
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default)
            }
        }
    };
}();
$bf811190dcf53ca3$var$node.hash = "6df37fe378e93b2269d708c82fda03c4";
var $bf811190dcf53ca3$export$2e2bcd8739ae039 = $bf811190dcf53ca3$var$node;

});

parcelRegister("jawdt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec6b69e9a3489800$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e3a18ee915c0b08d612d2e87cfc9491>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ec6b69e9a3489800$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "href"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_ConfluencePagesInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                "kind": "LinkedField",
                "name": "confluenceRemoteIssueLinks",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "pageContent",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v1 /*: any*/ 
                                                        ],
                                                        "type": "JiraConfluencePageContentDetails"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
            }
        ],
        "type": "JiraConfluenceRemoteIssueLinksField"
    };
}();
$ec6b69e9a3489800$var$node.hash = "0a786319535ed66ad895589d6a3c3b0d";
var $ec6b69e9a3489800$export$2e2bcd8739ae039 = $ec6b69e9a3489800$var$node;

});

parcelRegister("42SRb", function(module, exports) {
$parcel$export(module.exports, "default", () => $10e6d0a5d209f87f$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $10e6d0a5d209f87f$var$ConfluencePagesEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("jz3V5")), {
        moduleId: "7aa734f7",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $10e6d0a5d209f87f$export$2e2bcd8739ae039 = $10e6d0a5d209f87f$var$ConfluencePagesEditViewEntryPoint;

});
parcelRegister("jz3V5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("dZaje")
]).then(()=>parcelRequire('c3eOq'));

});


parcelRegister("gGrR8", function(module, exports) {
$parcel$export(module.exports, "ConfluencePagesReadView", () => $127aee618b583128$export$10de55138ce5421b);

var $1DLZD = parcelRequire("1DLZD");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8lb7o = parcelRequire("8lb7o");

var $lRq8t = parcelRequire("lRq8t");

var $3PRLs = parcelRequire("3PRLs");

var $4cTDP = parcelRequire("4cTDP");

var $eQdsc = parcelRequire("eQdsc");

var $43xuA = parcelRequire("43xuA");
const $127aee618b583128$export$10de55138ce5421b = ({ fragmentRef: fragmentRef, isTruncated: isTruncated = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { confluenceRemoteIssueLinks: confluenceRemoteIssueLinks } = (0, $j4oe4.useFragment)((0, $1DLZD.default), fragmentRef);
    const totalCount = confluenceRemoteIssueLinks?.totalCount ?? 0;
    const node = confluenceRemoteIssueLinks?.edges?.[0]?.node;
    const popupContentProps = (0, $eJOHy.useMemo)(()=>confluenceRemoteIssueLinks ? {
            fragmentRef: confluenceRemoteIssueLinks
        } : null, [
        confluenceRemoteIssueLinks
    ]);
    if (!popupContentProps || !node || totalCount === 0) return null;
    const url = (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') ? node.pageContent?.href ?? node.href ?? '' : node.href ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8lb7o.ItemWithEntryPointPopup), {
        ItemComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3PRLs.SimpleInlineSmartLink), {
            anchorTarget: "_blank",
            url: url
        }),
        totalItems: Math.min(totalCount, 1000),
        entryPoint: (0, $eQdsc.confluencePagesPopupContentEntryPoint),
        entryPointParams: {},
        entryPointRuntimeProps: popupContentProps,
        showMoreTooltip: formatMessage((0, $43xuA.default).showMore),
        actionSubjectIdPrefix: "confluencePages",
        isTruncated: isTruncated
    });
};

});
parcelRegister("1DLZD", function(module, exports) {
$parcel$export(module.exports, "default", () => $184f8f8f5a3afcf8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<be9406e042814591ec1e62ed2c45e3d2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $184f8f8f5a3afcf8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "href"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                "kind": "LinkedField",
                "name": "confluenceRemoteIssueLinks",
                "plural": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "popupContent_issueFieldConfluencePagesReadviewFull"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    },
                    {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "pageContent",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ 
                                                        ],
                                                        "type": "JiraConfluencePageContentDetails"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
            }
        ],
        "type": "JiraConfluenceRemoteIssueLinksField"
    };
}();
$184f8f8f5a3afcf8$var$node.hash = "f3dfa170a3952ce8210f6278505d4948";
var $184f8f8f5a3afcf8$export$2e2bcd8739ae039 = $184f8f8f5a3afcf8$var$node;

});

parcelRegister("eQdsc", function(module, exports) {
$parcel$export(module.exports, "confluencePagesPopupContentEntryPoint", () => $4cc0ba0819c90cbd$export$a98f421071b5b6ae);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $4cc0ba0819c90cbd$export$a98f421071b5b6ae = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("bDyQX")), {
        moduleId: "5019f0bb",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bDyQX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bJbeT").then(()=>parcelRequire('4sxUW'));

});


parcelRegister("43xuA", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf8902fe0b4f33fd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $bf8902fe0b4f33fd$var$messages = (0, $7qGN1.defineMessages)({
    showMore: {
        "id": "confluence-pages-readview-full.ui.confluence-pages.show-more",
        "defaultMessage": "Show more"
    }
});
var $bf8902fe0b4f33fd$export$2e2bcd8739ae039 = $bf8902fe0b4f33fd$var$messages;

});




parcelRegister("1LuaS", function(module, exports) {
$parcel$export(module.exports, "NumberCell", () => $6740de3d0823c560$export$da27302eef6199ea);

var $lxHNU = parcelRequire("lxHNU");

var $7wihl = parcelRequire("7wihl");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $lgXDp = parcelRequire("lgXDp");

var $j8Km1 = parcelRequire("j8Km1");

var $7jVFI = parcelRequire("7jVFI");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $6740de3d0823c560$export$da27302eef6199ea = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $7wihl.default), fieldRef);
    const isSingleRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (data.isStoryPointField || data.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).STORY_POINT_ESTIMATE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7jVFI.StoryPointEstimateCell), {
        fieldRef: data,
        shouldRenderHoverPopover: isSingleRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6740de3d0823c560$var$NumberInlineEditCell, {
        fieldRef: data,
        isSingleRowHeightEnabled: isSingleRowHeightEnabled,
        isFirstField: isFirstField,
        hasDuplicates: hasDuplicates
    });
});
const $6740de3d0823c560$var$NumberInlineEditCell = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isSingleRowHeightEnabled: isSingleRowHeightEnabled, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $lxHNU.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isSingleRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgXDp.NumberInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $6740de3d0823c560$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isSingleRowHeightEnabled: isFirstField && isSingleRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgXDp.NumberInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isSingleRowHeightEnabled: isSingleRowHeightEnabled
    });
});
const $6740de3d0823c560$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $6740de3d0823c560$var$customTargetStyles : $6740de3d0823c560$var$customTargetStylesOld,
        ref: ref
    });
});
const $6740de3d0823c560$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $6740de3d0823c560$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("lxHNU", function(module, exports) {
$parcel$export(module.exports, "default", () => $52b2a0ffcbde106c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2ca9a2224428eaa8baab227f4b90a8db>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $52b2a0ffcbde106c$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "NumberCell_NumberInlineEditCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraNumberField"
};
$52b2a0ffcbde106c$var$node.hash = "96b1d6b4586ae0a1c65ffaf350a06694";
var $52b2a0ffcbde106c$export$2e2bcd8739ae039 = $52b2a0ffcbde106c$var$node;

});

parcelRegister("7wihl", function(module, exports) {
$parcel$export(module.exports, "default", () => $53090515bd061899$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d986ca8f0840593b87371d1db847fdf0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $53090515bd061899$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "NumberCell",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "NumberCell_NumberInlineEditCell"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "StoryPointEstimateCell"
            }
        ],
        "type": "JiraNumberField"
    };
}();
$53090515bd061899$var$node.hash = "c443aa487352d4791d3b2181e5622bfa";
var $53090515bd061899$export$2e2bcd8739ae039 = $53090515bd061899$var$node;

});

parcelRegister("lgXDp", function(module, exports) {
$parcel$export(module.exports, "NumberInlineEditViewWithIsEditable", () => $1cd2ec746a518e4f$export$96ce9815e2ea97b5);
$parcel$export(module.exports, "NumberInlineEditView", () => $1cd2ec746a518e4f$export$47665260b410f801);

var $O5cCR = parcelRequire("O5cCR");

var $3kjdd = parcelRequire("3kjdd");

var $cNaHV = parcelRequire("cNaHV");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $4EKqI = parcelRequire("4EKqI");

var $auNLL = parcelRequire("auNLL");

var $2Sipn = parcelRequire("2Sipn");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $bJscI = parcelRequire("bJscI");

var $wZ00q = parcelRequire("wZ00q");

var $g5wv4 = parcelRequire("g5wv4");
const $1cd2ec746a518e4f$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-number-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $1cd2ec746a518e4f$export$96ce9815e2ea97b5 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, editViewPopupWidth: editViewPopupWidth, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, isSingleRowHeightEnabled: isSingleRowHeightEnabled })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $cNaHV.default), fragmentRef);
    const { id: uniqueFieldId, fieldId: fieldId, name: fieldName, type: type, number: number, formatConfig: formatConfig } = data;
    const initialValue = (0, $4cTDP.fg)('frontier-currency-field-fix-percentage-storage') ? (0, $g5wv4.transformToUI)(number, formatConfig?.formatStyle) : number;
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $3kjdd.default));
    // #endregion
    // #region Common state
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const isFieldEditable = overriding.overrideIsEditable(isEditable ?? false);
    // #endregion
    // #region Handle new value
    const handleSubmit = (0, $eJOHy.useCallback)((newNumber, { onSuccess: onSuccess, onFail: onFail })=>{
        const tranformedNumber = (0, $4cTDP.fg)('frontier-currency-field-fix-percentage-storage') ? (0, $g5wv4.transformToServer)(newNumber, formatConfig?.formatStyle) : newNumber;
        onSubmit?.(tranformedNumber);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        number: tranformedNumber
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateNumberField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateNumberField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            number: tranformedNumber
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId,
        formatConfig?.formatStyle
    ]);
    const getFormatConfigAnalyticsAttributes = (0, $eJOHy.useCallback)(()=>formatConfig ? {
            formatStyle: formatConfig.formatStyle,
            formatUnit: formatConfig.formatUnit
        } : {}, [
        formatConfig
    ]);
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: {
            ...attributes,
            ...getFormatConfigAnalyticsAttributes()
        },
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        clipboardComponentType: 'numberNullable',
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue
    });
    const onChange = (0, $eJOHy.useCallback)((event)=>{
        const typedValue = event.target.value === '' ? null : parseFloat(Number(event.target.value).toFixed(3));
        handleChange(typedValue);
    }, [
        handleChange
    ]);
    // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1cd2ec746a518e4f$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $wZ00q.NumberReadView), {
            fragmentRef: data,
            isSingleRowHeightEnabled: isSingleRowHeightEnabled
        }));
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            label: fieldName,
            defaultValue: updatedValue,
            onChange: onChange,
            spacing: spacing
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $2Sipn.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hasReadViewTruncateDisabled: isSingleRowHeightEnabled
    });
};
const $1cd2ec746a518e4f$export$47665260b410f801 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $O5cCR.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1cd2ec746a518e4f$export$96ce9815e2ea97b5, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("O5cCR", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f727d944c5db456$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<400e2c417f56cd4032eb1b86f93266a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9f727d944c5db456$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraNumberField"
};
$9f727d944c5db456$var$node.hash = "4d2b6ae17d10a992ce5a5b82bfdc0179";
var $9f727d944c5db456$export$2e2bcd8739ae039 = $9f727d944c5db456$var$node;

});

parcelRegister("3kjdd", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcbf44ca8b42f415$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9eac824a5d526dbdcbe1b4f030e7c4b8>>
 * @relayHash bac56b5a15fe2bdd371f393834598764
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b9b5e7ad81080c3ef0caaf8a1945246c94639ab4dd9c2bfabbb0adde00cb670
const $dcbf44ca8b42f415$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraNumberFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateNumberField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraNumberField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "number_issueFieldNumber_NumberField_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "number_issueFieldNumber_NumberField_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "5b9b5e7ad81080c3ef0caaf8a1945246c94639ab4dd9c2bfabbb0adde00cb670",
            "metadata": {},
            "name": "number_issueFieldNumber_NumberField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$dcbf44ca8b42f415$var$node.hash = "229bc4c46fc83a0e7aaf848fb3a4b543";
var $dcbf44ca8b42f415$export$2e2bcd8739ae039 = $dcbf44ca8b42f415$var$node;

});

parcelRegister("cNaHV", function(module, exports) {
$parcel$export(module.exports, "default", () => $388735a65b991295$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<551dba2675f09b90c1ded9ed27d88d82>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $388735a65b991295$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "number_issueFieldNumberReadviewFull_NumberReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "JiraNumberFieldFormatConfig",
                    "kind": "LinkedField",
                    "name": "formatConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "formatStyle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "formatUnit"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNumberField"
};
$388735a65b991295$var$node.hash = "b1237a150436223d181b77d20b811582";
var $388735a65b991295$export$2e2bcd8739ae039 = $388735a65b991295$var$node;

});

parcelRegister("2Sipn", function(module, exports) {
$parcel$export(module.exports, "default", () => $386d161ba121aaff$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $386d161ba121aaff$var$NumberEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("dzH8P")), {
        moduleId: "ac3a36e0",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $386d161ba121aaff$export$2e2bcd8739ae039 = $386d161ba121aaff$var$NumberEditViewEntryPoint;

});
parcelRegister("dzH8P", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aq2De").then(()=>parcelRequire('70nnk'));

});


parcelRegister("wZ00q", function(module, exports) {
$parcel$export(module.exports, "NumberReadViewInner", () => $4a1db8e5c57729b2$export$6c68fbb587c0f1dd);
$parcel$export(module.exports, "NumberReadView", () => $4a1db8e5c57729b2$export$9267d0b69e52e344);

var $iGyDc = parcelRequire("iGyDc");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $1M2hR = parcelRequire("1M2hR");

var $d9T1A = parcelRequire("d9T1A");

var $g5wv4 = parcelRequire("g5wv4");

var $tYLUh = parcelRequire("tYLUh");

var $4cTDP = parcelRequire("4cTDP");

var $3OT15 = parcelRequire("3OT15");

var $kTUE3 = parcelRequire("kTUE3");
const $4a1db8e5c57729b2$export$6c68fbb587c0f1dd = ({ fieldData: fieldData, isSingleRowHeightEnabled: isSingleRowHeightEnabled = false, shouldTransformNumber: shouldTransformNumber = true })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $lRq8t.default)();
    const noValueTextExperiment = formatMessage((0, $kTUE3.default).noValueTextExperiment);
    const locale = (0, $1M2hR.useLocale)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const hoverPopoverRefFactory = isSingleRowHeightEnabled ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(fieldData.id) : null;
    let hoverPopoverRef = null;
    const { number: number, formatConfig: formatConfig } = fieldData;
    const tranformedNumber = shouldTransformNumber && (0, $4cTDP.fg)('frontier-currency-field-fix-percentage-storage') ? (0, $g5wv4.transformToUI)(number, formatConfig?.formatStyle) : number;
    const numberContent = formatConfig && formatConfig.formatStyle && (0, $4cTDP.fg)('frontier-currency-field-d1') ? (0, $g5wv4.formatNumberField)(tranformedNumber ?? 0, {
        formatStyle: formatConfig.formatStyle,
        formatUnit: formatConfig.formatUnit,
        locale: locale
    }) : formatNumber(number ?? 0);
    const children = number === null || number === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    }) : numberContent;
    if (isSingleRowHeightEnabled) {
        if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
            content: numberContent
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            testId: "issue-field-number-readview-full.ui.number.text",
            ref: hoverPopoverRef,
            maxLines: 1
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": "issue-field-number-readview-full.ui.number.span"
    }, children);
};
const $4a1db8e5c57729b2$export$9267d0b69e52e344 = ({ fragmentRef: fragmentRef, isSingleRowHeightEnabled: isSingleRowHeightEnabled = false })=>{
    const fieldData = (0, $j4oe4.useFragment)((0, $iGyDc.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4a1db8e5c57729b2$export$6c68fbb587c0f1dd, {
        fieldData: fieldData,
        isSingleRowHeightEnabled: isSingleRowHeightEnabled
    });
};

});
parcelRegister("iGyDc", function(module, exports) {
$parcel$export(module.exports, "default", () => $46757e07d35079d2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9c9269db8fc4813c06734d7aade16678>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $46757e07d35079d2$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "number_issueFieldNumberReadviewFull_NumberReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "JiraNumberFieldFormatConfig",
                    "kind": "LinkedField",
                    "name": "formatConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "formatStyle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "formatUnit"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNumberField"
};
$46757e07d35079d2$var$node.hash = "7678fb417f2cd4513c78086113294dc1";
var $46757e07d35079d2$export$2e2bcd8739ae039 = $46757e07d35079d2$var$node;

});

parcelRegister("g5wv4", function(module, exports) {
$parcel$export(module.exports, "formatDecimal", () => $9f3ef12a68cb7fc4$export$845857f28dc08744);
$parcel$export(module.exports, "formatNumberField", () => $9f3ef12a68cb7fc4$export$d390e3b8d1c21e01);
$parcel$export(module.exports, "transformToUI", () => $9f3ef12a68cb7fc4$export$ecbf259380af1f03);
$parcel$export(module.exports, "transformToServer", () => $9f3ef12a68cb7fc4$export$e7caeabf4d12f5b4);
$parcel$export(module.exports, "isSidebarFormatConfigEnabled", () => $9f3ef12a68cb7fc4$export$3c854a930069a447);
$parcel$export(module.exports, "formatConfigFromAggJiraNumberFieldFormatConfig", () => $9f3ef12a68cb7fc4$export$29f524126725ba4b);

var $4cTDP = parcelRequire("4cTDP");

/**
 * This is due to Jira commonly using the POSIX format (using '_' for defining locales),
 * such as in jira/src/packages/platform/supported-locales/src/supported-locales.tsx,
 * whereas the Intl Javascript API requires locales to be in the IETF BCP 47 format.
 */ const $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat = (locale)=>{
    return locale.replace('_', '-');
};
// Converts strings to lower case while also preventing string literal types from being converted
// into the more general `string` type as the String.prototype.toLowerCase() method always returns
// a `string` type, even if the string is a string literal. For example:
// const string = 'CONSTANT'; // type is `'CONSTANT'`;
// string.toLowerCase() // returned type is `string`;
// toLowerCase(string) // returned type is `'constant'`;
const $9f3ef12a68cb7fc4$var$toLowerCase = (inputString)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return inputString.toLocaleLowerCase();
};
const $9f3ef12a68cb7fc4$var$isSupportedCurrencyCode = (currencyCode)=>{
    // Check if the currency code is supported
    return Intl.supportedValuesOf($9f3ef12a68cb7fc4$var$toLowerCase((0, $7b3dcdbff4fbb09a$export$a82896da99871ba4))).includes(currencyCode);
};
const $9f3ef12a68cb7fc4$var$isSupportedUnit = (unit)=>{
    // Check if the unit is supported
    return Intl.supportedValuesOf($9f3ef12a68cb7fc4$var$toLowerCase((0, $7b3dcdbff4fbb09a$export$83551de9ca24925e))).includes(unit);
};
const $9f3ef12a68cb7fc4$export$3dc27271f5d5c629 = (amount, config = {})=>{
    const { currencyCode: currencyCode = (0, $7b3dcdbff4fbb09a$export$c852e1f5bb177898), locale: locale, currencyDisplay: currencyDisplay = (0, $7b3dcdbff4fbb09a$export$b9e50a64e0ca3437), ...rest } = config;
    // Check if the currency code is supported. fall back to decimal format if not.
    // @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
    const formatOptions = $9f3ef12a68cb7fc4$var$isSupportedCurrencyCode(currencyCode) ? {
        style: (0, $7b3dcdbff4fbb09a$export$a82896da99871ba4).toLocaleLowerCase(),
        currency: currencyCode,
        currencyDisplay: currencyDisplay,
        maximumFractionDigits: Number.isInteger(amount) ? 0 : undefined,
        ...rest
    } : {
        style: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...rest
    };
    const formatter = new Intl.NumberFormat(locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(locale), formatOptions);
    return formatter.format(amount ?? 0);
};
const $9f3ef12a68cb7fc4$export$32e6b1ae352e94d6 = (amount, config = {})=>{
    const { locale: locale, ...rest } = config;
    return new Intl.NumberFormat(locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(locale), {
        ...rest,
        // @ts-expect-error - TS2769 Typescript 5.9.2 upgrade
        style: (0, $7b3dcdbff4fbb09a$export$83551de9ca24925e).toLocaleLowerCase(),
        unit: (0, $7b3dcdbff4fbb09a$export$97f1ae291e87b4b2)
    }).format(amount ?? 0);
};
const $9f3ef12a68cb7fc4$export$bd39b96f71da1885 = (number, config = {})=>{
    const { unit: unit, locale: locale, ...rest } = config;
    // Check if the unit code is supported. fall back to decimal format if not.
    // @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
    const formatOptions = unit && $9f3ef12a68cb7fc4$var$isSupportedUnit(unit) ? {
        style: (0, $7b3dcdbff4fbb09a$export$83551de9ca24925e).toLocaleLowerCase(),
        unit: unit,
        ...rest
    } : {
        style: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...rest
    };
    const formatter = new Intl.NumberFormat(locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(locale), formatOptions);
    return formatter.format(number ?? 0);
};
const $9f3ef12a68cb7fc4$export$845857f28dc08744 = (number, config = {})=>{
    const formatter = new Intl.NumberFormat(config.locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(config.locale), {
        // @ts-expect-error - TS2769 Typescript 5.9.2 upgrade
        style: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...config
    });
    return formatter.format(number ?? 0);
};
const $9f3ef12a68cb7fc4$export$d390e3b8d1c21e01 = (number, config = {
    formatStyle: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea)
})=>{
    const { formatStyle: formatStyle, formatUnit: formatUnit, locale: locale } = config;
    switch(formatStyle){
        case 0, $7b3dcdbff4fbb09a$export$a82896da99871ba4:
            return formatUnit ? $9f3ef12a68cb7fc4$export$3dc27271f5d5c629(number, {
                locale: locale,
                currencyCode: formatUnit
            }) : $9f3ef12a68cb7fc4$export$845857f28dc08744(number, {
                locale: locale
            });
        case 0, $7b3dcdbff4fbb09a$export$e50c15d5408652a9:
            return $9f3ef12a68cb7fc4$export$32e6b1ae352e94d6(number, {
                locale: locale
            });
        case 0, $7b3dcdbff4fbb09a$export$83551de9ca24925e:
            return formatUnit ? $9f3ef12a68cb7fc4$export$bd39b96f71da1885(number, {
                locale: locale,
                unit: formatUnit
            }) : $9f3ef12a68cb7fc4$export$845857f28dc08744(number, {
                locale: locale
            });
        default:
            return $9f3ef12a68cb7fc4$export$845857f28dc08744(number);
    }
};
const $9f3ef12a68cb7fc4$export$ecbf259380af1f03 = (number, formatStyle = (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea))=>number && formatStyle === (0, $7b3dcdbff4fbb09a$export$e50c15d5408652a9) && (0, $4cTDP.fg)('frontier-currency-field-fix-percentage-storage') ? number * 100 : number;
const $9f3ef12a68cb7fc4$export$e7caeabf4d12f5b4 = (number, formatStyle = (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea))=>{
    if (!number || formatStyle !== (0, $7b3dcdbff4fbb09a$export$e50c15d5408652a9) || !(0, $4cTDP.fg)('frontier-currency-field-fix-percentage-storage')) return number;
    // Use Number.EPSILON to avoid floating-point precision issues
    const result = number / 100;
    const factor = Math.pow(10, 8); // 8 decimal places should be sufficient for percentage precision
    return Math.round((result + Number.EPSILON) * factor) / factor;
};
const $9f3ef12a68cb7fc4$export$3c854a930069a447 = ()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('frontier-currency-field-d1') && (0, $4cTDP.fg)('fields-settings-currency-field-display');
const $9f3ef12a68cb7fc4$var$formatStyleMapper = (jiraFormatStyle)=>{
    switch(jiraFormatStyle){
        case 'CURRENCY':
            return 0, $7b3dcdbff4fbb09a$export$a82896da99871ba4;
        case 'PERCENT':
            return 0, $7b3dcdbff4fbb09a$export$e50c15d5408652a9;
        case 'UNIT':
            return 0, $7b3dcdbff4fbb09a$export$83551de9ca24925e;
        default:
            return 0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea;
    }
};
const $9f3ef12a68cb7fc4$export$29f524126725ba4b = (gqlFormatConfig)=>{
    const { formatDecimals: formatDecimals, formatStyle: formatStyle, formatUnit: formatUnit } = gqlFormatConfig || {};
    return {
        formatStyle: $9f3ef12a68cb7fc4$var$formatStyleMapper(formatStyle),
        formatUnit: formatUnit || null,
        formatDecimals: formatDecimals ?? null
    };
};

});
const $7b3dcdbff4fbb09a$export$c852e1f5bb177898 = 'USD';
const $7b3dcdbff4fbb09a$export$b9e50a64e0ca3437 = 'narrowSymbol';
const $7b3dcdbff4fbb09a$export$768e3e8e60d01cea = 'DECIMAL';
const $7b3dcdbff4fbb09a$export$a82896da99871ba4 = 'CURRENCY';
const $7b3dcdbff4fbb09a$export$e50c15d5408652a9 = 'PERCENT';
const $7b3dcdbff4fbb09a$export$83551de9ca24925e = 'UNIT';
const $7b3dcdbff4fbb09a$export$e0f41b79f8d902b5 = 'liter';
const $7b3dcdbff4fbb09a$export$83a33c313ebf2c4a = 'meter';
const $7b3dcdbff4fbb09a$export$32fca264df3a7957 = 'kilogram';
const $7b3dcdbff4fbb09a$export$97f1ae291e87b4b2 = 'percent';


parcelRegister("kTUE3", function(module, exports) {
$parcel$export(module.exports, "default", () => $43ed06390f00aff2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $43ed06390f00aff2$var$messages = (0, $7qGN1.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-number-readview-full.number.no-value-text-experiment",
        "defaultMessage": "Add number"
    }
});
var $43ed06390f00aff2$export$2e2bcd8739ae039 = $43ed06390f00aff2$var$messages;

});



parcelRegister("7jVFI", function(module, exports) {
$parcel$export(module.exports, "StoryPointEstimateCell", () => $156da583d0db6981$export$78dcdef75b89353b);

var $25EjO = parcelRequire("25EjO");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $fzIah = parcelRequire("fzIah");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");
const $156da583d0db6981$export$78dcdef75b89353b = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $25EjO.default), fieldRef);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fzIah.StoryPointEstimateInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        shouldRenderHoverPopover: shouldRenderHoverPopover
    });
});

});
parcelRegister("25EjO", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8072dcd3849c891$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2149b1dfc06498a68625beb316ebd9b3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e8072dcd3849c891$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "StoryPointEstimateCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "storyPointEstimate_issueFieldStoryPointEstimateInlineEditFull_StoryPointEstimateInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraNumberField"
};
$e8072dcd3849c891$var$node.hash = "4d4b9859c9022b4f86ea1672efbdc156";
var $e8072dcd3849c891$export$2e2bcd8739ae039 = $e8072dcd3849c891$var$node;

});

parcelRegister("fzIah", function(module, exports) {
$parcel$export(module.exports, "StoryPointEstimateInlineEditViewIsEditable", () => $dcc00af3f4448d4a$export$d2c15e488724d3b6);
$parcel$export(module.exports, "StoryPointEstimateInlineEditView", () => $dcc00af3f4448d4a$export$53d82fd5560565fa);

var $1we48 = parcelRequire("1we48");

var $czuWu = parcelRequire("czuWu");

var $chVa1 = parcelRequire("chVa1");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $3bSs8 = parcelRequire("3bSs8");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $2Sipn = parcelRequire("2Sipn");

var $8DpUN = parcelRequire("8DpUN");

var $3mZMJ = parcelRequire("3mZMJ");

var $5dZy9 = parcelRequire("5dZy9");
const $dcc00af3f4448d4a$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-story-point-estimate-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $dcc00af3f4448d4a$export$d2c15e488724d3b6 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isFieldEditable, isEditing: startWithEditViewOpen, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, readViewFitContainerHeight: readViewFitContainerHeight, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $chVa1.default), fragmentRef);
    const { id: uniqueFieldId, type: type, name: fieldName, number: initialValue } = data;
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $czuWu.default));
    // #endregion
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const validator = (0, $5dZy9.useStoryPointEstimateValidator)();
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        number: value
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateNumberField) {
                    const { success: success, errors: responseErrors, field: field } = mutationData.jira.updateNumberField;
                    if (success && field != null) onSuccess();
                    else {
                        const errorMessage = responseErrors?.[0]?.message;
                        onFail(new Error(errorMessage || 'Relay error encountered while updating number field'), // Display server error message in flag if it exists
                        errorMessage ?? undefined);
                    }
                }
            },
            onError: (incomingError)=>{
                onFail(incomingError);
            },
            optimisticResponse: {
                jira: {
                    updateNumberField: {
                        success: true,
                        errors: [],
                        field: {
                            id: uniqueFieldId,
                            number: value != null ? value : null
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleChange: handleChange, handleConfirm: handleConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        clipboardComponentType: 'numberNullable',
        onSubmit: handleSubmit,
        onSubmitSucceeded: onSubmitSucceeded,
        onSubmitFailed: onSubmitFailed,
        onUpdateValue: setUpdatedValue,
        ...(0, $4cTDP.fg)('prevent-negative-story-point-estimate') ? {
            validator: validator
        } : {},
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        analyticsFieldType: (0, $3bSs8.FIELD_TYPE_MAP)[0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE]
    });
    const onChange = (0, $eJOHy.useCallback)((event)=>{
        const typedValue = event.target.value === '' ? null : parseFloat(Number(event.target.value).toFixed(3));
        handleChange(typedValue);
    }, [
        handleChange
    ]);
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dcc00af3f4448d4a$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8DpUN.StoryPointEstimateReadView), {
            fragmentRef: data,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        })), [
        data,
        shouldRenderHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            label: fieldName,
            defaultValue: updatedValue,
            isInvalid: invalidMessage != null || hasServerValidationError,
            onChange: onChange
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $2Sipn.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage ?? undefined,
        isEditable: isFieldEditable,
        isEditing: isEditing || hasServerValidationError,
        keepEditViewOpenOnBlur: hasServerValidationError,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView
    });
};
const $dcc00af3f4448d4a$export$53d82fd5560565fa = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $1we48.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dcc00af3f4448d4a$export$d2c15e488724d3b6, {
        ...props,
        fragmentRef: data,
        isEditable: data.isEditableInIssueView ?? false
    });
};

});
parcelRegister("1we48", function(module, exports) {
$parcel$export(module.exports, "default", () => $0440b45d97340edd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c5a0439ffc3e7985b2ffc49200c7c91a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0440b45d97340edd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "storyPointEstimate_issueFieldStoryPointEstimateInlineEditFull_StoryPointEstimateInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "storyPointEstimate_issueFieldStoryPointEstimateInlineEditFull_StoryPointEstimateInlineEditViewIsEditable_fragmentRef"
        },
        {
            "kind": "ScalarField",
            "name": "isEditableInIssueView"
        }
    ],
    "type": "JiraNumberField"
};
$0440b45d97340edd$var$node.hash = "e4b34a649ef5dd8533f5cabe75fe48a9";
var $0440b45d97340edd$export$2e2bcd8739ae039 = $0440b45d97340edd$var$node;

});

parcelRegister("czuWu", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b4185afa23f7722$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3848ab8ba84307c52100812d34d678eb>>
 * @relayHash d31d751b8d2df6b00dba2227445c1922
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 22c405c1466d19ac86bfc1ee91264decd40c73ed8fc34c324f886cba733f9321
const $9b4185afa23f7722$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraNumberFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateNumberField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraNumberField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "22c405c1466d19ac86bfc1ee91264decd40c73ed8fc34c324f886cba733f9321",
            "metadata": {},
            "name": "storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9b4185afa23f7722$var$node.hash = "cd8233b80d650588112eb0d15d581a9c";
var $9b4185afa23f7722$export$2e2bcd8739ae039 = $9b4185afa23f7722$var$node;

});

parcelRegister("chVa1", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a20a0d498483582$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<104e7a7c30e42c208fb29f3aec68910d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1a20a0d498483582$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "storyPointEstimate_issueFieldStoryPointEstimateInlineEditFull_StoryPointEstimateInlineEditViewIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        }
    ],
    "type": "JiraNumberField"
};
$1a20a0d498483582$var$node.hash = "c258cd7d5b4392c1e7419c5721e2a6cd";
var $1a20a0d498483582$export$2e2bcd8739ae039 = $1a20a0d498483582$var$node;

});

parcelRegister("8DpUN", function(module, exports) {
$parcel$export(module.exports, "StoryPointEstimateReadView", () => $0b1dd76fc20e2df8$export$29398521b1f444c1);

var $b4kDw = parcelRequire("b4kDw");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $7q9BG = parcelRequire("7q9BG");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $tYLUh = parcelRequire("tYLUh");

var $3OT15 = parcelRequire("3OT15");


var $dXaoD = parcelRequire("dXaoD");
const $0b1dd76fc20e2df8$export$29398521b1f444c1 = ({ fragmentRef: fragmentRef, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $lRq8t.default)();
    const noValueTextExperiment = formatMessage((0, $dXaoD.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const data = (0, $j4oe4.useFragment)((0, $b4kDw.default), fragmentRef);
    const { number: number } = data;
    const hoverPopoverRefFactory = shouldRenderHoverPopover ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (number === null || number === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": (0, $9449af9a14f793a7$export$d3d47c5f37010b20)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    }));
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: formatNumber(number)
    });
    if (shouldRenderHoverPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": (0, $9449af9a14f793a7$export$d3d47c5f37010b20)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0b1dd76fc20e2df8$var$BadgeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
        testId: (0, $9449af9a14f793a7$export$3804bd7641b5a138)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: 1,
        ref: hoverPopoverRef
    }, formatNumber(number)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": (0, $9449af9a14f793a7$export$d3d47c5f37010b20)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0b1dd76fc20e2df8$var$BadgeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
        testId: (0, $9449af9a14f793a7$export$3804bd7641b5a138)
    }, formatNumber(number))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $0b1dd76fc20e2df8$var$BadgeWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_189e1dm9 _1dqonqa1 _1h6d3acm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("b4kDw", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec30a71cd9e8aa88$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c402fb1fd95bc1e95b501749101ff8fc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ec30a71cd9e8aa88$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        }
    ],
    "type": "JiraNumberField"
};
$ec30a71cd9e8aa88$var$node.hash = "23757b8b917d47b2444d3b2414b283dc";
var $ec30a71cd9e8aa88$export$2e2bcd8739ae039 = $ec30a71cd9e8aa88$var$node;

});

const $9449af9a14f793a7$export$3804bd7641b5a138 = 'issue-field-story-point-estimate-readview-full.ui.story-point-estimate.badge';
const $9449af9a14f793a7$export$d3d47c5f37010b20 = 'issue-field-story-point-estimate-readview-full.ui.story-point-estimate';

parcelRegister("dXaoD", function(module, exports) {
$parcel$export(module.exports, "default", () => $0fde5f4779b82760$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0fde5f4779b82760$var$messages = (0, $7qGN1.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-story-point-estimate-readview-full.story-point-estimate.no-value-text-experiment",
        "defaultMessage": "Add story points"
    }
});
var $0fde5f4779b82760$export$2e2bcd8739ae039 = $0fde5f4779b82760$var$messages;

});


parcelRegister("5dZy9", function(module, exports) {
$parcel$export(module.exports, "useStoryPointEstimateValidator", () => $334b6283e068d76c$export$a7e5b5687078d1af);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $3buZW = parcelRequire("3buZW");
const $334b6283e068d76c$export$a7e5b5687078d1af = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const submit = (0, $eJOHy.useCallback)((value)=>{
        if (value && value < 0) return {
            type: 'error',
            message: formatMessage((0, $3buZW.default).popupStoryPointNonNegative)
        };
        return null;
    }, [
        formatMessage
    ]);
    return {
        submit: submit
    };
};

});
parcelRegister("3buZW", function(module, exports) {
$parcel$export(module.exports, "default", () => $d236167a8cb6c457$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d236167a8cb6c457$var$messages = (0, $7qGN1.defineMessages)({
    popupStoryPointNonNegative: {
        "id": "issue-field-story-point-estimate-inline-edit.story-point-estimate.tooltip-label",
        "defaultMessage": "Time for some positivity. Story point estimates can't be negative."
    }
});
var $d236167a8cb6c457$export$2e2bcd8739ae039 = $d236167a8cb6c457$var$messages;

});





parcelRegister("h0Klc", function(module, exports) {
$parcel$export(module.exports, "OriginalEstimateCell", () => $01cd2beefc732cd3$export$6ffde629399d0fd4);

var $aZ3Mu = parcelRequire("aZ3Mu");

var $e7zIS = parcelRequire("e7zIS");

var $9ZJUg = parcelRequire("9ZJUg");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4iyed = parcelRequire("4iyed");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");
const $01cd2beefc732cd3$var$OriginalEstimateCellOld = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    // NOTE: original estimate type is used to get timeTrackingField data, which is used in underlying original estimate decomposed field.
    const data = (0, $j4oe4.useFragment)((0, $9ZJUg.default), fieldRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($01cd2beefc732cd3$var$OriginalEstimateTimeTrackingFieldCell, {
        fieldRef: data.issue?.timeTrackingField ?? null,
        isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover,
        issueFieldId: data.id
    });
};
const $01cd2beefc732cd3$var$OriginalEstimateCellNew = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    // NOTE: original estimate type is used to get timeTrackingField data, which is used in underlying original estimate decomposed field.
    const data = (0, $j4oe4.useFragment)((0, $e7zIS.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = data && 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data?.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4iyed.OriginalEstimateInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data?.issue?.timeTrackingField ?? null,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        readViewFitContainerHeight: true,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled,
        issueFieldId: data.id
    });
};
const $01cd2beefc732cd3$export$6ffde629399d0fd4 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jira-original-estimate-editable-fix'), $01cd2beefc732cd3$var$OriginalEstimateCellNew, $01cd2beefc732cd3$var$OriginalEstimateCellOld);
const $01cd2beefc732cd3$var$OriginalEstimateTimeTrackingFieldCell = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover, issueFieldId: issueFieldId })=>{
    const data = (0, $j4oe4.useFragment)((0, $aZ3Mu.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = data && 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data?.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4iyed.OriginalEstimateInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data ?? null,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        readViewFitContainerHeight: true,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled,
        issueFieldId: issueFieldId
    });
};

});
parcelRegister("aZ3Mu", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1dbd7e93b45d061$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b466e5a5db03aca0b437cf003393dbba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a1dbd7e93b45d061$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraTimeTrackingField"
};
$a1dbd7e93b45d061$var$node.hash = "2c3d3c8f77186bb4daccfec9a1c84692";
var $a1dbd7e93b45d061$export$2e2bcd8739ae039 = $a1dbd7e93b45d061$var$node;

});

parcelRegister("e7zIS", function(module, exports) {
$parcel$export(module.exports, "default", () => $96983856ab9a3b1e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a9c32a1ff4f249d1666bc93ab756523>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $96983856ab9a3b1e$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "OriginalEstimateCell_OriginalEstimateCellNew",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraTimeTrackingField",
                    "kind": "LinkedField",
                    "name": "timeTrackingField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraOriginalTimeEstimateField"
};
$96983856ab9a3b1e$var$node.hash = "f32a8180d501ca136d5e15126610a012";
var $96983856ab9a3b1e$export$2e2bcd8739ae039 = $96983856ab9a3b1e$var$node;

});

parcelRegister("9ZJUg", function(module, exports) {
$parcel$export(module.exports, "default", () => $479323b263ddb55c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<117bc721eb645cd6ae76146e94bffd56>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $479323b263ddb55c$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "OriginalEstimateCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraTimeTrackingField",
                    "kind": "LinkedField",
                    "name": "timeTrackingField",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isInlineEditingEnabled",
                                    "variableName": "isInlineEditingEnabled"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraOriginalTimeEstimateField"
};
$479323b263ddb55c$var$node.hash = "6dac9d8940c4d8f0a9099192b46018ab";
var $479323b263ddb55c$export$2e2bcd8739ae039 = $479323b263ddb55c$var$node;

});

parcelRegister("4iyed", function(module, exports) {
$parcel$export(module.exports, "OriginalEstimateInlineEditViewIsEditable", () => $6630dfecd752d78e$export$6b7ba0cc8e5fd10);
$parcel$export(module.exports, "OriginalEstimateInlineEditView", () => $6630dfecd752d78e$export$63b1ca4384eabbd8);

var $49Pz6 = parcelRequire("49Pz6");

var $93b50 = parcelRequire("93b50");

var $1FzlC = parcelRequire("1FzlC");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $auNLL = parcelRequire("auNLL");

var $flcqE = parcelRequire("flcqE");

var $iz9K8 = parcelRequire("iz9K8");

var $bWfD9 = parcelRequire("bWfD9");

var $8T4lL = parcelRequire("8T4lL");

var $99gun = parcelRequire("99gun");

var $4s7iN = parcelRequire("4s7iN");

var $tYLUh = parcelRequire("tYLUh");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $gc7nM = parcelRequire("gc7nM");
const $6630dfecd752d78e$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-original-estimate-lite-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $6630dfecd752d78e$export$6b7ba0cc8e5fd10 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, spacing: spacing = 'compact', readViewFitContainerHeight: readViewFitContainerHeight, isEditable: isEditable, isEditing: startWithEditViewOpen, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, shouldRenderHoverPopover: shouldRenderHoverPopover, issueFieldId: issueFieldId })=>{
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $1FzlC.default), fragmentRef);
    const { id: uniqueFieldId = '', name: name = '', fieldId: fieldId = '', type: fieldType = '', originalEstimate: originalEstimate, timeTrackingSettings: timeTrackingSettings } = data || {};
    const { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultFormat: defaultFormat, defaultUnit: defaultUnit } = timeTrackingSettings ?? {};
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $93b50.default));
    // #endregion
    // #region Common state
    const settingsInput = {
        workingHoursPerDay: workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek,
        defaultFormat: defaultFormat,
        defaultUnit: defaultUnit
    };
    const formatInputValue = (0, $bWfD9.useFormatInputValue)(settingsInput);
    const initialValue = (0, $eJOHy.useMemo)(()=>originalEstimate ? formatInputValue(originalEstimate.timeInSeconds ?? 0) : '', [
        formatInputValue,
        originalEstimate
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const validator = (0, $gc7nM.useOriginalEstimateValidator)(settingsInput);
    const parseTimeString = (0, $8T4lL.useParseTimeString)(settingsInput);
    const { overriding: { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } } = (0, $auNLL.useInlineEditFieldInjections)();
    const fieldName = overrideLabel(name);
    const isFieldEditable = overrideIsEditable(isEditable);
    // #region Action
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        const timeInSeconds = parseTimeString(value) ?? 0;
        onSubmit?.(timeInSeconds);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    originalEstimate: {
                        timeInSeconds: timeInSeconds
                    }
                }
            },
            onCompleted: (response)=>{
                if (response.jira?.updateTimeTrackingField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateTimeTrackingField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            originalEstimate: {
                                timeInSeconds: timeInSeconds
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        parseTimeString,
        uniqueFieldId
    ]);
    const handleSubmitSucceeded = (0, $eJOHy.useCallback)((value)=>onSubmitSucceeded?.(parseTimeString(value) ?? 0), [
        onSubmitSucceeded,
        parseTimeString
    ]);
    const actions = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        updatedValue: updatedValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: handleSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        validator: validator,
        clipboardComponentType: 'originalEstimate'
    });
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = actions;
    // #region View
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6630dfecd752d78e$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $flcqE.OriginalEstimateReadView), {
            fragmentRef: data ?? null,
            shouldRenderHoverPopover: shouldRenderHoverPopover,
            issueFieldId: issueFieldId
        })), [
        data,
        shouldRenderHoverPopover,
        issueFieldId
    ]);
    const onChange = (0, $eJOHy.useCallback)((event)=>{
        handleChange(event.target.value);
    }, [
        handleChange
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            ...isExperimentEnabled ? {
                value: updatedValue === '0m' ? undefined : updatedValue
            } : {
                value: updatedValue
            },
            spacing: spacing,
            onChange: onChange,
            isInvalid: Boolean(invalidMessage)
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $iz9K8.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage ?? undefined,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView
    });
};
const $6630dfecd752d78e$export$63b1ca4384eabbd8 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $49Pz6.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6630dfecd752d78e$export$6b7ba0cc8e5fd10, {
        ...props,
        fragmentRef: data ?? null,
        isEditable: data?.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("49Pz6", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd17049d241522f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5335009b59f96bef1dbea7b79653d9c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cd17049d241522f8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraTimeTrackingField"
};
$cd17049d241522f8$var$node.hash = "7c668f5d814871c9f0ed4a8aa42dca72";
var $cd17049d241522f8$export$2e2bcd8739ae039 = $cd17049d241522f8$var$node;

});

parcelRegister("93b50", function(module, exports) {
$parcel$export(module.exports, "default", () => $5bdc70370e89904f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8633ab51539eb5964d048f1e02614494>>
 * @relayHash 2b9999c9f430b4dda72109599e853618
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 778533cd42b1035109f3872065d291e4f0d98dadaae1304d1ee064df84405593
const $5bdc70370e89904f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraTimeTrackingFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateTimeTrackingField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraTimeTrackingField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "concreteType": "JiraEstimate",
                                    "kind": "LinkedField",
                                    "name": "originalEstimate",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "timeInSeconds"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "originalEstimate_OriginalEstimateInlineEditViewIsEditable_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "originalEstimate_OriginalEstimateInlineEditViewIsEditable_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "778533cd42b1035109f3872065d291e4f0d98dadaae1304d1ee064df84405593",
            "metadata": {},
            "name": "originalEstimate_OriginalEstimateInlineEditViewIsEditable_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$5bdc70370e89904f$var$node.hash = "8e4396c085a50b830136e492ba97931f";
var $5bdc70370e89904f$export$2e2bcd8739ae039 = $5bdc70370e89904f$var$node;

});

parcelRegister("1FzlC", function(module, exports) {
$parcel$export(module.exports, "default", () => $67c4ec09032f48e6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<565704827e85cb165877ec877094e77b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $67c4ec09032f48e6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "originalEstimate_issueFieldOriginalEstimateReadviewFull_OriginalEstimateReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "concreteType": "JiraEstimate",
            "kind": "LinkedField",
            "name": "originalEstimate",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "timeInSeconds"
                }
            ]
        },
        {
            "concreteType": "JiraTimeTrackingSettings",
            "kind": "LinkedField",
            "name": "timeTrackingSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "workingHoursPerDay"
                },
                {
                    "kind": "ScalarField",
                    "name": "workingDaysPerWeek"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultFormat"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultUnit"
                }
            ]
        }
    ],
    "type": "JiraTimeTrackingField"
};
$67c4ec09032f48e6$var$node.hash = "9d4d77e9fb33d79699c085bd5ddf9412";
var $67c4ec09032f48e6$export$2e2bcd8739ae039 = $67c4ec09032f48e6$var$node;

});

parcelRegister("flcqE", function(module, exports) {
$parcel$export(module.exports, "OriginalEstimateReadView", () => $a23c3d9b42eb819c$export$9fbd5776dc81fee9);

var $dXL85 = parcelRequire("dXL85");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7q9BG = parcelRequire("7q9BG");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $tYLUh = parcelRequire("tYLUh");

var $d9T1A = parcelRequire("d9T1A");

var $3OT15 = parcelRequire("3OT15");

var $bWfD9 = parcelRequire("bWfD9");

var $9QjVb = parcelRequire("9QjVb");
const $a23c3d9b42eb819c$export$9fbd5776dc81fee9 = ({ fragmentRef: fragmentRef, shouldRenderHoverPopover: shouldRenderHoverPopover, issueFieldId: issueFieldId })=>{
    const data = (0, $j4oe4.useFragment)((0, $dXL85.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const noValueTextExperiment = formatMessage((0, $9QjVb.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const settingsInput = {
        workingHoursPerDay: data?.timeTrackingSettings?.workingHoursPerDay,
        workingDaysPerWeek: data?.timeTrackingSettings?.workingDaysPerWeek,
        defaultFormat: data?.timeTrackingSettings?.defaultFormat,
        defaultUnit: data?.timeTrackingSettings?.defaultUnit
    };
    const formatInputValue = (0, $bWfD9.useFormatInputValue)(settingsInput);
    const timeString = (0, $eJOHy.useMemo)(()=>data ? formatInputValue(data.originalEstimate?.timeInSeconds ?? 0) : null, [
        data,
        formatInputValue
    ]);
    const hoverPopoverContentRefFactory = shouldRenderHoverPopover ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(issueFieldId) : null;
    let hoverPopoverContentRef = null;
    if (hoverPopoverContentRefFactory) hoverPopoverContentRef = hoverPopoverContentRefFactory({
        content: timeString
    });
    if (!data?.originalEstimate?.timeInSeconds && isExperimentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: noValueTextExperiment
    });
    if (timeString === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if (shouldRenderHoverPopover) return(// Empty div to allow ellipsis
    // eslint-disable-next-line jira/react/no-empty-divs
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: 1,
        ref: hoverPopoverContentRef
    }, timeString))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), null, timeString);
};

});
parcelRegister("dXL85", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7763255467467c8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f139c9e4c74bf141b30d416189961e0a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f7763255467467c8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "originalEstimate_issueFieldOriginalEstimateReadviewFull_OriginalEstimateReadView",
    "selections": [
        {
            "concreteType": "JiraEstimate",
            "kind": "LinkedField",
            "name": "originalEstimate",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "timeInSeconds"
                }
            ]
        },
        {
            "concreteType": "JiraTimeTrackingSettings",
            "kind": "LinkedField",
            "name": "timeTrackingSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "workingHoursPerDay"
                },
                {
                    "kind": "ScalarField",
                    "name": "workingDaysPerWeek"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultFormat"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultUnit"
                }
            ]
        }
    ],
    "type": "JiraTimeTrackingField"
};
$f7763255467467c8$var$node.hash = "416ee9c2ca1a0709882a616f7a6e726b";
var $f7763255467467c8$export$2e2bcd8739ae039 = $f7763255467467c8$var$node;

});

parcelRegister("bWfD9", function(module, exports) {
$parcel$export(module.exports, "useFormatInputValue", () => $0d58d74844c77d4a$export$249a26bf47be0b0b);

var $eJOHy = parcelRequire("eJOHy");

var $kjvkS = parcelRequire("kjvkS");

var $lRq8t = parcelRequire("lRq8t");


var $5GvTs = parcelRequire("5GvTs");
const $0d58d74844c77d4a$var$toTimeFormat = (format)=>{
    return format ? (0, $5GvTs.toLowercaseTimeUnion)(format) : (0, $e1e7fb6a6c70503b$export$c4d2eaadfa3c28df);
};
const $0d58d74844c77d4a$var$toTimeUnit = (unit)=>{
    return unit ? (0, $5GvTs.toLowercaseTimeUnion)(unit) : (0, $e1e7fb6a6c70503b$export$2ee07242bbb09b61);
};
const $0d58d74844c77d4a$export$249a26bf47be0b0b = ({ workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultFormat: defaultFormat, defaultUnit: defaultUnit })=>{
    const intl = (0, $lRq8t.default)();
    return (0, $eJOHy.useCallback)((value)=>{
        return (0, $kjvkS.timeTrackingFormatter)(value, {
            workingHoursPerDay: workingHoursPerDay || (0, $e1e7fb6a6c70503b$export$8c7070611f332ef9),
            workingDaysPerWeek: workingDaysPerWeek || (0, $e1e7fb6a6c70503b$export$21ed1f454652d913),
            timeFormat: $0d58d74844c77d4a$var$toTimeFormat(defaultFormat),
            defaultUnit: $0d58d74844c77d4a$var$toTimeUnit(defaultUnit)
        }, intl);
    }, [
        workingHoursPerDay,
        workingDaysPerWeek,
        defaultFormat,
        defaultUnit,
        intl
    ]);
};

});
parcelRegister("kjvkS", function(module, exports) {
$parcel$export(module.exports, "timeTrackingFormatter", () => $9d0512273747699d$export$5169d8c8f9327e33);
$parcel$export(module.exports, "timeTrackingFormatterLongForm", () => $9d0512273747699d$export$bb4e82d8c2aeeff1);
$parcel$export(module.exports, "transformAGGToJiraTimeFormat", () => $9d0512273747699d$export$9dccd3a07969375d);
$parcel$export(module.exports, "transformAGGToJiraTimeUnit", () => $9d0512273747699d$export$8516173ab945b52f);

var $iYiee = parcelRequire("iYiee");

var $b7Ydn = parcelRequire("b7Ydn");

var $hjbuK = parcelRequire("hjbuK");
const $9d0512273747699d$var$validate = (condition)=>(distance)=>condition ? distance : 0;
// Format time to be 2 decimal places without trailing zeros
const $9d0512273747699d$var$timeFormatter = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
const $9d0512273747699d$var$timePrettyFormatter = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0${formatMessage(units[3].suffix)}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${formatMessage(unit.suffix)}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $9d0512273747699d$var$timePrettyFormatterLongForm = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0 ${formatMessage(units[3].suffix, {
        [units[3].type]: 0
    })}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const { suffix: suffix, type: type } = unit;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (currentTimeValue === 1) return {
            secondsRemaining: timeObj.secondsRemaining % unit.seconds,
            time: `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
                [type]: currentTimeValue
            })}`
        };
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
            [type]: currentTimeValue
        })}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $9d0512273747699d$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $iYiee.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $hjbuK.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $b7Ydn.default).timeUnitWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $iYiee.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $b7Ydn.default).timeUnitDay,
            transform: $9d0512273747699d$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $iYiee.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $b7Ydn.default).timeUnitHour,
            transform: $9d0512273747699d$var$validate(isTimeValid),
            seconds: (0, $iYiee.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $b7Ydn.default).timeUnitMinute,
            seconds: (0, $iYiee.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $iYiee.TimeFormats).DAYS:
            return $9d0512273747699d$var$timeFormatter(units[1].time, formatMessage(units[1].suffix));
        case (0, $iYiee.TimeFormats).HOURS:
            return $9d0512273747699d$var$timeFormatter(units[2].time, formatMessage(units[2].suffix));
        case (0, $iYiee.TimeFormats).PRETTY:
        default:
            return $9d0512273747699d$var$timePrettyFormatter(timeInSeconds, units, formatMessage);
    }
};
const $9d0512273747699d$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
    const timeTrackingSettings = {
        workingHoursPerDay: workingHoursPerDay || (0, $iYiee.defaultTimeTrackingOptions).workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek || (0, $iYiee.defaultTimeTrackingOptions).workingDaysPerWeek,
        timeFormat: timeFormat || (0, $iYiee.defaultTimeTrackingOptions).timeFormat,
        defaultUnit: (0, $iYiee.defaultTimeTrackingOptions).defaultUnit
    };
    return $9d0512273747699d$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
};
const $9d0512273747699d$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $iYiee.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $hjbuK.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $b7Ydn.default).timeUnitLongWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $iYiee.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $b7Ydn.default).timeUnitLongDay,
            transform: $9d0512273747699d$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $iYiee.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $b7Ydn.default).timeUnitLongHour,
            transform: $9d0512273747699d$var$validate(isTimeValid),
            seconds: (0, $iYiee.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $b7Ydn.default).timeUnitLongMinute,
            seconds: (0, $iYiee.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $iYiee.TimeFormats).DAYS:
            return $9d0512273747699d$var$timeFormatter(units[1].time, ` ${formatMessage(units[1].suffix, {
                day: units[1].time
            })}`);
        case (0, $iYiee.TimeFormats).HOURS:
            return $9d0512273747699d$var$timeFormatter(units[2].time, ` ${formatMessage(units[2].suffix, {
                hour: units[2].time
            })}`);
        case (0, $iYiee.TimeFormats).PRETTY:
        default:
            return $9d0512273747699d$var$timePrettyFormatterLongForm(timeInSeconds, units, formatMessage);
    }
};
const $9d0512273747699d$export$9dccd3a07969375d = (format)=>{
    switch(String(format).toLowerCase()){
        case (0, $iYiee.TimeFormats).DAYS:
            return (0, $iYiee.TimeFormats).DAYS;
        case (0, $iYiee.TimeFormats).HOURS:
            return (0, $iYiee.TimeFormats).HOURS;
        case (0, $iYiee.TimeFormats).PRETTY:
            return (0, $iYiee.TimeFormats).PRETTY;
        default:
            return (0, $iYiee.TimeFormats).DAYS;
    }
};
const $9d0512273747699d$export$8516173ab945b52f = (defaultUnit)=>{
    switch(String(defaultUnit).toLowerCase()){
        case (0, $iYiee.TimeUnits).DAY:
            return (0, $iYiee.TimeUnits).DAY;
        case (0, $iYiee.TimeUnits).HOUR:
            return (0, $iYiee.TimeUnits).HOUR;
        case (0, $iYiee.TimeUnits).MINUTE:
            return (0, $iYiee.TimeUnits).MINUTE;
        case (0, $iYiee.TimeUnits).WEEK:
            return (0, $iYiee.TimeUnits).WEEK;
        default:
            return (0, $iYiee.TimeUnits).DAY;
    }
};

});
parcelRegister("iYiee", function(module, exports) {
$parcel$export(module.exports, "SECONDS_PER_MINUTE", () => $8c530bce5cc29340$export$544c576050746347);
$parcel$export(module.exports, "SECONDS_PER_HOUR", () => $8c530bce5cc29340$export$3cc7ae4b390f50a);
$parcel$export(module.exports, "TimeFormats", () => $8c530bce5cc29340$export$5d7ed58d46354b1);
$parcel$export(module.exports, "TimeUnits", () => $8c530bce5cc29340$export$5d7753c8ad881494);
$parcel$export(module.exports, "defaultTimeTrackingOptions", () => $8c530bce5cc29340$export$f8d48c1fed813e90);
const $8c530bce5cc29340$export$544c576050746347 = 60;
const $8c530bce5cc29340$var$MINUTES_PER_HOUR = 60;
const $8c530bce5cc29340$export$3cc7ae4b390f50a = $8c530bce5cc29340$var$MINUTES_PER_HOUR * $8c530bce5cc29340$export$544c576050746347;
const $8c530bce5cc29340$var$TIME_FORMAT_PRETTY = 'pretty';
const $8c530bce5cc29340$var$TIME_FORMAT_DAYS = 'days';
const $8c530bce5cc29340$var$TIME_FORMAT_HOURS = 'hours';
const $8c530bce5cc29340$export$5d7ed58d46354b1 = Object.freeze({
    PRETTY: $8c530bce5cc29340$var$TIME_FORMAT_PRETTY,
    DAYS: $8c530bce5cc29340$var$TIME_FORMAT_DAYS,
    HOURS: $8c530bce5cc29340$var$TIME_FORMAT_HOURS
});
const $8c530bce5cc29340$var$TIME_UNIT_WEEK = 'week';
const $8c530bce5cc29340$var$TIME_UNIT_DAY = 'day';
const $8c530bce5cc29340$var$TIME_UNIT_HOUR = 'hour';
const $8c530bce5cc29340$var$TIME_UNIT_MINUTE = 'minute';
const $8c530bce5cc29340$export$5d7753c8ad881494 = Object.freeze({
    WEEK: $8c530bce5cc29340$var$TIME_UNIT_WEEK,
    DAY: $8c530bce5cc29340$var$TIME_UNIT_DAY,
    HOUR: $8c530bce5cc29340$var$TIME_UNIT_HOUR,
    MINUTE: $8c530bce5cc29340$var$TIME_UNIT_MINUTE
});
const $8c530bce5cc29340$export$f8d48c1fed813e90 = {
    workingHoursPerDay: 8,
    workingDaysPerWeek: 5,
    timeFormat: $8c530bce5cc29340$export$5d7ed58d46354b1.PRETTY,
    defaultUnit: $8c530bce5cc29340$export$5d7753c8ad881494.MINUTE
};

});

parcelRegister("b7Ydn", function(module, exports) {
$parcel$export(module.exports, "default", () => $01af1416d2d590d9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $01af1416d2d590d9$var$messages = (0, $7qGN1.defineMessages)({
    timeUnitWeek: {
        "id": "time-tracking-formatter.time-unit-week",
        "defaultMessage": "w"
    },
    timeUnitDay: {
        "id": "time-tracking-formatter.time-unit-day",
        "defaultMessage": "d"
    },
    timeUnitHour: {
        "id": "time-tracking-formatter.time-unit-hour",
        "defaultMessage": "h"
    },
    timeUnitMinute: {
        "id": "time-tracking-formatter.time-unit-minute",
        "defaultMessage": "m"
    },
    timeUnitLongWeek: {
        "id": "time-tracking-formatter.time-unit-long-week",
        "defaultMessage": "{week, plural, zero {weeks} one {week} other {weeks} }"
    },
    timeUnitLongDay: {
        "id": "time-tracking-formatter.time-unit-long-day",
        "defaultMessage": "{day, plural, zero {days} one {day} other {days} }"
    },
    timeUnitLongHour: {
        "id": "time-tracking-formatter.time-unit-long-hour",
        "defaultMessage": "{hour, plural, zero {hours} one {hour} other {hours} }"
    },
    timeUnitLongMinute: {
        "id": "time-tracking-formatter.time-unit-long-minute",
        "defaultMessage": "{minute, plural, zero {minutes} one {minute} other {minutes} }"
    }
});
var $01af1416d2d590d9$export$2e2bcd8739ae039 = $01af1416d2d590d9$var$messages;

});

parcelRegister("hjbuK", function(module, exports) {
$parcel$export(module.exports, "createUnit", () => $df66d7a8dfc617f8$export$aab44654646f3ccc);
const $df66d7a8dfc617f8$export$aab44654646f3ccc = (timeInSeconds)=>({ suffix: suffix, seconds: seconds, type: type, transform: transform })=>{
        const distance = timeInSeconds / seconds;
        const time = transform ? transform(distance) : distance;
        return {
            seconds: seconds,
            suffix: suffix,
            time: time,
            type: type
        };
    };

});


const $e1e7fb6a6c70503b$export$8c7070611f332ef9 = 8;
const $e1e7fb6a6c70503b$export$21ed1f454652d913 = 5;
const $e1e7fb6a6c70503b$export$c4d2eaadfa3c28df = 'pretty';
const $e1e7fb6a6c70503b$export$2ee07242bbb09b61 = 'minute';

parcelRegister("5GvTs", function(module, exports) {
$parcel$export(module.exports, "toLowercaseTimeUnion", () => $2643f7fbf3114189$export$72046bdd228710d3);
// Exclude union value automatically added by Relay
// eslint-disable-next-line @atlassian/relay/no-future-added-value
const $2643f7fbf3114189$export$72046bdd228710d3 = (union)=>union.toLowerCase();

});


parcelRegister("9QjVb", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a5a4811371f334c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0a5a4811371f334c$var$messages = (0, $7qGN1.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-original-estimate-readview-full.original-estimate.no-value-text-experiment",
        "defaultMessage": "Add estimate"
    }
});
var $0a5a4811371f334c$export$2e2bcd8739ae039 = $0a5a4811371f334c$var$messages;

});


parcelRegister("iz9K8", function(module, exports) {
$parcel$export(module.exports, "default", () => $309767fda67bd6c2$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $309767fda67bd6c2$var$OriginalEstimateEditViewWithFormattedValueEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("jMxUj")), {
        moduleId: "78b5a554",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $309767fda67bd6c2$export$2e2bcd8739ae039 = $309767fda67bd6c2$var$OriginalEstimateEditViewWithFormattedValueEntryPoint;

});
parcelRegister("jMxUj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("74Sbn").then(()=>parcelRequire('fCAPY'));

});


parcelRegister("8T4lL", function(module, exports) {
$parcel$export(module.exports, "useValidateTimeString", () => $ffea187516977204$export$27badca43bbaa0e);
$parcel$export(module.exports, "useParseTimeString", () => $ffea187516977204$export$a1109322d92e0ba8);

var $eJOHy = parcelRequire("eJOHy");

var $169bb = parcelRequire("169bb");


var $5GvTs = parcelRequire("5GvTs");
const $ffea187516977204$var$toTimeFormat = (format)=>{
    return format ? (0, $5GvTs.toLowercaseTimeUnion)(format) : (0, $e1e7fb6a6c70503b$export$c4d2eaadfa3c28df);
};
const $ffea187516977204$var$toTimeUnit = (unit)=>{
    return unit ? (0, $5GvTs.toLowercaseTimeUnion)(unit) : (0, $e1e7fb6a6c70503b$export$2ee07242bbb09b61);
};
const $ffea187516977204$var$useTimeTrackingParsingConfig = ({ workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultFormat: defaultFormat, defaultUnit: defaultUnit })=>{
    return (0, $eJOHy.useMemo)(()=>({
            hoursPerDay: workingHoursPerDay || (0, $e1e7fb6a6c70503b$export$8c7070611f332ef9),
            daysPerWeek: workingDaysPerWeek || (0, $e1e7fb6a6c70503b$export$21ed1f454652d913),
            format: $ffea187516977204$var$toTimeFormat(defaultFormat),
            defaultUnit: $ffea187516977204$var$toTimeUnit(defaultUnit),
            isTimeTrackingEnabled: true
        }), [
        defaultFormat,
        defaultUnit,
        workingDaysPerWeek,
        workingHoursPerDay
    ]);
};
const $ffea187516977204$export$27badca43bbaa0e = (input)=>{
    const config = $ffea187516977204$var$useTimeTrackingParsingConfig(input);
    return (0, $eJOHy.useMemo)(()=>(0, $169bb.isValidTimeString)(config), [
        config
    ]);
};
const $ffea187516977204$export$a1109322d92e0ba8 = (input)=>{
    const config = $ffea187516977204$var$useTimeTrackingParsingConfig(input);
    return (0, $eJOHy.useMemo)(()=>(0, $169bb.parseTimeString)(config), [
        config
    ]);
};

});
parcelRegister("169bb", function(module, exports) {
$parcel$export(module.exports, "formatTimeString", () => $711aadf76714c8f0$export$2de90790c3ad23b1);
$parcel$export(module.exports, "isValidTimeString", () => $711aadf76714c8f0$export$669626963db3b187);
$parcel$export(module.exports, "parseTimeString", () => $711aadf76714c8f0$export$53148bfa4e677363);

var $1CwHR = parcelRequire("1CwHR");

var $bjCt4 = parcelRequire("bjCt4");

var $zOoy2 = parcelRequire("zOoy2");

var $5iJeL = parcelRequire("5iJeL");

const $711aadf76714c8f0$var$isNumeric = (num)=>num.length > 0 && !Number.isNaN(Number(num));
const $711aadf76714c8f0$export$2de90790c3ad23b1 = (config)=>(timeValue)=>(0, $bjCt4.default)(config.daysPerWeek, config.hoursPerDay)(timeValue || 0);
const $711aadf76714c8f0$var$appendTimeUnitIfMissing = (config)=>(value)=>{
        let trimmedValue = value.trim();
        // If user doesn't type the valid format (m, h, d, or w), use default unit format set in the configuration.
        const isValidNumber = $711aadf76714c8f0$var$isNumeric(trimmedValue.replaceAll(',', '.'));
        if (isValidNumber) {
            const { defaultUnit: defaultUnit } = config;
            trimmedValue = `${trimmedValue}${(0, $5iJeL.getDefaultTimeTrackingUnit)(defaultUnit)}`;
        }
        return trimmedValue;
    };
const $711aadf76714c8f0$export$669626963db3b187 = (config)=>(value)=>{
        const timeString = $711aadf76714c8f0$var$appendTimeUnitIfMissing(config)(value);
        return timeString === '' || (0, $1CwHR.default)(timeString);
    };
const $711aadf76714c8f0$export$53148bfa4e677363 = (config)=>(value)=>{
        const timeString = $711aadf76714c8f0$var$appendTimeUnitIfMissing(config)(value);
        if (!$711aadf76714c8f0$export$669626963db3b187(config)(timeString)) return 0;
        return (0, $zOoy2.default)(config.daysPerWeek, config.hoursPerDay)(timeString);
    };

});
parcelRegister("1CwHR", function(module, exports) {
$parcel$export(module.exports, "default", () => $719ef9dc390c2db4$export$2e2bcd8739ae039);

var $eRPqr = parcelRequire("eRPqr");

var $zOoy2 = parcelRequire("zOoy2");
const $719ef9dc390c2db4$var$isTimeStringValid = (timeString)=>{
    // We don't care about daysPerWeek or hoursPerDay - we only need to test that the value can be parsed.
    const result = (0, $zOoy2.default)(1, 1)(timeString);
    return result !== null && (0, (/*@__PURE__*/$parcel$interopDefault($eRPqr)))(result);
};
var $719ef9dc390c2db4$export$2e2bcd8739ae039 = $719ef9dc390c2db4$var$isTimeStringValid;

});
parcelRegister("eRPqr", function(module, exports) {

var $NROo8 = parcelRequire("NROo8");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ad2de7eeaba7a4ae$var$nativeIsFinite = $NROo8.isFinite;
/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */ function $ad2de7eeaba7a4ae$var$isFinite(value) {
    return typeof value == 'number' && $ad2de7eeaba7a4ae$var$nativeIsFinite(value);
}
module.exports = $ad2de7eeaba7a4ae$var$isFinite;

});

parcelRegister("zOoy2", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ff316664bfdacf2$export$2e2bcd8739ae039);
const $5ff316664bfdacf2$var$MINUTES_PER_HOUR = 60;
const $5ff316664bfdacf2$var$SECONDS_PER_MINUTE = 60;
// Supports both '.' and ',' as decimal separators
const $5ff316664bfdacf2$var$UNIT_STRING_PATTERN = /^(\d+(?:[.,]\d+)?)([wdhm])$/;
const $5ff316664bfdacf2$var$convertToUnitQuantity = (rawString)=>{
    const matches = $5ff316664bfdacf2$var$UNIT_STRING_PATTERN.exec(rawString);
    if (!matches) return null;
    // Replace comma with a period for evaluating arithmetic decimal
    const normalizedQuantity = matches[1].replaceAll(',', '.');
    return {
        quantity: parseFloat(normalizedQuantity),
        unit: matches[2]
    };
};
const $5ff316664bfdacf2$var$timeStringToSeconds = (daysPerWeek, hoursPerDay)=>{
    const unitDefinitions = [
        {
            unit: 'w',
            seconds: daysPerWeek * hoursPerDay * $5ff316664bfdacf2$var$MINUTES_PER_HOUR * $5ff316664bfdacf2$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'd',
            seconds: hoursPerDay * $5ff316664bfdacf2$var$MINUTES_PER_HOUR * $5ff316664bfdacf2$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'h',
            seconds: $5ff316664bfdacf2$var$MINUTES_PER_HOUR * $5ff316664bfdacf2$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'm',
            seconds: $5ff316664bfdacf2$var$SECONDS_PER_MINUTE
        }
    ];
    return (timeString)=>{
        // Split up the time string, and parse it into an array of UnitQuantities.
        const unitQuantities = timeString.split(' ').map($5ff316664bfdacf2$var$convertToUnitQuantity);
        let quantitiesConsumed = 0;
        let seconds = 0;
        for(let i = 0; i < unitDefinitions.length; i += 1){
            // If we have consumed all the quantity-unit pairs in the string
            // we are done.
            if (quantitiesConsumed === unitQuantities.length) break;
            const unitDefinition = unitDefinitions[i];
            const unitQuantity = unitQuantities[quantitiesConsumed];
            if (!unitQuantity) return null;
            // If the quantity-unit pair matches the unit definition we are up to, consume it.
            if (unitQuantity.unit === unitDefinition.unit) {
                seconds += unitQuantity.quantity * unitDefinition.seconds;
                quantitiesConsumed += 1;
            }
        }
        // We have made it through all the unit definitions, but there is still some left-over input
        if (quantitiesConsumed < unitQuantities.length) return null;
        return Math.floor(seconds);
    };
};
var $5ff316664bfdacf2$export$2e2bcd8739ae039 = $5ff316664bfdacf2$var$timeStringToSeconds;

});


parcelRegister("bjCt4", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b110ba771aff996$export$2e2bcd8739ae039);
const $1b110ba771aff996$var$MINUTES_PER_HOUR = 60;
const $1b110ba771aff996$var$SECONDS_PER_MINUTE = 60;
const $1b110ba771aff996$var$secondsToTimeString = (daysPerWeek, hoursPerDay)=>{
    const units = [
        {
            suffix: 'w',
            seconds: daysPerWeek * hoursPerDay * $1b110ba771aff996$var$MINUTES_PER_HOUR * $1b110ba771aff996$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'd',
            seconds: hoursPerDay * $1b110ba771aff996$var$MINUTES_PER_HOUR * $1b110ba771aff996$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'h',
            seconds: $1b110ba771aff996$var$MINUTES_PER_HOUR * $1b110ba771aff996$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'm',
            seconds: $1b110ba771aff996$var$SECONDS_PER_MINUTE
        }
    ];
    return (seconds)=>{
        const initial = {
            secondsRemaining: seconds,
            timeString: ''
        };
        const result = units.reduce((acc, unit)=>{
            // Skip this unit if it doesn't have a valid number of seconds
            if (unit.seconds <= 0) return acc;
            const numUnits = Math.floor(acc.secondsRemaining / unit.seconds);
            const updatedSecondsRemaining = numUnits >= 1 ? acc.secondsRemaining % unit.seconds : acc.secondsRemaining;
            const updatedTimeString = numUnits >= 1 ? `${acc.timeString} ${numUnits}${unit.suffix}` : acc.timeString;
            return {
                secondsRemaining: updatedSecondsRemaining,
                timeString: updatedTimeString
            };
        }, initial);
        return result.timeString.trim() || '0m';
    };
};
var $1b110ba771aff996$export$2e2bcd8739ae039 = $1b110ba771aff996$var$secondsToTimeString;

});

parcelRegister("5iJeL", function(module, exports) {
$parcel$export(module.exports, "getDefaultTimeTrackingUnit", () => $4a595c55416867fe$export$2b38dfc7401492ba);
// This is required to map the default time-tracking unit coming from the server (gira endpoint BENTO: 3334) to client
const $4a595c55416867fe$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT = {
    minute: 'm',
    hour: 'h',
    day: 'd',
    week: 'w'
};
const $4a595c55416867fe$export$2b38dfc7401492ba = (serverDefaultUnit)=>$4a595c55416867fe$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT[serverDefaultUnit] || $4a595c55416867fe$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT.minute;

});



parcelRegister("gc7nM", function(module, exports) {
$parcel$export(module.exports, "useOriginalEstimateValidator", () => $dff13978bd5b469e$export$339bd53893728f75);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $8T4lL = parcelRequire("8T4lL");

var $9EIWa = parcelRequire("9EIWa");
const $dff13978bd5b469e$export$339bd53893728f75 = (settingsInput)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const validate = (0, $8T4lL.useValidateTimeString)(settingsInput);
    const submit = (0, $eJOHy.useCallback)((value)=>{
        if (!validate(value)) return {
            type: 'error',
            message: formatMessage((0, $9EIWa.default).invalidInput)
        };
        return null;
    }, [
        formatMessage,
        validate
    ]);
    return {
        submit: submit
    };
};

});
parcelRegister("9EIWa", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8f021f33e8707aa$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f8f021f33e8707aa$var$messages = (0, $7qGN1.defineMessages)({
    invalidInput: {
        "id": "issue-field-original-estimate-inline-edit-full.original-estimate.invalid-input",
        "defaultMessage": "Your estimate must be in the format 2w 4d 6h 45m"
    }
});
var $f8f021f33e8707aa$export$2e2bcd8739ae039 = $f8f021f33e8707aa$var$messages;

});




parcelRegister("8lV7c", function(module, exports) {
$parcel$export(module.exports, "ParentCell", () => $4e88c77e2d329c18$export$d5a4cc78f8c5a2cd);

var $h7NdD = parcelRequire("h7NdD");

var $5m34R = parcelRequire("5m34R");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $4cTDP = parcelRequire("4cTDP");

var $11Y63 = parcelRequire("11Y63");

var $kDaaB = parcelRequire("kDaaB");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");

var $e0p2q = parcelRequire("e0p2q");
const $4e88c77e2d329c18$export$d5a4cc78f8c5a2cd = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, fieldType: fieldType = '', isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $5m34R.default), fieldRef);
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    /**
   * As part of the initiative to remove "Epic Link" and "Parent Link" fields from Jira,
   * we're rendering a "Replaced by Parent field" deprecation message in the "Parent Link" cell.
   * At the time of writing this comment, "Parent Link" is still used in ~1% of issue tables, and
   * we hope this message will help these users migrate and use the "Parent" field from now on.
   */ if (// eslint-disable-next-line jira/ff/no-preconditioning
    fieldType === 'com.atlassian.jpo:jpo-custom-field-parent' && (0, $4cTDP.fg)('replace-epic-parent-link-by-depreca-message-in-nin') && !(0, $4cTDP.fg)('jsc_fix_parent_cell_hooks_violation')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "span",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $e0p2q.default).replacedByParentField,
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                    as: "strong"
                }, chunks)
        }
    }));
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const inlineEditData = (0, $j4oe4.useFragment)((0, $h7NdD.default), data);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in inlineEditData && isInlineEditingExtendedFieldSupportEnabled ? inlineEditData.lazyIsEditableInIssueView : false;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eqbO4.useLazyLoadEditability)(inlineEditData.id, isEditable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $11Y63.ParentInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: inlineEditData,
        isTruncated: !isDensityFull || isSingleLineRowHeightEnabled,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        // Render an empty string when there is no parent and experiment is off to mimic FG off state
        emptyText: isInlineEditingExtendedFieldSupportEnabled ? undefined : '',
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled && !isReadOnlyWithoutHoverPopover
    });
});

});
parcelRegister("h7NdD", function(module, exports) {
$parcel$export(module.exports, "default", () => $f96908ece778202a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c1ff37455ed7e6adaa0c227f659e8d9f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f96908ece778202a$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "ParentCell_inlineEdit",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraParentIssueField"
};
$f96908ece778202a$var$node.hash = "ecb8ee006ef4291f9ce69e0f497da89c";
var $f96908ece778202a$export$2e2bcd8739ae039 = $f96908ece778202a$var$node;

});

parcelRegister("5m34R", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e51d6ce4825e2ec$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fa36fd9f05080dd53ed68b0e6a9e400e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4e51d6ce4825e2ec$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "ParentCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "ParentCell_inlineEdit"
        }
    ],
    "type": "JiraParentIssueField"
};
$4e51d6ce4825e2ec$var$node.hash = "8db06abab86f044a74a0380e75e7b907";
var $4e51d6ce4825e2ec$export$2e2bcd8739ae039 = $4e51d6ce4825e2ec$var$node;

});

parcelRegister("11Y63", function(module, exports) {
$parcel$export(module.exports, "ParentInlineEditViewIsEditable", () => $088da67924e4d7a9$export$ed7c5b45ec99cbc3);
$parcel$export(module.exports, "ParentInlineEditView", () => $088da67924e4d7a9$export$536c9a0501611e73);

var $cXkxq = parcelRequire("cXkxq");

var $8SqIE = parcelRequire("8SqIE");

var $hmLUp = parcelRequire("hmLUp");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $h6i8k = parcelRequire("h6i8k");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $d2AGn = parcelRequire("d2AGn");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $8MKsY = parcelRequire("8MKsY");

var $bARvQ = parcelRequire("bARvQ");

var $dSKax = parcelRequire("dSKax");

var $fkc6h = parcelRequire("fkc6h");

var $kev0f = parcelRequire("kev0f");
const $088da67924e4d7a9$var$isEqualParent = (a, b)=>a?.value === b?.value;
const $088da67924e4d7a9$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-parent-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $088da67924e4d7a9$export$ed7c5b45ec99cbc3 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, isTruncated: isTruncated, spacing: spacing = 'compact', emptyText: emptyText, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $hmLUp.default), fragmentRef);
    const { enrichCommitWithIssueExperienceMonitoring: enrichCommitWithIssueExperienceMonitoring } = (0, $fkc6h.useIssueExperienceMonitoring)();
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name } = data;
    const fieldName = overriding.overrideLabel(name);
    const isFieldEditable = overriding?.overrideIsEditable(isEditable);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $8SqIE.default));
    // #endregion
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (data?.parentIssue) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $bARvQ.transformParentNode)(data.parentIssue);
        return null;
    }, [
        data.parentIssue
    ]);
    // #region Common state
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        (0, $h6i8k.default)('issue.field.parent.edit');
        onSubmit?.((0, $kev0f.transformOptionToAgg)(option));
        commit(enrichCommitWithIssueExperienceMonitoring({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: option?.value?.toString() || null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateParentField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateParentField: {
                        success: true,
                        errors: [],
                        field: (0, $kev0f.transformOptionToOptimisticFieldResponse)(data, option?.aggValue)
                    }
                }
            }
        }, 'parent_issueFieldParent_ParentField_Mutation', {
            sendUFOEvent: true
        }));
    }, [
        onSubmit,
        commit,
        uniqueFieldId,
        data,
        enrichCommitWithIssueExperienceMonitoring
    ]);
    const handleSubmitSucceeded = (0, $eJOHy.useCallback)((option)=>{
        onSubmitSucceeded?.((0, $kev0f.transformOptionToAgg)(option));
    }, [
        onSubmitSucceeded
    ]);
    const setAnalyticsAttributes = (0, $eJOHy.useCallback)((value)=>{
        if (initialValue !== value) {
            const oldValId = initialValue?.issueId;
            const newValId = value?.issueId || null;
            (0, $d2AGn.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, oldValId, newValId);
        }
    }, [
        fieldId,
        initialValue
    ]);
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $088da67924e4d7a9$var$isEqualParent,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: handleSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        setAnalyticsAttributes: setAnalyticsAttributes,
        clipboardComponentType: 'parent'
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($088da67924e4d7a9$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dSKax.ParentReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            emptyText: emptyText,
            isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
        })), [
        data,
        isTruncated,
        emptyText,
        isSingleLineRowHeightEnabled
    ]);
    const getEditViewProps = (0, $eJOHy.useCallback)((fieldProps)=>({
            ...fieldProps,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            menuIsOpen: true,
            spacing: spacing
        }), [
        fieldName,
        handleChangeAndConfirm,
        menuPosition,
        menuPortalTarget,
        uniqueFieldId,
        updatedValue,
        spacing
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $8MKsY.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled
    });
};
const $088da67924e4d7a9$export$536c9a0501611e73 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $cXkxq.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($088da67924e4d7a9$export$ed7c5b45ec99cbc3, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("cXkxq", function(module, exports) {
$parcel$export(module.exports, "default", () => $e188389412905ca3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d698883de3c28ee2d0fd655b48eeea5a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e188389412905ca3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraParentIssueField"
};
$e188389412905ca3$var$node.hash = "935d17179ef6e93f2b74d57828fd1128";
var $e188389412905ca3$export$2e2bcd8739ae039 = $e188389412905ca3$var$node;

});

parcelRegister("8SqIE", function(module, exports) {
$parcel$export(module.exports, "default", () => $077428ba12d8ae80$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b90688151183c96d2e90f7b13ec9793e>>
 * @relayHash 84d315b6355716bff013d1faca7a35f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0c3507f60fd7cc902480ed8bc9a1f24c67a527dd7825518c1979ca92e72e3745

var $hRj2m = parcelRequire("hRj2m");
const $077428ba12d8ae80$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "text"
    }, v8 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v10 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "parent_issueFieldParent_ParentField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraParentFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateParentField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraParentIssueField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditViewIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "parent_issueFieldParent_ParentField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraParentFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateParentField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraParentIssueField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "parentIssue",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "concreteType": "JiraColorField",
                                                    "kind": "LinkedField",
                                                    "name": "issueColorField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "color",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "colorKey"
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraSingleLineTextField",
                                                    "kind": "LinkedField",
                                                    "name": "summaryField",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "issueId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "issuetype",
                                                                        "project",
                                                                        "summary",
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "__typename"
                                                                                },
                                                                                v4 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v8 /*: any*/ ,
                                                                                        v7 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraSingleLineTextField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v8 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v4 /*: any*/ ,
                                                                                                v9 /*: any*/ ,
                                                                                                v6 /*: any*/ ,
                                                                                                v5 /*: any*/ ,
                                                                                                v10 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v8 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v4 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v4 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        v10 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraStatusField",
                                                            "kind": "LinkedField",
                                                            "name": "statusField",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v4 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0c3507f60fd7cc902480ed8bc9a1f24c67a527dd7825518c1979ca92e72e3745",
            "metadata": {},
            "name": "parent_issueFieldParent_ParentField_Mutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default)
            }
        }
    };
}();
$077428ba12d8ae80$var$node.hash = "8b384097fdc3b65908abb3c6f1e54624";
var $077428ba12d8ae80$export$2e2bcd8739ae039 = $077428ba12d8ae80$var$node;

});

parcelRegister("hmLUp", function(module, exports) {
$parcel$export(module.exports, "default", () => $08a44b92af224f95$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<391e063db361cd447925786d6a4fe224>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $08a44b92af224f95$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "text"
    }, v4 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v5 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v6 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditViewIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "parent_issueFieldParentReadviewFull_ParentReadView"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v2 /*: any*/ ,
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "issueId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "webUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "concreteType": "JiraColorField",
                        "kind": "LinkedField",
                        "name": "issueColorField",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "color",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "colorKey"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "issuetype",
                                            "project",
                                            "summary",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v0 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v1 /*: any*/ ,
                                                            v3 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v1 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v0 /*: any*/ ,
                                                                    v4 /*: any*/ ,
                                                                    v2 /*: any*/ ,
                                                                    v5 /*: any*/ ,
                                                                    v6 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v1 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    v0 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraStatusCategory",
                                                                        "kind": "LinkedField",
                                                                        "name": "statusCategory",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v0 /*: any*/ ,
                                                                            v7 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": [
                                            v4 /*: any*/ ,
                                            v2 /*: any*/ ,
                                            v5 /*: any*/ ,
                                            v6 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraSingleLineTextField",
                                "kind": "LinkedField",
                                "name": "summaryField",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    v3 /*: any*/ 
                                ]
                            },
                            {
                                "concreteType": "JiraStatusField",
                                "kind": "LinkedField",
                                "name": "statusField",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    {
                                        "concreteType": "JiraStatus",
                                        "kind": "LinkedField",
                                        "name": "status",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraStatusCategory",
                                                "kind": "LinkedField",
                                                "name": "statusCategory",
                                                "plural": false,
                                                "selections": [
                                                    v7 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraParentIssueField"
    };
}();
$08a44b92af224f95$var$node.hash = "885477189b93e8b7aa9fa91adde92c64";
var $08a44b92af224f95$export$2e2bcd8739ae039 = $08a44b92af224f95$var$node;

});

parcelRegister("8MKsY", function(module, exports) {
$parcel$export(module.exports, "default", () => $6254ede357cd9891$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $6254ede357cd9891$var$ParentEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("bRPQL")), {
        moduleId: "c1f15ee7",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $6254ede357cd9891$export$2e2bcd8739ae039 = $6254ede357cd9891$var$ParentEditViewEntryPoint;

});
parcelRegister("bRPQL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dzONu").then(()=>parcelRequire('kTqjh'));

});


parcelRegister("bARvQ", function(module, exports) {
$parcel$export(module.exports, "transformParentNode", () => $346ef850ba3728ec$export$1b622b80a5cf731f);
$parcel$export(module.exports, "transformToSuggestions", () => $346ef850ba3728ec$export$6cffaaeb4c7c0c18);

var $jx0Vw = parcelRequire("jx0Vw");

var $8URAw = parcelRequire("8URAw");

var $4cTDP = parcelRequire("4cTDP");
const $346ef850ba3728ec$var$transformParentNodeOld = (edgeNode)=>{
    const fieldsEdges = edgeNode?.fieldsById?.edges || [];
    const summaryField = fieldsEdges.find((field)=>field?.node?.fieldId === 'summary');
    const issueTypeField = fieldsEdges.find((field)=>field?.node?.fieldId === 'issuetype');
    const statusField = fieldsEdges.find((field)=>field?.node?.fieldId === 'status');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKey = edgeNode?.issueColorField?.color?.colorKey;
    const checkParentIssueIsDone = (statusCategoryId)=>{
        const doneStatusCategoryId = (0, $jx0Vw).StatusCategoryIds[(0, $jx0Vw).StatusCategoryTypes.DONE];
        return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
    };
    const isDone = checkParentIssueIsDone(statusField?.node?.status?.statusCategory?.statusCategoryId || '');
    return {
        id: edgeNode?.id || '',
        key: edgeNode?.key || '',
        // @ts-expect-error Type 'string | undefined' is not assignable to type 'string'.
        issueId: edgeNode?.issueId || undefined,
        // @ts-expect-error Type 'string | undefined' is not assignable to type 'string'.
        webUrl: edgeNode?.webUrl || undefined,
        fields: {
            issuetype: {
                id: issueTypeField?.node?.issueType?.issueTypeId || '',
                name: issueTypeField?.node?.issueType?.name || '',
                iconUrl: issueTypeField?.node?.issueType?.avatar?.xsmall || ''
            },
            summary: summaryField?.node?.text || ''
        },
        color: colorKey in (0, $8URAw.MAP_FROM_SERVER_COLOR) ? (0, $8URAw.MAP_FROM_SERVER_COLOR)[colorKey] : undefined,
        value: edgeNode?.id || '',
        label: `${edgeNode?.key || ''} ${summaryField?.node?.text || ''}`,
        isDone: isDone,
        aggValue: edgeNode
    };
};
const $346ef850ba3728ec$export$1b622b80a5cf731f = (edgeNode)=>{
    if (!(0, $4cTDP.fg)('dfo_remove_fields_by_id')) return $346ef850ba3728ec$var$transformParentNodeOld(edgeNode);
    const summaryField = edgeNode?.summaryField;
    const issueTypeField = edgeNode?.issueTypeField;
    const statusField = edgeNode?.statusField;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKey = edgeNode?.issueColorField?.color?.colorKey;
    const checkParentIssueIsDone = (statusCategoryId)=>{
        const doneStatusCategoryId = (0, $jx0Vw).StatusCategoryIds[(0, $jx0Vw).StatusCategoryTypes.DONE];
        return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
    };
    const isDone = checkParentIssueIsDone(statusField?.status?.statusCategory?.statusCategoryId || '');
    return {
        id: edgeNode?.id || '',
        key: edgeNode?.key || '',
        // @ts-expect-error Type 'string | undefined' is not assignable to type 'string'.
        issueId: edgeNode?.issueId || undefined,
        // @ts-expect-error Type 'string | undefined' is not assignable to type 'string'.
        webUrl: edgeNode?.webUrl || undefined,
        fields: {
            issuetype: {
                id: issueTypeField?.issueType?.issueTypeId || '',
                name: issueTypeField?.issueType?.name || '',
                iconUrl: issueTypeField?.issueType?.avatar?.xsmall || ''
            },
            summary: summaryField?.text || ''
        },
        color: colorKey in (0, $8URAw.MAP_FROM_SERVER_COLOR) ? (0, $8URAw.MAP_FROM_SERVER_COLOR)[colorKey] : undefined,
        value: edgeNode?.id || '',
        label: `${edgeNode?.key || ''} ${summaryField?.text || ''}`,
        isDone: isDone,
        aggValue: edgeNode
    };
};
const $346ef850ba3728ec$export$6cffaaeb4c7c0c18 = (fieldOptionsData)=>(fieldOptionsData?.edges || [])?.filter((edge)=>edge?.node).map((edge)=>$346ef850ba3728ec$export$1b622b80a5cf731f(edge?.node));

});

parcelRegister("dSKax", function(module, exports) {
$parcel$export(module.exports, "ParentReadView", () => $257192e729b39853$export$72990b9b43fe6c69);

var $eijNw = parcelRequire("eijNw");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $tYLUh = parcelRequire("tYLUh");

var $coXKe = parcelRequire("coXKe");

var $3OT15 = parcelRequire("3OT15");

var $ajyMI = parcelRequire("ajyMI");

var $5Cerh = parcelRequire("5Cerh");
const $257192e729b39853$export$72990b9b43fe6c69 = ({ fragmentRef: fragmentRef, disableClickAction: disableClickAction, emptyText: emptyText, onClick: onClick, isTruncated: isTruncated = true, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled })=>{
    const data = (0, $j4oe4.useFragment)((0, $eijNw.default), fragmentRef);
    const { parentIssue: parentIssue } = data;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const { userPreferredLayout: userPreferredLayout } = (0, $coXKe.useUserPreferredWorkItemLayout)();
    const noValueTextExperiment = formatMessage((0, $ajyMI.default).noValueTextExperiment);
    const issueType = parentIssue?.issueTypeField?.issueType;
    const label = `${parentIssue?.key} ${parentIssue?.summaryField?.text ?? ''}`;
    const iconUrl = issueType?.avatar?.xsmall;
    const isWideViewLayout = userPreferredLayout === 'WIDE';
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: label
    });
    if (!parentIssue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : emptyText
    });
    if (!isSingleLineRowHeightEnabled) {
        const maybeTruncatedWithTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: label,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            alignBlock: "center",
            space: "space.100",
            xcss: [
                isTruncated && $257192e729b39853$var$containerStyles,
                isWideViewLayout && $257192e729b39853$var$wideLayoutMaxWidth
            ]
        }, iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($257192e729b39853$var$Icon, {
            src: iconUrl,
            alt: formatMessage((0, $ajyMI.default).icon, {
                issueType: issueType?.name ?? ''
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Cerh.Summary), {
            disableClickAction: disableClickAction,
            issueKey: parentIssue.key,
            label: label,
            colorKey: parentIssue.issueColorField?.color?.colorKey,
            onClick: onClick,
            isTruncated: isTruncated
        })));
        return (0, $4cTDP.fg)('jira-issues--truncate-parent-field-overflow') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $257192e729b39853$var$maxWidth100
        }, maybeTruncatedWithTooltip) : maybeTruncatedWithTooltip;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        space: "space.100",
        xcss: $257192e729b39853$var$containerStyles
    }, iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($257192e729b39853$var$Icon, {
        src: iconUrl,
        alt: formatMessage((0, $ajyMI.default).icon, {
            issueType: issueType?.name ?? ''
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Cerh.Summary), {
        disableClickAction: disableClickAction,
        issueKey: parentIssue?.key || '',
        label: label,
        colorKey: parentIssue?.issueColorField?.color?.colorKey,
        onClick: onClick,
        isTruncated: isTruncated,
        contentRef: hoverPopoverRef
    }));
};
const $257192e729b39853$var$containerStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $257192e729b39853$var$wideLayoutMaxWidth = (0, $1DXK0.xcss)({
    maxWidth: '240px'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $257192e729b39853$var$Icon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f7vkz",
            __cmplp.className
        ])
    });
});
const $257192e729b39853$var$maxWidth100 = (0, $1DXK0.xcss)({
    maxWidth: '100%'
});

});
parcelRegister("eijNw", function(module, exports) {
$parcel$export(module.exports, "default", () => $56f311847691a60c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0018f1696c12dc89489c683d60edc1be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $56f311847691a60c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "parent_issueFieldParentReadviewFull_ParentReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "parentIssue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "JiraColorField",
                    "kind": "LinkedField",
                    "name": "issueColorField",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraColor",
                            "kind": "LinkedField",
                            "name": "color",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "colorKey"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraIssueTypeField",
                    "kind": "LinkedField",
                    "name": "issueTypeField",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "xsmall"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraSingleLineTextField",
                    "kind": "LinkedField",
                    "name": "summaryField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "text"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraParentIssueField"
};
$56f311847691a60c$var$node.hash = "fc9fe20d1bac42ec7b82f622deb0a6d2";
var $56f311847691a60c$export$2e2bcd8739ae039 = $56f311847691a60c$var$node;

});

parcelRegister("coXKe", function(module, exports) {
$parcel$export(module.exports, "useIssueLayoutContainers", () => $3b984a26137eed7b$export$d146dfa0384f99a3);
$parcel$export(module.exports, "useLayoutContainerByType", () => $3b984a26137eed7b$export$5f49a43487b268);
$parcel$export(module.exports, "useLayoutContainerByTypeMemoised", () => $3b984a26137eed7b$export$ef5966e43b13b4a9);
$parcel$export(module.exports, "useIssueLayoutGlance", () => $3b984a26137eed7b$export$fd7f0cc3d2b405e6);
$parcel$export(module.exports, "useIssueLayoutContextPanel", () => $3b984a26137eed7b$export$5962da0433486667);
$parcel$export(module.exports, "useUserPreferredWorkItemLayout", () => $3b984a26137eed7b$export$9889eea62fdfa091);
$parcel$export(module.exports, "useIssueLayoutActions", () => $3b984a26137eed7b$export$1e5e9fc877a47cd9);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $pz0Wh = parcelRequire("pz0Wh");

var $kfvK2 = parcelRequire("kfvK2");

var $cxKOj = parcelRequire("cxKOj");

var $cs58I = parcelRequire("cs58I");

var $hbF3h = parcelRequire("hbF3h");

var $bmoS1 = parcelRequire("bmoS1");

var $1M2hR = parcelRequire("1M2hR");


var $bNexr = parcelRequire("bNexr");

var $4cTDP = parcelRequire("4cTDP");

var $eSnSE = parcelRequire("eSnSE");

var $l7Alo = parcelRequire("l7Alo");

var $lpEwy = parcelRequire("lpEwy");

var $co62F = parcelRequire("co62F");
const $3b984a26137eed7b$var$Tabs = {
    Description: 'description',
    WorkItems: 'workItems',
    Resources: 'resources',
    Integrations: 'integrations'
};
const $3b984a26137eed7b$var$defaultActiveTab = $3b984a26137eed7b$var$Tabs.Description;
const $3b984a26137eed7b$export$d146dfa0384f99a3 = (issueKey)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    return [
        containers
    ];
};
const $3b984a26137eed7b$export$5f49a43487b268 = (issueKey, type)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    // Forge app with UI Modifications module can hide selected fields using
    // UI modifications Field API. We are removing them here from the layout fields
    const fieldsHiddenByUim = (0, $pz0Wh.useEnabledHiddenFields)();
    return (0, $eJOHy.useMemo)(()=>[
            (0, $co62F.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim)
        ], [
        container?.items.nodes,
        fieldsHiddenByUim
    ]);
};
const $3b984a26137eed7b$export$ef5966e43b13b4a9 = (issueKey, type)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    const fieldsHiddenByUim = (0, $pz0Wh.useEnabledHiddenFields)();
    const filteredItems = (0, $eJOHy.useMemo)(()=>{
        return (0, $co62F.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim);
    }, [
        container,
        fieldsHiddenByUim
    ]);
    return [
        filteredItems
    ];
};
const $3b984a26137eed7b$export$fd7f0cc3d2b405e6 = (issueKey)=>{
    const [glance] = (0, $lpEwy.useIssueLayoutGlanceStore)(issueKey);
    return [
        glance
    ];
};
const $3b984a26137eed7b$export$5962da0433486667 = (issueKey)=>{
    const [contextPanel] = (0, $lpEwy.useIssueLayoutContextPanelStore)(issueKey);
    return [
        contextPanel
    ];
};
const $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOn = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const isFullIssueView = (0, $bmoS1.useIsFullPageIssueView)();
    const [userPreferredLayout] = (0, $cs58I.useUserPreferencesValue)((0, $e8c5fe022e7e442a$export$39aaf586c7ee5202));
    const isMobile = (0, $l7Alo.default)();
    const locale = (0, $1M2hR.useLocale)();
    try {
        // if neither tab layout nor issue view layout experiment is enabled return defaults
        if (!(0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate') && !(0, $4cTDP.fg)('issue_view_tab_layout_feature_gate')) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isSoftwareOrBusiness = projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        const shouldBeInLayoutExperimentAndTabLayoutEnabled = (0, $4cTDP.fg)('issue_view_tab_layout_feature_gate') && shouldBeInLayoutExperiment;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInTabLayoutExperiment = shouldBeInLayoutExperimentAndTabLayoutEnabled && (0, $cxKOj.expVal)('issue_view_tab_layout_experiment', 'isTabLayoutEnabled', false);
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment || isInTabLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        let userSelectedLayout = userLayoutType;
        if (!(0, $4cTDP.fg)('thor-make-layout-options-work-together')) {
            if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
            if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        }
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${JSON.stringify({
            error: error,
            isMobile: isMobile,
            isFullIssueView: isFullIssueView,
            isIssueKeyNull: issueKey === null,
            isProjectKeyNull: projectKey === null,
            isProjectTypeNull: projectType === null,
            userPreferredLayout: userPreferredLayout,
            locale: locale,
            isInWideLayoutExperiment: (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false),
            isInDiscussionLayoutExperiment: (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false)
        })}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOff = ()=>{
    try {
        // if neither tab layout nor issue view layout experiment is enabled return defaults
        if (!(0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate') && !(0, $4cTDP.fg)('issue_view_tab_layout_feature_gate')) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        /* eslint-disable react-hooks/rules-of-hooks */ const issueKey = (0, $bmoS1.useIssueKey)();
        const projectKey = (0, $bNexr.useProjectKey)(issueKey);
        const projectType = (0, $bNexr.useProjectType)(projectKey);
        const isFullIssueView = (0, $bmoS1.useIsFullPageIssueView)();
        const [userPreferredLayout] = (0, $cs58I.useUserPreferencesValue)((0, $e8c5fe022e7e442a$export$39aaf586c7ee5202));
        const isMobile = (0, $l7Alo.default)();
        const isSoftwareOrBusiness = projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        const shouldBeInLayoutExperimentAndTabLayoutEnabled = (0, $4cTDP.fg)('issue_view_tab_layout_feature_gate') && shouldBeInLayoutExperiment;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInTabLayoutExperiment = shouldBeInLayoutExperimentAndTabLayoutEnabled && (0, $cxKOj.expVal)('issue_view_tab_layout_experiment', 'isTabLayoutEnabled', false);
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment || isInTabLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        /* eslint-enable react-hooks/rules-of-hooks */ let userSelectedLayout = userLayoutType;
        if (!(0, $4cTDP.fg)('thor-make-layout-options-work-together')) {
            if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
            if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        }
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${error}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $3b984a26137eed7b$export$9889eea62fdfa091 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('issue_layout_rule_of_hook_fix'), $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOn, $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOff);
const $3b984a26137eed7b$export$1e5e9fc877a47cd9 = ()=>{
    const [, actions] = (0, $lpEwy.useIssueLayoutActionsStore)();
    const setIssueViewContainersLayout = (0, $eJOHy.useCallback)((issueKey, containersByType)=>{
        actions.setIssueViewContainersLayout(issueKey, containersByType);
    }, [
        actions
    ]);
    const setIssueViewLayoutGlance = (0, $eJOHy.useCallback)((issueKey, glance)=>{
        actions.setIssueViewLayoutGlance(issueKey, glance);
    }, [
        actions
    ]);
    const setIssueViewLayoutContextPanel = (0, $eJOHy.useCallback)((issueKey, newContextPanel)=>{
        actions.setIssueViewLayoutContextPanel(issueKey, newContextPanel);
    }, [
        actions
    ]);
    return [
        null,
        {
            setIssueViewContainersLayout: setIssueViewContainersLayout,
            setIssueViewLayoutGlance: setIssueViewLayoutGlance,
            setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel
        }
    ];
};
/**
 * useRouteToGetQueryParams hook
 * This hook retrieves the current query parameters from the router state.
 * It is used to access the active tab and other query parameters in the issue view layout.
 */ const $3b984a26137eed7b$var$useRouteToGetQueryParams = (0, $kfvK2.createRouterSelector)((state)=>{
    return state.query;
});
const $3b984a26137eed7b$export$b027791af8c9b114 = ()=>{
    const { activeTab: activeTab = $3b984a26137eed7b$var$defaultActiveTab, ...otherQueryParams } = $3b984a26137eed7b$var$useRouteToGetQueryParams();
    const { updateQueryParam: updateQueryParam } = (0, $kfvK2.useRouterStoreActions)();
    const setActiveTab = (0, $eJOHy.useCallback)((tab)=>{
        if (activeTab !== tab) updateQueryParam({
            ...otherQueryParams,
            activeTab: tab
        }, 'replace');
    }, [
        activeTab,
        otherQueryParams,
        updateQueryParam
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            setDescriptionAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.Description),
            setWorkItemsAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.WorkItems),
            setIntegrationsAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.Integrations),
            setResourcesAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.Resources),
            currentActiveTab: activeTab
        }), [
        activeTab,
        setActiveTab
    ]);
};

});
parcelRegister("pz0Wh", function(module, exports) {
$parcel$export(module.exports, "useEnabledHiddenFields", () => $437c493a8e065bc6$export$bb6c2b9159c3f32b);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $i7n3g = parcelRequire("i7n3g");

var $4Swsy = parcelRequire("4Swsy");
const $437c493a8e065bc6$export$bb6c2b9159c3f32b = ()=>{
    (0, $gRw8I.di)((0, $i7n3g.useAdjustmentsEnabled), (0, $4Swsy.useHiddenFields));
    const adjustmentsAreEnabled = (0, $i7n3g.useAdjustmentsEnabled)();
    const hiddenFields = (0, $4Swsy.useHiddenFields)();
    return (0, $eJOHy.useMemo)(()=>{
        if (!adjustmentsAreEnabled) return [];
        return hiddenFields;
    }, [
        adjustmentsAreEnabled,
        hiddenFields
    ]);
};

});
parcelRegister("i7n3g", function(module, exports) {
$parcel$export(module.exports, "store", () => $35b1fa370eb6f514$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $35b1fa370eb6f514$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $35b1fa370eb6f514$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $35b1fa370eb6f514$export$5eb9c167b683d125);

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $35b1fa370eb6f514$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $35b1fa370eb6f514$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($35b1fa370eb6f514$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $35b1fa370eb6f514$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue-adjustments-context',
    initialState: $35b1fa370eb6f514$var$initialState,
    actions: $35b1fa370eb6f514$export$e324594224ef24da
});
const $35b1fa370eb6f514$export$a12f82a132dee079 = (0, $iJq0l.createHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9);
const $35b1fa370eb6f514$export$358ad850b2f6d6fe = (0, $iJq0l.createStateHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $35b1fa370eb6f514$export$4f2729981f4b81d2 = (0, $iJq0l.createActionsHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9);
const $35b1fa370eb6f514$export$5eb9c167b683d125 = (0, $6E16M.createContainer)($35b1fa370eb6f514$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("4Swsy", function(module, exports) {
$parcel$export(module.exports, "useHiddenFields", () => $8e2f20b0b0e23b91$export$de6fdc67c945e596);

var $4MchI = parcelRequire("4MchI");
var $iJq0l = parcelRequire("iJq0l");

var $ixrOr = parcelRequire("ixrOr");
const $8e2f20b0b0e23b91$var$selectHiddenFields = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.appliedChanges, (formData, appliedChanges)=>{
    if (formData === null) return [];
    return Object.entries(formData).filter(([fieldId, field])=>appliedChanges?.[fieldId]?.isVisible !== undefined ? !appliedChanges[fieldId].isVisible : !field.isVisible).map(([fieldId])=>fieldId);
});
const $8e2f20b0b0e23b91$export$de6fdc67c945e596 = (0, $iJq0l.createStateHook)((0, $ixrOr.store), {
    selector: $8e2f20b0b0e23b91$var$selectHiddenFields
});

});
parcelRegister("ixrOr", function(module, exports) {
$parcel$export(module.exports, "store", () => $3142574379bc5921$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $3142574379bc5921$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $3142574379bc5921$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $3142574379bc5921$export$677b3e34bd14c681);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4XahM = parcelRequire("4XahM");

var $4CM51 = parcelRequire("4CM51");

var $aub9z = parcelRequire("aub9z");

var $cJU1r = parcelRequire("cJU1r");

var $2A1rz = parcelRequire("2A1rz");

var $jfSsT = parcelRequire("jfSsT");

var $hUz0e = parcelRequire("hUz0e");

var $8ZmJu = parcelRequire("8ZmJu");

var $cXMA2 = parcelRequire("cXMA2");

var $5qpxn = parcelRequire("5qpxn");

var $9w3dh = parcelRequire("9w3dh");

var $fkUIk = parcelRequire("fkUIk");

var $bfBqP = parcelRequire("bfBqP");

var $fY47y = parcelRequire("fY47y");

var $dmz3j = parcelRequire("dmz3j");
const $3142574379bc5921$var$name = 'issue-adjustments';
const $3142574379bc5921$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $3142574379bc5921$var$triggerFieldInitializationKey, viewType: $3142574379bc5921$var$scopedViewType, numberOfSupportedFields: $3142574379bc5921$var$numberOfSupportedFields, ...$3142574379bc5921$var$stateForResetAllFields } = $3142574379bc5921$export$d4c72bab9d6cc13a;
const $3142574379bc5921$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $5qpxn.processChange,
    setFieldValue: $fkUIk.setFieldValue,
    initializeField: $jfSsT.initializeField,
    initializeFields: $jfSsT.initializeFields,
    startFieldsInitialisationTimeout: $2A1rz.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $2A1rz.successFieldsInitalisation,
    registerFields: $9w3dh.registerFields,
    unregisterFields: $9w3dh.unregisterFields,
    updateFields: $fY47y.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($3142574379bc5921$var$stateForResetAllFields);
        },
    setError: $cJU1r.setError,
    resetError: $cJU1r.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $4XahM.setAppErrors,
    resetAppErrors: $4XahM.resetAppErrors,
    addAppsErrors: $4XahM.addAppsErrors,
    initializeNoScreenTab: $hUz0e.initializeNoScreenTab,
    initializeScreenTabs: $8ZmJu.initializeScreenTabs,
    updateScreenTabs: $dmz3j.updateScreenTabs,
    updateActiveScreenTab: $bfBqP.updateActiveScreenTab,
    detectAppliedChangesConflicts: $4CM51.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $aub9z.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $aub9z.collectFieldsAppliedChangesHistory,
    setNotification: $cXMA2.setNotification,
    resetNotification: $cXMA2.resetNotification
};
const $3142574379bc5921$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: $3142574379bc5921$var$name,
    initialState: $3142574379bc5921$export$d4c72bab9d6cc13a,
    actions: $3142574379bc5921$export$e324594224ef24da
});
const $3142574379bc5921$export$37792a602e748c08 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9);
const $3142574379bc5921$var$stableEmptyFieldFromIframe = {};
const $3142574379bc5921$export$c76e674a29843e21 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $3142574379bc5921$export$df4b0714e8177e0e = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $3142574379bc5921$var$stableEmptyFieldFromIframe
});
const $3142574379bc5921$export$cb9a014ec14556d8 = (0, $iJq0l.createActionsHook)($3142574379bc5921$export$6f57813fe9f31bf9);
const $3142574379bc5921$export$677b3e34bd14c681 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("4XahM", function(module, exports) {
$parcel$export(module.exports, "setAppErrors", () => $5579267a84760bc0$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $5579267a84760bc0$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $5579267a84760bc0$export$24c821207687a907);
const $5579267a84760bc0$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $5579267a84760bc0$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $5579267a84760bc0$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("4CM51", function(module, exports) {
$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $8731ff5311f46f9c$export$90d94f20d157e756);

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");


var $4XahM = parcelRequire("4XahM");

var $cXMA2 = parcelRequire("cXMA2");

var $7Agw7 = parcelRequire("7Agw7");
const $8731ff5311f46f9c$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $8731ff5311f46f9c$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $8731ff5311f46f9c$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $8731ff5311f46f9c$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $8731ff5311f46f9c$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId?.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $e65702a72ab5ec3d$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $7Agw7.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $4XahM.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $cXMA2.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("jgvEH", function(module, exports) {
$parcel$export(module.exports, "fireOperationalEvent", () => $cbc5413d6b6dbcfa$export$a1fb57756f0de62b);

var $5fWw9 = parcelRequire("5fWw9");


const $cbc5413d6b6dbcfa$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $5fWw9.default)((0, $0390845c0b61b1a1$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $e9db81972dce4ebc$export$12346a674644c156)
    })(createAnalyticsEvent);
};

});
const $e9db81972dce4ebc$export$f636b5b56f1d624a = 'Screen';
const $e9db81972dce4ebc$export$9d2de6eebf7462b5 = 'Drawer';
const $e9db81972dce4ebc$export$1171103ea9083ffa = 'Modal';
const $e9db81972dce4ebc$export$cae2783c9279926 = 'InlineDialog';
const $e9db81972dce4ebc$export$d1123261ca8831d2 = 'Dropdown';
const $e9db81972dce4ebc$export$a1562d08625f5d7e = 'UI';
const $e9db81972dce4ebc$export$947dac6c72b26f81 = 'TRACK';
const $e9db81972dce4ebc$export$f1d537d508d2945a = 'SCREEN';
const $e9db81972dce4ebc$export$12346a674644c156 = 'OPERATIONAL';
const $e9db81972dce4ebc$export$2ceccf177fae277c = 'analyticsBridge';

const $0390845c0b61b1a1$export$8280e5c6104c5b40 = 'ui-modifications';


const $e65702a72ab5ec3d$export$415cc1afa6445f90 = 'onInitChangeId';
const $e65702a72ab5ec3d$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("cXMA2", function(module, exports) {
$parcel$export(module.exports, "setNotification", () => $c89e780a89ca3c37$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $c89e780a89ca3c37$export$caafa3945f199bc7);
const $c89e780a89ca3c37$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $c89e780a89ca3c37$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("7Agw7", function(module, exports) {
$parcel$export(module.exports, "collectConflicts", () => $6ecf22ae7e9f4956$export$a06103ec99e4e394);

var $jFHCE = parcelRequire("jFHCE");


var $5sAot = parcelRequire("5sAot");

const $6ecf22ae7e9f4956$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $6ecf22ae7e9f4956$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $702a64456849b1c0$export$f674b7a3bbd94b5)) return {
            type: (0, $585e8f7167f61808$export$2a3fdceaae2188d5),
            cause: (0, $585e8f7167f61808$export$877da1000325f8b5),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$6ecf22ae7e9f4956$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $5sAot.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $585e8f7167f61808$export$2a3fdceaae2188d5),
            cause: (0, $585e8f7167f61808$export$e4ac32edd5da2ee7),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$6ecf22ae7e9f4956$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $6ecf22ae7e9f4956$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $6ecf22ae7e9f4956$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
const $585e8f7167f61808$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $585e8f7167f61808$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $585e8f7167f61808$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $585e8f7167f61808$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $585e8f7167f61808$export$e4ac32edd5da2ee7 = 'FIELD';
const $585e8f7167f61808$export$877da1000325f8b5 = 'SCREENTABS';

parcelRegister("5sAot", function(module, exports) {
$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $2728f69de31c50a0$export$e1cc7da28a1c4bb7);
const $2728f69de31c50a0$var$SET_NAME_METHOD = 'setName';
const $2728f69de31c50a0$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $2728f69de31c50a0$var$SET_VISIBLE_METHOD = 'setVisible';
const $2728f69de31c50a0$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $2728f69de31c50a0$var$SET_VALUE_METHOD = 'setValue';
const $2728f69de31c50a0$var$SET_REQUIRED_METHOD = 'setRequired';
const $2728f69de31c50a0$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $2728f69de31c50a0$export$8325709d137b2606 = {
    fieldName: $2728f69de31c50a0$var$SET_NAME_METHOD,
    description: $2728f69de31c50a0$var$SET_DESCRIPTION_METHOD,
    isVisible: $2728f69de31c50a0$var$SET_VISIBLE_METHOD,
    isReadOnly: $2728f69de31c50a0$var$SET_READ_ONLY_METHOD,
    value: $2728f69de31c50a0$var$SET_VALUE_METHOD,
    isRequired: $2728f69de31c50a0$var$SET_REQUIRED_METHOD,
    optionsVisibility: $2728f69de31c50a0$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $2728f69de31c50a0$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $2728f69de31c50a0$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

const $702a64456849b1c0$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $702a64456849b1c0$export$4a9f236a0db33834 = 'FIELD';



parcelRegister("aub9z", function(module, exports) {
$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $94bb1a042906c320$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $94bb1a042906c320$export$7d0f534e5b16dcc9);


var $gD9lZ = parcelRequire("gD9lZ");
const $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $94bb1a042906c320$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $702a64456849b1c0$export$f674b7a3bbd94b5)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $94bb1a042906c320$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $gD9lZ.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("gD9lZ", function(module, exports) {
$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $b80c31bd414cd9d4$export$8a23b3e9a1749620);

const $b80c31bd414cd9d4$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $702a64456849b1c0$export$4a9f236a0db33834)
        };
        return acc;
    }, {});
};
const $b80c31bd414cd9d4$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $b80c31bd414cd9d4$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("cJU1r", function(module, exports) {
$parcel$export(module.exports, "setError", () => $60a309f31f0bb435$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $60a309f31f0bb435$export$7e5930c6217b1d4e);
const $60a309f31f0bb435$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $60a309f31f0bb435$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("2A1rz", function(module, exports) {
$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $601c25cd313fe741$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $601c25cd313fe741$export$cf768a695e83eefa);

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");

var $ieQ0v = parcelRequire("ieQ0v");

var $cJU1r = parcelRequire("cJU1r");
const $601c25cd313fe741$var$getTimeout = ()=>50000;
const $601c25cd313fe741$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $601c25cd313fe741$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $601c25cd313fe741$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($601c25cd313fe741$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $601c25cd313fe741$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $601c25cd313fe741$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($601c25cd313fe741$var$isFieldInitialisationComplete(status) || (0, $ieQ0v.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $cJU1r.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $601c25cd313fe741$var$getTimeout(),
                fieldsInitializationTime: $601c25cd313fe741$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $601c25cd313fe741$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { status: status } = getState().fieldsInitialization;
        if ($601c25cd313fe741$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $601c25cd313fe741$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("ieQ0v", function(module, exports) {
$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $d3350efc4111ec81$export$4cadeedb8c3f31f7);

var $4MchI = parcelRequire("4MchI");
const $d3350efc4111ec81$export$4cadeedb8c3f31f7 = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("jfSsT", function(module, exports) {
$parcel$export(module.exports, "initializeField", () => $a40b94674a995fd7$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $a40b94674a995fd7$export$4a6b4707110b0552);

var $37MnT = parcelRequire("37MnT");
const $a40b94674a995fd7$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $a40b94674a995fd7$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("37MnT", function(module, exports) {
$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $cc8ab347810a3948$export$50806045b617d116);

var $gRw8I = parcelRequire("gRw8I");

var $1qarT = parcelRequire("1qarT");

var $82wKS = parcelRequire("82wKS");
const $cc8ab347810a3948$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    (0, $gRw8I.di)((0, $1qarT.fireErrorAnalytics), (0, $82wKS.getSupportedFieldConfiguration));
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $1qarT.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("1qarT", function(module, exports) {
$parcel$export(module.exports, "fireErrorAnalytics", () => $7486f28a569b9ec0$export$a27c21aa3ed8f0f1);

var $7U6OJ = parcelRequire("7U6OJ");

var $cMdIN = parcelRequire("cMdIN");
const $7486f28a569b9ec0$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $7486f28a569b9ec0$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $cMdIN.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $7U6OJ.fireErrorAnalytics)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $7486f28a569b9ec0$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("cMdIN", function(module, exports) {
$parcel$export(module.exports, "getErrorType", () => $c511a0dff3897a12$export$e19f9f08a6d79fd2);

var $l58EO = parcelRequire("l58EO");
const $c511a0dff3897a12$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $c511a0dff3897a12$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $c511a0dff3897a12$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $c511a0dff3897a12$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $c511a0dff3897a12$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $c511a0dff3897a12$export$89a175d4190df42e = 'Invoke value functions failed:';
const $c511a0dff3897a12$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $c511a0dff3897a12$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $c511a0dff3897a12$var$BAD_REQUEST = 400;
const $c511a0dff3897a12$var$REQUEST_TIMEOUT = 408;
const $c511a0dff3897a12$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $c511a0dff3897a12$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $c511a0dff3897a12$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $c511a0dff3897a12$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($c511a0dff3897a12$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $c511a0dff3897a12$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($c511a0dff3897a12$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $c511a0dff3897a12$var$BAD_REQUEST;
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $c511a0dff3897a12$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $c511a0dff3897a12$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($c511a0dff3897a12$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($c511a0dff3897a12$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $l58EO.isClientFetchError)(error)) return $c511a0dff3897a12$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("l58EO", function(module, exports) {
$parcel$export(module.exports, "isClientFetchError", () => $cd5265fc67dbb6eb$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $cd5265fc67dbb6eb$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $cd5265fc67dbb6eb$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $cd5265fc67dbb6eb$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $cd5265fc67dbb6eb$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $cd5265fc67dbb6eb$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($cd5265fc67dbb6eb$export$3876cb851aa46193.includes(error.name) || $cd5265fc67dbb6eb$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($cd5265fc67dbb6eb$export$3876cb851aa46193.includes(error.cause.name) || $cd5265fc67dbb6eb$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("82wKS", function(module, exports) {
$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $0757a5b98ef450f3$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $0757a5b98ef450f3$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $0757a5b98ef450f3$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $0757a5b98ef450f3$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $0757a5b98ef450f3$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $0757a5b98ef450f3$export$ef45e4471aa21b27);

var $1qarT = parcelRequire("1qarT");

var $6beFf = parcelRequire("6beFf");
const $0757a5b98ef450f3$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $0757a5b98ef450f3$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $6beFf.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $0757a5b98ef450f3$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$0757a5b98ef450f3$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $1qarT.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $0757a5b98ef450f3$export$e4330d77fd93d1de = (viewType)=>$0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $0757a5b98ef450f3$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $0757a5b98ef450f3$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $0757a5b98ef450f3$export$20eabd2b3ada6bf3(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $0757a5b98ef450f3$export$b768d6a95f7a930(context) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $0757a5b98ef450f3$export$b0297573c90085aa(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $0757a5b98ef450f3$export$c0728caa743a409e(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $0757a5b98ef450f3$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $0757a5b98ef450f3$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("6beFf", function(module, exports) {
$parcel$export(module.exports, "getViewConfiguration", () => $9cd8cd98b7c2eeee$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $9cd8cd98b7c2eeee$export$f0022a21ccd1f6be);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");
const $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS = new Map();
const $9cd8cd98b7c2eeee$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.has(viewType)) $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $9cd8cd98b7c2eeee$export$176b6e68da08ffa2 = (viewType)=>$9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.get(viewType);
const $9cd8cd98b7c2eeee$export$e8091eff40c4f16e = ()=>{
    $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.clear();
};
const $9cd8cd98b7c2eeee$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    (0, $gRw8I.di)($9cd8cd98b7c2eeee$export$cda1ad403b37fe70);
    /**
	 * Uses useState to load view configuration on component mount, before rendering.
	 */ (0, $eJOHy.useState)(()=>{
        $9cd8cd98b7c2eeee$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};

});




parcelRegister("hUz0e", function(module, exports) {
$parcel$export(module.exports, "initializeNoScreenTab", () => $7faac090c61abadc$export$93459ad9bfd6c380);
const $7faac090c61abadc$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("8ZmJu", function(module, exports) {
$parcel$export(module.exports, "initializeScreenTabs", () => $5faefcecd8cba222$export$7f7be235f64f029b);
const $5faefcecd8cba222$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("5qpxn", function(module, exports) {
$parcel$export(module.exports, "processChange", () => $bbbbfc09b273134e$export$352dfcce04d66748);

var $9UJzd = parcelRequire("9UJzd");

var $gRw8I = parcelRequire("gRw8I");

var $82wKS = parcelRequire("82wKS");

var $5ldku = parcelRequire("5ldku");
const $bbbbfc09b273134e$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($9UJzd))));
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = internalFormMetadata[fieldId]?.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $5ldku.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($9UJzd)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("9UJzd", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");
/** Used to generate unique IDs. */ var $737cb0a939387270$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $737cb0a939387270$var$uniqueId(prefix) {
    var id = ++$737cb0a939387270$var$idCounter;
    return $cz1WF(prefix) + id;
}
module.exports = $737cb0a939387270$var$uniqueId;

});

parcelRegister("5ldku", function(module, exports) {
$parcel$export(module.exports, "calculateNextFormValue", () => $e9fdc7a6e4eab5b9$export$25441a03bb8f1cb0);

var $cSmYj = parcelRequire("cSmYj");

var $37MnT = parcelRequire("37MnT");
const $e9fdc7a6e4eab5b9$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("9w3dh", function(module, exports) {
$parcel$export(module.exports, "registerFields", () => $60e092cfdd3e6be9$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $60e092cfdd3e6be9$export$1ca69a85bb7273de);

var $jFHCE = parcelRequire("jFHCE");

var $jvwCK = parcelRequire("jvwCK");
const $60e092cfdd3e6be9$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $60e092cfdd3e6be9$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("fkUIk", function(module, exports) {
$parcel$export(module.exports, "setFieldValue", () => $adb039aa861139a2$export$6556d46d2662453c);

var $5ldku = parcelRequire("5ldku");
const $adb039aa861139a2$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $5ldku.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("bfBqP", function(module, exports) {
$parcel$export(module.exports, "updateActiveScreenTab", () => $910f8611d1056e54$export$21363496760d39cd);
const $910f8611d1056e54$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("fY47y", function(module, exports) {
$parcel$export(module.exports, "updateFields", () => $e5c83e79d4f29b58$export$cceae62fd4d1ef0a);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");


var $6PplZ = parcelRequire("6PplZ");

var $81O8J = parcelRequire("81O8J");

var $cfL5m = parcelRequire("cfL5m");

var $3JMvu = parcelRequire("3JMvu");

var $82idB = parcelRequire("82idB");

var $lKslV = parcelRequire("lKslV");

var $4XahM = parcelRequire("4XahM");

var $aub9z = parcelRequire("aub9z");

var $TiFiE = parcelRequire("TiFiE");
const $e5c83e79d4f29b58$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $aub9z.collectFieldsAppliedChangesHistory));
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields, lastProcessedChange: lastProcessedChange } = getState();
        let isSameFieldValueChanged = false;
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $cfL5m.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $4XahM.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $7f80bdb4337734ff$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $7f80bdb4337734ff$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $7f80bdb4337734ff$export$3a106242c8f57ac2],
                [(0, $7f80bdb4337734ff$export$e10d4d251d909c59)]: lookupDataFromApi[0, $7f80bdb4337734ff$export$e10d4d251d909c59]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $TiFiE.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $lKslV.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $3JMvu.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            isSameFieldValueChanged = (0, $6PplZ.checkSameFieldValueChanged)(fieldsChanges, lastProcessedChange, changeId);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges,
                isSameFieldValueChanged: isSameFieldValueChanged
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(errorsByField)) throw new (0, $81O8J.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $82idB.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $aub9z.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
const $7f80bdb4337734ff$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $7f80bdb4337734ff$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $7f80bdb4337734ff$export$e10d4d251d909c59 = 'LOOKUP_SOURCE_PROJECTS_ASYNC_DATA';
const $7f80bdb4337734ff$export$f5d5f6bb902f1027 = '-1';
const $7f80bdb4337734ff$export$106087dcfd4fb129 = 100;

parcelRegister("6PplZ", function(module, exports) {
$parcel$export(module.exports, "checkSameFieldValueChanged", () => $520d86b9433cc3c6$export$4027d961191df7c3);

var $eGOwo = parcelRequire("eGOwo");
function $520d86b9433cc3c6$export$4027d961191df7c3(fieldsChanges, lastProcessedChange, changeId) {
    if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $eGOwo.fg)('ditto_uim_new_attributes_for_uim_use_submit') && fieldsChanges && lastProcessedChange?.changeId === changeId) {
        const fid = lastProcessedChange?.fieldId;
        const change = fieldsChanges[fid];
        return !!change && change.hasOwnProperty('value');
    }
    return false;
}

});

parcelRegister("81O8J", function(module, exports) {
$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $b784ee4f71bce498$export$9e8b5e552e255163);

var $607Dw = parcelRequire("607Dw");
class $b784ee4f71bce498$export$9e8b5e552e255163 extends (0, $607Dw.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("607Dw", function(module, exports) {
$parcel$export(module.exports, "UiModificationsValidationError", () => $8683b9e27ffb2718$export$6e8165c81a6a65df);
class $8683b9e27ffb2718$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("cfL5m", function(module, exports) {
$parcel$export(module.exports, "fieldWasRegistered", () => $84902f345f4d9ec2$export$fbe9157c12cb4e7b);
const $84902f345f4d9ec2$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("3JMvu", function(module, exports) {
$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $7a07bba1139035a5$export$460820f27643954e);

var $82wKS = parcelRequire("82wKS");
const $7a07bba1139035a5$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("82idB", function(module, exports) {
$parcel$export(module.exports, "prepareErrorsArray", () => $b396c3e05312c1f7$export$e1fce51bc5be90b7);
const $b396c3e05312c1f7$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("lKslV", function(module, exports) {
$parcel$export(module.exports, "transformFieldToIframe", () => $fb1c6d2f11d8a679$export$aa453854f74fab);

var $1qarT = parcelRequire("1qarT");

var $82wKS = parcelRequire("82wKS");
const $fb1c6d2f11d8a679$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("TiFiE", function(module, exports) {
$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $0fdd9846971f3713$export$d14f85c01e334a1);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $6rtzq = parcelRequire("6rtzq");

var $82wKS = parcelRequire("82wKS");


var $5sAot = parcelRequire("5sAot");

var $gOp4r = parcelRequire("gOp4r");

var $i9dWk = parcelRequire("i9dWk");
const $0fdd9846971f3713$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    (0, $gRw8I.di)((0, $82wKS.getSupportedFieldConfiguration));
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $gOp4r.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $gOp4r.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $6rtzq.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $585e8f7167f61808$export$d1996cb46a690190),
                        method: (0, $5sAot.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $i9dWk.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $i9dWk.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("6rtzq", function(module, exports) {
$parcel$export(module.exports, "FieldValueLookupError", () => $2f73a6dce6bcf96a$export$73c2f0689b6c4a5a);
class $2f73a6dce6bcf96a$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("gOp4r", function(module, exports) {
$parcel$export(module.exports, "VALID_RESULT", () => $af0c126b48130091$export$ee79e3ab53b8db79);
const $af0c126b48130091$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("i9dWk", function(module, exports) {
$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $d76dab7db88ac392$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $d76dab7db88ac392$export$ddd005554aecd409);
const $d76dab7db88ac392$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $d76dab7db88ac392$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("dmz3j", function(module, exports) {
$parcel$export(module.exports, "updateScreenTabs", () => $d4a266f6d4506eb1$export$131c67fd312b8a11);

var $gRw8I = parcelRequire("gRw8I");

var $9WNAv = parcelRequire("9WNAv");

var $iGhbB = parcelRequire("iGhbB");

var $aub9z = parcelRequire("aub9z");

var $2TFQ7 = parcelRequire("2TFQ7");
const $d4a266f6d4506eb1$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        (0, $gRw8I.di)((0, $aub9z.collectScreenTabsAppliedChangesHistory), (0, $2TFQ7.getScreenTabsPublicToInternalValidationErrors));
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $2TFQ7.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $2TFQ7.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $aub9z.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $9WNAv.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $2TFQ7.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $iGhbB.toScreenTabsValidationError))
        });
    };

});
parcelRegister("9WNAv", function(module, exports) {
$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $5a1018b8bae0ac45$export$faf1f1824ee0a136);

var $607Dw = parcelRequire("607Dw");
class $5a1018b8bae0ac45$export$faf1f1824ee0a136 extends (0, $607Dw.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("iGhbB", function(module, exports) {
$parcel$export(module.exports, "toScreenTabsValidationError", () => $609355188438e567$export$b2675440ade984fb);

const $609355188438e567$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $585e8f7167f61808$export$fd26696d109785a0)
    });

});

parcelRegister("2TFQ7", function(module, exports) {
$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $e157d25468b560b0$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $e157d25468b560b0$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $e157d25468b560b0$export$62d63af83dac7315);

var $eGOwo = parcelRequire("eGOwo");
const $e157d25468b560b0$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $e157d25468b560b0$var$isValidScreenTabId = (internalScreenTabs, id)=>$e157d25468b560b0$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $e157d25468b560b0$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $e157d25468b560b0$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $e157d25468b560b0$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$e157d25468b560b0$var$isValidScreenTabId(internalScreenTabs, id) && $e157d25468b560b0$var$isValidScreenTabIsVisible(isVisible) && $e157d25468b560b0$var$isValidScreenTabIsActive(isActive);
const $e157d25468b560b0$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($e157d25468b560b0$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($e157d25468b560b0$var$isValidScreenTabIsActive(isActive) && isActive && $e157d25468b560b0$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $e157d25468b560b0$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $e157d25468b560b0$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$e157d25468b560b0$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $e157d25468b560b0$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if ((0, $eGOwo.fg)('ditto_uim_error_cb_screen_tabs')) screenTabsFromApp.forEach((tab)=>{
        if (!$e157d25468b560b0$var$isValidScreenTabData(internalScreenTabs, tab)) {
            if (!$e157d25468b560b0$var$isValidScreenTabId(internalScreenTabs, tab.id)) errors.push(`Screen tab with id ${tab.id} does not exist in the current view.`);
            if (!$e157d25468b560b0$var$isValidScreenTabIsVisible(tab.isVisible)) errors.push(`Visible state for tab with id ${tab.id} should be a boolean.`);
            if (!$e157d25468b560b0$var$isValidScreenTabIsActive(tab.isActive)) errors.push(`Active state for tab with id ${tab.id} should be a boolean.`);
        }
    });
    if (screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





parcelRegister("cs58I", function(module, exports) {
$parcel$export(module.exports, "useUserPreferencesValue", () => $22623340bdbf14f6$export$8bd3660b16415efd);
$parcel$export(module.exports, "useUserPreferencesActions", () => $22623340bdbf14f6$export$eefe4b2985e8203e);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $jkWf0 = parcelRequire("jkWf0");

var $etbP7 = parcelRequire("etbP7");
const $22623340bdbf14f6$export$8bd3660b16415efd = (userPreferenceKey)=>{
    const [value, { setUserPreferenceValue: setUserPreferenceValue, deleteUserPreferenceValue: deleteUserPreferenceValue }] = (0, $jkWf0.useUserPreferencesStoreValue)(userPreferenceKey);
    /**
	 * persist: boolean - if true, save the value to the server ,else just update the local state and return a promise with the new value
	 */ const setValue = (0, $eJOHy.useCallback)((newValue, persist = true)=>{
        setUserPreferenceValue(userPreferenceKey, newValue);
        if (!persist) return Promise.resolve(newValue);
        return (0, $etbP7.saveUserPreferenceValue)(userPreferenceKey, newValue);
    }, [
        setUserPreferenceValue,
        userPreferenceKey
    ]);
    const deleteValue = (0, $eJOHy.useCallback)(()=>{
        deleteUserPreferenceValue(userPreferenceKey);
        return (0, $etbP7.removeUserPreferenceValue)(userPreferenceKey);
    }, [
        deleteUserPreferenceValue,
        userPreferenceKey
    ]);
    // As part of an experiment (jiv-21227_dev_panel_collapsibility_exp) we are introducing collapsibility to the dev panel
    // However, we need to iterate on the backend change that would see the userPreference for our collapsed state of the dev panel
    // come through Relay/Agg.
    // This fetchUserPreferenceValue is a temporary measure to be able to run our initial experiment - if successful, we will remove the below and implement the backend change
    // Please don't use this for anything else except this experiment. Reach out to https://atlassian.enterprise.slack.com/archives/C093S7Q436E
    // Please see the JIRA ticket https://jplat.atlassian.net/browse/JIV-21315 for more details.
    const fetchValue = (0, $eJOHy.useCallback)(async ()=>{
        try {
            if ((0, $cxKOj.expVal)('jiv-21227_dev_panel_collapsibility_exp', 'isEnabled', false)) {
                const serverValue = await (0, $etbP7.fetchUserPreferenceValue)(userPreferenceKey);
                if (serverValue !== null) {
                    const parsedValue = typeof serverValue === 'string' ? JSON.parse(serverValue) : serverValue;
                    setUserPreferenceValue(userPreferenceKey, parsedValue);
                    return parsedValue;
                }
            }
            return null;
        } catch (error) {
            return null;
        }
    }, [
        userPreferenceKey,
        setUserPreferenceValue
    ]);
    const setUserPreferences = (0, $eJOHy.useMemo)(()=>({
            setValue: setValue,
            deleteValue: deleteValue,
            fetchValue: fetchValue
        }), [
        setValue,
        deleteValue,
        fetchValue
    ]);
    return [
        value,
        setUserPreferences
    ];
};
const $22623340bdbf14f6$export$eefe4b2985e8203e = ()=>{
    const [, actions] = (0, $jkWf0.useUserPreferencesStoreActions)();
    const userPreferenceActions = (0, $eJOHy.useMemo)(()=>{
        const setUserPreferenceValue = (userPreferenceKey, value)=>{
            actions.setUserPreferenceValue(userPreferenceKey, value);
            (0, $etbP7.saveUserPreferenceValue)(userPreferenceKey, value);
        };
        const deleteUserPreferenceValue = (userPreferenceKey)=>{
            actions.deleteUserPreferenceValue(userPreferenceKey);
            (0, $etbP7.removeUserPreferenceValue)(userPreferenceKey);
        };
        const setUserPreferences = (userPreferences)=>{
            userPreferences && Object.keys(userPreferences).length !== 0 && actions.setUserPreferences(userPreferences);
        };
        return {
            setUserPreferenceValue: setUserPreferenceValue,
            setUserPreferences: setUserPreferences,
            deleteUserPreferenceValue: deleteUserPreferenceValue,
            getUserPreferenceValue: actions.getUserPreferenceValue
        };
    }, [
        actions
    ]);
    return [
        null,
        userPreferenceActions
    ];
};

});
parcelRegister("jkWf0", function(module, exports) {
$parcel$export(module.exports, "useUserPreferencesStoreValue", () => $97758271cd46a4b8$export$46e7eeb2fc34fab8);
$parcel$export(module.exports, "useUserPreferencesStoreActions", () => $97758271cd46a4b8$export$4d156074562bac9a);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $i64h0 = parcelRequire("i64h0");
const $97758271cd46a4b8$var$store = (0, $GtRbT.createStore)({
    name: 'user-preferences',
    initialState: {
        preferences: {}
    },
    actions: $i64h0.actions
});
const $97758271cd46a4b8$var$getUserPreference = (state, userPreferenceKey)=>state.preferences[userPreferenceKey];
const $97758271cd46a4b8$export$46e7eeb2fc34fab8 = (0, $iJq0l.createHook)($97758271cd46a4b8$var$store, {
    selector: $97758271cd46a4b8$var$getUserPreference
});
const $97758271cd46a4b8$export$4d156074562bac9a = (0, $iJq0l.createHook)($97758271cd46a4b8$var$store, {
    selector: null
});

});
parcelRegister("i64h0", function(module, exports) {
$parcel$export(module.exports, "actions", () => $343d470acbc8bd87$export$e324594224ef24da);
const $343d470acbc8bd87$var$setUserPreferenceValue = (key, value)=>({ setState: setState, getState: getState })=>{
        setState({
            preferences: {
                ...getState().preferences,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [key]: value
            }
        });
    };
const $343d470acbc8bd87$var$deleteUserPreferenceValue = (key)=>({ setState: setState, getState: getState })=>{
        const { [key]: _, ...preferences } = getState().preferences;
        setState({
            preferences: preferences
        });
    };
const $343d470acbc8bd87$var$setUserPreferences = (state)=>({ setState: setState })=>{
        setState({
            preferences: state
        });
    };
const $343d470acbc8bd87$var$getUserPreferenceValue = (key)=>({ getState: getState })=>{
        const { preferences: preferences } = getState();
        return preferences[key];
    };
const $343d470acbc8bd87$export$e324594224ef24da = {
    setUserPreferenceValue: $343d470acbc8bd87$var$setUserPreferenceValue,
    deleteUserPreferenceValue: $343d470acbc8bd87$var$deleteUserPreferenceValue,
    setUserPreferences: $343d470acbc8bd87$var$setUserPreferences,
    getUserPreferenceValue: $343d470acbc8bd87$var$getUserPreferenceValue
};

});


parcelRegister("etbP7", function(module, exports) {
$parcel$export(module.exports, "saveUserPreferenceValue", () => $a9cf1c440643deff$export$bebe1b9e9f4cbf16);
$parcel$export(module.exports, "fetchUserPreferenceValue", () => $a9cf1c440643deff$export$a3e5f8cedb0374ad);
$parcel$export(module.exports, "removeUserPreferenceValue", () => $a9cf1c440643deff$export$a60a810760d07867);

var $keOPi = parcelRequire("keOPi");

var $cxKOj = parcelRequire("cxKOj");
const $a9cf1c440643deff$export$bebe1b9e9f4cbf16 = async (userPreferenceKey, value)=>(0, $keOPi.performIssuePutRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, {
        body: value
    }, 'user-preferences-services/src/utils');
const $a9cf1c440643deff$export$a3e5f8cedb0374ad = async (userPreferenceKey)=>{
    try {
        if ((0, $cxKOj.expVal)('jiv-21227_dev_panel_collapsibility_exp', 'isEnabled', false)) {
            const response = await (0, $keOPi.performIssueGetRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, undefined, 'user-preferences-services/src/utils');
            return response;
        }
        return null;
    } catch (error) {
        // If the preference doesn't exist, return null
        return null;
    }
};
const $a9cf1c440643deff$export$a60a810760d07867 = async (userPreferenceKey)=>(0, $keOPi.performIssueDeleteRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, undefined, 'user-preferences-services/src/utils');

});


const $e8c5fe022e7e442a$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $e8c5fe022e7e442a$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $e8c5fe022e7e442a$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $e8c5fe022e7e442a$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';
const $e8c5fe022e7e442a$export$39aaf586c7ee5202 = 'jira.user.issue.user-preferred-layouts';
const $e8c5fe022e7e442a$export$25f5ee1223725a65 = 'jira.user.issue.comment-summaries.enabled';
const $e8c5fe022e7e442a$export$4936b1621439c095 = 'jira.user.issue.details.details-panel-fields-order';
const $e8c5fe022e7e442a$export$32a0b5eafccd5141 = 'jira.user.issue.comment-slack-flag.dismissed';
const $e8c5fe022e7e442a$export$ca0c9f1b6d9d892c = 'jira.user.issue.details.context-panel-fields-order';

parcelRegister("lpEwy", function(module, exports) {
$parcel$export(module.exports, "useIssueLayoutContainersStore", () => $e029db5d7fe89f63$export$5c4a1f63cea7b5b3);
$parcel$export(module.exports, "useIssueLayoutGlanceStore", () => $e029db5d7fe89f63$export$769bbe2bda9a43ce);
$parcel$export(module.exports, "useIssueLayoutContextPanelStore", () => $e029db5d7fe89f63$export$3aa9017e11451546);
$parcel$export(module.exports, "useIssueLayoutActionsStore", () => $e029db5d7fe89f63$export$5513f3c310d101f5);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $5TQFX = parcelRequire("5TQFX");
const $e029db5d7fe89f63$var$STABLE_EMPTY_CONTAINER_ARRAY = [];
const $e029db5d7fe89f63$var$getIssueViewLayoutContainers = (state, issueKey)=>state[String(issueKey)]?.containers || $e029db5d7fe89f63$var$STABLE_EMPTY_CONTAINER_ARRAY;
const $e029db5d7fe89f63$var$getIssueViewLayoutGlance = (state, issueKey)=>state[String(issueKey)]?.glance;
const $e029db5d7fe89f63$var$getIssueViewLayoutContextPanel = (state, issueKey)=>state[String(issueKey)]?.contextPanel;
// this is a global state
const $e029db5d7fe89f63$var$store = (0, $GtRbT.createStore)({
    name: 'issue-view-layout-service',
    initialState: {},
    actions: $5TQFX
});
const $e029db5d7fe89f63$export$5c4a1f63cea7b5b3 = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutContainers
});
const $e029db5d7fe89f63$export$769bbe2bda9a43ce = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutGlance
});
const $e029db5d7fe89f63$export$3aa9017e11451546 = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutContextPanel
});
const $e029db5d7fe89f63$export$5513f3c310d101f5 = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: null
});

});
parcelRegister("5TQFX", function(module, exports) {
$parcel$export(module.exports, "setIssueViewContainersLayout", () => $1fee7e98aeef55ea$export$e956c64a7167b73a);
$parcel$export(module.exports, "setIssueViewLayoutGlance", () => $1fee7e98aeef55ea$export$6a9b24c2efe66bb7);
$parcel$export(module.exports, "setIssueViewLayoutContextPanel", () => $1fee7e98aeef55ea$export$9a04e4b958ebc410);
const $1fee7e98aeef55ea$export$e956c64a7167b73a = (issueKey, containersByType)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                containers: containersByType?.containers || []
            }
        });
    };
const $1fee7e98aeef55ea$export$6a9b24c2efe66bb7 = (issueKey, glance)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                glance: glance
            }
        });
    };
const $1fee7e98aeef55ea$export$9a04e4b958ebc410 = (issueKey, contextPanel)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                contextPanel: contextPanel
            }
        });
    };

});


parcelRegister("co62F", function(module, exports) {
$parcel$export(module.exports, "getLayoutItemId", () => $f780ca908cc08c0e$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $f780ca908cc08c0e$export$355607dae809ec65);

var $5OyZl = parcelRequire("5OyZl");
const $f780ca908cc08c0e$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $5OyZl.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $5OyZl.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $5OyZl.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $f780ca908cc08c0e$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($f780ca908cc08c0e$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $5OyZl.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $f780ca908cc08c0e$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});
parcelRegister("5OyZl", function(module, exports) {
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $37dff345eecb4f05$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $37dff345eecb4f05$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $37dff345eecb4f05$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $37dff345eecb4f05$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $37dff345eecb4f05$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $37dff345eecb4f05$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $37dff345eecb4f05$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $37dff345eecb4f05$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $37dff345eecb4f05$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $37dff345eecb4f05$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $37dff345eecb4f05$export$ad3536b13febb432);
const $37dff345eecb4f05$export$99ad62164189f781 = 'ecosystemGlance';
const $37dff345eecb4f05$export$7719ef6e9283671 = 'forgeGlance';
const $37dff345eecb4f05$export$bfebea5ce2e1887a = 'ecosystemContext';
const $37dff345eecb4f05$export$be8e68fb1aed253e = 'forgeContext';
const $37dff345eecb4f05$export$7bf561e6ab380ea1 = 'context';
const $37dff345eecb4f05$export$f42c11634d75863e = 'content';
const $37dff345eecb4f05$export$b38842736b6dbc1d = 'content-request';
const $37dff345eecb4f05$export$bc9fa2d93b5fabae = 'FIELD';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$STATUS_TYPE = 'STATUS';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$TAB_TYPE = 'TAB';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$PANEL_TYPE = 'PANEL';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$FORGE_TYPE = 'FORGE';
const $37dff345eecb4f05$export$605c43f1b33ab69 = 'SUMMARY';
const $37dff345eecb4f05$export$e655b77b9efe622f = 'CustomItem';
const $37dff345eecb4f05$export$5cf403de05e9bea = 'FieldSectionItem';
const $37dff345eecb4f05$export$30f7f9a86f182492 = 'TabLayout';
const $37dff345eecb4f05$export$196e597ad9a97f7a = 'PanelSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $37dff345eecb4f05$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $37dff345eecb4f05$export$ad3536b13febb432 = (node)=>node.type === $37dff345eecb4f05$export$5507f31126c8b283.tab;

});



parcelRegister("ajyMI", function(module, exports) {
$parcel$export(module.exports, "default", () => $7febdbb69aed227c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7febdbb69aed227c$var$messages = (0, $7qGN1.defineMessages)({
    icon: {
        "id": "issue-field-parent-readview-full.parent.icon",
        "defaultMessage": "{issueType} icon"
    },
    noValueTextExperiment: {
        "id": "issue-field-parent.no-value-text-experiment",
        "defaultMessage": "Add parent"
    }
});
var $7febdbb69aed227c$export$2e2bcd8739ae039 = $7febdbb69aed227c$var$messages;

});

parcelRegister("5Cerh", function(module, exports) {
$parcel$export(module.exports, "Summary", () => $76aa50f6a6036032$export$46453a0401d6cd1a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lL4G9 = parcelRequire("lL4G9");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $1wTTU = parcelRequire("1wTTU");

var $bVyuq = parcelRequire("bVyuq");
const $76aa50f6a6036032$export$46453a0401d6cd1a = ({ disableClickAction: disableClickAction, onClick: onClick, label: label, colorKey: colorKey, issueKey: issueKey, isTruncated: isTruncated, contentRef: contentRef })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const lozengeTheme = (0, $eJOHy.useMemo)(()=>colorKey ? (0, $1wTTU.getLozengeThemeByColor)((0, $1wTTU.asColor)(colorKey)) : undefined, [
        colorKey
    ]);
    if (disableClickAction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($76aa50f6a6036032$var$WrapperNoClick // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: lozengeTheme
    }, label);
    if (onClick != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($76aa50f6a6036032$var$ButtonText, {
        onClick: onClick,
        style: lozengeTheme
    }, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    ), {
        testId: "issue-field-parent.ui.view-link",
        href: `/browse/${issueKey}`,
        "aria-label": formatMessage((0, $bVyuq.default).parentTitle, {
            label: label
        }),
        style: lozengeTheme,
        xcss: [
            $76aa50f6a6036032$var$linkTextStylesBase,
            isTruncated ? $76aa50f6a6036032$var$linkTextStylesTruncated : $76aa50f6a6036032$var$linkTextStylesNonTruncated
        ],
        ref: contentRef
    }, label);
};
const $76aa50f6a6036032$var$linkTextStylesBase = (0, $1DXK0.xcss)({
    borderRadius: "var(--ds-radius-small, 4px)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    paddingInline: 'space.050',
    paddingBlock: 'space.025',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $76aa50f6a6036032$var$linkTextStylesNonTruncated = (0, $1DXK0.xcss)({
    overflowWrap: 'anywhere'
});
const $76aa50f6a6036032$var$linkTextStylesTruncated = (0, $1DXK0.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $76aa50f6a6036032$var$ButtonText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _19itglyw _11q7glyw _11c82smr _12ji1r31 _1qu21kw7 _12y31o36 _2rkofajl _1bto1l2s _o5721q9c _syaz1kw7 _vwz47vkz _80omtlke _4t3igktf _p12f1osq _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $76aa50f6a6036032$var$WrapperNoClick = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _11c82smr _2rkofajl _1bto1l2s _o5721q9c _1e0c1ule _vwz47vkz _4t3i7vkz _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bVyuq", function(module, exports) {
$parcel$export(module.exports, "default", () => $66722d678b1a697a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $66722d678b1a697a$var$messages = (0, $7qGN1.defineMessages)({
    parentTitle: {
        "id": "issue-field-parent-readview-full.parent.summary.parent-title",
        "defaultMessage": "Click to visit {label}"
    }
});
var $66722d678b1a697a$export$2e2bcd8739ae039 = $66722d678b1a697a$var$messages;

});



parcelRegister("kev0f", function(module, exports) {
$parcel$export(module.exports, "transformOptionToAgg", () => $d2228ef4a598cc4e$export$4e115b8a3d13d179);
$parcel$export(module.exports, "transformOptionToOptimisticFieldResponse", () => $d2228ef4a598cc4e$export$728251e8d8f6eacb);

var $4cTDP = parcelRequire("4cTDP");
const $d2228ef4a598cc4e$export$4e115b8a3d13d179 = (option)=>{
    if (!option) return null;
    return {
        id: String(option?.id) || '',
        issueId: option?.issueId || '',
        webUrl: option?.webUrl || '',
        key: option?.key,
        issueColorField: {
            color: {
                colorKey: option?.color || ''
            }
        },
        issueTypeField: {
            issueType: {
                avatar: {
                    xsmall: option?.fields?.issuetype?.iconUrl || ''
                },
                name: option?.fields?.issuetype?.name || ''
            }
        },
        summaryField: {
            text: option?.fields.summary || ''
        }
    };
};
const $d2228ef4a598cc4e$export$728251e8d8f6eacb = (field, aggValue)=>{
    if ((0, $4cTDP.fg)('dfo_remove_fields_by_id')) {
        const summaryField = aggValue?.summaryField;
        const issueTypeField = aggValue?.issueTypeField;
        const statusField = aggValue?.statusField;
        return {
            id: field?.id,
            fieldId: field?.fieldId,
            type: field?.type,
            name: field?.name,
            parentIssue: aggValue ? {
                id: aggValue?.id,
                issueId: aggValue?.issueId,
                webUrl: aggValue?.webUrl,
                key: aggValue?.key,
                issueColorField: aggValue?.issueColorField,
                summaryField: {
                    id: summaryField?.id || '',
                    fieldId: summaryField?.fieldId || '',
                    text: summaryField?.text || ''
                },
                issueTypeField: {
                    id: issueTypeField?.id || '',
                    fieldId: issueTypeField?.fieldId || '',
                    issueType: {
                        id: issueTypeField?.issueType?.id || '',
                        avatar: {
                            xsmall: issueTypeField?.issueType?.avatar?.xsmall || ''
                        },
                        hierarchy: {
                            level: issueTypeField?.issueType?.hierarchy?.level || 0
                        },
                        issueTypeId: issueTypeField?.issueType?.issueTypeId || '',
                        name: issueTypeField?.issueType?.name || ''
                    }
                },
                statusField: {
                    id: statusField?.id || '',
                    fieldId: statusField?.fieldId || '',
                    status: {
                        id: statusField?.status?.id || '',
                        statusCategory: {
                            id: statusField?.status?.statusCategory?.id || '',
                            statusCategoryId: statusField?.status?.statusCategory?.statusCategoryId || ''
                        }
                    }
                }
            } : null
        };
    }
    const summaryField = aggValue?.fieldsById?.edges?.find((edge)=>edge?.node?.__typename === 'JiraSingleLineTextField');
    const issueTypeField = aggValue?.fieldsById?.edges?.find((edge)=>edge?.node?.__typename === 'JiraIssueTypeField');
    return {
        id: field?.id,
        fieldId: field?.fieldId,
        type: field?.type,
        name: field?.name,
        parentIssue: aggValue ? {
            id: aggValue?.id,
            issueId: aggValue?.issueId,
            webUrl: aggValue?.webUrl,
            key: aggValue?.key,
            issueColorField: aggValue?.issueColorField,
            fieldsById: aggValue?.fieldsById,
            summaryField: {
                id: summaryField?.node?.id || '',
                text: summaryField?.node?.text || '',
                fieldId: summaryField?.node?.fieldId || ''
            },
            issueTypeField: {
                id: issueTypeField?.node?.id || '',
                fieldId: issueTypeField?.node?.fieldId || '',
                issueType: {
                    id: issueTypeField?.node?.issueType?.id || '',
                    avatar: {
                        xsmall: issueTypeField?.node?.issueType?.avatar?.xsmall || ''
                    },
                    // Added to keep types in sync with new code path
                    hierarchy: {
                        level: issueTypeField?.node?.issueType?.hierarchy?.level || 0
                    },
                    issueTypeId: issueTypeField?.node?.issueType?.issueTypeId || '',
                    name: issueTypeField?.node?.issueType?.name || ''
                }
            }
        } : null
    };
};

});


parcelRegister("e0p2q", function(module, exports) {
$parcel$export(module.exports, "default", () => $1108666f999df9c8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $1108666f999df9c8$var$messages = (0, $7qGN1.defineMessages)({
    replacedByParentField: {
        "id": "native-issue-table.common.issue-cells.parent.replaced-by-parent-field",
        "defaultMessage": "Replaced by <strong>Parent</strong> field"
    }
});
var $1108666f999df9c8$export$2e2bcd8739ae039 = $1108666f999df9c8$var$messages;

});


parcelRegister("iCclW", function(module, exports) {
$parcel$export(module.exports, "PlainTextCell", () => $2995e0c8eb6a06ef$export$4e4b42df80bf4dce);

var $fp6Rv = parcelRequire("fp6Rv");

var $iMiU1 = parcelRequire("iMiU1");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $9t1Xl = parcelRequire("9t1Xl");

var $d9T1A = parcelRequire("d9T1A");

var $3OT15 = parcelRequire("3OT15");

var $4cTDP = parcelRequire("4cTDP");

var $8mV8n = parcelRequire("8mV8n");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $8jOO7 = parcelRequire("8jOO7");
// Attributes for inline editing track events
const $2995e0c8eb6a06ef$var$attributes = {
    // If the update was made inline (and not via the issue view)
    isInlineEditing: true
};
const $2995e0c8eb6a06ef$export$4e4b42df80bf4dce = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $iMiU1.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isDensityCompact = !(0, $34oCh.useIsDensityFull)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    const renderCustomReadView = (0, $eJOHy.useCallback)((text)=>{
        if (!text) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
        if (isSingleLineRowHeightEnabled) {
            if (hoverPopoverRefFactory) {
                let hoverPopoverRef = null;
                hoverPopoverRef = hoverPopoverRefFactory({
                    content: text
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                    ref: hoverPopoverRef,
                    maxLines: (0, $8jOO7.MAX_LINE_WRAP_NEW),
                    testId: "native-issue-table.common.ui.issue-cells.plain-text.text"
                }, text);
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            maxLines: isDensityCompact ? 2 : undefined
        }, text);
    }, [
        isDensityCompact,
        isSingleLineRowHeightEnabled,
        hoverPopoverRefFactory
    ]);
    if (!isInlineEditingExtendedFieldSupportEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2995e0c8eb6a06ef$export$8361effa71bec5d8, {
        fieldRef: data
    });
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9t1Xl.SingleLineTextInlineEditViewWithIsEditable), {
        attributes: $2995e0c8eb6a06ef$var$attributes,
        spacing: "default",
        editViewPopup: true,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $2995e0c8eb6a06ef$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        maxLength: 255,
        readViewFitContainerHeight: true,
        renderCustomReadView: isFirstField ? renderCustomReadView : undefined,
        hideEditButton: true,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled && isFirstField
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9t1Xl.SingleLineTextInlineEditViewWithIsEditable), {
        attributes: $2995e0c8eb6a06ef$var$attributes,
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        maxLength: 255,
        readViewFitContainerHeight: true,
        renderCustomReadView: renderCustomReadView,
        hideEditButton: true,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled
    });
});
const $2995e0c8eb6a06ef$export$8361effa71bec5d8 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, shouldOpenOnFirstRender: shouldOpenOnFirstRender = false })=>{
    const data = (0, $j4oe4.useFragment)((0, $fp6Rv.default), fieldRef);
    const { text: text } = data;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(shouldOpenOnFirstRender);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: text
    });
    if (isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        ref: hoverPopoverRef,
        maxLines: (0, $8jOO7.MAX_LINE_WRAP_NEW),
        testId: "native-issue-table.common.ui.issue-cells.plain-text.text"
    }, text));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8mV8n.TruncatedTextWithPopup), {
        isOpen: isOpen,
        onSetIsOpen: setIsOpen,
        // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, text),
        triggerText: text ?? null
    });
});
const $2995e0c8eb6a06ef$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $2995e0c8eb6a06ef$var$customTargetStyles : $2995e0c8eb6a06ef$var$customTargetStylesOld,
        ref: ref
    });
});
const $2995e0c8eb6a06ef$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $2995e0c8eb6a06ef$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("fp6Rv", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4b10ab29fe91d06$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a7d1c876b733b2ac680fe9f5899ea20>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d4b10ab29fe91d06$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PlainTextCellOld_PlainTextCellOld",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "text"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$d4b10ab29fe91d06$var$node.hash = "21ef2273331f78548bbf59a012bb6b51";
var $d4b10ab29fe91d06$export$2e2bcd8739ae039 = $d4b10ab29fe91d06$var$node;

});

parcelRegister("iMiU1", function(module, exports) {
$parcel$export(module.exports, "default", () => $867b457661c4e196$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0373734ffe77dec06c81d05fa1bec1ff>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $867b457661c4e196$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "PlainTextCellOld",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "PlainTextCellOld_PlainTextCellOld"
        },
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$867b457661c4e196$var$node.hash = "d9bf0805b04b32210f14fe02304844b2";
var $867b457661c4e196$export$2e2bcd8739ae039 = $867b457661c4e196$var$node;

});

parcelRegister("8mV8n", function(module, exports) {
$parcel$export(module.exports, "TruncatedTextWithPopup", () => $c45d5d8603d7c463$export$a81ef5b6e801751b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $4B7rn = parcelRequire("4B7rn");

var $8nMzv = parcelRequire("8nMzv");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $eS29z = parcelRequire("eS29z");

var $8jOO7 = parcelRequire("8jOO7");

var $lvbmo = parcelRequire("lvbmo");
const $c45d5d8603d7c463$export$a81ef5b6e801751b = /*#__PURE__*/ (0, $eJOHy.memo)(({ triggerText: triggerText, content: content, triggerRefCallback: triggerRefCallback, onSetIsOpen: onSetIsOpen, isOpen: isOpen, maxLength: maxLength = (0, $8jOO7.MAX_LINE_WRAP_OLD) })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (!triggerText) return null;
    const onClick = ()=>{
        onSetIsOpen(!isOpen);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'truncatedTextWithPopupButton');
    };
    const trigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c45d5d8603d7c463$var$TruncatedTextContainer, {
            onClick: onClick,
            ...triggerProps,
            ref: (element)=>{
                triggerRefCallback && triggerRefCallback(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref(element);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c45d5d8603d7c463$var$TruncatedText, {
            maxLength: maxLength
        }, triggerText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>onSetIsOpen(false),
        messageId: "native-issue-table.common.ui.truncated-text-cell-with-popup.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
                sourceName: "TruncatedTextPopUpContent",
                sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a)
            }, content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null)),
        trigger: trigger,
        placement: "bottom",
        popupComponent: (0, $lvbmo.PopupContainer)
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c45d5d8603d7c463$var$TruncatedTextContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11q7glyw _19itglyw _11c82smr _1rjc1b66 _18zru2gc _80omtlke _1e0c1ule _vchhusvi _syazi7uo _4t3i1osq _1bsb1osq _6sshglyw _1oex1dy8 _nt751r31 _49pcglyw _1hvw1o36 _7ehi2ef9 _irr31dpa",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c45d5d8603d7c463$var$TruncatedText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_jz2kj3": (0, $awdRS.default)(__cmplp.maxLength)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _y3gn1e5h _1e0ccj1k _1bto1l2s _sudp1e54 _1yyjpeh7 _1nmz1hna",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lvbmo", function(module, exports) {
$parcel$export(module.exports, "PopupContainer", () => $8fff991d977513ff$export$cca08eed9de89ba9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $IW7jS = parcelRequire("IW7jS");
// Workaround for https://github.com/atlassian-labs/compiled/issues/1200
const $8fff991d977513ff$var$layerValue = (0, $IW7jS.layers).layer;
/**
 * Styling the container itself removes the need for an additional nested `<div>`,
 * containing our custom styles, in the Popup content. Having an extra `<div>`
 * introduces problems with autofocus when popup is opened.
 *
 * Unfortunately the base PopupContainer styles are not exported from atlaskit,
 * so they had to be copy + pasted and extended with our custom styles.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8fff991d977513ff$var$StyledPopupContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _2rkofajl _1reo1wug _18m91wug _189edkaa _1dqonqa1 _1h6d1v1w _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs130s _1bsbdgin _c71l1kdj _1tke12am _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});
const $8fff991d977513ff$export$cca08eed9de89ba9 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8fff991d977513ff$var$StyledPopupContainer, {
        ...props,
        ref: ref
    }));

});



parcelRegister("fr65p", function(module, exports) {
$parcel$export(module.exports, "PriorityCell", () => $0a0ad7e9fcb5014b$export$b526cf238a0a0ab3);

var $gjxJ9 = parcelRequire("gjxJ9");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8sJ8t = parcelRequire("8sJ8t");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");

var $34oCh = parcelRequire("34oCh");
const $0a0ad7e9fcb5014b$export$b526cf238a0a0ab3 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $gjxJ9.default), fieldRef);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    let isEditable = false;
    if ('isEditableInIssueView' in data) isEditable = data.isEditableInIssueView;
    else if ('lazyIsEditableInIssueView' in data) isEditable = data.lazyIsEditableInIssueView;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8sJ8t.PriorityInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled
    });
});

});
parcelRegister("gjxJ9", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a515087ea8a01ce$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f3d6bfe11c8f936ac1ad55108b801dc5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1a515087ea8a01ce$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "PriorityCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isEditableSyncLoaded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditableInIssueView"
                }
            ]
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraPriorityField"
};
$1a515087ea8a01ce$var$node.hash = "3d9028ea969ee9e86affcf87707b2616";
var $1a515087ea8a01ce$export$2e2bcd8739ae039 = $1a515087ea8a01ce$var$node;

});

parcelRegister("8sJ8t", function(module, exports) {
$parcel$export(module.exports, "PriorityInlineEditViewIsEditable", () => $1e7fc42b27c29889$export$90b66d052260aa39);
$parcel$export(module.exports, "PriorityInlineEditView", () => $1e7fc42b27c29889$export$934d144304ae7d88);

var $gBBZ0 = parcelRequire("gBBZ0");

var $9iDk7 = parcelRequire("9iDk7");

var $907HD = parcelRequire("907HD");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $1IiSl = parcelRequire("1IiSl");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $d2AGn = parcelRequire("d2AGn");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $i0tCo = parcelRequire("i0tCo");

var $faRrL = parcelRequire("faRrL");

var $3OT15 = parcelRequire("3OT15");

var $gwLYs = parcelRequire("gwLYs");
const $1e7fc42b27c29889$var$isEqualPriority = (a, b)=>a?.value === b?.value;
const $1e7fc42b27c29889$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-priority-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $1e7fc42b27c29889$export$90b66d052260aa39 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isCompact: isCompact, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $907HD.default), fragmentRef);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name, priority: priority } = data;
    const hoverPopoverRefFactory = shouldRenderHoverPopover ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: data.priority?.name
    });
    const fieldName = (0, $eJOHy.useMemo)(()=>overriding?.overrideLabel(name), [
        name,
        overriding
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overriding?.overrideIsEditable(isEditable), [
        isEditable,
        overriding
    ]);
    const filterOptionsById = (0, $eJOHy.useMemo)(()=>overriding?.overrideFieldOptionsFilter(null), [
        overriding
    ]);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $9iDk7.default));
    // #endregion
    const initialValue = (0, $eJOHy.useMemo)(()=>priority ? {
            label: priority.name ?? '',
            value: priority.id,
            iconUrl: priority.iconUrl ?? ''
        } : null, [
        priority
    ]);
    // #region Common state
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        const aggValue = (0, $gwLYs.transformOptionToAgg)(option);
        onSubmit?.(aggValue);
        if (option?.value != null) commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: option?.value
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updatePriorityField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updatePriorityField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            priority: aggValue
                        }
                    }
                }
            }
        });
    }, [
        onSubmit,
        commit,
        uniqueFieldId
    ]);
    const handleSubmitSucceeded = (0, $eJOHy.useCallback)((value)=>{
        onSubmitSucceeded?.((0, $gwLYs.transformOptionToAgg)(value));
    }, [
        onSubmitSucceeded
    ]);
    const setAnalyticsAttributes = (0, $eJOHy.useCallback)((value)=>{
        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, (0, $1IiSl.getPriorityIdFromAri)(initialValue?.value), (0, $1IiSl.getPriorityIdFromAri)(value?.value));
    }, [
        fieldId,
        initialValue
    ]);
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $1e7fc42b27c29889$var$isEqualPriority,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: handleSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        clipboardComponentType: 'priority',
        setAnalyticsAttributes: setAnalyticsAttributes
    });
    const readViewContentRef = (0, $eJOHy.useRef)(null);
    const renderReadView = (0, $eJOHy.useCallback)((ref = null)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1e7fc42b27c29889$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $faRrL.PriorityReadView), {
                fragmentRef: data,
                isCompact: isCompact,
                contentRef: readViewContentRef,
                ref: ref
            })), [
        data,
        isCompact
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            openMenuOnFocus: true,
            menuPosition: menuPosition,
            filterOptionsById: filterOptionsById
        });
    const content = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
            editViewPopup: editViewPopup,
            editViewPopupAlignBlock: editViewPopupAlignBlock,
            editViewPopupMinWidth: "small",
            editViewEntryPoint: (0, $i0tCo.default),
            editViewEntryPointParams: {},
            getEditViewProps: getEditViewProps,
            fieldName: fieldName,
            hasUnsubmittedChanges: hasServerValidationError,
            invalidMessage: invalidMessage,
            isEditing: isEditing,
            isEditable: isFieldEditable,
            onCancel: handleCancel,
            onConfirm: handleConfirm,
            onEdit: handleEdit,
            onCopy: handleCopy,
            onCut: handleCut,
            onPaste: handlePaste,
            readViewFitContainerHeight: readViewFitContainerHeight,
            readView: ref ? renderReadView(ref) : renderReadView(),
            hideActionButtons: true
        });
    if (!shouldRenderHoverPopover) return content();
    return content(hoverPopoverRef);
};
const $1e7fc42b27c29889$export$934d144304ae7d88 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $gBBZ0.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1e7fc42b27c29889$export$90b66d052260aa39, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("gBBZ0", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d94dde4676cd166$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aa62d4fc64bc2c74e04363ef91ec33f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5d94dde4676cd166$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraPriorityField"
};
$5d94dde4676cd166$var$node.hash = "a5f9582db120fe1c7d1ede5d19fc0614";
var $5d94dde4676cd166$export$2e2bcd8739ae039 = $5d94dde4676cd166$var$node;

});

parcelRegister("9iDk7", function(module, exports) {
$parcel$export(module.exports, "default", () => $e21397462d892f86$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eb32ad0218f1234eb10ceea6afef44da>>
 * @relayHash afc6cf650d76ec77ae6c4e967b74c46b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e85774926933c84980d45da86dae031162c7414ce78af28e54effc3c4a04a2fa
const $e21397462d892f86$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "JiraPriority",
        "kind": "LinkedField",
        "name": "priority",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "priority_issueFieldPriority_PriorityField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPriorityFieldPayload",
                            "kind": "LinkedField",
                            "name": "updatePriorityField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraPriorityField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "priority_issueFieldPriority_PriorityField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPriorityFieldPayload",
                            "kind": "LinkedField",
                            "name": "updatePriorityField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraPriorityField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e85774926933c84980d45da86dae031162c7414ce78af28e54effc3c4a04a2fa",
            "metadata": {},
            "name": "priority_issueFieldPriority_PriorityField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$e21397462d892f86$var$node.hash = "e0f2a7894e2dd7cf045761e8324c5c39";
var $e21397462d892f86$export$2e2bcd8739ae039 = $e21397462d892f86$var$node;

});

parcelRegister("907HD", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e547a1b1cc29b5f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a915f86f984bf0d357677c111ce3d858>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5e547a1b1cc29b5f$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "priority_issueFieldPriorityReadviewFull_PriorityReadView"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v1 /*: any*/ ,
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    }
                ]
            }
        ],
        "type": "JiraPriorityField"
    };
}();
$5e547a1b1cc29b5f$var$node.hash = "d2dd68625b79ae7cbb16126a5aa64c95";
var $5e547a1b1cc29b5f$export$2e2bcd8739ae039 = $5e547a1b1cc29b5f$var$node;

});

parcelRegister("i0tCo", function(module, exports) {
$parcel$export(module.exports, "default", () => $09d00e9330fb89b3$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $09d00e9330fb89b3$var$PriorityEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("h2I6y")), {
        moduleId: "079c16d8",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $09d00e9330fb89b3$export$2e2bcd8739ae039 = $09d00e9330fb89b3$var$PriorityEditViewEntryPoint;

});
parcelRegister("h2I6y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5lDnH").then(()=>parcelRequire('hryia'));

});


parcelRegister("faRrL", function(module, exports) {
$parcel$export(module.exports, "PriorityReadView", () => $df35b4b66c4dd438$export$9ff40693dcfb2eb3);

var $f9vIb = parcelRequire("f9vIb");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $bQyn2 = parcelRequire("bQyn2");

var $d9T1A = parcelRequire("d9T1A");
const $df35b4b66c4dd438$export$9ff40693dcfb2eb3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ fragmentRef: fragmentRef, isCompact: isCompact, contentRef: contentRef }, ref)=>{
    const data = (0, $j4oe4.useFragment)((0, $f9vIb.default), fragmentRef);
    const value = data.priority;
    if (isCompact && (!value?.name || !value?.iconUrl)) return null;
    if (!value?.name || !value?.iconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df35b4b66c4dd438$var$Wrapper, {
        "data-testid": "issue-field-priority-readview-full.ui.priority.wrapper",
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQyn2.default), {
        url: value.iconUrl,
        alt: isCompact ? value.name : undefined
    }), !isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df35b4b66c4dd438$var$Text, {
        ref: contentRef
    }, value.name));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df35b4b66c4dd438$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _4t3igktf _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $df35b4b66c4dd438$var$Text = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _18u0u2gc _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("f9vIb", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8c2099afded368e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ac973913f9060bb519739c5dc997ac7d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f8c2099afded368e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "priority_issueFieldPriorityReadviewFull_PriorityReadView",
    "selections": [
        {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                }
            ]
        }
    ],
    "type": "JiraPriorityField"
};
$f8c2099afded368e$var$node.hash = "332bda8ea012bca1bc3e1ad5426cb13a";
var $f8c2099afded368e$export$2e2bcd8739ae039 = $f8c2099afded368e$var$node;

});

parcelRegister("bQyn2", function(module, exports) {
$parcel$export(module.exports, "default", () => $69a57831c94bcd51$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $69a57831c94bcd51$var$defaultIconSize = 16;
/* Represents an asynchronous icon loader that handles loading of icons from URLs with error handling.
 * It displays the icon fetched from the provided URL. In case of an error or if the URL is undefined,
 * a fallback UI component or placeholder is displayed.
 * This component accepts various props like URL, title, alt text, dimensions, and a fallback component
 * to customize the behavior and presentation of the loaded or placeholder icon.
 * The component also includes functionality to prevent the icon from being draggable.
 */ const $69a57831c94bcd51$var$AsyncIcon = /*#__PURE__*/ (0, $eJOHy.memo)(({ url: url, title: title, alt: alt, width: width, height: height, fallback: fallback })=>{
    const [isBroken, setIsBroken] = (0, $eJOHy.useState)(false);
    const onError = (0, $eJOHy.useCallback)(()=>{
        setIsBroken(true);
    }, []);
    const convertSize = (0, $eJOHy.useCallback)((size)=>size ? `${size}px` : '0', []);
    if (isBroken && fallback) return fallback();
    const convertedWidth = convertSize(width ?? $69a57831c94bcd51$var$defaultIconSize);
    const convertedHeight = convertSize(height ?? $69a57831c94bcd51$var$defaultIconSize);
    if (url) return /*#__PURE__*/ $eJOHy.createElement($69a57831c94bcd51$var$Image, {
        src: url,
        width: convertedWidth,
        height: convertedHeight,
        title: title ?? undefined,
        alt: alt ?? '',
        onError: onError,
        /**
     * Disabling dragging so drags happen on the parent instead of this icon.
     */ draggable: false,
        "data-vc": "common-components-async-icon"
    });
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            height: convertedHeight,
            width: convertedWidth
        },
        "data-testid": "common-components-async-icon.placeholder",
        className: (0, $hcewu.default)([
            "_2rkofajl _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _bfhkl4ek"
        ])
    });
});
const $69a57831c94bcd51$var$placeholderStyles = null;
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $69a57831c94bcd51$var$Image = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
$69a57831c94bcd51$var$AsyncIcon.displayName = 'AsyncIcon';
var $69a57831c94bcd51$export$2e2bcd8739ae039 = $69a57831c94bcd51$var$AsyncIcon;

});


parcelRegister("gwLYs", function(module, exports) {
$parcel$export(module.exports, "transformOptionToAgg", () => $f837a33cb89a6ac6$export$4e115b8a3d13d179);

var $1IiSl = parcelRequire("1IiSl");
const $f837a33cb89a6ac6$export$4e115b8a3d13d179 = (option)=>option ? {
        id: option.value,
        iconUrl: option.iconUrl,
        name: option.label,
        priorityId: (0, $1IiSl.getPriorityIdFromAri)(option.value)
    } : option;

});



parcelRegister("5U6Sf", function(module, exports) {
$parcel$export(module.exports, "ProjectCell", () => $2a05dff50778879d$export$a0acc7707bde1d3);

var $fYeVS = parcelRequire("fYeVS");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $11SWN = parcelRequire("11SWN");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $3OT15 = parcelRequire("3OT15");

var $34oCh = parcelRequire("34oCh");

var $86BUM = parcelRequire("86BUM");
const $2a05dff50778879d$export$a0acc7707bde1d3 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isRequired: isRequired, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const data = (0, $j4oe4.useFragment)((0, $fYeVS.default), fieldRef);
    const { project: project } = data;
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (!isRequired && project == null) return null;
    if (project == null || project.name == null || project.key == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "project",
        reason: "Missing required fields"
    });
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: project.name
    });
    if (!isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a05dff50778879d$var$AlignmentFix, {
        hasAvatar: Boolean(project.avatar?.large)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $11SWN.ProjectReadView), {
        value: {
            key: project.key,
            name: project.name,
            avatarUrls: {
                '48x48': project.avatar?.large ?? ''
            }
        },
        onClick: ()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'tableIssueLink');
        },
        isTruncated: !isDensityFull
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a05dff50778879d$var$AlignmentFix, {
        hasAvatar: Boolean(project.avatar?.large)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $11SWN.ProjectReadView), {
        value: {
            key: project.key,
            name: project.name,
            avatarUrls: {
                '48x48': project.avatar?.large ?? ''
            }
        },
        onClick: ()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'tableIssueLink');
        },
        isTruncated: !isDensityFull,
        contentRef: hoverPopoverRef
    }));
});
// The Project component has a 4px padding plus the avatar inside has a 2px invisible border that we have to account for
// Refer to: src/packages/issue/fields/project/src/ui/view/main.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a05dff50778879d$var$AlignmentFix = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasAvatar: hasAvatar, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ogwtze3t _6tinze3t _1cezze3t _m3zkze3t",
            __cmplp.hasAvatar ? "_ahbq1i6y" : "_ahbqze3t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fYeVS", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc30f935187490ec$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<74bd2c4f1dc5f0bbf77e81d505b4c61a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fc30f935187490ec$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ProjectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "large"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraProjectField"
};
$fc30f935187490ec$var$node.hash = "0010a81c0e94e4208da7772b6cf27cdc";
var $fc30f935187490ec$export$2e2bcd8739ae039 = $fc30f935187490ec$var$node;

});

parcelRegister("11SWN", function(module, exports) {
$parcel$export(module.exports, "ProjectReadView", () => $cd6933b72e61d231$export$5c3359f22f4596bc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $cd6933b72e61d231$export$5c3359f22f4596bc = ({ value: value, noValueText: noValueText, onClick: onClick, isTruncated: isTruncated = true, contentRef: contentRef })=>{
    const onClickLink = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        e.stopPropagation();
        onClick && onClick(e);
    }, [
        onClick
    ]);
    if (value === undefined || value === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $cd6933b72e61d231$var$emptyValueContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd6933b72e61d231$var$EmptyValue, {
        "data-testid": "issue-field-project.ui.view-read-view-empty-value"
    }, noValueText || ''));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const stopPropagation = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd6933b72e61d231$var$ReadViewContainer, {
        "data-component-selector": "project-read-view-container"
    }, Boolean(value.avatarUrls['48x48']) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd6933b72e61d231$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: "square",
        size: "xsmall",
        src: value.avatarUrls['48x48'],
        borderColor: "transparent",
        testId: "issue-field-project.ui.project-avatar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $cd6933b72e61d231$var$labelContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        testId: "issue-field-project.ui.view-label-link",
        onClick: onClickLink,
        onKeyUp: stopPropagation,
        onKeyDown: stopPropagation,
        href: `/projects/${value.key}`,
        xcss: [
            $cd6933b72e61d231$var$labelLinkStylesBase,
            isTruncated ? $cd6933b72e61d231$var$labelLinkStylesTruncated : $cd6933b72e61d231$var$labelLinkStylesNonTruncated
        ],
        ref: contentRef
    }, value.name)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cd6933b72e61d231$var$EmptyValue = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1rpy",
            __cmplp.className
        ])
    });
});
const $cd6933b72e61d231$var$ReadViewContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw _4cvr1h6o _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
});
const $cd6933b72e61d231$var$emptyValueContainerStyles = (0, $1DXK0.xcss)({
    paddingLeft: 'space.075',
    paddingRight: 'space.075'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cd6933b72e61d231$var$AvatarWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwxu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $cd6933b72e61d231$var$labelContainerStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    minWidth: '0',
    marginRight: 'space.100'
});
const $cd6933b72e61d231$var$labelLinkStylesBase = (0, $1DXK0.xcss)({
    display: 'inline-block',
    maxWidth: '100%',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $cd6933b72e61d231$var$labelLinkStylesTruncated = (0, $1DXK0.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $cd6933b72e61d231$var$labelLinkStylesNonTruncated = (0, $1DXK0.xcss)({
    overflowWrap: 'anywhere'
});

});


parcelRegister("36qKB", function(module, exports) {
$parcel$export(module.exports, "RadioSelectCell", () => $5e07189557c50d9d$export$fca29406b7991f70);

var $2GqSh = parcelRequire("2GqSh");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cVtVW = parcelRequire("cVtVW");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $5e07189557c50d9d$export$fca29406b7991f70 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $2GqSh.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cVtVW.RadioSelectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $5e07189557c50d9d$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        maxLines: 1,
        shouldRenderHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cVtVW.RadioSelectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        maxLines: 1,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $5e07189557c50d9d$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $5e07189557c50d9d$var$customTargetStyles : $5e07189557c50d9d$var$customTargetStylesOld,
        ref: ref
    });
});
const $5e07189557c50d9d$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $5e07189557c50d9d$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("2GqSh", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9af2bab53b7404d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3f28de48f4a4579a29fd8bd377fb7a27>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9af2bab53b7404d$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "RadioSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraRadioSelectField"
};
$f9af2bab53b7404d$var$node.hash = "a98ece099fb9c41b83161d791f1cb1c1";
var $f9af2bab53b7404d$export$2e2bcd8739ae039 = $f9af2bab53b7404d$var$node;

});

parcelRegister("cVtVW", function(module, exports) {
$parcel$export(module.exports, "RadioSelectInlineEditViewWithIsEditable", () => $b6983db111adbe70$export$75b30b2e24d95c5b);

var $4SIb3 = parcelRequire("4SIb3");

var $kaje0 = parcelRequire("kaje0");

var $78kaa = parcelRequire("78kaa");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $jF5pp = parcelRequire("jF5pp");

var $G3oln = parcelRequire("G3oln");

var $auNLL = parcelRequire("auNLL");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $b6983db111adbe70$var$isEqualOption = (a, b)=>a?.value === b?.value;
const $b6983db111adbe70$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-radio-select-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $b6983db111adbe70$export$75b30b2e24d95c5b = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, editViewPopupTarget: editViewPopupTarget, editViewPopupWidth: editViewPopupWidth, isEditable: isEditable, isEditing: startWithEditViewOpen = false, maxLines: maxLines, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $78kaa.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $kaje0.default));
    const { id: uniqueFieldId, name: name, selectedOption: selectedOption, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedOption?.label) return null;
        return {
            value: selectedOption?.value ?? '',
            label: selectedOption?.label ?? ''
        };
    }, [
        selectedOption
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(option);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: option?.value ?? null
                    }
                }
            },
            onCompleted (response) {
                if (response.jira?.updateRadioSelectField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateRadioSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedOption: {
                                id: option?.value ?? '',
                                label: option?.label ?? '',
                                value: option?.value ?? ''
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $b6983db111adbe70$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'radioSelect'
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b6983db111adbe70$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $G3oln.RadioSelectReadView), {
            fragmentRef: data,
            maxLines: maxLines,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        })), [
        data,
        maxLines,
        shouldRenderHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChangeAndConfirm,
            spacing: spacing
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $jF5pp.default),
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
};
const $b6983db111adbe70$export$2fe0a2918d206b4f = ({ fragmentRef: fragmentRef, ...props })=>{
    /**
   * This fragment should spread the inner InlineEditViewWithIsEditable fragment and read the isEditable flag from the
   * fieldConfig.
   */ const data = (0, $j4oe4.useFragment)((0, $4SIb3.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b6983db111adbe70$export$75b30b2e24d95c5b, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("4SIb3", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f76fff11fb7ba04$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a9b2d76f8b35cc5bb4a87c0769a312f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f76fff11fb7ba04$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraRadioSelectField"
};
$6f76fff11fb7ba04$var$node.hash = "dd081df58866af7dd0bb2712ac60b258";
var $6f76fff11fb7ba04$export$2e2bcd8739ae039 = $6f76fff11fb7ba04$var$node;

});

parcelRegister("kaje0", function(module, exports) {
$parcel$export(module.exports, "default", () => $afe368b03ce316dd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<09a77006108849a239b50899d995715a>>
 * @relayHash 0a9076c42b3eff02943fe0ca4c26d03d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a4bbe113bd046949ec9cd2e64f8e06f2200fcba03e659c207511757b491ce066
const $afe368b03ce316dd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "radioSelect_issueFieldRadioSelect_RadioSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRadioSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateRadioSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraRadioSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "radioSelect_issueFieldRadioSelect_RadioSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRadioSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateRadioSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraRadioSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraOption",
                                            "kind": "LinkedField",
                                            "name": "selectedOption",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "label",
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "alias": "value",
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a4bbe113bd046949ec9cd2e64f8e06f2200fcba03e659c207511757b491ce066",
            "metadata": {},
            "name": "radioSelect_issueFieldRadioSelect_RadioSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$afe368b03ce316dd$var$node.hash = "c21145b09e3422aaf4c5cef7684d37b2";
var $afe368b03ce316dd$export$2e2bcd8739ae039 = $afe368b03ce316dd$var$node;

});

parcelRegister("78kaa", function(module, exports) {
$parcel$export(module.exports, "default", () => $864e947ae5fb2750$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<59c263de72de7e78a494bb2126d6f5c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $864e947ae5fb2750$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "FragmentSpread",
            "name": "radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView"
        },
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "selectedOption",
            "plural": false,
            "selections": [
                {
                    "alias": "value",
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "alias": "label",
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ],
    "type": "JiraRadioSelectField"
};
$864e947ae5fb2750$var$node.hash = "e7794cc18631c54a9305078af2e6b52a";
var $864e947ae5fb2750$export$2e2bcd8739ae039 = $864e947ae5fb2750$var$node;

});

parcelRegister("jF5pp", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f9c80b6cdc9f62d$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $5f9c80b6cdc9f62d$var$RadioSelectEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("4ZzeW")), {
        moduleId: "d70243cc",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $5f9c80b6cdc9f62d$export$2e2bcd8739ae039 = $5f9c80b6cdc9f62d$var$RadioSelectEditViewEntryPoint;

});
parcelRegister("4ZzeW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jKXeZ").then(()=>parcelRequire('6OxSZ'));

});


parcelRegister("G3oln", function(module, exports) {
$parcel$export(module.exports, "RadioSelectReadView", () => $e7c58c6de3805c49$export$6455a2bb536ab8db);

var $lssY3 = parcelRequire("lssY3");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $d9T1A = parcelRequire("d9T1A");

var $3OT15 = parcelRequire("3OT15");
const $e7c58c6de3805c49$export$6455a2bb536ab8db = ({ fragmentRef: fragmentRef, maxLines: maxLines, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $lssY3.default), fragmentRef);
    const { selectedOption: selectedOption } = data;
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = shouldRenderHoverPopover ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (!selectedOption?.label) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: selectedOption?.label
    });
    if (shouldRenderHoverPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: maxLines,
        ref: hoverPopoverRef
    }, selectedOption?.label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: maxLines,
        ref: contentRef
    }, selectedOption?.label);
};

});
parcelRegister("lssY3", function(module, exports) {
$parcel$export(module.exports, "default", () => $b537fab79a813286$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d71d2b7baf0cb219c867813927a678df>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b537fab79a813286$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "selectedOption",
            "plural": false,
            "selections": [
                {
                    "alias": "label",
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ],
    "type": "JiraRadioSelectField"
};
$b537fab79a813286$var$node.hash = "b7cbd05b4ede163325935a84f69fdb87";
var $b537fab79a813286$export$2e2bcd8739ae039 = $b537fab79a813286$var$node;

});




parcelRegister("j5nH8", function(module, exports) {
$parcel$export(module.exports, "RequestTypeCell", () => $36b3f5de090b8472$export$f5707174b12c16a9);

var $55NqW = parcelRequire("55NqW");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $3OT15 = parcelRequire("3OT15");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");
const $36b3f5de090b8472$var$REQUEST_TYPE_IMAGE_SIZE = 16;
const $36b3f5de090b8472$export$f5707174b12c16a9 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $55NqW.default), fieldRef);
    const { requestType: requestType } = data;
    const hoverPopoverEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = hoverPopoverEnabled ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (!requestType) return null;
    if (!requestType.name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "requestType",
        reason: "Missing required fields"
    });
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: requestType.name
    });
    const content = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            alignBlock: "center",
            space: "space.100",
            ref: ref
        }, requestType?.avatar?.xsmall && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $36b3f5de090b8472$var$imageContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
            src: requestType.avatar.xsmall,
            width: $36b3f5de090b8472$var$REQUEST_TYPE_IMAGE_SIZE,
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "span",
            xcss: hoverPopoverEnabled ? $36b3f5de090b8472$var$textEllipsesStyles : $36b3f5de090b8472$var$textOverflowStyles,
            ref: contentRef
        }, requestType.name));
    if (hoverPopoverEnabled) return content(hoverPopoverRef);
    return content();
});
const $36b3f5de090b8472$var$imageContainerStyles = (0, $1DXK0.xcss)({
    display: 'inline',
    height: `${$36b3f5de090b8472$var$REQUEST_TYPE_IMAGE_SIZE}px`
});
const $36b3f5de090b8472$var$textOverflowStyles = (0, $1DXK0.xcss)({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word'
});
const $36b3f5de090b8472$var$textEllipsesStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordBreak: 'break-word'
});

});
parcelRegister("55NqW", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7c88e62cbc611c3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7849ca920a13f704e862bf49c3ec6adf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a7c88e62cbc611c3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RequestTypeCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraServiceManagementRequestType",
            "kind": "LinkedField",
            "name": "requestType",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "xsmall"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraServiceManagementRequestTypeField"
};
$a7c88e62cbc611c3$var$node.hash = "45180e31ad2753123d699f3c255083f3";
var $a7c88e62cbc611c3$export$2e2bcd8739ae039 = $a7c88e62cbc611c3$var$node;

});


parcelRegister("fAn1n", function(module, exports) {
$parcel$export(module.exports, "ResolutionCell", () => $40f067083f8f391c$export$8b67413bfec99fe);

var $boyH3 = parcelRequire("boyH3");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $3OT15 = parcelRequire("3OT15");

var $34oCh = parcelRequire("34oCh");

var $iOUbG = parcelRequire("iOUbG");
const $40f067083f8f391c$export$8b67413bfec99fe = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $boyH3.default), fieldRef);
    const { resolution: resolution } = data;
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    const text = resolution?.name ?? formatMessage((0, $iOUbG.default).unresolved);
    if (!isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($40f067083f8f391c$var$Cell, {
        "data-vc": "native-issue-table-ui-resolution-cell"
    }, text);
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: text
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($40f067083f8f391c$var$Cell, {
        "data-vc": "native-issue-table-ui-resolution-cell",
        ref: hoverPopoverRef
    }, text);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $40f067083f8f391c$var$Cell = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("boyH3", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba418895cfbd7314$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aeab19412c3a97981e1a0c8d007b9ef0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ba418895cfbd7314$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ResolutionCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraResolution",
            "kind": "LinkedField",
            "name": "resolution",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraResolutionField"
};
$ba418895cfbd7314$var$node.hash = "4449f0b7b9830682d20e8224a7da5b31";
var $ba418895cfbd7314$export$2e2bcd8739ae039 = $ba418895cfbd7314$var$node;

});

parcelRegister("iOUbG", function(module, exports) {
$parcel$export(module.exports, "default", () => $d76f5b91cdad1216$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d76f5b91cdad1216$var$messages = (0, $7qGN1.defineMessages)({
    unresolved: {
        "id": "native-issue-table.common.issue-cells.resolution.unresolved",
        "defaultMessage": "Unresolved"
    }
});
var $d76f5b91cdad1216$export$2e2bcd8739ae039 = $d76f5b91cdad1216$var$messages;

});


parcelRegister("gfFaI", function(module, exports) {
$parcel$export(module.exports, "RichTextCell", () => $d830ff7abe2ae704$export$b77590c339790c17);

var $kNqNh = parcelRequire("kNqNh");

var $782SB = parcelRequire("782SB");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7ep4S = parcelRequire("7ep4S");

var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $3cMgR = parcelRequire("3cMgR");

var $dk7W5 = parcelRequire("dk7W5");

var $cHtIB = parcelRequire("cHtIB");

var $iWvkh = parcelRequire("iWvkh");

var $9Mapt = parcelRequire("9Mapt");

var $cBavF = parcelRequire("cBavF");

var $ibVOD = parcelRequire("ibVOD");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");

var $5Rrfi = parcelRequire("5Rrfi");

var $8ia30 = parcelRequire("8ia30");

var $9Ubc3 = parcelRequire("9Ubc3");

var $g2AHA = parcelRequire("g2AHA");
const $d830ff7abe2ae704$export$b77590c339790c17 = /*#__PURE__*/ (0, $eJOHy.memo)(({ issueKey: issueKey, fieldRef: fieldRef, issueRef: issueRef, shouldOpenOnFirstRender: shouldOpenOnFirstRender = false, isFirstField: isFirstField })=>{
    const { richText: richText, fieldId: fieldId } = (0, $j4oe4.useFragment)((0, $782SB.default), fieldRef);
    const issueData = (0, $j4oe4.useFragment)((0, $kNqNh.default), issueRef || null);
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            fieldId: fieldId,
            issueKey: issueKey,
            cloudId: cloudId
        }), [
        fieldId,
        cloudId,
        issueKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $9Ubc3.richTextPopUpContentEntryPoint), entryPointParams);
    if (isSingleLineRowHeightEnabled && !isDensityFull) {
        const previewText = richText?.adfValue?.convertedPlainText?.plainText;
        if (!isFirstField) return /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
            xcss: $d830ff7abe2ae704$var$readOnlyNoPopoverStyles
        }, /*#__PURE__*/ $eJOHy.createElement((0, $3cMgR.default), {
            maxLines: 1
        }, previewText));
        return /*#__PURE__*/ $eJOHy.createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.CellHoverRenderer), null, (props)=>/*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.HoverPopoverWithContext), {
                content: previewText && /*#__PURE__*/ $eJOHy.createElement((0, $cBavF.JiraEntryPointContainer), {
                    entryPointReferenceSubject: entryPointReferenceSubject,
                    id: "rich-text-popup-content",
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    errorFallback: ()=>/*#__PURE__*/ $eJOHy.createElement((0, $g2AHA.ErrorState), null),
                    fallback: /*#__PURE__*/ $eJOHy.createElement((0, $7ep4S.default), {
                        size: "medium"
                    }),
                    runtimeProps: {}
                }),
                entryPointActions: entryPointActions,
                isInteractive: true // Applying a fixed width when the content contains media (e.g images) to prevent the popover from collapsing
                ,
                // when the popup only contains a single image or an image with a small amount of text
                isFixedWidth: previewText?.includes('[media]'),
                analyticsAttributes: {
                    cellType: 'rich-text'
                }
            }, ({ ref: ref })=>/*#__PURE__*/ $eJOHy.createElement((0, $bQP4O.default), {
                    xcss: $d830ff7abe2ae704$var$richTextCellWrapperStyles,
                    ref: ref,
                    ...props
                }, previewText))));
    }
    if (isDensityFull) return /*#__PURE__*/ $eJOHy.createElement((0, $8ia30.RichTextCellFull), {
        issueKey: issueKey,
        richText: richText?.adfValue?.json || (0, $dk7W5.emptyAdfObject),
        canBeExported: issueData?.canBeExported
    });
    return /*#__PURE__*/ $eJOHy.createElement((0, $5Rrfi.RichTextCellCompact), {
        fieldId: fieldId,
        plainText: richText?.adfValue?.convertedPlainText?.plainText || '',
        issueKey: issueKey,
        shouldOpenOnFirstRender: shouldOpenOnFirstRender
    });
});
const $d830ff7abe2ae704$var$richTextCellWrapperStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    display: 'block',
    backgroundColor: 'color.background.neutral.subtle',
    boxSizing: 'border-box',
    height: '100%',
    font: 'font.body',
    width: '100%',
    textAlign: 'left',
    borderWidth: 'border.width.focused',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    // @ts-expect-error Transparent is not valid but should be
    borderColor: 'transparent',
    ':focus': {
        borderColor: 'color.border.focused',
        outline: 'none'
    }
});
const $d830ff7abe2ae704$var$readOnlyNoPopoverStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    display: 'block',
    backgroundColor: 'color.background.neutral.subtle',
    boxSizing: 'border-box',
    height: '100%',
    font: 'font.body',
    width: '100%',
    textAlign: 'left',
    borderWidth: 'border.width.focused',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    // @ts-expect-error Transparent is not valid but should be
    borderColor: 'transparent',
    ':focus': {
        borderColor: 'color.border.focused',
        outline: 'none'
    }
});

});
parcelRegister("kNqNh", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a40d17426d8e7e0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f044573e2242b448613b0f9ebd46dad3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4a40d17426d8e7e0$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        }
    ],
    "kind": "Fragment",
    "name": "RichTextCell_issue",
    "selections": [
        {
            "condition": "isDensityFull",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canBeExported"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$4a40d17426d8e7e0$var$node.hash = "738c991e06df9ecde7051ba2a1a384c0";
var $4a40d17426d8e7e0$export$2e2bcd8739ae039 = $4a40d17426d8e7e0$var$node;

});

parcelRegister("782SB", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccfa7cd1077c2ac2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8081e5694135a10cc62137e48c7fc6e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ccfa7cd1077c2ac2$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        }
    ],
    "kind": "Fragment",
    "name": "RichTextCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "concreteType": "JiraRichText",
            "kind": "LinkedField",
            "name": "richText",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraADF",
                    "kind": "LinkedField",
                    "name": "adfValue",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isDensityFull",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "JiraAdfToConvertedPlainText",
                                    "kind": "LinkedField",
                                    "name": "convertedPlainText",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "plainText"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isDensityFull",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "json"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraRichTextField"
};
$ccfa7cd1077c2ac2$var$node.hash = "6f3718a989b4562bd8841af8ae1ead93";
var $ccfa7cd1077c2ac2$export$2e2bcd8739ae039 = $ccfa7cd1077c2ac2$var$node;

});

parcelRegister("dk7W5", function(module, exports) {
$parcel$export(module.exports, "emptyAdfObject", () => $330901af3cc572d4$export$202742e99f678c60);
$parcel$export(module.exports, "removeCollectionFromAdf", () => $330901af3cc572d4$export$9e9311e676291037);
$parcel$export(module.exports, "convertAdfStringToObject", () => $330901af3cc572d4$export$ee70d4eb14697455);
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $330901af3cc572d4$export$cf4bde415465976c);
$parcel$export(module.exports, "removeNewLineCharactersFromAdf", () => $330901af3cc572d4$export$d6ce0667c33b94ff);
$parcel$export(module.exports, "removeTrailingNewLineCharacters", () => $330901af3cc572d4$export$3688e35a300432d6);
$parcel$export(module.exports, "simplifyAdf", () => $330901af3cc572d4$export$def86d25f0c7f0bc);
$parcel$export(module.exports, "hasEmojiNode", () => $330901af3cc572d4$export$8c6c40d1455b914a);
$parcel$export(module.exports, "hasMediaFileNodes", () => $330901af3cc572d4$export$9a632b58fb9b287c);
$parcel$export(module.exports, "hasMediaFileNodesUpdated", () => $330901af3cc572d4$export$80a6e90c7b29d88c);

var $fpoq4 = parcelRequire("fpoq4");
var $0mclG = parcelRequire("0mclG");

var $eSnSE = parcelRequire("eSnSE");
const $330901af3cc572d4$export$202742e99f678c60 = {
    type: 'doc',
    version: 1,
    content: []
};
const $330901af3cc572d4$export$9e9311e676291037 = (adf)=>{
    if (adf === null || adf === undefined) return null;
    if (adf.type === 'media' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.type === 'mediaInline' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.content) return {
        ...adf,
        content: adf.content.map($330901af3cc572d4$export$9e9311e676291037)
    };
    return adf;
};
const $330901af3cc572d4$export$ee70d4eb14697455 = (adf)=>{
    if (typeof adf === 'string') try {
        return $330901af3cc572d4$export$9e9311e676291037(JSON.parse(adf));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
        return null;
    }
    return $330901af3cc572d4$export$9e9311e676291037(adf);
};
const $330901af3cc572d4$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
        if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
        return false;
    }) : false;
const $330901af3cc572d4$export$d6ce0667c33b94ff = (adf)=>{
    if (!adf || !adf.content) return $330901af3cc572d4$export$202742e99f678c60;
    let len;
    for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
        // if the last item of the node is of type mediaGroup, we don't want to strip newline character as
        // it practically makes it unclickable. Leave a new line character so there is still some space for ppl to click
        if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
    }
    return {
        ...adf,
        content: adf.content.slice(0, len + 1)
    };
};
const $330901af3cc572d4$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
const $330901af3cc572d4$export$def86d25f0c7f0bc = (adf)=>$330901af3cc572d4$export$cf4bde415465976c(adf) ? $330901af3cc572d4$export$202742e99f678c60 : adf;
const $330901af3cc572d4$export$8c6c40d1455b914a = (doc)=>{
    let hasEmoji = false;
    (0, $0mclG.traverse)(doc, {
        emoji: ()=>{
            hasEmoji = true;
            return false; // stop traversing
        }
    });
    return hasEmoji;
};
const $330901af3cc572d4$export$9a632b58fb9b287c = (doc)=>{
    const mediaNodes = new Map();
    (0, $0mclG.traverse)(doc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            mediaNodes.set(mediaNode.attrs.id, node);
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            mediaNodes.set(mediaInlineNode.attrs.id, node);
        }
    });
    return mediaNodes.size > 0;
};
const $330901af3cc572d4$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
    const currentMediaNodes = new Set();
    const newMediaNodes = new Set();
    const updatedMediaNodes = new Set();
    if (newDoc) (0, $0mclG.traverse)(newDoc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            newMediaNodes.add(mediaNode.attrs.id);
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            newMediaNodes.add(mediaInlineNode.attrs.id);
        }
    });
    if (currentDoc) (0, $0mclG.traverse)(currentDoc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            currentMediaNodes.add(mediaNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
            }
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            currentMediaNodes.add(mediaInlineNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
            }
        }
    });
    return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
};
const $330901af3cc572d4$export$ddf077301434502d = (doc)=>{
    if (doc === null || doc === undefined) return false;
    const nonSimpleTextNodes = (0, $fpoq4.filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
    return nonSimpleTextNodes.length === 0;
};



const $330901af3cc572d4$export$2277e89f0b6d4ed = async (node)=>{
    // the imports here were kept async so as not to blow the bundle sizes for everyone
    const { defaultSchema: defaultSchema } = await Promise.resolve((parcelRequire("g1bVT")));
    const { WikiMarkupTransformer: WikiMarkupTransformer } = await (parcelRequire("YTj3q"));
    const { JSONTransformer: JSONTransformer } = await Promise.resolve((parcelRequire("lovmf")));
    const jsonTransformer = new JSONTransformer();
    const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
    if (node === null || node === undefined) return '';
    const pmNode = jsonTransformer.parse(node);
    return wikiMarkupTransformer.encode(pmNode);
};

});
parcelRegister("fpoq4", function(module, exports) {
$parcel$export(module.exports, "filter", () => $01d8b182e291a8c9$export$3dea766d36a8935f);

var $0mclG = parcelRequire("0mclG");
function $01d8b182e291a8c9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $0mclG.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});

parcelRegister("YTj3q", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7r7tG").then(()=>parcelRequire('dmYzn'));

});


parcelRegister("5Rrfi", function(module, exports) {
$parcel$export(module.exports, "RichTextCellCompact", () => $d1b17c4c3bf914ca$export$367da69f6099f447);

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");

var $dZ3jN = parcelRequire("dZ3jN");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $cHtIB = parcelRequire("cHtIB");

var $8jOO7 = parcelRequire("8jOO7");

var $8mV8n = parcelRequire("8mV8n");

var $g2AHA = parcelRequire("g2AHA");

var $9Ubc3 = parcelRequire("9Ubc3");
const $d1b17c4c3bf914ca$var$runtimeProps = {};
const $d1b17c4c3bf914ca$export$367da69f6099f447 = /*#__PURE__*/ (0, $eJOHy.memo)(({ issueKey: issueKey, fieldId: fieldId, plainText: plainText, shouldOpenOnFirstRender: shouldOpenOnFirstRender = false })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            fieldId: fieldId,
            issueKey: issueKey,
            cloudId: cloudId
        }), [
        fieldId,
        cloudId,
        issueKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $9Ubc3.richTextPopUpContentEntryPoint), entryPointParams);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(shouldOpenOnFirstRender);
    const triggerRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8mV8n.TruncatedTextWithPopup), {
        triggerText: plainText,
        triggerRefCallback: triggerRef,
        isOpen: isOpen,
        onSetIsOpen: setIsOpen,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "rich-text-popup-content",
            packageName: (0, $8jOO7.PACKAGE_NAME),
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g2AHA.ErrorState), null),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                size: "medium"
            }),
            runtimeProps: $d1b17c4c3bf914ca$var$runtimeProps
        })
    });
});

});
parcelRegister("g2AHA", function(module, exports) {
$parcel$export(module.exports, "ErrorState", () => $96069305cd4df334$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $80DPg = parcelRequire("80DPg");

var $lRq8t = parcelRequire("lRq8t");

var $91wBH = parcelRequire("91wBH");

var $BE68B = parcelRequire("BE68B");
const $96069305cd4df334$export$c1ed4f415b9e7023 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($96069305cd4df334$var$StyledBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $BE68B.StyledText), null, formatMessage((0, $91wBH.default).errorMessage)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $96069305cd4df334$var$StyledBox = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _1tkeqkoa _1bah1h6o _19pkutpp _2hwx1ejb _otyrpxbi _18u01ejb _w8l5t9kd _1752t9kd",
            __cmplp.className
        ])
    });
});

});
parcelRegister("91wBH", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab34034d18cfc120$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ab34034d18cfc120$var$messages = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "native-issue-table.common.issue-cells.rich-text.error-state.error-message",
        "defaultMessage": "Something went wrong. Close and re-open this modal to try again."
    }
});
var $ab34034d18cfc120$export$2e2bcd8739ae039 = $ab34034d18cfc120$var$messages;

});

parcelRegister("BE68B", function(module, exports) {
$parcel$export(module.exports, "StyledText", () => $363421016b666d27$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $363421016b666d27$var$StyledTextComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $363421016b666d27$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($363421016b666d27$var$StyledTextComponent, props));

});


parcelRegister("9Ubc3", function(module, exports) {
$parcel$export(module.exports, "richTextPopUpContentEntryPoint", () => $bc94eab26320dc93$export$6c4574991456a42);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $d2SoN = parcelRequire("d2SoN");

const $bc94eab26320dc93$export$6c4574991456a42 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("h6ReS")), {
        moduleId: "81e41861",
        moduleName: "RichTextPopUpContent",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueKey: issueKey, fieldId: fieldId, cloudId: cloudId })=>({
            queries: {
                richTextContent: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $d2SoN.default,
                    variables: {
                        issueKey: issueKey,
                        fieldId: fieldId,
                        cloudId: cloudId
                    }
                }
            },
            extraProps: {
                issueKey: issueKey
            }
        })
});

});
parcelRegister("d2SoN", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a9e796547d21e78$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<caf203e6d50a85931ae87b988e667ad9>>
 * @relayHash 9766437351d45e8f988f1b9517f8d95d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fc6f224a2d810f0aa1a2e6a2edece177fe4fa2839dd95a4fd3010d3ce09f146c
const $7a9e796547d21e78$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fc6f224a2d810f0aa1a2e6a2edece177fe4fa2839dd95a4fd3010d3ce09f146c",
        "metadata": {},
        "name": "RichTextPopUpContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7a9e796547d21e78$export$2e2bcd8739ae039 = $7a9e796547d21e78$var$node;

});

parcelRegister("h6ReS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4ukIY").then(()=>parcelRequire('PEC4K'));

});



parcelRegister("8ia30", function(module, exports) {
$parcel$export(module.exports, "RichTextCellFull", () => $78462eb2a4e30a43$export$e41920e4ba1d08f2);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $jZFgr = parcelRequire("jZFgr");

var $JHcTN = parcelRequire("JHcTN");
const $78462eb2a4e30a43$export$e41920e4ba1d08f2 = /*#__PURE__*/ (0, $eJOHy.memo)(({ richText: richText, issueKey: issueKey, canBeExported: canBeExported })=>{
    const viewContext = (0, $jZFgr.useLazyMediaViewContext)(issueKey);
    const disableMediaDownload = canBeExported === false && (0, $4cTDP.fg)('block_attachment_download_on_data_export_dsp_rule');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $78462eb2a4e30a43$var$richTextCellWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $JHcTN.AsyncRichTextRenderer), {
        mediaContext: {
            viewContext: viewContext,
            uploadContext: null,
            userAuth: null
        },
        adfDocument: richText,
        disableMediaDownload: disableMediaDownload
    }));
});
const $78462eb2a4e30a43$var$richTextCellWrapperStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100'
});

});
parcelRegister("JHcTN", function(module, exports) {
$parcel$export(module.exports, "AsyncRichTextRenderer", () => $2b5fe3805c761c54$export$7e19ac09148aecfa);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $2b5fe3805c761c54$var$LazyRichTextRenderer = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("jreQK")), {
    moduleId: "./src/packages/platform/ui/issue-table/issue-table/src/common/ui/issue-cells/rich-text/rich-text-renderer/main.tsx"
});
const $2b5fe3805c761c54$export$7e19ac09148aecfa = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-rich-text-renderer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2b5fe3805c761c54$var$LazyRichTextRenderer, props));

});
parcelRegister("jreQK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2mJlZ").then(()=>parcelRequire('1H71o'));

});




parcelRegister("48WLd", function(module, exports) {
$parcel$export(module.exports, "SingleSelectCell", () => $1bf4e72dcfd00f2d$export$2574fb9bde9d7289);

var $1MnpO = parcelRequire("1MnpO");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k89l2 = parcelRequire("k89l2");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $1bf4e72dcfd00f2d$export$2574fb9bde9d7289 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $1MnpO.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k89l2.SingleSelectInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $1bf4e72dcfd00f2d$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        shouldShowPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k89l2.SingleSelectInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        shouldShowPopover: isSingleLineRowHeightEnabled
    });
};
const $1bf4e72dcfd00f2d$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $1bf4e72dcfd00f2d$var$customTargetStyles : $1bf4e72dcfd00f2d$var$customTargetStylesOld,
        ref: ref
    });
});
const $1bf4e72dcfd00f2d$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $1bf4e72dcfd00f2d$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("1MnpO", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb6cea05aaa1845c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1dd129c9d299987d365a3a5e652a15dc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bb6cea05aaa1845c$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "SingleSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectField"
};
$bb6cea05aaa1845c$var$node.hash = "282a9c597323dd65c2d74f5aba75a7ad";
var $bb6cea05aaa1845c$export$2e2bcd8739ae039 = $bb6cea05aaa1845c$var$node;

});

parcelRegister("k89l2", function(module, exports) {
$parcel$export(module.exports, "SingleSelectInlineEditView", () => $0cdfb48f3eeb9c25$export$dd40a625fe2da362);
$parcel$export(module.exports, "SingleSelectInlineEditViewIsEditable", () => $0cdfb48f3eeb9c25$export$abac8bafb7f6b6d4);

var $llxvo = parcelRequire("llxvo");

var $3JT6D = parcelRequire("3JT6D");

var $cHrh5 = parcelRequire("cHrh5");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $h6i8k = parcelRequire("h6i8k");

var $4EKqI = parcelRequire("4EKqI");

var $3edXJ = parcelRequire("3edXJ");

var $99gun = parcelRequire("99gun");

var $4s7iN = parcelRequire("4s7iN");

var $auNLL = parcelRequire("auNLL");

var $fmLhX = parcelRequire("fmLhX");

var $fkc6h = parcelRequire("fkc6h");

var $bJscI = parcelRequire("bJscI");
const $0cdfb48f3eeb9c25$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-single-select-lite-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Check if the new selected value is equal to the old value */ const $0cdfb48f3eeb9c25$var$isEqualSelection = (a, b)=>a?.value === b?.value;
const $0cdfb48f3eeb9c25$export$dd40a625fe2da362 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $cHrh5.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0cdfb48f3eeb9c25$export$abac8bafb7f6b6d4, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};
const $0cdfb48f3eeb9c25$export$abac8bafb7f6b6d4 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupWidth: editViewPopupWidth, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, spacing: spacing = 'compact', menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, readViewFitContainerHeight: readViewFitContainerHeight, isEditable: isEditable, shouldShowPopover: shouldShowPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $3JT6D.default), fragmentRef);
    const { enrichCommitWithIssueExperienceMonitoring: enrichCommitWithIssueExperienceMonitoring } = (0, $fkc6h.useIssueExperienceMonitoring)();
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $llxvo.default));
    const { id: uniqueFieldId, name: name, fieldOption: fieldOption, fieldId: fieldId, type: fieldType } = data;
    // #endregion Relay
    // #region State
    const initialValue = (0, $eJOHy.useMemo)(()=>fieldOption ? {
            label: fieldOption.value ?? '',
            value: fieldOption.id ?? '',
            optionId: fieldOption.optionId ?? ''
        } : null, [
        fieldOption
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable, overrideFieldOptionsFilter: overrideFieldOptionsFilter } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const filterOptionsById = (0, $eJOHy.useMemo)(()=>overrideFieldOptionsFilter(null), [
        overrideFieldOptionsFilter
    ]);
    // #endregion State
    // #region Action
    const handleSubmit = (0, $eJOHy.useCallback)((newOption, { onSuccess: onSuccess, onFail: onFail })=>{
        (0, $h6i8k.default)('issue.field.select.edit');
        onSubmit?.(newOption);
        commit(enrichCommitWithIssueExperienceMonitoring({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: newOption?.value ?? null
                    }
                }
            },
            onCompleted: (response)=>{
                if (response.jira?.updateSingleSelectField?.success) onSuccess();
                else {
                    const errorMessage = response.jira?.updateSingleSelectField?.errors?.[0]?.message ?? undefined;
                    errorMessage ? onFail(new Error(`Relay error encountered while updating single select field - ${errorMessage}`), errorMessage) : onFail();
                }
            },
            onError: (error)=>onFail(error, error.message),
            optimisticResponse: {
                jira: {
                    updateSingleSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: name,
                            fieldId: fieldId,
                            type: fieldType,
                            fieldOption: newOption ? {
                                id: newOption.value,
                                optionId: newOption.optionId,
                                value: newOption.label,
                                color: newOption.color ? {
                                    colorKey: newOption.color.colorKey,
                                    id: null
                                } : null
                            } : null
                        }
                    }
                }
            }
        }, 'lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation', {
            sendUFOEvent: true
        }));
    }, [
        commit,
        fieldId,
        fieldType,
        name,
        onSubmit,
        uniqueFieldId,
        enrichCommitWithIssueExperienceMonitoring
    ]);
    const actions = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        isValueEqual: $0cdfb48f3eeb9c25$var$isEqualSelection,
        clipboardComponentType: 'singleSelect'
    });
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = actions;
    // #endregion Action
    // #region View
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0cdfb48f3eeb9c25$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fmLhX.SingleSelectReadView), {
            fieldType: fieldType,
            fragmentRef: data,
            shouldShowPopover: shouldShowPopover
        })), [
        data,
        fieldType,
        shouldShowPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            fieldId: uniqueFieldId,
            fieldType: fieldType,
            fieldName: fieldName,
            autoFocus: true,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChangeAndConfirm,
            filterOptionsById: filterOptionsById,
            spacing: spacing,
            openMenuOnFocus: true
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $3edXJ.default),
        editViewEntryPointParams: {
            id: uniqueFieldId,
            filterById: filterOptionsById
        },
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: shouldShowPopover
    });
// #endregion View
};

});
parcelRegister("llxvo", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a179e3023fae32c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c5c7d0d88301d21f5ef6ef214f9bf88b>>
 * @relayHash 3b13ce5a1ead386852d30e6220d696ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 351e8ed663fceca6c76060046675d36c2ba86b6cbb1bd318c7ce386827de46fd
const $7a179e3023fae32c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraOption",
                                            "kind": "LinkedField",
                                            "name": "fieldOption",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                {
                                                    "concreteType": "JiraColor",
                                                    "kind": "LinkedField",
                                                    "name": "color",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "colorKey"
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "optionId"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "351e8ed663fceca6c76060046675d36c2ba86b6cbb1bd318c7ce386827de46fd",
            "metadata": {},
            "name": "lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$7a179e3023fae32c$var$node.hash = "4efc8e08a4925bceb3af2c617ed6d9ee";
var $7a179e3023fae32c$export$2e2bcd8739ae039 = $7a179e3023fae32c$var$node;

});

parcelRegister("3JT6D", function(module, exports) {
$parcel$export(module.exports, "default", () => $647a59e0e919edbc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf08ad1c8fb2273d225a10ddb1a04bd8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $647a59e0e919edbc$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView"
            },
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "fieldOption",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "optionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectField"
    };
}();
$647a59e0e919edbc$var$node.hash = "28f321ab534b072c7deae95a3905b5dd";
var $647a59e0e919edbc$export$2e2bcd8739ae039 = $647a59e0e919edbc$var$node;

});

parcelRegister("cHrh5", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e689b08be7fdc0b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<608f4af1a5cabdbfcda4b6156bf47821>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7e689b08be7fdc0b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectField"
};
$7e689b08be7fdc0b$var$node.hash = "91dade2591d1180af31cf3ea5a906996";
var $7e689b08be7fdc0b$export$2e2bcd8739ae039 = $7e689b08be7fdc0b$var$node;

});

parcelRegister("3edXJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d63ec91007e0fb8$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $7d63ec91007e0fb8$var$SingleSelectEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("hyquE")), {
        moduleId: "2f9b0ca9",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $7d63ec91007e0fb8$export$2e2bcd8739ae039 = $7d63ec91007e0fb8$var$SingleSelectEditViewEntryPoint;

});
parcelRegister("hyquE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5uj8R").then(()=>parcelRequire('kfaV9'));

});


parcelRegister("fmLhX", function(module, exports) {
$parcel$export(module.exports, "SingleSelectReadView", () => $18bf8c7160e24e99$export$68bfa072e694358d);

var $5hi9h = parcelRequire("5hi9h");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8IeH1 = parcelRequire("8IeH1");

var $cxKOj = parcelRequire("cxKOj");

var $d9T1A = parcelRequire("d9T1A");

var $kp5kj = parcelRequire("kp5kj");

var $3mZMJ = parcelRequire("3mZMJ");

var $4cTDP = parcelRequire("4cTDP");

var $k6Nau = parcelRequire("k6Nau");

var $d4GL0 = parcelRequire("d4GL0");

var $3Lkm9 = parcelRequire("3Lkm9");

var $3OT15 = parcelRequire("3OT15");
const $18bf8c7160e24e99$export$68bfa072e694358d = (props)=>{
    const { fragmentRef: fragmentRef, fieldType: fieldType, shouldShowPopover: shouldShowPopover } = props;
    const isJsmIssue = (0, $d4GL0.useIsJsmIssue)();
    const data = (0, $j4oe4.useFragment)((0, $5hi9h.default), fragmentRef);
    const hoverPopoverRefFactory = shouldShowPopover ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: data.fieldOption?.value
    });
    const isBespokeEmptyFieldTextGA = (0, $k6Nau.useBespokeEmptyFieldTextGA)();
    if (!data.fieldOption?.value) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), isBespokeEmptyFieldTextGA && {
        placeholderText: (0, $3Lkm9.default).bespokenSingleSelectPlaceholderEmptyFieldText
    });
    const isCategoryAndListExperimentON = props.fieldType === (0, $3mZMJ.CATEGORY_TYPE);
    // Separate checks to assure exposure
    const isSingleSelectAndColourfulExperimentOn = fieldType === (0, $3mZMJ.SELECT_CF_TYPE) && (0, $cxKOj.expVal)('thor_colourful_single_select_milestone2_experiment', 'isColorfulSingleSelectEnabled', false);
    if (isSingleSelectAndColourfulExperimentOn || isCategoryAndListExperimentON) {
        if (shouldShowPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp5kj.OptionTag), {
            name: data.fieldOption?.value ?? '',
            color: data.fieldOption?.color?.colorKey ?? null,
            ref: hoverPopoverRef
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp5kj.OptionTag), {
            name: data.fieldOption.value,
            color: data?.fieldOption?.color?.colorKey ?? null,
            showTooltip: (0, $4cTDP.fg)('add_tooltip_to_single_select_options') || !isJsmIssue && (0, $cxKOj.expVal)('single_select_with_tooltips', 'enabled', false)
        });
    }
    return shouldShowPopover ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        ref: hoverPopoverRef
    }, data.fieldOption?.value ?? '') : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data.fieldOption?.value ?? '');
};

});
parcelRegister("5hi9h", function(module, exports) {
$parcel$export(module.exports, "default", () => $705540d1e5ab33ab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<04ea739d1f4c36cb215a8176fe56e3cc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $705540d1e5ab33ab$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "fieldOption",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "JiraColor",
                    "kind": "LinkedField",
                    "name": "color",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "colorKey"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraSingleSelectField"
};
$705540d1e5ab33ab$var$node.hash = "1276308a1838194b7b78528c304458c7";
var $705540d1e5ab33ab$export$2e2bcd8739ae039 = $705540d1e5ab33ab$var$node;

});

parcelRegister("d4GL0", function(module, exports) {
$parcel$export(module.exports, "useIsJsmIssue", () => $c232e8d882e0b631$export$5f53c98aa7c9de5);
$parcel$export(module.exports, "useIsSoftwareIssue", () => $c232e8d882e0b631$export$ed33ecaf885020f8);
$parcel$export(module.exports, "useIsBusinessIssue", () => $c232e8d882e0b631$export$c4a50ee3a409d3b);

var $FhXEJ = parcelRequire("FhXEJ");

var $bmoS1 = parcelRequire("bmoS1");

var $bNexr = parcelRequire("bNexr");
const $c232e8d882e0b631$export$6362f1ad6af51d2e = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    return (0, $bNexr.useProjectType)(projectKey);
};
const $c232e8d882e0b631$export$5f53c98aa7c9de5 = ()=>{
    const projectType = $c232e8d882e0b631$export$6362f1ad6af51d2e();
    return projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT);
};
const $c232e8d882e0b631$export$ed33ecaf885020f8 = ()=>{
    const projectType = $c232e8d882e0b631$export$6362f1ad6af51d2e();
    return projectType === (0, $FhXEJ.SOFTWARE_PROJECT);
};
const $c232e8d882e0b631$export$c4a50ee3a409d3b = ()=>{
    const projectType = $c232e8d882e0b631$export$6362f1ad6af51d2e();
    return projectType === (0, $FhXEJ.CORE_PROJECT);
};

});




parcelRegister("aqqsA", function(module, exports) {
$parcel$export(module.exports, "SprintCell", () => $1d390bfb6b1daa80$export$a092d4418bd765b8);

var $kDOzr = parcelRequire("kDOzr");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $f26C8 = parcelRequire("f26C8");
var $jPlb3 = parcelRequire("jPlb3");
var $1jiqw = parcelRequire("1jiqw");

var $cMwFX = parcelRequire("cMwFX");

var $jJI50 = parcelRequire("jJI50");

var $eqbO4 = parcelRequire("eqbO4");

var $P01So = parcelRequire("P01So");

var $4vHFI = parcelRequire("4vHFI");

var $34oCh = parcelRequire("34oCh");
/**
 * Expected JQL Output: `${jqlTerm} = ${sprintId}`
 */ const $1d390bfb6b1daa80$var$getSprintJql = (jqlTerm, sprintId)=>{
    const jast = (0, $f26C8.default).jast((0, $f26C8.default).query((0, $f26C8.default).terminalClause((0, $f26C8.default).field((0, $P01So.escapeBackslashes)(jqlTerm)), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)), (0, $f26C8.default).valueOperand(String(sprintId)))));
    return (0, $1jiqw.print)(jast, {
        operatorCase: 'upper'
    });
};
const $1d390bfb6b1daa80$export$a092d4418bd765b8 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, projectKey: projectKey, issueSearchBaseUrl: issueSearchBaseUrl, jqlTerm: jqlTerm, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $kDOzr.default), fieldRef);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const [restrictSprints, { onRestrictSprints: onRestrictSprints }] = (0, $jJI50.useRestrictSprints)();
    const getUrl = (0, $eJOHy.useCallback)((sprintId)=>{
        const jql = $1d390bfb6b1daa80$var$getSprintJql(jqlTerm, sprintId);
        return `${issueSearchBaseUrl}?jql=${encodeURIComponent(jql)}`;
    }, [
        issueSearchBaseUrl,
        jqlTerm
    ]);
    const shouldTruncate = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cMwFX.SprintInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        getUrl: getUrl,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        onRestrictSprints: onRestrictSprints,
        projectKey: projectKey,
        readViewFitContainerHeight: true,
        restrictSprints: restrictSprints,
        isTruncated: shouldTruncate
    });
});

});
parcelRegister("kDOzr", function(module, exports) {
$parcel$export(module.exports, "default", () => $0df76e9dabd88917$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bc5d300657ae425f3250fd7b2c6d7b37>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0df76e9dabd88917$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "SprintCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSprintField"
};
$0df76e9dabd88917$var$node.hash = "afc7608d5e2caf73131c9fa1d441d4a2";
var $0df76e9dabd88917$export$2e2bcd8739ae039 = $0df76e9dabd88917$var$node;

});

parcelRegister("cMwFX", function(module, exports) {
$parcel$export(module.exports, "SprintInlineEditViewIsEditable", () => $fa6beaf7f70924f1$export$e7a88b03161da897);
$parcel$export(module.exports, "SprintInlineEditView", () => $fa6beaf7f70924f1$export$c035f6dfde6d5d50);

var $h5H4R = parcelRequire("h5H4R");

var $bYE0n = parcelRequire("bYE0n");

var $c8O3w = parcelRequire("c8O3w");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $h6i8k = parcelRequire("h6i8k");

var $d2AGn = parcelRequire("d2AGn");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $4DuQo = parcelRequire("4DuQo");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $iy7qP = parcelRequire("iy7qP");

var $9G6SK = parcelRequire("9G6SK");

var $ibVOD = parcelRequire("ibVOD");

var $fkc6h = parcelRequire("fkc6h");

var $fk01k = parcelRequire("fk01k");
const $fa6beaf7f70924f1$var$isEqualSprint = (a, b)=>a?.value === b?.value;
const $fa6beaf7f70924f1$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-sprint-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $fa6beaf7f70924f1$export$e7a88b03161da897 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, getUrl: getUrl, isEditable: isFieldEditable, isEditing: startWithEditViewOpen, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onRestrictSprints: onRestrictSprints, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, projectKey: projectKey, readViewFitContainerHeight: readViewFitContainerHeight, restrictSprints: restrictSprints, isTruncated: isTruncated })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $c8O3w.default), fragmentRef);
    const { enrichCommitWithIssueExperienceMonitoring: enrichCommitWithIssueExperienceMonitoring } = (0, $fkc6h.useIssueExperienceMonitoring)();
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: fieldName, selectedSprintsConnection: selectedSprintsConnection } = data;
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $bYE0n.default));
    const sprintEdges = (0, $eJOHy.useMemo)(()=>selectedSprintsConnection?.edges?.filter(Boolean) ?? [], [
        selectedSprintsConnection?.edges
    ]);
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        const sprintNodes = sprintEdges.map(({ node: node })=>node).filter(Boolean);
        const currentSprint = (0, $iy7qP.findActiveOrFutureSprint)(sprintNodes);
        return currentSprint && (0, $iy7qP.isObjectWithSprintState)(currentSprint) ? {
            value: currentSprint.id,
            label: currentSprint.name ?? '',
            state: currentSprint.state,
            sprintId: currentSprint.sprintId
        } : null;
    }, [
        sprintEdges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        (0, $h6i8k.default)('issue.field.sprint.edit');
        onSubmit?.((0, $fk01k.transformOptionToAgg)(selectedSprintsConnection?.edges ?? [], option));
        commit(enrichCommitWithIssueExperienceMonitoring({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: option?.value ?? null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateSprintField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: (0, $fk01k.toOptimisticResponse)(uniqueFieldId, option, sprintEdges)
        }, 'sprint_issueFieldSprint_SprintField_Mutation', {
            sendUFOEvent: true
        }));
    }, [
        commit,
        onSubmit,
        selectedSprintsConnection?.edges,
        sprintEdges,
        uniqueFieldId,
        enrichCommitWithIssueExperienceMonitoring
    ]);
    const handleSubmitSucceeded = (0, $eJOHy.useCallback)((value)=>{
        onSubmitSucceeded?.((0, $fk01k.transformOptionToAgg)(selectedSprintsConnection?.edges ?? [], value));
    }, [
        onSubmitSucceeded,
        selectedSprintsConnection?.edges
    ]);
    const setAnalyticsAttributes = (0, $eJOHy.useCallback)((value)=>{
        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, initialValue?.sprintId, value?.sprintId || null);
    }, [
        fieldId,
        initialValue
    ]);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $fa6beaf7f70924f1$var$isEqualSprint,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: handleSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'sprint',
        setAnalyticsAttributes: setAnalyticsAttributes
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fa6beaf7f70924f1$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9G6SK.SprintReadView), {
            fragmentRef: data,
            getUrl: getUrl,
            isTruncated: isTruncated
        }))), [
        data,
        getUrl,
        isTruncated
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            projectKey: projectKey,
            onRestrictSprints: onRestrictSprints,
            restrictSprints: restrictSprints,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $4DuQo.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hasReadViewTruncateDisabled: isTruncated,
        hideActionButtons: true
    });
};
const $fa6beaf7f70924f1$export$c035f6dfde6d5d50 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $h5H4R.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fa6beaf7f70924f1$export$e7a88b03161da897, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("h5H4R", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ff502dc566d78b3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<37eab354ffef704063d36bf755f8ce5b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3ff502dc566d78b3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSprintField"
};
$3ff502dc566d78b3$var$node.hash = "aba26260bac1c5d276c6291d7046e952";
var $3ff502dc566d78b3$export$2e2bcd8739ae039 = $3ff502dc566d78b3$var$node;

});

parcelRegister("bYE0n", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ca3b34094c6a410$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d38c11cbcc28d051d2caaff8b2100e27>>
 * @relayHash fe046116013b2c3336c51bcbbb0fadff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41bae81fc0a3022641c80d39ea76c8cb98023eb98fecc3699abf8ef4138c4e7
const $8ca3b34094c6a410$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sprint_issueFieldSprint_SprintField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSprintFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSprintField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSprintField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "sprint_issueFieldSprintReadviewFull_SprintReadView"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sprint_issueFieldSprint_SprintField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSprintFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSprintField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSprintField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "JiraSprintConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedSprintsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSprintEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSprint",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "sprintId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "state"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "endDate"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e41bae81fc0a3022641c80d39ea76c8cb98023eb98fecc3699abf8ef4138c4e7",
            "metadata": {},
            "name": "sprint_issueFieldSprint_SprintField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$8ca3b34094c6a410$var$node.hash = "10015ae363c37285aaa230e388ba466f";
var $8ca3b34094c6a410$export$2e2bcd8739ae039 = $8ca3b34094c6a410$var$node;

});

parcelRegister("c8O3w", function(module, exports) {
$parcel$export(module.exports, "default", () => $950f3e4423770719$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ac88ab127ac9ae040b14fea73c66a12b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $950f3e4423770719$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "sprint_issueFieldSprintReadviewFull_SprintReadView"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v1 /*: any*/ ,
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraSprintField"
    };
}();
$950f3e4423770719$var$node.hash = "52958eeea1ec618ec650c65098329a2d";
var $950f3e4423770719$export$2e2bcd8739ae039 = $950f3e4423770719$var$node;

});

parcelRegister("4DuQo", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b10e4eaf75093e1$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $7b10e4eaf75093e1$var$SprintEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("8X51a")), {
        moduleId: "8d561192",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $7b10e4eaf75093e1$export$2e2bcd8739ae039 = $7b10e4eaf75093e1$var$SprintEditViewEntryPoint;

});
parcelRegister("8X51a", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iMnjN").then(()=>parcelRequire('jqyo2'));

});


parcelRegister("iy7qP", function(module, exports) {
$parcel$export(module.exports, "getRapidViewUrl", () => $e14a9757607507d9$export$e6c9132cef5ee76f);
$parcel$export(module.exports, "findActiveOrFutureSprint", () => $e14a9757607507d9$export$d53a51166e1544ba);
$parcel$export(module.exports, "isClosedSprint", () => $e14a9757607507d9$export$7494fd835c1a1b3);
$parcel$export(module.exports, "filterClosedSprints", () => $e14a9757607507d9$export$af48278faaf4e92d);
$parcel$export(module.exports, "isObjectWithSprintState", () => $e14a9757607507d9$export$9ba6a679066a1e8c);

var $cJktn = parcelRequire("cJktn");
const $e14a9757607507d9$export$e6c9132cef5ee76f = (sprintId)=>`/secure/GHGoToBoard.jspa?sprintId=${sprintId}`;
const $e14a9757607507d9$var$hasState = (state)=>(sprint)=>sprint.state != null && sprint.state.toUpperCase() === state.toUpperCase();
const $e14a9757607507d9$var$findSprintWithState = (sprints, state)=>sprints.find($e14a9757607507d9$var$hasState(state));
const $e14a9757607507d9$export$d53a51166e1544ba = (value)=>{
    const activeSprint = $e14a9757607507d9$var$findSprintWithState(value, (0, $cJktn.ACTIVE_SPRINT_STATE));
    if (activeSprint) return activeSprint;
    const futureSprint = $e14a9757607507d9$var$findSprintWithState(value, (0, $cJktn.FUTURE_SPRINT_STATE));
    if (futureSprint) return futureSprint;
    return null;
};
const $e14a9757607507d9$export$7494fd835c1a1b3 = $e14a9757607507d9$var$hasState((0, $cJktn.CLOSED_SPRINT_STATE));
const $e14a9757607507d9$export$af48278faaf4e92d = (value)=>value.filter($e14a9757607507d9$export$7494fd835c1a1b3);
const $e14a9757607507d9$export$9ba6a679066a1e8c = (val)=>val.state ? val.state in (0, $cJktn.SPRINT_STATES) : false;

});
parcelRegister("cJktn", function(module, exports) {
$parcel$export(module.exports, "ACTIVE_SPRINT_STATE", () => $f86aa4c60e4f732e$export$3ebc9911a79d714f);
$parcel$export(module.exports, "FUTURE_SPRINT_STATE", () => $f86aa4c60e4f732e$export$863e42082c6bde5);
$parcel$export(module.exports, "CLOSED_SPRINT_STATE", () => $f86aa4c60e4f732e$export$86cdef09a89e8c4b);
$parcel$export(module.exports, "SPRINT_STATES", () => $f86aa4c60e4f732e$export$73a0206a4dc59760);
const $f86aa4c60e4f732e$export$3ebc9911a79d714f = 'ACTIVE';
const $f86aa4c60e4f732e$export$863e42082c6bde5 = 'FUTURE';
const $f86aa4c60e4f732e$export$86cdef09a89e8c4b = 'CLOSED';
const $f86aa4c60e4f732e$export$73a0206a4dc59760 = {
    ACTIVE: $f86aa4c60e4f732e$export$3ebc9911a79d714f,
    CLOSED: $f86aa4c60e4f732e$export$86cdef09a89e8c4b,
    FUTURE: $f86aa4c60e4f732e$export$863e42082c6bde5
};

});


parcelRegister("9G6SK", function(module, exports) {
$parcel$export(module.exports, "SprintReadView", () => $e0780739f49c9cfa$export$ea735e24cb7dd13);

var $9Ow2t = parcelRequire("9Ow2t");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jFHCE = parcelRequire("jFHCE");

var $j4oe4 = parcelRequire("j4oe4");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $3Lkm9 = parcelRequire("3Lkm9");

var $9Mapt = parcelRequire("9Mapt");

var $ibVOD = parcelRequire("ibVOD");

var $bzbsd = parcelRequire("bzbsd");

var $iy7qP = parcelRequire("iy7qP");

var $jON6X = parcelRequire("jON6X");

var $fLyz2 = parcelRequire("fLyz2");
const $e0780739f49c9cfa$export$ea735e24cb7dd13 = ({ fragmentRef: fragmentRef, shouldHideSprintLink: shouldHideSprintLink = false, shouldHideClosedSprintsLinks: shouldHideClosedSprintsLinks = false, placeholder: placeholder, onSprintClick: onSprintClick, getUrl: getUrl = (0, $iy7qP.getRapidViewUrl), isTruncated: isTruncated })=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $lRq8t.default)();
    const placeholderMessage = placeholder || formatMessage((0, $3Lkm9.default).emptyFieldText);
    const { selectedSprintsConnection: selectedSprintsConnection } = (0, $j4oe4.useFragment)((0, $9Ow2t.default), fragmentRef);
    const sprints = (0, $eJOHy.useMemo)(()=>selectedSprintsConnection?.edges?.filter(Boolean).map(({ node: node })=>node).filter(Boolean).filter((0, $iy7qP.isObjectWithSprintState)).map((node)=>({
                id: node.id,
                sprintId: parseInt(node.sprintId, 10),
                name: node.name,
                state: node.state,
                endDate: node.endDate ?? undefined
            })) ?? [], [
        selectedSprintsConnection?.edges
    ]);
    const value = (0, $eJOHy.useMemo)(()=>{
        const currentSprint = (0, $iy7qP.findActiveOrFutureSprint)(sprints);
        if (!currentSprint) return null;
        const sprintOption = {
            label: currentSprint.name,
            value: currentSprint.id,
            href: getUrl(currentSprint.sprintId),
            state: currentSprint.state
        }; // If in backlog, use onSprintClick instead of href
        return onSprintClick ? (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(sprintOption, 'href') : sprintOption;
    }, [
        getUrl,
        onSprintClick,
        sprints
    ]);
    const closedSprints = (0, $eJOHy.useMemo)(()=>(0, $iy7qP.filterClosedSprints)(sprints)?.map((closedSprint)=>({
                id: closedSprint.sprintId,
                name: closedSprint.name,
                href: getUrl(closedSprint.sprintId),
                endDate: formatDate(closedSprint.endDate, {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                })
            })), [
        formatDate,
        getUrl,
        sprints
    ]);
    const sprintContentRef = (0, $eJOHy.useRef)(null);
    const renderClosedSprints = (0, $eJOHy.useCallback)((props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, closedSprints.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jON6X.default), props));
    }, [
        closedSprints
    ]);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center",
        shouldWrap: !isTruncated,
        xcss: $e0780739f49c9cfa$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: value?.label,
            contentRef: sprintContentRef,
            shouldGetParentRef: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fLyz2.default), {
                value: value,
                shouldHideSprintLink: shouldHideSprintLink,
                placeholder: placeholderMessage,
                onClick: onSprintClick,
                sprintContentRef: (0, $bzbsd.mergeRefs)(ref, sprintContentRef),
                hoverAttributes: props
            }))), renderClosedSprints({
        closedSprints: closedSprints,
        shouldHideLinks: shouldHideClosedSprintsLinks,
        isTruncated: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e0780739f49c9cfa$var$ReadWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fLyz2.default), {
        value: value,
        shouldHideSprintLink: shouldHideSprintLink,
        placeholder: placeholderMessage,
        onClick: onSprintClick
    }), renderClosedSprints({
        closedSprints: closedSprints,
        shouldHideLinks: shouldHideClosedSprintsLinks
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e0780739f49c9cfa$var$ReadWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _1bsb1osq _1n261g80",
            __cmplp.className
        ])
    });
});
const $e0780739f49c9cfa$var$inlineStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden'
});

});
parcelRegister("9Ow2t", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6da3ab11fd18cb2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0ee21c1a385c649c86345ac0a88a0470>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b6da3ab11fd18cb2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "sprint_issueFieldSprintReadviewFull_SprintReadView",
    "selections": [
        {
            "concreteType": "JiraSprintConnection",
            "kind": "LinkedField",
            "name": "selectedSprintsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraSprintEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraSprint",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "sprintId"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    "action": "THROW",
                                    "path": "selectedSprintsConnection.edges.node.name"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    "action": "THROW",
                                    "path": "selectedSprintsConnection.edges.node.state"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraSprintField"
};
$b6da3ab11fd18cb2$var$node.hash = "94ae9fbf007cadd0e44b60b0777f74f2";
var $b6da3ab11fd18cb2$export$2e2bcd8739ae039 = $b6da3ab11fd18cb2$var$node;

});

parcelRegister("jON6X", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed002d22c6a98a04$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $3cMgR = parcelRequire("3cMgR");

var $6joHJ = parcelRequire("6joHJ");

var $lRq8t = parcelRequire("lRq8t");

var $c9uTK = parcelRequire("c9uTK");

var $9Mapt = parcelRequire("9Mapt");

var $5vUQ3 = parcelRequire("5vUQ3");
const $ed002d22c6a98a04$var$ClosedSprintsView = (props)=>{
    const { shouldHideLinks: shouldHideLinks = false, closedSprints: closedSprints, isTruncated: isTruncated } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isDialogOpen, setIsDialogOpen] = (0, $eJOHy.useState)(false);
    const handleButtonClick = (0, $eJOHy.useCallback)((e)=>{
        setIsDialogOpen(!isDialogOpen);
        e.stopPropagation();
    }, [
        isDialogOpen
    ]);
    const handleDialogClose = (0, $eJOHy.useCallback)((data)=>{
        setIsDialogOpen(data.isOpen);
    }, []);
    const handleDialogClick = (0, $eJOHy.useCallback)((e)=>{
        e.stopPropagation();
    }, []);
    const handleDialogMouseDown = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
    }, []);
    const closedSprintsLabel = (0, $eJOHy.useMemo)(()=>{
        const numberOfClosedSprints = closedSprints.length;
        return numberOfClosedSprints > 0 ? formatMessage((0, $5vUQ3.default).closedSprintsLabel, {
            count: numberOfClosedSprints
        }) : null;
    }, [
        closedSprints,
        formatMessage
    ]);
    const renderInlineDialogContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": "issue-field-sprint-readview-full.ui.sprint.closed-sprints.view-closed-sprint-inline-dialog-content-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            weight: "medium"
        }, closedSprintsLabel), closedSprints.map((sprint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$ItemContainer, {
                key: sprint.name,
                "data-testid": `issue-field-sprint-readview-full.ui.sprint.closed-sprints.closed-sprint-item-${sprint.id}`
            }, shouldHideLinks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$NameSpan, null, sprint.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$NameLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
                href: sprint.href
            }, sprint.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$NoWrapDate, null, sprint.endDate))));
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (hoverProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: renderInlineDialogContent(),
            isInteractive: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                spacing: "none",
                ref: ref,
                testId: "issue-field-sprint-readview-full.ui.sprint.closed-sprints.button",
                ...hoverProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$ClosedSprintsCount, null, `+${closedSprints.length}`)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$Container, {
        onClick: handleDialogClick,
        onMouseDown: handleDialogMouseDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6joHJ.JiraInlineDialog), {
        content: renderInlineDialogContent(),
        isOpen: isDialogOpen,
        onClose: handleDialogClose,
        placement: "bottom",
        messageId: "issue-field-sprint-readview-full.ui.sprint.closed-sprints.inline-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: handleButtonClick,
        spacing: "none",
        isSelected: isDialogOpen,
        testId: "issue-field-sprint-readview-full.ui.sprint.closed-sprints.button",
        "aria-expanded": isDialogOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$ClosedSprintsCount, null, `+${closedSprints.length}`))));
};
var $ed002d22c6a98a04$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = $ed002d22c6a98a04$var$ClosedSprintsView;
const $ed002d22c6a98a04$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed002d22c6a98a04$var$ClosedSprintsCount = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _k48pi7a9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed002d22c6a98a04$var$ItemContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc _1e0c1txw _1bah1yb4 _p12f1mjv",
            __cmplp.className
        ])
    });
});
const $ed002d22c6a98a04$var$nameStyles = `
    margin-right: ${"var(--ds-space-300, 24px)"};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $ed002d22c6a98a04$var$NameLinkContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _2hwx1ejb _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $ed002d22c6a98a04$var$NameSpan = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _2hwx1ejb _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed002d22c6a98a04$var$NoWrapDate = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6joHJ", function(module, exports) {
$parcel$export(module.exports, "JiraInlineDialog", () => $765bdfac52a4c302$export$7ab52478615504b3);

var $eJOHy = parcelRequire("eJOHy");

var $cwZBT = parcelRequire("cwZBT");

var $bRMVI = parcelRequire("bRMVI");

var $fYeTG = parcelRequire("fYeTG");

var $1kIuW = parcelRequire("1kIuW");
const $765bdfac52a4c302$export$7ab52478615504b3 = (props)=>{
    if ((0, $bRMVI.shouldBeChoreographed)(props)) {
        if ((0, $fYeTG.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1kIuW.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cwZBT.default), rest);
};

});
parcelRegister("1kIuW", function(module, exports) {
$parcel$export(module.exports, "ChoreographerInlineDialog", () => $7432b934335413bd$export$44a404f218b0e66e);

var $cwZBT = parcelRequire("cwZBT");

var $4GudG = parcelRequire("4GudG");
const $7432b934335413bd$export$44a404f218b0e66e = (0, $4GudG.withChoreographedToggle)((0, $cwZBT.default), 'isOpen', 'content');

});


parcelRegister("5vUQ3", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a3bdce371919139$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3a3bdce371919139$var$messages = (0, $7qGN1.defineMessages)({
    closedSprintsLabel: {
        "id": "issue-field-sprint-readview-full.sprint.closed-sprints.closed-sprints-label",
        "defaultMessage": "{count} completed {count, plural, one {sprint} other {sprints}}"
    }
});
var $3a3bdce371919139$export$2e2bcd8739ae039 = $3a3bdce371919139$var$messages;

});


parcelRegister("fLyz2", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd3a63dfa9d33df6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $jvd21 = parcelRequire("jvd21");

var $tYLUh = parcelRequire("tYLUh");

var $c9uTK = parcelRequire("c9uTK");

var $3qWdv = parcelRequire("3qWdv");
const $bd3a63dfa9d33df6$var$SprintContent = (props)=>{
    const { value: value, onClick: onClick, placeholder: placeholder, shouldHideSprintLink: shouldHideSprintLink = false, sprintContentRef: sprintContentRef, hoverAttributes: hoverAttributes } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const noValueTextExperiment = formatMessage((0, $3qWdv.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const renderSprintContent = ()=>{
        if (shouldHideSprintLink) return value && value.label;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
            "data-testid": "issue-field-sprint-readview-full.ui.sprint.sprint-content.view-sprint-content-link",
            href: value?.href,
            onClick: onClick,
            ref: sprintContentRef,
            ...hoverAttributes
        }, value && value.label);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd3a63dfa9d33df6$var$Ellipsis, {
        "data-testid": "issue-field-sprint-readview-full.ui.sprint.sprint-content.view-sprint-content"
    }, value ? renderSprintContent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvd21.default), null, isExperimentEnabled ? noValueTextExperiment : placeholder));
};
var $bd3a63dfa9d33df6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $bd3a63dfa9d33df6$var$SprintContent;
const $bd3a63dfa9d33df6$var$Ellipsis = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jvd21", function(module, exports) {
$parcel$export(module.exports, "default", () => $d76fa90793402a52$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $d76fa90793402a52$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1rpy",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3qWdv", function(module, exports) {
$parcel$export(module.exports, "default", () => $81f1641e160db5ad$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $81f1641e160db5ad$var$messages = (0, $7qGN1.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-sprint-readview-full.sprint.no-value-text-experiment",
        "defaultMessage": "Add sprint"
    }
});
var $81f1641e160db5ad$export$2e2bcd8739ae039 = $81f1641e160db5ad$var$messages;

});



parcelRegister("fk01k", function(module, exports) {
$parcel$export(module.exports, "toOptimisticResponse", () => $ab0accbcd13a5bc9$export$79353fa5e28d43d8);
$parcel$export(module.exports, "transformOptionToAgg", () => $ab0accbcd13a5bc9$export$4e115b8a3d13d179);

var $iy7qP = parcelRequire("iy7qP");
const $ab0accbcd13a5bc9$export$79353fa5e28d43d8 = (fieldId, option, previousEdges)=>{
    // Previously closed sprints should still be displayed for the updated field
    const selectedSprints = previousEdges.filter((edge)=>edge?.node && (0, $iy7qP.isClosedSprint)(edge.node));
    if (option) selectedSprints.unshift({
        node: {
            id: option.value,
            name: option.label,
            state: option.state,
            sprintId: option.sprintId,
            endDate: null
        }
    });
    return {
        jira: {
            updateSprintField: {
                success: true,
                errors: null,
                field: {
                    id: fieldId,
                    selectedSprintsConnection: {
                        edges: selectedSprints
                    }
                }
            }
        }
    };
};
const $ab0accbcd13a5bc9$export$4e115b8a3d13d179 = (currentEdges, option)=>{
    // Previously closed sprints should still be displayed for the updated field
    const selectedSprints = currentEdges.filter((edge)=>edge?.node && (0, $iy7qP.isClosedSprint)(edge.node));
    if (option) selectedSprints.unshift({
        node: {
            id: option.value,
            name: option.label,
            state: option.state,
            sprintId: option.sprintId,
            endDate: null
        }
    });
    return {
        selectedSprintsConnection: {
            edges: selectedSprints
        }
    };
};

});


parcelRegister("jJI50", function(module, exports) {
$parcel$export(module.exports, "useRestrictSprints", () => $1d7048aa3f6edc98$export$8fafa660b00d922);

var $4JBcj = parcelRequire("4JBcj");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $1d7048aa3f6edc98$var$initialState = {
    restrictSprints: (0, $4JBcj.getSharedRestrictSprintsValueFromLocalStorage)()
};
const $1d7048aa3f6edc98$var$actions = {
    onRestrictSprints: (restrictSprints)=>({ setState: setState })=>{
            (0, $4JBcj.setSharedRestrictSprintsValueInLocalStorage)(restrictSprints);
            setState({
                restrictSprints: restrictSprints
            });
        }
};
const $1d7048aa3f6edc98$var$RestrictSprintsStore = (0, $GtRbT.createStore)({
    initialState: $1d7048aa3f6edc98$var$initialState,
    actions: $1d7048aa3f6edc98$var$actions
});
const $1d7048aa3f6edc98$export$8fafa660b00d922 = (0, $iJq0l.createHook)($1d7048aa3f6edc98$var$RestrictSprintsStore, {
    selector: (state)=>state.restrictSprints
});

});
parcelRegister("4JBcj", function(module, exports) {
$parcel$export(module.exports, "getSharedRestrictSprintsValueFromLocalStorage", () => $f5002babcd0c3294$export$7186d1e916f1211c);
$parcel$export(module.exports, "setSharedRestrictSprintsValueInLocalStorage", () => $f5002babcd0c3294$export$4e2f56cec9369837);

var $3hRxq = parcelRequire("3hRxq");

var $4cTDP = parcelRequire("4cTDP");
// Helper functions to get the checkbox value in sprint edit component from local storage
const $f5002babcd0c3294$var$SHARED_RESTRICT_SPRINTS_CACHE_KEY = 'edit_sprint_cache_value';
const $f5002babcd0c3294$var$storageProvider = (0, $3hRxq.createLocalStorageProvider)('', false);
const $f5002babcd0c3294$var$getRestrictSprintsValueFromLocalStorage = (key)=>{
    // SSR should not try to retrieve local storage values, so return default value
    if (false) return true;
    let value;
    try {
        if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) value = $f5002babcd0c3294$var$storageProvider.get(key);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        value = window.localStorage?.getItem(key);
        return value ? JSON.parse(value) : true;
    } catch  {
        return true;
    }
};
const $f5002babcd0c3294$var$setRestrictSprintsValueInLocalStorage = (key, value)=>{
    try {
        const valueToStore = String(value);
        if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) $f5002babcd0c3294$var$storageProvider.set(key, valueToStore);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.localStorage.setItem(key, valueToStore);
    } catch  {
    // do nothing
    }
};
const $f5002babcd0c3294$export$7186d1e916f1211c = ()=>$f5002babcd0c3294$var$getRestrictSprintsValueFromLocalStorage($f5002babcd0c3294$var$SHARED_RESTRICT_SPRINTS_CACHE_KEY);
const $f5002babcd0c3294$export$4e2f56cec9369837 = (value)=>$f5002babcd0c3294$var$setRestrictSprintsValueInLocalStorage($f5002babcd0c3294$var$SHARED_RESTRICT_SPRINTS_CACHE_KEY, value);

});



parcelRegister("fj3ot", function(module, exports) {
$parcel$export(module.exports, "TeamCell", () => $4640eab72db9f5d4$export$2ea8e60ef5e5f6ad);

var $bnJ3B = parcelRequire("bnJ3B");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $aXKmr = parcelRequire("aXKmr");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $2dtFa = parcelRequire("2dtFa");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $4640eab72db9f5d4$export$2ea8e60ef5e5f6ad = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const sessionId = (0, $eJOHy.useRef)((0, $aXKmr.v4)());
    const data = (0, $j4oe4.useFragment)((0, $bnJ3B.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dtFa.TeamInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $4640eab72db9f5d4$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        sessionId: sessionId.current,
        maxLines: isSingleLineRowHeightEnabled ? 1 : 2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dtFa.TeamInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        sessionId: sessionId.current,
        maxLines: isSingleLineRowHeightEnabled ? 1 : 2
    });
};
const $4640eab72db9f5d4$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $4640eab72db9f5d4$var$customTargetStyles : $4640eab72db9f5d4$var$customTargetStylesOld,
        ref: ref
    });
});
const $4640eab72db9f5d4$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $4640eab72db9f5d4$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("bnJ3B", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e8b92a33c302941$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cddd286a4f083996a72d34795de9cca2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6e8b92a33c302941$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "TeamCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraTeamViewField"
};
$6e8b92a33c302941$var$node.hash = "ebd36d00384a18703786e3ff2edd2e21";
var $6e8b92a33c302941$export$2e2bcd8739ae039 = $6e8b92a33c302941$var$node;

});

parcelRegister("2dtFa", function(module, exports) {
$parcel$export(module.exports, "TeamInlineEditViewWithIsEditable", () => $f82f0d90cc8d59f5$export$810a8205b15f6ef5);
$parcel$export(module.exports, "TeamInlineEditView", () => $f82f0d90cc8d59f5$export$d6fa94a3a6e2c653);

var $lucKB = parcelRequire("lucKB");

var $cEnDa = parcelRequire("cEnDa");

var $3hPoY = parcelRequire("3hPoY");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $luwvO = parcelRequire("luwvO");

var $gbhyT = parcelRequire("gbhyT");

var $8BFAJ = parcelRequire("8BFAJ");

var $auNLL = parcelRequire("auNLL");

var $b1dAu = parcelRequire("b1dAu");
const $f82f0d90cc8d59f5$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-team-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $f82f0d90cc8d59f5$var$isEqualOption = (a, b)=>a?.id === b?.id;
const $f82f0d90cc8d59f5$export$810a8205b15f6ef5 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupTarget: editViewPopupTarget, editViewPopupWidth: editViewPopupWidth, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', sessionId: sessionId, maxLines: maxLines })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $3hPoY.default), fragmentRef);
    // Team will not always be available in Jira when is recently created,
    // at least not right away, due to eventual consistency. We are retrying
    // to give time to Jira to receive the newly team and accepts the given
    // team ARI as a valid team
    const retryCommit = (0, $b1dAu.useMutationWithRetriesCommit)((0, $eJOHy.useMemo)(()=>({
            retries: 3,
            isValidOnCompleted: (response)=>Boolean(response.jira?.updateTeamField?.success)
        }), []));
    const [commit] = (0, $j4oe4.useMutation)((0, $cEnDa.default), retryCommit);
    // #endregion
    // #region Common state
    const { id: uniqueFieldId, name: name, selectedTeam: selectedTeam, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedTeam) return null;
        return {
            id: selectedTeam.jiraSuppliedId,
            name: selectedTeam.jiraSuppliedName ?? ''
        };
    }, [
        selectedTeam
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    // #endregion Common state
    // #region Actions
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onFail: onFail, onSuccess: onSuccess })=>{
        onSubmit?.(value);
        const id = (0, $luwvO.isRecentlyCreatedTeam)(value) ? value.teamAri : value?.id ?? null;
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: id
                    }
                }
            },
            onCompleted (response) {
                if (response.jira?.updateTeamField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateTeamField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedTeam: value && {
                                jiraSuppliedId: id ?? '',
                                jiraSuppliedName: value?.name ?? ''
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $f82f0d90cc8d59f5$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'team'
    });
    // #endregion Actions
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f82f0d90cc8d59f5$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8BFAJ.TeamReadView), {
            fragmentRef: data,
            maxLines: maxLines,
            triggerLinkType: isFieldEditable ? 'none' : 'link'
        })), [
        data,
        maxLines,
        isFieldEditable
    ]);
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChangeAndConfirm,
            spacing: spacing,
            sessionId: sessionId
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $gbhyT.default),
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
};
const $f82f0d90cc8d59f5$export$d6fa94a3a6e2c653 = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $lucKB.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f82f0d90cc8d59f5$export$810a8205b15f6ef5, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("lucKB", function(module, exports) {
$parcel$export(module.exports, "default", () => $7159f6e367b15848$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<65a0c0d2951c8f6f84c344c3564c0df1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7159f6e367b15848$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraTeamViewField"
};
$7159f6e367b15848$var$node.hash = "10546ea9458e9373d43b23a6a4446d16";
var $7159f6e367b15848$export$2e2bcd8739ae039 = $7159f6e367b15848$var$node;

});

parcelRegister("cEnDa", function(module, exports) {
$parcel$export(module.exports, "default", () => $d658af436007160b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2f20c59dab77492604598897b506d3fd>>
 * @relayHash ead4aeaad9bf490eb7d3435ec219e3a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c49ad7e0999f23413665b12454770bad160b1b9af9354368998b9abe8369bcc
const $d658af436007160b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "team_issueFieldTeam_TeamField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraTeamFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateTeamField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraTeamViewField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "team_issueFieldTeam_TeamField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraTeamFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateTeamField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraTeamViewField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraTeamView",
                                            "kind": "LinkedField",
                                            "name": "selectedTeam",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jiraSuppliedId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jiraSuppliedName"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3c49ad7e0999f23413665b12454770bad160b1b9af9354368998b9abe8369bcc",
            "metadata": {},
            "name": "team_issueFieldTeam_TeamField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d658af436007160b$var$node.hash = "f3f61da99e07b74cee3d1344c1a154d1";
var $d658af436007160b$export$2e2bcd8739ae039 = $d658af436007160b$var$node;

});

parcelRegister("3hPoY", function(module, exports) {
$parcel$export(module.exports, "default", () => $412219900269c0f1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7807a89c68ac9a44db6c3316858f4987>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $412219900269c0f1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "FragmentSpread",
            "name": "team_issueFieldTeamReadviewFull_TeamReadView"
        },
        {
            "concreteType": "JiraTeamView",
            "kind": "LinkedField",
            "name": "selectedTeam",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedId"
                },
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedName"
                }
            ]
        }
    ],
    "type": "JiraTeamViewField"
};
$412219900269c0f1$var$node.hash = "b9fb955ce9530b3f35116dcc41a56241";
var $412219900269c0f1$export$2e2bcd8739ae039 = $412219900269c0f1$var$node;

});

parcelRegister("luwvO", function(module, exports) {
$parcel$export(module.exports, "isRecentlyCreatedTeam", () => $bfc9862a1d9200d8$export$695c72729cb9130e);
const $bfc9862a1d9200d8$export$695c72729cb9130e = (team)=>{
    return team != null && Object.hasOwn(team, 'isRecentlyCreated');
};

});

parcelRegister("gbhyT", function(module, exports) {
$parcel$export(module.exports, "default", () => $0815c43a3970e724$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $0815c43a3970e724$var$MultiUserPickerEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("9cBAp")), {
        moduleId: "47e554b4",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $0815c43a3970e724$export$2e2bcd8739ae039 = $0815c43a3970e724$var$MultiUserPickerEditViewEntryPoint;

});
parcelRegister("9cBAp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("6RcIS")
]).then(()=>parcelRequire('33Ayl'));

});


parcelRegister("8BFAJ", function(module, exports) {
$parcel$export(module.exports, "TeamReadView", () => $ede7f5ac143c4eec$export$87458045213a5f61);

var $lGTvX = parcelRequire("lGTvX");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $FhXEJ = parcelRequire("FhXEJ");

var $3cMgR = parcelRequire("3cMgR");

var $d9T1A = parcelRequire("d9T1A");

var $kgwPr = parcelRequire("kgwPr");

var $4cTDP = parcelRequire("4cTDP");

var $aVor1 = parcelRequire("aVor1");

var $eWzpp = parcelRequire("eWzpp");
const $ede7f5ac143c4eec$export$87458045213a5f61 = ({ fragmentRef: fragmentRef, maxLines: maxLines, triggerLinkType: triggerLinkType })=>{
    const { selectedTeam: selectedTeam } = (0, $j4oe4.useFragment)((0, $lGTvX.default), fragmentRef);
    const { data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $FhXEJ.toProjectType)(project?.type);
    const isJSMOrJPDProject = projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT) || projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT);
    if (!selectedTeam?.jiraSuppliedName) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('jira-preview-panel-team-integration') && (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') && (0, $4cTDP.fg)('jira-glance-panel') && ((0, $4cTDP.fg)('jsm_enable_preview_panel') || !isJSMOrJPDProject)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVor1.TeamReadViewWithGpp), {
        teamName: selectedTeam?.jiraSuppliedName,
        ariId: selectedTeam?.jiraSuppliedId,
        maxLines: maxLines,
        showTeamPreview: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kgwPr.default), {
        teamId: selectedTeam.jiraSuppliedId,
        trigger: "hover-click",
        position: "left-start",
        triggerLinkType: triggerLinkType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: maxLines
    }, selectedTeam.jiraSuppliedName));
};

});
parcelRegister("lGTvX", function(module, exports) {
$parcel$export(module.exports, "default", () => $80b3b01a9930b2c2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2eecf37369c6c8c0d95dae02e8db59b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $80b3b01a9930b2c2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "team_issueFieldTeamReadviewFull_TeamReadView",
    "selections": [
        {
            "concreteType": "JiraTeamView",
            "kind": "LinkedField",
            "name": "selectedTeam",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedId"
                },
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedName"
                }
            ]
        }
    ],
    "type": "JiraTeamViewField"
};
$80b3b01a9930b2c2$var$node.hash = "69af0ce99580e256b8a8c95839ad6bd2";
var $80b3b01a9930b2c2$export$2e2bcd8739ae039 = $80b3b01a9930b2c2$var$node;

});

parcelRegister("kgwPr", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f47cd7ff49890ce$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $e6YEs = parcelRequire("e6YEs");

var $kh7bJ = parcelRequire("kh7bJ");

var $83DiZ = parcelRequire("83DiZ");

var $5vQ2T = parcelRequire("5vQ2T");

var $4cTDP = parcelRequire("4cTDP");

var $4LBQr = parcelRequire("4LBQr");


var $iy37d = parcelRequire("iy37d");
const $6f47cd7ff49890ce$var$TeamProfileCardNext = (props)=>{
    const { children: children, teamId: teamId } = props;
    const userId = (0, $e6YEs.useAccountId)();
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    if (!teamId || isAnonymous || !userId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "team-profilecard",
        packageName: (0, $9122f643e6cb5228$export$9345d7360ffe0722),
        fallback: (0, $4cTDP.fg)('empanada_profilecard_fix_error_boundary_fallback') ? ()=>children : 'flag'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4LBQr.ProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iy37d.TeamProfileCardInner), {
        ...props,
        userId: userId,
        onRedirect: push
    })));
};
var $6f47cd7ff49890ce$export$2e2bcd8739ae039 = $6f47cd7ff49890ce$var$TeamProfileCardNext;

});
parcelRegister("4LBQr", function(module, exports) {
$parcel$export(module.exports, "ProfileCardWrapper", () => $a6c333f8f16da456$export$59abd6feb7dc8540);

var $eJOHy = parcelRequire("eJOHy");

var $cHtIB = parcelRequire("cHtIB");

var $e6YEs = parcelRequire("e6YEs");

var $cGMXY = parcelRequire("cGMXY");

var $2sKkz = parcelRequire("2sKkz");

var $7t8WA = parcelRequire("7t8WA");
const $a6c333f8f16da456$export$59abd6feb7dc8540 = ({ externalProfileClient: externalProfileClient, children: children, onLoadError: onLoadError })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const accountId = (0, $e6YEs.useAccountId)();
    const fabricPfDirUrl = (0, $2sKkz.useFabricProfileDirectoryUrl)();
    const orgId = (0, $cGMXY.useOrgId)();
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7t8WA.ProfileClientContainer), {
        fabricPfDirUrl: fabricPfDirUrl,
        profileClient: externalProfileClient || null,
        onLoadError: onLoadError,
        cloudId: cloudId,
        // Only use the global store when no external client is provided
        isGlobal: !externalProfileClient,
        orgId: orgId
    }, children);
    // When there is no tenantContext, this will cause the child
    // component of <ProfileCard> to render without being wrapped by
    // a profile card and it will do nothing on hover
    return children;
};

});
parcelRegister("cGMXY", function(module, exports) {
$parcel$export(module.exports, "useOrgId", () => $42be11c449d1c554$export$52a03a3207af3687);

var $koAZ4 = parcelRequire("koAZ4");
const $42be11c449d1c554$export$52a03a3207af3687 = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.orgId;
};

});

parcelRegister("2sKkz", function(module, exports) {
$parcel$export(module.exports, "useFabricProfileDirectoryUrl", () => $af60317985c62746$export$cb9379d435214a54);

var $koAZ4 = parcelRequire("koAZ4");
const $af60317985c62746$export$cb9379d435214a54 = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.fabricPfDirUrl || '';
};

});

parcelRegister("7t8WA", function(module, exports) {
$parcel$export(module.exports, "createUserProfileCardClient", () => $fb0c29c9969e62d5$export$c4393c51e6d104c3);
$parcel$export(module.exports, "ProfileClientContainer", () => $fb0c29c9969e62d5$export$d816ba2709570028);
$parcel$export(module.exports, "useProfileClient", () => $fb0c29c9969e62d5$export$d43dc22a8337ee9f);

var $d5fwz = parcelRequire("d5fwz");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $ki24N = parcelRequire("ki24N");
const $fb0c29c9969e62d5$var$GATEWAY_GRAPHQL_URL = '/gateway/api/graphql';
const $fb0c29c9969e62d5$export$c4393c51e6d104c3 = (fabricPfDirUrl, onLoadError, gatewayGraphqlUrl, cloudId, orgId)=>{
    const userClient = new (0, $ki24N.CustomUserProfileClient)(fabricPfDirUrl, onLoadError);
    // From upward version 14 of `@atlaskit/profilecard`, `ProfileClient` class accepts `userClient` and `teamClient` in the 2nd argument.
    return new (0, $d5fwz.default)({
        cacheMaxAge: 180000,
        cacheSize: 20,
        url: fabricPfDirUrl,
        productIdentifier: 'jira',
        gatewayGraphqlUrl: gatewayGraphqlUrl,
        cloudId: cloudId,
        orgId: orgId
    }, {
        userClient: userClient
    });
};
const $fb0c29c9969e62d5$export$e324594224ef24da = {
    bootstrap: ()=>({ setState: setState }, { fabricPfDirUrl: fabricPfDirUrl, profileClient: profileClient, onLoadError: onLoadError, cloudId: cloudId, orgId: orgId })=>{
            const finalProfileClient = profileClient || $fb0c29c9969e62d5$export$c4393c51e6d104c3(fabricPfDirUrl ?? '', onLoadError, $fb0c29c9969e62d5$var$GATEWAY_GRAPHQL_URL, cloudId, orgId);
            setState({
                profileClient: finalProfileClient
            });
        }
};
const $fb0c29c9969e62d5$export$d816ba2709570028 = (0, $6E16M.createContainer)({
    displayName: 'ProfileClientContainer'
});
const $fb0c29c9969e62d5$export$d4c72bab9d6cc13a = {
    profileClient: null
};
const $fb0c29c9969e62d5$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'ProfileClientStore',
    initialState: $fb0c29c9969e62d5$export$d4c72bab9d6cc13a,
    actions: $fb0c29c9969e62d5$export$e324594224ef24da,
    containedBy: $fb0c29c9969e62d5$export$d816ba2709570028,
    handlers: {
        onInit: ()=>({ dispatch: dispatch })=>dispatch($fb0c29c9969e62d5$export$e324594224ef24da.bootstrap())
    }
});
const $fb0c29c9969e62d5$export$d43dc22a8337ee9f = (0, $iJq0l.createStateHook)($fb0c29c9969e62d5$export$6f57813fe9f31bf9);

});
parcelRegister("ki24N", function(module, exports) {
$parcel$export(module.exports, "CustomUserProfileClient", () => $cb11a1ab876afdf4$export$4b2a86afb64f42f1);

var $9uvjI = parcelRequire("9uvjI");

var $hgi0g = parcelRequire("hgi0g");

var $cVBK8 = parcelRequire("cVBK8");
class $cb11a1ab876afdf4$export$4b2a86afb64f42f1 extends (0, $9uvjI.default) {
    constructor(fabricPfDirUrl, onLoadError){
        super({
            url: fabricPfDirUrl,
            cacheSize: 20,
            cacheMaxAge: 180000
        }), this.makeRequest = async (cloudId, userId)=>{
            // call old profile rest endpoint
            try {
                if ((0, $cVBK8.isCustomerAccount)(userId)) {
                    const response = await (0, $hgi0g.default)(`/rest/api/3/user?accountId=${userId}`);
                    return (0, $cVBK8.restResponseToUserData)(response);
                }
                return await this.parentMakeRequest(cloudId, userId);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const error = new Error(`Unable to fetch user: ${err.message}`, {
                    cause: err
                });
                this.onLoadError?.(err);
                throw error;
            }
        };
        this.onLoadError = onLoadError;
        this.parentMakeRequest = super.makeRequest;
    }
}

});
parcelRegister("cVBK8", function(module, exports) {
$parcel$export(module.exports, "generateUserLink", () => $af7a028094d71a13$export$f4673d7e11341514);
$parcel$export(module.exports, "generateTeamLink", () => $af7a028094d71a13$export$b163ce931504dcff);
$parcel$export(module.exports, "isTeamProfileCardEventContentRendered", () => $af7a028094d71a13$export$6dc006c3779708c0);
$parcel$export(module.exports, "fireLegacyTeamAnalytics", () => $af7a028094d71a13$export$ffbbcf55d672ec61);
$parcel$export(module.exports, "restResponseToUserData", () => $af7a028094d71a13$export$66691b1affeb3bc5);
$parcel$export(module.exports, "isCustomerAccount", () => $af7a028094d71a13$export$67a41405362363f0);
$parcel$export(module.exports, "getSpaActions", () => $af7a028094d71a13$export$518f47d656cb4e1a);
$parcel$export(module.exports, "getSpaActionsWithRouterPush", () => $af7a028094d71a13$export$96e0a21dc8f6c225);

var $4cTDP = parcelRequire("4cTDP");

var $kRgKj = parcelRequire("kRgKj");

var $a62R3 = parcelRequire("a62R3");

var $kEnfd = parcelRequire("kEnfd");

const $af7a028094d71a13$export$f4673d7e11341514 = (userId)=>{
    const userProfile = (0, $a62R3.getNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId
        }
    });
    return (0, $a62R3.isTeamsAppEnabled)() ? userProfile.href : `/jira/people/${userId}`;
};
const $af7a028094d71a13$export$b163ce931504dcff = (teamId)=>{
    const teamProfile = (0, $a62R3.getNavigateToTeamsApp)({
        type: 'TEAM',
        payload: {
            teamId: teamId
        }
    });
    return (0, $a62R3.isTeamsAppEnabled)() ? teamProfile.href : `/jira/people/team/${teamId}`;
};
const $af7a028094d71a13$export$7b55c373f7e07896 = (label, profileUrl)=>({
        id: 'view-profile',
        label: label,
        callback: (event)=>{
            event.stopPropagation();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(profileUrl);
        }
    });
const $af7a028094d71a13$export$6dc006c3779708c0 = (analyticsPayload)=>analyticsPayload?.action === 'rendered' && analyticsPayload?.actionSubjectId === 'content';
const $af7a028094d71a13$export$ffbbcf55d672ec61 = (analyticsEvent)=>{
    if (analyticsEvent?.payload?.eventType === 'ui') {
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, `legacyTeamProfileCard ${analyticsEvent.payload.action}}`);
        if ($af7a028094d71a13$export$6dc006c3779708c0(analyticsEvent?.payload)) (0, $kRgKj.fireScreenAnalytics)(analyticsEvent);
    }
};
const $af7a028094d71a13$export$66691b1affeb3bc5 = (userData)=>({
        avatarUrl: userData.avatarUrls?.['48x48'],
        email: userData.emailAddress,
        fullName: userData.displayName,
        isBot: false,
        isCurrentUser: false,
        status: userData.active ? 'active' : 'inactive',
        accountType: userData.accountType
    });
const $af7a028094d71a13$export$67a41405362363f0 = (accountId)=>accountId ? accountId.lastIndexOf('qm:', 0) === 0 : false;
const $af7a028094d71a13$export$f38de51a346a7b1 = (intl, accountId)=>{
    const userProfile = (0, $a62R3.getNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: accountId
        }
    });
    return {
        label: intl && intl.formatMessage((0, $kEnfd.profileCardMessages).viewProfile),
        id: 'view-profile',
        link: (0, $a62R3.isTeamsAppEnabled)() ? userProfile.href : `/jira/people/${accountId}`,
        callback: (0, $a62R3.isTeamsAppEnabled)() ? userProfile.onNavigate : undefined,
        shouldRender: (data)=>/*
     * Those without @atlassian.com accounts do not have viewable profiles
     */ data?.accountType !== 'customer'
    };
};
const $af7a028094d71a13$var$getSpaViewProfileActionWithRouterPush = (intl, accountId, onPushAction, onActionCleanup)=>({
        label: intl && intl.formatMessage((0, $kEnfd.profileCardMessages).viewProfile),
        id: 'view-profile',
        callback: ()=>{
            onPushAction(`/jira/people/${accountId}`);
            onActionCleanup && onActionCleanup();
        },
        link: `/jira/people/${accountId}`,
        shouldRender: (data)=>/*
   * Those without @atlassian.com accounts do not have viewable profiles
   */ data?.accountType !== 'customer'
    });
const $af7a028094d71a13$var$getAssignedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $kEnfd.profileCardMessages).assignedIssuesIssueTerminologyRefreshM4 : (0, $kEnfd.profileCardMessages).assignedIssues),
        id: 'assigned-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`assignee="${accountId || ''}" AND resolution is empty`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $af7a028094d71a13$var$getReportedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $kEnfd.profileCardMessages).reportedIssuesIssueTerminologyRefreshM4 : (0, $kEnfd.profileCardMessages).reportedIssues),
        id: 'reported-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`reporter="${accountId || ''}" order by created DESC`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $af7a028094d71a13$var$getViewFiltersAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $kEnfd.profileCardMessages).viewFilters),
        id: 'view-filters',
        callback: ()=>{
            const url = `/jira/filters?owner=${encodeURIComponent(accountId)}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $af7a028094d71a13$export$518f47d656cb4e1a = (accountId, intl, actions)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $9122f643e6cb5228$export$23cedd3261bd8015:
                return $af7a028094d71a13$export$f38de51a346a7b1(intl, accountId);
            case 0, $9122f643e6cb5228$export$6bef782d14a92db8:
                return $af7a028094d71a13$var$getAssignedIssuesAction(intl, accountId);
            case 0, $9122f643e6cb5228$export$6b36f20db7a18a86:
                return $af7a028094d71a13$var$getReportedIssuesAction(intl, accountId);
            case 0, $9122f643e6cb5228$export$56da0dd0b0aa67b9:
                return $af7a028094d71a13$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $af7a028094d71a13$export$f38de51a346a7b1(intl, accountId)
    ];
};
const $af7a028094d71a13$export$96e0a21dc8f6c225 = (accountId, intl, onPushAction, actions, onActionCleanup)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $9122f643e6cb5228$export$23cedd3261bd8015:
                return $af7a028094d71a13$var$getSpaViewProfileActionWithRouterPush(intl, accountId, onPushAction, onActionCleanup);
            case 0, $9122f643e6cb5228$export$6bef782d14a92db8:
                return $af7a028094d71a13$var$getAssignedIssuesAction(intl, accountId);
            case 0, $9122f643e6cb5228$export$6b36f20db7a18a86:
                return $af7a028094d71a13$var$getReportedIssuesAction(intl, accountId);
            case 0, $9122f643e6cb5228$export$56da0dd0b0aa67b9:
                return $af7a028094d71a13$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $af7a028094d71a13$var$getSpaViewProfileActionWithRouterPush(intl, accountId, onPushAction, onActionCleanup)
    ];
};

});
parcelRegister("kEnfd", function(module, exports) {
$parcel$export(module.exports, "profileCardMessages", () => $4e049bd416c46183$export$49f2d2ccb123fddf);

var $7qGN1 = parcelRequire("7qGN1");
const $4e049bd416c46183$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    view: {
        "id": "profilecard-next",
        "defaultMessage": "View profile"
    }
});
const $4e049bd416c46183$export$49f2d2ccb123fddf = (0, $7qGN1.defineMessages)({
    assignedIssues: {
        "id": "profilecard-next.assigned-issues",
        "defaultMessage": "Assigned issues"
    },
    viewProfile: {
        "id": "profilecard-next.view-profile",
        "defaultMessage": "View profile"
    },
    reportedIssues: {
        "id": "profilecard-next.reported-issues",
        "defaultMessage": "Reported issues"
    },
    viewFilters: {
        "id": "profilecard-next.view-filters",
        "defaultMessage": "View filters"
    },
    assignedIssuesIssueTerminologyRefreshM4: {
        "id": "profilecard-next.assigned-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Assigned work items"
    },
    reportedIssuesIssueTerminologyRefreshM4: {
        "id": "profilecard-next.reported-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Reported work items"
    }
});

});

const $9122f643e6cb5228$export$9345d7360ffe0722 = 'jira-profilecard-next';
const $9122f643e6cb5228$export$81319ffa9c0d18d7 = 'profileCardNext';
const $9122f643e6cb5228$export$50632e21ea714398 = 'profileCardNextLegacy';
const $9122f643e6cb5228$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $9122f643e6cb5228$export$23cedd3261bd8015 = 'viewProfile';
const $9122f643e6cb5228$export$6bef782d14a92db8 = 'assignedIssues';
const $9122f643e6cb5228$export$6b36f20db7a18a86 = 'reportedIssues';
const $9122f643e6cb5228$export$56da0dd0b0aa67b9 = 'viewFilters';





parcelRegister("iy37d", function(module, exports) {
$parcel$export(module.exports, "TeamProfileCardInner", () => $53ee96d70731dc27$export$25379cf72e576e0e);

var $eJOHy = parcelRequire("eJOHy");

var $3VLQJ = parcelRequire("3VLQJ");

var $ymEZt = parcelRequire("ymEZt");
var $jn1Cb = parcelRequire("jn1Cb");
var $cSXp8 = parcelRequire("cSXp8");

var $g9Vr6 = parcelRequire("g9Vr6");

var $a62R3 = parcelRequire("a62R3");

var $4cTDP = parcelRequire("4cTDP");

var $cVBK8 = parcelRequire("cVBK8");

var $7t8WA = parcelRequire("7t8WA");
const $53ee96d70731dc27$export$25379cf72e576e0e = ({ children: children, onRedirect: onRedirect, position: position, shouldRenderToParent: shouldRenderToParent, teamId: teamId, trigger: trigger, triggerLinkType: triggerLinkType, userId: userId })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
    const onUserClick = (0, $eJOHy.useCallback)((accountId)=>onRedirect((0, $cVBK8.generateUserLink)(accountId)), [
        onRedirect
    ]);
    const { href: href, onNavigate: onNavigate } = (0, $a62R3.useNavigateToTeamsApp)({
        type: 'TEAM',
        payload: {
            teamId: teamId
        }
    });
    const teamProfileUrl = (0, $4cTDP.fg)('jira-adopt-teams-nav-config') ? href : `/jira/people/team/${teamId}`;
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { profileClient: profileClient } = (0, $7t8WA.useProfileClient)();
    if (!profileClient) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3VLQJ.default), {
        teamId: teamId,
        orgId: orgId,
        viewingUserId: userId,
        resourceClient: profileClient,
        trigger: trigger,
        triggerLinkType: triggerLinkType,
        viewProfileLink: teamProfileUrl,
        viewProfileOnClick: ()=>(0, $4cTDP.fg)('jira-adopt-teams-nav-config') ? onNavigate() : onRedirect(teamProfileUrl),
        generateUserLink: (0, $cVBK8.generateUserLink),
        onUserClick: onUserClick,
        position: position,
        shouldRenderToParent: shouldRenderToParent,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- FYI: Typed as "any" in platform component
        addFlag: (flag)=>{
            const flagId = (0, $jn1Cb.toFlagId)(flag.id);
            showFlag({
                id: flagId,
                render: (flagProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ymEZt.default), {
                        ...flag,
                        onDismissed: ()=>{
                            dismissFlag(flagId);
                        },
                        messageId: `profilecard-next.ui.team-profilecard.ak-flag.${flagId}`,
                        messageType: "transactional",
                        ...flagProps
                    })
            });
        }
    }, children);
};

});
parcelRegister("3VLQJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $211b7e44240e97e1$export$2e2bcd8739ae039);
// Do not export TeamProfileCard here as it will break lazy-loading for the team trigger.


var $zgYE5 = parcelRequire("zgYE5");
var $211b7e44240e97e1$export$2e2bcd8739ae039 = (0, $zgYE5.default);

});
parcelRegister("zgYE5", function(module, exports) {
$parcel$export(module.exports, "default", () => $ecd450f82eec537e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $6YFG2 = parcelRequire("6YFG2");

var $4J0ad = parcelRequire("4J0ad");

var $7m76n = parcelRequire("7m76n");
var $XUWry = parcelRequire("XUWry");

var $eGOwo = parcelRequire("eGOwo");

var $kioCn = parcelRequire("kioCn");

var $kJsb4 = parcelRequire("kJsb4");

var $8IeH1 = parcelRequire("8IeH1");

var $g06PH = parcelRequire("g06PH");

var $IW7jS = parcelRequire("IW7jS");

var $gh6xW = parcelRequire("gh6xW");

var $2L2e5 = parcelRequire("2L2e5");

var $2EPX4 = parcelRequire("2EPX4");

var $g5TmB = parcelRequire("g5TmB");


var $kNQN4 = parcelRequire("kNQN4");

var $74i65 = parcelRequire("74i65");

var $aci2z = parcelRequire("aci2z");

var $8ZI1l = parcelRequire("8ZI1l");
class $ecd450f82eec537e$export$f811dc569217c959 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static{
        this.defaultProps = {
            actions: [],
            trigger: 'hover',
            position: 'bottom-start',
            triggerLinkType: 'link',
            shouldRenderToParent: true
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentDidUpdate(prevProps) {
        const { orgId: orgId, teamId: teamId, resourceClient: resourceClient } = this.props;
        const { visible: visible } = this.state;
        // just re-fetching data when the card opens
        if (visible && (teamId !== prevProps.teamId || orgId !== prevProps.orgId || resourceClient !== prevProps.resourceClient)) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
        clearTimeout(this.showTimer);
        clearTimeout(this.hideTimer);
    }
    handleClientSuccess(team, shouldShowGiveKudos, teamCentralBaseUrl) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: team,
            shouldShowGiveKudos: shouldShowGiveKudos,
            teamCentralBaseUrl: teamCentralBaseUrl
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    filterActions() {
        const actions = (0, $gh6xW.default)(this.props.actions, this.state.data);
        if (this.state.shouldShowGiveKudos) {
            const kudosAction = {
                label: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $2L2e5.default).giveKudosButton
                }),
                id: 'give-kudos',
                callback: ()=>{
                    this.openKudosDrawer();
                },
                link: this.kudosUrl()
            };
            return actions.concat([
                kudosAction
            ]);
        }
        return actions;
    }
    renderPopup() {
        if (this.state.renderError) return this.props.children;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $74i65.ErrorBoundary), {
            onError: this.onErrorBoundary,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
                isOpen: !!this.state.visible,
                onClose: this.onClose,
                placement: this.props.position,
                content: this.renderProfileCard,
                trigger: (triggerProps)=>this.renderTrigger(triggerProps),
                zIndex: (0, $IW7jS.layers).modal(),
                shouldFlip: true,
                autoFocus: this.props.trigger !== 'hover' && !this.openedByHover,
                shouldRenderToParent: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card') && this.props.shouldRenderToParent
            })
        });
    }
    render() {
        if (this.props.children) return this.renderPopup();
        else throw new Error('Component "TeamProfileCardTrigger" must have "children" property');
    }
    constructor(...args){
        super(...args), this._isMounted = false, this.showTimer = 0, this.hideTimer = 0, this.openedByHover = false, this.openTime = 0, this.fireAnalytics = (payload)=>{
            // Don't fire any analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.createAnalyticsEvent) (0, $2EPX4.fireEvent)(this.props.createAnalyticsEvent, payload);
        }, this.fireAnalyticsNext = (eventKey, ...attributes)=>{
            // Don't fire any analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.fireEvent) this.props.fireEvent(eventKey, ...attributes);
        }, this.fireAnalyticsWithDuration = (generator)=>{
            const event = generator((0, $kNQN4.getPageTime)() - this.openTime);
            this.fireAnalytics(event);
        }, this.fireAnalyticsWithDurationNext = (eventKey, generator)=>{
            const duration = (0, $kNQN4.getPageTime)() - this.openTime;
            const attributes = generator(duration);
            this.fireAnalyticsNext(eventKey, attributes);
        }, this.hideProfilecard = (delay = 0)=>{
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
            this.hideTimer = window.setTimeout(()=>{
                this.setState({
                    visible: false
                });
            }, delay);
        }, this.showProfilecard = (delay = 0)=>{
            clearTimeout(this.hideTimer);
            clearTimeout(this.showTimer);
            this.showTimer = window.setTimeout(()=>{
                if (!this.state.visible) {
                    this.clientFetchProfile();
                    this.openTime = (0, $kNQN4.getPageTime)();
                    this.setState({
                        visible: true
                    });
                }
            }, delay);
        }, this.onClick = (event)=>{
            if (this.props.triggerLinkType === 'link') // We want to prevent navigation occurring on basic click, but it's important that
            // cmd+click, ctrl+click, etc. still work as expected.
            {
                if ((0, $g5TmB.isBasicClick)(event)) event.preventDefault();
            }
            if (this.props.triggerLinkType === 'clickable-link') {
                if (this.props.viewProfileOnClick) this.props.viewProfileOnClick(event);
            }
            if (this.props.trigger !== 'hover') {
                this.openedByHover = false;
                this.showProfilecard(0);
                if (!this.state.visible) {
                    if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) this.fireAnalyticsNext('ui.teamProfileCard.triggered', {
                        method: 'click',
                        ...(0, $2EPX4.PACKAGE_META_DATA),
                        firedAt: Math.round((0, $kNQN4.getPageTime)()),
                        teamId: this.props.teamId
                    });
                    else this.fireAnalytics((0, $2EPX4.cardTriggered)('team', 'click', this.props.teamId));
                }
            }
        }, this.onMouseEnter = ()=>{
            if (this.props.trigger === 'click') return;
            if (!this.state.visible) {
                this.openedByHover = true;
                if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) this.fireAnalyticsNext('ui.teamProfileCard.triggered', {
                    method: 'hover',
                    ...(0, $2EPX4.PACKAGE_META_DATA),
                    firedAt: Math.round((0, $kNQN4.getPageTime)()),
                    teamId: this.props.teamId
                });
                else this.fireAnalytics((0, $2EPX4.cardTriggered)('team', 'hover', this.props.teamId));
            }
            this.showProfilecard((0, $776ef75d5b01ad48$export$5b956b542f1bc1b3));
        }, this.onMouseLeave = ()=>{
            if (this.props.trigger === 'click') return;
            if (this.openedByHover) this.hideProfilecard((0, $776ef75d5b01ad48$export$89a9f35a94d7f196));
        }, this.onKeyPress = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isTriggeredByKeyboard: true
                });
                this.showProfilecard(0);
                if (!this.state.visible) {
                    if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) this.fireAnalyticsNext('ui.teamProfileCard.triggered', {
                        method: 'click',
                        firedAt: Math.round((0, $kNQN4.getPageTime)()),
                        teamId: this.props.teamId,
                        ...(0, $2EPX4.PACKAGE_META_DATA)
                    });
                    else this.fireAnalytics((0, $2EPX4.cardTriggered)('team', 'click', this.props.teamId));
                }
            }
        }, this.onClose = ()=>{
            this.hideProfilecard();
            this.setState({
                isTriggeredByKeyboard: false
            });
        }, this.openKudosDrawer = ()=>{
            this.hideProfilecard((0, $776ef75d5b01ad48$export$89a9f35a94d7f196));
            this.setState({
                kudosDrawerOpen: true
            });
        }, this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        }, this.kudosUrl = ()=>{
            const recipientId = this.props.teamId && `&recipientId=${this.props.teamId}` || '';
            const cloudId = this.props.cloudId && `&cloudId=${this.props.cloudId}` || '';
            return `${this.state.teamCentralBaseUrl}/kudos/give?type=team${recipientId}${cloudId}`;
        }, this.stopPropagation = (event)=>{
            // We need to stop propagation when users click on the card, so that it
            // doesn't trigger any special effects that occur when clicking the trigger.
            event.stopPropagation();
        }, this.triggerListeners = {
            onClick: this.onClick,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        }, this.cardListeners = {
            onClick: this.stopPropagation,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        }, this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            shouldShowGiveKudos: false,
            teamCentralBaseUrl: undefined,
            kudosDrawerOpen: false,
            isTriggeredByKeyboard: false
        }, this.clientFetchProfile = ()=>{
            const { orgId: orgId, teamId: teamId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                isLoading: true,
                data: null
            }, ()=>{
                const fireEvent = (event)=>{
                    this.fireAnalytics(event);
                };
                const fireAnalyticsNext = (eventKey, ...attributes)=>{
                    this.fireAnalyticsNext(eventKey, ...attributes);
                };
                const requests = Promise.all([
                    this.props.resourceClient.getTeamProfile(teamId, orgId, fireEvent, fireAnalyticsNext),
                    this.props.resourceClient.shouldShowGiveKudos(),
                    this.props.resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        }, this.onErrorBoundary = ()=>{
            if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) this.fireAnalyticsNext('ui.teamProfileCard.rendered.errorBoundary', {
                ...(0, $2EPX4.PACKAGE_META_DATA),
                firedAt: Math.round((0, $kNQN4.getPageTime)()),
                duration: 0
            });
            else this.fireAnalytics((0, $2EPX4.profileCardRendered)('team', 'errorBoundary', {
                duration: 0
            }));
            this.setState({
                renderError: true
            });
        }, this.renderProfileCard = ()=>{
            const { generateUserLink: generateUserLink, onUserClick: onUserClick, viewingUserId: viewingUserId, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick } = this.props;
            const { data: data, error: error, hasError: hasError, isLoading: isLoading } = this.state;
            const newProps = {
                clientFetchProfile: this.clientFetchProfile,
                actions: this.filterActions(),
                analytics: this.fireAnalyticsWithDuration,
                analyticsNext: this.fireAnalyticsWithDurationNext,
                team: data || undefined,
                generateUserLink: generateUserLink,
                onUserClick: onUserClick,
                viewingUserId: viewingUserId,
                viewProfileLink: viewProfileLink,
                viewProfileOnClick: viewProfileOnClick
            };
            return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ...this.cardListeners,
                children: this.state.visible && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                    fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ZI1l.default), {
                        analytics: this.fireAnalyticsWithDuration,
                        analyticsNext: this.fireAnalyticsWithDurationNext
                    }),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aci2z.TeamProfileCardLazy), {
                        ...newProps,
                        isLoading: isLoading,
                        hasError: hasError,
                        errorType: error,
                        isTriggeredByKeyboard: this.state.isTriggeredByKeyboard
                    })
                })
            });
        }, this.renderKudosLauncher = ()=>{
            return this.state.shouldShowGiveKudos && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7m76n.GiveKudosLauncherLazy), {
                    isOpen: this.state.kudosDrawerOpen,
                    recipient: {
                        type: (0, $XUWry.KudosType).TEAM,
                        recipientId: this.props.teamId
                    },
                    analyticsSource: "team-profile-card",
                    teamCentralBaseUrl: this.state.teamCentralBaseUrl,
                    cloudId: this.props.cloudId || '',
                    addFlag: this.props.addFlag,
                    onClose: this.closeKudosDrawer
                })
            });
        }, this.renderTrigger = (triggerProps)=>{
            const { children: children, intl: intl, triggerLinkType: triggerLinkType, viewProfileLink: viewProfileLink } = this.props;
            if (triggerLinkType === 'none') return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        as: "span",
                        role: "button",
                        testId: "team-profilecard-trigger-wrapper",
                        tabIndex: 0,
                        "aria-label": intl.formatMessage((0, $2L2e5.default).teamProfileCardAriaLabel),
                        onKeyUp: this.onKeyPress,
                        ...triggerProps,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
            return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                        "data-testid": "team-profilecard-trigger-wrapper",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            color: 'initial',
                            textDecoration: 'none'
                        },
                        href: viewProfileLink,
                        ...triggerProps,
                        ref: triggerProps.ref,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
        };
    }
}
const $ecd450f82eec537e$var$TeamProfileCardTriggerWithAnalytics = (props)=>{
    const { fireEvent: fireEvent } = (0, $g06PH.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ecd450f82eec537e$export$f811dc569217c959, {
        ...props,
        fireEvent: fireEvent
    });
};
var $ecd450f82eec537e$export$2e2bcd8739ae039 = (0, $kioCn.componentWithFG)('ptc-enable-profile-card-analytics-refactor', (0, $6YFG2.default)($ecd450f82eec537e$var$TeamProfileCardTriggerWithAnalytics), (0, $4J0ad.default)()((0, $6YFG2.default)($ecd450f82eec537e$export$f811dc569217c959)));

});
parcelRegister("2L2e5", function(module, exports) {
$parcel$export(module.exports, "default", () => $0136d5b4c5e5df89$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0136d5b4c5e5df89$var$messages = (0, $7qGN1.defineMessages)({
    inactiveAccountMsg: {
        id: 'pt.profile-card.inactive.account',
        defaultMessage: 'Account deactivated',
        description: 'A text in a grey lozenge shows that this user is inactive'
    },
    generalDescMsgForDisabledUser: {
        id: 'pt.profile-card.general.msg.disabled.user',
        defaultMessage: 'You can no longer collaborate with this person.',
        description: 'A first sentence of a long text explains this user is inactive/closed'
    },
    inactiveAccountDescMsgNoDate: {
        id: 'pt.profile-card.inactive.account.no.date',
        defaultMessage: 'Their account has been deactivated.',
        description: 'A long text explains this user is inactive when we do not know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.inactive.account.has.date.this.week',
        defaultMessage: 'Their account was deactivated this week.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.inactive.account.has.date.this.month',
        defaultMessage: 'Their account was deactivated this month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.inactive.account.has.date.last.month',
        defaultMessage: 'Their account was deactivated last month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.inactive.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deactivated for a few months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.inactive.account.has.date.several.months',
        defaultMessage: 'Their account has been deactivated for several months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.inactive.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deactivated for more than a year.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    closedAccountMsg: {
        id: 'pt.profile-card.closed.account',
        defaultMessage: 'Account deleted',
        description: 'A text in a grey lozenge shows that this user is closed/deleted'
    },
    closedAccountDescMsgNoDate: {
        id: 'pt.profile-card.closed.account.no.date',
        defaultMessage: 'Their account has been deleted.',
        description: 'A long text explains this user is closed when we do not know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.closed.account.has.date.this.week',
        defaultMessage: 'Their account was deleted this week.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.closed.account.has.date.this.month',
        defaultMessage: 'Their account was deleted this month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.closed.account.has.date.last.month',
        defaultMessage: 'Their account was deleted last month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.closed.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deleted for a few months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.closed.account.has.date.several.months',
        defaultMessage: 'Their account has been deleted for several months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.closed.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deleted for more than a year.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    disabledAccountDefaultName: {
        id: 'pt.profile-card.disabled.account.default.name',
        defaultMessage: 'Former user',
        description: 'A default name when we cannot get name of an inactive or closed user'
    },
    teamViewProfile: {
        id: 'pt.team-profile-card.team.action.view-profile',
        defaultMessage: 'View profile',
        description: "Button that takes you to view this team\u2019s profile"
    },
    memberCount: {
        id: 'pt.team-profile-card.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team'
    },
    memberCountIncludingYou: {
        id: 'pt.team-profile-card.team.member.count-including-you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team and highlight that the user is a member'
    },
    membersMoreThan50: {
        id: 'pt.team-profile-card.team.member.many',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the team has more than 50 members'
    },
    membersMoreThan50IncludingYou: {
        id: 'pt.team-profile-card.team.member.many-including-you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the team has more than 50 members and highlight that the user is a member'
    },
    teamErrorTitle: {
        id: 'pt.team-profile-card.error.title',
        defaultMessage: "We\u2019re having trouble retrieving this teams information",
        description: 'Title for an error view explaining that data for this team cannot be accessed'
    },
    teamErrorText: {
        id: 'pt.team-profile-card.error.suggestion',
        defaultMessage: 'Wait a few moments, then try again.',
        description: 'Second line suggesting how to fix the issue'
    },
    teamErrorButton: {
        id: 'pt.team-profile-card.error.refresh-button',
        defaultMessage: 'Try again',
        description: 'Text on a button that will try to get the data again when clicked'
    },
    teamForbiddenErrorStateTitle: {
        id: 'pt.team-profile-card.forbidden-error-state.title',
        defaultMessage: "We can\u2019t show you this team",
        description: 'Title for the error state that is displayed when a user lacks access to the team'
    },
    teamForbiddenErrorStateDescription: {
        id: 'pt.team-profile-card.forbidden-error-state.description',
        defaultMessage: "You don\u2019t have access to view this team.",
        description: 'Description for the error state that is displayed when a user lacks access to the team'
    },
    managerSectionHeading: {
        id: 'pt.team-profile-card.manager.heading',
        defaultMessage: 'Manager',
        description: "Title for a section on the profile card that show the user's direct manager"
    },
    directReportsSectionHeading: {
        id: 'pt.team-profile-card.directReports.heading',
        defaultMessage: 'Direct reports',
        description: "Title for a section on the profile card that show the user's direct reports"
    },
    teamProfileCardAriaLabel: {
        id: 'pt.team-profile-card.aria-label',
        defaultMessage: 'More information about this team',
        description: 'Aria label for the team profile card'
    },
    giveKudosButton: {
        id: 'pt.profile-card.give-kudos',
        defaultMessage: 'Give kudos',
        description: 'Title for the button on the profile card for a user to give a kudos'
    },
    // Remove this as part of the FG Cleanup for jfp_a11y_team_profile_card_actions_label
    profileCardMoreIconLabel: {
        id: 'pt.profile-card.more-icon-label',
        defaultMessage: 'More',
        description: 'Label for the meatballs icon on the profile card, which when clicked will provide more options'
    },
    profileCardMoreIconLabelWithName: {
        id: 'pt.profile-card.more-icon-label-with-name',
        defaultMessage: 'More actions for {fullName}',
        description: 'Label for the meatballs icon on the profile card, which when clicked will provide more options'
    },
    profileCardMoreReportingLinesLabel: {
        id: 'pt.user-profile-card.reporting-lines.more-icon-label',
        defaultMessage: '+{count} more {count, plural, one {profile} other {profiles}}',
        description: 'Label for the "more profiles" indicator in the reporting lines section of the user profile card'
    },
    profileCardMoreMembersLabel: {
        id: 'pt.team.profile-card.members.more-icon-label',
        defaultMessage: '+{count} more {count, plural, one {members} other {members}}',
        description: 'Label for the "more members" indicator in the members section of the team profile card'
    },
    archivedLozenge: {
        id: 'pt.team-profile-card.archived-lozenge',
        defaultMessage: 'Archived',
        description: 'Lozenge to indicate that a team is archived'
    }
});
var $0136d5b4c5e5df89$export$2e2bcd8739ae039 = $0136d5b4c5e5df89$var$messages;

});

parcelRegister("g5TmB", function(module, exports) {
$parcel$export(module.exports, "isBasicClick", () => $d966bd6e0cdd5a4c$export$eddcd8a5b7e09991);
const $d966bd6e0cdd5a4c$export$eddcd8a5b7e09991 = (event)=>{
    return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

});

const $776ef75d5b01ad48$export$5b956b542f1bc1b3 = 800;
const $776ef75d5b01ad48$export$89a9f35a94d7f196 = 200;

parcelRegister("74i65", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $c1e0a551e3d32906$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");
class $c1e0a551e3d32906$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidCatch() {
        // Failure analytics here too
        this.props.onError();
    }
    render() {
        return this.props.children;
    }
}
var $c1e0a551e3d32906$export$2e2bcd8739ae039 = $c1e0a551e3d32906$export$e926676385687eaf;

});

parcelRegister("aci2z", function(module, exports) {
$parcel$export(module.exports, "TeamProfileCardLazy", () => $0341a64f783b98dd$export$82a49d896f41ca78);

var $eJOHy = parcelRequire("eJOHy");

const $0341a64f783b98dd$export$82a49d896f41ca78 = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("efLsN")));

});
parcelRegister("efLsN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("azqRW").then(()=>parcelRequire('gVW5o'));

});


parcelRegister("8ZI1l", function(module, exports) {
$parcel$export(module.exports, "default", () => $46bb11efbe40b76f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $7ep4S = parcelRequire("7ep4S");

var $84DsM = parcelRequire("84DsM");

var $2EPX4 = parcelRequire("2EPX4");

var $kNQN4 = parcelRequire("kNQN4");
var $46bb11efbe40b76f$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics, analyticsNext: analyticsNext } = props;
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) analyticsNext('ui.teamProfileCard.rendered.spinner', (duration)=>({
                duration: duration,
                firedAt: Math.round((0, $kNQN4.getPageTime)()),
                ...(0, $2EPX4.PACKAGE_META_DATA)
            }));
        else analytics((duration)=>(0, $2EPX4.profileCardRendered)('team', 'spinner', {
                duration: duration
            }));
    }, [
        analytics,
        analyticsNext
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $84DsM.CardWrapper), {
        testId: "team-profilecard",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $84DsM.CardHeader), {
                isLoading: true
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $84DsM.CardContent), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $84DsM.LoadingWrapper), {
                    testId: "team-profilecard-spinner",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {})
                })
            })
        ]
    });
};

});
parcelRegister("84DsM", function(module, exports) {
$parcel$export(module.exports, "CardWrapper", () => $a368743025da7b9f$export$6aa22a823032b784);
$parcel$export(module.exports, "CardHeader", () => $a368743025da7b9f$export$5665775b26e26c5d);
$parcel$export(module.exports, "CardContent", () => $a368743025da7b9f$export$64ef9b8c11710c47);
$parcel$export(module.exports, "LoadingWrapper", () => $a368743025da7b9f$export$43a792a870d28db2);
/* TeamTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");

var $gVqtd = parcelRequire("gVqtd");
const $a368743025da7b9f$var$styles = {
    cardtriggerwrapper: "_1e0c1kw7",
    cardwrapper: "_2rko12b0 _1bsbnklw _kqswh2mm",
    cardheader: "_4t3i1qr7 _1bsb1osq",
    cardcontent: "_1e0c1txw _2lx21bp4 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _1tke1l8a",
    loadingwrapper: "_y3gn1h6o _19pk1jfw _otyr1jfw",
    grayoutImage: "_kdam7g3v"
};
const $a368743025da7b9f$export$a443be8291b92497 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.cardtriggerwrapper)
    });
const $a368743025da7b9f$export$6aa22a823032b784 = ({ testId: testId, children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.cardwrapper),
        backgroundColor: "elevation.surface.overlay",
        testId: testId,
        children: children
    });
const $a368743025da7b9f$export$5665775b26e26c5d = ({ image: image, isLoading: isLoading, label: label, isDisabled: isDisabled })=>isLoading || !image ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.cardheader, isDisabled && $a368743025da7b9f$var$styles.grayoutImage),
        backgroundColor: "color.background.neutral"
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gVqtd.CoverImage), {
        alt: label || '',
        src: image,
        isDisabled: isDisabled
    });
const $a368743025da7b9f$export$64ef9b8c11710c47 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.cardcontent),
        ...props
    });
const $a368743025da7b9f$export$43a792a870d28db2 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.loadingwrapper),
        ...props
    });

});
parcelRegister("gVqtd", function(module, exports) {
$parcel$export(module.exports, "CoverImage", () => $2e76209cd6ae11d8$export$a65e282337ff0f53);
/* CoverImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
const $2e76209cd6ae11d8$var$styles = {
    container: "_1reo15vq _18m915vq _1bsb1osq _4t3i1qr7 _kqswh2mm _13li12b0 _qrwq12b0 _1e0c1txw _1bah1h6o _4cvr1h6o",
    image: "_1bsbnklw _4t3i1wug",
    imageNext: "_4t3i1osq _5ral1dfr",
    grayoutImage: "_kdam7g3v"
};
const $2e76209cd6ae11d8$export$a65e282337ff0f53 = ({ src: src, alt: alt = '', isDisabled: isDisabled })=>{
    const containerRef = (0, $eJOHy.useRef)(null);
    const imgRef = (0, $eJOHy.useRef)(null);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        ref: containerRef,
        xcss: $2e76209cd6ae11d8$var$styles.container,
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            as: "img",
            ref: imgRef,
            src: src,
            alt: alt,
            xcss: (0, $6qaBj.cx)((0, $eGOwo.fg)('cover-header-image-team-profilecard') ? $2e76209cd6ae11d8$var$styles.imageNext : $2e76209cd6ae11d8$var$styles.image, isDisabled && $2e76209cd6ae11d8$var$styles.grayoutImage)
        })
    });
};

});







parcelRegister("aVor1", function(module, exports) {
$parcel$export(module.exports, "TeamReadViewWithGpp", () => $deb0ebcb9ca82ac4$export$ad83489c3f151e9e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lL4G9 = parcelRequire("lL4G9");
var $1DXK0 = parcelRequire("1DXK0");

var $2sLVw = parcelRequire("2sLVw");
var $3cMgR = parcelRequire("3cMgR");

var $6qS8z = parcelRequire("6qS8z");

var $6bLlX = parcelRequire("6bLlX");

var $bmoS1 = parcelRequire("bmoS1");

var $lRq8t = parcelRequire("lRq8t");

var $48BVs = parcelRequire("48BVs");

var $kgwPr = parcelRequire("kgwPr");

var $4cTDP = parcelRequire("4cTDP");

var $lO5gq = parcelRequire("lO5gq");
const $deb0ebcb9ca82ac4$export$ad83489c3f151e9e = ({ teamName: teamName, teamId: teamId, ariId: ariId, maxLines: maxLines, triggerLinkType: triggerLinkType = 'link', showTeamPreview: showTeamPreview = false })=>{
    const isPreviewPanelContextAvailable = (0, $eJOHy.useContext)((0, $6bLlX.JiraPreviewPanelsContext));
    let isPreviewPanelAvailable = !!isPreviewPanelContextAvailable;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const resolvedTeamId = teamId || (ariId ? (0, $48BVs.getIdFromAri)(ariId) : '');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const teamUrl = `${window.location.origin}/jira/people/team/${resolvedTeamId}`;
    let openPreviewPanelWithTeamData = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    (event)=>{}, []);
    if (isPreviewPanelAvailable) {
        const { openPreviewPanel: openPreviewPanel, isPreviewPanelAvailable: isPreviewPanelAvailableInContext } = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $6bLlX.useGlobalObjectPreviewPanels)();
        isPreviewPanelAvailable = isPreviewPanelAvailable && isPreviewPanelAvailableInContext({
            ari: ariId || ''
        });
        // eslint-disable-next-line react-hooks/rules-of-hooks
        openPreviewPanelWithTeamData = (0, $eJOHy.useCallback)((event)=>{
            // For keyboard events, only respond to Enter and Space
            if ('key' in event && event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            event.stopPropagation();
            openPreviewPanel({
                ari: ariId,
                url: teamUrl,
                name: 'identity-team'
            });
        }, [
            ariId,
            openPreviewPanel,
            teamUrl
        ]);
    }
    const handleLinkClick = (0, $eJOHy.useCallback)((event)=>{
        event.stopPropagation();
    }, []);
    const ariaLabel = formatMessage((0, $lO5gq.default).teamPreviewLabel, {
        teamName: teamName
    });
    const isModal = (0, $bmoS1.useIsModal)();
    const canShowPreview = !isModal && isPreviewPanelAvailable;
    const teamNameContent = canShowPreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($deb0ebcb9ca82ac4$var$TeamNameWrapper, {
        onClick: openPreviewPanelWithTeamData,
        onKeyDown: openPreviewPanelWithTeamData,
        role: "button",
        tabIndex: 0,
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: maxLines
    }, teamName)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        href: teamUrl,
        target: "_blank",
        onClick: handleLinkClick,
        xcss: $deb0ebcb9ca82ac4$var$teamLinkStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: maxLines
    }, teamName));
    const gppContent = (0, $4cTDP.fg)('avatar_for_jira_team_field') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        gap: "space.050",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6qS8z.default), {
        size: "small",
        teamId: teamId
    }), teamNameContent) : teamNameContent;
    if (showTeamPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kgwPr.default), {
        teamId: ariId,
        trigger: "hover",
        position: "left-start",
        triggerLinkType: triggerLinkType
    }, gppContent);
    return gppContent;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $deb0ebcb9ca82ac4$var$TeamNameWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _80omtlke _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $deb0ebcb9ca82ac4$var$teamLinkStyles = (0, $1DXK0.xcss)({
    cursor: 'pointer',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: 'color.text',
    ':hover': {
        textDecoration: 'underline',
        color: 'color.text'
    },
    ':visited': {
        color: 'color.text'
    },
    ':focus': {
        color: 'color.text'
    }
});

});
parcelRegister("48BVs", function(module, exports) {
$parcel$export(module.exports, "getColorForProgress", () => $de59d015c44f2268$export$58950a4b8fb8acf4);
$parcel$export(module.exports, "getScorecardHealthCountsFromScores", () => $de59d015c44f2268$export$a64a7643d5a3fae);
$parcel$export(module.exports, "getSummaryText", () => $de59d015c44f2268$export$d48af90fda49897);
$parcel$export(module.exports, "getScorecardsSortedByHealth", () => $de59d015c44f2268$export$6e2af0614a0d9b67);
$parcel$export(module.exports, "getIdFromAri", () => $de59d015c44f2268$export$79640a85913af5aa);


var $9CuM6 = parcelRequire("9CuM6");
const $de59d015c44f2268$export$aa91e30498abc411 = {
    FAILING: 0,
    NEEDS_ATTENTION: 50,
    PASSING: 100
};
const $de59d015c44f2268$var$COLOR_RANGES = [
    {
        start: $de59d015c44f2268$export$aa91e30498abc411.FAILING,
        end: $de59d015c44f2268$export$aa91e30498abc411.NEEDS_ATTENTION - 1,
        color: (0, $7bb4c1736002a04a$exports).R300
    },
    {
        start: $de59d015c44f2268$export$aa91e30498abc411.NEEDS_ATTENTION,
        end: $de59d015c44f2268$export$aa91e30498abc411.PASSING - 1,
        color: (0, $7bb4c1736002a04a$exports).Y300
    },
    {
        start: $de59d015c44f2268$export$aa91e30498abc411.PASSING,
        end: $de59d015c44f2268$export$aa91e30498abc411.PASSING,
        color: (0, $7bb4c1736002a04a$exports).G300
    }
];
const $de59d015c44f2268$export$58950a4b8fb8acf4 = (progress)=>{
    for (const { start: start, end: end, color: color } of $de59d015c44f2268$var$COLOR_RANGES){
        if (progress >= start && progress <= end) return color;
    }
    // Default.
    return (0, $7bb4c1736002a04a$exports).R300;
};
const $de59d015c44f2268$export$921f23fa0f13f23e = 90;
const $de59d015c44f2268$export$69a1d9a35c04a358 = 50;
const $de59d015c44f2268$export$a64a7643d5a3fae = (scorecardScores)=>{
    let failingScorecards = 0;
    let needsAttentionScorecards = 0;
    let totalScorecards = 0;
    scorecardScores.forEach((scorecardScore)=>{
        const totalScore = scorecardScore?.totalScore ?? 0;
        totalScorecards += 1;
        if (totalScore < $de59d015c44f2268$export$69a1d9a35c04a358) failingScorecards += 1;
        else if (totalScore >= $de59d015c44f2268$export$69a1d9a35c04a358 && totalScore < $de59d015c44f2268$export$921f23fa0f13f23e) needsAttentionScorecards += 1;
    });
    return {
        total: totalScorecards,
        passing: totalScorecards - failingScorecards - needsAttentionScorecards,
        needsAttention: needsAttentionScorecards
    };
};
const $de59d015c44f2268$export$d48af90fda49897 = (scorecardHealthCount, totalScorecardsCount, formatMessage)=>{
    const { passing: passing } = scorecardHealthCount;
    const { needsAttention: needsAttention } = scorecardHealthCount;
    let numerator = 0;
    let message;
    if (passing === 0 && totalScorecardsCount === 0) message = (0, $9CuM6.default).noScorecards;
    else if (passing + needsAttention < totalScorecardsCount) {
        numerator = Math.floor(totalScorecardsCount) - Math.floor(passing) - Math.floor(needsAttention);
        message = (0, $9CuM6.default).summaryTextForFailing;
    } else if (needsAttention > 0) {
        numerator = Math.floor(needsAttention);
        message = (0, $9CuM6.default).summaryTextForNeedsAttention;
    } else {
        numerator = Math.floor(totalScorecardsCount);
        message = (0, $9CuM6.default).summaryTextForHealthy;
    }
    return formatMessage(message, {
        numerator: numerator
    });
};
const $de59d015c44f2268$export$6e2af0614a0d9b67 = (scorecards)=>[
        ...scorecards
    ].sort((a, b)=>{
        const aTotalScore = a?.scorecardScore?.totalScore ?? 0;
        const bTotalScore = b?.scorecardScore?.totalScore ?? 0;
        return aTotalScore - bTotalScore;
    });
function $de59d015c44f2268$export$79640a85913af5aa(ari) {
    const regex = /\/([\w-]+)$/; // Matches the id at the end of the string
    const match = ari.match(regex);
    return match ? match[1] : '';
}

});
parcelRegister("9CuM6", function(module, exports) {
$parcel$export(module.exports, "default", () => $3693706a70d8818b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3693706a70d8818b$var$messages = (0, $7qGN1.defineMessages)({
    noScorecards: {
        "id": "compass-common.common.no-scorecards",
        "defaultMessage": "No scorecards"
    },
    summaryTextForFailing: {
        "id": "compass-common.common.summary-text-for-failing",
        "defaultMessage": "{numerator} {numerator, plural, one {failing} other {failing}}"
    },
    summaryTextForHealthy: {
        "id": "compass-common.common.summary-text-for-healthy",
        "defaultMessage": "All passing"
    },
    summaryTextForNeedsAttention: {
        "id": "compass-common.common.summary-text-for-needs-attention",
        "defaultMessage": "{numerator} {numerator, plural, one {needs} other {need}} attention"
    }
});
var $3693706a70d8818b$export$2e2bcd8739ae039 = $3693706a70d8818b$var$messages;

});


parcelRegister("lO5gq", function(module, exports) {
$parcel$export(module.exports, "default", () => $fadc8f0700e23504$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $fadc8f0700e23504$var$messages = (0, $7qGN1.defineMessages)({
    teamPreviewLabel: {
        "id": "issue-field-team-readview-with-gpp.team.preview-label",
        "defaultMessage": "Click to view {teamName} team details"
    }
});
var $fadc8f0700e23504$export$2e2bcd8739ae039 = $fadc8f0700e23504$var$messages;

});



parcelRegister("b1dAu", function(module, exports) {
$parcel$export(module.exports, "useMutationWithRetriesCommit", () => $8dfcccfd6d6324ba$export$aaa0248df1ccb7fc);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");
const $8dfcccfd6d6324ba$export$aaa0248df1ccb7fc = ({ retries: retries, isValidOnCompleted: isValidOnCompleted })=>{
    return (0, $eJOHy.useCallback)((environment, config)=>{
        let disposable;
        let optimisticDisposable = null;
        const handleCommitWithRetries = ({ retriesLeft: retriesLeft })=>{
            disposable = (0, $j4oe4.commitMutation)(environment, {
                ...config,
                onCompleted: (response, errors)=>{
                    if (isValidOnCompleted(response, errors)) {
                        config.onCompleted?.(response, errors);
                        return;
                    }
                    if (retriesLeft > 0) {
                        optimisticDisposable = (0, $j4oe4.applyOptimisticMutation)(environment, config);
                        // Wait 100ms before retrying
                        const timeout = setTimeout(()=>{
                            optimisticDisposable?.dispose();
                            handleCommitWithRetries({
                                retriesLeft: retriesLeft - 1
                            });
                        }, 100);
                        disposable = {
                            dispose: ()=>{
                                optimisticDisposable?.dispose();
                                clearTimeout(timeout);
                            }
                        };
                        return;
                    }
                    // Last retry needs to call onComplete
                    config.onCompleted?.(response, errors);
                }
            });
        };
        handleCommitWithRetries({
            retriesLeft: retries
        });
        // Return a new disposable that cleans up the optimistic AND committed operations
        return {
            dispose: ()=>{
                disposable?.dispose();
            }
        };
    }, [
        isValidOnCompleted,
        retries
    ]);
};

});



parcelRegister("g6JiP", function(module, exports) {
$parcel$export(module.exports, "UserCell", () => $54354a9b04f5dfc5$export$dc0ef711c0db7c30);

var $3y5jp = parcelRequire("3y5jp");

var $4ttDI = parcelRequire("4ttDI");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $lpMrC = parcelRequire("lpMrC");

var $lRq8t = parcelRequire("lRq8t");

var $6AqNd = parcelRequire("6AqNd");

var $krQQZ = parcelRequire("krQQZ");

var $iZVkR = parcelRequire("iZVkR");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");

var $jpLGv = parcelRequire("jpLGv");
const $54354a9b04f5dfc5$export$dc0ef711c0db7c30 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, projectKey: projectKey, isFirstField: isFirstField, hasDuplicates: hasDuplicates, isColumnSticky: isColumnSticky })=>{
    const data = (0, $j4oe4.useFragment)((0, $4ttDI.default), fieldRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($54354a9b04f5dfc5$export$df3d80016052952c, {
        fieldRef: data,
        projectKey: projectKey,
        menuPortalTarget: // Portal the menu outside of the scroll container, i.e., table body
        // to prevent clipping in Frozen Columns or Safari (see https://bugs.webkit.org/show_bug.cgi?id=160953#c20)
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        (0, $lpMrC.isSafari)() || isColumnSticky ? document.body : undefined,
        isFirstField: isFirstField,
        hasDuplicates: hasDuplicates
    });
});
const $54354a9b04f5dfc5$export$df3d80016052952c = ({ fieldRef: fieldRef, projectKey: projectKey, menuPortalTarget: menuPortalTarget, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $3y5jp.default), fieldRef);
    const isAssigneeReporter = data.fieldId === 'assignee' || data.fieldId === 'reporter';
    const isCreatorField = data.fieldId === 'creator';
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isInlineEditingSupported = isAssigneeReporter || isInlineEditingExtendedFieldSupportEnabled;
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    // We can also disable editability of the creator field as it is never editable.
    let isEditable;
    if ('isEditableInIssueView' in data) isEditable = data.isEditableInIssueView;
    else isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingSupported && !isCreatorField ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const shouldRenderHoverPopover = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && shouldRenderHoverPopover) switch(data.fieldId){
        case 'assignee':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6AqNd.AssigneeInlineEditViewWithIsEditable), {
                attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                spacing: "default",
                editViewPopup: true,
                editViewPopupAlignBlock: "start",
                editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
                // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
                editViewPopupTarget: isFirstField ? $54354a9b04f5dfc5$var$CustomTarget : undefined,
                fragmentRef: data,
                isEditable: isEditable ?? false,
                menuPosition: isFirstField ? 'fixed' : 'absolute',
                portalElement: menuPortalTarget,
                readViewFitContainerHeight: true,
                projectKey: projectKey,
                shouldRenderHoverPopover: shouldRenderHoverPopover
            });
        case 'reporter':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $krQQZ.ReporterInlineEditViewWithIsEditable), {
                attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                spacing: "default",
                editViewPopup: true,
                editViewPopupAlignBlock: "start",
                editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
                // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
                editViewPopupTarget: isFirstField ? $54354a9b04f5dfc5$var$CustomTarget : undefined,
                fragmentRef: data,
                isEditable: isEditable ?? false,
                menuPosition: isFirstField ? 'fixed' : 'absolute',
                portalElement: menuPortalTarget,
                readViewFitContainerHeight: true,
                shouldRenderHoverPopover: shouldRenderHoverPopover
            });
        default:
            {
                const noneOptionLabel = isCreatorField ? formatMessage((0, $jpLGv.default).anonymous) : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iZVkR.SingleUserPickerInlineEditViewWithIsEditable), {
                    attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                    spacing: "default",
                    editViewPopup: true,
                    editViewPopupAlignBlock: "start",
                    editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
                    // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
                    editViewPopupTarget: isFirstField ? $54354a9b04f5dfc5$var$CustomTarget : undefined,
                    fragmentRef: data,
                    isEditable: isEditable ?? false,
                    menuPosition: isFirstField ? 'fixed' : 'absolute',
                    portalElement: menuPortalTarget,
                    readViewFitContainerHeight: true,
                    noneOptionLabel: noneOptionLabel,
                    shouldRenderHoverPopover: shouldRenderHoverPopover
                });
            }
    }
    switch(data.fieldId){
        case 'assignee':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6AqNd.AssigneeInlineEditViewWithIsEditable), {
                attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                spacing: "default",
                editViewPopup: true,
                editViewPopupAlignBlock: "center",
                fragmentRef: data,
                isEditable: isEditable ?? false,
                menuPosition: "fixed",
                portalElement: menuPortalTarget,
                readViewFitContainerHeight: true,
                projectKey: projectKey,
                shouldRenderHoverPopover: shouldRenderHoverPopover
            });
        case 'reporter':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $krQQZ.ReporterInlineEditViewWithIsEditable), {
                attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                spacing: "default",
                editViewPopup: true,
                editViewPopupAlignBlock: "center",
                fragmentRef: data,
                isEditable: isEditable ?? false,
                menuPosition: "fixed",
                portalElement: menuPortalTarget,
                readViewFitContainerHeight: true,
                shouldRenderHoverPopover: shouldRenderHoverPopover
            });
        default:
            {
                const noneOptionLabel = isCreatorField ? formatMessage((0, $jpLGv.default).anonymous) : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iZVkR.SingleUserPickerInlineEditViewWithIsEditable), {
                    attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                    spacing: "default",
                    editViewPopup: true,
                    editViewPopupAlignBlock: "center",
                    fragmentRef: data,
                    menuPosition: "fixed",
                    isEditable: isEditable ?? false,
                    portalElement: menuPortalTarget,
                    readViewFitContainerHeight: true,
                    noneOptionLabel: noneOptionLabel,
                    shouldRenderHoverPopover: shouldRenderHoverPopover
                });
            }
    }
};
const $54354a9b04f5dfc5$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $54354a9b04f5dfc5$var$customTargetStyles : $54354a9b04f5dfc5$var$customTargetStylesOld,
        ref: ref
    });
});
const $54354a9b04f5dfc5$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $54354a9b04f5dfc5$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("3y5jp", function(module, exports) {
$parcel$export(module.exports, "default", () => $15765ade2dc78d1d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<561f3c0cf0f18cedb74f8c5220acb78f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $15765ade2dc78d1d$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "UserCellInternal_UserCellInternal",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "condition": "isEditableSyncLoaded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditableInIssueView"
                }
            ]
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "kind": "FragmentSpread",
            "name": "reporter_issueFieldReporterInlineEditFull_ReporterInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$15765ade2dc78d1d$var$node.hash = "b46332f2b35b377120e45dd1115efebd";
var $15765ade2dc78d1d$export$2e2bcd8739ae039 = $15765ade2dc78d1d$var$node;

});

parcelRegister("4ttDI", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0096fa544764fe5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63d074d8358322ecb5e2b5b6bd912136>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f0096fa544764fe5$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "UserCellInternal",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isEditableSyncLoaded",
                    "variableName": "isEditableSyncLoaded"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "UserCellInternal_UserCellInternal"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$f0096fa544764fe5$var$node.hash = "222a689111ce0aec54903a0d814d0501";
var $f0096fa544764fe5$export$2e2bcd8739ae039 = $f0096fa544764fe5$var$node;

});

parcelRegister("6AqNd", function(module, exports) {
$parcel$export(module.exports, "AssigneeInlineEditViewWithIsEditable", () => $324f37a604262e80$export$e07ee235d4f5b512);
$parcel$export(module.exports, "AssigneeInlineEditView", () => $324f37a604262e80$export$9f32fa927ad908e5);

var $ap9fZ = parcelRequire("ap9fZ");

var $4ijkS = parcelRequire("4ijkS");

var $irvrj = parcelRequire("irvrj");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $k71qx = parcelRequire("k71qx");

var $41wNq = parcelRequire("41wNq");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $d2AGn = parcelRequire("d2AGn");

var $ftZVn = parcelRequire("ftZVn");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $fsoQR = parcelRequire("fsoQR");


var $14RSn = parcelRequire("14RSn");

var $jHI6h = parcelRequire("jHI6h");

var $4cTDP = parcelRequire("4cTDP");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $9RttA = parcelRequire("9RttA");

var $RPb3k = parcelRequire("RPb3k");

var $9vs2V = parcelRequire("9vs2V");
const $324f37a604262e80$var$isEqualUser = (a, b)=>a?.id === b?.id;
const $324f37a604262e80$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-assignee-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $324f37a604262e80$export$e07ee235d4f5b512 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, portalElement: portalElement, onCancel: onCancel, onEdit: onEdit, isDisabledTooltipShown: isDisabledTooltipShown = false, projectKey: projectKey, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, shouldRenderHoverPopover: shouldRenderHoverPopover, position: position })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overriding.overrideIsEditable(isEditable || false), [
        isEditable,
        overriding
    ]);
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $irvrj.default), fragmentRef);
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name, user: user, fieldConfig: fieldConfig } = data;
    const fieldName = (0, $eJOHy.useMemo)(()=>overriding.overrideLabel(name), [
        name,
        overriding
    ]);
    const isFieldRequired = fieldConfig?.isRequired ?? false;
    // Node: Change the MUTATION_NAME whenever the mutation name is also being changed
    const MUTATION_NAME = 'assignee_issueFieldAssignee_AssigneeField_Mutation';
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $4ijkS.default));
    // #endregion
    const initialValue = user ?? null;
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { humanSupervisor: humanSupervisor } = (0, $9vs2V.useSupervisorWithFg)(user, updatedValue);
    const handleSubmit = (0, $eJOHy.useCallback)((newUser, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newUser);
        (0, $jHI6h.startCapturingTraceIds)(MUTATION_NAME);
        if ((0, $4cTDP.fg)('timeline-issue-table-additional-analytics')) (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd(fieldId, {
            analytics: createAnalyticsEvent({}),
            attributes: {
                ...attributes,
                fieldType: type
            }
        });
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: newUser?.id ?? null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateSingleSelectUserPickerField?.success) {
                    (0, $jHI6h.stopCapturingTraceIds)(MUTATION_NAME);
                    onSuccess();
                } else {
                    const traceIds = (0, $jHI6h.getTraceIds)(MUTATION_NAME);
                    (0, $jHI6h.stopCapturingTraceIds)(MUTATION_NAME);
                    const gqlError = mutationData.jira?.updateSingleSelectUserPickerField?.errors?.[0];
                    onFail(new (0, $14RSn.default)(gqlError?.extensions?.statusCode || 0, gqlError?.message || undefined, traceIds[0]));
                }
            },
            onError (error) {
                onFail(error);
                (0, $jHI6h.stopCapturingTraceIds)(MUTATION_NAME);
            },
            optimisticResponse: {
                jira: {
                    updateSingleSelectUserPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            user: newUser ? {
                                id: newUser.id,
                                accountId: newUser.accountId,
                                accountStatus: newUser.accountStatus,
                                name: newUser.name,
                                picture: newUser.picture,
                                __typename: 'AtlassianAccountUser'
                            } : null
                        }
                    }
                }
            }
        });
    }, [
        onSubmit,
        commit,
        uniqueFieldId,
        fieldId,
        createAnalyticsEvent,
        attributes,
        type
    ]);
    const setAnalyticsAttributes = (0, $eJOHy.useCallback)((value)=>{
        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, initialValue?.accountId, value?.accountId || null);
    }, [
        fieldId,
        initialValue
    ]);
    const validator = (0, $RPb3k.useAssigneeValidator)(fieldName, isFieldRequired);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $324f37a604262e80$var$isEqualUser,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitSucceeded: onSubmitSucceeded,
        onSubmitFailed: onSubmitFailed,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        validator: validator,
        clipboardComponentType: 'singleUser',
        setAnalyticsAttributes: setAnalyticsAttributes
    });
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($324f37a604262e80$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fsoQR.SingleUserPickerWithProfileCardReadView), {
            fragmentRef: data,
            emptyUserLabel: formatMessage((0, $9RttA.default).unassignedOption),
            profileCardAction: (0, $9122f643e6cb5228$export$6bef782d14a92db8),
            shouldRenderHoverPopover: shouldRenderHoverPopover,
            position: position,
            fieldId: fieldId,
            humanSupervisor: humanSupervisor
        })), [
        data,
        formatMessage,
        shouldRenderHoverPopover,
        fieldId,
        position,
        humanSupervisor
    ]);
    // #endregion
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            fieldId: uniqueFieldId,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            spacing: spacing,
            projectKey: projectKey,
            fetchSuggestionsOnMount: false,
            portalElement: portalElement,
            enablePeopleInvite: true,
            includeNoneOption: !isFieldRequired,
            isClearable: !isFieldRequired,
            menuPosition: menuPosition,
            label: fieldName,
            isInvalid: !!invalidMessage
        });
    const editButtonLabel = formatMessage((0, $41wNq.default).extendedEditButtonLabel, {
        inputFieldValue: initialValue?.name ?? formatMessage((0, $9RttA.default).unassignedOption),
        fieldName: fieldName
    });
    const inlineEditElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupTarget: editViewPopupTarget,
        editViewEntryPoint: (0, $ftZVn.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readView: renderReadView,
        hideActionButtons: true,
        editButtonLabel: editButtonLabel,
        readViewFitContainerHeight: readViewFitContainerHeight,
        disableReadViewAppearanceOnHoverOnly: true
    });
    return isDisabledTooltipShown && !isFieldEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $41wNq.default).disabledReporterTooltip, {
            fieldName: fieldName
        }),
        position: "mouse"
    }, inlineEditElement) : inlineEditElement;
};
const $324f37a604262e80$export$9f32fa927ad908e5 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $ap9fZ.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($324f37a604262e80$export$e07ee235d4f5b512, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("ap9fZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6858eb28f4cc7b13$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b9ea929c7ab7c075bed623095bf805b7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6858eb28f4cc7b13$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$6858eb28f4cc7b13$var$node.hash = "93c1d9e2338da6a23190803216172e69";
var $6858eb28f4cc7b13$export$2e2bcd8739ae039 = $6858eb28f4cc7b13$var$node;

});

parcelRegister("4ijkS", function(module, exports) {
$parcel$export(module.exports, "default", () => $fef5b29c6cf3cf5c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e918e00b96147ea6bf09ae576e90430e>>
 * @relayHash edf533ecdfe81145f0d5ed0486a7d74c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d872673080e443d67f3c30873225e21fdfd2b89e010b0cfb4f1f1c7f8da5f301
const $fef5b29c6cf3cf5c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v8 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "assignee_issueFieldAssignee_AssigneeField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "assignee_issueFieldAssignee_AssigneeField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d872673080e443d67f3c30873225e21fdfd2b89e010b0cfb4f1f1c7f8da5f301",
            "metadata": {},
            "name": "assignee_issueFieldAssignee_AssigneeField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$fef5b29c6cf3cf5c$var$node.hash = "6c6c314bdc60901e8c03415b7add3145";
var $fef5b29c6cf3cf5c$export$2e2bcd8739ae039 = $fef5b29c6cf3cf5c$var$node;

});

parcelRegister("irvrj", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbc56aa1ed9822a7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cad097852aaf130deec964b49552f3bb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dbc56aa1ed9822a7$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v1 /*: any*/ ,
            {
                "kind": "FragmentSpread",
                "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerWithProfileCardReadView_fragmentRef"
            },
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "picture"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accountStatus"
                    },
                    v0 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "appType"
                                    }
                                ]
                            }
                        ],
                        "type": "AppUser"
                    }
                ]
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectUserPickerField"
    };
}();
$dbc56aa1ed9822a7$var$node.hash = "ffceb7681d0d729e0e38a6e6914cd375";
var $dbc56aa1ed9822a7$export$2e2bcd8739ae039 = $dbc56aa1ed9822a7$var$node;

});

parcelRegister("41wNq", function(module, exports) {
$parcel$export(module.exports, "default", () => $68be5f461eda860e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $68be5f461eda860e$var$messages = (0, $7qGN1.defineMessages)({
    confirmButtonLabel: {
        "id": "inline-edit.confirm-button-label",
        "defaultMessage": "Confirm {fieldName}"
    },
    cancelButtonLabel: {
        "id": "inline-edit.cancel-button-label",
        "defaultMessage": "Cancel {fieldName}"
    },
    editButtonLabel: {
        "id": "inline-edit.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    },
    addButtonLabel: {
        "id": "inline-edit.add-button-label",
        "defaultMessage": "Add {fieldName}"
    },
    extendedEditButtonLabel: {
        "id": "inline-edit.extended-edit-button-label",
        "defaultMessage": "{inputFieldValue}- edit {fieldName}"
    },
    disabledEditButtonLabel: {
        "id": "inline-edit.disabled-edit-button-label",
        "defaultMessage": "{fieldName} - can\u2019t be edited"
    },
    disabledReporterTooltip: {
        "id": "inline-edit.disabled-inline-edit-tooltip",
        "defaultMessage": "{fieldName} can\u2019t be edited"
    },
    columnTitleAriaLabel: {
        "id": "inline-edit.column-title-aria-label",
        "defaultMessage": "Add column name"
    }
});
var $68be5f461eda860e$export$2e2bcd8739ae039 = $68be5f461eda860e$var$messages;

});

parcelRegister("ftZVn", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad0c1b7ae89be577$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $2tLaT = parcelRequire("2tLaT");

const $ad0c1b7ae89be577$var$AssigneeEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("3x5cn")), {
        moduleId: "3f5ced6e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            queries: {
                rootData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $2tLaT.default,
                    variables: {}
                }
            }
        })
});
var $ad0c1b7ae89be577$export$2e2bcd8739ae039 = $ad0c1b7ae89be577$var$AssigneeEditViewEntryPoint;

});
parcelRegister("2tLaT", function(module, exports) {
$parcel$export(module.exports, "default", () => $859cef0b15489eb7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8c5c71604b2b7c342534cc0cda6e842a>>
 * @relayHash d628801de49aa5093fee568fc182828d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c2ffb45b563e23441251e860dbb87504b353d4e8ff2e4b70b88aa208de90a395

var $04qit = parcelRequire("04qit");
const $859cef0b15489eb7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "c2ffb45b563e23441251e860dbb87504b353d4e8ff2e4b70b88aa208de90a395",
        "metadata": {},
        "name": "assigneeEditView_rootQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": (0, $04qit.default)
        }
    }
};
var $859cef0b15489eb7$export$2e2bcd8739ae039 = $859cef0b15489eb7$var$node;

});

parcelRegister("3x5cn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cwtwt").then(()=>parcelRequire('dWIha'));

});


parcelRegister("fsoQR", function(module, exports) {
$parcel$export(module.exports, "SingleUserPickerWithProfileCardReadView", () => $a7294ab276327711$export$2f1ab379ffebbded);

var $9KzoD = parcelRequire("9KzoD");

var $h9bQ9 = parcelRequire("h9bQ9");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5DgXR = parcelRequire("5DgXR");

var $gqBnP = parcelRequire("gqBnP");

var $3cMgR = parcelRequire("3cMgR");

var $ktHCr = parcelRequire("ktHCr");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $tYLUh = parcelRequire("tYLUh");


var $kaujN = parcelRequire("kaujN");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $4cTDP = parcelRequire("4cTDP");

var $3OT15 = parcelRequire("3OT15");

var $ckebs = parcelRequire("ckebs");
const $a7294ab276327711$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', (0, $eJOHy.Fragment), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-single-user-picker-read-view",
        mode: "list"
    }, children)); /**
                   * The SingleUserPickerReadView will show a read only view of SingleUserPicker field.
                   * @param props [SingleUserPickerReadViewProps](./types.tsx)
                   */ 
const $a7294ab276327711$export$65db1532781bc51 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fragmentRef: fragmentRef, emptyUserLabel: emptyUserLabel = null, shouldRenderHoverPopover: shouldRenderHoverPopover, fieldId: fieldId, humanSupervisor: humanSupervisor })=>{
    const data = (0, $j4oe4.useFragment)((0, $h9bQ9.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const { name: name = emptyUserLabel ?? formatMessage((0, $ckebs.default).anonymousOption), picture: picture, accountStatus: accountStatus } = data?.user || {};
    const hoverPopoverRefFactory = shouldRenderHoverPopover ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (!data?.user && fieldId !== 'assignee' && fieldId !== 'reporter' && isExperimentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: formatMessage((0, $ckebs.default).noValueTextExperiment)
    });
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: name
    });
    if (shouldRenderHoverPopover && data?.user === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$Container, null, (0, $4cTDP.fg)('jira_ai_agent_avatar_single_user_picker') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ktHCr.AvatarRelay), {
        as: $a7294ab276327711$var$AvatarAlignmentFix,
        fragmentRef: null,
        name: name,
        size: "small",
        borderColor: "transparent"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        as: $a7294ab276327711$var$AvatarAlignmentFix,
        src: picture,
        name: name,
        size: "small",
        borderColor: "transparent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: 1,
        ref: hoverPopoverRef
    }, name));
     // TODO: to be either cleaned up in CRCS-3113 or replaced with a unified solution
    if (humanSupervisor && (0, $4cTDP.fg)('jira_ai_show_human_supervisor_avatar')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gqBnP.default), {
        appearance: "stack",
        data: [
            {
                name: name,
                src: picture,
                appearance: 'hexagon'
            },
            {
                name: name,
                src: humanSupervisor?.avatarUrls.large
            }
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$TextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "aria-label": "human supervisor"
    }, name, " with ", humanSupervisor?.displayName), data?.user && accountStatus !== 'active' && // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$UserStatus, null, `(${formatMessage((0, $ckebs.default).deactivated)})`)));
    return(// We use our own container element rather than an AvatarItem as we've observed hydration bugs with SSR+Emotion
    // when this component is wrapped in an async profile card, and this approach is the path of least friction.
    // Further context here https://atlassian.slack.com/archives/C060GTVV988/p1712624943348969.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$Container, null, (0, $4cTDP.fg)('jira_ai_agent_avatar_single_user_picker') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ktHCr.AvatarRelay), {
        as: $a7294ab276327711$var$AvatarAlignmentFix,
        fragmentRef: data.user ?? null,
        name: name,
        size: "small",
        borderColor: "transparent"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        as: $a7294ab276327711$var$AvatarAlignmentFix,
        src: picture,
        name: name,
        size: "small",
        borderColor: "transparent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$TextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, name), data?.user && accountStatus !== 'active' && // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$UserStatus, null, `(${formatMessage((0, $ckebs.default).deactivated)})`))));
});
const $a7294ab276327711$export$2f1ab379ffebbded = /*#__PURE__*/ (0, $eJOHy.memo)(({ fragmentRef: fragmentRef, emptyUserLabel: emptyUserLabel, profileCardAction: profileCardAction, position: position, shouldRenderHoverPopover: shouldRenderHoverPopover, fieldId: fieldId, humanSupervisor: humanSupervisor })=>{
    const data = (0, $j4oe4.useFragment)((0, $9KzoD.default), fragmentRef);
    const accountId = data?.user?.accountId || null;
    const actions = (0, $eJOHy.useMemo)(()=>profileCardAction ? [
            (0, $9122f643e6cb5228$export$23cedd3261bd8015),
            profileCardAction
        ] : [
            (0, $9122f643e6cb5228$export$23cedd3261bd8015)
        ], [
        profileCardAction
    ]);
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kaujN.default), {
        prepopulatedData: {
            fullName: data?.user?.name
        },
        accountId: accountId,
        actions: actions,
        position: position
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$export$65db1532781bc51, {
        fragmentRef: data,
        emptyUserLabel: emptyUserLabel,
        shouldRenderHoverPopover: shouldRenderHoverPopover,
        fieldId: fieldId,
        humanSupervisor: humanSupervisor
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$export$65db1532781bc51, {
        fragmentRef: data,
        emptyUserLabel: emptyUserLabel,
        shouldRenderHoverPopover: shouldRenderHoverPopover,
        fieldId: fieldId
    }));
}); /**
     * Component to pass for "as" prop of Avatar. It reverses the 2px margin added in the Avatar
     * component when a transparent border is used.
     *
     * Done using div + css because styled components are not compatible with Avatar's types.
     */ 
const $a7294ab276327711$var$AvatarAlignmentFix = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ...props,
        ref: ref,
        className: (0, $hcewu.default)([
            "_19pk1i6y _2hwx1i6y _otyr1i6y _18u01i6y"
        ])
    }));
const $a7294ab276327711$var$avatarAlignmentStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7294ab276327711$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _p12f1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7294ab276327711$var$TextContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7294ab276327711$var$UserStatus = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1rpy _18u0v77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9KzoD", function(module, exports) {
$parcel$export(module.exports, "default", () => $9aba137f8d5441a2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<75c9f0edae87b35dae025f46e4be4e99>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9aba137f8d5441a2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerWithProfileCardReadView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef"
        },
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$9aba137f8d5441a2$var$node.hash = "c59dbeffeee9029f50284e101470f0fa";
var $9aba137f8d5441a2$export$2e2bcd8739ae039 = $9aba137f8d5441a2$var$node;

});

parcelRegister("h9bQ9", function(module, exports) {
$parcel$export(module.exports, "default", () => $e849c5707a445295$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<30f1571aaa7cafc2056826c1b1199c1f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e849c5707a445295$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                {
                    "kind": "ScalarField",
                    "name": "accountStatus"
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "avatarRelay_UsePictureAndAppTypeFragment"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$e849c5707a445295$var$node.hash = "2f5cfd29249780f5a332f572f777b4e2";
var $e849c5707a445295$export$2e2bcd8739ae039 = $e849c5707a445295$var$node;

});

parcelRegister("ktHCr", function(module, exports) {
$parcel$export(module.exports, "AvatarRelay", () => $0519fe7e6928deb5$export$4bc8bcb977dc5ae2);

var $gt9Am = parcelRequire("gt9Am");

var $9VxBt = parcelRequire("9VxBt");
parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5DgXR = parcelRequire("5DgXR");

var $64Lg2 = parcelRequire("64Lg2");
const $0519fe7e6928deb5$export$4bc8bcb977dc5ae2 = ({ fragmentRef: fragmentRef, label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, presence: presence, size: size, status: status, stackIndex: stackIndex, tabIndex: tabIndex, target: target, onClick: onClick, testId: testId, analyticsContext: analyticsContext, as: as, isDecorative: isDecorative, imgLoading: imgLoading })=>{
    const data = (0, $j4oe4.useFragment)((0, $9VxBt.default), fragmentRef);
    const appearance = (0, $64Lg2.getAppearanceForAppType)(data?.appType);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
        // from relay fragment
        src: data?.picture,
        appearance: appearance,
        // prop-drill from AvatarRelayProps
        label: label,
        borderColor: borderColor,
        children: children,
        href: href,
        isDisabled: isDisabled,
        name: name,
        presence: presence,
        size: size,
        status: status,
        stackIndex: stackIndex,
        tabIndex: tabIndex,
        target: target,
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext,
        as: as,
        isDecorative: isDecorative,
        imgLoading: imgLoading
    });
};

});
parcelRegister("9VxBt", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d0e1cac11f99f44$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<38c573559469cadb0b4446c5a9a36e10>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7d0e1cac11f99f44$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "avatarRelay_UsePictureAndAppTypeFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "appType"
                }
            ],
            "type": "AppUser"
        }
    ],
    "type": "User",
    "abstractKey": "__isUser"
};
$7d0e1cac11f99f44$var$node.hash = "865b09ca369f75c658decd19239f2068";
var $7d0e1cac11f99f44$export$2e2bcd8739ae039 = $7d0e1cac11f99f44$var$node;

});

parcelRegister("64Lg2", function(module, exports) {
$parcel$export(module.exports, "getAppearanceForAppType", () => $987717cec5ca10b3$export$6b45b5bd2259198a);
function $987717cec5ca10b3$export$6b45b5bd2259198a(appType) {
    switch(appType){
        case 'agent':
            return 'hexagon';
        case 'team':
            // @TODO investigate if team comes from appType or if it is a separate way to detect
            return 'square';
        case 'user':
        case 'system':
        default:
            return 'circle';
    }
}

});


parcelRegister("kaujN", function(module, exports) {
$parcel$export(module.exports, "ProfileCard", () => $a91fed983bc1d05e$export$bed540ccfa8743c4);
$parcel$export(module.exports, "default", () => $a91fed983bc1d05e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cSXp8 = parcelRequire("cSXp8");

var $kGj4V = parcelRequire("kGj4V");

var $lcB5K = parcelRequire("lcB5K");

var $lRq8t = parcelRequire("lRq8t");

var $e6YEs = parcelRequire("e6YEs");

var $4cTDP = parcelRequire("4cTDP");

var $5vQ2T = parcelRequire("5vQ2T");

var $a62R3 = parcelRequire("a62R3");


var $4LBQr = parcelRequire("4LBQr");

var $cVBK8 = parcelRequire("cVBK8");

var $l69E3 = parcelRequire("l69E3");
const $a91fed983bc1d05e$export$bed540ccfa8743c4 = ({ externalProfileClient: externalProfileClient, accountId: accountId, actions: actions, analyticsData: analyticsData, children: children, position: position, testId: testId, trigger: trigger, prepopulatedData: prepopulatedData, ariaHideProfileTrigger: ariaHideProfileTrigger, isChildComment: isChildComment = false, shouldTruncate: shouldTruncate = false, showDelay: showDelay, hideDelay: hideDelay, isVisible: isVisible, hideAgentMoreActions: hideAgentMoreActions })=>{
    const intl = (0, $lRq8t.default)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
    const currentUserAccountId = (0, $e6YEs.useAccountId)();
    const toTeamsAppUserProfile = (userId)=>(0, $a62R3.getNavigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: userId
            }
        }).onNavigate();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "profilecard",
        packageName: (0, $9122f643e6cb5228$export$9345d7360ffe0722),
        fallback: (0, $4cTDP.fg)('empanada_profilecard_fix_error_boundary_fallback') ? ()=>children : 'flag'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: (0, $9122f643e6cb5228$export$81319ffa9c0d18d7),
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4LBQr.ProfileCardWrapper), {
        externalProfileClient: externalProfileClient
    }, currentUserAccountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lcB5K.RouterActions), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l69E3.ProfileCardView), {
            accountId: accountId,
            actions: (0, $4cTDP.fg)('jsc_nin_smart_link_fast_follows') ? (0, $cVBK8.getSpaActions)(accountId, intl, actions) : (0, $cVBK8.getSpaActionsWithRouterPush)(accountId, intl, push, actions),
            position: position,
            onProfileClick: (profileAccountId)=>(0, $a62R3.isTeamsAppEnabled)() ? toTeamsAppUserProfile(profileAccountId) : push(`/jira/people/${profileAccountId}`),
            addFlag: showFlag,
            dismissFlag: dismissFlag,
            testId: testId,
            trigger: trigger,
            prepopulatedData: prepopulatedData,
            ariaHideProfileTrigger: ariaHideProfileTrigger,
            isChildComment: isChildComment,
            shouldTruncate: shouldTruncate,
            showDelay: showDelay,
            hideDelay: hideDelay,
            isVisible: isVisible,
            hideAgentMoreActions: hideAgentMoreActions
        }, children)) : children)));
};
var $a91fed983bc1d05e$export$2e2bcd8739ae039 = $a91fed983bc1d05e$export$bed540ccfa8743c4;

});
parcelRegister("l69E3", function(module, exports) {
$parcel$export(module.exports, "ProfileCardView", () => $724fce4f5df4705a$export$da5098f02f405a40);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $caeqU = parcelRequire("caeqU");

var $ymEZt = parcelRequire("ymEZt");
var $jn1Cb = parcelRequire("jn1Cb");

var $c3tJH = parcelRequire("c3tJH");

var $e6YEs = parcelRequire("e6YEs");

var $cHtIB = parcelRequire("cHtIB");

var $a62R3 = parcelRequire("a62R3");

var $9RE4U = parcelRequire("9RE4U");

var $7t8WA = parcelRequire("7t8WA");

const $724fce4f5df4705a$var$PEOPLE_PROFILE_PATH = '/people/';
const $724fce4f5df4705a$var$ProfileCardTriggerWithAnalytics = (0, $c3tJH.AnalyticsEventToProps)((0, $1f42fe6c39d9ca34$export$a1455360a24a2234), {
    analytics: ''
})((0, $caeqU.default));
const $724fce4f5df4705a$export$da5098f02f405a40 = ({ children: children, position: position = 'top-start', trigger: trigger = 'hover', accountId: accountId, actions: actions, onProfileClick: onProfileClick, addFlag: addFlag, dismissFlag: dismissFlag, testId: testId, prepopulatedData: prepopulatedData, ariaHideProfileTrigger: ariaHideProfileTrigger, isChildComment: isChildComment, shouldTruncate: shouldTruncate, showDelay: showDelay, hideDelay: hideDelay, isVisible: isVisible, hideAgentMoreActions: hideAgentMoreActions })=>{
    const profileCardWrapperRef = (0, $eJOHy.useRef)(null);
    const cloudId = (0, $cHtIB.useCloudId)();
    const viewingUserId = (0, $e6YEs.useAccountId)();
    const { profileClient: profileClient } = (0, $7t8WA.useProfileClient)();
    const isPageHydrating = (0, $9RE4U.useIsHydrateRenderMode)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($724fce4f5df4705a$var$Wrapper, {
        ref: profileCardWrapperRef,
        onClick: (event)=>{
            if (profileCardWrapperRef?.current !== null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            !profileCardWrapperRef?.current?.contains(event.target)) event.stopPropagation();
        },
        "data-vc": `profilecard-wrapper${false && !isPageHydrating ? '-ssr' : ''}`,
        className: (0, $hcewu.default)([
            isChildComment && "_kqswh2mm _1hjgt94y _1pty1eak _161e7qp0 _ft5qdlk8 _2wzdc71f _2kncueha _qlwiueha _aetrb3bt _631ousvi _18postnw _g0nf1yie _15l21pz7 _z0aiduof _1hfk1w7a _1e9pu2gc _1qdg1osq",
            isChildComment && "_p12f1kdh _kqswh2mm _uglpt94y _161e7qp0 _1pty1eak _2knc163p _qlwi163p _631ousvi _aetrb3bt _18postnw _g0nf1yie _15l24uri _z0aiduof _1hfk1w7a _1e9pu2gc _1qdg1osq",
            shouldTruncate && "_1reo15vq _18m915vq _1o9zidpf _1bto1l2s _o5721q9c"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($724fce4f5df4705a$var$ProfileCardTriggerWithAnalytics, {
        cloudId: cloudId,
        userId: accountId,
        resourceClient: profileClient,
        position: position,
        trigger: trigger,
        testId: testId,
        actions: actions,
        reportingLinesProfileUrl: $724fce4f5df4705a$var$PEOPLE_PROFILE_PATH,
        prepopulatedData: prepopulatedData,
        showDelay: showDelay,
        hideDelay: hideDelay,
        hideAgentMoreActions: hideAgentMoreActions,
        onReportingLinesClick: onProfileClick ? // @ts-expect-error - TS7006 - Parameter 'user' implicitly has an 'any' type.
        (user)=>{
            onProfileClick(user.accountIdentifier);
            if ((0, $a62R3.isTeamsAppEnabled)()) return false;
        } : null,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        addFlag: (flag)=>{
            const flagId = (0, $jn1Cb.toFlagId)(flag.id);
            addFlag({
                id: flagId,
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ymEZt.default), {
                        ...flag,
                        onDismissed: ()=>{
                            dismissFlag(flagId);
                        },
                        ...props
                    })
            });
        },
        viewingUserId: viewingUserId,
        ariaHideProfileTrigger: ariaHideProfileTrigger,
        isVisible: isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "profilecard-next.ui.profilecard.profilecard-trigger",
        className: (0, $hcewu.default)([
            shouldTruncate && "_1e0c1nu9"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $724fce4f5df4705a$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f1osq _syazazsu",
            __cmplp.className
        ])
    });
});
const $724fce4f5df4705a$var$profileCardStyles = null;
const $724fce4f5df4705a$var$replyProfileCardStyles = null;
const $724fce4f5df4705a$var$truncatedProfileCardStyles = null;
const $724fce4f5df4705a$var$truncatedProfileCardInnerStyles = null;
$724fce4f5df4705a$var$Wrapper.displayName = 'Wrapper';

});
parcelRegister("caeqU", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9b60a56512bd43f$export$2e2bcd8739ae039);


var $1GAK3 = parcelRequire("1GAK3");

var $39Fdj = parcelRequire("39Fdj");
var $f9b60a56512bd43f$export$2e2bcd8739ae039 = (0, $39Fdj.default);

});

parcelRegister("c3tJH", function(module, exports) {
$parcel$export(module.exports, "AnalyticsEventToProps", () => $6571f9d80c82bd3a$export$3e9ef96ba97ea9dc);

var $4J0ad = parcelRequire("4J0ad");
const $6571f9d80c82bd3a$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $6571f9d80c82bd3a$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $4J0ad.default)($6571f9d80c82bd3a$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

const $1f42fe6c39d9ca34$export$a1455360a24a2234 = 'profileCardNextView';



parcelRegister("ckebs", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a464ef5085b9801$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3a464ef5085b9801$var$messages = (0, $7qGN1.defineMessages)({
    deactivated: {
        "id": "issue-field-single-user-picker-readview-full.single-user-picker.deactivated",
        "defaultMessage": "Deactivated"
    },
    anonymousOption: {
        "id": "issue-field-single-user-picker-readview-full.single-user-picker.anonymous-option",
        "defaultMessage": "Anonymous"
    },
    noValueTextExperiment: {
        "id": "issue-field-single-user-picker-readview-full.single-user-picker.no-value-text-experiment",
        "defaultMessage": "Add user"
    }
});
var $3a464ef5085b9801$export$2e2bcd8739ae039 = $3a464ef5085b9801$var$messages;

});


parcelRegister("9RttA", function(module, exports) {
$parcel$export(module.exports, "default", () => $baff1950d7ccac9c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $baff1950d7ccac9c$var$messages = (0, $7qGN1.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee-inline-edit-full.assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    assignToMe: {
        "id": "issue-field-assignee-inline-edit-full.assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    requiredErrorMessage: {
        "id": "issue-field-assignee-inline-edit-full.assignee.required-error-message",
        "defaultMessage": "{fieldName} is required"
    }
});
var $baff1950d7ccac9c$export$2e2bcd8739ae039 = $baff1950d7ccac9c$var$messages;

});

parcelRegister("RPb3k", function(module, exports) {
$parcel$export(module.exports, "useAssigneeValidator", () => $02dcb8981a357561$export$37df2b94c6c5d4a3);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $9RttA = parcelRequire("9RttA");
const $02dcb8981a357561$export$37df2b94c6c5d4a3 = (fieldName, isRequired)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const submit = (0, $eJOHy.useCallback)((value)=>{
        if (isRequired && value === null) return {
            type: 'error',
            message: formatMessage((0, $9RttA.default).requiredErrorMessage, {
                fieldName: fieldName
            })
        };
        return null;
    }, [
        fieldName,
        formatMessage,
        isRequired
    ]);
    return {
        submit: submit
    };
};

});

parcelRegister("9vs2V", function(module, exports) {
$parcel$export(module.exports, "useSupervisorWithFg", () => $e02131b26eaa3db7$export$fca3d223ba9f0bef);
/**
 * This is a temporary solution to show the human supervisor avatar in the assignee field for Team EU 25.
 * To be cleaned up in https://jplat.atlassian.net/browse/CRCS-3113 once we settle and move to a long term solution.
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $bmoS1 = parcelRequire("bmoS1");

var $3MbOI = parcelRequire("3MbOI");

var $fq2RT = parcelRequire("fq2RT");

var $6rzJr = parcelRequire("6rzJr");

var $4cTDP = parcelRequire("4cTDP");

var $hbF3h = parcelRequire("hbF3h");

var $6d9QY = parcelRequire("6d9QY");
const $e02131b26eaa3db7$var$IssueHistoryQuery = `
	query IssueHistoryQuery($issueKey: String!, $startAt: Long, $maxResults: Int, $orderBy: String) {
		viewIssue(issueKey: $issueKey) {
			history(orderBy: $orderBy, startAt: $startAt, maxResults: $maxResults) {
				isLast
				totalCount
				startIndex
				nodes {
					fieldId
					actor {
						avatarUrls {
							large
						}
						displayName
						accountId
					}
					to {
						... on AssigneeFieldValue {
							displayValue
							value
							avatarUrl
						}
					}
				}
			}
		}
	}
`;
const $e02131b26eaa3db7$var$useSupervisor = (user, updatedValue)=>{
    const [humanSupervisor, setHumanSupervisor] = (0, $eJOHy.useState)(null);
    const issueKey = (0, $bmoS1.useIssueKey)();
    const prevUpdatedValue = (0, $6d9QY.usePrevious)(updatedValue);
    const hasInitialDataLoadedRef = (0, $eJOHy.useRef)(false);
    const { data: { user: currentUser } } = (0, $3MbOI.useCurrentUser)();
    // For agent assignee, load human supervisor from issue history, when issue or user changes
    (0, $eJOHy.useEffect)(()=>{
        if (!issueKey) return;
        if (user?.appType !== 'agent') {
            hasInitialDataLoadedRef.current = true;
            setHumanSupervisor(null);
            return;
        }
        const history = (0, $6rzJr.getClient)('fields/platform/user/assignee/inline-edit-full/src/ui/assignee/index').query({
            query: $e02131b26eaa3db7$var$IssueHistoryQuery,
            variables: {
                issueKey: issueKey,
                startAt: 0,
                maxResults: 5,
                orderBy: '-created'
            }
        });
        history.then((result)=>{
            const issueHistoryNodes = result?.data?.viewIssue?.history?.nodes;
            const mostRecentAgentAssignmentRecord = issueHistoryNodes?.find((node)=>node.fieldId === 'assignee' && node.to?.displayValue === user?.name);
            if (mostRecentAgentAssignmentRecord) setHumanSupervisor({
                ...mostRecentAgentAssignmentRecord.actor,
                displayName: currentUser.accountId === mostRecentAgentAssignmentRecord.actor.accountId ? 'You' : mostRecentAgentAssignmentRecord.actor.displayName
            });
            hasInitialDataLoadedRef.current = true;
        });
    // TODO: error handling
    }, [
        issueKey,
        user?.accountId,
        user?.name,
        user?.appType,
        currentUser.accountId
    ]); // accountId here to protect again identical agent names
    // Optimistic update: set supervisor to current user when assignee **changed** from client side
    (0, $eJOHy.useEffect)(()=>{
        // skip when assignee didn't really change, or before initial data is loaded
        if (!hasInitialDataLoadedRef.current || prevUpdatedValue?.id === updatedValue?.id) return;
        if (updatedValue?.appType !== 'agent') {
            setHumanSupervisor(null);
            return;
        }
        setHumanSupervisor({
            accountId: currentUser.accountId ?? '',
            displayName: 'You',
            avatarUrls: {
                large: (0, $fq2RT.isDataExtra)(currentUser) ? currentUser.avatarUrls['48x48'] : ''
            }
        });
    }, [
        updatedValue,
        prevUpdatedValue,
        currentUser
    ]);
    return {
        humanSupervisor: humanSupervisor
    };
};
const $e02131b26eaa3db7$export$fca3d223ba9f0bef = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jira_ai_show_human_supervisor_avatar'), $e02131b26eaa3db7$var$useSupervisor, ()=>({
        humanSupervisor: null
    }));

});
parcelRegister("fq2RT", function(module, exports) {
$parcel$export(module.exports, "isDataExtra", () => $a3b2f2c11205ea94$export$ba78a24d4b61cf6b);
function $a3b2f2c11205ea94$export$ba78a24d4b61cf6b(data) {
    return data ? 'avatarUrls' in data : false;
}

});

parcelRegister("6rzJr", function(module, exports) {
$parcel$export(module.exports, "getClient", () => $dc2f954dac87a9b3$export$6bb76d6eba7e258c);

var $4mEPL = parcelRequire("4mEPL");
const $dc2f954dac87a9b3$var$appendOperationQuery = (operation)=>operation ? `?operation=${operation}` : '';
const $dc2f954dac87a9b3$export$aefb19023b2eda55 = (operation)=>`/rest/gira/1/${$dc2f954dac87a9b3$var$appendOperationQuery(operation)}`;
const $dc2f954dac87a9b3$var$makeFetchClient = (path)=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $4mEPL.default)($dc2f954dac87a9b3$export$aefb19023b2eda55(operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            }, path)
    });
let $dc2f954dac87a9b3$var$client;
const $dc2f954dac87a9b3$export$6bb76d6eba7e258c = (path)=>{
    if (!$dc2f954dac87a9b3$var$client) $dc2f954dac87a9b3$var$client = $dc2f954dac87a9b3$var$makeFetchClient(path);
    return $dc2f954dac87a9b3$var$client;
};

});



parcelRegister("krQQZ", function(module, exports) {
$parcel$export(module.exports, "ReporterInlineEditViewWithIsEditable", () => $fb2bd4b71c691326$export$f3ca6190158a888f);
$parcel$export(module.exports, "ReporterInlineEditView", () => $fb2bd4b71c691326$export$981d7f2f0ffb0beb);

var $cOCPl = parcelRequire("cOCPl");

var $f5QZc = parcelRequire("f5QZc");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $iZVkR = parcelRequire("iZVkR");


var $9qZqK = parcelRequire("9qZqK");
const $fb2bd4b71c691326$export$f3ca6190158a888f = ({ fragmentRef: fragmentRef, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $f5QZc.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iZVkR.SingleUserPickerInlineEditViewWithIsEditable), {
        ...props,
        fragmentRef: data,
        noneOptionLabel: formatMessage((0, $9qZqK.default).anonymous),
        profileCardAction: (0, $9122f643e6cb5228$export$6b36f20db7a18a86)
    });
};
const $fb2bd4b71c691326$export$981d7f2f0ffb0beb = ({ fragmentRef: fragmentRef, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $cOCPl.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iZVkR.SingleUserPickerInlineEditView), {
        ...props,
        fragmentRef: data,
        noneOptionLabel: formatMessage((0, $9qZqK.default).anonymous),
        profileCardAction: (0, $9122f643e6cb5228$export$6b36f20db7a18a86)
    });
};

});
parcelRegister("cOCPl", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ea24f828a1bc17e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e444162d4db31fe2d8cf9ce3d49c500a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3ea24f828a1bc17e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "reporter_issueFieldReporterInlineEditFull_ReporterInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditView_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$3ea24f828a1bc17e$var$node.hash = "bd02fa384b206ea57830ba99674f24b9";
var $3ea24f828a1bc17e$export$2e2bcd8739ae039 = $3ea24f828a1bc17e$var$node;

});

parcelRegister("f5QZc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b165acb56b0977ff$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fb86f10febd7873bf5fcf89f85958c48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b165acb56b0977ff$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "reporter_issueFieldReporterInlineEditFull_ReporterInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$b165acb56b0977ff$var$node.hash = "75550b2f1743d8a0b6176f6ded3b5c91";
var $b165acb56b0977ff$export$2e2bcd8739ae039 = $b165acb56b0977ff$var$node;

});

parcelRegister("iZVkR", function(module, exports) {
$parcel$export(module.exports, "SingleUserPickerInlineEditViewWithIsEditable", () => $18a4c20873122153$export$c143582b21f1a708);
$parcel$export(module.exports, "SingleUserPickerInlineEditView", () => $18a4c20873122153$export$f182346570197b8);

var $jdlUt = parcelRequire("jdlUt");

var $ekOAq = parcelRequire("ekOAq");

var $lnV80 = parcelRequire("lnV80");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $41wNq = parcelRequire("41wNq");

var $lRq8t = parcelRequire("lRq8t");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $fsoQR = parcelRequire("fsoQR");

var $1LCPi = parcelRequire("1LCPi");

var $22FmW = parcelRequire("22FmW");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $3vB7G = parcelRequire("3vB7G");

var $iqAIM = parcelRequire("iqAIM");
const $18a4c20873122153$var$isEqualUser = (a, b)=>a?.id === b?.id;
const $18a4c20873122153$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-single-user-picker-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $18a4c20873122153$export$c143582b21f1a708 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, onCancel: onCancel, onEdit: onEdit, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, noneOptionLabel: noneOptionLabel, profileCardAction: profileCardAction, portalElement: portalElement, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $lnV80.default), fragmentRef);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name, user: user, fieldConfig: fieldConfig } = data;
    const isFieldRequired = (0, $eJOHy.useMemo)(()=>fieldConfig?.isRequired ?? false, [
        fieldConfig?.isRequired
    ]);
    const fieldName = (0, $eJOHy.useMemo)(()=>overriding.overrideLabel(name), [
        name,
        overriding
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overriding.overrideIsEditable(isEditable), [
        isEditable,
        overriding
    ]);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $ekOAq.default));
    const initialValue = user ?? null;
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((newUser, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newUser);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: newUser?.id ?? null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateSingleSelectUserPickerField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateSingleSelectUserPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            user: newUser ? {
                                id: newUser.id,
                                accountId: newUser.accountId,
                                accountStatus: newUser.accountStatus,
                                name: newUser.name,
                                picture: newUser.picture,
                                __typename: 'AtlassianAccountUser'
                            } : null
                        }
                    }
                }
            }
        });
    }, [
        commit,
        uniqueFieldId,
        onSubmit
    ]);
    const validator = (0, $iqAIM.useSingleUserPickerValidator)(fieldName, isFieldRequired);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $18a4c20873122153$var$isEqualUser,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitSucceeded: onSubmitSucceeded,
        onSubmitFailed: onSubmitFailed,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        validator: validator,
        clipboardComponentType: 'singleUser'
    });
    // #region Read view
    const finalNoneOptionLabel = noneOptionLabel ?? formatMessage((0, $3vB7G.default).noneOption);
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($18a4c20873122153$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fsoQR.SingleUserPickerWithProfileCardReadView), {
            fragmentRef: data,
            emptyUserLabel: finalNoneOptionLabel,
            profileCardAction: profileCardAction,
            shouldRenderHoverPopover: shouldRenderHoverPopover,
            fieldId: fieldId
        })), [
        data,
        finalNoneOptionLabel,
        profileCardAction,
        shouldRenderHoverPopover,
        fieldId
    ]);
    // #endregion
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            fieldId: uniqueFieldId,
            autoFocus: true,
            value: updatedValue ? (0, $22FmW.transformAggToUserOption)(updatedValue) : null,
            onChange: handleChangeAndConfirm,
            onClear: ()=>handleChangeAndConfirm(null),
            spacing: spacing,
            noneOptionLabel: finalNoneOptionLabel,
            includeNoneOption: !isFieldRequired,
            isClearable: !isFieldRequired,
            menuPosition: menuPosition,
            portalElement: portalElement,
            ariaLabel: fieldName,
            isInvalid: !!invalidMessage
        });
    const editButtonLabel = formatMessage((0, $41wNq.default).extendedEditButtonLabel, {
        inputFieldValue: initialValue?.name ?? finalNoneOptionLabel,
        fieldName: fieldName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupTarget: editViewPopupTarget,
        editViewEntryPoint: (0, $1LCPi.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readView: renderReadView,
        hideActionButtons: true,
        editButtonLabel: editButtonLabel,
        readViewFitContainerHeight: readViewFitContainerHeight,
        disableReadViewAppearanceOnHoverOnly: fieldId === 'reporter'
    });
};
const $18a4c20873122153$export$f182346570197b8 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $jdlUt.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($18a4c20873122153$export$c143582b21f1a708, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("jdlUt", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cbfc7f2f05bc93d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ece559cc75651d75622d9b47e5f4a4ac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7cbfc7f2f05bc93d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$7cbfc7f2f05bc93d$var$node.hash = "d6afe351b35e0beb2951194f3010ad16";
var $7cbfc7f2f05bc93d$export$2e2bcd8739ae039 = $7cbfc7f2f05bc93d$var$node;

});

parcelRegister("ekOAq", function(module, exports) {
$parcel$export(module.exports, "default", () => $a28cad7f77dff659$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<08007f396db418a9d13cbce15739952a>>
 * @relayHash b249572b29f7cf45d6d7890c57510aed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8768a3b7a61167cb3f57c1ea183973ef7e13af793cc24d86f169fda9c41a20dd
const $a28cad7f77dff659$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "singleUserPicker_issueFieldSingleUser_SingleUserPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "singleUserPicker_issueFieldSingleUser_SingleUserPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8768a3b7a61167cb3f57c1ea183973ef7e13af793cc24d86f169fda9c41a20dd",
            "metadata": {},
            "name": "singleUserPicker_issueFieldSingleUser_SingleUserPickerField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$a28cad7f77dff659$var$node.hash = "bd06a0600bf6d9530e408c77f4b2739a";
var $a28cad7f77dff659$export$2e2bcd8739ae039 = $a28cad7f77dff659$var$node;

});

parcelRegister("lnV80", function(module, exports) {
$parcel$export(module.exports, "default", () => $0595050f6d5f7855$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<13beec71928bfcdc44a62173d9c393a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0595050f6d5f7855$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v1 /*: any*/ ,
            {
                "kind": "FragmentSpread",
                "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerWithProfileCardReadView_fragmentRef"
            },
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "picture"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accountStatus"
                    },
                    v0 /*: any*/ 
                ]
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectUserPickerField"
    };
}();
$0595050f6d5f7855$var$node.hash = "aebeab1812e893081e79766395b9288b";
var $0595050f6d5f7855$export$2e2bcd8739ae039 = $0595050f6d5f7855$var$node;

});

parcelRegister("1LCPi", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a534d5cb9d0b17f$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $2a534d5cb9d0b17f$var$SingleUserPickerEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("gQ0Bj")), {
        moduleId: "9f05df27",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $2a534d5cb9d0b17f$export$2e2bcd8739ae039 = $2a534d5cb9d0b17f$var$SingleUserPickerEditViewEntryPoint;

});
parcelRegister("gQ0Bj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9PLvk").then(()=>parcelRequire('hlQGS'));

});


parcelRegister("3vB7G", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e730141fc6dc9ec$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3e730141fc6dc9ec$var$messages = (0, $7qGN1.defineMessages)({
    noneOption: {
        "id": "issue-field-single-user-picker-inline-edit-full.single-user-picker.none-option",
        "defaultMessage": "None"
    },
    requiredErrorMessage: {
        "id": "issue-field-single-user-picker-inline-edit-full.single-user-picker.required-error-message",
        "defaultMessage": "{fieldName} is required"
    }
});
var $3e730141fc6dc9ec$export$2e2bcd8739ae039 = $3e730141fc6dc9ec$var$messages;

});

parcelRegister("iqAIM", function(module, exports) {
$parcel$export(module.exports, "useSingleUserPickerValidator", () => $b59aeb64ee7301b0$export$fb9026d1d46dfabe);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $3vB7G = parcelRequire("3vB7G");
const $b59aeb64ee7301b0$export$fb9026d1d46dfabe = (fieldName, isRequired)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const submit = (0, $eJOHy.useCallback)((value)=>{
        if (isRequired && value === null) return {
            type: 'error',
            message: formatMessage((0, $3vB7G.default).requiredErrorMessage, {
                fieldName: fieldName
            })
        };
        return null;
    }, [
        fieldName,
        formatMessage,
        isRequired
    ]);
    return {
        submit: submit
    };
};

});


parcelRegister("9qZqK", function(module, exports) {
$parcel$export(module.exports, "default", () => $b148334e47965f96$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b148334e47965f96$var$messages = (0, $7qGN1.defineMessages)({
    anonymous: {
        "id": "issue-field-reporter-inline-edit-full.reporter.anonymous",
        "defaultMessage": "Anonymous"
    }
});
var $b148334e47965f96$export$2e2bcd8739ae039 = $b148334e47965f96$var$messages;

});


parcelRegister("jpLGv", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cd21ab76f02e18a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5cd21ab76f02e18a$var$messages = (0, $7qGN1.defineMessages)({
    anonymous: {
        "id": "native-issue-table.common.issue-cells.user.anonymous",
        "defaultMessage": "Anonymous"
    }
});
var $5cd21ab76f02e18a$export$2e2bcd8739ae039 = $5cd21ab76f02e18a$var$messages;

});


parcelRegister("9wlkB", function(module, exports) {
$parcel$export(module.exports, "CommentSummaryCell", () => $a1e94c8eb5a5484f$export$ec9db7e6afbd918a);

var $hHX59 = parcelRequire("hHX59");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $gDKBr = parcelRequire("gDKBr");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $jiTA8 = parcelRequire("jiTA8");

var $34oCh = parcelRequire("34oCh");

var $bFwiO = parcelRequire("bFwiO");
const $a1e94c8eb5a5484f$export$ec9db7e6afbd918a = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueKey: issueKey, onIssueLinkSelected: onIssueLinkSelected })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isEmbedMode = (0, $jiTA8.useIsEmbedMode)();
    const data = (0, $j4oe4.useFragment)((0, $hHX59.default), fieldRef);
    const canAddComment = data?.commentSummary?.canAddComment;
    const totalCount = data?.commentSummary?.totalCount;
    const renderedCommentCount = (0, $eJOHy.useMemo)(()=>{
        // No comments, add comment
        if (!totalCount) return formatMessage((0, $bFwiO.default).addComment);
        // Less than 100 comments, show count
        if (totalCount < 100) return formatMessage((0, $bFwiO.default).commentsCount, {
            commentCount: totalCount
        });
        // More than 99 comments, show 99+
        return formatMessage((0, $bFwiO.default).moreComments);
    }, [
        formatMessage,
        totalCount
    ]);
    const handleClick = (0, $eJOHy.useCallback)((e)=>{
        // Use default browser event handling when a modifier key is pressed during the click event
        const isModifierKeyUsed = e.ctrlKey || e.shiftKey || e.metaKey;
        const handled = !isEmbedMode && !isModifierKeyUsed && onIssueLinkSelected !== undefined && onIssueLinkSelected(issueKey, true);
        if (handled) e.preventDefault();
    }, [
        isEmbedMode,
        issueKey,
        onIssueLinkSelected
    ]);
    const hoverPopoverEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (!totalCount && !canAddComment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        href: `/browse/${issueKey}`,
        xcss: [
            $a1e94c8eb5a5484f$var$buttonStyles,
            !totalCount && $a1e94c8eb5a5484f$var$emptyStyles
        ],
        onClick: handleClick,
        backgroundColor: "color.background.neutral.subtle",
        paddingInline: "space.075",
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDKBr))), {
        color: "currentColor",
        label: formatMessage((0, $bFwiO.default).comments)
    }), hoverPopoverEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        maxLines: 1
    }, renderedCommentCount) : renderedCommentCount);
});
const $a1e94c8eb5a5484f$var$buttonStyles = (0, $1DXK0.xcss)({
    color: 'color.text',
    borderRadius: 'radius.small',
    borderWidth: 'border.width.focused',
    borderStyle: 'solid',
    // borderColor doesn't allow transparent as a value so we use inline/block which has looser typing
    borderInlineColor: 'transparent',
    borderBlockColor: 'transparent',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minHeight: '100%',
    maxWidth: '100%',
    textDecoration: 'none',
    ':focus': {
        borderInlineColor: 'color.border.focused',
        borderBlockColor: 'color.border.focused',
        outline: 0,
        color: 'color.text',
        textDecoration: 'none'
    },
    ':focus-visible': {
        borderInlineColor: 'color.border.focused',
        borderBlockColor: 'color.border.focused',
        outline: 0
    },
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        color: 'color.text',
        textDecoration: 'none'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $a1e94c8eb5a5484f$var$emptyStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtlest',
    ':focus': {
        color: 'color.text.subtlest'
    },
    ':hover': {
        color: 'color.text.subtlest'
    }
});

});
parcelRegister("hHX59", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2199c29fe20e111$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ffa60ed574f3d1189e97a9eaa3b8c340>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a2199c29fe20e111$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "CommentSummaryCell",
    "selections": [
        {
            "concreteType": "JiraCommentSummary",
            "kind": "LinkedField",
            "name": "commentSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canAddComment"
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                }
            ]
        }
    ],
    "type": "JiraCommentSummaryField"
};
$a2199c29fe20e111$var$node.hash = "4704a2d7c0c9a0c38b8dab59696c6807";
var $a2199c29fe20e111$export$2e2bcd8739ae039 = $a2199c29fe20e111$var$node;

});

parcelRegister("bFwiO", function(module, exports) {
$parcel$export(module.exports, "default", () => $9772c4bb281d361c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9772c4bb281d361c$var$messages = (0, $7qGN1.defineMessages)({
    comments: {
        "id": "business-list.list-view.comments-cell.comments",
        "defaultMessage": "Comments"
    },
    commentsCount: {
        "id": "business-list.list-view.comments-cell.comments-count",
        "defaultMessage": "{commentCount, plural, one {# comment} other {# comments}}"
    },
    moreComments: {
        "id": "business-list.list-view.comments-cell.more-comments",
        "defaultMessage": "99+ comments"
    },
    addComment: {
        "id": "business-list.list-view.comments-cell.add-comment",
        "defaultMessage": "Add comment"
    }
});
var $9772c4bb281d361c$export$2e2bcd8739ae039 = $9772c4bb281d361c$var$messages;

});


parcelRegister("4UEvW", function(module, exports) {
$parcel$export(module.exports, "UrlCell", () => $a2b5e1bc1ee659e3$export$110272e30ac53e5);

var $8JEgf = parcelRequire("8JEgf");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $57mJt = parcelRequire("57mJt");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $a2b5e1bc1ee659e3$export$110272e30ac53e5 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $8JEgf.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $57mJt.UrlInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $a2b5e1bc1ee659e3$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isSimpleInlineSmartLinkEnabled: true,
        shouldRenderHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $57mJt.UrlInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isSimpleInlineSmartLinkEnabled: true,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $a2b5e1bc1ee659e3$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $a2b5e1bc1ee659e3$var$customTargetStyles : $a2b5e1bc1ee659e3$var$customTargetStylesOld,
        ref: ref
    });
});
const $a2b5e1bc1ee659e3$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $a2b5e1bc1ee659e3$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("8JEgf", function(module, exports) {
$parcel$export(module.exports, "default", () => $43f6573ad7018422$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c7be4c4e943900dfca31bc10ad8f1ef7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $43f6573ad7018422$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "UrlCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraUrlField"
};
$43f6573ad7018422$var$node.hash = "a091578da8f9acb46861f2691520469b";
var $43f6573ad7018422$export$2e2bcd8739ae039 = $43f6573ad7018422$var$node;

});

parcelRegister("57mJt", function(module, exports) {
$parcel$export(module.exports, "UrlInlineEditViewIsEditable", () => $d5b0aa8cf071a4d2$export$b805891365234836);
$parcel$export(module.exports, "UrlInlineEditView", () => $d5b0aa8cf071a4d2$export$9c96a1eab7a0bc87);

var $iO15v = parcelRequire("iO15v");

var $jw24n = parcelRequire("jw24n");

var $g1Gaj = parcelRequire("g1Gaj");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $auNLL = parcelRequire("auNLL");

var $77rtG = parcelRequire("77rtG");

var $1yqND = parcelRequire("1yqND");

var $bJscI = parcelRequire("bJscI");

var $99gun = parcelRequire("99gun");

var $4s7iN = parcelRequire("4s7iN");

var $4EKqI = parcelRequire("4EKqI");

var $6GBsJ = parcelRequire("6GBsJ");

var $entKp = parcelRequire("entKp");
const $d5b0aa8cf071a4d2$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-url-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $d5b0aa8cf071a4d2$export$b805891365234836 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, fragmentRef: fragmentRef, spacing: spacing = 'compact', readViewFitContainerHeight: readViewFitContainerHeight, isEditable: isEditable, isSimpleInlineSmartLinkEnabled: isSimpleInlineSmartLinkEnabled, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $g1Gaj.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $jw24n.default));
    const { id: uniqueFieldId, name: name, fieldId: fieldId, type: fieldType } = data;
    // #endregion Relay
    // #region State
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const uri = data.uri ?? '';
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(uri);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    // #endregion State
    // #region Action
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        uri: value
                    }
                }
            },
            onCompleted: (response)=>{
                if (response.jira?.updateUrlField?.success) onSuccess();
                else onFail();
            },
            onError: (error)=>{
                onFail(error, error.message);
            },
            optimisticResponse: {
                jira: {
                    updateUrlField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            fieldId: fieldId,
                            type: fieldType,
                            name: name,
                            uri: value
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldType,
        name,
        onSubmit,
        uniqueFieldId
    ]);
    const validator = (0, $eJOHy.useMemo)(()=>{
        const change = (value)=>{
            if (!(0, $entKp.isAllowed)(value)) return {
                type: 'error',
                message: formatMessage((0, $6GBsJ.default).validUrl)
            };
            return null;
        };
        return {
            change: change
        };
    }, [
        formatMessage
    ]);
    const actions = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: uri,
        updatedValue: updatedValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        validator: validator,
        clipboardComponentType: 'url'
    });
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = actions;
    const onChange = (0, $eJOHy.useCallback)(({ target: target })=>{
        handleChange(target.value);
    }, [
        handleChange
    ]);
    // #endregion Action
    // #region View
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d5b0aa8cf071a4d2$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1yqND.UrlReadView), {
            fragmentRef: data,
            isSimpleInlineSmartLinkEnabled: isSimpleInlineSmartLinkEnabled,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        })), [
        data,
        isSimpleInlineSmartLinkEnabled,
        shouldRenderHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            value: updatedValue,
            spacing: spacing,
            onChange: onChange,
            type: 'url',
            isInvalid: Boolean(invalidMessage),
            ariaLabel: fieldName
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $77rtG.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView
    });
};
const $d5b0aa8cf071a4d2$export$9c96a1eab7a0bc87 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $iO15v.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d5b0aa8cf071a4d2$export$b805891365234836, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("iO15v", function(module, exports) {
$parcel$export(module.exports, "default", () => $d175414bb3c14971$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<37b313f79c6a03c4fa93aaac275bdf29>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d175414bb3c14971$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraUrlField"
};
$d175414bb3c14971$var$node.hash = "5aed5e7bdc192a64e4e820aace0e3608";
var $d175414bb3c14971$export$2e2bcd8739ae039 = $d175414bb3c14971$var$node;

});

parcelRegister("jw24n", function(module, exports) {
$parcel$export(module.exports, "default", () => $51943ec85b74d6d0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<413ccd688c8790d22dc7a1baf17763da>>
 * @relayHash 9cf7383e10e7a7f292242fc29022a01d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 448dd3bf9d4c082dc9e838d4055dc8989cf72c0256f51f4b2e10c0d31d8253b6
const $51943ec85b74d6d0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "url_issueFieldUrl_UrlField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUrlFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateUrlField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraUrlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "url_issueFieldUrl_UrlField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUrlFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateUrlField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraUrlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "uri"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "448dd3bf9d4c082dc9e838d4055dc8989cf72c0256f51f4b2e10c0d31d8253b6",
            "metadata": {},
            "name": "url_issueFieldUrl_UrlField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$51943ec85b74d6d0$var$node.hash = "60222c1fb24270ee0c27b8d3bfc763a4";
var $51943ec85b74d6d0$export$2e2bcd8739ae039 = $51943ec85b74d6d0$var$node;

});

parcelRegister("g1Gaj", function(module, exports) {
$parcel$export(module.exports, "default", () => $eeb13133234f5ed9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63b14e199759744cdf583eb0c109846a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $eeb13133234f5ed9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "uri"
        },
        {
            "kind": "FragmentSpread",
            "name": "url_issueFieldUrlReadviewFull_UrlReadView"
        }
    ],
    "type": "JiraUrlField"
};
$eeb13133234f5ed9$var$node.hash = "f560c76a2ba024cc2bd7b741c47d14d9";
var $eeb13133234f5ed9$export$2e2bcd8739ae039 = $eeb13133234f5ed9$var$node;

});

parcelRegister("1yqND", function(module, exports) {
$parcel$export(module.exports, "UrlReadView", () => $d24b7315cb4e95ba$export$7e9a6aefd9dafa88);

var $hTBSZ = parcelRequire("hTBSZ");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $d9T1A = parcelRequire("d9T1A");

var $8CGjN = parcelRequire("8CGjN");

var $gg9AF = parcelRequire("gg9AF");

var $3PRLs = parcelRequire("3PRLs");

var $3OT15 = parcelRequire("3OT15");

var $3Lkm9 = parcelRequire("3Lkm9");

var $k6Nau = parcelRequire("k6Nau");

var $8fZi6 = parcelRequire("8fZi6");
// eslint-disable-next-line no-script-url
const $d24b7315cb4e95ba$var$forbiddenScheme = 'javascript:';
const $d24b7315cb4e95ba$export$7e9a6aefd9dafa88 = ({ fragmentRef: fragmentRef, isSimpleInlineSmartLinkEnabled: isSimpleInlineSmartLinkEnabled, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $hTBSZ.default), fragmentRef);
    const { uri: value } = data;
    const [isUrlErrorState, setIsUrlErrorState] = (0, $eJOHy.useState)(false);
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = shouldRenderHoverPopover ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: value
    });
    const handleSmartLinkError = ()=>{
        setIsUrlErrorState(true);
    };
    const isBespokeEmptyFieldTextGA = (0, $k6Nau.useBespokeEmptyFieldTextGA)();
    if (value == null || value === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), isBespokeEmptyFieldTextGA && {
        placeholderText: (0, $3Lkm9.default).bespokenUrlPlaceholderEmptyFieldText
    });
    if (isSimpleInlineSmartLinkEnabled) {
        if (value.startsWith($d24b7315cb4e95ba$var$forbiddenScheme)) {
            if (shouldRenderHoverPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                maxLines: 1,
                ref: hoverPopoverRef
            }, value);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $d24b7315cb4e95ba$var$truncatedStyles,
                ref: contentRef
            }, value);
        }
        let renderContent = (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3PRLs.SimpleInlineSmartLink), {
                anchorTarget: "_blank",
                url: (0, $gg9AF.default)(value, '//'),
                anchorRef: ref,
                onError: shouldRenderHoverPopover ? handleSmartLinkError : undefined
            });
        if ((0, $8CGjN.default)(value)) renderContent = (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3PRLs.SimpleInlineSmartLink), {
                anchorTarget: "_blank",
                url: `mailto:${value}`,
                text: value,
                anchorRef: ref,
                onError: shouldRenderHoverPopover ? handleSmartLinkError : undefined
            });
        if (shouldRenderHoverPopover && isUrlErrorState) return renderContent(hoverPopoverRef);
        return renderContent(undefined);
    }
    const lDisplayValue = (0, $8fZi6.formatReadValue)(value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d24b7315cb4e95ba$var$Ellipsis, {
        title: value
    }, lDisplayValue);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d24b7315cb4e95ba$var$Ellipsis = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $d24b7315cb4e95ba$var$truncatedStyles = (0, $1DXK0.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});
parcelRegister("hTBSZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $742c700a3991249e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<92147b16395451d8bfecdd9df74b8c13>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $742c700a3991249e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "url_issueFieldUrlReadviewFull_UrlReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "uri"
        }
    ],
    "type": "JiraUrlField"
};
$742c700a3991249e$var$node.hash = "6f1b369836bf61ff873cf37f18025e6a";
var $742c700a3991249e$export$2e2bcd8739ae039 = $742c700a3991249e$var$node;

});

parcelRegister("8CGjN", function(module, exports) {
$parcel$export(module.exports, "default", () => $1859a6867727826b$export$2e2bcd8739ae039);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1859a6867727826b$var$isValidEmailAddress = (string)=>{
    if (!string || typeof string !== 'string') return false;
    return /\S+@\S+/.test(string);
};
var $1859a6867727826b$export$2e2bcd8739ae039 = $1859a6867727826b$var$isValidEmailAddress;

});

parcelRegister("gg9AF", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa271c6a6316ebe8$export$2e2bcd8739ae039);

var $eNS8S = parcelRequire("eNS8S");
/**
 * Absolute URL regex
 */ const $fa271c6a6316ebe8$var$AbsoluteURLRegex = new RegExp(/^[a-z][a-z\d+.-]*:/);
/**
 * Prefix url if it is url, return what we got if not
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fa271c6a6316ebe8$var$prefixUrl = (string, prefix)=>{
    // The same line is in isUrl, but flow requires it here too
    if (typeof string !== 'string' || !prefix) return string;
    // Exit early
    if (!(0, $eNS8S.default)(string)) return string;
    // Double slash urls are absolute too, relative to the schema used in current window
    if (string.substring(0, 2) === '//') return string;
    // If it's an absolute URL, return it, no need to prefix
    if ($fa271c6a6316ebe8$var$AbsoluteURLRegex.test(string)) return string;
    // If it's a relative URL, prefix it with prefix
    return prefix + string;
};
var $fa271c6a6316ebe8$export$2e2bcd8739ae039 = $fa271c6a6316ebe8$var$prefixUrl;

});

parcelRegister("8fZi6", function(module, exports) {
$parcel$export(module.exports, "formatReadValue", () => $b989a4aaa09f3a35$export$7ff86f9bff10df25);

var $eJOHy = parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $4cTDP = parcelRequire("4cTDP");

var $8CGjN = parcelRequire("8CGjN");

var $gg9AF = parcelRequire("gg9AF");

var $cxKOj = parcelRequire("cxKOj");

var $ix81O = parcelRequire("ix81O");
// eslint-disable-next-line no-script-url
const $b989a4aaa09f3a35$var$forbiddenScheme = 'javascript:';
const $b989a4aaa09f3a35$export$7ff86f9bff10df25 = (value)=>{
    if (value.toString().startsWith($b989a4aaa09f3a35$var$forbiddenScheme)) return value;
    if ((0, $8CGjN.default)(value)) {
        if ((0, $cxKOj.expValEquals)('jsw_perf_format-links-in-custom-fields', 'issue-view', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ix81O.LazySingleLineSmartLink), {
            anchorTarget: "_blank",
            url: `mailto:${value}`,
            text: value,
            fieldType: "url"
        });
        return (0, $4cTDP.fg)('replace-anchor-with-link__issue-view---kenji') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: `mailto:${value}`
        }, value) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
            href: `mailto:${value}`
        }, value);
    }
    if ((0, $cxKOj.expValEquals)('jsw_perf_format-links-in-custom-fields', 'issue-view', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ix81O.LazySingleLineSmartLink), {
        anchorTarget: "_blank",
        url: (0, $gg9AF.default)(value, '//'),
        fieldType: "url"
    });
    return (0, $4cTDP.fg)('replace-anchor-with-link__issue-view---kenji') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        href: (0, $gg9AF.default)(value, '//'),
        target: "_blank"
    }, value) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
        href: (0, $gg9AF.default)(value, '//'),
        target: "_blank"
    }, value);
};

});
parcelRegister("ix81O", function(module, exports) {
$parcel$export(module.exports, "LazySingleLineSmartLink", () => $77b5c4612dd0593c$export$80092fcb07ccc4b4);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $8kVp5 = parcelRequire("8kVp5");
const $77b5c4612dd0593c$var$entryPointParams = {};
const $77b5c4612dd0593c$export$80092fcb07ccc4b4 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $8kVp5.SingleLineSmartLinkEntryPoint), $77b5c4612dd0593c$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jira.issue-field.single-line-smart-link",
        packageName: "issue-field-smart-link",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("8kVp5", function(module, exports) {
$parcel$export(module.exports, "SingleLineSmartLinkEntryPoint", () => $9db257858ff44ec9$export$e236c9b35543c8d);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $9db257858ff44ec9$export$e236c9b35543c8d = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("918qg")).then((module)=>module.SingleLineSmartLink), {
        moduleId: "97818dc4",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("918qg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lxHfr").then(()=>parcelRequire('cNXTd'));

});





parcelRegister("6GBsJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $479b929ad3b0e6bc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $479b929ad3b0e6bc$var$messages = (0, $7qGN1.defineMessages)({
    validUrl: {
        "id": "issue-field-url-inline-edit-full.url.valid-url",
        "defaultMessage": "Please enter a valid URL."
    }
});
var $479b929ad3b0e6bc$export$2e2bcd8739ae039 = $479b929ad3b0e6bc$var$messages;

});

parcelRegister("entKp", function(module, exports) {
$parcel$export(module.exports, "isAllowed", () => $ba8c953f4fc4bb00$export$f023ae853add2e3e);

var $eNS8S = parcelRequire("eNS8S");
const $ba8c953f4fc4bb00$export$5c13dfcb31dfce7a = 'javascript:';
const $ba8c953f4fc4bb00$export$f023ae853add2e3e = (value)=>{
    if (value === '' || value === null) return true;
    if ((0, $eNS8S.default)(value)) return true;
    if (!value.startsWith($ba8c953f4fc4bb00$export$5c13dfcb31dfce7a)) return true;
    return false;
};

});



parcelRegister("81JsW", function(module, exports) {
$parcel$export(module.exports, "MultiVersionPickerCell", () => $bc7b294e5d9897f8$export$5ca120a08ed26914);

var $hoWAS = parcelRequire("hoWAS");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $MUcBt = parcelRequire("MUcBt");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $bc7b294e5d9897f8$export$5ca120a08ed26914 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $hoWAS.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MUcBt.MultiVersionPickerInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $bc7b294e5d9897f8$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MUcBt.MultiVersionPickerInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $bc7b294e5d9897f8$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $bc7b294e5d9897f8$var$customTargetStyles : $bc7b294e5d9897f8$var$customTargetStylesOld,
        ref: ref
    });
});
const $bc7b294e5d9897f8$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $bc7b294e5d9897f8$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("hoWAS", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3601dbceb0c1bf2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6e8e2603676f5c65049348206c684002>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d3601dbceb0c1bf2$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "MultiVersionPickerCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraMultipleVersionPickerField"
};
$d3601dbceb0c1bf2$var$node.hash = "57df00bf3570b866d064b3658b63c53f";
var $d3601dbceb0c1bf2$export$2e2bcd8739ae039 = $d3601dbceb0c1bf2$var$node;

});

parcelRegister("MUcBt", function(module, exports) {
$parcel$export(module.exports, "MultiVersionPickerInlineEditViewWithIsEditable", () => $1d553014db36a9f7$export$f431495591c5e674);

var $XI31d = parcelRequire("XI31d");

var $a9eYo = parcelRequire("a9eYo");

var $hwF63 = parcelRequire("hwF63");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4EKqI = parcelRequire("4EKqI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $dzwt3 = parcelRequire("dzwt3");

var $lI4O9 = parcelRequire("lI4O9");

var $auNLL = parcelRequire("auNLL");

var $bJscI = parcelRequire("bJscI");
const $1d553014db36a9f7$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-multi-version-picker-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $1d553014db36a9f7$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.value));
    return b.every((option)=>aIdSet.has(option.value));
};
const $1d553014db36a9f7$export$f431495591c5e674 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupTarget: editViewPopupTarget, editViewPopupWidth: editViewPopupWidth, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $hwF63.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $a9eYo.default));
    const { id: uniqueFieldId, name: name, selectedVersionsConnection: selectedOptions, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedOptions?.edges) return null;
        return selectedOptions.edges.map((edge)=>({
                id: edge?.node?.value ?? '',
                optionId: edge?.node?.versionId ?? '',
                value: edge?.node?.label ?? '',
                selectableLabel: edge?.node?.label ?? '',
                selectableGroupKey: null,
                selectableIconUrl: null
            }));
    }, [
        selectedOptions?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.id) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateMultipleVersionPickerField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateMultipleVersionPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedVersionsConnection: {
                                edges: values?.map((edge)=>({
                                        node: {
                                            id: edge.id ?? '',
                                            name: edge.selectableLabel ?? '',
                                            label: edge.selectableLabel ?? '',
                                            value: edge.id ?? '',
                                            versionId: edge.optionId ?? ''
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChange: handleChange } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $1d553014db36a9f7$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'multiVersionSelect'
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1d553014db36a9f7$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lI4O9.MultiVersionPickerReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            isTruncatedWithHoverPopover: isTruncatedWithHoverPopover
        })), [
        data,
        isTruncated,
        isTruncatedWithHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            spacing: spacing
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $dzwt3.default),
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isTruncatedWithHoverPopover
    });
};
const $1d553014db36a9f7$export$39b0857e7fc9fc58 = ({ fragmentRef: fragmentRef, ...props })=>{
    /**
   * This fragment should spread the inner InlineEditViewWithIsEditable fragment and read the isEditable flag from the
   * fieldConfig.
   */ const data = (0, $j4oe4.useFragment)((0, $XI31d.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1d553014db36a9f7$export$f431495591c5e674, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("XI31d", function(module, exports) {
$parcel$export(module.exports, "default", () => $1216c6af2431e309$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2bc41e79d78b8f6ab7ab8377a87047ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1216c6af2431e309$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraMultipleVersionPickerField"
};
$1216c6af2431e309$var$node.hash = "f3cd0ae179a2d6df739a19203f713cf5";
var $1216c6af2431e309$export$2e2bcd8739ae039 = $1216c6af2431e309$var$node;

});

parcelRegister("a9eYo", function(module, exports) {
$parcel$export(module.exports, "default", () => $e14ed67c2f59abfc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8342c4e836b7ec8b7c2b0ddfa6134252>>
 * @relayHash d19489d06d268f2aa2afd983864117f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 221728ae5b3c6aa07ca8d90d92a49ae0c66a238ebcf155f78b4ee1fc1d21e007
const $e14ed67c2f59abfc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "multiVersionPicker_issueFieldMultiVersionPicker_MultiVersionPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleVersionPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleVersionPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleVersionPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "multiVersionPicker_issueFieldMultiVersionPicker_MultiVersionPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleVersionPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleVersionPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleVersionPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000
                                                }
                                            ],
                                            "concreteType": "JiraVersionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedVersionsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersion",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "alias": "value",
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                },
                                                                {
                                                                    "alias": "label",
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "versionId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "221728ae5b3c6aa07ca8d90d92a49ae0c66a238ebcf155f78b4ee1fc1d21e007",
            "metadata": {},
            "name": "multiVersionPicker_issueFieldMultiVersionPicker_MultiVersionPickerField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$e14ed67c2f59abfc$var$node.hash = "c18481704920c57572e95641cfc0676b";
var $e14ed67c2f59abfc$export$2e2bcd8739ae039 = $e14ed67c2f59abfc$var$node;

});

parcelRegister("hwF63", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fc4a35634360e4d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<64112bc4a30b3469275bdfcb6eadd44c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3fc4a35634360e4d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "FragmentSpread",
            "name": "multiVersionPicker_issueFieldMultiVersionPickerReadviewFull_MultiVersionPickerReadView"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraVersionConnection",
            "kind": "LinkedField",
            "name": "selectedVersionsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraVersionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraVersion",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "value",
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "alias": "label",
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "versionId"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "selectedVersionsConnection(first:1000)"
        }
    ],
    "type": "JiraMultipleVersionPickerField"
};
$3fc4a35634360e4d$var$node.hash = "f3af5be7640f993ae73c44b61cc0fcb5";
var $3fc4a35634360e4d$export$2e2bcd8739ae039 = $3fc4a35634360e4d$var$node;

});

parcelRegister("dzwt3", function(module, exports) {
$parcel$export(module.exports, "default", () => $d87a6dba00e0e973$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $d87a6dba00e0e973$var$MultiVersionPickerEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("3mp2i")), {
        moduleId: "e516a23c",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $d87a6dba00e0e973$export$2e2bcd8739ae039 = $d87a6dba00e0e973$var$MultiVersionPickerEditViewEntryPoint;

});
parcelRegister("3mp2i", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1ppIg").then(()=>parcelRequire('83cMO'));

});


parcelRegister("lI4O9", function(module, exports) {
$parcel$export(module.exports, "MultiVersionPickerReadView", () => $d8943f78bceb81f0$export$555d899a217b3354);

var $3jA8G = parcelRequire("3jA8G");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $ewOxf = parcelRequire("ewOxf");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $1z178 = parcelRequire("1z178");
const $d8943f78bceb81f0$export$555d899a217b3354 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $3jA8G.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const selectedOptions = data?.selectedVersionsConnection?.edges?.filter((edge)=>Boolean(edge?.node?.name)).map((edge)=>({
            name: edge?.node?.name || '',
            key: edge?.node?.id || ''
        })) || [];
    if (!selectedOptions?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        xcss: isTruncatedWithHoverPopover && $d8943f78bceb81f0$var$containerWidthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: selectedOptions,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $1z178.default).showMoreTooltip),
        isHoverPopoverEnabled: isTruncatedWithHoverPopover
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d8943f78bceb81f0$var$containerWithNegativeMarginOffset
    }, selectedOptions.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
            key: item.key,
            text: item.name
        })));
};
const $d8943f78bceb81f0$var$containerWithNegativeMarginOffset = (0, $1DXK0.xcss)({
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    // Tag has a built-in margin of 4px, so we use a negative side margin to allow tags to align with their parent.
    marginTop: 'space.0',
    marginRight: 'space.negative.050',
    marginBottom: 'space.0',
    marginLeft: 'space.negative.050'
});
const $d8943f78bceb81f0$var$containerWidthStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("3jA8G", function(module, exports) {
$parcel$export(module.exports, "default", () => $a25aea708c625518$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c210e8b6e67913f30c2d1a9eedbd636>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a25aea708c625518$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiVersionPicker_issueFieldMultiVersionPickerReadviewFull_MultiVersionPickerReadView",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraVersionConnection",
            "kind": "LinkedField",
            "name": "selectedVersionsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraVersionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraVersion",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "selectedVersionsConnection(first:1000)"
        }
    ],
    "type": "JiraMultipleVersionPickerField"
};
$a25aea708c625518$var$node.hash = "7940aec048cb5cd7c9f0feb1ad306f48";
var $a25aea708c625518$export$2e2bcd8739ae039 = $a25aea708c625518$var$node;

});

parcelRegister("1z178", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d340ee67f462666$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0d340ee67f462666$var$messages = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-multi-version-picker-readview-full.multi-version-picker.truncated.show-more-tooltip",
        "defaultMessage": "See more items"
    }
});
var $0d340ee67f462666$export$2e2bcd8739ae039 = $0d340ee67f462666$var$messages;

});




parcelRegister("100iH", function(module, exports) {
$parcel$export(module.exports, "MultiGroupPickerCell", () => $7d58a69deed2c53f$export$73d843f1843865aa);

var $jrQ9a = parcelRequire("jrQ9a");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $20P47 = parcelRequire("20P47");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $7d58a69deed2c53f$export$73d843f1843865aa = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $jrQ9a.default), fieldRef);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    const fieldId = typeof data.id === 'string' ? data.id : '';
    (0, $eqbO4.useLazyLoadEditability)(fieldId, isEditable);
    // In edit mode, use the MultiGroupPickerEditView
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $20P47.MultiGroupPickerInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $7d58a69deed2c53f$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $20P47.MultiGroupPickerInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $7d58a69deed2c53f$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $7d58a69deed2c53f$var$customTargetStyles : $7d58a69deed2c53f$var$customTargetStylesOld,
        ref: ref
    });
});
const $7d58a69deed2c53f$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $7d58a69deed2c53f$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("jrQ9a", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1c8c7f5584211ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<579d027801fa5d2267ebebe5770bf4e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c1c8c7f5584211ea$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "MultiGroupPickerCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraMultipleGroupPickerField"
};
$c1c8c7f5584211ea$var$node.hash = "af5d3f55e3c502f94bcda205556783dd";
var $c1c8c7f5584211ea$export$2e2bcd8739ae039 = $c1c8c7f5584211ea$var$node;

});

parcelRegister("20P47", function(module, exports) {
$parcel$export(module.exports, "MultiGroupPickerInlineEditViewWithIsEditable", () => $41255fd266381b8b$export$7acb84464848fc0e);
$parcel$export(module.exports, "MultiGroupPickerInlineEditView", () => $41255fd266381b8b$export$4caaf52d4af1250c);

var $iOtiv = parcelRequire("iOtiv");

var $lRl95 = parcelRequire("lRl95");

var $5kZvX = parcelRequire("5kZvX");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $auNLL = parcelRequire("auNLL");

var $g9mk1 = parcelRequire("g9mk1");

var $jW4Yt = parcelRequire("jW4Yt");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $41255fd266381b8b$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.id));
    return b.every((option)=>aIdSet.has(option.id));
};
const $41255fd266381b8b$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-multi-group-picker-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $41255fd266381b8b$export$7acb84464848fc0e = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupTarget: editViewPopupTarget, editViewPopupWidth: editViewPopupWidth, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $5kZvX.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $lRl95.default));
    // #endregion Relay
    // #region Common state
    const { id: uniqueFieldId, name: name, selectedGroupsConnection: selectedGroupsConnection, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedGroupsConnection?.edges) return null;
        return selectedGroupsConnection.edges.map((edge)=>({
                id: edge?.node?.id ?? '',
                groupId: edge?.node?.groupId ?? '',
                name: edge?.node?.name ?? '',
                type: 'group'
            }));
    }, [
        selectedGroupsConnection?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable, overrideFieldOptionsFilter: overrideFieldOptionsFilter } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const filterOptionsById = (0, $eJOHy.useMemo)(()=>overrideFieldOptionsFilter(null), [
        overrideFieldOptionsFilter
    ]);
    // #endregion Common state
    // #region Actions
    const handleSubmit = (0, $eJOHy.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.id) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateMultipleGroupPickerField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateMultipleGroupPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedGroupsConnection: {
                                edges: values?.map((selection)=>({
                                        node: {
                                            id: selection.id,
                                            groupId: selection.groupId ?? '',
                                            name: selection.name
                                        }
                                    }))
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $41255fd266381b8b$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'multiGroupPicker'
    });
    // #endregion Actions
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($41255fd266381b8b$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jW4Yt.MultiGroupPickerReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            isTruncatedWithHoverPopover: isTruncatedWithHoverPopover
        })), [
        data,
        isTruncated,
        isTruncatedWithHoverPopover
    ]);
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            value: updatedValue,
            menuPosition: menuPosition,
            onChange: handleChange,
            filterOptionsById: filterOptionsById,
            isMulti: true
        });
    // #endregion Edit view
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $g9mk1.default),
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isTruncatedWithHoverPopover
    });
};
const $41255fd266381b8b$export$4caaf52d4af1250c = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $iOtiv.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($41255fd266381b8b$export$7acb84464848fc0e, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("iOtiv", function(module, exports) {
$parcel$export(module.exports, "default", () => $f65447c2ab5db073$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d5623bc30488e88f1d3982f57e69c5eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f65447c2ab5db073$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraMultipleGroupPickerField"
};
$f65447c2ab5db073$var$node.hash = "2b6dc2f7fb34ef75b6db441fb9ae7810";
var $f65447c2ab5db073$export$2e2bcd8739ae039 = $f65447c2ab5db073$var$node;

});

parcelRegister("lRl95", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9399d2366b7b47e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<02595abe4be4750a238e67d255544203>>
 * @relayHash cf7363cfea249c0b2da1cf11c7c42d39
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e6ffaa25a287e76c421668cfe52d8e9f94b8ae3c13144e889b27b520dc510540
const $c9399d2366b7b47e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleGroupPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleGroupPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleGroupPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleGroupPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleGroupPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleGroupPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraGroupConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedGroupsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraGroupEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraGroup",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "groupId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e6ffaa25a287e76c421668cfe52d8e9f94b8ae3c13144e889b27b520dc510540",
            "metadata": {},
            "name": "ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c9399d2366b7b47e$var$node.hash = "23b63517ce9fe10047fcdf0eced5f652";
var $c9399d2366b7b47e$export$2e2bcd8739ae039 = $c9399d2366b7b47e$var$node;

});

parcelRegister("5kZvX", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ac99f9be6c2cbae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ab669355cea1b866d173b253a3cfa88>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5ac99f9be6c2cbae$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_issueFieldMultiGroupPickerReadviewFull_MultiGroupPickerReadView"
            },
            {
                "concreteType": "JiraGroupConnection",
                "kind": "LinkedField",
                "name": "selectedGroupsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "groupId"
                                    },
                                    v1 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleGroupPickerField"
    };
}();
$5ac99f9be6c2cbae$var$node.hash = "8432d03e246ec4da1c38b93c6858f003";
var $5ac99f9be6c2cbae$export$2e2bcd8739ae039 = $5ac99f9be6c2cbae$var$node;

});

parcelRegister("g9mk1", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d7b6bc74037ca57$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $4d7b6bc74037ca57$var$MultiSelectEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("g8Kt0")), {
        moduleId: "5031be7a",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $4d7b6bc74037ca57$export$2e2bcd8739ae039 = $4d7b6bc74037ca57$var$MultiSelectEditViewEntryPoint;

});
parcelRegister("g8Kt0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("rFPjj").then(()=>parcelRequire('juA5l'));

});


parcelRegister("jW4Yt", function(module, exports) {
$parcel$export(module.exports, "MultiGroupPickerReadView", () => $f48eaf993afb193e$export$247ad3b7069fda16);

var $6anRJ = parcelRequire("6anRJ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $3Lkm9 = parcelRequire("3Lkm9");

var $kp5kj = parcelRequire("kp5kj");

var $1tX0c = parcelRequire("1tX0c");

var $2j0d2 = parcelRequire("2j0d2");

var $k6Nau = parcelRequire("k6Nau");

var $9HfjG = parcelRequire("9HfjG");
const $f48eaf993afb193e$export$247ad3b7069fda16 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $6anRJ.default), fragmentRef);
    const transformedSelectedOptions = (0, $eJOHy.useMemo)(()=>{
        if (!data?.selectedGroupsConnection?.edges) return null;
        const selectedOptions = data.selectedGroupsConnection.edges.map((edge)=>edge?.node).filter((node)=>!!node);
        return selectedOptions.map((node)=>({
                key: node.id,
                name: node.name,
                color: null,
                isInteractive: false
            }));
    }, [
        data?.selectedGroupsConnection?.edges
    ]);
    const isBespokeEmptyFieldTextGA = (0, $k6Nau.useBespokeEmptyFieldTextGA)();
    if (!transformedSelectedOptions?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), isBespokeEmptyFieldTextGA && {
        placeholderText: (0, $3Lkm9.default).bespokenMultiGroupPickerPlaceholderEmptyFieldText
    });
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        role: "group",
        xcss: isTruncatedWithHoverPopover && $f48eaf993afb193e$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: transformedSelectedOptions,
        ItemComponent: isTruncatedWithHoverPopover ? (0, $1tX0c.TagItem) : (0, $kp5kj.OptionTag),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $9HfjG.default).showMoreTooltip),
        isHoverPopoverEnabled: isTruncatedWithHoverPopover
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        role: "group",
        shouldWrap: true
    }, transformedSelectedOptions.map(({ key: key, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp5kj.OptionTag), {
            key: key,
            ...restProps
        })));
};
const $f48eaf993afb193e$var$inlineStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("6anRJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $43f60ac3a3a08a05$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5e4a0b4f914cbdbb0312a353542384d1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $43f60ac3a3a08a05$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueFieldMultiGroupPickerReadviewFull_MultiGroupPickerReadView",
    "selections": [
        {
            "concreteType": "JiraGroupConnection",
            "kind": "LinkedField",
            "name": "selectedGroupsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraGroup",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraMultipleGroupPickerField"
};
$43f60ac3a3a08a05$var$node.hash = "e7a12645b4d832047ab02c9f7b91d410";
var $43f60ac3a3a08a05$export$2e2bcd8739ae039 = $43f60ac3a3a08a05$var$node;

});

parcelRegister("9HfjG", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b04cc2321b0b85f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0b04cc2321b0b85f$var$messages = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-multi-group-picker-readview-full.multi-group-picker.compact.show-more-tooltip",
        "defaultMessage": "See more selected options"
    }
});
var $0b04cc2321b0b85f$export$2e2bcd8739ae039 = $0b04cc2321b0b85f$var$messages;

});




parcelRegister("01wyE", function(module, exports) {
$parcel$export(module.exports, "TimelineCellRenderer", () => $809beec470e16000$export$ad6d59b978eafde7);

var $ihVuF = parcelRequire("ihVuF");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9r0oq = parcelRequire("9r0oq");
const $809beec470e16000$export$ad6d59b978eafde7 = ({ depth: depth, groupId: groupId, fieldRef: fieldRef })=>{
    const timelineCustomComponents = (0, $9r0oq.useTimelineCustomComponents)();
    const data = (0, $j4oe4.useFragment)((0, $ihVuF.default), fieldRef);
    return timelineCustomComponents?.Cell && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(timelineCustomComponents.Cell, {
        depth: depth,
        groupId: groupId,
        fieldRef: data
    });
};

});
parcelRegister("ihVuF", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d5066200e5cf638$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<41cf844e8a41ba92ddf25cc7ef876a4f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4d5066200e5cf638$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "TimelineCellRenderer",
    "selections": [
        {
            "condition": "isTimelineEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "TimelineCell"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "TimelineCell_AggregatedTimelineCell"
                }
            ]
        }
    ],
    "type": "JiraIssueField",
    "abstractKey": "__isJiraIssueField"
};
$4d5066200e5cf638$var$node.hash = "c1de1facc7b86a79d000f40f979013d6";
var $4d5066200e5cf638$export$2e2bcd8739ae039 = $4d5066200e5cf638$var$node;

});


parcelRegister("9FoLd", function(module, exports) {
$parcel$export(module.exports, "WatchersCell", () => $53e330b40da2f7af$export$1e71e15ea9d46d5d);

var $32XeF = parcelRequire("32XeF");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8IeH1 = parcelRequire("8IeH1");
const $53e330b40da2f7af$var$styles = {
    watchesCell: "_1reo15vq _18m915vq _1rjc1b66 _p12f1osq _1bto1l2s"
};
const $53e330b40da2f7af$export$1e71e15ea9d46d5d = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $32XeF.default), fieldRef);
    const countValue = (0, $eJOHy.useMemo)(()=>{
        return data?.watch?.count;
    }, [
        data?.watch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $53e330b40da2f7af$var$styles.watchesCell
    }, countValue);
});

});
parcelRegister("32XeF", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b8ae0d8e37eb362$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5101f8bb18a86a59b2e9be60de468eac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5b8ae0d8e37eb362$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "WatchersCell",
    "selections": [
        {
            "concreteType": "JiraWatch",
            "kind": "LinkedField",
            "name": "watch",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                },
                {
                    "kind": "ScalarField",
                    "name": "isWatching"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "JiraWatchesField"
};
$5b8ae0d8e37eb362$var$node.hash = "4d470f783113ad6813aa2ebd466222c4";
var $5b8ae0d8e37eb362$export$2e2bcd8739ae039 = $5b8ae0d8e37eb362$var$node;

});


parcelRegister("ajiOP", function(module, exports) {
$parcel$export(module.exports, "LinkRelationshipTypeCell", () => $236b5c948089bc7e$export$d9d4a0e66ee82c3f);

var $a9Q9p = parcelRequire("a9Q9p");

var $aX3N8 = parcelRequire("aX3N8");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5WzNk = parcelRequire("5WzNk");

var $auNLL = parcelRequire("auNLL");

var $eqbO4 = parcelRequire("eqbO4");
const $236b5c948089bc7e$export$d9d4a0e66ee82c3f = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueRef: issueRef, onIssueUnlink: onIssueUnlink, issueStoreId: issueStoreId, itemsConnectionId: itemsConnectionId })=>{
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const issueData = (0, $j4oe4.useFragment)((0, $aX3N8.default), issueRef);
    const data = (0, $j4oe4.useFragment)((0, $a9Q9p.default), fieldRef);
    let baseIsEditable = false;
    if ('isEditableInIssueView' in data) baseIsEditable = data.isEditableInIssueView;
    else if ('lazyIsEditableInIssueView' in data) baseIsEditable = data.lazyIsEditableInIssueView;
    (0, $eqbO4.useLazyLoadEditability)(data.id, baseIsEditable);
    const isEditable = (0, $eJOHy.useMemo)(()=>overriding.overrideIsEditable(Boolean(baseIsEditable)), [
        baseIsEditable,
        overriding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5WzNk.LinkRelationshipInlineEditView), {
        fieldRef: data,
        issueRef: issueData,
        isEditable: isEditable ?? false,
        issueStoreId: issueStoreId,
        itemsConnectionId: itemsConnectionId,
        onIssueUnlink: onIssueUnlink
    }));
});

});
parcelRegister("a9Q9p", function(module, exports) {
$parcel$export(module.exports, "default", () => $85c0ad47df2260d6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<98f17c2f802ffc2b779e63bb5a3c39c4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $85c0ad47df2260d6$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "LinkRelationshipTypeCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isEditableSyncLoaded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditableInIssueView"
                }
            ]
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_fieldRef"
        }
    ],
    "type": "JiraIssueLinkRelationshipTypeField"
};
$85c0ad47df2260d6$var$node.hash = "6e86b25020acd81a9ac5426b8f69e24b";
var $85c0ad47df2260d6$export$2e2bcd8739ae039 = $85c0ad47df2260d6$var$node;

});

parcelRegister("aX3N8", function(module, exports) {
$parcel$export(module.exports, "default", () => $60f31fb1f1ed45bc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<11d18e7e368bab9a1845fbe1c7c3b712>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $60f31fb1f1ed45bc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "LinkRelationshipTypeCell_issueRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_issueRef"
        }
    ],
    "type": "JiraIssue"
};
$60f31fb1f1ed45bc$var$node.hash = "24d8dd2e4859e1fdbaadfd853328b22a";
var $60f31fb1f1ed45bc$export$2e2bcd8739ae039 = $60f31fb1f1ed45bc$var$node;

});

parcelRegister("5WzNk", function(module, exports) {
$parcel$export(module.exports, "LinkRelationshipInlineEditView", () => $ed193198e4107b6f$export$cdf1201d8417a5e2);

var $cRYxM = parcelRequire("cRYxM");

var $eOpmb = parcelRequire("eOpmb");

var $6hOU2 = parcelRequire("6hOU2");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $iCRih = parcelRequire("iCRih");

var $hi2yk = parcelRequire("hi2yk");

var $956it = parcelRequire("956it");

var $jn1Cb = parcelRequire("jn1Cb");
var $cSXp8 = parcelRequire("cSXp8");

var $99gun = parcelRequire("99gun");

var $4s7iN = parcelRequire("4s7iN");

var $d2AGn = parcelRequire("d2AGn");

var $4SjAP = parcelRequire("4SjAP");

var $4B7rn = parcelRequire("4B7rn");

var $lRq8t = parcelRequire("lRq8t");

var $14RSn = parcelRequire("14RSn");

var $kRgKj = parcelRequire("kRgKj");

var $ftN6c = parcelRequire("ftN6c");

var $8gALd = parcelRequire("8gALd");

var $jYDsp = parcelRequire("jYDsp");

var $gomlP = parcelRequire("gomlP");
const $ed193198e4107b6f$var$isMutationErrorPayload = (error)=>typeof error === 'object' && error !== null && 'extensions' in error && Boolean(error.extensions);
const $ed193198e4107b6f$var$isEqualValue = (a, b)=>a?.id === b?.id;
const $ed193198e4107b6f$export$cdf1201d8417a5e2 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueRef: issueRef, onIssueUnlink: onIssueUnlink, issueStoreId: issueStoreId, itemsConnectionId: itemsConnectionId, isEditable: isEditable })=>{
    const [showUnlinkConfirmation, setShowUnlinkConfirmation] = (0, $eJOHy.useState)(false);
    const { showFlag: showFlag } = (0, $cSXp8.useFlagService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const issueData = (0, $j4oe4.useFragment)((0, $6hOU2.default), issueRef);
    const data = (0, $j4oe4.useFragment)((0, $eOpmb.default), fieldRef);
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        const issueLinkData = {
            issueLinkTypeARI: data?.issueLink?.type?.id ?? '',
            relationName: data?.issueLink?.relationName ?? '',
            direction: data?.issueLink?.direction ?? 'INWARD'
        };
        return (0, $8gALd.createSelectedOptionFromFieldData)(issueLinkData);
    }, [
        data?.issueLink
    ]);
    const [selectedOption, setSelectedOption] = (0, $eJOHy.useState)(initialValue);
    const [commit] = (0, $j4oe4.useMutation)((0, $cRYxM.default));
    const issueId = issueData?.issueId ?? '';
    const issueKey = issueData?.key ?? '';
    const workType = issueData?.issueType?.name ?? '';
    const currentIssueFieldARI = data?.id || '';
    const currentIssueLinkARI = data?.issueLink?.id || '';
    const handleSubmit = (0, $eJOHy.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        const nextDirection = option?.direction;
        const nextRelationName = option?.label;
        const nextIssueLinkTypeARI = option?.value;
        if (!nextIssueLinkTypeARI) {
            onFail(new Error('No issue link type id provided'));
            return;
        }
        commit({
            variables: {
                input: {
                    id: currentIssueFieldARI,
                    operation: {
                        operation: 'SET',
                        update: {
                            issueLinkId: currentIssueLinkARI,
                            issueLinkTypeId: nextIssueLinkTypeARI,
                            direction: nextDirection
                        }
                    }
                }
            },
            onCompleted: (mutationData)=>{
                const mutationResponse = mutationData.jira?.updateIssueLinkRelationshipTypeField;
                if (mutationResponse?.success) {
                    onSuccess();
                    (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskSuccess', {
                        task: 'linkRelationshipTypeUpdate',
                        linkedWorkItemId: issueId
                    });
                } else {
                    const mutationError = mutationResponse?.errors?.[0];
                    const message = mutationError?.message ?? 'Failed to update issue link relationship type field';
                    const statusCode = mutationError?.extensions?.statusCode ?? 0;
                    if (statusCode >= 400 && statusCode < 500) onFail(new (0, $14RSn.ValidationError)(message, [], statusCode));
                    else onFail(new (0, $4SjAP.MutationError)(mutationError ?? {
                        message: message
                    }));
                    (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
                        task: 'linkRelationshipTypeUpdate',
                        errorMessage: message,
                        errorType: mutationError?.extensions?.errorType,
                        statusCode: statusCode,
                        linkedWorkItemId: issueId
                    });
                }
            },
            onError (error) {
                (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
                    task: 'linkRelationshipTypeUpdate',
                    errorMessage: error?.message ?? 'Failed to update issue link relationship type field',
                    linkedWorkItemId: issueId
                });
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateIssueLinkRelationshipTypeField: {
                        success: true,
                        errors: null,
                        field: {
                            id: currentIssueFieldARI,
                            issueLink: {
                                id: currentIssueLinkARI,
                                direction: nextDirection,
                                relationName: nextRelationName,
                                type: {
                                    id: nextIssueLinkTypeARI
                                }
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        currentIssueFieldARI,
        currentIssueLinkARI,
        createAnalyticsEvent,
        issueId
    ]);
    const fieldId = data?.fieldId;
    const setAnalyticsAttributes = (0, $eJOHy.useCallback)((value)=>{
        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, `${initialValue?.value}_${initialValue?.direction}`, `${value?.value}_${value?.direction}`);
    }, [
        fieldId,
        initialValue
    ]);
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleEdit: handleEdit, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        fieldId: data?.fieldId,
        fieldName: data?.name,
        fieldType: data?.type,
        initialValue: initialValue,
        updatedValue: selectedOption,
        isValueEqual: $ed193198e4107b6f$var$isEqualValue,
        clipboardComponentType: undefined,
        onSubmit: handleSubmit,
        onUpdateValue: setSelectedOption,
        setAnalyticsAttributes: setAnalyticsAttributes
    });
    const handleUnlinkSuccess = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        showFlag({
            id: (0, $jn1Cb.toFlagId)('unlink-success'),
            type: 'success',
            messageId: 'issue-field-link-relationship-inline-edit-full.ui.show-flag.success.issue-cells.link-relationship-type.show-flag.success.unlink-success',
            messageType: 'transactional',
            title: formatMessage((0, $jYDsp.default).unlinkSuccessTitle, {
                workType: workType,
                issueKey: issueKey
            }),
            isAutoDismiss: true,
            actions: [
                {
                    content: formatMessage((0, $jYDsp.default).viewCta),
                    href: issueData?.isRemoteIssue ? issueData?.webUrl ?? '' : `/browse/${issueKey}`,
                    target: issueData?.isRemoteIssue ? '_blank' : undefined
                }
            ]
        });
        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd(data?.type, {
            analytics: analyticsEvent,
            attributes: {
                fieldType: data?.type,
                actionTaken: 'remove',
                issueId: issueId
            }
        }, false);
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'ui taskSuccess', {
            task: 'linkRelationshipTypeUnlink',
            linkedWorkItemId: issueId
        });
        onIssueUnlink?.(issueKey);
    }, [
        issueKey,
        showFlag,
        formatMessage,
        onIssueUnlink,
        data?.type,
        issueId,
        issueData?.isRemoteIssue,
        issueData?.webUrl,
        workType
    ]);
    const handleUnlinkError = (0, $eJOHy.useCallback)((error, analyticsEvent)=>{
        showFlag({
            id: (0, $jn1Cb.toFlagId)('unlink-error'),
            type: 'error',
            messageId: 'issue-field-link-relationship-inline-edit-full.ui.show-flag.error.issue-cells.link-relationship-type.show-flag.error.unlink-error',
            messageType: 'transactional',
            title: formatMessage((0, $jYDsp.default).unlinkErrorTitle, {
                workType: workType.toLowerCase(),
                issueKey: issueKey
            }),
            description: formatMessage((0, $jYDsp.default).unlinkErrorDescription),
            isAutoDismiss: true,
            actions: [
                {
                    content: formatMessage((0, $jYDsp.default).refreshCta),
                    onClick: ()=>globalThis.location.reload()
                }
            ]
        });
        let attributes = {
            errorMessage: error?.message ?? 'Failed to unlink work item',
            linkedWorkItemId: issueId
        };
        if ($ed193198e4107b6f$var$isMutationErrorPayload(error)) attributes = {
            ...attributes,
            statusCode: error.extensions?.statusCode,
            errorType: error.extensions?.errorType
        };
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'ui taskFail', {
            task: 'linkRelationshipTypeUnlink',
            ...attributes
        });
    }, [
        showFlag,
        formatMessage,
        workType,
        issueKey,
        issueId
    ]);
    const handleUnlinkSubmit = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        setShowUnlinkConfirmation(false);
        commit({
            variables: {
                input: {
                    id: currentIssueFieldARI,
                    operation: {
                        operation: 'SET',
                        update: {
                            issueLinkId: currentIssueLinkARI,
                            issueLinkTypeId: null
                        }
                    }
                }
            },
            optimisticUpdater: (store)=>{
                // Optimistically remove the issue row from the table using ConnectionHandler
                // This follows the same pattern as the hide done functionality
                if (itemsConnectionId && issueStoreId) {
                    const connectionRecord = store.get(itemsConnectionId);
                    if (connectionRecord) (0, $j4oe4.ConnectionHandler).deleteNode(connectionRecord, issueStoreId);
                }
            },
            updater: (store)=>{
                // Ensure the row stays removed after the server response
                // This prevents the server response from re-adding the row
                if (itemsConnectionId && issueStoreId) {
                    const connectionRecord = store.get(itemsConnectionId);
                    if (connectionRecord) {
                        // Check if the node still exists in the connection
                        const edges = connectionRecord.getLinkedRecords('edges');
                        const nodeExists = edges?.some((edge)=>{
                            const node = edge?.getLinkedRecord('node');
                            return node?.getDataID() === issueStoreId;
                        });
                        // If the node was re-added by the server response, remove it again
                        if (nodeExists) (0, $j4oe4.ConnectionHandler).deleteNode(connectionRecord, issueStoreId);
                    }
                }
            },
            onCompleted: (mutationData)=>{
                const mutationResponse = mutationData?.jira?.updateIssueLinkRelationshipTypeField;
                if (mutationResponse?.success) handleUnlinkSuccess(analyticsEvent);
                else {
                    const mutationError = mutationResponse?.errors?.[0];
                    handleUnlinkError(mutationError, analyticsEvent);
                }
            },
            onError: (error)=>handleUnlinkError(error, analyticsEvent)
        });
    }, [
        commit,
        currentIssueFieldARI,
        currentIssueLinkARI,
        handleUnlinkSuccess,
        handleUnlinkError,
        issueStoreId,
        itemsConnectionId
    ]);
    const handleUnlinkCancel = (0, $eJOHy.useCallback)(()=>{
        setShowUnlinkConfirmation(false);
    }, []);
    const handleUnlink = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        handleCancel(analyticsEvent);
        setShowUnlinkConfirmation(true);
    }, [
        handleCancel
    ]);
    const getEditViewProps = (0, $eJOHy.useCallback)((fieldProps)=>({
            ...fieldProps,
            selectedOption: selectedOption,
            isDisabled: !isEditable,
            onChange: (value)=>{
                handleChangeAndConfirm(value);
            },
            onUnlink: handleUnlink
        }), [
        handleChangeAndConfirm,
        handleUnlink,
        isEditable,
        selectedOption
    ]);
    const readView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hi2yk.LinkRelationshipTypeReadView), {
            fieldRef: data
        }), [
        data
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $iCRih.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: data?.name,
        isEditable: isEditable,
        readView: readView,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        hasUnsubmittedChanges: hasServerValidationError,
        onEdit: handleEdit,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        readViewFitContainerHeight: true,
        hideActionButtons: true
    }), showUnlinkConfirmation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gomlP.default), {
        issueKey: issueKey,
        issueId: issueId,
        workType: workType,
        onUnlinkCancel: handleUnlinkCancel,
        onUnlinkSubmit: handleUnlinkSubmit
    }))));
});

});
parcelRegister("cRYxM", function(module, exports) {
$parcel$export(module.exports, "default", () => $eaaaa320439dfd57$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<45b13792c2a67860a1a3f255ca096a9c>>
 * @relayHash 7d884945e43cd762b79a25b956abcba1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b658d4873910d5690188b027f1f6dfa9f5b1a72e5b60a83978f900e51e0a7d29
const $eaaaa320439dfd57$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = {
        "concreteType": "JiraIssueLinkRelationshipTypeField",
        "kind": "LinkedField",
        "name": "field",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "concreteType": "JiraIssueLink",
                "kind": "LinkedField",
                "name": "issueLink",
                "plural": false,
                "selections": [
                    v6 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "direction"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "relationName"
                    },
                    {
                        "concreteType": "JiraIssueLinkType",
                        "kind": "LinkedField",
                        "name": "type",
                        "plural": false,
                        "selections": v7 /*: any*/ 
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateIssueLinkRelationshipTypeFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateIssueLinkRelationshipTypeField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateIssueLinkRelationshipTypeFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateIssueLinkRelationshipTypeField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v7 /*: any*/ ,
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b658d4873910d5690188b027f1f6dfa9f5b1a72e5b60a83978f900e51e0a7d29",
            "metadata": {},
            "name": "ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$eaaaa320439dfd57$var$node.hash = "2f0a2d2138cd528cd40ded3dce91df75";
var $eaaaa320439dfd57$export$2e2bcd8739ae039 = $eaaaa320439dfd57$var$node;

});

parcelRegister("eOpmb", function(module, exports) {
$parcel$export(module.exports, "default", () => $788d2305675af529$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39890d294c755583b46f2182f49c048e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $788d2305675af529$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_fieldRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "JiraIssueLink",
                "kind": "LinkedField",
                "name": "issueLink",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "direction"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "relationName"
                    },
                    {
                        "concreteType": "JiraIssueLinkType",
                        "kind": "LinkedField",
                        "name": "type",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_IssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView"
            }
        ],
        "type": "JiraIssueLinkRelationshipTypeField"
    };
}();
$788d2305675af529$var$node.hash = "9cfdc8201ada4d220c4623a0703ec8fb";
var $788d2305675af529$export$2e2bcd8739ae039 = $788d2305675af529$var$node;

});

parcelRegister("6hOU2", function(module, exports) {
$parcel$export(module.exports, "default", () => $c50c788350d9a681$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8a9aec33ad138a8cebd529d62e2a01eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c50c788350d9a681$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_issueRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "issueId"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "isRemoteIssue"
        },
        {
            "kind": "ScalarField",
            "name": "webUrl"
        },
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueType",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$c50c788350d9a681$var$node.hash = "5ff93c29f4e7ae110de337bc54ea1e6e";
var $c50c788350d9a681$export$2e2bcd8739ae039 = $c50c788350d9a681$var$node;

});

parcelRegister("iCRih", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b0df9380b4d471a$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $0b0df9380b4d471a$var$RelationshipTypeEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("88Ck3")), {
        moduleId: "dd9f033e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $0b0df9380b4d471a$export$2e2bcd8739ae039 = $0b0df9380b4d471a$var$RelationshipTypeEditViewEntryPoint;

});
parcelRegister("88Ck3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5Wleb").then(()=>parcelRequire('b7081'));

});


parcelRegister("hi2yk", function(module, exports) {
$parcel$export(module.exports, "LinkRelationshipTypeReadView", () => $c60daa2bf4da7ff9$export$2a5ee9588693f44d);

var $6JaSD = parcelRequire("6JaSD");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $d9T1A = parcelRequire("d9T1A");
const $c60daa2bf4da7ff9$export$2a5ee9588693f44d = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $6JaSD.default), fieldRef);
    const relationName = data?.issueLink?.relationName;
    if (!relationName) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        testId: "issue-field-link-relationship-readview-full.ui.text"
    }, relationName);
});

});
parcelRegister("6JaSD", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d92a0f97d63706d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<acf7e55b7b68ea87267b36d7a8a42c0e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6d92a0f97d63706d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_IssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView",
    "selections": [
        {
            "concreteType": "JiraIssueLink",
            "kind": "LinkedField",
            "name": "issueLink",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "relationName"
                }
            ]
        }
    ],
    "type": "JiraIssueLinkRelationshipTypeField"
};
$6d92a0f97d63706d$var$node.hash = "99eeee1e19009209c4cbc431eef50271";
var $6d92a0f97d63706d$export$2e2bcd8739ae039 = $6d92a0f97d63706d$var$node;

});


parcelRegister("8gALd", function(module, exports) {
$parcel$export(module.exports, "createSelectedOptionFromFieldData", () => $867b869f881dd328$export$48295089bb76e387);
const $867b869f881dd328$export$48295089bb76e387 = (issueLinkData)=>{
    const { issueLinkTypeARI: issueLinkTypeARI, relationName: relationName, direction: direction } = issueLinkData || {};
    if (!issueLinkTypeARI || !relationName || !direction) return null;
    return {
        id: `${issueLinkTypeARI}_${direction}`,
        value: issueLinkTypeARI,
        label: relationName,
        direction: direction
    };
};

});

parcelRegister("jYDsp", function(module, exports) {
$parcel$export(module.exports, "default", () => $a44f012b27cbb718$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a44f012b27cbb718$var$messages = (0, $7qGN1.defineMessages)({
    unlinkConfirmationModalTitle: {
        "id": "issue-field-link-relationship-inline-edit-full.unlink-confirmation-modal-title",
        "defaultMessage": "Unlink {workType} {issueKey} from this work item."
    },
    unlinkConfirmationCancelButton: {
        "id": "issue-field-link-relationship-inline-edit-full.unlink-confirmation-cancel-button",
        "defaultMessage": "Cancel"
    },
    unlinkConfirmationConfirmButton: {
        "id": "issue-field-link-relationship-inline-edit-full.unlink-confirmation-confirm-button",
        "defaultMessage": "Unlink"
    },
    unlinkSuccessTitle: {
        "id": "issue-field-link-relationship-inline-edit-full.unlink-success-title",
        "defaultMessage": "{workType} {issueKey} has been unlinked from this work item."
    },
    viewCta: {
        "id": "issue-field-link-relationship-inline-edit-full.view-cta",
        "defaultMessage": "View"
    },
    unlinkErrorTitle: {
        "id": "issue-field-link-relationship-inline-edit-full.unlink-error-title",
        "defaultMessage": "We can't unlink {workType} {issueKey}"
    },
    unlinkErrorDescription: {
        "id": "issue-field-link-relationship-inline-edit-full.unlink-error-description",
        "defaultMessage": "Refresh the page and try again."
    },
    refreshCta: {
        "id": "issue-field-link-relationship-inline-edit-full.refresh-cta",
        "defaultMessage": "Refresh"
    }
});
var $a44f012b27cbb718$export$2e2bcd8739ae039 = $a44f012b27cbb718$var$messages;

});

parcelRegister("gomlP", function(module, exports) {
$parcel$export(module.exports, "default", () => $21038cce3e13c989$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $48q59 = parcelRequire("48q59");
var $goZPP = parcelRequire("goZPP");

var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $lJKII = parcelRequire("lJKII");

var $lRq8t = parcelRequire("lRq8t");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");

var $jYDsp = parcelRequire("jYDsp");
const $21038cce3e13c989$var$ConfirmationDialog = ({ issueKey: issueKey, issueId: issueId, workType: workType, onUnlinkCancel: onUnlinkCancel, onUnlinkSubmit: onUnlinkSubmit })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleUnlinkSubmit = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'unlinkConfirmation', {
            issueId: issueId
        });
        onUnlinkSubmit(analyticsEvent);
    }, [
        onUnlinkSubmit,
        issueId
    ]);
    const handleUnlinkCancel = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'unlinkCancel', {
            issueId: issueId
        });
        onUnlinkCancel();
    }, [
        onUnlinkCancel,
        issueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "removeLinkedIssue",
        sourceType: (0, $aa42ce8e355d58fa$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
        messageId: "issue-field-link-relationship-inline-edit-full.ui.confirmation-dialog.modal-dialog.unlink-confirmation.modal-dialog",
        messageType: "transactional",
        onClose: onUnlinkCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "warning"
    }, formatMessage((0, $jYDsp.default).unlinkConfirmationModalTitle, {
        issueKey: issueKey,
        workType: workType.toLowerCase()
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        onClick: handleUnlinkCancel
    }, formatMessage((0, $jYDsp.default).unlinkConfirmationCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "warning",
        onClick: handleUnlinkSubmit
    }, formatMessage((0, $jYDsp.default).unlinkConfirmationConfirmButton))))));
};
var $21038cce3e13c989$export$2e2bcd8739ae039 = $21038cce3e13c989$var$ConfirmationDialog;

});



parcelRegister("jQO5F", function(module, exports) {
$parcel$export(module.exports, "useCellsConditionalFormatting", () => $f44df94406f27c19$export$22d9e69227bc5741);

var $9yAnF = parcelRequire("9yAnF");

var $acX6B = parcelRequire("acX6B");

var $94MIl = parcelRequire("94MIl");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kQ82p = parcelRequire("kQ82p");

var $5d1YD = parcelRequire("5d1YD");

var $4cTDP = parcelRequire("4cTDP");

var $jUTKf = parcelRequire("jUTKf");

var $34oCh = parcelRequire("34oCh");
const $f44df94406f27c19$var$emptyObject = {};
const $f44df94406f27c19$export$22d9e69227bc5741 = (project, fieldSets, savedViewFormattingRules)=>{
    const isConditionalFormattingEnabled = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4cTDP.fg)('jira_list_conditional_formatting') && (0, $34oCh.useIsConditionalFormattingEnabled)();
    const isSavedViewConditionalFormattingEnabled = (0, $4cTDP.fg)('saved_list_view_technical_changes') && isConditionalFormattingEnabled;
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks
    const fields = (0, $j4oe4.useFragment)((0, $94MIl.default), isConditionalFormattingEnabled ? fieldSets : null);
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks
    const rulesOld = (0, $j4oe4.useFragment)((0, $acX6B.default), isConditionalFormattingEnabled ? project ?? null : null);
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks
    const rulesNew = (0, $j4oe4.useFragment)((0, $9yAnF.default), isSavedViewConditionalFormattingEnabled ? savedViewFormattingRules : null);
    const rules = isSavedViewConditionalFormattingEnabled ? rulesNew : rulesOld?.conditionalFormattingRules;
    const valuesByFieldId = (0, $eJOHy.useMemo)(()=>{
        if (!isConditionalFormattingEnabled) return null;
        if (rules?.edges == null || rules?.edges.length === 0) return null;
        if (fields?.edges == null || fields?.edges?.length === 0) return null;
        const localMap = new Map();
        fields.edges.forEach((fieldSet)=>fieldSet?.node?.fields?.edges?.forEach((fieldEdge)=>{
                const field = fieldEdge?.node;
                switch(field?.__typename){
                    case 'JiraSingleLineTextField':
                        localMap.set(field.fieldId, field.text);
                        break;
                    case 'JiraLabelsField':
                        {
                            const names = field.selectedLabelsConnection?.edges?.map((edge)=>edge?.node?.name).filter((name)=>name != null) ?? [];
                            localMap.set(field.fieldId, names);
                            break;
                        }
                    case 'JiraComponentsField':
                        {
                            const ids = field.selectedComponentsConnection?.edges?.map((edge)=>edge?.node?.componentId).filter((componentId)=>componentId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraSingleSelectUserPickerField':
                        localMap.set(field.fieldId, field.user?.accountId ?? 'UNASSIGNED');
                        break;
                    case 'JiraDatePickerField':
                        {
                            const parsedDate = field.date ? (0, $kQ82p.default)(field.date) : undefined;
                            localMap.set(field.fieldId, parsedDate);
                            break;
                        }
                    case 'JiraDateTimePickerField':
                        {
                            const parsedDate = field.dateTime ? (0, $kQ82p.default)(field.dateTime) : undefined;
                            localMap.set(field.fieldId, parsedDate);
                            break;
                        }
                    case 'JiraNumberField':
                        localMap.set(field.fieldId, field.number);
                        break;
                    case 'JiraPriorityField':
                        localMap.set(field.fieldId, field.priority?.priorityId);
                        break;
                    case 'JiraProjectField':
                        localMap.set(field.fieldId, field.project?.projectId);
                        break;
                    case 'JiraSingleVersionPickerField':
                        localMap.set(field.fieldId, field.version?.versionId);
                        break;
                    case 'JiraIssueTypeField':
                        localMap.set(field.fieldId, field.issueType?.issueTypeId);
                        break;
                    case 'JiraStatusField':
                        localMap.set(field.fieldId, field.status?.statusId);
                        break;
                    case 'JiraMultipleSelectUserPickerField':
                        {
                            const ids = field.selectedUsersConnection?.edges?.map((edge)=>edge?.node?.accountId).filter((componentId)=>componentId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraSprintField':
                        {
                            const ids = field.selectedSprintsConnection?.edges?.map((edge)=>edge?.node?.sprintId).filter((sprintId)=>sprintId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraMultipleVersionPickerField':
                        {
                            const ids = field.selectedVersionsConnection?.edges?.map((edge)=>edge?.node?.versionId).filter((versionId)=>versionId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraSingleSelectField':
                        localMap.set(field.fieldId, field.selectedValue?.id);
                        break;
                    case 'JiraMultipleSelectField':
                        {
                            const ids = field.selectedValues?.edges?.map((edge)=>edge?.node?.id).filter((selectedValueId)=>selectedValueId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraRadioSelectField':
                        localMap.set(field.fieldId, field.selectedOption?.label);
                        break;
                    // TODO: Add all supported types value mapping
                    default:
                        break;
                }
            }));
        return localMap;
    }, [
        fields,
        isConditionalFormattingEnabled,
        rules
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        if (!isConditionalFormattingEnabled) return $f44df94406f27c19$var$emptyObject;
        /*
    	Evaluate all rules.
    	Get all rules before first row rule that's active.
    	groupBy fieldId first rule that is active for that fieldId.  {[fieldId]: {value, hoverValue}}
    */ const formattingRules = rules?.edges;
        if (!formattingRules || formattingRules.length === 0 || fields?.edges == null || fields?.edges.length === 0) return $f44df94406f27c19$var$emptyObject;
        if (valuesByFieldId == null) return $f44df94406f27c19$var$emptyObject;
        let hasActiveRowRule = false;
        const fieldWithActiveRule = new Set();
        const evaluatedRules = Object.fromEntries(formattingRules.map((rule, index)=>{
            if (hasActiveRowRule) // We dont want to evaluate more rules when
            // an active Row rule exists
            return null;
            const expression = rule?.node?.expression;
            const fieldId = expression?.fieldId;
            const value = expression?.value ?? expression?.values;
            const formattingArea = rule?.node?.formattingArea;
            const operator = expression?.noValueOperator ?? expression?.singleValueOperator ?? expression?.multipleValueOperator;
            if (!fieldId || !operator || formattingArea === 'CELL' && fieldWithActiveRule.has(fieldId)) // FieldId and Operator are mandatory for evaluation
            // First rule per fieldId will be used anything else should not be evaluated
            return null;
            const fieldValue = valuesByFieldId.get(fieldId);
            const active = (0, $5d1YD.evaluateRule)(operator, fieldValue, value);
            if (!active) return null;
            if (formattingArea === 'ROW') {
                hasActiveRowRule = true;
                return null;
            }
            fieldWithActiveRule.add(fieldId);
            return [
                fieldId,
                {
                    index: index,
                    id: fieldId,
                    color: (0, $jUTKf.formattingColors)[rule?.node?.formattingColor?.colorKey ?? ''],
                    type: 'CELL'
                }
            ];
        }).filter((maybeRule)=>maybeRule != null));
        return Object.fromEntries(fields.edges.map((fieldSetEdge)=>{
            const fieldSet = fieldSetEdge?.node;
            if (fieldSet?.fieldSetId == null) return null;
            let rule;
            fieldSet.fields?.edges?.forEach((fieldEdge)=>{
                if (fieldEdge?.node == null) return;
                const maybeRule = evaluatedRules[fieldEdge.node.fieldId];
                if (maybeRule != null && maybeRule.index < (rule?.index ?? Infinity)) rule = maybeRule;
                return null;
            });
            if (rule?.color == null) return null;
            return [
                fieldSet.fieldSetId,
                {
                    ...rule.color,
                    index: rule.index
                }
            ];
        }).filter((maybeRule)=>maybeRule != null));
    }, [
        isConditionalFormattingEnabled,
        rules,
        fields,
        valuesByFieldId
    ]);
};

});
parcelRegister("9yAnF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e624303d86da6edc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<647de14796a034c2309ff08d7ed0b996>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e624303d86da6edc$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useCellsConditionalFormatting_savedView_rules",
        "selections": [
            {
                "concreteType": "JiraFormattingRuleEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraFormattingRule",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "expression",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "alias": "singleValueOperator",
                                                "kind": "ScalarField",
                                                "name": "operator"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "value"
                                            }
                                        ],
                                        "type": "JiraFormattingSingleValueOperand"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "alias": "multipleValueOperator",
                                                "kind": "ScalarField",
                                                "name": "operator"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "values"
                                            }
                                        ],
                                        "type": "JiraFormattingMultipleValueOperand"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "alias": "noValueOperator",
                                                "kind": "ScalarField",
                                                "name": "operator"
                                            }
                                        ],
                                        "type": "JiraFormattingNoValueOperand"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "formattingArea"
                            },
                            {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "formattingColor",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "colorKey"
                                    }
                                ]
                            },
                            v1 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraFormattingRuleConnection"
    };
}();
$e624303d86da6edc$var$node.hash = "579376b5624a74e7adccc6df7f4fbfe4";
var $e624303d86da6edc$export$2e2bcd8739ae039 = $e624303d86da6edc$var$node;

});

parcelRegister("acX6B", function(module, exports) {
$parcel$export(module.exports, "default", () => $4773b3bf6bee09ba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ff32447f6f6a3d7dbbd91560065dad22>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4773b3bf6bee09ba$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useCellsConditionalFormatting_rules",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 20
                    }
                ],
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "expression",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "singleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    }
                                                ],
                                                "type": "JiraFormattingSingleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "multipleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "values"
                                                    }
                                                ],
                                                "type": "JiraFormattingMultipleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "noValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    }
                                                ],
                                                "type": "JiraFormattingNoValueOperand"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "formattingArea"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "formattingColor",
                                        "plural": false,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            }
                                        ]
                                    },
                                    v1 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "conditionalFormattingRules(first:20)"
            }
        ],
        "type": "JiraProject"
    };
}();
$4773b3bf6bee09ba$var$node.hash = "4ad11db40961c16bb414c671329a0ed5";
var $4773b3bf6bee09ba$export$2e2bcd8739ae039 = $4773b3bf6bee09ba$var$node;

});

parcelRegister("94MIl", function(module, exports) {
$parcel$export(module.exports, "default", () => $a272eb8dc36081dd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fea2d740ce5705e2b312a4fcfe696611>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a272eb8dc36081dd$var$node = function() {
    var v0 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "versionId"
        }
    ], v4 = [
        v2 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useCellsConditionalFormatting",
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "fieldSetId"
                            },
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fieldId"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "text"
                                                            }
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v0 /*: any*/ ,
                                                                "concreteType": "JiraComponentConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedComponentsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraComponentEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraComponent",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "componentId"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedComponentsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraComponentsField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v0 /*: any*/ ,
                                                                "concreteType": "JiraLabelConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedLabelsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraLabelEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraLabel",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "name"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedLabelsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraLabelsField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    v2 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraUserConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedUsersConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraUserEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v1 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraMultipleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "date"
                                                            }
                                                        ],
                                                        "type": "JiraDatePickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "dateTime"
                                                            }
                                                        ],
                                                        "type": "JiraDateTimePickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "number"
                                                            }
                                                        ],
                                                        "type": "JiraNumberField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraPriority",
                                                                "kind": "LinkedField",
                                                                "name": "priority",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "priorityId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraPriorityField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraProject",
                                                                "kind": "LinkedField",
                                                                "name": "project",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "projectId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraProjectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraSprintConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedSprintsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSprintEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSprint",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "sprintId"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSprintField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraVersion",
                                                                "kind": "LinkedField",
                                                                "name": "version",
                                                                "plural": false,
                                                                "selections": v3 /*: any*/ 
                                                            }
                                                        ],
                                                        "type": "JiraSingleVersionPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v0 /*: any*/ ,
                                                                "concreteType": "JiraVersionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedVersionsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraVersionEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraVersion",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": v3 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedVersionsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraMultipleVersionPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "selectedValue",
                                                                "plural": false,
                                                                "selections": v4 /*: any*/ 
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraSelectableValueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedValues",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSelectableValueEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": v4 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraMultipleSelectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOption",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOption",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "alias": "label",
                                                                        "kind": "ScalarField",
                                                                        "name": "value"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraRadioSelectField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$a272eb8dc36081dd$var$node.hash = "2151ef0116104b28f71c46bfce531ce1";
var $a272eb8dc36081dd$export$2e2bcd8739ae039 = $a272eb8dc36081dd$var$node;

});

parcelRegister("5d1YD", function(module, exports) {
$parcel$export(module.exports, "evaluateRule", () => $8e832ab75969f901$export$6b882d50951f579a);

var $dGJCK = parcelRequire("dGJCK");
var $cNTKl = parcelRequire("cNTKl");
var $3bI3H = parcelRequire("3bI3H");
var $ibLUB = parcelRequire("ibLUB");
var $bf0oy = parcelRequire("bf0oy");
var $lncFc = parcelRequire("lncFc");
var $37UhW = parcelRequire("37UhW");
var $bODPS = parcelRequire("bODPS");
var $i6NVB = parcelRequire("i6NVB");
var $dBLX0 = parcelRequire("dBLX0");
var $dSLL3 = parcelRequire("dSLL3");
var $kQ82p = parcelRequire("kQ82p");
var $lTtQZ = parcelRequire("lTtQZ");
var $hwbrf = parcelRequire("hwbrf");
var $dy6Fq = parcelRequire("dy6Fq");

var $9iBuw = parcelRequire("9iBuw");
const $8e832ab75969f901$var$evaluateRuleNoValue = (operator, fieldValue)=>{
    if (Array.isArray(fieldValue)) switch(operator){
        case 'IS_EMPTY':
            return fieldValue.length === 0;
        case 'IS_NOT_EMPTY':
            return fieldValue.length > 0;
        default:
            return false;
    }
    switch(operator){
        case 'IS_EMPTY':
            return fieldValue === 0 ? false : !fieldValue;
        case 'IS_NOT_EMPTY':
            return fieldValue === 0 ? true : Boolean(fieldValue);
        default:
            return false;
    }
};
const $8e832ab75969f901$var$ruleSingleValueStringOperations = {
    CONTAINS: (fieldValue, ruleValue)=>{
        if (Array.isArray(fieldValue)) return fieldValue.some((value)=>{
            if (value == null) return false;
            if ((0, $9iBuw.isNumber)(value)) return value === Number(ruleValue);
            if ((0, $9iBuw.isString)(value)) return value.includes(ruleValue);
            return false;
        });
        return fieldValue.includes(ruleValue);
    }
};
const $8e832ab75969f901$var$ruleSingleValueOperations = {
    EQUALS: (fieldValue, ruleValue)=>{
        return Boolean(fieldValue && String(fieldValue) === ruleValue);
    }
};
const $8e832ab75969f901$var$ruleSingleValueNumberOperations = {
    GREATER_THAN: (fieldValue, ruleValue)=>{
        return fieldValue > Number(ruleValue);
    }
};
const $8e832ab75969f901$var$dateRuleValueEvaluators = {
    IS: (fieldValue, ruleValue)=>{
        switch(ruleValue){
            case 'TODAY':
                return (0, $bODPS.default)(fieldValue);
            case 'TOMORROW':
                return (0, $i6NVB.default)(fieldValue);
            case 'YESTERDAY':
                return (0, $dSLL3.default)(fieldValue);
            case 'THIS_WEEK':
                return (0, $37UhW.default)(fieldValue);
            case 'LAST_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) === -1;
            case 'NEXT_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) === 1;
            case 'THIS_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) === 0;
            case 'LAST_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) === -1;
            case 'NEXT_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) === 1;
            case 'THIS_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) === 0;
            case 'LAST_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) === -1;
            case 'NEXT_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) === 1;
            default:
                {
                    const dateValue = (0, $kQ82p.default)(ruleValue);
                    if ((0, $dBLX0.default)(dateValue)) return (0, $lncFc.default)(dateValue, fieldValue);
                    return false;
                }
        }
    },
    IS_AFTER: (fieldValue, ruleValue)=>{
        switch(ruleValue){
            case 'TODAY':
                return (0, $ibLUB.default)(fieldValue, (0, $lTtQZ.default)());
            case 'TOMORROW':
                return (0, $ibLUB.default)(fieldValue, (0, $hwbrf.default)());
            case 'YESTERDAY':
                return (0, $ibLUB.default)(fieldValue, (0, $dy6Fq.default)());
            case 'THIS_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) > 0;
            case 'LAST_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) >= 0;
            case 'NEXT_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) > 1;
            case 'THIS_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) > 0;
            case 'LAST_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) >= 0;
            case 'NEXT_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) > 1;
            case 'THIS_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) > 0;
            case 'LAST_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) >= 0;
            case 'NEXT_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) > 1;
            default:
                {
                    const dateValue = (0, $kQ82p.default)(ruleValue);
                    if ((0, $dBLX0.default)(dateValue)) return (0, $ibLUB.default)(fieldValue, dateValue);
                    return false;
                }
        }
    },
    IS_BEFORE: (fieldValue, ruleValue)=>{
        switch(ruleValue){
            case 'TODAY':
                return (0, $bf0oy.default)(fieldValue, (0, $lTtQZ.default)());
            case 'TOMORROW':
                return (0, $bf0oy.default)(fieldValue, (0, $hwbrf.default)());
            case 'YESTERDAY':
                return (0, $bf0oy.default)(fieldValue, (0, $dy6Fq.default)());
            case 'THIS_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) < 0;
            case 'LAST_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) < -1;
            case 'NEXT_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) < 1;
            case 'THIS_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) < 0;
            case 'LAST_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) < -1;
            case 'NEXT_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) < 1;
            case 'THIS_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) < 0;
            case 'LAST_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) < -1;
            case 'NEXT_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) < 1;
            default:
                {
                    const dateValue = (0, $kQ82p.default)(ruleValue);
                    if ((0, $dBLX0.default)(dateValue)) return (0, $bf0oy.default)(fieldValue, dateValue);
                    return false;
                }
        }
    },
    IS_NOT: (field, value)=>!$8e832ab75969f901$var$dateRuleValueEvaluators.IS?.(field, value),
    IS_ON_OR_AFTER: (field, value)=>Boolean($8e832ab75969f901$var$dateRuleValueEvaluators.IS?.(field, value) || $8e832ab75969f901$var$dateRuleValueEvaluators.IS_AFTER?.(field, value)),
    IS_ON_OR_BEFORE: (field, value)=>Boolean($8e832ab75969f901$var$dateRuleValueEvaluators.IS?.(field, value) || $8e832ab75969f901$var$dateRuleValueEvaluators.IS_BEFORE?.(field, value))
};
const $8e832ab75969f901$var$evaluateRuleSingleValue = (operator, fieldValue, ruleValue)=>{
    if ((0, $9iBuw.isDateRuleOnlyOperator)(operator) && fieldValue instanceof Date) return $8e832ab75969f901$var$dateRuleValueEvaluators[operator](fieldValue, ruleValue) ?? false;
    // Operators that apply to all field value types
    switch(operator){
        case 'EQUALS':
            return $8e832ab75969f901$var$ruleSingleValueOperations.EQUALS(fieldValue, ruleValue);
        case 'DOES_NOT_EQUAL':
            return !$8e832ab75969f901$var$ruleSingleValueOperations.EQUALS(fieldValue, ruleValue);
        case 'IS':
            return fieldValue === ruleValue;
        case 'IS_NOT':
            return fieldValue !== ruleValue;
        default:
            break;
    }
    if (fieldValue == null) // All single value rule requires the field value to exist
    return false;
    if ((0, $9iBuw.isString)(fieldValue) || Array.isArray(fieldValue)) // Operators that does not apply to number or nullish fields
    switch(operator){
        case 'CONTAINS':
            return $8e832ab75969f901$var$ruleSingleValueStringOperations.CONTAINS(fieldValue, ruleValue);
        case 'DOES_NOT_CONTAIN':
            return !$8e832ab75969f901$var$ruleSingleValueStringOperations.CONTAINS(fieldValue, ruleValue);
        default:
            return false;
    }
    if ((0, $9iBuw.isNumber)(fieldValue)) switch(operator){
        // Only applies to number
        case 'GREATER_THAN':
            return $8e832ab75969f901$var$ruleSingleValueNumberOperations.GREATER_THAN(fieldValue, ruleValue) ?? false;
        case 'LESS_THAN':
            return !($8e832ab75969f901$var$ruleSingleValueNumberOperations.GREATER_THAN(fieldValue, ruleValue) ?? true) && !($8e832ab75969f901$var$ruleSingleValueOperations.EQUALS(fieldValue, ruleValue) ?? true);
        case 'GREATER_THAN_OR_EQUALS':
            return ($8e832ab75969f901$var$ruleSingleValueNumberOperations.GREATER_THAN(fieldValue, ruleValue) ?? false) || ($8e832ab75969f901$var$ruleSingleValueOperations.EQUALS(fieldValue, ruleValue) ?? false);
        case 'LESS_THAN_OR_EQUALS':
            return !($8e832ab75969f901$var$ruleSingleValueNumberOperations.GREATER_THAN(fieldValue, ruleValue) ?? true);
        default:
            break;
    }
    return false;
};
const $8e832ab75969f901$var$multipleValueOperatorSingleFieldValueEvaluators = {
    HAS_ANY_OF: (fieldValue, ruleValue)=>{
        if (fieldValue == null) return false;
        return ruleValue.includes(String(fieldValue));
    },
    // No valid rule single field value contains a multiple rule value
    CONTAINS: ()=>false,
    DOES_NOT_CONTAIN: ()=>false,
    // eslint-disable-next-line @atlassian/relay/no-future-added-value
    '%future added value': ()=>false
};
const $8e832ab75969f901$var$multipleValueOperatorEvaluators = {
    CONTAINS: (fieldValue, ruleValue)=>{
        return fieldValue.filter((fval)=>{
            return ruleValue.includes(String(fval));
        }).length === ruleValue.length;
    },
    DOES_NOT_CONTAIN: (...args)=>!$8e832ab75969f901$var$multipleValueOperatorEvaluators.CONTAINS(...args),
    HAS_ANY_OF: (fieldValue, ruleValue)=>{
        return fieldValue.some((fval)=>{
            return $8e832ab75969f901$var$multipleValueOperatorSingleFieldValueEvaluators.HAS_ANY_OF(fval, ruleValue);
        });
    },
    // eslint-disable-next-line @atlassian/relay/no-future-added-value
    '%future added value': ()=>false
};
const $8e832ab75969f901$var$evaluateRuleMultipleValue = (operator, fieldValue, ruleValue)=>{
    if (Array.isArray(fieldValue)) return $8e832ab75969f901$var$multipleValueOperatorEvaluators[operator](fieldValue, ruleValue);
    return $8e832ab75969f901$var$multipleValueOperatorSingleFieldValueEvaluators[operator](fieldValue, ruleValue);
};
const $8e832ab75969f901$export$6b882d50951f579a = (operator, fieldValue, ruleValue)=>{
    if (ruleValue === undefined) {
        if ((0, $9iBuw.isNoValueOperator)(operator)) return $8e832ab75969f901$var$evaluateRuleNoValue(operator, fieldValue);
        return false;
    }
    if (Array.isArray(ruleValue) && (0, $9iBuw.isMultipleValueOperator)(operator)) return $8e832ab75969f901$var$evaluateRuleMultipleValue(operator, fieldValue, ruleValue);
    if ((0, $9iBuw.isSingleValueOperator)(operator) && typeof ruleValue === 'string') return $8e832ab75969f901$var$evaluateRuleSingleValue(operator, fieldValue, ruleValue);
// We will need to handle this in the hook, and sent analytics event when missing.
// throw new Error('Unhandled format rule'); https://jbusiness.atlassian.net/browse/JSC-2764 Uncomment when error is properly handled
};

});
parcelRegister("9iBuw", function(module, exports) {
$parcel$export(module.exports, "isNoValueOperator", () => $04d6240c5de8c6c9$export$88b85e57ca1e3f4a);
$parcel$export(module.exports, "isSingleValueOperator", () => $04d6240c5de8c6c9$export$99197f1cc2c9c086);
$parcel$export(module.exports, "isDateRuleOnlyOperator", () => $04d6240c5de8c6c9$export$f0a7020d8f55379d);
$parcel$export(module.exports, "isMultipleValueOperator", () => $04d6240c5de8c6c9$export$71082e7c2ba7f454);
$parcel$export(module.exports, "isString", () => $04d6240c5de8c6c9$export$844ec244b1367d54);
$parcel$export(module.exports, "isNumber", () => $04d6240c5de8c6c9$export$7e4aa119212bc614);
const $04d6240c5de8c6c9$var$dateRuleValue = new Set([
    'EXACT_DATE',
    'LAST_QUARTER',
    'LAST_WEEK',
    'LAST_YEAR',
    'NEXT_QUARTER',
    'NEXT_WEEK',
    'NEXT_YEAR',
    'THIS_QUARTER',
    'THIS_WEEK',
    'THIS_YEAR',
    'TODAY',
    'TOMORROW',
    'YESTERDAY'
]);
const $04d6240c5de8c6c9$export$7a93007e84f4988d = (value)=>{
    return $04d6240c5de8c6c9$var$dateRuleValue.has(value);
};
const $04d6240c5de8c6c9$var$noValueOperators = new Set([
    'IS_EMPTY',
    'IS_NOT_EMPTY'
]);
const $04d6240c5de8c6c9$export$88b85e57ca1e3f4a = (operator)=>{
    return $04d6240c5de8c6c9$var$noValueOperators.has(operator);
};
const $04d6240c5de8c6c9$var$singleValueOperators = new Set([
    'CONTAINS',
    'DOES_NOT_CONTAIN',
    'DOES_NOT_EQUAL',
    'EQUALS',
    'GREATER_THAN',
    'GREATER_THAN_OR_EQUALS',
    'IS',
    'IS_AFTER',
    'IS_BEFORE',
    'IS_NOT',
    'IS_ON_OR_AFTER',
    'IS_ON_OR_BEFORE',
    'LESS_THAN',
    'LESS_THAN_OR_EQUALS'
]);
const $04d6240c5de8c6c9$export$99197f1cc2c9c086 = (operator)=>{
    return $04d6240c5de8c6c9$var$singleValueOperators.has(operator);
};
const $04d6240c5de8c6c9$var$dateRuleOnlyOperator = new Set([
    'IS',
    'IS_AFTER',
    'IS_BEFORE',
    'IS_NOT',
    'IS_ON_OR_AFTER',
    'IS_ON_OR_BEFORE'
]);
const $04d6240c5de8c6c9$export$f0a7020d8f55379d = (operator)=>{
    return $04d6240c5de8c6c9$var$dateRuleOnlyOperator.has(operator);
};
const $04d6240c5de8c6c9$var$multipleValueOperators = new Set([
    'CONTAINS',
    'DOES_NOT_CONTAIN',
    'HAS_ANY_OF',
    'IS_BETWEEN'
]);
const $04d6240c5de8c6c9$export$71082e7c2ba7f454 = (operator)=>{
    return $04d6240c5de8c6c9$var$multipleValueOperators.has(operator);
};
const $04d6240c5de8c6c9$export$844ec244b1367d54 = (maybeString)=>{
    return typeof maybeString === 'string';
};
const $04d6240c5de8c6c9$export$7e4aa119212bc614 = (maybeNumber)=>{
    return typeof maybeNumber === 'number';
};

});


parcelRegister("jUTKf", function(module, exports) {
$parcel$export(module.exports, "formattingColors", () => $c30971d2a738910c$export$2fedf4ac4eb04087);

var $LFmXM = parcelRequire("LFmXM");

var $5zzUt = parcelRequire("5zzUt");
const $c30971d2a738910c$export$2fedf4ac4eb04087 = {
    lightPurple: {
        label: (0, $5zzUt.default).lightPurple,
        value: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
        hoverValue: "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)"
    },
    lightBlue: {
        label: (0, $5zzUt.default).lightBlue,
        value: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
        hoverValue: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)"
    },
    lightGreen: {
        label: (0, $5zzUt.default).lightGreen,
        value: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        hoverValue: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)"
    },
    lightTeal: {
        label: (0, $5zzUt.default).lightTeal,
        value: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        hoverValue: "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)"
    },
    lightYellow: {
        label: (0, $5zzUt.default).lightYellow,
        value: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        hoverValue: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)"
    },
    lightRed: {
        label: (0, $5zzUt.default).lightRed,
        value: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        hoverValue: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)"
    },
    lightGray: {
        label: (0, $5zzUt.default).lightGray,
        value: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        hoverValue: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"
    },
    purple: {
        label: (0, $5zzUt.default).purple,
        value: "var(--ds-background-accent-purple-subtler, #EED7FC)",
        hoverValue: "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)"
    },
    blue: {
        label: (0, $5zzUt.default).blue,
        value: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        hoverValue: "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)"
    },
    green: {
        label: (0, $5zzUt.default).green,
        value: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        hoverValue: "var(--ds-background-accent-green-subtler-hovered, #97EDC9)"
    },
    teal: {
        label: (0, $5zzUt.default).teal,
        value: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        hoverValue: "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)"
    },
    yellow: {
        label: (0, $5zzUt.default).yellow,
        value: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        hoverValue: "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)"
    },
    red: {
        label: (0, $5zzUt.default).red,
        value: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        hoverValue: "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)"
    },
    gray: {
        label: (0, $5zzUt.default).gray,
        value: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
        hoverValue: "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)"
    }
};
const $c30971d2a738910c$export$a41cbf3b0b6192fa = (cssValue)=>{
    const match = cssValue.match(/var\((--[^,)]+)/);
    return match ? match[1] : cssValue;
};
const $c30971d2a738910c$export$ae7e938b8bdf2df5 = (0, $LFmXM.default)((value)=>{
    const inputVariableName = $c30971d2a738910c$export$a41cbf3b0b6192fa(value);
    const selectedColor = Object.entries($c30971d2a738910c$export$2fedf4ac4eb04087).find(([_, color])=>$c30971d2a738910c$export$a41cbf3b0b6192fa(color.value) === inputVariableName);
    return selectedColor?.[0];
});

});
parcelRegister("5zzUt", function(module, exports) {
$parcel$export(module.exports, "default", () => $37202181219e5e4d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $37202181219e5e4d$var$messages = (0, $7qGN1.defineMessages)({
    lightPurple: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-purple",
        "defaultMessage": "Subtle purple"
    },
    lightBlue: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-blue",
        "defaultMessage": "Subtle blue"
    },
    lightGreen: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-green",
        "defaultMessage": "Subtle green"
    },
    lightTeal: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-teal",
        "defaultMessage": "Subtle teal"
    },
    lightYellow: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-yellow",
        "defaultMessage": "Subtle yellow"
    },
    lightRed: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-red",
        "defaultMessage": "Subtle red"
    },
    lightGray: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-gray",
        "defaultMessage": "Subtle gray"
    },
    purple: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.purple",
        "defaultMessage": "Bold purple"
    },
    blue: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.blue",
        "defaultMessage": "Bold blue"
    },
    green: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.green",
        "defaultMessage": "Bold green"
    },
    teal: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.teal",
        "defaultMessage": "Bold teal"
    },
    yellow: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.yellow",
        "defaultMessage": "Bold yellow"
    },
    red: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.red",
        "defaultMessage": "Bold red"
    },
    gray: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.gray",
        "defaultMessage": "Bold gray"
    }
});
var $37202181219e5e4d$export$2e2bcd8739ae039 = $37202181219e5e4d$var$messages;

});



parcelRegister("cOqgG", function(module, exports) {
$parcel$export(module.exports, "default", () => $11224fa3afbf416f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $4cTDP = parcelRequire("4cTDP");

var $kGj4V = parcelRequire("kGj4V");

var $8jOO7 = parcelRequire("8jOO7");

var $86BUM = parcelRequire("86BUM");

var $bKlUQ = parcelRequire("bKlUQ");

var $dvCjO = parcelRequire("dvCjO");
const $11224fa3afbf416f$var$DefaultFallbackComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
const $11224fa3afbf416f$var$IssueRowCellErrorFallback = ({ type: type, border: border, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        border: border
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: type,
        reason: (0, $4cTDP.fg)('empanada_error_cell_logging') ? error : 'Unhandled error'
    }));
const $11224fa3afbf416f$var$IssueRowCell = ({ type: type, beforeElement: beforeElement, cellElement: cellElement, border: border, spacing: spacing, multipleFieldLayoutAdjustment: multipleFieldLayoutAdjustment, FallbackComponent: FallbackComponent = $11224fa3afbf416f$var$DefaultFallbackComponent, formatting: formatting, style: style, isColumnResizing: isColumnResizing, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, hasRightShadow: hasRightShadow, fieldId: fieldId, onFocusHandler: onFocusHandler, onBlurHandler: onBlurHandler, issueKey: issueKey, fieldName: fieldName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: {
            fieldType: type
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: (0, $8jOO7.PACKAGE_NAME),
        teamName: (0, $8jOO7.TEAM_NAME),
        id: "issueRowCellUnhandled",
        sendToPrivacyUnsafeSplunk: true,
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($11224fa3afbf416f$var$IssueRowCellErrorFallback, {
                type: type,
                border: border,
                error: error
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        spacing: spacing,
        border: border,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
            isColumnSticky: isColumnSticky,
            stickyOffsets: stickyOffsets,
            isColumnResizing: isColumnResizing,
            hasRightShadow: hasRightShadow
        },
        formatting: formatting,
        fieldId: fieldId,
        ...onFocusHandler && (0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') ? {
            onFocusHandler: onFocusHandler
        } : {},
        ...onBlurHandler && (0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') ? {
            onBlurHandler: onBlurHandler
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, beforeElement, Array.isArray(cellElement) && cellElement.length > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dvCjO.MultipleCellElements), {
        ...(0, $4cTDP.fg)('nin_duplicated_fields_info_a11y_fix') && {
            issueKey: issueKey,
            fieldName: fieldName
        },
        cellElements: cellElement,
        type: type,
        multipleFieldLayoutAdjustment: multipleFieldLayoutAdjustment
    }) : cellElement ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FallbackComponent, null)))));
var $11224fa3afbf416f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($11224fa3afbf416f$var$IssueRowCell);

});
parcelRegister("dvCjO", function(module, exports) {
$parcel$export(module.exports, "MultipleCellElements", () => $0dfcc569f582c593$export$4b5a1f36c48df9b0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $5PQOA = parcelRequire("5PQOA");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $2R0ne = parcelRequire("2R0ne");

var $Ay1uj = parcelRequire("Ay1uj");

var $lL4G9 = parcelRequire("lL4G9");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $ibVOD = parcelRequire("ibVOD");

var $9Mapt = parcelRequire("9Mapt");

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");

var $9LCGj = parcelRequire("9LCGj");
const $0dfcc569f582c593$export$1d1457a281374128 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((fieldType, numberOfElements, createAnalyticsEvent)=>{
    (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'tableCell multipleElementsRendered', {
        fieldType: fieldType,
        numberOfElements: numberOfElements
    });
});
const $0dfcc569f582c593$var$MoreFieldsContent = ({ elements: elements })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0dfcc569f582c593$var$moreFieldsHeaderRowStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        size: "medium",
        weight: "medium"
    }, formatMessage((0, $9LCGj.default).duplicateFieldsHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0dfcc569f582c593$var$moreFieldsDescriptionStyles
    }, formatMessage((0, $9LCGj.default).duplicateFieldsContent, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
                href: "/jira/settings/issues/fields",
                target: "_blank"
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("hr", {
        role: "presentation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0dfcc569f582c593$var$fieldsContainerStyles
    }, elements.map((element, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $0dfcc569f582c593$var$fieldStyles,
            key: idx
        }, element))));
};
const $0dfcc569f582c593$export$4b5a1f36c48df9b0 = ({ issueKey: issueKey, cellElements: cellElements, multipleFieldLayoutAdjustment: multipleFieldLayoutAdjustment = false, type: type, fieldName: fieldName })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    $0dfcc569f582c593$export$1d1457a281374128(type, cellElements.length, createAnalyticsEvent);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (multipleFieldLayoutAdjustment && cellElements.length > 0 && isSingleLineRowHeightEnabled) {
        const firstElement = cellElements[0];
        const rest = cellElements.slice(1);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $0dfcc569f582c593$var$rowStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                ...props,
                className: (0, $hcewu.default)([
                    "_1reo15vq _18m915vq _1bto1l2s",
                    "_4t3i1osq",
                    "_1bsb1osq"
                ])
            }, firstElement))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0dfcc569f582c593$var$MoreFieldsContent, {
                    elements: rest
                }),
                isInteractive: true,
                isFixedWidth: true,
                analyticsAttributes: {
                    duplicateField: true
                }
            }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                    ref: ref,
                    className: (0, $hcewu.default)([
                        "_2hwx1b66"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                    label: (0, $4cTDP.fg)('nin_duplicated_fields_info_a11y_fix') ? formatMessage((0, $9LCGj.default).duplicateFieldsInfoIconMessage, {
                        issueKey: issueKey ?? '',
                        fieldName: fieldName ?? ''
                    }) : '',
                    appearance: "subtle",
                    icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
                            ...iconProps,
                            color: "var(--ds-icon-information, #357DE8)"
                        }),
                    testId: "native-issue-table.ui.row.issue-row.cell.multiple-cell-elements.issue-table",
                    ...props
                }))))));
    }
    return multipleFieldLayoutAdjustment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0dfcc569f582c593$var$containerStyles
    }, cellElements.map((cellElement, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            key: index,
            xcss: $0dfcc569f582c593$var$elementContainerStyles
        }, cellElement))) : cellElements;
};
const $0dfcc569f582c593$var$rowStyle = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 'space.050',
    height: '100%'
});
const $0dfcc569f582c593$var$containerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 'space.050'
});
const $0dfcc569f582c593$var$elementContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: '32px'
});
const $0dfcc569f582c593$var$moreFieldsHeaderRowStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginBottom: 'space.050'
});
const $0dfcc569f582c593$var$moreFieldsDescriptionStyles = (0, $1DXK0.xcss)({
    font: 'font.body.medium'
});
const $0dfcc569f582c593$var$fieldsContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: 'space.050',
    width: '100%',
    height: '100%'
});
const $0dfcc569f582c593$var$fieldStyles = (0, $1DXK0.xcss)({
    height: '40px',
    width: '100%'
});
const $0dfcc569f582c593$var$contentStyles = null;
const $0dfcc569f582c593$var$buttonStyle = null;
const $0dfcc569f582c593$var$fillHeight = null;
const $0dfcc569f582c593$var$fillWidth = null;

});
parcelRegister("9LCGj", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce16bf62d775f359$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ce16bf62d775f359$var$messages = (0, $7qGN1.defineMessages)({
    duplicateFieldsHeader: {
        "id": "native-issue-table.duplicate-fields-header",
        "defaultMessage": "Duplicate fields"
    },
    duplicateFieldsContent: {
        "id": "native-issue-table.duplicate-fields-content",
        "defaultMessage": "<link>Configure fields</link> to remove duplicates"
    },
    duplicateFieldsInfoIconMessage: {
        "id": "native-issue-table.duplicate-fields-info-icon-message",
        "defaultMessage": "Duplicate fields info {issueKey} {fieldName}"
    }
});
var $ce16bf62d775f359$export$2e2bcd8739ae039 = $ce16bf62d775f359$var$messages;

});



parcelRegister("gToWi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b244ccc87c9091fc$export$2e2bcd8739ae039);

var $62ZYQ = parcelRequire("62ZYQ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2XtSM = parcelRequire("2XtSM");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $34oCh = parcelRequire("34oCh");

var $jNv5I = parcelRequire("jNv5I");
const $b244ccc87c9091fc$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "first-column-cell",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/**
 * @deprecated should be removed when jira_list_merged_column_gate is cleaned up
 */ const $b244ccc87c9091fc$var$FirstColumnCell = ({ isRowHoveredOrSelected: isRowHoveredOrSelected, itemsConnectionId: itemsConnectionId, depth: depth, issueRef: issueRef, triggerProps: triggerProps, isFormVisible: isFormVisible })=>{
    const issueData = (0, $j4oe4.useFragment)((0, $62ZYQ.default), issueRef);
    const { hasChildren: hasChildren, canHaveChildIssues: canHaveChildIssues } = issueData;
    const { issueId: issueId } = issueData.node ?? {};
    const { groupId: groupId } = (0, $jNv5I.useRowContext)();
    const isChildIssueCreateEnabled = (0, $34oCh.useIsChildIssueCreateEnabled)();
    const showCreateChildButton = isChildIssueCreateEnabled && isRowHoveredOrSelected && Boolean(canHaveChildIssues);
    return issueId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b244ccc87c9091fc$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2XtSM.ExpandButtonWithCreateChildButton), {
        itemId: issueId,
        itemsConnectionId: itemsConnectionId,
        depth: depth,
        hasChildren: Boolean(hasChildren),
        showCreateChildButton: showCreateChildButton,
        isRowHoveredOrSelected: isRowHoveredOrSelected,
        isCreateChildFormVisible: isFormVisible,
        createChildTriggerProps: triggerProps,
        groupId: groupId
    }));
};
var $b244ccc87c9091fc$export$2e2bcd8739ae039 = $b244ccc87c9091fc$var$FirstColumnCell;

});
parcelRegister("62ZYQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c2407ded474c888$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1bf3401344813a938315cca7608ff8fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6c2407ded474c888$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "FirstColumnCell",
    "selections": [
        {
            "condition": "shouldQueryHasChildren",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "filterByProjectKeys",
                            "variableName": "projectKeys"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "hasChildren"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canHaveChildIssues"
                }
            ]
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "issueId"
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$6c2407ded474c888$var$node.hash = "3cdfef30b98027986ca5f2832216e2e7";
var $6c2407ded474c888$export$2e2bcd8739ae039 = $6c2407ded474c888$var$node;

});


parcelRegister("4XMye", function(module, exports) {
$parcel$export(module.exports, "MergedCell", () => $b082cfc5b9e74dcc$export$91a9bd0bc931a6e5);

var $CoNRa = parcelRequire("CoNRa");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $dcLzM = parcelRequire("dcLzM");

var $2XtSM = parcelRequire("2XtSM");

var $bJscI = parcelRequire("bJscI");

var $4EKqI = parcelRequire("4EKqI");

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");

var $9r0oq = parcelRequire("9r0oq");
const $b082cfc5b9e74dcc$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "merged-cell",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $b082cfc5b9e74dcc$var$CELL_PADDING = 8;
const $b082cfc5b9e74dcc$var$HIERARCHY_LEVEL_PADDING = 12;
const $b082cfc5b9e74dcc$var$EXPAND_ICON_WIDTH = 24;
const $b082cfc5b9e74dcc$export$91a9bd0bc931a6e5 = ({ issueRef: issueRef, itemsConnectionId: itemsConnectionId, depth: depth, isRowHoveredOrSelected: isRowHoveredOrSelected, createChildTriggerProps: createChildTriggerProps, isCreateChildFormVisible: isCreateChildFormVisible, groupId: groupId, renderContent: renderContent, isHierarchyEnabled: isHierarchyEnabled, isFocused: isFocused })=>{
    const issueData = (0, $j4oe4.useFragment)((0, $CoNRa.default), issueRef);
    const hasChildren = Boolean(issueData?.hasChildren);
    const canHaveChildIssues = Boolean(issueData?.canHaveChildIssues);
    const issueId = issueData?.node?.issueId;
    const isChildIssueCreateEnabled = (0, $34oCh.useIsChildIssueCreateEnabled)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    // State for managing hover
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const isMergedCellFocusedOrHovered = (0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') ? isFocused || isHovered : Boolean(isRowHoveredOrSelected);
    let showCreateChildButton;
    if ((0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style')) showCreateChildButton = isGridNavigationEnabled ? isChildIssueCreateEnabled && isMergedCellFocusedOrHovered && canHaveChildIssues : isChildIssueCreateEnabled && canHaveChildIssues;
    else showCreateChildButton = isChildIssueCreateEnabled && isMergedCellFocusedOrHovered && canHaveChildIssues;
    const createChildButton = showCreateChildButton && issueId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2XtSM.CreateChildButtonWithExpandToggle), {
        depth: depth,
        itemId: issueId,
        groupId: groupId,
        itemsConnectionId: itemsConnectionId,
        createChildTriggerProps: createChildTriggerProps,
        isCreateChildFormVisible: isCreateChildFormVisible,
        renderIcon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                ...iconProps,
                color: "var(--ds-icon)",
                size: "small"
            })
    });
    let childCreateButton;
    if ((0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style')) childCreateButton = !isGridNavigationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "native-issue-table.ui.row.issue-row.merged-cell.child-create-button-wrap",
        xcss: $b082cfc5b9e74dcc$var$actionButtonDisplayVariableStyle
    }, createChildButton) : createChildButton;
    else childCreateButton = createChildButton;
    const timelineCustomComponents = (0, $9r0oq.useTimelineCustomComponents)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const contextualItemMenu = ((0, $4cTDP.fg)('refactor_issue_table_for_timline') || isTimelineEnabled) && timelineCustomComponents?.ContextualItemMenu && issueData?.node?.id && isMergedCellFocusedOrHovered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(timelineCustomComponents.ContextualItemMenu, {
        id: issueData.node.id
    }) : null;
    const onMouseLeaveHandler = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(false);
    }, []);
    const onMouseEnterHandler = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(true);
    }, []);
    const actionButtons = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, childCreateButton, contextualItemMenu);
    let shouldShowExpandButton = hasChildren;
    if (isTimelineEnabled || (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_issue_table_updates')) shouldShowExpandButton = isHierarchyEnabled && shouldShowExpandButton;
    if (shouldShowExpandButton && issueId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b082cfc5b9e74dcc$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "native-issue-table.ui.row.issue-row.merged-cell",
        xcss: $b082cfc5b9e74dcc$var$cellStyles,
        tabIndex: isGridNavigationEnabled ? undefined : 0,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            paddingLeft: `${$b082cfc5b9e74dcc$var$HIERARCHY_LEVEL_PADDING * depth + $b082cfc5b9e74dcc$var$CELL_PADDING}px`
        },
        "data-vc": "merged-cell",
        ...(0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') ? {
            onMouseEnter: onMouseEnterHandler,
            onMouseLeave: onMouseLeaveHandler
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b082cfc5b9e74dcc$var$expandButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2XtSM.ExpandButton), {
        itemId: issueId,
        itemsConnectionId: itemsConnectionId,
        depth: depth
    })), renderContent({
        actionButtons: actionButtons,
        isMergedCellFocusedOrHovered: (0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') ? isMergedCellFocusedOrHovered : undefined
    })));
    const cellPadding = isHierarchyEnabled ? $b082cfc5b9e74dcc$var$EXPAND_ICON_WIDTH + $b082cfc5b9e74dcc$var$HIERARCHY_LEVEL_PADDING * depth + $b082cfc5b9e74dcc$var$CELL_PADDING : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b082cfc5b9e74dcc$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "native-issue-table.ui.row.issue-row.merged-cell",
        xcss: $b082cfc5b9e74dcc$var$cellStyles,
        tabIndex: isGridNavigationEnabled ? undefined : 0,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            paddingLeft: `${cellPadding}px`
        },
        "data-vc": "merged-cell",
        ...(0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') ? {
            onMouseEnter: onMouseEnterHandler,
            onMouseLeave: onMouseLeaveHandler
        } : {}
    }, renderContent({
        actionButtons: actionButtons,
        isMergedCellFocusedOrHovered: isMergedCellFocusedOrHovered
    })));
};
const $b082cfc5b9e74dcc$var$cellStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: ' 100%',
    position: 'relative',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $b082cfc5b9e74dcc$var$expandButtonStyle = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $b082cfc5b9e74dcc$var$actionButtonDisplayVariableStyle = (0, $1DXK0.xcss)({
    display: 'var(--action-button-display, "flex")'
});

});
parcelRegister("CoNRa", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0cfd85d040936a5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0c6395281e13821d5d028f0321900902>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c0cfd85d040936a5$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "MergedCell",
    "selections": [
        {
            "condition": "shouldQueryHasChildren",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "filterByProjectKeys",
                            "variableName": "projectKeys"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "hasChildren"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canHaveChildIssues"
                }
            ]
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "issueId"
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$c0cfd85d040936a5$var$node.hash = "5ab28427c1039e081714dcbb034b2728";
var $c0cfd85d040936a5$export$2e2bcd8739ae039 = $c0cfd85d040936a5$var$node;

});


parcelRegister("69bTC", function(module, exports) {
$parcel$export(module.exports, "getMergedFields", () => $9857920eda2307ec$export$dd9429df1dba0f03);

var $j8Km1 = parcelRequire("j8Km1");
const $9857920eda2307ec$export$dd9429df1dba0f03 = (fieldSetsData)=>{
    const nodes = fieldSetsData?.edges?.flatMap((edgeData)=>edgeData?.node?.fields?.edges?.map((edge)=>edge?.node) ?? []);
    let issueTypeField;
    let issueKeyField;
    let summaryField;
    let fieldId;
    nodes?.forEach((node)=>{
        if (node?.__typename === 'JiraIssueTypeField') issueTypeField = node;
        else if (node?.__typename === 'JiraSingleLineTextField' && node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY) issueKeyField = node;
        else if (node?.__typename === 'JiraSingleLineTextField' && node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY) {
            summaryField = node;
            fieldId = node?.id;
        }
    });
    return {
        issueTypeField: issueTypeField,
        issueKeyField: issueKeyField,
        summaryField: summaryField,
        fieldId: fieldId
    };
};

});


parcelRegister("8zNZc", function(module, exports) {
$parcel$export(module.exports, "useRowColor", () => $1d5c36051e2adc81$export$b08eff1e3a7a6523);

var $k6MJb = parcelRequire("k6MJb");

var $5m5x6 = parcelRequire("5m5x6");

var $dCwp6 = parcelRequire("dCwp6");

var $eJOHy = parcelRequire("eJOHy");

var $kQ82p = parcelRequire("kQ82p");

var $j4oe4 = parcelRequire("j4oe4");

var $5d1YD = parcelRequire("5d1YD");

var $4cTDP = parcelRequire("4cTDP");

var $jUTKf = parcelRequire("jUTKf");

var $34oCh = parcelRequire("34oCh");
const $1d5c36051e2adc81$export$b08eff1e3a7a6523 = (fieldSets, project, formattingRules)=>{
    const isConditionalFormattingEnabled = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4cTDP.fg)('jira_list_conditional_formatting') && (0, $34oCh.useIsConditionalFormattingEnabled)();
    const isSavedViewConditionalFormattingEnabled = (0, $4cTDP.fg)('saved_list_view_technical_changes') && isConditionalFormattingEnabled;
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks
    const fields = (0, $j4oe4.useFragment)((0, $dCwp6.default), isConditionalFormattingEnabled ? fieldSets : null);
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks
    const rulesOld = (0, $j4oe4.useFragment)((0, $5m5x6.default), isConditionalFormattingEnabled ? project ?? null : null);
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks
    const rulesNew = (0, $j4oe4.useFragment)((0, $k6MJb.default), isSavedViewConditionalFormattingEnabled ? formattingRules : null);
    const rules = isSavedViewConditionalFormattingEnabled ? rulesNew : rulesOld?.conditionalFormattingRules;
    const valuesByFieldId = (0, $eJOHy.useMemo)(()=>{
        if (!isConditionalFormattingEnabled || rules?.edges == null || rules?.edges.length === 0 || fields?.edges == null || fields?.edges?.length === 0) return null;
        const localMap = new Map();
        fields.edges.forEach((fieldSet)=>fieldSet?.node?.fields?.edges?.forEach((fieldEdge)=>{
                const field = fieldEdge?.node;
                switch(field?.__typename){
                    case 'JiraSingleLineTextField':
                        localMap.set(field.fieldId, field.text);
                        break;
                    case 'JiraLabelsField':
                        {
                            const names = field.selectedLabelsConnection?.edges?.map((edge)=>edge?.node?.name).filter((name)=>name != null) ?? [];
                            localMap.set(field.fieldId, names);
                            break;
                        }
                    case 'JiraComponentsField':
                        {
                            const ids = field.selectedComponentsConnection?.edges?.map((edge)=>edge?.node?.componentId).filter((componentId)=>componentId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraSingleSelectUserPickerField':
                        localMap.set(field.fieldId, field.user?.accountId ?? 'UNASSIGNED');
                        break;
                    case 'JiraDatePickerField':
                        {
                            const parsedDate = field.date ? (0, $kQ82p.default)(field.date) : undefined;
                            localMap.set(field.fieldId, parsedDate);
                            break;
                        }
                    case 'JiraDateTimePickerField':
                        {
                            const parsedDate = field.dateTime ? (0, $kQ82p.default)(field.dateTime) : undefined;
                            localMap.set(field.fieldId, parsedDate);
                            break;
                        }
                    case 'JiraNumberField':
                        localMap.set(field.fieldId, field.number);
                        break;
                    case 'JiraPriorityField':
                        localMap.set(field.fieldId, field.priority?.priorityId);
                        break;
                    case 'JiraProjectField':
                        localMap.set(field.fieldId, field.project?.projectId);
                        break;
                    case 'JiraSingleVersionPickerField':
                        localMap.set(field.fieldId, field.version?.versionId);
                        break;
                    case 'JiraIssueTypeField':
                        localMap.set(field.fieldId, field.issueType?.issueTypeId);
                        break;
                    case 'JiraStatusField':
                        localMap.set(field.fieldId, field.status?.statusId);
                        break;
                    case 'JiraMultipleSelectUserPickerField':
                        {
                            const ids = field.selectedUsersConnection?.edges?.map((edge)=>edge?.node?.accountId).filter((componentId)=>componentId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraSprintField':
                        {
                            const ids = field.selectedSprintsConnection?.edges?.map((edge)=>edge?.node?.sprintId).filter((sprintId)=>sprintId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraMultipleVersionPickerField':
                        {
                            const ids = field.selectedVersionsConnection?.edges?.map((edge)=>edge?.node?.versionId).filter((versionId)=>versionId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraSingleSelectField':
                        localMap.set(field.fieldId, field.selectedValue?.id);
                        break;
                    case 'JiraMultipleSelectField':
                        {
                            const ids = field.selectedValues?.edges?.map((edge)=>edge?.node?.id).filter((selectedValueId)=>selectedValueId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraRadioSelectField':
                        localMap.set(field.fieldId, field.selectedOption?.label);
                        break;
                    // TODO: Add all supported types value mapping
                    default:
                        break;
                }
            }));
        return localMap;
    }, [
        fields,
        isConditionalFormattingEnabled,
        rules
    ]);
    const formatRule = (0, $eJOHy.useMemo)(()=>{
        const formattingRulesEdges = rules?.edges;
        if (formattingRulesEdges == null || formattingRulesEdges.length === 0 || !isConditionalFormattingEnabled || valuesByFieldId == null) return null;
        for (const rule of formattingRulesEdges){
            const isRowRule = rule?.node?.formattingArea === 'ROW';
            const expression = rule?.node?.expression;
            const fieldId = expression?.fieldId;
            const value = expression?.value ?? expression?.values;
            const operator = expression?.noValueOperator ?? expression?.singleValueOperator ?? expression?.multipleValueOperator;
            if (fieldId && operator && isRowRule) {
                const fieldValue = valuesByFieldId.get(fieldId);
                const ruleResult = (0, $5d1YD.evaluateRule)(operator, fieldValue, value);
                if (ruleResult) return rule;
            }
        }
        return null;
    }, [
        valuesByFieldId,
        rules,
        isConditionalFormattingEnabled
    ]);
    const key = formatRule?.node?.formattingColor?.colorKey;
    if (!key) return null;
    return (0, $jUTKf.formattingColors)[key];
};

});
parcelRegister("k6MJb", function(module, exports) {
$parcel$export(module.exports, "default", () => $437180adc65aaf78$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2e318d100a45089dcaa0c24955654187>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $437180adc65aaf78$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useRowColor_savedView_rules",
        "selections": [
            {
                "concreteType": "JiraFormattingRuleEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraFormattingRule",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "expression",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "alias": "singleValueOperator",
                                                "kind": "ScalarField",
                                                "name": "operator"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "value"
                                            }
                                        ],
                                        "type": "JiraFormattingSingleValueOperand"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "alias": "multipleValueOperator",
                                                "kind": "ScalarField",
                                                "name": "operator"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "values"
                                            }
                                        ],
                                        "type": "JiraFormattingMultipleValueOperand"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "alias": "noValueOperator",
                                                "kind": "ScalarField",
                                                "name": "operator"
                                            }
                                        ],
                                        "type": "JiraFormattingNoValueOperand"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "formattingArea"
                            },
                            {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "formattingColor",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "colorKey"
                                    }
                                ]
                            },
                            v1 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraFormattingRuleConnection"
    };
}();
$437180adc65aaf78$var$node.hash = "7c7d190a153839738109032a75510a88";
var $437180adc65aaf78$export$2e2bcd8739ae039 = $437180adc65aaf78$var$node;

});

parcelRegister("5m5x6", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea8e5531d882e00e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a3d97f71041d11de8c9cd397ded5bf12>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ea8e5531d882e00e$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useRowColor_rules",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 20
                    }
                ],
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "expression",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "singleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    }
                                                ],
                                                "type": "JiraFormattingSingleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "multipleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "values"
                                                    }
                                                ],
                                                "type": "JiraFormattingMultipleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "noValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    }
                                                ],
                                                "type": "JiraFormattingNoValueOperand"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "formattingArea"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "formattingColor",
                                        "plural": false,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            }
                                        ]
                                    },
                                    v1 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "conditionalFormattingRules(first:20)"
            }
        ],
        "type": "JiraProject"
    };
}();
$ea8e5531d882e00e$var$node.hash = "8b3aacb9e958c242bd940634ade5587f";
var $ea8e5531d882e00e$export$2e2bcd8739ae039 = $ea8e5531d882e00e$var$node;

});

parcelRegister("dCwp6", function(module, exports) {
$parcel$export(module.exports, "default", () => $3018162255d35097$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a94579dfd4800f7632c62705d9e723d0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3018162255d35097$var$node = function() {
    var v0 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "versionId"
        }
    ], v4 = [
        v2 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useRowColor",
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fieldId"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "text"
                                                            }
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v0 /*: any*/ ,
                                                                "concreteType": "JiraComponentConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedComponentsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraComponentEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraComponent",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "componentId"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedComponentsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraComponentsField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v0 /*: any*/ ,
                                                                "concreteType": "JiraLabelConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedLabelsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraLabelEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraLabel",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "name"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedLabelsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraLabelsField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    v2 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraUserConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedUsersConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraUserEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v1 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraMultipleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "date"
                                                            }
                                                        ],
                                                        "type": "JiraDatePickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "dateTime"
                                                            }
                                                        ],
                                                        "type": "JiraDateTimePickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "number"
                                                            }
                                                        ],
                                                        "type": "JiraNumberField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraPriority",
                                                                "kind": "LinkedField",
                                                                "name": "priority",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "priorityId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraPriorityField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraProject",
                                                                "kind": "LinkedField",
                                                                "name": "project",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "projectId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraProjectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraSprintConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedSprintsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSprintEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSprint",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "sprintId"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSprintField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraVersion",
                                                                "kind": "LinkedField",
                                                                "name": "version",
                                                                "plural": false,
                                                                "selections": v3 /*: any*/ 
                                                            }
                                                        ],
                                                        "type": "JiraSingleVersionPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v0 /*: any*/ ,
                                                                "concreteType": "JiraVersionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedVersionsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraVersionEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraVersion",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": v3 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedVersionsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraMultipleVersionPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "selectedValue",
                                                                "plural": false,
                                                                "selections": v4 /*: any*/ 
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraSelectableValueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedValues",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSelectableValueEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": v4 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraMultipleSelectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOption",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOption",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "alias": "label",
                                                                        "kind": "ScalarField",
                                                                        "name": "value"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraRadioSelectField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$3018162255d35097$var$node.hash = "ee73292706be38f260a2451ef8fc0bc2";
var $3018162255d35097$export$2e2bcd8739ae039 = $3018162255d35097$var$node;

});



parcelRegister("f9D6R", function(module, exports) {
$parcel$export(module.exports, "RowsAdditionalContentRenderer", () => $a2123f66dc9ec48b$export$62e57fc2b6b904bc);

var $bhhQ2 = parcelRequire("bhhQ2");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9r0oq = parcelRequire("9r0oq");
const $a2123f66dc9ec48b$export$62e57fc2b6b904bc = ({ depth: depth, groupId: groupId, issues: issues })=>{
    const timelineCustomComponents = (0, $9r0oq.useTimelineCustomComponents)();
    const issuesData = (0, $j4oe4.useFragment)((0, $bhhQ2.default), issues);
    return timelineCustomComponents?.RowsAdditionalContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(timelineCustomComponents.RowsAdditionalContent, {
        depth: depth,
        groupId: groupId,
        issues: issuesData
    });
};

});
parcelRegister("bhhQ2", function(module, exports) {
$parcel$export(module.exports, "default", () => $95909c6b1e273240$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2b6f75448a7ba7acd2e2baf149013c32>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $95909c6b1e273240$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "RowsAdditionalContentRenderer",
    "selections": [
        {
            "condition": "isTimelineEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "TimelineRowsContent"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$95909c6b1e273240$var$node.hash = "fa60dcc2c4e7e90daa4d28978abe34b9";
var $95909c6b1e273240$export$2e2bcd8739ae039 = $95909c6b1e273240$var$node;

});


parcelRegister("km3XC", function(module, exports) {
$parcel$export(module.exports, "VirtualizedRows", () => $ec1352550c791a56$export$bfdb633a3745996);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("gMNDC");
var $8GBQp = parcelRequire("8GBQp");

var $Kdcei = parcelRequire("Kdcei");

var $34oCh = parcelRequire("34oCh");
const $ec1352550c791a56$export$bfdb633a3745996 = ({ hasSpacers: hasSpacers, columnsCount: columnsCount, children: children })=>{
    const virtualizer = (0, $Kdcei.useVirtualization)();
    if (virtualizer == null) return children();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec1352550c791a56$var$VirtualizedRowsInner, {
        hasSpacers: hasSpacers,
        columnsCount: columnsCount,
        virtualizer: virtualizer
    }, children);
};
const $ec1352550c791a56$var$VirtualizedRowsInner = ({ hasSpacers: hasSpacers, columnsCount: columnsCount, virtualizer: virtualizer, children: children })=>{
    const virtualItemsMap = (0, $Kdcei.useVirtualItemsMap)();
    const virtualItemsMapRef = (0, $eJOHy.useRef)(virtualItemsMap);
    virtualItemsMapRef.current = virtualItemsMap;
    const isItemVirtual = (0, $eJOHy.useCallback)((key)=>Boolean(virtualItemsMapRef.current[key]), []);
    const items = virtualizer.getVirtualItems();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    // Calculates the height (top and bottom) of the non rendered portion of table
    const [before, after] = items.length > 0 ? [
        (0, $8GBQp.notUndefined)(items[0]).start - virtualizer.options.scrollMargin,
        virtualizer.getTotalSize() - (0, $8GBQp.notUndefined)(items.at(-1)).end
    ] : [
        0,
        0
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, hasSpacers && before > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", {
        ...isGridNavigationEnabled && {
            'aria-hidden': true
        },
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", {
        colSpan: columnsCount,
        // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
        style: {
            '--local-row-top-spacer-height': `${before}px`
        },
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3i1m6g"
        ])
    })), children(isItemVirtual, virtualizer.measureElement), hasSpacers && after > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", {
        ...isGridNavigationEnabled && {
            'aria-hidden': true
        },
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", {
        colSpan: columnsCount,
        // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
        style: {
            '--local-row-bottom-spacer-height': `${after}px`
        },
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3ibvba"
        ])
    })));
};
const $ec1352550c791a56$var$virtualRowStyles = null;
const $ec1352550c791a56$var$virtualTopSpacerStyles = null;
const $ec1352550c791a56$var$virtualBottomSpacerStyles = null;

});



parcelRegister("d2QWN", function(module, exports) {
$parcel$export(module.exports, "Header", () => $c31e1dc5d3cdffb4$export$8b251419efc915eb);

var $6O5GC = parcelRequire("6O5GC");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $j4oe4 = parcelRequire("j4oe4");

var $exQoy = parcelRequire("exQoy");

var $3nrCN = parcelRequire("3nrCN");

var $1l4lS = parcelRequire("1l4lS");

var $bGx3v = parcelRequire("bGx3v");

var $isfFo = parcelRequire("isfFo");

var $EzBXZ = parcelRequire("EzBXZ");

var $j8Km1 = parcelRequire("j8Km1");

var $9cbmy = parcelRequire("9cbmy");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $4cTDP = parcelRequire("4cTDP");

var $jE8Tu = parcelRequire("jE8Tu");

var $f2JN3 = parcelRequire("f2JN3");

var $cxKOj = parcelRequire("cxKOj");

var $ac9c5 = parcelRequire("ac9c5");

var $cgCO4 = parcelRequire("cgCO4");

var $8FfYE = parcelRequire("8FfYE");

var $8jOO7 = parcelRequire("8jOO7");

var $johMb = parcelRequire("johMb");

var $9r0oq = parcelRequire("9r0oq");

var $kbYhH = parcelRequire("kbYhH");

var $34oCh = parcelRequire("34oCh");

var $7n9BS = parcelRequire("7n9BS");

var $c4xBS = parcelRequire("c4xBS");

var $6UQ01 = parcelRequire("6UQ01");

var $3utN3 = parcelRequire("3utN3");
const $c31e1dc5d3cdffb4$var$BORDER_WIDTH = '1px';
const $c31e1dc5d3cdffb4$var$RESIZE_HANDLE_Z_INDEX = 1;
const $c31e1dc5d3cdffb4$var$MaybeInlineFieldCreateOnboardingProvider = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jira_inline_field_config_gate'), (0, $c4xBS.InlineFieldCreateOnboardingProvider), ({ children: children })=>children);
const $c31e1dc5d3cdffb4$var$baseHeaderContainerCellStyles = {
    backgroundColor: "var(--ds-surface-sunken, #F8F8F8)",
    borderColor: "var(--ds-border, #0B120E24)",
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderBottomWidth: $c31e1dc5d3cdffb4$var$BORDER_WIDTH,
    borderLeftWidth: 0,
    borderRightWidth: $c31e1dc5d3cdffb4$var$BORDER_WIDTH,
    '&:first-of-type': {
        borderTopLeftRadius: "var(--ds-radius-large, 8px)"
    },
    '&:last-of-type': {
        borderTopRightRadius: "var(--ds-radius-large, 8px)",
        borderRightWidth: 0
    }
};
const $c31e1dc5d3cdffb4$var$baseHeaderContainerCellKeyboardStyles = {
    backgroundColor: "var(--ds-surface-sunken, #F8F8F8)",
    borderColor: "var(--ds-border, #0B120E24)",
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderBottomWidth: $c31e1dc5d3cdffb4$var$BORDER_WIDTH,
    borderLeftWidth: 0,
    borderRightWidth: $c31e1dc5d3cdffb4$var$BORDER_WIDTH,
    '&:first-of-type': {
        borderTopLeftRadius: "var(--ds-radius-large, 8px)",
        '&:focus::before': {
            left: '-1px',
            width: 'calc(100% + 3px)',
            height: 'calc(100% + 4px)',
            borderTopLeftRadius: "var(--ds-radius-large, 8px)"
        }
    },
    '&:last-of-type': {
        borderTopRightRadius: "var(--ds-radius-large, 8px)",
        borderRightWidth: 0,
        '&:focus::before': {
            borderTopRightRadius: "var(--ds-radius-large, 8px)"
        }
    },
    '&:focus': {
        outline: 'unset',
        '&:before': {
            content: ' ',
            boxSizing: 'border-box',
            display: 'block',
            position: 'absolute',
            height: 'calc(100% + 4px)',
            width: 'calc(100% + 5px)',
            inset: '0px',
            left: '-3px',
            top: '-2px',
            border: `2px solid ${"var(--ds-border-focused, #4688EC)"}`
        }
    }
};
const $c31e1dc5d3cdffb4$var$HEADER_HEIGHT = 40;
const $c31e1dc5d3cdffb4$var$STICKY_CELL_Z_INDEX = $c31e1dc5d3cdffb4$var$RESIZE_HANDLE_Z_INDEX + 1; // exported for testing purposes
const $c31e1dc5d3cdffb4$var$triggerColumnFlash = (table, index)=>{
    const columnCellsSelector = `th:nth-of-type(${index + 1}), td:nth-of-type(${index + 1})`;
    Array.from(table.querySelectorAll(columnCellsSelector)).filter((element)=>element instanceof HTMLElement).forEach((element)=>(0, $exQoy.triggerPostMoveFlash)(element));
};
const $c31e1dc5d3cdffb4$export$8b251419efc915eb = /*#__PURE__*/ (0, $eJOHy.memo)(({ view: view, columnPickerProps: columnPickerProps, columns: columns, canViewColumnConfiguration: canViewColumnConfiguration, canEditColumnConfiguration: canEditColumnConfiguration, isCompactColumnEnabled: isCompactColumnEnabled = false, resizeHandleType: resizeHandleType, onColumnsChange: onColumnsChange, onResizeColumn: onResizeColumn, onFreezeColumn: onFreezeColumn, tableRef: tableRef, tableBorderRadius: tableBorderRadius, showNoColumns: showNoColumns, resizingColumnIndex: resizingColumnIndex, setResizingColumnIndex: setResizingColumnIndex, enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn, mergedColumnMinWidth: mergedColumnMinWidth })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const timelineCustomComponents = (0, $9r0oq.useTimelineCustomComponents)();
    let isStickyColumnsVisible = false;
    let isAutoUnstickyOnSmallScreenEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)(); // eslint-disable-next-line react-hooks/rules-of-hooks
        isAutoUnstickyOnSmallScreenEnabled = (0, $34oCh.useIsAutoUnstickyOnSmallScreenEnabled)();
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { isStickyColumnsVisible: isStickyColumnsVisibleOld } = (0, $cgCO4.useShouldApplyFrozenColumns)();
        isStickyColumnsVisible = isStickyColumnsVisibleOld;
    }
    const viewData = (0, $j4oe4.useFragment)((0, $6O5GC.default), view ?? null); // Unique identifier for the header of this particular issue table instance
    const [instanceId] = (0, $eJOHy.useState)(()=>Symbol('pdnd-issue-table-header'));
    const [lastReorderOperation, setLastReorderOperation] = (0, $eJOHy.useState)(null);
    const [screenReaderMessage, setScreenReaderMessage] = (0, $eJOHy.useState)('');
    const reorderColumn = (0, $eJOHy.useCallback)(({ startIndex: startIndex, indexOfTarget: indexOfTarget, closestEdgeOfTarget: closestEdgeOfTarget = null, analyticsAttributes: analyticsAttributes = {} })=>{
        const finishIndex = (0, $1l4lS.getReorderDestinationIndex)({
            axis: 'horizontal',
            startIndex: startIndex,
            indexOfTarget: indexOfTarget,
            closestEdgeOfTarget: closestEdgeOfTarget
        });
        if (startIndex === finishIndex) return;
        const newColumns = (0, $isfFo.reorder)({
            list: columns,
            startIndex: startIndex,
            finishIndex: finishIndex
        });
        onColumnsChange?.(newColumns);
        setLastReorderOperation({
            finishIndex: finishIndex
        });
        setScreenReaderMessage(formatMessage((0, $3utN3.default).movedColumn, {
            column: columns[startIndex]?.title,
            previousPosition: startIndex + 1,
            position: finishIndex + 1,
            // TODO: EM-7165 update to columns.length when excluding column picker
            total: columns.length - 1
        }));
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'reordered',
            actionSubject: 'columns'
        }), 'issueTable', analyticsAttributes);
    }, [
        columns,
        createAnalyticsEvent,
        formatMessage,
        onColumnsChange
    ]);
    const stickyColumnsWidth = (0, $4cTDP.fg)('issue_table_frozen_columns') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>(0, $8FfYE.calculateStickyColumnsWidth)(columns), [
        columns
    ]) : 0; // Calculate the count of additional sticky columns (excluding non-movable columns)
    const additionalStickyColumnsCount = (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>columns.filter((col)=>col.isColumnSticky && !(0, $8jOO7.NON_MOVABLE_COLUMN_IDS).includes(col.id)).length, [
        columns
    ]) : 0; // Calculate the amount of moveable columns in the table
    const totalMoveableColumns = (0, $eJOHy.useMemo)(()=>{
        if (!columns.length) return 0; // Count how many of these non-movable columns actually exist in the current column set
        const nonMovableCount = columns.filter((column)=>(0, $8jOO7.NON_MOVABLE_COLUMN_IDS).includes(column.id)).length;
        return columns.length - nonMovableCount;
    }, [
        columns
    ]); // We use an object for lastReorderOperation so we can trigger the column flash
    // if the finish index is the same as the previous reorder operation.
    (0, $eJOHy.useEffect)(()=>{
        const table = tableRef?.current;
        if (table && lastReorderOperation !== null) $c31e1dc5d3cdffb4$var$triggerColumnFlash(table, lastReorderOperation.finishIndex);
    }, [
        lastReorderOperation,
        tableRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!canEditColumnConfiguration) return;
        return (0, $bGx3v.monitorForElements)({
            canMonitor ({ source: source }) {
                // Only monitor this particular instance id
                // (i.e. prevent monitoring entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId;
            },
            onDrop ({ source: source, location: location }) {
                const [destination] = location.current.dropTargets;
                if (!destination) return;
                const startIndex = columns.findIndex((column)=>column.id === source.data.id);
                if (startIndex === -1) return;
                const indexOfTarget = columns.findIndex((column)=>column.id === destination.data.id);
                if (indexOfTarget === -1) return;
                const closestEdgeOfTarget = (0, $3nrCN.extractClosestEdge)(destination.data);
                reorderColumn({
                    startIndex: startIndex,
                    indexOfTarget: indexOfTarget,
                    closestEdgeOfTarget: closestEdgeOfTarget,
                    analyticsAttributes: {
                        operation: 'drop'
                    }
                });
            }
        });
    }, [
        columns,
        canEditColumnConfiguration,
        instanceId,
        reorderColumn,
        tableRef
    ]);
    const onMoveColumn = (index, position)=>{
        if (canEditColumnConfiguration && onColumnsChange !== undefined) switch(position){
            case 0, $8jOO7.MOVE_COLUMN_FIRST:
                if (index > 0) {
                    let indexOfTarget = 0;
                    const allowMergedColumnReordering = enableDynamicOrderForMergedColumn && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate');
                    if (!allowMergedColumnReordering && (0, $4cTDP.fg)('jira_list_merged_column_move_first')) indexOfTarget = columns.findIndex((column)=>column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN)) + 1;
                    reorderColumn({
                        startIndex: index,
                        indexOfTarget: indexOfTarget,
                        closestEdgeOfTarget: 'left',
                        analyticsAttributes: {
                            operation: 'move-first'
                        }
                    });
                }
                break;
            case 0, $8jOO7.MOVE_COLUMN_LEFT:
                if (index > 0) reorderColumn({
                    startIndex: index,
                    indexOfTarget: index - 1,
                    closestEdgeOfTarget: 'left',
                    analyticsAttributes: {
                        operation: 'move-left'
                    }
                });
                break;
            case 0, $8jOO7.MOVE_COLUMN_RIGHT:
                // TODO: EM-7165 change this to `columns.length - 1` when excluding column picker
                if (index < columns.length - 2) reorderColumn({
                    startIndex: index,
                    indexOfTarget: index + 1,
                    closestEdgeOfTarget: 'right',
                    analyticsAttributes: {
                        operation: 'move-right'
                    }
                });
                break;
            case 0, $8jOO7.MOVE_COLUMN_LAST:
                // TODO: EM-7165 change this to `columns.length - 1` when excluding column picker
                if (index < columns.length - 2) reorderColumn({
                    startIndex: index,
                    // TODO: EM-7165 change this to `columns.length - 1` when excluding column picker
                    indexOfTarget: columns.length - 2,
                    closestEdgeOfTarget: 'right',
                    analyticsAttributes: {
                        operation: 'move-last'
                    }
                });
                break;
            default:
                throw new Error(`Unexpected target column position ${position}`);
        }
    };
    const onRemoveColumn = (index)=>{
        if (canEditColumnConfiguration && onColumnsChange !== undefined) {
            const newColumns = [
                ...columns
            ];
            newColumns.splice(index, 1);
            onColumnsChange(newColumns);
        }
    };
    const tableWidth = (0, $kbYhH.useElementSizeSelector)((size)=>size.width);
    const { hasShadowBottom: hasShadowBottom, hasShadowLeft: hasShadowLeft } = (0, $7n9BS.useScrollStateSelector)((scrollState)=>{
        const { scrollTop: scrollTop, scrollLeft: scrollLeft, width: containerWidth } = scrollState;
        return {
            hasShadowBottom: scrollTop > 0,
            // Scroll measurements are fractional, while width measurements are integer, so we need to round before comparing
            hasShadowLeft: containerWidth < tableWidth && Math.round(scrollLeft) < tableWidth - containerWidth
        };
    });
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const isInBetweenColumnPickerEnabled = (0, $34oCh.useIsInBetweenColumnPickerEnabled)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const visibleDepth = (0, $jE8Tu.useVisibleDepth)();
    let isChildIssuesTableVisualUpliftEnabled = false;
    if ((0, $4cTDP.fg)('fg_visual_uplift_for_child_issues_table')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isChildIssuesTableVisualUpliftEnabled = (0, $34oCh.useIsChildIssuesTableVisualUpliftEnabled)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eJOHy.useState)(false);
    const handleDropdownStateChange = (isOpen)=>{
        setIsDropdownOpen(isOpen);
    };
    const hasMeatball = columns.some((column)=>column.type === (0, $8jOO7.COLUMN_ID_MEATBALL_MENU));
    const hasTimeline = columns.some((column)=>column.id === (0, $8jOO7.COLUMN_ID_TIMELINE));
    let lastDataColumnIndex = columns.length - 1; // Count fixed-position columns from the end
    if (hasMeatball) lastDataColumnIndex--;
    if (hasTimeline) lastDataColumnIndex--;
    const stickyColumns = (0, $eJOHy.useMemo)(()=>(0, $4cTDP.fg)('timeline_harmonisation_m3_targeting') ? columns.filter(({ isColumnSticky: isColumnSticky })=>isColumnSticky).map(({ id: id, customWidth: customWidth, defaultWidth: defaultWidth, stickyOffsets: stickyOffsets }, index)=>({
                id: id,
                width: customWidth ?? defaultWidth,
                columnOffset: (0, $johMb.getColumnOffset)(stickyOffsets ?? 0, (resizingColumnIndex ?? 0) < index)
            })) : [], [
        columns,
        resizingColumnIndex
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", null, columns.map((column, index)=>{
        const { isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets } = column;
        const isExpandColumn = column.id === (0, $j8Km1.COLUMN_ID_EXPAND_BUTTON);
        const isMergedColumn = column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) && (0, $4cTDP.fg)('jira_list_merged_column_gate');
        const isMeatballMenu = column.id === (0, $8jOO7.COLUMN_ID_MEATBALL_MENU);
        const defaultColumnWidth = column.customWidth ?? column.defaultWidth;
        const columnWidth = isExpandColumn || isMergedColumn ? (0, $johMb.getExpandColumnWidth)(visibleDepth) : defaultColumnWidth;
        let hasShadow = isExpandColumn ? false : canViewColumnConfiguration && hasShadowLeft;
        if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) hasShadow = isMeatballMenu && canViewColumnConfiguration && hasShadowLeft;
        let customHeader = column.customHeader;
        let isStickyHeaderContainer = canViewColumnConfiguration;
        if (((0, $4cTDP.fg)('refactor_issue_table_for_timline') || isTimelineEnabled) && timelineCustomComponents?.ColumnHeader && column.id === (0, $8jOO7.COLUMN_ID_TIMELINE)) {
            customHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(timelineCustomComponents.ColumnHeader, null);
            isStickyHeaderContainer = false;
        }
        let isLast = !hasMeatball && (0, $4cTDP.fg)('jracloud-95753_fix_scrollbar_in_chin') ? index === columns.length - 1 : index === columns.length - 2;
        let shouldShowResizeHandle = !(!hasMeatball && isLast); // will override isLast logic above when fg is enabled
        if ((0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns')) {
            isLast = index === lastDataColumnIndex;
            const isFixedPositionColumn = (0, $8jOO7.FIXED_POSITION_COLUMN_TYPES).includes(column.type); // Show resize handle when: NOT a fixed-position column AND (timeline exists OR meatball exists OR not last)
            shouldShowResizeHandle = !isFixedPositionColumn && (hasTimeline || hasMeatball || !isLast);
        }
        return(// TODO: EM-7165 – refactor column picker logic, separating it from regular columns
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
            key: column.id
        }, // Empty cell to fill remaining space if configured columns are not wide enough to fill the table
        isFixedTableLayoutEnabled && column.id === (0, $8jOO7.COLUMN_ID_MEATBALL_MENU) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c31e1dc5d3cdffb4$var$EmptyHeaderCell, {
            "aria-hidden": true
        }), customHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c31e1dc5d3cdffb4$export$429fd509d8532e18, {
            scope: "col",
            columnWidth: columnWidth,
            // read as the column title when a user is navigating between columns in the table content.
            "aria-label": column.title,
            isSticky: (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? isStickyHeaderContainer : canViewColumnConfiguration,
            hasShadow: hasShadow,
            visualRefresh: (0, $6XJko.isVisualRefreshEnabled)(),
            isCompactColumnEnabled: isCompactColumnEnabled,
            tableBorderRadius: tableBorderRadius,
            tabIndex: index === 0 ? 0 : -1,
            ...isStickyColumnsVisible && (0, $4cTDP.fg)('issue_table_frozen_columns') && {
                isColumnSticky: isColumnSticky,
                stickyOffsets: stickyOffsets
            },
            ...isStickyColumnsVisible && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') && {
                isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled
            },
            isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled,
            isGridNavigationEnabled: isGridNavigationEnabled,
            isTimelineColumn: isTimelineEnabled && ((0, $cxKOj.expVal)('bulk_operations_in_timeline', 'isEnabled', false) ? timelineCustomComponents?.ColumnHeader && column?.id === (0, $8jOO7.COLUMN_ID_TIMELINE) : true)
        }, customHeader) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UQ01.HeaderCell), {
            column: column,
            hasColumnConfiguration: canEditColumnConfiguration,
            instanceId: instanceId,
            isCompactColumnEnabled: isCompactColumnEnabled,
            isFirst: index === 0,
            isLast: isLast,
            ...(0, $4cTDP.fg)('jracloud-95753_fix_scrollbar_in_chin') && {
                shouldHaveResizeHandle: shouldShowResizeHandle
            },
            previousColumn: index === 0 ? undefined : columns[index - 1],
            resizeHandleType: resizeHandleType,
            tableRef: tableRef,
            tableBorderRadius: tableBorderRadius,
            onMoveColumn: (position)=>onMoveColumn(index, position),
            onDropdownStateChange: handleDropdownStateChange,
            onRemoveColumn: ()=>onRemoveColumn(index),
            onResizeColumn: onResizeColumn,
            onFreezeColumn: onFreezeColumn,
            index: index,
            enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn,
            ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
                isStickyColumnsVisible: isStickyColumnsVisible,
                stickyColumnsWidth: stickyColumnsWidth,
                resizingColumnIndex: resizingColumnIndex,
                setResizingColumnIndex: setResizingColumnIndex
            },
            ...(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') && {
                additionalStickyColumnsCount: additionalStickyColumnsCount
            },
            mergedColumnMinWidth: mergedColumnMinWidth,
            ...(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') && {
                totalMoveableColumns: totalMoveableColumns
            }
        })));
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $EzBXZ.RenderOnClient), {
        fg: "jfp-magma-nin-hydration-fixes"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c31e1dc5d3cdffb4$var$MaybeInlineFieldCreateOnboardingProvider, null, isInBetweenColumnPickerEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ac9c5.InsertColumnButton), {
        columns: columns,
        columnPickerProps: columnPickerProps,
        view: viewData,
        isStickyColumnsVisible: isStickyColumnsVisible,
        mergedColumnMinWidth: mergedColumnMinWidth
    }), (isInlineFieldConfigEnabled || isInBetweenColumnPickerEnabled) && !showNoColumns && (0, $4cTDP.fg)('jira_inline_field_config_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4xBS.InlineFieldCreateOnboarding), null))), (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting') ? screenReaderMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderCaption), {
        "aria-live": "assertive",
        "data-testid": "native-issue-table.ui.issue-table.header.screen-reader-caption"
    }, screenReaderMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderCaption), {
        "aria-live": "assertive",
        "data-testid": "native-issue-table.ui.issue-table.header.screen-reader-caption"
    }, screenReaderMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("thead", {
        className: (0, $hcewu.default)([
            isStickyColumnsVisible && (0, $4cTDP.fg)('issue_table_frozen_columns') ? "_kqsw1if8 _154iidpf _1pby1406" : "_kqsw1if8 _154iidpf _1pbycs5v",
            isDropdownOpen && "_1pbyjwwv",
            hasShadowBottom && (0, $4cTDP.fg)('reduce_size_of_scroll_container_shadow') && "_16qs1nax",
            hasShadowBottom && !(0, $4cTDP.fg)('reduce_size_of_scroll_container_shadow') && "_16qs1vtw"
        ])
    }, content, timelineCustomComponents?.HeaderAdditionalContent && (0, $4cTDP.fg)('timeline_harmonisation_m3_targeting') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(timelineCustomComponents.HeaderAdditionalContent, {
        stickyColumns: stickyColumns
    })));
});
const $c31e1dc5d3cdffb4$var$baseStickyHeaderStylesOld = null; // When a column is frozen, the table cell has z-index: 7. The header must have a higher z-index(8) to avoid being visually covered by the cell during vertical scrolling.
const $c31e1dc5d3cdffb4$var$baseStickyHeaderStyles = null;
const $c31e1dc5d3cdffb4$var$increasedZIndexStyles = null; // remove when cleaning up reduce_size_of_scroll_container_shadow
const $c31e1dc5d3cdffb4$var$shadowStylesOld = null;
const $c31e1dc5d3cdffb4$var$shadowStyles = null; // Exported for testing
const $c31e1dc5d3cdffb4$export$429fd509d8532e18 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isGridNavigationEnabled: isGridNavigationEnabled, tableBorderRadius: tableBorderRadius, columnWidth: columnWidth, minColumnWidth: minColumnWidth, isCompactColumnEnabled: isCompactColumnEnabled, isDraggable: isDraggable, isHovered: isHovered, isSticky: isSticky, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled, hasShadow: hasShadow, visualRefresh: visualRefresh, isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled, isTimelineColumn: isTimelineColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_2x37x7": (0, $awdRS.default)(__cmplp.tableBorderRadius ?? "var(--ds-space-100, 8px)"),
            "--_1so474g": (0, $awdRS.default)(__cmplp.columnWidth != null ? `${__cmplp.columnWidth}px` : 'auto'),
            "--_19bvh75": (0, $awdRS.default)(__cmplp.minColumnWidth != null ? `${__cmplp.minColumnWidth}px` : 'auto'),
            "--_sj363t": (0, $awdRS.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            __cmplp.isCompactColumnEnabled && __cmplp.columnWidth && __cmplp.columnWidth < 40 ? '0px' : "var(--ds-space-100, 8px)"),
            "--_1vpctke": (0, $awdRS.default)(__cmplp.stickyOffsets, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1rjcze3t _18zru2gc _kqswh2mm _vchhusvi _4t3i1ylp _c71l1ylp _1tke1ylp _s7n4nkob _o5721q9c _1276baal _1bsbdva2 _142idise _1ul9qagj _1rcdhxdp _1lhcu2gc _4x86hxdp _1o59u2gc _1lhcwb8e _1o59wb8e",
            __cmplp.isGridNavigationEnabled ? "_1h6d1l7x _1dqonqa1 _bfhkhfxm _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _1rcd1mok _1av71n1a _jrfr1p7v _1vhm1pbc _cdln1mok _4x861mok _1nd4idpf _1obq1mok _nt751r31 _49pcn7od _1hvw1o36 _2qv9idpf _qzh67g83 _x7uvf705 _6i55usvi _1j5l1ule _1qtkstnw _1w0p1pbc _1814iopo _p0vij39m _1cl912gs" : "_1h6d1l7x _1dqonqa1 _bfhkhfxm _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _1rcd1mok _4x861mok _1nd4idpf",
            __cmplp.isGridNavigationEnabled && "_nt751r31 _49pcn7od _1hvw1o36 _858upm4j _1ya5nqa1 _1mb8dkaa",
            __cmplp.isDraggable && __cmplp.isHovered && "_d0al1qgj _irr319i6",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && "_kqsw1if8 _1pbycs5v",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isSticky && "_1xi2idpf",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isColumnSticky && "_1ltv1l64",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isAutoUnstickyOnSmallScreenEnabled && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') && __cmplp.isColumnSticky && "_z115qete _16sigrf3",
            __cmplp.hasShadow && "_16qs1omh _t6vd1aa3",
            __cmplp.visualRefresh ? "_11c81vhk _syazazsu" : "_syaz1sqi _k48p1wq8",
            __cmplp.isChildIssuesTableVisualUpliftEnabled && "_bfhkglyw _hr4jidpf",
            __cmplp.isTimelineColumn && "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $c31e1dc5d3cdffb4$var$EmptyHeaderCell = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1h6d1l7x _1dqonqa1 _bfhkhfxm _uwhkidpf _1doct94y _t6vdidpf _hr4jidpf _1rcd1mok _4x861mok _1nd4idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6O5GC", function(module, exports) {
$parcel$export(module.exports, "default", () => $52c89c62438516ff$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2242e7128755b781c99f2ad1c8164ba1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $52c89c62438516ff$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "HeaderCellContainer",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "InsertColumnButton"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$52c89c62438516ff$var$node.hash = "8c7ed6259e396b6167d470ec77da7fd5";
var $52c89c62438516ff$export$2e2bcd8739ae039 = $52c89c62438516ff$var$node;

});

parcelRegister("ac9c5", function(module, exports) {
$parcel$export(module.exports, "InsertColumnButton", () => $fb42fc247ec374bd$export$ce61804b1701b38c);

var $bcaji = parcelRequire("bcaji");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $6G5P1 = parcelRequire("6G5P1");
var $8qmYl = parcelRequire("8qmYl");
var $azjc1 = parcelRequire("azjc1");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $PETi0 = parcelRequire("PETi0");

var $jE8Tu = parcelRequire("jE8Tu");

var $88wTt = parcelRequire("88wTt");

var $9NBLG = parcelRequire("9NBLG");

var $j8Km1 = parcelRequire("j8Km1");

var $f2JN3 = parcelRequire("f2JN3");

var $c4xBS = parcelRequire("c4xBS");

var $johMb = parcelRequire("johMb");

var $6KVf0 = parcelRequire("6KVf0");

var $7n9BS = parcelRequire("7n9BS");


var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $7XD6x = parcelRequire("7XD6x");
// Height/width of the popup button
const $fb42fc247ec374bd$var$DEFAULT_BUTTON_SIZE = 24;
// Height/width of the reference element the popup button is anchored to
const $fb42fc247ec374bd$var$REFERENCE_SIZE = 1;
const $fb42fc247ec374bd$var$constantModifiers = [
    {
        name: 'flip',
        enabled: false
    }
];
const $fb42fc247ec374bd$export$582d36594507a709 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns'), (0, $9NBLG.default), (0, $88wTt.default));
const $fb42fc247ec374bd$export$96c0bbf49f7c219f = ({ view: view, columns: columns, columnPickerProps: columnPickerProps, isStickyColumnsVisible: isStickyColumnsVisible, mergedColumnMinWidth: mergedColumnMinWidth })=>{
    const [{ index: columnIndex }] = (0, $6KVf0.useInlineFieldCreateActiveIndex)();
    const [{ isOpen: isOpen }, { close: close }] = (0, $PETi0.useColumnPickerOpenState)();
    const { lockIndex: lockIndex, clearIndex: clearIndex, clearIndexAfterDelay: clearIndexAfterDelay, setIndex: setIndex, setIsHovered: setIsHovered, clearIsHovered: clearIsHovered } = (0, $6KVf0.useInlineCreateActiveIndexActions)();
    const { showInlineFieldCreateOnboarding: showInlineFieldCreateOnboarding } = (0, $c4xBS.useInlineFieldCreateOnboardingContext)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    const isInBetweenStickyColumnPickerEnabled = (0, $34oCh.useIsInBetweenStickyColumnPickerEnabled)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const projectContext = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $34oCh.useProjectContext)() : undefined;
    const viewData = (0, $j4oe4.useFragment)((0, $bcaji.default), view);
    const visibleDepth = (0, $jE8Tu.useVisibleDepth)();
    let isMergedColumnEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnEnabled = (0, $34oCh.useIsMergedColumnEnabled)();
    const firstFieldColumnIndex = (0, $eJOHy.useMemo)(()=>{
        return columns.findIndex((column)=>!column.id.startsWith((0, $8jOO7.COLUMN_ID_INTERNAL_COLUMN))) - 1;
    }, [
        columns
    ]);
    const hasShownOnboarding = (0, $eJOHy.useRef)(false);
    const shouldShowOnboarding = showInlineFieldCreateOnboarding && !hasShownOnboarding.current;
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    if (shouldShowOnboarding) {
        setIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74), firstFieldColumnIndex);
        lockIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
        hasShownOnboarding.current = true;
    }
    const columnsWidth = (0, $eJOHy.useMemo)(()=>columns.map((column)=>{
            if (column.id === (0, $8jOO7.COLUMN_ID_EXPAND_BUTTON)) return (0, $johMb.getExpandColumnWidth)(visibleDepth);
            if (column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) && column.mergedColumns && column.mergedColumns.length > 1) {
                if ((0, $4cTDP.fg)('refactor_issue_table_for_timline')) return Math.max(mergedColumnMinWidth ?? (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH), column.customWidth ?? column.defaultWidth);
                return Math.max(isTimelineEnabled ? (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH_TIMELINE) : (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH), column.customWidth ?? column.defaultWidth);
            }
            return column.customWidth ?? column.defaultWidth;
        }), [
        columns,
        isTimelineEnabled,
        mergedColumnMinWidth,
        visibleDepth
    ]);
    const fixedColumnCount = (0, $eJOHy.useMemo)(()=>columns.filter((column)=>column.id === (0, $8jOO7.COLUMN_ID_EXPAND_BUTTON) || column.id === (0, $8jOO7.COLUMN_ID_CHECKBOX) || column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) || isStickyColumnsVisible && column.isColumnSticky && (!(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') || !isInBetweenStickyColumnPickerEnabled) && (0, $4cTDP.fg)('issue_table_frozen_columns')).length, [
        columns,
        isStickyColumnsVisible,
        isInBetweenStickyColumnPickerEnabled
    ]);
    const mergedColumnsCount = isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate') ? (columns.find((column)=>column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN))?.mergedColumns ?? []).length : 0;
    const isEmptyColumnExist = columnsWidth.length - columns.length === 1;
    const isStickyInsertButtonApplied = (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? isInBetweenStickyColumnPickerEnabled && isStickyColumnsVisible && columnIndex != null && columns[columnIndex]?.isColumnSticky && (0, $4cTDP.fg)('issue_table_frozen_columns') : false;
    let scrollElement = null;
    if ((0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns')) // eslint-disable-next-line react-hooks/rules-of-hooks
    scrollElement = (0, $7n9BS.useScrollStateSelector)((state)=>state.scrollElement);
    const referenceRef = (0, $eJOHy.useRef)(null);
    const insertButtonXOffset = (0, $eJOHy.useMemo)(()=>{
        if (columnIndex != null && columnsWidth.length > 0) return columnsWidth.slice(0, columnIndex + 1).reduce((acc, width)=>acc + width, -$fb42fc247ec374bd$var$REFERENCE_SIZE);
        return 0;
    }, [
        columnIndex,
        columnsWidth
    ]);
    // Update position of + button on sticky columns using CSS variable on scroll - this will not trigger re renders
    (0, $eJOHy.useEffect)(()=>{
        if (!isStickyInsertButtonApplied || !scrollElement || !referenceRef.current) return;
        const updatePosition = ()=>{
            if (referenceRef.current && scrollElement) // Update CSS variable directly - this will not trigger a re-render
            referenceRef.current.style.setProperty('--scroll-offset', `${scrollElement.scrollLeft}px`);
        };
        updatePosition();
        scrollElement.addEventListener('scroll', updatePosition, {
            passive: true
        });
        return ()=>{
            scrollElement.removeEventListener('scroll', updatePosition);
        };
    }, [
        isStickyInsertButtonApplied,
        scrollElement
    ]);
    const finalOffset = (0, $eJOHy.useMemo)(()=>// Negatively offset the popup by the button + reference size to center the button on the secondary axis
        [
            insertButtonXOffset,
            (0, $8jOO7.INSERT_COLUMN_BUTTON_Y_OFFSET) - ($fb42fc247ec374bd$var$DEFAULT_BUTTON_SIZE + $fb42fc247ec374bd$var$REFERENCE_SIZE) / 2
        ], [
        insertButtonXOffset
    ]);
    const modifiers = (0, $eJOHy.useMemo)(()=>{
        // Adjust the overflow calculation for the primary axis so it is relative to the center of the button.
        const alongCenterOffset = -($fb42fc247ec374bd$var$DEFAULT_BUTTON_SIZE / 2);
        // Retain the provided offset for the secondary axis
        const padding = {
            top: finalOffset[1],
            left: alongCenterOffset,
            right: alongCenterOffset
        };
        return [
            ...$fb42fc247ec374bd$var$constantModifiers,
            {
                name: 'preventOverflow',
                options: {
                    mainAxis: true,
                    altAxis: true,
                    padding: padding,
                    altBoundary: true,
                    rootBoundary: 'viewport',
                    tether: false
                }
            },
            {
                name: 'eventListeners',
                options: {
                    // Only recompute position on scroll/resize events while the button is focused to reduce CPU load
                    scroll: isOpen,
                    resize: isOpen
                }
            }
        ];
    }, [
        finalOffset,
        isOpen
    ]);
    const handleMouseEnter = (0, $eJOHy.useCallback)(()=>{
        lockIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        lockIndex
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        !isOpen && clearIndexAfterDelay((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        clearIndexAfterDelay,
        isOpen
    ]);
    const handlePickerMouseEnter = (0, $eJOHy.useCallback)(()=>{
        setIsHovered((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        setIsHovered
    ]);
    const handlePickerMouseLeave = (0, $eJOHy.useCallback)(()=>{
        clearIsHovered((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        clearIsHovered
    ]);
    const shouldNotShowInsertButton = (0, $eJOHy.useMemo)(()=>columnIndex == null || isEmptyColumnExist && columnIndex >= columnsWidth.length - 3 || // If an empty column exists, prevent inserting in the last two columns.
        !((0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') && isStickyInsertButtonApplied) && columnIndex >= columnsWidth.length - 2 || // Prevent inserting on the left or right of the last column unless isStickyInsertButtonApplied.
        columnIndex < fixedColumnCount - 1, [
        columnIndex,
        columnsWidth.length,
        fixedColumnCount,
        isEmptyColumnExist,
        isStickyInsertButtonApplied
    ]);
    if (shouldNotShowInsertButton) {
        if (!shouldShowOnboarding) {
            clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
            close();
        }
    }
    if (columnPickerProps) {
        const { components: components, ...props } = columnPickerProps;
        const emptyFooter = (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? {} : {
            Footer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6G5P1.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $azjc1.Reference), null, ({ ref: ref })=>{
            const handleRef = (node)=>{
                if (typeof ref === 'function') ref(node);
                if (isStickyInsertButtonApplied) referenceRef.current = node;
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: [
                    $fb42fc247ec374bd$var$referenceStyles,
                    $fb42fc247ec374bd$var$visuallyHiddenStyles,
                    ...isStickyInsertButtonApplied ? [
                        $fb42fc247ec374bd$var$stickyStyles
                    ] : []
                ],
                ref: (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? handleRef : ref
            });
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8qmYl.Popper), {
            placement: "bottom",
            offset: finalOffset,
            modifiers: modifiers
        }, ({ ref: ref, style: style })=>{
            const styleProps = {
                style: style
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                ref: ref,
                ...styleProps,
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                xcss: [
                    $fb42fc247ec374bd$var$buttonStyles,
                    shouldNotShowInsertButton && $fb42fc247ec374bd$var$hideStyles,
                    ...isStickyInsertButtonApplied ? [
                        $fb42fc247ec374bd$var$stickyPopperStyles
                    ] : []
                ],
                backgroundColor: "color.background.input",
                testId: `native-issue-table.ui.issue-table.insert-column-button.popper${shouldNotShowInsertButton ? '-hidden' : ''}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb42fc247ec374bd$export$582d36594507a709, {
                ...props,
                view: viewData,
                components: {
                    ...components,
                    ...isInlineFieldConfigEnabled ? {
                        Footer: (0, $7XD6x.IFCFooter)
                    } : emptyFooter
                },
                columnInsertIndex: columnIndex != null ? columnIndex - fixedColumnCount + mergedColumnsCount + 1 : undefined,
                isInBetweenColumnPickerEnabled: true,
                showInlineFieldCreateOnboarding: columnIndex === firstFieldColumnIndex && showInlineFieldCreateOnboarding,
                onPickerMouseEnter: handlePickerMouseEnter,
                onPickerMouseLeave: handlePickerMouseLeave,
                isMergedColumnEnabled: isMergedColumnEnabled,
                isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
                projectContext: projectContext !== null && (0, $4cTDP.fg)('jira_inline_field_config_gate') ? projectContext : undefined
            }));
        }));
    }
    return null;
};
const $fb42fc247ec374bd$export$ce61804b1701b38c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $PETi0.ColumnPickerContainer), {
        scope: (0, $8jOO7.COLUMN_PICKER_ADD_COLUMN_CONTAINER)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb42fc247ec374bd$export$96c0bbf49f7c219f, props));
};
const $fb42fc247ec374bd$var$buttonStyles = (0, $1DXK0.xcss)({
    zIndex: 'dialog'
});
const $fb42fc247ec374bd$var$referenceStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: `${$fb42fc247ec374bd$var$DEFAULT_BUTTON_SIZE / 2 + 2}px`
});
const $fb42fc247ec374bd$var$hideStyles = (0, $1DXK0.xcss)({
    display: 'none'
});
const $fb42fc247ec374bd$var$stickyStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: "var(--ds-space-0, 0px)",
    transform: 'translateX(var(--scroll-offset, 0px))',
    willChange: 'transform'
});
const $fb42fc247ec374bd$var$stickyPopperStyles = (0, $1DXK0.xcss)({
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $fb42fc247ec374bd$var$visuallyHiddenStyles = (0, $1DXK0.xcss)({
    width: '1px',
    height: '1px',
    padding: 'space.0',
    position: 'absolute',
    border: 'none',
    clipPath: 'rect(1px 1px 1px 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});

});
parcelRegister("bcaji", function(module, exports) {
$parcel$export(module.exports, "default", () => $a891a31ff309261c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ea1d68cbf02643e2ccf6c2858ea4f944>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a891a31ff309261c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "InsertColumnButton",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ColumnConfigWithContainer_savedViewId"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$a891a31ff309261c$var$node.hash = "6ab7fc38f11e427975f678187d262f14";
var $a891a31ff309261c$export$2e2bcd8739ae039 = $a891a31ff309261c$var$node;

});

parcelRegister("c4xBS", function(module, exports) {
$parcel$export(module.exports, "InlineFieldCreateOnboardingProvider", () => $b87aababb5e9070a$export$de078953583b045f);
$parcel$export(module.exports, "useInlineFieldCreateOnboardingContext", () => $b87aababb5e9070a$export$9649d04db063d324);
$parcel$export(module.exports, "InlineFieldCreateOnboarding", () => $b87aababb5e9070a$export$f07afb14f98859fd);

var $eJOHy = parcelRequire("eJOHy");

var $7UDun = parcelRequire("7UDun");

var $3cMgR = parcelRequire("3cMgR");

var $d2s5v = parcelRequire("d2s5v");

var $58yRG = parcelRequire("58yRG");

var $lRq8t = parcelRequire("lRq8t");

var $cHtIB = parcelRequire("cHtIB");

var $iC2Fk = parcelRequire("iC2Fk");

var $9zZj0 = parcelRequire("9zZj0");

var $6zxfT = parcelRequire("6zxfT");

var $kAwwe = parcelRequire("kAwwe");

var $2aY2d = parcelRequire("2aY2d");

var $6KVf0 = parcelRequire("6KVf0");


var $cKKo4 = parcelRequire("cKKo4");

var $i7jEw = parcelRequire("i7jEw");

var $lCPZ7 = parcelRequire("lCPZ7");

var $bgZld = parcelRequire("bgZld");

var $lXTaV = parcelRequire("lXTaV");
const $b87aababb5e9070a$var$useIsProjectAdmin = ()=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    return !!data?.isProjectAdmin;
};
const $b87aababb5e9070a$export$7749a74b05b28c3e = 'issue-navigator-inline-field-create';
const $b87aababb5e9070a$var$STARGATE_URL = '/gateway/api';
const $b87aababb5e9070a$var$InlineFieldCreateOnboardingContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $b87aababb5e9070a$export$de078953583b045f = ({ children: children })=>{
    const [showInlineFieldCreateOnboarding, setShowInlineFieldCreateOnboarding] = (0, $eJOHy.useState)(false);
    const value = (0, $eJOHy.useMemo)(()=>({
            showInlineFieldCreateOnboarding: showInlineFieldCreateOnboarding,
            setShowInlineFieldCreateOnboarding: setShowInlineFieldCreateOnboarding
        }), [
        showInlineFieldCreateOnboarding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b87aababb5e9070a$var$InlineFieldCreateOnboardingContext.Provider, {
        value: value
    }, children);
};
const $b87aababb5e9070a$export$9649d04db063d324 = ()=>{
    const inlineFieldCreateOnboardingContext = (0, $eJOHy.useContext)($b87aababb5e9070a$var$InlineFieldCreateOnboardingContext);
    if (!inlineFieldCreateOnboardingContext) throw new Error('useInlineFieldCreateOnboardingContext must be used within a InlineFieldCreateOnboardingProvider');
    return inlineFieldCreateOnboardingContext;
};
const $b87aababb5e9070a$var$ConfigureFieldsOnboardingComponent = ({ setActiveSpotlight: setActiveSpotlight, isTMPAdmin: isTMPAdmin })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { clearIndex: clearIndex } = (0, $6KVf0.useInlineCreateActiveIndexActions)();
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const { setShowInlineFieldCreateOnboarding: setShowInlineFieldCreateOnboarding } = $b87aababb5e9070a$export$9649d04db063d324();
    const actions = isTMPAdmin ? [
        {
            text: formatMessage((0, $lXTaV.default).nextButtonText),
            onClick: ()=>{
                setActiveSpotlight(1);
                clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
            }
        },
        {
            text: formatMessage((0, $lXTaV.default).createFieldDismiss),
            onClick: ()=>{
                setActiveSpotlight(null);
                setShowInlineFieldCreateOnboarding(false);
                clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
            }
        }
    ] : [
        {
            text: formatMessage((0, $lXTaV.default).createFieldDismiss),
            onClick: ()=>{
                setActiveSpotlight(null);
                setShowInlineFieldCreateOnboarding(false);
                clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
            }
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2Fk.JiraSpotlight), {
        pulse: true,
        messageId: "native-issue-table.ui.inline-field-create-onboarding.jira-spotlight.inline-field-create-onboarding-column-picker-button.in-between",
        messageType: "engagement",
        actions: actions,
        dialogWidth: 320,
        target: "inline-field-create-onboarding-column-picker-button.in-between",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        image: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($bgZld))) : (0, (/*@__PURE__*/$parcel$interopDefault($lCPZ7))),
        actionsBeforeElement: isTMPAdmin ? '1/2' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $lXTaV.default).inlineColumnCreateBody, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                weight: "bold"
            }, chunks)
    })));
};
const $b87aababb5e9070a$var$InlineFieldCreateOnboardingComponent = ({ setActiveSpotlight: setActiveSpotlight })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { clearIndex: clearIndex } = (0, $6KVf0.useInlineCreateActiveIndexActions)();
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const { setShowInlineFieldCreateOnboarding: setShowInlineFieldCreateOnboarding } = $b87aababb5e9070a$export$9649d04db063d324();
    if (!colorMode) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2Fk.JiraSpotlight), {
        pulse: true,
        messageId: "native-issue-table.ui.inline-field-create-onboarding.jira-spotlight.inline-field-create-onboarding-column-picker-button.default",
        messageType: "engagement",
        actions: [
            {
                text: formatMessage((0, $lXTaV.default).createFieldDismiss),
                onClick: ()=>{
                    setActiveSpotlight(null);
                    setShowInlineFieldCreateOnboarding(false);
                    clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
                }
            }
        ],
        dialogPlacement: "bottom right",
        dialogWidth: 320,
        target: "inline-field-create-onboarding-column-picker-button.default",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        image: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($i7jEw))) : (0, (/*@__PURE__*/$parcel$interopDefault($cKKo4))),
        actionsBeforeElement: "2/2"
    }, formatMessage((0, $lXTaV.default).createFieldBody));
};
const $b87aababb5e9070a$export$f07afb14f98859fd = ()=>{
    const { setShowInlineFieldCreateOnboarding: setShowInlineFieldCreateOnboarding } = $b87aababb5e9070a$export$9649d04db063d324();
    const cloudId = (0, $cHtIB.useCloudId)();
    const [activeSpotlight, setActiveSpotlight] = (0, $eJOHy.useState)(null);
    const isSiteAdmin = (0, $kAwwe.useIsAdmin)();
    const isProjectAdmin = $b87aababb5e9070a$var$useIsProjectAdmin();
    const isTMP = (0, $2aY2d.useIsSimplifiedProject)();
    const isAdmin = isSiteAdmin || isProjectAdmin;
    const isTMPAdmin = isAdmin && isTMP;
    const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, $b87aababb5e9070a$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isEnrolled, stopEnrolment] = (0, $7UDun.useCoordination)(coordinationClient, $b87aababb5e9070a$export$7749a74b05b28c3e);
    const hasShownOnboarding = (0, $eJOHy.useRef)(false);
    if (isEnrolled && !hasShownOnboarding.current) {
        setShowInlineFieldCreateOnboarding(true);
        stopEnrolment(false);
        setActiveSpotlight(0);
        hasShownOnboarding.current = true;
    }
    const renderActiveSpotlight = ()=>{
        const spotlights = isTMPAdmin ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b87aababb5e9070a$var$ConfigureFieldsOnboardingComponent, {
                key: "configure-fields",
                setActiveSpotlight: setActiveSpotlight,
                isTMPAdmin: true
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b87aababb5e9070a$var$InlineFieldCreateOnboardingComponent, {
                key: "inline-field-create",
                setActiveSpotlight: setActiveSpotlight
            })
        ] : [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b87aababb5e9070a$var$ConfigureFieldsOnboardingComponent, {
                key: "configure-fields",
                setActiveSpotlight: setActiveSpotlight
            })
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6zxfT.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, isEnrolled && activeSpotlight !== null && renderActiveSpotlight()));
};

});
parcelRegister("cKKo4", function(module, exports) {
module.exports = new URL("configure-fields-light.fd3f907d.png", import.meta.url).toString();

});

parcelRegister("i7jEw", function(module, exports) {
module.exports = new URL("configure-fields-dark.cda4df1f.png", import.meta.url).toString();

});

parcelRegister("lCPZ7", function(module, exports) {
module.exports = new URL("inline-column-create-light.25926891.png", import.meta.url).toString();

});

parcelRegister("bgZld", function(module, exports) {
module.exports = new URL("inline-column-create-dark.7d2ee1ec.png", import.meta.url).toString();

});

parcelRegister("lXTaV", function(module, exports) {
$parcel$export(module.exports, "default", () => $b198919880e512f2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b198919880e512f2$var$messages = (0, $7qGN1.defineMessages)({
    createFieldBody: {
        "id": "native-issue-table.ui.inline-field-create-onboarding.create-field-body",
        "defaultMessage": "Create and configure fields without leaving your view."
    },
    createFieldDismiss: {
        "id": "native-issue-table.ui.inline-field-create-onboarding.create-field-dismiss",
        "defaultMessage": "Dismiss"
    },
    inlineColumnCreateBody: {
        "id": "native-issue-table.ui.inline-field-create-onboarding.inline-column-create-body",
        "defaultMessage": "Select <b>+</b> to quickly add columns exactly where you want them."
    },
    nextButtonText: {
        "id": "native-issue-table.ui.inline-field-create-onboarding.next-button-text",
        "defaultMessage": "Next"
    }
});
var $b198919880e512f2$export$2e2bcd8739ae039 = $b198919880e512f2$var$messages;

});



parcelRegister("6UQ01", function(module, exports) {
$parcel$export(module.exports, "HeaderCell", () => $16f432ebf3f5233a$export$efcbfab786023e1a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $aQK2r = parcelRequire("aQK2r");

var $6DCNy = parcelRequire("6DCNy");

var $12DRg = parcelRequire("12DRg");

var $3nrCN = parcelRequire("3nrCN");

var $igtYB = parcelRequire("igtYB");

var $dROq6 = parcelRequire("dROq6");

var $bGx3v = parcelRequire("bGx3v");

var $92EV7 = parcelRequire("92EV7");

var $aHiGM = parcelRequire("aHiGM");

var $ltpqI = parcelRequire("ltpqI");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $guChT = parcelRequire("guChT");

var $j8Km1 = parcelRequire("j8Km1");

var $4cTDP = parcelRequire("4cTDP");

var $6d9QY = parcelRequire("6d9QY");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");


var $6KVf0 = parcelRequire("6KVf0");

var $8jOO7 = parcelRequire("8jOO7");

var $k1Whm = parcelRequire("k1Whm");

var $34oCh = parcelRequire("34oCh");

var $7n9BS = parcelRequire("7n9BS");

var $johMb = parcelRequire("johMb");

var $2cK5s = parcelRequire("2cK5s");

var $4G6Vc = parcelRequire("4G6Vc");

var $3R7ZX = parcelRequire("3R7ZX");

var $9iFH8 = parcelRequire("9iFH8");
const $16f432ebf3f5233a$var$DRAG_PREVIEW_MAX_WIDTH = 260;
const $16f432ebf3f5233a$var$BORDER_WIDTH = '1px';
const $16f432ebf3f5233a$var$HEADER_HEIGHT = 40;
const $16f432ebf3f5233a$export$10fece0d97415ebc = 60; // ensure that the resize handle displays above subsequent header cells, but that a sticky cell will display above the
// resize handle. Improper z-index may cause the resize handle to render _above_ the column picker.
const $16f432ebf3f5233a$var$RESIZE_HANDLE_Z_INDEX = 1;
const $16f432ebf3f5233a$var$STICKY_CELL_Z_INDEX = $16f432ebf3f5233a$var$RESIZE_HANDLE_Z_INDEX + 1;
const $16f432ebf3f5233a$var$BOUNDARY = 70;
const $16f432ebf3f5233a$var$MOUSE_MOVE_THROTTLE = 16;
const $16f432ebf3f5233a$var$SpotlightWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "native-issue-table.ui.issue-table.header.header-cell.spotlight-wrapper",
        className: (0, $hcewu.default)([
            "_11c81vhk _2rkolb4i _18zru2gc _bfhkhfxm _4t3i1osq _1e0c1txw _4cvr1h6o _syazazsu _1bsbnau3"
        ])
    }, children);
};
const $16f432ebf3f5233a$export$efcbfab786023e1a = ({ column: column, hasColumnConfiguration: hasColumnConfiguration, instanceId: instanceId, isCompactColumnEnabled: isCompactColumnEnabled = false, isFirst: isFirst, isLast: isLast, previousColumn: previousColumn, resizeHandleType: resizeHandleType = (0, $8jOO7.COLUMN_RESIZE_HANDLE_FULL_HEIGHT), shouldHaveResizeHandle: shouldHaveResizeHandle = true, tableRef: tableRef, onMoveColumn: onMoveColumnProp, onRemoveColumn: onRemoveColumn, onResizeColumn: onResizeColumnProp, onFreezeColumn: onFreezeColumnProp, index: index, tableBorderRadius: tableBorderRadius, onDropdownStateChange: onDropdownStateChange, stickyColumnsWidth: stickyColumnsWidth = 0, additionalStickyColumnsCount: additionalStickyColumnsCount = 0, resizingColumnIndex: resizingColumnIndex, setResizingColumnIndex: setResizingColumnIndex, enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn, isStickyColumnsVisible: isStickyColumnsVisible, mergedColumnMinWidth: mergedColumnMinWidth, totalMoveableColumns: totalMoveableColumns })=>{
    const headerCellContainerRef = (0, $eJOHy.useRef)(null);
    const headerCellActionsTriggerRef = (0, $eJOHy.useRef)(null);
    const resizeHandleRef = (0, $eJOHy.useRef)(null);
    const isColumnResizingEnabled = (0, $34oCh.useIsColumnResizingEnabled)();
    const isInBetweenColumnPickerEnabled = (0, $34oCh.useIsInBetweenColumnPickerEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const isStickyColumnsEnabled = (0, $34oCh.useIsStickyColumnsEnabled)();
    const isInBetweenStickyColumnPickerEnabled = (0, $34oCh.useIsInBetweenStickyColumnPickerEnabled)();
    const isIssueHierarchyEnabled = (0, $34oCh.useIsIssueHierarchyEnabled)();
    let isAutoUnstickyOnSmallScreenEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isAutoUnstickyOnSmallScreenEnabled = (0, $34oCh.useIsAutoUnstickyOnSmallScreenEnabled)();
    let isChildIssuesTableVisualUpliftEnabled = false;
    if ((0, $4cTDP.fg)('fg_visual_uplift_for_child_issues_table')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isChildIssuesTableVisualUpliftEnabled = (0, $34oCh.useIsChildIssuesTableVisualUpliftEnabled)();
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eJOHy.useState)(false);
    const handleDropdownOpenChange = (0, $eJOHy.useCallback)((isOpen)=>{
        setIsDropdownOpen(isOpen);
        if (onDropdownStateChange) onDropdownStateChange(isOpen);
    }, [
        onDropdownStateChange
    ]);
    const [state, setState] = (0, $eJOHy.useState)({
        type: 'idle'
    });
    const [dropEdge, setDropEdge] = (0, $eJOHy.useState)(null);
    let clearIndex = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let setIndex = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let clearIndexAfterDelay = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let columnIndex;
    let isInlineFieldCreateHovered;
    if (isInBetweenColumnPickerEnabled) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ({ clearIndex: clearIndex, setIndex: setIndex, clearIndexAfterDelay: clearIndexAfterDelay } = (0, $6KVf0.useInlineCreateActiveIndexActions)());
        [{ index: columnIndex, isHovered: isInlineFieldCreateHovered }] = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $6KVf0.useInlineFieldCreateActiveIndex)();
    }
    const height = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.height);
    let scrollElement;
    let scrollLeft = 0;
    let isScrolling = false;
    let hasScrolled = false;
    let tableWidth = 0;
    if ((0, $4cTDP.fg)('issue_table_frozen_columns')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const scrollState = (0, $7n9BS.useScrollStateSelector)((s)=>({
                scrollLeft: s.scrollLeft,
                isScrolling: (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? s.isScrolling && s.hasScrolled : s.isScrolling,
                width: (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? 0 : s.width,
                hasScrolled: s.hasScrolled,
                scrollElement: s.scrollElement
            }));
        scrollLeft = scrollState.scrollLeft ?? 0;
        isScrolling = scrollState.isScrolling ?? false;
        hasScrolled = scrollState.hasScrolled ?? false;
        scrollElement = scrollState.scrollElement;
        tableWidth = scrollState.width ?? 0;
    }
    tableWidth = (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? scrollElement?.clientWidth ?? 0 : tableWidth;
    if (isStickyColumnsVisible && isScrolling && isDropdownOpen && !column.isColumnSticky && (0, $4cTDP.fg)('issue_table_frozen_columns')) {
        const scrollElementToLeft = scrollElement?.getBoundingClientRect().left ?? 0;
        const triggerOffsetFromLeft = headerCellActionsTriggerRef.current?.getBoundingClientRect().left;
        if (triggerOffsetFromLeft !== undefined && triggerOffsetFromLeft - scrollElementToLeft < stickyColumnsWidth) setIsDropdownOpen(false);
    }
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>({
            fieldType: column.type
        }), [
        column.type
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isStickyColumn = (0, $eJOHy.useMemo)(()=>column.isColumnSticky && isInBetweenStickyColumnPickerEnabled && (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns'), [
        column.isColumnSticky,
        isInBetweenStickyColumnPickerEnabled
    ]);
    const throttledHandler = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))((event)=>{
            if (!event.currentTarget) return;
            const scrollElementToLeft = scrollElement?.getBoundingClientRect().left ?? 0;
            const stickyBoundary = scrollElementToLeft + stickyColumnsWidth;
            const rect = event.currentTarget.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const width = rect.right - rect.left; // For sticky columns, allow insert button on both sides
            // For non-sticky columns, only allow on the right side if they're past the sticky boundary
            if (x < width / 2 && x <= $16f432ebf3f5233a$var$BOUNDARY) {
                // Left side: allow for sticky columns, or non-sticky columns past the boundary
                if (isStickyColumn || rect.left >= stickyBoundary) setIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74), index - 1);
                else clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
            } else if (x >= width / 2 && x >= width - $16f432ebf3f5233a$var$BOUNDARY) // Right side: always allow
            setIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74), index);
            else clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
        }, $16f432ebf3f5233a$var$MOUSE_MOVE_THROTTLE), [
        scrollElement,
        stickyColumnsWidth,
        setIndex,
        index,
        clearIndex,
        isStickyColumn
    ]);
    const calculateColumnIndex = (0, $eJOHy.useCallback)(throttledHandler, [
        throttledHandler
    ]);
    const onMouseEnter = (0, $eJOHy.useCallback)((event)=>{
        if (event.target === resizeHandleRef.current) // prevent showing "hovered" state when only the resize handle is hovered
        return;
        setIsHovered(true);
    }, []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(false);
        if (isInBetweenColumnPickerEnabled) clearIndexAfterDelay((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        clearIndexAfterDelay,
        isInBetweenColumnPickerEnabled
    ]);
    const handleMouseMove = (0, $eJOHy.useCallback)((event)=>{
        event.persist(); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (headerCellContainerRef.current?.contains(event.target)) calculateColumnIndex(event);
        else clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        calculateColumnIndex,
        clearIndex
    ]);
    const handleMouseClick = (0, $eJOHy.useCallback)((event)=>{
        if (event.target instanceof HTMLElement && headerCellContainerRef.current?.contains(event.target.closest('button'))) clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        clearIndex
    ]); // #region Column reordering
    const onMoveColumn = (0, $eJOHy.useCallback)((position)=>{
        onMoveColumnProp(position);
        setIsHovered(false);
    }, [
        onMoveColumnProp
    ]);
    let isMergedColumnEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnEnabled = (0, $34oCh.useIsMergedColumnEnabled)();
    const isMergedColumn = isMergedColumnEnabled && column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) && (0, $4cTDP.fg)('jira_list_merged_column_gate');
    const isHiddenByFrozenColumn = (0, $eJOHy.useMemo)(()=>{
        if (isStickyColumnsVisible && resizeHandleRef && resizeHandleRef.current && hasScrolled && (0, $4cTDP.fg)('issue_table_frozen_columns')) {
            if (isMergedColumn && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) return false;
            const scrollElementToLeft = scrollElement?.getBoundingClientRect().left ?? 0;
            const stickyBoundary = scrollElementToLeft + stickyColumnsWidth;
            return resizeHandleRef.current.getBoundingClientRect().left < stickyBoundary || isScrolling;
        }
        return false;
    }, [
        isMergedColumn,
        isStickyColumnsVisible,
        hasScrolled,
        scrollElement,
        stickyColumnsWidth,
        isScrolling
    ]);
    const isMultiColumnMergedCell = isMergedColumn && column.mergedColumns && column.mergedColumns.length > 1;
    (0, $eJOHy.useEffect)(()=>{
        const headerCellContainer = headerCellContainerRef.current;
        const allowMergedColumnReordering = (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate') ? enableDynamicOrderForMergedColumn : false;
        if (!hasColumnConfiguration || !headerCellContainer || isMergedColumn && !allowMergedColumnReordering) return;
        return (0, $dROq6.combine)((0, $bGx3v.draggable)({
            element: headerCellContainer,
            getInitialData () {
                if (isStickyColumnsVisible) return {
                    operation: (0, $8jOO7.COLUMN_OPERATION_REORDER),
                    id: column.id,
                    instanceId: instanceId,
                    isColumnSticky: column.isColumnSticky
                };
                return {
                    operation: (0, $8jOO7.COLUMN_OPERATION_REORDER),
                    id: column.id,
                    instanceId: instanceId
                };
            },
            onDragStart () {
                setState({
                    type: 'reordering'
                });
            },
            onDrop () {
                setState({
                    type: 'idle'
                });
            },
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage }) {
                const headerCellWidth = headerCellContainer.getBoundingClientRect().width;
                (0, $aHiGM.setCustomNativeDragPreview)({
                    getOffset () {
                        return {
                            x: 20,
                            y: 20
                        };
                    },
                    render ({ container: container }) {
                        // Cause a React re-render to create portal synchronously
                        setState({
                            type: 'preview',
                            container: container,
                            previewWidth: Math.min(headerCellWidth, $16f432ebf3f5233a$var$DRAG_PREVIEW_MAX_WIDTH)
                        }); // Cause a React re-render to remove portal on cleanup
                        return ()=>setState({
                                type: 'reordering'
                            });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            }
        }), (0, $bGx3v.dropTargetForElements)({
            element: headerCellContainer,
            canDrop ({ source: source }) {
                if (isStickyColumnsVisible) // Only allow drops from the same instance id
                // (i.e. prevent dropping entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId && // Only allow columns to be dropped within their original section:
                // frozen columns into the frozen section, and unfrozen columns into the unfrozen section
                column.isColumnSticky === source.data.isColumnSticky;
                 // Only allow drops from the same instance id
                // (i.e. prevent dropping entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId;
            },
            getData ({ input: input, element: element }) {
                const data = {
                    id: column.id,
                    instanceId: instanceId
                };
                return (0, $3nrCN.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'left',
                        'right'
                    ]
                });
            },
            onDrag ({ self: self }) {
                const closestEdge = (0, $3nrCN.extractClosestEdge)(self.data);
                if (!closestEdge) return;
                setDropEdge(closestEdge);
            },
            onDragLeave () {
                setDropEdge(null);
            },
            onDrop () {
                setDropEdge(null);
            }
        }), (0, $bGx3v.monitorForElements)({
            canMonitor ({ source: source }) {
                // Only monitor this particular instance id
                // (i.e. prevent monitoring entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId;
            },
            onDrag () {
                // Close the dropdown menu when a drag starts on any column
                setIsDropdownOpen(false);
            }
        }));
    }, [
        column.id,
        column.isColumnSticky,
        hasColumnConfiguration,
        instanceId,
        isMergedColumn,
        isStickyColumnsVisible,
        enableDynamicOrderForMergedColumn
    ]); // #endregion
    // #region Column resizing
    const mergedColumnWidth = Math.max(mergedColumnMinWidth || (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH), column.customWidth ?? column.defaultWidth);
    const maxFrozenMergedColumnWidth = isMergedColumn && column.isColumnSticky && tableWidth > 0 && (!(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') || additionalStickyColumnsCount === 0) ? tableWidth - stickyColumnsWidth + mergedColumnWidth - $16f432ebf3f5233a$export$10fece0d97415ebc : mergedColumnWidth; // eslint-disable-next-line no-nested-ternary
    const columnWidth = isMultiColumnMergedCell ? (0, $4cTDP.fg)('issue_table_frozen_columns') ? Math.min(mergedColumnWidth, maxFrozenMergedColumnWidth) : mergedColumnWidth : column.customWidth ?? column.defaultWidth; // eslint-disable-next-line no-nested-ternary
    const prevColumnCustomWidth = isMultiColumnMergedCell ? (0, $4cTDP.fg)('issue_table_frozen_columns') ? Math.min(columnWidth, maxFrozenMergedColumnWidth) : columnWidth : column.customWidth;
    const [componentColumnWidth, setComponentColumnWidth] = (0, $eJOHy.useState)(columnWidth);
    const prevColumnConfigCustomWidth = (0, $6d9QY.usePreviousWithInitial)(prevColumnCustomWidth);
    const [isResizePopupOpen, setIsResizePopupOpen] = (0, $eJOHy.useState)(false);
    const ariaSortDirection = (sortOrder)=>{
        switch(sortOrder){
            case 0, $8jOO7.SORT_ASC:
                return 'ascending';
            case 0, $8jOO7.SORT_DESC:
                return 'descending';
            default:
                return 'none';
        }
    };
    const onResizeColumn = (0, $eJOHy.useCallback)((width, resizeMethod)=>{
        if (width === componentColumnWidth) // Skip state updates if column width has not changed
        return;
        setComponentColumnWidth(width);
        const resizeColumnId = column.resizeColumnId ?? column.id;
        onResizeColumnProp && onResizeColumnProp(resizeColumnId, width === column.defaultWidth ? undefined : width);
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'column'
        }), 'issueTable', {
            ...analyticsAttributes,
            resizeMethod: resizeMethod,
            columnWidth: width
        });
    }, [
        componentColumnWidth,
        onResizeColumnProp,
        column.id,
        column.defaultWidth,
        column.resizeColumnId,
        createAnalyticsEvent,
        analyticsAttributes
    ]);
    const onFreezeColumn = (0, $eJOHy.useCallback)(()=>{
        if (column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN)) onFreezeColumnProp?.((0, $j8Km1.MERGED_COLUMN_TYPES).map((fieldSetId)=>({
                fieldSetId: fieldSetId,
                isFrozen: true
            })));
        else onFreezeColumnProp?.([
            {
                fieldSetId: column.id,
                isFrozen: true
            }
        ]);
    }, [
        column.id,
        onFreezeColumnProp
    ]);
    const onUnfreezeColumn = (0, $eJOHy.useCallback)(()=>{
        if (column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN)) onFreezeColumnProp?.((0, $j8Km1.MERGED_COLUMN_TYPES).map((fieldSetId)=>({
                fieldSetId: fieldSetId,
                isFrozen: false
            })));
        else onFreezeColumnProp?.([
            {
                fieldSetId: column.id,
                isFrozen: false
            }
        ]);
    }, [
        column.id,
        onFreezeColumnProp
    ]); // Header actions callbacks
    const onResizeColumnAction = (0, $eJOHy.useCallback)(()=>{
        setIsResizePopupOpen(true);
        if (column.isColumnSticky && additionalStickyColumnsCount > 0 && (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns')) setResizingColumnIndex?.(index);
    }, [
        column.isColumnSticky,
        setResizingColumnIndex,
        index,
        additionalStickyColumnsCount
    ]);
    const onResetColumnWidthAction = (0, $eJOHy.useCallback)(()=>{
        onResizeColumn(column.defaultWidth, 'reset');
    }, [
        onResizeColumn,
        column.defaultWidth
    ]); // Resize popup callbacks
    const onChangeResizePopup = (0, $eJOHy.useCallback)((width)=>{
        (0, $3R7ZX.setCssResizingWidth)(headerCellContainerRef.current, width); // Update CSS offset for other sticky columns to reposition in real-time
        if (tableRef && column.isColumnSticky && additionalStickyColumnsCount > 0 && (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns')) {
            const diffWidth = width - componentColumnWidth;
            (0, $3R7ZX.setCssResizingOffset)(tableRef.current, diffWidth);
        }
    }, [
        tableRef,
        column.isColumnSticky,
        componentColumnWidth,
        additionalStickyColumnsCount
    ]);
    const onCloseResizePopup = (0, $eJOHy.useCallback)((event, overrideKeyboardCheck)=>{
        setIsResizePopupOpen(false);
        (0, $3R7ZX.clearCssResizingWidth)(headerCellContainerRef.current); // Clear resizing state for sticky columns
        if (tableRef && column.isColumnSticky && additionalStickyColumnsCount > 0 && (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns')) {
            setResizingColumnIndex?.(undefined);
            (0, $3R7ZX.clearCssResizingOffset)(tableRef.current);
        } // Focus header cell actions trigger if the resize popup was closed by keyboard
        // navigation or an override was requested
        //
        // `event.detail` docs: https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
        // (click count is 0 when using keyboard to activate a button)
        if (overrideKeyboardCheck === true || event && event.detail === 0) requestAnimationFrame(()=>headerCellActionsTriggerRef.current?.focus());
    }, [
        tableRef,
        column.isColumnSticky,
        setResizingColumnIndex,
        additionalStickyColumnsCount
    ]);
    const onSubmitResizePopup = (0, $eJOHy.useCallback)((width)=>{
        onResizeColumn(width, 'popup'); // No event available from form submission. We will re-focus the actions
        // trigger because submit can't be triggerd by clicking outside of popup,
        // so don't have to worry about stealing focus from what the user clicked
        onCloseResizePopup(undefined, true);
    }, [
        onResizeColumn,
        onCloseResizePopup
    ]); // Resize handle callbacks
    const onMouseEnterResizeHandle = (0, $eJOHy.useCallback)((event)=>{
        // prevent showing the drag & drop/reorder hover effect when resizing
        setIsHovered(false);
        event.stopPropagation();
    }, []);
    const onMouseLeaveResizeHandle = (0, $eJOHy.useCallback)((event)=>{
        // restore header hover state if mouse exits into the header element
        if (state.type !== 'resizing' && (event.relatedTarget === headerCellContainerRef.current || event.relatedTarget instanceof Node && headerCellContainerRef.current?.contains(event.relatedTarget))) setIsHovered(true);
    }, [
        state.type
    ]); // Update column width state if a change is made in the column config
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $4cTDP.fg)('restore-default-width-in-issue-table')) {
            // Consider if `customWidth` doesn't exist, e.g., restore default columns is triggered
            // In this case, use the `defaultWidth` instead
            const nextColumnWidth = isMultiColumnMergedCell ? columnWidth : column.customWidth ?? column.defaultWidth;
            if (prevColumnConfigCustomWidth !== prevColumnCustomWidth && componentColumnWidth !== prevColumnCustomWidth && nextColumnWidth != null) {
                // Update merged cell width state if a change is made in the column config
                if (isMultiColumnMergedCell) setComponentColumnWidth(columnWidth);
                else setComponentColumnWidth(nextColumnWidth);
            }
        } else if (prevColumnConfigCustomWidth !== column.customWidth && componentColumnWidth !== column.customWidth && column.customWidth != null) // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
        setComponentColumnWidth(column.customWidth);
    }, [
        column.customWidth,
        column.defaultWidth,
        prevColumnCustomWidth,
        componentColumnWidth,
        isMultiColumnMergedCell,
        columnWidth,
        prevColumnConfigCustomWidth
    ]);
    const setFocusNone = ()=>{
        /*
    	If drag ends, setFocusNone.
    	if drag never starts but mouse down then back up, setFocusNone.
    	Focus should be yielded back when dragging ends.
    */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const focused = document.activeElement;
        if (!(focused instanceof HTMLElement)) return;
        focused.blur();
    }; // Creates draggable resize handle
    (0, $eJOHy.useEffect)(()=>{
        const resizeHandle = resizeHandleRef.current;
        if (!resizeHandle || isResizePopupOpen) return;
        return (0, $bGx3v.draggable)({
            element: resizeHandle,
            getInitialData () {
                return {
                    operation: (0, $8jOO7.COLUMN_OPERATION_RESIZE),
                    id: column.id
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // we will be moving the line to indicate a drag
                // we can disable the native drag preview
                (0, $92EV7.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                }); // we don't want any native drop animation for when the user
                // does not drop on a drop target. we want the drag to finish immediately
                (0, $ltpqI.preventUnhandled).start();
            },
            onDragStart () {
                setState({
                    type: 'resizing'
                });
                if (column.isColumnSticky && !(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') && (0, $4cTDP.fg)('issue_table_frozen_columns')) setResizingColumnIndex?.(index);
                 // Disable pointer events on the table while dragging in order to prevent buggy hover states in chrome
                // https://issues.chromium.org/issues/41129937#comment43
                (0, $3R7ZX.disableCssPointerEvents)(tableRef?.current);
            },
            onDrag ({ location: location }) {
                //  stickyColumnsWidth - componentColumnWidth + proposedWidth  < tableWidth
                const proposedWidth = isMergedColumn && column.isColumnSticky && (0, $4cTDP.fg)('issue_table_frozen_columns') ? Math.min((0, $3R7ZX.getProposedWidth)({
                    initialWidth: componentColumnWidth,
                    location: location,
                    isCompactColumnEnabled: isCompactColumnEnabled,
                    isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                    isMultiColumnMergedCell: isMultiColumnMergedCell,
                    mergedColumnMinWidth: mergedColumnMinWidth
                }), tableWidth - stickyColumnsWidth + componentColumnWidth - $16f432ebf3f5233a$export$10fece0d97415ebc) : (0, $3R7ZX.getProposedWidth)({
                    initialWidth: componentColumnWidth,
                    location: location,
                    isCompactColumnEnabled: isCompactColumnEnabled,
                    isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                    isMultiColumnMergedCell: isMultiColumnMergedCell,
                    mergedColumnMinWidth: mergedColumnMinWidth
                });
                if (tableRef && column.isColumnSticky && (0, $4cTDP.fg)('issue_table_frozen_columns')) {
                    const diffX = location.current.input.clientX - location.initial.input.clientX; // prevents the offset from being set when the width is already at the maximum width
                    if (additionalStickyColumnsCount > 0 && (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns')) (0, $3R7ZX.setCssResizingOffset)(tableRef.current, proposedWidth - componentColumnWidth);
                    else (0, $3R7ZX.setCssResizingOffset)(tableRef.current, Math.max(proposedWidth - componentColumnWidth, diffX));
                }
                (0, $3R7ZX.setCssResizingWidth)(headerCellContainerRef.current, proposedWidth);
            },
            onDrop ({ location: location }) {
                const proposedWidth = (0, $3R7ZX.getProposedWidth)({
                    initialWidth: componentColumnWidth,
                    location: location,
                    isCompactColumnEnabled: isCompactColumnEnabled,
                    isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                    isMultiColumnMergedCell: isMultiColumnMergedCell,
                    mergedColumnMinWidth: mergedColumnMinWidth
                });
                (0, $ltpqI.preventUnhandled).stop();
                setState({
                    type: 'idle'
                });
                if (tableRef && column.isColumnSticky && (0, $4cTDP.fg)('issue_table_frozen_columns')) {
                    setResizingColumnIndex?.(undefined);
                    (0, $3R7ZX.clearCssResizingOffset)(tableRef.current);
                }
                onResizeColumn(isMergedColumn && column.isColumnSticky && (0, $4cTDP.fg)('issue_table_frozen_columns') ? Math.min(proposedWidth, tableWidth - stickyColumnsWidth + componentColumnWidth - $16f432ebf3f5233a$export$10fece0d97415ebc) : proposedWidth, 'drag-and-drop'); // Re-enable pointer events to restore normal behaviour
                // https://issues.chromium.org/issues/41129937#comment43
                (0, $3R7ZX.enableCssPointerEvents)(tableRef?.current);
                (0, $3R7ZX.clearCssResizingWidth)(headerCellContainerRef.current);
                setFocusNone();
            }
        });
    }, [
        isResizePopupOpen,
        column.id,
        componentColumnWidth,
        tableRef,
        onResizeColumn,
        isCompactColumnEnabled,
        column.type,
        isSingleLineRowHeightEnabled,
        index,
        column.isColumnSticky,
        setResizingColumnIndex,
        isMultiColumnMergedCell,
        stickyColumnsWidth,
        isMergedColumn,
        mergedColumnMinWidth,
        tableWidth,
        additionalStickyColumnsCount
    ]);
    const MaybeSpotlightWrapper = (0, $eJOHy.useCallback)(({ children: children })=>{
        if (isMergedColumn && isStickyColumnsEnabled && (0, $4cTDP.fg)('frozen_columns_onboarding')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$SpotlightWrapper, null, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    }, [
        isMergedColumn,
        isStickyColumnsEnabled
    ]); // #endregion
    // #region Render
    const headerCell = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$export$429fd509d8532e18, {
        ref: headerCellContainerRef,
        scope: "col",
        columnWidth: componentColumnWidth,
        minColumnWidth: !isColumnResizingEnabled ? column.customWidth : undefined,
        isDraggable: isMergedColumn ? (enableDynamicOrderForMergedColumn && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) ?? false : hasColumnConfiguration,
        isHovered: isHovered,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        isFirst: isFirst,
        isLast: isLast,
        index: index,
        ...isInBetweenColumnPickerEnabled && (isInBetweenStickyColumnPickerEnabled && (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') || !(column.isColumnSticky && (0, $4cTDP.fg)('issue_table_frozen_columns'))) && {
            onMouseMove: handleMouseMove
        },
        ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
            onClick: handleMouseClick
        },
        // read as the column title when a user is navigating between columns in the table content.
        "aria-label": column.title,
        visualRefresh: (0, $6XJko.isVisualRefreshEnabled)(),
        isCompactColumnEnabled: isCompactColumnEnabled,
        tableBorderRadius: tableBorderRadius,
        tabIndex: index === 0 ? 0 : -1,
        isResizing: state.type === 'resizing',
        ...isStickyColumnsVisible && (0, $4cTDP.fg)('issue_table_frozen_columns') && {
            isColumnSticky: column.isColumnSticky,
            stickyOffsets: column.stickyOffsets,
            hasRightShadow: column.isLastStickyColumn && scrollLeft > 0,
            isColumnResizing: column.isColumnSticky && (resizingColumnIndex ?? 0) < index
        },
        ...isStickyColumnsVisible && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') && {
            isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled
        },
        "aria-sort": ariaSortDirection(column.currentSorting),
        isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isFrozenColumnsSpotlightVisible: isMergedColumn && isStickyColumnsEnabled && (0, $4cTDP.fg)('frozen_columns_onboarding')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MaybeSpotlightWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        spread: "space-between",
        xcss: [
            state.type === 'reordering' && $16f432ebf3f5233a$var$reorderingStyles,
            isMergedColumn && isStickyColumnsEnabled && (0, $4cTDP.fg)('frozen_columns_onboarding') && $16f432ebf3f5233a$var$spotlightInnerStyles
        ],
        testId: "native-issue-table.ui.issue-table.header.header-cell.header-cell-container-inline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        space: "space.050",
        xcss: $16f432ebf3f5233a$var$overflowHiddenStyles
    }, isIssueHierarchyEnabled && isMergedColumn && (0, $4cTDP.fg)('jsc_list_expand_all') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9iFH8.ExpandAllButton), null), column.warningText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k1Whm.default), {
        tooltip: column.warningText
    }), (0, $4cTDP.fg)('jira_list_merged_column_gate') && column.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$Title, null, column.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2cK5s.HeaderCellActions), {
        column: column,
        previousColumn: previousColumn,
        currentColumnWidth: componentColumnWidth,
        hasColumnConfiguration: isMergedColumn ? (enableDynamicOrderForMergedColumn && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) ?? false : hasColumnConfiguration,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isCompactColumnEnabled: isCompactColumnEnabled,
        isHeaderCellHovered: isHovered,
        isFirst: isFirst,
        isLast: isLast,
        isOpen: isDropdownOpen,
        triggerRef: headerCellActionsTriggerRef,
        isMergedColumn: isMergedColumn,
        enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn,
        onMoveColumn: onMoveColumn,
        onOpenChange: handleDropdownOpenChange,
        onRemoveColumn: onRemoveColumn,
        onResizeColumn: onResizeColumnAction,
        onResetColumnWidth: onResetColumnWidthAction,
        onFreezeColumn: onFreezeColumnProp ? onFreezeColumn : undefined,
        onUnfreezeColumn: onFreezeColumnProp ? onUnfreezeColumn : undefined,
        mergedColumnMinWidth: mergedColumnMinWidth,
        ...(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') && {
            totalMoveableColumns: totalMoveableColumns
        }
    }))), isColumnResizingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4G6Vc.ResizePopup), {
        columnTitle: column.title,
        initialWidth: componentColumnWidth,
        placement: "bottom-start",
        isOpen: isResizePopupOpen,
        isCompactColumnEnabled: isCompactColumnEnabled,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
        trigger: $16f432ebf3f5233a$var$resizePopupTarget,
        onChange: onChangeResizePopup,
        onCancel: onCloseResizePopup,
        onSubmit: onSubmitResizePopup,
        isMultiColumnMergedCell: isMultiColumnMergedCell,
        ...(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') && {
            mergedColumnMinWidth: mergedColumnMinWidth
        }
    }), !isResizePopupOpen && (0, $4cTDP.fg)('use_native_css_to_set_column_resize_handle_height') && (()=>{
        const commonProps = {
            ref: resizeHandleRef,
            isActive: state.type === 'resizing' || columnIndex === index && isInlineFieldCreateHovered && (0, $4cTDP.fg)('jira_inline_field_config_gate'),
            ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
                isHiddenByFrozenColumn: isHiddenByFrozenColumn
            },
            onMouseEnter: onMouseEnterResizeHandle,
            onMouseLeave: onMouseLeaveResizeHandle,
            onDoubleClick: onResetColumnWidthAction,
            onMouseDown: ()=>{
                if (column.isColumnSticky && (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns')) setResizingColumnIndex?.(index);
                setState({
                    type: 'resizing'
                });
            },
            onMouseUp: ()=>{
                if (column.isColumnSticky && (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns')) setResizingColumnIndex?.(undefined);
                setFocusNone();
                setState({
                    type: 'idle'
                });
            },
            'data-testid': 'native-issue-table.ui.issue-table.header.header-cell.resize-handle',
            'data-vc': 'native-issue-table-ui-resize-handle',
            ...isInBetweenColumnPickerEnabled && {
                onMouseMove: (e)=>e.stopPropagation()
            }
        };
        if (!shouldHaveResizeHandle) return;
        return resizeHandleType === (0, $8jOO7.COLUMN_RESIZE_HANDLE_FULL_HEIGHT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$ResizeHandleFullHeight, commonProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$ResizeHandleHeaderOnly, commonProps);
    })(), !isResizePopupOpen && shouldHaveResizeHandle && !(0, $4cTDP.fg)('use_native_css_to_set_column_resize_handle_height') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$ResizeHandleOld, {
        ref: resizeHandleRef,
        height: resizeHandleType === (0, $8jOO7.COLUMN_RESIZE_HANDLE_FULL_HEIGHT) ? height : undefined,
        isActive: state.type === 'resizing' || columnIndex === index && isInlineFieldCreateHovered && (0, $4cTDP.fg)('jira_inline_field_config_gate'),
        ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
            isHiddenByFrozenColumn: isHiddenByFrozenColumn
        },
        onMouseEnter: onMouseEnterResizeHandle,
        onMouseLeave: onMouseLeaveResizeHandle,
        onMouseDown: ()=>{
            if (column.isColumnSticky && (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns')) setResizingColumnIndex?.(index);
            setState({
                type: 'resizing'
            });
        },
        onMouseUp: ()=>{
            if (column.isColumnSticky && (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns')) setResizingColumnIndex?.(undefined);
            setFocusNone();
            setState({
                type: 'idle'
            });
        },
        onDoubleClick: onResetColumnWidthAction,
        "data-testid": "native-issue-table.ui.issue-table.header.header-cell.resize-handle",
        "data-vc": "native-issue-table-ui-resize-handle" /*
                                                                                                                                                                                    * Consumers may currently update non-visual styles dynamically based off height prop.
                                                                                                                                                                                    * Here we allow consumers to exclude the update of height styles from VC calculation.
                                                                                                                                                                                    * Learn more about why this has been introduced https://jplat.atlassian.net/browse/EM-9208
                                                                                                                                                                                    */ ,
        "data-vc-nvs": (0, $4cTDP.fg)('ignore_column_resize_handle'),
        ...isInBetweenColumnPickerEnabled && {
            onMouseMove: (e)=>e.stopPropagation()
        }
    })), dropEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$DropTarget, {
        "data-testid": "native-issue-table.ui.issue-table.header.header-cell.drop-target",
        height: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $igtYB.DropIndicator), {
        edge: dropEdge,
        gap: $16f432ebf3f5233a$var$BORDER_WIDTH,
        type: "no-terminal"
    })), state.type === 'preview' && /*#__PURE__*/ (0, $aQK2r.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$DragPreview, {
        "data-testid": "native-issue-table.ui.issue-table.header.header-cell.drag-preview",
        height: height,
        width: state.previewWidth
    }), state.container)));
    if (isMergedColumn && isStickyColumnsEnabled && (0, $4cTDP.fg)('frozen_columns_onboarding')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: "frozen-columns-onboarding-spotlight"
    }, headerCell);
    return headerCell; // #endregion
};
// #region Styles
/**
 * Invisible element to attach resizing popup to - the intermediate component is required to allow
 * passing the ref while blocking the other props from being passed to the underlying div.
 *
 * This is because the other props are intended for a trigger button, but we are only using this
 * for positioning pourposes.
 */ const $16f432ebf3f5233a$var$resizePopupTarget = ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$ResizePopupTargetDiv, {
        ref: ref
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $16f432ebf3f5233a$var$ResizePopupTargetDiv = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbidpf _4t3iidpf _kqswstnw _1ltvidpf _94n517m2",
            __cmplp.className
        ])
    });
});
const $16f432ebf3f5233a$var$reorderingStyles = (0, $1DXK0.xcss)({
    opacity: 0.4
}); // Add overflow: hidden to the inline div so that the title can collapse its width if needed
// and give space to the right-hand side icons (sort/actions)
const $16f432ebf3f5233a$var$overflowHiddenStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden'
});
const $16f432ebf3f5233a$var$baseHeaderContainerCellStyles = {
    backgroundColor: "var(--ds-surface-sunken, #F8F8F8)",
    borderColor: "var(--ds-border, #0B120E24)",
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderBottomWidth: $16f432ebf3f5233a$var$BORDER_WIDTH,
    borderLeftWidth: 0,
    borderRightWidth: $16f432ebf3f5233a$var$BORDER_WIDTH,
    '&:first-of-type': {
        borderTopLeftRadius: "var(--ds-radius-large, 8px)"
    },
    '&:last-of-type': {
        borderTopRightRadius: "var(--ds-radius-large, 8px)",
        borderRightWidth: 0
    }
};
const $16f432ebf3f5233a$var$baseHeaderContainerCellKeyboardStyles = {
    backgroundColor: "var(--ds-surface-sunken, #F8F8F8)",
    borderColor: "var(--ds-border, #0B120E24)",
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderBottomWidth: $16f432ebf3f5233a$var$BORDER_WIDTH,
    borderLeftWidth: 0,
    borderRightWidth: $16f432ebf3f5233a$var$BORDER_WIDTH,
    '&:focus': {
        outline: 'unset',
        borderRight: `2px solid ${"var(--ds-border-focused, #4688EC)"}`,
        boxShadow: `inset 0 2px 0 0 ${"var(--ds-border-focused, #4688EC)"}`,
        '&:before': {
            content: ' ',
            display: 'block',
            position: 'absolute',
            height: '100%',
            width: '100%',
            top: '-3px',
            left: '-1px',
            right: '-1px',
            bottom: '-1px',
            border: `2px solid ${"var(--ds-border-focused, #4688EC)"}`
        }
    }
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles
const $16f432ebf3f5233a$export$429fd509d8532e18 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isGridNavigationEnabled: isGridNavigationEnabled, isResizing: isResizing, isFirst: isFirst, index: index, tableBorderRadius: tableBorderRadius, columnWidth: columnWidth, minColumnWidth: minColumnWidth, isCompactColumnEnabled: isCompactColumnEnabled, isDraggable: isDraggable, isHovered: isHovered, isSticky: isSticky, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, isColumnResizing: isColumnResizing, isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled, hasRightShadow: hasRightShadow, hasShadow: hasShadow, visualRefresh: visualRefresh, isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled, isFrozenColumnsSpotlightVisible: isFrozenColumnsSpotlightVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_2x37x7": (0, $awdRS.default)(__cmplp.tableBorderRadius ?? "var(--ds-space-100, 8px)"),
            "--_1so474g": (0, $awdRS.default)(__cmplp.columnWidth != null ? `${__cmplp.columnWidth}px` : 'auto'),
            "--_19bvh75": (0, $awdRS.default)(__cmplp.minColumnWidth != null ? `${__cmplp.minColumnWidth}px` : 'auto'),
            "--_sj363t": (0, $awdRS.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            __cmplp.isCompactColumnEnabled && __cmplp.columnWidth && __cmplp.columnWidth < 40 ? '0px' : "var(--ds-space-100, 8px)"),
            "--_hmx90c": (0, $awdRS.default)((0, $johMb.getColumnOffset)(__cmplp.stickyOffsets ?? 0, !!__cmplp.isColumnResizing))
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1rjcze3t _18zru2gc _kqswh2mm _vchhusvi _4t3i1ylp _c71l1ylp _1tke1ylp _s7n4nkob _o5721q9c _1276baal _1bsbdva2 _142idise _1ul9qagj _1rcdhxdp _1lhcu2gc _4x86hxdp _1o59u2gc _1lhcwb8e _1o59wb8e",
            __cmplp.isGridNavigationEnabled ? "_1h6d1l7x _1dqonqa1 _bfhkhfxm _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _nt751r31 _49pcn7od _1hvw1o36 _qzh67g83 _x7uvf705 _1j5l1ule _1qtkstnw _1w0p1osq _18141osq _1cl9j39m _p0vi1n1a _t0aw1n1a _eahy1n1a _7u4s7g83 _7ehicxu3" : "_1h6d1l7x _1dqonqa1 _bfhkhfxm _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _1rcd1mok _4x861mok _1nd4idpf",
            __cmplp.isResizing && __cmplp.isGridNavigationEnabled && "_qzh6n7od _7u4sn7od _7ehin7od",
            __cmplp.isFirst && __cmplp.isGridNavigationEnabled && "_13li1mok _qnecidpf",
            __cmplp.index === 2 && __cmplp.isGridNavigationEnabled && "_1n9didpf _12s81n1a _1hw81n1a _zzeu1n1a _1qc71hup",
            __cmplp.isDraggable && __cmplp.isHovered && "_d0al1qgj _irr319i6",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && "_kqsw1if8 _1pbycs5v",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isSticky && "_1xi2idpf",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isColumnSticky && "_1ltv5eq1",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isAutoUnstickyOnSmallScreenEnabled && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') && __cmplp.isColumnSticky && "_z115qete _16sigrf3",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.hasRightShadow && __cmplp.isAutoUnstickyOnSmallScreenEnabled && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') && "_1mhxgrf3",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.hasRightShadow && "_qc5o6vh0 _1qdg1osq _z0ai1y44 _aetrb3bt _1peq105o _3p6m1vpr _18postnw _32rx1lpd _15l2ze3t",
            __cmplp.hasShadow && "_16qs1omh _t6vd1aa3",
            __cmplp.visualRefresh ? "_11c81vhk _syazazsu" : "_syaz1sqi _k48p1wq8",
            __cmplp.isChildIssuesTableVisualUpliftEnabled && "_bfhkglyw _hr4jidpf",
            __cmplp.isFrozenColumnsSpotlightVisible && "_18zridpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16f432ebf3f5233a$var$Title = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _u5f31b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16f432ebf3f5233a$var$ResizeHandleFullHeight = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, isHiddenByFrozenColumn: isHiddenByFrozenColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18zr1b66 _1y1m1ntv _1bsbyh40 _kqswstnw _154ize3t _1xi213c4 _4t3i1kxc _80omuf7j _1pbykb7n",
            __cmplp.isActive ? "_bfhkq98m" : "_bfhk18uv",
            !__cmplp.isActive && !__cmplp.isHiddenByFrozenColumn && "_irr31ihb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16f432ebf3f5233a$var$ResizeHandleHeaderOnly = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, isHiddenByFrozenColumn: isHiddenByFrozenColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18zr1b66 _1y1m1ntv _1bsbyh40 _kqswstnw _154ize3t _1xi213c4 _4t3i1osq _80omuf7j _1pbykb7n",
            __cmplp.isActive ? "_bfhkq98m" : "_bfhk18uv",
            !__cmplp.isActive && !__cmplp.isHiddenByFrozenColumn && "_irr31ihb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16f432ebf3f5233a$var$ResizeHandleOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, isHiddenByFrozenColumn: isHiddenByFrozenColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10ib6lf": (0, $awdRS.default)(__cmplp.height, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18zr1b66 _1y1m1ntv _1bsbyh40 _kqswstnw _154ize3t _1xi213c4 _80omuf7j _1pbykb7n",
            __cmplp.isActive ? "_bfhkq98m" : "_bfhk18uv",
            __cmplp.height != null ? "_4t3it1jn" : "_4t3i1osq",
            !__cmplp.isActive && !__cmplp.isHiddenByFrozenColumn && "_irr31ihb",
            __cmplp.className
        ])
    });
}); // Invisible box surrounding the full column for the `DropIndicator` to attach to
const $16f432ebf3f5233a$var$DropTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $awdRS.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154ize3t _1ltvze3t _4t3i2nrh _1bsb1osq",
            __cmplp.className
        ])
    });
}); // Custom drag preview that looks like a ghost blue column
const $16f432ebf3f5233a$var$DragPreview = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $awdRS.default)(`${__cmplp.height}px`),
            "--_6f8077": (0, $awdRS.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko12b0 _1h6d1v1w _1dqonqa1 _189edkaa _4t3i2nrh _c71l1kxc _1bsb1hdq _bfhk7wq0",
            __cmplp.className
        ])
    });
});
const $16f432ebf3f5233a$var$spotlightWrapperStyles = null;
const $16f432ebf3f5233a$var$spotlightInnerStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("k1Whm", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d54147c849a5eab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $d8UFE = parcelRequire("d8UFE");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $i2rto = parcelRequire("i2rto");
const $0d54147c849a5eab$var$WarningIndicator = ({ tooltip: tooltip })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0d54147c849a5eab$var$WarningIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8UFE))), {
        label: formatMessage((0, $i2rto.default).warningLabel),
        color: "var(--ds-icon-warning, #E06C00)"
    })));
};
var $0d54147c849a5eab$export$2e2bcd8739ae039 = $0d54147c849a5eab$var$WarningIndicator;
const $0d54147c849a5eab$var$HEADER_CELL_HEIGHT = 28; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0d54147c849a5eab$var$WarningIconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwxv77o _4t3i1f4h _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i2rto", function(module, exports) {
$parcel$export(module.exports, "default", () => $072fd65944448136$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $072fd65944448136$var$messages = (0, $7qGN1.defineMessages)({
    warningLabel: {
        "id": "native-issue-table.common.warning-indicator.warning-label",
        "defaultMessage": "Warning"
    }
});
var $072fd65944448136$export$2e2bcd8739ae039 = $072fd65944448136$var$messages;

});


parcelRegister("2cK5s", function(module, exports) {
$parcel$export(module.exports, "HeaderCellActions", () => $5f46d7781007ccd9$export$1d48fcee1df11ffa);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $5V25X = parcelRequire("5V25X");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $czQLf = parcelRequire("czQLf");

var $ieul7 = parcelRequire("ieul7");
const $5f46d7781007ccd9$export$1d48fcee1df11ffa = ({ column: column, previousColumn: previousColumn, currentColumnWidth: currentColumnWidth, hasColumnConfiguration: hasColumnConfiguration, isColumnResizingEnabled: isColumnResizingEnabled, isCompactColumnEnabled: isCompactColumnEnabled = false, isHeaderCellHovered: isHeaderCellHovered, isFirst: isFirst, isLast: isLast, isOpen: isOpen, triggerRef: triggerRef = null, isMergedColumn: isMergedColumn = false, enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn = false, onMoveColumn: onMoveColumn, onOpenChange: onOpenChange, onRemoveColumn: onRemoveColumn, onResizeColumn: onResizeColumn, onFreezeColumn: onFreezeColumn, onUnfreezeColumn: onUnfreezeColumn, onResetColumnWidth: onResetColumnWidth, mergedColumnMinWidth: mergedColumnMinWidth, totalMoveableColumns: totalMoveableColumns })=>{
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const onFocus = (0, $eJOHy.useCallback)(()=>{
        setIsFocused(true);
    }, []);
    const onBlur = (0, $eJOHy.useCallback)(()=>{
        setIsFocused(false);
    }, []);
    const isSortable = column.onSortOrderChanged !== undefined && column.isSortable;
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    // Header actions width must be static when fixed table layout is disabled to prevent column
    // widths shifting as the user hovers the table header
    const isStaticWidth = !isFixedTableLayoutEnabled;
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const isStickyColumnsEnabled = (0, $34oCh.useIsStickyColumnsEnabled)();
    const { isActive: isSpotlightVisible } = (0, $4cTDP.fg)('frozen_columns_onboarding') ? (0, $5V25X.useTrigger)(isMergedColumn && isStickyColumnsEnabled ? 'frozen-columns-onboarding-is-spotlight-visible' : undefined) : {
        isActive: false
    };
    let minimumColumnWidth;
    if (isMergedColumn && column.mergedColumns && column.mergedColumns.length > 1) minimumColumnWidth = mergedColumnMinWidth || (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH);
    else minimumColumnWidth = isSingleLineRowHeightEnabled ? (0, $8jOO7.SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH) : (0, $8jOO7.MINIMUM_COLUMN_WIDTH);
    if (!isSortable && !hasColumnConfiguration && !isColumnResizingEnabled) return null;
    const isMoreActionsVisible = isHeaderCellHovered || isOpen || isFocused || isSpotlightVisible;
    const isSorted = column.currentSorting === (0, $8jOO7.SORT_ASC) || column.currentSorting === (0, $8jOO7.SORT_DESC);
    const isSortVisible = isMoreActionsVisible || isSorted;
    const isSortOnlyAction = isSortable && !hasColumnConfiguration && !isColumnResizingEnabled;
    const sortButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $5f46d7781007ccd9$var$baseStyles,
            !isSortVisible && $5f46d7781007ccd9$var$hiddenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ieul7.SortButton), {
        column: column,
        onFocus: onFocus,
        onBlur: onBlur
    }));
    const moreActionsButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $5f46d7781007ccd9$var$baseStyles,
            !isMoreActionsVisible && $5f46d7781007ccd9$var$hiddenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $czQLf.MoreActions), {
        column: column,
        previousColumn: previousColumn,
        currentColumnWidth: currentColumnWidth,
        hasColumnConfiguration: hasColumnConfiguration,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isFirst: isFirst,
        isLast: isLast,
        isOpen: isOpen,
        triggerRef: triggerRef,
        isMergedColumn: isMergedColumn,
        enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn,
        onMoveColumn: onMoveColumn,
        onOpenChange: onOpenChange,
        onRemoveColumn: onRemoveColumn,
        onResizeColumn: onResizeColumn,
        onFreezeColumn: onFreezeColumn,
        onUnfreezeColumn: onUnfreezeColumn,
        onResetColumnWidth: onResetColumnWidth,
        onFocus: onFocus,
        onBlur: onBlur,
        ...(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') && {
            totalMoveableColumns: totalMoveableColumns
        }
    }));
    if (isSortOnlyAction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: [
            $5f46d7781007ccd9$var$containerStyles,
            isStaticWidth && $5f46d7781007ccd9$var$singleButtonWidth
        ]
    }, sortButton);
    if (!isSortable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: [
            $5f46d7781007ccd9$var$containerStyles,
            isStaticWidth && $5f46d7781007ccd9$var$singleButtonWidth
        ]
    }, moreActionsButton);
    if (isCompactColumnEnabled && currentColumnWidth < minimumColumnWidth) {
        if (column.currentSorting !== (0, $8jOO7.SORT_NONE) && !isHeaderCellHovered) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            xcss: [
                $5f46d7781007ccd9$var$containerStyles,
                isStaticWidth && $5f46d7781007ccd9$var$singleButtonWidth
            ]
        }, sortButton);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            xcss: [
                $5f46d7781007ccd9$var$containerStyles,
                isStaticWidth && $5f46d7781007ccd9$var$singleButtonWidth
            ]
        }, moreActionsButton);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignInline: isStaticWidth ? 'end' : undefined,
        xcss: [
            $5f46d7781007ccd9$var$containerStyles,
            // Animate between single and all button width when sorted (only when in a dynamic layout)
            !isStaticWidth && isSorted && $5f46d7781007ccd9$var$singleButtonWidth,
            (isStaticWidth || isMoreActionsVisible) && $5f46d7781007ccd9$var$allButtonsWidth
        ]
    }, sortButton, moreActionsButton);
};
const $5f46d7781007ccd9$var$containerStyles = (0, $1DXK0.xcss)({
    gap: 'space.050',
    transition: 'width .25s'
});
const $5f46d7781007ccd9$var$singleButtonWidth = (0, $1DXK0.xcss)({
    width: '24px'
});
const $5f46d7781007ccd9$var$allButtonsWidth = (0, $1DXK0.xcss)({
    width: '52px'
});
const $5f46d7781007ccd9$var$baseStyles = (0, $1DXK0.xcss)({
    transition: 'opacity .25s'
});
const $5f46d7781007ccd9$var$hiddenStyles = (0, $1DXK0.xcss)({
    clip: 'rect(1px, 1px, 1px, 1px)',
    clipPath: 'inset(50%)',
    height: '1px',
    width: '1px',
    margin: 'space.negative.025',
    overflow: 'hidden',
    padding: 'space.0',
    opacity: 0,
    position: 'absolute',
    pointerEvents: 'none'
});

});
parcelRegister("czQLf", function(module, exports) {
$parcel$export(module.exports, "MoreActions", () => $356971f4066577c6$export$f2f44eb5b71ba65f);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $NByNW = parcelRequire("NByNW");

var $goZPP = parcelRequire("goZPP");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $8Y8kU = parcelRequire("8Y8kU");
var $880Uc = parcelRequire("880Uc");

var $xEGV6 = parcelRequire("xEGV6");

var $cQxBL = parcelRequire("cQxBL");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $4B7rn = parcelRequire("4B7rn");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $bzbsd = parcelRequire("bzbsd");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $lpMrC = parcelRequire("lpMrC");

var $j8Km1 = parcelRequire("j8Km1");

var $3mZMJ = parcelRequire("3mZMJ");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $pZqvR = parcelRequire("pZqvR");

var $cEWre = parcelRequire("cEWre");

var $cgCO4 = parcelRequire("cgCO4");

var $fn6we = parcelRequire("fn6we");

var $9sCxj = parcelRequire("9sCxj");
const $356971f4066577c6$var$NestedSortingDropdown = ({ column: column, customMessage: customMessage, onOpenChange: onOpenChange })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const sortAsc = (0, $eJOHy.useCallback)(()=>{
        column.onSortOrderChanged?.(column.jqlTerm, (0, $8jOO7.SORT_ASC), (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? column.aliases : undefined);
        onOpenChange(false);
    }, [
        column,
        onOpenChange
    ]);
    const sortDesc = (0, $eJOHy.useCallback)(()=>{
        column.onSortOrderChanged?.(column.jqlTerm, (0, $8jOO7.SORT_DESC), (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? column.aliases : undefined);
        onOpenChange(false);
    }, [
        column,
        onOpenChange
    ]);
    let title = column.title;
    if (column.currentSorting === (0, $8jOO7.SORT_ASC) && column.ascText) title = `${column.title}: ${formatMessage((0, $9sCxj.default).sortDirection, {
        sortDescription: column.ascText
    })}`;
    else if (column.currentSorting === (0, $8jOO7.SORT_DESC) && column.descText) title = `${column.title}: ${formatMessage((0, $9sCxj.default).sortDirection, {
        sortDescription: column.descText
    })}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        placement: "right-start",
        // We should also enable shouldRenderToParent only in Chrome nested dropdown menu.
        // Mismatched `shouldRenderToParent` settings between parent and nested dropdowns
        // can break the nested menu behavior.
        shouldRenderToParent: (0, $lpMrC.isChrome)(),
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
                ...triggerProps,
                ref: triggerRef,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                    size: "small",
                    spacing: "spacious",
                    label: ""
                })
            }, title)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "sortAsc",
        onClick: sortAsc,
        isSelected: column.currentSorting === (0, $8jOO7.SORT_ASC),
        fieldType: column.type
    }, column.ascText ?? false ? formatMessage(customMessage, {
        sortDescription: column.ascText
    }) : formatMessage((0, $9sCxj.default).sortAsc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "sortDesc",
        onClick: sortDesc,
        isSelected: column.currentSorting === (0, $8jOO7.SORT_DESC),
        fieldType: column.type
    }, column.descText ?? false ? formatMessage(customMessage, {
        sortDescription: column.descText
    }) : formatMessage((0, $9sCxj.default).sortDesc))));
};
const $356971f4066577c6$var$FreezeColumnOption = ({ isColumnSticky: isColumnSticky, isSortable: isSortable, hasColumnConfiguration: hasColumnConfiguration, shouldShowNestedSorting: shouldShowNestedSorting, onFreezeColumn: onFreezeColumn, onUnfreezeColumn: onUnfreezeColumn })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isAutoUnstickyOnSmallScreenEnabled = (0, $34oCh.useIsAutoUnstickyOnSmallScreenEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        hasSeparator: isSortable || hasColumnConfiguration || shouldShowNestedSorting
    }, isAutoUnstickyOnSmallScreenEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $880Uc.Show), {
        below: "md",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "freezeColumn",
        onClick: onFreezeColumn,
        isDisabled: true
    }, formatMessage((0, $9sCxj.default).freezeColumn))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Y8kU.Hide), {
        below: "md",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: isColumnSticky ? 'unfreezeColumn' : 'freezeColumn',
        onClick: isColumnSticky ? onUnfreezeColumn : onFreezeColumn
    }, formatMessage(isColumnSticky ? (0, $9sCxj.default).unfreezeColumn : (0, $9sCxj.default).freezeColumn)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: isColumnSticky ? 'unfreezeColumn' : 'freezeColumn',
        onClick: isColumnSticky ? onUnfreezeColumn : onFreezeColumn
    }, formatMessage(isColumnSticky ? (0, $9sCxj.default).unfreezeColumn : (0, $9sCxj.default).freezeColumn)));
};
const $356971f4066577c6$export$f2f44eb5b71ba65f = ({ column: column, previousColumn: previousColumn, currentColumnWidth: currentColumnWidth, hasColumnConfiguration: hasColumnConfiguration, isColumnResizingEnabled: isColumnResizingEnabled, isMergedColumn: isMergedColumn, enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn, isFirst: isFirst, isLast: isLast, isOpen: isOpen, triggerRef: triggerRef = null, onMoveColumn: onMoveColumn, onOpenChange: onOpenChange, onRemoveColumn: onRemoveColumn, onResizeColumn: onResizeColumn, onFreezeColumn: onFreezeColumn, onUnfreezeColumn: onUnfreezeColumn, onResetColumnWidth: onResetColumnWidth, onFocus: onFocus, onBlur: onBlur, totalMoveableColumns: totalMoveableColumns })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const isRemoveColumnEnabled = (0, $4cTDP.fg)('jira_issue_table_remove_column_check') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $34oCh.useIsRemoveColumnEnabled)() : true;
    const { ifcConfig: ifcConfig } = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $pZqvR.useIFCConfigContext)() : {
        ifcConfig: null
    };
    const editField = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $cEWre.useIFCEditField)() : undefined;
    const sortAsc = (0, $eJOHy.useCallback)(()=>{
        column.onSortOrderChanged?.(column.jqlTerm, (0, $8jOO7.SORT_ASC), (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? column.aliases : undefined);
    }, [
        column
    ]);
    const sortDesc = (0, $eJOHy.useCallback)(()=>{
        column.onSortOrderChanged?.(column.jqlTerm, (0, $8jOO7.SORT_DESC), (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? column.aliases : undefined);
    }, [
        column
    ]);
    const clearSorting = (0, $eJOHy.useCallback)(()=>{
        if (isMergedColumn) column.mergedColumns?.forEach((mergedColumn)=>{
            if (mergedColumn.currentSorting && mergedColumn.currentSorting !== (0, $8jOO7.SORT_NONE)) mergedColumn.onSortOrderChanged?.(mergedColumn.jqlTerm, (0, $8jOO7.SORT_NONE), (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? mergedColumn.aliases : undefined);
        });
        else column.onSortOrderChanged?.(column.jqlTerm, (0, $8jOO7.SORT_NONE), (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? column.aliases : undefined);
    }, [
        column,
        isMergedColumn
    ]);
    const handleOnOpenChange = (0, $eJOHy.useCallback)(({ isOpen: newIsOpen })=>{
        if (newIsOpen) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'dropdown'
        }), 'issueTableHeaderActions');
        onOpenChange(newIsOpen);
    }, [
        createAnalyticsEvent,
        onOpenChange
    ]);
    const mergedColumns = column.mergedColumns ?? [];
    const shouldShowNestedSorting = isTimelineEnabled || (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_issue_table_updates') ? Boolean(isMergedColumn && mergedColumns.length > 1) && // Ensure that merged columns are sortable before showing the dropdown item group
    mergedColumns.some((mergedCol)=>mergedCol.isSortable && mergedCol.onSortOrderChanged) : Boolean(isMergedColumn && mergedColumns.length > 1);
    const fieldType = Boolean(isMergedColumn) && mergedColumns.length === 1 && (0, $4cTDP.fg)('jira_list_merged_column_gate') ? mergedColumns[0]?.type : undefined;
    const isColumnSortable = (0, $eJOHy.useCallback)((col)=>Boolean(!!col.onSortOrderChanged && col.isSortable), []);
    let isSortable = isColumnSortable(column);
    if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) isSortable = isColumnSortable(column) || Boolean(isMergedColumn && !shouldShowNestedSorting && column.mergedColumns?.some(isColumnSortable));
    let isMergedColumnEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnEnabled = (0, $34oCh.useIsMergedColumnEnabled)();
    let isStickyColumnsEnabled = false;
    if ((0, $4cTDP.fg)('issue_table_frozen_columns')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isStickyColumnsEnabled = (0, $34oCh.useIsStickyColumnsEnabled)();
    let isSmallScreen = false;
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $4cTDP.fg)('issue_table_frozen_columns') && !(0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { isSmallScreen: smallScreen } = (0, $cgCO4.useShouldApplyFrozenColumns)();
        isSmallScreen = smallScreen;
    }
    let canMoveColumnLeft = true;
    if (isMergedColumnEnabled && previousColumn) {
        if ((0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) canMoveColumnLeft = enableDynamicOrderForMergedColumn ? true : previousColumn?.id !== (0, $j8Km1.COLUMN_ID_MERGED_COLUMN);
        else canMoveColumnLeft = previousColumn?.id !== (0, $j8Km1.COLUMN_ID_MERGED_COLUMN);
    }
    const triggerLabel = formatMessage((0, $9sCxj.default).columnActions, {
        column: column.title
    });
    // Ensure a stable ref function is passed through to the trigger button
    const memoizedMergeRefs = (0, $eJOHy.useMemo)(()=>(0, $LFmXM.default)((0, $bzbsd.mergeRefs)), []);
    const customMessage = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $9sCxj.default).sortCustomNew : (0, $9sCxj.default).sortCustom;
    const shouldShowRemoveColumnOption = (0, $4cTDP.fg)('jira_issue_table_remove_column_check') ? hasColumnConfiguration && isRemoveColumnEnabled : hasColumnConfiguration;
    const isCategoryField = column.type === (0, $3mZMJ.CATEGORY_TYPE);
    /*
  	The JWM category field is a bit of a snowflake as it can be used in CMP projects but doesn't support configuration
  	in global admin.
  	We include this exception here to allow the category field to be updated through inline field configuration as an
  	intermediate measure as category will be decommissioned and replaced with the single select custom field type (at
  	which point this condition can be removed).
  	This is supported in IFC as we call bespoke APIs for updating the category field that support
  	CMP projects.
   */ const isIfcConfigEnabledNew = ifcConfig?.isEnabledForProject || ifcConfig?.isEnabledForCategoryField && isCategoryField;
    const isIfcConfigEnabled = (0, $4cTDP.fg)('jsc_list_category_editing_in_nin') ? isIfcConfigEnabledNew : ifcConfig?.IFCTriggerRef;
    // Action dropdown only displays Move column to the last position and Move Column to the first position for 3 or more columns
    const hasMoveToFirstAndLastOptions = (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? totalMoveableColumns && totalMoveableColumns > 2 : true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        testId: "native-issue-table.ui.issue-table.header.header-cell.header-cell-actions.more-actions.dropdown-menu",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        placement: "bottom-start",
        trigger: ({ triggerRef: dropdownTriggerRef, ...triggerProps })=>(0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                ...triggerProps,
                ref: memoizedMergeRefs(dropdownTriggerRef, triggerRef),
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                        ...iconProps,
                        size: "small"
                    }),
                label: triggerLabel,
                onFocus: onFocus,
                onBlur: onBlur,
                isTooltipDisabled: false,
                spacing: "compact",
                appearance: "subtle",
                testId: "native-issue-table.ui.issue-table.header.header-cell.header-cell-actions.more-actions.icon-button"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                content: triggerLabel,
                delay: 0,
                ignoreTooltipPointerEvents: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $356971f4066577c6$var$triggerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...triggerProps,
                ref: memoizedMergeRefs(dropdownTriggerRef, triggerRef),
                appearance: "subtle",
                spacing: "compact",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($xEGV6))), {
                    label: triggerLabel
                }),
                onFocus: onFocus,
                onBlur: onBlur
            }))),
        // We should only enable shouldRenderToParent in Chrome.
        // Safari and Firefox can clip elements inside a `position: sticky` container if the container isn’t tall enough.
        // This affects dropdowns rendered inside sticky table headers.
        shouldRenderToParent: (0, $lpMrC.isChrome)()
    }, isSortable && !shouldShowNestedSorting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, column.currentSorting !== (0, $8jOO7.SORT_ASC) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "sortAsc",
        onClick: sortAsc,
        fieldType: fieldType
    }, column.ascText ?? false ? formatMessage(customMessage, {
        sortDescription: column.ascText
    }) : formatMessage((0, $9sCxj.default).sortAsc)), column.currentSorting !== (0, $8jOO7.SORT_DESC) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "sortDesc",
        onClick: sortDesc,
        fieldType: fieldType
    }, column.descText ?? false ? formatMessage(customMessage, {
        sortDescription: column.descText
    }) : formatMessage((0, $9sCxj.default).sortDesc)), column.currentSorting !== (0, $8jOO7.SORT_NONE) && (0, $4cTDP.fg)('jsc_list_reranking_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "clearSorting",
        onClick: clearSorting,
        fieldType: fieldType
    }, formatMessage((0, $9sCxj.default).clearSorting))), shouldShowNestedSorting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        title: formatMessage((0, $9sCxj.default).sortByColumns)
    }, mergedColumns.map((mergedColumn)=>isTimelineEnabled || (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_issue_table_updates') ? // Ensure that the column is sortable
        mergedColumn.isSortable && mergedColumn.onSortOrderChanged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($356971f4066577c6$var$NestedSortingDropdown, {
            key: mergedColumn.id,
            column: mergedColumn,
            customMessage: customMessage,
            onOpenChange: onOpenChange
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($356971f4066577c6$var$NestedSortingDropdown, {
            key: mergedColumn.id,
            column: mergedColumn,
            customMessage: customMessage,
            onOpenChange: onOpenChange
        })), mergedColumns.some((col)=>col.currentSorting && col.currentSorting !== (0, $8jOO7.SORT_NONE)) && (0, $4cTDP.fg)('jsc_list_reranking_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "clearSorting",
        onClick: clearSorting
    }, formatMessage((0, $9sCxj.default).clearSorting))), hasColumnConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        hasSeparator: isSortable
    }, !isFirst && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (!isMergedColumnEnabled || canMoveColumnLeft && (0, $4cTDP.fg)('jira_list_merged_column_move_first')) && hasMoveToFirstAndLastOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "moveColumnFirst",
        onClick: ()=>onMoveColumn((0, $8jOO7.MOVE_COLUMN_FIRST))
    }, (0, $4cTDP.fg)('jira_inline_field_config_gate') ? formatMessage((0, $9sCxj.default).moveFirstNew) : formatMessage((0, $9sCxj.default).moveFirst)), canMoveColumnLeft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "moveColumnLeft",
        onClick: ()=>onMoveColumn((0, $8jOO7.MOVE_COLUMN_LEFT))
    }, (0, $4cTDP.fg)('jira_inline_field_config_gate') ? formatMessage((0, $9sCxj.default).moveLeftNew) : formatMessage((0, $9sCxj.default).moveLeft))), !isLast && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "moveColumnRight",
        onClick: ()=>onMoveColumn((0, $8jOO7.MOVE_COLUMN_RIGHT))
    }, (0, $4cTDP.fg)('jira_inline_field_config_gate') ? formatMessage((0, $9sCxj.default).moveRightNew) : formatMessage((0, $9sCxj.default).moveRight)), hasMoveToFirstAndLastOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "moveColumnLast",
        onClick: ()=>onMoveColumn((0, $8jOO7.MOVE_COLUMN_LAST))
    }, (0, $4cTDP.fg)('jira_inline_field_config_gate') ? formatMessage((0, $9sCxj.default).moveLastNew) : formatMessage((0, $9sCxj.default).moveLast))), shouldShowRemoveColumnOption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "removeColumn",
        onClick: onRemoveColumn
    }, formatMessage((0, $9sCxj.default).removeColumn))), // eslint-disable-next-line jira/ff/no-preconditioning
    isStickyColumnsEnabled && isMergedColumn && onUnfreezeColumn && onFreezeColumn && (0, $4cTDP.fg)('issue_table_frozen_columns') && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($356971f4066577c6$var$FreezeColumnOption, {
        onFreezeColumn: onFreezeColumn,
        onUnfreezeColumn: onUnfreezeColumn,
        isColumnSticky: column.isColumnSticky,
        isSortable: isSortable,
        hasColumnConfiguration: hasColumnConfiguration,
        shouldShowNestedSorting: shouldShowNestedSorting
    }), // eslint-disable-next-line jira/ff/no-preconditioning
    isStickyColumnsEnabled && isMergedColumn && onUnfreezeColumn && onFreezeColumn && (0, $4cTDP.fg)('issue_table_frozen_columns') && !(0, $4cTDP.fg)('jira_list_frozen_column_bugfix') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        hasSeparator: isSortable || hasColumnConfiguration || shouldShowNestedSorting
    }, isSmallScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "freezeColumn",
        onClick: onFreezeColumn,
        isDisabled: true
    }, formatMessage((0, $9sCxj.default).freezeColumn)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: column.isColumnSticky ? 'unfreezeColumn' : 'freezeColumn',
        onClick: column.isColumnSticky ? onUnfreezeColumn : onFreezeColumn
    }, formatMessage(column.isColumnSticky ? (0, $9sCxj.default).unfreezeColumn : (0, $9sCxj.default).freezeColumn))), isColumnResizingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        hasSeparator: isMergedColumn && (0, $4cTDP.fg)('issue_table_frozen_columns') ? false : isSortable || hasColumnConfiguration || shouldShowNestedSorting
    }, isMergedColumn && (0, $4cTDP.fg)('issue_table_frozen_columns'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "resizeColumn",
        onClick: onResizeColumn
    }, formatMessage((0, $9sCxj.default).resizeColumn)), currentColumnWidth != null && currentColumnWidth !== column.defaultWidth && !isMergedColumn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "resetColumnWidth",
        onClick: onResetColumnWidth
    }, formatMessage((0, $9sCxj.default).resetColumnWidth))), isInlineFieldConfigEnabled && column.configureableFieldId && ifcConfig && isIfcConfigEnabled && editField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ifcConfig.IFCTriggerRef, null, ({ triggerRef: ifcTriggerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
            ref: ifcTriggerRef,
            actionType: "editField",
            onClick: ()=>{
                if (column.configureableFieldId) editField(column.configureableFieldId, column.id);
            }
        }, formatMessage((0, $9sCxj.default).editField)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null));
};
const $356971f4066577c6$var$triggerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    height: '24px',
    width: '24px'
});

});
parcelRegister("8Y8kU", function(module, exports) {
$parcel$export(module.exports, "Hide", () => $ac5f46d65a30da5a$export$bed28288a051538);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");

var $1DXK0 = parcelRequire("1DXK0");

var $j14qM = parcelRequire("j14qM");
const $ac5f46d65a30da5a$var$hideAboveQueries = (0, $j14qM.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $ac5f46d65a30da5a$var$hideBelowQueries = (0, $j14qM.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $ac5f46d65a30da5a$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1DXK0.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $1NIU8.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $ac5f46d65a30da5a$var$hideAboveQueries[above],
            below && $ac5f46d65a30da5a$var$hideBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};

});
parcelRegister("j14qM", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $58139abb853d4481$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $58139abb853d4481$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $fvncH = parcelRequire("fvncH");

var $6efFi = parcelRequire("6efFi");
const $58139abb853d4481$export$918f8818cfbbeb2c = (input)=>{
    return (0, $fvncH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $6efFi.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $58139abb853d4481$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $fvncH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $6efFi.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("fvncH", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $5a3422a08c082ecc$export$2d293d9871c38e91);
const $5a3422a08c082ecc$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $5a3422a08c082ecc$export$2d293d9871c38e91 = Object.keys($5a3422a08c082ecc$export$e5ee4fe8b989fd09);
const $5a3422a08c082ecc$export$b7ed752a57b4177b = $5a3422a08c082ecc$export$2d293d9871c38e91[0];

});



parcelRegister("880Uc", function(module, exports) {
$parcel$export(module.exports, "Show", () => $f800bab042621a59$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");

var $1DXK0 = parcelRequire("1DXK0");

var $j14qM = parcelRequire("j14qM");
function $f800bab042621a59$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f800bab042621a59$var$showAboveQueries = (0, $j14qM.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $f800bab042621a59$var$showBelowQueries = (0, $j14qM.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $f800bab042621a59$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $f800bab042621a59$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1DXK0.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $1NIU8.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $f800bab042621a59$var$defaultHiddenStyles,
            above && $f800bab042621a59$var$showAboveQueries[above],
            below && $f800bab042621a59$var$showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};

});

parcelRegister("xEGV6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c71f464f0a68ac13cf34d8bdc60b231>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0652a59e631f32d8$var$_react = $0652a59e631f32d8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0652a59e631f32d8$var$_baseNew = $0652a59e631f32d8$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0652a59e631f32d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus, traditionally on mobile.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0652a59e631f32d8$var$ShowMoreVerticalIcon = (props)=>/*#__PURE__*/ $0652a59e631f32d8$var$_react.default.createElement($0652a59e631f32d8$var$_baseNew.default, Object.assign({
        name: "ShowMoreVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.5 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$0652a59e631f32d8$var$ShowMoreVerticalIcon.displayName = 'ShowMoreVerticalIcon';
var $0652a59e631f32d8$var$_default = module.exports.default = $0652a59e631f32d8$var$ShowMoreVerticalIcon;

});

parcelRegister("fn6we", function(module, exports) {
$parcel$export(module.exports, "ActionItem", () => $b29831993dcd24a9$export$ac06cb4ab481cfab);

var $eJOHy = parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");
const $b29831993dcd24a9$export$841c406d190a3baa = ({ actionType: actionType, fieldType: fieldType, children: children, isSelected: isSelected = false, isDisabled: isDisabled = false, onClick: onClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'issueTableHeaderActions', {
            actionType: actionType,
            fieldType: (0, $4cTDP.fg)('jira_list_merged_column_gate') ? fieldType : undefined
        });
        onClick();
    }, [
        actionType,
        fieldType,
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        onClick: handleOnClick,
        isSelected: isSelected,
        ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
            isDisabled: isDisabled
        }
    }, children);
};
const $b29831993dcd24a9$export$ec2208c4baf896f0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ actionType: actionType, fieldType: fieldType, children: children, isSelected: isSelected = false, isDisabled: isDisabled = false, onClick: onClick }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'issueTableHeaderActions', {
            actionType: actionType,
            fieldType: (0, $4cTDP.fg)('jira_list_merged_column_gate') ? fieldType : undefined
        });
        onClick();
    }, [
        actionType,
        fieldType,
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        ref: ref,
        onClick: handleOnClick,
        isSelected: isSelected,
        ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
            isDisabled: isDisabled
        }
    }, children);
});
const $b29831993dcd24a9$export$ac06cb4ab481cfab = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jira_inline_field_config_gate'), $b29831993dcd24a9$export$ec2208c4baf896f0, $b29831993dcd24a9$export$841c406d190a3baa);

});

parcelRegister("9sCxj", function(module, exports) {
$parcel$export(module.exports, "default", () => $6cda8b0f41e72a74$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6cda8b0f41e72a74$var$messages = (0, $7qGN1.defineMessages)({
    columnActions: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.column-actions",
        "defaultMessage": "More actions for {column}"
    },
    sortAsc: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-asc",
        "defaultMessage": "Sort in ascending order"
    },
    sortDesc: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-desc",
        "defaultMessage": "Sort in descending order"
    },
    sortCustom: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-custom",
        "defaultMessage": "Sort {sortDescription}"
    },
    sortCustomNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-custom-new",
        "defaultMessage": "Sort {sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}"
    },
    sortDirection: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-direction",
        "defaultMessage": "{sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}"
    },
    clearSorting: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.clear-sorting",
        "defaultMessage": "Clear sorting"
    },
    sortByColumns: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-by-columns",
        "defaultMessage": "Sort by columns"
    },
    moveFirst: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-first",
        "defaultMessage": "Move column to the first position"
    },
    moveLeft: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-left",
        "defaultMessage": "Move column to the left"
    },
    moveRight: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-right",
        "defaultMessage": "Move column to the right"
    },
    moveLast: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-last",
        "defaultMessage": "Move column to the last position"
    },
    moveFirstNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-first-new",
        "defaultMessage": "Move column to first position"
    },
    moveLeftNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-left-new",
        "defaultMessage": "Move column to left"
    },
    moveRightNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-right-new",
        "defaultMessage": "Move column to right"
    },
    moveLastNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-last-new",
        "defaultMessage": "Move column to last position"
    },
    removeColumn: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.remove-column",
        "defaultMessage": "Remove column"
    },
    resizeColumn: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.resize-column",
        "defaultMessage": "Resize column"
    },
    resetColumnWidth: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.reset-column-width",
        "defaultMessage": "Reset column width"
    },
    editField: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.edit-field",
        "defaultMessage": "Edit field"
    },
    freezeColumn: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.freeze-column",
        "defaultMessage": "Freeze column"
    },
    unfreezeColumn: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.unfreeze-column",
        "defaultMessage": "Unfreeze column"
    }
});
var $6cda8b0f41e72a74$export$2e2bcd8739ae039 = $6cda8b0f41e72a74$var$messages;

});


parcelRegister("ieul7", function(module, exports) {
$parcel$export(module.exports, "SortButton", () => $dc75ba32cd925e8e$export$e464399b18ba2124);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $Ay1uj = parcelRequire("Ay1uj");

var $8Gywp = parcelRequire("8Gywp");

var $aDbql = parcelRequire("aDbql");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $4cTDP = parcelRequire("4cTDP");

var $j8Km1 = parcelRequire("j8Km1");

var $8jOO7 = parcelRequire("8jOO7");

var $dIts6 = parcelRequire("dIts6");
const $dc75ba32cd925e8e$var$ConditionalIconContainer = ({ children: children })=>{
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $dc75ba32cd925e8e$var$iconContainerStyles
    }, children, " ");
    return children;
};
const $dc75ba32cd925e8e$var$useAccessibleLabel = ({ ascText: ascText, currentSorting: currentSorting, descText: descText, title: title })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const labelSuffix = (0, $eJOHy.useMemo)(()=>{
        const sortedTooltipMessage = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $dIts6.default).sortedTooltipNew : (0, $dIts6.default).sortedTooltip;
        const sortPromptTooltipMessage = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $dIts6.default).sortPromptTooltipNew : (0, $dIts6.default).sortPromptTooltip;
        switch(currentSorting){
            case 0, $8jOO7.SORT_ASC:
                return ascText ?? false ? formatMessage(sortedTooltipMessage, {
                    sortDescription: ascText
                }) : formatMessage((0, $dIts6.default).sortedDefaultAscendingTooltip);
            case 0, $8jOO7.SORT_DESC:
                return descText ?? false ? formatMessage(sortedTooltipMessage, {
                    sortDescription: descText
                }) : formatMessage((0, $dIts6.default).sortedDefaultDescendingTooltip);
            default:
                return ascText ?? false ? formatMessage(sortPromptTooltipMessage, {
                    sortDescription: ascText
                }) : formatMessage((0, $dIts6.default).sortPromptDefaultTooltip);
        }
    }, [
        ascText,
        currentSorting,
        descText,
        formatMessage
    ]);
    return (0, $eJOHy.useMemo)(()=>`${title} \u{2022} ${labelSuffix}`, [
        labelSuffix,
        title
    ]);
};
const $dc75ba32cd925e8e$export$e464399b18ba2124 = ({ column: column, onFocus: onFocus, onBlur: onBlur })=>{
    const label = $dc75ba32cd925e8e$var$useAccessibleLabel(column);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        let nextDirection = (0, $8jOO7.SORT_ASC);
        if (column.currentSorting === (0, $8jOO7.SORT_ASC)) nextDirection = (0, $8jOO7.SORT_DESC);
        else if (column.currentSorting === (0, $8jOO7.SORT_DESC)) nextDirection = (0, $4cTDP.fg)('jsc_list_reranking_gate') ? (0, $8jOO7.SORT_NONE) : (0, $8jOO7.SORT_ASC);
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const fieldType = column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) && (0, $4cTDP.fg)('jira_list_merged_column_gate') ? column.mergedColumns?.[0]?.type ?? column.type : column.type;
        const attributes = {
            fieldType: fieldType,
            sortOrder: nextDirection
        };
        (0, $kRgKj.fireUIAnalytics)(event, 'sortOrderChange', attributes);
        column.onSortOrderChanged?.(column.jqlTerm, nextDirection, (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? column.aliases : undefined);
    }, [
        column,
        createAnalyticsEvent
    ]);
    const Icon = column.currentSorting === (0, $8jOO7.SORT_DESC) ? (0, (/*@__PURE__*/$parcel$interopDefault($8Gywp))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDbql)));
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: (iconProps)=>column.currentSorting === (0, $8jOO7.SORT_DESC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8Gywp))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDbql))), {
                ...iconProps,
                size: "small"
            }),
        label: label,
        spacing: "compact",
        appearance: "subtle",
        isTooltipDisabled: false,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        testId: "native-issue-table.ui.issue-table.header.header-cell.header-cell-actions.sort-button.icon-button"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: label,
        delay: 0,
        ignoreTooltipPointerEvents: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dc75ba32cd925e8e$var$ConditionalIconContainer, null, column.currentSorting === (0, $8jOO7.SORT_DESC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
            label: label,
            color: "currentColor",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
            label: label,
            color: "currentColor",
            size: "small"
        })),
        isSelected: column.currentSorting !== (0, $8jOO7.SORT_NONE),
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    }));
};
const $dc75ba32cd925e8e$var$iconContainerStyles = (0, $1DXK0.xcss)({
    margin: 'space.025'
});

});
parcelRegister("8Gywp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfd9fc2877ad309c8a5d6e5d6ea9482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $652d0645e24346a6$var$_react = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $652d0645e24346a6$var$_baseNew = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $652d0645e24346a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $652d0645e24346a6$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $652d0645e24346a6$var$_react.default.createElement($652d0645e24346a6$var$_baseNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$652d0645e24346a6$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $652d0645e24346a6$var$_default = module.exports.default = $652d0645e24346a6$var$ArrowDownIcon;

});

parcelRegister("dIts6", function(module, exports) {
$parcel$export(module.exports, "default", () => $b92c373f114cd793$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b92c373f114cd793$var$messages = (0, $7qGN1.defineMessages)({
    sortedTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-tooltip",
        "defaultMessage": "Sorted {sortDescription}"
    },
    sortedTooltipNew: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-tooltip-new",
        "defaultMessage": "Sorted {sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}"
    },
    sortPromptTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sort-prompt-tooltip",
        "defaultMessage": "Sort {sortDescription}"
    },
    sortPromptTooltipNew: {
        "id": "native-issue-table.table-header-row.sort-headers.sort-prompt-tooltip-new",
        "defaultMessage": "Sort {sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}"
    },
    sortPromptDefaultTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sort-prompt-default-tooltip",
        "defaultMessage": "Sort in ascending order"
    },
    sortedDefaultAscendingTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-default-ascending-tooltip",
        "defaultMessage": "Sorted in ascending order"
    },
    sortedDefaultDescendingTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-default-descending-tooltip",
        "defaultMessage": "Sorted in descending order"
    }
});
var $b92c373f114cd793$export$2e2bcd8739ae039 = $b92c373f114cd793$var$messages;

});



parcelRegister("4G6Vc", function(module, exports) {
$parcel$export(module.exports, "ResizePopup", () => $75984c1816247788$export$8ddf8c84a74a26df);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $3L3Os = parcelRequire("3L3Os");
var $dNvCk = parcelRequire("dNvCk");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $MevUn = parcelRequire("MevUn");

var $4B7rn = parcelRequire("4B7rn");

var $lRq8t = parcelRequire("lRq8t");

var $8nMzv = parcelRequire("8nMzv");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $8jOO7 = parcelRequire("8jOO7");

var $3R7ZX = parcelRequire("3R7ZX");

var $eEBCh = parcelRequire("eEBCh");
const $75984c1816247788$var$ResizePopupContent = ({ columnTitle: columnTitle, initialWidth: initialWidth, isCompactColumnEnabled: isCompactColumnEnabled = false, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled, minimumWidth: minimumWidth, onChange: onChange, onCancel: onCancel, onSubmit: onSubmit, setInitialFocusRef: setInitialFocusRef, isMultiColumnMergedCell: isMultiColumnMergedCell, mergedColumnMinWidth: mergedColumnMinWidth })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleDragOrTouchStart = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
    }, []);
    let minimumColumnWidth;
    if (isMultiColumnMergedCell) minimumColumnWidth = mergedColumnMinWidth || (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH);
    else minimumColumnWidth = isSingleLineRowHeightEnabled ? (0, $8jOO7.SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH) : (0, $8jOO7.MINIMUM_COLUMN_WIDTH);
    const defaultMinWidth = isCompactColumnEnabled ? (0, $8jOO7.MINIMUM_COLUMN_WIDTH_COMPACT) : minimumColumnWidth;
    const minWidth = minimumWidth || defaultMinWidth;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingInline: "space.200",
        xcss: $75984c1816247788$var$PopupContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3L3Os.default), {
        onSubmit: ({ width: width })=>onSubmit((0, $3R7ZX.ensureWidthWithinLimits)(width, isCompactColumnEnabled, isSingleLineRowHeightEnabled, isMultiColumnMergedCell, mergedColumnMinWidth))
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dNvCk.default), {
            label: formatMessage((0, $eEBCh.default).columnWidthLabel, {
                columnTitle: columnTitle
            }),
            name: "width",
            defaultValue: initialWidth
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MevUn.default), {
                ...fieldProps,
                ref: setInitialFocusRef,
                min: minWidth,
                max: (0, $8jOO7.MAXIMUM_COLUMN_WIDTH),
                step: 5,
                onChange: (value)=>{
                    onChange(value);
                    fieldProps.onChange(value);
                },
                draggable: true,
                onDragStart: handleDragOrTouchStart,
                onTouchStart: handleDragOrTouchStart
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            space: "space.100",
            alignInline: "end",
            xcss: $75984c1816247788$var$FormFooterStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "subtle",
            onClick: onCancel
        }, formatMessage((0, $eEBCh.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            type: "submit",
            appearance: "primary"
        }, formatMessage((0, $eEBCh.default).save))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null));
};
const $75984c1816247788$export$8ddf8c84a74a26df = ({ columnTitle: columnTitle, initialWidth: initialWidth, placement: placement, isOpen: isOpen, isCompactColumnEnabled: isCompactColumnEnabled = false, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled, minimumWidth: minimumWidth, trigger: trigger, onChange: onChange, onCancel: onCancelProp, onSubmit: onSubmit, isMultiColumnMergedCell: isMultiColumnMergedCell, mergedColumnMinWidth: mergedColumnMinWidth })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onCancel = (0, $eJOHy.useCallback)((event, analyticsEventParam)=>{
        const analyticsEvent = analyticsEventParam ?? createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'cancelColumnResize');
        onCancelProp(event);
    }, [
        onCancelProp,
        createAnalyticsEvent
    ]);
    const PopupContent = (0, $eJOHy.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($75984c1816247788$var$ResizePopupContent, {
            columnTitle: columnTitle,
            initialWidth: initialWidth,
            isCompactColumnEnabled: isCompactColumnEnabled,
            minimumWidth: minimumWidth,
            onChange: onChange,
            onCancel: onCancel,
            onSubmit: onSubmit,
            setInitialFocusRef: setInitialFocusRef,
            isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
            isMultiColumnMergedCell: isMultiColumnMergedCell,
            mergedColumnMinWidth: mergedColumnMinWidth
        }), [
        columnTitle,
        initialWidth,
        isCompactColumnEnabled,
        minimumWidth,
        onChange,
        onCancel,
        onSubmit,
        isSingleLineRowHeightEnabled,
        isMultiColumnMergedCell,
        mergedColumnMinWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        testId: "native-issue-table.ui.issue-table.header.header-cell.resize-popup.resize-popup",
        placement: placement,
        isOpen: isOpen,
        onClose: onCancel,
        trigger: trigger,
        content: PopupContent,
        shouldRenderToParent: true,
        messageId: "native-issue-table.ui.issue-table.header.header-cell.resize-popup.popup",
        messageType: "transactional",
        role: "dialog",
        label: columnTitle
    });
};
const $75984c1816247788$var$PopupContentStyles = (0, $1DXK0.xcss)({
    fontWeight: "var(--ds-font-weight-regular, 400)",
    marginBlock: 'space.200',
    whiteSpace: 'normal'
});
const $75984c1816247788$var$FormFooterStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginTop: 'space.100'
});

});
parcelRegister("dNvCk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4bc12428617c0200$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6svxr = parcelRequire("6svxr");
/**
 * __Range field__
 *
 * A range field is where a user can submit a range input as a part of a form.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#rangefield-reference)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#rangefield-reference)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#rangefield-reference)
 */ const $4bc12428617c0200$var$RangeField = ({ children: children, defaultValue: defaultValue, id: id, isDisabled: isDisabled, label: label, name: name })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
        defaultValue: defaultValue,
        id: id,
        isDisabled: isDisabled,
        label: label,
        name: name,
        transform: Number,
        children: ({ fieldProps: { isInvalid: isInvalid, isRequired: isRequired, ...fieldProps }, ...rest })=>// isInvalid and isRequired are specifically invalid for range inputs
            children({
                fieldProps: fieldProps,
                ...rest
            })
    });
var $4bc12428617c0200$export$2e2bcd8739ae039 = $4bc12428617c0200$var$RangeField;

});

parcelRegister("MevUn", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c0f57dfc7b1472c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $dbgh6 = parcelRequire("dbgh6");
const $9c0f57dfc7b1472c$var$snapToStep = (value, min, step)=>{
    // Normalise the value to allow for division properly with different min values
    const adjustedValue = value - min;
    // Find the number of steps the value covers
    const numSteps = Math.round(adjustedValue / step);
    // Convert numSteps back into original range
    return numSteps * step + min;
};
const $9c0f57dfc7b1472c$var$getRoundedPercentValue = (value, min, max, step)=>{
    let percent = '0';
    if (min < max && value > min) {
        const snappedValue = $9c0f57dfc7b1472c$var$snapToStep(value, min, step);
        percent = ((snappedValue - min) / (max - min) * 100).toFixed(2);
    }
    return percent;
};
const $9c0f57dfc7b1472c$var$noop = (0, $3Vuhz.default);
/**
 * __Range__
 *
 * A range lets users choose an approximate value on a slider.
 *
 * - [Examples](https://atlassian.design/components/range/examples)
 * - [Code](https://atlassian.design/components/range/code)
 * - [Usage](https://atlassian.design/components/range/usage)
 */ const $9c0f57dfc7b1472c$var$Range = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Range(props, ref) {
    const { isDisabled: isDisabled = false, defaultValue: defaultValue = 50, max: max = 100, min: min = 0, onChange: onChange = $9c0f57dfc7b1472c$var$noop, step: step = 1, value: propsValue, testId: testId, ...rest } = props;
    const spreadProps = {
        max: max,
        min: min,
        step: step,
        ref: ref,
        ...rest
    };
    const [value, setValue] = (0, $eJOHy.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const handleChange = (0, $eJOHy.useCallback)((e)=>{
        const newValue = Number(e.target.value);
        setValue(newValue);
        // Note use of newValue to ensure up=to-date value is used
        onChange(newValue);
    }, [
        onChange
    ]);
    const renderValue = propsValue !== undefined ? propsValue : value;
    const valuePercent = $9c0f57dfc7b1472c$var$getRoundedPercentValue(renderValue, min, max, step);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dbgh6.Input), {
        type: "range",
        disabled: isDisabled,
        onChange: handleChange,
        value: renderValue,
        valuePercent: valuePercent,
        "data-testid": testId,
        ...spreadProps
    });
});
var $9c0f57dfc7b1472c$export$2e2bcd8739ae039 = $9c0f57dfc7b1472c$var$Range;

});
parcelRegister("dbgh6", function(module, exports) {
$parcel$export(module.exports, "Input", () => $b65ac72e66820907$export$f5b8910cec6cf069);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $b65ac72e66820907$var$rangeHeight = 40; // Height of the range input, used for the track and thumb
const $b65ac72e66820907$var$trackHeight = 6; // Height of the track, used for the track and thumb
const $b65ac72e66820907$var$thumbSize = "var(--ds-space-200, 16px)"; // Size of the thumb, used for the thumb styles
// Styles are split up to avoid edge-cases with TS implementations between `css` and `cssMap` with some
// of these edge-case pseudo-selectors.
// Previously, in Emotion, these selectors weren't consolidated, eg. `&::webkit-thumb, &::moz-thumb`
// would not be parsed by either browser, but this may no longer be the case in Compiled
const $b65ac72e66820907$var$webkitStyles = null;
const $b65ac72e66820907$var$firefoxStyles = null;
const $b65ac72e66820907$var$baseStyles = null;
const $b65ac72e66820907$var$themeStyles = null;
const $b65ac72e66820907$var$trackStyles = {
    root: "_1bsb1osq _4t3i1ylp _kqswh2mm _14mj1qll _1ywu1ule _z0ai1y44 _1qdg1y44 _18postnw _1hfkof27 _aetrb3bt _19nq1ssb _g0nfo1yi",
    disabled: "_1peq2wxo"
};
const $b65ac72e66820907$var$rangeA11yStyles = null;
const $b65ac72e66820907$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { valuePercent: valuePercent, style: style, ...strippedProps } = props;
    const input = /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
        ...strippedProps,
        style: {
            // We are creating a css variable to control the "progress" portion of the range input
            // This avoids us needing to create a new css class for each new percentage value
            '--track-fg-width': `${valuePercent}%`
        },
        ref: ref,
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1ylp _bfhk18uv _j5dh13gf _1j552wxo _nt751r31 _49pcglyw _1hvw1o36",
            "_wstuglyw _h2ksglyw _1kdl1qll _m8f8bpmo _1yz62hjt _1bdkusvi _u98zpxbi _1j70pxbi _1esf5udg _4w431ik2 _yfyntlke _1sdc196n _18k7v77o _1cdcglyw _10lridpf _g6tdlb4i _vi4t2hjt _1g2h1osq _168l1y44 _9u3f2hce _1g741hsc _1d8tmgnk _np53xlkz _18tdtlke _1p201osq _1yte13gf _5i7a13gf",
            "_1yq0glyw _108m1qll _1rf3bpmo _1yeu2hjt _g4ppusvi _r763pxbi _1mn5pxbi _12el5udg _1oqe1ik2 _10o7tlke _1kzev77o _15raidpf _e8hnidpf _37ywlb4i _1tcb2hjt _aoww1osq _1kd2i2wt _vt2s1w6o _1ssqtlke _ru37idpf _1gvolb4i _1nx42hjt _1f5t1osq _142y1y44 _d7w62hce _b3fmtlke _1vq313gf _1fov13gf _34m613gf",
            "_14h11kge _15dp1yrq _18lxyvsn _jxar1eo5 _ydqghkel _1jhc1eo5 _1ruc16ss _164c194a",
            "_1drqof27 _15dp1vck _18lxof27 _g6tdfajl _168li2wt _37ywfajl _1kd2i2wt _1sdc1lpd _ydqgmpja"
        ])
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $b65ac72e66820907$var$trackStyles.root,
            strippedProps.disabled && $b65ac72e66820907$var$trackStyles.disabled
        ]),
        children: input
    });
});
$b65ac72e66820907$export$f5b8910cec6cf069.displayName = 'InputRange';

});


parcelRegister("3R7ZX", function(module, exports) {
$parcel$export(module.exports, "setCssResizingOffset", () => $89884b47ae19eb85$export$1799580b35bc0fce);
$parcel$export(module.exports, "clearCssResizingOffset", () => $89884b47ae19eb85$export$4a29049b3e1cea2c);
$parcel$export(module.exports, "setCssResizingWidth", () => $89884b47ae19eb85$export$7bda7a969edeaaf9);
$parcel$export(module.exports, "clearCssResizingWidth", () => $89884b47ae19eb85$export$c418ab97f3e5c176);
$parcel$export(module.exports, "disableCssPointerEvents", () => $89884b47ae19eb85$export$b0074a660e898e0);
$parcel$export(module.exports, "enableCssPointerEvents", () => $89884b47ae19eb85$export$1b5de7c0486b5e41);
$parcel$export(module.exports, "ensureWidthWithinLimits", () => $89884b47ae19eb85$export$3a38b06f96ddcc2d);
$parcel$export(module.exports, "getProposedWidth", () => $89884b47ae19eb85$export$39e6ff87d188b0e6);

var $8jOO7 = parcelRequire("8jOO7");
const $89884b47ae19eb85$var$CSS_RESIZING_WIDTH_PROPERTY = '--local-resizing-width';
const $89884b47ae19eb85$var$CSS_RESIZING_OFFSETX_PROPERTY = '--local-resizing-offset';
const $89884b47ae19eb85$export$1799580b35bc0fce = (container, width)=>{
    container?.style.setProperty($89884b47ae19eb85$var$CSS_RESIZING_OFFSETX_PROPERTY, `${width}px`);
};
const $89884b47ae19eb85$export$4a29049b3e1cea2c = (container)=>{
    container?.style.removeProperty($89884b47ae19eb85$var$CSS_RESIZING_OFFSETX_PROPERTY);
};
const $89884b47ae19eb85$export$7bda7a969edeaaf9 = (container, width)=>{
    container?.style.setProperty($89884b47ae19eb85$var$CSS_RESIZING_WIDTH_PROPERTY, `${width}px`);
};
const $89884b47ae19eb85$export$c418ab97f3e5c176 = (container)=>{
    container?.style.removeProperty($89884b47ae19eb85$var$CSS_RESIZING_WIDTH_PROPERTY);
};
const $89884b47ae19eb85$export$b0074a660e898e0 = (container)=>{
    container?.style.setProperty('pointer-events', 'none');
};
const $89884b47ae19eb85$export$1b5de7c0486b5e41 = (container)=>{
    container?.style.removeProperty('pointer-events');
};
const $89884b47ae19eb85$export$3a38b06f96ddcc2d = (width, isCompactColumnEnabled, isSingleLineRowHeightEnabled, isMultiColumnMergedCell, mergedColumnMinWidth)=>{
    let minColumnWidth;
    if (isMultiColumnMergedCell) minColumnWidth = mergedColumnMinWidth || (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH);
    else minColumnWidth = isSingleLineRowHeightEnabled ? (0, $8jOO7.SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH) : (0, $8jOO7.MINIMUM_COLUMN_WIDTH);
    return Math.min(Math.max(isCompactColumnEnabled ? (0, $8jOO7.MINIMUM_COLUMN_WIDTH_COMPACT) : minColumnWidth, width), (0, $8jOO7.MAXIMUM_COLUMN_WIDTH));
};
const $89884b47ae19eb85$export$39e6ff87d188b0e6 = ({ initialWidth: initialWidth, isCompactColumnEnabled: isCompactColumnEnabled, location: location, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled, isMultiColumnMergedCell: isMultiColumnMergedCell, mergedColumnMinWidth: mergedColumnMinWidth })=>{
    const diffX = location.current.input.clientX - location.initial.input.clientX;
    const proposedWidth = initialWidth + diffX;
    // ensure we don't go below the min allowed width
    return $89884b47ae19eb85$export$3a38b06f96ddcc2d(proposedWidth, isCompactColumnEnabled, isSingleLineRowHeightEnabled, isMultiColumnMergedCell, mergedColumnMinWidth);
};

});

parcelRegister("eEBCh", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff6be754c5e1a549$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ff6be754c5e1a549$var$messages = (0, $7qGN1.defineMessages)({
    columnWidthLabel: {
        "id": "native-issue-table.issue-table.header.header-cell.resize-popup.column-width-label",
        "defaultMessage": "Column width - {columnTitle}"
    },
    cancel: {
        "id": "native-issue-table.issue-table.header.header-cell.resize-popup.cancel",
        "defaultMessage": "Cancel"
    },
    save: {
        "id": "native-issue-table.issue-table.header.header-cell.resize-popup.save",
        "defaultMessage": "Save"
    }
});
var $ff6be754c5e1a549$export$2e2bcd8739ae039 = $ff6be754c5e1a549$var$messages;

});


parcelRegister("9iFH8", function(module, exports) {
$parcel$export(module.exports, "ExpandAllButton", () => $e49fc1c730c99c74$export$5ff5d43387dfedab);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $cQxBL = parcelRequire("cQxBL");

var $1OQKp = parcelRequire("1OQKp");

var $lRq8t = parcelRequire("lRq8t");

var $bvZ13 = parcelRequire("bvZ13");
const $e49fc1c730c99c74$export$5ff5d43387dfedab = ()=>{
    // TODO: Implement store for expand all state
    const [isExpanded, setIsExpanded] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        label: isExpanded ? formatMessage((0, $bvZ13.default).collapseAllTooltip) : formatMessage((0, $bvZ13.default).expandAllTooltip),
        spacing: "compact",
        appearance: "subtle",
        icon: (iconProps)=>isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                ...iconProps,
                size: "small"
            }),
        onClick: ()=>setIsExpanded(!isExpanded),
        isTooltipDisabled: false
    });
};

});
parcelRegister("bvZ13", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6c79b63e320691b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b6c79b63e320691b$var$messages = (0, $7qGN1.defineMessages)({
    expandAllTooltip: {
        "id": "native-issue-table.table-header-row.expand-all-button.expand-all-tooltip",
        "defaultMessage": "Expand all"
    },
    collapseAllTooltip: {
        "id": "native-issue-table.table-header-row.expand-all-button.collapse-all-tooltip",
        "defaultMessage": "Collapse all"
    }
});
var $b6c79b63e320691b$export$2e2bcd8739ae039 = $b6c79b63e320691b$var$messages;

});



parcelRegister("3utN3", function(module, exports) {
$parcel$export(module.exports, "default", () => $3771e5fb7245c307$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3771e5fb7245c307$var$messages = (0, $7qGN1.defineMessages)({
    movedColumn: {
        "id": "native-issue-table.issue-table.header.moved-column",
        "defaultMessage": "You\u2019ve moved {column} from {previousPosition} to {position} of {total}."
    }
});
var $3771e5fb7245c307$export$2e2bcd8739ae039 = $3771e5fb7245c307$var$messages;

});


parcelRegister("eI4dM", function(module, exports) {
$parcel$export(module.exports, "default", () => $65dc4e4263660c62$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $65dc4e4263660c62$var$messages = (0, $7qGN1.defineMessages)({
    issuesTableLabel: {
        "id": "native-issue-table.issue-table.issues-table-label",
        "defaultMessage": "Issues"
    },
    issuesTableLabelIssueTermRefresh: {
        "id": "native-issue-table.issue-table.issues-table-label-issue-term-refresh",
        "defaultMessage": "Work"
    }
});
var $65dc4e4263660c62$export$2e2bcd8739ae039 = $65dc4e4263660c62$var$messages;

});

parcelRegister("l00LF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e01c1501c2df9d15$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $3xT3U = parcelRequire("3xT3U");

var $eS29z = parcelRequire("eS29z");

var $dK9Sm = parcelRequire("dK9Sm");

var $hnyyS = parcelRequire("hnyyS");
const $e01c1501c2df9d15$var$NoColumnsRenderer = ({ NoColumns: NoColumns = (0, $dK9Sm.NoColumns), hasColumnConfiguration: hasColumnConfiguration, isLoading: isLoading = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e01c1501c2df9d15$var$NoColumnsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NoColumns, {
        defaultNoColumnsGlyph: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $e01c1501c2df9d15$var$ImageWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3xT3U.default), {
            alt: ""
        })),
        hasColumnConfiguration: hasColumnConfiguration
    }), isLoading && ((0, $4cTDP.fg)('add_nin_press_interactions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hnyyS.Overlay), {
        interactionName: "issue-table-no-columns-renderer-overlay"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hnyyS.OverlayOld), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "nativeIssueTableNoColumns"
    }));
var $e01c1501c2df9d15$export$2e2bcd8739ae039 = $e01c1501c2df9d15$var$NoColumnsRenderer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e01c1501c2df9d15$var$NoColumnsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _kqsw1if8 _1ltvidpf",
            __cmplp.className
        ])
    });
});
const $e01c1501c2df9d15$var$ImageWrapperStyles = (0, $1DXK0.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginBottom: 'space.300'
});

});
parcelRegister("3xT3U", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b1b1236d04dc76a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("e8HDz")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("aiB9q")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $c4huj = parcelRequire("c4huj");

var $aiB9q = parcelRequire("aiB9q");

var $e8HDz = parcelRequire("e8HDz");
const $3b1b1236d04dc76a$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($e8HDz)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($aiB9q))
});
var $3b1b1236d04dc76a$export$2e2bcd8739ae039 = $3b1b1236d04dc76a$var$Illustration;
// for advanced use only
const $3b1b1236d04dc76a$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("aiB9q", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("e8HDz", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});


parcelRegister("dK9Sm", function(module, exports) {
$parcel$export(module.exports, "NoColumns", () => $edb4c92fc13b3452$export$a0e9f6d02eee4aa4);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $8IeH1 = parcelRequire("8IeH1");

var $lRq8t = parcelRequire("lRq8t");

var $PETi0 = parcelRequire("PETi0");

var $kRgKj = parcelRequire("kRgKj");

var $5F0C9 = parcelRequire("5F0C9");
const $edb4c92fc13b3452$export$a0e9f6d02eee4aa4 = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph, hasColumnConfiguration: hasColumnConfiguration })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ isOpen: isOpen }, actions] = (0, $PETi0.useColumnPickerOpenState)();
    const onOpenColumnPicker = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'button clicked', 'noColumnsButton');
        if (!isOpen) actions.open();
    }, [
        isOpen,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $5F0C9.default).noColumnsHeaderText),
        description: formatMessage((0, $5F0C9.default).noColumnsDescriptionText),
        testId: "native-issue-table.common.ui.components.no-columns.no-columns",
        primaryAction: hasColumnConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "primary",
            onClick: onOpenColumnPicker
        }, formatMessage((0, $5F0C9.default).configureColumns)) : undefined,
        renderImage: ()=>defaultNoColumnsGlyph
    }));
};

});
parcelRegister("5F0C9", function(module, exports) {
$parcel$export(module.exports, "default", () => $eacbcb43f37199f6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $eacbcb43f37199f6$var$messages = (0, $7qGN1.defineMessages)({
    noColumnsHeaderText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-header-text",
        "defaultMessage": "Configure your columns"
    },
    noColumnsDescriptionText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-description-text",
        "defaultMessage": "You haven't configured any columns yet. Add fields as columns to see search results and their information."
    },
    configureColumns: {
        "id": "native-issue-table.issue-table.no-columns.configure-columns",
        "defaultMessage": "Configure columns"
    }
});
var $eacbcb43f37199f6$export$2e2bcd8739ae039 = $eacbcb43f37199f6$var$messages;

});



parcelRegister("kaSuB", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8f0c91843002930$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $7uL8m = parcelRequire("7uL8m");

var $kKCMK = parcelRequire("kKCMK");

var $eS29z = parcelRequire("eS29z");

var $6XJko = parcelRequire("6XJko");

var $hnyyS = parcelRequire("hnyyS");

var $eu3ki = parcelRequire("eu3ki");
const $c8f0c91843002930$var$NoIssuesRenderer = ({ NoIssues: NoIssues = (0, $eu3ki.NoIssues), isLoading: isLoading = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c8f0c91843002930$var$EmptyIssuesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NoIssues, {
        defaultNoIssuesGlyph: (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $c8f0c91843002930$var$ImageWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kKCMK.default), {
            alt: ""
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $c8f0c91843002930$var$ImageWrapperStylesOld
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7uL8m.default), {
            alt: ""
        }))
    }), isLoading && ((0, $4cTDP.fg)('add_nin_press_interactions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hnyyS.Overlay), {
        interactionName: "issue-table-no-issues-renderer-overlay"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hnyyS.OverlayOld), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "nativeIssueTableNoResults"
    }));
var $c8f0c91843002930$export$2e2bcd8739ae039 = $c8f0c91843002930$var$NoIssuesRenderer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c8f0c91843002930$var$EmptyIssuesContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _kqsw1if8 _1ltvidpf _mezj18pt",
            __cmplp.className
        ])
    });
});
const $c8f0c91843002930$var$ImageWrapperStylesOld = (0, $1DXK0.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginBottom: 'space.300'
});
const $c8f0c91843002930$var$ImageWrapperStyles = (0, $1DXK0.xcss)({
    maxHeight: '165px',
    maxWidth: '150px',
    margin: 'auto',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginBottom: 'space.300'
});

});
parcelRegister("7uL8m", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a8498e45c2fcae9$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $c4huj = parcelRequire("c4huj");

var $lGiXj = parcelRequire("lGiXj");

var $dIBgP = parcelRequire("dIBgP");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $8a8498e45c2fcae9$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($dIBgP)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($lGiXj))
});
var $8a8498e45c2fcae9$export$2e2bcd8739ae039 = $8a8498e45c2fcae9$var$Illustration;
// for advanced use only
const $8a8498e45c2fcae9$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("lGiXj", function(module, exports) {
module.exports = new URL("search-no-results-old-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("dIBgP", function(module, exports) {
module.exports = new URL("search-no-results-old.10b14394.svg", import.meta.url).toString();

});


parcelRegister("kKCMK", function(module, exports) {
$parcel$export(module.exports, "default", () => $aaae219acd4147f1$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $c4huj = parcelRequire("c4huj");

var $js5cg = parcelRequire("js5cg");

var $hj82Y = parcelRequire("hj82Y");
const $aaae219acd4147f1$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($hj82Y)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($js5cg))
});
var $aaae219acd4147f1$export$2e2bcd8739ae039 = $aaae219acd4147f1$var$Illustration;
// for advanced use only
const $aaae219acd4147f1$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    184
];

});
parcelRegister("js5cg", function(module, exports) {
module.exports = new URL("search-no-results-darkmode.c66ae5fb.svg", import.meta.url).toString();

});

parcelRegister("hj82Y", function(module, exports) {
module.exports = new URL("search-no-results.1d478205.svg", import.meta.url).toString();

});


parcelRegister("eu3ki", function(module, exports) {
$parcel$export(module.exports, "NoIssues", () => $ab49ca26ec37a201$export$a7a61a727a1d891b);

var $eJOHy = parcelRequire("eJOHy");

var $6MnLl = parcelRequire("6MnLl");

var $8IeH1 = parcelRequire("8IeH1");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $fjV4E = parcelRequire("fjV4E");
const $ab49ca26ec37a201$export$a7a61a727a1d891b = ({ defaultNoIssuesGlyph: defaultNoIssuesGlyph })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fjV4E.default).emptyIssuesIssueTermRefresh : (0, $fjV4E.default).emptyIssues),
        renderImage: ()=>defaultNoIssuesGlyph,
        testId: "native-issue-table.ui.issue-table.no-issues-renderer.no-issues.empty-state"
    }));
};

});
parcelRegister("fjV4E", function(module, exports) {
$parcel$export(module.exports, "default", () => $386c8ad01edb0ce6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $386c8ad01edb0ce6$var$messages = (0, $7qGN1.defineMessages)({
    emptyIssues: {
        "id": "native-issue-table.issue-table.empty-issues.empty-issues",
        "defaultMessage": "There are no issues"
    },
    emptyIssuesIssueTermRefresh: {
        "id": "native-issue-table.issue-table.no-issues-renderer.no-issues.empty-issues-issue-term-refresh",
        "defaultMessage": "There are no work items"
    }
});
var $386c8ad01edb0ce6$export$2e2bcd8739ae039 = $386c8ad01edb0ce6$var$messages;

});



parcelRegister("l7U99", function(module, exports) {
$parcel$export(module.exports, "default", () => $3954d1d23379332f$export$2e2bcd8739ae039);

var $huC5G = parcelRequire("huC5G");

var $lJPLz = parcelRequire("lJPLz");

var $iNBNx = parcelRequire("iNBNx");

var $i6kbW = parcelRequire("i6kbW");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $bJscI = parcelRequire("bJscI");

var $1q3Q0 = parcelRequire("1q3Q0");

var $jNv5I = parcelRequire("jNv5I");

var $8Ckd4 = parcelRequire("8Ckd4");
const $3954d1d23379332f$var$TableBodyNonMemoized = ({ issueResults: issueResults, project: project, rankField: rankField, isGroupingSupported: isGroupingSupported, isConditionalFormattingEnabled: isConditionalFormattingEnabled, isDraggingRowFaded: isDraggingRowFaded, formattingRules: formattingRules, rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields, topLevelIssueCreateConfig: topLevelIssueCreateConfig, initialPopulateConnectionArgs: initialPopulateConnectionArgs, ...tableBodyProps })=>{
    const issueResultsData = (0, $j4oe4.useFragment)((0, $i6kbW.default), issueResults);
    const projectData = (0, $j4oe4.useFragment)((0, $iNBNx.default), project);
    const formattingRulesData = (0, $j4oe4.useFragment)((0, $lJPLz.default), formattingRules);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $huC5G.default), rankField);
    const renderChildRows = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Ckd4.RenderChildRowsComp), {
            project: projectData,
            projectKey: projectData?.key,
            columns: tableBodyProps.columns,
            isGroupingSupported: isGroupingSupported,
            rankField: rankFieldData ?? null,
            formattingRules: formattingRulesData,
            rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
            ...props
        }), [
        projectData,
        tableBodyProps.columns,
        isGroupingSupported,
        rankFieldData,
        formattingRulesData,
        rowInlineCreateCanShowAdditionalFields
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3954d1d23379332f$var$StyledTableBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jNv5I.RowContextProvider), {
        ...tableBodyProps,
        renderChildRows: renderChildRows
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1q3Q0.default), {
        issueResults: issueResultsData,
        parentItemId: "root",
        itemsConnectionId: issueResultsData.__id,
        project: projectData,
        rankFieldId: rankFieldData?.fieldId,
        isDraggingRowFaded: isDraggingRowFaded,
        formattingRules: formattingRulesData,
        rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
        topLevelIssueCreateConfig: topLevelIssueCreateConfig,
        ...(0, $4cTDP.fg)('jsc_list_reparenting') ? {
            projectKey: projectData?.key
        } : {},
        initialPopulateConnectionArgs: initialPopulateConnectionArgs
    })));
};
const $3954d1d23379332f$var$TableBody = (0, $bJscI.componentWithFG)('memoise_issuetable_components', /*#__PURE__*/ (0, $eJOHy.memo)($3954d1d23379332f$var$TableBodyNonMemoized), $3954d1d23379332f$var$TableBodyNonMemoized);
var $3954d1d23379332f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3954d1d23379332f$var$TableBody;
const $3954d1d23379332f$var$StyledTableBody = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "tbody", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zlglyw _1reo15vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("huC5G", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6195cee04f08bf3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<16e19713d9f0bff2841d815c12afe04a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c6195cee04f08bf3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TableBody_rankField",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "FragmentSpread",
            "name": "RenderChildRowsComp_rank"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$c6195cee04f08bf3$var$node.hash = "3b686d9f0dadcc2230fcc1b560e63dd1";
var $c6195cee04f08bf3$export$2e2bcd8739ae039 = $c6195cee04f08bf3$var$node;

});

parcelRegister("lJPLz", function(module, exports) {
$parcel$export(module.exports, "default", () => $ead626ac1aa943be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e1ad2d5389fd1a44a3c0fa95125a714>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ead626ac1aa943be$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TableBody_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Rows_rules"
        },
        {
            "kind": "FragmentSpread",
            "name": "RenderChildRowsComp_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$ead626ac1aa943be$var$node.hash = "f8bf89a7757ce2f426b62f58f32de215";
var $ead626ac1aa943be$export$2e2bcd8739ae039 = $ead626ac1aa943be$var$node;

});

parcelRegister("iNBNx", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8b3fb94bc32e404$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e8defb12120a37aaf18eb712863faea6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f8b3fb94bc32e404$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "TableBody_project",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "Rows_project"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RenderChildRowsComp"
            }
        ],
        "type": "JiraProject"
    };
}();
$f8b3fb94bc32e404$var$node.hash = "b3eb4cabe24774b041888ec784130720";
var $f8b3fb94bc32e404$export$2e2bcd8739ae039 = $f8b3fb94bc32e404$var$node;

});

parcelRegister("i6kbW", function(module, exports) {
$parcel$export(module.exports, "default", () => $aaae21fc2e10a1de$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2db2e90eea340443c8f60868a63b6c50>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aaae21fc2e10a1de$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRemoteLinkedIssuesEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "TableBodyTableBody",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isEditableSyncLoaded",
                    "variableName": "isEditableSyncLoaded"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isRemoteLinkedIssuesEnabled",
                    "variableName": "isRemoteLinkedIssuesEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "Rows"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$aaae21fc2e10a1de$var$node.hash = "c3eb6bdb6dddda37a06dbda438791d22";
var $aaae21fc2e10a1de$export$2e2bcd8739ae039 = $aaae21fc2e10a1de$var$node;

});

parcelRegister("8Ckd4", function(module, exports) {
$parcel$export(module.exports, "RenderChildRowsComp", () => $8e9548743b291663$export$c65f147e25ffd0e6);

var $bBTKN = parcelRequire("bBTKN");

var $6gc4l = parcelRequire("6gc4l");

var $f3aTj = parcelRequire("f3aTj");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $cNwIG = parcelRequire("cNwIG");

var $l6qXI = parcelRequire("l6qXI");

var $4cTDP = parcelRequire("4cTDP");

var $1q3Q0 = parcelRequire("1q3Q0");

var $8jOO7 = parcelRequire("8jOO7");

var $cgCO4 = parcelRequire("cgCO4");

var $34oCh = parcelRequire("34oCh");

var $bKlUQ = parcelRequire("bKlUQ");

var $7n9BS = parcelRequire("7n9BS");

var $aNnbk = parcelRequire("aNnbk");

var $kfIml = parcelRequire("kfIml");

var $9r0oq = parcelRequire("9r0oq");
const $8e9548743b291663$var$renderDraggableWrapper = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kfIml.DraggableRowsContainer), {
        issueConnectionId: props.issueConnectionId,
        instanceId: props.instanceId
    }, props.children);
};
const $8e9548743b291663$export$c65f147e25ffd0e6 = ({ project: project, projectKey: projectKey, isGroupingSupported: isGroupingSupported, columns: columns, rankField: rankField, formattingRules: formattingRules, rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields, ...childRowsProps })=>{
    const ChildIssueCreateRowComponent = (0, $9r0oq.useTimelineCustomComponents)()?.ChildIssueCreateRow;
    let isStickyColumnsVisible = false;
    if ((0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
    else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { isStickyColumnsVisible: isStickyColumnsVisibleOld } = (0, $cgCO4.useShouldApplyFrozenColumns)();
        isStickyColumnsVisible = isStickyColumnsVisibleOld;
    }
    const renderTableCell = (tableCellProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), tableCellProps);
    const projectRef = (0, $j4oe4.useFragment)((0, $f3aTj.default), project);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $6gc4l.default), rankField);
    const formattingRulesData = (0, $j4oe4.useFragment)((0, $bBTKN.default), formattingRules);
    /**
   * Passing those values down to ChildRowsLoader as props to avoid direct imports
   */ const jql = (0, $34oCh.useJql)();
    const sortField = (0, $34oCh.useSortField)();
    const sortDirection = (0, $34oCh.useSortDirection)();
    const isReparentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const isHideDoneItemsEnabled = (0, $34oCh.useIsHideDoneItemsEnabled)();
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const width = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.width);
    const isIssueRankDescending = (0, $34oCh.useIsIssueRankDescending)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    const isLinkRelationshipFieldEnabled = (0, $34oCh.useIsRelationshipFieldEnabled)();
    const isRemoteLinkedIssuesEnabled = (0, $34oCh.useIsRemoteLinkedIssuesEnabled)();
    const isEditableSyncLoaded = (0, $34oCh.useIsEditableSyncLoaded)();
    const cellBorderStyle = (0, $34oCh.useCellBorderStyle)();
    const isInlineEditingEnabled = (0, $4cTDP.fg)('jira_timeline_disable_child_inline_editing') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $34oCh.useIsInlineEditingEnabled)() : true;
    const isConditionalFormattingEnabled = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4cTDP.fg)('jira_list_conditional_formatting') && (0, $34oCh.useIsConditionalFormattingEnabled)();
    const shouldQuerySprints = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4cTDP.fg)('timeline_harmonisation_m3_targeting') && (0, $34oCh.useShouldQuerySprints)();
    const rankFieldTerms = (0, $eJOHy.useMemo)(()=>({
            jqlTerm: rankFieldData?.jqlTerm ?? null,
            aliases: rankFieldData?.aliases ? Array.from(rankFieldData.aliases) : null
        }), [
        rankFieldData
    ]);
    const renderCreateIssueController = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aNnbk.CreateIssueController), {
            ...props,
            jql: jql,
            rankFieldTerms: rankFieldTerms
        }), [
        jql,
        rankFieldTerms
    ]);
    const renderChildRowsLoader = (0, $eJOHy.useCallback)((childRowsLoaderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l6qXI.ChildRowsLoader), {
            ...childRowsLoaderProps,
            jql: jql,
            width: width,
            sortField: sortField,
            sortDirection: sortDirection,
            columns: columns,
            amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
            actionColumns: (0, $8jOO7.ACTION_COLUMNS),
            pageSize: (0, $8jOO7.CHILD_QUERY_PAGE_SIZE),
            isReparentingEnabled: isReparentingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            isIssueRankDescending: isIssueRankDescending,
            isHideDoneItemsEnabled: isHideDoneItemsEnabled,
            isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            shouldQuerySprints: shouldQuerySprints,
            rankFieldId: rankFieldData?.fieldId,
            renderRows: (rowProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1q3Q0.default), {
                    project: projectRef,
                    formattingRules: formattingRulesData,
                    rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
                    ...rowProps
                }),
            renderDraggableWrapper: $8e9548743b291663$var$renderDraggableWrapper,
            renderTableCell: renderTableCell,
            isStickyColumnsVisible: isStickyColumnsVisible,
            renderCreateIssueController: renderCreateIssueController,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
            ChildIssueCreateRowComponent: ChildIssueCreateRowComponent,
            isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
            isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
            isEditableSyncLoaded: isEditableSyncLoaded,
            cellBorderStyle: cellBorderStyle,
            isInlineEditingEnabled: isInlineEditingEnabled
        }), [
        jql,
        width,
        sortField,
        sortDirection,
        columns,
        isReparentingEnabled,
        isTimelineEnabled,
        isIssueRankDescending,
        isHideDoneItemsEnabled,
        isFixedTableLayoutEnabled,
        isConditionalFormattingEnabled,
        shouldQuerySprints,
        rankFieldData?.fieldId,
        isStickyColumnsVisible,
        renderCreateIssueController,
        isInlineFieldConfigEnabled,
        ChildIssueCreateRowComponent,
        isLinkRelationshipFieldEnabled,
        isRemoteLinkedIssuesEnabled,
        isEditableSyncLoaded,
        cellBorderStyle,
        isInlineEditingEnabled,
        projectRef,
        formattingRulesData,
        rowInlineCreateCanShowAdditionalFields
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNwIG.ChildRows), {
        ...childRowsProps,
        projectKey: projectKey,
        isGroupingSupported: isGroupingSupported,
        childItemsExperience: (0, $8jOO7.CHILD_ITEMS_EXPERIENCE),
        childItemsLoadMoreExperience: (0, $8jOO7.CHILD_ITEMS_LOAD_MORE_EXPERIENCE),
        analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE),
        renderChildRowsLoader: renderChildRowsLoader
    });
};

});
parcelRegister("bBTKN", function(module, exports) {
$parcel$export(module.exports, "default", () => $52566d0868a1e8fd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7052991347d47bc90cc91bb7b32bbf89>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $52566d0868a1e8fd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RenderChildRowsComp_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Rows_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$52566d0868a1e8fd$var$node.hash = "c7d2d776221c63e40579cb004a5363d9";
var $52566d0868a1e8fd$export$2e2bcd8739ae039 = $52566d0868a1e8fd$var$node;

});

parcelRegister("6gc4l", function(module, exports) {
$parcel$export(module.exports, "default", () => $492b455ffb5baaea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aa6a155db23a8bab5e2a76e41692e658>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $492b455ffb5baaea$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "RenderChildRowsComp_rank",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "jqlTerm"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "aliases"
                }
            ]
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$492b455ffb5baaea$var$node.hash = "f7566d909ef8ff6dbcaf39bc2e7997a7";
var $492b455ffb5baaea$export$2e2bcd8739ae039 = $492b455ffb5baaea$var$node;

});

parcelRegister("f3aTj", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b674747461ab969$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<26953e9dec78044a229ec6efe64b64d3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2b674747461ab969$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "RenderChildRowsComp",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "Rows_project"
        }
    ],
    "type": "JiraProject"
};
$2b674747461ab969$var$node.hash = "b22d740a214bd50022d2b05cb96bd804";
var $2b674747461ab969$export$2e2bcd8739ae039 = $2b674747461ab969$var$node;

});



parcelRegister("7WpdI", function(module, exports) {
$parcel$export(module.exports, "InitializeVirtualizer", () => $771cea3dfdc61397$export$de49fec4748def14);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $6d9QY = parcelRequire("6d9QY");

var $fsisP = parcelRequire("fsisP");

var $8jOO7 = parcelRequire("8jOO7");

var $7n9BS = parcelRequire("7n9BS");

var $4jaZO = parcelRequire("4jaZO");

var $Kdcei = parcelRequire("Kdcei");
const $771cea3dfdc61397$var$estimateSize = ()=>(0, $8jOO7.ROW_HEIGHT) + 1; // include border
const $771cea3dfdc61397$var$InitializeVirtualizerInner = ({ rows: rows = 0, getItemKey: getItemKey, totalSizeRef: totalSizeRef, options: virtualizerOptions })=>{
    const scrollElement = (0, $7n9BS.useScrollElement)();
    const { setVirtualizer: setVirtualizer, setVirtualItemsMap: setVirtualItemsMap } = (0, $Kdcei.useVirtualizationActions)();
    const options = (0, $eJOHy.useMemo)(()=>({
            count: rows,
            getScrollElement: ()=>scrollElement,
            estimateSize: $771cea3dfdc61397$var$estimateSize,
            getItemKey: getItemKey,
            overscan: 10,
            ...virtualizerOptions
        }), [
        getItemKey,
        rows,
        scrollElement,
        virtualizerOptions
    ]);
    const virtualizer = (0, $4jaZO.useSSRSafeVirtualizer)(options);
    const totalSize = virtualizer?.getTotalSize();
    const items = virtualizer?.getVirtualItems();
    // eslint-disable-next-line no-param-reassign
    totalSizeRef.current = totalSize ?? 0;
    const prevVirtualizer = (0, $6d9QY.usePrevious)(virtualizer);
    const prevItems = (0, $6d9QY.usePrevious)(items);
    if (!(0, $fsisP.isShallowEqual)(prevVirtualizer, virtualizer)) setVirtualizer(virtualizer);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevItems, items)) {
        const virtualItemsMap = items?.reduce((acc, item)=>{
            acc[String(item.key)] = true;
            return acc;
        }, {});
        setVirtualItemsMap(virtualItemsMap);
    }
    return null;
};
const $771cea3dfdc61397$export$de49fec4748def14 = (props)=>{
    // Skip any attempts to perform virtualization in SSR
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($771cea3dfdc61397$var$InitializeVirtualizerInner, props);
};

});

parcelRegister("kmVLU", function(module, exports) {
$parcel$export(module.exports, "InitializeVirtualizer", () => $c926824b20470c00$export$de49fec4748def14);

var $frNtp = parcelRequire("frNtp");

var $3hCvp = parcelRequire("3hCvp");

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $6d9QY = parcelRequire("6d9QY");

var $4cTDP = parcelRequire("4cTDP");

var $fsisP = parcelRequire("fsisP");

var $jE8Tu = parcelRequire("jE8Tu");

var $jBNts = parcelRequire("jBNts");

var $8jOO7 = parcelRequire("8jOO7");

var $7n9BS = parcelRequire("7n9BS");

var $4jaZO = parcelRequire("4jaZO");

var $Kdcei = parcelRequire("Kdcei");
const $c926824b20470c00$var$estimateSize = ()=>(0, $8jOO7.ROW_HEIGHT) + 1; // include border
const $c926824b20470c00$var$InitializeVirtualizerInner = ({ options: virtualizerOptions, issueResults: issueResults, groupResults: groupResults })=>{
    const scrollElement = (0, $7n9BS.useScrollElement)();
    const flatList = (0, $jE8Tu.useFlatList)();
    const { setVirtualizer: setVirtualizer, setVirtualItemsMap: setVirtualItemsMap } = (0, $Kdcei.useVirtualizationActions)();
    const issueResultsData = (0, $j4oe4.useFragment)((0, $3hCvp.default), issueResults);
    const groupResultsData = (0, $j4oe4.useFragment)((0, $frNtp.default), groupResults);
    // initialFlatList is currently only guaranteed to keep virtualiser props stable while flatList is empty
    // If flatList is no longer empty, initialFlatList should be ignored
    const initialFlatList = (0, $eJOHy.useMemo)(()=>{
        if (!(flatList?.length <= 0 && (0, $4cTDP.fg)('mimic_flatlist_rss_while_uninitialised'))) return [];
        if (issueResultsData && issueResultsData.edges) return issueResultsData.edges.map((edge)=>edge?.node?.issueId).filter(Boolean).map((issueId)=>(0, $jBNts.getFlatListKey)({
                itemId: issueId
            }));
        if (groupResultsData && groupResultsData.firstGroup && groupResultsData?.firstGroup?.id) {
            const firstGroupId = groupResultsData.firstGroup.id;
            return [
                (0, $jBNts.getFlatListKey)({
                    itemId: firstGroupId,
                    groupId: firstGroupId
                }),
                ...(groupResultsData.firstGroup.issues?.edges ?? []).map((edge)=>edge?.node?.issueId).filter(Boolean).map((issueId)=>(0, $jBNts.getFlatListKey)({
                        itemId: issueId,
                        groupId: firstGroupId
                    })),
                ...groupResultsData.firstGroup.issues?.pageInfo?.hasNextPage ? [
                    (0, $jBNts.getFlatListKey)({
                        itemId: (0, $jE8Tu.getShowMoreItemKey)(firstGroupId),
                        groupId: firstGroupId
                    })
                ] : [],
                ...(groupResultsData.edges ?? []).map((edge)=>edge?.node?.id).filter((id)=>id !== firstGroupId).filter(Boolean).map((id)=>(0, $jBNts.getFlatListKey)({
                        itemId: id,
                        groupId: id
                    }))
            ];
        }
        return [];
    }, [
        flatList?.length,
        groupResultsData,
        issueResultsData
    ]);
    // Represents a stable list of item keys between first render (i.e. flat list is empty) and after flat list has been initialised in RSS.
    const readyFlatList = flatList?.length === 0 && (0, $4cTDP.fg)('mimic_flatlist_rss_while_uninitialised') ? initialFlatList : flatList;
    const getItemKey = (0, $eJOHy.useCallback)((index)=>readyFlatList[index] ?? index, [
        readyFlatList
    ]);
    // eslint-disable-next-line no-nested-ternary
    const rowsCount = (0, $4cTDP.fg)('mimic_flatlist_rss_while_uninitialised') ? readyFlatList.length : flatList?.length > 0 ? flatList?.length : issueResultsData?.edges?.length;
    const options = (0, $eJOHy.useMemo)(()=>({
            count: rowsCount ?? 0,
            getScrollElement: ()=>scrollElement,
            estimateSize: $c926824b20470c00$var$estimateSize,
            getItemKey: getItemKey,
            overscan: 10,
            ...virtualizerOptions
        }), [
        getItemKey,
        rowsCount,
        scrollElement,
        virtualizerOptions
    ]);
    const virtualizer = (0, $4jaZO.useSSRSafeVirtualizer)(options);
    const items = virtualizer?.getVirtualItems();
    const prevVirtualizer = (0, $6d9QY.usePrevious)(virtualizer);
    const prevItems = (0, $6d9QY.usePrevious)(items);
    if (!(0, $fsisP.isShallowEqual)(prevVirtualizer, virtualizer)) setVirtualizer(virtualizer);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevItems, items)) {
        const virtualItemsMap = items?.reduce((acc, item)=>{
            acc[String(item.key)] = true;
            return acc;
        }, {});
        setVirtualItemsMap(virtualItemsMap);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c926824b20470c00$export$7615e534b4b87b24, {
        getItemKey: getItemKey,
        rows: rowsCount ?? 0
    });
};
const $c926824b20470c00$export$de49fec4748def14 = (props)=>{
    // Skip any attempts to perform virtualization in SSR
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c926824b20470c00$var$InitializeVirtualizerInner, props);
};
const $c926824b20470c00$export$7615e534b4b87b24 = ()=>{
    return null;
};

});
parcelRegister("frNtp", function(module, exports) {
$parcel$export(module.exports, "default", () => $df2ec2ed6698d84b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a2ab4549740a08c60a5a377fd202454c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $df2ec2ed6698d84b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isPaginating"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            }
        ],
        "kind": "Fragment",
        "name": "InitializeVirtualizer_groupResults",
        "selections": [
            {
                "concreteType": "JiraSpreadsheetGroupEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "isPaginating",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraSpreadsheetGroup",
                                "kind": "LinkedField",
                                "name": "firstGroup",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "fieldSetsInput",
                                                "variableName": "fieldSetsInput"
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 50
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "scope",
                                                "variableName": "fieldSetsScope"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "settings",
                                                "variableName": "settings"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "viewConfigInput",
                                                "variableName": "viewConfigInput"
                                            }
                                        ],
                                        "concreteType": "JiraIssueConnection",
                                        "kind": "LinkedField",
                                        "name": "issues",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "issueId"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasNextPage"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraSpreadsheetGroupConnection"
    };
}();
$df2ec2ed6698d84b$var$node.hash = "041a2f3e0cbd55d5bc5ccc47012c8bc7";
var $df2ec2ed6698d84b$export$2e2bcd8739ae039 = $df2ec2ed6698d84b$var$node;

});

parcelRegister("3hCvp", function(module, exports) {
$parcel$export(module.exports, "default", () => $07d9cae88edce7de$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<89398bacc5a0e8b4b9465000462ad480>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $07d9cae88edce7de$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "InitializeVirtualizer_issueResults",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "issueId"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$07d9cae88edce7de$var$node.hash = "782e50263411de77c070e5d511a50075";
var $07d9cae88edce7de$export$2e2bcd8739ae039 = $07d9cae88edce7de$var$node;

});



parcelRegister("12O1M", function(module, exports) {
$parcel$export(module.exports, "default", () => $b411531270e205ba$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fo3wk = parcelRequire("fo3wk");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $83DiZ = parcelRequire("83DiZ");

var $jE8Tu = parcelRequire("jE8Tu");

var $34oCh = parcelRequire("34oCh");
const $b411531270e205ba$var$KeyboardShortcuts = ({ onIssueLinkSelected: onIssueLinkSelected })=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const [selectedRowIndex, { selectNextRow: selectNextRow, selectPrevRow: selectPrevRow }] = (0, $jE8Tu.useSelectedRow)();
    const [selectedIssueKey] = (0, $jE8Tu.useSelectedIssueKey)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const keyMap = (0, $eJOHy.useMemo)(()=>{
        const navigateToIssue = (issueKey)=>{
            push(`/browse/${issueKey}`);
        };
        return {
            arrowup: {
                callback: (e)=>{
                    // Prevent native browser scrolling as we provide auto-scroll functionality via scrollIntoView
                    e?.preventDefault();
                    if (isGridNavigationEnabled) return;
                    selectPrevRow();
                }
            },
            arrowdown: {
                callback: (e)=>{
                    // Prevent native browser scrolling as we provide auto-scroll functionality via scrollIntoView
                    e?.preventDefault();
                    if (isGridNavigationEnabled) return;
                    selectNextRow();
                }
            },
            k: {
                callback: ()=>{
                    if (isGridNavigationEnabled) return;
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'rowItem pressed', 'navigateRowUp', {
                        rowIndex: selectedRowIndex,
                        keyPressed: 'k'
                    });
                    selectPrevRow();
                }
            },
            j: {
                callback: ()=>{
                    if (isGridNavigationEnabled) return;
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'rowItem pressed', 'navigateRowDown', {
                        rowIndex: selectedRowIndex,
                        keyPressed: 'j'
                    });
                    selectNextRow();
                }
            },
            o: {
                callback: ()=>{
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'tableIssueLink', {
                        fieldType: 'unknown',
                        keyPressed: 'o',
                        tableRowNumber: selectedRowIndex,
                        keyboardShortcut: true
                    });
                    if (typeof selectedIssueKey === 'string' && selectedIssueKey.length > 0) {
                        const handled = onIssueLinkSelected !== undefined && onIssueLinkSelected(selectedIssueKey);
                        if (!handled) navigateToIssue(selectedIssueKey);
                    }
                }
            },
            z: {
                callback: ()=>{
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'tableIssueLink', {
                        fieldType: 'unknown',
                        keyPressed: 'z',
                        tableRowNumber: selectedRowIndex,
                        keyboardShortcut: true
                    });
                    if (typeof selectedIssueKey === 'string' && selectedIssueKey.length > 0) {
                        const handled = onIssueLinkSelected !== undefined && onIssueLinkSelected(selectedIssueKey);
                        if (!handled) navigateToIssue(selectedIssueKey);
                    }
                }
            }
        };
    }, [
        push,
        selectPrevRow,
        selectNextRow,
        createAnalyticsEvent,
        selectedRowIndex,
        selectedIssueKey,
        onIssueLinkSelected,
        isGridNavigationEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fo3wk.default), {
        keyMap: keyMap
    });
};
var $b411531270e205ba$export$2e2bcd8739ae039 = $b411531270e205ba$var$KeyboardShortcuts;

});
parcelRegister("fo3wk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4454c8bb14df47ef$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $hrKgE = parcelRequire("hrKgE");

var $9ltuT = parcelRequire("9ltuT");

var $lObif = parcelRequire("lObif");

var $5R5jr = parcelRequire("5R5jr");

var $d94A4 = parcelRequire("d94A4");

var $4B7rn = parcelRequire("4B7rn");

var $8gJRB = parcelRequire("8gJRB");
let $4454c8bb14df47ef$var$shortcutsCount = 0;
let $4454c8bb14df47ef$var$subscription = null;
const $4454c8bb14df47ef$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eJOHy.useContext)((0, $4B7rn.ShortcutRegistryContext)) || (0, $d94A4.rootRegistry);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const addKeyMap = (0, $eJOHy.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $8gJRB.bindKeyMapWithErrorHandling)(keyMap, location, createAnalyticsEvent({
                    action: 'pressed',
                    actionSubject: 'keyboardShortcut'
                })),
                label: label
            })), [
        parentRegistry,
        keyMap,
        location,
        createAnalyticsEvent,
        label
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $4454c8bb14df47ef$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $4454c8bb14df47ef$var$shortcutsCount -= 1;
            if ($4454c8bb14df47ef$var$subscription && $4454c8bb14df47ef$var$shortcutsCount === 0) {
                $4454c8bb14df47ef$var$subscription.unsubscribe();
                $4454c8bb14df47ef$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $4454c8bb14df47ef$var$subscription = $4454c8bb14df47ef$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $5R5jr.default)().subscribe((0, $lObif.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
const $4454c8bb14df47ef$var$Shortcuts = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $9ltuT.useKeyboardShortcutsToggle), ...unstableProps })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    const props = (0, $hrKgE.useShallowStableReference)(unstableProps, true);
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4454c8bb14df47ef$var$ShortcutsSubscriber, props) : null;
};
var $4454c8bb14df47ef$export$2e2bcd8739ae039 = $4454c8bb14df47ef$var$Shortcuts;

});
parcelRegister("9ltuT", function(module, exports) {
$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $08e42e851d357ae1$export$a33a81f1fc5458ad);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $hWeHP = parcelRequire("hWeHP");

var $kRgKj = parcelRequire("kRgKj");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $08e42e851d357ae1$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $08e42e851d357ae1$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$08e42e851d357ae1$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $3ugTQ.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $08e42e851d357ae1$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $hWeHP.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $08e42e851d357ae1$export$b62f67be35e65859
    }
});
const $08e42e851d357ae1$export$a33a81f1fc5458ad = (0, $iJq0l.createHook)($08e42e851d357ae1$var$Store);

});

parcelRegister("lObif", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6eea6b4ddedc8b9$export$2e2bcd8739ae039);

var $5R5jr = parcelRequire("5R5jr");

var $d94A4 = parcelRequire("d94A4");
const $f6eea6b4ddedc8b9$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
/**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ const $f6eea6b4ddedc8b9$var$handler = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $d94A4.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $5R5jr.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f6eea6b4ddedc8b9$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $5R5jr.flush)();
    }
};
var $f6eea6b4ddedc8b9$export$2e2bcd8739ae039 = $f6eea6b4ddedc8b9$var$handler;

});
parcelRegister("5R5jr", function(module, exports) {
$parcel$export(module.exports, "flush", () => $6bc56ab68fad194d$export$4909b86c8034bf73);
$parcel$export(module.exports, "default", () => $6bc56ab68fad194d$export$2e2bcd8739ae039);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $7kixv = parcelRequire("7kixv");

var $6WhQS = parcelRequire("6WhQS");
parcelRequire("7SsGX");
parcelRequire("hnYRz");
parcelRequire("llumX");
parcelRequire("lVRem");
parcelRequire("1o2WJ");
parcelRequire("8rm0O");
parcelRequire("9Zsih");
parcelRequire("lf3vd");

var $gPrdS = parcelRequire("gPrdS");

var $6ju76 = parcelRequire("6ju76");
const $6bc56ab68fad194d$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $6bc56ab68fad194d$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6bc56ab68fad194d$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$6bc56ab68fad194d$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6bc56ab68fad194d$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$6bc56ab68fad194d$var$isEditable(e.target) && !$6bc56ab68fad194d$var$ignoredKeys[e.key]);
let $6bc56ab68fad194d$var$key$;
const $6bc56ab68fad194d$var$flush$ = new (0, $6WhQS.Subject)();
const $6bc56ab68fad194d$var$createSequences = ()=>{
    if (!$6bc56ab68fad194d$var$key$) {
        $6bc56ab68fad194d$var$key$ = false ? new (0, $6WhQS.Subject)() : (0, $7kixv.Observable).fromEvent(document, 'keydown').filter($6bc56ab68fad194d$var$isRelevantKeyEvent).filter((0, $6ju76.isLegacyAuiBlanketClosed)).map((0, $gPrdS.toKeyWithModifiers));
        const sequence$ = $6bc56ab68fad194d$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $6bc56ab68fad194d$var$key$ = $6bc56ab68fad194d$var$key$.debounceTime(1000).startWith(null).merge($6bc56ab68fad194d$var$flush$).switchMapTo(sequence$);
    }
    return $6bc56ab68fad194d$var$key$;
};
const $6bc56ab68fad194d$export$4909b86c8034bf73 = ()=>{
    $6bc56ab68fad194d$var$flush$.next();
};
var $6bc56ab68fad194d$export$2e2bcd8739ae039 = $6bc56ab68fad194d$var$createSequences;

});


parcelRegister("8gJRB", function(module, exports) {
$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $91e416a701a8c178$export$77477772a9b904da);

var $eSnSE = parcelRequire("eSnSE");

var $kRgKj = parcelRequire("kRgKj");
const $91e416a701a8c178$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common', analyticsEvent)=>(e)=>{
        try {
            if (analyticsEvent) (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'keyboardShortcut pressed', {
                key: key
            });
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $91e416a701a8c178$export$77477772a9b904da = (keyMap, location, analyticsEvent)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $91e416a701a8c178$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location, analyticsEvent)
            }
        }), {});

});



parcelRegister("clZvH", function(module, exports) {
$parcel$export(module.exports, "default", () => $19be9f81dd7817e6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $19be9f81dd7817e6$var$messages = (0, $7qGN1.defineMessages)({
    columnHeaderIssueType: {
        "id": "native-issue-table.column-header-issue-type",
        "defaultMessage": "Type"
    },
    columnHeaderIssueKey: {
        "id": "native-issue-table.column-header-issue-key",
        "defaultMessage": "Key"
    },
    columnHeaderIssueSummary: {
        "id": "native-issue-table.column-header-issue-summary",
        "defaultMessage": "Summary"
    },
    columnHeaderIssueAssignee: {
        "id": "native-issue-table.column-header-issue-assignee",
        "defaultMessage": "Assignee"
    },
    columnHeaderIssueReporter: {
        "id": "native-issue-table.column-header-issue-reporter",
        "defaultMessage": "Reporter"
    },
    columnHeaderIssuePriority: {
        "id": "native-issue-table.column-header-issue-priority",
        "defaultMessage": "P"
    },
    columnHeaderIssueStatus: {
        "id": "native-issue-table.column-header-issue-status",
        "defaultMessage": "Status"
    },
    columnHeaderIssueResolution: {
        "id": "native-issue-table.column-header-issue-resolution",
        "defaultMessage": "Resolution"
    },
    columnHeaderIssueCreatedDate: {
        "id": "native-issue-table.column-header-issue-created-date",
        "defaultMessage": "Created"
    },
    columnHeaderIssueUpdatedDate: {
        "id": "native-issue-table.column-header-issue-updated-date",
        "defaultMessage": "Updated"
    },
    columnHeaderIssueDueDate: {
        "id": "native-issue-table.column-header-issue-due-date",
        "defaultMessage": "Due"
    },
    columnHeaderIssueActions: {
        "id": "native-issue-table.column-header-issue-actions",
        "defaultMessage": "More actions"
    },
    aToZOrder: {
        "id": "native-issue-table.a-to-z-order",
        "defaultMessage": "A \u279E Z"
    },
    zToAOrder: {
        "id": "native-issue-table.z-to-a-order",
        "defaultMessage": "Z \u279E A"
    },
    oldestToNewestOrder: {
        "id": "native-issue-table.oldest-to-newest-order",
        "defaultMessage": "oldest \u279E newest"
    },
    newestToOldestOrder: {
        "id": "native-issue-table.newest-to-oldest-order",
        "defaultMessage": "newest \u279E oldest"
    },
    reorderColumnsErrorTitle: {
        "id": "native-issue-table.reorder-columns-error-title",
        "defaultMessage": "We couldn't reorder your columns"
    },
    reorderColumnsErrorDescription: {
        "id": "native-issue-table.reorder-columns-error-description",
        "defaultMessage": "Refresh and try again."
    },
    deprecatedParentLinkMessage: {
        "id": "native-issue-table.deprecated-parent-link-message",
        "defaultMessage": "<strong>Parent Link</strong> is replaced by <strong>Parent</strong>."
    }
});
var $19be9f81dd7817e6$export$2e2bcd8739ae039 = $19be9f81dd7817e6$var$messages;

});

parcelRegister("9VBAD", function(module, exports) {
$parcel$export(module.exports, "ScrollContainer", () => $ba39e90ae3fa936c$export$2631a3ab3cdd158d);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $aIjmF = parcelRequire("aIjmF");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $bzbsd = parcelRequire("bzbsd");

var $6d9QY = parcelRequire("6d9QY");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $bmoS1 = parcelRequire("bmoS1");

var $4cTDP = parcelRequire("4cTDP");

var $hbF3h = parcelRequire("hbF3h");

var $aVTEC = parcelRequire("aVTEC");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $7khpH = parcelRequire("7khpH");

var $7n9BS = parcelRequire("7n9BS");

var $4NiKr = parcelRequire("4NiKr");

var $3F6xT = parcelRequire("3F6xT");

var $hGS9u = parcelRequire("hGS9u");
const $ba39e90ae3fa936c$export$afb5fd3c74e214f9 = ({ loading: loading, resetScroll: resetScroll })=>{
    const prevLoading = (0, $6d9QY.usePrevious)(loading);
    // Reseting the scroll when the connection id change will cover any variable change
    (0, $eJOHy.useEffect)(()=>{
        if (prevLoading !== loading && prevLoading === true) resetScroll();
    });
};
const $ba39e90ae3fa936c$export$2631a3ab3cdd158d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ Layout: Layout = $ba39e90ae3fa936c$var$ScrollContainerLayout, children: children, footer: footer, loading: loading, isGrouping: isGrouping, isChildIssuesTable: isChildIssuesTable = false, onScroll: externalOnScroll, columnCount: columnCount, ...infiniteScrollProps }, ref)=>{
    const scrollContainerRef = (0, $eJOHy.useRef)(null);
    const siblingIssueCreateOnScroll = (0, $4NiKr.useSiblingIssueCreateOnScroll)();
    const isInfiniteScrollEnabled = (0, $34oCh.useIsInfiniteScrollEnabled)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isFullPageIssueView = (0, $bmoS1.useIsFullPageIssueView)();
    const previousScrollLeftRef = (0, $eJOHy.useRef)(0);
    const totalScrollableWidthRef = (0, $eJOHy.useRef)(0);
    const resetScroll = (0, $eJOHy.useCallback)(()=>{
        if (scrollContainerRef.current != null && isInfiniteScrollEnabled) scrollContainerRef.current.scrollTop = 0;
    }, [
        isInfiniteScrollEnabled
    ]);
    $ba39e90ae3fa936c$export$afb5fd3c74e214f9({
        loading: loading,
        resetScroll: resetScroll
    });
    const { onLoadingThresholdCheck: onLoadingThresholdCheck, onScroll: infiniteScrollOnScroll } = (0, $7khpH.useInfiniteScrollHandler)(infiniteScrollProps);
    let sendAnalyticsEventDebounced;
    if (isChildIssuesTable && (0, $4cTDP.fg)('ken-2879_is_child_issue_table')) {
        const ANALYTICS_EVENT_DEBOUNCE_DELAY = 1000;
        sendAnalyticsEventDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'childIssuesTable scrolled');
        }, ANALYTICS_EVENT_DEBOUNCE_DELAY);
    }
    // Horizontal scroll analytics function
    const useHorizontalScrollAnalytics = ()=>{
        // TODO: update to avoid violating the rules of hooks
        // See https://jbusiness.atlassian.net/browse/JSC-3369
        const fireDebouncedAnalyticsForHorizontalScroll = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((currentScroll, totalScrollableWidth)=>{
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueView horizontalScroll', {
                    actionSubjectId: 'issueView',
                    scrollLeft: currentScroll,
                    totalScrollableWidth: totalScrollableWidth,
                    section: 'childIssueTable',
                    columnCount: columnCount
                });
            }, 400), []);
        return fireDebouncedAnalyticsForHorizontalScroll;
    };
    // Wrapped with feature gate
    const useHorizontalScrollAnalyticsWithFF = (0, $hbF3h.functionUnionWithCondition)(()=>(0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate'), useHorizontalScrollAnalytics, ()=>undefined);
    // TODO: update to avoid violating the rules of hooks
    // See https://jbusiness.atlassian.net/browse/JSC-3369
    const fireDebouncedAnalyticsForHorizontalScroll = useHorizontalScrollAnalyticsWithFF();
    const fireHorizontalScrollDirectionChangeAnalytics = (0, $aVTEC.useHorizontalScrollDirectionChangeAnalytics)();
    const onScroll = (0, $eJOHy.useCallback)((event)=>{
        if (isChildIssuesTable && typeof sendAnalyticsEventDebounced === 'function' && (0, $4cTDP.fg)('ken-2879_is_child_issue_table')) sendAnalyticsEventDebounced();
        siblingIssueCreateOnScroll?.(event);
        if (isInfiniteScrollEnabled) infiniteScrollOnScroll(event);
        externalOnScroll?.(event);
        if (event.currentTarget instanceof HTMLElement) fireHorizontalScrollDirectionChangeAnalytics(event.currentTarget);
        if (event.target instanceof HTMLElement && (0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate')) {
            const target = event.target;
            const currentScroll = Math.round(target.scrollLeft);
            if (totalScrollableWidthRef.current === 0) totalScrollableWidthRef.current = Math.round(target.scrollWidth - target.clientWidth);
            // Send horizontal scroll analytics when scrolling right for child issue table
            const isScrollingRight = currentScroll > previousScrollLeftRef.current;
            if (isScrollingRight && isChildIssuesTable && isFullPageIssueView && fireDebouncedAnalyticsForHorizontalScroll) fireDebouncedAnalyticsForHorizontalScroll(currentScroll, totalScrollableWidthRef.current);
            previousScrollLeftRef.current = currentScroll;
        }
    }, [
        siblingIssueCreateOnScroll,
        isInfiniteScrollEnabled,
        infiniteScrollOnScroll,
        sendAnalyticsEventDebounced,
        isChildIssuesTable,
        externalOnScroll,
        fireDebouncedAnalyticsForHorizontalScroll,
        isFullPageIssueView,
        fireHorizontalScrollDirectionChangeAnalytics
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Handle auto-scrolling for pragmatic dnd operations like column resizing
        const scrollableElement = scrollContainerRef.current;
        let cleanup;
        if (scrollableElement) cleanup = (0, $aIjmF.autoScrollForElements)({
            element: scrollableElement,
            canScroll: ({ source: source })=>source.data.operation !== (0, $8jOO7.COLUMN_OPERATION_RESIZE)
        });
        return ()=>{
            cleanup?.();
            fireDebouncedAnalyticsForHorizontalScroll?.cancel();
        };
    }, [
        fireDebouncedAnalyticsForHorizontalScroll
    ]);
    const intersectionObsRef = (0, $3F6xT.useIntersectionObserver)();
    const mergedRefs = (0, $bzbsd.default)(ref, intersectionObsRef, scrollContainerRef);
    const loadingManager = isInfiniteScrollEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hGS9u.LoadingManager), {
        isLoadingPrevious: infiniteScrollProps.isLoadingPrevious,
        isLoadingNext: infiniteScrollProps.isLoadingNext,
        onLoadingThresholdCheck: onLoadingThresholdCheck,
        isGrouping: isGrouping
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7n9BS.ScrollStateProvider), {
        scrollRef: scrollContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Layout, {
        containerRef: mergedRefs,
        footer: footer,
        loadingManager: loadingManager,
        onScroll: onScroll
    }, children));
});
const $ba39e90ae3fa936c$var$ScrollContainerLayout = ({ containerRef: containerRef, children: children, footer: footer, loadingManager: loadingManager, onScroll: onScroll })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ba39e90ae3fa936c$var$loadingIndicatorContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ba39e90ae3fa936c$var$scrollContainerStyles,
        ref: containerRef,
        onScroll: onScroll,
        testId: "native-issue-table.ui.scroll-container.scroll-container"
    }, children), loadingManager), footer);
const $ba39e90ae3fa936c$var$HEADER_HEIGHT = 40;
const $ba39e90ae3fa936c$var$scrollContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    position: 'relative',
    flexFlow: 'column nowrap',
    overflow: 'auto',
    // Since header is sticky, we need to specify a scroll padding that matches its height so that auto-scrolling
    // functionality accounts for this element in its calculations, otherwise header can overlap the selected row.
    scrollPaddingTop: `${$ba39e90ae3fa936c$var$HEADER_HEIGHT}px`
});
const $ba39e90ae3fa936c$var$loadingIndicatorContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexFlow: 'column nowrap',
    position: 'relative',
    overflow: 'hidden'
});

});
parcelRegister("aVTEC", function(module, exports) {
$parcel$export(module.exports, "useHorizontalScrollDirectionChangeAnalytics", () => $066f2008dcdea2eb$export$7f82c6c9c621dfa1);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");
const $066f2008dcdea2eb$export$7f82c6c9c621dfa1 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const lastScrollLeft = (0, $eJOHy.useRef)(0);
    const lastDirection = (0, $eJOHy.useRef)(null);
    let isStickyColumnsEnabled = false;
    let isStickyColumnsVisible = false;
    if ((0, $4cTDP.fg)('issue_table_frozen_columns')) {
        // eslint-disable-next-line  react-hooks/rules-of-hooks
        isStickyColumnsEnabled = (0, $34oCh.useIsStickyColumnsEnabled)();
        // eslint-disable-next-line  react-hooks/rules-of-hooks
        isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
    }
    return (0, $eJOHy.useCallback)((target)=>{
        const currentScrollLeft = target.scrollLeft;
        let direction = null;
        if (currentScrollLeft > lastScrollLeft.current) direction = 'right';
        else if (currentScrollLeft < lastScrollLeft.current) direction = 'left';
        // Only fire event if direction changed and it's not the first scroll
        if (direction && lastDirection.current && direction !== lastDirection.current) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueView horizontalScrollChanged', {
            actionSubjectId: 'issueView',
            direction: direction,
            isStickyColumnsEnabled: isStickyColumnsEnabled,
            isStickyColumnsVisible: isStickyColumnsVisible
        });
        if (direction) lastDirection.current = direction;
        lastScrollLeft.current = currentScrollLeft;
    }, [
        createAnalyticsEvent,
        isStickyColumnsEnabled,
        isStickyColumnsVisible
    ]);
};

});

parcelRegister("7khpH", function(module, exports) {
$parcel$export(module.exports, "useInfiniteScrollHandler", () => $8f8e5c1656e840b4$export$ee8d81e7d8c9f22d);

var $eJOHy = parcelRequire("eJOHy");

var $8jOO7 = parcelRequire("8jOO7");

var $5M8i8 = parcelRequire("5M8i8");
const $8f8e5c1656e840b4$var$DEFAULT_ACTIVATION_THRESHOLD = 10 * (0, $8jOO7.ROW_HEIGHT);
const $8f8e5c1656e840b4$export$ee8d81e7d8c9f22d = ({ onLoadNext: onLoadNextProp, onLoadPrevious: onLoadPreviousProp, ...dataProps })=>{
    // Keep props as ref so the callback is stable across rerenders.
    const dataPropsRef = (0, $eJOHy.useRef)(dataProps);
    dataPropsRef.current = dataProps;
    const onLoadNext = (0, $5M8i8.useThrottle)(onLoadNextProp);
    const onLoadPrevious = (0, $5M8i8.useThrottle)(onLoadPreviousProp);
    const onLoadingThresholdCheck = (0, $eJOHy.useCallback)(({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop })=>{
        const { isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious, activationThreshold: activationThreshold = $8f8e5c1656e840b4$var$DEFAULT_ACTIVATION_THRESHOLD } = dataPropsRef.current;
        const scrollBottom = scrollHeight - clientHeight - scrollTop;
        const isLoading = isLoadingNext || isLoadingPrevious;
        // Prioritising loading next over loading previous to fill results downwards first,
        // to hopefully feel more natural.
        if (hasNext && !isLoading && scrollBottom <= activationThreshold) onLoadNext?.();
        else if (hasPrevious && !isLoading && scrollTop <= activationThreshold) onLoadPrevious?.();
    }, // Ensure that the callback is not recreated when props change.
    // onLoadNext & onLoadPrevious should be throttled & stable.
    [
        onLoadNext,
        onLoadPrevious
    ]);
    const onScroll = (0, $eJOHy.useCallback)((event)=>{
        onLoadingThresholdCheck(event.currentTarget);
    }, // Ensure that the callback is not recreated when props change.
    // onLoadingThresholdCheck should be stable.
    [
        onLoadingThresholdCheck
    ]);
    return {
        onLoadingThresholdCheck: onLoadingThresholdCheck,
        onScroll: onScroll
    };
};

});
parcelRegister("5M8i8", function(module, exports) {
$parcel$export(module.exports, "useThrottle", () => $47c0698a2db18423$export$8b7b9481d6186f21);

var $eJOHy = parcelRequire("eJOHy");
const $47c0698a2db18423$export$8b7b9481d6186f21 = (fn, wait = 100)=>{
    const fnRef = (0, $eJOHy.useRef)(fn);
    fnRef.current = fn;
    const waitRef = (0, $eJOHy.useRef)(wait);
    waitRef.current = wait;
    const timeout = (0, $eJOHy.useRef)(undefined);
    const throttled = (0, $eJOHy.useCallback)(()=>{
        if (timeout.current !== undefined) return;
        fnRef.current?.();
        timeout.current = setTimeout(()=>{
            timeout.current = undefined;
        }, waitRef.current);
    // Ensure the callback is not recreated when props change,
    // dependency array should be empty.
    }, []);
    // Cleanup the timeout on unmount.
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (timeout.current !== undefined) clearTimeout(timeout.current);
        };
    }, []);
    return throttled;
};

});


parcelRegister("hGS9u", function(module, exports) {
$parcel$export(module.exports, "LoadingManager", () => $96783ac5fc2dbf3b$export$99cc795e99919eed);

var $eJOHy = parcelRequire("eJOHy");

var $9cbmy = parcelRequire("9cbmy");

var $lRq8t = parcelRequire("lRq8t");

var $6d9QY = parcelRequire("6d9QY");

var $cxKOj = parcelRequire("cxKOj");

var $kbYhH = parcelRequire("kbYhH");

var $7n9BS = parcelRequire("7n9BS");

var $2HFPH = parcelRequire("2HFPH");

var $5ik33 = parcelRequire("5ik33");
const $96783ac5fc2dbf3b$var$getLoadingA11YMessage = ({ isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasFinishedLoadingNext: hasFinishedLoadingNext, hasFinishedLoadingPrevious: hasFinishedLoadingPrevious, isGrouping: isGrouping })=>{
    if (isGrouping) {
        if (isLoadingPrevious) return (0, $5ik33.default).loadStartA11YMessageTopWithGrouping;
        if (hasFinishedLoadingPrevious) return (0, $5ik33.default).loadEndA11YMessageTopWithGrouping;
        if (isLoadingNext) return (0, $5ik33.default).loadStartA11YMessageBottomWithGrouping;
        if (hasFinishedLoadingNext) return (0, $5ik33.default).loadEndA11YMessageBottomWithGrouping;
    }
    if (isLoadingPrevious) return (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ik33.default).loadStartA11YMessageTopIssueTermRefresh : (0, $5ik33.default).loadStartA11YMessageTop;
    if (hasFinishedLoadingPrevious) return (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ik33.default).loadEndA11YMessageTopIssueTermRefresh : (0, $5ik33.default).loadEndA11YMessageTop;
    if (isLoadingNext) return (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ik33.default).loadStartA11YMessageBottomIssueTermRefresh : (0, $5ik33.default).loadStartA11YMessageBottom;
    if (hasFinishedLoadingNext) return (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ik33.default).loadEndA11YMessageBottomIssueTermRefresh : (0, $5ik33.default).loadEndA11YMessageBottom;
    return undefined;
};
const $96783ac5fc2dbf3b$export$99cc795e99919eed = ({ isLoadingPrevious: isLoadingPrevious, isLoadingNext: isLoadingNext, isGrouping: isGrouping, onLoadingThresholdCheck: onLoadingThresholdCheck })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // Table has height 0 during first render due to virtualization. Some checks need to wait for the table to have a height.
    const hasTableHeight = (0, $kbYhH.useElementSizeSelector)((tableState)=>Boolean(tableState.height));
    const scrollElement = (0, $7n9BS.useScrollElement)();
    const height = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.height);
    // #region After-load Handler
    /**
   * After initial render and any subsequent loading events, make sure that we continue loading in more issues if
   * necessary because a single load may not have enough issues to fill the scroll container.
   */ (0, $eJOHy.useEffect)(()=>{
        if (scrollElement && onLoadingThresholdCheck && hasTableHeight && !isLoadingPrevious && !isLoadingNext && height) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        onLoadingThresholdCheck(scrollElement);
    }, [
        hasTableHeight,
        isLoadingPrevious,
        isLoadingNext,
        onLoadingThresholdCheck,
        scrollElement,
        height
    ]);
    // #endregion
    // #region Top Scroll Handler
    /**
   * A component that ensures that the scroll position is kept stable when loading previous issues.
   * This is necessary because sometimes the browser does scroll to keep existing rows in view when new rows are prepended.
   *
   * Without this, we may see issues like continuously loading all previous issues until there are none left.
   */ const prevIsLoadingPrevious = (0, $6d9QY.usePreviousWithInitial)(isLoadingPrevious);
    const hasStartedLoadingPrevious = !prevIsLoadingPrevious && isLoadingPrevious;
    const hasFinishedLoadingPrevious = prevIsLoadingPrevious && !isLoadingPrevious;
    // Hook's scrollHeight doesn't update the height information when the scroll height changes due to DOM mutations
    // Need to track this separately when loading starts
    const scrollHeightRef = (0, $eJOHy.useRef)(0);
    (0, $eJOHy.useEffect)(()=>{
        if (scrollElement && hasStartedLoadingPrevious) scrollHeightRef.current = scrollElement.scrollHeight;
    }, [
        hasStartedLoadingPrevious,
        scrollElement
    ]);
    // Ensure that the scroll is kept in place after loading previous issues - browser doesn't always handle this properly
    // Using a layout effect to make sure this happens as quickly as possible to reduce visible movement
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (scrollElement && hasFinishedLoadingPrevious) {
            const newScrollHeight = scrollElement.scrollHeight;
            if (newScrollHeight > scrollHeightRef.current) {
                const heightIncrease = newScrollHeight - scrollHeightRef.current;
                scrollElement.scrollBy(0, heightIncrease);
            }
            scrollHeightRef.current = newScrollHeight;
        }
    }, [
        hasFinishedLoadingPrevious,
        scrollElement
    ]);
    // #endregion
    // #region Loading A11y
    const prevIsLoadingNext = (0, $6d9QY.usePreviousWithInitial)(isLoadingNext);
    const hasFinishedLoadingNext = prevIsLoadingNext && !isLoadingNext;
    const loadingCompleteLiveMessage = (0, $eJOHy.useRef)(undefined);
    loadingCompleteLiveMessage.current = $96783ac5fc2dbf3b$var$getLoadingA11YMessage({
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        hasFinishedLoadingNext: hasFinishedLoadingNext,
        hasFinishedLoadingPrevious: hasFinishedLoadingPrevious,
        isGrouping: isGrouping
    });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isLoadingPrevious && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2HFPH.LoadingIndicator), {
        position: "top",
        isGrouping: isGrouping
    }), isLoadingNext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2HFPH.LoadingIndicator), {
        position: "bottom",
        isGrouping: isGrouping
    }), loadingCompleteLiveMessage.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), {
        role: "alert",
        "aria-live": "polite"
    }, formatMessage(loadingCompleteLiveMessage.current)));
};

});
parcelRegister("2HFPH", function(module, exports) {
$parcel$export(module.exports, "LoadingIndicator", () => $b6040ad16371eb3a$export$7c20be4c1d342248);

var $eJOHy = parcelRequire("eJOHy");

var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $cxKOj = parcelRequire("cxKOj");

var $etVWf = parcelRequire("etVWf");
const $b6040ad16371eb3a$export$7c20be4c1d342248 = ({ position: position, isGrouping: isGrouping })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getLoadingMessage = ()=>{
        if (isGrouping) return (0, $etVWf.default).loadingMessageWithGrouping;
        return (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $etVWf.default).loadingMessageIssueTermRefresh : (0, $etVWf.default).loadingMessage;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignInline: "center",
        xcss: [
            (0, $4cTDP.fg)('issue_table_frozen_columns') ? $b6040ad16371eb3a$var$containerStyles : $b6040ad16371eb3a$var$containerOldStyles,
            position === 'top' ? $b6040ad16371eb3a$var$positionTopStyles : $b6040ad16371eb3a$var$positionBottomStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center",
        grow: "hug",
        xcss: $b6040ad16371eb3a$var$loadingIndicatorStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        appearance: "invert",
        size: "small",
        interactionName: (0, $4cTDP.fg)('add_nin_press_interactions') ? 'issue-table-infinite-scroll-loading' : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: "color.text.inverse"
    }, formatMessage(getLoadingMessage()))));
};
// Account for the sticky header row height
const $b6040ad16371eb3a$var$HEADER_HEIGHT = 40;
// eslint-disable-next-line @atlaskit/design-system/no-physical-properties
const $b6040ad16371eb3a$var$positionTopStyles = (0, $1DXK0.xcss)({
    top: `${$b6040ad16371eb3a$var$HEADER_HEIGHT}px`
});
// eslint-disable-next-line @atlaskit/design-system/no-physical-properties
const $b6040ad16371eb3a$var$positionBottomStyles = (0, $1DXK0.xcss)({
    bottom: 'space.0'
});
const $b6040ad16371eb3a$var$loadingIndicatorStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral.bold',
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay',
    color: 'color.text.inverse',
    marginBlock: 'space.200',
    padding: 'space.100'
});
const $b6040ad16371eb3a$var$containerOldStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    width: '100%'
});
const $b6040ad16371eb3a$var$containerStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    width: '100%',
    // TODO update this value to 7 when migrating styles to compiled
    // using 7 here because CHART_PREVIEW_BAR_Z_INDEX has a z-index of
    zIndex: 'card'
});

});
parcelRegister("etVWf", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa7af19b14864c77$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $fa7af19b14864c77$var$messages = (0, $7qGN1.defineMessages)({
    loadingMessage: {
        "id": "native-issue-table.scroll-container.loading-manager.loading-indicator.loading-message",
        "defaultMessage": "Loading more issues"
    },
    loadingMessageIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.loading-indicator.loading-message-issue-term-refresh",
        "defaultMessage": "Loading more"
    },
    loadingMessageWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.loading-indicator.loading-message-with-grouping",
        "defaultMessage": "Loading more groups"
    }
});
var $fa7af19b14864c77$export$2e2bcd8739ae039 = $fa7af19b14864c77$var$messages;

});


parcelRegister("5ik33", function(module, exports) {
$parcel$export(module.exports, "default", () => $42222096832b96bf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $42222096832b96bf$var$messages = (0, $7qGN1.defineMessages)({
    loadStartA11YMessageTop: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-top",
        "defaultMessage": "Loading more issues at the top of the table."
    },
    loadEndA11YMessageTop: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-top",
        "defaultMessage": "Finished loading more issues at the top of the table."
    },
    loadStartA11YMessageBottom: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-bottom",
        "defaultMessage": "Loading more issues at the bottom of the table."
    },
    loadEndA11YMessageBottom: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-bottom",
        "defaultMessage": "Finished loading more issues at the bottom of the table."
    },
    loadStartA11YMessageTopIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-top-issue-term-refresh",
        "defaultMessage": "Loading more work items at the top of the table."
    },
    loadEndA11YMessageTopIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-top-issue-term-refresh",
        "defaultMessage": "Finished loading more work items at the top of the table."
    },
    loadStartA11YMessageBottomIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-bottom-issue-term-refresh",
        "defaultMessage": "Loading more work items at the bottom of the table."
    },
    loadEndA11YMessageBottomIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-bottom-issue-term-refresh",
        "defaultMessage": "Finished loading more work items at the bottom of the table."
    },
    loadStartA11YMessageTopWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-top-with-grouping",
        "defaultMessage": "Loading more groups at the top of the table."
    },
    loadEndA11YMessageTopWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-top-with-grouping",
        "defaultMessage": "Finished loading more groups at the top of the table."
    },
    loadStartA11YMessageBottomWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-bottom-with-grouping",
        "defaultMessage": "Loading more groups at the bottom of the table."
    },
    loadEndA11YMessageBottomWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-bottom-with-grouping",
        "defaultMessage": "Finished loading more groups at the bottom of the table."
    }
});
var $42222096832b96bf$export$2e2bcd8739ae039 = $42222096832b96bf$var$messages;

});



parcelRegister("eiAn5", function(module, exports) {
$parcel$export(module.exports, "MainContainer", () => $14f0d3bdd18b09ef$export$d653589df987fd93);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $14f0d3bdd18b09ef$export$d653589df987fd93 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($14f0d3bdd18b09ef$var$StyledMainContainer, props, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $14f0d3bdd18b09ef$var$StyledMainContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { tableBorderWidth: tableBorderWidth, tableBorderRadius: tableBorderRadius, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rg2d25": (0, $awdRS.default)(__cmplp.tableBorderWidth)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2lx21bp4 _1n261q9c _1reo15vq _18m915vq _1h6d1l7x _1dqonqa1 _189e1ht6 _1e0c1txw _kqswpfqs",
            __cmplp.tableBorderRadius ?? "_2rko1mok",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bUOjV", function(module, exports) {
$parcel$export(module.exports, "IssueTableSelectedIssuesProvider", () => $7234e6cdb0c3bc3b$export$8560e956e1937d5);

var $eJOHy = parcelRequire("eJOHy");

var $3TtKq = parcelRequire("3TtKq");
const $7234e6cdb0c3bc3b$export$8560e956e1937d5 = (Component)=>{
    const SelectedIssuesWrapperComponent = (props)=>{
        if (props.enableMultiSelect) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3TtKq.IssueTableSelectedIssuesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props));
    };
    return SelectedIssuesWrapperComponent;
};

});

parcelRegister("cyJHb", function(module, exports) {
$parcel$export(module.exports, "CopyPasteContainer", () => $3d37cc73a680e8e4$export$f22393f54af5c587);

var $eJOHy = parcelRequire("eJOHy");

var $kjtxW = parcelRequire("kjtxW");

var $34oCh = parcelRequire("34oCh");
const $3d37cc73a680e8e4$export$f22393f54af5c587 = ({ children: children })=>{
    const isInlineEditingEnabled = (0, $34oCh.useIsInlineEditingEnabled)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    return isInlineEditingEnabled && isInlineEditingExtendedFieldSupportEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kjtxW.CopyPasteContextProvider), null, children) : children;
};

});

parcelRegister("1GzaA", function(module, exports) {
$parcel$export(module.exports, "ConnectionsSubscriberContainer", () => $1dfdcf001ed824dc$export$dca2df00a75a6b37);

var $eJOHy = parcelRequire("eJOHy");

var $dLXgn = parcelRequire("dLXgn");

var $57Nys = parcelRequire("57Nys");
const $1dfdcf001ed824dc$export$dca2df00a75a6b37 = ({ ConnectionsSubscriber: ConnectionsSubscriber })=>{
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const updateConnectionDetails = (0, $57Nys.useUpdateConnectionDetails)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ConnectionsSubscriber, {
        connections: connections,
        updateConnectionDetails: updateConnectionDetails
    });
};

});

parcelRegister("5CeML", function(module, exports) {
$parcel$export(module.exports, "RootConnectionRegister", () => $681bba3551e30191$export$f2eeecab3dd535b2);

var $0mZLZ = parcelRequire("0mZLZ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $dLXgn = parcelRequire("dLXgn");
const $681bba3551e30191$export$f2eeecab3dd535b2 = ({ issues: issues })=>{
    const issueConnection = (0, $j4oe4.useFragment)((0, $0mZLZ.default), issues ?? null);
    const rootConnectionDetails = (0, $eJOHy.useMemo)(()=>{
        if (issueConnection && issueConnection.__id) return {
            type: 'ROOT_ISSUES',
            connectionId: issueConnection.__id,
            first: issueConnection?.edges?.length ?? 0
        };
        return undefined;
    }, [
        issueConnection
    ]);
    (0, $dLXgn.useRegisterConnection)(rootConnectionDetails);
    return null;
};

});
parcelRegister("0mZLZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $65beac920e379720$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec5d1429b6bc8aa29206c4a7f0299f79>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $65beac920e379720$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RootConnectionRegister",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$65beac920e379720$var$node.hash = "2b16ecb2b05570b21f8d4dc859600431";
var $65beac920e379720$export$2e2bcd8739ae039 = $65beac920e379720$var$node;

});


parcelRegister("1PY5i", function(module, exports) {
$parcel$export(module.exports, "IssueRealtimeUpdater", () => $ecbc742375e79e61$export$d456d8c8edd7984c);

var $krKow = parcelRequire("krKow");

var $8COAi = parcelRequire("8COAi");

var $4jwUM = parcelRequire("4jwUM");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $eruNJ = parcelRequire("eruNJ");

var $cHbHW = parcelRequire("cHbHW");

var $4cTDP = parcelRequire("4cTDP");

var $6f7Qn = parcelRequire("6f7Qn");

var $cC4HA = parcelRequire("cC4HA");

var $dnCkQ = parcelRequire("dnCkQ");

var $8U0rJ = parcelRequire("8U0rJ");
const $ecbc742375e79e61$export$d456d8c8edd7984c = ({ project: project, issues: issues, groups: groups, isHierarchyEnabled: isHierarchyEnabled, isStatusTrackingEnabled: isStatusTrackingEnabled, onRefetch: onRefetchProp, useCustomSubscription: useCustomSubscription = false })=>{
    const realtimeUpdatesForIssues = (0, $8U0rJ.useRealtimeUpdatesForIssues)();
    const onRefetch = (0, $8U0rJ.useRealtimeUpdateOnRefresh)(onRefetchProp);
    const issueConnection = (0, $j4oe4.useFragment)((0, $4jwUM.default), issues ?? null);
    const groupConnection = (0, $j4oe4.useFragment)((0, $8COAi.default), groups ?? null);
    const { projectId: projectId, key: projectKey } = (0, $j4oe4.useFragment)((0, $krKow.default), project);
    const { issueDeleteUpdater: issueDeleteUpdater } = (0, $dnCkQ.useIssueRealtimeUpdater)();
    const onDelete = (0, $eJOHy.useCallback)((store, issueAri)=>{
        return issueDeleteUpdater({
            store: store,
            issueResourceId: issueAri,
            groupConnectionId: groupConnection?.__id,
            projectKey: projectKey
        });
    }, [
        groupConnection?.__id,
        projectKey,
        issueDeleteUpdater
    ]);
    const onIssuesCreatedUpdated = (0, $eJOHy.useCallback)((issuesCreatedUpdated)=>{
        realtimeUpdatesForIssues({
            issues: issuesCreatedUpdated,
            isHierarchyEnabled: isHierarchyEnabled ?? false,
            jql: issueConnection?.jql || groupConnection?.jql || '',
            groupByFieldId: groupConnection?.groupByField || undefined,
            groupConnectionId: groupConnection?.__id,
            numGroupsLoaded: groupConnection?.edges?.length ?? 0,
            projectKey: projectKey,
            isStatusTrackingEnabled: isStatusTrackingEnabled ?? false
        });
    }, [
        realtimeUpdatesForIssues,
        isHierarchyEnabled,
        issueConnection?.jql,
        groupConnection?.jql,
        groupConnection?.groupByField,
        groupConnection?.__id,
        groupConnection?.edges?.length,
        projectKey,
        isStatusTrackingEnabled
    ]);
    const projectIds = (0, $eJOHy.useMemo)(()=>[
            projectId
        ], [
        projectId
    ]);
    return (0, $4cTDP.fg)('jsc-3441-refactor-nin-subscription-to-eventemitter') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6f7Qn.IssuePubSubProvider), null, !useCustomSubscription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ecbc742375e79e61$var$DefaultListSubscription, {
        projectIds: projectIds
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eruNJ.IssueRealtimeUpdates), {
        onIssuesCreatedUpdated: onIssuesCreatedUpdated,
        onDelete: onDelete,
        onRefetch: onRefetch
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cHbHW.IssueRealtimeUpdatesOld), {
        projectIds: projectIds,
        onIssuesCreatedUpdated: onIssuesCreatedUpdated,
        onDelete: onDelete,
        onRefetch: onRefetch
    });
};
const $ecbc742375e79e61$var$DefaultListSubscription = ({ projectIds: projectIds })=>{
    (0, $cC4HA.useListSubscriptions)({
        projectIds: projectIds
    });
    return null;
};

});
parcelRegister("krKow", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd7561295b7c6837$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9be28c345f906c80c49959c9ee530754>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fd7561295b7c6837$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueRealtimeUpdater_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        }
    ],
    "type": "JiraProject"
};
$fd7561295b7c6837$var$node.hash = "a5539e715af10148bab39eda849e59a5";
var $fd7561295b7c6837$export$2e2bcd8739ae039 = $fd7561295b7c6837$var$node;

});

parcelRegister("8COAi", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b3208402fc03f94$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8c99835fbb7a7a86f36fab01de2f9e84>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4b3208402fc03f94$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueRealtimeUpdater_spreadsheetGroupConnection",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "ScalarField",
            "name": "groupByField"
        },
        {
            "concreteType": "JiraSpreadsheetGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$4b3208402fc03f94$var$node.hash = "f4c9f9679d436f8fef9fddc4aaf7fa66";
var $4b3208402fc03f94$export$2e2bcd8739ae039 = $4b3208402fc03f94$var$node;

});

parcelRegister("4jwUM", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c7199ac12695aaf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e3ad345667cc1a204b05076252805c01>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0c7199ac12695aaf$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueRealtimeUpdater",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$0c7199ac12695aaf$var$node.hash = "0dd12505590cf3a645eeeccd268004c4";
var $0c7199ac12695aaf$export$2e2bcd8739ae039 = $0c7199ac12695aaf$var$node;

});

parcelRegister("eruNJ", function(module, exports) {
$parcel$export(module.exports, "IssueRealtimeUpdates", () => $ee613b2478cf200b$export$14b03bca5fb897a7);

var $eJOHy = parcelRequire("eJOHy");

var $6DCNy = parcelRequire("6DCNy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $2ApNu = parcelRequire("2ApNu");


var $6f7Qn = parcelRequire("6f7Qn");

var $7atDR = parcelRequire("7atDR");

var $CxwzV = parcelRequire("CxwzV");
const $ee613b2478cf200b$var$REAL_TIME_EVENT_TYPE_KEY = 'realTimeEventType';
const $ee613b2478cf200b$export$14b03bca5fb897a7 = ({ onIssuesCreatedUpdated: onIssuesCreatedUpdated, onDelete: onDelete, onRefetch: onRefetch })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const throttledFireTrackAnalytics = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))((0, $kRgKj.fireTrackAnalytics), 1000), []);
    const hasExceededMaxQueueSizeRef = (0, $eJOHy.useRef)(false);
    const showRealtimeUpdateExceededMaxFlag = (0, $CxwzV.useRealtimeUpdateExceededMaxFlag)();
    const queueRef = (0, $eJOHy.useRef)(new Map());
    const timeoutRef = (0, $eJOHy.useRef)(null);
    const processQueue = (0, $eJOHy.useCallback)(()=>{
        if (queueRef.current.size === 0 || hasExceededMaxQueueSizeRef.current) return;
        (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'realTimeEventQueueProcessing started', {
            queueSize: queueRef.current.size
        });
        if (queueRef.current.size > (0, $b567b8b0cf775133$export$d3ea91bf4184016b)) {
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'realTimeEventsExceededMaxFlag shown', {
                queueSize: queueRef.current.size
            });
            hasExceededMaxQueueSizeRef.current = true;
            showRealtimeUpdateExceededMaxFlag({
                onRefresh: ()=>{
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'realTimeEventsExceededMaxRefresh clicked');
                    hasExceededMaxQueueSizeRef.current = false;
                    queueRef.current = new Map();
                    onRefetch?.();
                }
            });
        } else onIssuesCreatedUpdated(Array.from(queueRef.current.values()));
        queueRef.current = new Map();
    }, [
        createAnalyticsEvent,
        showRealtimeUpdateExceededMaxFlag,
        onRefetch,
        onIssuesCreatedUpdated
    ]);
    const triggerDelayedProcessingOfQueue = (0, $eJOHy.useCallback)(()=>{
        // Existing timeout exists, so we don't need to create a new one
        if (timeoutRef.current) return;
        timeoutRef.current = setTimeout(()=>{
            processQueue();
            timeoutRef.current = null;
        }, (0, $b567b8b0cf775133$export$2c7ede6e55079caa));
    }, [
        processQueue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    const onUpdatedOrCreated = (0, $eJOHy.useCallback)((payload)=>{
        const { resourceId: resourceId } = payload;
        const issueId = (0, $2ApNu.JiraIssueAri).parse(resourceId).issueId;
        handleCreateOrUpdateEventRef.current(resourceId, issueId);
    }, []);
    const onDeleted = (0, $eJOHy.useCallback)((payload)=>{
        const { resourceId: resourceId, store: store } = payload;
        const wasDeleted = onDeleteRef.current(store, resourceId);
        wasDeleted && throttledFireTrackAnalytics(createAnalyticsEvent({}), 'realTimeEvent processed', {
            [$ee613b2478cf200b$var$REAL_TIME_EVENT_TYPE_KEY]: 'delete'
        });
    }, [
        createAnalyticsEvent,
        throttledFireTrackAnalytics
    ]);
    (0, $6f7Qn.useSubscribeToIssueEvent)((0, $7atDR.ISSUE_EVENT_NAMES).UPDATED_OR_CREATED, onUpdatedOrCreated);
    (0, $6f7Qn.useSubscribeToIssueEvent)((0, $7atDR.ISSUE_EVENT_NAMES).DELETED, onDeleted);
    const handleCreateOrUpdateEvent = (0, $eJOHy.useCallback)((issueAri, issueId)=>{
        queueRef.current.set(issueAri, {
            issueAri: issueAri,
            issueId: issueId
        });
        triggerDelayedProcessingOfQueue();
    }, [
        triggerDelayedProcessingOfQueue
    ]);
    const handleCreateOrUpdateEventRef = (0, $eJOHy.useRef)(handleCreateOrUpdateEvent);
    if (handleCreateOrUpdateEventRef.current !== handleCreateOrUpdateEvent) handleCreateOrUpdateEventRef.current = handleCreateOrUpdateEvent;
    const onDeleteRef = (0, $eJOHy.useRef)(onDelete);
    if (onDeleteRef.current !== onDelete) onDeleteRef.current = onDelete;
    return null;
};

});
const $b567b8b0cf775133$export$b8b9d90f9e5bd72b = 'jiraIssueRealtimeUpdates';
const $b567b8b0cf775133$export$d57b6b390e78d90f = 'jira-yurree';
const $b567b8b0cf775133$export$d3ea91bf4184016b = 100;
const $b567b8b0cf775133$export$2c7ede6e55079caa = 3000;

parcelRegister("6f7Qn", function(module, exports) {
$parcel$export(module.exports, "IssuePubSubProvider", () => $a00b131204ee9014$export$6eca6dc85568d47f);
$parcel$export(module.exports, "usePublishIssueEvent", () => $a00b131204ee9014$export$c102c68ed7818307);
$parcel$export(module.exports, "useSubscribeToIssueEvent", () => $a00b131204ee9014$export$d92f57082bdd35c);

var $eJOHy = parcelRequire("eJOHy");
class $a00b131204ee9014$var$IssuePubSub {
    subscribe(event, subscriber) {
        const list = this.subscribers[event];
        if (list) list.push(subscriber);
        else this.subscribers[event] = [
            subscriber
        ];
        return ()=>this.unsubscribe(event, subscriber);
    }
    unsubscribe(event, subscriber) {
        const list = this.subscribers[event];
        if (!list) return;
        this.subscribers[event] = list.filter((s)=>s !== subscriber);
    }
    publish(event, payload) {
        this.subscribers[event]?.forEach((s)=>s(payload));
    }
    constructor(){
        this.subscribers = {};
    }
}
const $a00b131204ee9014$var$IssuePubSubContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
function $a00b131204ee9014$export$6eca6dc85568d47f({ children: children }) {
    const issuePubSub = (0, $eJOHy.useContext)($a00b131204ee9014$var$IssuePubSubContext);
    const newPubSub = (0, $eJOHy.useMemo)(()=>{
        if (issuePubSub === null) return new $a00b131204ee9014$var$IssuePubSub(); // create a new pubsub if it's null
        return issuePubSub;
    }, [
        issuePubSub
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a00b131204ee9014$var$IssuePubSubContext.Provider, {
        value: newPubSub
    }, children);
}
const $a00b131204ee9014$export$e29ff1c32b6e0fbe = ()=>{
    const issuePubSub = (0, $eJOHy.useContext)($a00b131204ee9014$var$IssuePubSubContext);
    if (issuePubSub === null) throw new Error('IssuePubSub is been used without a context.');
    return issuePubSub;
};
function $a00b131204ee9014$export$c102c68ed7818307() {
    const pubsub = $a00b131204ee9014$export$e29ff1c32b6e0fbe();
    return (0, $eJOHy.useCallback)((event, payload)=>{
        pubsub.publish(event, payload);
    }, [
        pubsub
    ]);
}
function $a00b131204ee9014$export$d92f57082bdd35c(event, subscriber) {
    const pubsub = $a00b131204ee9014$export$e29ff1c32b6e0fbe();
    (0, $eJOHy.useEffect)(()=>{
        const eventsArray = Array.isArray(event) ? event : [
            event
        ];
        const unsubs = eventsArray.map((e)=>pubsub.subscribe(e, subscriber));
        return ()=>{
            return unsubs.forEach((u)=>u());
        };
    }, [
        pubsub,
        event,
        subscriber
    ]);
}

});

parcelRegister("7atDR", function(module, exports) {
$parcel$export(module.exports, "ISSUE_EVENT_NAMES", () => $cc8682994c177026$export$f42329487063540f);
const $cc8682994c177026$export$f42329487063540f = {
    UPDATED_OR_CREATED: 'issueUpdatedOrCreated',
    DELETED: 'issueDeleted'
};

});

parcelRegister("CxwzV", function(module, exports) {
$parcel$export(module.exports, "useRealtimeUpdateExceededMaxFlag", () => $998a3d12bee9ba4c$export$b8dd0666e1c54372);

var $eJOHy = parcelRequire("eJOHy");

var $2R0ne = parcelRequire("2R0ne");

var $cSXp8 = parcelRequire("cSXp8");

var $8N38Y = parcelRequire("8N38Y");
const $998a3d12bee9ba4c$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID = 'jira-issue-realtime-updates.ui.flag.info.realtime-update-exceeded-max-flag';
const $998a3d12bee9ba4c$export$b8dd0666e1c54372 = ()=>{
    const { showFlag: showFlag, hasFlag: hasFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
    return (0, $eJOHy.useCallback)(({ onRefresh: onRefresh })=>{
        if (!hasFlag?.($998a3d12bee9ba4c$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID)) showFlag({
            type: 'info',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-information, #357DE8)"
            }),
            title: (0, $8N38Y.default).realtimeUpdateExceededMaxHeader,
            description: (0, $8N38Y.default).realtimeUpdateExceededMaxDescription,
            messageId: $998a3d12bee9ba4c$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID,
            id: $998a3d12bee9ba4c$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID,
            messageType: 'transactional',
            isAutoDismiss: true,
            actions: [
                {
                    content: (0, $8N38Y.default).realtimeUpdateExceededMaxRefreshButton,
                    onClick: ()=>{
                        dismissFlag($998a3d12bee9ba4c$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID);
                        onRefresh();
                    }
                }
            ]
        });
    }, [
        dismissFlag,
        hasFlag,
        showFlag
    ]);
};

});
parcelRegister("8N38Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $bea8de0a5e97e5e4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $bea8de0a5e97e5e4$var$messages = (0, $7qGN1.defineMessages)({
    realtimeUpdateExceededMaxHeader: {
        "id": "jira-issue-realtime-updates.ui.flag.info.realtime-update-exceeded-max-header",
        "defaultMessage": "Updating those work items"
    },
    realtimeUpdateExceededMaxDescription: {
        "id": "jira-issue-realtime-updates.ui.flag.info.realtime-update-exceeded-max-description",
        "defaultMessage": "Refresh the page to see the updates"
    },
    realtimeUpdateExceededMaxRefreshButton: {
        "id": "jira-issue-realtime-updates.ui.flag.info.realtime-update-exceeded-max-refresh-button",
        "defaultMessage": "Refresh"
    }
});
var $bea8de0a5e97e5e4$export$2e2bcd8739ae039 = $bea8de0a5e97e5e4$var$messages;

});



parcelRegister("cHbHW", function(module, exports) {
$parcel$export(module.exports, "IssueRealtimeUpdatesOld", () => $08b8fdfe9eff335c$export$811879fdfef0137d);

var $8gDYS = parcelRequire("8gDYS");

var $gY7EX = parcelRequire("gY7EX");

var $heQUp = parcelRequire("heQUp");

var $eJOHy = parcelRequire("eJOHy");

var $6DCNy = parcelRequire("6DCNy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $cHtIB = parcelRequire("cHtIB");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $8oKDI = parcelRequire("8oKDI");


var $CxwzV = parcelRequire("CxwzV");
const $08b8fdfe9eff335c$var$REAL_TIME_EVENT_TYPE_KEY = 'realTimeEventType';
const $08b8fdfe9eff335c$var$CREATE_ERROR_ID = 'realTimeIssueCreate';
const $08b8fdfe9eff335c$var$UPDATE_ERROR_ID = 'realTimeIssueUpdate';
const $08b8fdfe9eff335c$var$DELETE_ERROR_ID = 'realTimeIssueDelete';
const $08b8fdfe9eff335c$var$issueCreatedSubscription = (0, $heQUp.default);
const $08b8fdfe9eff335c$var$issueUpdatedSubscription = (0, $gY7EX.default);
const $08b8fdfe9eff335c$var$issueDeletedSubscription = (0, $8gDYS.default);
const $08b8fdfe9eff335c$export$811879fdfef0137d = ({ projectIds: projectIds, onIssuesCreatedUpdated: onIssuesCreatedUpdated, onDelete: onDelete, onRefetch: onRefetch })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const throttledFireTrackAnalytics = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))((0, $kRgKj.fireTrackAnalytics), 1000), []);
    const hasExceededMaxQueueSizeRef = (0, $eJOHy.useRef)(false);
    const showRealtimeUpdateExceededMaxFlag = (0, $CxwzV.useRealtimeUpdateExceededMaxFlag)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const variables = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectIds: projectIds
        }), [
        cloudId,
        projectIds
    ]);
    const queueRef = (0, $eJOHy.useRef)(new Map());
    const timeoutRef = (0, $eJOHy.useRef)(null);
    const processQueue = (0, $eJOHy.useCallback)(()=>{
        if (queueRef.current.size === 0 || hasExceededMaxQueueSizeRef.current) return;
        (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'realTimeEventQueueProcessing started', {
            queueSize: queueRef.current.size
        });
        if (queueRef.current.size > (0, $b567b8b0cf775133$export$d3ea91bf4184016b)) {
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'realTimeEventsExceededMaxFlag shown', {
                queueSize: queueRef.current.size
            });
            hasExceededMaxQueueSizeRef.current = true;
            showRealtimeUpdateExceededMaxFlag({
                onRefresh: ()=>{
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'realTimeEventsExceededMaxRefresh clicked');
                    hasExceededMaxQueueSizeRef.current = false;
                    queueRef.current = new Map();
                    onRefetch?.();
                }
            });
        } else onIssuesCreatedUpdated(Array.from(queueRef.current.values()));
        queueRef.current = new Map();
    }, [
        createAnalyticsEvent,
        showRealtimeUpdateExceededMaxFlag,
        onRefetch,
        onIssuesCreatedUpdated
    ]);
    const triggerDelayedProcessingOfQueue = (0, $eJOHy.useCallback)(()=>{
        // Existing timeout exists, so we don't need to create a new one
        if (timeoutRef.current) return;
        timeoutRef.current = setTimeout(()=>{
            processQueue();
            timeoutRef.current = null;
        }, (0, $b567b8b0cf775133$export$2c7ede6e55079caa));
    }, [
        processQueue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    const handleCreateOrUpdateEvent = (0, $eJOHy.useCallback)((issueAri, issueId)=>{
        queueRef.current.set(issueAri, {
            issueAri: issueAri,
            issueId: issueId
        });
        triggerDelayedProcessingOfQueue();
    }, [
        triggerDelayedProcessingOfQueue
    ]);
    const handleCreateOrUpdateEventRef = (0, $eJOHy.useRef)(handleCreateOrUpdateEvent);
    if (handleCreateOrUpdateEventRef.current !== handleCreateOrUpdateEvent) handleCreateOrUpdateEventRef.current = handleCreateOrUpdateEvent;
    const createConfig = (0, $eJOHy.useMemo)(()=>({
            variables: variables,
            subscription: $08b8fdfe9eff335c$var$issueCreatedSubscription,
            onNext: async (response)=>{
                try {
                    const resourceId = response?.jira?.onIssueCreatedByProjectsNoEnrichment?.resource;
                    if (resourceId && (0, $8oKDI.isAri)(resourceId)) handleCreateOrUpdateEventRef.current(resourceId, (0, $8oKDI.getAriConfig)(resourceId).resourceId);
                } catch (error) {
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: $08b8fdfe9eff335c$var$CREATE_ERROR_ID,
                            packageName: (0, $b567b8b0cf775133$export$b8b9d90f9e5bd72b),
                            teamName: (0, $b567b8b0cf775133$export$d57b6b390e78d90f)
                        },
                        attributes: {
                            logLocation: 'onNext'
                        },
                        error: error instanceof Error ? error : undefined,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError: (error)=>{
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: $08b8fdfe9eff335c$var$CREATE_ERROR_ID,
                        packageName: (0, $b567b8b0cf775133$export$b8b9d90f9e5bd72b),
                        teamName: (0, $b567b8b0cf775133$export$d57b6b390e78d90f)
                    },
                    attributes: {
                        logLocation: 'onError'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }), [
        variables
    ]);
    const updateConfig = (0, $eJOHy.useMemo)(()=>({
            variables: variables,
            subscription: $08b8fdfe9eff335c$var$issueUpdatedSubscription,
            onNext: async (response)=>{
                try {
                    const resourceId = response?.jira?.onIssueUpdatedByProjectsNoEnrichment?.resource;
                    if (resourceId && (0, $8oKDI.isAri)(resourceId)) handleCreateOrUpdateEventRef.current(resourceId, (0, $8oKDI.getAriConfig)(resourceId).resourceId);
                } catch (error) {
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: $08b8fdfe9eff335c$var$UPDATE_ERROR_ID,
                            packageName: (0, $b567b8b0cf775133$export$b8b9d90f9e5bd72b),
                            teamName: (0, $b567b8b0cf775133$export$d57b6b390e78d90f)
                        },
                        attributes: {
                            logLocation: 'onNext'
                        },
                        error: error instanceof Error ? error : undefined,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError: (error)=>{
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: $08b8fdfe9eff335c$var$UPDATE_ERROR_ID,
                        packageName: (0, $b567b8b0cf775133$export$b8b9d90f9e5bd72b),
                        teamName: (0, $b567b8b0cf775133$export$d57b6b390e78d90f)
                    },
                    attributes: {
                        logLocation: 'onError'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }), [
        variables
    ]);
    const onDeleteRef = (0, $eJOHy.useRef)(onDelete);
    if (onDeleteRef.current !== onDelete) onDeleteRef.current = onDelete;
    const deleteConfig = (0, $eJOHy.useMemo)(()=>{
        return {
            variables: variables,
            subscription: $08b8fdfe9eff335c$var$issueDeletedSubscription,
            updater: (store, response)=>{
                try {
                    if (response?.jira?.onIssueDeletedByProjectsNoEnrichment?.resource) {
                        const wasDeleted = onDeleteRef.current(store, response.jira.onIssueDeletedByProjectsNoEnrichment.resource);
                        wasDeleted && throttledFireTrackAnalytics(createAnalyticsEvent({}), 'realTimeEvent processed', {
                            [$08b8fdfe9eff335c$var$REAL_TIME_EVENT_TYPE_KEY]: 'delete'
                        });
                    }
                } catch (error) {
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: $08b8fdfe9eff335c$var$DELETE_ERROR_ID,
                            packageName: (0, $b567b8b0cf775133$export$b8b9d90f9e5bd72b),
                            teamName: (0, $b567b8b0cf775133$export$d57b6b390e78d90f)
                        },
                        attributes: {
                            logLocation: 'updater'
                        },
                        error: error instanceof Error ? error : undefined,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError: (error)=>{
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: $08b8fdfe9eff335c$var$DELETE_ERROR_ID,
                        packageName: (0, $b567b8b0cf775133$export$b8b9d90f9e5bd72b),
                        teamName: (0, $b567b8b0cf775133$export$d57b6b390e78d90f)
                    },
                    attributes: {
                        logLocation: 'onError'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
    }, [
        variables,
        createAnalyticsEvent,
        throttledFireTrackAnalytics
    ]);
    (0, $j4oe4.useSubscription)(createConfig);
    (0, $j4oe4.useSubscription)(updateConfig);
    (0, $j4oe4.useSubscription)(deleteConfig);
    return null;
};

});
parcelRegister("8gDYS", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b6a383e7ce0f7fb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0cde08d239abb7e6fa3bdc3169a233d6>>
 * @relayHash 74cea7861d3deecdd672e43c4b88d11e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2312b735aa3c534a08b5277cb3b3537aeba7adf4bb55c12e9eefc67f83c12a72
const $1b6a383e7ce0f7fb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIds"
        }
    ], v1 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectIds",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraIssueDeletedStreamHubPayload",
                    "kind": "LinkedField",
                    "name": "onIssueDeletedByProjectsNoEnrichment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "IssueRealtimeUpdatesOld_issueDeletedSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "IssueRealtimeUpdatesOld_issueDeletedSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "2312b735aa3c534a08b5277cb3b3537aeba7adf4bb55c12e9eefc67f83c12a72",
            "metadata": {},
            "name": "IssueRealtimeUpdatesOld_issueDeletedSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$1b6a383e7ce0f7fb$var$node.hash = "c0907310f347cd999732690f33d13e85";
var $1b6a383e7ce0f7fb$export$2e2bcd8739ae039 = $1b6a383e7ce0f7fb$var$node;

});

parcelRegister("gY7EX", function(module, exports) {
$parcel$export(module.exports, "default", () => $d10933a1c11f8923$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ed602b8309e4c6b80d87ca187403028e>>
 * @relayHash 479cc21a1fb5fc53e2a65af4221b3eaa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 582b608f854de79f12d4546eb7b8b8b95988dbb5dc489a6d1b38191927fe334e
const $d10933a1c11f8923$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIds"
        }
    ], v1 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectIds",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraIssueUpdatedStreamHubPayload",
                    "kind": "LinkedField",
                    "name": "onIssueUpdatedByProjectsNoEnrichment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "IssueRealtimeUpdatesOld_issueUpdatedSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "IssueRealtimeUpdatesOld_issueUpdatedSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "582b608f854de79f12d4546eb7b8b8b95988dbb5dc489a6d1b38191927fe334e",
            "metadata": {},
            "name": "IssueRealtimeUpdatesOld_issueUpdatedSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$d10933a1c11f8923$var$node.hash = "e282e82465724e5d7819eb55e1da2e50";
var $d10933a1c11f8923$export$2e2bcd8739ae039 = $d10933a1c11f8923$var$node;

});

parcelRegister("heQUp", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ca25822ab202048$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<57aa0d7a21aa8a4cf07941b81c5ffba0>>
 * @relayHash b284f67f1f656435d82e16aa401fb7e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 507ca052fcb589da5c9b26c9f675c8eb132b3e37eae53f299dad3bee8ac6a7c4
const $8ca25822ab202048$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIds"
        }
    ], v1 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectIds",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraIssueCreatedStreamHubPayload",
                    "kind": "LinkedField",
                    "name": "onIssueCreatedByProjectsNoEnrichment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "IssueRealtimeUpdatesOld_issueCreatedSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "IssueRealtimeUpdatesOld_issueCreatedSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "507ca052fcb589da5c9b26c9f675c8eb132b3e37eae53f299dad3bee8ac6a7c4",
            "metadata": {},
            "name": "IssueRealtimeUpdatesOld_issueCreatedSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$8ca25822ab202048$var$node.hash = "b15cdab36914d0d913c7f692d88fbcd1";
var $8ca25822ab202048$export$2e2bcd8739ae039 = $8ca25822ab202048$var$node;

});


parcelRegister("cC4HA", function(module, exports) {
$parcel$export(module.exports, "useListSubscriptions", () => $da7b4a9a1b92808e$export$46e2c8442457ca66);

var $4M6KT = parcelRequire("4M6KT");

var $1HbzI = parcelRequire("1HbzI");

var $1GoRD = parcelRequire("1GoRD");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $cHtIB = parcelRequire("cHtIB");

var $9pTd3 = parcelRequire("9pTd3");

var $6f7Qn = parcelRequire("6f7Qn");


var $7atDR = parcelRequire("7atDR");
const $da7b4a9a1b92808e$var$CREATE_ERROR_ID = 'realTimeIssueCreate';
const $da7b4a9a1b92808e$var$UPDATE_ERROR_ID = 'realTimeIssueUpdate';
const $da7b4a9a1b92808e$var$DELETE_ERROR_ID = 'realTimeIssueDelete';
const $da7b4a9a1b92808e$export$daa9188a20201c68 = (0, $1GoRD.default);
const $da7b4a9a1b92808e$export$163dcd45fda57fc4 = (0, $1HbzI.default);
const $da7b4a9a1b92808e$export$85b4374627769d27 = (0, $4M6KT.default);
function $da7b4a9a1b92808e$export$46e2c8442457ca66({ projectIds: projectIds }) {
    const cloudId = (0, $cHtIB.useCloudId)();
    const variables = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectIds: projectIds
        }), [
        cloudId,
        projectIds
    ]);
    const publishIssueEvent = (0, $6f7Qn.usePublishIssueEvent)();
    const createConfig = (0, $eJOHy.useMemo)(()=>({
            variables: variables,
            subscription: $da7b4a9a1b92808e$export$daa9188a20201c68,
            onNext: async (response)=>{
                try {
                    const resourceId = response?.jira?.onIssueCreatedByProjectsNoEnrichment?.resource;
                    if (resourceId) publishIssueEvent((0, $7atDR.ISSUE_EVENT_NAMES).UPDATED_OR_CREATED, {
                        resourceId: resourceId
                    });
                } catch (error) {
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: $da7b4a9a1b92808e$var$CREATE_ERROR_ID,
                            packageName: (0, $b567b8b0cf775133$export$b8b9d90f9e5bd72b),
                            teamName: (0, $b567b8b0cf775133$export$d57b6b390e78d90f)
                        },
                        attributes: {
                            logLocation: 'onNext'
                        },
                        error: error instanceof Error ? error : undefined,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError: (error)=>{
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: $da7b4a9a1b92808e$var$CREATE_ERROR_ID,
                        packageName: (0, $b567b8b0cf775133$export$b8b9d90f9e5bd72b),
                        teamName: (0, $b567b8b0cf775133$export$d57b6b390e78d90f)
                    },
                    attributes: {
                        logLocation: 'onError'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }), [
        variables,
        publishIssueEvent
    ]);
    const updateConfig = (0, $eJOHy.useMemo)(()=>({
            variables: variables,
            subscription: $da7b4a9a1b92808e$export$163dcd45fda57fc4,
            onNext: async (response)=>{
                try {
                    const resourceId = response?.jira?.onIssueUpdatedByProjectsNoEnrichment?.resource;
                    if (resourceId) publishIssueEvent((0, $7atDR.ISSUE_EVENT_NAMES).UPDATED_OR_CREATED, {
                        resourceId: resourceId
                    });
                } catch (error) {
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: $da7b4a9a1b92808e$var$UPDATE_ERROR_ID,
                            packageName: (0, $b567b8b0cf775133$export$b8b9d90f9e5bd72b),
                            teamName: (0, $b567b8b0cf775133$export$d57b6b390e78d90f)
                        },
                        attributes: {
                            logLocation: 'onNext'
                        },
                        error: error instanceof Error ? error : undefined,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError: (error)=>{
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: $da7b4a9a1b92808e$var$UPDATE_ERROR_ID,
                        packageName: (0, $b567b8b0cf775133$export$b8b9d90f9e5bd72b),
                        teamName: (0, $b567b8b0cf775133$export$d57b6b390e78d90f)
                    },
                    attributes: {
                        logLocation: 'onError'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }), [
        variables,
        publishIssueEvent
    ]);
    const deleteConfig = (0, $eJOHy.useMemo)(()=>{
        return {
            variables: variables,
            subscription: $da7b4a9a1b92808e$export$85b4374627769d27,
            updater: (store, response)=>{
                try {
                    if (response?.jira?.onIssueDeletedByProjectsNoEnrichment?.resource) publishIssueEvent((0, $7atDR.ISSUE_EVENT_NAMES).DELETED, {
                        resourceId: response.jira.onIssueDeletedByProjectsNoEnrichment.resource,
                        store: store
                    });
                } catch (error) {
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: $da7b4a9a1b92808e$var$DELETE_ERROR_ID,
                            packageName: (0, $b567b8b0cf775133$export$b8b9d90f9e5bd72b),
                            teamName: (0, $b567b8b0cf775133$export$d57b6b390e78d90f)
                        },
                        attributes: {
                            logLocation: 'updater'
                        },
                        error: error instanceof Error ? error : undefined,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError: (error)=>{
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: $da7b4a9a1b92808e$var$DELETE_ERROR_ID,
                        packageName: (0, $b567b8b0cf775133$export$b8b9d90f9e5bd72b),
                        teamName: (0, $b567b8b0cf775133$export$d57b6b390e78d90f)
                    },
                    attributes: {
                        logLocation: 'onError'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
    }, [
        variables,
        publishIssueEvent
    ]);
    (0, $j4oe4.useSubscription)(createConfig);
    (0, $j4oe4.useSubscription)(updateConfig);
    (0, $j4oe4.useSubscription)(deleteConfig);
    return null;
}

});
parcelRegister("4M6KT", function(module, exports) {
$parcel$export(module.exports, "default", () => $439726444bc4aacc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<857273134efc375bfee32779dbbd4d07>>
 * @relayHash 0cf2289498521d72da58e16e658edd91
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 70e4795808ac0d4f83134e8c310d6575e84f5e548a299f0bfb03b131e6699dc8
const $439726444bc4aacc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIds"
        }
    ], v1 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectIds",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraIssueDeletedStreamHubPayload",
                    "kind": "LinkedField",
                    "name": "onIssueDeletedByProjectsNoEnrichment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useListSubscriptions_issueDeletedSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useListSubscriptions_issueDeletedSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "70e4795808ac0d4f83134e8c310d6575e84f5e548a299f0bfb03b131e6699dc8",
            "metadata": {},
            "name": "useListSubscriptions_issueDeletedSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$439726444bc4aacc$var$node.hash = "e885b6209a4f84743ea2296af6385e22";
var $439726444bc4aacc$export$2e2bcd8739ae039 = $439726444bc4aacc$var$node;

});

parcelRegister("1HbzI", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fbbf8189ffcbe0e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1043f5dbef807ef1d1794fc56bb363a3>>
 * @relayHash 48d188b53dadf4628f1e10205a108aaa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 216fa5c0118b3930f52bc8f3d87c0a1efc90ca653cdb4b6f3156d32b2b03d7a9
const $4fbbf8189ffcbe0e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIds"
        }
    ], v1 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectIds",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraIssueUpdatedStreamHubPayload",
                    "kind": "LinkedField",
                    "name": "onIssueUpdatedByProjectsNoEnrichment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useListSubscriptions_issueUpdatedSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useListSubscriptions_issueUpdatedSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "216fa5c0118b3930f52bc8f3d87c0a1efc90ca653cdb4b6f3156d32b2b03d7a9",
            "metadata": {},
            "name": "useListSubscriptions_issueUpdatedSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$4fbbf8189ffcbe0e$var$node.hash = "dcd2c2ff534c8759baebc1f02e009c14";
var $4fbbf8189ffcbe0e$export$2e2bcd8739ae039 = $4fbbf8189ffcbe0e$var$node;

});

parcelRegister("1GoRD", function(module, exports) {
$parcel$export(module.exports, "default", () => $df5f65729a7f174b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7774909b94e44b758e6bcf61d951cd9f>>
 * @relayHash dfa04e51a646cfd023e8af5ff319e30e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0bfdc624a6e47e20f82bbb750221d5d10a3e538d9013f6081b973ff3fcff8f60
const $df5f65729a7f174b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIds"
        }
    ], v1 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectIds",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraIssueCreatedStreamHubPayload",
                    "kind": "LinkedField",
                    "name": "onIssueCreatedByProjectsNoEnrichment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useListSubscriptions_issueCreatedSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useListSubscriptions_issueCreatedSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "0bfdc624a6e47e20f82bbb750221d5d10a3e538d9013f6081b973ff3fcff8f60",
            "metadata": {},
            "name": "useListSubscriptions_issueCreatedSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$df5f65729a7f174b$var$node.hash = "068495a33345aa411b7d71217aa48e6b";
var $df5f65729a7f174b$export$2e2bcd8739ae039 = $df5f65729a7f174b$var$node;

});


parcelRegister("dnCkQ", function(module, exports) {
$parcel$export(module.exports, "useIssueRealtimeUpdater", () => $9930494e7ca458a9$export$bf267694965fe0e3);

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");

var $kqd31 = parcelRequire("kqd31");

var $dLXgn = parcelRequire("dLXgn");

var $57Nys = parcelRequire("57Nys");
const $9930494e7ca458a9$var$JIRA_ISSUE_TYPENAME = 'JiraIssue';
const $9930494e7ca458a9$export$6d61b264f874da2c = ({ store: store, connectionRecord: connectionRecord, fieldSetsRecordId: fieldSetsRecordId, issueRecordId: issueRecordId, position: position, projectKey: projectKey })=>{
    const issueRecord = store.get(issueRecordId);
    const fieldSetsRecord = fieldSetsRecordId ? store.get(fieldSetsRecordId) : undefined;
    if (!issueRecord || !fieldSetsRecord) return;
    const edge = (0, $37Ewn.ConnectionHandler).createEdge(store, connectionRecord, issueRecord, 'JiraIssueEdge');
    const fieldSets = edge.getOrCreateLinkedRecord('fieldSets', 'JiraIssueFieldSetEdge', {
        first: 500
    });
    fieldSets.copyFieldsFrom(fieldSetsRecord);
    const updateArgs = projectKey ? {
        projectKey: projectKey
    } : undefined;
    const canHaveChildIssues = issueRecord.getValue('canHaveChildIssues', updateArgs);
    if (canHaveChildIssues) edge.setValue(true, 'canHaveChildIssues', updateArgs);
    // no before or after implies an empty connection, verify then create the edges list
    const { EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
    const edges = connectionRecord.getLinkedRecords(EDGES);
    if (!edges || position === -1 || position == null) return;
    const nextEdges = edges.slice(0, position).concat(edge).concat(edges.slice(position));
    connectionRecord.setLinkedRecords(nextEdges, EDGES);
};
const $9930494e7ca458a9$export$bf267694965fe0e3 = ()=>{
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const updateConnectionDetails = (0, $57Nys.useUpdateConnectionDetails)();
    const updateIssuesOnConnection = (0, $eJOHy.useCallback)(({ store: store, connection: connection, searchViewContexts: searchViewContexts, updatedIssues: updatedIssues, groupConnectionId: groupConnectionId, projectKey: projectKey, hasAccurateGroupCounts: hasAccurateGroupCounts })=>{
        const issuesProcessedAnalytics = {
            issuesUnmoved: new Set(),
            issuesMoved: new Set(),
            issuesRemoved: new Set(),
            issuesUnrelated: new Set()
        };
        const connectionRecord = store.get(connection.connectionId);
        if (!connectionRecord) return issuesProcessedAnalytics;
        const issuesWithContext = new Set(searchViewContexts?.flatMap((context)=>context?.sourceIssueId).filter(Boolean));
        const startingIssuesInConnection = new Set(connectionRecord.getLinkedRecords('edges')?.map((edge)=>edge?.getLinkedRecord('node')?.getDataID()));
        let changeInIssueCount = 0;
        updatedIssues.forEach((issue)=>{
            if (!issuesWithContext.has(issue.issueId)) {
                if (startingIssuesInConnection.has(issue.issueRecordId)) {
                    (0, $37Ewn.ConnectionHandler).deleteNode(connectionRecord, issue.issueRecordId);
                    changeInIssueCount -= 1;
                    issuesProcessedAnalytics.issuesRemoved.add(issue.issueId);
                } else issuesProcessedAnalytics.issuesUnrelated.add(issue.issueId);
            }
        });
        searchViewContexts?.forEach((context)=>{
            const currentIssues = connectionRecord.getLinkedRecords('edges');
            const issueForContext = updatedIssues.get(context.sourceIssueId);
            if (!currentIssues || !issueForContext) return;
            const positionForIssue = (0, $57Nys.getIssueIndexInConnection)({
                issues: currentIssues,
                issuesWithContext: issuesWithContext,
                context: context
            });
            const issueAtPosition = currentIssues[positionForIssue];
            if (issueAtPosition && issueAtPosition.getLinkedRecord('node')?.getDataID() !== issueForContext.issueRecordId || context.position === currentIssues.length // the item would be the next loaded issue, insert in case the last page is loaded to ensure it appears in all cases
            ) {
                if (startingIssuesInConnection.has(issueForContext.issueRecordId)) (0, $37Ewn.ConnectionHandler).deleteNode(connectionRecord, issueForContext.issueRecordId);
                else changeInIssueCount += 1;
                $9930494e7ca458a9$export$6d61b264f874da2c({
                    store: store,
                    connectionRecord: connectionRecord,
                    fieldSetsRecordId: issueForContext.fieldSetsRecordId,
                    issueRecordId: issueForContext.issueRecordId,
                    position: positionForIssue,
                    projectKey: projectKey
                });
                issuesProcessedAnalytics.issuesMoved.add(issueForContext.issueId);
            } else if (issueAtPosition != null) issuesProcessedAnalytics.issuesUnmoved.add(issueForContext.issueId);
            else if (positionForIssue > currentIssues.length && startingIssuesInConnection.has(issueForContext.issueRecordId)) {
                (0, $37Ewn.ConnectionHandler).deleteNode(connectionRecord, issueForContext.issueRecordId);
                issuesProcessedAnalytics.issuesMoved.add(issueForContext.issueId);
                changeInIssueCount -= 1;
            } else issuesProcessedAnalytics.issuesUnrelated.add(issueForContext.issueId);
            // the issue has been handled, pop it so we can know its place in the list is trustworthy and will not be moved for relative positioning purposes
            issuesWithContext.delete(context.sourceIssueId);
        });
        updateConnectionDetails({
            store: store,
            connection: connection,
            netChangeInIssueCount: changeInIssueCount,
            remainingIssueCount: connectionRecord.getLinkedRecords('edges')?.length,
            groupConnectionId: groupConnectionId,
            projectKey: projectKey,
            hasAccurateGroupCounts: hasAccurateGroupCounts
        });
        return issuesProcessedAnalytics;
    }, [
        updateConnectionDetails
    ]);
    const updateNewParentsOnConnection = (0, $eJOHy.useCallback)(({ store: store, connection: connection, updatedParents: updatedParents, projectKey: projectKey })=>{
        const connectionRecord = store.get(connection.connectionId);
        const { EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
        const edges = connectionRecord?.getLinkedRecords(EDGES);
        edges?.forEach((edge)=>{
            const parentIssueRecordId = edge?.getLinkedRecord('node')?.getDataID();
            if (parentIssueRecordId && updatedParents.has(parentIssueRecordId)) (0, $57Nys.updateParentHasChildren)({
                store: store,
                parentIssueEdgeRecordId: edge?.getDataID(),
                // this refers the the children connection of the parent, where this update is designed to work on parents where no connection can exist now
                connectionId: undefined,
                hasChildren: true,
                projectKey: projectKey
            });
        });
    }, []);
    const issueDeleteUpdater = (0, $eJOHy.useCallback)(({ store: store, issueResourceId: issueResourceId, groupConnectionId: groupConnectionId, projectKey: projectKey })=>{
        const id = (0, $kqd31.default)({
            id: issueResourceId
        }, $9930494e7ca458a9$var$JIRA_ISSUE_TYPENAME);
        let wasDeleted = false;
        if (!id) return wasDeleted;
        Object.values(connections).forEach((connection)=>{
            const connectionRecord = store.get(connection.connectionId);
            if (!connectionRecord) return;
            // check if the issue is in the connection
            if (connectionRecord.getLinkedRecords('edges')?.some((edge)=>edge?.getLinkedRecord('node')?.getDataID() === id)) {
                (0, $37Ewn.ConnectionHandler).deleteNode(connectionRecord, id);
                updateConnectionDetails({
                    store: store,
                    connection: connection,
                    netChangeInIssueCount: -1,
                    remainingIssueCount: connectionRecord.getLinkedRecords('edges')?.length,
                    groupConnectionId: groupConnectionId,
                    projectKey: projectKey
                });
                wasDeleted = true;
            }
        });
        return wasDeleted;
    }, [
        connections,
        updateConnectionDetails
    ]);
    const groupsForIssueUpdater = (0, $eJOHy.useCallback)(({ store: store, groupConnectionId: groupConnectionId, groupsForIssue: groupsForIssue })=>{
        let wasUpdated = false;
        if (!groupConnectionId) return wasUpdated;
        const groupsConnection = store.get(groupConnectionId);
        if (!groupsConnection) return wasUpdated;
        let groupEdges = groupsConnection.getLinkedRecords('edges') || [];
        const existingGroupIds = new Set(groupEdges?.map((edge)=>edge?.getLinkedRecord('node')?.getValue('id')));
        groupsForIssue.forEach((group)=>{
            const newGroup = store.get(group.__id);
            if (!existingGroupIds.has(group.id) && newGroup) {
                groupEdges = (0, $57Nys.insertNewGroupInGroupsConnection)({
                    store: store,
                    groupsConnection: groupsConnection,
                    newGroup: newGroup,
                    groupEdges: groupEdges,
                    afterGroupId: group.afterGroupId
                });
                wasUpdated = true;
            }
        });
        groupsConnection.setLinkedRecords(groupEdges, 'edges');
        return wasUpdated;
    }, []);
    return {
        issueDeleteUpdater: issueDeleteUpdater,
        groupsForIssueUpdater: groupsForIssueUpdater,
        updateIssuesOnConnection: updateIssuesOnConnection,
        updateNewParentsOnConnection: updateNewParentsOnConnection
    };
};

});

parcelRegister("8U0rJ", function(module, exports) {
$parcel$export(module.exports, "useRealtimeUpdatesForIssues", () => $71c3c0a590161895$export$9688da58398f9e26);
$parcel$export(module.exports, "useRealtimeUpdateOnRefresh", () => $71c3c0a590161895$export$dd28753b70cf6515);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");

var $cHtIB = parcelRequire("cHtIB");

var $dLXgn = parcelRequire("dLXgn");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");

var $5NEjg = parcelRequire("5NEjg");

var $dnCkQ = parcelRequire("dnCkQ");

var $fes1G = parcelRequire("fes1G");

var $lEvni = parcelRequire("lEvni");
const $71c3c0a590161895$export$cb618b52025e9ed0 = ({ connections: connections, isGroupingEnabled: isGroupingEnabled, groupedByFieldId: groupedByFieldId })=>{
    const expandedParents = [];
    const groups = [];
    let topLevelItemsLoaded = 0;
    Object.values(connections).forEach((connection)=>{
        if (connection.type === 'PARENT_CHILDREN') expandedParents.push({
            parentIssueId: connection.parentId,
            first: connection.first
        });
        else if (connection.type === 'GROUP_CHILDREN') groups.push({
            jql: connection.jql,
            fieldValue: connection.fieldValue,
            first: connection.first
        });
        else if (connection.type === 'ROOT_ISSUES') topLevelItemsLoaded = connection.first;
    });
    if (isGroupingEnabled && groupedByFieldId) return {
        expandedGroups: {
            groupedByFieldId: groupedByFieldId,
            groups: groups
        }
    };
    return {
        expandedParents: expandedParents,
        topLevelItemsLoaded: topLevelItemsLoaded
    };
};
const $71c3c0a590161895$export$9688da58398f9e26 = ()=>{
    const environment = (0, $7zZ4w.default)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const { fieldSetIds: fieldSetIds } = (0, $5NEjg.useIssueFetchQueryVariables)();
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isInlineEditingEnabled = (0, $34oCh.useIsInlineEditingEnabled)();
    const isHideDoneItemsEnabled = (0, $34oCh.useIsHideDoneItemsEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const isLinkRelationshipFieldEnabled = (0, $34oCh.useIsRelationshipFieldEnabled)();
    const isEditableSyncLoaded = (0, $34oCh.useIsEditableSyncLoaded)();
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const getGroupsForIssues = (0, $lEvni.useGetGroupsForIssues)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const getRealtimeIssueDetails = (0, $fes1G.useGetRealtimeIssueDetails)();
    const { updateIssuesOnConnection: updateIssuesOnConnection, groupsForIssueUpdater: groupsForIssueUpdater, updateNewParentsOnConnection: updateNewParentsOnConnection } = (0, $dnCkQ.useIssueRealtimeUpdater)();
    const isConditionalFormattingEnabled = (0, $4cTDP.fg)('jira_list_conditional_formatting') && // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $34oCh.useIsConditionalFormattingEnabled)();
    return (0, $eJOHy.useCallback)(async ({ issues: issues, jql: jql, groupByFieldId: groupByFieldId, numGroupsLoaded: numGroupsLoaded, groupConnectionId: groupConnectionId, isHierarchyEnabled: isHierarchyEnabled, projectKey: projectKey, isStatusTrackingEnabled: isStatusTrackingEnabled })=>{
        const isGroupingEnabled = !!groupByFieldId;
        const searchViewContextInput = $71c3c0a590161895$export$cb618b52025e9ed0({
            connections: connections,
            isGroupingEnabled: isGroupingEnabled,
            groupedByFieldId: groupByFieldId
        });
        const { issues: updatedIssues, searchViewContexts: searchViewContexts } = await getRealtimeIssueDetails({
            issues: issues,
            cloudId: cloudId,
            fieldSetIds: fieldSetIds,
            isInlineEditingEnabled: isInlineEditingEnabled,
            isDensityFull: isDensityFull,
            isHierarchyEnabled: isHierarchyEnabled,
            isGroupingEnabled: isGroupingEnabled,
            isHideDoneItemsEnabled: isHideDoneItemsEnabled,
            issueSearchInput: {
                jql: jql
            },
            searchViewContextInput: searchViewContextInput,
            projectKey: projectKey,
            isStatusTrackingEnabled: isStatusTrackingEnabled,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
            isEditableSyncLoaded: isEditableSyncLoaded
        });
        let groupsToInsert;
        const shouldQueryGroupsForIssues = isGroupingEnabled && !!groupByFieldId;
        if (shouldQueryGroupsForIssues) {
            const issueKeysWithContext = new Set(searchViewContexts?.flatMap((connection)=>{
                return connection.contexts?.map((context)=>context?.sourceIssueId);
            }).filter(Boolean));
            const issueChangesWithoutContext = (0, $4cTDP.fg)('group_by_any_field') ? updatedIssues?.map((issue)=>({
                    issueId: issue.issueId
                })) : updatedIssues?.reduce((acc, issue)=>{
                if (issue && !issueKeysWithContext.has(issue.issueId ?? '')) acc.push({
                    issueId: issue.issueId
                });
                return acc;
            }, []);
            groupsToInsert = await getGroupsForIssues({
                issueChanges: issueChangesWithoutContext,
                fieldId: groupByFieldId,
                numGroupsLoaded: numGroupsLoaded,
                issueSearchInput: {
                    jql: jql
                },
                staticViewInput: {
                    isHierarchyEnabled: isHierarchyEnabled,
                    isGroupingEnabled: isGroupingEnabled,
                    isHideDoneEnabled: isHideDoneItemsEnabled
                }
            });
        }
        const eventDetails = {
            issuesUnmoved: new Set(),
            issuesUnrelated: new Set(),
            issuesUpdated: new Set()
        };
        const updatedIssuesMap = new Map(updatedIssues?.map(({ issueId: issueId, issueRecordId: issueRecordId, fieldSetsRecordId: fieldSetsRecordId })=>[
                issueId,
                {
                    issueId: issueId,
                    issueRecordId: issueRecordId,
                    fieldSetsRecordId: fieldSetsRecordId
                }
            ]));
        const updatedParents = new Set(updatedIssues.map((issue)=>issue.parentIssueRecordId).filter(Boolean));
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            Object.values(connections).forEach((connection)=>{
                updateNewParentsOnConnection({
                    store: store,
                    connection: connection,
                    updatedParents: updatedParents,
                    projectKey: projectKey
                });
                const matchingContext = searchViewContexts?.find((context)=>{
                    if (connection.type === 'PARENT_CHILDREN') return context?.parentIssueId === connection.parentId;
                    if (connection.type === 'GROUP_CHILDREN') return context?.jql === connection.jql;
                    return context?.jql == null && context?.parentIssueId == null;
                });
                const updatedDetails = updateIssuesOnConnection({
                    store: store,
                    connection: connection,
                    searchViewContexts: matchingContext?.contexts ?? [],
                    updatedIssues: updatedIssuesMap,
                    groupConnectionId: groupConnectionId,
                    projectKey: projectKey,
                    hasAccurateGroupCounts: (0, $4cTDP.fg)('group_by_any_field') ? connection.type === 'GROUP_CHILDREN' && groupsToInsert?.some((group)=>group.id === connection.groupId) : undefined
                });
                updatedDetails.issuesMoved.forEach(eventDetails.issuesUpdated.add, eventDetails.issuesUpdated);
                updatedDetails.issuesUnmoved.forEach(eventDetails.issuesUnmoved.add, eventDetails.issuesUnmoved);
                updatedDetails.issuesUnrelated.forEach(eventDetails.issuesUnrelated.add, eventDetails.issuesUnrelated);
                updatedDetails.issuesRemoved.forEach(eventDetails.issuesUpdated.add, eventDetails.issuesUpdated);
            });
            if (groupsToInsert && groupsToInsert.length > 0) groupsForIssueUpdater({
                store: store,
                groupConnectionId: groupConnectionId,
                groupsForIssue: groupsToInsert
            });
        });
        (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueTableRealTimeEventsIssueDetails Processed', {
            issuesInSamePosition: eventDetails.issuesUnmoved.size,
            issuesInNewPosition: eventDetails.issuesUpdated.size,
            issuesNotImpactingList: Array.from(eventDetails.issuesUnrelated).reduce((acc, issueId)=>eventDetails.issuesUpdated.has(issueId) || eventDetails.issuesUnmoved.has(issueId) ? acc : acc + 1, 0)
        });
    }, [
        connections,
        getRealtimeIssueDetails,
        cloudId,
        fieldSetIds,
        isInlineEditingEnabled,
        isDensityFull,
        isHideDoneItemsEnabled,
        environment,
        createAnalyticsEvent,
        getGroupsForIssues,
        updateNewParentsOnConnection,
        updateIssuesOnConnection,
        groupsForIssueUpdater,
        isConditionalFormattingEnabled,
        isTimelineEnabled,
        isLinkRelationshipFieldEnabled,
        isEditableSyncLoaded
    ]);
};
const $71c3c0a590161895$export$dd28753b70cf6515 = (onRefresh)=>{
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const environment = (0, $7zZ4w.default)();
    return (0, $eJOHy.useCallback)(()=>{
        // This will reload all expanded parents/groups
        environment.commitUpdate((store)=>{
            Object.values(connections).forEach((connection)=>{
                const connectionToInvalidate = store.get(connection.connectionId);
                if (connectionToInvalidate) connectionToInvalidate.invalidateRecord();
            });
        });
        onRefresh?.();
    }, [
        connections,
        environment,
        onRefresh
    ]);
};

});
parcelRegister("fes1G", function(module, exports) {
$parcel$export(module.exports, "useGetRealtimeIssueDetails", () => $f73212fb4bd676d3$export$d36444b54640c2df);

var $2TA0V = parcelRequire("2TA0V");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $7zZ4w = parcelRequire("7zZ4w");

var $8jOO7 = parcelRequire("8jOO7");
const $f73212fb4bd676d3$export$d36444b54640c2df = ()=>{
    return (0, $eJOHy.useCallback)(async ({ issues: issues, cloudId: cloudId, fieldSetIds: fieldSetIds, isInlineEditingEnabled: isInlineEditingEnabled, isDensityFull: isDensityFull, isHierarchyEnabled: isHierarchyEnabled, isGroupingEnabled: isGroupingEnabled, isHideDoneItemsEnabled: isHideDoneItemsEnabled, isConditionalFormattingEnabled: isConditionalFormattingEnabled, issueSearchInput: issueSearchInput, searchViewContextInput: searchViewContextInput, projectKey: projectKey, isTimelineEnabled: isTimelineEnabled, isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled, isEditableSyncLoaded: isEditableSyncLoaded })=>{
        const environment = (0, $7zZ4w.default)();
        try {
            // if the issue is in a loaded context, the issue is visible so we need to fetch the fields for display
            const result = await (0, $j4oe4.fetchQuery)(environment, (0, $2TA0V.default), {
                issueAris: issues.map((issue)=>issue.issueAri),
                cloudId: cloudId,
                fieldSetIds: fieldSetIds,
                isInlineEditingEnabled: isInlineEditingEnabled,
                isDensityFull: isDensityFull,
                issueSearchInput: issueSearchInput,
                searchViewContextInput: searchViewContextInput,
                isHierarchyEnabled: isHierarchyEnabled ?? false,
                projectKey: projectKey,
                issueChanges: issues.map((issue)=>({
                        issueId: issue.issueId
                    })),
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                staticViewInput: {
                    isHierarchyEnabled: isHierarchyEnabled,
                    isGroupingEnabled: isGroupingEnabled,
                    isHideDoneEnabled: isHideDoneItemsEnabled
                },
                isTimelineEnabled: isTimelineEnabled,
                isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
                isEditableSyncLoaded: isEditableSyncLoaded
            }, {
                fetchPolicy: 'network-only'
            }).toPromise();
            return {
                issues: result?.jira_issuesByIds?.filter(Boolean)?.map((issue)=>({
                        issueId: issue.issueId,
                        issueRecordId: issue.__id,
                        fieldSetsRecordId: issue.fieldSetsById?.__id,
                        parentIssueRecordId: issue.parentIssueField?.parentIssue?.__id
                    })) ?? [],
                searchViewContexts: result?.jira?.searchViewContexts?.edges?.map((edge)=>{
                    if (!edge?.node) return undefined;
                    return {
                        parentIssueId: edge.node.parentIssueId ?? undefined,
                        jql: edge.node.jql ?? undefined,
                        contexts: edge?.node?.contexts?.map((context)=>({
                                position: context.position,
                                sourceIssueId: context.sourceIssueId,
                                beforeIssueId: context.beforeIssueId,
                                afterIssueId: context.afterIssueId
                            })) ?? []
                    };
                }).filter(Boolean) ?? []
            };
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'realTimeFetchIssueFieldSetConnection',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                },
                error: error instanceof Error ? error : undefined,
                sendToPrivacyUnsafeSplunk: true
            });
            return Promise.resolve({
                issues: [],
                searchViewContexts: []
            });
        }
    }, []);
};

});
parcelRegister("2TA0V", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c542931a973f177$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5429565503ab29bec2ae99d94c0fb898>>
 * @relayHash 930c89043e37e321c6ba0390fb3192d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f9da774271b8b61bc148453a312d1a3d1208b2d126106296f9095772ae6ff51

var $3Bt2F = parcelRequire("3Bt2F");

var $3jVIX = parcelRequire("3jVIX");

var $hRj2m = parcelRequire("hRj2m");

var $6AioA = parcelRequire("6AioA");

var $04qit = parcelRequire("04qit");

var $jvWSl = parcelRequire("jvWSl");

var $ePJhs = parcelRequire("ePJhs");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $1fipb = parcelRequire("1fipb");

var $FU9UR = parcelRequire("FU9UR");
const $2c542931a973f177$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDensityFull"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isEditableSyncLoaded"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHierarchyEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isInlineEditingEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLinkRelationshipFieldEnabled"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueAris"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueChanges"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchViewContextInput"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "ids",
            "variableName": "issueAris"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v17 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v18 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "key"
    }, v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v22 = {
        "args": [
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ],
        "kind": "ScalarField",
        "name": "canHaveChildIssues"
    }, v23 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "issueChanges",
            "variableName": "issueChanges"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "searchViewContextInput",
            "variableName": "searchViewContextInput"
        },
        {
            "kind": "Variable",
            "name": "staticViewInput",
            "variableName": "staticViewInput"
        }
    ], v24 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "parentIssueId"
            }
        ],
        "type": "JiraIssueSearchBulkViewParentContexts"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "jql"
            }
        ],
        "type": "JiraIssueSearchBulkViewGroupContexts"
    }, v26 = {
        "kind": "ScalarField",
        "name": "sourceIssueId"
    }, v27 = {
        "kind": "ScalarField",
        "name": "position"
    }, v28 = {
        "kind": "ScalarField",
        "name": "beforeIssueId"
    }, v29 = {
        "kind": "ScalarField",
        "name": "afterIssueId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "type"
    }, v31 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v32 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v33 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v34 = {
        "kind": "ScalarField",
        "name": "name"
    }, v35 = {
        "kind": "ScalarField",
        "name": "value"
    }, v36 = [
        v35 /*: any*/ ,
        v20 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v37 = {
        "condition": "isInlineEditingEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lazyIsEditableInIssueView"
                    }
                ]
            }
        ]
    }, v38 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v39 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v40 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v41 = {
        "kind": "ScalarField",
        "name": "date"
    }, v42 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v43 = {
        "kind": "ScalarField",
        "name": "text"
    }, v44 = {
        "condition": "isEditableSyncLoaded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditableInIssueView"
            }
        ]
    }, v45 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v46 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v45 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v47 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v20 /*: any*/ 
        ]
    }, v48 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v49 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v50 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v51 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v46 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v52 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v53 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v54 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v55 = [
        {
            "kind": "ScalarField",
            "name": "appType"
        }
    ], v56 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v57 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v58 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v59 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v60 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v61 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v62 = [
        v20 /*: any*/ 
    ], v63 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v62 /*: any*/ 
    }, v64 = {
        "kind": "ScalarField",
        "name": "href"
    }, v65 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v51 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v66 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v67 = {
        "kind": "InlineFragment",
        "selections": [
            v41 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v68 = [
        v32 /*: any*/ ,
        v33 /*: any*/ ,
        v67 /*: any*/ ,
        v20 /*: any*/ 
    ], v69 = [
        v32 /*: any*/ ,
        v67 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": v62 /*: any*/ ,
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ], v70 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "issue",
                    "plural": false,
                    "selections": [
                        v20 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                        v34 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v20 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraParentIssueField",
                            "kind": "LinkedField",
                            "name": "parentIssueField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "parentIssue",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v20 /*: any*/ 
                            ]
                        },
                        v19 /*: any*/ ,
                        v65 /*: any*/ ,
                        {
                            "concreteType": "JiraSingleSelectUserPickerField",
                            "kind": "LinkedField",
                            "name": "assigneeField",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v32 /*: any*/ ,
                                        v52 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v20 /*: any*/ 
                            ]
                        },
                        {
                            "args": v66 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "startDateViewField",
                            "plural": false,
                            "selections": v68 /*: any*/ ,
                            "storageKey": "startDateViewField(viewId:\"list_default\")"
                        },
                        {
                            "args": v66 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "endDateViewField",
                            "plural": false,
                            "selections": v68 /*: any*/ ,
                            "storageKey": "endDateViewField(viewId:\"list_default\")"
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "aggregatedStartDateViewField",
                                    "plural": false,
                                    "selections": v69 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "aggregatedEndDateViewField",
                                    "plural": false,
                                    "selections": v69 /*: any*/ 
                                }
                            ],
                            "type": "JiraAggregatedTimelineField"
                        }
                    ]
                }
            ],
            "type": "JiraTimelineVirtualField",
            "abstractKey": "__isJiraTimelineVirtualField"
        }
    ], v71 = [
        v32 /*: any*/ ,
        v20 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useGetRealtimeIssueDetailsQuery",
            "selections": [
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "jira_issuesByIds",
                    "plural": true,
                    "selections": [
                        v16 /*: any*/ ,
                        {
                            "concreteType": "JiraParentIssueField",
                            "kind": "LinkedField",
                            "name": "parentIssueField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "parentIssue",
                                    "plural": false,
                                    "selections": [
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v18 /*: any*/ ,
                            "concreteType": "JiraIssueFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "isConditionalFormattingEnabled",
                                            "variableName": "isConditionalFormattingEnabled"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "isDensityFull",
                                            "variableName": "isDensityFull"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "isEditableSyncLoaded",
                                            "variableName": "isEditableSyncLoaded"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "isInlineEditingEnabled",
                                            "variableName": "isInlineEditingEnabled"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "isLinkRelationshipFieldEnabled",
                                            "variableName": "isLinkRelationshipFieldEnabled"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "isTimelineEnabled",
                                            "variableName": "isTimelineEnabled"
                                        }
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "IssueRow_fieldSets"
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        v19 /*: any*/ ,
                        {
                            "condition": "isHierarchyEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        v20 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "progressSummary_issueViewChildIssuesPanel_statusAndResolved"
                        },
                        v17 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v23 /*: any*/ ,
                            "concreteType": "JiraIssueSearchBulkViewContextsConnection",
                            "kind": "LinkedField",
                            "name": "searchViewContexts",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchBulkViewContextsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v24 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueSearchBulkViewContextMapping",
                                                    "kind": "LinkedField",
                                                    "name": "contexts",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v26 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "jira.searchViewContexts.edges.node.contexts.sourceIssueId"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v27 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "jira.searchViewContexts.edges.node.contexts.position"
                                                        },
                                                        v28 /*: any*/ ,
                                                        v29 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v14 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v12 /*: any*/ ,
                v2 /*: any*/ ,
                v8 /*: any*/ ,
                v7 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "useGetRealtimeIssueDetailsQuery",
            "selections": [
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "jira_issuesByIds",
                    "plural": true,
                    "selections": [
                        v16 /*: any*/ ,
                        {
                            "concreteType": "JiraParentIssueField",
                            "kind": "LinkedField",
                            "name": "parentIssueField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "parentIssue",
                                    "plural": false,
                                    "selections": [
                                        v20 /*: any*/ ,
                                        v17 /*: any*/ 
                                    ]
                                },
                                v20 /*: any*/ 
                            ]
                        },
                        {
                            "args": v18 /*: any*/ ,
                            "concreteType": "JiraIssueFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldSetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v30 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fieldSetId"
                                                },
                                                {
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": false,
                                                    "selections": [
                                                        v31 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        v32 /*: any*/ ,
                                                                        v33 /*: any*/ ,
                                                                        v30 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isJiraIssueField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "serviceId"
                                                                                                        },
                                                                                                        v34 /*: any*/ ,
                                                                                                        v20 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraAffectedServicesField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraCascadingOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "cascadingOption",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "parentOptionValue",
                                                                                            "plural": false,
                                                                                            "selections": v36 /*: any*/ 
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "childOptionValue",
                                                                                            "plural": false,
                                                                                            "selections": v36 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraCascadingSelectField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "objectId"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "label"
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "mediaClientConfig",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "clientId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "fileId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "mediaJwtToken"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "url48"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "QueryError",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "errors",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "message"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraCMDBField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "args": v38 /*: any*/ ,
                                                                                    "concreteType": "JiraComponentConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedComponentsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraComponentEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraComponent",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v39 /*: any*/ ,
                                                                                                        v40 /*: any*/ ,
                                                                                                        v20 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraComponentsField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v41 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v42 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraDatePickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "dateTime"
                                                                                },
                                                                                v34 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraDateTimePickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraEpic",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "epic",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v19 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "summary"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "color"
                                                                                        },
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraEpicLinkField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "renderedFieldHtml"
                                                                                }
                                                                            ],
                                                                            "type": "JiraFallbackField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v43 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v44 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraSingleLineTextField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraStatusCategory",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "statusCategory",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        v45 /*: any*/ ,
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraStatusCategoryField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraStatus",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "status",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "statusId"
                                                                                        },
                                                                                        v46 /*: any*/ ,
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraStatusField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "args": v38 /*: any*/ ,
                                                                                    "concreteType": "JiraLabelConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedLabelsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraLabelEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraLabel",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v34 /*: any*/ ,
                                                                                                        v47 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                },
                                                                                v34 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraLabelsField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraAvatar",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "avatar",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "small"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v34 /*: any*/ ,
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraIssueTypeField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "parentIssue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v19 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraColorField",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueColorField",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v47 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueTypeField",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v48 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        v20 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraSingleLineTextField",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summaryField",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v43 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v20 /*: any*/ ,
                                                                                        v16 /*: any*/ ,
                                                                                        v49 /*: any*/ ,
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "ids",
                                                                                                            "value": [
                                                                                                                "issuetype",
                                                                                                                "project",
                                                                                                                "summary",
                                                                                                                "status"
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldsById",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v32 /*: any*/ ,
                                                                                                                        v20 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v33 /*: any*/ ,
                                                                                                                                v43 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v33 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueType",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v20 /*: any*/ ,
                                                                                                                                        v50 /*: any*/ ,
                                                                                                                                        v34 /*: any*/ ,
                                                                                                                                        v48 /*: any*/ ,
                                                                                                                                        v21 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v33 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "status",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v20 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "statusCategory",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v20 /*: any*/ ,
                                                                                                                                                v45 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraStatusField"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueTypeField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v33 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v50 /*: any*/ ,
                                                                                                                v21 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "summaryField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v33 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraStatusField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        v51 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v34 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraParentIssueField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraPriority",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "priority",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "iconUrl"
                                                                                        },
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v34 /*: any*/ ,
                                                                                v44 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraPriorityField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraProject",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "project",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        v19 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraAvatar",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "avatar",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "large"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraProjectField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraResolution",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "resolution",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraResolutionField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprintConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedSprintsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraSprintEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprint",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "sprintId"
                                                                                                        },
                                                                                                        v34 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "state"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "endDate"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v34 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraSprintField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v32 /*: any*/ ,
                                                                                        v34 /*: any*/ ,
                                                                                        v52 /*: any*/ ,
                                                                                        v53 /*: any*/ ,
                                                                                        v20 /*: any*/ ,
                                                                                        v54 /*: any*/ ,
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "TypeDiscriminator",
                                                                                                    "abstractKey": "__isUser"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": v55 /*: any*/ ,
                                                                                                    "type": "AppUser"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": v55 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "AppUser"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v42 /*: any*/ ,
                                                                                v44 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraRichText",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "richText",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraADF",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "adfValue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "condition": "isDensityFull",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "convertedPlainText",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "plainText"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "isDensityFull",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "json"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraRichTextField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "requestType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        v48 /*: any*/ ,
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "args": [
                                                                                        {
                                                                                            "kind": "Literal",
                                                                                            "name": "first",
                                                                                            "value": 1
                                                                                        }
                                                                                    ],
                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueLinkConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v49 /*: any*/ ,
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "statusCategory"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v32 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v46 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                        },
                                                                                                                                        v20 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        v56 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v20 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v57 /*: any*/ ,
                                                                                                        v20 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                }
                                                                            ],
                                                                            "type": "JiraIssueLinkField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isStoryPointField"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "number"
                                                                                },
                                                                                v34 /*: any*/ ,
                                                                                v37 /*: any*/ ,
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraNumberFieldFormatConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "formatConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "formatStyle"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "formatUnit"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraNumberField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraCommentSummary",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "commentSummary",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "canAddComment"
                                                                                        },
                                                                                        v31 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraCommentSummaryField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "uri"
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraUrlField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldOption",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v20 /*: any*/ ,
                                                                                        v58 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraSingleSelectField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraOptionConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedOptions",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraOptionEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v35 /*: any*/ ,
                                                                                                        v58 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraMultipleSelectField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraOptionConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedOptions",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraOptionEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v35 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraCheckboxesField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraUserConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedUsersConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraUserEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v32 /*: any*/ ,
                                                                                                        v54 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        v52 /*: any*/ ,
                                                                                                        v20 /*: any*/ ,
                                                                                                        v53 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "email"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "AtlassianAccountUser"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraTeamView",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedTeam",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "jiraSuppliedId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "jiraSuppliedName"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraTeamViewField"
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "timeTrackingField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v37 /*: any*/ ,
                                                                                                        v59 /*: any*/ ,
                                                                                                        v60 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        v30 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "timeTrackingField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v59 /*: any*/ ,
                                                                                                        v60 /*: any*/ ,
                                                                                                        v20 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        v30 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v37 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedOption",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": "label",
                                                                                            "kind": "ScalarField",
                                                                                            "name": "value"
                                                                                        },
                                                                                        v20 /*: any*/ ,
                                                                                        v39 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraRadioSelectField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "args": v38 /*: any*/ ,
                                                                                    "concreteType": "JiraVersionConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedVersionsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraVersionEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersion",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        v39 /*: any*/ ,
                                                                                                        v40 /*: any*/ ,
                                                                                                        v61 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraMultipleVersionPickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                v63 /*: any*/ ,
                                                                                {
                                                                                    "args": v38 /*: any*/ ,
                                                                                    "concreteType": "JiraGoalConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedGoals",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraGoalEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGoal",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v19 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                v34 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "status"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v17 /*: any*/ 
                                                                                    ],
                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                },
                                                                                v37 /*: any*/ ,
                                                                                v17 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraGoalsField"
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        v63 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isLinkEditable"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraTownsquareProject",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "project",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v20 /*: any*/ ,
                                                                                                {
                                                                                                    "alias": "atlasProjectName",
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "name"
                                                                                                },
                                                                                                {
                                                                                                    "alias": "atlasProjectKey",
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "key"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "privateProject"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "hasPermission"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isWorkspaceActive"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v37 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraTownsquareProjectField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "args": v38 /*: any*/ ,
                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v64 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "pageContent",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v32 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v64 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraConfluencePageContentDetails"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v31 /*: any*/ 
                                                                                    ],
                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraGroupConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedGroupsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraGroupEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGroup",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "groupId"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraMultipleGroupPickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraFlag",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "flag",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isFlagged"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraFlagField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraWatch",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "watch",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "count"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isWatching"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraWatchesField"
                                                                        },
                                                                        {
                                                                            "condition": "isLinkRelationshipFieldEnabled",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueLink",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueLink",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v20 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "direction"
                                                                                                },
                                                                                                v57 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueLinkType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "type",
                                                                                                    "plural": false,
                                                                                                    "selections": v62 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v44 /*: any*/ ,
                                                                                        v37 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraIssueLinkRelationshipTypeField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "isTimelineEnabled",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v70 /*: any*/ ,
                                                                                    "type": "JiraTimelineField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v70 /*: any*/ ,
                                                                                    "type": "JiraAggregatedTimelineField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v17 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "isConditionalFormattingEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldSetEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSet",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fields",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "args": v38 /*: any*/ ,
                                                                                            "concreteType": "JiraComponentConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedComponentsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponent",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "componentId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraComponentsField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraPriority",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "priority",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "priorityId"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraPriorityField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraProject",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "project",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "projectId"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraVersion",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "version",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v61 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleVersionPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v50 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedValue",
                                                                                            "plural": false,
                                                                                            "selections": v71 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraSelectableValueConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedValues",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSelectableValueEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": v71 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraMultipleSelectField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        v19 /*: any*/ ,
                        v20 /*: any*/ ,
                        {
                            "condition": "isHierarchyEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        v20 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                v20 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v56 /*: any*/ ,
                                v65 /*: any*/ 
                            ]
                        },
                        v17 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v23 /*: any*/ ,
                            "concreteType": "JiraIssueSearchBulkViewContextsConnection",
                            "kind": "LinkedField",
                            "name": "searchViewContexts",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchBulkViewContextsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v32 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueSearchBulkViewContextMapping",
                                                    "kind": "LinkedField",
                                                    "name": "contexts",
                                                    "plural": true,
                                                    "selections": [
                                                        v26 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        v28 /*: any*/ ,
                                                        v29 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3f9da774271b8b61bc148453a312d1a3d1208b2d126106296f9095772ae6ff51",
            "metadata": {},
            "name": "useGetRealtimeIssueDetailsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": (0, $04qit.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $6AioA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": (0, $1fipb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": (0, $ePJhs.default)
            }
        }
    };
}();
$2c542931a973f177$var$node.hash = "2a2eeea788a2e6bf9581e08300a2d126";
var $2c542931a973f177$export$2e2bcd8739ae039 = $2c542931a973f177$var$node;

});
parcelRegister("ePJhs", function(module, exports) {
$parcel$export(module.exports, "default", () => $92292d3add361cda$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $92292d3add361cda$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jira-issue-view-child-issues-panel-realtime-update');
    }
};

});



parcelRegister("lEvni", function(module, exports) {
$parcel$export(module.exports, "useGetGroupsForIssues", () => $32c874d5ac433567$export$c756ae1e1c570081);

var $1MJ98 = parcelRequire("1MJ98");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $7zZ4w = parcelRequire("7zZ4w");

var $cHtIB = parcelRequire("cHtIB");

var $8jOO7 = parcelRequire("8jOO7");
const $32c874d5ac433567$export$c756ae1e1c570081 = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    return (0, $eJOHy.useCallback)(async ({ issueChanges: issueChanges, staticViewInput: staticViewInput, fieldId: fieldId, issueSearchInput: issueSearchInput, numGroupsLoaded: numGroupsLoaded })=>{
        const environment = (0, $7zZ4w.default)();
        try {
            const data = await (0, $j4oe4.fetchQuery)(environment, (0, $1MJ98.default), {
                cloudId: cloudId,
                issueChanges: issueChanges,
                issueSearchInput: issueSearchInput,
                fieldId: fieldId,
                // Needs to be connection length + 1 to ensure a potentially new group at the end of the
                // currently loaded connection is included
                firstNGroupsToSearch: numGroupsLoaded + 1,
                staticViewInput: staticViewInput
            }, {
                fetchPolicy: 'network-only'
            }).toPromise();
            return data?.jira?.groupsForIssues?.edges?.map((edge)=>edge?.node ? {
                    __id: edge.node.__id,
                    id: edge.node.id,
                    afterGroupId: edge.node.afterGroupId
                } : undefined)?.filter(Boolean) ?? [];
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'realTimeFetchGroupsForIssue',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                },
                error: error instanceof Error ? error : undefined,
                sendToPrivacyUnsafeSplunk: true
            });
            return [];
        }
    }, [
        cloudId
    ]);
};

});
parcelRegister("1MJ98", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e1efcb17c11e775$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3b728e364bcdaa2f0bb25e85a85311ef>>
 * @relayHash 0083cbce9e4bab746454c2ba530787db
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9bf27ca5afcfd276f2b63de76f71261f127292892443054a26b7381593b07bf5

var $8jq8m = parcelRequire("8jq8m");

var $4GS9O = parcelRequire("4GS9O");
const $2e1efcb17c11e775$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "firstNGroupsToSearch"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueChanges"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "fieldId",
            "variableName": "fieldId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "kind": "Variable",
            "name": "firstNGroupsToSearch",
            "variableName": "firstNGroupsToSearch"
        },
        {
            "kind": "Variable",
            "name": "issueChanges",
            "variableName": "issueChanges"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "staticViewInput",
            "variableName": "staticViewInput"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "afterGroupId"
    }, v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "name"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v14 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v7 /*: any*/ 
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "key"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useGetGroupsForIssuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetGroupConnection",
                            "kind": "LinkedField",
                            "name": "groupsForIssues",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSpreadsheetGroupEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSpreadsheetGroup",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "FirstGroupRow_GroupRow"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "useGetGroupsForIssuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetGroupConnection",
                            "kind": "LinkedField",
                            "name": "groupsForIssues",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSpreadsheetGroupEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSpreadsheetGroup",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jql"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fieldId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fieldType"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fieldSetId"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fieldValue",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "jqlTerm"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "priorityId"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        }
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlPriorityFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "accountId"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "picture"
                                                                        }
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraStatusCategory",
                                                                    "kind": "LinkedField",
                                                                    "name": "statusCategory",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlStatusFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "number"
                                                                }
                                                            ],
                                                            "type": "JiraJqlNumberFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "option",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "optionId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        },
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlOptionFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "sprintId"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "state"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "endDate"
                                                                        }
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlSprintFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraLabel",
                                                                    "kind": "LinkedField",
                                                                    "name": "label",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlLabelFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGroup",
                                                                    "kind": "LinkedField",
                                                                    "name": "group",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "groupId"
                                                                        },
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlGroupFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersion",
                                                                    "kind": "LinkedField",
                                                                    "name": "version",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "versionId"
                                                                        },
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlVersionFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraGoal",
                                                                    "kind": "LinkedField",
                                                                    "name": "goal",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "status"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "score"
                                                                        },
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                v15 /*: any*/ ,
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlGoalsFieldValue"
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraTownsquareProject",
                                                                            "kind": "LinkedField",
                                                                            "name": "project",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "privateProject"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "hasPermission"
                                                                                },
                                                                                v11 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "iconName"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraJqlTownsquareProjectFieldValue"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "issueTypeId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                            "kind": "LinkedField",
                                                                            "name": "hierarchy",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "level"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraResolution",
                                                                    "kind": "LinkedField",
                                                                    "name": "resolution",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlResolutionFieldValue"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "issueCount"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9bf27ca5afcfd276f2b63de76f71261f127292892443054a26b7381593b07bf5",
            "metadata": {},
            "name": "useGetGroupsForIssuesQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider": (0, $4GS9O.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider": (0, $8jq8m.default)
            }
        }
    };
}();
$2e1efcb17c11e775$var$node.hash = "f80b5893a2d3beef812b43f19aafcbbe";
var $2e1efcb17c11e775$export$2e2bcd8739ae039 = $2e1efcb17c11e775$var$node;

});




parcelRegister("jyos0", function(module, exports) {
$parcel$export(module.exports, "FlatListUpdateHandler", () => $c5d3771d2cf8f18c$export$a86357b97b9cc5c5);

var $eJOHy = parcelRequire("eJOHy");

var $jE8Tu = parcelRequire("jE8Tu");

var $cxKOj = parcelRequire("cxKOj");
const $c5d3771d2cf8f18c$var$EMPTY_ARRAY = [];
const $c5d3771d2cf8f18c$export$a86357b97b9cc5c5 = ({ onIssueFlatListUpdated: onIssueFlatListUpdated })=>{
    const flatList = (0, $jE8Tu.useFlatList)();
    const flatListIssueKeys = (0, $jE8Tu.useFlatListIssueKeys)();
    const flatListIssueIds = (0, $jE8Tu.useIssueIds)();
    const flatListChildIssueIds = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? (0, $jE8Tu.useChildIssueIds)() : $c5d3771d2cf8f18c$var$EMPTY_ARRAY;
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        onIssueFlatListUpdated?.(flatListIssueKeys.filter(Boolean), flatListIssueIds, flatListChildIssueIds);
    }, [
        flatList,
        flatListIssueIds,
        flatListIssueKeys,
        onIssueFlatListUpdated,
        flatListChildIssueIds
    ]);
    return null;
};

});



$parcel$global.rlb("jr04i")
//# sourceMappingURL=async-issue-navigator-native-issue-table.59cf125c.js.map
